/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(868);
	module.exports = __webpack_require__(222);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2073);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _isPlaceholder = __webpack_require__(260);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Trans", {
	  enumerable: true,
	  get: function get() {
	    return _Trans.Trans;
	  }
	});
	Object.defineProperty(exports, "TransWithoutContext", {
	  enumerable: true,
	  get: function get() {
	    return _TransWithoutContext.Trans;
	  }
	});
	Object.defineProperty(exports, "useTranslation", {
	  enumerable: true,
	  get: function get() {
	    return _useTranslation.useTranslation;
	  }
	});
	Object.defineProperty(exports, "withTranslation", {
	  enumerable: true,
	  get: function get() {
	    return _withTranslation.withTranslation;
	  }
	});
	Object.defineProperty(exports, "Translation", {
	  enumerable: true,
	  get: function get() {
	    return _Translation.Translation;
	  }
	});
	Object.defineProperty(exports, "I18nextProvider", {
	  enumerable: true,
	  get: function get() {
	    return _I18nextProvider.I18nextProvider;
	  }
	});
	Object.defineProperty(exports, "withSSR", {
	  enumerable: true,
	  get: function get() {
	    return _withSSR.withSSR;
	  }
	});
	Object.defineProperty(exports, "useSSR", {
	  enumerable: true,
	  get: function get() {
	    return _useSSR.useSSR;
	  }
	});
	Object.defineProperty(exports, "I18nContext", {
	  enumerable: true,
	  get: function get() {
	    return _context.I18nContext;
	  }
	});
	Object.defineProperty(exports, "initReactI18next", {
	  enumerable: true,
	  get: function get() {
	    return _context.initReactI18next;
	  }
	});
	Object.defineProperty(exports, "setDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _context.setDefaults;
	  }
	});
	Object.defineProperty(exports, "getDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _context.getDefaults;
	  }
	});
	Object.defineProperty(exports, "setI18n", {
	  enumerable: true,
	  get: function get() {
	    return _context.setI18n;
	  }
	});
	Object.defineProperty(exports, "getI18n", {
	  enumerable: true,
	  get: function get() {
	    return _context.getI18n;
	  }
	});
	Object.defineProperty(exports, "composeInitialProps", {
	  enumerable: true,
	  get: function get() {
	    return _context.composeInitialProps;
	  }
	});
	Object.defineProperty(exports, "getInitialProps", {
	  enumerable: true,
	  get: function get() {
	    return _context.getInitialProps;
	  }
	});
	exports.selectOrdinal = exports.plural = exports.select = exports.number = exports.time = exports.date = void 0;
	
	var _Trans = __webpack_require__(1965);
	
	var _TransWithoutContext = __webpack_require__(654);
	
	var _useTranslation = __webpack_require__(383);
	
	var _withTranslation = __webpack_require__(1970);
	
	var _Translation = __webpack_require__(1966);
	
	var _I18nextProvider = __webpack_require__(1964);
	
	var _withSSR = __webpack_require__(1969);
	
	var _useSSR = __webpack_require__(655);
	
	var _context = __webpack_require__(152);
	
	var date = function date() {
	  return '';
	};
	
	exports.date = date;
	
	var time = function time() {
	  return '';
	};
	
	exports.time = time;
	
	var number = function number() {
	  return '';
	};
	
	exports.number = number;
	
	var select = function select() {
	  return '';
	};
	
	exports.select = select;
	
	var plural = function plural() {
	  return '';
	};
	
	exports.plural = plural;
	
	var selectOrdinal = function selectOrdinal() {
	  return '';
	};
	
	exports.selectOrdinal = selectOrdinal;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  batch: true
	};
	
	var _exports = __webpack_require__(2040);
	
	Object.keys(_exports).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _exports[key]) return;
	  exports[key] = _exports[key];
	});
	
	var _reactBatchedUpdates = __webpack_require__(2045);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _batch = __webpack_require__(682);
	
	// Enable batched updates in our subscriptions for use
	// with standard React renderers (ReactDOM, React Native)
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gaEvent = exports.trackGA = exports.trackPageview = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _transliterate = __webpack_require__(1176);
	
	var _transliterate2 = _interopRequireDefault(_transliterate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRACKER_ID = 'G-JTN4FER772';
	
	var trackPageview = exports.trackPageview = function trackPageview(path) {
	  if (window.gtag) {
	    window.gtag('config', TRACKER_ID, {
	      page_path: path
	    });
	  }
	};
	
	var trackGA = exports.trackGA = function trackGA(_ref) {
	  var event_id = _ref.event_id,
	      screenName = _ref.screenName,
	      eventName = _ref.eventName,
	      eventCategory = _ref.eventCategory,
	      eventAction = _ref.eventAction,
	      eventLabel = _ref.eventLabel,
	      _ref$eventContent = _ref.eventContent,
	      eventContent = _ref$eventContent === undefined ? null : _ref$eventContent,
	      _ref$eventContext = _ref.eventContext,
	      eventContext = _ref$eventContext === undefined ? null : _ref$eventContext,
	      _ref$productType = _ref.productType,
	      productType = _ref$productType === undefined ? null : _ref$productType,
	      _ref$productName = _ref.productName,
	      productName = _ref$productName === undefined ? null : _ref$productName,
	      _ref$productID = _ref.productID,
	      productID = _ref$productID === undefined ? null : _ref$productID,
	      user_id = _ref.user_id;
	
	  if (window.gtag) {
	    window.gtag('event', eventName, _extends({
	      event_id: event_id,
	      screenName: screenName,
	      eventCategory: eventCategory,
	      eventAction: eventAction,
	      eventLabel: eventLabel,
	      user_id: user_id
	    }, eventContent && { eventContent: eventContent }, eventContext && { eventContext: eventContext }, productType && { productType: productType }, productName && { productName: productName }, productID && { productID: productID }));
	
	    // if (process.env.NODE_ENV === 'development') {
	    //   let logMessage = `%cGA tracked: ${event_id}|${screenName}|${eventName}|${eventCategory}|${eventAction}|${eventLabel}`;
	
	    //   if (user_id) {
	    //     logMessage += `\nUser ID: ${user_id}`;
	    //   }
	
	    //   if (eventContent) {
	    //     logMessage += `\nContent: ${eventContent}`;
	    //   }
	
	    //   if (eventContext) {
	    //     logMessage += `\nContext: ${eventContext}`;
	    //   }
	
	    //   if (productType) {
	    //     logMessage += `\nProduct Type: ${productType}`;
	    //   }
	
	    //   if (productName) {
	    //     logMessage += `\nProduct Name: ${productName}`;
	    //   }
	
	    //   if (productID) {
	    //     logMessage += `\nProduct ID: ${productID}`;
	    //   }
	
	    //   console.log(logMessage, 'background: #D7F1FF; padding: 2px 4px; border-radius: 4px;');
	    // }
	  }
	};
	
	//
	
	var gaEvent = exports.gaEvent = {
	  // События просмотра экрана. Должно срабатывать на каждом новом экране.
	  pageShow: function pageShow(_ref2) {
	    var screenName = _ref2.screenName;
	    return {
	      event_id: '1.0',
	      screenName: screenName,
	      eventName: 'nxPageview',
	      eventCategory: 'pageview',
	      eventLabel: screenName
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 3 символов + 3 секунды без ввода) в поле "телефон" на странице авторизации после клика на кнопку "вход"
	  loginPhoneInput: function loginPhoneInput() {
	    return {
	      event_id: '10.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'form_fill',
	      eventLabel: 'nomer_telefona'
	    };
	  },
	
	  // Клик на кнопки appstore и google play на странице логинки для перехода на загрузку приложения
	  downloadAppClick: function downloadAppClick(_ref3) {
	    var eventContent = _ref3.eventContent;
	    return {
	      event_id: '11.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'element_click',
	      eventLabel: 'skachat_prilozhenie',
	      eventContent: eventContent
	    };
	  },
	
	  // Клик на кнопки на странице авторизации.
	  loginButtonsClick: function loginButtonsClick(_ref4) {
	    var eventLabel = _ref4.eventLabel;
	    return {
	      event_id: '12.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'button_click',
	      eventLabel: eventLabel
	    };
	  },
	
	  // Показ поп-апа "Регистрация" после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationPopupShow: function registrationPopupShow() {
	    return {
	      event_id: '13.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'popup_show',
	      eventLabel: 'registraciya'
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 3 символов + 3 секунды без ввода) в поля "Имя" "Фамилия" "Номер телефона" "e-mail" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationFormInput: function registrationFormInput(_ref5) {
	    var eventLabel = _ref5.eventLabel;
	    return {
	      event_id: '14.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'form_fill',
	      eventLabel: eventLabel,
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Клик на выпадающее меню "Выберите ваше место работы" или "Выберите город" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationDropdownClick: function registrationDropdownClick(_ref6) {
	    var eventLabel = _ref6.eventLabel;
	    return {
	      event_id: '15.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Клик на выбор города или типа работы в выпадающих меню на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationDropdownOptionClick: function registrationDropdownOptionClick(_ref7) {
	    var eventLabel = _ref7.eventLabel,
	        eventContent = _ref7.eventContent;
	    return {
	      event_id: '16.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Клик на кнопки на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationButtonsClick: function registrationButtonsClick(_ref8) {
	    var eventLabel = _ref8.eventLabel;
	    return {
	      event_id: '17.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Показ "Некорректно введен email" "Некорректно введено имя" "Некорректно введена фамилия" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationErrorsShow: function registrationErrorsShow(_ref9) {
	    var eventLabel = _ref9.eventLabel;
	    return {
	      event_id: '18.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Факт успешной регистрации после заполнения формы на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
	  registrationSuccess: function registrationSuccess() {
	    return {
	      event_id: '19.0',
	      screenName: '/login',
	      eventName: 'nxLogin',
	      eventCategory: 'login',
	      eventAction: 'confirmed',
	      eventLabel: 'uspeshnaya_registraciya',
	      eventContext: 'registraciya'
	    };
	  },
	
	  // Клик на кнопки главного меню внутри приложения
	  headerButtonsClick: function headerButtonsClick(_ref10) {
	    var eventLabel = _ref10.eventLabel,
	        user_id = _ref10.user_id;
	    return {
	      event_id: '52.0',
	      screenName: '/',
	      eventName: 'nxAppMainMenu',
	      eventCategory: 'app_main_menu',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Клик на выбор типа поиска или кнопки закрыть на попапе "поиск" внутри приложения
	  searchButtonsClick: function searchButtonsClick(_ref11) {
	    var eventLabel = _ref11.eventLabel,
	        user_id = _ref11.user_id;
	    return {
	      event_id: '53.0',
	      screenName: '/',
	      eventName: 'nxAppSearch',
	      eventCategory: 'app_search',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода)  в поле "Поиск"
	  searchInput: function searchInput(_ref12) {
	    var eventLabel = _ref12.eventLabel,
	        eventContent = _ref12.eventContent,
	        eventContext = _ref12.eventContext,
	        user_id = _ref12.user_id;
	    return {
	      event_id: '54.0',
	      screenName: '/',
	      eventName: 'nxAppSearch',
	      eventCategory: 'app_search',
	      eventAction: 'form_fill',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Клик по кнопкам в выпадающем меню при нажатии на кнопку "Профиль" в главном меню
	  profileDropdownButtonsClick: function profileDropdownButtonsClick(_ref13) {
	    var eventLabel = _ref13.eventLabel,
	        user_id = _ref13.user_id;
	    return {
	      event_id: '55.0',
	      screenName: '/',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях на странице профиля
	  profileFormInput: function profileFormInput(_ref14) {
	    var eventLabel = _ref14.eventLabel,
	        user_id = _ref14.user_id;
	    return {
	      event_id: '56.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'form_fill',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на странице профиля
	  profileButtonsClick: function profileButtonsClick(_ref15) {
	    var eventLabel = _ref15.eventLabel,
	        user_id = _ref15.user_id;
	    return {
	      event_id: '57.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Показ ошибок при заполнении полей на странице профиля
	  profileSaveSuccessAndErrorsShow: function profileSaveSuccessAndErrorsShow(_ref16) {
	    var eventContent = _ref16.eventContent,
	        eventLabel = _ref16.eventLabel,
	        user_id = _ref16.user_id;
	    return {
	      event_id: '58.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      user_id: user_id
	    };
	  },
	
	  // Клик на пункты фильтра объектов на главной странице
	  filterButtonsClick: function filterButtonsClick(_ref17) {
	    var eventLabel = _ref17.eventLabel,
	        eventContext = _ref17.eventContext,
	        productType = _ref17.productType,
	        user_id = _ref17.user_id;
	    return {
	      event_id: '59.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Выбор района на вкладке фильтра "район"
	  filterDistrictButtonsClick: function filterDistrictButtonsClick(_ref18) {
	    var eventContent = _ref18.eventContent,
	        eventContext = _ref18.eventContext,
	        productType = _ref18.productType,
	        user_id = _ref18.user_id;
	    return {
	      event_id: '60.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: 'raion',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Выбор микрорайона на вкладке фильтра "район"
	  filterMicrodistrictButtonsClick: function filterMicrodistrictButtonsClick(_ref19) {
	    var eventContent = _ref19.eventContent,
	        eventContext = _ref19.eventContext,
	        productType = _ref19.productType,
	        user_id = _ref19.user_id;
	    return {
	      event_id: '61.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: 'mikroraion',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях "цена от" "цена до" или "площадь от" "площадь до" на вкладках фильтра "цена" или "площадь"
	  filterInput: function filterInput(_ref20) {
	    var eventLabel = _ref20.eventLabel,
	        eventContent = _ref20.eventContent,
	        eventContext = _ref20.eventContext,
	        productType = _ref20.productType,
	        user_id = _ref20.user_id;
	    return {
	      event_id: '62.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'form_fill',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Выбор остальных параметров (отделка, оформление, срок сдачи, варианты оплаты, тип недвижимости, расстояние до моря, класс дома, преимущества, вид из окна) на соответствующих вкладках фильтра
	  // TODO: patameter_filtra - parameter ??
	  filterCheckboxesClick: function filterCheckboxesClick(_ref21) {
	    var eventContent = _ref21.eventContent,
	        eventContext = _ref21.eventContext,
	        productType = _ref21.productType,
	        user_id = _ref21.user_id;
	    return {
	      event_id: '63.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: 'parameter_filtra',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Клик по быстрому фильтру (nedvex, новинки, акции, популярное ) на главной странице приложения
	  filterTypeButtonsClick: function filterTypeButtonsClick(_ref22) {
	    var eventLabel = _ref22.eventLabel,
	        eventContent = _ref22.eventContent,
	        eventContext = _ref22.eventContext,
	        productType = _ref22.productType,
	        user_id = _ref22.user_id;
	    return {
	      event_id: '64.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Клик по кнопке "сбросить фильтр" на лююбой вкладке общего фильтра или быстрого фильтра "nedvex"
	  filterClearButtonsClick: function filterClearButtonsClick(_ref23) {
	    var eventContent = _ref23.eventContent,
	        eventContext = _ref23.eventContext,
	        productType = _ref23.productType,
	        user_id = _ref23.user_id;
	    return {
	      event_id: '65.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: 'sbrosit_filtr',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Клик на выбор сортировки на фильтре на главной странице
	  filterSortByButtonsClick: function filterSortByButtonsClick(_ref24) {
	    var eventContent = _ref24.eventContent,
	        eventContext = _ref24.eventContext,
	        productType = _ref24.productType,
	        user_id = _ref24.user_id;
	    return {
	      event_id: '66.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: 'sortirovka',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Клик по кнопке выбора отображения объектов недвижимости "карта" "искать на списке"
	  filterListModeSwitchClick: function filterListModeSwitchClick(_ref25) {
	    var eventLabel = _ref25.eventLabel,
	        eventContext = _ref25.eventContext,
	        productType = _ref25.productType,
	        user_id = _ref25.user_id;
	    return {
	      event_id: '67.0',
	      screenName: '/',
	      eventName: 'nxAppFilter',
	      eventCategory: 'app_filter',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Показ карточки объекта недвижимости в любом месте на сайте
	  buildingCardShow: function buildingCardShow(_ref26) {
	    var screenName = _ref26.screenName,
	        eventContent = _ref26.eventContent,
	        eventContext = _ref26.eventContext,
	        productType = _ref26.productType,
	        productName = _ref26.productName,
	        productID = _ref26.productID,
	        user_id = _ref26.user_id;
	    return {
	      event_id: '68.0',
	      screenName: screenName,
	      eventName: 'nxAppObjectCard',
	      eventCategory: 'app_object_card',
	      eventAction: 'card_show',
	      eventLabel: 'kartochka_obyekta',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на элементы на карточке объекта, либо на саму карточку (для перехода на страницу объекта)
	  buildingCardClick: function buildingCardClick(_ref27) {
	    var screenName = _ref27.screenName,
	        eventLabel = _ref27.eventLabel,
	        eventContext = _ref27.eventContext,
	        productType = _ref27.productType,
	        productName = _ref27.productName,
	        productID = _ref27.productID,
	        user_id = _ref27.user_id;
	    return {
	      event_id: '69.0',
	      screenName: screenName,
	      eventName: 'nxAppObjectCard',
	      eventCategory: 'app_object_card',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "все" "избранное" "от сервиса" в разделе "новости" на главной странице
	  // TODO: name и id объекта тут быть не может
	  newsButtonsClick: function newsButtonsClick(_ref28) {
	    var eventLabel = _ref28.eventLabel,
	        eventContext = _ref28.eventContext,
	        productType = _ref28.productType,
	        user_id = _ref28.user_id;
	    return {
	      event_id: '70.0',
	      screenName: '/',
	      eventName: 'nxAppNews',
	      eventCategory: 'app_news',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: eventContext,
	      productType: productType,
	      user_id: user_id
	    };
	  },
	
	  // Показ карточки с новостью на страницах сайта
	  newsCardShow: function newsCardShow(_ref29) {
	    var screenName = _ref29.screenName,
	        eventContent = _ref29.eventContent,
	        eventContext = _ref29.eventContext,
	        productType = _ref29.productType,
	        productName = _ref29.productName,
	        productID = _ref29.productID,
	        user_id = _ref29.user_id;
	    return {
	      event_id: '71.0',
	      screenName: screenName,
	      eventName: 'nxAppNewsCard',
	      eventCategory: 'app_news_card',
	      eventAction: 'card_show',
	      eventLabel: 'kartochka_novosti',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик по карточке новости или на элемент "Читать далее" на карточке новости на страницах сайта
	  newsCardClick: function newsCardClick(_ref30) {
	    var screenName = _ref30.screenName,
	        eventContent = _ref30.eventContent,
	        eventContext = _ref30.eventContext,
	        productType = _ref30.productType,
	        productName = _ref30.productName,
	        productID = _ref30.productID,
	        user_id = _ref30.user_id;
	    return {
	      event_id: '72.0',
	      screenName: screenName,
	      eventName: 'nxAppNewsCard',
	      eventCategory: 'app_news_card',
	      eventAction: 'element_click',
	      eventLabel: 'chitat_dalee',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик по наименованию объекта на карточке новости
	  newsCardObjectLinkClick: function newsCardObjectLinkClick(_ref31) {
	    var screenName = _ref31.screenName,
	        eventContent = _ref31.eventContent,
	        eventContext = _ref31.eventContext,
	        productType = _ref31.productType,
	        productName = _ref31.productName,
	        productID = _ref31.productID,
	        user_id = _ref31.user_id;
	    return {
	      event_id: '73.0',
	      screenName: screenName,
	      eventName: 'nxAppNewsCard',
	      eventCategory: 'app_news_card',
	      eventAction: 'element_click',
	      eventLabel: 'obyekt',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ верхнего баннера объекта на странице объекта, срабатывает повторно при свайпе картинки
	  buildingImageShow: function buildingImageShow(_ref32) {
	    var eventContent = _ref32.eventContent,
	        eventContext = _ref32.eventContext,
	        productType = _ref32.productType,
	        productName = _ref32.productName,
	        productID = _ref32.productID,
	        user_id = _ref32.user_id;
	    return {
	      event_id: '74.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'banner_show',
	      eventLabel: 'banner_obyekta',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик по кнопкам в верхней части страницы объекта: "сообщить о неточности" "в подборку" "в избранное" "поделиться" "печать информации"  "шахматка" "информация о ЖК/КП"
	  buildingTitleButtonsClick: function buildingTitleButtonsClick(_ref33) {
	    var eventLabel = _ref33.eventLabel,
	        eventContent = _ref33.eventContent,
	        productType = _ref33.productType,
	        productName = _ref33.productName,
	        productID = _ref33.productID,
	        user_id = _ref33.user_id;
	    return {
	      event_id: '75.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле на попапе  "Сообщить о неточности" после нажатия на кнопку "Сообщить о неточности"  на странице объекта
	  buildingInaccuracyReportInput: function buildingInaccuracyReportInput(_ref34) {
	    var eventContent = _ref34.eventContent,
	        productType = _ref34.productType,
	        productName = _ref34.productName,
	        productID = _ref34.productID,
	        user_id = _ref34.user_id;
	    return {
	      event_id: '76.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'form_fill',
	      eventLabel: 'soobshchit_o_netochnosti',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе  "Сообщить о неточности" после нажатия на кнопку "Сообщить о неточности"  на странице объекта
	  buildingInaccuracyReportButtonsClick: function buildingInaccuracyReportButtonsClick(_ref35) {
	    var eventLabel = _ref35.eventLabel,
	        productType = _ref35.productType,
	        productName = _ref35.productName,
	        productID = _ref35.productID,
	        user_id = _ref35.user_id;
	    return {
	      event_id: '77.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: 'soobshchit_o_netochnosti',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на выбор подборки на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
	  buildingPickCollectionButtonClick: function buildingPickCollectionButtonClick(_ref36) {
	    var eventContent = _ref36.eventContent,
	        productType = _ref36.productType,
	        productName = _ref36.productName,
	        productID = _ref36.productID,
	        user_id = _ref36.user_id;
	    return {
	      event_id: '78.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'nazvanie_podborki',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: 'dobavit_v_podborku',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
	  buildingCollectionDialogButtonsClick: function buildingCollectionDialogButtonsClick(_ref37) {
	    var eventLabel = _ref37.eventLabel,
	        eventContent = _ref37.eventContent,
	        productType = _ref37.productType,
	        productName = _ref37.productName,
	        productID = _ref37.productID,
	        user_id = _ref37.user_id;
	    return {
	      event_id: '79.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'dobavit_v_podborku',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле "Введите название новой подборки" на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
	  buildingCollectionDialogInput: function buildingCollectionDialogInput(_ref38) {
	    var eventLabel = _ref38.eventLabel,
	        eventContent = _ref38.eventContent,
	        productType = _ref38.productType,
	        productName = _ref38.productName,
	        productID = _ref38.productID,
	        user_id = _ref38.user_id;
	    return {
	      event_id: '80.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'form_fill',
	      eventLabel: 'novaya_podborka',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'dobavit_v_podborku',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ всплывающего окна "ЖК добавлен в избранное" и "ЖК убран из избранного" после нажатия на кнопку "Добавить в избранное" на странице объекта
	  buildingFavoritesResult: function buildingFavoritesResult(_ref39) {
	    var eventLabel = _ref39.eventLabel,
	        eventContent = _ref39.eventContent,
	        productType = _ref39.productType,
	        productName = _ref39.productName,
	        productID = _ref39.productID,
	        user_id = _ref39.user_id;
	    return {
	      event_id: '81.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на пункты выбора раздела на попапе после нажатия на кнопку "поделиться" на странице объекта
	  buildingShareCheckboxesPick: function buildingShareCheckboxesPick(_ref40) {
	    var eventContent = _ref40.eventContent,
	        productType = _ref40.productType,
	        productName = _ref40.productName,
	        productID = _ref40.productID,
	        user_id = _ref40.user_id;
	    return {
	      event_id: '82.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'parametr_podelitsya',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: 'podelitsya',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе "поделиться" после нажатия на кнопку "поделиться" на странице объекта
	  buildingShareButtonsClick: function buildingShareButtonsClick(_ref41) {
	    var eventLabel = _ref41.eventLabel,
	        eventContent = _ref41.eventContent,
	        productType = _ref41.productType,
	        productName = _ref41.productName,
	        productID = _ref41.productID,
	        user_id = _ref41.user_id;
	    return {
	      event_id: '83.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'podelitsya',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Выбор пункта на попапе "Печать" после нажатия на кнопку "Печать" на странице объекта
	  buildingPrintCheckboxesPick: function buildingPrintCheckboxesPick(_ref42) {
	    var eventContent = _ref42.eventContent,
	        productType = _ref42.productType,
	        productName = _ref42.productName,
	        productID = _ref42.productID,
	        user_id = _ref42.user_id;
	    return {
	      event_id: '84.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'punkt_pechati',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'pechat_informacii',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на элементы на попапе "Печать" после нажатия на кнопку "Печать" на странице объекта
	  buildingPrintButtonsClick: function buildingPrintButtonsClick(_ref43) {
	    var eventLabel = _ref43.eventLabel,
	        eventContent = _ref43.eventContent,
	        productType = _ref43.productType,
	        productName = _ref43.productName,
	        productID = _ref43.productID,
	        user_id = _ref43.user_id;
	    return {
	      event_id: '85.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'pechat_informacii',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "посмотреть все фото" "на карте" на баннере на странице объекта
	  buildingGalleryButtonsClick: function buildingGalleryButtonsClick(_ref44) {
	    var eventLabel = _ref44.eventLabel,
	        eventContent = _ref44.eventContent,
	        productType = _ref44.productType,
	        productName = _ref44.productName,
	        productID = _ref44.productID,
	        user_id = _ref44.user_id;
	    return {
	      event_id: '86.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на выбор подборки фото или на кнопку закрыть на попапе  "все фото" после нажатия на кнопку "посмотреть все фото" на странице объекта
	  buildingGalleryAlbumsButtonsClick: function buildingGalleryAlbumsButtonsClick(_ref45) {
	    var eventContent = _ref45.eventContent,
	        productType = _ref45.productType,
	        productName = _ref45.productName,
	        productID = _ref45.productID,
	        user_id = _ref45.user_id;
	    return {
	      event_id: '87.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'foto_podborka',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ фото на попапе  "все фото" после нажатия на кнопку "посмотреть все фото" на странице объекта
	  buildingGalleryModalImageShow: function buildingGalleryModalImageShow(_ref46) {
	    var eventContent = _ref46.eventContent,
	        eventContext = _ref46.eventContext,
	        productType = _ref46.productType,
	        productName = _ref46.productName,
	        productID = _ref46.productID,
	        user_id = _ref46.user_id;
	    return {
	      event_id: '88.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_show',
	      eventLabel: 'foto_obyekta',
	      eventContent: eventContent,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "читать далее" или "смотреть все новости" на странице объекта
	  buildingNewsLinksClick: function buildingNewsLinksClick(_ref47) {
	    var productType = _ref47.productType,
	        productName = _ref47.productName,
	        productID = _ref47.productID,
	        user_id = _ref47.user_id;
	    return {
	      event_id: '89.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'smotret_vse_novosti',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку закрыть на попапе "все новости" после клика на кнопки "читать далее" или "смотреть все новости" на странице объекта
	  buildingNewsDialogClose: function buildingNewsDialogClose(_ref48) {
	    var productType = _ref48.productType,
	        productName = _ref48.productName,
	        productID = _ref48.productID,
	        user_id = _ref48.user_id;
	    return {
	      event_id: '90.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'zakryt',
	      eventContent: 'vse_novosti',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ информационных блоков на странице объекта
	  buildingInfoBlocksShow: function buildingInfoBlocksShow(_ref49) {
	    var eventLabel = _ref49.eventLabel,
	        productType = _ref49.productType,
	        productName = _ref49.productName,
	        productID = _ref49.productID,
	        user_id = _ref49.user_id;
	    return {
	      event_id: '91.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на элементы "свернуть" "подробнее" в разделах  на странице объекта
	  buildingInfoBlocksExpand: function buildingInfoBlocksExpand(_ref50) {
	    var eventLabel = _ref50.eventLabel,
	        eventContent = _ref50.eventContent,
	        productType = _ref50.productType,
	        productName = _ref50.productName,
	        productID = _ref50.productID,
	        user_id = _ref50.user_id;
	    return {
	      event_id: '92.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на элемент "Смотреть шахматку" в разделе "корпуса" на странице объекта
	  buildingChessLinkClick: function buildingChessLinkClick(_ref51) {
	    var eventContent = _ref51.eventContent,
	        productType = _ref51.productType,
	        productName = _ref51.productName,
	        productID = _ref51.productID,
	        user_id = _ref51.user_id;
	    return {
	      event_id: '93.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'smotret_shahmatku',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки перелистывания похожих проектов в разделе ДРУГИЕ ЖК В МИКРОРАЙОНЕ на странице объекта
	  buildingSuggestionsButtonsClick: function buildingSuggestionsButtonsClick(_ref52) {
	    var eventContent = _ref52.eventContent,
	        productType = _ref52.productType,
	        productName = _ref52.productName,
	        productID = _ref52.productID,
	        user_id = _ref52.user_id;
	    return {
	      event_id: '94.0',
	      screenName: '/building/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'drugie_zhk_strelka',
	      eventContent: eventContent,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на переключение между режимами "шахматка" и "список" на странице квартир объекта
	  buildingChessSwitcherClick: function buildingChessSwitcherClick(_ref53) {
	    var eventLabel = _ref53.eventLabel,
	        productType = _ref53.productType,
	        productName = _ref53.productName,
	        productID = _ref53.productID,
	        user_id = _ref53.user_id;
	    return {
	      event_id: '95.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на раскрытие падающего меню со списком корпусов объекта на странице "шахматка"
	  buildingChessDropdownClick: function buildingChessDropdownClick(_ref54) {
	    var productType = _ref54.productType,
	        productName = _ref54.productName,
	        productID = _ref54.productID,
	        user_id = _ref54.user_id;
	    return {
	      event_id: '96.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'vybor_korpusa',
	      eventContent: 'shahmatka',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Выбор корпуса в меню выбора корпусов объекта на странице "шахматка"
	  buildingChessDropdownListItemClick: function buildingChessDropdownListItemClick(_ref55) {
	    var eventContent = _ref55.eventContent,
	        productType = _ref55.productType,
	        productName = _ref55.productName,
	        productID = _ref55.productID,
	        user_id = _ref55.user_id;
	    return {
	      event_id: '97.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'korpus',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      eventContext: 'shahmatka',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки фильтрации на странице шахматка (в режимах "шахматка" и "список")
	  buildingChessFiltersClick: function buildingChessFiltersClick(_ref56) {
	    var eventContent = _ref56.eventContent,
	        eventContext = _ref56.eventContext,
	        productType = _ref56.productType,
	        productName = _ref56.productName,
	        productID = _ref56.productID,
	        user_id = _ref56.user_id;
	    return {
	      event_id: '98.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'filtr',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях "цена от" "цена до" или "площадь" на вкладках фильтра "цена" или "площадь" на странице шахматка или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
	  buildingChessFiltersInput: function buildingChessFiltersInput(_ref57) {
	    var eventLabel = _ref57.eventLabel,
	        eventContent = _ref57.eventContent,
	        eventContext = _ref57.eventContext,
	        productType = _ref57.productType,
	        productName = _ref57.productName,
	        productID = _ref57.productID,
	        user_id = _ref57.user_id;
	    return {
	      event_id: '99.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'form_fill',
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Выбор параметров в остальных разделах фильтра на странице шахматка или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
	  buildingChessFilterCheckboxesClick: function buildingChessFilterCheckboxesClick(_ref58) {
	    var eventContent = _ref58.eventContent,
	        eventContext = _ref58.eventContext,
	        productType = _ref58.productType,
	        productName = _ref58.productName,
	        productID = _ref58.productID,
	        user_id = _ref58.user_id;
	    return {
	      event_id: '100.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'parameter_filtra',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ ховера с информацией о квартире при наведении на ячейку шахматки на странице шахматка объекта или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
	  buildingChessLotHover: function buildingChessLotHover(_ref59) {
	    var eventContent = _ref59.eventContent,
	        productType = _ref59.productType,
	        productName = _ref59.productName,
	        productID = _ref59.productID,
	        user_id = _ref59.user_id;
	    return {
	      event_id: '101.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_hover',
	      eventLabel: 'hover_kvartira',
	      eventContent: eventContent,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на карточку квартиры на шахматке или на списке квартир на странице "шахматка объекта"
	  buildingChessLotClick: function buildingChessLotClick(_ref60) {
	    var eventContent = _ref60.eventContent,
	        eventContext = _ref60.eventContext,
	        productType = _ref60.productType,
	        productName = _ref60.productName,
	        productID = _ref60.productID,
	        user_id = _ref60.user_id;
	    return {
	      event_id: '102.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'kartochka_kvartiry',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на элементы в правой части страницы шахматка при отображении выбранной квартиры в режимах "шахматка" и "список" а также на попапе  "планировка этажа" после нажатия на кнопку "увеличить планировку этажа"  в правой части страницы шахматка в режимах "шахматка" и "список"
	  buildingChessLotAboutButtonsClick: function buildingChessLotAboutButtonsClick(_ref61) {
	    var eventLabel = _ref61.eventLabel,
	        eventContext = _ref61.eventContext,
	        productType = _ref61.productType,
	        productName = _ref61.productName,
	        productID = _ref61.productID,
	        user_id = _ref61.user_id;
	    return {
	      event_id: '103.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку закрыть на попапе "планировка квартиры" после нажатия на кнопку увеличить планировку  в правой части страницы шахматка в режимах "шахматка" и "список"
	  buildingChessLotPlanCloseClick: function buildingChessLotPlanCloseClick(_ref62) {
	    var eventContext = _ref62.eventContext,
	        productType = _ref62.productType,
	        productName = _ref62.productName,
	        productID = _ref62.productID,
	        user_id = _ref62.user_id;
	    return {
	      event_id: '104.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'zakryt',
	      eventContent: 'planirovka_kvartiry',
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа"  в правой части страницы шахматка в режимах "шахматка" и "список"
	  buildingChessFloorDialogButtonsClick: function buildingChessFloorDialogButtonsClick(_ref63) {
	    var eventLabel = _ref63.eventLabel,
	        eventContext = _ref63.eventContext,
	        productType = _ref63.productType,
	        productName = _ref63.productName,
	        productID = _ref63.productID,
	        user_id = _ref63.user_id;
	    return {
	      event_id: '105.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: 'planirovka_etazha',
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Выбор сортировки при отображении квартир на странице шахматка объекта в режиме "список"
	  buildingChessListSortButtonsClick: function buildingChessListSortButtonsClick(_ref64) {
	    var eventContent = _ref64.eventContent,
	        eventContext = _ref64.eventContext,
	        productType = _ref64.productType,
	        productName = _ref64.productName,
	        productID = _ref64.productID,
	        user_id = _ref64.user_id;
	    return {
	      event_id: '106.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'sortirovka_spiska',
	      eventContent: eventContent,
	      eventContext: eventContext,
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ уведомления "все лоты проданы" на страницы шахматка
	  buildingChessListSoldOutCardShow: function buildingChessListSoldOutCardShow(_ref65) {
	    var eventContent = _ref65.eventContent,
	        productType = _ref65.productType,
	        productName = _ref65.productName,
	        productID = _ref65.productID,
	        user_id = _ref65.user_id;
	    return {
	      event_id: '107.0',
	      screenName: '/building/chess/',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_show',
	      eventLabel: 'vse_loty_prodany',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ карточки подборки на странице "Подборки"
	  collectionsListItemShow: function collectionsListItemShow(_ref66) {
	    var eventContent = _ref66.eventContent,
	        user_id = _ref66.user_id;
	    return {
	      event_id: '108.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollectionCard',
	      eventCategory: 'app_collection_card',
	      eventAction: 'element_show',
	      eventLabel: 'kartochka_podborki',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на карточке подборки или на саму карточку на странице подборки или других страницах
	  collectionsListItemButtonsClick: function collectionsListItemButtonsClick(_ref67) {
	    var eventLabel = _ref67.eventLabel,
	        user_id = _ref67.user_id;
	    return {
	      event_id: '109.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollectionCard',
	      eventCategory: 'app_collection_card',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле имени  подборки при нажатии на кнопку "переименовать"
	  collectionsListItemRenameInput: function collectionsListItemRenameInput(_ref68) {
	    var eventContent = _ref68.eventContent,
	        user_id = _ref68.user_id;
	    return {
	      event_id: '110.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollectionCard',
	      eventCategory: 'app_collection_card',
	      eventAction: 'form_fill',
	      eventLabel: 'pereimenovat',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку "Создать подборку" на странице "подборки"
	  collectionsCreateButtonClick: function collectionsCreateButtonClick(_ref69) {
	    var user_id = _ref69.user_id;
	    return {
	      event_id: '111.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: 'sozdat_podborku',
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле имени подборки при нажатии на кнопку "Создать подборку" на странице "подборки"
	  collectionsCreateDialogInput: function collectionsCreateDialogInput(_ref70) {
	    var user_id = _ref70.user_id;
	    return {
	      event_id: '112.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'form_fill',
	      eventLabel: 'nazvanie_podborki',
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе "Создать подборку" при нажатии на кнопку "Создать подборку" на странице подборки
	  collectionsCreateDialogButtonsClick: function collectionsCreateDialogButtonsClick(_ref71) {
	    var eventLabel = _ref71.eventLabel,
	        user_id = _ref71.user_id;
	    return {
	      event_id: '113.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: 'nazvanie_podborki',
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на попапе  "Удаление подборки" при нажатии на кнопку "Удалить" на карточке подборки на странице "Подборки"
	  collectionsDeleteDialogButtonsClick: function collectionsDeleteDialogButtonsClick(_ref72) {
	    var eventLabel = _ref72.eventLabel,
	        user_id = _ref72.user_id;
	    return {
	      event_id: '114.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: 'udalit_podborku',
	      user_id: user_id
	    };
	  },
	
	  // Показ всплывающего окна "Подборка удалена"  после нажатия на кнопку "Удалить" на попапе "Удаление подборки" на странице Подборки
	  collectionsDeleteResult: function collectionsDeleteResult(_ref73) {
	    var user_id = _ref73.user_id;
	    return {
	      event_id: '115.0',
	      screenName: '/collections/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_show',
	      eventLabel: 'podborka_udalena',
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку "Поделиться" на странице конкрентой подборки
	  collectionShareButtonClick: function collectionShareButtonClick(_ref74) {
	    var eventContext = _ref74.eventContext,
	        user_id = _ref74.user_id;
	    return {
	      event_id: '116.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: 'podelitsya_podborkoi',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки на карточке объекта на странице конкретной подборки
	  collectionListItemButtonsClick: function collectionListItemButtonsClick(_ref75) {
	    var eventLabel = _ref75.eventLabel,
	        eventContext = _ref75.eventContext,
	        productType = _ref75.productType,
	        productID = _ref75.productID,
	        productName = _ref75.productName,
	        user_id = _ref75.user_id;
	    return {
	      event_id: '117.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле комментарий после нажатия на кнопку "Добавить комментарий" на странице подборки
	  collectionListItemCommentInput: function collectionListItemCommentInput(_ref76) {
	    var eventContext = _ref76.eventContext,
	        productType = _ref76.productType,
	        productID = _ref76.productID,
	        productName = _ref76.productName,
	        user_id = _ref76.user_id;
	    return {
	      event_id: '118.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'form_fill',
	      eventLabel: 'dobavit_kommentarii',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле комментарий после нажатия на кнопку "Добавить комментарий" на странице подборки
	  collectionListItemCommentButtonsClick: function collectionListItemCommentButtonsClick(_ref77) {
	    var eventLabel = _ref77.eventLabel,
	        eventContext = _ref77.eventContext,
	        productType = _ref77.productType,
	        productID = _ref77.productID,
	        productName = _ref77.productName,
	        user_id = _ref77.user_id;
	    return {
	      event_id: '119.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ всплывающих окон "ЖК удален из подборки" и "ЖК добавлен в подборку" на странице подборки
	  collectionAddAndDeleteBuildingResult: function collectionAddAndDeleteBuildingResult(_ref78) {
	    var eventLabel = _ref78.eventLabel,
	        eventContext = _ref78.eventContext,
	        productType = _ref78.productType,
	        productID = _ref78.productID,
	        productName = _ref78.productName,
	        user_id = _ref78.user_id;
	    return {
	      event_id: '120.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки отменить и закрыть на всплывающем окне "ЖК удален из подборки" на странице подборки
	  collectionNotificationButtonsClick: function collectionNotificationButtonsClick(_ref79) {
	    var eventLabel = _ref79.eventLabel,
	        eventContext = _ref79.eventContext,
	        productType = _ref79.productType,
	        productID = _ref79.productID,
	        productName = _ref79.productName,
	        user_id = _ref79.user_id;
	    return {
	      event_id: '121.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: (0, _transliterate2.default)(eventContext),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ баннера "Пустая подборка" на странице подборки
	  collectionEmptyCardShow: function collectionEmptyCardShow(_ref80) {
	    var eventContext = _ref80.eventContext,
	        user_id = _ref80.user_id;
	    return {
	      event_id: '122.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_show',
	      eventLabel: 'pustaya_podborka',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку "Перейти к списку объектов" на баннере "Пустая подборка" на странице подборки
	  collectionEmptyCardButtonClick: function collectionEmptyCardButtonClick(_ref81) {
	    var eventContext = _ref81.eventContext,
	        user_id = _ref81.user_id;
	    return {
	      event_id: '123.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: 'pereiti_k_spisku',
	      eventContent: 'pustaya_podborka',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Раскрытие падающего меню на попапе "поделиться подборкой" на странице подборки
	  collectionShareDialogDropdownClick: function collectionShareDialogDropdownClick(_ref82) {
	    var eventContext = _ref82.eventContext,
	        user_id = _ref82.user_id;
	    return {
	      event_id: '124.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: 'loty',
	      eventContent: 'podelitsya_podborkoi',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Выбор разделов на попапе "Поделиться подборкой" на странице подборки
	  collectionShareDialogCheckboxesPick: function collectionShareDialogCheckboxesPick(_ref83) {
	    var eventContent = _ref83.eventContent,
	        eventContext = _ref83.eventContext,
	        user_id = _ref83.user_id;
	    return {
	      event_id: '125.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: 'parametr_podelitsya',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + eventContent[1],
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "Скопировать" "Закрыть" на попапе "Поделиться подборкой" на странице подборки
	  collectionShareDialogButtonsClick: function collectionShareDialogButtonsClick(_ref84) {
	    var eventLabel = _ref84.eventLabel,
	        eventContext = _ref84.eventContext,
	        user_id = _ref84.user_id;
	    return {
	      event_id: '126.0',
	      screenName: '/collections/manage/',
	      eventName: 'nxAppCollection',
	      eventCategory: 'app_collections',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: 'podelitsya_podborkoi',
	      eventContext: (0, _transliterate2.default)(eventContext),
	      user_id: user_id
	    };
	  },
	
	  // Клик на элементы на карточке объекта на странице "Избранное" на странице избранное
	  favoritesBuildingCardButtonsClick: function favoritesBuildingCardButtonsClick(_ref85) {
	    var eventLabel = _ref85.eventLabel,
	        eventContent = _ref85.eventContent,
	        user_id = _ref85.user_id;
	    return {
	      event_id: '127.0',
	      screenName: '/favorites/',
	      eventName: 'nxAppFavourite',
	      eventCategory: 'app_favourite',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Показ вспылвающих окон "ЖК удален из избранного"  или "ЖК добавлен в избранного" на странице избранное
	  favoritesAddAndDeleteBuildingResult: function favoritesAddAndDeleteBuildingResult(_ref86) {
	    var eventLabel = _ref86.eventLabel,
	        eventContent = _ref86.eventContent,
	        user_id = _ref86.user_id;
	    return {
	      event_id: '128.0',
	      screenName: '/favorites/',
	      eventName: 'nxAppFavourite',
	      eventCategory: 'app_favourite',
	      eventAction: 'element_show',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "Отменить" "Закрыть" на всплывающих окнах "ЖК удален из избранного" и "ЖК добавлен в избранное" на странице избранное
	  favoritesNotificationButtonsClick: function favoritesNotificationButtonsClick(_ref87) {
	    var eventLabel = _ref87.eventLabel,
	        eventContent = _ref87.eventContent,
	        user_id = _ref87.user_id;
	    return {
	      event_id: '129.0',
	      screenName: '/favorites/',
	      eventName: 'nxAppFavourite',
	      eventCategory: 'app_favourite',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку "Связаться с нами" на любой странице сайта
	  supportClick: function supportClick(_ref88) {
	    var screenName = _ref88.screenName,
	        user_id = _ref88.user_id;
	    return {
	      event_id: '130.0',
	      screenName: screenName,
	      eventName: 'nxAppContact',
	      eventCategory: 'app_contact',
	      eventAction: 'element_click',
	      eventLabel: 'svyazatsya_s_nami',
	      user_id: user_id
	    };
	  },
	
	  // Клик на выбор способа связи в меню "Связаться с нами" на любой странице сайта
	  supportDialogButtonsClick: function supportDialogButtonsClick(_ref89) {
	    var screenName = _ref89.screenName,
	        eventLabel = _ref89.eventLabel,
	        user_id = _ref89.user_id;
	    return {
	      event_id: '131.0',
	      screenName: screenName,
	      eventName: 'nxAppContact',
	      eventCategory: 'app_contact',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Клик на локацию в попапе выбор страны
	  locationDialogButtonsClick: function locationDialogButtonsClick(_ref90) {
	    var eventContent = _ref90.eventContent,
	        user_id = _ref90.user_id;
	    return {
	      event_id: '132.0',
	      screenName: '/',
	      eventName: 'nxAppLocation',
	      eventCategory: 'app_location',
	      eventAction: 'element_click',
	      eventLabel: 'lokaciya',
	      eventContent: (0, _transliterate2.default)(eventContent[0]) + ' | ' + (0, _transliterate2.default)(eventContent[1]),
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопку "выйти" и "отмена" после клика на "выход из агенства" на странице профиля
	  leaveAgencyDialogButtonsClick: function leaveAgencyDialogButtonsClick(_ref91) {
	    var eventLabel = _ref91.eventLabel,
	        user_id = _ref91.user_id;
	    return {
	      event_id: '133.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContent: 'vyiti_iz_agentstva',
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "Выйти из аккаунта" и "Выйти из агенства" на экране "Доступ приостановлен"
	  agencyNoAccessButtonsClick: function agencyNoAccessButtonsClick(_ref92) {
	    var eventLabel = _ref92.eventLabel,
	        user_id = _ref92.user_id;
	    return {
	      event_id: '134.0',
	      screenName: '/',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContext: 'dostup_priostanovlen',
	      user_id: user_id
	    };
	  },
	
	  // Клик на кнопки "Выйти" и "Отмена" на попапе после нажатия "Выйти из агентсва" на экране "Доступ приостановлен"
	  agencyNoAccessDialogButtonsClick: function agencyNoAccessDialogButtonsClick(_ref93) {
	    var screenName = _ref93.screenName,
	        eventLabel = _ref93.eventLabel,
	        user_id = _ref93.user_id;
	    return {
	      event_id: '136.0',
	      screenName: screenName,
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContent: 'vyiti_iz_agentstva',
	      eventContext: 'dostup_priostanovlen',
	      user_id: user_id
	    };
	  },
	
	  // Показ информационного баннера на любой странице
	  infoBannerShow: function infoBannerShow(_ref94) {
	    var screenName = _ref94.screenName,
	        eventContent = _ref94.eventContent,
	        user_id = _ref94.user_id;
	    return {
	      event_id: '137.0',
	      screenName: screenName,
	      eventName: 'nxAppBanner',
	      eventCategory: 'app_banner',
	      eventAction: 'banner_show',
	      eventLabel: 'banner_info',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик по информационному баннеру на любой странице
	  infoBannerClick: function infoBannerClick(_ref95) {
	    var screenName = _ref95.screenName,
	        eventContent = _ref95.eventContent,
	        user_id = _ref95.user_id;
	    return {
	      event_id: '138.0',
	      screenName: screenName,
	      eventName: 'nxAppBanner',
	      eventCategory: 'app_banner',
	      eventAction: 'banner_click',
	      eventLabel: 'banner_info',
	      eventContent: (0, _transliterate2.default)(eventContent),
	      user_id: user_id
	    };
	  },
	
	  // Клик на документ на странице объекта
	  documentClick: function documentClick(_ref96) {
	    var screenName = _ref96.screenName,
	        productType = _ref96.productType,
	        productName = _ref96.productName,
	        productID = _ref96.productID,
	        user_id = _ref96.user_id;
	    return {
	      event_id: '139.0',
	      screenName: screenName,
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: 'skachivanie_dokumenta',
	      eventContent: (0, _transliterate2.default)(productName),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик на странице объекта на кнопку:
	  // - показать контакты
	  // - записаться на показ
	  // - сообщить о неточности
	  buildingRightMenuButtonsClick: function buildingRightMenuButtonsClick(_ref97) {
	    var eventLabel = _ref97.eventLabel,
	        productType = _ref97.productType,
	        productName = _ref97.productName,
	        productID = _ref97.productID,
	        user_id = _ref97.user_id;
	    return {
	      event_id: '140.0',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(productName),
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // В процессе записи на показ в модальном окне клик на:
	  // - вкладку "ОФФЛАЙН" или "ОНЛАЙН", где осуществляется выбор свободного тайм-слота
	  // - кнопку "Далее"
	  // - кнопку "Записаться"
	  // - кнопку "В мои записи", где осуществляется информирование, что запись успшно осуществлена
	  // - кнопку "Хорошо", где осуществляется информирование, что запись успешно осуществлена
	  appointmentDialogButtonsClick: function appointmentDialogButtonsClick(_ref98) {
	    var eventLabel = _ref98.eventLabel,
	        productType = _ref98.productType,
	        productName = _ref98.productName,
	        productID = _ref98.productID,
	        user_id = _ref98.user_id;
	    return {
	      event_id: '141.0',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(productName),
	      eventContext: 'zapis_na_pokaz',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показа модального окна информирующего об успешной записи на показ
	  appointmentDialogConfirmedResultShow: function appointmentDialogConfirmedResultShow(_ref99) {
	    var productType = _ref99.productType,
	        productName = _ref99.productName,
	        productID = _ref99.productID,
	        user_id = _ref99.user_id;
	    return {
	      event_id: '142.0',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'confirmed',
	      eventLabel: 'uspeshnaya_zapis_na_pokaz',
	      eventContent: (0, _transliterate2.default)(productName),
	      eventContext: 'zapis_na_pokaz',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показа модального окна информирующего о неуспешной записи на показ
	  appointmentDialogRejectedResultShow: function appointmentDialogRejectedResultShow(_ref100) {
	    var productType = _ref100.productType,
	        productName = _ref100.productName,
	        productID = _ref100.productID,
	        user_id = _ref100.user_id;
	    return {
	      event_id: '143.0',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'confirmed',
	      eventLabel: 'neuspeshnaya_zapis_na_pokaz',
	      eventContent: (0, _transliterate2.default)(productName),
	      eventContext: 'neuspeshnaya_zapis_na_pokaz',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик в модальном окне записи на показ, где осуществляется информирование, что запись осуществить не удалось на кнопку:
	  // - Перезаписаться
	  // - Закрыть
	  appointmentDialogRejectedResultButtonClick: function appointmentDialogRejectedResultButtonClick(_ref101) {
	    var eventLabel = _ref101.eventLabel,
	        productType = _ref101.productType,
	        productName = _ref101.productName,
	        productID = _ref101.productID,
	        user_id = _ref101.user_id;
	    return {
	      event_id: '144.0',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'button_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(productName),
	      eventContext: 'neuspeshnaya_zapis_na_pokaz',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик в профиле на вкладку:
	  // - Мои записи
	  // - Мои данные
	  profileTabsClick: function profileTabsClick(_ref102) {
	    var eventLabel = _ref102.eventLabel,
	        user_id = _ref102.user_id;
	    return {
	      event_id: '145.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      user_id: user_id
	    };
	  },
	
	  // Клик на экране "Мои записи" на вклакду:
	  // - Будущие
	  // - Прошедшие
	  profileAppointmentsTabsClick: function profileAppointmentsTabsClick(_ref103) {
	    var eventLabel = _ref103.eventLabel,
	        user_id = _ref103.user_id;
	    return {
	      event_id: '146.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContext: 'moi_zapisi',
	      user_id: user_id
	    };
	  },
	
	  // Клик на экране "Мои записи" на:
	  // - кнопку "Смотреть"
	  profileAppointmentButtonClick: function profileAppointmentButtonClick(_ref104) {
	    var eventContent = _ref104.eventContent,
	        productType = _ref104.productType,
	        productName = _ref104.productName,
	        productID = _ref104.productID,
	        user_id = _ref104.user_id;
	    return {
	      event_id: '147.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_click',
	      eventLabel: 'smotret',
	      eventContent: eventContent,
	      eventContext: 'moi_zapisi',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Показ карточки записи на показ
	  profileAppointmentCardShow: function profileAppointmentCardShow(_ref105) {
	    var eventContent = _ref105.eventContent,
	        productType = _ref105.productType,
	        productName = _ref105.productName,
	        productID = _ref105.productID,
	        user_id = _ref105.user_id;
	    return {
	      event_id: '148.0',
	      screenName: '/profile',
	      eventName: 'nxAppProfile',
	      eventCategory: 'app_profile',
	      eventAction: 'element_show',
	      eventLabel: 'kartochka_zapisi_na_pokaz',
	      eventContent: eventContent,
	      eventContext: 'moi_zapisi',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  },
	
	  // Клик в модальном окне контактов на:
	  // - номер телефона
	  // - иконку telegram
	  // - иконку whatsApp
	  contactsDialogButtonsClick: function contactsDialogButtonsClick(_ref106) {
	    var eventLabel = _ref106.eventLabel,
	        productType = _ref106.productType,
	        productName = _ref106.productName,
	        productID = _ref106.productID,
	        user_id = _ref106.user_id;
	    return {
	      event_id: '149.1',
	      screenName: '/building',
	      eventName: 'nxAppObjectPage',
	      eventCategory: 'app_object_page',
	      eventAction: 'element_click',
	      eventLabel: eventLabel,
	      eventContent: (0, _transliterate2.default)(productName),
	      eventContext: 'kontakty',
	      productType: productType,
	      productName: (0, _transliterate2.default)(productName),
	      productID: productID,
	      user_id: user_id
	    };
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(34)
	  , core      = __webpack_require__(62)
	  , hide      = __webpack_require__(95)
	  , redefine  = __webpack_require__(81)
	  , ctx       = __webpack_require__(79)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.operate = exports.hasLift = void 0;
	var isFunction_1 = __webpack_require__(27);
	function hasLift(source) {
	    return isFunction_1.isFunction(source === null || source === void 0 ? void 0 : source.lift);
	}
	exports.hasLift = hasLift;
	function operate(init) {
	    return function (source) {
	        if (hasLift(source)) {
	            return source.lift(function (liftedSource) {
	                try {
	                    return init(liftedSource, this);
	                }
	                catch (err) {
	                    this.error(err);
	                }
	            });
	        }
	        throw new TypeError('Unable to lift unknown Observable type');
	    };
	}
	exports.operate = operate;
	//# sourceMappingURL=lift.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OperatorSubscriber = exports.createOperatorSubscriber = void 0;
	var Subscriber_1 = __webpack_require__(192);
	function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
	    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
	}
	exports.createOperatorSubscriber = createOperatorSubscriber;
	var OperatorSubscriber = (function (_super) {
	    __extends(OperatorSubscriber, _super);
	    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
	        var _this = _super.call(this, destination) || this;
	        _this.onFinalize = onFinalize;
	        _this.shouldUnsubscribe = shouldUnsubscribe;
	        _this._next = onNext
	            ? function (value) {
	                try {
	                    onNext(value);
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	            }
	            : _super.prototype._next;
	        _this._error = onError
	            ? function (err) {
	                try {
	                    onError(err);
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	                finally {
	                    this.unsubscribe();
	                }
	            }
	            : _super.prototype._error;
	        _this._complete = onComplete
	            ? function () {
	                try {
	                    onComplete();
	                }
	                catch (err) {
	                    destination.error(err);
	                }
	                finally {
	                    this.unsubscribe();
	                }
	            }
	            : _super.prototype._complete;
	        return _this;
	    }
	    OperatorSubscriber.prototype.unsubscribe = function () {
	        var _a;
	        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
	            var closed_1 = this.closed;
	            _super.prototype.unsubscribe.call(this);
	            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
	        }
	    };
	    return OperatorSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OperatorSubscriber = OperatorSubscriber;
	//# sourceMappingURL=OperatorSubscriber.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(260);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printNumber = exports.getTarifPeriodName = exports.getTarifName = exports.getUserRole = exports.formatTime = exports.formatDate = exports.updateStringPrint = exports.updateString = exports.monthToString = exports.initAxios = exports.compileQuery = exports.parseQuery = exports.formatNumber = exports.formatPhoneNumber = exports.pluralize = exports.addUrlProtocol = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(92);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addUrlProtocol = exports.addUrlProtocol = function addUrlProtocol(url) {
	  var protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https';
	  return url ? protocol + '://' + url.replace(/(http|https):\/\//, '') : url;
	};
	
	var pluralize = exports.pluralize = function pluralize(n, one, few, many) {
	  var num = n ? Number(n) : 0;
	  if (num >= 10 && num <= 19) return many;
	
	  var lastDigit = num % 10;
	  if (lastDigit === 1) return one;
	  if (lastDigit >= 2 && lastDigit <= 4) return few;
	  return many;
	};
	
	var formatPhoneNumber = exports.formatPhoneNumber = function formatPhoneNumber(s) {
	  var s2 = ('' + s).replace(/\D/g, '');
	  var m = s2.match(/^(7|8)(\d{3})(\d{3})(\d{2})(\d{2})$/);
	  return !m ? s : (m[1] === '7' ? '+7' : '8') + ' (' + m[2] + ') ' + m[3] + '-' + m[4] + '-' + m[5];
	};
	
	var formatNumber = exports.formatNumber = function formatNumber(s) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
	
	  var parts = s.toString().split('.');
	  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
	  return parts.join('.');
	};
	
	var parseQuery = exports.parseQuery = function parseQuery(query) {
	  return query ? query.replace(/^\?/, '').split('&').reduce(function (prev, cur) {
	    var _cur$split = cur.split('='),
	        _cur$split2 = _slicedToArray(_cur$split, 2),
	        key = _cur$split2[0],
	        value = _cur$split2[1];
	
	    if (key) {
	      prev[key] = value;
	    }
	    return prev;
	  }, {}) : {};
	};
	var typeFilters = ['new', 'viewAction', 'orderField', 'blackList'];
	
	var compileQuery = exports.compileQuery = function compileQuery(params, query) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (compileQuery.lastParams === params && compileQuery.lastQuery === query) {
	    return compileQuery.cache;
	  }
	  compileQuery.lastParams = params;
	  compileQuery.lastQuery = query;
	  var prevParams = parseQuery(query);
	  var nextParams = _extends({}, prevParams);
	  Object.keys(params).forEach(function (key) {
	    var value = params[key];
	    if (value == null || typeFilters.includes(value)) {
	      delete nextParams[key];
	    } else {
	      nextParams[key] = value;
	    }
	  });
	  if (options.withoutTypeFilters) {
	    Object.keys(nextParams).forEach(function (key) {
	      return typeFilters.includes(key) && delete nextParams[key];
	    });
	  }
	
	  compileQuery.cache = Object.keys(nextParams).reduce(function (prev, cur) {
	    prev.push(cur + '=' + nextParams[cur]);
	    return prev;
	  }, []).join('&');
	
	  return compileQuery.cache;
	};
	
	var initAxios = exports.initAxios = function initAxios(token) {
	  // header('Content-type: text/html; charset=utf-8');
	  window.axios = _axios2.default;
	  if (token) {
	    _axios2.default.defaults.headers.common['x-api-token'] = token;
	  } else {
	    delete _axios2.default.defaults.headers.common['x-api-token'];
	  }
	};
	
	var monthToString = exports.monthToString = function monthToString(month) {
	  if (month >= 0 && month <= 11) {
	    return _i18n2.default.t('utils.monthToString.' + month);
	  }
	
	  return '';
	};
	
	var updateString = exports.updateString = function updateString(updated) {
	  if (!updated) {
	    return null;
	  }
	
	  var date = new Date(updated * 1000);
	  date.setHours(date.getHours() + 3); // Cast from Moscow Time to UTC, may be a server-side problem?
	  var now = new Date();
	
	  if (date.toDateString() === now.toDateString()) {
	    return _i18n2.default.t('utils.updateString.todayAt', {
	      time: date.toTimeString().slice(0, 5)
	    });
	  } else if (date.getFullYear() === now.getFullYear()) {
	    return date.getDate() + ' ' + monthToString(date.getMonth());
	  }
	  return date.getDate() + ' ' + monthToString(date.getMonth()) + ' ' + date.getFullYear();
	};
	
	var updateStringPrint = exports.updateStringPrint = function updateStringPrint(updated) {
	  if (!updated) {
	    return null;
	  }
	  var date = new Date(updated * 1000);
	  date.setHours(date.getHours() + 3); // Cast from Moscow Time to UTC, may be a server-side problem?
	  var now = new Date();
	
	  if (date.getFullYear() === now.getFullYear()) {
	    return date.getDate() + ' ' + monthToString(date.getMonth());
	  }
	  return date.getDate() + ' ' + monthToString(date.getMonth()) + ' ' + date.getFullYear();
	};
	
	var formatDate = exports.formatDate = function formatDate(d) {
	  var date = new Date(d.replace(/-/g, '/')); // Fix for safari
	  var day = new Date();
	  if (date.toDateString() === day.toDateString()) {
	    return _i18n2.default.t('utils.formatDate.today');
	  }
	  day.setDate(day.getDate() - 1);
	  if (date.toDateString() === day.toDateString()) {
	    return _i18n2.default.t('utils.formatDate.yesterday');
	  }
	  return date.getDate() + ' ' + monthToString(date.getMonth()) + (date.getFullYear() < day.getFullYear() ? ' ' + date.getFullYear() : '');
	};
	
	var formatTime = exports.formatTime = function formatTime(d) {
	  var date = new Date(d.replace(/-/g, '/')); // Fix for safari
	  date.setHours(date.getHours());
	  return date.toTimeString().slice(0, 5);
	};
	
	var getUserRole = exports.getUserRole = function getUserRole(_ref) {
	  var agencyName = _ref.agencyName,
	      roleName = _ref.roleName;
	
	  if (roleName === 'owner') {
	    return _constants.USER_ROLE.ADMIN;
	  }
	  if (roleName === 'agent' && agencyName) {
	    return _constants.USER_ROLE.WORKER;
	  }
	  if (roleName === 'agent' && !agencyName) {
	    return _constants.USER_ROLE.INDIVIDUAL;
	  }
	};
	
	var getTarifName = exports.getTarifName = function getTarifName(name) {
	  switch (name) {
	    case _constants.TARIFFS.COMPANY:
	      return _i18n2.default.t('utils.getTarifName.company');
	    case _constants.TARIFFS.PERSONAL:
	      return _i18n2.default.t('utils.getTarifName.personal');
	    case _constants.TARIFFS.COMPANY_TEST:
	      return _i18n2.default.t('utils.getTarifName.test');
	    case _constants.TARIFFS.PERSONAL_TEST:
	      return _i18n2.default.t('utils.getTarifName.test');
	    default:
	      console.warn('No such tarif name: ', name);
	      return _i18n2.default.t('utils.getTarifName.test');
	  }
	};
	
	var getTarifPeriodName = exports.getTarifPeriodName = function getTarifPeriodName(name) {
	  switch (name) {
	    case _constants.TARIFFS.COMPANY:
	      return _i18n2.default.t('utils.getTarifPeriodName.company');
	    case _constants.TARIFFS.PERSONAL:
	      return _i18n2.default.t('utils.getTarifPeriodName.company');
	    case _constants.TARIFFS.COMPANY_TEST:
	      return _i18n2.default.t('utils.getTarifPeriodName.test');
	    case _constants.TARIFFS.PERSONAL_TEST:
	      return _i18n2.default.t('utils.getTarifPeriodName.test');
	    default:
	      console.warn('No such tarif name: ', name);
	      return _i18n2.default.t('utils.getTarifPeriodName.test');
	  }
	};
	
	var printNumber = exports.printNumber = function printNumber(number) {
	  if (number != null) {
	    return number;
	  }
	
	  return '';
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(686);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var isFunction_1 = __webpack_require__(210);
	var Observer_1 = __webpack_require__(841);
	var Subscription_1 = __webpack_require__(45);
	var rxSubscriber_1 = __webpack_require__(456);
	var config_1 = __webpack_require__(297);
	var hostReportError_1 = __webpack_require__(458);
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    function Subscriber(destinationOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        _this.syncErrorValue = null;
	        _this.syncErrorThrown = false;
	        _this.syncErrorThrowable = false;
	        _this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                _this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    _this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
	                        _this.destination = destinationOrNext;
	                        destinationOrNext.add(_this);
	                    }
	                    else {
	                        _this.syncErrorThrowable = true;
	                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                _this.syncErrorThrowable = true;
	                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
	                break;
	        }
	        return _this;
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _parentOrParents = this._parentOrParents;
	        this._parentOrParents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parentOrParents = _parentOrParents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        _this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = _this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    _this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = _this.unsubscribe.bind(_this);
	            }
	        }
	        _this._context = context;
	        _this._next = next;
	        _this._error = error;
	        _this._complete = complete;
	        return _this;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!config_1.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            var useDeprecatedSynchronousErrorHandling = config_1.config.useDeprecatedSynchronousErrorHandling;
	            if (this._error) {
	                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                if (useDeprecatedSynchronousErrorHandling) {
	                    throw err;
	                }
	                hostReportError_1.hostReportError(err);
	            }
	            else {
	                if (useDeprecatedSynchronousErrorHandling) {
	                    _parentSubscriber.syncErrorValue = err;
	                    _parentSubscriber.syncErrorThrown = true;
	                }
	                else {
	                    hostReportError_1.hostReportError(err);
	                }
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!config_1.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	                throw err;
	            }
	            else {
	                hostReportError_1.hostReportError(err);
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        if (!config_1.config.useDeprecatedSynchronousErrorHandling) {
	            throw new Error('bad call');
	        }
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	                parent.syncErrorValue = err;
	                parent.syncErrorThrown = true;
	                return true;
	            }
	            else {
	                hostReportError_1.hostReportError(err);
	                return true;
	            }
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	exports.SafeSubscriber = SafeSubscriber;
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1763)();
	}


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CLIENT_ID = exports.CLIENT_ID = 'f4323c6f7c0cd73d2d786a2b1cdae80c';
	var MAP_API_KEY = exports.MAP_API_KEY = 'AIzaSyDHgBKhbpf43KlsthHUHpl8vK_gN0JskJ0';
	
	var domain = exports.domain = 'nedvex';
	var currentUrl = window.location.hostname;
	
	function getApiUrl() {
	  switch (currentUrl) {
	    case 'test.nedvex.ru':
	      return 'https://testapi.nedvex.ru';
	    case 'preprod.app.nedvex.ru':
	      return 'https://preprod.api.nedvex.ru';
	    case 'test.app.nedvex.ru':
	      return 'https://api.nedvex.pro';
	    case 'app.nedvex.ru':
	      return 'https://api.nedvex.ru';
	    default:
	      return 'https://api.nedvex.pro';
	  }
	}
	
	function getDocumentBaseUrl() {
	  switch (currentUrl) {
	    case 'test.nedvex.ru':
	      return 'https://testapi.nedvex.ru';
	    case 'test.app.nedvex.ru':
	      return 'https://cp.nedvex.ru';
	    case 'app.nedvex.ru':
	      return 'https://cp.nedvex.pro';
	    default:
	      return 'https://cp.nedvex.ru';
	  }
	}
	
	var ROOT_URL = exports.ROOT_URL = getApiUrl();
	var DOCUMENT_BASE_URL = exports.DOCUMENT_BASE_URL = getDocumentBaseUrl();
	var ROOT_URL_AUTH = exports.ROOT_URL_AUTH = 'https://prodapp.' + domain + '.net';
	// ~location.origin.indexOf('portaldev') ?
	// 'http://devapp.nedvex.net:84' :
	// 'https://prodapp.nedvex.net'
	
	var CDN = exports.CDN = 'https://' + domain + '.ru/cdn';
	
	// Hardcoded panormas for a while
	var ROOM_LIST = exports.ROOM_LIST = {
	  '11-46': 0,
	  '2-66': 1,
	  '3-68': 3,
	  '4-40.1': 4,
	  '5-32': 5,
	  '6-36.7': 6,
	  '7-38': 7,
	  '8-44.1': 8,
	  '9-44.1': 9,
	  '11-61.1': 10,
	  '12-43.7': 11,
	  '4-34.8': 12,
	  '5-34.8': 13,
	  '6-31.3': 14,
	  '7-31.3': 15,
	  '8-32.6': 16
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _curry2 = __webpack_require__(3);
	var _isPlaceholder = __webpack_require__(260);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ym = __webpack_require__(1177);
	
	var _ym2 = _interopRequireDefault(_ym);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tracker = function () {
	  function Tracker(_ref) {
	    var _ref$services = _ref.services,
	        services = _ref$services === undefined ? [] : _ref$services;
	
	    _classCallCheck(this, Tracker);
	
	    this.services = services;
	  }
	
	  _createClass(Tracker, [{
	    key: 'sendEvent',
	    value: function sendEvent(eventName) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      console.log('tracker', eventName, params);
	      this.services.forEach(function (service) {
	        return service.sendEvent(eventName, params);
	      });
	    }
	  }, {
	    key: 'sendEventOnce',
	    value: function sendEventOnce(eventName) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var isSent = localStorage.getItem(eventName);
	
	      if (isSent) {
	        return;
	      }
	
	      localStorage.setItem(eventName, '1');
	      this.sendEvent(eventName, params);
	    }
	  }, {
	    key: 'sendVariantEvent',
	    value: function sendVariantEvent(_ref2) {
	      var variants = _ref2.variants,
	          key = _ref2.key,
	          selected = _ref2.selected,
	          _ref2$eventData = _ref2.eventData,
	          eventData = _ref2$eventData === undefined ? {} : _ref2$eventData;
	
	      var variant = Object.values(variants).find(function (item) {
	        return item.key === key;
	      });
	
	      if (variant && variant.event) {
	        this.sendEvent(variant.event, _extends({}, eventData, {
	          selected: selected
	        }));
	      }
	    }
	  }]);
	
	  return Tracker;
	}();
	
	var tracker = new Tracker({
	  services: [_ym2.default]
	});
	
	exports.default = tracker;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeIsMobile = changeIsMobile;
	exports.changeWidthAndHeight = changeWidthAndHeight;
	exports.setPopUp = setPopUp;
	exports.initEnvironment = initEnvironment;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function changeIsMobile(isMobile) {
	  return {
	    type: types.CHANGE_IS_MOBILE,
	    isMobile: isMobile
	  };
	} /* global navigator */
	
	function changeWidthAndHeight(height, width) {
	  return {
	    type: types.CHANGE_WIDTH_AND_HEIGHT,
	    height: height,
	    width: width
	  };
	}
	
	function setPopUp(popUp, popUpProps) {
	  return {
	    type: types.SET_POPUP,
	    popUp: popUp,
	    popUpProps: popUpProps
	  };
	}
	
	function initEnvironment() {
	  return function (dispatch) {
	    dispatch({ type: 'INIT_APP' });
	    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	    // if (isMobile) {
	    // document.body.style.overflow = 'hidden';
	    // }
	    dispatch(changeIsMobile(isMobile));
	
	    var onResize = function onResize() {
	      return dispatch(changeWidthAndHeight(window.innerHeight, window.innerWidth));
	    };
	    onResize();
	    window.onresize = onResize;
	  };
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(1626);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ru = __webpack_require__(1642);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_i18next2.default.use(_reactI18next.initReactI18next) // passes i18n down to react-i18next
	.init({
	  resources: {
	    ru: {
	      translation: _ru2.default
	    }
	  },
	  lng: 'ru',
	  fallbackLng: 'en',
	  debug: true,
	  interpolation: {
	    escapeValue: false // not needed for react as it escapes by default
	
	    /* react: {
	      bindI18n: 'languageChanged',
	      bindI18nStore: '',
	      transEmptyNodeValue: '',
	      transSupportBasicHtmlNodes: true,
	      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
	      useSuspense: true
	    } */
	  } });
	
	if (localStorage.getItem('debug') === '*') {
	  document.addEventListener('keydown', function (event) {
	    if (event.key === 'l') {
	      _i18next2.default.changeLanguage(_i18next2.default.language === 'ru' ? 'en' : 'ru');
	    }
	  });
	}
	
	exports.default = _i18next2.default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _splice = _interopRequireDefault(__webpack_require__(2199));
	
	var _getIn = _interopRequireDefault(__webpack_require__(2196));
	
	var _setIn = _interopRequireDefault(__webpack_require__(2198));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(2194));
	
	var _deleteIn = _interopRequireDefault(__webpack_require__(2195));
	
	var _keys = _interopRequireDefault(__webpack_require__(2197));
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn["default"],
	  setIn: _setIn["default"],
	  deepEqual: _deepEqual["default"],
	  deleteIn: _deleteIn["default"],
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys["default"],
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice["default"],
	  equals: function equals(a, b) {
	    return b.every(function (val) {
	      return ~a.indexOf(val);
	    });
	  },
	  orderChanged: function orderChanged(a, b) {
	    return b.some(function (val, index) {
	      return val !== a[index];
	    });
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports["default"] = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __asyncValues = (this && this.__asyncValues) || function (o) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var m = o[Symbol.asyncIterator], i;
	    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	};
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromReadableStreamLike = exports.fromAsyncIterable = exports.fromIterable = exports.fromPromise = exports.fromArrayLike = exports.fromInteropObservable = exports.innerFrom = void 0;
	var isArrayLike_1 = __webpack_require__(441);
	var isPromise_1 = __webpack_require__(835);
	var Observable_1 = __webpack_require__(28);
	var isInteropObservable_1 = __webpack_require__(833);
	var isAsyncIterable_1 = __webpack_require__(832);
	var throwUnobservableError_1 = __webpack_require__(838);
	var isIterable_1 = __webpack_require__(834);
	var isReadableStreamLike_1 = __webpack_require__(443);
	var isFunction_1 = __webpack_require__(27);
	var reportUnhandledError_1 = __webpack_require__(837);
	var observable_1 = __webpack_require__(292);
	function innerFrom(input) {
	    if (input instanceof Observable_1.Observable) {
	        return input;
	    }
	    if (input != null) {
	        if (isInteropObservable_1.isInteropObservable(input)) {
	            return fromInteropObservable(input);
	        }
	        if (isArrayLike_1.isArrayLike(input)) {
	            return fromArrayLike(input);
	        }
	        if (isPromise_1.isPromise(input)) {
	            return fromPromise(input);
	        }
	        if (isAsyncIterable_1.isAsyncIterable(input)) {
	            return fromAsyncIterable(input);
	        }
	        if (isIterable_1.isIterable(input)) {
	            return fromIterable(input);
	        }
	        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
	            return fromReadableStreamLike(input);
	        }
	    }
	    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
	}
	exports.innerFrom = innerFrom;
	function fromInteropObservable(obj) {
	    return new Observable_1.Observable(function (subscriber) {
	        var obs = obj[observable_1.observable]();
	        if (isFunction_1.isFunction(obs.subscribe)) {
	            return obs.subscribe(subscriber);
	        }
	        throw new TypeError('Provided object does not correctly implement Symbol.observable');
	    });
	}
	exports.fromInteropObservable = fromInteropObservable;
	function fromArrayLike(array) {
	    return new Observable_1.Observable(function (subscriber) {
	        for (var i = 0; i < array.length && !subscriber.closed; i++) {
	            subscriber.next(array[i]);
	        }
	        subscriber.complete();
	    });
	}
	exports.fromArrayLike = fromArrayLike;
	function fromPromise(promise) {
	    return new Observable_1.Observable(function (subscriber) {
	        promise
	            .then(function (value) {
	            if (!subscriber.closed) {
	                subscriber.next(value);
	                subscriber.complete();
	            }
	        }, function (err) { return subscriber.error(err); })
	            .then(null, reportUnhandledError_1.reportUnhandledError);
	    });
	}
	exports.fromPromise = fromPromise;
	function fromIterable(iterable) {
	    return new Observable_1.Observable(function (subscriber) {
	        var e_1, _a;
	        try {
	            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
	                var value = iterable_1_1.value;
	                subscriber.next(value);
	                if (subscriber.closed) {
	                    return;
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        subscriber.complete();
	    });
	}
	exports.fromIterable = fromIterable;
	function fromAsyncIterable(asyncIterable) {
	    return new Observable_1.Observable(function (subscriber) {
	        process(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
	    });
	}
	exports.fromAsyncIterable = fromAsyncIterable;
	function fromReadableStreamLike(readableStream) {
	    return fromAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(readableStream));
	}
	exports.fromReadableStreamLike = fromReadableStreamLike;
	function process(asyncIterable, subscriber) {
	    var asyncIterable_1, asyncIterable_1_1;
	    var e_2, _a;
	    return __awaiter(this, void 0, void 0, function () {
	        var value, e_2_1;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    _b.trys.push([0, 5, 6, 11]);
	                    asyncIterable_1 = __asyncValues(asyncIterable);
	                    _b.label = 1;
	                case 1: return [4, asyncIterable_1.next()];
	                case 2:
	                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
	                    value = asyncIterable_1_1.value;
	                    subscriber.next(value);
	                    if (subscriber.closed) {
	                        return [2];
	                    }
	                    _b.label = 3;
	                case 3: return [3, 1];
	                case 4: return [3, 11];
	                case 5:
	                    e_2_1 = _b.sent();
	                    e_2 = { error: e_2_1 };
	                    return [3, 11];
	                case 6:
	                    _b.trys.push([6, , 9, 10]);
	                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
	                    return [4, _a.call(asyncIterable_1)];
	                case 7:
	                    _b.sent();
	                    _b.label = 8;
	                case 8: return [3, 10];
	                case 9:
	                    if (e_2) throw e_2.error;
	                    return [7];
	                case 10: return [7];
	                case 11:
	                    subscriber.complete();
	                    return [2];
	            }
	        });
	    });
	}
	//# sourceMappingURL=innerFrom.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var canReportError_1 = __webpack_require__(457);
	var toSubscriber_1 = __webpack_require__(2371);
	var observable_1 = __webpack_require__(157);
	var pipe_1 = __webpack_require__(461);
	var config_1 = __webpack_require__(297);
	var Observable = (function () {
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            sink.add(operator.call(sink, this.source));
	        }
	        else {
	            sink.add(this.source || (config_1.config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
	                this._subscribe(sink) :
	                this._trySubscribe(sink));
	        }
	        if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	            if (sink.syncErrorThrowable) {
	                sink.syncErrorThrowable = false;
	                if (sink.syncErrorThrown) {
	                    throw sink.syncErrorValue;
	                }
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	                sink.syncErrorThrown = true;
	                sink.syncErrorValue = err;
	            }
	            if (canReportError_1.canReportError(sink)) {
	                sink.error(err);
	            }
	            else {
	                console.warn(err);
	            }
	        }
	    };
	    Observable.prototype.forEach = function (next, promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                try {
	                    next(value);
	                }
	                catch (err) {
	                    reject(err);
	                    if (subscription) {
	                        subscription.unsubscribe();
	                    }
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        return source && source.subscribe(subscriber);
	    };
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    Observable.prototype.toPromise = function (promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	function getPromiseCtor(promiseCtor) {
	    if (!promiseCtor) {
	        promiseCtor = config_1.config.Promise || Promise;
	    }
	    if (!promiseCtor) {
	        throw new Error('no Promise impl found');
	    }
	    return promiseCtor;
	}
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Environment
	
	var CHANGE_IS_MOBILE = exports.CHANGE_IS_MOBILE = 'CHANGE_IS_MOBILE';
	var CHANGE_WIDTH_AND_HEIGHT = exports.CHANGE_WIDTH_AND_HEIGHT = 'CHANGE_WIDTH_AND_HEIGHT';
	var SET_POPUP = exports.SET_POPUP = 'SET_POPUP';
	
	// Objects
	
	var SET_SCROLL_TOP = exports.SET_SCROLL_TOP = 'SET_SCROLL_TOP';
	
	var LOAD_OBJECTS_START = exports.LOAD_OBJECTS_START = 'LOAD_OBJECTS_START';
	var LOAD_OBJECTS_SUCCESS = exports.LOAD_OBJECTS_SUCCESS = 'LOAD_OBJECTS_SUCCESS';
	var LOAD_OBJECTS_ERROR = exports.LOAD_OBJECTS_ERROR = 'LOAD_OBJECTS_ERROR';
	
	var LOAD_PINS_START = exports.LOAD_PINS_START = 'LOAD_PINS_START';
	var LOAD_PINS_SUCCESS = exports.LOAD_PINS_SUCCESS = 'LOAD_PINS_SUCCESS';
	var LOAD_PINS_ERROR = exports.LOAD_PINS_ERROR = 'LOAD_PINS_ERROR';
	
	var LOAD_POINT_START = exports.LOAD_POINT_START = 'LOAD_POINT_START';
	var LOAD_POINT_SUCCESS = exports.LOAD_POINT_SUCCESS = 'LOAD_POINT_SUCCESS';
	var LOAD_POINT_ERROR = exports.LOAD_POINT_ERROR = 'LOAD_POINT_ERROR';
	
	var LOAD_POINT_LIST_START = exports.LOAD_POINT_LIST_START = 'LOAD_POINT_LIST_START';
	var LOAD_POINT_LIST_SUCCESS = exports.LOAD_POINT_LIST_SUCCESS = 'LOAD_POINT_LIST_SUCCESS';
	var LOAD_POINT_LIST_ERROR = exports.LOAD_POINT_LIST_ERROR = 'LOAD_POINT_LIST_ERROR';
	
	// Search
	
	var FORCED_SEARCH_CHANGE = exports.FORCED_SEARCH_CHANGE = 'FORCED_SEARCH_CHANGE';
	var CHANGE_FILTERS = exports.CHANGE_FILTERS = 'CHANGE_FILTERS';
	var CHANGE_FOCUS = exports.CHANGE_FOCUS = 'CHANGE_FOCUS';
	var LOAD_AUTOCOMPLETE = exports.LOAD_AUTOCOMPLETE = 'LOAD_AUTOCOMPLETE';
	var LOAD_AUTOCOMPLETE_FETCHING = exports.LOAD_AUTOCOMPLETE_FETCHING = 'LOAD_AUTOCOMPLETE_FETCHING';
	var LOAD_AUTOCOMPLETE_SUCCESS = exports.LOAD_AUTOCOMPLETE_SUCCESS = 'LOAD_AUTOCOMPLETE_SUCCESS';
	var LOAD_AUTOCOMPLETE_ERROR = exports.LOAD_AUTOCOMPLETE_ERROR = 'LOAD_AUTOCOMPLETE_ERROR';
	var SET_SEARCH_VALUE = exports.SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
	var SET_SEARCH_MODAL_STATE = exports.SET_SEARCH_MODAL_STATE = 'SET_SEARCH_MODAL_STATE';
	
	// Building
	
	var LOAD_BUILDING_START = exports.LOAD_BUILDING_START = 'LOAD_BUILDING_START';
	var LOAD_BUILDING_SUCCESS = exports.LOAD_BUILDING_SUCCESS = 'LOAD_BUILDING_SUCCESS';
	var LOAD_BUILDING_ERROR = exports.LOAD_BUILDING_ERROR = 'LOAD_BUILDING_ERROR';
	var TOGGLE_CHESS = exports.TOGGLE_CHESS = 'TOGGLE_CHESS';
	
	var CREATE_INACCURACY_REPORT = exports.CREATE_INACCURACY_REPORT = 'CREATE_INACCURACY_REPORT';
	var CREATE_INACCURACY_REPORT_SUCCESS = exports.CREATE_INACCURACY_REPORT_SUCCESS = 'CREATE_INACCURACY_REPORT_SUCCESS';
	var CREATE_INACCURACY_REPORT_ERROR = exports.CREATE_INACCURACY_REPORT_ERROR = 'CREATE_INACCURACY_REPORT_ERROR';
	
	// Chess
	
	var LOAD_PAVILIONS_START = exports.LOAD_PAVILIONS_START = 'LOAD_PAVILIONS_START';
	var LOAD_PAVILIONS_SUCCESS = exports.LOAD_PAVILIONS_SUCCESS = 'LOAD_PAVILIONS_SUCCESS';
	var LOAD_PAVILIONS_ERROR = exports.LOAD_PAVILIONS_ERROR = 'LOAD_PAVILIONS_ERROR';
	var SET_CHESS_CELLS = exports.SET_CHESS_CELLS = 'SET_CHESS_CELLS';
	var SET_CHESS_FILTERS = exports.SET_CHESS_FILTERS = 'SET_CHESS_FILTERS';
	var SET_CELL_SELECTED = exports.SET_CELL_SELECTED = 'SET_CELL_SELECTED';
	var SET_CHESS_TABLE = exports.SET_CHESS_TABLE = 'SET_CHESS_TABLE';
	var SET_CHESS_EXTENDED = exports.SET_CHESS_EXTENDED = 'SET_CHESS_EXTENDED';
	var SET_CHESS_DESCRIPTION_HIDE = exports.SET_CHESS_DESCRIPTION_HIDE = 'SET_CHESS_DESCRIPTION_HIDE';
	var SET_LIST_SORT = exports.SET_LIST_SORT = 'SET_LIST_SORT';
	var SET_TABLE_SCROLL = exports.SET_TABLE_SCROLL = 'SET_TABLE_SCROLL';
	var SET_PREV_LOCATION = exports.SET_PREV_LOCATION = 'SET_PREV_LOCATION';
	var UPDATE_CHESS_STATE = exports.UPDATE_CHESS_STATE = 'UPDATE_CHESS_STATE';
	var SET_ZOOM = exports.SET_ZOOM = 'SET_ZOOM';
	var LOAD_CHESS_START = exports.LOAD_CHESS_START = 'LOAD_CHESS_START';
	var LOAD_CHESS_SUCCESS = exports.LOAD_CHESS_SUCCESS = 'LOAD_CHESS_SUCCESS';
	var LOAD_CHESS_ERROR = exports.LOAD_CHESS_ERROR = 'LOAD_CHESS_ERROR';
	
	// Documents
	
	var LOAD_DOCUMENTS_START = exports.LOAD_DOCUMENTS_START = 'LOAD_DOCUMENTS_START';
	var LOAD_DOCUMENTS_SUCCESS = exports.LOAD_DOCUMENTS_SUCCESS = 'LOAD_DOCUMENTS_SUCCESS';
	var LOAD_DOCUMENTS_ERROR = exports.LOAD_DOCUMENTS_ERROR = 'LOAD_DOCUMENTS_ERROR';
	
	// News
	
	var LOAD_NEWS_START = exports.LOAD_NEWS_START = 'LOAD_NEWS_START';
	var LOAD_NEWS_SUCCESS = exports.LOAD_NEWS_SUCCESS = 'LOAD_NEWS_SUCCESS';
	var LOAD_NEWS_ERROR = exports.LOAD_NEWS_ERROR = 'LOAD_NEWS_ERROR';
	
	// LoginForms
	
	var INVITE_FORM_SENDING_START = exports.INVITE_FORM_SENDING_START = 'INVITE_FORM_SENDING_START';
	var INVITE_FORM_SENDING_SUCCESS = exports.INVITE_FORM_SENDING_SUCCESS = 'INVITE_FORM_SENDING_SUCCESS';
	var INVITE_FORM_SENDING_ERROR = exports.INVITE_FORM_SENDING_ERROR = 'INVITE_FORM_SENDING_ERROR';
	
	var NUMBER_FORM_SENDING_START = exports.NUMBER_FORM_SENDING_START = 'NUMBER_FORM_SENDING_START';
	var NUMBER_FORM_SENDING_SUCCESS = exports.NUMBER_FORM_SENDING_SUCCESS = 'NUMBER_FORM_SENDING_SUCCESS';
	var NUMBER_FORM_SENDING_ERROR = exports.NUMBER_FORM_SENDING_ERROR = 'NUMBER_FORM_SENDING_ERROR';
	
	var SMS_FORM_SENDING_START = exports.SMS_FORM_SENDING_START = 'SMS_FORM_SENDING_START';
	var SMS_FORM_SENDING_SUCCESS = exports.SMS_FORM_SENDING_SUCCESS = 'SMS_FORM_SENDING_SUCCESS';
	var SMS_FORM_SENDING_ERROR = exports.SMS_FORM_SENDING_ERROR = 'SMS_FORM_SENDING_ERROR';
	
	var RESTORE_FORM_SENDING_START = exports.RESTORE_FORM_SENDING_START = 'RESTORE_FORM_SENDING_START';
	var RESTORE_FORM_SENDING_SUCCESS = exports.RESTORE_FORM_SENDING_SUCCESS = 'RESTORE_FORM_SENDING_SUCCESS';
	var RESTORE_FORM_SENDING_ERROR = exports.RESTORE_FORM_SENDING_ERROR = 'RESTORE_FORM_SENDING_ERROR';
	
	var RECONNECT_FORM_SENDING_START = exports.RECONNECT_FORM_SENDING_START = 'RECONNECT_FORM_SENDING_START';
	var RECONNECT_FORM_SENDING_SUCCESS = exports.RECONNECT_FORM_SENDING_SUCCESS = 'RECONNECT_FORM_SENDING_SUCCESS';
	var RECONNECT_FORM_SENDING_ERROR = exports.RECONNECT_FORM_SENDING_ERROR = 'RECONNECT_FORM_SENDING_ERROR';
	
	var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
	
	var USER_LOGOUT_START = exports.USER_LOGOUT_START = 'USER_LOGOUT_START';
	var USER_LOGOUT_SUCCESS = exports.USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
	var USER_LOGOUT_ERROR = exports.USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';
	
	var REQUEST_TOKEN_START = exports.REQUEST_TOKEN_START = 'REQUEST_TOKEN_START';
	var REQUEST_TOKEN_SUCCESS = exports.REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS';
	var REQUEST_TOKEN_ERROR = exports.REQUEST_TOKEN_ERROR = 'REQUEST_TOKEN_ERROR';
	
	// Profile
	
	var LOAD_PROFILE_START = exports.LOAD_PROFILE_START = 'LOAD_PROFILE_START';
	var LOAD_PROFILE_SUCCESS = exports.LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
	var LOAD_PROFILE_ERROR = exports.LOAD_PROFILE_ERROR = 'LOAD_PROFILE_ERROR';
	
	var EDIT_PROFILE_START = exports.EDIT_PROFILE_START = 'EDIT_PROFILE_START';
	var EDIT_PROFILE_SUCCESS = exports.EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
	var EDIT_PROFILE_ERROR = exports.EDIT_PROFILE_ERROR = 'EDIT_PROFILE_ERROR';
	
	var UPLOAD_PHOTO_START = exports.UPLOAD_PHOTO_START = 'UPLOAD_PHOTO_START';
	var UPLOAD_PHOTO_SUCCESS = exports.UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
	var UPLOAD_PHOTO_ERROR = exports.UPLOAD_PHOTO_ERROR = 'UPLOAD_PHOTO_ERROR';
	
	var UPLOAD_LOGO_REQUEST = exports.UPLOAD_LOGO_REQUEST = 'UPLOAD_LOGO_REQUEST';
	var UPLOAD_LOGO_OK = exports.UPLOAD_LOGO_OK = 'UPLOAD_LOGO_OK';
	var UPLOAD_LOGO_ERROR = exports.UPLOAD_LOGO_ERROR = 'UPLOAD_LOGO_ERROR';
	
	var CHECK_USER_PHONE_REQUEST = exports.CHECK_USER_PHONE_REQUEST = 'CHECK_USER_PHONE_REQUEST';
	var CHECK_USER_PHONE_OK = exports.CHECK_USER_PHONE_OK = 'CHECK_USER_PHONE_OK';
	var CHECK_USER_PHONE_ERROR = exports.CHECK_USER_PHONE_ERROR = 'CHECK_USER_PHONE_ERROR';
	
	// Collections
	
	var LOAD_COLLECTIONS_START = exports.LOAD_COLLECTIONS_START = 'LOAD_COLLECTIONS_START';
	var LOAD_COLLECTIONS_SUCCESS = exports.LOAD_COLLECTIONS_SUCCESS = 'LOAD_COLLECTIONS_SUCCESS';
	var LOAD_COLLECTIONS_ERROR = exports.LOAD_COLLECTIONS_ERROR = 'LOAD_COLLECTIONS_ERROR';
	
	var LOAD_COLLECTION_START = exports.LOAD_COLLECTION_START = 'LOAD_COLLECTION_START';
	var LOAD_COLLECTION_SUCCESS = exports.LOAD_COLLECTION_SUCCESS = 'LOAD_COLLECTION_SUCCESS';
	var LOAD_COLLECTION_ERROR = exports.LOAD_COLLECTION_ERROR = 'LOAD_COLLECTION_ERROR';
	
	var LOAD_COLLECTION_BUILDING_LOTS_START = exports.LOAD_COLLECTION_BUILDING_LOTS_START = 'LOAD_COLLECTION_BUILDING_LOTS_START';
	var LOAD_COLLECTION_BUILDING_LOTS_SUCCESS = exports.LOAD_COLLECTION_BUILDING_LOTS_SUCCESS = 'LOAD_COLLECTION_BUILDING_LOTS_SUCCESS';
	var LOAD_COLLECTION_BUILDING_LOTS_ERROR = exports.LOAD_COLLECTION_BUILDING_LOTS_ERROR = 'LOAD_COLLECTION_BUILDING_LOTS_ERROR';
	
	var LOAD_COLLECTION_BUILDING_START = exports.LOAD_COLLECTION_BUILDING_START = 'LOAD_COLLECTION_BUILDING_START';
	var LOAD_COLLECTION_BUILDING_SUCCESS = exports.LOAD_COLLECTION_BUILDING_SUCCESS = 'LOAD_COLLECTION_BUILDING_SUCCESS';
	var LOAD_COLLECTION_BUILDING_ERROR = exports.LOAD_COLLECTION_BUILDING_ERROR = 'LOAD_COLLECTION_BUILDING_ERROR';
	
	var SHARE_BUILDING_REQUEST = exports.SHARE_BUILDING_REQUEST = 'SHARE_BUILDING_REQUEST';
	var SHARE_BUILDING_SUCCESS = exports.SHARE_BUILDING_SUCCESS = 'SHARE_BUILDING_SUCCESS';
	var SHARE_BUILDING_ERROR = exports.SHARE_BUILDING_ERROR = 'SHARE_BUILDING_ERROR';
	
	var CREATE_COLLECTION_START = exports.CREATE_COLLECTION_START = 'CREATE_COLLECTION_START';
	var CREATE_COLLECTION_SUCCESS = exports.CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';
	var CREATE_COLLECTION_ERROR = exports.CREATE_COLLECTION_ERROR = 'CREATE_COLLECTION_ERROR';
	
	var DELETE_COLLECTION_START = exports.DELETE_COLLECTION_START = 'DELETE_COLLECTION_START';
	var DELETE_COLLECTION_SUCCESS = exports.DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
	var DELETE_COLLECTION_ERROR = exports.DELETE_COLLECTION_ERROR = 'DELETE_COLLECTION_ERROR';
	
	var ADD_TO_COLLECTION_START = exports.ADD_TO_COLLECTION_START = 'ADD_TO_COLLECTION_START';
	var ADD_TO_COLLECTION_SUCCESS = exports.ADD_TO_COLLECTION_SUCCESS = 'ADD_TO_COLLECTION_SUCCESS';
	var ADD_TO_COLLECTION_ERROR = exports.ADD_TO_COLLECTION_ERROR = 'ADD_TO_COLLECTION_ERROR';
	
	var REMOVE_FROM_COLLECTION_START = exports.REMOVE_FROM_COLLECTION_START = 'REMOVE_FROM_COLLECTION_START';
	var REMOVE_FROM_COLLECTION_SUCCESS = exports.REMOVE_FROM_COLLECTION_SUCCESS = 'REMOVE_FROM_COLLECTION_SUCCESS';
	var REMOVE_FROM_COLLECTION_ERROR = exports.REMOVE_FROM_COLLECTION_ERROR = 'REMOVE_FROM_COLLECTION_ERROR';
	
	var COMMENT_COLLECTION_START = exports.COMMENT_COLLECTION_START = 'COMMENT_COLLECTION_START';
	var COMMENT_COLLECTION_SUCCESS = exports.COMMENT_COLLECTION_SUCCESS = 'COMMENT_COLLECTION_SUCCESS';
	var COMMENT_COLLECTION_ERROR = exports.COMMENT_COLLECTION_ERROR = 'COMMENT_COLLECTION_ERROR';
	
	var DUP_COLLECTION_START = exports.DUP_COLLECTION_START = 'DUP_COLLECTION_START';
	var DUP_COLLECTION_SUCCESS = exports.DUP_COLLECTION_SUCCESS = 'DUP_COLLECTION_SUCCESS';
	var DUP_COLLECTION_ERROR = exports.DUP_COLLECTION_ERROR = 'DUP_COLLECTION_ERROR';
	
	var RENAME_COLLECTION_START = exports.RENAME_COLLECTION_START = 'RENAME_COLLECTION_START';
	var RENAME_COLLECTION_SUCCESS = exports.RENAME_COLLECTION_SUCCESS = 'RENAME_COLLECTION_SUCCESS';
	var RENAME_COLLECTION_ERROR = exports.RENAME_COLLECTION_ERROR = 'RENAME_COLLECTION_ERROR';
	
	var CHECK_BUILDING_START = exports.CHECK_BUILDING_START = 'CHECK_BUILDING_START';
	var CHECK_BUILDING_SUCCESS = exports.CHECK_BUILDING_SUCCESS = 'CHECK_BUILDING_SUCCESS';
	var CHECK_BUILDING_ERROR = exports.CHECK_BUILDING_ERROR = 'CHECK_BUILDING_ERROR';
	
	// Favorites
	
	var LOAD_FAVORITES_START = exports.LOAD_FAVORITES_START = 'LOAD_FAVORITES_START';
	var LOAD_FAVORITES_SUCCESS = exports.LOAD_FAVORITES_SUCCESS = 'LOAD_FAVORITES_SUCCESS';
	var LOAD_FAVORITES_ERROR = exports.LOAD_FAVORITES_ERROR = 'LOAD_FAVORITES_ERROR';
	
	var ADD_TO_FAVORITES_START = exports.ADD_TO_FAVORITES_START = 'ADD_TO_FAVORITES_START';
	var ADD_TO_FAVORITES_SUCCESS = exports.ADD_TO_FAVORITES_SUCCESS = 'ADD_TO_FAVORITES_SUCCESS';
	var ADD_TO_FAVORITES_ERROR = exports.ADD_TO_FAVORITES_ERROR = 'ADD_TO_FAVORITES_ERROR';
	
	var REMOVE_FROM_FAVORITES_START = exports.REMOVE_FROM_FAVORITES_START = 'REMOVE_FROM_FAVORITES_START';
	var REMOVE_FROM_FAVORITES_SUCCESS = exports.REMOVE_FROM_FAVORITES_SUCCESS = 'REMOVE_FROM_FAVORITES_SUCCESS';
	var REMOVE_FROM_FAVORITES_ERROR = exports.REMOVE_FROM_FAVORITES_ERROR = 'REMOVE_FROM_FAVORITES_ERROR';
	
	// Privacy
	
	var SWITCH_WITH_CLIENT = exports.SWITCH_WITH_CLIENT = 'SWITCH_WITH_CLIENT';
	
	// Payments
	
	var SHOW_PAYMENT_NOTIFCATION = exports.SHOW_PAYMENT_NOTIFCATION = 'SHOW_PAYMENT_NOTIFCATION';
	var HIDE_PAYMENT_NOTIFCATION = exports.HIDE_PAYMENT_NOTIFCATION = 'HIDE_PAYMENT_NOTIFCATION';
	
	var REQUEST_TO_CONNECT = exports.REQUEST_TO_CONNECT = 'REQUEST_TO_CONNECT';
	
	var GET_CITIES = exports.GET_CITIES = 'GET_CITIES';
	var SET_CITIES = exports.SET_CITIES = 'SET_CITIES';
	
	var GET_BANNER = exports.GET_BANNER = 'GET_BANNER';
	var SET_BANNER = exports.SET_BANNER = 'SET_BANNER';
	
	// Appointments
	
	var LOAD_CALENDAR = exports.LOAD_CALENDAR = 'LOAD_CALENDAR';
	var LOAD_CALENDAR_SUCCESS = exports.LOAD_CALENDAR_SUCCESS = 'LOAD_CALENDAR_SUCCESS';
	var LOAD_CALENDAR_ERROR = exports.LOAD_CALENDAR_ERROR = 'LOAD_CALENDAR_ERROR';
	
	var LOAD_APPOINTMENT_STATUSES = exports.LOAD_APPOINTMENT_STATUSES = 'LOAD_APPOINTMENT_STATUSES';
	var LOAD_APPOINTMENT_STATUSES_SUCCESS = exports.LOAD_APPOINTMENT_STATUSES_SUCCESS = 'LOAD_APPOINTMENT_STATUSES_SUCCESS';
	var LOAD_APPOINTMENT_STATUSES_ERROR = exports.LOAD_APPOINTMENT_STATUSES_ERROR = 'LOAD_APPOINTMENT_STATUSES_ERROR';
	
	var LOAD_CREATE_APPOINTMENT = exports.LOAD_CREATE_APPOINTMENT = 'LOAD_CREATE_APPOINTMENT';
	var LOAD_CREATE_APPOINTMENT_SUCCESS = exports.LOAD_CREATE_APPOINTMENT_SUCCESS = 'LOAD_CREATE_APPOINTMENT_SUCCESS';
	var LOAD_CREATE_APPOINTMENT_ERROR = exports.LOAD_CREATE_APPOINTMENT_ERROR = 'LOAD_CREATE_APPOINTMENT_ERROR';

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isFunction = void 0;
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Observable = void 0;
	var Subscriber_1 = __webpack_require__(192);
	var Subscription_1 = __webpack_require__(64);
	var observable_1 = __webpack_require__(292);
	var pipe_1 = __webpack_require__(294);
	var config_1 = __webpack_require__(193);
	var isFunction_1 = __webpack_require__(27);
	var errorContext_1 = __webpack_require__(440);
	var Observable = (function () {
	    function Observable(subscribe) {
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var _this = this;
	        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new Subscriber_1.SafeSubscriber(observerOrNext, error, complete);
	        errorContext_1.errorContext(function () {
	            var _a = _this, operator = _a.operator, source = _a.source;
	            subscriber.add(operator
	                ?
	                    operator.call(subscriber, source)
	                : source
	                    ?
	                        _this._subscribe(subscriber)
	                    :
	                        _this._trySubscribe(subscriber));
	        });
	        return subscriber;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.error(err);
	        }
	    };
	    Observable.prototype.forEach = function (next, promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var subscriber = new Subscriber_1.SafeSubscriber({
	                next: function (value) {
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscriber.unsubscribe();
	                    }
	                },
	                error: reject,
	                complete: resolve,
	            });
	            _this.subscribe(subscriber);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        var _a;
	        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
	    };
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i] = arguments[_i];
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    Observable.prototype.toPromise = function (promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	function getPromiseCtor(promiseCtor) {
	    var _a;
	    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config_1.config.Promise) !== null && _a !== void 0 ? _a : Promise;
	}
	function isObserver(value) {
	    return value && isFunction_1.isFunction(value.next) && isFunction_1.isFunction(value.error) && isFunction_1.isFunction(value.complete);
	}
	function isSubscriber(value) {
	    return (value && value instanceof Subscriber_1.Subscriber) || (isObserver(value) && Subscription_1.isSubscription(value));
	}
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Observable_1 = __webpack_require__(24);
	var subscribeTo_1 = __webpack_require__(305);
	var SimpleInnerSubscriber = (function (_super) {
	    __extends(SimpleInnerSubscriber, _super);
	    function SimpleInnerSubscriber(parent) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        return _this;
	    }
	    SimpleInnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(value);
	    };
	    SimpleInnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error);
	        this.unsubscribe();
	    };
	    SimpleInnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete();
	        this.unsubscribe();
	    };
	    return SimpleInnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SimpleInnerSubscriber = SimpleInnerSubscriber;
	var ComplexInnerSubscriber = (function (_super) {
	    __extends(ComplexInnerSubscriber, _super);
	    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.outerValue = outerValue;
	        _this.outerIndex = outerIndex;
	        return _this;
	    }
	    ComplexInnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
	    };
	    ComplexInnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error);
	        this.unsubscribe();
	    };
	    ComplexInnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return ComplexInnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ComplexInnerSubscriber = ComplexInnerSubscriber;
	var SimpleOuterSubscriber = (function (_super) {
	    __extends(SimpleOuterSubscriber, _super);
	    function SimpleOuterSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    SimpleOuterSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SimpleOuterSubscriber.prototype.notifyComplete = function () {
	        this.destination.complete();
	    };
	    return SimpleOuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SimpleOuterSubscriber = SimpleOuterSubscriber;
	var ComplexOuterSubscriber = (function (_super) {
	    __extends(ComplexOuterSubscriber, _super);
	    function ComplexOuterSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComplexOuterSubscriber.prototype.notifyNext = function (_outerValue, innerValue, _outerIndex, _innerSub) {
	        this.destination.next(innerValue);
	    };
	    ComplexOuterSubscriber.prototype.notifyError = function (error) {
	        this.destination.error(error);
	    };
	    ComplexOuterSubscriber.prototype.notifyComplete = function (_innerSub) {
	        this.destination.complete();
	    };
	    return ComplexOuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ComplexOuterSubscriber = ComplexOuterSubscriber;
	function innerSubscribe(result, innerSubscriber) {
	    if (innerSubscriber.closed) {
	        return undefined;
	    }
	    if (result instanceof Observable_1.Observable) {
	        return result.subscribe(innerSubscriber);
	    }
	    var subscription;
	    try {
	        subscription = subscribeTo_1.subscribeTo(result)(innerSubscriber);
	    }
	    catch (error) {
	        innerSubscriber.error(error);
	    }
	    return subscription;
	}
	exports.innerSubscribe = innerSubscribe;
	//# sourceMappingURL=innerSubscribe.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(871);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(1451);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      rest = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  return _react2.default.createElement(
	    'button',
	    _extends({ type: 'button', className: (0, _classnames2.default)(_Button2.default.Button, className) }, rest),
	    children
	  );
	};
	
	exports.default = Button;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(527)('wks')
	  , uid    = __webpack_require__(146)
	  , Symbol = __webpack_require__(34).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1959);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(104);
	var _isTransformer = __webpack_require__(375);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(881);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1179);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uploadAgentPhoto = exports.uploadPhoto = exports.updateCompany = exports.loadCompany = exports.deleteProfile = exports.loadCompanyProfiles = exports.updateAgentProfile = exports.loadAgentProfile = exports.createProfile = exports.updateProfileRegion = exports.updateProfileSurvey = exports.updateProfile = exports.leaveProfileAgency = exports.loadProfile = undefined;
	exports.uploadLogo = uploadLogo;
	exports.checkUserPhone = checkUserPhone;
	
	var _actions = __webpack_require__(211);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/* global localStorage */
	var loadProfile = exports.loadProfile = (0, _actions.createRequestActions)({
	  type: 'LOAD_PROFILE',
	  url: '/user/profile'
	});
	
	var leaveProfileAgency = exports.leaveProfileAgency = (0, _actions.createRequestActions)({
	  type: 'LEAVE_PROFILE_AGENCY',
	  url: '/user/agency/exit',
	  method: 'post'
	});
	
	var updateProfile = exports.updateProfile = (0, _actions.createRequestActions)({
	  type: 'UPDATE_PROFILE',
	  url: '/user/update',
	  method: 'post'
	});
	
	var updateProfileSurvey = exports.updateProfileSurvey = (0, _actions.createRequestActions)({
	  type: 'UPDATE_PROFILE_SURVEY',
	  url: '/user/update',
	  method: 'post'
	});
	
	var updateProfileRegion = exports.updateProfileRegion = (0, _actions.createRequestActions)({
	  type: 'UPDATE_PROFILE_REGION',
	  url: '/user/update',
	  method: 'post'
	});
	
	var createProfile = exports.createProfile = (0, _actions.createRequestActions)({
	  type: 'CREATE_PROFILE',
	  url: '/user/create',
	  method: 'post'
	});
	
	var loadAgentProfile = exports.loadAgentProfile = (0, _actions.createRequestActions)({
	  type: 'LOAD_AGENT_PROFILE',
	  url: '/user/profile'
	});
	
	var updateAgentProfile = exports.updateAgentProfile = (0, _actions.createRequestActions)({
	  type: 'UPDATE_AGENT_PROFILE',
	  url: '/user/update',
	  method: 'post'
	});
	
	var loadCompanyProfiles = exports.loadCompanyProfiles = (0, _actions.createRequestActions)({
	  type: 'LOAD_COMPANY_PROFILES',
	  url: '/user/agency/list'
	});
	
	var deleteProfile = exports.deleteProfile = (0, _actions.createRequestActions)({
	  type: 'DELETE_PROFILE',
	  url: '/user/agent/delete',
	  method: 'post'
	});
	
	var loadCompany = exports.loadCompany = (0, _actions.createRequestActions)({
	  type: 'LOAD_COMPANY',
	  url: '/user/agency/get'
	});
	
	var updateCompany = exports.updateCompany = (0, _actions.createRequestActions)({
	  type: 'UPDATE_COMPANY',
	  url: '/user/create/agency',
	  method: 'post'
	});
	
	var uploadPhoto = exports.uploadPhoto = (0, _actions.createRequestActions)({
	  type: 'UPLOAD_PHOTO',
	  url: '/image/upload',
	  method: 'post'
	});
	
	var uploadAgentPhoto = exports.uploadAgentPhoto = (0, _actions.createRequestActions)({
	  type: 'UPLOAD_AGENT_PHOTO',
	  url: '/image/upload',
	  method: 'post'
	});
	
	function uploadLogo(data) {
	  return function (dispatch) {
	    dispatch({ type: types.UPLOAD_LOGO_REQUEST, data: 'adfadfadfadfa' });
	    return _axios2.default.post(_Config.ROOT_URL + '/image/upload', data).then(function (res) {
	      dispatch({ type: types.UPLOAD_LOGO_OK, payload: { response: res.data.data } });
	      return res.data.data;
	    })
	    // .then((res) => {
	    //   return axios.post(`${ROOT_URL}/user/update`, { avatarId: res.imageId });
	    // })
	    .catch(function (error) {
	      dispatch({ type: types.UPLOAD_LOGO_ERROR, payload: error });
	    });
	  };
	}
	
	function checkUserPhone(data) {
	  var phone = data.phone,
	      agencyId = data.agencyId;
	
	
	  return function (dispatch) {
	    dispatch({ type: 'CHECK_USER_PHONE_REQUEST', meta: { loader: true } });
	
	    return _axios2.default.get(_Config.ROOT_URL + '/user/check/' + phone + '/' + agencyId, {}).then(function (response) {
	      dispatch({ type: 'CHECK_USER_PHONE_SUCCESS', payload: response.data });
	
	      return response.data;
	    }).catch(function (error) {
	      console.error(error);
	      dispatch({ type: 'CHECK_USER_PHONE_ERROR', payload: error });
	
	      throw error;
	    });
	  };
	}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.noop = noop;
	exports.functionalUpdate = functionalUpdate;
	exports.isValidTimeout = isValidTimeout;
	exports.ensureQueryKeyArray = ensureQueryKeyArray;
	exports.difference = difference;
	exports.replaceAt = replaceAt;
	exports.timeUntilStale = timeUntilStale;
	exports.parseQueryArgs = parseQueryArgs;
	exports.parseMutationArgs = parseMutationArgs;
	exports.parseFilterArgs = parseFilterArgs;
	exports.parseMutationFilterArgs = parseMutationFilterArgs;
	exports.mapQueryStatusFilter = mapQueryStatusFilter;
	exports.matchQuery = matchQuery;
	exports.matchMutation = matchMutation;
	exports.hashQueryKeyByOptions = hashQueryKeyByOptions;
	exports.hashQueryKey = hashQueryKey;
	exports.stableValueHash = stableValueHash;
	exports.partialMatchKey = partialMatchKey;
	exports.partialDeepEqual = partialDeepEqual;
	exports.replaceEqualDeep = replaceEqualDeep;
	exports.shallowEqualObjects = shallowEqualObjects;
	exports.isPlainObject = isPlainObject;
	exports.isQueryKey = isQueryKey;
	exports.isError = isError;
	exports.sleep = sleep;
	exports.scheduleMicrotask = scheduleMicrotask;
	exports.getAbortController = getAbortController;
	exports.isServer = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	// TYPES
	// UTILS
	var isServer = typeof window === 'undefined';
	exports.isServer = isServer;
	
	function noop() {
	  return undefined;
	}
	
	function functionalUpdate(updater, input) {
	  return typeof updater === 'function' ? updater(input) : updater;
	}
	
	function isValidTimeout(value) {
	  return typeof value === 'number' && value >= 0 && value !== Infinity;
	}
	
	function ensureQueryKeyArray(value) {
	  return Array.isArray(value) ? value : [value];
	}
	
	function difference(array1, array2) {
	  return array1.filter(function (x) {
	    return array2.indexOf(x) === -1;
	  });
	}
	
	function replaceAt(array, index, value) {
	  var copy = array.slice(0);
	  copy[index] = value;
	  return copy;
	}
	
	function timeUntilStale(updatedAt, staleTime) {
	  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
	}
	
	function parseQueryArgs(arg1, arg2, arg3) {
	  if (!isQueryKey(arg1)) {
	    return arg1;
	  }
	
	  if (typeof arg2 === 'function') {
	    return (0, _extends2.default)({}, arg3, {
	      queryKey: arg1,
	      queryFn: arg2
	    });
	  }
	
	  return (0, _extends2.default)({}, arg2, {
	    queryKey: arg1
	  });
	}
	
	function parseMutationArgs(arg1, arg2, arg3) {
	  if (isQueryKey(arg1)) {
	    if (typeof arg2 === 'function') {
	      return (0, _extends2.default)({}, arg3, {
	        mutationKey: arg1,
	        mutationFn: arg2
	      });
	    }
	
	    return (0, _extends2.default)({}, arg2, {
	      mutationKey: arg1
	    });
	  }
	
	  if (typeof arg1 === 'function') {
	    return (0, _extends2.default)({}, arg2, {
	      mutationFn: arg1
	    });
	  }
	
	  return (0, _extends2.default)({}, arg1);
	}
	
	function parseFilterArgs(arg1, arg2, arg3) {
	  return isQueryKey(arg1) ? [(0, _extends2.default)({}, arg2, {
	    queryKey: arg1
	  }), arg3] : [arg1 || {}, arg2];
	}
	
	function parseMutationFilterArgs(arg1, arg2) {
	  return isQueryKey(arg1) ? (0, _extends2.default)({}, arg2, {
	    mutationKey: arg1
	  }) : arg1;
	}
	
	function mapQueryStatusFilter(active, inactive) {
	  if (active === true && inactive === true || active == null && inactive == null) {
	    return 'all';
	  } else if (active === false && inactive === false) {
	    return 'none';
	  } else {
	    // At this point, active|inactive can only be true|false or false|true
	    // so, when only one value is provided, the missing one has to be the negated value
	    var isActive = active != null ? active : !inactive;
	    return isActive ? 'active' : 'inactive';
	  }
	}
	
	function matchQuery(filters, query) {
	  var active = filters.active,
	      exact = filters.exact,
	      fetching = filters.fetching,
	      inactive = filters.inactive,
	      predicate = filters.predicate,
	      queryKey = filters.queryKey,
	      stale = filters.stale;
	
	  if (isQueryKey(queryKey)) {
	    if (exact) {
	      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
	        return false;
	      }
	    } else if (!partialMatchKey(query.queryKey, queryKey)) {
	      return false;
	    }
	  }
	
	  var queryStatusFilter = mapQueryStatusFilter(active, inactive);
	
	  if (queryStatusFilter === 'none') {
	    return false;
	  } else if (queryStatusFilter !== 'all') {
	    var isActive = query.isActive();
	
	    if (queryStatusFilter === 'active' && !isActive) {
	      return false;
	    }
	
	    if (queryStatusFilter === 'inactive' && isActive) {
	      return false;
	    }
	  }
	
	  if (typeof stale === 'boolean' && query.isStale() !== stale) {
	    return false;
	  }
	
	  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
	    return false;
	  }
	
	  if (predicate && !predicate(query)) {
	    return false;
	  }
	
	  return true;
	}
	
	function matchMutation(filters, mutation) {
	  var exact = filters.exact,
	      fetching = filters.fetching,
	      predicate = filters.predicate,
	      mutationKey = filters.mutationKey;
	
	  if (isQueryKey(mutationKey)) {
	    if (!mutation.options.mutationKey) {
	      return false;
	    }
	
	    if (exact) {
	      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
	        return false;
	      }
	    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
	      return false;
	    }
	  }
	
	  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
	    return false;
	  }
	
	  if (predicate && !predicate(mutation)) {
	    return false;
	  }
	
	  return true;
	}
	
	function hashQueryKeyByOptions(queryKey, options) {
	  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
	  return hashFn(queryKey);
	}
	/**
	 * Default query keys hash function.
	 */
	
	
	function hashQueryKey(queryKey) {
	  var asArray = ensureQueryKeyArray(queryKey);
	  return stableValueHash(asArray);
	}
	/**
	 * Hashes the value into a stable hash.
	 */
	
	
	function stableValueHash(value) {
	  return JSON.stringify(value, function (_, val) {
	    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
	      result[key] = val[key];
	      return result;
	    }, {}) : val;
	  });
	}
	/**
	 * Checks if key `b` partially matches with key `a`.
	 */
	
	
	function partialMatchKey(a, b) {
	  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
	}
	/**
	 * Checks if `b` partially matches with `a`.
	 */
	
	
	function partialDeepEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  if (typeof a !== typeof b) {
	    return false;
	  }
	
	  if (a && b && typeof a === 'object' && typeof b === 'object') {
	    return !Object.keys(b).some(function (key) {
	      return !partialDeepEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	/**
	 * This function returns `a` if `b` is deeply equal.
	 * If not, it will replace any deeply equal children of `b` with those of `a`.
	 * This can be used for structural sharing between JSON values for example.
	 */
	
	
	function replaceEqualDeep(a, b) {
	  if (a === b) {
	    return a;
	  }
	
	  var array = Array.isArray(a) && Array.isArray(b);
	
	  if (array || isPlainObject(a) && isPlainObject(b)) {
	    var aSize = array ? a.length : Object.keys(a).length;
	    var bItems = array ? b : Object.keys(b);
	    var bSize = bItems.length;
	    var copy = array ? [] : {};
	    var equalItems = 0;
	
	    for (var i = 0; i < bSize; i++) {
	      var key = array ? i : bItems[i];
	      copy[key] = replaceEqualDeep(a[key], b[key]);
	
	      if (copy[key] === a[key]) {
	        equalItems++;
	      }
	    }
	
	    return aSize === bSize && equalItems === aSize ? a : copy;
	  }
	
	  return b;
	}
	/**
	 * Shallow compare objects. Only works with objects that always have the same properties.
	 */
	
	
	function shallowEqualObjects(a, b) {
	  if (a && !b || b && !a) {
	    return false;
	  }
	
	  for (var key in a) {
	    if (a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	} // Copied from: https://github.com/jonschlinkert/is-plain-object
	
	
	function isPlainObject(o) {
	  if (!hasObjectPrototype(o)) {
	    return false;
	  } // If has modified constructor
	
	
	  var ctor = o.constructor;
	
	  if (typeof ctor === 'undefined') {
	    return true;
	  } // If has modified prototype
	
	
	  var prot = ctor.prototype;
	
	  if (!hasObjectPrototype(prot)) {
	    return false;
	  } // If constructor does not have an Object-specific method
	
	
	  if (!prot.hasOwnProperty('isPrototypeOf')) {
	    return false;
	  } // Most likely a plain Object
	
	
	  return true;
	}
	
	function hasObjectPrototype(o) {
	  return Object.prototype.toString.call(o) === '[object Object]';
	}
	
	function isQueryKey(value) {
	  return typeof value === 'string' || Array.isArray(value);
	}
	
	function isError(value) {
	  return value instanceof Error;
	}
	
	function sleep(timeout) {
	  return new Promise(function (resolve) {
	    setTimeout(resolve, timeout);
	  });
	}
	/**
	 * Schedules a microtask.
	 * This can be useful to schedule state updates after rendering.
	 */
	
	
	function scheduleMicrotask(callback) {
	  Promise.resolve().then(callback).catch(function (error) {
	    return setTimeout(function () {
	      throw error;
	    });
	  });
	}
	
	function getAbortController() {
	  if (typeof AbortController === 'function') {
	    return new AbortController();
	  }
	}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSelector = void 0;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = void 0;
	Object.defineProperty(exports, "defaultEqualityCheck", {
	  enumerable: true,
	  get: function get() {
	    return _defaultMemoize.defaultEqualityCheck;
	  }
	});
	Object.defineProperty(exports, "defaultMemoize", {
	  enumerable: true,
	  get: function get() {
	    return _defaultMemoize.defaultMemoize;
	  }
	});
	
	var _defaultMemoize = __webpack_require__(2252);
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
	    }).join(', ');
	    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
	  }
	
	  var createSelector = function createSelector() {
	    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var _recomputations = 0;
	
	    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
	    // So, start by declaring the default value here.
	    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
	
	
	    var directlyPassedOptions = {
	      memoizeOptions: undefined
	    }; // Normally, the result func or "output selector" is the last arg
	
	    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
	
	    if (typeof resultFunc === 'object') {
	      directlyPassedOptions = resultFunc; // and pop the real result func off
	
	      resultFunc = funcs.pop();
	    }
	
	    if (typeof resultFunc !== 'function') {
	      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
	    } // Determine which set of options we're using. Prefer options passed directly,
	    // but fall back to options given to createSelectorCreator.
	
	
	    var _directlyPassedOption = directlyPassedOptions,
	        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
	        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
	    // is an array. In most libs I've looked at, it's an equality function or options object.
	    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
	    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
	    // we wrap it in an array so we can apply it.
	
	    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
	    var dependencies = getDependencies(funcs);
	    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
	      _recomputations++; // apply arguments instead of spreading for performance.
	
	      return resultFunc.apply(null, arguments);
	    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	
	    var selector = memoize(function dependenciesChecker() {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        // @ts-ignore
	        params.push(dependencies[i].apply(null, arguments));
	      } // apply arguments instead of spreading for performance.
	
	
	      _lastResult = memoizedResultFunc.apply(null, params);
	      return _lastResult;
	    });
	    Object.assign(selector, {
	      resultFunc: resultFunc,
	      memoizedResultFunc: memoizedResultFunc,
	      dependencies: dependencies,
	      lastResult: function lastResult() {
	        return _lastResult;
	      },
	      recomputations: function recomputations() {
	        return _recomputations;
	      },
	      resetRecomputations: function resetRecomputations() {
	        return _recomputations = 0;
	      }
	    });
	    return selector;
	  }; // @ts-ignore
	
	
	  return createSelector;
	}
	
	var createSelector = /* #__PURE__ */createSelectorCreator(_defaultMemoize.defaultMemoize);
	exports.createSelector = createSelector;
	
	// Manual definition of state and output arguments
	var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
	  if (selectorCreator === void 0) {
	    selectorCreator = createSelector;
	  }
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
	  }
	
	  var objectKeys = Object.keys(selectors);
	  var resultSelector = selectorCreator( // @ts-ignore
	  objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	  return resultSelector;
	};
	
	exports.createStructuredSelector = createStructuredSelector;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isArray_1 = __webpack_require__(59);
	var isObject_1 = __webpack_require__(459);
	var isFunction_1 = __webpack_require__(210);
	var UnsubscriptionError_1 = __webpack_require__(862);
	var Subscription = (function () {
	    function Subscription(unsubscribe) {
	        this.closed = false;
	        this._parentOrParents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._ctorUnsubscribe = true;
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    Subscription.prototype.unsubscribe = function () {
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parentOrParents = null;
	        this._subscriptions = null;
	        if (_parentOrParents instanceof Subscription) {
	            _parentOrParents.remove(this);
	        }
	        else if (_parentOrParents !== null) {
	            for (var index = 0; index < _parentOrParents.length; ++index) {
	                var parent_1 = _parentOrParents[index];
	                parent_1.remove(this);
	            }
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            if (_ctorUnsubscribe) {
	                this._unsubscribe = undefined;
	            }
	            try {
	                _unsubscribe.call(this);
	            }
	            catch (e) {
	                errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            var index = -1;
	            var len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    try {
	                        sub.unsubscribe();
	                    }
	                    catch (e) {
	                        errors = errors || [];
	                        if (e instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
	                        }
	                        else {
	                            errors.push(e);
	                        }
	                    }
	                }
	            }
	        }
	        if (errors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    Subscription.prototype.add = function (teardown) {
	        var subscription = teardown;
	        if (!teardown) {
	            return Subscription.EMPTY;
	        }
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (!(subscription instanceof Subscription)) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default: {
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	            }
	        }
	        var _parentOrParents = subscription._parentOrParents;
	        if (_parentOrParents === null) {
	            subscription._parentOrParents = this;
	        }
	        else if (_parentOrParents instanceof Subscription) {
	            if (_parentOrParents === this) {
	                return subscription;
	            }
	            subscription._parentOrParents = [_parentOrParents, this];
	        }
	        else if (_parentOrParents.indexOf(this) === -1) {
	            _parentOrParents.push(this);
	        }
	        else {
	            return subscription;
	        }
	        var subscriptions = this._subscriptions;
	        if (subscriptions === null) {
	            this._subscriptions = [subscription];
	        }
	        else {
	            subscriptions.push(subscription);
	        }
	        return subscription;
	    };
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnonymousSubject = exports.Subject = void 0;
	var Observable_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(64);
	var ObjectUnsubscribedError_1 = __webpack_require__(827);
	var arrRemove_1 = __webpack_require__(112);
	var errorContext_1 = __webpack_require__(440);
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        var _this = _super.call(this) || this;
	        _this.closed = false;
	        _this.currentObservers = null;
	        _this.observers = [];
	        _this.isStopped = false;
	        _this.hasError = false;
	        _this.thrownError = null;
	        return _this;
	    }
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype._throwIfClosed = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	    };
	    Subject.prototype.next = function (value) {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            var e_1, _a;
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                if (!_this.currentObservers) {
	                    _this.currentObservers = Array.from(_this.observers);
	                }
	                try {
	                    for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var observer = _c.value;
	                        observer.next(value);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	        });
	    };
	    Subject.prototype.error = function (err) {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                _this.hasError = _this.isStopped = true;
	                _this.thrownError = err;
	                var observers = _this.observers;
	                while (observers.length) {
	                    observers.shift().error(err);
	                }
	            }
	        });
	    };
	    Subject.prototype.complete = function () {
	        var _this = this;
	        errorContext_1.errorContext(function () {
	            _this._throwIfClosed();
	            if (!_this.isStopped) {
	                _this.isStopped = true;
	                var observers = _this.observers;
	                while (observers.length) {
	                    observers.shift().complete();
	                }
	            }
	        });
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = this.closed = true;
	        this.observers = this.currentObservers = null;
	    };
	    Object.defineProperty(Subject.prototype, "observed", {
	        get: function () {
	            var _a;
	            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Subject.prototype._trySubscribe = function (subscriber) {
	        this._throwIfClosed();
	        return _super.prototype._trySubscribe.call(this, subscriber);
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        this._throwIfClosed();
	        this._checkFinalizedStatuses(subscriber);
	        return this._innerSubscribe(subscriber);
	    };
	    Subject.prototype._innerSubscribe = function (subscriber) {
	        var _this = this;
	        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
	        if (hasError || isStopped) {
	            return Subscription_1.EMPTY_SUBSCRIPTION;
	        }
	        this.currentObservers = null;
	        observers.push(subscriber);
	        return new Subscription_1.Subscription(function () {
	            _this.currentObservers = null;
	            arrRemove_1.arrRemove(observers, subscriber);
	        });
	    };
	    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
	        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
	        if (hasError) {
	            subscriber.error(thrownError);
	        }
	        else if (isStopped) {
	            subscriber.complete();
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        var _this = _super.call(this) || this;
	        _this.destination = destination;
	        _this.source = source;
	        return _this;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var _a, _b;
	        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var _a, _b;
	        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription_1.EMPTY_SUBSCRIPTION;
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.identity = void 0;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.noop = void 0;
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.switchInfoAccess = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCollections = loadCollections;
	exports.checkBuilding = checkBuilding;
	exports.loadCollection = loadCollection;
	exports.loadPublicCollection = loadPublicCollection;
	exports.loadCollectionBuildingLots = loadCollectionBuildingLots;
	exports.loadCollectionBuilding = loadCollectionBuilding;
	exports.loadRefBuilding = loadRefBuilding;
	exports.createCollection = createCollection;
	exports.renameCollection = renameCollection;
	exports.dupCollection = dupCollection;
	exports.deleteCollection = deleteCollection;
	exports.addToCollection = addToCollection;
	exports.shareBuilding = shareBuilding;
	exports.removeFromCollection = removeFromCollection;
	exports.removeChessFromCollection = removeChessFromCollection;
	exports.addComment = addComment;
	exports.sendCollectionStats = sendCollectionStats;
	exports.sendCollectionBuildingStats = sendCollectionBuildingStats;
	exports.sendCollectionBuildingLotStats = sendCollectionBuildingLotStats;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(211);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var handleTrackEvent = function handleTrackEvent(_ref) {
	  var eventName = _ref.eventName,
	      eventLabel = _ref.eventLabel,
	      eventContext = _ref.eventContext,
	      productType = _ref.productType,
	      productName = _ref.productName,
	      productID = _ref.productID,
	      profileId = _ref.profileId;
	
	  (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	    eventLabel: eventLabel,
	    eventContext: eventContext,
	    productType: productType,
	    productName: productName,
	    productID: productID,
	    user_id: profileId
	  }));
	};
	
	function loadCollections(data) {
	  var updateOnlyTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTIONS_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/lists', { params: data }).then(function (res) {
	      dispatch({
	        type: types.LOAD_COLLECTIONS_SUCCESS,
	        payload: _extends({}, res.data, { updateOnlyTotal: updateOnlyTotal })
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_COLLECTIONS_ERROR, payload: { error: error } });
	    });
	  };
	}
	
	function checkBuilding(data) {
	  return function (dispatch) {
	    dispatch({ type: types.CHECK_BUILDING_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/check/buildings', { params: data }).then(function (res) {
	      dispatch({ type: types.CHECK_BUILDING_SUCCESS, payload: res.data });
	    }).catch(function (error) {
	      dispatch({ type: types.CHECK_BUILDING_ERROR, payload: { error: error } });
	    });
	  };
	}
	
	function loadCollection(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTION_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/lists/buildings', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_COLLECTION_SUCCESS, payload: res.data });
	      return res.data;
	    }).catch(function (error) {
	      dispatch({
	        type: types.LOAD_COLLECTION_ERROR,
	        payload: { error: error.response.data.error }
	      });
	    });
	  };
	}
	
	function loadPublicCollection(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTION_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/list/buildings', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_COLLECTION_SUCCESS, payload: res.data });
	      return res.data;
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_COLLECTION_ERROR, payload: { error: error } });
	    });
	  };
	}
	
	function loadCollectionBuildingLots(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTION_BUILDING_LOTS_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/buildings/lots', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_COLLECTION_BUILDING_LOTS_SUCCESS, payload: res.data });
	      return res.data;
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_COLLECTION_BUILDING_LOTS_ERROR, payload: { error: error } });
	    });
	  };
	}
	
	function loadCollectionBuilding(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTION_BUILDING_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/get/buildings', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_COLLECTION_BUILDING_SUCCESS, payload: res.data });
	      return res.data;
	    }).catch(function (error) {
	      dispatch({
	        type: types.LOAD_COLLECTION_BUILDING_ERROR,
	        payload: { error: error.response.data.error }
	      });
	    });
	  };
	}
	
	function loadRefBuilding(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_COLLECTION_BUILDING_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/selection/building/get', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_COLLECTION_BUILDING_SUCCESS, payload: res.data });
	      return res.data;
	    }).catch(function (error) {
	      dispatch({
	        type: types.LOAD_COLLECTION_BUILDING_ERROR,
	        payload: { error: error.response.data.error }
	      });
	    });
	  };
	}
	
	function createCollection(data) {
	  return function (dispatch) {
	    dispatch({ type: types.CREATE_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/in', data).then(function (res) {
	      dispatch({ type: types.CREATE_COLLECTION_SUCCESS, payload: res.data });
	    }).catch(function (error) {
	      dispatch({ type: types.CREATE_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function renameCollection(data) {
	  return function (dispatch) {
	    dispatch({ type: types.RENAME_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/edit', data).then(function (res) {
	      dispatch({ type: types.RENAME_COLLECTION_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.RENAME_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function dupCollection(data) {
	  return function (dispatch) {
	    dispatch({ type: types.DUP_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/duplicate', data).then(function (res) {
	      dispatch({ type: types.DUP_COLLECTION_SUCCESS, payload: res.data });
	    }).catch(function (error) {
	      dispatch({ type: types.DUP_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function deleteCollection(data, profileId) {
	  return function (dispatch) {
	    dispatch({ type: types.DELETE_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/delete', data).then(function (res) {
	      dispatch({ type: types.DELETE_COLLECTION_SUCCESS, payload: data });
	
	      handleTrackEvent({ eventName: 'collectionsDeleteResult', profileId: profileId });
	    }).catch(function (error) {
	      dispatch({ type: types.DELETE_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function addToCollection(data, meta) {
	  return function (dispatch) {
	    dispatch({ type: types.ADD_TO_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/add/building', data).then(function (res) {
	      dispatch({ type: types.ADD_TO_COLLECTION_SUCCESS, payload: data, meta: meta });
	      handleTrackEvent({
	        eventName: 'collectionAddAndDeleteBuildingResult',
	        eventLabel: 'dobavlen_v_podborku',
	        eventContext: meta.collectionName,
	        productType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th',
	        productName: meta.buildingName,
	        productID: data.buildingId,
	        profileId: meta.profileId
	      });
	    }).catch(function (error) {
	      console.log(error);
	      dispatch({ type: types.ADD_TO_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function shareBuilding(data) {
	  var buildingId = data.buildingId;
	
	
	  return function (dispatch) {
	    dispatch({ type: types.SHARE_BUILDING_REQUEST });
	
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/building/add', { building_id: buildingId }).then(function (res) {
	      dispatch({ type: types.SHARE_BUILDING_SUCCESS, payload: res.data });
	      return res;
	    }).catch(function (error) {
	      dispatch({ type: types.SHARE_BUILDING_ERROR, payload: error });
	    });
	  };
	}
	
	function removeFromCollection(data, meta) {
	  return function (dispatch) {
	    dispatch({ type: types.REMOVE_FROM_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/building/delete', data).then(function (res) {
	      dispatch({
	        type: types.REMOVE_FROM_COLLECTION_SUCCESS,
	        payload: data,
	        meta: _extends({}, meta, {
	          cancel: addToCollection.bind(null, data, _extends({}, meta, { cancelation: true }))
	        })
	      });
	      handleTrackEvent({
	        eventName: 'collectionAddAndDeleteBuildingResult',
	        eventLabel: 'udalen_iz_podborki',
	        eventContext: meta.collectionName,
	        productType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th',
	        productName: meta.buildingName,
	        productID: data.buildingId,
	        profileId: meta.profileId
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.REMOVE_FROM_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function removeChessFromCollection(data, meta) {
	  return function (dispatch) {
	    dispatch({ type: types.REMOVE_FROM_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/building/delete/chess', data).then(function (res) {
	      dispatch({
	        type: types.REMOVE_FROM_COLLECTION_SUCCESS,
	        payload: data,
	        meta: _extends({}, meta, {
	          cancel: addToCollection.bind(null, data, _extends({}, meta, { cancelation: true }))
	        })
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.REMOVE_FROM_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	function addComment(data) {
	  return function (dispatch) {
	    dispatch({ type: types.COMMENT_COLLECTION_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/selection/building/comment', data).then(function (res) {
	      dispatch({ type: types.COMMENT_COLLECTION_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.COMMENT_COLLECTION_ERROR, payload: error });
	    });
	  };
	}
	
	var switchInfoAccess = exports.switchInfoAccess = (0, _actions.createRequestActions)({
	  type: 'SWITCH_INFO_ACCESS',
	  url: '/selection/show/info',
	  method: 'post'
	});
	
	function sendCollectionStats(data) {
	  return _axios2.default.post(_Config.ROOT_URL + '/collection/stats', data);
	}
	
	function sendCollectionBuildingStats(data) {
	  return _axios2.default.post(_Config.ROOT_URL + '/collection/statsByBuilding', data);
	}
	
	function sendCollectionBuildingLotStats(data) {
	  return _axios2.default.post(_Config.ROOT_URL + '/collection/statsByChess', data);
	}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry1 = __webpack_require__(11);
	var _curry2 = __webpack_require__(3);
	var _curryN = __webpack_require__(258);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscriber_1 = __webpack_require__(14);
	var Subscription_1 = __webpack_require__(45);
	var ObjectUnsubscribedError_1 = __webpack_require__(303);
	var SubjectSubscription_1 = __webpack_require__(843);
	var rxSubscriber_1 = __webpack_require__(456);
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        return _this;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        var _this = _super.call(this) || this;
	        _this.observers = [];
	        _this.closed = false;
	        _this.isStopped = false;
	        _this.hasError = false;
	        _this.thrownError = null;
	        return _this;
	    }
	    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        var _this = _super.call(this) || this;
	        _this.destination = destination;
	        _this.source = source;
	        return _this;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchChess = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createInaccuracyReport = createInaccuracyReport;
	exports.getCities = getCities;
	exports.loadBuilding = loadBuilding;
	exports.loadDocuments = loadDocuments;
	exports.loadNews = loadNews;
	exports.loadPavilions = loadPavilions;
	exports.loadChess = loadChess;
	exports.setCells = setCells;
	exports.setSelected = setSelected;
	exports.setFilters = setFilters;
	exports.setZoom = setZoom;
	exports.setChessTable = setChessTable;
	exports.setChessExtended = setChessExtended;
	exports.setListSort = setListSort;
	exports.setTableScroll = setTableScroll;
	exports.setPrevLocation = setPrevLocation;
	exports.updateChessState = updateChessState;
	exports.clickContact = clickContact;
	
	var _actions = __webpack_require__(211);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function createInaccuracyReport(data) {
	  var id = data.id,
	      message = data.message;
	
	  return function (dispatch) {
	    dispatch({ type: types.CREATE_INACCURACY_REPORT, meta: { loader: true } });
	    return _axios2.default.post(_Config.ROOT_URL + '/buildings/inaccuracy/create', { message: message, id: id }).then(function (response) {
	      dispatch({ type: types.CREATE_INACCURACY_REPORT_SUCCESS, payload: response.data });
	    }).catch(function (error) {
	      console.error(error);
	      dispatch({ type: types.CREATE_INACCURACY_REPORT_ERROR, payload: error });
	    });
	  };
	}
	
	function getCities() {
	  return function (dispatch) {
	    try {
	      return _axios2.default.get(_Config.ROOT_URL + '/cities').then(function (_ref) {
	        var data = _ref.data.data;
	
	        dispatch({ type: types.SET_CITIES, payload: data });
	        return data;
	      });
	    } catch (error) {
	      console.error(error);
	      dispatch({ type: types.SET_CITIES, payload: [] });
	    }
	  };
	}
	
	var prepareDataBuilding = function prepareDataBuilding(data) {
	  var buildingData = data.data;
	
	  if (buildingData.builders !== undefined && buildingData.builders.name) {
	    buildingData.builder = [{
	      id: buildingData.builders.id,
	      name: buildingData.builders.name
	    }];
	  }
	
	  var users = [];
	
	  if (Array.isArray(buildingData.sales_offices)) {
	    buildingData.sales_offices.forEach(function (office, officeIndex) {
	      if (Array.isArray(office.users) && office.users.length) {
	        office.users.forEach(function (user, userIndex) {
	          if (user.phone && user.first_name) {
	            users.push({
	              email: user.email,
	              email2: '',
	              name: [user.first_name, user.last_name].filter(function (item) {
	                return item;
	              }).join(' '),
	              phone: user.phone,
	              phone2: '',
	              position: user.position,
	              id: officeIndex + '-' + userIndex
	            });
	          }
	        });
	      }
	    });
	  }
	
	  if (users.length) {
	    buildingData.contacts = users;
	  }
	
	  return data;
	};
	
	function loadBuilding(id) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_BUILDING_START, payload: { id: id }, meta: { loader: true } });
	    var userUid = localStorage.getItem('public');
	    return _axios2.default.get(_Config.ROOT_URL + '/buildings/get?id=' + id + '&userUid=' + userUid).then(function (response) {
	      dispatch({
	        type: types.LOAD_BUILDING_SUCCESS,
	        payload: prepareDataBuilding(response.data),
	        meta: { loader: true }
	      });
	      return response;
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_BUILDING_ERROR, payload: error, meta: { loader: true } });
	    });
	  };
	}
	
	function loadDocuments(id) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_DOCUMENTS_START, meta: { loader: true } });
	    return _axios2.default.get(_Config.ROOT_URL + '/buildings/docs/list?id=' + id).then(function (response) {
	      dispatch({
	        type: types.LOAD_DOCUMENTS_SUCCESS,
	        payload: response.data,
	        meta: { loader: true }
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_DOCUMENTS_ERROR, payload: error, meta: { loader: true } });
	    });
	  };
	}
	
	function loadNews(id) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_NEWS_START, meta: { loader: true } });
	    var userUid = localStorage.getItem('public');
	    return _axios2.default.get(_Config.ROOT_URL + '/buildings/news?id=' + id + '&userUid=' + userUid).then(function (response) {
	      dispatch({ type: types.LOAD_NEWS_SUCCESS, payload: response.data, meta: { loader: true } });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_NEWS_ERROR, payload: error, meta: { loader: true } });
	    });
	  };
	}
	
	function loadPavilions(id) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_PAVILIONS_START, meta: { loader: true } });
	    return _axios2.default.get(_Config.ROOT_URL + '/buildings/pavilion/list?id=' + id).then(function (response) {
	      dispatch({
	        type: types.LOAD_PAVILIONS_SUCCESS,
	        payload: response.data,
	        meta: { loader: true }
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_PAVILIONS_ERROR, payload: error, meta: { loader: true } });
	    });
	  };
	}
	
	function loadChess(params) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_CHESS_START, meta: { loader: true } });
	    return _axios2.default.get(_Config.ROOT_URL + '/section/chess', { params: params }).then(function (response) {
	      dispatch({
	        type: types.LOAD_CHESS_SUCCESS,
	        payload: _extends({}, response.data, { id: params.id }),
	        meta: { loader: true }
	      });
	      return response;
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_CHESS_ERROR, payload: error, meta: { loader: true } });
	    });
	  };
	}
	
	var searchChess = exports.searchChess = (0, _actions.createRequestActions)({
	  type: 'SEARCH_CHESS',
	  path: ['data'],
	  method: 'post',
	  url: '/chess/search'
	});
	
	function setCells(id, cells, selected) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_CHESS_CELLS, payload: { id: id, cells: cells, selected: selected } });
	  };
	}
	
	function setSelected(id, selected) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_CELL_SELECTED, payload: { id: id, selected: selected } });
	  };
	}
	
	function setFilters(filters) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_CHESS_FILTERS, payload: filters });
	  };
	}
	
	function setZoom(payload) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_ZOOM, payload: payload });
	  };
	}
	
	function setChessTable(selected) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_CHESS_TABLE, payload: selected });
	  };
	}
	
	function setChessExtended() {
	  return function (dispatch) {
	    dispatch({ type: types.SET_CHESS_EXTENDED });
	  };
	}
	
	function setListSort(col) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_LIST_SORT, payload: col });
	  };
	}
	
	function setTableScroll(id, scroll) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_TABLE_SCROLL, payload: { id: id, scroll: scroll } });
	  };
	}
	
	function setPrevLocation(location) {
	  return function (dispatch) {
	    dispatch({ type: types.SET_PREV_LOCATION, payload: location });
	  };
	}
	
	function updateChessState(state) {
	  return function (dispatch) {
	    dispatch({ type: types.UPDATE_CHESS_STATE, payload: state });
	  };
	}
	
	function clickContact(data) {
	  var objectId = data.objectId,
	      userId = data.userId;
	
	  return function (dispatch) {
	    dispatch({ type: types.CREATE_INACCURACY_REPORT, meta: { loader: true } });
	    return _axios2.default.post(_Config.ROOT_URL + '/buildings/contact/click', { objectId: objectId, userId: userId }).catch(function (error) {
	      console.error(error);
	    });
	  };
	}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkifyText = exports.getLotsType = exports.WITHOUT_LOTS = exports.SELECTED_LOTS = exports.ALL_LOTS = exports.isSectionAllowed = exports.getParams = exports.makeBase64 = exports.SectionsMap = exports.getBuildingType = exports.LotsValues = exports.firstLetterToUpper = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Config = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var firstLetterToUpper = exports.firstLetterToUpper = function firstLetterToUpper(str) {
	  return str.substring(0, 1).toUpperCase() + str.substring(1);
	};
	
	var LotsValues = exports.LotsValues = ['Показывать все лоты', // allLots
	'Только отобранные лоты', // selectedLots
	'Не отображать лоты' // withoutLots
	];
	
	var getBuildingType = exports.getBuildingType = function getBuildingType(type) {
	  if (type === 2) {
	    return _i18n2.default.t('common.kp');
	  }
	
	  return _i18n2.default.t('common.jk');
	};
	
	var SectionsMap = exports.SectionsMap = {
	  nameAddress: 'nameAddress',
	  description: 'description',
	  characteristics: 'characteristics',
	  communications: 'communications',
	  checkout: 'checkout',
	  payment: 'payment',
	  map: 'map',
	  lots: 'lots',
	  withoutLots: 'withoutLots',
	  allLots: 'allLots',
	  selectedLots: 'selectedLots'
	};
	
	var makeBase64 = exports.makeBase64 = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    var values, rest, keys, obj, response;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            values = data.values, rest = _objectWithoutProperties(data, ['values']);
	            keys = Object.keys(values).filter(function (key) {
	              return !values[key] || key === 'lots';
	            });
	            obj = _extends({}, rest);
	
	
	            keys.forEach(function (key) {
	              var index = SectionsMap[key];
	
	              if (index === 'lots') {
	                switch (values[index]) {
	                  case LotsValues[0]:
	                    {
	                      obj.selectedLots = 1;
	                      obj.withoutLots = 1;
	                      break;
	                    }
	                  case LotsValues[1]:
	                    {
	                      obj.allLots = 1;
	                      obj.withoutLots = 1;
	                      break;
	                    }
	                  case LotsValues[2]:
	                    {
	                      obj.allLots = 1;
	                      obj.selectedLots = 1;
	                      break;
	                    }
	                  case false:
	                    {
	                      obj[index] = 1;
	                      break;
	                    }
	                }
	              } else {
	                obj[index] = 1;
	              }
	            });
	
	            _context.next = 6;
	            return _axios2.default.post(_Config.ROOT_URL + '/selection/short/link', { data: obj });
	
	          case 6:
	            response = _context.sent;
	            return _context.abrupt('return', response.data.data.hash);
	
	          case 8:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function makeBase64(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var paramsCache = {};
	var getParams = exports.getParams = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(hash) {
	    var response;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _axios2.default.get(_Config.ROOT_URL + '/selection/short/link?hash=' + hash);
	
	          case 2:
	            response = _context2.sent;
	
	
	            if (response.data.data.resp) {
	              paramsCache[hash] = response.data.data.resp;
	            }
	
	            return _context2.abrupt('return', paramsCache[hash] || {});
	
	          case 5:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function getParams(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var getDataByHash = function getDataByHash() {
	  var _window$location$path = window.location.pathname.split('/'),
	      _window$location$path2 = _slicedToArray(_window$location$path, 3),
	      base64 = _window$location$path2[2];
	
	  return paramsCache[base64] || {};
	};
	
	var isSectionAllowed = exports.isSectionAllowed = function isSectionAllowed(sectionName) {
	  if (['/ncollection/', '/nbref/'].findIndex(function (url) {
	    return location.pathname.includes(url);
	  }) === -1) {
	    return true;
	  }
	
	  var innerSectionName = sectionName;
	  var data = getDataByHash();
	
	  if (sectionName === 'map' && location.pathname.includes('/nbref/')) {
	    /*
	      Для старых ссылок у тех, кто не обновил андроид и айос клиента
	      Нужно удалить следующий if при следующем редактировании функции
	     */
	    if (data.map) {
	      return false;
	    }
	
	    // В шаринге объекта за карту отвечает nameAddress
	    innerSectionName = 'nameAddress';
	  }
	
	  var isHided = data[innerSectionName] == 1 || false;
	  return !isHided;
	};
	
	var ALL_LOTS = exports.ALL_LOTS = 2;
	var SELECTED_LOTS = exports.SELECTED_LOTS = 1;
	var WITHOUT_LOTS = exports.WITHOUT_LOTS = 0;
	
	var getLotsType = exports.getLotsType = function getLotsType() {
	  if (['/ncollection/', '/nbref/'].findIndex(function (url) {
	    return location.pathname.includes(url);
	  }) === -1) {
	    return ALL_LOTS;
	  }
	
	  if (location.pathname.includes('nbref')) {
	    return isSectionAllowed('lots') ? ALL_LOTS : WITHOUT_LOTS;
	  }
	
	  if (isSectionAllowed('withoutLots')) {
	    return WITHOUT_LOTS;
	  }
	
	  if (isSectionAllowed('selectedLots')) {
	    return SELECTED_LOTS;
	  }
	
	  return ALL_LOTS;
	};
	
	var linkifyText = exports.linkifyText = function linkifyText(text, maxLength) {
	  var regex = /((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})|(\n+|(?:(?!(?:https?:\/\/|ftp:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,}).)+)/gim;
	  var message = [];
	  var totalLength = 0;
	
	  text.replace(regex, function (match, link, plainText) {
	    if (totalLength >= maxLength) {
	      return;
	    }
	
	    if (link) {
	      var href = link.startsWith('www.') ? '//' + link : link;
	      var linkLength = link.length;
	      if (totalLength + linkLength > maxLength) {
	        message.push('…');
	        totalLength = maxLength;
	        return;
	      }
	      message.push(_react2.default.createElement(
	        'a',
	        { key: message.length, target: '_blank', rel: 'noopener noreferrer', href: href },
	        link
	      ));
	      totalLength += linkLength;
	    } else if (plainText) {
	      var remainingLength = maxLength - totalLength;
	      if (plainText.length > remainingLength) {
	        message.push(plainText.slice(0, remainingLength));
	        message.push('…');
	        totalLength = maxLength;
	      } else {
	        message.push(plainText);
	        totalLength += plainText.length;
	      }
	    }
	  });
	
	  return message;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.notifyManager = exports.NotifyManager = void 0;
	
	var _utils = __webpack_require__(43);
	
	// CLASS
	var NotifyManager = /*#__PURE__*/function () {
	  function NotifyManager() {
	    this.queue = [];
	    this.transactions = 0;
	
	    this.notifyFn = function (callback) {
	      callback();
	    };
	
	    this.batchNotifyFn = function (callback) {
	      callback();
	    };
	  }
	
	  var _proto = NotifyManager.prototype;
	
	  _proto.batch = function batch(callback) {
	    var result;
	    this.transactions++;
	
	    try {
	      result = callback();
	    } finally {
	      this.transactions--;
	
	      if (!this.transactions) {
	        this.flush();
	      }
	    }
	
	    return result;
	  };
	
	  _proto.schedule = function schedule(callback) {
	    var _this = this;
	
	    if (this.transactions) {
	      this.queue.push(callback);
	    } else {
	      (0, _utils.scheduleMicrotask)(function () {
	        _this.notifyFn(callback);
	      });
	    }
	  }
	  /**
	   * All calls to the wrapped function will be batched.
	   */
	  ;
	
	  _proto.batchCalls = function batchCalls(callback) {
	    var _this2 = this;
	
	    return function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this2.schedule(function () {
	        callback.apply(void 0, args);
	      });
	    };
	  };
	
	  _proto.flush = function flush() {
	    var _this3 = this;
	
	    var queue = this.queue;
	    this.queue = [];
	
	    if (queue.length) {
	      (0, _utils.scheduleMicrotask)(function () {
	        _this3.batchNotifyFn(function () {
	          queue.forEach(function (callback) {
	            _this3.notifyFn(callback);
	          });
	        });
	      });
	    }
	  }
	  /**
	   * Use this method to set a custom notify function.
	   * This can be used to for example wrap notifications with `React.act` while running tests.
	   */
	  ;
	
	  _proto.setNotifyFunction = function setNotifyFunction(fn) {
	    this.notifyFn = fn;
	  }
	  /**
	   * Use this method to set a custom function to batch notifications together into a single tick.
	   * By default React Query will use the batch function provided by ReactDOM or React Native.
	   */
	  ;
	
	  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
	    this.batchNotifyFn = fn;
	  };
	
	  return NotifyManager;
	}(); // SINGLETON
	
	
	exports.NotifyManager = NotifyManager;
	var notifyManager = new NotifyManager();
	exports.notifyManager = notifyManager;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncAction_1 = __webpack_require__(205);
	var AsyncScheduler_1 = __webpack_require__(206);
	exports.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	exports.async = exports.asyncScheduler;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isArray = (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
	//# sourceMappingURL=isArray.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(872)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Checkbox = __webpack_require__(1452);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_Checkbox2.default);
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
	      var _this$props = _this.props,
	          handle = _this$props.handle,
	          checked = _this$props.checked;
	
	      handle(!checked);
	      _this.props.onChange && _this.props.onChange(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          innerStyle = _props.innerStyle,
	          className = _props.className,
	          classNameClone = _props.classNameClone,
	          text = _props.text,
	          checked = _props.checked,
	          type = _props.type,
	          name = _props.name,
	          partialChecked = _props.partialChecked,
	          additional = _props.additional;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(className, _defineProperty({}, _Checkbox2.default.Radio, type == 'radio'), _defineProperty({}, _Checkbox2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: (0, _bind2.default)(innerStyle, _Checkbox2.default.CheckboxInner, _Checkbox2.default.CheckboxInnerChecked) },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              name: name,
	              onChange: this.onChange,
	              ref: function ref(checkbox) {
	                _this2._checkbox = checkbox;
	              },
	              className: cx({ Checked: checked, PartialChecked: !checked && partialChecked }, _Checkbox2.default.Checkbox)
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: (0, _bind2.default)(_Checkbox2.default.CheckboxClone, classNameClone ? _Checkbox2.default[classNameClone] : null) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('span', null)
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Checkbox2.default.Text },
	              text
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	exports.default = Checkbox;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _map = __webpack_require__(262);
	var _reduce = __webpack_require__(71);
	var _xmap = __webpack_require__(1852);
	var curryN = __webpack_require__(51);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isSubscription = exports.EMPTY_SUBSCRIPTION = exports.Subscription = void 0;
	var isFunction_1 = __webpack_require__(27);
	var UnsubscriptionError_1 = __webpack_require__(829);
	var arrRemove_1 = __webpack_require__(112);
	var Subscription = (function () {
	    function Subscription(initialTeardown) {
	        this.initialTeardown = initialTeardown;
	        this.closed = false;
	        this._parentage = null;
	        this._finalizers = null;
	    }
	    Subscription.prototype.unsubscribe = function () {
	        var e_1, _a, e_2, _b;
	        var errors;
	        if (!this.closed) {
	            this.closed = true;
	            var _parentage = this._parentage;
	            if (_parentage) {
	                this._parentage = null;
	                if (Array.isArray(_parentage)) {
	                    try {
	                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
	                            var parent_1 = _parentage_1_1.value;
	                            parent_1.remove(this);
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                }
	                else {
	                    _parentage.remove(this);
	                }
	            }
	            var initialFinalizer = this.initialTeardown;
	            if (isFunction_1.isFunction(initialFinalizer)) {
	                try {
	                    initialFinalizer();
	                }
	                catch (e) {
	                    errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? e.errors : [e];
	                }
	            }
	            var _finalizers = this._finalizers;
	            if (_finalizers) {
	                this._finalizers = null;
	                try {
	                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
	                        var finalizer = _finalizers_1_1.value;
	                        try {
	                            execFinalizer(finalizer);
	                        }
	                        catch (err) {
	                            errors = errors !== null && errors !== void 0 ? errors : [];
	                            if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
	                            }
	                            else {
	                                errors.push(err);
	                            }
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	            if (errors) {
	                throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	            }
	        }
	    };
	    Subscription.prototype.add = function (teardown) {
	        var _a;
	        if (teardown && teardown !== this) {
	            if (this.closed) {
	                execFinalizer(teardown);
	            }
	            else {
	                if (teardown instanceof Subscription) {
	                    if (teardown.closed || teardown._hasParent(this)) {
	                        return;
	                    }
	                    teardown._addParent(this);
	                }
	                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
	            }
	        }
	    };
	    Subscription.prototype._hasParent = function (parent) {
	        var _parentage = this._parentage;
	        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _parentage = this._parentage;
	        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
	    };
	    Subscription.prototype._removeParent = function (parent) {
	        var _parentage = this._parentage;
	        if (_parentage === parent) {
	            this._parentage = null;
	        }
	        else if (Array.isArray(_parentage)) {
	            arrRemove_1.arrRemove(_parentage, parent);
	        }
	    };
	    Subscription.prototype.remove = function (teardown) {
	        var _finalizers = this._finalizers;
	        _finalizers && arrRemove_1.arrRemove(_finalizers, teardown);
	        if (teardown instanceof Subscription) {
	            teardown._removeParent(this);
	        }
	    };
	    Subscription.EMPTY = (function () {
	        var empty = new Subscription();
	        empty.closed = true;
	        return empty;
	    })();
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	exports.EMPTY_SUBSCRIPTION = Subscription.EMPTY;
	function isSubscription(value) {
	    return (value instanceof Subscription ||
	        (value && 'closed' in value && isFunction_1.isFunction(value.remove) && isFunction_1.isFunction(value.add) && isFunction_1.isFunction(value.unsubscribe)));
	}
	exports.isSubscription = isSubscription;
	function execFinalizer(finalizer) {
	    if (isFunction_1.isFunction(finalizer)) {
	        finalizer();
	    }
	    else {
	        finalizer.unsubscribe();
	    }
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.async = exports.asyncScheduler = void 0;
	var AsyncAction_1 = __webpack_require__(201);
	var AsyncScheduler_1 = __webpack_require__(202);
	exports.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	exports.async = exports.asyncScheduler;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.popNumber = exports.popScheduler = exports.popResultSelector = void 0;
	var isFunction_1 = __webpack_require__(27);
	var isScheduler_1 = __webpack_require__(293);
	function last(arr) {
	    return arr[arr.length - 1];
	}
	function popResultSelector(args) {
	    return isFunction_1.isFunction(last(args)) ? args.pop() : undefined;
	}
	exports.popResultSelector = popResultSelector;
	function popScheduler(args) {
	    return isScheduler_1.isScheduler(last(args)) ? args.pop() : undefined;
	}
	exports.popScheduler = popScheduler;
	function popNumber(args, defaultValue) {
	    return typeof last(args) === 'number' ? args.pop() : defaultValue;
	}
	exports.popNumber = popNumber;
	//# sourceMappingURL=args.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(466);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSearchModalState = exports.setSearchValue = exports.changeFilters = exports.forcedSearchChange = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.autocomplete = autocomplete;
	
	var _ActionTypes = __webpack_require__(26);
	
	var t = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _reduxActions = __webpack_require__(282);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var forcedSearchChange = exports.forcedSearchChange = (0, _reduxActions.createAction)(t.FORCED_SEARCH_CHANGE);
	
	// export const changeFilters = createAction(t.CHANGE_FILTERS);
	
	function _changeFilters(filters) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // const { costMin, costMax, priceMin, priceMax, areaFrom, areaTo, hasFilters } = filters || {};
	  // const meta = filters && !hasFilters && (costMin || costMax || priceMin || priceMax || areaFrom || areaTo) ?
	  // {
	  //   meta: {
	  //     debounce: {
	  //       time: 1000
	  //     }
	  //   }
	  // } : {};
	  return {
	    type: t.CHANGE_FILTERS,
	    payload: filters,
	    reset: options.reset || false,
	    withoutTypeFilters: options.withoutTypeFilters || false
	    // ...meta
	  };
	}
	
	var changeFilters = exports.changeFilters = function changeFilters(filters, options) {
	  return function (dispatch) {
	    // FIXME: вынести это отсюда, сделать всю страницу с новострйоками в виде контенеров
	    // вью
	    if (window.location.pathname.includes('cottages')) {
	      dispatch(_changeFilters(_extends({}, filters, { typeId: 2 }), options));
	    } else if (window.location.pathname.includes('building')) {
	      dispatch(_changeFilters(_extends({}, filters, { typeId: 1 }), options));
	    } else {
	      dispatch(_changeFilters(filters, options));
	    }
	  };
	};
	
	// export const changeFocus = createAction(t.CHANGE_FOCUS);
	
	// export const autocomplete = createAction(t.LOAD_AUTOCOMPLETE, async (query) => {
	//   const response = await axios.get(`${ROOT_URL}/buildings/autocomplete?query=${encodeURIComponent(query)}`);
	//   return response.data;
	// });
	
	// FIXME: make it work with redux promise middlware
	
	function autocomplete(query) {
	  return function (dispatch) {
	    dispatch({ type: t.LOAD_AUTOCOMPLETE_FETCHING });
	    return _axios2.default.get(_Config.ROOT_URL + '/buildings/autocomplete?query=' + encodeURIComponent(query)).then(function (response) {
	      dispatch({ type: t.LOAD_AUTOCOMPLETE_SUCCESS, payload: response.data });
	    }).catch(function (error) {
	      dispatch({ type: t.LOAD_AUTOCOMPLETE_ERROR, payload: error });
	    });
	  };
	}
	
	var _setSearchValue = (0, _reduxActions.createAction)(t.SET_SEARCH_VALUE);
	
	var setSearchValue = exports.setSearchValue = function setSearchValue(value) {
	  return function (dispatch) {
	    dispatch(_setSearchValue(value));
	    if (value) {
	      dispatch(autocomplete(value));
	    }
	  };
	};
	
	var setSearchModalState = exports.setSearchModalState = (0, _reduxActions.createAction)(t.SET_SEARCH_MODAL_STATE);

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(227)
	  , defined = __webpack_require__(94);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(626);
	var bind = __webpack_require__(601);
	var isArrayLike = __webpack_require__(179);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.count = 0;
	        _this.thisArg = thisArg || _this;
	        return _this;
	    }
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(50)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(169)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.empty = exports.EMPTY = void 0;
	var Observable_1 = __webpack_require__(28);
	exports.EMPTY = new Observable_1.Observable(function (subscriber) { return subscriber.complete(); });
	function empty(scheduler) {
	    return scheduler ? emptyScheduled(scheduler) : exports.EMPTY;
	}
	exports.empty = empty;
	function emptyScheduled(scheduler) {
	    return new Observable_1.Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
	}
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(this && this[arg] || arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(this, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(this && this[key] || key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(117);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8)
	  , core    = __webpack_require__(62)
	  , fails   = __webpack_require__(50);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(34)
	  , hide      = __webpack_require__(95)
	  , SRC       = __webpack_require__(146)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(62).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(580);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _equals = __webpack_require__(1827);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _has = __webpack_require__(56);
	var _isArguments = __webpack_require__(619);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var _reduce = __webpack_require__(71);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	exports.EMPTY = new Observable_1.Observable(function (subscriber) { return subscriber.complete(); });
	function empty(scheduler) {
	    return scheduler ? emptyScheduled(scheduler) : exports.EMPTY;
	}
	exports.empty = empty;
	function emptyScheduled(scheduler) {
	    return new Observable_1.Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
	}
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var subscribeTo_1 = __webpack_require__(305);
	var scheduled_1 = __webpack_require__(858);
	function from(input, scheduler) {
	    if (!scheduler) {
	        if (input instanceof Observable_1.Observable) {
	            return input;
	        }
	        return new Observable_1.Observable(subscribeTo_1.subscribeTo(input));
	    }
	    else {
	        return scheduled_1.scheduled(input, scheduler);
	    }
	}
	exports.from = from;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footer = __webpack_require__(1000);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Footer2.default;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DISTRICTS_MAP = exports.DISTRICTS_MAP = '12GZW3A2aMVzhBz_VoTrzbaAxy9uzaqUS0ltJl78D';
	var MICRODISTRICTS_MAP = exports.MICRODISTRICTS_MAP = '1GwBebhDkJkWFImZ9te0862yLepiG80-Uc61zkf0i';
	var ZOOM = exports.ZOOM = 12;
	
	var regionsLabels = exports.regionsLabels = [{ index: '', name: 'Лазаревский', lng: 39.48898, lat: 43.84542 }, { index: '', name: 'Хостинский', lng: 39.80827, lat: 43.558 }, { index: '', name: 'Центральный', lng: 39.72038, lat: 43.62663 }, { index: '', name: 'Адлерский', lng: 40.01426, lat: 43.55252
	  // { index: '', name: 'Бали', lng: 115.219203, lat: -8.682427 }
	}];
	
	var microregionsLabels = exports.microregionsLabels = [{ index: '', name: 'Донская', lng: 39.727249, lat: 43.62626 }, { index: '', name: 'Завокзальный', lng: 39.735746, lat: 43.592763 }, { index: '', name: 'Заречный', lng: 39.729746, lat: 43.598763 }, { index: '', name: 'КСМ', lng: 39.746904, lat: 43.644771 }, { index: '', name: 'Макаренко', lng: 39.749222, lat: 43.621662 }, { index: '', name: 'Мамайка низ', lng: 39.692659, lat: 43.635237 }, { index: '', name: 'Мамайка Верх', lng: 39.710169, lat: 43.641076 }, { index: '', name: 'Новый Сочи', lng: 39.713173, lat: 43.608737 }, { index: '', name: 'Клубничная', lng: 39.710984, lat: 43.622563 }, { index: '', name: 'Центр', lng: 39.722571, lat: 43.583717 }, { index: '', name: 'Ахун', lng: 39.823036, lat: 43.54158 }, { index: '', name: 'Бытха', lng: 39.766388, lat: 43.565964 }, { index: '', name: 'Кудепста', lng: 39.894962, lat: 43.496643 }, { index: '', name: 'Мацеста', lng: 39.799862, lat: 43.562108 }, { index: '', name: 'Приморье', lng: 39.776344, lat: 43.554893 }, { index: '', name: 'Раздольное село', lng: 39.778061, lat: 43.589219 }, { index: '', name: 'Светлана низ', lng: 39.736261, lat: 43.572432 }, { index: '', name: 'Светлана верх', lng: 39.742184, lat: 43.581137 }, { index: '', name: 'Соболевка', lng: 39.747162, lat: 43.590463 }, { index: '', name: 'Яна Фабрициуса', lng: 39.749823, lat: 43.572991 }, { index: '', name: 'Хоста', lng: 39.867496, lat: 43.519676 }, { index: '', name: 'Транспортная', lng: 39.754543, lat: 43.60333 }, { index: '', name: 'Адлер-Центр', lng: 39.916935, lat: 43.43466 }, { index: '', name: 'Блиново', lng: 39.975557, lat: 43.4197 }, { index: '', name: 'Веселое село', lng: 40.000362, lat: 43.406045 }, { index: '', name: 'Голубые дали', lng: 39.905262, lat: 43.453667 }, { index: '', name: 'Красная Поляна пос.', lng: 40.201721, lat: 43.673335 }, { index: '', name: 'Курортный городок', lng: 39.89831, lat: 43.47329 }, { index: '', name: 'Мирный пос.', lng: 39.959164, lat: 43.413465 }, { index: '', name: 'Молдовка село', lng: 39.961052, lat: 43.461766 }, { index: '', name: 'Орел-Изумруд село', lng: 39.926376, lat: 43.461953 }, { index: '', name: 'Южный культуры', lng: 39.933157, lat: 43.419762 }, { index: '', name: 'Имеретинская низменность', lng: 39.964914, lat: 43.403613 }, { index: '', name: 'Лоо пос.', lng: 39.588547, lat: 43.707221 }, { index: '', name: 'Дагомыс пос.', lng: 39.674034, lat: 43.670976 }, { index: '', name: 'Лазаревский пос.', lng: 39.334831, lat: 43.911621 }];
	
	var USER_ROLE = exports.USER_ROLE = {
	  INDIVIDUAL: 'INDIVIDUAL',
	  WORKER: 'WORKER',
	  ADMIN: 'ADMIN'
	};
	
	var TARIFFS = exports.TARIFFS = {
	  COMPANY: 'company',
	  PERSONAL: 'personal',
	  COMPANY_TEST: 'personalTest',
	  PERSONAL_TEST: 'companyTest'
	};
	
	var OFFLINE_APPOINTMENT_TYPE = exports.OFFLINE_APPOINTMENT_TYPE = 'offline';
	var ONLINE_APPOINTMENT_TYPE = exports.ONLINE_APPOINTMENT_TYPE = 'online';

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReserved = exports.isReserved = function isReserved(status) {
	  return ['assignment_reservation', 'reservStatus'].includes(status);
	};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(20)
	  , createDesc = __webpack_require__(101);
	module.exports = __webpack_require__(73) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cross.87a14b4c.svg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.withReduxForm = exports.renderChildren = exports.ReduxFormContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReduxFormContext = React.createContext(null);
	exports.ReduxFormContext = ReduxFormContext;
	
	var renderChildren = function renderChildren(Component, _ref) {
	  var forwardedRef = _ref.forwardedRef,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["forwardedRef"]);
	  return function (_reduxForm) {
	    return React.createElement(Component, (0, _extends2["default"])({}, rest, {
	      _reduxForm: _reduxForm,
	      ref: forwardedRef
	    }));
	  };
	};
	
	exports.renderChildren = renderChildren;
	
	var withReduxForm = function withReduxForm(Component) {
	  var Hoc = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(Hoc, _React$Component);
	
	    function Hoc() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = Hoc.prototype;
	
	    _proto.render = function render() {
	      return React.createElement(ReduxFormContext.Consumer, {
	        children: renderChildren(Component, this.props)
	      });
	    };
	
	    return Hoc;
	  }(React.Component);
	
	  var ref = React.forwardRef(function (props, ref) {
	    return React.createElement(Hoc, (0, _extends2["default"])({}, props, {
	      forwardedRef: ref
	    }));
	  });
	  ref.displayName = Component.displayName || Component.name || 'Component';
	  return ref;
	};
	
	exports.withReduxForm = withReduxForm;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeMap = void 0;
	var map_1 = __webpack_require__(111);
	var innerFrom_1 = __webpack_require__(23);
	var lift_1 = __webpack_require__(9);
	var mergeInternals_1 = __webpack_require__(431);
	var isFunction_1 = __webpack_require__(27);
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    if (isFunction_1.isFunction(resultSelector)) {
	        return mergeMap(function (a, i) { return map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom_1.innerFrom(project(a, i))); }, concurrent);
	    }
	    else if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return lift_1.operate(function (source, subscriber) { return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent); });
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setScrollTop = setScrollTop;
	exports.loadData = loadData;
	exports.loadPoint = loadPoint;
	exports.loadPointList = loadPointList;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setScrollTop(scrollTop) {
	  return {
	    type: types.SET_SCROLL_TOP,
	    payload: scrollTop
	  };
	}
	
	var recent = void 0;
	
	function loadData(isList, search, clear) {
	  recent = search;
	  var isRecent = function isRecent() {
	    return search === recent;
	  };
	  var OBJECTS = isList ? 'OBJECTS' : 'PINS';
	
	  return function (dispatch) {
	    dispatch(_extends({
	      type: types['LOAD_' + OBJECTS + '_START']
	    }, isRecent() && { meta: { loader: true } }));
	
	    var request = function request() {
	      if (isRecent()) {
	        var path = isList ? _Config.ROOT_URL + '/buildings/search' : _Config.ROOT_URL + '/buildings/pin';
	        var userUid = localStorage.getItem('public');
	        _axios2.default.post(path, _extends({}, search, { userUid: userUid })).then(function (data) {
	          if (isRecent()) {
	            dispatch({
	              type: types['LOAD_' + OBJECTS + '_SUCCESS'],
	              payload: { data: data.data, clear: clear },
	              meta: { loader: true }
	            });
	          }
	        }).catch(function (error) {
	          if (isRecent()) {
	            dispatch({
	              type: types['LOAD_' + OBJECTS + '_ERROR'],
	              payload: error,
	              meta: { loader: true }
	            });
	          }
	        });
	      }
	    };
	
	    return clear ? setTimeout(request, 100) : request();
	  };
	}
	
	function loadPoint(id) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_POINT_START });
	    _axios2.default.get(_Config.ROOT_URL + '/buildings/building?id=' + id).then(function (data) {
	      dispatch({ type: types.LOAD_POINT_SUCCESS, payload: { id: id, data: data.data } });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_POINT_ERROR, payload: error });
	    });
	  };
	}
	
	function loadPointList(ids, longLat) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_POINT_LIST_START });
	
	    var encodedIds = encodeURIComponent(ids.join(','));
	
	    _axios2.default.get(_Config.ROOT_URL + '/buildings/listById?ids=' + encodedIds).then(function (data) {
	      dispatch({
	        type: types.LOAD_POINT_LIST_SUCCESS,
	        payload: { id: longLat, data: data.data }
	      });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_POINT_LIST_ERROR, payload: error });
	    });
	  };
	}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(94);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDown = function FaAngleDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 16.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.5 0.3t-0.6-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l1.2-1.1q0.2-0.2 0.5-0.2t0.5 0.2l8.8 8.8 8.7-8.8q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDown;
	module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createAction", {
	  enumerable: true,
	  get: function get() {
	    return _createAction["default"];
	  }
	});
	Object.defineProperty(exports, "createReducer", {
	  enumerable: true,
	  get: function get() {
	    return _createReducer["default"];
	  }
	});
	Object.defineProperty(exports, "assignAll", {
	  enumerable: true,
	  get: function get() {
	    return _assignAll["default"];
	  }
	});
	Object.defineProperty(exports, "bindAll", {
	  enumerable: true,
	  get: function get() {
	    return _bindAll["default"];
	  }
	});
	Object.defineProperty(exports, "batch", {
	  enumerable: true,
	  get: function get() {
	    return _batch["default"];
	  }
	});
	Object.defineProperty(exports, "disbatch", {
	  enumerable: true,
	  get: function get() {
	    return _disbatch["default"];
	  }
	});
	Object.defineProperty(exports, "loggers", {
	  enumerable: true,
	  get: function get() {
	    return _loggers["default"];
	  }
	});
	Object.defineProperty(exports, "asError", {
	  enumerable: true,
	  get: function get() {
	    return _asError["default"];
	  }
	});
	exports.types = void 0;
	
	var _types = _interopRequireWildcard(__webpack_require__(708));
	
	var _createAction = _interopRequireDefault(__webpack_require__(707));
	
	var _createReducer = _interopRequireDefault(__webpack_require__(2113));
	
	var _assignAll = _interopRequireDefault(__webpack_require__(2111));
	
	var _bindAll = _interopRequireDefault(__webpack_require__(2112));
	
	var _batch = _interopRequireDefault(__webpack_require__(281));
	
	var _disbatch = _interopRequireDefault(__webpack_require__(2114));
	
	var _loggers = _interopRequireDefault(__webpack_require__(2115));
	
	var _asError = _interopRequireDefault(__webpack_require__(2110));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	var types = _types;
	exports.types = types;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.from = void 0;
	var scheduled_1 = __webpack_require__(821);
	var innerFrom_1 = __webpack_require__(23);
	function from(input, scheduler) {
	    return scheduler ? scheduled_1.scheduled(input, scheduler) : innerFrom_1.innerFrom(input);
	}
	exports.from = from;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.filter = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function filter(predicate, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
	    });
	}
	exports.filter = filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.map = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function map(project, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            subscriber.next(project.call(thisArg, value, index++));
	        }));
	    });
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.arrRemove = void 0;
	function arrRemove(arr, item) {
	    if (arr) {
	        var index = arr.indexOf(item);
	        0 <= index && arr.splice(index, 1);
	    }
	}
	exports.arrRemove = arrRemove;
	//# sourceMappingURL=arrRemove.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.executeSchedule = void 0;
	function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
	    if (delay === void 0) { delay = 0; }
	    if (repeat === void 0) { repeat = false; }
	    var scheduleSubscription = scheduler.schedule(function () {
	        work();
	        if (repeat) {
	            parentSubscription.add(this.schedule(null, delay));
	        }
	        else {
	            this.unsubscribe();
	        }
	    }, delay);
	    parentSubscription.add(scheduleSubscription);
	    if (!repeat) {
	        return scheduleSubscription;
	    }
	}
	exports.executeSchedule = executeSchedule;
	//# sourceMappingURL=executeSchedule.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Blocker = __webpack_require__(905);
	
	var _Blocker2 = _interopRequireDefault(_Blocker);
	
	var _reactRedux = __webpack_require__(5);
	
	var _profile = __webpack_require__(40);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var profile = _ref.profile;
	  return {
	    profile: profile
	  };
	};
	
	var mapDispatchToProps = {
	  loadProfile: _profile.loadProfile
	};
	
	var sendTariffInfo = function sendTariffInfo(tariff) {
	  try {
	    if (!tariff) {
	      return;
	    }
	
	    var pricing = tariff.pricing;
	
	
	    if (!pricing) {
	      return;
	    }
	
	    if (localStorage.getItem('sendProfileInfo')) {
	      return;
	    }
	
	    if (pricing !== 'company' && pricing !== 'personal') {
	      return;
	    }
	
	    localStorage.setItem('sendProfileInfo', '1');
	    _tracker2.default.sendEvent('Web_Profile_Payment_User');
	    // eslint-disable-next-line no-empty
	  } catch (e) {}
	};
	
	var asyncComponent = function asyncComponent() {
	  var isBlocked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  return function (wrapedComponent) {
	    var _dec, _class;
	
	    var AsyncComponent = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	      _inherits(AsyncComponent, _React$Component);
	
	      function AsyncComponent() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AsyncComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { Component: AsyncComponent.Component }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(AsyncComponent, [{
	        key: 'UNSAFE_componentWillMount',
	        value: function UNSAFE_componentWillMount() {
	          var _this2 = this;
	
	          if (!this.state.Component) {
	            if (this.props.profile.tariff) {
	              var tariff = this.props.profile.tariff;
	
	              if (tariff.countDay === 0 && !isBlocked) {
	                this.setState({ Component: _Blocker2.default });
	              } else {
	                this.setState({ Component: wrapedComponent });
	              }
	            } else {
	              this.props.loadProfile().then(function (response) {
	                var tariff = response.response.data.data.tariff;
	
	
	                sendTariffInfo(tariff);
	
	                if (tariff.countDay === 0 && !isBlocked) {
	                  _this2.setState({ Component: _Blocker2.default });
	                } else {
	                  _this2.setState({ Component: wrapedComponent });
	                }
	              });
	            }
	          }
	        }
	      }, {
	        key: 'UNSAFE_componentWillReceiveProps',
	        value: function UNSAFE_componentWillReceiveProps() {
	          if (this.props.profile.tariff) {
	            var tariff = this.props.profile.tariff;
	
	            if (tariff.countDay === 0 && !isBlocked) {
	              this.setState({ Component: _Blocker2.default });
	            } else {
	              this.setState({ Component: wrapedComponent });
	            }
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var Component = this.state.Component;
	
	          var isBlockedLocal = false;
	          if (this.props.profile.tariff) {
	            var tariff = this.props.profile.tariff;
	
	            if (tariff.countDay === 0 && isBlocked) {
	              isBlockedLocal = true;
	            }
	          }
	
	          if (Component) {
	            return _react2.default.createElement(Component, _extends({}, this.props, { isBlocked: isBlockedLocal }));
	          }
	          return null;
	        }
	      }]);
	
	      return AsyncComponent;
	    }(_react2.default.Component)) || _class);
	
	    return AsyncComponent;
	  };
	};
	
	exports.default = asyncComponent;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nothingfound.3fc906a0.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1666),
	    getValue = __webpack_require__(1695);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(618);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(177);
	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(15));
	var withSideEffect = _interopDefault(__webpack_require__(1963));
	var isEqual = _interopDefault(__webpack_require__(1961));
	var React = _interopDefault(__webpack_require__(1));
	var objectAssign = _interopDefault(__webpack_require__(1962));
	
	var ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src",
	    TARGET: "target"
	};
	
	var REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
	        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [React.createElement(TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return React.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case ATTRIBUTE_NAMES.BODY:
	        case ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            classCallCheck(this, HelmetWrapper);
	            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !isEqual(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case TAG_NAMES.SCRIPT:
	                case TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _babelHelpers$extends;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _babelHelpers$extends2, _babelHelpers$extends3;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
	
	                case TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _babelHelpers$extends4;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            React.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case TAG_NAMES.LINK:
	                    case TAG_NAMES.META:
	                    case TAG_NAMES.NOSCRIPT:
	                    case TAG_NAMES.SCRIPT:
	                    case TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return React.createElement(Component, newProps);
	        };
	
	        createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set$$1(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	        return HelmetWrapper;
	    }(React.Component), _class.propTypes = {
	        base: PropTypes.object,
	        bodyAttributes: PropTypes.object,
	        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	        defaultTitle: PropTypes.string,
	        defer: PropTypes.bool,
	        encodeSpecialCharacters: PropTypes.bool,
	        htmlAttributes: PropTypes.object,
	        link: PropTypes.arrayOf(PropTypes.object),
	        meta: PropTypes.arrayOf(PropTypes.object),
	        noscript: PropTypes.arrayOf(PropTypes.object),
	        onChangeClientState: PropTypes.func,
	        script: PropTypes.arrayOf(PropTypes.object),
	        style: PropTypes.arrayOf(PropTypes.object),
	        title: PropTypes.string,
	        titleAttributes: PropTypes.object,
	        titleTemplate: PropTypes.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = withSideEffect(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 125 */
[2404, 656],
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.Subscribable = void 0;
	
	var Subscribable = /*#__PURE__*/function () {
	  function Subscribable() {
	    this.listeners = [];
	  }
	
	  var _proto = Subscribable.prototype;
	
	  _proto.subscribe = function subscribe(listener) {
	    var _this = this;
	
	    var callback = listener || function () {
	      return undefined;
	    };
	
	    this.listeners.push(callback);
	    this.onSubscribe();
	    return function () {
	      _this.listeners = _this.listeners.filter(function (x) {
	        return x !== callback;
	      });
	
	      _this.onUnsubscribe();
	    };
	  };
	
	  _proto.hasListeners = function hasListeners() {
	    return this.listeners.length > 0;
	  };
	
	  _proto.onSubscribe = function onSubscribe() {// Do nothing
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
	  };
	
	  return Subscribable;
	}();
	
	exports.Subscribable = Subscribable;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueryClientProvider = exports.useQueryClient = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var defaultContext = /*#__PURE__*/_react.default.createContext(undefined);
	
	var QueryClientSharingContext = /*#__PURE__*/_react.default.createContext(false); // if contextSharing is on, we share the first and at least one
	// instance of the context across the window
	// to ensure that if React Query is used across
	// different bundles or microfrontends they will
	// all use the same **instance** of context, regardless
	// of module scoping.
	
	
	function getQueryClientContext(contextSharing) {
	  if (contextSharing && typeof window !== 'undefined') {
	    if (!window.ReactQueryClientContext) {
	      window.ReactQueryClientContext = defaultContext;
	    }
	
	    return window.ReactQueryClientContext;
	  }
	
	  return defaultContext;
	}
	
	var useQueryClient = function useQueryClient() {
	  var queryClient = _react.default.useContext(getQueryClientContext(_react.default.useContext(QueryClientSharingContext)));
	
	  if (!queryClient) {
	    throw new Error('No QueryClient set, use QueryClientProvider to set one');
	  }
	
	  return queryClient;
	};
	
	exports.useQueryClient = useQueryClient;
	
	var QueryClientProvider = function QueryClientProvider(_ref) {
	  var client = _ref.client,
	      _ref$contextSharing = _ref.contextSharing,
	      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
	      children = _ref.children;
	
	  _react.default.useEffect(function () {
	    client.mount();
	    return function () {
	      client.unmount();
	    };
	  }, [client]);
	
	  var Context = getQueryClientContext(contextSharing);
	  return /*#__PURE__*/_react.default.createElement(QueryClientSharingContext.Provider, {
	    value: contextSharing
	  }, /*#__PURE__*/_react.default.createElement(Context.Provider, {
	    value: client
	  }, children));
	};
	
	exports.QueryClientProvider = QueryClientProvider;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	
	function ___$insertStyle(css) {
	  if (!css) {
	    return;
	  }
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var style = document.createElement('style');
	
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	  document.head.appendChild(style);
	  return css;
	}
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: "__react_tooltip_hide_event",
	    REBUILD: "__react_tooltip_rebuild_event",
	    SHOW: "__react_tooltip_show_event"
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event;
	
	  if (typeof window.CustomEvent === "function") {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent("Event");
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	};
	
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	
	
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	
	
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = {
	        currentTarget: event.detail.target
	      };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
	
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
	
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
	
	    if (resizeHide) {
	      window.removeEventListener("resize", this.onWindowResize);
	      window.addEventListener("resize", this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener("resize", this.onWindowResize);
	  };
	  /**
	   * invoked by resize event of window
	   */
	
	
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute("currentItem");
	  if (!isCapture) e.stopPropagation();
	
	  if (show && currentItem === "true") {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute("currentItem", "true");
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute("currentItem", "false");
	    } else {
	      targetArray[i].setAttribute("currentItem", "true");
	    }
	  }
	};
	
	var customListeners = {
	  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute("data-event");
	  };
	  /* Bind listener for custom event */
	
	
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute("data-event") || event;
	    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
	    dataEvent.split(" ").forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	
	    if (dataEventOff) {
	      dataEventOff.split(" ").forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	  /* Unbind listener for custom event */
	
	
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	        event = _this$state2.event,
	        eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute("data-event");
	    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute("data-effect");
	    return dataEffect || this.props.effect || "float";
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	
	  for (var key in e) {
	    if (typeof e[key] === "function") {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	
	  return proxy;
	};
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = e.target.getAttribute("data-tip") || null;
	  var forId = e.target.getAttribute("data-for") || null;
	  var target = e.target;
	
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(" ").forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName("body")[0];
	};
	
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff,
	        possibleCustomEvents = _this$state.possibleCustomEvents,
	        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, "data-event");
	    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(" ").forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(" ").forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  }; //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	
	
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  }; // Check whether the tooltip with orientation p is completely inside the client window
	
	
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ["top", "bottom", "left", "right"];
	  var insideList = [];
	
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace;
	  var shouldUpdatePlace = desiredPlace !== place;
	
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	}; // Get current mouse offset
	
	
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === "float") {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	}; // List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	
	
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === "float") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === "solid") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	}; // Consider additional offset into position calculation
	
	
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === "[object String]") {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
	  }
	
	  for (var key in offset) {
	    if (key === "top") {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === "bottom") {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === "left") {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === "right") {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return {
	    extraOffset_X: extraOffset_X,
	    extraOffset_Y: extraOffset_Y
	  };
	}; // Get the offset of the parent elements
	
	
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function getTipContent (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	
	  if (!multiline || multiline === "false" || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  } // Multiline tooltip content
	
	
	  return tip.split(regexp).map(function (d, i) {
	    return React.createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
	
	var _class, _class2, _temp;
	
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, ReactTooltip);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
	    _this.state = {
	      place: props.place || "top",
	      // Direction of tooltip
	      desiredPlace: props.place || "top",
	      type: "dark",
	      // Color theme of tooltip
	      effect: "float",
	      // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: "",
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || "",
	      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          insecure = _this$props.insecure,
	          resizeHide = _this$props.resizeHide;
	
	      this.bindListener(); // Bind listener for tooltip
	
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	
	        return this.tooltipRef.matches(":hover");
	      }
	
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray;
	
	      if (!id) {
	        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
	      } else {
	        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
	      } // targetArray is a NodeList, convert it to a real array
	
	
	      return nodeListToArray(targetArray);
	    }
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          globalEventOff = _this$props2.globalEventOff,
	          isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute("currentItem") === null) {
	          target.setAttribute("currentItem", "false");
	        }
	
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	
	          var effect = _this3.getEffect(target);
	
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	
	            return;
	          }
	
	          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
	
	          if (effect === "float") {
	            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
	          }
	
	          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
	        });
	      } // Global event to hide tooltip
	
	
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      } // Track removal of targetArray elements from DOM
	
	
	      this.bindRemovalTracker();
	    }
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          globalEventOff = _this$props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
	      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
	      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	          getContent = _this$props4.getContent,
	          children = _this$props4.children; // Generate tooltip content
	
	      var content;
	
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
	    }
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      } // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	
	
	      var _this$props5 = this.props,
	          multiline = _this$props5.multiline,
	          getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute("data-tip");
	      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
	
	      var scrollHide = true;
	
	      if (e.currentTarget.getAttribute("data-scroll-hide")) {
	        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      } // Make sure the correct place is set
	
	
	      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
	      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
	
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute("data-type") || self.props.type || "dark",
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
	          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
	          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
	          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
	          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
	          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      }; // If there is no delay call immediately, don't allow events to get in first.
	
	
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _this$state = this.state,
	          delayShow = _this$state.delayShow,
	          disable = _this$state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	
	          return;
	        }
	
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener() {
	      window.removeEventListener("scroll", this.hideTooltipOnScroll);
	    } // Calculation the position
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _this$state2 = this.state,
	          currentEvent = _this$state2.currentEvent,
	          currentTarget = _this$state2.currentTarget,
	          place = _this$state2.place,
	          desiredPlace = _this$state2.desiredPlace,
	          effect = _this$state2.effect,
	          offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      } // Set tooltip position
	
	
	      node.style.left = result.position.left + "px";
	      node.style.top = result.position.top + "px";
	    }
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	    /* setStyleHeader() {
	      const head = document.getElementsByTagName("head")[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        const tag = document.createElement("style");
	        tag.id = "react-tooltip";
	        tag.innerHTML = cssStyle; */
	
	    /* eslint-disable */
	
	    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	            tag.setAttribute('nonce', __webpack_nonce__)
	          }*/
	
	    /* eslint-enable */
	
	    /*    head.insertBefore(tag, head.firstChild);
	      }
	    } */
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _this$state3 = this.state,
	          extraClass = _this$state3.extraClass,
	          html = _this$state3.html,
	          ariaProps = _this$state3.ariaProps,
	          disable = _this$state3.disable;
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
	      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
	      var Wrapper = this.props.wrapper;
	
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
	
	      if (html) {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: placeholder
	          }
	        }));
	      } else {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this8.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), placeholder);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	
	      if (!isChanged) {
	        return null;
	      }
	
	      return _objectSpread2({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(React.Component), _defineProperty(_class2, "propTypes", {
	  children: propTypes.any,
	  place: propTypes.string,
	  type: propTypes.string,
	  effect: propTypes.string,
	  offset: propTypes.object,
	  multiline: propTypes.bool,
	  border: propTypes.bool,
	  insecure: propTypes.bool,
	  "class": propTypes.string,
	  className: propTypes.string,
	  id: propTypes.string,
	  html: propTypes.bool,
	  delayHide: propTypes.number,
	  delayUpdate: propTypes.number,
	  delayShow: propTypes.number,
	  event: propTypes.string,
	  eventOff: propTypes.string,
	  watchWindow: propTypes.bool,
	  isCapture: propTypes.bool,
	  globalEventOff: propTypes.string,
	  getContent: propTypes.any,
	  afterShow: propTypes.func,
	  afterHide: propTypes.func,
	  overridePosition: propTypes.func,
	  disable: propTypes.bool,
	  scrollHide: propTypes.bool,
	  resizeHide: propTypes.bool,
	  wrapper: propTypes.string,
	  bodyMode: propTypes.bool,
	  possibleCustomEvents: propTypes.string,
	  possibleCustomEventsOff: propTypes.string,
	  clickable: propTypes.bool
	}), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: "div",
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.updateSyncErrors = exports.updateSyncWarnings = exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.resetSection = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.clearSubmit = exports.clearFields = exports.clearAsyncError = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.SubmissionError = exports.ReduxFormContext = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.isAsyncValidating = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.propTypes = exports.FormSection = exports.FormName = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = exports.actionTypes = void 0;
	
	var _actions = _interopRequireDefault(__webpack_require__(718));
	
	var _actionTypes = _interopRequireDefault(__webpack_require__(410));
	
	exports.actionTypes = _actionTypes["default"];
	
	var _ReduxFormContext = __webpack_require__(97);
	
	exports.ReduxFormContext = _ReduxFormContext.ReduxFormContext;
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(720));
	
	exports.defaultShouldAsyncValidate = _defaultShouldAsyncValidate["default"];
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(722));
	
	exports.defaultShouldValidate = _defaultShouldValidate["default"];
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(721));
	
	exports.defaultShouldError = _defaultShouldError["default"];
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(723));
	
	exports.defaultShouldWarn = _defaultShouldWarn["default"];
	
	var _Form = _interopRequireDefault(__webpack_require__(2138));
	
	exports.Form = _Form["default"];
	
	var _FormName = _interopRequireDefault(__webpack_require__(2139));
	
	exports.FormName = _FormName["default"];
	
	var _FormSection = _interopRequireDefault(__webpack_require__(2140));
	
	exports.FormSection = _FormSection["default"];
	
	var _SubmissionError = __webpack_require__(717);
	
	exports.SubmissionError = _SubmissionError.SubmissionError;
	
	var _propTypes = _interopRequireWildcard(__webpack_require__(2176));
	
	exports.propTypes = _propTypes["default"];
	exports.fieldInputPropTypes = _propTypes.fieldInputPropTypes;
	exports.fieldMetaPropTypes = _propTypes.fieldMetaPropTypes;
	exports.fieldPropTypes = _propTypes.fieldPropTypes;
	exports.fieldArrayFieldsPropTypes = _propTypes.fieldArrayFieldsPropTypes;
	exports.fieldArrayMetaPropTypes = _propTypes.fieldArrayMetaPropTypes;
	exports.fieldArrayPropTypes = _propTypes.fieldArrayPropTypes;
	exports.formPropTypes = _propTypes.formPropTypes;
	
	var _Field = _interopRequireDefault(__webpack_require__(2135));
	
	exports.Field = _Field["default"];
	
	var _Fields = _interopRequireDefault(__webpack_require__(2137));
	
	exports.Fields = _Fields["default"];
	
	var _FieldArray = _interopRequireDefault(__webpack_require__(2136));
	
	exports.FieldArray = _FieldArray["default"];
	
	var _formValueSelector = _interopRequireDefault(__webpack_require__(2154));
	
	exports.formValueSelector = _formValueSelector["default"];
	
	var _formValues = _interopRequireDefault(__webpack_require__(2155));
	
	exports.formValues = _formValues["default"];
	
	var _getFormError = _interopRequireDefault(__webpack_require__(2158));
	
	exports.getFormError = _getFormError["default"];
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(2161));
	
	exports.getFormNames = _getFormNames["default"];
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(2165));
	
	exports.getFormValues = _getFormValues["default"];
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(2159));
	
	exports.getFormInitialValues = _getFormInitialValues["default"];
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(2163));
	
	exports.getFormSyncErrors = _getFormSyncErrors["default"];
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(2160));
	
	exports.getFormMeta = _getFormMeta["default"];
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(2157));
	
	exports.getFormAsyncErrors = _getFormAsyncErrors["default"];
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(2164));
	
	exports.getFormSyncWarnings = _getFormSyncWarnings["default"];
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(2162));
	
	exports.getFormSubmitErrors = _getFormSubmitErrors["default"];
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(2170));
	
	exports.isAsyncValidating = _isAsyncValidating["default"];
	
	var _isDirty = _interopRequireDefault(__webpack_require__(2171));
	
	exports.isDirty = _isDirty["default"];
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(2172));
	
	exports.isInvalid = _isInvalid["default"];
	
	var _isPristine = _interopRequireDefault(__webpack_require__(2173));
	
	exports.isPristine = _isPristine["default"];
	
	var _isValid = _interopRequireDefault(__webpack_require__(2175));
	
	exports.isValid = _isValid["default"];
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(2174));
	
	exports.isSubmitting = _isSubmitting["default"];
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(2169));
	
	exports.hasSubmitSucceeded = _hasSubmitSucceeded["default"];
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(2168));
	
	exports.hasSubmitFailed = _hasSubmitFailed["default"];
	
	var _reduxForm = _interopRequireDefault(__webpack_require__(2178));
	
	exports.reduxForm = _reduxForm["default"];
	
	var _reducer = _interopRequireDefault(__webpack_require__(2177));
	
	exports.reducer = _reducer["default"];
	
	var _values = _interopRequireDefault(__webpack_require__(2203));
	
	exports.values = _values["default"];
	// alias for propTypes
	var arrayInsert = _actions["default"].arrayInsert;
	exports.arrayInsert = arrayInsert;
	var arrayMove = _actions["default"].arrayMove;
	exports.arrayMove = arrayMove;
	var arrayPop = _actions["default"].arrayPop;
	exports.arrayPop = arrayPop;
	var arrayPush = _actions["default"].arrayPush;
	exports.arrayPush = arrayPush;
	var arrayRemove = _actions["default"].arrayRemove;
	exports.arrayRemove = arrayRemove;
	var arrayRemoveAll = _actions["default"].arrayRemoveAll;
	exports.arrayRemoveAll = arrayRemoveAll;
	var arrayShift = _actions["default"].arrayShift;
	exports.arrayShift = arrayShift;
	var arraySplice = _actions["default"].arraySplice;
	exports.arraySplice = arraySplice;
	var arraySwap = _actions["default"].arraySwap;
	exports.arraySwap = arraySwap;
	var arrayUnshift = _actions["default"].arrayUnshift;
	exports.arrayUnshift = arrayUnshift;
	var autofill = _actions["default"].autofill;
	exports.autofill = autofill;
	var blur = _actions["default"].blur;
	exports.blur = blur;
	var change = _actions["default"].change;
	exports.change = change;
	var clearAsyncError = _actions["default"].clearAsyncError;
	exports.clearAsyncError = clearAsyncError;
	var clearFields = _actions["default"].clearFields;
	exports.clearFields = clearFields;
	var clearSubmit = _actions["default"].clearSubmit;
	exports.clearSubmit = clearSubmit;
	var clearSubmitErrors = _actions["default"].clearSubmitErrors;
	exports.clearSubmitErrors = clearSubmitErrors;
	var destroy = _actions["default"].destroy;
	exports.destroy = destroy;
	var focus = _actions["default"].focus;
	exports.focus = focus;
	var initialize = _actions["default"].initialize;
	exports.initialize = initialize;
	var registerField = _actions["default"].registerField;
	exports.registerField = registerField;
	var reset = _actions["default"].reset;
	exports.reset = reset;
	var resetSection = _actions["default"].resetSection;
	exports.resetSection = resetSection;
	var setSubmitFailed = _actions["default"].setSubmitFailed;
	exports.setSubmitFailed = setSubmitFailed;
	var setSubmitSucceeded = _actions["default"].setSubmitSucceeded;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	var startAsyncValidation = _actions["default"].startAsyncValidation;
	exports.startAsyncValidation = startAsyncValidation;
	var startSubmit = _actions["default"].startSubmit;
	exports.startSubmit = startSubmit;
	var stopAsyncValidation = _actions["default"].stopAsyncValidation;
	exports.stopAsyncValidation = stopAsyncValidation;
	var stopSubmit = _actions["default"].stopSubmit;
	exports.stopSubmit = stopSubmit;
	var submit = _actions["default"].submit;
	exports.submit = submit;
	var touch = _actions["default"].touch;
	exports.touch = touch;
	var unregisterField = _actions["default"].unregisterField;
	exports.unregisterField = unregisterField;
	var untouch = _actions["default"].untouch;
	exports.untouch = untouch;
	var updateSyncWarnings = _actions["default"].updateSyncWarnings;
	exports.updateSyncWarnings = updateSyncWarnings;
	var updateSyncErrors = _actions["default"].updateSyncErrors;
	exports.updateSyncErrors = updateSyncErrors;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _reactIs = __webpack_require__(386);
	
	var validateComponentProp = function validateComponentProp(props, propName, componentName) {
	  if (!(0, _reactIs.isValidElementType)(props[propName])) {
	    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
	  }
	
	  return null;
	};
	
	var _default = validateComponentProp;
	exports["default"] = _default;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timer = void 0;
	var Observable_1 = __webpack_require__(28);
	var async_1 = __webpack_require__(65);
	var isScheduler_1 = __webpack_require__(293);
	var isDate_1 = __webpack_require__(442);
	function timer(dueTime, intervalOrScheduler, scheduler) {
	    if (dueTime === void 0) { dueTime = 0; }
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var intervalDuration = -1;
	    if (intervalOrScheduler != null) {
	        if (isScheduler_1.isScheduler(intervalOrScheduler)) {
	            scheduler = intervalOrScheduler;
	        }
	        else {
	            intervalDuration = intervalOrScheduler;
	        }
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var due = isDate_1.isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
	        if (due < 0) {
	            due = 0;
	        }
	        var n = 0;
	        return scheduler.schedule(function () {
	            if (!subscriber.closed) {
	                subscriber.next(n++);
	                if (0 <= intervalDuration) {
	                    this.schedule(undefined, intervalDuration);
	                }
	                else {
	                    subscriber.complete();
	                }
	            }
	        }, due);
	    });
	}
	exports.timer = timer;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmptyError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.EmptyError = createErrorClass_1.createErrorClass(function (_super) { return function EmptyErrorImpl() {
	    _super(this);
	    this.name = 'EmptyError';
	    this.message = 'no elements in sequence';
	}; });
	//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.argsOrArgArray = void 0;
	var isArray = Array.isArray;
	function argsOrArgArray(args) {
	    return args.length === 1 && isArray(args[0]) ? args[0] : args;
	}
	exports.argsOrArgArray = argsOrArgArray;
	//# sourceMappingURL=argsOrArgArray.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createErrorClass = void 0;
	function createErrorClass(createImpl) {
	    var _super = function (instance) {
	        Error.call(instance);
	        instance.stack = new Error().stack;
	    };
	    var ctorFunc = createImpl(_super);
	    ctorFunc.prototype = Object.create(Error.prototype);
	    ctorFunc.prototype.constructor = ctorFunc;
	    return ctorFunc;
	}
	exports.createErrorClass = createErrorClass;
	//# sourceMappingURL=createErrorClass.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mapOneOrManyArgs = void 0;
	var map_1 = __webpack_require__(111);
	var isArray = Array.isArray;
	function callOrApply(fn, args) {
	    return isArray(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
	}
	function mapOneOrManyArgs(fn) {
	    return map_1.map(function (args) { return callOrApply(fn, args); });
	}
	exports.mapOneOrManyArgs = mapOneOrManyArgs;
	//# sourceMappingURL=mapOneOrManyArgs.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(870);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	
	function isCrushed() {}
	
	if (false) {
	  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InnerSubscriber_1 = __webpack_require__(2256);
	var subscribeTo_1 = __webpack_require__(305);
	var Observable_1 = __webpack_require__(24);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
	    if (innerSubscriber === void 0) { innerSubscriber = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex); }
	    if (innerSubscriber.closed) {
	        return undefined;
	    }
	    if (result instanceof Observable_1.Observable) {
	        return result.subscribe(innerSubscriber);
	    }
	    return subscribeTo_1.subscribeTo(result)(innerSubscriber);
	}
	exports.subscribeToResult = subscribeToResult;
	//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(314);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(35)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(95)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(100)
	  , TAG = __webpack_require__(35)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(79)
	  , call        = __webpack_require__(520)
	  , isArrayIter = __webpack_require__(517)
	  , anObject    = __webpack_require__(30)
	  , toLength    = __webpack_require__(74)
	  , getIterFn   = __webpack_require__(233);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(241),
	    getRawTag = __webpack_require__(1693),
	    objectToString = __webpack_require__(1721);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.composeInitialProps = composeInitialProps;
	exports.getInitialProps = getInitialProps;
	Object.defineProperty(exports, "getDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _defaults.getDefaults;
	  }
	});
	Object.defineProperty(exports, "setDefaults", {
	  enumerable: true,
	  get: function get() {
	    return _defaults.setDefaults;
	  }
	});
	Object.defineProperty(exports, "getI18n", {
	  enumerable: true,
	  get: function get() {
	    return _i18nInstance.getI18n;
	  }
	});
	Object.defineProperty(exports, "setI18n", {
	  enumerable: true,
	  get: function get() {
	    return _i18nInstance.setI18n;
	  }
	});
	Object.defineProperty(exports, "initReactI18next", {
	  enumerable: true,
	  get: function get() {
	    return _initReactI18next.initReactI18next;
	  }
	});
	exports.ReportNamespaces = exports.I18nContext = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1973));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(1974));
	
	var _react = __webpack_require__(1);
	
	var _defaults = __webpack_require__(381);
	
	var _i18nInstance = __webpack_require__(382);
	
	var _initReactI18next = __webpack_require__(1967);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var I18nContext = (0, _react.createContext)();
	exports.I18nContext = I18nContext;
	
	var ReportNamespaces = function () {
	  function ReportNamespaces() {
	    (0, _classCallCheck2["default"])(this, ReportNamespaces);
	    this.usedNamespaces = {};
	  }
	
	  (0, _createClass2["default"])(ReportNamespaces, [{
	    key: "addUsedNamespaces",
	    value: function addUsedNamespaces(namespaces) {
	      var _this = this;
	
	      namespaces.forEach(function (ns) {
	        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
	      });
	    }
	  }, {
	    key: "getUsedNamespaces",
	    value: function getUsedNamespaces() {
	      return Object.keys(this.usedNamespaces);
	    }
	  }]);
	  return ReportNamespaces;
	}();
	
	exports.ReportNamespaces = ReportNamespaces;
	
	function composeInitialProps(ForComponent) {
	  return function (ctx) {
	    return new Promise(function (resolve) {
	      var i18nInitialProps = getInitialProps();
	
	      if (ForComponent.getInitialProps) {
	        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
	          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
	        });
	      } else {
	        resolve(i18nInitialProps);
	      }
	    });
	  };
	}
	
	function getInitialProps() {
	  var i18n = (0, _i18nInstance.getI18n)();
	  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
	  var ret = {};
	  var initialI18nStore = {};
	  i18n.languages.forEach(function (l) {
	    initialI18nStore[l] = {};
	    namespaces.forEach(function (ns) {
	      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
	    });
	  });
	  ret.initialI18nStore = initialI18nStore;
	  ret.initialLanguage = i18n.language;
	  return ret;
	}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.reduce = void 0;
	var scanInternals_1 = __webpack_require__(791);
	var lift_1 = __webpack_require__(9);
	function reduce(accumulator, seed) {
	    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, false, true));
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function filter(predicate, thisArg) {
	    return function filterOperatorFunction(source) {
	        return source.lift(new FilterOperator(predicate, thisArg));
	    };
	}
	exports.filter = filter;
	var FilterOperator = (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	var FilterSubscriber = (function (_super) {
	    __extends(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.thisArg = thisArg;
	        _this.count = 0;
	        return _this;
	    }
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ConnectableObservable_1 = __webpack_require__(844);
	function multicast(subjectOrSubjectFactory, selector) {
	    return function multicastOperatorFunction(source) {
	        var subjectFactory;
	        if (typeof subjectOrSubjectFactory === 'function') {
	            subjectFactory = subjectOrSubjectFactory;
	        }
	        else {
	            subjectFactory = function subjectFactory() {
	                return subjectOrSubjectFactory;
	            };
	        }
	        if (typeof selector === 'function') {
	            return source.lift(new MulticastOperator(subjectFactory, selector));
	        }
	        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
	        connectable.source = source;
	        connectable.subjectFactory = subjectFactory;
	        return connectable;
	    };
	}
	exports.multicast = multicast;
	var MulticastOperator = (function () {
	    function MulticastOperator(subjectFactory, selector) {
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastOperator.prototype.call = function (subscriber, source) {
	        var selector = this.selector;
	        var subject = this.subjectFactory();
	        var subscription = selector(subject).subscribe(subscriber);
	        subscription.add(source.subscribe(subject));
	        return subscription;
	    };
	    return MulticastOperator;
	}());
	exports.MulticastOperator = MulticastOperator;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observable = (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadCalendar = loadCalendar;
	exports.loadAppointmentStatuses = loadAppointmentStatuses;
	exports.createAppointment = createAppointment;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function loadCalendar(data) {
	  var _this = this;
	
	  var building_id = data.building_id,
	      type = data.type;
	
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch({ type: types.LOAD_CALENDAR, meta: { loader: true } });
	              _context.prev = 1;
	              _context.next = 4;
	              return _axios2.default.post(_Config.ROOT_URL + '/record/calendar', {
	                building_id: building_id,
	                type: type
	              });
	
	            case 4:
	              response = _context.sent;
	
	              if (response.status === 200) {
	                dispatch({ type: types.LOAD_CALENDAR_SUCCESS, payload: response.data });
	              }
	              return _context.abrupt('return', response.data);
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              dispatch({ type: types.LOAD_CALENDAR_ERROR, payload: _context.t0 });
	              throw _context.t0;
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1, 9]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}
	
	function loadAppointmentStatuses() {
	  var _this2 = this;
	
	  return function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch) {
	      var params, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch({ type: types.LOAD_APPOINTMENT_STATUSES, meta: { loader: true } });
	              _context2.prev = 1;
	              params = {
	                status: JSON.stringify([0, 1, 2, 3])
	              };
	              _context2.next = 5;
	              return _axios2.default.get(_Config.ROOT_URL + '/record/status', {
	                params: params,
	                paramsSerializer: function paramsSerializer(params) {
	                  return new URLSearchParams(params).toString();
	                }
	              });
	
	            case 5:
	              response = _context2.sent;
	
	              if (response.status === 200) {
	                dispatch({ type: types.LOAD_APPOINTMENT_STATUSES_SUCCESS, payload: response.data });
	              }
	              return _context2.abrupt('return', response.data);
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2['catch'](1);
	
	              dispatch({ type: types.LOAD_APPOINTMENT_STATUSES_ERROR, payload: _context2.t0 });
	              throw _context2.t0;
	
	            case 14:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[1, 10]]);
	    }));
	
	    return function (_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	}
	
	function createAppointment(data) {
	  var _this3 = this;
	
	  var buildingId = data.buildingId,
	      type = data.type,
	      dateTimeFrom = data.dateTimeFrom,
	      firstNameClient = data.firstNameClient,
	      phoneClient = data.phoneClient,
	      comment = data.comment;
	
	  return function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch) {
	      var response;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              dispatch({ type: types.LOAD_CREATE_APPOINTMENT, meta: { loader: true } });
	              _context3.prev = 1;
	              _context3.next = 4;
	              return _axios2.default.post(_Config.ROOT_URL + '/record/make', {
	                buildingId: buildingId,
	                type: type,
	                dateTimeFrom: dateTimeFrom,
	                firstNameClient: firstNameClient,
	                phoneClient: phoneClient,
	                comment: comment
	              });
	
	            case 4:
	              response = _context3.sent;
	
	              if (response.status === 200) {
	                dispatch({ type: types.LOAD_CREATE_APPOINTMENT_SUCCESS, payload: response.data });
	              }
	              return _context3.abrupt('return', response.data);
	
	            case 9:
	              _context3.prev = 9;
	              _context3.t0 = _context3['catch'](1);
	
	              dispatch({ type: types.LOAD_CREATE_APPOINTMENT_ERROR, payload: _context3.t0 });
	              throw _context3.t0;
	
	            case 13:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3, [[1, 9]]);
	    }));
	
	    return function (_x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadFavorites = loadFavorites;
	exports.addToFavorites = addToFavorites;
	exports.removeFromFavorites = removeFromFavorites;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var handleTrackEvent = function handleTrackEvent(_ref) {
	  var eventName = _ref.eventName,
	      eventLabel = _ref.eventLabel,
	      buildingId = _ref.buildingId,
	      buildingName = _ref.buildingName,
	      profileId = _ref.profileId,
	      objectType = _ref.objectType;
	
	  (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	    eventLabel: eventLabel,
	    eventContent: buildingName,
	    productType: objectType || '',
	    productName: buildingName || '',
	    productID: buildingId || '',
	    user_id: profileId
	  }));
	};
	
	function loadFavorites(data) {
	  return function (dispatch) {
	    dispatch({ type: types.LOAD_FAVORITES_START });
	    return _axios2.default.get(_Config.ROOT_URL + '/favorite/lists', { params: data }).then(function (res) {
	      dispatch({ type: types.LOAD_FAVORITES_SUCCESS, payload: res.data });
	    }).catch(function (error) {
	      dispatch({ type: types.LOAD_FAVORITES_ERROR, payload: { error: error } });
	    });
	  };
	}
	
	function addToFavorites(data, meta) {
	  return function (dispatch) {
	    dispatch({ type: types.ADD_TO_FAVORITES_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/favorite/create', data).then(function (res) {
	      dispatch({ type: types.ADD_TO_FAVORITES_SUCCESS, payload: data, meta: meta });
	      if (meta.eventLocation === 'favorites') {
	        handleTrackEvent({
	          eventName: 'favoritesAddAndDeleteBuildingResult',
	          eventLabel: 'dobavlen_v_izbrannoe',
	          buildingName: meta.buildingName,
	          profileId: meta.profileId
	        });
	      } else {
	        handleTrackEvent({
	          eventName: 'buildingFavoritesResult',
	          eventLabel: 'dobavlen_v_izbrannoe',
	          buildingId: data.buildingId,
	          buildingName: meta.buildingName,
	          profileId: meta.profileId,
	          objectType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th'
	        });
	      }
	    }).catch(function (error) {
	      dispatch({ type: types.ADD_TO_FAVORITES_ERROR, payload: error });
	    });
	  };
	}
	
	function removeFromFavorites(data) {
	  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function (dispatch) {
	    dispatch({ type: types.REMOVE_FROM_FAVORITES_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/favorite/delete', data).then(function (res) {
	      dispatch({
	        type: types.REMOVE_FROM_FAVORITES_SUCCESS,
	        payload: data,
	        meta: Object.assign(meta, { cancel: addToFavorites.bind(null, data, meta) })
	      });
	      if (meta.eventLocation === 'favorites') {
	        handleTrackEvent({
	          eventName: 'favoritesAddAndDeleteBuildingResult',
	          eventLabel: 'udalen_iz_izbrannogo',
	          buildingName: meta.buildingName,
	          profileId: meta.profileId
	        });
	      } else {
	        handleTrackEvent({
	          eventName: 'buildingFavoritesResult',
	          eventLabel: 'ubran_iz_izbrannogo',
	          buildingId: data.buildingId,
	          buildingName: meta.buildingName,
	          profileId: meta.profileId,
	          objectType: meta.data.type_id === 1 ? 'zhk' : 'kp_i_th'
	        });
	      }
	    }).catch(function (error) {
	      dispatch({ type: types.REMOVE_FROM_FAVORITES_ERROR, payload: error });
	    });
	  };
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.login = undefined;
	exports.inviteFormSending = inviteFormSending;
	exports.numberFormSending = numberFormSending;
	exports.smsFormSending = smsFormSending;
	exports.restoreFormSending = restoreFormSending;
	exports.reconnectFormSending = reconnectFormSending;
	exports.userLogout = userLogout;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function inviteFormSending(data) {
	  return function (dispatch) {
	    dispatch({ type: types.INVITE_FORM_SENDING_START });
	    return _axios2.default.post('' + _Config.ROOT_URL, data).then(function (data) {
	      dispatch({ type: types.INVITE_FORM_SENDING_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.INVITE_FORM_SENDING_ERROR, payload: error });
	    });
	  };
	}
	
	// TODO: remove
	
	
	// import { loadProfile } from './profile'
	//
	
	/* global localStorage */
	
	function numberFormSending(phone) {
	  return function (dispatch) {
	    dispatch({ type: types.NUMBER_FORM_SENDING_START, payload: phone });
	    return _axios2.default.post(_Config.ROOT_URL + '/user/send/sms', { phone: phone }).then(function (data) {
	      setTimeout(function () {
	        return dispatch({ type: types.NUMBER_FORM_SENDING_SUCCESS, payload: data });
	      }, 1500);
	    }).catch(function (error) {
	      console.log('dispatch error: ', error.response.data.error['error-code']);
	      dispatch({ type: types.NUMBER_FORM_SENDING_ERROR, payload: error.response.data.error['error-code'] });
	    }).catch(function () {
	      dispatch({ type: types.NUMBER_FORM_SENDING_ERROR, payload: 'unknown' });
	    });
	  };
	}
	
	// TODO: remove
	function smsFormSending(phone, code) {
	  return function (dispatch) {
	    dispatch({ type: types.SMS_FORM_SENDING_START });
	    // const deviceId = localStorage.getItem('deviceId') || uuid() // ?
	    return _axios2.default.post(_Config.ROOT_URL + '/user/sms/login', { phone: phone, code: code, platform: 'web' }).then(function (resp) {
	      dispatch({ type: types.SMS_FORM_SENDING_SUCCESS, payload: resp.data.data });
	      return resp;
	    }).catch(function (error) {
	      dispatch({ type: types.SMS_FORM_SENDING_ERROR, payload: error });
	    });
	  };
	}
	
	var login = exports.login = function login(data) {
	  return {
	    type: types.SMS_FORM_SENDING_SUCCESS,
	    payload: data
	  };
	};
	
	function restoreFormSending(email) {
	  return function (dispatch) {
	    dispatch({ type: types.RESTORE_FORM_SENDING_START });
	    return _axios2.default.post('' + _Config.ROOT_URL_AUTH, email).then(function (data) {
	      dispatch({ type: types.RESTORE_FORM_SENDING_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.RESTORE_FORM_SENDING_ERROR, payload: error });
	    });
	  };
	}
	
	function reconnectFormSending() {
	  return function (dispatch) {
	    dispatch({ type: types.RECONNECT_FORM_SENDING_START });
	    return _axios2.default.post('' + _Config.ROOT_URL_AUTH, 'data').then(function (data) {
	      dispatch({ type: types.RECONNECT_FORM_SENDING_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.RECONNECT_FORM_SENDING_ERROR, payload: error });
	    });
	  };
	}
	
	function userLogout() {
	  return function (dispatch) {
	    dispatch({ type: types.USER_LOGOUT_START });
	    return _axios2.default.post(_Config.ROOT_URL + '/user/logout').then(function (data) {
	      dispatch({ type: types.USER_LOGOUT_SUCCESS, payload: data });
	    }).catch(function (error) {
	      dispatch({ type: types.USER_LOGOUT_ERROR, payload: error });
	    });
	  };
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CollectionsDialog = __webpack_require__(930);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CollectionsDialog2.default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// function preventTouchMove (e) {
	// 	e.preventDefault();
	// };
	//
	// function allowTouchMove (e) {
	// 	e.stopPropagation();
	// };
	//
	// function preventInertiaScroll () {
	// 	var top = this.scrollTop;
	// 	var totalScroll = this.scrollHeight;
	// 	var currentScroll = top + this.offsetHeight;
	//
	// 	if (top === 0) {
	// 		this.scrollTop = 1;
	// 	} else if (currentScroll === totalScroll) {
	// 		this.scrollTop = top - 1;
	// 	}
	// }
	
	var ScrollLock = function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.setScrollingElement = function (r) {
	      _this.scrollingElement = r ? r.firstChild : r;
	    }, _this.onScrollHandler = function (e) {
	      var elem = _this.scrollingElement;
	      var scrollTop = elem.scrollTop,
	          scrollHeight = elem.scrollHeight,
	          clientHeight = elem.clientHeight;
	
	      var wheelDelta = e.deltaY;
	      var isDeltaPositive = wheelDelta > 0;
	
	      if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	        elem.scrollTop = scrollHeight;
	        return _this.cancelScrollEvent(e);
	      } else {
	        if (!e.path.includes(_this.scrollingElement)) {
	          return _this.cancelScrollEvent(e);
	        } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	          elem.scrollTop = 0;
	          return _this.cancelScrollEvent(e);
	        }
	      }
	    }, _this.cancelScrollEvent = function (e) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      e.returnValue = false;
	      return false;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('wheel', this.onScrollHandler, false);
	      // this.scrollingElement.addEventListener('touchmove', preventTouchMove, false); // 2.
	      // this.scrollingElement.addEventListener('touchstart', preventInertiaScroll, false); // 3.
	      // this.scrollingElement.addEventListener('touchmove', allowTouchMove, false); // 3.
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('wheel', this.onScrollHandler, false);
	      // this.scrollingElement.removeEventListener('touchmove', preventTouchMove, false);
	      // this.scrollingElement.removeEventListener('touchstart', preventInertiaScroll, false);
	      // this.scrollingElement.removeEventListener('touchmove', allowTouchMove, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { ref: this.setScrollingElement },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.Component);
	
	exports.default = ScrollLock;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.ButtonSpinner = ButtonSpinner;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ButtonSpinner(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 24 24" }, props),
	    _react2.default.createElement(
	      "path",
	      {
	        fill: "currentColor",
	        d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
	      },
	      _react2.default.createElement("animateTransform", {
	        attributeName: "transform",
	        dur: "0.75s",
	        repeatCount: "indefinite",
	        type: "rotate",
	        values: "0 12 12;360 12 12"
	      })
	    )
	  );
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Dropdown = __webpack_require__(1453);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _reactOnclickoutside = __webpack_require__(667);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_Dropdown2.default);
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
	    _this.showMenu = function (allowClose) {
	      if (_this.props.onShow) {
	        _this.props.onShow();
	      }
	      if (!_this.state.isVisible) {
	        _this.setState({ isVisible: true, allowClose: allowClose });
	      }
	    };
	
	    _this.state = {
	      isVisible: false
	    };
	
	    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	    _this.hideMenu = _this.hideMenu.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'hideMenu',
	    value: function hideMenu() {
	      if (this.state.isVisible) {
	        this.setState({ isVisible: false, allowClose: false });
	      }
	    }
	  }, {
	    key: 'onMouseEnter',
	    value: function onMouseEnter(e) {
	      var _this2 = this;
	
	      // TODO Нужно убрать этот костыль и сделать как-то более красивше функционал
	      // с показом и сокрытием меню
	      setTimeout(this.showMenu, 100);
	      setTimeout(function () {
	        _this2.setState({ allowClose: true });
	      }, 400);
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave(e) {
	      setTimeout(this.hideMenu, 100);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      // const { isVisible } = this.state;
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick();
	      }
	
	      if (this.state.isVisible && this.state.allowClose) {
	        this.hideMenu();
	      } else {
	        this.showMenu(true);
	      }
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(e) {
	      if (this.state.isVisible) {
	        this.hideMenu();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.hideMenu();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          buttonStyle = _props.buttonStyle,
	          textStyle = _props.textStyle,
	          dropdownMenuStyle = _props.dropdownMenuStyle,
	          subtextStyle = _props.subtextStyle,
	          text = _props.text,
	          subtext = _props.subtext,
	          additionalCount = _props.additionalCount,
	          icon = _props.icon,
	          iconStyle = _props.iconStyle,
	          fixed = _props.fixed,
	          rightShift = _props.rightShift,
	          topShift = _props.topShift,
	          leftShift = _props.leftShift,
	          filter = _props.filter,
	          openByClick = _props.openByClick,
	          _props$chessfilter = _props.chessfilter,
	          chessfilter = _props$chessfilter === undefined ? true : _props$chessfilter,
	          onClick = _props.onClick;
	      var isVisible = this.state.isVisible;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cx(className, _Dropdown2.default.Dropdown, _defineProperty({}, _Dropdown2.default.DropdownChessfilter, chessfilter), _defineProperty({}, _Dropdown2.default[chessfilter], chessfilter), _defineProperty({}, _Dropdown2.default.Filter, filter)),
	          onMouseLeave: !openByClick ? this.onMouseLeave : null },
	        _react2.default.createElement(
	          'div',
	          {
	            className: cx(buttonStyle, _Dropdown2.default.Button),
	            onMouseEnter: !openByClick ? this.onMouseEnter : null,
	            onClick: this.onClick
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _Dropdown2.default.Text_Container },
	            text ? _react2.default.createElement(
	              'p',
	              { className: cx(textStyle, _Dropdown2.default.Text, _defineProperty({}, _Dropdown2.default.Active, this.state.isVisible)) },
	              text,
	              ' ',
	              additionalCount ? _react2.default.createElement(
	                'span',
	                { className: _Dropdown2.default.AdditionalCount },
	                additionalCount
	              ) : null
	            ) : null,
	            subtext ? _react2.default.createElement(
	              'p',
	              { className: cx(subtextStyle, _Dropdown2.default.Subtext) },
	              subtext
	            ) : null
	          ),
	          icon ? icon === 'custom' ? _react2.default.createElement('i', { className: iconStyle }) : _react2.default.createElement('img', { src: icon, alt: '', className: cx(iconStyle, _Dropdown2.default.Icon) }) : _react2.default.createElement(_angleDown2.default, { className: cx(iconStyle, _Dropdown2.default.Icon, _defineProperty({}, _Dropdown2.default.Active, this.state.isVisible)) })
	        ),
	        isVisible ? _react2.default.createElement(
	          'div',
	          { ref: this.getMenu, className: cx(_Dropdown2.default.Menu, { Fixed: fixed, RightShift: rightShift, TopShift: topShift, LeftShift: leftShift }, _Dropdown2.default[dropdownMenuStyle]) },
	          this.props.children || _react2.default.createElement(
	            'div',
	            null,
	            'Example'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(Dropdown);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Menu = __webpack_require__(1458);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.preventDefault = function (e) {
	      /* e = e || window.event;
	      const scrollTop = this.scrollContainer.scrollTop;
	      if (
	        e.preventDefault && e.deltaY && (
	          (e.deltaY > 0 && scrollTop >= this.scrollContainer.scrollHeight - this.scrollContainer.offsetHeight) ||
	          (e.deltaY < 0 && scrollTop <= 0)
	        )
	      ) {
	        // e.preventDefault();
	      }
	      // e.returnValue = false; */
	    }, _this.preventDefaultForScrollKeys = function (e) {
	      if (keys[e.keyCode]) {
	        _this.preventDefault(e);
	        return false;
	      }
	    }, _this.getScrollContainer = function (ref) {
	      _this.scrollContainer = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.onwheel = this.preventDefault; // modern standard
	      window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
	      window.ontouchmove = this.preventDefault; // mobile
	      // document.onkeydown  = this.preventDefaultForScrollKeys;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onmousewheel = document.onmousewheel = null;
	      window.onwheel = null;
	      window.ontouchmove = null;
	      // document.onkeydown = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn4;
	
	      var _props = this.props,
	          className = _props.className,
	          styleName = _props.styleName,
	          rightArrow = _props.rightArrow,
	          pure = _props.pure,
	          children = _props.children,
	          maxHeight = _props.maxHeight,
	          header = _props.header,
	          footer = _props.footer,
	          chessfilter = _props.chessfilter,
	          noArrow = _props.noArrow;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Menu2.default.Menu, _Menu2.default[styleName], className, _defineProperty({}, _Menu2.default.Wrapper, !pure), _defineProperty({}, _Menu2.default.MenuChessfilter, chessfilter)) },
	        header,
	        _react2.default.createElement(
	          'div',
	          { ref: this.getScrollContainer, className: (0, _classnames2.default)(_defineProperty({}, _Menu2.default.scrollArea, !!maxHeight), 'custom-scrollbar'), style: { maxHeight: maxHeight } },
	          children
	        ),
	        noArrow ? '' : _react2.default.createElement('div', {
	          className: (0, _classnames2.default)(_Menu2.default.Arrow, (_cn4 = {}, _defineProperty(_cn4, _Menu2.default.RightArrow, rightArrow), _defineProperty(_cn4, _Menu2.default.RightArrowInCollection, location.href.includes('ncollection')), _cn4))
	        }),
	        footer
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).setDesc
	  , has = __webpack_require__(69)
	  , TAG = __webpack_require__(35)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(169)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1307);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FlatsWrapper":"styles__FlatsWrapper___3z8M5","FlatsTitle":"styles__FlatsTitle___3fQzu","FlatsFilters":"styles__FlatsFilters___3WhHU","FlatsFilter":"styles__FlatsFilter___Yid9e","FlatsFilterInputs":"styles__FlatsFilterInputs___3e8Sn","InputWrap":"styles__InputWrap___1h_M6","Input":"styles__Input___cEgH-","Prefix":"styles__Prefix___Ub2mw","Filled":"styles__Filled___AmsLh","InputPrice":"styles__InputPrice___26RRL","InputArea":"styles__InputArea___1Ojou","Select":"styles__Select___2B5Ob","SelectArrow":"styles__SelectArrow___Ec9aV","FlatsListTitle":"styles__FlatsListTitle___Lz_ke","FlatsListSort":"styles__FlatsListSort___2jZdK","FlatsListItem":"styles__FlatsListItem___3H0EW","Left":"styles__Left___3XKun","Active":"styles__Active___j9j4S","FlatTitle":"styles__FlatTitle___1Jycj","FlatsListItemContent":"styles__FlatsListItemContent___2Ftbo","Floor":"styles__Floor___1V_Qt","Price":"styles__Price___2OQFZ","FlatPlan":"styles__FlatPlan___cbuon","WithoutPLan":"styles__WithoutPLan___24RQh","TagPromo":"styles__TagPromo___kg4hV","TagReserve":"styles__TagReserve___1L7gX","FlatPrice":"styles__FlatPrice___1kIDd","FlatHousing":"styles__FlatHousing___16D9-","Done":"styles__Done___1xVRU","InProcess":"styles__InProcess___1e_V0","FlatsListShowMore":"styles__FlatsListShowMore___2UQVw","DropdownInterior":"styles__DropdownInterior___16xg_","DropdownInteriorButton":"styles__DropdownInteriorButton___1XbWZ","DropdownText":"styles__DropdownText___3KtwH","DropdownInteriorText":"styles__DropdownInteriorText___1z2CO","DropdownInteriorIcon":"styles__DropdownInteriorIcon___214-O","DropdownInteriorMenu":"styles__DropdownInteriorMenu___3Y0QB","InteriorMenuItem":"styles__InteriorMenuItem___3YYAh","Dropdown":"styles__Dropdown___2CYRe","DropdownIcon":"styles__DropdownIcon___1Ghqe","DropdownButton":"styles__DropdownButton___1S3SK","DropdownMenu":"styles__DropdownMenu___2fVIt","DropdownMenuItem":"styles__DropdownMenuItem___1AICe","FlatsListItemHidden":"styles__FlatsListItemHidden___3MdIv","FlatPlanBig":"styles__FlatPlanBig___1UA3u","FlatPlanHover":"styles__FlatPlanHover___lxIrh","FlatInfo":"styles__FlatInfo___2Fe39","FlatInfoItem":"styles__FlatInfoItem___2AqNT","FlatStatus":"styles__FlatStatus___35uSf","FloorPlanBtn":"styles__FloorPlanBtn___17omy","ImageInner":"styles__ImageInner___X-LY8","floorWrapper":"styles__floorWrapper___2xFjD","SpinnerImage":"styles__SpinnerImage___27Ts8","ShowMd":"styles__ShowMd___2J81-","ModalContent":"styles__ModalContent___3zmsR","fadein":"styles__fadein___2MXRc","badMessageContainer":"styles__badMessageContainer___khFvp","alignTop":"styles__alignTop___19SxC","badMessageLeft":"styles__badMessageLeft___3xc-B","badMessageImage":"styles__badMessageImage___1aQYu","badMessageTitle":"styles__badMessageTitle___19Xuf","badMessageSubtitle":"styles__badMessageSubtitle___3Qff4","badMessageBtn":"styles__badMessageBtn___2l1vP","ModalClose":"styles__ModalClose___TB8OC","OnlyMobile":"styles__OnlyMobile___2unZU","ShowMobile":"styles__ShowMobile___1riDc","HiddenMd":"styles__HiddenMd___1x1Yk","Interior":"styles__Interior___24xeT","Right":"styles__Right___3JwEn","RightFloor":"styles__RightFloor___2Uz97","TagsWrapper":"styles__TagsWrapper___1FPjk","MobileHide":"styles__MobileHide___pK0MD","PriceMobile":"styles__PriceMobile___3OmTJ","Favorite":"styles__Favorite___10JP4","HideMobile":"styles__HideMobile___MUiV7"};

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Profile":"Profile__Profile___3rIZG","HasNotification":"Profile__HasNotification___4rhjE","ButtonGroup":"Profile__ButtonGroup___3MoVw","TabButton":"Profile__TabButton___3vS-d","Active":"Profile__Active___2_A79","SubscriptionBarInProfile":"Profile__SubscriptionBarInProfile___3lBvy","PermissionNotification":"Profile__PermissionNotification___3tqaN","Container":"Profile__Container___bLH_Z","Title":"Profile__Title___2JLPz","Inner":"Profile__Inner___2kR8_","FormInner":"Profile__FormInner___2tszn","PopupFormInner":"Profile__PopupFormInner___1trHC","PopupInner":"Profile__PopupInner___14TF6","ButtonSave":"Profile__ButtonSave___Cpoj3","AvatarWrapper":"Profile__AvatarWrapper___2x42X","Section":"Profile__Section___3aGr0","SectionInputs":"Profile__SectionInputs___3JBaA","SectionSocial":"Profile__SectionSocial___14C0h","Social":"Profile__Social___1EWUa","SectionTitle":"Profile__SectionTitle___17V8_","InputWrap":"Profile__InputWrap___L9wQZ","PhoneInputWrap":"Profile__PhoneInputWrap___21epJ","TextareaWrap":"Profile__TextareaWrap___3lJyH","Loader":"Profile__Loader___2jVEx","rotate":"Profile__rotate___1-kc-","Message":"Profile__Message___1NiV1","Error":"Profile__Error___1Oega","SocialInputWrap":"Profile__SocialInputWrap___Szzp0","Input":"Profile__Input___2O0en","Textarea":"Profile__Textarea___99LyF","SocialInput":"Profile__SocialInput___3ZN1y","SocialLabel":"Profile__SocialLabel___W8Luz","ButtonsWrap":"Profile__ButtonsWrap___65ZUz","ButtonsWrapSticky":"Profile__ButtonsWrapSticky___2igka","Extend":"Profile__Extend___2c0mN","Nav":"Profile__Nav___1CIX2","Button":"Profile__Button___14WcP","ButtonNewMember":"Profile__ButtonNewMember___1mUBU","MembersList":"Profile__MembersList___2NH_M","Member":"Profile__Member___2Ae8a","AvatarWrap":"Profile__AvatarWrap___1DARj","InputsWrap":"Profile__InputsWrap___2Cmpo","InputWrapper":"Profile__InputWrapper___32qZb","TextareaWrapper":"Profile__TextareaWrapper___1Nq6D","PairInputs":"Profile__PairInputs___1Yr69"};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/banner-placeholder.d56c1d33.jpg";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(251);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(250),
	    isLength = __webpack_require__(362);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(104);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isFunction = __webpack_require__(259);
	var curryN = __webpack_require__(51);
	var toString = __webpack_require__(182);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _isArray = __webpack_require__(104);
	var _isString = __webpack_require__(261);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isString = __webpack_require__(261);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var map = __webpack_require__(63);
	var prop = __webpack_require__(376);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _toString = __webpack_require__(1839);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(1977);
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(2003);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  CancelledError: true,
	  QueryCache: true,
	  QueryClient: true,
	  QueryObserver: true,
	  QueriesObserver: true,
	  InfiniteQueryObserver: true,
	  MutationCache: true,
	  MutationObserver: true,
	  setLogger: true,
	  notifyManager: true,
	  focusManager: true,
	  onlineManager: true,
	  hashQueryKey: true,
	  isError: true,
	  isCancelledError: true,
	  dehydrate: true,
	  hydrate: true
	};
	exports.hydrate = exports.dehydrate = exports.isCancelledError = exports.isError = exports.hashQueryKey = exports.onlineManager = exports.focusManager = exports.notifyManager = exports.setLogger = exports.MutationObserver = exports.MutationCache = exports.InfiniteQueryObserver = exports.QueriesObserver = exports.QueryObserver = exports.QueryClient = exports.QueryCache = exports.CancelledError = void 0;
	
	var _retryer = __webpack_require__(186);
	
	exports.CancelledError = _retryer.CancelledError;
	exports.isCancelledError = _retryer.isCancelledError;
	
	var _queryCache = __webpack_require__(674);
	
	exports.QueryCache = _queryCache.QueryCache;
	
	var _queryClient = __webpack_require__(2018);
	
	exports.QueryClient = _queryClient.QueryClient;
	
	var _queryObserver = __webpack_require__(393);
	
	exports.QueryObserver = _queryObserver.QueryObserver;
	
	var _queriesObserver = __webpack_require__(673);
	
	exports.QueriesObserver = _queriesObserver.QueriesObserver;
	
	var _infiniteQueryObserver = __webpack_require__(669);
	
	exports.InfiniteQueryObserver = _infiniteQueryObserver.InfiniteQueryObserver;
	
	var _mutationCache = __webpack_require__(671);
	
	exports.MutationCache = _mutationCache.MutationCache;
	
	var _mutationObserver = __webpack_require__(672);
	
	exports.MutationObserver = _mutationObserver.MutationObserver;
	
	var _logger = __webpack_require__(273);
	
	exports.setLogger = _logger.setLogger;
	
	var _notifyManager = __webpack_require__(57);
	
	exports.notifyManager = _notifyManager.notifyManager;
	
	var _focusManager = __webpack_require__(272);
	
	exports.focusManager = _focusManager.focusManager;
	
	var _onlineManager = __webpack_require__(392);
	
	exports.onlineManager = _onlineManager.onlineManager;
	
	var _utils = __webpack_require__(43);
	
	exports.hashQueryKey = _utils.hashQueryKey;
	exports.isError = _utils.isError;
	
	var _hydration = __webpack_require__(2016);
	
	exports.dehydrate = _hydration.dehydrate;
	exports.hydrate = _hydration.hydrate;
	
	var _types = __webpack_require__(2019);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  exports[key] = _types[key];
	});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isCancelable = isCancelable;
	exports.isCancelledError = isCancelledError;
	exports.Retryer = exports.CancelledError = void 0;
	
	var _focusManager = __webpack_require__(272);
	
	var _onlineManager = __webpack_require__(392);
	
	var _utils = __webpack_require__(43);
	
	function defaultRetryDelay(failureCount) {
	  return Math.min(1000 * Math.pow(2, failureCount), 30000);
	}
	
	function isCancelable(value) {
	  return typeof (value == null ? void 0 : value.cancel) === 'function';
	}
	
	var CancelledError = function CancelledError(options) {
	  this.revert = options == null ? void 0 : options.revert;
	  this.silent = options == null ? void 0 : options.silent;
	};
	
	exports.CancelledError = CancelledError;
	
	function isCancelledError(value) {
	  return value instanceof CancelledError;
	} // CLASS
	
	
	var Retryer = function Retryer(config) {
	  var _this = this;
	
	  var cancelRetry = false;
	  var cancelFn;
	  var continueFn;
	  var promiseResolve;
	  var promiseReject;
	  this.abort = config.abort;
	
	  this.cancel = function (cancelOptions) {
	    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
	  };
	
	  this.cancelRetry = function () {
	    cancelRetry = true;
	  };
	
	  this.continueRetry = function () {
	    cancelRetry = false;
	  };
	
	  this.continue = function () {
	    return continueFn == null ? void 0 : continueFn();
	  };
	
	  this.failureCount = 0;
	  this.isPaused = false;
	  this.isResolved = false;
	  this.isTransportCancelable = false;
	  this.promise = new Promise(function (outerResolve, outerReject) {
	    promiseResolve = outerResolve;
	    promiseReject = outerReject;
	  });
	
	  var resolve = function resolve(value) {
	    if (!_this.isResolved) {
	      _this.isResolved = true;
	      config.onSuccess == null ? void 0 : config.onSuccess(value);
	      continueFn == null ? void 0 : continueFn();
	      promiseResolve(value);
	    }
	  };
	
	  var reject = function reject(value) {
	    if (!_this.isResolved) {
	      _this.isResolved = true;
	      config.onError == null ? void 0 : config.onError(value);
	      continueFn == null ? void 0 : continueFn();
	      promiseReject(value);
	    }
	  };
	
	  var pause = function pause() {
	    return new Promise(function (continueResolve) {
	      continueFn = continueResolve;
	      _this.isPaused = true;
	      config.onPause == null ? void 0 : config.onPause();
	    }).then(function () {
	      continueFn = undefined;
	      _this.isPaused = false;
	      config.onContinue == null ? void 0 : config.onContinue();
	    });
	  }; // Create loop function
	
	
	  var run = function run() {
	    // Do nothing if already resolved
	    if (_this.isResolved) {
	      return;
	    }
	
	    var promiseOrValue; // Execute query
	
	    try {
	      promiseOrValue = config.fn();
	    } catch (error) {
	      promiseOrValue = Promise.reject(error);
	    } // Create callback to cancel this fetch
	
	
	    cancelFn = function cancelFn(cancelOptions) {
	      if (!_this.isResolved) {
	        reject(new CancelledError(cancelOptions));
	        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported
	
	        if (isCancelable(promiseOrValue)) {
	          try {
	            promiseOrValue.cancel();
	          } catch (_unused) {}
	        }
	      }
	    }; // Check if the transport layer support cancellation
	
	
	    _this.isTransportCancelable = isCancelable(promiseOrValue);
	    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
	      var _config$retry, _config$retryDelay;
	
	      // Stop if the fetch is already resolved
	      if (_this.isResolved) {
	        return;
	      } // Do we need to retry the request?
	
	
	      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
	      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
	      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
	      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
	
	      if (cancelRetry || !shouldRetry) {
	        // We are done if the query does not need to be retried
	        reject(error);
	        return;
	      }
	
	      _this.failureCount++; // Notify on fail
	
	      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay
	
	      (0, _utils.sleep)(delay) // Pause if the document is not visible or when the device is offline
	      .then(function () {
	        if (!_focusManager.focusManager.isFocused() || !_onlineManager.onlineManager.isOnline()) {
	          return pause();
	        }
	      }).then(function () {
	        if (cancelRetry) {
	          reject(error);
	        } else {
	          run();
	        }
	      });
	    });
	  }; // Start loop
	
	
	  run();
	};
	
	exports.Retryer = Retryer;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sticky = __webpack_require__(2070);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _sticky2.default;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(404)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ACTION_TYPE_DELIMITER = exports.DEFAULT_NAMESPACE = void 0;
	var DEFAULT_NAMESPACE = '/';
	exports.DEFAULT_NAMESPACE = DEFAULT_NAMESPACE;
	var ACTION_TYPE_DELIMITER = '||';
	exports.ACTION_TYPE_DELIMITER = ACTION_TYPE_DELIMITER;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  if (typeof value !== 'object' || value === null) return false;
	  var proto = value;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(value) === proto;
	};
	
	exports.default = _default;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + "." + name : name;
	};
	
	var _default = formatName;
	exports["default"] = _default;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EMPTY_OBSERVER = exports.SafeSubscriber = exports.Subscriber = void 0;
	var isFunction_1 = __webpack_require__(27);
	var Subscription_1 = __webpack_require__(64);
	var config_1 = __webpack_require__(193);
	var reportUnhandledError_1 = __webpack_require__(837);
	var noop_1 = __webpack_require__(48);
	var NotificationFactories_1 = __webpack_require__(2207);
	var timeoutProvider_1 = __webpack_require__(823);
	var errorContext_1 = __webpack_require__(440);
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    function Subscriber(destination) {
	        var _this = _super.call(this) || this;
	        _this.isStopped = false;
	        if (destination) {
	            _this.destination = destination;
	            if (Subscription_1.isSubscription(destination)) {
	                destination.add(_this);
	            }
	        }
	        else {
	            _this.destination = exports.EMPTY_OBSERVER;
	        }
	        return _this;
	    }
	    Subscriber.create = function (next, error, complete) {
	        return new SafeSubscriber(next, error, complete);
	    };
	    Subscriber.prototype.next = function (value) {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.nextNotification(value), this);
	        }
	        else {
	            this._next(value);
	        }
	    };
	    Subscriber.prototype.error = function (err) {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.errorNotification(err), this);
	        }
	        else {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    Subscriber.prototype.complete = function () {
	        if (this.isStopped) {
	            handleStoppedNotification(NotificationFactories_1.COMPLETE_NOTIFICATION, this);
	        }
	        else {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.isStopped = true;
	            _super.prototype.unsubscribe.call(this);
	            this.destination = null;
	        }
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        try {
	            this.destination.error(err);
	        }
	        finally {
	            this.unsubscribe();
	        }
	    };
	    Subscriber.prototype._complete = function () {
	        try {
	            this.destination.complete();
	        }
	        finally {
	            this.unsubscribe();
	        }
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	var _bind = Function.prototype.bind;
	function bind(fn, thisArg) {
	    return _bind.call(fn, thisArg);
	}
	var ConsumerObserver = (function () {
	    function ConsumerObserver(partialObserver) {
	        this.partialObserver = partialObserver;
	    }
	    ConsumerObserver.prototype.next = function (value) {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.next) {
	            try {
	                partialObserver.next(value);
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	    };
	    ConsumerObserver.prototype.error = function (err) {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.error) {
	            try {
	                partialObserver.error(err);
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	        else {
	            handleUnhandledError(err);
	        }
	    };
	    ConsumerObserver.prototype.complete = function () {
	        var partialObserver = this.partialObserver;
	        if (partialObserver.complete) {
	            try {
	                partialObserver.complete();
	            }
	            catch (error) {
	                handleUnhandledError(error);
	            }
	        }
	    };
	    return ConsumerObserver;
	}());
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(observerOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        var partialObserver;
	        if (isFunction_1.isFunction(observerOrNext) || !observerOrNext) {
	            partialObserver = {
	                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
	                error: error !== null && error !== void 0 ? error : undefined,
	                complete: complete !== null && complete !== void 0 ? complete : undefined,
	            };
	        }
	        else {
	            var context_1;
	            if (_this && config_1.config.useDeprecatedNextContext) {
	                context_1 = Object.create(observerOrNext);
	                context_1.unsubscribe = function () { return _this.unsubscribe(); };
	                partialObserver = {
	                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
	                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
	                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1),
	                };
	            }
	            else {
	                partialObserver = observerOrNext;
	            }
	        }
	        _this.destination = new ConsumerObserver(partialObserver);
	        return _this;
	    }
	    return SafeSubscriber;
	}(Subscriber));
	exports.SafeSubscriber = SafeSubscriber;
	function handleUnhandledError(error) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	        errorContext_1.captureError(error);
	    }
	    else {
	        reportUnhandledError_1.reportUnhandledError(error);
	    }
	}
	function defaultErrorHandler(err) {
	    throw err;
	}
	function handleStoppedNotification(notification, subscriber) {
	    var onStoppedNotification = config_1.config.onStoppedNotification;
	    onStoppedNotification && timeoutProvider_1.timeoutProvider.setTimeout(function () { return onStoppedNotification(notification, subscriber); });
	}
	exports.EMPTY_OBSERVER = {
	    closed: true,
	    next: noop_1.noop,
	    error: defaultErrorHandler,
	    complete: noop_1.noop,
	};
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.config = void 0;
	exports.config = {
	    onUnhandledError: null,
	    onStoppedNotification: null,
	    Promise: undefined,
	    useDeprecatedSynchronousErrorHandling: false,
	    useDeprecatedNextContext: false,
	};
	//# sourceMappingURL=config.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defaultIfEmpty = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function defaultIfEmpty(defaultValue) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            subscriber.next(value);
	        }, function () {
	            if (!hasValue) {
	                subscriber.next(defaultValue);
	            }
	            subscriber.complete();
	        }));
	    });
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeAll = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var identity_1 = __webpack_require__(47);
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    return mergeMap_1.mergeMap(identity_1.identity, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observeOn = void 0;
	var executeSchedule_1 = __webpack_require__(113);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule_1.executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
	    });
	}
	exports.observeOn = observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.subscribeOn = void 0;
	var lift_1 = __webpack_require__(9);
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return lift_1.operate(function (source, subscriber) {
	        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
	    });
	}
	exports.subscribeOn = subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchMap = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function switchMap(project, resultSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSubscriber = null;
	        var index = 0;
	        var isComplete = false;
	        var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
	            var innerIndex = 0;
	            var outerIndex = index++;
	            innerFrom_1.innerFrom(project(value, outerIndex)).subscribe((innerSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) { return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue); }, function () {
	                innerSubscriber = null;
	                checkComplete();
	            })));
	        }, function () {
	            isComplete = true;
	            checkComplete();
	        }));
	    });
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.take = void 0;
	var empty_1 = __webpack_require__(77);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function take(count) {
	    return count <= 0
	        ?
	            function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var seen = 0;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (++seen <= count) {
	                    subscriber.next(value);
	                    if (count <= seen) {
	                        subscriber.complete();
	                    }
	                }
	            }));
	        });
	}
	exports.take = take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throwIfEmpty = void 0;
	var EmptyError_1 = __webpack_require__(133);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function throwIfEmpty(errorFactory) {
	    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            subscriber.next(value);
	        }, function () { return (hasValue ? subscriber.complete() : subscriber.error(errorFactory())); }));
	    });
	}
	exports.throwIfEmpty = throwIfEmpty;
	function defaultErrorFactory() {
	    return new EmptyError_1.EmptyError();
	}
	//# sourceMappingURL=throwIfEmpty.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncAction = void 0;
	var Action_1 = __webpack_require__(2232);
	var intervalProvider_1 = __webpack_require__(2243);
	var arrRemove_1 = __webpack_require__(112);
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.pending = false;
	        return _this;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        this.state = state;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.pending = true;
	        this.delay = delay;
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return intervalProvider_1.intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay != null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        intervalProvider_1.intervalProvider.clearInterval(id);
	        return undefined;
	    };
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, _delay) {
	        var errored = false;
	        var errorValue;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = e ? e : new Error('Scheduled action threw falsy error');
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            var _a = this, id = _a.id, scheduler = _a.scheduler;
	            var actions = scheduler.actions;
	            this.work = this.state = this.scheduler = null;
	            this.pending = false;
	            arrRemove_1.arrRemove(actions, this);
	            if (id != null) {
	                this.id = this.recycleAsyncId(scheduler, id, null);
	            }
	            this.delay = null;
	            _super.prototype.unsubscribe.call(this);
	        }
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncScheduler = void 0;
	var Scheduler_1 = __webpack_require__(732);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler_1.Scheduler.now; }
	        var _this = _super.call(this, SchedulerAction, now) || this;
	        _this.actions = [];
	        _this._active = false;
	        _this._scheduled = undefined;
	        return _this;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this._active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this._active = true;
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions.shift()));
	        this._active = false;
	        if (error) {
	            while ((action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var subscribeToArray_1 = __webpack_require__(867);
	var scheduleArray_1 = __webpack_require__(455);
	function fromArray(input, scheduler) {
	    if (!scheduler) {
	        return new Observable_1.Observable(subscribeToArray_1.subscribeToArray(input));
	    }
	    else {
	        return scheduleArray_1.scheduleArray(input, scheduler);
	    }
	}
	exports.fromArray = fromArray;
	//# sourceMappingURL=fromArray.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	var DefaultIfEmptyOperator = (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	var DefaultIfEmptySubscriber = (function (_super) {
	    __extends(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        var _this = _super.call(this, destination) || this;
	        _this.defaultValue = defaultValue;
	        _this.isEmpty = true;
	        return _this;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Action_1 = __webpack_require__(2355);
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.pending = false;
	        return _this;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        this.state = state;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.pending = true;
	        this.delay = delay;
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        clearInterval(id);
	        return undefined;
	    };
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Scheduler_1 = __webpack_require__(842);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler_1.Scheduler.now; }
	        var _this = _super.call(this, SchedulerAction, function () {
	            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
	                return AsyncScheduler.delegate.now();
	            }
	            else {
	                return now();
	            }
	        }) || this;
	        _this.actions = [];
	        _this.active = false;
	        _this.scheduled = undefined;
	        return _this;
	    }
	    AsyncScheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
	            return AsyncScheduler.delegate.schedule(work, delay, state);
	        }
	        else {
	            return _super.prototype.schedule.call(this, work, delay, state);
	        }
	    };
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift());
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getSymbolIterator() {
	    if (typeof Symbol !== 'function' || !Symbol.iterator) {
	        return '@@iterator';
	    }
	    return Symbol.iterator;
	}
	exports.getSymbolIterator = getSymbolIterator;
	exports.iterator = getSymbolIterator();
	exports.$$iterator = exports.iterator;
	//# sourceMappingURL=iterator.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ArgumentOutOfRangeErrorImpl = (function () {
	    function ArgumentOutOfRangeErrorImpl() {
	        Error.call(this);
	        this.message = 'argument out of range';
	        this.name = 'ArgumentOutOfRangeError';
	        return this;
	    }
	    ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
	    return ArgumentOutOfRangeErrorImpl;
	})();
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmptyErrorImpl = (function () {
	    function EmptyErrorImpl() {
	        Error.call(this);
	        this.message = 'no elements in sequence';
	        this.name = 'EmptyError';
	        return this;
	    }
	    EmptyErrorImpl.prototype = Object.create(Error.prototype);
	    return EmptyErrorImpl;
	})();
	exports.EmptyError = EmptyErrorImpl;
	//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createRequestActions = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxActAsync = __webpack_require__(279);
	
	var _Config = __webpack_require__(16);
	
	var _lodash = __webpack_require__(566);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createRequestActions = exports.createRequestActions = function createRequestActions(_ref) {
	  var type = _ref.type,
	      url = _ref.url,
	      _ref$method = _ref.method,
	      method = _ref$method === undefined ? 'get' : _ref$method,
	      _ref$path = _ref.path,
	      path = _ref$path === undefined ? 'data' : _ref$path;
	  return (0, _reduxActAsync.createActionAsync)(type, function (params) {
	    var data = typeof params === 'function' ? {} : method === 'get' ? { params: params } : params;
	    return _axios2.default[method]('' + _Config.ROOT_URL + url, data);
	  }, {
	    ok: {
	      payloadReducer: function payloadReducer(payload) {
	        return _extends({}, payload, {
	          response: (0, _lodash2.default)(payload.response.data, path)
	        });
	      }
	    }
	  });
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.favoritesNews = exports.nedvexNews = exports.allNews = undefined;
	
	var _actions = __webpack_require__(211);
	
	var allNews = exports.allNews = (0, _actions.createRequestActions)({
	  type: 'ALL_NEWS',
	  url: '/buildings/news/all?type=all'
	});
	
	var nedvexNews = exports.nedvexNews = (0, _actions.createRequestActions)({
	  type: 'NEDVEX_NEWS',
	  url: '/buildings/news/all?type=nedvex'
	});
	
	var favoritesNews = exports.favoritesNews = (0, _actions.createRequestActions)({
	  type: 'FAVORITES_NEWS',
	  url: '/buildings/news/all?type=favorites'
	});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _About = __webpack_require__(534);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _reactI18next = __webpack_require__(4);
	
	var _house = __webpack_require__(1595);
	
	var _house2 = _interopRequireDefault(_house);
	
	var _total = __webpack_require__(1596);
	
	var _total2 = _interopRequireDefault(_total);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reselect = __webpack_require__(44);
	
	var _Print = __webpack_require__(472);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _SpinnerImage = __webpack_require__(218);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	var _iconZoom = __webpack_require__(343);
	
	var _iconZoom2 = _interopRequireDefault(_iconZoom);
	
	var _iconLock = __webpack_require__(235);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _utils = __webpack_require__(12);
	
	var _CollectionsDialog = __webpack_require__(162);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _reactRouter = __webpack_require__(274);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _helper = __webpack_require__(93);
	
	var _ViewType = __webpack_require__(914);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddToCollection = function AddToCollection(_ref) {
	  var chessId = _ref.chessId,
	      building = _ref.building,
	      isTable = _ref.isTable,
	      profile = _ref.profile,
	      objectType = _ref.objectType;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var location = (0, _reactRouter.useLocation)();
	
	  if (location.pathname.includes('print')) {
	    return null;
	  }
	
	  var handleClick = function handleClick() {
	    _tracker2.default.sendEvent('Web_Lots_AddToCollection', {
	      name: building.title,
	      id: building.id
	    });
	
	    (0, _ga.trackGA)(_ga.gaEvent.buildingChessLotAboutButtonsClick({
	      eventLabel: 'v_podborku',
	      eventContext: isTable ? 'shahmatka' : 'spisok',
	      productType: objectType,
	      productName: building.title,
	      productID: building.id,
	      user_id: profile.id
	    }));
	
	    dispatch((0, _environment.setPopUp)(_react2.default.createElement(_CollectionsDialog2.default, {
	      chessId: chessId,
	      building: {
	        data: building
	      },
	      profile: profile,
	      objectType: objectType
	    }), {
	      closeStyleName: 'Default',
	      contentStyleName: 'Default',
	      closeIcon: 'default',
	      lockScroll: false
	    }));
	  };
	
	  return _react2.default.createElement(
	    'p',
	    { className: _About2.default.Button, onClick: handleClick },
	    t('components.building.rightMenu.addToCollection')
	  );
	};
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About(props) {
	    _classCallCheck(this, About);
	
	    var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building,
	          isTable = _this$props.isTable;
	
	      var eventContext = isTable ? 'shahmatka' : 'spisok';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.renderFund = function () {
	      var _this$props2 = _this.props,
	          room = _this$props2.data,
	          print = _this$props2.print,
	          client = _this$props2.client,
	          type_id = _this$props2.building.type_id,
	          t = _this$props2.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_About2.default.About, _defineProperty({}, _About2.default.Client, client), _defineProperty({}, _About2.default.Print, print)) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_About2.default.Row, _About2.default.Wide) },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.Floor },
	            _react2.default.createElement(
	              'span',
	              { className: _About2.default.FloorNumber },
	              '' + (type_id === 2 ? '' : '№') + (0, _utils.printNumber)(room.data.number)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.FlatReserved },
	            _react2.default.createElement('img', { src: _iconLock2.default, alt: '', className: _About2.default.FlatReservedImage }),
	            _react2.default.createElement('p', {
	              className: _About2.default.FlatReservedText,
	              dangerouslySetInnerHTML: {
	                __html: type_id === 1 ? t('components.building.rightMenu.flatReserved') : t('components.building.rightMenu.houseReserved')
	              }
	            })
	          )
	        )
	      );
	    };
	
	    _this.renderReserved = function () {
	      var _this$props3 = _this.props,
	          room = _this$props3.data,
	          sectionId = _this$props3.sectionId,
	          print = _this$props3.print,
	          client = _this$props3.client,
	          _this$props3$withImag = _this$props3.withImage,
	          withImage = _this$props3$withImag === undefined ? true : _this$props3$withImag,
	          chessfilter = _this$props3.chessfilter,
	          isClientView = _this$props3.isClientView,
	          type_id = _this$props3.building.type_id,
	          t = _this$props3.t,
	          currency = _this$props3.currency;
	      var _room$data = room.data,
	          _room$data$costFormat = _room$data.costFormatted,
	          costFormatted = _room$data$costFormat === undefined ? (0, _utils.formatNumber)(room.data.priceAll) : _room$data$costFormat,
	          _room$data$priceForma = _room$data.priceFormatted,
	          priceFormatted = _room$data$priceForma === undefined ? (0, _utils.formatNumber)(room.data.priceM) : _room$data$priceForma;
	      var isLoaded = _this.state.isLoaded;
	
	      var isReserved = (0, _helper.isReserved)(room.data.status);
	      var isAssign = room.data.status == 'assignmentStatus';
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_About2.default.About, _defineProperty({}, _About2.default.Client, client), _defineProperty({}, _About2.default.Print, print), _defineProperty({}, _About2.default.Chessfilter, chessfilter))
	        },
	        withImage && room.data.poligon_id ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_About2.default.Row, _About2.default.ImageWrap) },
	          _react2.default.createElement(_SpinnerImage2.default, {
	            key: room.id,
	            className: _About2.default.ImageInner,
	            imageSrc: _Config.ROOT_URL + '/image/polygon?id=' + room.data.poligon_id + '&preset=' + (print ? 1000 : 200),
	            imageAlt: 'Room preview',
	            handleImageLoad: _this.handleImageLoad,
	            handleImageError: _this.props.handleImageError,
	            spinner: _react2.default.createElement('div', { className: _About2.default.Loader })
	          }),
	          isLoaded ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_About2.default.Zoom, 'tooltip'), onClick: _this.setPopUp },
	            _react2.default.createElement('img', {
	              alt: 'zoom',
	              src: _iconZoom2.default,
	              'data-tip': t('components.building.rightMenu.zoomImg'),
	              'data-for': 'global'
	            })
	          ) : null
	        ) : null,
	        costFormatted !== '0' && room.data.area ? _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_About2.default.Row, _About2.default.RowReserved, _defineProperty({}, _About2.default.Wide, !room.data.poligon_id))
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.Floor },
	            _react2.default.createElement(
	              'span',
	              { className: _About2.default.FloorNumber },
	              '' + (type_id === 2 ? '' : '№') + (0, _utils.printNumber)(room.data.number)
	            ),
	            room.data.view_action === '1' ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagPromo },
	              t('components.building.rightMenu.promo')
	            ) : null,
	            isReserved ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagReserve },
	              _react2.default.createElement(
	                'i',
	                null,
	                t('components.building.rightMenu.reserve')
	              )
	            ) : null,
	            isAssign ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagAssign },
	              t('components.building.rightMenu.assign')
	            ) : null,
	            room.data.poligon_id && !isClientView ? _react2.default.createElement(_Print2.default, {
	              className: _About2.default.PrintButton,
	              pure: true,
	              tooltip: t('components.building.rightMenu.print'),
	              href: '/print1/' + _this.props.building.id + '?roomPlan=' + room.id + '&sectionId=' + sectionId
	            }) : null
	          ),
	          room.hidden ? _react2.default.createElement(
	            'div',
	            { className: _About2.default.Sold },
	            _react2.default.createElement(
	              'span',
	              null,
	              t('components.building.rightMenu.sold')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.Price },
	              costFormatted !== '0' ? _react2.default.createElement(
	                'span',
	                null,
	                t('components.building.rightMenu.cost', { costFormatted: costFormatted, currency: currency })
	              ) : '',
	              priceFormatted !== '0' ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.Small },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.building.rightMenu.price', { priceFormatted: priceFormatted, currency: currency })
	                )
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.FlatOptions },
	              room.data.area ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('img', { src: _house2.default }),
	                  ' ',
	                  t('components.building.rightMenu.area', { area: room.data.area })
	                )
	              ) : '',
	              room.data.apartmentsName ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                room.data.apartmentsName
	              ) : '',
	              room.data.interior === 'predChistInt' ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.building.rightMenu.predChistInt')
	                )
	              ) : room.data.interiorName ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  room.data.interiorName
	                )
	              ) : '',
	              !!room.data.floors && _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                t('components.building.rightMenu.floorNumber', { number: room.data.floors })
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_About2.default.Row, _About2.default.Wide) },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.Floor },
	            '' + (type_id === 2 ? '' : '№') + (0, _utils.printNumber)(room.data.number)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.FlatReserved },
	            _react2.default.createElement(
	              'p',
	              { className: _About2.default.FlatReservedText },
	              t('components.building.rightMenu.reserved')
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderSimple = function () {
	      var _this$props4 = _this.props,
	          room = _this$props4.data,
	          sectionId = _this$props4.sectionId,
	          print = _this$props4.print,
	          client = _this$props4.client,
	          _this$props4$withImag = _this$props4.withImage,
	          withImage = _this$props4$withImag === undefined ? true : _this$props4$withImag,
	          chessfilter = _this$props4.chessfilter,
	          isClientView = _this$props4.isClientView,
	          type_id = _this$props4.building.type_id,
	          t = _this$props4.t,
	          currency = _this$props4.currency,
	          objectType = _this$props4.objectType,
	          profile = _this$props4.profile,
	          isTable = _this$props4.isTable;
	      var _room$data2 = room.data,
	          _room$data2$costForma = _room$data2.costFormatted,
	          costFormatted = _room$data2$costForma === undefined ? (0, _utils.formatNumber)(room.data.priceAll) : _room$data2$costForma,
	          _room$data2$priceForm = _room$data2.priceFormatted,
	          priceFormatted = _room$data2$priceForm === undefined ? (0, _utils.formatNumber)(room.data.priceM) : _room$data2$priceForm;
	      var isLoaded = _this.state.isLoaded;
	
	      var isReserved = (0, _helper.isReserved)(room.data.status);
	      var isAssign = room.data.status == 'assignmentStatus';
	      var isCottage = type_id === 2;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_About2.default.About, _defineProperty({}, _About2.default.Client, client), _defineProperty({}, _About2.default.Print, print), _defineProperty({}, _About2.default.Chessfilter, chessfilter))
	        },
	        withImage && room.data.poligon_id ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_About2.default.Row, _About2.default.ImageWrap) },
	          _react2.default.createElement(_SpinnerImage2.default, {
	            key: room.id,
	            className: _About2.default.ImageInner,
	            imageSrc: _Config.ROOT_URL + '/image/polygon?id=' + room.data.poligon_id + '&preset=' + (print ? 1000 : 200),
	            imageAlt: 'Room preview',
	            handleImageLoad: _this.handleImageLoad,
	            handleImageError: _this.props.handleImageError,
	            spinner: _react2.default.createElement('div', { className: _About2.default.Loader })
	          }),
	          isLoaded ? _react2.default.createElement(
	            'div',
	            { className: _About2.default.Zoom, onClick: _this.setPopUp },
	            _react2.default.createElement('img', {
	              alt: 'zoom',
	              src: _iconZoom2.default,
	              'data-tip': t('components.building.rightMenu.zoomImg'),
	              'data-for': 'global'
	            })
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_About2.default.Row, _About2.default.FlatInfo, _defineProperty({}, _About2.default.Wide, !room.data.poligon_id)) },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.Floor },
	            _react2.default.createElement(
	              'span',
	              { className: _About2.default.FloorNumber },
	              '' + (isCottage ? '' : '№') + (0, _utils.printNumber)(room.data.number)
	            ),
	            room.data.view_action === '1' && !(room.data.status === 'soldStatus') ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagPromo },
	              t('components.building.rightMenu.promo')
	            ) : null,
	            isReserved ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagReserve },
	              _react2.default.createElement(
	                'i',
	                null,
	                t('components.building.rightMenu.reserve')
	              )
	            ) : null,
	            isAssign ? _react2.default.createElement(
	              'span',
	              { className: _About2.default.TagAssign },
	              t('components.building.rightMenu.assign')
	            ) : null,
	            room.data.poligon_id && !isClientView ? _react2.default.createElement(_Print2.default, {
	              className: _About2.default.PrintButton,
	              pure: true,
	              tooltip: t('components.building.rightMenu.print'),
	              href: '/print/' + _this.props.building.id + '?roomPlan=' + room.id + '&sectionId=' + sectionId,
	              onPrintClick: function onPrintClick() {
	                return _this.handleTrackEvent({
	                  eventName: 'buildingChessLotAboutButtonsClick',
	                  eventLabel: 'pechat'
	                });
	              }
	            }) : null
	          ),
	          room.hidden ? _react2.default.createElement(
	            'div',
	            { className: _About2.default.Sold },
	            _react2.default.createElement(
	              'span',
	              null,
	              t('components.building.rightMenu.sold')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.Price },
	              costFormatted !== '0' ? _react2.default.createElement(
	                'span',
	                null,
	                t('components.building.rightMenu.cost', { costFormatted: costFormatted, currency: currency })
	              ) : '',
	              priceFormatted !== '0' ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.Small },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.building.rightMenu.price', { priceFormatted: priceFormatted, currency: currency })
	                )
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.FlatOptions },
	              room.data.area ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('img', { src: _house2.default }),
	                  ' ',
	                  t('components.building.rightMenu.area', { area: room.data.area })
	                )
	              ) : '',
	              room.data.apartmentsName ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                room.data.apartmentsName
	              ) : '',
	              room.data.interior === 'predChistInt' ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.building.rightMenu.predChistInt')
	                )
	              ) : room.data.interiorName ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  room.data.interiorName
	                )
	              ) : '',
	              !!room.data.floors && _react2.default.createElement(
	                'div',
	                { className: _About2.default.FlatOption },
	                t('components.building.rightMenu.floorNumber', { number: room.data.floors })
	              ),
	              room.data.totalArea > 0 && isCottage && _react2.default.createElement(
	                'div',
	                { className: _About2.default.TotalArea },
	                _react2.default.createElement('img', { src: _total2.default }),
	                ' ',
	                t('components.building.rightMenu.totalArea', {
	                  totalArea: room.data.totalArea
	                })
	              )
	            )
	          ),
	          (0, _ViewType.ViewType)(room.data),
	          room.data.status !== 'soldStatus' && _react2.default.createElement(AddToCollection, {
	            chessId: +_this.props.data.id,
	            building: _this.props.building,
	            profile: profile,
	            objectType: objectType,
	            isTable: isTable
	          })
	        )
	      );
	    };
	
	    _this.state = {
	      isLoaded: false
	    };
	
	    _this.setPopUp = _this.setPopUp.bind(_this);
	    _this.handleImageLoad = _this.handleImageLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(About, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prev) {
	      if (prev.data !== this.props.data) {
	        this.setState({ isLoaded: false });
	      }
	    }
	  }, {
	    key: 'setPopUp',
	    value: function setPopUp() {
	      var _this2 = this;
	
	      var _props = this.props,
	          setPopUp = _props.setPopUp,
	          room = _props.data,
	          building = _props.building,
	          t = _props.t,
	          currency = _props.currency;
	      var _room$data3 = room.data,
	          _room$data3$costForma = _room$data3.costFormatted,
	          costFormatted = _room$data3$costForma === undefined ? (0, _utils.formatNumber)(room.data.priceAll) : _room$data3$costForma,
	          _room$data3$priceForm = _room$data3.priceFormatted,
	          priceFormatted = _room$data3$priceForm === undefined ? (0, _utils.formatNumber)(room.data.priceM) : _room$data3$priceForm;
	
	      var isReserved = (0, _helper.isReserved)(room.data.status);
	      var isCottage = building.type_id === 2;
	
	      this.handleTrackEvent({
	        eventName: 'buildingChessLotAboutButtonsClick',
	        eventLabel: 'uvelichit_planirovku_kvartiry'
	      });
	
	      setPopUp(_react2.default.createElement(
	        'div',
	        { className: _About2.default.PopUpOuter },
	        _react2.default.createElement(
	          'div',
	          { className: _About2.default.PopUpInner },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.TopInfo },
	            _react2.default.createElement(
	              'span',
	              null,
	              building.title,
	              ' /',
	              ' ',
	              room.data.floorName == 'М' ? t('components.building.rightMenu.attic') : room.data.floorName + ' ' + t('components.building.rightMenu.floor'),
	              ' ',
	              '/ ',
	              isCottage ? '' : '№',
	              (0, _utils.printNumber)(room.data.number),
	              ' '
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.BottomInfo },
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.LeftInfo },
	              _react2.default.createElement(_SpinnerImage2.default, {
	                key: room.id,
	                className: _About2.default.ImageInfo,
	                imageSrc: _Config.ROOT_URL + '/image/polygon?id=' + room.data.poligon_id + '&preset=800',
	                imageAlt: 'Room',
	                spinner: _react2.default.createElement('div', { className: _About2.default.LoaderInfo })
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.RightInfo },
	              room.hidden ? isReserved ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement('span', {
	                  dangerouslySetInnerHTML: {
	                    __html: t('components.building.rightMenu.reserved')
	                  }
	                })
	              ) : _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.building.rightMenu.sold')
	                )
	              ) : isReserved && costFormatted == 0 ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement('span', {
	                  dangerouslySetInnerHTML: {
	                    __html: t('components.building.rightMenu.reserved')
	                  }
	                })
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.PopupFlatInfo },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.FlatNum },
	                    isCottage ? '' : '№',
	                    (0, _utils.printNumber)(room.data.number)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.PopupTagsWrap },
	                    room.data.view_action === '1' && !(room.data.status === 'soldStatus') ? _react2.default.createElement(
	                      'span',
	                      { className: _About2.default.TagPromo },
	                      t('components.building.rightMenu.promo')
	                    ) : null,
	                    isReserved ? _react2.default.createElement(
	                      'span',
	                      { className: _About2.default.TagReserve },
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        t('components.building.rightMenu.reserve')
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.PriceInfo },
	                  t('components.building.rightMenu.cost', { costFormatted: costFormatted, currency: currency }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.SmallInfo },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.rightMenu.price', { priceFormatted: priceFormatted, currency: currency })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_About2.default.FlatOptions, _About2.default.PopupFlatOptions) },
	                  room.data.area ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: _house2.default }),
	                      ' ',
	                      t('components.building.rightMenu.area', { area: room.data.area })
	                    )
	                  ) : '',
	                  room.data.apartmentsName ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    room.data.apartmentsName
	                  ) : '',
	                  room.data.interior == 'predChistInt' ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.rightMenu.predChistInt')
	                    )
	                  ) : room.data.interiorName ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      room.data.interiorName
	                    )
	                  ) : '',
	                  !!room.data.floors && _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    t('components.building.rightMenu.floorNumber', {
	                      number: room.data.floors
	                    })
	                  ),
	                  room.data.totalArea > 0 && isCottage && _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.TotalArea },
	                    _react2.default.createElement('img', { src: _total2.default }),
	                    ' ',
	                    t('components.building.rightMenu.totalArea', {
	                      totalArea: room.data.totalArea
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      ), {
	        className: _About2.default.popupFlat,
	        backgroundClassName: _About2.default.popupFlatBg,
	        contentClassName: _About2.default.popupFlatContent,
	        closeIcon: 'gallery',
	        hideCloseIcon: true,
	        onClose: function onClose() {
	          return _this2.handleTrackEvent({ eventName: 'buildingChessLotPlanCloseClick' });
	        }
	      });
	    }
	  }, {
	    key: 'handleImageLoad',
	    value: function handleImageLoad() {
	      this.setState({ isLoaded: true }, _reactTooltip2.default.rebuild);
	      if (this.props.handleImageLoad) {
	        this.props.handleImageLoad();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var room = this.props.data;
	
	
	      var isFund = room.data.status === 'fundStatus';
	      var isReserved = (0, _helper.isReserved)(room.data.status);
	
	      if (isFund) {
	        return this.renderFund();
	      }
	
	      if (isReserved) {
	        this.renderReserved();
	      }
	
	      return this.renderSimple();
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	var aboutSelector = (0, _reselect.createSelector)(function (state) {
	  return state.profile;
	}, function (profile) {
	  return {
	    currency: profile.user_region.country_currency_symbol
	  };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(aboutSelector, { setPopUp: _environment.setPopUp })(About));

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PayForTarifBtn = __webpack_require__(1049);
	
	var _PayForTarifBtn2 = _interopRequireDefault(_PayForTarifBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PayForTarifBtn2.default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHighlightedText = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getHighlightedText = exports.getHighlightedText = function getHighlightedText(text, higlight) {
	  var parts = text.split(new RegExp('(' + higlight + ')', 'gi'));
	  return _react2.default.createElement(
	    'span',
	    null,
	    ' ',
	    parts.map(function (part, i) {
	      return _react2.default.createElement(
	        'span',
	        { key: i, style: part.toLowerCase() === higlight.toLowerCase() ? { color: 'red' } : {} },
	        part
	      );
	    }),
	    ' '
	  );
	};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(165);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dropdown2.default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Menu = __webpack_require__(166);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu2.default;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SpinnerImage = __webpack_require__(1113);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SpinnerImage2.default;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apartments = {
	  studioAp: _i18n2.default.t('constants.apartments.studioAp'),
	  oneAp: _i18n2.default.t('constants.apartments.oneAp'),
	  twoAp: _i18n2.default.t('constants.apartments.twoAp'),
	  threeAp: _i18n2.default.t('constants.apartments.threeAp'),
	  allAp: _i18n2.default.t('constants.apartments.allAp'),
	  penthaus: _i18n2.default.t('constants.apartments.penthaus')
	};
	
	exports.default = apartments;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendPhone = exports.Types = exports.Steps = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Steps = exports.Steps = {
	  Phone: 'phone',
	  Code: 'code'
	};
	
	var Types = exports.Types = {
	  Call: 'call',
	  Sms: 'sms'
	};
	
	var sendPhone = exports.sendPhone = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref2) {
	    var phone = _ref2.phone,
	        type = _ref2.type;
	    var url;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            url = type === Types.Call ? _Config.ROOT_URL + '/calls/makecall' : _Config.ROOT_URL + '/user/send/sms';
	            _context.prev = 1;
	            _context.next = 4;
	            return _axios2.default.post(url, {
	              phone: phone.match(/\d+/g).join('')
	            });
	
	          case 4:
	            return _context.abrupt('return', Promise.resolve(true));
	
	          case 7:
	            _context.prev = 7;
	            _context.t0 = _context['catch'](1);
	            return _context.abrupt('return', Promise.reject(_context.t0.response.data.error['error-code']));
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[1, 7]]);
	  }));
	
	  return function sendPhone(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _payments = __webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var profile = _ref.profile,
	      payments = _ref.payments;
	  return {
	    profile: profile,
	    isShown: payments.isNotificationShown
	  };
	};
	
	var withObservePayments = function withObservePayments(WrapedComponent) {
	  var _dec, _class;
	
	  var WithObservePayments = (_dec = (0, _reactRedux.connect)(mapStateToProps, { showNotification: _payments.showNotification }), _dec(_class = function (_Component) {
	    _inherits(WithObservePayments, _Component);
	
	    function WithObservePayments() {
	      _classCallCheck(this, WithObservePayments);
	
	      return _possibleConstructorReturn(this, (WithObservePayments.__proto__ || Object.getPrototypeOf(WithObservePayments)).apply(this, arguments));
	    }
	
	    _createClass(WithObservePayments, [{
	      key: 'UNSAFE_componentWillReceiveProps',
	      value: function UNSAFE_componentWillReceiveProps(_ref2) {
	        var profile = _ref2.profile,
	            showNotification = _ref2.showNotification,
	            isShown = _ref2.isShown;
	
	        // console.log(1);
	        // this.interval = !this.interval && setInterval(() => {
	        //   console.log(profile);
	        //
	        //   if (profile.isLoaded && profile.tariff) {
	        //     const { tariff } = profile;
	        //     console.log(tariff.countDay);
	        //     if (tariff.countDay <= 80 && !isShown) {
	        //       showNotification();
	        //     }
	        //   }
	        // }, 10000);
	        if (profile.isLoaded && profile.tariff) {
	          var tariff = profile.tariff;
	
	          if (tariff.countDay <= 5 && tariff.countDay !== 0 && !isShown) {
	            var psd = +localStorage.getItem('psd');
	            var shouldDisplay = psd ? Date.now() - 24 * 3600 * 1000 >= psd : true;
	            if (shouldDisplay) {
	              showNotification();
	            }
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapedComponent, this.props);
	      }
	    }]);
	
	    return WithObservePayments;
	  }(_react.Component)) || _class);
	
	  return WithObservePayments;
	};
	
	exports.default = withObservePayments;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _configureStore = __webpack_require__(1178);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactI18next = __webpack_require__(4);
	
	var _utils = __webpack_require__(12);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _profile = __webpack_require__(40);
	
	var _App = __webpack_require__(1123);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(1319);
	
	__webpack_require__(1323);
	
	__webpack_require__(1322);
	
	__webpack_require__(1324);
	
	var _runtime = __webpack_require__(1757);
	
	var _runtime2 = _interopRequireDefault(_runtime);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_runtime2.default.install({
	  onInstalled: function onInstalled() {
	    console.log('SW Event:', 'onInstalled');
	  },
	  onUpdating: function onUpdating() {
	    console.log('SW Event:', 'onUpdating');
	  },
	  onUpdateReady: function onUpdateReady() {
	    console.log('SW Event:', 'onUpdateReady');
	    // Tells to new SW to take control immediately
	    _runtime2.default.applyUpdate();
	  },
	  onUpdated: function onUpdated() {
	    console.log('SW Event:', 'onUpdated');
	    // Reload the webpage to load into the new version
	    window.location.reload();
	  },
	
	  onUpdateFailed: function onUpdateFailed() {
	    console.log('SW Event:', 'onUpdateFailed');
	  }
	});
	
	if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
	  navigator.serviceWorker.getRegistrations().then(function (registrations) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var registration = _step.value;
	
	        registration.unregister();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  });
	}
	
	var store = exports.store = (0, _configureStore2.default)();
	
	var token = '';
	try {
	  token = localStorage.getItem('token');
	} catch (e) {}
	
	(0, _utils.initAxios)(token);
	
	// axios.interceptors.response.use(
	//   function (response) {
	//     // Do something with response data
	//     return response
	//   }, function (error) {
	//     if (R.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NO_PAID_SERVICE') {
	//       window.location = '/';
	//     }
	//     if (R.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NOT_PERMISSION') {
	//       store.getState().authentication.authenticated = false
	//       store.getState().loginForms.isLoading = false
	//       store.getState().loginForms.loginState = 'Number'
	//       localStorage.removeItem('token')
	//       initAxios()
	//       store.dispatch(userLogout())
	//     }
	//     return Promise.reject(error)
	//   }
	// )
	_axios2.default.interceptors.request.use(function (config) {
	  var token = '';
	  try {
	    token = localStorage.getItem('token');
	  } catch (e) {}
	  config.headers = { 'x-api-token': token };
	  if (token && _axios2.default.defaults.headers.common['x-api-token'] !== token) {
	    (0, _utils.initAxios)(token);
	    store.dispatch((0, _profile.loadProfile)());
	  }
	  return config;
	}, function (error) {
	  return Promise.reject(error);
	});
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(
	    _reactI18next.I18nextProvider,
	    { i18n: _i18n2.default },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        _i18n2.default.t('common.title')
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouterDom.BrowserRouter,
	      { basename: '' },
	      _react2.default.createElement(_App2.default, null)
	    )
	  )
	), document.getElementById('root'));

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(79)
	  , IObject  = __webpack_require__(227)
	  , toObject = __webpack_require__(102)
	  , toLength = __webpack_require__(74)
	  , asc      = __webpack_require__(1187);
	module.exports = function(TYPE){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(34)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(81)
	  , redefineAll    = __webpack_require__(229)
	  , forOf          = __webpack_require__(144)
	  , strictNew      = __webpack_require__(231)
	  , isObject       = __webpack_require__(29)
	  , fails          = __webpack_require__(50)
	  , $iterDetect    = __webpack_require__(325)
	  , setToStringTag = __webpack_require__(167);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO;
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        strictNew(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    IS_WEAK || instance.forEach(function(val, key){
	      BUGGY_ZERO = 1 / key === -Infinity;
	    });
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(95)
	  , redefine = __webpack_require__(81)
	  , fails    = __webpack_require__(50)
	  , defined  = __webpack_require__(94)
	  , wks      = __webpack_require__(35);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , original = ''[KEY];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return original.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return original.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(100);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(327)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(81)
	  , hide           = __webpack_require__(95)
	  , has            = __webpack_require__(69)
	  , Iterators      = __webpack_require__(145)
	  , $iterCreate    = __webpack_require__(324)
	  , setToStringTag = __webpack_require__(167)
	  , getProto       = __webpack_require__(20).getProto
	  , ITERATOR       = __webpack_require__(35)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(81);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(34)
	  , $           = __webpack_require__(20)
	  , DESCRIPTORS = __webpack_require__(73)
	  , SPECIES     = __webpack_require__(35)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , defined = __webpack_require__(94)
	  , fails   = __webpack_require__(50)
	  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec){
	  var exp  = {};
	  exp[KEY] = exec(trim);
	  $export($export.P + $export.F * fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  }), 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(143)
	  , ITERATOR  = __webpack_require__(35)('iterator')
	  , Iterators = __webpack_require__(145);
	module.exports = __webpack_require__(62).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"resultSection":"style__resultSection___FAe2A","resultSectionTitle":"style__resultSectionTitle___1-hIo","resultItem":"style__resultItem___2R3cN","resultItemRegion":"style__resultItemRegion___3ik-X","resultItemWrap":"style__resultItemWrap___2qY0Z","resultItemTitle":"style__resultItemTitle___2LHP_","resultItemTitleRegion":"style__resultItemTitleRegion___EyA9X","resultItemDescrip":"style__resultItemDescrip___BEml0"};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-lock.d111b32c.svg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-user-sq.e9cea28a.svg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/update-arrows.520d5f52.svg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no-floor.79e178fc.png";

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1706),
	    listCacheDelete = __webpack_require__(1707),
	    listCacheGet = __webpack_require__(1708),
	    listCacheHas = __webpack_require__(1709),
	    listCacheSet = __webpack_require__(1710);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(83);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(175);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(578);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1664),
	    isObjectLike = __webpack_require__(120);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1704);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1663),
	    isObjectLike = __webpack_require__(120);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(83),
	    stubFalse = __webpack_require__(1750);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(147),
	    isObject = __webpack_require__(103);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(147),
	    isObjectLike = __webpack_require__(120);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1667),
	    baseUnary = __webpack_require__(1680),
	    nodeUtil = __webpack_require__(1720);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(571),
	    copyArray = __webpack_require__(577),
	    isArray = __webpack_require__(75),
	    isSymbol = __webpack_require__(251),
	    stringToPath = __webpack_require__(587),
	    toKey = __webpack_require__(174),
	    toString = __webpack_require__(592);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var curry = __webpack_require__(256);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _isPlaceholder = __webpack_require__(260);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var map = __webpack_require__(63);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var liftN = __webpack_require__(631);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(258);
	var _dispatchable = __webpack_require__(37);
	var _has = __webpack_require__(56);
	var _reduce = __webpack_require__(71);
	var _xreduceBy = __webpack_require__(1853);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general `groupBy` function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(615);
	var _curry2 = __webpack_require__(3);
	var filter = __webpack_require__(370);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _isString = __webpack_require__(261);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = warn;
	exports.warnOnce = warnOnce;
	exports.loadNamespaces = loadNamespaces;
	exports.hasLoadedNamespace = hasLoadedNamespace;
	exports.getDisplayName = getDisplayName;
	
	function warn() {
	  if (console && console.warn) {
	    var _console;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
	
	    (_console = console).warn.apply(_console, args);
	  }
	}
	
	var alreadyWarned = {};
	
	function warnOnce() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
	  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
	  warn.apply(void 0, args);
	}
	
	function loadNamespaces(i18n, ns, cb) {
	  i18n.loadNamespaces(ns, function () {
	    if (i18n.isInitialized) {
	      cb();
	    } else {
	      var initialized = function initialized() {
	        setTimeout(function () {
	          i18n.off('initialized', initialized);
	        }, 0);
	        cb();
	      };
	
	      i18n.on('initialized', initialized);
	    }
	  });
	}
	
	function oldI18nextHasLoadedNamespace(ns, i18n) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var lng = i18n.languages[0];
	  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
	  var lastLng = i18n.languages[i18n.languages.length - 1];
	  if (lng.toLowerCase() === 'cimode') return true;
	
	  var loadNotPending = function loadNotPending(l, n) {
	    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
	    return loadState === -1 || loadState === 2;
	  };
	
	  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
	  if (i18n.hasResourceBundle(lng, ns)) return true;
	  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
	  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
	  return false;
	}
	
	function hasLoadedNamespace(ns, i18n) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!i18n.languages || !i18n.languages.length) {
	    warnOnce('i18n.languages were undefined or empty', i18n.languages);
	    return true;
	  }
	
	  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
	
	  if (!isNewerI18next) {
	    return oldI18nextHasLoadedNamespace(ns, i18n, options);
	  }
	
	  return i18n.hasLoadedNamespace(ns, {
	    precheck: function precheck(i18nInstance, loadNotPending) {
	      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
	    }
	  });
	}
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
	}

/***/ }),
/* 270 */
239,
/* 271 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.focusManager = exports.FocusManager = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _subscribable = __webpack_require__(126);
	
	var _utils = __webpack_require__(43);
	
	var FocusManager = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(FocusManager, _Subscribable);
	
	  function FocusManager() {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	
	    _this.setup = function (onFocus) {
	      var _window;
	
	      if (!_utils.isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
	        var listener = function listener() {
	          return onFocus();
	        }; // Listen to visibillitychange and focus
	
	
	        window.addEventListener('visibilitychange', listener, false);
	        window.addEventListener('focus', listener, false);
	        return function () {
	          // Be sure to unsubscribe if a new handler is set
	          window.removeEventListener('visibilitychange', listener);
	          window.removeEventListener('focus', listener);
	        };
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = FocusManager.prototype;
	
	  _proto.onSubscribe = function onSubscribe() {
	    if (!this.cleanup) {
	      this.setEventListener(this.setup);
	    }
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {
	    if (!this.hasListeners()) {
	      var _this$cleanup;
	
	      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
	      this.cleanup = undefined;
	    }
	  };
	
	  _proto.setEventListener = function setEventListener(setup) {
	    var _this$cleanup2,
	        _this2 = this;
	
	    this.setup = setup;
	    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
	    this.cleanup = setup(function (focused) {
	      if (typeof focused === 'boolean') {
	        _this2.setFocused(focused);
	      } else {
	        _this2.onFocus();
	      }
	    });
	  };
	
	  _proto.setFocused = function setFocused(focused) {
	    this.focused = focused;
	
	    if (focused) {
	      this.onFocus();
	    }
	  };
	
	  _proto.onFocus = function onFocus() {
	    this.listeners.forEach(function (listener) {
	      listener();
	    });
	  };
	
	  _proto.isFocused = function isFocused() {
	    if (typeof this.focused === 'boolean') {
	      return this.focused;
	    } // document global can be unavailable in react native
	
	
	    if (typeof document === 'undefined') {
	      return true;
	    }
	
	    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
	  };
	
	  return FocusManager;
	}(_subscribable.Subscribable);
	
	exports.FocusManager = FocusManager;
	var focusManager = new FocusManager();
	exports.focusManager = focusManager;

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getLogger = getLogger;
	exports.setLogger = setLogger;
	// TYPES
	// FUNCTIONS
	var logger = console;
	
	function getLogger() {
	  return logger;
	}
	
	function setLogger(newLogger) {
	  logger = newLogger;
	}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(2048);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(276);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _animateScroll = __webpack_require__(688);
	
	var _animateScroll2 = _interopRequireDefault(_animateScroll);
	
	var _scrollEvents = __webpack_require__(398);
	
	var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __mapped = {};
	var __activeLink = void 0;
	
	exports.default = {
	
	  unmount: function unmount() {
	    __mapped = {};
	  },
	
	  register: function register(name, element) {
	    __mapped[name] = element;
	  },
	
	  unregister: function unregister(name) {
	    delete __mapped[name];
	  },
	
	  get: function get(name) {
	    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
	  },
	
	  setActiveLink: function setActiveLink(link) {
	    return __activeLink = link;
	  },
	
	  getActiveLink: function getActiveLink() {
	    return __activeLink;
	  },
	
	  scrollTo: function scrollTo(to, props) {
	
	    var target = this.get(to);
	
	    if (!target) {
	      console.warn("target Element not found");
	      return;
	    }
	
	    props = _extends({}, props, { absolute: false });
	
	    var containerId = props.containerId;
	    var container = props.container;
	
	    var containerElement = void 0;
	    if (containerId) {
	      containerElement = document.getElementById(containerId);
	    } else if (container && container.nodeType) {
	      containerElement = container;
	    } else {
	      containerElement = document;
	    }
	
	    props.absolute = true;
	
	    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);
	
	    /*
	     * if animate is not provided just scroll into the view
	     */
	    if (!props.smooth) {
	      if (_scrollEvents2.default.registered['begin']) {
	        _scrollEvents2.default.registered['begin'](to, target);
	      }
	
	      if (containerElement === document) {
	        window.scrollTo(0, scrollOffset);
	      } else {
	        containerElement.scrollTop = scrollOffset;
	      }
	
	      if (_scrollEvents2.default.registered['end']) {
	        _scrollEvents2.default.registered['end'](to, target);
	      }
	
	      return;
	    }
	
	    /*
	     * Animate scrolling
	     */
	
	    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
	  }
	};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var pushHash = function pushHash(hash) {
	  hash = hash ? hash.indexOf('#') === 0 ? hash : '#' + hash : '';
	
	  if (history.pushState) {
	    var loc = window.location;
	    history.pushState(null, null, hash ? loc.pathname + loc.search + hash
	    // remove hash
	    : loc.pathname + loc.search);
	  } else {
	    location.hash = hash;
	  }
	};
	
	var getHash = function getHash() {
	  return window.location.hash.replace(/^#/, '');
	};
	
	var filterElementInContainer = function filterElementInContainer(container) {
	  return function (element) {
	    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
	  };
	};
	
	var calculatingOffsetParent = function calculatingOffsetParent(c, t) {
	  return t.offsetParent.isEqualNode(c) ? t.offsetTop : t.offsetTop + calculatingOffsetParent(c, t.offsetParent);
	};
	
	var scrollOffset = function scrollOffset(c, t) {
	  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== 'static' ? calculatingOffsetParent(c, t) : calculatingOffsetParent(c.offsetParent, t.offsetParent) - c.offsetTop;
	};
	
	exports.default = {
	  pushHash: pushHash,
	  getHash: getHash,
	  filterElementInContainer: filterElementInContainer,
	  scrollOffset: scrollOffset
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1992);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _defaultArrowRenderer = __webpack_require__(695);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(696);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(401);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(402);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(693);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(694);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	// !!! WARNING: ONLY CHANGE THIS FILE IF OUTPUT FOLDER CHANGES !!!
	// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	'use strict';
	
	// This determines which build to use based on the `NODE_ENV` of your end user.
	if (true) {
	  module.exports = __webpack_require__(2072);
	} else {
	  module.exports = require('./dist/development/react-yandex-maps.js');
	}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createReducerAsync = exports.createActionAsync = exports.ASYNC_META = undefined;
	
	var _createActionAsync = __webpack_require__(2076);
	
	var _createActionAsync2 = _interopRequireDefault(_createActionAsync);
	
	var _createReducerAsync = __webpack_require__(2077);
	
	var _createReducerAsync2 = _interopRequireDefault(_createReducerAsync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ASYNC_META = _createActionAsync.ASYNC_META;
	exports.createActionAsync = _createActionAsync2.default;
	exports.createReducerAsync = _createReducerAsync2.default;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createAction = _interopRequireDefault(__webpack_require__(707));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = (0, _createAction["default"])('Batch', function () {
	  for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
	    actions[_key] = arguments[_key];
	  }
	
	  if (actions.length === 1 && Array.isArray(actions[0])) {
	    return actions[0];
	  }
	
	  return actions;
	});
	
	exports["default"] = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _combineActions = _interopRequireDefault(__webpack_require__(2117));
	
	exports.combineActions = _combineActions.default;
	
	var _createAction = _interopRequireDefault(__webpack_require__(407));
	
	exports.createAction = _createAction.default;
	
	var _createActions = _interopRequireDefault(__webpack_require__(2118));
	
	exports.createActions = _createActions.default;
	
	var _createCurriedAction = _interopRequireDefault(__webpack_require__(2119));
	
	exports.createCurriedAction = _createCurriedAction.default;
	
	var _handleAction = _interopRequireDefault(__webpack_require__(709));
	
	exports.handleAction = _handleAction.default;
	
	var _handleActions = _interopRequireDefault(__webpack_require__(2120));
	
	exports.handleActions = _handleActions.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'function';
	};
	
	exports.default = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof Map !== 'undefined' && value instanceof Map;
	};
	
	exports.default = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ConnectableObservable = void 0;
	var Observable_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(64);
	var refCount_1 = __webpack_require__(433);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var lift_1 = __webpack_require__(9);
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subjectFactory = subjectFactory;
	        _this._subject = null;
	        _this._refCount = 0;
	        _this._connection = null;
	        if (lift_1.hasLift(source)) {
	            _this.lift = source.lift;
	        }
	        return _this;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype._teardown = function () {
	        this._refCount = 0;
	        var _connection = this._connection;
	        this._subject = this._connection = null;
	        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var _this = this;
	        var connection = this._connection;
	        if (!connection) {
	            connection = this._connection = new Subscription_1.Subscription();
	            var subject_1 = this.getSubject();
	            connection.add(this.source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subject_1, undefined, function () {
	                _this._teardown();
	                subject_1.complete();
	            }, function (err) {
	                _this._teardown();
	                subject_1.error(err);
	            }, function () { return _this._teardown(); })));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concat = void 0;
	var concatAll_1 = __webpack_require__(288);
	var args_1 = __webpack_require__(66);
	var from_1 = __webpack_require__(109);
	function concat() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return concatAll_1.concatAll()(from_1.from(args, args_1.popScheduler(args)));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defer = void 0;
	var Observable_1 = __webpack_require__(28);
	var innerFrom_1 = __webpack_require__(23);
	function defer(observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        innerFrom_1.innerFrom(observableFactory()).subscribe(subscriber);
	    });
	}
	exports.defer = defer;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatAll = void 0;
	var mergeAll_1 = __webpack_require__(195);
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.connect = void 0;
	var Subject_1 = __webpack_require__(46);
	var innerFrom_1 = __webpack_require__(23);
	var lift_1 = __webpack_require__(9);
	var fromSubscribable_1 = __webpack_require__(2217);
	var DEFAULT_CONFIG = {
	    connector: function () { return new Subject_1.Subject(); },
	};
	function connect(selector, config) {
	    if (config === void 0) { config = DEFAULT_CONFIG; }
	    var connector = config.connector;
	    return lift_1.operate(function (source, subscriber) {
	        var subject = connector();
	        innerFrom_1.innerFrom(selector(fromSubscribable_1.fromSubscribable(subject))).subscribe(subscriber);
	        subscriber.add(source.subscribe(subject));
	    });
	}
	exports.connect = connect;
	//# sourceMappingURL=connect.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.multicast = void 0;
	var ConnectableObservable_1 = __webpack_require__(285);
	var isFunction_1 = __webpack_require__(27);
	var connect_1 = __webpack_require__(289);
	function multicast(subjectOrSubjectFactory, selector) {
	    var subjectFactory = isFunction_1.isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () { return subjectOrSubjectFactory; };
	    if (isFunction_1.isFunction(selector)) {
	        return connect_1.connect(selector, {
	            connector: subjectFactory,
	        });
	    }
	    return function (source) { return new ConnectableObservable_1.ConnectableObservable(source, subjectFactory); };
	}
	exports.multicast = multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeout = exports.TimeoutError = void 0;
	var async_1 = __webpack_require__(65);
	var isDate_1 = __webpack_require__(442);
	var lift_1 = __webpack_require__(9);
	var innerFrom_1 = __webpack_require__(23);
	var createErrorClass_1 = __webpack_require__(135);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var executeSchedule_1 = __webpack_require__(113);
	exports.TimeoutError = createErrorClass_1.createErrorClass(function (_super) {
	    return function TimeoutErrorImpl(info) {
	        if (info === void 0) { info = null; }
	        _super(this);
	        this.message = 'Timeout has occurred';
	        this.name = 'TimeoutError';
	        this.info = info;
	    };
	});
	function timeout(config, schedulerArg) {
	    var _a = (isDate_1.isValidDate(config) ? { first: config } : typeof config === 'number' ? { each: config } : config), first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : async_1.asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
	    if (first == null && each == null) {
	        throw new TypeError('No timeout provided.');
	    }
	    return lift_1.operate(function (source, subscriber) {
	        var originalSourceSubscription;
	        var timerSubscription;
	        var lastValue = null;
	        var seen = 0;
	        var startTimer = function (delay) {
	            timerSubscription = executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                try {
	                    originalSourceSubscription.unsubscribe();
	                    innerFrom_1.innerFrom(_with({
	                        meta: meta,
	                        lastValue: lastValue,
	                        seen: seen,
	                    })).subscribe(subscriber);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                }
	            }, delay);
	        };
	        originalSourceSubscription = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
	            seen++;
	            subscriber.next((lastValue = value));
	            each > 0 && startTimer(each);
	        }, undefined, undefined, function () {
	            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
	                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
	            }
	            lastValue = null;
	        }));
	        !seen && startTimer(first != null ? (typeof first === 'number' ? first : +first - scheduler.now()) : each);
	    });
	}
	exports.timeout = timeout;
	function timeoutErrorFactory(info) {
	    throw new exports.TimeoutError(info);
	}
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observable = void 0;
	exports.observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isScheduler = void 0;
	var isFunction_1 = __webpack_require__(27);
	function isScheduler(value) {
	    return value && isFunction_1.isFunction(value.schedule);
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pipeFromArray = exports.pipe = void 0;
	var identity_1 = __webpack_require__(47);
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	function pipeFromArray(fns) {
	    if (fns.length === 0) {
	        return identity_1.identity;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var Subscription_1 = __webpack_require__(45);
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.value = null;
	        _this.hasNext = false;
	        _this.hasCompleted = false;
	        return _this;
	    }
	    AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.error = function (error) {
	        if (!this.hasCompleted) {
	            _super.prototype.error.call(this, error);
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var empty_1 = __webpack_require__(88);
	var of_1 = __webpack_require__(299);
	var throwError_1 = __webpack_require__(447);
	var NotificationKind;
	(function (NotificationKind) {
	    NotificationKind["NEXT"] = "N";
	    NotificationKind["ERROR"] = "E";
	    NotificationKind["COMPLETE"] = "C";
	})(NotificationKind = exports.NotificationKind || (exports.NotificationKind = {}));
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return of_1.of(this.value);
	            case 'E':
	                return throwError_1.throwError(this.error);
	            case 'C':
	                return empty_1.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	//# sourceMappingURL=Notification.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var _enable_super_gross_mode_that_will_cause_bad_things = false;
	exports.config = {
	    Promise: undefined,
	    set useDeprecatedSynchronousErrorHandling(value) {
	        if (value) {
	            var error = new Error();
	            console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
	        }
	        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
	            console.log('RxJS: Back to a better error behavior. Thank you. <3');
	        }
	        _enable_super_gross_mode_that_will_cause_bad_things = value;
	    },
	    get useDeprecatedSynchronousErrorHandling() {
	        return _enable_super_gross_mode_that_will_cause_bad_things;
	    },
	};
	//# sourceMappingURL=config.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var of_1 = __webpack_require__(299);
	var concatAll_1 = __webpack_require__(850);
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isScheduler_1 = __webpack_require__(90);
	var fromArray_1 = __webpack_require__(203);
	var scheduleArray_1 = __webpack_require__(455);
	function of() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args[args.length - 1];
	    if (isScheduler_1.isScheduler(scheduler)) {
	        args.pop();
	        return scheduleArray_1.scheduleArray(args, scheduler);
	    }
	    else {
	        return fromArray_1.fromArray(args);
	    }
	}
	exports.of = of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var map_1 = __webpack_require__(72);
	var from_1 = __webpack_require__(89);
	var innerSubscribe_1 = __webpack_require__(31);
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'function') {
	        return function (source) { return source.pipe(mergeMap(function (a, i) { return from_1.from(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
	    }
	    else if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.concurrent = concurrent;
	        _this.hasCompleted = false;
	        _this.buffer = [];
	        _this.active = 0;
	        _this.index = 0;
	        return _this;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish) {
	        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe_1.innerSubscribe(ish, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	exports.flatMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var scan_1 = __webpack_require__(451);
	var takeLast_1 = __webpack_require__(454);
	var defaultIfEmpty_1 = __webpack_require__(204);
	var pipe_1 = __webpack_require__(461);
	function reduce(accumulator, seed) {
	    if (arguments.length >= 2) {
	        return function reduceOperatorFunctionWithSeed(source) {
	            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
	        };
	    }
	    return function reduceOperatorFunction(source) {
	        return pipe_1.pipe(scan_1.scan(function (acc, value, index) { return accumulator(acc, value, index + 1); }), takeLast_1.takeLast(1))(source);
	    };
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmptyError_1 = __webpack_require__(209);
	var Subscriber_1 = __webpack_require__(14);
	function throwIfEmpty(errorFactory) {
	    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
	    return function (source) {
	        return source.lift(new ThrowIfEmptyOperator(errorFactory));
	    };
	}
	exports.throwIfEmpty = throwIfEmpty;
	var ThrowIfEmptyOperator = (function () {
	    function ThrowIfEmptyOperator(errorFactory) {
	        this.errorFactory = errorFactory;
	    }
	    ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
	    };
	    return ThrowIfEmptyOperator;
	}());
	var ThrowIfEmptySubscriber = (function (_super) {
	    __extends(ThrowIfEmptySubscriber, _super);
	    function ThrowIfEmptySubscriber(destination, errorFactory) {
	        var _this = _super.call(this, destination) || this;
	        _this.errorFactory = errorFactory;
	        _this.hasValue = false;
	        return _this;
	    }
	    ThrowIfEmptySubscriber.prototype._next = function (value) {
	        this.hasValue = true;
	        this.destination.next(value);
	    };
	    ThrowIfEmptySubscriber.prototype._complete = function () {
	        if (!this.hasValue) {
	            var err = void 0;
	            try {
	                err = this.errorFactory();
	            }
	            catch (e) {
	                err = e;
	            }
	            this.destination.error(err);
	        }
	        else {
	            return this.destination.complete();
	        }
	    };
	    return ThrowIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	function defaultErrorFactory() {
	    return new EmptyError_1.EmptyError();
	}
	//# sourceMappingURL=throwIfEmpty.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ObjectUnsubscribedErrorImpl = (function () {
	    function ObjectUnsubscribedErrorImpl() {
	        Error.call(this);
	        this.message = 'object unsubscribed';
	        this.name = 'ObjectUnsubscribedError';
	        return this;
	    }
	    ObjectUnsubscribedErrorImpl.prototype = Object.create(Error.prototype);
	    return ObjectUnsubscribedErrorImpl;
	})();
	exports.ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isArray_1 = __webpack_require__(59);
	function isNumeric(val) {
	    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}
	exports.isNumeric = isNumeric;
	//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var subscribeToArray_1 = __webpack_require__(867);
	var subscribeToPromise_1 = __webpack_require__(2370);
	var subscribeToIterable_1 = __webpack_require__(2368);
	var subscribeToObservable_1 = __webpack_require__(2369);
	var isArrayLike_1 = __webpack_require__(863);
	var isPromise_1 = __webpack_require__(865);
	var isObject_1 = __webpack_require__(459);
	var iterator_1 = __webpack_require__(207);
	var observable_1 = __webpack_require__(157);
	exports.subscribeTo = function (result) {
	    if (!!result && typeof result[observable_1.observable] === 'function') {
	        return subscribeToObservable_1.subscribeToObservable(result);
	    }
	    else if (isArrayLike_1.isArrayLike(result)) {
	        return subscribeToArray_1.subscribeToArray(result);
	    }
	    else if (isPromise_1.isPromise(result)) {
	        return subscribeToPromise_1.subscribeToPromise(result);
	    }
	    else if (!!result && typeof result[iterator_1.iterator] === 'function') {
	        return subscribeToIterable_1.subscribeToIterable(result);
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = "You provided " + value + " where a stream was expected."
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        throw new TypeError(msg);
	    }
	};
	//# sourceMappingURL=subscribeTo.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestToConnect = exports.hideNotification = exports.showNotification = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _ActionTypes = __webpack_require__(26);
	
	var t = _interopRequireWildcard(_ActionTypes);
	
	var _reduxActions = __webpack_require__(282);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Config = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var showNotification = exports.showNotification = (0, _reduxActions.createAction)(t.SHOW_PAYMENT_NOTIFCATION, function () {
	  localStorage.setItem('psd', Date.now());
	});
	
	var hideNotification = exports.hideNotification = (0, _reduxActions.createAction)(t.HIDE_PAYMENT_NOTIFCATION);
	
	var requestToConnect = exports.requestToConnect = (0, _reduxActions.createAction)(t.REQUEST_TO_CONNECT, function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _axios2.default.post(_Config.ROOT_URL + '/user/company/send/email', data);
	
	          case 2:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}());
	
	// export const requestToConnect = (вфеф) => (dispatch, getState) =>
	//   dispatch(_requestToConnect(getState));

/***/ }),
/* 308 */
[2394, 909],
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(956);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Chess = __webpack_require__(920);
	
	var _Chess2 = _interopRequireDefault(_Chess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Main: _Main2.default,
	  Chess: _Chess2.default
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BuildingCard = __webpack_require__(960);
	
	var _BuildingCard2 = _interopRequireDefault(_BuildingCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BuildingCard2.default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FilterLabel = __webpack_require__(962);
	
	var _FilterLabel2 = _interopRequireDefault(_FilterLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FilterLabel2.default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _YMap = __webpack_require__(319);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Map = __webpack_require__(1374);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _utils = __webpack_require__(562);
	
	var _constants = __webpack_require__(92);
	
	var _supercluster = __webpack_require__(2382);
	
	var _supercluster2 = _interopRequireDefault(_supercluster);
	
	var _objects = __webpack_require__(99);
	
	var _YPlaceInfo = __webpack_require__(1120);
	
	var _YPlaceInfo2 = _interopRequireDefault(_YPlaceInfo);
	
	var _placeInfoList = __webpack_require__(1121);
	
	var _placeInfoList2 = _interopRequireDefault(_placeInfoList);
	
	var _reselect = __webpack_require__(44);
	
	var _iconClose = __webpack_require__(340);
	
	var _iconClose2 = _interopRequireDefault(_iconClose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var size = {
	  width: 800,
	  height: 500
	};
	
	var clusterOptions = {
	  radius: 68,
	  maxZoom: 14,
	  minPoints: 10
	};
	
	var MainMap = (_temp = _class = function (_Component) {
	  _inherits(MainMap, _Component);
	
	  function MainMap(props) {
	    _classCallCheck(this, MainMap);
	
	    var _this = _possibleConstructorReturn(this, (MainMap.__proto__ || Object.getPrototypeOf(MainMap)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var mapProps = _this.fitBounds(props.data);
	    var data = _this.transformData(props.data);
	
	    _this.state = {
	      mapProps: mapProps,
	      data: data,
	      key: 1
	    };
	    return _this;
	  }
	
	  _createClass(MainMap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextData = nextProps.data;
	      var data = this.props.data;
	
	      if (nextData !== data) {
	        var mapProps = this.fitBounds(nextData);
	        var _data = this.transformData(nextData);
	        this.setState(function (state) {
	          return { data: _data, mapProps: mapProps, info: null, key: state.key + 1 };
	        });
	
	        if (this.map) {
	          this.map.setCenter([mapProps.center.lat, mapProps.center.lng], mapProps.zoom);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.data !== this.props.data && this.props.data.length > 0) {
	        var mapProps = this.fitBounds(this.props.data);
	        if (this.state.mapProps.center.lat !== mapProps.center.lat || this.state.mapProps.center.lng !== mapProps.center.lng || this.state.mapProps.zoom !== mapProps.zoom) {
	          this.setState({ mapProps: mapProps });
	
	          if (this.map) {
	            this.map.setCenter([mapProps.center.lat, mapProps.center.lng], mapProps.zoom);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'transformData',
	    value: function transformData(data) {
	      return data.map(function (place) {
	        return _extends({}, place, {
	          geometry: { coordinates: [place.longitude, place.latitude] }
	        });
	      });
	    }
	  }, {
	    key: 'fitBounds',
	    value: function fitBounds(data) {
	      var maxLat = -Infinity,
	          minLat = Infinity,
	          maxLng = -Infinity,
	          minLng = Infinity;
	
	      if (data.length > 1) {
	        data.forEach(function (item) {
	          var lat = parseFloat(item.latitude);
	          var lng = parseFloat(item.longitude);
	
	          if (lat > maxLat) maxLat = lat;
	          if (lat < minLat) minLat = lat;
	          if (lng > maxLng) maxLng = lng;
	          if (lng < minLng) minLng = lng;
	        });
	      } else if (data.length === 1) {
	        var lat = parseFloat(data[0].latitude);
	        var lng = parseFloat(data[0].longitude);
	
	        maxLat = lat + 0.005;
	        minLat = lat - 0.005;
	        maxLng = lng + 0.005;
	        minLng = lng - 0.005;
	      } else {
	        return {
	          center: { lat: 0, lng: 0 },
	          zoom: 1
	        };
	      }
	
	      if (maxLat === -Infinity || minLat === Infinity || maxLng === -Infinity || minLng === Infinity) {
	        return {
	          center: { lat: 0, lng: 0 },
	          zoom: 1
	        };
	      }
	
	      var bounds = {
	        nw: {
	          lat: maxLat,
	          lng: minLng
	        },
	        se: {
	          lat: minLat,
	          lng: maxLng
	        }
	      };
	
	      return (0, _utils.fitBounds)(bounds, size);
	    }
	  }, {
	    key: 'getClusters',
	    value: function getClusters() {
	      if (!(this.state.mapProps.bounds || this.state.mapProps.newBounds)) {
	        return [];
	      }
	
	      var _state = this.state,
	          data = _state.data,
	          mapProps = _state.mapProps;
	      var zoom = mapProps.zoom,
	          bounds = mapProps.bounds,
	          newBounds = mapProps.newBounds;
	
	      var _ref = bounds || newBounds,
	          nw = _ref.nw,
	          se = _ref.se;
	
	      var index = new _supercluster2.default(_extends({}, clusterOptions, {
	        map: function map(props) {
	          return _extends({}, props, {
	            clusteredPoints: []
	          });
	        }
	      }));
	
	      index.load(data);
	
	      var clusters = index.getClusters([nw.lng, se.lat, se.lng, nw.lat], zoom);
	
	      return clusters.map(function (cluster) {
	        var properties = cluster.properties;
	
	
	        if (properties && properties.cluster) {
	          try {
	            var clusteredPoints = index.getLeaves(properties.cluster_id, Infinity);
	            return _extends({}, cluster, {
	              properties: _extends({}, properties, {
	                clusteredPoints: clusteredPoints
	              })
	            });
	          } catch (error) {
	            console.error('Ошибка при получении точек кластера:', error);
	            return cluster;
	          }
	        }
	
	        return cluster;
	      });
	    }
	  }, {
	    key: 'renderCaptions',
	    value: function renderCaptions() {
	      var cities = this.props.cities;
	      var zoom = this.state.mapProps.zoom;
	
	
	      var captions = zoom >= _constants.ZOOM ? cities.map(function (city) {
	        return city.areas && city.areas.map(function (area) {
	          return area.subareas && area.subareas.map(function (subarea) {
	            return {
	              name: subarea.name,
	              lat: parseFloat(subarea.latitude),
	              lng: parseFloat(subarea.longitude)
	            };
	          });
	        });
	      }).flat(2).filter(Boolean) : cities.map(function (city) {
	        return city.areas && city.areas.map(function (area) {
	          return {
	            name: area.name,
	            lat: parseFloat(area.latitude),
	            lng: parseFloat(area.longitude)
	          };
	        });
	      }).flat(1).filter(Boolean);
	
	      return captions.map(function (_ref2) {
	        var name = _ref2.name,
	            lat = _ref2.lat,
	            lng = _ref2.lng;
	        return _react2.default.createElement(_YMap.YCaption, { name: name, lat: lat, lng: lng, key: name + '-' + lat + '-' + lng });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          points = _props.points,
	          infoType = _props.infoType,
	          pointsList = _props.pointsList;
	      var _state2 = this.state,
	          _state2$mapProps = _state2.mapProps,
	          center = _state2$mapProps.center,
	          zoom = _state2$mapProps.zoom,
	          newBounds = _state2$mapProps.newBounds,
	          info = _state2.info,
	          infoList = _state2.infoList;
	
	      var clusters = this.getClusters();
	
	      var places = clusters.map(function (item) {
	        if (item.geometry.type) {
	          var pointCount = item.properties.point_count,
	              _item$geometry$coordi = _slicedToArray(item.geometry.coordinates, 2),
	              _longitude = _item$geometry$coordi[0],
	              _latitude = _item$geometry$coordi[1];
	
	          return _react2.default.createElement(_YMap.YClusterPoint, {
	            name: pointCount,
	            pointCount: pointCount,
	            lat: _latitude,
	            lng: _longitude,
	            onClick: _this2.handleShowListInfo.bind(_this2, item),
	            key: pointCount + '-' + _latitude + '-' + _longitude,
	            item: item
	          });
	        }
	
	        var longitude = item.longitude,
	            latitude = item.latitude,
	            id = item.id;
	
	
	        var contexuality = void 0;
	        var isActive = false;
	
	        if (Number(item.count_flats) === 0) {
	          contexuality = 'disabled';
	        } else if (item.construction_finished) {
	          contexuality = isActive ? 'active' : 'success';
	        } else {
	          contexuality = isActive ? 'warningActive' : 'warningSuccess';
	        }
	
	        if (item.status == 3) {
	          contexuality = 'almostFinished';
	        }
	
	        return _react2.default.createElement(_YMap.YMapPoint, {
	          key: id,
	          id: id,
	          lat: +latitude,
	          lng: +longitude,
	          onClick: _this2.handleShowInfo.bind(_this2, item),
	          contexuality: contexuality,
	          isActive: _this2.state.info && _this2.state.info.id === id
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Map2.default.Map, className) },
	        _react2.default.createElement(
	          _YMap.YMap,
	          {
	            key: this.state.key,
	            defaultState: {
	              center: [center.lat, center.lng],
	              zoom: zoom
	            },
	            defaultOptions: {
	              restrictMapArea: [[newBounds.sw.lat - 1.5, newBounds.sw.lng - 1.5], [newBounds.ne.lat + 1.5, newBounds.ne.lng + 1.5]]
	            },
	            instanceRef: function instanceRef(ref) {
	              return _this2.map = ref;
	            },
	            onLoad: this.handleMapLoad
	          },
	          info && points && points[info.id] && _react2.default.createElement(
	            'div',
	            { className: _Map2.default.MapInfo },
	            _react2.default.createElement(_YPlaceInfo2.default, {
	              onClose: this.handleCloseInfo,
	              infoType: infoType,
	              point: points[info.id]
	            })
	          ),
	          infoList && pointsList[infoList.longLat] && _react2.default.createElement(
	            'div',
	            { className: _Map2.default.MapInfoList },
	            pointsList[infoList.longLat].map(function (point) {
	              return _react2.default.createElement(_placeInfoList2.default, { infoType: infoType, point: point, longLat: infoList.longLat });
	            }),
	            _react2.default.createElement('img', {
	              src: _iconClose2.default,
	              alt: '',
	              onClick: function onClick(e) {
	                return _this2.handleCloseInfo(e);
	              },
	              className: _Map2.default.CloseListButton
	            })
	          ),
	          this.renderCaptions(),
	          places
	        )
	      );
	    }
	  }]);
	
	  return MainMap;
	}(_react.Component), _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.map = null;
	
	  this.handleMapLoad = function (ymaps) {
	    var myMap = _this3.map;
	
	    myMap.events.add('boundschange', function (event) {
	      var points = event.get('newBounds').map(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            latitude = _ref4[0],
	            longitude = _ref4[1];
	
	        return { latitude: latitude, longitude: longitude };
	      });
	      var mapProps = _this3.fitBounds(points);
	
	      _this3.setState({
	        mapProps: mapProps
	      });
	    });
	  };
	
	  this.handleShowInfo = function (item, info) {
	    var id = item.id;
	    var _props2 = _this3.props,
	        points = _props2.points,
	        dispatch = _props2.dispatch;
	
	    _this3.setState({
	      infoList: null
	    });
	
	    var clusterData = Boolean(item.properties);
	
	    var longitude = clusterData ? item.geometry.coordinates[0] : item.longitude;
	    var latitude = clusterData ? item.geometry.coordinates[1] : item.latitude;
	    var longLat = longitude + '-' + latitude;
	
	    _this3.setState({
	      info: clusterData ? _extends({}, item.properties.clusteredPoints, { id: longLat }) : _extends({}, info, { id: id })
	    });
	
	    _this3.map.setCenter([latitude, longitude]);
	
	    if (points && !points[id]) {
	      dispatch((0, _objects.loadPoint)(id));
	    }
	  };
	
	  this.handleShowListInfo = function (item, info) {
	    var _props3 = _this3.props,
	        points = _props3.points,
	        pointsList = _props3.pointsList;
	
	
	    var longitude = item.geometry.coordinates[0];
	    var latitude = item.geometry.coordinates[1];
	
	    _this3.map.setCenter([latitude, longitude]);
	
	    var clusterPointIds = item.properties.clusteredPoints.map(function (obj) {
	      return Number(obj.id);
	    }) || [];
	    var longLat = longitude + '-' + latitude;
	
	    _this3.setState({
	      infoList: _extends({}, info, { longLat: longLat })
	    });
	
	    if (points && !pointsList[longLat]) {
	      var dispatch = _this3.props.dispatch;
	
	      dispatch((0, _objects.loadPointList)(clusterPointIds, longLat));
	    }
	  };
	
	  this.handleCloseInfo = function (e) {
	    e.preventDefault();
	    e.stopPropagation();
	    _this3.setState({ info: null, infoList: null });
	  };
	}, _temp);
	
	
	var citiesSelector = (0, _reselect.createSelector)(function (state) {
	  return state.building.cities;
	}, function (state) {
	  return state.objects.pointsList;
	}, function (_, props) {
	  return props;
	}, function (cities, pointsList, props) {
	  return {
	    cities: cities,
	    pointsList: pointsList,
	    someProp: props.someProp
	  };
	});
	
	exports.default = (0, _reactRedux.connect)(citiesSelector)(MainMap);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClientHeader = __webpack_require__(1002);
	
	var _ClientHeader2 = _interopRequireDefault(_ClientHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ClientHeader2.default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1424);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactModal = __webpack_require__(184);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var scrollOn = function scrollOn() {
	  document.body.classList.remove('scroll-off');
	};
	
	var scrollOff = function scrollOff() {
	  document.body.classList.add('scroll-off');
	};
	
	var Modal = function Modal(_ref) {
	  var _ref$classNames = _ref.classNames;
	  _ref$classNames = _ref$classNames === undefined ? {} : _ref$classNames;
	  var titleClassName = _ref$classNames.titleClassName,
	      bodyClassName = _ref$classNames.bodyClassName,
	      closeClassName = _ref$classNames.closeClassName,
	      _ref$footer = _ref.footer,
	      footer = _ref$footer === undefined ? null : _ref$footer,
	      isOpen = _ref.isOpen,
	      handleClose = _ref.handleClose,
	      title = _ref.title,
	      children = _ref.children,
	      _ref$contentStyle = _ref.contentStyle,
	      contentStyle = _ref$contentStyle === undefined ? {} : _ref$contentStyle,
	      _ref$overlayStyle = _ref.overlayStyle,
	      overlayStyle = _ref$overlayStyle === undefined ? {} : _ref$overlayStyle;
	
	  var onClose = function onClose() {
	    scrollOn();
	    handleClose();
	  };
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    {
	      isOpen: isOpen,
	      onAfterOpen: scrollOff,
	      onRequestClose: onClose,
	      contentLabel: 'Modal',
	      className: _styles2.default.ModalContent,
	      style: {
	        overlay: _extends({
	          zIndex: 10,
	          backgroundColor: 'rgba(0, 0, 0, 0.5)'
	        }, overlayStyle),
	        content: _extends({
	          padding: 0,
	          background: '#fff',
	          border: 'none',
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          WebkitTransform: 'translate(-50%, -50%)',
	          transform: 'translate(-50%, -50%)',
	          display: 'flex',
	          flexDirection: 'column'
	        }, contentStyle)
	      }
	    },
	    title && _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.Title, _defineProperty({}, titleClassName, !!titleClassName))
	      },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.Close, _defineProperty({}, closeClassName, !!closeClassName)),
	        onClick: onClose
	      },
	      _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.Content, _defineProperty({}, bodyClassName, !!bodyClassName))
	      },
	      children
	    ),
	    footer && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Footer },
	      footer
	    )
	  );
	};
	
	exports.default = Modal;

/***/ }),
/* 315 */
[2400, 485],
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatAppointmentDate = exports.getTypeLabel = exports.getStatusLabel = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Appointments = __webpack_require__(1434);
	
	var _Appointments2 = _interopRequireDefault(_Appointments);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _AppointmentInfoDialog = __webpack_require__(1057);
	
	var _AppointmentInfoDialog2 = _interopRequireDefault(_AppointmentInfoDialog);
	
	var _appointment = __webpack_require__(159);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _ButtonSpinner = __webpack_require__(164);
	
	var _ga = __webpack_require__(7);
	
	var _AppointmentCard = __webpack_require__(1056);
	
	var _AppointmentCard2 = _interopRequireDefault(_AppointmentCard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getStatusLabel = exports.getStatusLabel = function getStatusLabel(status) {
	  var statusClass = void 0;
	  var statusText = void 0;
	
	  switch (status) {
	    case 0:
	      statusClass = _Appointments2.default.inProgress;
	      statusText = 'В РАБОТЕ';
	      break;
	    case 1:
	      statusClass = _Appointments2.default.assigned;
	      statusText = 'НАЗНАЧЕН';
	      break;
	    case 2:
	      statusClass = _Appointments2.default.completed;
	      statusText = 'ПРОВЕДЕН';
	      break;
	    case 3:
	      statusClass = _Appointments2.default.canceled;
	      statusText = 'ОТМЕНЕН';
	      break;
	    default:
	      break;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Appointments2.default.StatusLabel + ' ' + statusClass },
	    statusText
	  );
	};
	
	var getTypeLabel = exports.getTypeLabel = function getTypeLabel(type) {
	  var typeClass = type === 'online' ? _Appointments2.default.online : _Appointments2.default.offline;
	  var typeText = type === 'online' ? 'ОНЛАЙН' : 'ОФФЛАЙН';
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Appointments2.default.StatusLabel + ' ' + typeClass },
	    typeText
	  );
	};
	
	var formatAppointmentDate = exports.formatAppointmentDate = function formatAppointmentDate(dateString) {
	  var appointmentDate = new Date(dateString);
	  var now = new Date();
	
	  var isToday = appointmentDate.toDateString() === now.toDateString();
	  var isYesterday = appointmentDate.toDateString() === new Date(now.setDate(now.getDate() - 1)).toDateString();
	
	  var options = {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: '2-digit',
	    minute: '2-digit'
	  };
	
	  if (isToday) {
	    return '\u0421\u0435\u0433\u043E\u0434\u043D\u044F ' + appointmentDate.toLocaleTimeString('ru-RU', {
	      hour: '2-digit',
	      minute: '2-digit'
	    });
	  }
	
	  if (isYesterday) {
	    return '\u0412\u0447\u0435\u0440\u0430 ' + appointmentDate.toLocaleTimeString('ru-RU', {
	      hour: '2-digit',
	      minute: '2-digit'
	    });
	  }
	
	  return '' + appointmentDate.toLocaleDateString('ru-RU', _extends({}, options));
	};
	
	var Appointments = function Appointments(_ref) {
	  var profile = _ref.profile;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeTabIndex = _useState2[0],
	      setActiveTabIndex = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isLoading = _useState4[0],
	      setIsLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      futureAppointments = _useState6[0],
	      setFutureAppointments = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      pastAppointments = _useState8[0],
	      setPastAppointments = _useState8[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchData = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var result, future, past;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                setIsLoading(true);
	                _context.prev = 1;
	                _context.next = 4;
	                return dispatch((0, _appointment.loadAppointmentStatuses)());
	
	              case 4:
	                result = _context.sent;
	
	                if (result.data) {
	                  future = result.data.items.filter(function (appointment) {
	                    return appointment.status === 0 || appointment.status === 1;
	                  });
	                  past = result.data.items.filter(function (appointment) {
	                    return appointment.status === 2 || appointment.status === 3;
	                  });
	
	
	                  setFutureAppointments(future);
	                  setPastAppointments(past);
	                } else {
	                  dispatch({ type: types.LOAD_APPOINTMENT_STATUSES_ERROR });
	                }
	                _context.next = 11;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context['catch'](1);
	
	                console.error(_context.t0);
	
	              case 11:
	                _context.prev = 11;
	
	                setIsLoading(false);
	                return _context.finish(11);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[1, 8, 11, 14]]);
	      }));
	
	      return function fetchData() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    fetchData();
	  }, [dispatch]);
	
	  var handleSwitchTab = function handleSwitchTab(tabIndex) {
	    var eventLabel = tabIndex === 1 ? 'budushchie' : 'proshedshie';
	
	    (0, _ga.trackGA)(_ga.gaEvent.profileAppointmentsTabsClick({
	      eventLabel: eventLabel,
	      user_id: profile.id
	    }));
	
	    if (activeTabIndex !== tabIndex) {
	      setActiveTabIndex(tabIndex);
	    }
	  };
	
	  var handleShowInfo = function handleShowInfo(appointment) {
	    dispatch((0, _environment.setPopUp)(_react2.default.createElement(_AppointmentInfoDialog2.default, { appointment: appointment }), {
	      closeStyleName: 'Default',
	      contentStyleName: 'Default',
	      closeIcon: 'default',
	      lockScroll: false
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Appointments2.default.Appointments },
	    isLoading ? _react2.default.createElement(_ButtonSpinner.ButtonSpinner, null) : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _Appointments2.default.TabButtons },
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_Appointments2.default.TabButton, _defineProperty({}, _Appointments2.default.Active, activeTabIndex === 1)),
	            onClick: function onClick() {
	              return handleSwitchTab(1);
	            }
	          },
	          t('components.profile.appointments.futureAppointments')
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_Appointments2.default.TabButton, _defineProperty({}, _Appointments2.default.Active, activeTabIndex === 2)),
	            onClick: function onClick() {
	              return handleSwitchTab(2);
	            }
	          },
	          t('components.profile.appointments.pastAppointments')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Appointments2.default.AppointmentCards },
	        activeTabIndex === 1 && futureAppointments.length > 0 ? futureAppointments.map(function (appointment) {
	          return _react2.default.createElement(_AppointmentCard2.default, {
	            key: appointment.id,
	            appointment: appointment,
	            activeTabIndex: activeTabIndex,
	            profileId: profile.id,
	            onShowInfo: handleShowInfo
	          });
	        }) : activeTabIndex === 1 ? _react2.default.createElement(
	          'div',
	          { className: _Appointments2.default.NoAppointments },
	          _react2.default.createElement(
	            'p',
	            { className: _Appointments2.default.NoAppointmentsTitle },
	            t('components.profile.appointments.noAppointments')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _Appointments2.default.NoAppointmentsDescription },
	            t('components.profile.appointments.noFutureAppointments')
	          )
	        ) : null,
	        activeTabIndex === 2 && pastAppointments.length > 0 ? pastAppointments.map(function (appointment) {
	          return _react2.default.createElement(_AppointmentCard2.default, {
	            key: appointment.id,
	            appointment: appointment,
	            activeTabIndex: activeTabIndex,
	            profileId: profile.id,
	            onShowInfo: handleShowInfo
	          });
	        }) : activeTabIndex === 2 ? _react2.default.createElement(
	          'div',
	          { className: _Appointments2.default.NoAppointments },
	          _react2.default.createElement(
	            'p',
	            { className: _Appointments2.default.NoAppointmentsTitle },
	            t('components.profile.appointments.noAppointments')
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _Appointments2.default.NoAppointmentsDescription },
	            t('components.profile.appointments.noPastAppointments')
	          )
	        ) : null
	      )
	    )
	  );
	};
	
	exports.default = Appointments;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filtersPlaceholder = exports.FILTERS = exports.modalStyles = undefined;
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyles = exports.modalStyles = {
	  overlay: {
	    zIndex: 10,
	    backgroundColor: 'rgba(255, 255, 255, 0.98)'
	  },
	  content: {
	    background: 'rgba(255, 255, 255, 0)',
	    border: 'none',
	    padding: '0',
	    top: '0',
	    left: '0',
	    right: 'auto',
	    bottom: 'auto',
	    width: '100%',
	    height: '100%',
	    overflow: 'hidden'
	  }
	};
	
	var FILTERS = exports.FILTERS = {
	  ALL: 'ALL',
	  BUILDINGS: 'BUILDINGS',
	  SUB_REGIONS: 'SUB_REGIONS',
	  REGIONS: 'REGIONS',
	  STREETS: 'STREETS'
	};
	
	var filtersPlaceholder = exports.filtersPlaceholder = new Map([[FILTERS.ALL, [_i18n2.default.t('components.searchFullscreen.constants.all1'), _i18n2.default.t('components.searchFullscreen.constants.all1')]], [FILTERS.REGIONS, [_i18n2.default.t('components.searchFullscreen.constants.regions'), _i18n2.default.t('components.searchFullscreen.constants.regions')]], [FILTERS.SUB_REGIONS, [_i18n2.default.t('components.searchFullscreen.constants.sub_regions'), _i18n2.default.t('components.searchFullscreen.constants.sub_regions')]], [FILTERS.BUILDINGS, [_i18n2.default.t('components.searchFullscreen.constants.buildings'), _i18n2.default.t('components.searchFullscreen.constants.buildings')]], [FILTERS.STREETS, [_i18n2.default.t('components.searchFullscreen.constants.streets'), _i18n2.default.t('components.searchFullscreen.constants.streets')]]]);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Spinner = __webpack_require__(1463);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_Spinner2.default);
	
	var Spinner = function Spinner(_ref) {
	  var children = _ref.children,
	      isLoading = _ref.isLoading,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: cx(_Spinner2.default.Spinner, className) },
	    isLoading ? _react2.default.createElement(
	      'div',
	      { className: _Spinner2.default.doubleBounce },
	      _react2.default.createElement('div', { className: _Spinner2.default.doubleBounce1 }),
	      _react2.default.createElement('div', { className: _Spinner2.default.doubleBounce2 })
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { className: cx(_Spinner2.default.Content, { Blur: isLoading }) },
	      children
	    )
	  );
	};
	
	exports.default = Spinner;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YMap = exports.YClusterPoint = exports.YCaption = exports.YMapPoint = undefined;
	
	var _YCaption = __webpack_require__(1117);
	
	var _YCaption2 = _interopRequireDefault(_YCaption);
	
	var _YMapPoint = __webpack_require__(1119);
	
	var _YMapPoint2 = _interopRequireDefault(_YMapPoint);
	
	var _YClusterPoint = __webpack_require__(1118);
	
	var _YClusterPoint2 = _interopRequireDefault(_YClusterPoint);
	
	var _ymap = __webpack_require__(1122);
	
	var _ymap2 = _interopRequireDefault(_ymap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.YMapPoint = _YMapPoint2.default;
	exports.YCaption = _YCaption2.default;
	exports.YClusterPoint = _YClusterPoint2.default;
	exports.YMap = _ymap2.default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var variants = [{
	  tabText: _i18n2.default.t('constants.variants.central.title'),
	  title: _i18n2.default.t('constants.variants.selectMicro'),
	  checkboxes: {
	    1: _i18n2.default.t('constants.variants.central.checkboxes.1'),
	    2: _i18n2.default.t('constants.variants.central.checkboxes.2'),
	    3: _i18n2.default.t('constants.variants.central.checkboxes.3'),
	    4: _i18n2.default.t('constants.variants.central.checkboxes.4'),
	    5: _i18n2.default.t('constants.variants.central.checkboxes.5'),
	    6: _i18n2.default.t('constants.variants.central.checkboxes.6'),
	    7: _i18n2.default.t('constants.variants.central.checkboxes.7'),
	    8: _i18n2.default.t('constants.variants.central.checkboxes.8'),
	    9: _i18n2.default.t('constants.variants.central.checkboxes.9'),
	    10: _i18n2.default.t('constants.variants.central.checkboxes.10')
	  }
	}, {
	  tabText: _i18n2.default.t('constants.variants.hostinskii.title'),
	  title: _i18n2.default.t('constants.variants.selectMicro'),
	  checkboxes: {
	    11: _i18n2.default.t('constants.variants.hostinskii.checkboxes.11'),
	    12: _i18n2.default.t('constants.variants.hostinskii.checkboxes.12'),
	    13: _i18n2.default.t('constants.variants.hostinskii.checkboxes.13'),
	    14: _i18n2.default.t('constants.variants.hostinskii.checkboxes.14'),
	    15: _i18n2.default.t('constants.variants.hostinskii.checkboxes.15'),
	    16: _i18n2.default.t('constants.variants.hostinskii.checkboxes.16'),
	    18: _i18n2.default.t('constants.variants.hostinskii.checkboxes.17'),
	    17: _i18n2.default.t('constants.variants.hostinskii.checkboxes.18'),
	    19: _i18n2.default.t('constants.variants.hostinskii.checkboxes.19'),
	    20: _i18n2.default.t('constants.variants.hostinskii.checkboxes.20'),
	    21: _i18n2.default.t('constants.variants.hostinskii.checkboxes.21'),
	    22: _i18n2.default.t('constants.variants.hostinskii.checkboxes.22')
	  }
	}, {
	  tabText: _i18n2.default.t('constants.variants.adler.title'),
	  title: _i18n2.default.t('constants.variants.selectMicro'),
	  checkboxes: {
	    23: _i18n2.default.t('constants.variants.adler.checkboxes.23'),
	    24: _i18n2.default.t('constants.variants.adler.checkboxes.24'),
	    25: _i18n2.default.t('constants.variants.adler.checkboxes.25'),
	    26: _i18n2.default.t('constants.variants.adler.checkboxes.26'),
	    27: _i18n2.default.t('constants.variants.adler.checkboxes.27'),
	    28: _i18n2.default.t('constants.variants.adler.checkboxes.28'),
	    29: _i18n2.default.t('constants.variants.adler.checkboxes.29'),
	    30: _i18n2.default.t('constants.variants.adler.checkboxes.30'),
	    31: _i18n2.default.t('constants.variants.adler.checkboxes.31'),
	    32: _i18n2.default.t('constants.variants.adler.checkboxes.32'),
	    33: _i18n2.default.t('constants.variants.adler.checkboxes.33')
	  }
	}, {
	  tabText: _i18n2.default.t('constants.variants.lazar.title'),
	  title: _i18n2.default.t('constants.variants.selectMicro'),
	  checkboxes: {
	    34: _i18n2.default.t('constants.variants.lazar.checkboxes.34'),
	    35: _i18n2.default.t('constants.variants.lazar.checkboxes.35'),
	    36: _i18n2.default.t('constants.variants.lazar.checkboxes.36')
	  }
	}, {
	  tabText: _i18n2.default.t('constants.variants.tuapse.title'),
	  title: _i18n2.default.t('constants.variants.selectMicro'),
	  checkboxes: {
	    37: _i18n2.default.t('constants.variants.tuapse.checkboxes.37')
	  }
	}];
	
	exports.default = variants;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  zeroInt: '',
	  all: _i18n2.default.t('constants.interiors.all'),
	  chernInt: _i18n2.default.t('constants.interiors.chernInt'),
	  chistInt: _i18n2.default.t('constants.interiors.chistInt'),
	  whiteBox: _i18n2.default.t('constants.interiors.whiteBox'),
	  repair: _i18n2.default.t('constants.interiors.repair'),
	  predChistInt: _i18n2.default.t('constants.interiors.predChistInt'),
	  remInt: _i18n2.default.t('constants.interiors.remInt'),
	  chastRemInt: _i18n2.default.t('constants.interiors.chastRemInt')
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(35)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(100);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(20)
	  , descriptor     = __webpack_require__(101)
	  , setToStringTag = __webpack_require__(167)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(95)(IteratorPrototype, __webpack_require__(35)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(35)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	module.exports = Math.expm1 || function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	};

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(20)
	  , toObject = __webpack_require__(102)
	  , IObject  = __webpack_require__(227);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(50)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var $        = __webpack_require__(20)
	  , anObject = __webpack_require__(30)
	  , Reflect  = __webpack_require__(34).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = $.getNames(anObject(it))
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(525)
	  , invoke    = __webpack_require__(226)
	  , aFunction = __webpack_require__(117);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that  = this
	      , $$    = arguments
	      , $$len = $$.length
	      , j = 0, k = 0, args;
	    if(!holder && !$$len)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
	    while($$len > k)args.push($$[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(20).getDesc
	  , isObject = __webpack_require__(29)
	  , anObject = __webpack_require__(30);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(79)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(169)
	  , defined   = __webpack_require__(94);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(519)
	  , defined  = __webpack_require__(94);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ProfileCompany":"styles__ProfileCompany___CM11W","Container":"styles__Container___3zZ7k","Title":"styles__Title___1HyP2","SubscriptionBar":"styles__SubscriptionBar___1iRlk","Inner":"styles__Inner___3QXNN","Nav":"styles__Nav___1Hgez","NavLink":"styles__NavLink___36NC2","Active":"styles__Active___1GLxZ","InnerContent":"styles__InnerContent___1RUmC","Row":"styles__Row___29tqV","Input":"styles__Input___2Mr7I","SpecialRow":"styles__SpecialRow___2v2Nr","Extend":"styles__Extend___1REdP","Dialog":"styles__Dialog___2evoP","AvatarWrap":"styles__AvatarWrap___1NNWW","InputsWrap":"styles__InputsWrap___18Spx","Columns":"styles__Columns___n1xcW","InputWrapper":"styles__InputWrapper___1Zixi","PairInputs":"styles__PairInputs___3l7Qz","TextareaWrapper":"styles__TextareaWrapper___2tatB","Textarea":"styles__Textarea___3MgtX","SocialInput":"styles__SocialInput___2nhkz","SocialLabel":"styles__SocialLabel___1FD5T","OfficeBlock":"styles__OfficeBlock___1XWP9","SectionTitle":"styles__SectionTitle___MyK1Q","MapBlock":"styles__MapBlock___1VNXq","MovingPlace":"styles__MovingPlace___1Z_s-","AddOfficeBtnWrap":"styles__AddOfficeBtnWrap___M2Oq3","AddOfficeBtn":"styles__AddOfficeBtn___2dZdS","SectionSocial":"styles__SectionSocial___3xUyH","SocialInputWrap":"styles__SocialInputWrap___3J-05","Divider":"styles__Divider___1ij65","Buttons":"styles__Buttons___ZZ_zX","SaveButtonWrapSticky":"styles__SaveButtonWrapSticky___3hz50","SaveButtonWrap":"styles__SaveButtonWrap___1RkIu","ButtonSave":"styles__ButtonSave___F-AZW","Button":"styles__Button___2AQC3","ButtonNewMember":"styles__ButtonNewMember___UoBnQ","ButtonCancel":"styles__ButtonCancel___1u98j","AddEmployee":"styles__AddEmployee___joq9x","AddEmployeeText":"styles__AddEmployeeText___q-FIX","MembersContent":"styles__MembersContent___3ioYx","MembersList":"styles__MembersList___kSrGR","Member":"styles__Member___1REO1","MemberHover":"styles__MemberHover___1nwo0","MemberAvatar":"styles__MemberAvatar___XbGwu","MemberInfo":"styles__MemberInfo___3npbV","MemberName":"styles__MemberName___1o6qn","MemberPosition":"styles__MemberPosition___17xYH","MemberPhone":"styles__MemberPhone___1c9kB","MemberAction":"styles__MemberAction___1kJN-","Edit":"styles__Edit___GgdhD","Delete":"styles__Delete___2kfPU","AdminTag":"styles__AdminTag___2mvp4","PopUpOuter":"styles__PopUpOuter___37XTt","PopUpInner":"styles__PopUpInner___2JLFT","PopupClose":"styles__PopupClose___2Mhz5","PopupHeader":"styles__PopupHeader___2RM_E","PopupTitle":"styles__PopupTitle___1uF4I","PopupFooter":"styles__PopupFooter___2qbEV","PopupContent":"styles__PopupContent___2dgyd","ModalContent":"styles__ModalContent___33WzT","fadein":"styles__fadein___2Z2n8"};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LoginForm":"styles__LoginForm___2LxmW","LoginFormTitle":"styles__LoginFormTitle___1m3Xd","LoginFormSubTitle":"styles__LoginFormSubTitle___bsNK9","LoginFormHint":"styles__LoginFormHint___1GXCS","LoginFormHintError":"styles__LoginFormHintError___2mS2Y","LoginFormButtons":"styles__LoginFormButtons___1IzSW","LoginFormRegistration":"styles__LoginFormRegistration___uUg8r","PhoneInput":"styles__PhoneInput___1La6y","CodeInputContainer":"styles__CodeInputContainer___1z7Ag","CodeInputContainerError":"styles__CodeInputContainerError___TytOT","CodeInputContainerPhone":"styles__CodeInputContainerPhone___2lK95","CodeInputContainerSMS":"styles__CodeInputContainerSMS___3BrBu","Registration":"styles__Registration___sseQG"};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check-icon.224d2e57.svg";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-close.c12ae116.svg";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-doc.353db59a.svg";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-heart.0c5c27ad.svg";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-zoom.f811bd6b.svg";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-fb.b651f7e2.svg";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-inst.6a1b12f2.svg";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-ok.261a3eb3.svg";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-vk.268c234d.svg";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-youtube.400ad823.svg";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo-black.47469250.svg";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/non-photo.d826c856.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nothingfound@2x.d9f2d5b0.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(386);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity]
	 *  The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    result[key] = [value];
	  }
	});
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = groupBy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(114)(module)))

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = intersection;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119),
	    root = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1711),
	    mapCacheDelete = __webpack_require__(1712),
	    mapCacheGet = __webpack_require__(1713),
	    mapCacheHas = __webpack_require__(1714),
	    mapCacheSet = __webpack_require__(1715);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(240),
	    stackClear = __webpack_require__(1728),
	    stackDelete = __webpack_require__(1729),
	    stackGet = __webpack_require__(1730),
	    stackHas = __webpack_require__(1731),
	    stackSet = __webpack_require__(1732);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(75),
	    isSymbol = __webpack_require__(251);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(570),
	    baseKeys = __webpack_require__(575),
	    isArrayLike = __webpack_require__(176);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(243),
	    baseForOwn = __webpack_require__(1660),
	    baseIteratee = __webpack_require__(1668);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1760)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	var _reduce = __webpack_require__(71);
	var map = __webpack_require__(63);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {Array} fns An array of functions
	 * @param {Array} vs An array of values
	 * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applicative, fn) {
	  return (
	    typeof applicative.ap === 'function' ?
	      applicative.ap(fn) :
	    typeof applicative === 'function' ?
	      function(x) { return applicative(x)(fn(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, fn)); }, [], applicative)
	  );
	});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _makeFlat = __webpack_require__(623);
	var _xchain = __webpack_require__(1842);
	var map = __webpack_require__(63);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(640);
	var reverse = __webpack_require__(268);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isArray = __webpack_require__(104);
	var _isFunction = __webpack_require__(259);
	var toString = __webpack_require__(182);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (a == null || !_isFunction(a.concat)) {
	    throw new TypeError(toString(a) + ' does not have a method named "concat"');
	  }
	  if (_isArray(a) && !_isArray(b)) {
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  return a.concat(b);
	});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _filter = __webpack_require__(617);
	var _isObject = __webpack_require__(622);
	var _reduce = __webpack_require__(71);
	var _xfilter = __webpack_require__(1847);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _identity = __webpack_require__(374);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(1832);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(177);
	var _curry1 = __webpack_require__(11);
	var slice = __webpack_require__(123);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(371);
	var uniqBy = __webpack_require__(648);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. `R.equals` is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(373);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDefaults = setDefaults;
	exports.getDefaults = getDefaults;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _unescape = __webpack_require__(1968);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var defaultOptions = {
	  bindI18n: 'languageChanged',
	  bindI18nStore: '',
	  transEmptyNodeValue: '',
	  transSupportBasicHtmlNodes: true,
	  transWrapTextNodes: '',
	  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
	  useSuspense: true,
	  unescape: _unescape.unescape
	};
	
	function setDefaults() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
	}
	
	function getDefaults() {
	  return defaultOptions;
	}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setI18n = setI18n;
	exports.getI18n = getI18n;
	var i18nInstance;
	
	function setI18n(instance) {
	  i18nInstance = instance;
	}
	
	function getI18n() {
	  return i18nInstance;
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useTranslation = useTranslation;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(384));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(270));
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(152);
	
	var _utils = __webpack_require__(269);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var usePrevious = function usePrevious(value, ignore) {
	  var ref = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    ref.current = ignore ? ref.current : value;
	  }, [value, ignore]);
	  return ref.current;
	};
	
	function useTranslation(ns) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var i18nFromProps = props.i18n;
	
	  var _ref = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref.i18n,
	      defaultNSFromContext = _ref.defaultNS;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new _context.ReportNamespaces();
	
	  if (!i18n) {
	    (0, _utils.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
	
	    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
	      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
	      if (optsOrDefaultValue && (0, _typeof2["default"])(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
	      return Array.isArray(k) ? k[k.length - 1] : k;
	    };
	
	    var retNotReady = [notReadyT, {}, false];
	    retNotReady.t = notReadyT;
	    retNotReady.i18n = {};
	    retNotReady.ready = false;
	    return retNotReady;
	  }
	
	  if (i18n.options.react && i18n.options.react.wait !== undefined) (0, _utils.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
	
	  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0, _context.getDefaults)()), i18n.options.react), props);
	
	  var useSuspense = i18nOptions.useSuspense,
	      keyPrefix = i18nOptions.keyPrefix;
	  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
	  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
	  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
	  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
	    return (0, _utils.hasLoadedNamespace)(n, i18n, i18nOptions);
	  });
	
	  function getT() {
	    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
	  }
	
	  var _useState = (0, _react.useState)(getT),
	      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
	      t = _useState2[0],
	      setT = _useState2[1];
	
	  var joinedNS = namespaces.join();
	  var previousJoinedNS = usePrevious(joinedNS);
	  var isMounted = (0, _react.useRef)(true);
	  (0, _react.useEffect)(function () {
	    var bindI18n = i18nOptions.bindI18n,
	        bindI18nStore = i18nOptions.bindI18nStore;
	    isMounted.current = true;
	
	    if (!ready && !useSuspense) {
	      (0, _utils.loadNamespaces)(i18n, namespaces, function () {
	        if (isMounted.current) setT(getT);
	      });
	    }
	
	    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
	      setT(getT);
	    }
	
	    function boundReset() {
	      if (isMounted.current) setT(getT);
	    }
	
	    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
	    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
	    return function () {
	      isMounted.current = false;
	      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
	        return i18n.off(e, boundReset);
	      });
	      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
	        return i18n.store.off(e, boundReset);
	      });
	    };
	  }, [i18n, joinedNS]);
	  var isInitial = (0, _react.useRef)(true);
	  (0, _react.useEffect)(function () {
	    if (isMounted.current && !isInitial.current) {
	      setT(getT);
	    }
	
	    isInitial.current = false;
	  }, [i18n, keyPrefix]);
	  var ret = [t, i18n, ready];
	  ret.t = t;
	  ret.i18n = i18n;
	  ret.ready = ready;
	  if (ready) return ret;
	  if (!ready && !useSuspense) return ret;
	  throw new Promise(function (resolve) {
	    (0, _utils.loadNamespaces)(i18n, namespaces, function () {
	      resolve();
	    });
	  });
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(1972);
	var iterableToArrayLimit = __webpack_require__(1975);
	var unsupportedIterableToArray = __webpack_require__(1979);
	var nonIterableRest = __webpack_require__(1976);
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(1993);
	} else {
	  module.exports = require('./lib/react-input-mask.development.js');
	}


/***/ }),
/* 386 */
[2408, 1995],
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
	
	var _exenv = __webpack_require__(1318);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
	
	var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.onlineManager = exports.OnlineManager = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _subscribable = __webpack_require__(126);
	
	var _utils = __webpack_require__(43);
	
	var OnlineManager = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(OnlineManager, _Subscribable);
	
	  function OnlineManager() {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	
	    _this.setup = function (onOnline) {
	      var _window;
	
	      if (!_utils.isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
	        var listener = function listener() {
	          return onOnline();
	        }; // Listen to online
	
	
	        window.addEventListener('online', listener, false);
	        window.addEventListener('offline', listener, false);
	        return function () {
	          // Be sure to unsubscribe if a new handler is set
	          window.removeEventListener('online', listener);
	          window.removeEventListener('offline', listener);
	        };
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = OnlineManager.prototype;
	
	  _proto.onSubscribe = function onSubscribe() {
	    if (!this.cleanup) {
	      this.setEventListener(this.setup);
	    }
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {
	    if (!this.hasListeners()) {
	      var _this$cleanup;
	
	      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
	      this.cleanup = undefined;
	    }
	  };
	
	  _proto.setEventListener = function setEventListener(setup) {
	    var _this$cleanup2,
	        _this2 = this;
	
	    this.setup = setup;
	    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
	    this.cleanup = setup(function (online) {
	      if (typeof online === 'boolean') {
	        _this2.setOnline(online);
	      } else {
	        _this2.onOnline();
	      }
	    });
	  };
	
	  _proto.setOnline = function setOnline(online) {
	    this.online = online;
	
	    if (online) {
	      this.onOnline();
	    }
	  };
	
	  _proto.onOnline = function onOnline() {
	    this.listeners.forEach(function (listener) {
	      listener();
	    });
	  };
	
	  _proto.isOnline = function isOnline() {
	    if (typeof this.online === 'boolean') {
	      return this.online;
	    }
	
	    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
	      return true;
	    }
	
	    return navigator.onLine;
	  };
	
	  return OnlineManager;
	}(_subscribable.Subscribable);
	
	exports.OnlineManager = OnlineManager;
	var onlineManager = new OnlineManager();
	exports.onlineManager = onlineManager;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueryObserver = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _utils = __webpack_require__(43);
	
	var _notifyManager = __webpack_require__(57);
	
	var _focusManager = __webpack_require__(272);
	
	var _subscribable = __webpack_require__(126);
	
	var _logger = __webpack_require__(273);
	
	var _retryer = __webpack_require__(186);
	
	var QueryObserver = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(QueryObserver, _Subscribable);
	
	  function QueryObserver(client, options) {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	    _this.client = client;
	    _this.options = options;
	    _this.trackedProps = [];
	    _this.selectError = null;
	
	    _this.bindMethods();
	
	    _this.setOptions(options);
	
	    return _this;
	  }
	
	  var _proto = QueryObserver.prototype;
	
	  _proto.bindMethods = function bindMethods() {
	    this.remove = this.remove.bind(this);
	    this.refetch = this.refetch.bind(this);
	  };
	
	  _proto.onSubscribe = function onSubscribe() {
	    if (this.listeners.length === 1) {
	      this.currentQuery.addObserver(this);
	
	      if (shouldFetchOnMount(this.currentQuery, this.options)) {
	        this.executeFetch();
	      }
	
	      this.updateTimers();
	    }
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {
	    if (!this.listeners.length) {
	      this.destroy();
	    }
	  };
	
	  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
	    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
	  };
	
	  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
	    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
	  };
	
	  _proto.destroy = function destroy() {
	    this.listeners = [];
	    this.clearTimers();
	    this.currentQuery.removeObserver(this);
	  };
	
	  _proto.setOptions = function setOptions(options, notifyOptions) {
	    var prevOptions = this.options;
	    var prevQuery = this.currentQuery;
	    this.options = this.client.defaultQueryObserverOptions(options);
	
	    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
	      throw new Error('Expected enabled to be a boolean');
	    } // Keep previous query key if the user does not supply one
	
	
	    if (!this.options.queryKey) {
	      this.options.queryKey = prevOptions.queryKey;
	    }
	
	    this.updateQuery();
	    var mounted = this.hasListeners(); // Fetch if there are subscribers
	
	    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
	      this.executeFetch();
	    } // Update result
	
	
	    this.updateResult(notifyOptions); // Update stale interval if needed
	
	    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
	      this.updateStaleTimeout();
	    }
	
	    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
	
	    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
	      this.updateRefetchInterval(nextRefetchInterval);
	    }
	  };
	
	  _proto.getOptimisticResult = function getOptimisticResult(options) {
	    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
	    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
	    return this.createResult(query, defaultedOptions);
	  };
	
	  _proto.getCurrentResult = function getCurrentResult() {
	    return this.currentResult;
	  };
	
	  _proto.trackResult = function trackResult(result, defaultedOptions) {
	    var _this2 = this;
	
	    var trackedResult = {};
	
	    var trackProp = function trackProp(key) {
	      if (!_this2.trackedProps.includes(key)) {
	        _this2.trackedProps.push(key);
	      }
	    };
	
	    Object.keys(result).forEach(function (key) {
	      Object.defineProperty(trackedResult, key, {
	        configurable: false,
	        enumerable: true,
	        get: function get() {
	          trackProp(key);
	          return result[key];
	        }
	      });
	    });
	
	    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
	      trackProp('error');
	    }
	
	    return trackedResult;
	  };
	
	  _proto.getNextResult = function getNextResult(options) {
	    var _this3 = this;
	
	    return new Promise(function (resolve, reject) {
	      var unsubscribe = _this3.subscribe(function (result) {
	        if (!result.isFetching) {
	          unsubscribe();
	
	          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
	            reject(result.error);
	          } else {
	            resolve(result);
	          }
	        }
	      });
	    });
	  };
	
	  _proto.getCurrentQuery = function getCurrentQuery() {
	    return this.currentQuery;
	  };
	
	  _proto.remove = function remove() {
	    this.client.getQueryCache().remove(this.currentQuery);
	  };
	
	  _proto.refetch = function refetch(options) {
	    return this.fetch((0, _extends2.default)({}, options, {
	      meta: {
	        refetchPage: options == null ? void 0 : options.refetchPage
	      }
	    }));
	  };
	
	  _proto.fetchOptimistic = function fetchOptimistic(options) {
	    var _this4 = this;
	
	    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
	    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
	    return query.fetch().then(function () {
	      return _this4.createResult(query, defaultedOptions);
	    });
	  };
	
	  _proto.fetch = function fetch(fetchOptions) {
	    var _this5 = this;
	
	    return this.executeFetch(fetchOptions).then(function () {
	      _this5.updateResult();
	
	      return _this5.currentResult;
	    });
	  };
	
	  _proto.executeFetch = function executeFetch(fetchOptions) {
	    // Make sure we reference the latest query as the current one might have been removed
	    this.updateQuery(); // Fetch
	
	    var promise = this.currentQuery.fetch(this.options, fetchOptions);
	
	    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
	      promise = promise.catch(_utils.noop);
	    }
	
	    return promise;
	  };
	
	  _proto.updateStaleTimeout = function updateStaleTimeout() {
	    var _this6 = this;
	
	    this.clearStaleTimeout();
	
	    if (_utils.isServer || this.currentResult.isStale || !(0, _utils.isValidTimeout)(this.options.staleTime)) {
	      return;
	    }
	
	    var time = (0, _utils.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
	    // To mitigate this issue we always add 1 ms to the timeout.
	
	    var timeout = time + 1;
	    this.staleTimeoutId = setTimeout(function () {
	      if (!_this6.currentResult.isStale) {
	        _this6.updateResult();
	      }
	    }, timeout);
	  };
	
	  _proto.computeRefetchInterval = function computeRefetchInterval() {
	    var _this$options$refetch;
	
	    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
	  };
	
	  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
	    var _this7 = this;
	
	    this.clearRefetchInterval();
	    this.currentRefetchInterval = nextInterval;
	
	    if (_utils.isServer || this.options.enabled === false || !(0, _utils.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
	      return;
	    }
	
	    this.refetchIntervalId = setInterval(function () {
	      if (_this7.options.refetchIntervalInBackground || _focusManager.focusManager.isFocused()) {
	        _this7.executeFetch();
	      }
	    }, this.currentRefetchInterval);
	  };
	
	  _proto.updateTimers = function updateTimers() {
	    this.updateStaleTimeout();
	    this.updateRefetchInterval(this.computeRefetchInterval());
	  };
	
	  _proto.clearTimers = function clearTimers() {
	    this.clearStaleTimeout();
	    this.clearRefetchInterval();
	  };
	
	  _proto.clearStaleTimeout = function clearStaleTimeout() {
	    if (this.staleTimeoutId) {
	      clearTimeout(this.staleTimeoutId);
	      this.staleTimeoutId = undefined;
	    }
	  };
	
	  _proto.clearRefetchInterval = function clearRefetchInterval() {
	    if (this.refetchIntervalId) {
	      clearInterval(this.refetchIntervalId);
	      this.refetchIntervalId = undefined;
	    }
	  };
	
	  _proto.createResult = function createResult(query, options) {
	    var prevQuery = this.currentQuery;
	    var prevOptions = this.options;
	    var prevResult = this.currentResult;
	    var prevResultState = this.currentResultState;
	    var prevResultOptions = this.currentResultOptions;
	    var queryChange = query !== prevQuery;
	    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
	    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
	    var state = query.state;
	    var dataUpdatedAt = state.dataUpdatedAt,
	        error = state.error,
	        errorUpdatedAt = state.errorUpdatedAt,
	        isFetching = state.isFetching,
	        status = state.status;
	    var isPreviousData = false;
	    var isPlaceholderData = false;
	    var data; // Optimistically set result in fetching state if needed
	
	    if (options.optimisticResults) {
	      var mounted = this.hasListeners();
	      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
	      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
	
	      if (fetchOnMount || fetchOptionally) {
	        isFetching = true;
	
	        if (!dataUpdatedAt) {
	          status = 'loading';
	        }
	      }
	    } // Keep previous data if needed
	
	
	    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
	      data = prevQueryResult.data;
	      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
	      status = prevQueryResult.status;
	      isPreviousData = true;
	    } // Select data if needed
	    else if (options.select && typeof state.data !== 'undefined') {
	        // Memoize select result
	        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
	          data = this.selectResult;
	        } else {
	          try {
	            this.selectFn = options.select;
	            data = options.select(state.data);
	
	            if (options.structuralSharing !== false) {
	              data = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, data);
	            }
	
	            this.selectResult = data;
	            this.selectError = null;
	          } catch (selectError) {
	            (0, _logger.getLogger)().error(selectError);
	            this.selectError = selectError;
	          }
	        }
	      } // Use query data
	      else {
	          data = state.data;
	        } // Show placeholder data if needed
	
	
	    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
	      var placeholderData; // Memoize placeholder data
	
	      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
	        placeholderData = prevResult.data;
	      } else {
	        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
	
	        if (options.select && typeof placeholderData !== 'undefined') {
	          try {
	            placeholderData = options.select(placeholderData);
	
	            if (options.structuralSharing !== false) {
	              placeholderData = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, placeholderData);
	            }
	
	            this.selectError = null;
	          } catch (selectError) {
	            (0, _logger.getLogger)().error(selectError);
	            this.selectError = selectError;
	          }
	        }
	      }
	
	      if (typeof placeholderData !== 'undefined') {
	        status = 'success';
	        data = placeholderData;
	        isPlaceholderData = true;
	      }
	    }
	
	    if (this.selectError) {
	      error = this.selectError;
	      data = this.selectResult;
	      errorUpdatedAt = Date.now();
	      status = 'error';
	    }
	
	    var result = {
	      status: status,
	      isLoading: status === 'loading',
	      isSuccess: status === 'success',
	      isError: status === 'error',
	      isIdle: status === 'idle',
	      data: data,
	      dataUpdatedAt: dataUpdatedAt,
	      error: error,
	      errorUpdatedAt: errorUpdatedAt,
	      failureCount: state.fetchFailureCount,
	      errorUpdateCount: state.errorUpdateCount,
	      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
	      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
	      isFetching: isFetching,
	      isRefetching: isFetching && status !== 'loading',
	      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
	      isPlaceholderData: isPlaceholderData,
	      isPreviousData: isPreviousData,
	      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
	      isStale: isStale(query, options),
	      refetch: this.refetch,
	      remove: this.remove
	    };
	    return result;
	  };
	
	  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
	    if (!prevResult) {
	      return true;
	    }
	
	    var _this$options = this.options,
	        notifyOnChangeProps = _this$options.notifyOnChangeProps,
	        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
	
	    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
	      return true;
	    }
	
	    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
	      return true;
	    }
	
	    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
	    return Object.keys(result).some(function (key) {
	      var typedKey = key;
	      var changed = result[typedKey] !== prevResult[typedKey];
	      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
	        return x === key;
	      });
	      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
	        return x === key;
	      });
	      return changed && !isExcluded && (!includedProps || isIncluded);
	    });
	  };
	
	  _proto.updateResult = function updateResult(notifyOptions) {
	    var prevResult = this.currentResult;
	    this.currentResult = this.createResult(this.currentQuery, this.options);
	    this.currentResultState = this.currentQuery.state;
	    this.currentResultOptions = this.options; // Only notify if something has changed
	
	    if ((0, _utils.shallowEqualObjects)(this.currentResult, prevResult)) {
	      return;
	    } // Determine which callbacks to trigger
	
	
	    var defaultNotifyOptions = {
	      cache: true
	    };
	
	    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
	      defaultNotifyOptions.listeners = true;
	    }
	
	    this.notify((0, _extends2.default)({}, defaultNotifyOptions, notifyOptions));
	  };
	
	  _proto.updateQuery = function updateQuery() {
	    var query = this.client.getQueryCache().build(this.client, this.options);
	
	    if (query === this.currentQuery) {
	      return;
	    }
	
	    var prevQuery = this.currentQuery;
	    this.currentQuery = query;
	    this.currentQueryInitialState = query.state;
	    this.previousQueryResult = this.currentResult;
	
	    if (this.hasListeners()) {
	      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
	      query.addObserver(this);
	    }
	  };
	
	  _proto.onQueryUpdate = function onQueryUpdate(action) {
	    var notifyOptions = {};
	
	    if (action.type === 'success') {
	      notifyOptions.onSuccess = true;
	    } else if (action.type === 'error' && !(0, _retryer.isCancelledError)(action.error)) {
	      notifyOptions.onError = true;
	    }
	
	    this.updateResult(notifyOptions);
	
	    if (this.hasListeners()) {
	      this.updateTimers();
	    }
	  };
	
	  _proto.notify = function notify(notifyOptions) {
	    var _this8 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      // First trigger the configuration callbacks
	      if (notifyOptions.onSuccess) {
	        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
	        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
	      } else if (notifyOptions.onError) {
	        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
	        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
	      } // Then trigger the listeners
	
	
	      if (notifyOptions.listeners) {
	        _this8.listeners.forEach(function (listener) {
	          listener(_this8.currentResult);
	        });
	      } // Then the cache listeners
	
	
	      if (notifyOptions.cache) {
	        _this8.client.getQueryCache().notify({
	          query: _this8.currentQuery,
	          type: 'observerResultsUpdated'
	        });
	      }
	    });
	  };
	
	  return QueryObserver;
	}(_subscribable.Subscribable);
	
	exports.QueryObserver = QueryObserver;
	
	function shouldLoadOnMount(query, options) {
	  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
	}
	
	function shouldFetchOnMount(query, options) {
	  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
	}
	
	function shouldFetchOn(query, options, field) {
	  if (options.enabled !== false) {
	    var value = typeof field === 'function' ? field(query) : field;
	    return value === 'always' || value !== false && isStale(query, options);
	  }
	
	  return false;
	}
	
	function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
	  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
	}
	
	function isStale(query, options) {
	  return query.isStaleByTime(options.staleTime);
	}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(185);
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  exports[key] = _core[key];
	});
	
	var _react = __webpack_require__(2021);
	
	Object.keys(_react).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  exports[key] = _react[key];
	});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSubscription = createSubscription;
	
	var _batch = __webpack_require__(682);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var nullListeners = {
	  notify: function notify() {},
	  get: function get() {
	    return [];
	  }
	};
	
	function createSubscription(store, parentSub) {
	  var unsubscribe;
	  var listeners = nullListeners;
	
	  function addNestedSub(listener) {
	    trySubscribe();
	    return listeners.subscribe(listener);
	  }
	
	  function notifyNestedSubs() {
	    listeners.notify();
	  }
	
	  function handleChangeWrapper() {
	    if (subscription.onStateChange) {
	      subscription.onStateChange();
	    }
	  }
	
	  function isSubscribed() {
	    return Boolean(unsubscribe);
	  }
	
	  function trySubscribe() {
	    if (!unsubscribe) {
	      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
	      listeners = createListenerCollection();
	    }
	  }
	
	  function tryUnsubscribe() {
	    if (unsubscribe) {
	      unsubscribe();
	      unsubscribe = undefined;
	      listeners.clear();
	      listeners = nullListeners;
	    }
	  }
	
	  var subscription = {
	    addNestedSub: addNestedSub,
	    notifyNestedSubs: notifyNestedSubs,
	    handleChangeWrapper: handleChangeWrapper,
	    isSubscribed: isSubscribed,
	    trySubscribe: trySubscribe,
	    tryUnsubscribe: tryUnsubscribe,
	    getListeners: function getListeners() {
	      return listeners;
	    }
	  };
	  return subscription;
	}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * Tell the browser that the event listener won't prevent a scroll.
	 * Allowing the browser to continue scrolling without having to
	 * to wait for the listener to return.
	 */
	var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
	  var supportsPassiveOption = function () {
	    var supportsPassiveOption = false;
	    try {
	      var opts = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      });
	      window.addEventListener('test', null, opts);
	    } catch (e) {}
	    return supportsPassiveOption;
	  }();
	  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
	};
	
	var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
	  target.removeEventListener(eventName, listener);
	};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var Events = {
		registered: {},
		scrollEvent: {
			register: function register(evtName, callback) {
				Events.registered[evtName] = callback;
			},
			remove: function remove(evtName) {
				Events.registered[evtName] = null;
			}
		}
	};
	
	exports.default = Events;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollSpy = __webpack_require__(400);
	
	var _scrollSpy2 = _interopRequireDefault(_scrollSpy);
	
	var _scroller = __webpack_require__(275);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scrollHash = __webpack_require__(690);
	
	var _scrollHash2 = _interopRequireDefault(_scrollHash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var protoTypes = {
	  to: _propTypes2.default.string.isRequired,
	  containerId: _propTypes2.default.string,
	  container: _propTypes2.default.object,
	  activeClass: _propTypes2.default.string,
	  spy: _propTypes2.default.bool,
	  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  offset: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	  isDynamic: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  absolute: _propTypes2.default.bool,
	  onSetActive: _propTypes2.default.func,
	  onSetInactive: _propTypes2.default.func,
	  ignoreCancelEvents: _propTypes2.default.bool,
	  hashSpy: _propTypes2.default.bool
	};
	
	exports.default = function (Component, customScroller) {
	
	  var scroller = customScroller || _scroller2.default;
	
	  var Link = function (_React$PureComponent) {
	    _inherits(Link, _React$PureComponent);
	
	    function Link(props) {
	      _classCallCheck(this, Link);
	
	      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
	
	      _initialiseProps.call(_this);
	
	      _this.state = {
	        active: false
	      };
	      return _this;
	    }
	
	    _createClass(Link, [{
	      key: 'getScrollSpyContainer',
	      value: function getScrollSpyContainer() {
	        var containerId = this.props.containerId;
	        var container = this.props.container;
	
	        if (containerId && !container) {
	          return document.getElementById(containerId);
	        }
	
	        if (container && container.nodeType) {
	          return container;
	        }
	
	        return document;
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.spy || this.props.hashSpy) {
	          var scrollSpyContainer = this.getScrollSpyContainer();
	
	          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
	            _scrollSpy2.default.mount(scrollSpyContainer);
	          }
	
	          if (this.props.hashSpy) {
	            if (!_scrollHash2.default.isMounted()) {
	              _scrollHash2.default.mount(scroller);
	            }
	            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
	          }
	
	          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);
	
	          this.setState({
	            container: scrollSpyContainer
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var className = "";
	
	        if (this.state && this.state.active) {
	          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	        } else {
	          className = this.props.className;
	        }
	
	        var props = _extends({}, this.props);
	
	        for (var prop in protoTypes) {
	          if (props.hasOwnProperty(prop)) {
	            delete props[prop];
	          }
	        }
	
	        props.className = className;
	        props.onClick = this.handleClick;
	
	        return _react2.default.createElement(Component, props);
	      }
	    }]);
	
	    return Link;
	  }(_react2.default.PureComponent);
	
	  var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.scrollTo = function (to, props) {
	      scroller.scrollTo(to, _extends({}, _this2.state, props));
	    };
	
	    this.handleClick = function (event) {
	
	      /*
	       * give the posibility to override onClick
	       */
	
	      if (_this2.props.onClick) {
	        _this2.props.onClick(event);
	      }
	
	      /*
	       * dont bubble the navigation
	       */
	
	      if (event.stopPropagation) event.stopPropagation();
	      if (event.preventDefault) event.preventDefault();
	
	      /*
	       * do the magic!
	       */
	      _this2.scrollTo(_this2.props.to, _this2.props);
	    };
	
	    this.spyHandler = function (y) {
	
	      var scrollSpyContainer = _this2.getScrollSpyContainer();
	
	      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
	        return;
	      }
	
	      var to = _this2.props.to;
	      var element = null;
	      var elemTopBound = 0;
	      var elemBottomBound = 0;
	      var containerTop = 0;
	
	      if (scrollSpyContainer.getBoundingClientRect) {
	        var containerCords = scrollSpyContainer.getBoundingClientRect();
	        containerTop = containerCords.top;
	      }
	
	      if (!element || _this2.props.isDynamic) {
	        element = scroller.get(to);
	        if (!element) {
	          return;
	        }
	
	        var cords = element.getBoundingClientRect();
	        elemTopBound = cords.top - containerTop + y;
	        elemBottomBound = elemTopBound + cords.height;
	      }
	
	      var offsetY = y - _this2.props.offset;
	      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
	      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
	      var activeLink = scroller.getActiveLink();
	
	      if (isOutside) {
	        if (to === activeLink) {
	          scroller.setActiveLink(void 0);
	        }
	
	        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
	          _scrollHash2.default.changeHash();
	        }
	
	        if (_this2.props.spy && _this2.state.active) {
	          _this2.setState({ active: false });
	          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
	        }
	      }
	
	      if (isInside && (activeLink !== to || _this2.state.active === false)) {
	        scroller.setActiveLink(to);
	
	        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);
	
	        if (_this2.props.spy) {
	          _this2.setState({ active: true });
	          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
	        }
	      }
	    };
	  };
	
	  ;
	
	  Link.propTypes = protoTypes;
	
	  Link.defaultProps = { offset: 0 };
	
	  return Link;
	};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(1647);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _passiveEventListeners = __webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The eventHandler will execute at a rate of 15fps
	var eventThrottler = function eventThrottler(eventHandler) {
	  return (0, _lodash2.default)(eventHandler, 66);
	};
	
	var scrollSpy = {
	
	  spyCallbacks: [],
	  spySetState: [],
	  scrollSpyContainers: [],
	
	  mount: function mount(scrollSpyContainer) {
	    if (scrollSpyContainer) {
	      var eventHandler = eventThrottler(function (event) {
	        scrollSpy.scrollHandler(scrollSpyContainer);
	      });
	      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
	      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
	    }
	  },
	  isMounted: function isMounted(scrollSpyContainer) {
	    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
	  },
	  currentPositionY: function currentPositionY(scrollSpyContainer) {
	    if (scrollSpyContainer === document) {
	      var supportPageOffset = window.pageXOffset !== undefined;
	      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
	      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	    } else {
	      return scrollSpyContainer.scrollTop;
	    }
	  },
	  scrollHandler: function scrollHandler(scrollSpyContainer) {
	    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
	    callbacks.forEach(function (c) {
	      return c(scrollSpy.currentPositionY(scrollSpyContainer));
	    });
	  },
	  addStateHandler: function addStateHandler(handler) {
	    scrollSpy.spySetState.push(handler);
	  },
	  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
	    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];
	
	    if (!container.spyCallbacks) {
	      container.spyCallbacks = [];
	    }
	
	    container.spyCallbacks.push(handler);
	
	    handler(scrollSpy.currentPositionY(scrollSpyContainer));
	  },
	  updateStates: function updateStates() {
	    scrollSpy.spySetState.forEach(function (s) {
	      return s();
	    });
	  },
	  unmount: function unmount(stateHandler, spyHandler) {
	    scrollSpy.scrollSpyContainers.forEach(function (c) {
	      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
	    });
	
	    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
	      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
	    }
	
	    document.removeEventListener('scroll', scrollSpy.scrollHandler);
	  },
	
	
	  update: function update() {
	    return scrollSpy.scrollSpyContainers.forEach(function (c) {
	      return scrollSpy.scrollHandler(c);
	    });
	  }
	};
	
	exports.default = scrollSpy;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(697);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(2058);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(699);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createAction;
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(283));
	
	var _identity = _interopRequireDefault(__webpack_require__(408));
	
	var _isNull = _interopRequireDefault(__webpack_require__(2127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type, payloadCreator, metaCreator) {
	  if (payloadCreator === void 0) {
	    payloadCreator = _identity.default;
	  }
	
	  (0, _invariant.default)((0, _isFunction.default)(payloadCreator) || (0, _isNull.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	  var finalPayloadCreator = (0, _isNull.default)(payloadCreator) || payloadCreator === _identity.default ? _identity.default : function (head) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(void 0, [head].concat(args));
	  };
	  var hasMeta = (0, _isFunction.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(void 0, arguments);
	    var action = {
	      type: type
	    };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(void 0, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value;
	};
	
	exports.default = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownKeys;
	
	var _isMap = _interopRequireDefault(__webpack_require__(284));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object) {
	  if ((0, _isMap.default)(object)) {
	    // We are using loose transforms in babel. Here we are trying to convert an
	    // interable to an array. Loose mode expects everything to already be an
	    // array. The problem is that our eslint rules encourage us to prefer
	    // spread over Array.from.
	    //
	    // Instead of disabling loose mode we simply disable the warning.
	    // eslint-disable-next-line unicorn/prefer-spread
	    return Array.from(object.keys());
	  }
	
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = exports.UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_ERRORS = exports.UNTOUCH = exports.UNREGISTER_FIELD = exports.TOUCH = exports.SUBMIT = exports.STOP_SUBMIT = exports.STOP_ASYNC_VALIDATION = exports.START_SUBMIT = exports.START_ASYNC_VALIDATION = exports.SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_FAILED = exports.RESET_SECTION = exports.RESET = exports.REGISTER_FIELD = exports.INITIALIZE = exports.FOCUS = exports.DESTROY = exports.CLEAR_ASYNC_ERROR = exports.CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT = exports.CLEAR_FIELDS = exports.CHANGE = exports.BLUR = exports.AUTOFILL = exports.ARRAY_SWAP = exports.ARRAY_UNSHIFT = exports.ARRAY_SPLICE = exports.ARRAY_SHIFT = exports.ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE = exports.ARRAY_PUSH = exports.ARRAY_POP = exports.ARRAY_MOVE = exports.ARRAY_INSERT = exports.prefix = void 0;
	var prefix = '@@redux-form/';
	exports.prefix = prefix;
	var ARRAY_INSERT = prefix + "ARRAY_INSERT";
	exports.ARRAY_INSERT = ARRAY_INSERT;
	var ARRAY_MOVE = prefix + "ARRAY_MOVE";
	exports.ARRAY_MOVE = ARRAY_MOVE;
	var ARRAY_POP = prefix + "ARRAY_POP";
	exports.ARRAY_POP = ARRAY_POP;
	var ARRAY_PUSH = prefix + "ARRAY_PUSH";
	exports.ARRAY_PUSH = ARRAY_PUSH;
	var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
	exports.ARRAY_REMOVE = ARRAY_REMOVE;
	var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
	exports.ARRAY_REMOVE_ALL = ARRAY_REMOVE_ALL;
	var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
	exports.ARRAY_SHIFT = ARRAY_SHIFT;
	var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
	exports.ARRAY_SPLICE = ARRAY_SPLICE;
	var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
	exports.ARRAY_UNSHIFT = ARRAY_UNSHIFT;
	var ARRAY_SWAP = prefix + "ARRAY_SWAP";
	exports.ARRAY_SWAP = ARRAY_SWAP;
	var AUTOFILL = prefix + "AUTOFILL";
	exports.AUTOFILL = AUTOFILL;
	var BLUR = prefix + "BLUR";
	exports.BLUR = BLUR;
	var CHANGE = prefix + "CHANGE";
	exports.CHANGE = CHANGE;
	var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
	exports.CLEAR_FIELDS = CLEAR_FIELDS;
	var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
	exports.CLEAR_SUBMIT = CLEAR_SUBMIT;
	var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
	exports.CLEAR_SUBMIT_ERRORS = CLEAR_SUBMIT_ERRORS;
	var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
	exports.CLEAR_ASYNC_ERROR = CLEAR_ASYNC_ERROR;
	var DESTROY = prefix + "DESTROY";
	exports.DESTROY = DESTROY;
	var FOCUS = prefix + "FOCUS";
	exports.FOCUS = FOCUS;
	var INITIALIZE = prefix + "INITIALIZE";
	exports.INITIALIZE = INITIALIZE;
	var REGISTER_FIELD = prefix + "REGISTER_FIELD";
	exports.REGISTER_FIELD = REGISTER_FIELD;
	var RESET = prefix + "RESET";
	exports.RESET = RESET;
	var RESET_SECTION = prefix + "RESET_SECTION";
	exports.RESET_SECTION = RESET_SECTION;
	var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
	exports.SET_SUBMIT_FAILED = SET_SUBMIT_FAILED;
	var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
	exports.SET_SUBMIT_SUCCEEDED = SET_SUBMIT_SUCCEEDED;
	var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
	exports.START_ASYNC_VALIDATION = START_ASYNC_VALIDATION;
	var START_SUBMIT = prefix + "START_SUBMIT";
	exports.START_SUBMIT = START_SUBMIT;
	var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
	exports.STOP_ASYNC_VALIDATION = STOP_ASYNC_VALIDATION;
	var STOP_SUBMIT = prefix + "STOP_SUBMIT";
	exports.STOP_SUBMIT = STOP_SUBMIT;
	var SUBMIT = prefix + "SUBMIT";
	exports.SUBMIT = SUBMIT;
	var TOUCH = prefix + "TOUCH";
	exports.TOUCH = TOUCH;
	var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
	exports.UNREGISTER_FIELD = UNREGISTER_FIELD;
	var UNTOUCH = prefix + "UNTOUCH";
	exports.UNTOUCH = UNTOUCH;
	var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
	exports.UPDATE_SYNC_ERRORS = UPDATE_SYNC_ERRORS;
	var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
	exports.UPDATE_SYNC_WARNINGS = UPDATE_SYNC_WARNINGS;
	var _default = {
	  ARRAY_INSERT: ARRAY_INSERT,
	  ARRAY_MOVE: ARRAY_MOVE,
	  ARRAY_POP: ARRAY_POP,
	  ARRAY_PUSH: ARRAY_PUSH,
	  ARRAY_REMOVE: ARRAY_REMOVE,
	  ARRAY_REMOVE_ALL: ARRAY_REMOVE_ALL,
	  ARRAY_SHIFT: ARRAY_SHIFT,
	  ARRAY_SPLICE: ARRAY_SPLICE,
	  ARRAY_UNSHIFT: ARRAY_UNSHIFT,
	  ARRAY_SWAP: ARRAY_SWAP,
	  AUTOFILL: AUTOFILL,
	  BLUR: BLUR,
	  CHANGE: CHANGE,
	  CLEAR_FIELDS: CLEAR_FIELDS,
	  CLEAR_SUBMIT: CLEAR_SUBMIT,
	  CLEAR_SUBMIT_ERRORS: CLEAR_SUBMIT_ERRORS,
	  CLEAR_ASYNC_ERROR: CLEAR_ASYNC_ERROR,
	  DESTROY: DESTROY,
	  FOCUS: FOCUS,
	  INITIALIZE: INITIALIZE,
	  REGISTER_FIELD: REGISTER_FIELD,
	  RESET: RESET,
	  RESET_SECTION: RESET_SECTION,
	  SET_SUBMIT_FAILED: SET_SUBMIT_FAILED,
	  SET_SUBMIT_SUCCEEDED: SET_SUBMIT_SUCCEEDED,
	  START_ASYNC_VALIDATION: START_ASYNC_VALIDATION,
	  START_SUBMIT: START_SUBMIT,
	  STOP_ASYNC_VALIDATION: STOP_ASYNC_VALIDATION,
	  STOP_SUBMIT: STOP_SUBMIT,
	  SUBMIT: SUBMIT,
	  TOUCH: TOUCH,
	  UNREGISTER_FIELD: UNREGISTER_FIELD,
	  UNTOUCH: UNTOUCH,
	  UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS,
	  UPDATE_SYNC_WARNINGS: UPDATE_SYNC_WARNINGS
	};
	exports["default"] = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	var _default = isEvent;
	exports["default"] = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsValid;
	
	var _hasError = _interopRequireDefault(__webpack_require__(2167));
	
	function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	  var hasError = (0, _hasError["default"])(structure);
	  return function (form, getFormState, ignoreSubmitErrors) {
	    if (ignoreSubmitErrors === void 0) {
	      ignoreSubmitErrors = false;
	    }
	
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + ".syncError");
	
	      if (syncError) {
	        return false;
	      }
	
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + ".error");
	
	        if (error) {
	          return false;
	        }
	      }
	
	      var syncErrors = getIn(formState, form + ".syncErrors");
	      var asyncErrors = getIn(formState, form + ".asyncErrors");
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");
	
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + ".registeredFields");
	
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, "['" + name + "'].count") > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.warn = exports.deprecate = exports.resetDeprecationsSeen = void 0;
	var deprecationsSeen = {};
	var resetDeprecationsSeen = function () {
	    deprecationsSeen = {};
	};
	exports.resetDeprecationsSeen = resetDeprecationsSeen;
	var consoleWarn = (typeof console === 'object' && typeof console.warn === 'function')
	    ? function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return console.warn.apply(console, args);
	    }
	    : function () { };
	var deprecate = function (msg) {
	    if (!deprecationsSeen[msg]) {
	        deprecationsSeen[msg] = true;
	        consoleWarn("redux-observable | DEPRECATION: " + msg);
	    }
	};
	exports.deprecate = deprecate;
	var warn = function (msg) {
	    consoleWarn("redux-observable | WARNING: " + msg);
	};
	exports.warn = warn;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.interval = exports.iif = exports.generate = exports.fromEventPattern = exports.fromEvent = exports.from = exports.forkJoin = exports.empty = exports.defer = exports.connectable = exports.concat = exports.combineLatest = exports.bindNodeCallback = exports.bindCallback = exports.UnsubscriptionError = exports.TimeoutError = exports.SequenceError = exports.ObjectUnsubscribedError = exports.NotFoundError = exports.EmptyError = exports.ArgumentOutOfRangeError = exports.firstValueFrom = exports.lastValueFrom = exports.isObservable = exports.identity = exports.noop = exports.pipe = exports.NotificationKind = exports.Notification = exports.Subscriber = exports.Subscription = exports.Scheduler = exports.VirtualAction = exports.VirtualTimeScheduler = exports.animationFrameScheduler = exports.animationFrame = exports.queueScheduler = exports.queue = exports.asyncScheduler = exports.async = exports.asapScheduler = exports.asap = exports.AsyncSubject = exports.ReplaySubject = exports.BehaviorSubject = exports.Subject = exports.animationFrames = exports.observable = exports.ConnectableObservable = exports.Observable = void 0;
	exports.filter = exports.expand = exports.exhaustMap = exports.exhaustAll = exports.exhaust = exports.every = exports.endWith = exports.elementAt = exports.distinctUntilKeyChanged = exports.distinctUntilChanged = exports.distinct = exports.dematerialize = exports.delayWhen = exports.delay = exports.defaultIfEmpty = exports.debounceTime = exports.debounce = exports.count = exports.connect = exports.concatWith = exports.concatMapTo = exports.concatMap = exports.concatAll = exports.combineLatestWith = exports.combineLatestAll = exports.combineAll = exports.catchError = exports.bufferWhen = exports.bufferToggle = exports.bufferTime = exports.bufferCount = exports.buffer = exports.auditTime = exports.audit = exports.config = exports.NEVER = exports.EMPTY = exports.scheduled = exports.zip = exports.using = exports.timer = exports.throwError = exports.range = exports.race = exports.partition = exports.pairs = exports.onErrorResumeNext = exports.of = exports.never = exports.merge = void 0;
	exports.switchMapTo = exports.switchMap = exports.switchAll = exports.subscribeOn = exports.startWith = exports.skipWhile = exports.skipUntil = exports.skipLast = exports.skip = exports.single = exports.shareReplay = exports.share = exports.sequenceEqual = exports.scan = exports.sampleTime = exports.sample = exports.refCount = exports.retryWhen = exports.retry = exports.repeatWhen = exports.repeat = exports.reduce = exports.raceWith = exports.publishReplay = exports.publishLast = exports.publishBehavior = exports.publish = exports.pluck = exports.pairwise = exports.observeOn = exports.multicast = exports.min = exports.mergeWith = exports.mergeScan = exports.mergeMapTo = exports.mergeMap = exports.flatMap = exports.mergeAll = exports.max = exports.materialize = exports.mapTo = exports.map = exports.last = exports.isEmpty = exports.ignoreElements = exports.groupBy = exports.first = exports.findIndex = exports.find = exports.finalize = void 0;
	exports.zipWith = exports.zipAll = exports.withLatestFrom = exports.windowWhen = exports.windowToggle = exports.windowTime = exports.windowCount = exports.window = exports.toArray = exports.timestamp = exports.timeoutWith = exports.timeout = exports.timeInterval = exports.throwIfEmpty = exports.throttleTime = exports.throttle = exports.tap = exports.takeWhile = exports.takeUntil = exports.takeLast = exports.take = exports.switchScan = void 0;
	var Observable_1 = __webpack_require__(28);
	Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return Observable_1.Observable; } });
	var ConnectableObservable_1 = __webpack_require__(285);
	Object.defineProperty(exports, "ConnectableObservable", { enumerable: true, get: function () { return ConnectableObservable_1.ConnectableObservable; } });
	var observable_1 = __webpack_require__(292);
	Object.defineProperty(exports, "observable", { enumerable: true, get: function () { return observable_1.observable; } });
	var animationFrames_1 = __webpack_require__(2213);
	Object.defineProperty(exports, "animationFrames", { enumerable: true, get: function () { return animationFrames_1.animationFrames; } });
	var Subject_1 = __webpack_require__(46);
	Object.defineProperty(exports, "Subject", { enumerable: true, get: function () { return Subject_1.Subject; } });
	var BehaviorSubject_1 = __webpack_require__(731);
	Object.defineProperty(exports, "BehaviorSubject", { enumerable: true, get: function () { return BehaviorSubject_1.BehaviorSubject; } });
	var ReplaySubject_1 = __webpack_require__(417);
	Object.defineProperty(exports, "ReplaySubject", { enumerable: true, get: function () { return ReplaySubject_1.ReplaySubject; } });
	var AsyncSubject_1 = __webpack_require__(415);
	Object.defineProperty(exports, "AsyncSubject", { enumerable: true, get: function () { return AsyncSubject_1.AsyncSubject; } });
	var asap_1 = __webpack_require__(2241);
	Object.defineProperty(exports, "asap", { enumerable: true, get: function () { return asap_1.asap; } });
	Object.defineProperty(exports, "asapScheduler", { enumerable: true, get: function () { return asap_1.asapScheduler; } });
	var async_1 = __webpack_require__(65);
	Object.defineProperty(exports, "async", { enumerable: true, get: function () { return async_1.async; } });
	Object.defineProperty(exports, "asyncScheduler", { enumerable: true, get: function () { return async_1.asyncScheduler; } });
	var queue_1 = __webpack_require__(2245);
	Object.defineProperty(exports, "queue", { enumerable: true, get: function () { return queue_1.queue; } });
	Object.defineProperty(exports, "queueScheduler", { enumerable: true, get: function () { return queue_1.queueScheduler; } });
	var animationFrame_1 = __webpack_require__(2240);
	Object.defineProperty(exports, "animationFrame", { enumerable: true, get: function () { return animationFrame_1.animationFrame; } });
	Object.defineProperty(exports, "animationFrameScheduler", { enumerable: true, get: function () { return animationFrame_1.animationFrameScheduler; } });
	var VirtualTimeScheduler_1 = __webpack_require__(2239);
	Object.defineProperty(exports, "VirtualTimeScheduler", { enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualTimeScheduler; } });
	Object.defineProperty(exports, "VirtualAction", { enumerable: true, get: function () { return VirtualTimeScheduler_1.VirtualAction; } });
	var Scheduler_1 = __webpack_require__(732);
	Object.defineProperty(exports, "Scheduler", { enumerable: true, get: function () { return Scheduler_1.Scheduler; } });
	var Subscription_1 = __webpack_require__(64);
	Object.defineProperty(exports, "Subscription", { enumerable: true, get: function () { return Subscription_1.Subscription; } });
	var Subscriber_1 = __webpack_require__(192);
	Object.defineProperty(exports, "Subscriber", { enumerable: true, get: function () { return Subscriber_1.Subscriber; } });
	var Notification_1 = __webpack_require__(416);
	Object.defineProperty(exports, "Notification", { enumerable: true, get: function () { return Notification_1.Notification; } });
	Object.defineProperty(exports, "NotificationKind", { enumerable: true, get: function () { return Notification_1.NotificationKind; } });
	var pipe_1 = __webpack_require__(294);
	Object.defineProperty(exports, "pipe", { enumerable: true, get: function () { return pipe_1.pipe; } });
	var noop_1 = __webpack_require__(48);
	Object.defineProperty(exports, "noop", { enumerable: true, get: function () { return noop_1.noop; } });
	var identity_1 = __webpack_require__(47);
	Object.defineProperty(exports, "identity", { enumerable: true, get: function () { return identity_1.identity; } });
	var isObservable_1 = __webpack_require__(2248);
	Object.defineProperty(exports, "isObservable", { enumerable: true, get: function () { return isObservable_1.isObservable; } });
	var lastValueFrom_1 = __webpack_require__(2209);
	Object.defineProperty(exports, "lastValueFrom", { enumerable: true, get: function () { return lastValueFrom_1.lastValueFrom; } });
	var firstValueFrom_1 = __webpack_require__(2208);
	Object.defineProperty(exports, "firstValueFrom", { enumerable: true, get: function () { return firstValueFrom_1.firstValueFrom; } });
	var ArgumentOutOfRangeError_1 = __webpack_require__(825);
	Object.defineProperty(exports, "ArgumentOutOfRangeError", { enumerable: true, get: function () { return ArgumentOutOfRangeError_1.ArgumentOutOfRangeError; } });
	var EmptyError_1 = __webpack_require__(133);
	Object.defineProperty(exports, "EmptyError", { enumerable: true, get: function () { return EmptyError_1.EmptyError; } });
	var NotFoundError_1 = __webpack_require__(826);
	Object.defineProperty(exports, "NotFoundError", { enumerable: true, get: function () { return NotFoundError_1.NotFoundError; } });
	var ObjectUnsubscribedError_1 = __webpack_require__(827);
	Object.defineProperty(exports, "ObjectUnsubscribedError", { enumerable: true, get: function () { return ObjectUnsubscribedError_1.ObjectUnsubscribedError; } });
	var SequenceError_1 = __webpack_require__(828);
	Object.defineProperty(exports, "SequenceError", { enumerable: true, get: function () { return SequenceError_1.SequenceError; } });
	var timeout_1 = __webpack_require__(291);
	Object.defineProperty(exports, "TimeoutError", { enumerable: true, get: function () { return timeout_1.TimeoutError; } });
	var UnsubscriptionError_1 = __webpack_require__(829);
	Object.defineProperty(exports, "UnsubscriptionError", { enumerable: true, get: function () { return UnsubscriptionError_1.UnsubscriptionError; } });
	var bindCallback_1 = __webpack_require__(2210);
	Object.defineProperty(exports, "bindCallback", { enumerable: true, get: function () { return bindCallback_1.bindCallback; } });
	var bindNodeCallback_1 = __webpack_require__(2211);
	Object.defineProperty(exports, "bindNodeCallback", { enumerable: true, get: function () { return bindNodeCallback_1.bindNodeCallback; } });
	var combineLatest_1 = __webpack_require__(418);
	Object.defineProperty(exports, "combineLatest", { enumerable: true, get: function () { return combineLatest_1.combineLatest; } });
	var concat_1 = __webpack_require__(286);
	Object.defineProperty(exports, "concat", { enumerable: true, get: function () { return concat_1.concat; } });
	var connectable_1 = __webpack_require__(2212);
	Object.defineProperty(exports, "connectable", { enumerable: true, get: function () { return connectable_1.connectable; } });
	var defer_1 = __webpack_require__(287);
	Object.defineProperty(exports, "defer", { enumerable: true, get: function () { return defer_1.defer; } });
	var empty_1 = __webpack_require__(77);
	Object.defineProperty(exports, "empty", { enumerable: true, get: function () { return empty_1.empty; } });
	var forkJoin_1 = __webpack_require__(2214);
	Object.defineProperty(exports, "forkJoin", { enumerable: true, get: function () { return forkJoin_1.forkJoin; } });
	var from_1 = __webpack_require__(109);
	Object.defineProperty(exports, "from", { enumerable: true, get: function () { return from_1.from; } });
	var fromEvent_1 = __webpack_require__(2215);
	Object.defineProperty(exports, "fromEvent", { enumerable: true, get: function () { return fromEvent_1.fromEvent; } });
	var fromEventPattern_1 = __webpack_require__(2216);
	Object.defineProperty(exports, "fromEventPattern", { enumerable: true, get: function () { return fromEventPattern_1.fromEventPattern; } });
	var generate_1 = __webpack_require__(2218);
	Object.defineProperty(exports, "generate", { enumerable: true, get: function () { return generate_1.generate; } });
	var iif_1 = __webpack_require__(2219);
	Object.defineProperty(exports, "iif", { enumerable: true, get: function () { return iif_1.iif; } });
	var interval_1 = __webpack_require__(734);
	Object.defineProperty(exports, "interval", { enumerable: true, get: function () { return interval_1.interval; } });
	var merge_1 = __webpack_require__(2220);
	Object.defineProperty(exports, "merge", { enumerable: true, get: function () { return merge_1.merge; } });
	var never_1 = __webpack_require__(735);
	Object.defineProperty(exports, "never", { enumerable: true, get: function () { return never_1.never; } });
	var of_1 = __webpack_require__(419);
	Object.defineProperty(exports, "of", { enumerable: true, get: function () { return of_1.of; } });
	var onErrorResumeNext_1 = __webpack_require__(2221);
	Object.defineProperty(exports, "onErrorResumeNext", { enumerable: true, get: function () { return onErrorResumeNext_1.onErrorResumeNext; } });
	var pairs_1 = __webpack_require__(2222);
	Object.defineProperty(exports, "pairs", { enumerable: true, get: function () { return pairs_1.pairs; } });
	var partition_1 = __webpack_require__(2223);
	Object.defineProperty(exports, "partition", { enumerable: true, get: function () { return partition_1.partition; } });
	var race_1 = __webpack_require__(736);
	Object.defineProperty(exports, "race", { enumerable: true, get: function () { return race_1.race; } });
	var range_1 = __webpack_require__(2224);
	Object.defineProperty(exports, "range", { enumerable: true, get: function () { return range_1.range; } });
	var throwError_1 = __webpack_require__(737);
	Object.defineProperty(exports, "throwError", { enumerable: true, get: function () { return throwError_1.throwError; } });
	var timer_1 = __webpack_require__(132);
	Object.defineProperty(exports, "timer", { enumerable: true, get: function () { return timer_1.timer; } });
	var using_1 = __webpack_require__(2225);
	Object.defineProperty(exports, "using", { enumerable: true, get: function () { return using_1.using; } });
	var zip_1 = __webpack_require__(420);
	Object.defineProperty(exports, "zip", { enumerable: true, get: function () { return zip_1.zip; } });
	var scheduled_1 = __webpack_require__(821);
	Object.defineProperty(exports, "scheduled", { enumerable: true, get: function () { return scheduled_1.scheduled; } });
	var empty_2 = __webpack_require__(77);
	Object.defineProperty(exports, "EMPTY", { enumerable: true, get: function () { return empty_2.EMPTY; } });
	var never_2 = __webpack_require__(735);
	Object.defineProperty(exports, "NEVER", { enumerable: true, get: function () { return never_2.NEVER; } });
	__exportStar(__webpack_require__(2246), exports);
	var config_1 = __webpack_require__(193);
	Object.defineProperty(exports, "config", { enumerable: true, get: function () { return config_1.config; } });
	var audit_1 = __webpack_require__(421);
	Object.defineProperty(exports, "audit", { enumerable: true, get: function () { return audit_1.audit; } });
	var auditTime_1 = __webpack_require__(738);
	Object.defineProperty(exports, "auditTime", { enumerable: true, get: function () { return auditTime_1.auditTime; } });
	var buffer_1 = __webpack_require__(739);
	Object.defineProperty(exports, "buffer", { enumerable: true, get: function () { return buffer_1.buffer; } });
	var bufferCount_1 = __webpack_require__(740);
	Object.defineProperty(exports, "bufferCount", { enumerable: true, get: function () { return bufferCount_1.bufferCount; } });
	var bufferTime_1 = __webpack_require__(741);
	Object.defineProperty(exports, "bufferTime", { enumerable: true, get: function () { return bufferTime_1.bufferTime; } });
	var bufferToggle_1 = __webpack_require__(742);
	Object.defineProperty(exports, "bufferToggle", { enumerable: true, get: function () { return bufferToggle_1.bufferToggle; } });
	var bufferWhen_1 = __webpack_require__(743);
	Object.defineProperty(exports, "bufferWhen", { enumerable: true, get: function () { return bufferWhen_1.bufferWhen; } });
	var catchError_1 = __webpack_require__(744);
	Object.defineProperty(exports, "catchError", { enumerable: true, get: function () { return catchError_1.catchError; } });
	var combineAll_1 = __webpack_require__(745);
	Object.defineProperty(exports, "combineAll", { enumerable: true, get: function () { return combineAll_1.combineAll; } });
	var combineLatestAll_1 = __webpack_require__(422);
	Object.defineProperty(exports, "combineLatestAll", { enumerable: true, get: function () { return combineLatestAll_1.combineLatestAll; } });
	var combineLatestWith_1 = __webpack_require__(747);
	Object.defineProperty(exports, "combineLatestWith", { enumerable: true, get: function () { return combineLatestWith_1.combineLatestWith; } });
	var concatAll_1 = __webpack_require__(288);
	Object.defineProperty(exports, "concatAll", { enumerable: true, get: function () { return concatAll_1.concatAll; } });
	var concatMap_1 = __webpack_require__(423);
	Object.defineProperty(exports, "concatMap", { enumerable: true, get: function () { return concatMap_1.concatMap; } });
	var concatMapTo_1 = __webpack_require__(749);
	Object.defineProperty(exports, "concatMapTo", { enumerable: true, get: function () { return concatMapTo_1.concatMapTo; } });
	var concatWith_1 = __webpack_require__(750);
	Object.defineProperty(exports, "concatWith", { enumerable: true, get: function () { return concatWith_1.concatWith; } });
	var connect_1 = __webpack_require__(289);
	Object.defineProperty(exports, "connect", { enumerable: true, get: function () { return connect_1.connect; } });
	var count_1 = __webpack_require__(751);
	Object.defineProperty(exports, "count", { enumerable: true, get: function () { return count_1.count; } });
	var debounce_1 = __webpack_require__(752);
	Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return debounce_1.debounce; } });
	var debounceTime_1 = __webpack_require__(753);
	Object.defineProperty(exports, "debounceTime", { enumerable: true, get: function () { return debounceTime_1.debounceTime; } });
	var defaultIfEmpty_1 = __webpack_require__(194);
	Object.defineProperty(exports, "defaultIfEmpty", { enumerable: true, get: function () { return defaultIfEmpty_1.defaultIfEmpty; } });
	var delay_1 = __webpack_require__(754);
	Object.defineProperty(exports, "delay", { enumerable: true, get: function () { return delay_1.delay; } });
	var delayWhen_1 = __webpack_require__(424);
	Object.defineProperty(exports, "delayWhen", { enumerable: true, get: function () { return delayWhen_1.delayWhen; } });
	var dematerialize_1 = __webpack_require__(755);
	Object.defineProperty(exports, "dematerialize", { enumerable: true, get: function () { return dematerialize_1.dematerialize; } });
	var distinct_1 = __webpack_require__(756);
	Object.defineProperty(exports, "distinct", { enumerable: true, get: function () { return distinct_1.distinct; } });
	var distinctUntilChanged_1 = __webpack_require__(425);
	Object.defineProperty(exports, "distinctUntilChanged", { enumerable: true, get: function () { return distinctUntilChanged_1.distinctUntilChanged; } });
	var distinctUntilKeyChanged_1 = __webpack_require__(757);
	Object.defineProperty(exports, "distinctUntilKeyChanged", { enumerable: true, get: function () { return distinctUntilKeyChanged_1.distinctUntilKeyChanged; } });
	var elementAt_1 = __webpack_require__(758);
	Object.defineProperty(exports, "elementAt", { enumerable: true, get: function () { return elementAt_1.elementAt; } });
	var endWith_1 = __webpack_require__(759);
	Object.defineProperty(exports, "endWith", { enumerable: true, get: function () { return endWith_1.endWith; } });
	var every_1 = __webpack_require__(760);
	Object.defineProperty(exports, "every", { enumerable: true, get: function () { return every_1.every; } });
	var exhaust_1 = __webpack_require__(761);
	Object.defineProperty(exports, "exhaust", { enumerable: true, get: function () { return exhaust_1.exhaust; } });
	var exhaustAll_1 = __webpack_require__(426);
	Object.defineProperty(exports, "exhaustAll", { enumerable: true, get: function () { return exhaustAll_1.exhaustAll; } });
	var exhaustMap_1 = __webpack_require__(427);
	Object.defineProperty(exports, "exhaustMap", { enumerable: true, get: function () { return exhaustMap_1.exhaustMap; } });
	var expand_1 = __webpack_require__(762);
	Object.defineProperty(exports, "expand", { enumerable: true, get: function () { return expand_1.expand; } });
	var filter_1 = __webpack_require__(110);
	Object.defineProperty(exports, "filter", { enumerable: true, get: function () { return filter_1.filter; } });
	var finalize_1 = __webpack_require__(763);
	Object.defineProperty(exports, "finalize", { enumerable: true, get: function () { return finalize_1.finalize; } });
	var find_1 = __webpack_require__(428);
	Object.defineProperty(exports, "find", { enumerable: true, get: function () { return find_1.find; } });
	var findIndex_1 = __webpack_require__(764);
	Object.defineProperty(exports, "findIndex", { enumerable: true, get: function () { return findIndex_1.findIndex; } });
	var first_1 = __webpack_require__(765);
	Object.defineProperty(exports, "first", { enumerable: true, get: function () { return first_1.first; } });
	var groupBy_1 = __webpack_require__(767);
	Object.defineProperty(exports, "groupBy", { enumerable: true, get: function () { return groupBy_1.groupBy; } });
	var ignoreElements_1 = __webpack_require__(429);
	Object.defineProperty(exports, "ignoreElements", { enumerable: true, get: function () { return ignoreElements_1.ignoreElements; } });
	var isEmpty_1 = __webpack_require__(768);
	Object.defineProperty(exports, "isEmpty", { enumerable: true, get: function () { return isEmpty_1.isEmpty; } });
	var last_1 = __webpack_require__(770);
	Object.defineProperty(exports, "last", { enumerable: true, get: function () { return last_1.last; } });
	var map_1 = __webpack_require__(111);
	Object.defineProperty(exports, "map", { enumerable: true, get: function () { return map_1.map; } });
	var mapTo_1 = __webpack_require__(430);
	Object.defineProperty(exports, "mapTo", { enumerable: true, get: function () { return mapTo_1.mapTo; } });
	var materialize_1 = __webpack_require__(771);
	Object.defineProperty(exports, "materialize", { enumerable: true, get: function () { return materialize_1.materialize; } });
	var max_1 = __webpack_require__(772);
	Object.defineProperty(exports, "max", { enumerable: true, get: function () { return max_1.max; } });
	var mergeAll_1 = __webpack_require__(195);
	Object.defineProperty(exports, "mergeAll", { enumerable: true, get: function () { return mergeAll_1.mergeAll; } });
	var flatMap_1 = __webpack_require__(766);
	Object.defineProperty(exports, "flatMap", { enumerable: true, get: function () { return flatMap_1.flatMap; } });
	var mergeMap_1 = __webpack_require__(98);
	Object.defineProperty(exports, "mergeMap", { enumerable: true, get: function () { return mergeMap_1.mergeMap; } });
	var mergeMapTo_1 = __webpack_require__(774);
	Object.defineProperty(exports, "mergeMapTo", { enumerable: true, get: function () { return mergeMapTo_1.mergeMapTo; } });
	var mergeScan_1 = __webpack_require__(775);
	Object.defineProperty(exports, "mergeScan", { enumerable: true, get: function () { return mergeScan_1.mergeScan; } });
	var mergeWith_1 = __webpack_require__(776);
	Object.defineProperty(exports, "mergeWith", { enumerable: true, get: function () { return mergeWith_1.mergeWith; } });
	var min_1 = __webpack_require__(777);
	Object.defineProperty(exports, "min", { enumerable: true, get: function () { return min_1.min; } });
	var multicast_1 = __webpack_require__(290);
	Object.defineProperty(exports, "multicast", { enumerable: true, get: function () { return multicast_1.multicast; } });
	var observeOn_1 = __webpack_require__(196);
	Object.defineProperty(exports, "observeOn", { enumerable: true, get: function () { return observeOn_1.observeOn; } });
	var pairwise_1 = __webpack_require__(779);
	Object.defineProperty(exports, "pairwise", { enumerable: true, get: function () { return pairwise_1.pairwise; } });
	var pluck_1 = __webpack_require__(780);
	Object.defineProperty(exports, "pluck", { enumerable: true, get: function () { return pluck_1.pluck; } });
	var publish_1 = __webpack_require__(781);
	Object.defineProperty(exports, "publish", { enumerable: true, get: function () { return publish_1.publish; } });
	var publishBehavior_1 = __webpack_require__(782);
	Object.defineProperty(exports, "publishBehavior", { enumerable: true, get: function () { return publishBehavior_1.publishBehavior; } });
	var publishLast_1 = __webpack_require__(783);
	Object.defineProperty(exports, "publishLast", { enumerable: true, get: function () { return publishLast_1.publishLast; } });
	var publishReplay_1 = __webpack_require__(784);
	Object.defineProperty(exports, "publishReplay", { enumerable: true, get: function () { return publishReplay_1.publishReplay; } });
	var raceWith_1 = __webpack_require__(432);
	Object.defineProperty(exports, "raceWith", { enumerable: true, get: function () { return raceWith_1.raceWith; } });
	var reduce_1 = __webpack_require__(154);
	Object.defineProperty(exports, "reduce", { enumerable: true, get: function () { return reduce_1.reduce; } });
	var repeat_1 = __webpack_require__(785);
	Object.defineProperty(exports, "repeat", { enumerable: true, get: function () { return repeat_1.repeat; } });
	var repeatWhen_1 = __webpack_require__(786);
	Object.defineProperty(exports, "repeatWhen", { enumerable: true, get: function () { return repeatWhen_1.repeatWhen; } });
	var retry_1 = __webpack_require__(787);
	Object.defineProperty(exports, "retry", { enumerable: true, get: function () { return retry_1.retry; } });
	var retryWhen_1 = __webpack_require__(788);
	Object.defineProperty(exports, "retryWhen", { enumerable: true, get: function () { return retryWhen_1.retryWhen; } });
	var refCount_1 = __webpack_require__(433);
	Object.defineProperty(exports, "refCount", { enumerable: true, get: function () { return refCount_1.refCount; } });
	var sample_1 = __webpack_require__(434);
	Object.defineProperty(exports, "sample", { enumerable: true, get: function () { return sample_1.sample; } });
	var sampleTime_1 = __webpack_require__(789);
	Object.defineProperty(exports, "sampleTime", { enumerable: true, get: function () { return sampleTime_1.sampleTime; } });
	var scan_1 = __webpack_require__(790);
	Object.defineProperty(exports, "scan", { enumerable: true, get: function () { return scan_1.scan; } });
	var sequenceEqual_1 = __webpack_require__(792);
	Object.defineProperty(exports, "sequenceEqual", { enumerable: true, get: function () { return sequenceEqual_1.sequenceEqual; } });
	var share_1 = __webpack_require__(435);
	Object.defineProperty(exports, "share", { enumerable: true, get: function () { return share_1.share; } });
	var shareReplay_1 = __webpack_require__(793);
	Object.defineProperty(exports, "shareReplay", { enumerable: true, get: function () { return shareReplay_1.shareReplay; } });
	var single_1 = __webpack_require__(794);
	Object.defineProperty(exports, "single", { enumerable: true, get: function () { return single_1.single; } });
	var skip_1 = __webpack_require__(795);
	Object.defineProperty(exports, "skip", { enumerable: true, get: function () { return skip_1.skip; } });
	var skipLast_1 = __webpack_require__(796);
	Object.defineProperty(exports, "skipLast", { enumerable: true, get: function () { return skipLast_1.skipLast; } });
	var skipUntil_1 = __webpack_require__(797);
	Object.defineProperty(exports, "skipUntil", { enumerable: true, get: function () { return skipUntil_1.skipUntil; } });
	var skipWhile_1 = __webpack_require__(798);
	Object.defineProperty(exports, "skipWhile", { enumerable: true, get: function () { return skipWhile_1.skipWhile; } });
	var startWith_1 = __webpack_require__(799);
	Object.defineProperty(exports, "startWith", { enumerable: true, get: function () { return startWith_1.startWith; } });
	var subscribeOn_1 = __webpack_require__(197);
	Object.defineProperty(exports, "subscribeOn", { enumerable: true, get: function () { return subscribeOn_1.subscribeOn; } });
	var switchAll_1 = __webpack_require__(800);
	Object.defineProperty(exports, "switchAll", { enumerable: true, get: function () { return switchAll_1.switchAll; } });
	var switchMap_1 = __webpack_require__(198);
	Object.defineProperty(exports, "switchMap", { enumerable: true, get: function () { return switchMap_1.switchMap; } });
	var switchMapTo_1 = __webpack_require__(801);
	Object.defineProperty(exports, "switchMapTo", { enumerable: true, get: function () { return switchMapTo_1.switchMapTo; } });
	var switchScan_1 = __webpack_require__(802);
	Object.defineProperty(exports, "switchScan", { enumerable: true, get: function () { return switchScan_1.switchScan; } });
	var take_1 = __webpack_require__(199);
	Object.defineProperty(exports, "take", { enumerable: true, get: function () { return take_1.take; } });
	var takeLast_1 = __webpack_require__(436);
	Object.defineProperty(exports, "takeLast", { enumerable: true, get: function () { return takeLast_1.takeLast; } });
	var takeUntil_1 = __webpack_require__(803);
	Object.defineProperty(exports, "takeUntil", { enumerable: true, get: function () { return takeUntil_1.takeUntil; } });
	var takeWhile_1 = __webpack_require__(804);
	Object.defineProperty(exports, "takeWhile", { enumerable: true, get: function () { return takeWhile_1.takeWhile; } });
	var tap_1 = __webpack_require__(805);
	Object.defineProperty(exports, "tap", { enumerable: true, get: function () { return tap_1.tap; } });
	var throttle_1 = __webpack_require__(437);
	Object.defineProperty(exports, "throttle", { enumerable: true, get: function () { return throttle_1.throttle; } });
	var throttleTime_1 = __webpack_require__(806);
	Object.defineProperty(exports, "throttleTime", { enumerable: true, get: function () { return throttleTime_1.throttleTime; } });
	var throwIfEmpty_1 = __webpack_require__(200);
	Object.defineProperty(exports, "throwIfEmpty", { enumerable: true, get: function () { return throwIfEmpty_1.throwIfEmpty; } });
	var timeInterval_1 = __webpack_require__(807);
	Object.defineProperty(exports, "timeInterval", { enumerable: true, get: function () { return timeInterval_1.timeInterval; } });
	var timeout_2 = __webpack_require__(291);
	Object.defineProperty(exports, "timeout", { enumerable: true, get: function () { return timeout_2.timeout; } });
	var timeoutWith_1 = __webpack_require__(808);
	Object.defineProperty(exports, "timeoutWith", { enumerable: true, get: function () { return timeoutWith_1.timeoutWith; } });
	var timestamp_1 = __webpack_require__(809);
	Object.defineProperty(exports, "timestamp", { enumerable: true, get: function () { return timestamp_1.timestamp; } });
	var toArray_1 = __webpack_require__(438);
	Object.defineProperty(exports, "toArray", { enumerable: true, get: function () { return toArray_1.toArray; } });
	var window_1 = __webpack_require__(810);
	Object.defineProperty(exports, "window", { enumerable: true, get: function () { return window_1.window; } });
	var windowCount_1 = __webpack_require__(811);
	Object.defineProperty(exports, "windowCount", { enumerable: true, get: function () { return windowCount_1.windowCount; } });
	var windowTime_1 = __webpack_require__(812);
	Object.defineProperty(exports, "windowTime", { enumerable: true, get: function () { return windowTime_1.windowTime; } });
	var windowToggle_1 = __webpack_require__(813);
	Object.defineProperty(exports, "windowToggle", { enumerable: true, get: function () { return windowToggle_1.windowToggle; } });
	var windowWhen_1 = __webpack_require__(814);
	Object.defineProperty(exports, "windowWhen", { enumerable: true, get: function () { return windowWhen_1.windowWhen; } });
	var withLatestFrom_1 = __webpack_require__(815);
	Object.defineProperty(exports, "withLatestFrom", { enumerable: true, get: function () { return withLatestFrom_1.withLatestFrom; } });
	var zipAll_1 = __webpack_require__(817);
	Object.defineProperty(exports, "zipAll", { enumerable: true, get: function () { return zipAll_1.zipAll; } });
	var zipWith_1 = __webpack_require__(818);
	Object.defineProperty(exports, "zipWith", { enumerable: true, get: function () { return zipWith_1.zipWith; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsyncSubject = void 0;
	var Subject_1 = __webpack_require__(46);
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._value = null;
	        _this._hasValue = false;
	        _this._isComplete = false;
	        return _this;
	    }
	    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
	        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
	        if (hasError) {
	            subscriber.error(thrownError);
	        }
	        else if (isStopped || _isComplete) {
	            _hasValue && subscriber.next(_value);
	            subscriber.complete();
	        }
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._value = value;
	            this._hasValue = true;
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
	        if (!_isComplete) {
	            this._isComplete = true;
	            _hasValue && _super.prototype.next.call(this, _value);
	            _super.prototype.complete.call(this);
	        }
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observeNotification = exports.Notification = exports.NotificationKind = void 0;
	var empty_1 = __webpack_require__(77);
	var of_1 = __webpack_require__(419);
	var throwError_1 = __webpack_require__(737);
	var isFunction_1 = __webpack_require__(27);
	var NotificationKind;
	(function (NotificationKind) {
	    NotificationKind["NEXT"] = "N";
	    NotificationKind["ERROR"] = "E";
	    NotificationKind["COMPLETE"] = "C";
	})(NotificationKind = exports.NotificationKind || (exports.NotificationKind = {}));
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    Notification.prototype.observe = function (observer) {
	        return observeNotification(this, observer);
	    };
	    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
	        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
	        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
	    };
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        var _a;
	        return isFunction_1.isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
	            ? this.observe(nextOrObserver)
	            : this.do(nextOrObserver, error, complete);
	    };
	    Notification.prototype.toObservable = function () {
	        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
	        var result = kind === 'N'
	            ?
	                of_1.of(value)
	            :
	                kind === 'E'
	                    ?
	                        throwError_1.throwError(function () { return error; })
	                    :
	                        kind === 'C'
	                            ?
	                                empty_1.EMPTY
	                            :
	                                0;
	        if (!result) {
	            throw new TypeError("Unexpected notification kind " + kind);
	        }
	        return result;
	    };
	    Notification.createNext = function (value) {
	        return new Notification('N', value);
	    };
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    return Notification;
	}());
	exports.Notification = Notification;
	function observeNotification(notification, observer) {
	    var _a, _b, _c;
	    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
	    if (typeof kind !== 'string') {
	        throw new TypeError('Invalid notification, missing "kind"');
	    }
	    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
	}
	exports.observeNotification = observeNotification;
	//# sourceMappingURL=Notification.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ReplaySubject = void 0;
	var Subject_1 = __webpack_require__(46);
	var dateTimestampProvider_1 = __webpack_require__(439);
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
	        if (_bufferSize === void 0) { _bufferSize = Infinity; }
	        if (_windowTime === void 0) { _windowTime = Infinity; }
	        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
	        var _this = _super.call(this) || this;
	        _this._bufferSize = _bufferSize;
	        _this._windowTime = _windowTime;
	        _this._timestampProvider = _timestampProvider;
	        _this._buffer = [];
	        _this._infiniteTimeWindow = true;
	        _this._infiniteTimeWindow = _windowTime === Infinity;
	        _this._bufferSize = Math.max(1, _bufferSize);
	        _this._windowTime = Math.max(1, _windowTime);
	        return _this;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
	        if (!isStopped) {
	            _buffer.push(value);
	            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
	        }
	        this._trimBuffer();
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        this._throwIfClosed();
	        this._trimBuffer();
	        var subscription = this._innerSubscribe(subscriber);
	        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
	        var copy = _buffer.slice();
	        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
	            subscriber.next(copy[i]);
	        }
	        this._checkFinalizedStatuses(subscriber);
	        return subscription;
	    };
	    ReplaySubject.prototype._trimBuffer = function () {
	        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
	        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
	        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
	        if (!_infiniteTimeWindow) {
	            var now = _timestampProvider.now();
	            var last = 0;
	            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
	                last = i;
	            }
	            last && _buffer.splice(0, last + 1);
	        }
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestInit = exports.combineLatest = void 0;
	var Observable_1 = __webpack_require__(28);
	var argsArgArrayOrObject_1 = __webpack_require__(830);
	var from_1 = __webpack_require__(109);
	var identity_1 = __webpack_require__(47);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var args_1 = __webpack_require__(66);
	var createObject_1 = __webpack_require__(831);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var executeSchedule_1 = __webpack_require__(113);
	function combineLatest() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var resultSelector = args_1.popResultSelector(args);
	    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
	    if (observables.length === 0) {
	        return from_1.from([], scheduler);
	    }
	    var result = new Observable_1.Observable(combineLatestInit(observables, scheduler, keys
	        ?
	            function (values) { return createObject_1.createObject(keys, values); }
	        :
	            identity_1.identity));
	    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
	}
	exports.combineLatest = combineLatest;
	function combineLatestInit(observables, scheduler, valueTransform) {
	    if (valueTransform === void 0) { valueTransform = identity_1.identity; }
	    return function (subscriber) {
	        maybeSchedule(scheduler, function () {
	            var length = observables.length;
	            var values = new Array(length);
	            var active = length;
	            var remainingFirstValues = length;
	            var _loop_1 = function (i) {
	                maybeSchedule(scheduler, function () {
	                    var source = from_1.from(observables[i], scheduler);
	                    var hasFirstValue = false;
	                    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                        values[i] = value;
	                        if (!hasFirstValue) {
	                            hasFirstValue = true;
	                            remainingFirstValues--;
	                        }
	                        if (!remainingFirstValues) {
	                            subscriber.next(valueTransform(values.slice()));
	                        }
	                    }, function () {
	                        if (!--active) {
	                            subscriber.complete();
	                        }
	                    }));
	                }, subscriber);
	            };
	            for (var i = 0; i < length; i++) {
	                _loop_1(i);
	            }
	        }, subscriber);
	    };
	}
	exports.combineLatestInit = combineLatestInit;
	function maybeSchedule(scheduler, execute, subscription) {
	    if (scheduler) {
	        executeSchedule_1.executeSchedule(subscription, scheduler, execute);
	    }
	    else {
	        execute();
	    }
	}
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.of = void 0;
	var args_1 = __webpack_require__(66);
	var from_1 = __webpack_require__(109);
	function of() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    return from_1.from(args, scheduler);
	}
	exports.of = of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zip = void 0;
	var Observable_1 = __webpack_require__(28);
	var innerFrom_1 = __webpack_require__(23);
	var argsOrArgArray_1 = __webpack_require__(134);
	var empty_1 = __webpack_require__(77);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var args_1 = __webpack_require__(66);
	function zip() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    var sources = argsOrArgArray_1.argsOrArgArray(args);
	    return sources.length
	        ? new Observable_1.Observable(function (subscriber) {
	            var buffers = sources.map(function () { return []; });
	            var completed = sources.map(function () { return false; });
	            subscriber.add(function () {
	                buffers = completed = null;
	            });
	            var _loop_1 = function (sourceIndex) {
	                innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                    buffers[sourceIndex].push(value);
	                    if (buffers.every(function (buffer) { return buffer.length; })) {
	                        var result = buffers.map(function (buffer) { return buffer.shift(); });
	                        subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray([], __read(result))) : result);
	                        if (buffers.some(function (buffer, i) { return !buffer.length && completed[i]; })) {
	                            subscriber.complete();
	                        }
	                    }
	                }, function () {
	                    completed[sourceIndex] = true;
	                    !buffers[sourceIndex].length && subscriber.complete();
	                }));
	            };
	            for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
	                _loop_1(sourceIndex);
	            }
	            return function () {
	                buffers = completed = null;
	            };
	        })
	        : empty_1.EMPTY;
	}
	exports.zip = zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.audit = void 0;
	var lift_1 = __webpack_require__(9);
	var innerFrom_1 = __webpack_require__(23);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function audit(durationSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        var durationSubscriber = null;
	        var isComplete = false;
	        var endDuration = function () {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            durationSubscriber = null;
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	            isComplete && subscriber.complete();
	        };
	        var cleanupDuration = function () {
	            durationSubscriber = null;
	            isComplete && subscriber.complete();
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            lastValue = value;
	            if (!durationSubscriber) {
	                innerFrom_1.innerFrom(durationSelector(value)).subscribe((durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, endDuration, cleanupDuration)));
	            }
	        }, function () {
	            isComplete = true;
	            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
	        }));
	    });
	}
	exports.audit = audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestAll = void 0;
	var combineLatest_1 = __webpack_require__(418);
	var joinAllInternals_1 = __webpack_require__(769);
	function combineLatestAll(project) {
	    return joinAllInternals_1.joinAllInternals(combineLatest_1.combineLatest, project);
	}
	exports.combineLatestAll = combineLatestAll;
	//# sourceMappingURL=combineLatestAll.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatMap = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var isFunction_1 = __webpack_require__(27);
	function concatMap(project, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? mergeMap_1.mergeMap(project, resultSelector, 1) : mergeMap_1.mergeMap(project, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.delayWhen = void 0;
	var concat_1 = __webpack_require__(286);
	var take_1 = __webpack_require__(199);
	var ignoreElements_1 = __webpack_require__(429);
	var mapTo_1 = __webpack_require__(430);
	var mergeMap_1 = __webpack_require__(98);
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return concat_1.concat(subscriptionDelay.pipe(take_1.take(1), ignoreElements_1.ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
	        };
	    }
	    return mergeMap_1.mergeMap(function (value, index) { return delayDurationSelector(value, index).pipe(take_1.take(1), mapTo_1.mapTo(value)); });
	}
	exports.delayWhen = delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinctUntilChanged = void 0;
	var identity_1 = __webpack_require__(47);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function distinctUntilChanged(comparator, keySelector) {
	    if (keySelector === void 0) { keySelector = identity_1.identity; }
	    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
	    return lift_1.operate(function (source, subscriber) {
	        var previousKey;
	        var first = true;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var currentKey = keySelector(value);
	            if (first || !comparator(previousKey, currentKey)) {
	                first = false;
	                previousKey = currentKey;
	                subscriber.next(value);
	            }
	        }));
	    });
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	function defaultCompare(a, b) {
	    return a === b;
	}
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaustAll = void 0;
	var exhaustMap_1 = __webpack_require__(427);
	var identity_1 = __webpack_require__(47);
	function exhaustAll() {
	    return exhaustMap_1.exhaustMap(identity_1.identity);
	}
	exports.exhaustAll = exhaustAll;
	//# sourceMappingURL=exhaustAll.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaustMap = void 0;
	var map_1 = __webpack_require__(111);
	var innerFrom_1 = __webpack_require__(23);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function exhaustMap(project, resultSelector) {
	    if (resultSelector) {
	        return function (source) {
	            return source.pipe(exhaustMap(function (a, i) { return innerFrom_1.innerFrom(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); }));
	        };
	    }
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        var innerSub = null;
	        var isComplete = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (outerValue) {
	            if (!innerSub) {
	                innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                    innerSub = null;
	                    isComplete && subscriber.complete();
	                });
	                innerFrom_1.innerFrom(project(outerValue, index++)).subscribe(innerSub);
	            }
	        }, function () {
	            isComplete = true;
	            !innerSub && subscriber.complete();
	        }));
	    });
	}
	exports.exhaustMap = exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createFind = exports.find = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function find(predicate, thisArg) {
	    return lift_1.operate(createFind(predicate, thisArg, 'value'));
	}
	exports.find = find;
	function createFind(predicate, thisArg, emit) {
	    var findIndex = emit === 'index';
	    return function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var i = index++;
	            if (predicate.call(thisArg, value, i, source)) {
	                subscriber.next(findIndex ? i : value);
	                subscriber.complete();
	            }
	        }, function () {
	            subscriber.next(findIndex ? -1 : undefined);
	            subscriber.complete();
	        }));
	    };
	}
	exports.createFind = createFind;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ignoreElements = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	function ignoreElements() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, noop_1.noop));
	    });
	}
	exports.ignoreElements = ignoreElements;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mapTo = void 0;
	var map_1 = __webpack_require__(111);
	function mapTo(value) {
	    return map_1.map(function () { return value; });
	}
	exports.mapTo = mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeInternals = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var executeSchedule_1 = __webpack_require__(113);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
	    var buffer = [];
	    var active = 0;
	    var index = 0;
	    var isComplete = false;
	    var checkComplete = function () {
	        if (isComplete && !buffer.length && !active) {
	            subscriber.complete();
	        }
	    };
	    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
	    var doInnerSub = function (value) {
	        expand && subscriber.next(value);
	        active++;
	        var innerComplete = false;
	        innerFrom_1.innerFrom(project(value, index++)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (innerValue) {
	            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
	            if (expand) {
	                outerNext(innerValue);
	            }
	            else {
	                subscriber.next(innerValue);
	            }
	        }, function () {
	            innerComplete = true;
	        }, undefined, function () {
	            if (innerComplete) {
	                try {
	                    active--;
	                    var _loop_1 = function () {
	                        var bufferedValue = buffer.shift();
	                        if (innerSubScheduler) {
	                            executeSchedule_1.executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
	                        }
	                        else {
	                            doInnerSub(bufferedValue);
	                        }
	                    };
	                    while (buffer.length && active < concurrent) {
	                        _loop_1();
	                    }
	                    checkComplete();
	                }
	                catch (err) {
	                    subscriber.error(err);
	                }
	            }
	        }));
	    };
	    source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, outerNext, function () {
	        isComplete = true;
	        checkComplete();
	    }));
	    return function () {
	        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
	    };
	}
	exports.mergeInternals = mergeInternals;
	//# sourceMappingURL=mergeInternals.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.raceWith = void 0;
	var race_1 = __webpack_require__(736);
	var lift_1 = __webpack_require__(9);
	var identity_1 = __webpack_require__(47);
	function raceWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return !otherSources.length
	        ? identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            race_1.raceInit(__spreadArray([source], __read(otherSources)))(subscriber);
	        });
	}
	exports.raceWith = raceWith;
	//# sourceMappingURL=raceWith.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.refCount = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function refCount() {
	    return lift_1.operate(function (source, subscriber) {
	        var connection = null;
	        source._refCount++;
	        var refCounter = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
	            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
	                connection = null;
	                return;
	            }
	            var sharedConnection = source._connection;
	            var conn = connection;
	            connection = null;
	            if (sharedConnection && (!conn || sharedConnection === conn)) {
	                sharedConnection.unsubscribe();
	            }
	            subscriber.unsubscribe();
	        });
	        source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            connection = source.connect();
	        }
	    });
	}
	exports.refCount = refCount;
	//# sourceMappingURL=refCount.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sample = void 0;
	var lift_1 = __webpack_require__(9);
	var noop_1 = __webpack_require__(48);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function sample(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            lastValue = value;
	        }));
	        notifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        }, noop_1.noop));
	    });
	}
	exports.sample = sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.share = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var Subject_1 = __webpack_require__(46);
	var Subscriber_1 = __webpack_require__(192);
	var lift_1 = __webpack_require__(9);
	function share(options) {
	    if (options === void 0) { options = {}; }
	    var _a = options.connector, connector = _a === void 0 ? function () { return new Subject_1.Subject(); } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
	    return function (wrapperSource) {
	        var connection;
	        var resetConnection;
	        var subject;
	        var refCount = 0;
	        var hasCompleted = false;
	        var hasErrored = false;
	        var cancelReset = function () {
	            resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
	            resetConnection = undefined;
	        };
	        var reset = function () {
	            cancelReset();
	            connection = subject = undefined;
	            hasCompleted = hasErrored = false;
	        };
	        var resetAndUnsubscribe = function () {
	            var conn = connection;
	            reset();
	            conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
	        };
	        return lift_1.operate(function (source, subscriber) {
	            refCount++;
	            if (!hasErrored && !hasCompleted) {
	                cancelReset();
	            }
	            var dest = (subject = subject !== null && subject !== void 0 ? subject : connector());
	            subscriber.add(function () {
	                refCount--;
	                if (refCount === 0 && !hasErrored && !hasCompleted) {
	                    resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
	                }
	            });
	            dest.subscribe(subscriber);
	            if (!connection &&
	                refCount > 0) {
	                connection = new Subscriber_1.SafeSubscriber({
	                    next: function (value) { return dest.next(value); },
	                    error: function (err) {
	                        hasErrored = true;
	                        cancelReset();
	                        resetConnection = handleReset(reset, resetOnError, err);
	                        dest.error(err);
	                    },
	                    complete: function () {
	                        hasCompleted = true;
	                        cancelReset();
	                        resetConnection = handleReset(reset, resetOnComplete);
	                        dest.complete();
	                    },
	                });
	                innerFrom_1.innerFrom(source).subscribe(connection);
	            }
	        })(wrapperSource);
	    };
	}
	exports.share = share;
	function handleReset(reset, on) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (on === true) {
	        reset();
	        return;
	    }
	    if (on === false) {
	        return;
	    }
	    var onSubscriber = new Subscriber_1.SafeSubscriber({
	        next: function () {
	            onSubscriber.unsubscribe();
	            reset();
	        },
	    });
	    return on.apply(void 0, __spreadArray([], __read(args))).subscribe(onSubscriber);
	}
	//# sourceMappingURL=share.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeLast = void 0;
	var empty_1 = __webpack_require__(77);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function takeLast(count) {
	    return count <= 0
	        ? function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var buffer = [];
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                buffer.push(value);
	                count < buffer.length && buffer.shift();
	            }, function () {
	                var e_1, _a;
	                try {
	                    for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
	                        var value = buffer_1_1.value;
	                        subscriber.next(value);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                subscriber.complete();
	            }, undefined, function () {
	                buffer = null;
	            }));
	        });
	}
	exports.takeLast = takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttle = exports.defaultThrottleConfig = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false,
	};
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return lift_1.operate(function (source, subscriber) {
	        var leading = config.leading, trailing = config.trailing;
	        var hasValue = false;
	        var sendValue = null;
	        var throttled = null;
	        var isComplete = false;
	        var endThrottling = function () {
	            throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
	            throttled = null;
	            if (trailing) {
	                send();
	                isComplete && subscriber.complete();
	            }
	        };
	        var cleanupThrottling = function () {
	            throttled = null;
	            isComplete && subscriber.complete();
	        };
	        var startThrottle = function (value) {
	            return (throttled = innerFrom_1.innerFrom(durationSelector(value)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling)));
	        };
	        var send = function () {
	            if (hasValue) {
	                hasValue = false;
	                var value = sendValue;
	                sendValue = null;
	                subscriber.next(value);
	                !isComplete && startThrottle(value);
	            }
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            hasValue = true;
	            sendValue = value;
	            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
	        }, function () {
	            isComplete = true;
	            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
	        }));
	    });
	}
	exports.throttle = throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.toArray = void 0;
	var reduce_1 = __webpack_require__(154);
	var lift_1 = __webpack_require__(9);
	var arrReducer = function (arr, value) { return (arr.push(value), arr); };
	function toArray() {
	    return lift_1.operate(function (source, subscriber) {
	        reduce_1.reduce(arrReducer, [])(source).subscribe(subscriber);
	    });
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.dateTimestampProvider = void 0;
	exports.dateTimestampProvider = {
	    now: function () {
	        return (exports.dateTimestampProvider.delegate || Date).now();
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=dateTimestampProvider.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.captureError = exports.errorContext = void 0;
	var config_1 = __webpack_require__(193);
	var context = null;
	function errorContext(cb) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	        var isRoot = !context;
	        if (isRoot) {
	            context = { errorThrown: false, error: null };
	        }
	        cb();
	        if (isRoot) {
	            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
	            context = null;
	            if (errorThrown) {
	                throw error;
	            }
	        }
	    }
	    else {
	        cb();
	    }
	}
	exports.errorContext = errorContext;
	function captureError(err) {
	    if (config_1.config.useDeprecatedSynchronousErrorHandling && context) {
	        context.errorThrown = true;
	        context.error = err;
	    }
	}
	exports.captureError = captureError;
	//# sourceMappingURL=errorContext.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isArrayLike = void 0;
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isValidDate = void 0;
	function isValidDate(value) {
	    return value instanceof Date && !isNaN(value);
	}
	exports.isValidDate = isValidDate;
	//# sourceMappingURL=isDate.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
	var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var g = generator.apply(thisArg, _arguments || []), i, q = [];
	    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	    function fulfill(value) { resume("next", value); }
	    function reject(value) { resume("throw", value); }
	    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isReadableStreamLike = exports.readableStreamLikeToAsyncGenerator = void 0;
	var isFunction_1 = __webpack_require__(27);
	function readableStreamLikeToAsyncGenerator(readableStream) {
	    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
	        var reader, _a, value, done;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    reader = readableStream.getReader();
	                    _b.label = 1;
	                case 1:
	                    _b.trys.push([1, , 9, 10]);
	                    _b.label = 2;
	                case 2:
	                    if (false) return [3, 8];
	                    return [4, __await(reader.read())];
	                case 3:
	                    _a = _b.sent(), value = _a.value, done = _a.done;
	                    if (!done) return [3, 5];
	                    return [4, __await(void 0)];
	                case 4: return [2, _b.sent()];
	                case 5: return [4, __await(value)];
	                case 6: return [4, _b.sent()];
	                case 7:
	                    _b.sent();
	                    return [3, 2];
	                case 8: return [3, 10];
	                case 9:
	                    reader.releaseLock();
	                    return [7];
	                case 10: return [2];
	            }
	        });
	    });
	}
	exports.readableStreamLikeToAsyncGenerator = readableStreamLikeToAsyncGenerator;
	function isReadableStreamLike(obj) {
	    return isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
	}
	exports.isReadableStreamLike = isReadableStreamLike;
	//# sourceMappingURL=isReadableStreamLike.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var queue_1 = __webpack_require__(860);
	var Subscription_1 = __webpack_require__(45);
	var observeOn_1 = __webpack_require__(855);
	var ObjectUnsubscribedError_1 = __webpack_require__(303);
	var SubjectSubscription_1 = __webpack_require__(843);
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	        var _this = _super.call(this) || this;
	        _this.scheduler = scheduler;
	        _this._events = [];
	        _this._infiniteTimeWindow = false;
	        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        _this._windowTime = windowTime < 1 ? 1 : windowTime;
	        if (windowTime === Number.POSITIVE_INFINITY) {
	            _this._infiniteTimeWindow = true;
	            _this.next = _this.nextInfiniteTimeWindow;
	        }
	        else {
	            _this.next = _this.nextTimeWindow;
	        }
	        return _this;
	    }
	    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
	        if (!this.isStopped) {
	            var _events = this._events;
	            _events.push(value);
	            if (_events.length > this._bufferSize) {
	                _events.shift();
	            }
	        }
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype.nextTimeWindow = function (value) {
	        if (!this.isStopped) {
	            this._events.push(new ReplayEvent(this._getNow(), value));
	            this._trimBufferThenGetEvents();
	        }
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _infiniteTimeWindow = this._infiniteTimeWindow;
	        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        var len = _events.length;
	        var subscription;
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.isStopped || this.hasError) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	        if (scheduler) {
	            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
	        }
	        if (_infiniteTimeWindow) {
	            for (var i = 0; i < len && !subscriber.closed; i++) {
	                subscriber.next(_events[i]);
	            }
	        }
	        else {
	            for (var i = 0; i < len && !subscriber.closed; i++) {
	                subscriber.next(_events[i].value);
	            }
	        }
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	        }
	        return subscription;
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue_1.queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	var ReplayEvent = (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());
	//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var isScheduler_1 = __webpack_require__(90);
	var isArray_1 = __webpack_require__(59);
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	var fromArray_1 = __webpack_require__(203);
	var NONE = {};
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var resultSelector = undefined;
	    var scheduler = undefined;
	    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        resultSelector = observables.pop();
	    }
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return fromArray_1.fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
	}
	exports.combineLatest = combineLatest;
	var CombineLatestOperator = (function () {
	    function CombineLatestOperator(resultSelector) {
	        this.resultSelector = resultSelector;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
	    };
	    return CombineLatestOperator;
	}());
	exports.CombineLatestOperator = CombineLatestOperator;
	var CombineLatestSubscriber = (function (_super) {
	    __extends(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, resultSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.resultSelector = resultSelector;
	        _this.active = 0;
	        _this.values = [];
	        _this.observables = [];
	        return _this;
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(NONE);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult_1.subscribeToResult(this, observable, undefined, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === NONE ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.resultSelector) {
	                this._tryResultSelector(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
	        var result;
	        try {
	            result = this.resultSelector.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.CombineLatestSubscriber = CombineLatestSubscriber;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var from_1 = __webpack_require__(89);
	var empty_1 = __webpack_require__(88);
	function defer(observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        var input;
	        try {
	            input = observableFactory();
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var source = input ? from_1.from(input) : empty_1.empty();
	        return source.subscribe(subscriber);
	    });
	}
	exports.defer = defer;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	function throwError(error, scheduler) {
	    if (!scheduler) {
	        return new Observable_1.Observable(function (subscriber) { return subscriber.error(error); });
	    }
	    else {
	        return new Observable_1.Observable(function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
	    }
	}
	exports.throwError = throwError;
	function dispatch(_a) {
	    var error = _a.error, subscriber = _a.subscriber;
	    subscriber.error(error);
	}
	//# sourceMappingURL=throwError.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var fromArray_1 = __webpack_require__(203);
	var isArray_1 = __webpack_require__(59);
	var Subscriber_1 = __webpack_require__(14);
	var iterator_1 = __webpack_require__(207);
	var innerSubscribe_1 = __webpack_require__(31);
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var resultSelector = observables[observables.length - 1];
	    if (typeof resultSelector === 'function') {
	        observables.pop();
	    }
	    return fromArray_1.fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
	}
	exports.zip = zip;
	var ZipOperator = (function () {
	    function ZipOperator(resultSelector) {
	        this.resultSelector = resultSelector;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
	    };
	    return ZipOperator;
	}());
	exports.ZipOperator = ZipOperator;
	var ZipSubscriber = (function (_super) {
	    __extends(ZipSubscriber, _super);
	    function ZipSubscriber(destination, resultSelector, values) {
	        if (values === void 0) { values = Object.create(null); }
	        var _this = _super.call(this, destination) || this;
	        _this.resultSelector = resultSelector;
	        _this.iterators = [];
	        _this.active = 0;
	        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
	        return _this;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        if (isArray_1.isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator_1.iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        this.unsubscribe();
	        if (len === 0) {
	            this.destination.complete();
	            return;
	        }
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                var destination = this.destination;
	                destination.add(iterator.subscribe());
	            }
	            else {
	                this.active--;
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.resultSelector) {
	            this._tryresultSelector(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryresultSelector = function (args) {
	        var result;
	        try {
	            result = this.resultSelector.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ZipSubscriber = ZipSubscriber;
	var StaticIterator = (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return Boolean(nextResult && nextResult.done);
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	var ZipBufferIterator = (function (_super) {
	    __extends(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable) {
	        var _this = _super.call(this, destination) || this;
	        _this.parent = parent;
	        _this.observable = observable;
	        _this.stillUnsubscribed = true;
	        _this.buffer = [];
	        _this.isComplete = false;
	        return _this;
	    }
	    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function () {
	        return innerSubscribe_1.innerSubscribe(this.observable, new innerSubscribe_1.SimpleInnerSubscriber(this));
	    };
	    return ZipBufferIterator;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeMap_1 = __webpack_require__(300);
	var identity_1 = __webpack_require__(139);
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(identity_1.identity, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function refCount() {
	    return function refCountOperatorFunction(source) {
	        return source.lift(new RefCountOperator(source));
	    };
	}
	exports.refCount = refCount;
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        var _this = _super.call(this, destination) || this;
	        _this.connectable = connectable;
	        return _this;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=refCount.js.map

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function scan(accumulator, seed) {
	    var hasSeed = false;
	    if (arguments.length >= 2) {
	        hasSeed = true;
	    }
	    return function scanOperatorFunction(source) {
	        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
	    };
	}
	exports.scan = scan;
	var ScanOperator = (function () {
	    function ScanOperator(accumulator, seed, hasSeed) {
	        if (hasSeed === void 0) { hasSeed = false; }
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.hasSeed = hasSeed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
	    };
	    return ScanOperator;
	}());
	var ScanSubscriber = (function (_super) {
	    __extends(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
	        var _this = _super.call(this, destination) || this;
	        _this.accumulator = accumulator;
	        _this._seed = _seed;
	        _this.hasSeed = hasSeed;
	        _this.index = 0;
	        return _this;
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.hasSeed = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.hasSeed) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var map_1 = __webpack_require__(72);
	var from_1 = __webpack_require__(89);
	var innerSubscribe_1 = __webpack_require__(31);
	function switchMap(project, resultSelector) {
	    if (typeof resultSelector === 'function') {
	        return function (source) { return source.pipe(switchMap(function (a, i) { return from_1.from(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
	    }
	    return function (source) { return source.lift(new SwitchMapOperator(project)); };
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project) {
	        this.project = project;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
	    };
	    return SwitchMapOperator;
	}());
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.index = 0;
	        return _this;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        this.innerSubscription = innerSubscribe_1.innerSubscribe(result, innerSubscriber);
	        if (this.innerSubscription !== innerSubscriber) {
	            destination.add(this.innerSubscription);
	        }
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	        this.unsubscribe();
	    };
	    SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = undefined;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function () {
	        this.innerSubscription = undefined;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    return SwitchMapSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var ArgumentOutOfRangeError_1 = __webpack_require__(208);
	var empty_1 = __webpack_require__(88);
	function take(count) {
	    return function (source) {
	        if (count === 0) {
	            return empty_1.empty();
	        }
	        else {
	            return source.lift(new TakeOperator(count));
	        }
	    };
	}
	exports.take = take;
	var TakeOperator = (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	var TakeSubscriber = (function (_super) {
	    __extends(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.count = 0;
	        return _this;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        var count = ++this.count;
	        if (count <= total) {
	            this.destination.next(value);
	            if (count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=take.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var ArgumentOutOfRangeError_1 = __webpack_require__(208);
	var empty_1 = __webpack_require__(88);
	function takeLast(count) {
	    return function takeLastOperatorFunction(source) {
	        if (count === 0) {
	            return empty_1.empty();
	        }
	        else {
	            return source.lift(new TakeLastOperator(count));
	        }
	    };
	}
	exports.takeLast = takeLast;
	var TakeLastOperator = (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	var TakeLastSubscriber = (function (_super) {
	    __extends(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.ring = new Array();
	        _this.count = 0;
	        return _this;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscription_1 = __webpack_require__(45);
	function scheduleArray(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var sub = new Subscription_1.Subscription();
	        var i = 0;
	        sub.add(scheduler.schedule(function () {
	            if (i === input.length) {
	                subscriber.complete();
	                return;
	            }
	            subscriber.next(input[i++]);
	            if (!subscriber.closed) {
	                sub.add(this.schedule());
	            }
	        }));
	        return sub;
	    });
	}
	exports.scheduleArray = scheduleArray;
	//# sourceMappingURL=scheduleArray.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.rxSubscriber = (function () {
	    return typeof Symbol === 'function'
	        ? Symbol('rxSubscriber')
	        : '@@rxSubscriber_' + Math.random();
	})();
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function canReportError(observer) {
	    while (observer) {
	        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
	        if (closed_1 || isStopped) {
	            return false;
	        }
	        else if (destination && destination instanceof Subscriber_1.Subscriber) {
	            observer = destination;
	        }
	        else {
	            observer = null;
	        }
	    }
	    return true;
	}
	exports.canReportError = canReportError;
	//# sourceMappingURL=canReportError.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function hostReportError(err) {
	    setTimeout(function () { throw err; }, 0);
	}
	exports.hostReportError = hostReportError;
	//# sourceMappingURL=hostReportError.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isObject(x) {
	    return x !== null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var identity_1 = __webpack_require__(139);
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	function pipeFromArray(fns) {
	    if (fns.length === 0) {
	        return identity_1.identity;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? prefix + ": " + provided : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = Point;
	
	/**
	 * A standalone point geometry with useful accessor, comparison, and
	 * modification methods.
	 *
	 * @class Point
	 * @param {Number} x the x-coordinate. this could be longitude or screen
	 * pixels, or any other sort of unit.
	 * @param {Number} y the y-coordinate. this could be latitude or screen
	 * pixels, or any other sort of unit.
	 * @example
	 * var point = new Point(-77, 38);
	 */
	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point.prototype = {
	
	    /**
	     * Clone this point, returning a new point that can be modified
	     * without affecting the old one.
	     * @return {Point} the clone
	     */
	    clone: function() { return new Point(this.x, this.y); },
	
	    /**
	     * Add this point's x & y coordinates to another point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    add:     function(p) { return this.clone()._add(p); },
	
	    /**
	     * Subtract this point's x & y coordinates to from point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    sub:     function(p) { return this.clone()._sub(p); },
	
	    /**
	     * Multiply this point's x & y coordinates by point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    multByPoint:    function(p) { return this.clone()._multByPoint(p); },
	
	    /**
	     * Divide this point's x & y coordinates by point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    divByPoint:     function(p) { return this.clone()._divByPoint(p); },
	
	    /**
	     * Multiply this point's x & y coordinates by a factor,
	     * yielding a new point.
	     * @param {Point} k factor
	     * @return {Point} output point
	     */
	    mult:    function(k) { return this.clone()._mult(k); },
	
	    /**
	     * Divide this point's x & y coordinates by a factor,
	     * yielding a new point.
	     * @param {Point} k factor
	     * @return {Point} output point
	     */
	    div:     function(k) { return this.clone()._div(k); },
	
	    /**
	     * Rotate this point around the 0, 0 origin by an angle a,
	     * given in radians
	     * @param {Number} a angle to rotate around, in radians
	     * @return {Point} output point
	     */
	    rotate:  function(a) { return this.clone()._rotate(a); },
	
	    /**
	     * Rotate this point around p point by an angle a,
	     * given in radians
	     * @param {Number} a angle to rotate around, in radians
	     * @param {Point} p Point to rotate around
	     * @return {Point} output point
	     */
	    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },
	
	    /**
	     * Multiply this point by a 4x1 transformation matrix
	     * @param {Array<Number>} m transformation matrix
	     * @return {Point} output point
	     */
	    matMult: function(m) { return this.clone()._matMult(m); },
	
	    /**
	     * Calculate this point but as a unit vector from 0, 0, meaning
	     * that the distance from the resulting point to the 0, 0
	     * coordinate will be equal to 1 and the angle from the resulting
	     * point to the 0, 0 coordinate will be the same as before.
	     * @return {Point} unit vector point
	     */
	    unit:    function() { return this.clone()._unit(); },
	
	    /**
	     * Compute a perpendicular point, where the new y coordinate
	     * is the old x coordinate and the new x coordinate is the old y
	     * coordinate multiplied by -1
	     * @return {Point} perpendicular point
	     */
	    perp:    function() { return this.clone()._perp(); },
	
	    /**
	     * Return a version of this point with the x & y coordinates
	     * rounded to integers.
	     * @return {Point} rounded point
	     */
	    round:   function() { return this.clone()._round(); },
	
	    /**
	     * Return the magitude of this point: this is the Euclidean
	     * distance from the 0, 0 coordinate to this point's x and y
	     * coordinates.
	     * @return {Number} magnitude
	     */
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    /**
	     * Judge whether this point is equal to another point, returning
	     * true or false.
	     * @param {Point} other the other point
	     * @return {boolean} whether the points are equal
	     */
	    equals: function(other) {
	        return this.x === other.x &&
	               this.y === other.y;
	    },
	
	    /**
	     * Calculate the distance from this point to another point
	     * @param {Point} p the other point
	     * @return {Number} distance
	     */
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    /**
	     * Calculate the distance from this point to another point,
	     * without the square root step. Useful if you're comparing
	     * relative distances.
	     * @param {Point} p the other point
	     * @return {Number} distance
	     */
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    /**
	     * Get the angle from the 0, 0 coordinate to this point, in radians
	     * coordinates.
	     * @return {Number} angle
	     */
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    /**
	     * Get the angle from this point to another point, in radians
	     * @param {Point} b the other point
	     * @return {Number} angle
	     */
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    /**
	     * Get the angle between this point and another point, in radians
	     * @param {Point} b the other point
	     * @return {Number} angle
	     */
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    /*
	     * Find the angle of the two vectors, solving the formula for
	     * the cross product a x b = |a||b|sin(θ) for θ.
	     * @param {Number} x the x-coordinate
	     * @param {Number} y the y-coordinate
	     * @return {Number} the angle in radians
	     */
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _multByPoint: function(p) {
	        this.x *= p.x;
	        this.y *= p.y;
	        return this;
	    },
	
	    _divByPoint: function(p) {
	        this.x /= p.x;
	        this.y /= p.y;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _rotateAround: function(angle, p) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
	            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	/**
	 * Construct a point from an array if necessary, otherwise if the input
	 * is already a Point, or an unknown type, return it unchanged
	 * @param {Array<Number>|Point|*} a any kind of input value
	 * @return {Point} constructed point, or passed-through value.
	 * @example
	 * // this
	 * var point = Point.convert([0, 1]);
	 * // is equivalent to
	 * var point = new Point(0, 1);
	 */
	Point.convert = function (a) {
	    if (a instanceof Point) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point(a[0], a[1]);
	    }
	    return a;
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	var settle = __webpack_require__(886);
	var buildURL = __webpack_require__(890);
	var parseHeaders = __webpack_require__(896);
	var isURLSameOrigin = __webpack_require__(894);
	var createError = __webpack_require__(465);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(889);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      if (request.status === 0) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(892);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(885);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChessGalleryPopupWithRouter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _normalizeWheel = __webpack_require__(593);
	
	var _normalizeWheel2 = _interopRequireDefault(_normalizeWheel);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactModal = __webpack_require__(184);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _polylabel = __webpack_require__(879);
	
	var _polylabel2 = _interopRequireDefault(_polylabel);
	
	var _reselect = __webpack_require__(44);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _apartments = __webpack_require__(219);
	
	var _apartments2 = _interopRequireDefault(_apartments);
	
	var _SpinnerImage = __webpack_require__(218);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	var _Filters = __webpack_require__(308);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _About = __webpack_require__(213);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Gallery = __webpack_require__(1336);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _iconZoom = __webpack_require__(343);
	
	var _iconZoom2 = _interopRequireDefault(_iconZoom);
	
	var _noFloor = __webpack_require__(238);
	
	var _noFloor2 = _interopRequireDefault(_noFloor);
	
	var _iconLock = __webpack_require__(235);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _logoBlack = __webpack_require__(349);
	
	var _logoBlack2 = _interopRequireDefault(_logoBlack);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _helper = __webpack_require__(93);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getFloorName = function getFloorName(name) {
	  switch (name) {
	    case 'M':
	    case 'М':
	      return _i18n2.default.t('components.building.rightMenu.attic');
	    case 'Мансарда':
	    case 'Парковка':
	    case 'Цоколь':
	    case 'Терраса':
	      return name;
	    default:
	      return name + ' ' + _i18n2.default.t('components.building.rightMenu.floor');
	  }
	};
	
	var MIN_SCALE = 1;
	var MAX_SCALE = 5;
	var WHEEL_FACTOR = 1.05;
	var CLICK_FACTOR = 1.5;
	
	var ChessGalleryPopup = function (_Component) {
	  _inherits(ChessGalleryPopup, _Component);
	
	  function ChessGalleryPopup(props) {
	    _classCallCheck(this, ChessGalleryPopup);
	
	    var _this = _possibleConstructorReturn(this, (ChessGalleryPopup.__proto__ || Object.getPrototypeOf(ChessGalleryPopup)).call(this, props));
	
	    _this.isNegative = function (n) {
	      return ((n = +n) || 1 / n) < 0;
	    };
	
	    _this.handleMouseWheel = function (e) {
	      e.preventDefault();
	      var normalized = (0, _normalizeWheel2.default)(e);
	      _this.zoom(_this.isNegative(normalized.pixelY), WHEEL_FACTOR);
	    };
	
	    _this.zoom = function (zoomIn, zoomFactor) {
	      var newScale = _this.state.scale * (zoomIn ? zoomFactor : 1 / zoomFactor);
	
	      _this.setState({
	        scale: Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale))
	      });
	    };
	
	    _this.zoomIn = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingChessFloorDialogButtonsClick',
	        eventLabel: 'uvelichit'
	      });
	
	      _this.zoom(true, CLICK_FACTOR);
	    };
	
	    _this.zoomOut = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingChessFloorDialogButtonsClick',
	        eventLabel: 'umenshit'
	      });
	
	      _this.zoom(false, CLICK_FACTOR);
	    };
	
	    _this.handleZoomChange = function (e) {
	      _this.setState({
	        scale: e.target.value
	      });
	    };
	
	    _this.handleZoomMouseDown = function (e) {
	      e.stopPropagation();
	    };
	
	    _this.getZoomPercent = function () {
	      return (_this.state.scale - MIN_SCALE) / (MAX_SCALE - MIN_SCALE);
	    };
	
	    _this.adjustFloorScroll = function (e) {
	      _this.setState({
	        showFloorScroll: _this.floors.clientHeight < _this.floors.scrollHeight
	      });
	    };
	
	    _this.handleTouchStart = function (e) {
	      _this.handleMouseDown(e.touches[0]);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.setState({ dragging: true });
	      // Set coords
	      _this.coords = {
	        x: e.pageX,
	        y: e.pageY
	      };
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ dragging: false });
	      _this.coords = {};
	    };
	
	    _this.handleTouchMove = function (e) {
	      _this.handleMove(e.touches[0]);
	    };
	
	    _this.handleMouseMove = function (e) {
	      if (!_this.state.dragging) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleMove(e);
	    };
	
	    _this.handleMove = function (e) {
	      var xDiff = _this.coords.x - e.pageX;
	      var yDiff = _this.coords.y - e.pageY;
	      // Update to our new coordinates
	      _this.coords.x = e.pageX;
	      _this.coords.y = e.pageY;
	
	      _this.setState({
	        x: _this.state.x - xDiff,
	        y: _this.state.y - yDiff
	      });
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building,
	          isTable = _this$props.isTable;
	
	      var eventContext = isTable ? 'shahmatka' : 'spisok';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.handleFloorClick = function (row) {
	      _this.handleTrackEvent({
	        eventName: 'buildingChessLotAboutButtonsClick',
	        eventLabel: 'etazh'
	      });
	
	      _this.setState({
	        row: row
	      });
	    };
	
	    _this.handleNextFloorClick = function (row) {
	      _this.floors.scrollTop += _this.floors.clientHeight;
	    };
	
	    _this.handlePrevFloorClick = function (row) {
	      _this.floors.scrollTop -= _this.floors.clientHeight;
	    };
	
	    _this.renderRow = function (_ref2, i) {
	      var _cn;
	
	      var name = _ref2.name;
	
	      var disabled = _this.props.sectionCells[i].cells.filter(function (cell) {
	        return cell && !cell.hidden && cell.pointers && cell.mark !== false;
	      }).length === 0;
	      return _react2.default.createElement(
	        'div',
	        {
	          key: i,
	          className: (0, _classnames2.default)(_Gallery2.default.FloorItem, (_cn = {}, _defineProperty(_cn, _Gallery2.default.Active, i === _this.state.row), _defineProperty(_cn, _Gallery2.default.Light, disabled), _cn)),
	          onClick: _this.handleFloorClick.bind(_this, i)
	        },
	        ' ',
	        name,
	        ' '
	      );
	    };
	
	    _this.getFloorsRef = function (ref) {
	      _this.floors = ref;
	      if (_this.floors) {
	        _this.adjustFloorScroll();
	      }
	    };
	
	    _this.state = {
	      hoverCellId: null,
	      dragging: false,
	      scale: 1,
	      x: 0,
	      y: 0,
	      row: props.row,
	      showFloorScroll: false
	    };
	    return _this;
	  }
	
	  _createClass(ChessGalleryPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousemove', this.handleMouseMove, false);
	      document.addEventListener('mouseup', this.handleMouseUp, false);
	      document.addEventListener('touchmove', this.handleTouchMove, false);
	      document.addEventListener('touchend', this.handleMouseUp, false);
	      window.addEventListener('resize', this.adjustFloorScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.handleMouseMove, false);
	      document.removeEventListener('mouseup', this.handleMouseUp, false);
	      document.removeEventListener('touchmove', this.handleTouchMove, false);
	      document.removeEventListener('touchend', this.handleMouseUp, false);
	      window.removeEventListener('resize', this.adjustFloorScroll);
	    }
	  }, {
	    key: 'renderVectorOverlay',
	    value: function renderVectorOverlay() {
	      var _this2 = this;
	
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$all = _ref3.all,
	          all = _ref3$all === undefined ? false : _ref3$all;
	
	      var rowData = arguments[1];
	      var _props = this.props,
	          t = _props.t,
	          sectionCells = _props.sectionCells,
	          selected = _props.data,
	          currency = _props.currency;
	
	      var data = rowData;
	      if (data.pointers) {
	        var _data$pointers$split = data.pointers.split(':'),
	            _data$pointers$split2 = _slicedToArray(_data$pointers$split, 2),
	            width = _data$pointers$split2[0],
	            height = _data$pointers$split2[1];
	
	        return _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Plan },
	          _react2.default.createElement(
	            'div',
	            { className: 'lol' },
	            _react2.default.createElement(
	              'svg',
	              {
	                xmlns: 'http://www.w3.org/2000/svg',
	                height: height,
	                width: width,
	                viewBox: '0 0 ' + width + ' ' + height
	              },
	              _react2.default.createElement(
	                'g',
	                null,
	                (all ? sectionCells[this.state.row].cells : [data]).filter(function (cell) {
	                  return cell && !cell.hidden && cell.pointers;
	                }).map(function (cell) {
	                  var _cn2;
	
	                  var coordinates = cell.pointers.split(':')[2];
	                  var cs = coordinates.split(',');
	                  var path = cs.reduce(function (path, c, i) {
	                    return path.concat(i % 2 === 1 ? c + ' L ' : c + ' ');
	                  }, 'M ').replace(/L $/, 'Z');
	                  return [_react2.default.createElement('path', {
	                    className: (0, _classnames2.default)(_Gallery2.default.Flat, (_cn2 = {}, _defineProperty(_cn2, _Gallery2.default.SelectedFlat, cell.id === selected.id), _defineProperty(_cn2, _Gallery2.default.FilteredFlat, cell.mark === false), _cn2)),
	                    d: path,
	                    key: cell.id,
	                    onMouseEnter: function onMouseEnter() {
	                      _this2.setState({ hoverCellId: cell.id });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                      if (_this2.state.hoverCellId === cell.id) {
	                        _this2.setState({ hoverCellId: null });
	                      }
	                    },
	                    onClick: _this2.props.handleCellClick.bind(_this2, cell.id, [cell.row, cell.col])
	                  })];
	                })
	              )
	            ),
	            all && sectionCells[this.state.row].cells.filter(function (cell) {
	              return cell && !cell.hidden && cell.pointers;
	            }).map(function (cell) {
	              var _cn3;
	
	              var coordinates = cell.pointers.split(':')[2];
	              var cs = coordinates.split(',');
	
	              var geo = cs.reduce(function (geo, val, i) {
	                if (i % 2 === 0) {
	                  return [].concat(_toConsumableArray(geo), [[~~cs[i], ~~cs[i + 1]]]);
	                }
	                return geo;
	              }, []).concat([[~~cs[0], ~~cs[1]]]);
	
	              var center = (0, _polylabel2.default)([geo], 20.0);
	
	              return _react2.default.createElement(
	                'div',
	                {
	                  key: cell.id,
	                  className: (0, _classnames2.default)(_Gallery2.default.FlatPopup, (_cn3 = {}, _defineProperty(_cn3, _Gallery2.default.FlatHover, cell.id === _this2.state.hoverCellId), _defineProperty(_cn3, _Gallery2.default.Reservation, (0, _helper.isReserved)(cell.data.status)), _defineProperty(_cn3, _Gallery2.default.Locked, cell.data.status === 'fundStatus'), _defineProperty(_cn3, _Gallery2.default.Promo, cell.data.view_action === '1'), _cn3)),
	                  style: {
	                    left: center[0] * 100 / width + '%',
	                    top: center[1] * 100 / height + '%',
	                    transform: 'scale(' + 1 / _this2.state.scale + ')'
	                  }
	                },
	                cell.data.status === 'fundStatus' ? _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.FlatPopupInner },
	                  _react2.default.createElement('img', { src: _iconLock2.default, alt: '', className: _Gallery2.default.iconFund })
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.FlatPopupInner },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.FlatNumber },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      '\u2116',
	                      cell.data.number
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.FlatArea },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.rightMenu.area', { area: cell.data.area })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.FlatCost },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      cell.data.costFormatted,
	                      ' ',
	                      currency
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.FlatType },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _apartments2.default[cell.data.cnt_apart]
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.FlatAreaAndPrice },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.rightMenu.area', { area: cell.data.area }),
	                      ', ',
	                      cell.data.priceFormatted,
	                      ' ',
	                      t('components.building.rightMenu.priceForM2', { currency: currency })
	                    )
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          building = _props2.building,
	          room = _props2.data,
	          rows = _props2.rows,
	          client = _props2.client,
	          sectionId = _props2.sectionId,
	          filters = _props2.filters,
	          pavilionsFlat = _props2.pavilionsFlat,
	          handleFilters = _props2.handleFilters,
	          sectionCells = _props2.sectionCells,
	          cells = _props2.cells,
	          isClientView = _props2.isClientView,
	          t = _props2.t,
	          profile = _props2.profile,
	          objectType = _props2.objectType,
	          isTable = _props2.isTable;
	
	      var rowCells = sectionCells[this.state.row].cells.filter(function (cell) {
	        return cell && cell.pointers;
	      });
	
	      var _split = (rowCells[0] && rowCells[0].pointers || '0:0').split(':'),
	          _split2 = _slicedToArray(_split, 2),
	          width = _split2[0],
	          height = _split2[1];
	
	      var _state = this.state,
	          scale = _state.scale,
	          x = _state.x,
	          y = _state.y;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Gallery2.default.PopUpOuter },
	        _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.PopUpInner },
	          _react2.default.createElement(
	            'div',
	            { className: _Gallery2.default.FloorPlanWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanTop },
	              !isClientView && _react2.default.createElement(_Filters2.default, {
	                pavilions: building.pavilions,
	                pavilionsFlat: pavilionsFlat,
	                filters: filters,
	                handleFilters: handleFilters,
	                search: filters,
	                chessfilter: 'true',
	                cells: cells,
	                profile: profile,
	                buildingData: building,
	                objectType: objectType,
	                isTable: isTable
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.Close, onClick: this.props.onClose },
	                _react2.default.createElement('img', { src: _cross2.default, alt: 'close' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanLeft },
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.SelectFloor },
	                this.state.showFloorScroll && _react2.default.createElement('div', {
	                  className: (0, _classnames2.default)(_Gallery2.default.SelectFloorArrow, _Gallery2.default.Top),
	                  onClick: this.handlePrevFloorClick
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.Floors, ref: this.getFloorsRef },
	                  rows.map(this.renderRow)
	                ),
	                this.state.showFloorScroll && _react2.default.createElement('div', {
	                  className: (0, _classnames2.default)(_Gallery2.default.SelectFloorArrow, _Gallery2.default.Bottom),
	                  onClick: this.handleNextFloorClick
	                })
	              )
	            ),
	            !isClientView && _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanRight },
	              _react2.default.createElement(_About2.default, {
	                data: room,
	                building: building,
	                client: client,
	                sectionId: sectionId,
	                withImage: false,
	                chessfilter: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: _Gallery2.default.FloorPlan,
	                onWheel: this.handleMouseWheel,
	                onMouseDown: rowCells[0] ? this.handleMouseDown : function (_) {
	                  return _;
	                },
	                onTouchStart: rowCells[0] ? this.handleTouchStart : function (_) {
	                  return _;
	                },
	                style: {
	                  cursor: this.state.dragging ? '-webkit-grabbing' : 'default'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.FloorTitle },
	                rows[this.state.row].name,
	                ' ',
	                t('components.building.rightMenu.floor')
	              ),
	              !!rowCells[0] && _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.ZoomButtons },
	                _react2.default.createElement('div', { onClick: this.zoomOut, className: (0, _classnames2.default)(_Gallery2.default.ZoomBtn, _Gallery2.default.ZoomOut) }),
	                _react2.default.createElement('input', { type: 'range', value: this.state.scale, step: 0.01, min: MIN_SCALE, max: MAX_SCALE, onChange: this.handleZoomChange, onMouseDown: this.handleZoomMouseDown }),
	                _react2.default.createElement('div', { onClick: this.zoomIn, className: (0, _classnames2.default)(_Gallery2.default.ZoomBtn, _Gallery2.default.ZoomIn) })
	              ),
	              _react2.default.createElement(
	                _SpinnerImage2.default,
	                {
	                  key: this.state.row,
	                  className: _Gallery2.default.ImageInfo,
	                  imageSrc: _Config.ROOT_URL + '/image/plan?id=' + (rowCells[0] ? rowCells[0].planId : null) + '&preset=4000',
	                  imageAlt: 'Room',
	                  spinner: _react2.default.createElement('div', { className: _Gallery2.default.LoaderInfo }),
	                  blur: this.props.isChessLoading,
	                  placeholder: _react2.default.createElement(
	                    'div',
	                    { className: _Gallery2.default.PlaceholderOuter },
	                    _react2.default.createElement('img', { className: _Gallery2.default.PlaceholderImage, src: _noFloor2.default, alt: 'Not found' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Gallery2.default.PlaceholderText },
	                      t('components.building.rightMenu.emptyPlanning')
	                    )
	                  ),
	                  style: rowCells[0] ? _extends({}, height && width && {
	                    width: Math.min(69, 54 * width / height) + 'vmin',
	                    height: Math.min(54, 69 * height / width) + 'vmin',
	                    transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')'
	                  }, this.state.dragging && { transition: '0s' }) : !this.props.isClientView ? {
	                    transition: '0s',
	                    left: '-280px'
	                  } : {
	                    transition: '0s'
	                  }
	                },
	                rowCells[0] && !this.props.isClientView && this.renderVectorOverlay({ all: true }, rowCells[0])
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChessGalleryPopup;
	}(_react.Component);
	
	var ChessGalleryPopupWithRouter = exports.ChessGalleryPopupWithRouter = (0, _reactRouterDom.withRouter)(ChessGalleryPopup);
	
	/** **********   ************ */
	
	var Gallery = function (_Component2) {
	  _inherits(Gallery, _Component2);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this3 = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));
	
	    _this3.setPopUp = function () {
	      _this3.handleTrackEvent({
	        eventName: 'buildingChessLotAboutButtonsClick',
	        eventLabel: 'uvelichit_planirovku_etazha'
	      });
	      _this3.setState({
	        showPopup: true
	      });
	    };
	
	    _this3.handleClose = function () {
	      _this3.handleTrackEvent({
	        eventName: 'buildingChessFloorDialogButtonsClick',
	        eventLabel: 'zakryt'
	      });
	
	      _this3.setState({
	        showPopup: false
	      });
	    };
	
	    _this3.getRanges = function (array) {
	      var ranges = [],
	          rstart = void 0,
	          rend = void 0;
	      for (var i = 0; i < array.length; i++) {
	        rstart = array[i];
	        rend = rstart;
	        while (array[i + 1] - array[i] === 1) {
	          rend = array[i + 1]; // increment the index if the numbers sequential
	          i++;
	        }
	        ranges.push(rstart === rend ? '' + rstart : rstart + '\u200A\u2014\u200A' + rend);
	      }
	      return ranges;
	    };
	
	    _this3.handleTrackEvent = function (_ref4) {
	      var eventName = _ref4.eventName,
	          eventLabel = _ref4.eventLabel;
	      var _this3$props = _this3.props,
	          profile = _this3$props.profile,
	          objectType = _this3$props.objectType,
	          building = _this3$props.building,
	          isTable = _this3$props.isTable;
	
	      var eventContext = isTable ? 'shahmatka' : 'spisok';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this3.state = {
	      isLoaded: false
	    };
	
	    _this3.handleImageLoad = _this3.handleImageLoad.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(Gallery, [{
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (this.props.data.planId !== nextProps.data.planId) {
	        this.setState({ isLoaded: false });
	      }
	    }
	  }, {
	    key: 'renderVectorOverlay',
	    value: function renderVectorOverlay() {
	      var _this4 = this;
	
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref5$all = _ref5.all,
	          all = _ref5$all === undefined ? false : _ref5$all;
	
	      var _props3 = this.props,
	          row = _props3.row,
	          data = _props3.data,
	          sectionCells = _props3.sectionCells;
	
	      if (data.pointers) {
	        var _data$pointers$split3 = data.pointers.split(':'),
	            _data$pointers$split4 = _slicedToArray(_data$pointers$split3, 2),
	            width = _data$pointers$split4[0],
	            height = _data$pointers$split4[1];
	
	        return _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Plan },
	          _react2.default.createElement(
	            'div',
	            { className: 'lol' },
	            _react2.default.createElement(
	              'svg',
	              {
	                xmlns: 'http://www.w3.org/2000/svg',
	                height: height,
	                width: width,
	                viewBox: '0 0 ' + width + ' ' + height
	              },
	              _react2.default.createElement(
	                'g',
	                null,
	                (all ? sectionCells[row].cells : [data]).filter(function (cell) {
	                  return cell && cell.pointers;
	                }).map(function (cell) {
	                  var coordinates = cell.pointers.split(':')[2];
	                  var cs = coordinates.split(',');
	                  var path = cs.reduce(function (path, c, i) {
	                    return path.concat(i % 2 === 1 ? c + ' L ' : c + ' ');
	                  }, 'M ').replace(/L $/, 'Z');
	                  return [_react2.default.createElement('path', {
	                    className: (0, _classnames2.default)(_Gallery2.default.Flat, _defineProperty({}, _Gallery2.default.SelectedFlat, cell.id === data.id)),
	                    d: path,
	                    key: cell.id,
	                    onMouseEnter: function onMouseEnter() {
	                      _this4.setState({ hoverCellId: cell.id });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                      if (_this4.state.hoverCellId === cell.id) {
	                        _this4.setState({ hoverCellId: null });
	                      }
	                    }
	                  })];
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleImageLoad',
	    value: function handleImageLoad() {
	      this.setState({ isLoaded: true }, _reactTooltip2.default.rebuild);
	      if (this.props.handleImageLoad) {
	        this.props.handleImageLoad();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          room = _props4.data,
	          client = _props4.client,
	          print = _props4.print,
	          pavilionName = _props4.pavilionName,
	          sectionName = _props4.sectionName,
	          t = _props4.t,
	          currency = _props4.currency;
	      var isLoaded = this.state.isLoaded;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Gallery2.default.Gallery, _defineProperty({}, _Gallery2.default.Client, client), _defineProperty({}, _Gallery2.default.Print, print)) },
	        _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Slider },
	          print && _react2.default.createElement(
	            'div',
	            { className: _Gallery2.default.PrintHeader },
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.PrintHeaderLeft },
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.FloorNumberPrint },
	                print ? t('components.building.rightMenu.corps') + ' ' + pavilionName + ', ' + t('components.building.rightMenu.section') + ' ' + sectionName + ', ' + getFloorName(room.data.floorName) : getFloorName(room.data.floorName)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.PrintHeaderObjectName },
	                this.props.building.data.title
	              )
	            ),
	            _react2.default.createElement('img', { src: _logoBlack2.default, alt: '', className: _Gallery2.default.LogoPrint })
	          ),
	          _react2.default.createElement('span', { className: (0, _classnames2.default)(_Gallery2.default.FloorNumber, _defineProperty({}, _Gallery2.default.FloorNumberPrint, print)) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Gallery2.default.ImageOuter, _Gallery2.default.ImageWrap) },
	          _react2.default.createElement(
	            _SpinnerImage2.default,
	            {
	              key: room.id,
	              className: (0, _classnames2.default)(_Gallery2.default.ImageInner, _defineProperty({}, _Gallery2.default.ImagePrint, print)),
	              imageSrc: _Config.ROOT_URL + '/image/plan?id=' + room.planId + '&preset=' + (print ? '900' : '300'),
	              imageAlt: 'Floor preview',
	              handleImageLoad: this.handleImageLoad,
	              handleImageError: this.props.handleImageError,
	              spinner: _react2.default.createElement('div', { className: _Gallery2.default.Loader }),
	              placeholder: _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.PlaceholderOuter },
	                _react2.default.createElement('img', { className: _Gallery2.default.PlaceholderImage, src: _noFloor2.default, alt: 'Not found' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.PlaceholderText },
	                  t('components.building.rightMenu.emptyPlanning')
	                )
	              )
	            },
	            this.renderVectorOverlay(),
	            isLoaded ? _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_Gallery2.default.Zoom),
	                onClick: this.setPopUp
	              },
	              _react2.default.createElement('img', {
	                alt: 'zoom',
	                src: _iconZoom2.default,
	                'data-tip': t('components.building.rightMenu.zoomImg'),
	                'data-for': 'global'
	              })
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: this.state.showPopup,
	            onRequestClose: this.handleClose,
	            contentLabel: 'Modal',
	            style: {
	              overlay: {
	                backgroundColor: 'rgba(0, 0, 0, 0.75)'
	              },
	              content: {
	                padding: 0,
	                border: 'none'
	              }
	            }
	          },
	          _react2.default.createElement(ChessGalleryPopupWithRouter, _extends({}, this.props, {
	            onClose: this.handleClose
	          }))
	        )
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	var gallerySelector = (0, _reselect.createSelector)(function (state) {
	  return state.profile;
	}, function (profile) {
	  return {
	    currency: profile.user_region.country_currency_symbol
	  };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(gallerySelector, { setPopUp: _environment.setPopUp })(Gallery));

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InaccuracyReport = __webpack_require__(1341);
	
	var _InaccuracyReport2 = _interopRequireDefault(_InaccuracyReport);
	
	var _reactI18next = __webpack_require__(4);
	
	var _iconFeedback = __webpack_require__(1541);
	
	var _iconFeedback2 = _interopRequireDefault(_iconFeedback);
	
	var _InaccuracyReportDialog = __webpack_require__(922);
	
	var _InaccuracyReportDialog2 = _interopRequireDefault(_InaccuracyReportDialog);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InaccuracyReport = function (_Component) {
	  _inherits(InaccuracyReport, _Component);
	
	  function InaccuracyReport() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InaccuracyReport);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InaccuracyReport.__proto__ || Object.getPrototypeOf(InaccuracyReport)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      var _this$props = _this.props,
	          building = _this$props.building,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.buildingRightMenuButtonsClick({
	        eventLabel: 'soobshchit_o_netochnosti',
	        eventContent: building.title,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	
	      _this.props.setPopUp(_react2.default.createElement(_InaccuracyReportDialog2.default, { building: building, profile: profile, objectType: objectType }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InaccuracyReport, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t,
	          withText = _props.withText;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_InaccuracyReport2.default.InaccuracyReport, className) },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _InaccuracyReport2.default.ButtonCreateInaccuracyReport,
	            onClick: this.handleClick,
	            'data-tip': t('components.building.main.inaccuracyReport.add'),
	            'data-for': 'global'
	          },
	          withText ? _react2.default.createElement(
	            'div',
	            { className: _InaccuracyReport2.default.ButtonContent },
	            _react2.default.createElement('img', { src: _iconFeedback2.default, alt: '', className: _InaccuracyReport2.default.ButtonIcon }),
	            _react2.default.createElement(
	              'span',
	              { className: _InaccuracyReport2.default.ButtonText },
	              t('components.building.main.inaccuracyReport.add')
	            )
	          ) : _react2.default.createElement('img', { src: _iconFeedback2.default, alt: 'feedback' })
	        )
	      );
	    }
	  }]);
	
	  return InaccuracyReport;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return state.profile;
	}, {
	  setPopUp: _environment.setPopUp
	})(InaccuracyReport));

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InaccuracyReport = __webpack_require__(468);
	
	var _InaccuracyReport2 = _interopRequireDefault(_InaccuracyReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InaccuracyReport2.default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSwipeable = __webpack_require__(2071);
	
	var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_INTERVAL = 500;
	
	function throttle(func, wait) {
	  var context = void 0,
	      args = void 0,
	      result = void 0;
	  var timeout = null;
	  var previous = 0;
	
	  var later = function later() {
	    previous = new Date().getTime();
	    timeout = null;
	    result = func.apply(context, args);
	    if (!timeout) context = args = null;
	  };
	
	  return function () {
	    var now = new Date().getTime();
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0 || remaining > wait) {
	      if (timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	      previous = now;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    } else if (!timeout) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  };
	}
	
	// This is to handle accessing event properties in an asynchronous way
	// https://facebook.github.io/react/docs/events.html#syntheticevent
	function debounceEventHandler() {
	  var throttled = throttle.apply(undefined, arguments);
	  return function (event) {
	    if (event) {
	      event.persist();
	      return throttled(event);
	    }
	
	    return throttled();
	  };
	}
	
	var screenChangeEvents = ['fullscreenchange', 'msfullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange'];
	
	var ImageGallery = function (_React$Component) {
	  _inherits(ImageGallery, _React$Component);
	
	  function ImageGallery(props) {
	    _classCallCheck(this, ImageGallery);
	
	    var _this = _possibleConstructorReturn(this, (ImageGallery.__proto__ || Object.getPrototypeOf(ImageGallery)).call(this, props));
	
	    _this.state = {
	      currentIndex: props.startIndex,
	      thumbsTranslateX: 0,
	      offsetPercentage: 0,
	      galleryWidth: 0,
	      thumbnailWidth: 0,
	      isFullscreen: false,
	      isPlaying: false
	    };
	    return _this;
	  }
	
	  _createClass(ImageGallery, [{
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (this.props.disableArrowKeys !== nextProps.disableArrowKeys) {
	        if (nextProps.disableArrowKeys) {
	          window.removeEventListener('keydown', this._handleKeyDown);
	        } else {
	          window.addEventListener('keydown', this._handleKeyDown);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.thumbnailWidth !== this.state.thumbnailWidth || prevProps.showThumbnails !== this.props.showThumbnails) {
	        // adjust thumbnail container when thumbnail width is adjusted
	        this._setThumbsTranslateX(-this._getThumbsTranslateX(this.state.currentIndex > 0 ? 1 : 0) * this.state.currentIndex);
	      }
	
	      if (prevState.currentIndex !== this.state.currentIndex) {
	        if (this.props.onSlide) {
	          this.props.onSlide(this.state.currentIndex);
	        }
	
	        this._updateThumbnailTranslateX(prevState);
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      this._slideLeft = debounceEventHandler(this._slideLeft.bind(this), MIN_INTERVAL, true);
	
	      this._slideRight = debounceEventHandler(this._slideRight.bind(this), MIN_INTERVAL, true);
	
	      this._handleResize = this._handleResize.bind(this);
	      this._handleScreenChange = this._handleScreenChange.bind(this);
	      this._handleKeyDown = this._handleKeyDown.bind(this);
	      this._thumbnailDelay = 300;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // delay initial resize to get the accurate this._imageGallery.offsetWidth
	      window.setTimeout(function () {
	        return _this2._handleResize();
	      }, 500);
	
	      this.handleTrackEvent({ imageIndex: 0 });
	
	      if (this.props.autoPlay) {
	        this.play();
	      }
	      if (!this.props.disableArrowKeys) {
	        window.addEventListener('keydown', this._handleKeyDown);
	      }
	      window.addEventListener('resize', this._handleResize);
	      this._onScreenChangeEvent();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disableArrowKeys) {
	        window.removeEventListener('keydown', this._handleKeyDown);
	      }
	      window.removeEventListener('resize', this._handleResize);
	      this._offScreenChangeEvent();
	
	      if (this._intervalId) {
	        window.clearInterval(this._intervalId);
	        this._intervalId = null;
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var _this3 = this;
	
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!this._intervalId) {
	        this.setState({ isPlaying: true });
	        var slideInterval = this.props.slideInterval;
	
	        this._intervalId = window.setInterval(function () {
	          if (!_this3.state.hovering) {
	            if (!_this3.props.infinite && !_this3._canSlideRight()) {
	              _this3.pause();
	            } else {
	              _this3.slideToIndex(_this3.state.currentIndex + 1);
	            }
	          }
	        }, slideInterval > MIN_INTERVAL ? slideInterval : MIN_INTERVAL);
	
	        if (this.props.onPlay && callback) {
	          this.props.onPlay(this.state.currentIndex);
	        }
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (this._intervalId) {
	        window.clearInterval(this._intervalId);
	        this._intervalId = null;
	        this.setState({ isPlaying: false });
	
	        if (this.props.onPause && callback) {
	          this.props.onPause(this.state.currentIndex);
	        }
	      }
	    }
	  }, {
	    key: 'fullScreen',
	    value: function fullScreen() {
	      var gallery = this._imageGallery;
	
	      if (gallery.requestFullscreen) {
	        gallery.requestFullscreen();
	      } else if (gallery.msRequestFullscreen) {
	        gallery.msRequestFullscreen();
	      } else if (gallery.mozRequestFullScreen) {
	        gallery.mozRequestFullScreen();
	      } else if (gallery.webkitRequestFullscreen) {
	        gallery.webkitRequestFullscreen();
	      } else {
	        // fallback to modal for unsupported browsers
	        this.setState({ modalFullscreen: true });
	      }
	
	      this.setState({ isFullscreen: true });
	    }
	  }, {
	    key: 'exitFullScreen',
	    value: function exitFullScreen() {
	      if (this.state.isFullscreen) {
	        if (document.exitFullscreen) {
	          document.exitFullscreen();
	        } else if (document.webkitExitFullscreen) {
	          document.webkitExitFullscreen();
	        } else if (document.mozCancelFullScreen) {
	          document.mozCancelFullScreen();
	        } else if (document.msExitFullscreen) {
	          document.msExitFullscreen();
	        } else {
	          // fallback to modal for unsupported browsers
	          this.setState({ modalFullscreen: false });
	        }
	
	        this.setState({ isFullscreen: false });
	      }
	    }
	  }, {
	    key: 'slideToIndex',
	    value: function slideToIndex(index, event) {
	      if (event) {
	        event.preventDefault();
	        if (this._intervalId) {
	          // user triggered event while ImageGallery is playing, reset interval
	          this.pause(false);
	          this.play(false);
	        }
	      }
	
	      var slideCount = this.props.items.length - 1;
	      var currentIndex = index;
	
	      if (index < 0) {
	        currentIndex = slideCount;
	      } else if (index > slideCount) {
	        currentIndex = 0;
	      }
	
	      this.handleTrackEvent({ imageIndex: index });
	
	      this.setState({
	        previousIndex: this.state.currentIndex,
	        currentIndex: currentIndex,
	        offsetPercentage: 0,
	        style: {
	          transition: 'transform .45s ease-out'
	        }
	      });
	    }
	  }, {
	    key: 'getCurrentIndex',
	    value: function getCurrentIndex() {
	      return this.state.currentIndex;
	    }
	  }, {
	    key: 'handleTrackEvent',
	    value: function handleTrackEvent(_ref) {
	      var imageIndex = _ref.imageIndex;
	      var _props = this.props,
	          profile = _props.profile,
	          buildingData = _props.buildingData,
	          objectType = _props.objectType,
	          galleryData = _props.galleryData,
	          isModal = _props.isModal;
	
	      var eventName = isModal ? 'buildingGalleryModalImageShow' : 'buildingImageShow';
	
	      var totalImages = galleryData.itemsForGallery.length;
	
	      var currentImageNumber = (imageIndex + totalImages) % totalImages + 1;
	
	      var currentImageAlbumData = galleryData.metaForGallery.meta.find(function (album) {
	        return currentImageNumber >= album.first && currentImageNumber <= album.last;
	      });
	
	      var albumName = '';
	
	      if (currentImageAlbumData) {
	        albumName = currentImageAlbumData.name;
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: isModal ? currentImageNumber : albumName,
	        eventContext: isModal ? albumName : currentImageNumber + ' | ' + totalImages,
	        productType: objectType,
	        productName: buildingData.title,
	        productID: buildingData.id,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: '_onScreenChangeEvent',
	    value: function _onScreenChangeEvent() {
	      var _this4 = this;
	
	      screenChangeEvents.map(function (eventName) {
	        document.addEventListener(eventName, _this4._handleScreenChange);
	      });
	    }
	  }, {
	    key: '_offScreenChangeEvent',
	    value: function _offScreenChangeEvent() {
	      var _this5 = this;
	
	      screenChangeEvents.map(function (eventName) {
	        document.removeEventListener(eventName, _this5._handleScreenChange);
	      });
	    }
	  }, {
	    key: '_togglePlay',
	    value: function _togglePlay() {
	      if (this._intervalId) {
	        this.pause();
	      } else {
	        this.play();
	      }
	    }
	  }, {
	    key: '_toggleFullScreen',
	    value: function _toggleFullScreen() {
	      if (this.state.isFullscreen) {
	        this.exitFullScreen();
	      } else {
	        this.fullScreen();
	      }
	    }
	  }, {
	    key: '_handleResize',
	    value: function _handleResize() {
	      if (this._imageGallery) {
	        this.setState({ galleryWidth: this._imageGallery.offsetWidth });
	      }
	
	      if (this._imageGalleryThumbnail) {
	        this.setState({ thumbnailWidth: this._imageGalleryThumbnail.offsetWidth });
	      }
	    }
	  }, {
	    key: '_handleScreenChange',
	    value: function _handleScreenChange() {
	      var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
	
	      if (this.props.onScreenChange) {
	        this.props.onScreenChange(fullScreenElement);
	      }
	
	      this.setState({ isFullscreen: !!fullScreenElement });
	    }
	  }, {
	    key: '_handleKeyDown',
	    value: function _handleKeyDown(event) {
	      var LEFT_ARROW = 37;
	      var RIGHT_ARROW = 39;
	      var key = parseInt(event.keyCode || event.which || 0);
	
	      switch (key) {
	        case LEFT_ARROW:
	          if (this._canSlideLeft() && !this._intervalId) {
	            this._slideLeft();
	          }
	          break;
	        case RIGHT_ARROW:
	          if (this._canSlideRight() && !this._intervalId) {
	            this._slideRight();
	          }
	          break;
	      }
	    }
	  }, {
	    key: '_handleMouseOverThumbnails',
	    value: function _handleMouseOverThumbnails(index) {
	      var _this6 = this;
	
	      if (this.props.slideOnThumbnailHover) {
	        this.setState({ hovering: true });
	        if (this._thumbnailTimer) {
	          window.clearTimeout(this._thumbnailTimer);
	          this._thumbnailTimer = null;
	        }
	        this._thumbnailTimer = window.setTimeout(function () {
	          _this6.slideToIndex(index);
	        }, this._thumbnailDelay);
	      }
	    }
	  }, {
	    key: '_handleMouseLeaveThumbnails',
	    value: function _handleMouseLeaveThumbnails() {
	      if (this._thumbnailTimer) {
	        window.clearTimeout(this._thumbnailTimer);
	        this._thumbnailTimer = null;
	        if (this.props.autoPlay === true) {
	          this.play(false);
	        }
	      }
	      this.setState({ hovering: false });
	    }
	  }, {
	    key: '_handleImageError',
	    value: function _handleImageError(event) {
	      if (this.props.defaultImage && event.target.src.indexOf(this.props.defaultImage) === -1) {
	        event.target.src = this.props.defaultImage;
	      }
	    }
	  }, {
	    key: '_handleOnSwiped',
	    value: function _handleOnSwiped(ev, x, y, isFlick) {
	      this.setState({ isFlick: isFlick });
	    }
	  }, {
	    key: '_shouldSlideOnSwipe',
	    value: function _shouldSlideOnSwipe() {
	      var shouldSlide = Math.abs(this.state.offsetPercentage) > 30 || this.state.isFlick;
	
	      if (shouldSlide) {
	        // reset isFlick state after so data is not persisted
	        this.setState({ isFlick: false });
	      }
	      return shouldSlide;
	    }
	  }, {
	    key: '_handleOnSwipedTo',
	    value: function _handleOnSwipedTo(index) {
	      var slideTo = this.state.currentIndex;
	
	      if (this._shouldSlideOnSwipe()) {
	        slideTo += index;
	      }
	
	      if (index < 0) {
	        if (!this._canSlideLeft()) {
	          slideTo = this.state.currentIndex;
	        }
	      } else if (!this._canSlideRight()) {
	        slideTo = this.state.currentIndex;
	      }
	
	      this.slideToIndex(slideTo);
	    }
	  }, {
	    key: '_handleSwiping',
	    value: function _handleSwiping(index, _, delta) {
	      var offsetPercentage = index * (delta / this.state.galleryWidth * 100);
	      this.setState({ offsetPercentage: offsetPercentage, style: {} });
	    }
	  }, {
	    key: '_canNavigate',
	    value: function _canNavigate() {
	      return this.props.items.length >= 2;
	    }
	  }, {
	    key: '_canSlideLeft',
	    value: function _canSlideLeft() {
	      return this.props.infinite || this.state.currentIndex > 0;
	    }
	  }, {
	    key: '_canSlideRight',
	    value: function _canSlideRight() {
	      return this.props.infinite || this.state.currentIndex < this.props.items.length - 1;
	    }
	  }, {
	    key: '_updateThumbnailTranslateX',
	    value: function _updateThumbnailTranslateX(prevState) {
	      if (this.state.currentIndex === 0) {
	        this._setThumbsTranslateX(0);
	      } else {
	        var indexDifference = Math.abs(prevState.currentIndex - this.state.currentIndex);
	        var scrollX = this._getThumbsTranslateX(indexDifference);
	        if (scrollX > 0) {
	          if (prevState.currentIndex < this.state.currentIndex) {
	            this._setThumbsTranslateX(this.state.thumbsTranslateX - scrollX);
	          } else if (prevState.currentIndex > this.state.currentIndex) {
	            this._setThumbsTranslateX(this.state.thumbsTranslateX + scrollX);
	          }
	        }
	      }
	    }
	  }, {
	    key: '_setThumbsTranslateX',
	    value: function _setThumbsTranslateX(thumbsTranslateX) {
	      this.setState({ thumbsTranslateX: thumbsTranslateX });
	    }
	  }, {
	    key: '_getThumbsTranslateX',
	    value: function _getThumbsTranslateX(indexDifference) {
	      if (this.props.disableThumbnailScroll) {
	        return 0;
	      }
	
	      var thumbnailWidth = this.state.thumbnailWidth;
	
	
	      if (this._thumbnails) {
	        if (this._thumbnails.scrollWidth <= thumbnailWidth) {
	          return 0;
	        }
	        var totalThumbnails = this._thumbnails.children.length;
	        // total scroll-x required to see the last thumbnail
	        var totalScrollX = this._thumbnails.scrollWidth - thumbnailWidth;
	        // scroll-x required per index change
	        var perIndexScrollX = totalScrollX / (totalThumbnails - 1);
	
	        return indexDifference * perIndexScrollX;
	      }
	    }
	  }, {
	    key: '_getAlignmentClassName',
	    value: function _getAlignmentClassName(index) {
	      // LEFT, and RIGHT alignments are necessary for lazyLoad
	      var currentIndex = this.state.currentIndex;
	
	      var alignment = '';
	      var LEFT = 'left';
	      var CENTER = 'center';
	      var RIGHT = 'right';
	
	      switch (index) {
	        case currentIndex - 1:
	          alignment = ' ' + LEFT;
	          break;
	        case currentIndex:
	          alignment = ' ' + CENTER;
	          break;
	        case currentIndex + 1:
	          alignment = ' ' + RIGHT;
	          break;
	      }
	
	      if (this.props.items.length >= 3 && this.props.infinite) {
	        if (index === 0 && currentIndex === this.props.items.length - 1) {
	          // set first slide as right slide if were sliding right from last slide
	          alignment = ' ' + RIGHT;
	        } else if (index === this.props.items.length - 1 && currentIndex === 0) {
	          // set last slide as left slide if were sliding left from first slide
	          alignment = ' ' + LEFT;
	        }
	      }
	
	      return alignment;
	    }
	  }, {
	    key: '_getTranslateXForTwoSlide',
	    value: function _getTranslateXForTwoSlide(index) {
	      // For taking care of infinite swipe when there are only two slides
	      var _state = this.state,
	          currentIndex = _state.currentIndex,
	          offsetPercentage = _state.offsetPercentage,
	          previousIndex = _state.previousIndex;
	
	      var baseTranslateX = -100 * currentIndex;
	      var translateX = baseTranslateX + index * 100 + offsetPercentage;
	
	      // keep track of user swiping direction
	      if (offsetPercentage > 0) {
	        this.direction = 'left';
	      } else if (offsetPercentage < 0) {
	        this.direction = 'right';
	      }
	
	      // when swiping make sure the slides are on the correct side
	      if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
	        translateX = -100 + offsetPercentage;
	      } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
	        translateX = 100 + offsetPercentage;
	      }
	
	      if (currentIndex !== previousIndex) {
	        // when swiped move the slide to the correct side
	        if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
	          translateX = 100;
	        } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
	          translateX = -100;
	        }
	      } else {
	        // keep the slide on the correct slide even when not a swipe
	        if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
	          translateX = -100;
	        } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
	          translateX = 100;
	        }
	      }
	
	      return translateX;
	    }
	  }, {
	    key: '_getSlideStyle',
	    value: function _getSlideStyle(index) {
	      var _state2 = this.state,
	          currentIndex = _state2.currentIndex,
	          offsetPercentage = _state2.offsetPercentage;
	      var _props2 = this.props,
	          infinite = _props2.infinite,
	          items = _props2.items;
	
	      var baseTranslateX = -100 * currentIndex;
	      var totalSlides = items.length - 1;
	
	      // calculates where the other slides belong based on currentIndex
	      var translateX = baseTranslateX + index * 100 + offsetPercentage;
	
	      // adjust zIndex so that only the current slide and the slide were going
	      // to is at the top layer, this prevents transitions from flying in the
	      // background when swiping before the first slide or beyond the last slide
	      var zIndex = 1;
	      if (index === currentIndex) {
	        zIndex = 3;
	      } else if (index === this.state.previousIndex) {
	        zIndex = 2;
	      }
	
	      if (infinite && items.length > 2) {
	        if (currentIndex === 0 && index === totalSlides) {
	          // make the last slide the slide before the first
	          translateX = -100 + offsetPercentage;
	        } else if (currentIndex === totalSlides && index === 0) {
	          // make the first slide the slide after the last
	          translateX = 100 + offsetPercentage;
	        }
	      }
	
	      // Special case when there are only 2 items with infinite on
	      if (infinite && items.length === 2) {
	        translateX = this._getTranslateXForTwoSlide(index);
	      }
	
	      var translate3d = 'translate3d(' + translateX + '%, 0, 0)';
	
	      return {
	        WebkitTransform: translate3d,
	        MozTransform: translate3d,
	        msTransform: translate3d,
	        OTransform: translate3d,
	        transform: translate3d,
	        zIndex: zIndex
	      };
	    }
	  }, {
	    key: '_getThumbnailStyle',
	    value: function _getThumbnailStyle() {
	      var translate3d = 'translate3d(' + this.state.thumbsTranslateX + 'px, 0, 0)';
	      return {
	        WebkitTransform: translate3d,
	        MozTransform: translate3d,
	        msTransform: translate3d,
	        OTransform: translate3d,
	        transform: translate3d
	      };
	    }
	  }, {
	    key: '_slideLeft',
	    value: function _slideLeft(event) {
	      this.slideToIndex(this.state.currentIndex - 1, event);
	    }
	  }, {
	    key: '_slideRight',
	    value: function _slideRight(event) {
	      this.slideToIndex(this.state.currentIndex + 1, event);
	    }
	  }, {
	    key: '_renderItem',
	    value: function _renderItem(item) {
	      var onImageError = this.props.onImageError || this._handleImageError;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'image-gallery-image' },
	        _react2.default.createElement('img', {
	          src: item.original,
	          alt: item.originalAlt,
	          srcSet: item.srcSet,
	          sizes: item.sizes,
	          onLoad: this.props.onImageLoad,
	          onError: onImageError.bind(this)
	        }),
	        item.description && _react2.default.createElement(
	          'span',
	          { className: 'image-gallery-description' },
	          item.description
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          currentIndex = _state3.currentIndex,
	          isFullscreen = _state3.isFullscreen,
	          modalFullscreen = _state3.modalFullscreen,
	          isPlaying = _state3.isPlaying;
	
	
	      var thumbnailStyle = this._getThumbnailStyle();
	
	      var slideLeft = this._slideLeft.bind(this);
	      var slideRight = this._slideRight.bind(this);
	
	      var slides = [];
	      var thumbnails = [];
	      var bullets = [];
	
	      this.props.items.map(function (item, index) {
	        var alignment = _this7._getAlignmentClassName(index);
	        var originalClass = item.originalClass ? ' ' + item.originalClass : '';
	        var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';
	
	        var renderItem = item.renderItem || _this7.props.renderItem || _this7._renderItem.bind(_this7);
	
	        var slide = _react2.default.createElement(
	          'div',
	          {
	            key: index,
	            className: 'image-gallery-slide' + alignment + originalClass,
	            style: Object.assign(_this7._getSlideStyle(index), _this7.state.style),
	            onClick: _this7.props.onClick
	          },
	          renderItem(item)
	        );
	
	        if (_this7.props.lazyLoad) {
	          if (alignment) {
	            slides.push(slide);
	          }
	        } else {
	          slides.push(slide);
	        }
	
	        var onThumbnailError = _this7._handleImageError;
	        if (_this7.props.onThumbnailError) {
	          onThumbnailError = _this7.props.onThumbnailError;
	        }
	
	        if (_this7.props.showThumbnails) {
	          thumbnails.push(_react2.default.createElement(
	            'a',
	            {
	              onMouseOver: _this7._handleMouseOverThumbnails.bind(_this7, index),
	              onMouseLeave: _this7._handleMouseLeaveThumbnails.bind(_this7, index),
	              key: index,
	              className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
	
	              onTouchStart: function onTouchStart(event) {
	                return _this7.slideToIndex.call(_this7, index, event);
	              },
	              onClick: function onClick(event) {
	                return _this7.slideToIndex.call(_this7, index, event);
	              }
	            },
	            _react2.default.createElement('img', {
	              ref: 'thumbnailRef',
	              src: item.thumbnail(_this7.refs.thumbnailRef),
	              alt: item.thumbnailAlt,
	              onError: onThumbnailError.bind(_this7)
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'image-gallery-thumbnail-label' },
	              item.thumbnailLabel
	            )
	          ));
	        }
	
	        if (_this7.props.showBullets) {
	          bullets.push(_react2.default.createElement('button', {
	            key: index,
	            className: 'image-gallery-bullet ' + (currentIndex === index ? 'active' : ''),
	
	            onTouchStart: function onTouchStart(event) {
	              return _this7.slideToIndex.call(_this7, index, event);
	            },
	            onClick: function onClick(event) {
	              return _this7.slideToIndex.call(_this7, index, event);
	            }
	          }));
	        }
	      });
	
	      return _react2.default.createElement(
	        'section',
	        {
	          ref: function ref(i) {
	            return _this7._imageGallery = i;
	          },
	          className: (0, _classnames2.default)({
	            'image-gallery': !modalFullscreen,
	            'image-galleryfullscreen-modal': modalFullscreen,
	            'image-gallery-short': this.props.isShort
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'image-gallery-slide-wrapper' },
	            this.props.showFullscreenButton && _react2.default.createElement('a', {
	              className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
	              onClick: this._toggleFullScreen.bind(this)
	            }),
	            this.props.showPlayButton && _react2.default.createElement('a', {
	              ref: function ref(p) {
	                return _this7._playButton = p;
	              },
	              className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
	              onClick: this._togglePlay.bind(this)
	            }),
	            this._canNavigate() ? [this.props.showNav && _react2.default.createElement(
	              'span',
	              { key: 'navigation' },
	              _react2.default.createElement('button', {
	                className: 'image-gallery-left-nav',
	                disabled: !this._canSlideLeft(),
	                onTouchStart: slideLeft,
	                onClick: slideLeft
	              }),
	              _react2.default.createElement('button', {
	                className: 'image-gallery-right-nav',
	                disabled: !this._canSlideRight(),
	                onTouchStart: slideRight,
	                onClick: slideRight
	              })
	            ), this.props.disableSwipe ? _react2.default.createElement(
	              'div',
	              { className: 'image-gallery-slides', key: 'slides' },
	              slides
	            ) : _react2.default.createElement(
	              _reactSwipeable2.default,
	              {
	                className: 'image-gallery-swipe',
	                key: 'swipeable',
	                delta: 1,
	                onSwipingLeft: this._handleSwiping.bind(this, -1),
	                onSwipingRight: this._handleSwiping.bind(this, 1),
	                onSwiped: this._handleOnSwiped.bind(this),
	                onSwipedLeft: this._handleOnSwipedTo.bind(this, 1),
	                onSwipedRight: this._handleOnSwipedTo.bind(this, -1)
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'image-gallery-slides' },
	                slides
	              )
	            )] : _react2.default.createElement(
	              'div',
	              { className: 'image-gallery-slides' },
	              slides
	            ),
	            this.props.showBullets && _react2.default.createElement(
	              'div',
	              { className: 'image-gallery-bullets' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'image-gallery-bullets-container' },
	                bullets
	              )
	            ),
	            this.props.showIndex && _react2.default.createElement(
	              'div',
	              { className: 'image-gallery-index' },
	              _react2.default.createElement(
	                'span',
	                { className: 'image-gallery-index-current' },
	                this.state.currentIndex + 1
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'image-gallery-index-separator' },
	                this.props.indexSeparator
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'image-gallery-index-total' },
	                this.props.items.length
	              )
	            )
	          ),
	          this.props.showThumbnails && _react2.default.createElement(
	            'div',
	            {
	              className: 'image-gallery-thumbnails',
	              ref: function ref(i) {
	                return _this7._imageGalleryThumbnail = i;
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(t) {
	                  return _this7._thumbnails = t;
	                },
	                className: 'image-gallery-thumbnails-container',
	                style: thumbnailStyle
	              },
	              thumbnails
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImageGallery;
	}(_react2.default.Component);
	
	exports.default = ImageGallery;
	
	
	ImageGallery.propTypes = {
	  items: _propTypes2.default.array.isRequired,
	  showNav: _propTypes2.default.bool,
	  autoPlay: _propTypes2.default.bool,
	  lazyLoad: _propTypes2.default.bool,
	  infinite: _propTypes2.default.bool,
	  showIndex: _propTypes2.default.bool,
	  showBullets: _propTypes2.default.bool,
	  showThumbnails: _propTypes2.default.bool,
	  showPlayButton: _propTypes2.default.bool,
	  showFullscreenButton: _propTypes2.default.bool,
	  slideOnThumbnailHover: _propTypes2.default.bool,
	  disableThumbnailScroll: _propTypes2.default.bool,
	  disableArrowKeys: _propTypes2.default.bool,
	  disableSwipe: _propTypes2.default.bool,
	  defaultImage: _propTypes2.default.string,
	  indexSeparator: _propTypes2.default.string,
	  startIndex: _propTypes2.default.number,
	  slideInterval: _propTypes2.default.number,
	  onSlide: _propTypes2.default.func,
	  onScreenChange: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onImageLoad: _propTypes2.default.func,
	  onImageError: _propTypes2.default.func,
	  onThumbnailError: _propTypes2.default.func,
	  renderItem: _propTypes2.default.func
	};
	
	ImageGallery.defaultProps = {
	  items: [],
	  showNav: true,
	  autoPlay: false,
	  lazyLoad: false,
	  infinite: true,
	  showIndex: false,
	  showBullets: false,
	  showThumbnails: true,
	  showPlayButton: true,
	  showFullscreenButton: true,
	  slideOnThumbnailHover: false,
	  disableThumbnailScroll: false,
	  disableArrowKeys: false,
	  disableSwipe: false,
	  indexSeparator: ' / ',
	  startIndex: 0,
	  slideInterval: 3000
	};

/***/ }),
/* 471 */
[2396, 951],
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Print = __webpack_require__(957);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Print2.default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NoBuildings = __webpack_require__(968);
	
	var _NoBuildings2 = _interopRequireDefault(_NoBuildings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NoBuildings2.default;

/***/ }),
/* 474 */
[2398, 961],
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1379);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NoPage(_ref) {
	  var className = _ref.className;
	
	  var classes = (0, _classnames2.default)(_style2.default.root, className);
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_style2.default.Rectangle) },
	      _react2.default.createElement('img', { className: (0, _classnames2.default)(_style2.default.Image), src: _nothingfound2.default, alt: 'nothing found' }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.Info) },
	        _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)(_style2.default.InfoTitle) },
	          t('components.clientCollection.noPageTitle')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)(_style2.default.InfoSubTitle) },
	          t('components.clientCollection.noPageSubTitle')
	        )
	      )
	    )
	  );
	}
	
	exports.default = NoPage;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BuildingTitle = __webpack_require__(1001);
	
	var _BuildingTitle2 = _interopRequireDefault(_BuildingTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BuildingTitle2.default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(12);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Area = __webpack_require__(1394);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ga = __webpack_require__(7);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var digits = function digits(number) {
	  return number ? (0, _utils.formatNumber)(number) : '...';
	};
	
	var inputDigits = function inputDigits(number) {
	  var formattedNumber = (0, _utils.formatNumber)(parseInt(number, 10));
	  return Number(number) === '0' || isNaN(parseInt(number, 10)) ? '' : formattedNumber;
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var areaFrom = search.areaFrom,
	      areaTo = search.areaTo;
	
	  return { areaFrom: areaFrom, areaTo: areaTo };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var areaFrom = data.areaFrom,
	      areaTo = data.areaTo;
	
	  var min = areaFrom ? Number(areaFrom) : undefined;
	  var max = areaTo ? Number(areaTo) : undefined;
	  return { areaFrom: min, areaTo: max };
	};
	
	var compileRequest = exports.compileRequest = compileSearch;
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      areaFrom = _parseSearch.areaFrom,
	      areaTo = _parseSearch.areaTo;
	
	  return areaFrom || areaTo ? digits(areaFrom) + ' - ' + digits(areaTo) : _i18n2.default.t('components.header.filtersBar.filters.area.notSelected');
	};
	
	var Area = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area(props) {
	    _classCallCheck(this, Area);
	
	    var _this = _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).call(this, props));
	
	    _this.state = _extends({}, parseSearch(props.search));
	
	    _this.handleMinValueChange = _this.handleMinValueChange.bind(_this);
	    _this.handleMaxValueChange = _this.handleMaxValueChange.bind(_this);
	    _this.handleClearButtonClick = _this.handleClearButtonClick.bind(_this);
	    _this.updateSearch = _this.updateSearch.bind(_this);
	
	    _this.debouncedEnterMinAreaEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'ot'), 3000);
	    _this.debouncedEnterMaxAreaEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'do'), 3000);
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: 'updateSearch',
	    value: function updateSearch() {
	      var dropdownData = this.props.dropdownData;
	
	      var compiled = compileSearch(this.state);
	      dropdownData(compiled, compiled);
	    }
	  }, {
	    key: 'parseValue',
	    value: function parseValue(value) {
	      var parsed = Number(parseInt(value.replace(/\s/g, ''), 10));
	      return value ? isNaN(parsed) ? undefined : parsed : undefined;
	    }
	  }, {
	    key: 'handleMinValueChange',
	    value: function handleMinValueChange(event) {
	      var value = event.target.value;
	
	      var areaFrom = this.parseValue(value);
	      if (this.state.areaFrom !== areaFrom) {
	        this.setState({ areaFrom: areaFrom }, this.updateSearch);
	      }
	      if (value && String(value).length >= 2) {
	        this.debouncedEnterMinAreaEvent();
	      }
	    }
	  }, {
	    key: 'handleMaxValueChange',
	    value: function handleMaxValueChange(event) {
	      var value = event.target.value;
	
	      var areaTo = this.parseValue(value);
	      if (this.state.areaTo !== areaTo) {
	        this.setState({ areaTo: areaTo }, this.updateSearch);
	      }
	      if (value && String(value).length >= 2) {
	        this.debouncedEnterMaxAreaEvent();
	      }
	    }
	  }, {
	    key: 'handleClearButtonClick',
	    value: function handleClearButtonClick() {
	      this.setState({ areaFrom: undefined, areaTo: undefined }, this.updateSearch);
	    }
	  }, {
	    key: 'trackInputEvent',
	    value: function trackInputEvent(inputName) {
	      var _props = this.props,
	          profile = _props.profile,
	          buildingData = _props.buildingData,
	          mode = _props.mode,
	          chessfilter = _props.chessfilter,
	          objectType = _props.objectType,
	          _props$search = _props.search,
	          areaFrom = _props$search.areaFrom,
	          areaTo = _props$search.areaTo;
	
	
	      var eventName = chessfilter ? 'buildingChessFiltersInput' : 'filterInput';
	
	      var inputValue = inputName === 'ot' ? areaFrom : areaTo;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: 'ploshchad',
	        eventContent: inputValue + ' | ' + inputName,
	        eventContext: mode,
	        productType: objectType,
	        productName: buildingData ? buildingData.title : '',
	        productID: buildingData ? buildingData.id : '',
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          chessfilter = _props2.chessfilter,
	          t = _props2.t,
	          mode = _props2.mode,
	          profile = _props2.profile,
	          objectType = _props2.objectType;
	      var _state = this.state,
	          areaFrom = _state.areaFrom,
	          areaTo = _state.areaTo;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Area2.default.Menu, className, _defineProperty({}, _Area2.default.MenuChessfilter, chessfilter)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Area2.default.Title },
	          t('components.header.filtersBar.filters.area.title'),
	          !!(areaFrom || areaTo) && _react2.default.createElement(
	            _Button2.default,
	            {
	              className: _Area2.default.Button,
	              onClick: function onClick() {
	                _this2.handleClearButtonClick();
	                (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	                  eventContent: 'ploshchad',
	                  eventContext: mode,
	                  productType: objectType,
	                  user_id: profile.id
	                }));
	              }
	            },
	            t('components.header.filtersBar.filters.area.clear')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Area2.default.Inputs },
	          _react2.default.createElement('input', {
	            value: inputDigits(areaFrom),
	            onChange: this.handleMinValueChange,
	            className: _Area2.default.Input,
	            placeholder: chessfilter ? t('components.header.filtersBar.filters.area.from') : t('components.header.filtersBar.filters.area.fromFull'),
	            maxLength: '7'
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: _Area2.default.Dash },
	            ' \u2013 '
	          ),
	          _react2.default.createElement('input', {
	            value: inputDigits(areaTo),
	            onChange: this.handleMaxValueChange,
	            className: _Area2.default.Input,
	            placeholder: chessfilter ? t('components.header.filtersBar.filters.area.to') : t('components.header.filtersBar.filters.area.toFull'),
	            maxLength: '7'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Area);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequest = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(12);
	
	var _Menu = __webpack_require__(166);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Dropdown = __webpack_require__(165);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _District = __webpack_require__(1008);
	
	var _District2 = _interopRequireDefault(_District);
	
	var _Price = __webpack_require__(479);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Area = __webpack_require__(477);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Registration = __webpack_require__(1012);
	
	var _Registration2 = _interopRequireDefault(_Registration);
	
	var _Deadline = __webpack_require__(1006);
	
	var _Deadline2 = _interopRequireDefault(_Deadline);
	
	var _Payment = __webpack_require__(1011);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _Type = __webpack_require__(1014);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _Sea = __webpack_require__(1013);
	
	var _Sea2 = _interopRequireDefault(_Sea);
	
	var _BuildingClass = __webpack_require__(1005);
	
	var _BuildingClass2 = _interopRequireDefault(_BuildingClass);
	
	var _Decoration = __webpack_require__(1007);
	
	var _Decoration2 = _interopRequireDefault(_Decoration);
	
	var _Advantages = __webpack_require__(1004);
	
	var _Advantages2 = _interopRequireDefault(_Advantages);
	
	var _TypeFilters = __webpack_require__(500);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Filters = __webpack_require__(1399);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _search = __webpack_require__(68);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ViewType = __webpack_require__(480);
	
	var _ViewType2 = _interopRequireDefault(_ViewType);
	
	var _FederalLaw = __webpack_require__(1009);
	
	var _FederalLaw2 = _interopRequireDefault(_FederalLaw);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAYMENT_HIDEN_WIDTH = 1241;
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return _extends({}, (0, _District.getRequest)(search), (0, _Price.getRequest)(search), (0, _Area.getRequest)(search), (0, _Registration.getRequest)(search), (0, _Deadline.getRequest)(search), (0, _Payment.getRequest)(search), (0, _Type.getRequest)(search), (0, _Sea.getRequest)(search), (0, _BuildingClass.getRequest)(search), (0, _Decoration.getRequest)(search), (0, _TypeFilters.getRequest)(search), (0, _ViewType.getRequest)(search), (0, _FederalLaw.getRequest)(search), (0, _Advantages.getRequest)(search));
	};
	
	var MAX_MENU_HEIGHT = 'calc(100vh - 210px)';
	
	var Filters = function (_Component) {
	  _inherits(Filters, _Component);
	
	  function Filters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Filters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filters.__proto__ || Object.getPrototypeOf(Filters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      handledFilters: {}
	    }, _this.addFilters = function () {
	      var search = (0, _utils.parseQuery)(location.search);
	      var payment = _this.props.currentWidth < PAYMENT_HIDEN_WIDTH ? search.payment ? (0, _Payment.parseSearch)(search).payment : [] : [];
	
	      var filters = {
	        building: search.buildingClass ? (0, _BuildingClass.parseSearch)(search).buildingClass : [],
	        sea: search.sea ? [(0, _Sea.parseSearch)(search).sea] : [],
	        type: search.type ? (0, _Type.parseSearch)(search).type : [],
	        payment: payment,
	        interior: search.interior ? (0, _Decoration.parseSearch)(search).interior : [],
	        advantages: search.advantages ? (0, _Advantages.parseSearch)(search).advantages : [],
	        federal_law: search.federal_law ? (0, _FederalLaw.parseSearch)(search).federal_law : []
	      };
	      _this.setState({ handledFilters: filters });
	    }, _this.getFilters = function (filters, request) {
	      var _this$props = _this.props,
	          location = _this$props.location,
	          history = _this$props.history,
	          changeFilters = _this$props.changeFilters;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var query = (0, _utils.compileQuery)(filters, search, { withoutTypeFilters: false });
	      var newSearch = query ? '?' + query : '';
	      var path = '' + pathname + newSearch;
	      history.push(path);
	      changeFilters(request, { withoutTypeFilters: true });
	    }, _this.handleFiltersOpen = function () {
	      var location = _this.props.location;
	      var pathname = location.pathname,
	          search = location.search;
	
	      _this.setState({
	        path: '' + pathname + search,
	        request: _this.props.search.request
	      });
	    }, _this.handleCancel = function () {
	      var history = _this.props.history;
	
	      if (_this.state.path && _this.state.request) {
	        history.push(_this.state.path);
	        _this.props.changeFilters(_this.state.request);
	      }
	      _this.handleClose();
	    }, _this.handleClose = function () {
	      _this.dropdown.refs.instance.hideMenu();
	    }, _this.getDropdownRef = function (r) {
	      _this.dropdown = r;
	    }, _this.clearAdditionalFilters = function (type) {
	      var filters = _this.state.handledFilters;
	      filters[type] = [];
	      _this.setState({ handledFilters: _extends({}, filters) });
	    }, _this.sendFilterEventClick = function (event) {
	      var location = _this.props.location;
	
	      var mode = location.search.includes('view=map') ? 'map' : 'list';
	
	      _tracker2.default.sendEvent(event, { mode: mode });
	    }, _this.handleFilterDropdownClick = function (_ref2) {
	      var eventLabel = _ref2.eventLabel,
	          mode = _ref2.mode,
	          objectType = _ref2.objectType;
	      var profile = _this.props.profile;
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterButtonsClick({
	        eventLabel: eventLabel,
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Filters, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addFilters();
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var location = nextProps.location;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var path = '' + pathname + search;
	      this.addFilters();
	      if (path !== sessionStorage.getItem('filtersUrl')) {
	        sessionStorage.setItem('filtersUrl', path);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _cn8;
	
	      var _props = this.props,
	          location = _props.location,
	          t = _props.t,
	          profile = _props.profile;
	
	      var search = (0, _utils.parseQuery)(location.search);
	      var _props2 = this.props,
	          className = _props2.className,
	          currency = _props2.currency;
	
	      var additionalFiltersCount = 0;
	      var isCottegePage = location.pathname.includes('/cottages');
	      Object.keys(this.state.handledFilters).map(function (key) {
	        var filter = _this2.state.handledFilters[key];
	        additionalFiltersCount += Array.isArray(filter) ? filter.length : !!filter;
	      });
	      var objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
	      var mode = location.search.includes('view=map') ? 'karta' : 'spisok';
	
	      var eventData = {
	        mode: location.search.includes('view=map') ? 'map' : 'list'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Filters2.default.Filters, className) },
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.header.filtersBar.filters.districtTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_District');
	              _this2.handleFilterDropdownClick({ eventLabel: 'raion', mode: mode, objectType: objectType });
	            },
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterDistrict, _defineProperty({}, _Filters2.default.Active, search.subregion)),
	            textStyle: _Filters2.default.Title,
	            buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(_District2.default, {
	            className: _Filters2.default.District,
	            dropdownData: this.getFilters,
	            search: search,
	            profile: profile,
	            objectType: objectType,
	            mode: mode
	          })
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.header.filtersBar.filters.priceTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Price');
	              _this2.handleFilterDropdownClick({ eventLabel: 'cena', mode: mode, objectType: objectType });
	            },
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterPrice, _defineProperty({}, _Filters2.default.Active, search.priceMin || search.priceMax || search.costMin || search.costMax)),
	            textStyle: _Filters2.default.Title,
	            subtext: search.priceMin || search.priceMax || search.costMin || search.costMax ? (0, _Price.subtext)(search) : null,
	            buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, className: 'FiltersMenu' },
	            _react2.default.createElement(_Price2.default, {
	              events: {
	                left: 'Web_Filters_Price_General',
	                right: 'Web_Filters_Price_Kv'
	              },
	              eventData: eventData,
	              dropdownData: this.getFilters,
	              search: search,
	              currency: currency,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.header.filtersBar.filters.areaTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Square');
	              _this2.handleFilterDropdownClick({ eventLabel: 'ploshchad', mode: mode, objectType: objectType });
	            },
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterArea, _defineProperty({}, _Filters2.default.Active, search.areaFrom || search.areaTo)),
	            textStyle: _Filters2.default.Title,
	            subtext: search.areaFrom || search.areaTo ? (0, _Area.subtext)(search) : null,
	            buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, className: 'FiltersMenu' },
	            _react2.default.createElement(_Area2.default, {
	              dropdownData: this.getFilters,
	              search: search,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            leftShift: true,
	            text: t('components.header.filtersBar.filters.registrationTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Decoration');
	              _this2.handleFilterDropdownClick({ eventLabel: 'oformlenie', mode: mode, objectType: objectType });
	            },
	            subtext: (0, _Registration.subtext)(search),
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterRegistration, _Filters2.default.Hide960, _defineProperty({}, _Filters2.default.Active, search.registration)),
	            textStyle: _Filters2.default.Title, buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, leftArrow: true },
	            _react2.default.createElement(_Registration2.default, {
	              eventData: eventData,
	              dropdownData: this.getFilters,
	              search: search,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            rightShift: true,
	            text: t('components.header.filtersBar.filters.registrationTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Decoration');
	              _this2.handleFilterDropdownClick({ eventLabel: 'oformlenie', mode: mode, objectType: objectType });
	            },
	            subtext: search.registration ? (0, _Registration.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterRegistration, _Filters2.default.Show960, _defineProperty({}, _Filters2.default.Active, search.registration)),
	            textStyle: _Filters2.default.Title, buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true,
	            dropdownMenuStyle: 'RegistrationDropdownMenu'
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, rightArrow: true },
	            _react2.default.createElement(_Registration2.default, {
	              eventData: eventData,
	              dropdownData: this.getFilters,
	              search: search,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            rightShift: true,
	            text: t('components.header.filtersBar.filters.deadlineTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Delivery_Deadline');
	              _this2.handleFilterDropdownClick({ eventLabel: 'varianty_oplaty', mode: mode, objectType: objectType });
	            },
	            subtext: search.deadline ? (0, _Deadline.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterDeadline, _defineProperty({}, _Filters2.default.Active, search.deadline)),
	            textStyle: _Filters2.default.Title,
	            buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, rightArrow: true },
	            _react2.default.createElement(_Deadline2.default, {
	              eventData: eventData,
	              dropdownData: this.getFilters,
	              search: search,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            rightShift: true,
	            text: t('components.header.filtersBar.filters.paymentTitle'),
	            onClick: function onClick() {
	              _this2.sendFilterEventClick('Web_Filters_Payment_Options');
	              _this2.handleFilterDropdownClick({ eventLabel: 'varianty_oplaty', mode: mode, objectType: objectType });
	            },
	            subtext: search.payment ? (0, _Payment.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterPayment, _Filters2.default.Hide1240, _defineProperty({}, _Filters2.default.Active, search.payment)),
	            textStyle: _Filters2.default.Title,
	            buttonStyle: _Filters2.default.Button,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { maxHeight: MAX_MENU_HEIGHT, rightArrow: true },
	            _react2.default.createElement(_Payment2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters,
	              search: search,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            ref: this.getDropdownRef,
	            rightShift: true,
	            onClick: function onClick() {
	              _this2.handleFilterDropdownClick({ eventLabel: 'eshchyo', mode: mode, objectType: objectType });
	            },
	            text: t('components.header.filtersBar.filters.moreTitle'),
	            additionalCount: additionalFiltersCount,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterAdditional, (_cn8 = {}, _defineProperty(_cn8, _Filters2.default.Active1240, search.payment), _defineProperty(_cn8, _Filters2.default.Active, search.type || search.sea || search.buildingClass), _cn8)),
	            textStyle: _Filters2.default.Title,
	            dropdownMenuStyle: 'AddFiltersDropdownMenu',
	            buttonStyle: _Filters2.default.Button,
	            onShow: this.handleFiltersOpen,
	            filter: true,
	            openByClick: true
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              maxHeight: 'calc(100vh - 190px)',
	              styleName: 'AdditionalFilters',
	              rightArrow: true
	            },
	            _react2.default.createElement(_Sea2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              className: _Filters2.default.AdditionalSea,
	              dropdownData: this.getFilters,
	              search: search,
	              additional: 'true',
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            _react2.default.createElement(_Payment2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters,
	              search: search,
	              additional: 'true',
	              className: (0, _classnames2.default)(_Filters2.default.Show1240),
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            _react2.default.createElement(_Decoration2.default, {
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters,
	              search: search,
	              className: _Filters2.default.AdditionalDecoration,
	              additional: 'true',
	              isCottegePage: isCottegePage,
	              eventData: eventData,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            !isCottegePage && _react2.default.createElement(_Type2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              className: _Filters2.default.AdditionalType,
	              dropdownData: this.getFilters,
	              search: search, additional: 'true',
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            _react2.default.createElement(_BuildingClass2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters,
	              search: search,
	              additional: 'true',
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            _react2.default.createElement(_Advantages2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters,
	              search: search,
	              className: _Filters2.default.AdditionalAdvantages,
	              additional: 'true',
	              isCottegePage: isCottegePage,
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            }),
	            _react2.default.createElement(_ViewType2.default, {
	              eventData: eventData,
	              onClearClick: this.clearAdditionalFilters,
	              dropdownData: this.getFilters, search: search,
	              className: _Filters2.default.AdditionalAdvantages,
	              additional: 'true',
	              profile: profile,
	              objectType: objectType,
	              mode: mode
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Filters;
	}(_react.Component);
	
	var mapStateToProps = (0, _reselect.createSelector)(function (state) {
	  return state.search;
	}, function (state) {
	  return state.environment.width;
	}, function (state) {
	  return state.profile;
	}, function (search, currentWidth, profile) {
	  return { search: search, currentWidth: currentWidth, profile: profile };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(mapStateToProps, { changeFilters: _search.changeFilters }, null, { pure: false })((0, _reactRouterDom.withRouter)(Filters)));

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(12);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Price = __webpack_require__(1402);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Switcher = __webpack_require__(1116);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var digits = function digits(number) {
	  return number ? (0, _utils.formatNumber)(number) : '...';
	};
	var inputDigits = function inputDigits(number) {
	  var parsed = parseInt(number, 10);
	  return Number(number) === '0' || isNaN(parsed) ? '' : (0, _utils.formatNumber)(parsed);
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var costMin = search.costMin,
	      costMax = search.costMax,
	      priceMin = search.priceMin,
	      priceMax = search.priceMax;
	
	  if (priceMin || priceMax) {
	    return {
	      valueMin: priceMin ? String(priceMin) : '',
	      valueMax: priceMax ? String(priceMax) : '',
	      isChecked: false
	    };
	  }
	  return {
	    valueMin: costMin ? String(costMin) : '',
	    valueMax: costMax ? String(costMax) : '',
	    isChecked: true
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var valueMin = data.valueMin,
	      valueMax = data.valueMax,
	      isChecked = data.isChecked;
	
	  var min = valueMin ? Number(valueMin) : undefined;
	  var max = valueMax ? Number(valueMax) : undefined;
	  return isChecked ? { costMin: min, costMax: max, priceMin: undefined, priceMax: undefined } : { costMin: undefined, costMax: undefined, priceMin: min, priceMax: max };
	};
	
	var compileRequest = exports.compileRequest = compileSearch;
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      valueMin = _parseSearch.valueMin,
	      valueMax = _parseSearch.valueMax,
	      isChecked = _parseSearch.isChecked;
	
	  if (valueMin || valueMax) {
	    if (isChecked) {
	      var valueMaxFin = void 0,
	          valueMinFin = void 0;
	      if (parseFloat(valueMax) % 1000000 == 0 && parseFloat(valueMin) % 1000000 == 0) {
	        valueMaxFin = _i18n2.default.t('components.header.filtersBar.filters.price.cost', {
	          price: valueMax.substring(0, valueMax.length - 6)
	        });
	        valueMinFin = _i18n2.default.t('components.header.filtersBar.filters.price.cost', {
	          price: valueMin.substring(0, valueMin.length - 6)
	        });
	        return valueMinFin + ' - ' + valueMaxFin;
	      } else if (parseFloat(valueMax) % 1000000 == 0) {
	        valueMaxFin = _i18n2.default.t('components.header.filtersBar.filters.price.cost', {
	          price: valueMax.substring(0, valueMax.length - 6)
	        });
	        return digits(valueMin) + ' - ' + valueMaxFin;
	      } else if (parseFloat(valueMin) % 1000000 == 0) {
	        valueMinFin = _i18n2.default.t('components.header.filtersBar.filters.price.cost', {
	          price: valueMin.substring(0, valueMin.length - 6)
	        });
	        return valueMinFin + ' - ' + digits(valueMax);
	      }
	      return digits(valueMin) + ' - ' + digits(valueMax);
	    }
	
	    return _i18n2.default.t('components.header.filtersBar.filters.price.perMeter', {
	      min: digits(valueMin),
	      max: digits(valueMax)
	    });
	  }
	  return _i18n2.default.t('components.header.filtersBar.filters.price.notSelected');
	};
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (ref) {
	      _this.ref = ref;
	    }, _this.updateValue = function () {
	      var oldLength = _this.ref.value.length;
	      var oldIdx = _this.ref.selectionStart;
	      _this.ref.value = _this.props.value;
	      if (document.activeElement === _this.ref) {
	        var newIdx = Math.max(0, _this.ref.value.length - oldLength + oldIdx);
	        _this.ref.selectionStart = _this.ref.selectionEnd = newIdx;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Input, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateValue();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var checked = this.props.checked;
	
	      return _react2.default.createElement('input', _extends({ ref: this.getRef }, this.props, { value: undefined, maxLength: checked ? 11 : 8 }));
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	var Price = function (_Component2) {
	  _inherits(Price, _Component2);
	
	  function Price(props) {
	    _classCallCheck(this, Price);
	
	    var _this2 = _possibleConstructorReturn(this, (Price.__proto__ || Object.getPrototypeOf(Price)).call(this, props));
	
	    _this2.state = _extends({}, parseSearch(props.search));
	
	    _this2.handleMinValueChange = _this2.handleMinValueChange.bind(_this2);
	    _this2.handleMaxValueChange = _this2.handleMaxValueChange.bind(_this2);
	    _this2.handleClearButtonClick = _this2.handleClearButtonClick.bind(_this2);
	    _this2.handleSwitcherClick = _this2.handleSwitcherClick.bind(_this2);
	    _this2.updateSearch = _this2.updateSearch.bind(_this2);
	
	    _this2.debouncedEnterMinPriceEvent = (0, _lodash2.default)(_this2.trackInputEvent.bind(_this2, 'ot'), 3000);
	    _this2.debouncedEnterMaxPriceEvent = (0, _lodash2.default)(_this2.trackInputEvent.bind(_this2, 'do'), 3000);
	    return _this2;
	  }
	
	  _createClass(Price, [{
	    key: 'handleMinValueChange',
	    value: function handleMinValueChange(event) {
	      var valueMin = this.parseValue(event.target.value);
	      var cb = valueMin !== this.state.valueMin ? this.updateSearch : function (_) {
	        return _;
	      };
	      this.setState({ valueMin: valueMin }, cb);
	      if (valueMin && String(valueMin).length >= 2) {
	        this.debouncedEnterMinPriceEvent();
	      }
	    }
	  }, {
	    key: 'handleMaxValueChange',
	    value: function handleMaxValueChange(event) {
	      var valueMax = this.parseValue(event.target.value);
	      var cb = valueMax !== this.state.valueMax ? this.updateSearch : function (_) {
	        return _;
	      };
	      this.setState({ valueMax: valueMax }, cb);
	      if (valueMax && String(valueMax).length >= 2) {
	        this.debouncedEnterMaxPriceEvent();
	      }
	    }
	  }, {
	    key: 'handleClearButtonClick',
	    value: function handleClearButtonClick() {
	      var _props = this.props,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	
	      this.setState({ valueMin: '', valueMax: '' }, this.updateSearch);
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'cena',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleSwitcherClick',
	    value: function handleSwitcherClick(checked) {
	      var _this3 = this;
	
	      var _state = this.state,
	          valueMin = _state.valueMin,
	          valueMax = _state.valueMax;
	
	      this.setState({ isChecked: checked }, function () {
	        if (valueMin || valueMax) {
	          _this3.updateSearch();
	        }
	      });
	    }
	  }, {
	    key: 'updateSearch',
	    value: function updateSearch() {
	      var dropdownData = this.props.dropdownData;
	
	      var compiled = compileSearch(this.state);
	      dropdownData(compiled, compiled);
	    }
	  }, {
	    key: 'parseValue',
	    value: function parseValue(value) {
	      var parsed = Number(parseInt(value.replace(/\s/g, ''), 10));
	      return value ? isNaN(parsed) ? undefined : parsed : undefined;
	    }
	  }, {
	    key: 'trackInputEvent',
	    value: function trackInputEvent(inputName) {
	      var _props2 = this.props,
	          profile = _props2.profile,
	          buildingData = _props2.buildingData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          chessfilter = _props2.chessfilter,
	          _props2$search = _props2.search,
	          costMin = _props2$search.costMin,
	          costMax = _props2$search.costMax,
	          priceMin = _props2$search.priceMin,
	          priceMax = _props2$search.priceMax;
	      var isChecked = this.state.isChecked;
	
	
	      var eventName = chessfilter ? 'buildingChessFiltersInput' : 'filterInput';
	
	      var valueName = isChecked ? { min: costMin, max: costMax } : { min: priceMin, max: priceMax };
	      var inputValue = inputName === 'ot' ? valueName.min : valueName.max;
	      var eventLabel = isChecked ? 'obshchaya_cena' : 'cena_za_m';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: inputValue + ' | ' + inputName,
	        eventContext: mode,
	        productType: objectType,
	        productName: buildingData ? buildingData.title : '',
	        productID: buildingData ? buildingData.id : '',
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          chessfilter = _props3.chessfilter,
	          events = _props3.events,
	          eventData = _props3.eventData,
	          t = _props3.t,
	          currency = _props3.currency;
	      var _state2 = this.state,
	          isChecked = _state2.isChecked,
	          valueMin = _state2.valueMin,
	          valueMax = _state2.valueMax;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Price2.default.Menu, className, _defineProperty({}, _Price2.default.MenuChessfilter, chessfilter)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Price2.default.Title },
	          !chessfilter ? t('components.header.filtersBar.filters.price.title') : null,
	          _react2.default.createElement(_Switcher2.default, {
	            onClick: this.handleSwitcherClick,
	            defaultChecked: isChecked,
	            enabledColor: '#085286',
	            events: events,
	            eventData: eventData,
	            leftText: chessfilter ? t('components.header.filtersBar.filters.price.commonPriceWithCurrency', { currency: currency }) : t('components.header.filtersBar.filters.price.commonPrice'),
	            rightText: chessfilter ? t('components.header.filtersBar.filters.price.commonPriceMeterWithCurrency', { currency: currency }) : t('components.header.filtersBar.filters.price.commonPriceMeter'),
	            className: (0, _classnames2.default)(_Price2.default.Switcher),
	            chessfilter: chessfilter
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Price2.default.Inner },
	          _react2.default.createElement(
	            'div',
	            { className: _Price2.default.Inputs },
	            _react2.default.createElement(Input, {
	              value: inputDigits(valueMin),
	              onChange: this.handleMinValueChange,
	              className: _Price2.default.Input,
	              placeholder: t('components.header.filtersBar.filters.price.from'),
	              checked: isChecked
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: _Price2.default.Dash },
	              ' \u2013 '
	            ),
	            _react2.default.createElement(Input, {
	              value: inputDigits(valueMax),
	              onChange: this.handleMaxValueChange,
	              className: _Price2.default.Input,
	              placeholder: t('components.header.filtersBar.filters.price.to'),
	              checked: isChecked
	            })
	          ),
	          !!(valueMin || valueMax) && _react2.default.createElement(
	            _Button2.default,
	            {
	              className: (0, _classnames2.default)(_Price2.default.Button),
	              onClick: this.handleClearButtonClick
	            },
	            t('components.header.filtersBar.filters.price.clear')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Price;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Price);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _style = __webpack_require__(1406);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// eslint-disable-next-line import/first
	
	
	var variants = {
	  intoYard: {
	    param: 'intoYard',
	    key: 'intoYard',
	    text: _i18n2.default.t('constants.view_type.filter.intoYard'),
	    event: 'Web_Filters_Into_Yard',
	    chessEvent: 'Web_List_Filters_Into_Yard'
	  },
	  toMountains: {
	    param: 'toMountains',
	    key: 'toMountains',
	    text: _i18n2.default.t('constants.view_type.filter.toMountains'),
	    event: 'Web_Filters_To_Mountains',
	    chessEvent: 'Web_List_Filters_To_Mountains'
	  },
	  onSea: {
	    param: 'onSea',
	    key: 'onSea',
	    text: _i18n2.default.t('constants.view_type.filter.onSea'),
	    event: 'Web_Filters_On_Sea',
	    chessEvent: 'Web_List_Filters_On_Sea'
	  },
	  toPark: {
	    param: 'toPark',
	    key: 'toPark',
	    text: _i18n2.default.t('constants.view_type.filter.toPark'),
	    event: 'Web_Filters_To_Park',
	    chessEvent: 'Web_List_Filters_To_Park'
	  },
	  toGarden: {
	    param: 'toGarden',
	    key: 'toGarden',
	    text: _i18n2.default.t('constants.view_type.filter.toGarden'),
	    event: 'Web_Filters_To_Garden',
	    chessEvent: 'Web_List_Filters_To_Garden'
	  },
	  toForest: {
	    param: 'toForest',
	    key: 'toForest',
	    text: _i18n2.default.t('constants.view_type.filter.toForest'),
	    event: 'Web_Filters_To_Forest',
	    chessEvent: 'Web_List_Filters_To_Forest'
	  },
	  onSocialObjects: {
	    param: 'onSocialObjects',
	    key: 'onSocialObjects',
	    text: _i18n2.default.t('constants.view_type.filter.onSocialObjects'),
	    event: 'Web_Filters_On_Social_Objects',
	    chessEvent: 'Web_List_Filters_On_Social_Object'
	  },
	  panoramicView: {
	    param: 'panoramicView',
	    key: 'panoramicView',
	    text: _i18n2.default.t('constants.view_type.filter.panoramicView'),
	    event: 'Web_Filters_Panoramic_View',
	    chessEvent: 'Web_List_Filters_Panoramic_View'
	  }
	};
	
	var defaultViewTypes = {
	  intoYard: false,
	  toMountains: false,
	  onSea: false,
	  toPark: false,
	  toGarden: false,
	  toForest: false,
	  onSocialObjects: false,
	  panoramicView: false
	};
	
	// ////////////////////////////
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var view_type = search.view_type;
	
	
	  if (!view_type) {
	    return { view_type: [] };
	  }
	  var keys = view_type.split(',');
	  return {
	    view_type: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.view_type;
	
	  if (!keys || !keys.length) {
	    return { view_type: undefined };
	  }
	
	  return {
	    view_type: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var view_type = data.view_type;
	
	  return { view_type: view_type.length ? view_type : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.view_type;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.viewTypes.notSelected');
	};
	
	var ViewTypes = function (_Component) {
	  _inherits(ViewTypes, _Component);
	
	  function ViewTypes(props) {
	    _classCallCheck(this, ViewTypes);
	
	    var _this = _possibleConstructorReturn(this, (ViewTypes.__proto__ || Object.getPrototypeOf(ViewTypes)).call(this, props));
	
	    _this.calculateList = function () {
	      if (!_this.props.chessfilter) {
	        return;
	      }
	
	      _this.list = _this.props.cells.reduce(function (list, cell) {
	        return cell.data.view_type ? list.add(cell.data.view_type) : list;
	      }, new Set());
	    };
	
	    _this.state = {
	      isExpanded: false
	    };
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    _this.calculateList();
	    _this.toggleExpand = _this.toggleExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(ViewTypes, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      this.calculateList();
	    }
	  }, {
	    key: 'handleClearClick',
	    value: function handleClearClick(e) {
	      e.stopPropagation();
	      var _props = this.props,
	          search = _props.search,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var _parseSearch2 = parseSearch(search),
	          view_type = _parseSearch2.view_type;
	
	      var data = { view_type: defaultViewTypes };
	      var compiledSearch = compileSearch(data);
	
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick(Object.keys(view_type));
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'eshchyo',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile,
	          chessfilter = _props2.chessfilter,
	          buildingData = _props2.buildingData;
	
	      var _parseSearch3 = parseSearch(search),
	          keys = _parseSearch3.view_type;
	
	      var view_type = [].concat(_toConsumableArray(keys));
	      var id = eventData.id,
	          name = eventData.name;
	
	
	      var eventName = chessfilter ? 'buildingChessFilterCheckboxesClick' : 'filterCheckboxesClick';
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        productName: buildingData && buildingData.title,
	        productID: buildingData && buildingData.id,
	        user_id: profile.id
	      }));
	
	      if (eventData) {
	        if (id) {
	          _tracker2.default.sendEvent(variants[key].chessEvent, { name: name, id: id });
	        } else {
	          _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	        }
	      }
	
	      if (!view_type.includes(key)) {
	        view_type.push(key);
	      } else {
	        view_type.splice(view_type.indexOf(key), 1);
	      }
	
	      var data = { view_type: view_type };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      if (this.props.chessfilter && !this.list.has(key)) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch4 = parseSearch(search),
	          view_type = _parseSearch4.view_type;
	
	      var variant = variants[key];
	
	      return _react2.default.createElement(_Checkbox2.default, {
	        key: variant.key,
	        className: _style2.default.Checkbox,
	        innerStyle: _style2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: view_type.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        additional: additional,
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'toggleExpand',
	    value: function toggleExpand() {
	      this.setState(function (prevState) {
	        return { isExpanded: !prevState.isExpanded };
	      });
	    }
	  }, {
	    key: 'getSelectedCount',
	    value: function getSelectedCount() {
	      var search = this.props.search;
	
	      var _parseSearch5 = parseSearch(search),
	          view_type = _parseSearch5.view_type;
	
	      return view_type.length;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          chessfilter = _props4.chessfilter,
	          search = _props4.search,
	          t = _props4.t;
	
	      var _parseSearch6 = parseSearch(search),
	          view_type = _parseSearch6.view_type;
	
	      var isViewTypesDefined = !!view_type.length;
	      var isExpanded = this.state.isExpanded;
	
	      var selectedCount = this.getSelectedCount();
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.Menu, className, _defineProperty({}, _style2.default.Additional, additional)) },
	        chessfilter ? _react2.default.createElement(
	          'p',
	          { className: _style2.default.ChessFilterTitle },
	          t('components.header.filtersBar.filters.viewTypes.chooseViewType')
	        ) : _react2.default.createElement(
	          'div',
	          { className: _style2.default.Header, onClick: this.toggleExpand },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.Title },
	            t('components.header.filtersBar.filters.viewTypes.title'),
	            selectedCount > 0 && ' (' + selectedCount + ')',
	            _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_style2.default.Icon, _defineProperty({}, _style2.default.Active, isExpanded)) })
	          ),
	          additional && isViewTypesDefined && _react2.default.createElement(
	            _Button2.default,
	            { className: _style2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.viewTypes.clear')
	          )
	        ),
	        chessfilter ? _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_style2.default.Checkboxes, _defineProperty({}, _style2.default.CheckboxesInChess, this.props.chessfilter))
	          },
	          this.checkbox('intoYard'),
	          this.checkbox('onSea'),
	          this.checkbox('toGarden'),
	          this.checkbox('toMountains'),
	          this.checkbox('panoramicView'),
	          this.checkbox('onSocialObjects'),
	          this.checkbox('toForest'),
	          this.checkbox('toPark')
	        ) : isExpanded && _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_style2.default.Checkboxes, _defineProperty({}, _style2.default.CheckboxesInChess, this.props.chessfilter))
	          },
	          this.checkbox('intoYard'),
	          this.checkbox('onSea'),
	          this.checkbox('toGarden'),
	          this.checkbox('toMountains'),
	          this.checkbox('panoramicView'),
	          this.checkbox('onSocialObjects'),
	          this.checkbox('toForest'),
	          this.checkbox('toPark')
	        )
	      );
	    }
	  }]);
	
	  return ViewTypes;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(ViewTypes);

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _Logo = __webpack_require__(1409);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _objects = __webpack_require__(99);
	
	var _logo = __webpack_require__(1581);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import logoNg from 'assets/images/logoNg.png';
	
	var Logo = function Logo(_ref) {
	  var className = _ref.className,
	      nolink = _ref.nolink,
	      _ref$to = _ref.to,
	      to = _ref$to === undefined ? '/' : _ref$to;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var history = (0, _reactRouterDom.useHistory)();
	  // const location = useLocation();
	
	  // const logoSrc = location.pathname.startsWith('/ncollection') ? logo : logoNg;
	
	  var handleClick = function handleClick(e) {
	    e.preventDefault();
	    history.push(sessionStorage.getItem('filtersUrl') || to);
	    dispatch((0, _objects.setScrollTop)(null));
	  };
	
	  return nolink ? _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: _Logo2.default.Logo },
	      _react2.default.createElement('img', { alt: 'logo', src: _logo2.default })
	    )
	  ) : _react2.default.createElement(
	    'a',
	    { href: to, className: className, onClick: handleClick },
	    _react2.default.createElement(
	      'div',
	      { className: _Logo2.default.Logo },
	      _react2.default.createElement('img', { alt: 'logo', src: _logo2.default })
	    )
	  );
	};
	
	exports.default = Logo;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Select = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Select = __webpack_require__(1421);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select(props) {
	    _classCallCheck(this, Select);
	
	    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	    _this.state = {
	      toggle: false
	    };
	
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	
	    _this.toggleInput = _this.toggleInput.bind(_this);
	    _this.selectedItem = _this.selectedItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleClickOutside);
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      if (this.refs.wrapperRef && !this.refs.wrapperRef.contains(event.target)) {
	        this.setState({ toggle: false });
	      }
	    }
	  }, {
	    key: 'selectedItem',
	    value: function selectedItem(event) {
	      event.stopPropagation();
	      var onChange = this.props.onChange;
	      var value = event.target.dataset.value;
	
	      this.toggleInput();
	      onChange(value);
	    }
	  }, {
	    key: 'toggleInput',
	    value: function toggleInput() {
	      this.setState(function (prev) {
	        return { toggle: !prev.toggle };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var toggle = this.state.toggle;
	
	      var _props = this.props,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          options = _props.options,
	          onChange = _props.onChange,
	          isError = _props.isError,
	          _props$inputStyle = _props.inputStyle,
	          inputStyle = _props$inputStyle === undefined ? {} : _props$inputStyle,
	          other = _objectWithoutProperties(_props, ['value', 'placeholder', 'options', 'onChange', 'isError', 'inputStyle']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)(_Select2.default.Select, toggle && _Select2.default.Open) }, other, { ref: 'wrapperRef' }),
	        _react2.default.createElement('div', { className: _Select2.default.Backdrop, onClick: this.toggleInput }),
	        _react2.default.createElement('input', { style: _extends({}, inputStyle), readOnly: true, className: (0, _classnames2.default)(_Select2.default.Input, isError && _Select2.default.InputError), onClick: this.toggleInput, value: value, placeholder: placeholder }),
	        _react2.default.createElement('i', { onClick: this.toggleInput, className: toggle ? _Select2.default.ChevronUp : _Select2.default.ChevronDown }),
	        _react2.default.createElement(
	          'div',
	          { className: _Select2.default.Dropdown },
	          _react2.default.createElement(
	            'ul',
	            { className: _Select2.default.List },
	            options.map(function (item, index) {
	              return _react2.default.createElement(
	                'li',
	                { style: _extends({}, inputStyle), key: index, className: (0, _classnames2.default)(_Select2.default.Item, item === value && _Select2.default.selected), 'data-value': item, onClick: _this2.selectedItem },
	                item
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	// eslint-disable-next-line import/prefer-default-export
	
	
	exports.Select = Select;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormTechnicalProblem = __webpack_require__(1423);
	
	var _FormTechnicalProblem2 = _interopRequireDefault(_FormTechnicalProblem);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormTechnicalProblem(_ref) {
	  var handleCloseModal = _ref.handleCloseModal;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _FormTechnicalProblem2.default.Overlay },
	    _react2.default.createElement(
	      'div',
	      { className: _FormTechnicalProblem2.default.Modal },
	      _react2.default.createElement('div', { className: _FormTechnicalProblem2.default.CloseButton, onClick: handleCloseModal }),
	      _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: t('components.login.formTechnicalProblem.title') } })
	    )
	  );
	}
	
	exports.default = FormTechnicalProblem;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormTechnicalProblem = exports.FormRegistration = undefined;
	
	var _FormInvite = __webpack_require__(1030);
	
	var _FormInvite2 = _interopRequireDefault(_FormInvite);
	
	var _FormNumber = __webpack_require__(1034);
	
	var _FormNumber2 = _interopRequireDefault(_FormNumber);
	
	var _FormSMS = __webpack_require__(1039);
	
	var _FormSMS2 = _interopRequireDefault(_FormSMS);
	
	var _FormPasswordRestore = __webpack_require__(1036);
	
	var _FormPasswordRestore2 = _interopRequireDefault(_FormPasswordRestore);
	
	var _FormNotConnected = __webpack_require__(1032);
	
	var _FormNotConnected2 = _interopRequireDefault(_FormNotConnected);
	
	var _FormRegistration = __webpack_require__(1037);
	
	var _FormRegistration2 = _interopRequireDefault(_FormRegistration);
	
	var _FormTechnicalProblem = __webpack_require__(483);
	
	var _FormTechnicalProblem2 = _interopRequireDefault(_FormTechnicalProblem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FormRegistration = _FormRegistration2.default;
	exports.FormTechnicalProblem = _FormTechnicalProblem2.default;
	exports.default = {
	  FormInvite: _FormInvite2.default,
	  FormNumber: _FormNumber2.default,
	  FormSMS: _FormSMS2.default,
	  FormPasswordRestore: _FormPasswordRestore2.default,
	  FormNotConnected: _FormNotConnected2.default
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(274);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1425);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import iconClose from 'assets/images/icons/icon-close.svg';
	
	
	var Notification = function (_Component) {
	  _inherits(Notification, _Component);
	
	  function Notification() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Notification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.resetTimeout = function () {
	      _this.clearTimeout();
	      _this.timeout = setTimeout(function (_) {
	        _this.handleCloseClick();
	      }, _this.props.timeout || _this.props.status === 1 ? 6000 : 3000);
	    }, _this.clearTimeout = function () {
	      if (_this.timeout) {
	        clearTimeout(_this.timeout);
	      }
	    }, _this.handleCloseClick = function () {
	      var eventData = _this.props.eventData;
	
	      if (location.pathname.startsWith('/collection/manage')) {
	        _this.handleTrackEvent({
	          eventName: 'collectionNotificationButtonsClick',
	          eventLabel: 'zakryt',
	          eventContext: eventData.collectionName,
	          productType: eventData.data.type_id === 1 ? 'zhk' : 'kp_i_th',
	          productName: eventData.buildingName,
	          productID: eventData.data.id,
	          profileId: eventData.profileId
	        });
	      } else if (location.pathname.startsWith('/favorites')) {
	        _this.handleTrackEvent({
	          eventName: 'favoritesNotificationButtonsClick',
	          eventLabel: 'zakryt',
	          eventContent: eventData.buildingName,
	          profileId: eventData.profileId
	        });
	      }
	
	      _this.props.dispatch({ type: 'HIDE_NOTIFICATION' });
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	    }, _this.handleCancelClick = function () {
	      var eventData = _this.props.eventData;
	
	      if (location.pathname.startsWith('/collection/manage')) {
	        _this.handleTrackEvent({
	          eventName: 'collectionNotificationButtonsClick',
	          eventLabel: 'otmenit',
	          eventContext: eventData.collectionName,
	          productType: eventData.data.type_id === 1 ? 'zhk' : 'kp_i_th',
	          productName: eventData.buildingName,
	          productID: eventData.data.id,
	          profileId: eventData.profileId
	        });
	      } else if (location.pathname.startsWith('/favorites')) {
	        _this.handleTrackEvent({
	          eventName: 'favoritesNotificationButtonsClick',
	          eventLabel: 'otmenit',
	          eventContent: eventData.buildingName,
	          profileId: eventData.profileId
	        });
	      }
	
	      if (Array.isArray(_this.props.cancel)) {
	        Promise.all(_this.props.cancel.filter(function (_) {
	          return _;
	        }).reverse().map(function (cancel) {
	          return _this.props.dispatch(cancel());
	        })).then(function () {
	          return _this.props.dispatch({ type: 'CANCELATION_SUCCESS' });
	        });
	      } else {
	        _this.props.dispatch(_this.props.cancel());
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.clearTimeout();
	    }, _this.handleMouseLeave = function () {
	      _this.resetTimeout();
	    }, _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent,
	          eventContext = _ref2.eventContext,
	          productType = _ref2.productType,
	          productName = _ref2.productName,
	          productID = _ref2.productID,
	          profileId = _ref2.profileId;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent,
	        eventContext: eventContext,
	        productType: productType,
	        productName: productName,
	        productID: productID,
	        user_id: profileId
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Notification, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!this.props.show && nextProps.show || this.props.message !== nextProps.message) {
	        this.resetTimeout();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          message = _props.message,
	          show = _props.show,
	          _props$status = _props.status,
	          status = _props$status === undefined ? 0 : _props$status,
	          cancel = _props.cancel,
	          t = _props.t;
	
	      var color = this.props.color || (status === 1 ? '#e74c3c' : '#2ecc71');
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles2.default.NotificationWrapper, _defineProperty({}, _styles2.default.LowerNotification, location.pathname.includes('building'))),
	          style: {
	            height: show ? '40px' : '0px'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: _styles2.default.Notification,
	            style: {
	              height: '40px',
	              opacity: show && !this.props.isPopupOpen ? 1 : 0,
	              backgroundColor: color
	            },
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave
	          },
	          message,
	          status === 1 && cancel && _react2.default.createElement(
	            'span',
	            { className: _styles2.default.Cancel, onClick: this.handleCancelClick, style: { color: color } },
	            t('components.notification.cancel')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.MessageClose, onClick: this.handleCloseClick },
	            _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.notification, {
	    isPopupOpen: !!state.environment.popUp,
	    profile: state.profile
	  });
	})((0, _reactRouter.withRouter)((0, _reactI18next.withTranslation)()(Notification)));

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubscriptionBar = __webpack_require__(1053);
	
	var _SubscriptionBar2 = _interopRequireDefault(_SubscriptionBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SubscriptionBar2.default;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getNumEnding = exports.getNumEnding = function getNumEnding(iNumber, aEndings) {
	  var sEnding, i;
	  iNumber = iNumber % 100;
	  if (iNumber >= 11 && iNumber <= 19) {
	    sEnding = aEndings[2];
	  } else {
	    i = iNumber % 10;
	    switch (i) {
	      case 1:
	        sEnding = aEndings[0];break;
	      case 2:
	      case 3:
	      case 4:
	        sEnding = aEndings[1];break;
	      default:
	        sEnding = aEndings[2];
	    }
	  }
	  return sEnding;
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Avatar = __webpack_require__(1435);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _iconUserSq = __webpack_require__(236);
	
	var _iconUserSq2 = _interopRequireDefault(_iconUserSq);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon = function icon() {
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', x: '0px', y: '0px', viewBox: '0 0 486.3 486.3', width: '512px', height: '512px' },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5    c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16    C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86    c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69    c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9    c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6    c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6    c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z' }),
	        _react2.default.createElement('path', { d: 'M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1    c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5    C310.4,285.3,318.9,285.3,324.2,280z' })
	      )
	    )
	  );
	};
	
	var Avatar = function (_Component) {
	  _inherits(Avatar, _Component);
	
	  function Avatar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Avatar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	      var file = e.target.files[0];
	      var reader = new FileReader();
	      reader.onload = function (event) {
	        var preview = event.target.result;
	        _this.props.onLoadPhoto({ preview: preview, file: file });
	        _this.inEl.value = '';
	      };
	      reader.readAsDataURL(file);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          src = _props.src,
	          popup = _props.popup,
	          t = _props.t;
	
	      var message = src ? t('components.profile.avatar.update') : t('components.profile.avatar.upload');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Avatar2.default.Avatar, _Avatar2.default.HasImage, _defineProperty({}, _Avatar2.default.InPopup, popup)) },
	        _react2.default.createElement('img', { className: _Avatar2.default.Img, alt: 'avatar', src: src || _iconUserSq2.default }),
	        _react2.default.createElement(
	          'div',
	          { className: _Avatar2.default.Caption },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'i',
	              { className: _Avatar2.default.Icon },
	              icon()
	            ),
	            message
	          ),
	          _react2.default.createElement('input', { type: 'file', onChange: this.onChange, ref: function ref(inEl) {
	              _this2.inEl = inEl;
	            } })
	        )
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Avatar);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvatarUploader = __webpack_require__(1058);
	
	var _AvatarUploader2 = _interopRequireDefault(_AvatarUploader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AvatarUploader2.default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _LeaveAgencyDialog = __webpack_require__(1438);
	
	var _LeaveAgencyDialog2 = _interopRequireDefault(_LeaveAgencyDialog);
	
	var _environment = __webpack_require__(19);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _profile = __webpack_require__(40);
	
	var _loginForms = __webpack_require__(161);
	
	var _ga = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveAgencyDialog = function (_Component) {
	  _inherits(LeaveAgencyDialog, _Component);
	
	  function LeaveAgencyDialog() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LeaveAgencyDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeaveAgencyDialog.__proto__ || Object.getPrototypeOf(LeaveAgencyDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleLeaveAgencyClick = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, profile, location, eventName, _this$props2, _leaveProfileAgency, _userLogout, _setPopUp, result;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, profile = _this$props.profile, location = _this$props.location;
	              eventName = location.pathname === '/' ? 'agencyNoAccessDialogButtonsClick' : 'leaveAgencyDialogButtonsClick';
	
	
	              if (profile) {
	                (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	                  screenName: location.pathname,
	                  eventLabel: 'vyiti_agenstvo_uveren',
	                  user_id: profile.id
	                }));
	              }
	
	              _context.prev = 3;
	              _this$props2 = _this.props, _leaveProfileAgency = _this$props2.leaveProfileAgency, _userLogout = _this$props2.userLogout, _setPopUp = _this$props2.setPopUp;
	              _context.next = 7;
	              return _leaveProfileAgency();
	
	            case 7:
	              result = _context.sent;
	
	              if (!result.response.data.status) {
	                _context.next = 13;
	                break;
	              }
	
	              _context.next = 11;
	              return _userLogout();
	
	            case 11:
	              _context.next = 14;
	              break;
	
	            case 13:
	              _setPopUp();
	
	            case 14:
	              _context.next = 20;
	              break;
	
	            case 16:
	              _context.prev = 16;
	              _context.t0 = _context['catch'](3);
	
	              _this.handleClosePopup();
	              console.error(_context.t0);
	
	            case 20:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[3, 16]]);
	    })), _this.handleClosePopup = function () {
	      var _this$props3 = _this.props,
	          profile = _this$props3.profile,
	          location = _this$props3.location;
	
	      var eventName = location.pathname === '/' ? 'agencyNoAccessDialogButtonsClick' : 'leaveAgencyDialogButtonsClick';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        screenName: location.pathname,
	        eventLabel: 'vyiti_agenstvo_otmena',
	        user_id: profile.id
	      }));
	
	      _this.props.setPopUp();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LeaveAgencyDialog, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _LeaveAgencyDialog2.default.PopupContent },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _LeaveAgencyDialog2.default.PopupTitle },
	              t('components.profile.profileForm.leaveAgencyDialog.title')
	            ),
	            _react2.default.createElement('div', { className: _LeaveAgencyDialog2.default.Divider }),
	            _react2.default.createElement(
	              'div',
	              { className: _LeaveAgencyDialog2.default.PopupSubtitle },
	              t('components.profile.profileForm.leaveAgencyDialog.subtitle')
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: (0, _classnames2.default)(_LeaveAgencyDialog2.default.ActionBtn, _LeaveAgencyDialog2.default.LeaveAgencyButton, 'button-primary', 'button-primary--md'),
	                onClick: this.handleLeaveAgencyClick
	              },
	              t('components.profile.profileForm.leaveAgencyDialog.leave')
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: (0, _classnames2.default)(_LeaveAgencyDialog2.default.ActionBtn, _LeaveAgencyDialog2.default.LeaveAgencyButton, 'button-default', 'button-primary--md'),
	                onClick: this.handleClosePopup
	              },
	              t('components.profile.profileForm.leaveAgencyDialog.cancel')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeaveAgencyDialog;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(mapStateToProps, {
	  setPopUp: _environment.setPopUp,
	  leaveProfileAgency: _profile.leaveProfileAgency,
	  userLogout: _loginForms.userLogout
	})(LeaveAgencyDialog)));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(130);
	
	var _reactMaskedinput = __webpack_require__(2002);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _index = __webpack_require__(222);
	
	var _Profile = __webpack_require__(172);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _utils = __webpack_require__(494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var handleMaskedInputChange = function handleMaskedInputChange(input, e) {
	  // FIXME: BAD!
	  _index.store.dispatch((0, _reduxForm.change)('ProfileForm', input.name, (0, _utils.normalizePhone)(e.target.value)));
	};
	
	var handleNumberInputChange = function handleNumberInputChange(input, e) {
	  // FIXME: BAD!
	  _index.store.dispatch((0, _reduxForm.change)('CompanyForm', input.name, e.target.value.replace(/\D/g, '')));
	};
	
	var Input = function Input(_ref) {
	  var className = _ref.className,
	      label = _ref.label,
	      input = _ref.input,
	      _ref$inputProps = _ref.inputProps,
	      inputProps = _ref$inputProps === undefined ? {} : _ref$inputProps,
	      required = _ref.required,
	      id = _ref.id,
	      disabled = _ref.disabled,
	      mask = _ref.mask,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      submitFailed = _ref$meta.submitFailed;
	
	  var classes = (0, _classnames2.default)(_Profile2.default.InputWrapper, className);
	
	  var handleOnChange = input.onChange;
	
	  if (inputProps.inputType && inputProps.inputType === 'number') {
	    handleOnChange = function handleOnChange(e) {
	      return handleNumberInputChange(input, e);
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id },
	      label,
	      required ? _react2.default.createElement(
	        'span',
	        null,
	        ' *'
	      ) : null
	    ),
	    mask ? _react2.default.createElement(_reactMaskedinput2.default, _extends({
	      mask: mask,
	      className: (0, _classnames2.default)(_Profile2.default.Input, _defineProperty({}, _Profile2.default.Touched, !!input.value), _defineProperty({}, _Profile2.default.Error, error)),
	      id: id,
	      disabled: disabled
	    }, input, inputProps, {
	      onChange: function onChange(e) {
	        return handleMaskedInputChange(input, e);
	      }
	    })) : _react2.default.createElement('input', _extends({
	      className: (0, _classnames2.default)(_Profile2.default.Input, _defineProperty({}, _Profile2.default.Touched, !!input.value), _defineProperty({}, _Profile2.default.Error, error)),
	      id: id,
	      disabled: disabled
	    }, input, inputProps, {
	      onChange: handleOnChange
	    })),
	    touched && error && !disabled && submitFailed && _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)(_Profile2.default.Message, _Profile2.default.Error) },
	      error
	    )
	  );
	};
	
	exports.default = Input;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Profile = __webpack_require__(172);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Textarea(_ref) {
	  var className = _ref.className,
	      label = _ref.label,
	      input = _ref.input,
	      required = _ref.required,
	      id = _ref.id,
	      placeholder = _ref.placeholder,
	      maxLength = _ref.maxLength,
	      error = _ref.meta.error;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Profile2.default.TextareaWrap, className) },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: 'text-about' },
	      label
	    ),
	    _react2.default.createElement('textarea', _extends({
	      cols: '30',
	      rows: '10',
	      placeholder: placeholder,
	      className: _Profile2.default.Textarea
	    }, input)),
	    maxLength && _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)(_Profile2.default.Message, _defineProperty({}, _Profile2.default.Error, error)) },
	      input.value.length,
	      '/',
	      maxLength
	    )
	  );
	}
	
	exports.default = Textarea;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProfileForm = __webpack_require__(1067);
	
	var _ProfileForm2 = _interopRequireDefault(_ProfileForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProfileForm2.default;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var normalizePhone = exports.normalizePhone = function normalizePhone(value) {
	  return value.replace(/\D+/g, '');
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(130);
	
	var _Profile = __webpack_require__(172);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _socialVk = __webpack_require__(347);
	
	var _socialVk2 = _interopRequireDefault(_socialVk);
	
	var _socialOk = __webpack_require__(346);
	
	var _socialOk2 = _interopRequireDefault(_socialOk);
	
	var _socialFb = __webpack_require__(344);
	
	var _socialFb2 = _interopRequireDefault(_socialFb);
	
	var _socialInst = __webpack_require__(345);
	
	var _socialInst2 = _interopRequireDefault(_socialInst);
	
	var _socialYoutube = __webpack_require__(348);
	
	var _socialYoutube2 = _interopRequireDefault(_socialYoutube);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SocialInput = function SocialInput(_ref) {
	  var input = _ref.input,
	      placeholder = _ref.placeholder,
	      id = _ref.id;
	  return _react2.default.createElement('input', _extends({
	    className: (0, _classnames2.default)(_Profile2.default.Input, _Profile2.default.SocialInput, _defineProperty({}, _Profile2.default.Touched, !!input.value)),
	    id: id,
	    placeholder: placeholder
	  }, input));
	};
	
	var items = [{
	  name: 'vk',
	  icon: _socialVk2.default,
	  label: _i18n2.default.t('components.profile.profileForm.vk')
	}, {
	  name: 'ok',
	  icon: _socialOk2.default,
	  label: _i18n2.default.t('components.profile.profileForm.ok')
	}, {
	  name: 'facebok',
	  icon: _socialFb2.default,
	  label: 'Facebook'
	}, {
	  name: 'instagram',
	  icon: _socialInst2.default,
	  label: 'Instagram'
	}, {
	  name: 'youtube',
	  icon: _socialYoutube2.default,
	  label: 'YouTube'
	}];
	
	var Social = function (_Component) {
	  _inherits(Social, _Component);
	
	  function Social() {
	    _classCallCheck(this, Social);
	
	    return _possibleConstructorReturn(this, (Social.__proto__ || Object.getPrototypeOf(Social)).apply(this, arguments));
	  }
	
	  _createClass(Social, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Profile2.default.Social },
	        items.map(function (_ref2) {
	          var name = _ref2.name,
	              icon = _ref2.icon,
	              label = _ref2.label;
	          return _react2.default.createElement(
	            'div',
	            { className: _Profile2.default.SocialInputWrap, key: name },
	            _react2.default.createElement(_reduxForm.Field, { component: SocialInput, name: name, placeholder: t('components.profile.profileForm.profileLink') }),
	            _react2.default.createElement(
	              'label',
	              { className: _Profile2.default.SocialLabel },
	              _react2.default.createElement('img', { src: icon, alt: '' }),
	              label
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return Social;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Social);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isTariffsEnabled = exports.isTariffsEnabled = window.location.hostname !== 'app.nedvex.ru';

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RealtorCard = __webpack_require__(1071);
	
	var _RealtorCard2 = _interopRequireDefault(_RealtorCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RealtorCard2.default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RealtorPopup = __webpack_require__(1072);
	
	var _RealtorPopup2 = _interopRequireDefault(_RealtorPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RealtorPopup2.default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasRegionsInside = undefined;
	
	var _Districts = __webpack_require__(320);
	
	var _Districts2 = _interopRequireDefault(_Districts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasRegionsInside = exports.hasRegionsInside = function hasRegionsInside(items) {
	  var hasItemsInside = items.reduce(function (acc, item) {
	    if (_Districts2.default[item.id - 1] !== undefined) {
	      return acc + 1;
	    }
	
	    return acc;
	  }, 0);
	
	  return hasItemsInside > 0;
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequest = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(12);
	
	var _style = __webpack_require__(1448);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _iconNedvex = __webpack_require__(553);
	
	var _iconNedvex2 = _interopRequireDefault(_iconNedvex);
	
	var _iconNew = __webpack_require__(554);
	
	var _iconNew2 = _interopRequireDefault(_iconNew);
	
	var _iconAction = __webpack_require__(1563);
	
	var _iconAction2 = _interopRequireDefault(_iconAction);
	
	var _iconPopular = __webpack_require__(1564);
	
	var _iconPopular2 = _interopRequireDefault(_iconPopular);
	
	var _iconBlacklist = __webpack_require__(552);
	
	var _iconBlacklist2 = _interopRequireDefault(_iconBlacklist);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var newOrderFields = ['visit_day', 'visit_week', 'visit_month'];
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  var request = {
	    nedvex: search.nedvex,
	    new: search.new,
	    viewAction: search.viewAction,
	    orderField: search.orderField,
	    blackList: search.blackList
	  };
	  return request;
	};
	
	var TypeFilters = function (_Component) {
	  _inherits(TypeFilters, _Component);
	
	  function TypeFilters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TypeFilters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeFilters.__proto__ || Object.getPrototypeOf(TypeFilters)).call.apply(_ref, [this].concat(args))), _this), _this.getFilters = function (filters, request) {
	      var _this$props = _this.props,
	          location = _this$props.location,
	          history = _this$props.history,
	          changeFilters = _this$props.changeFilters;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var query = (0, _utils.compileQuery)(filters, search);
	      var newSearch = query ? '?' + query : '';
	      var path = '' + pathname + newSearch;
	
	      _this.registerFilterClick(filters);
	
	      history.push(path);
	      changeFilters(request, { reset: true });
	    }, _this.registerFilterClick = function (filters) {
	      var nedvex = filters.nedvex,
	          newBuildings = filters.new,
	          viewAction = filters.viewAction,
	          orderField = filters.orderField,
	          blackList = filters.blackList;
	
	
	      if (nedvex) {
	        _tracker2.default.sendEvent('Web_ZHK_Nedvex');
	      }
	
	      if (newBuildings) {
	        _tracker2.default.sendEvent('Web_New');
	      }
	
	      if (viewAction) {
	        _tracker2.default.sendEvent('Web_Stock');
	      }
	
	      if (orderField) {
	        _tracker2.default.sendEvent('Web_Popular');
	      }
	
	      if (blackList) {
	        _tracker2.default.sendEvent('Web_Illegal');
	      }
	    }, _this.formFilters = function (filters, options) {
	      var location = _this.props.location;
	
	      var search = (0, _utils.parseQuery)(location.search);
	      var request = {
	        nedvex: search.nedvex && filters.nedvex ? undefined : filters.nedvex,
	        new: search.new && filters.new ? undefined : filters.new,
	        viewAction: search.viewAction && filters.viewAction ? undefined : filters.viewAction,
	        orderField: newOrderFields.includes(search.orderField) && filters.orderField ? undefined : filters.orderField,
	        blackList: search.blackList && filters.blackList ? undefined : filters.blackList
	      };
	      console.log(filters, search);
	      var query = request;
	      _this.getFilters(request, query);
	    }, _this.isActive = function (filter) {
	      var location = _this.props.location;
	
	      var search = (0, _utils.parseQuery)(location.search);
	
	      if (filter === 'orderField') {
	        return newOrderFields.includes(search[filter]);
	      }
	      if (search[filter]) return true;
	    }, _this.handleButtonClick = function (_ref2) {
	      var buttonName = _ref2.buttonName,
	          isActive = _ref2.isActive;
	      var _this$props2 = _this.props,
	          mode = _this$props2.mode,
	          objectType = _this$props2.objectType,
	          profile = _this$props2.profile;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterTypeButtonsClick({
	        eventLabel: buttonName,
	        eventContent: isActive ? 'off' : 'on',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TypeFilters, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          t = _props.t,
	          isCottegesPage = _props.isCottegesPage;
	
	
	      var wrapClass = this.isActive('nedvex') || this.isActive('new') || this.isActive('viewAction') || this.isActive('orderField') || this.isActive('blackList') ? 'Active' : null;
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.TypeFiltersWrap, _style2.default[wrapClass]) },
	        isCottegesPage === false && _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_style2.default.TypeFiltersBtn, _style2.default.Nedvex, this.isActive('nedvex') && _style2.default.Active),
	            onClick: function onClick() {
	              _this2.formFilters({ nedvex: 'true' });
	              _this2.handleButtonClick({ buttonName: 'nedvex', isActive: _this2.isActive('nedvex') });
	            }
	          },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnLeft },
	            _react2.default.createElement('img', { src: _iconNedvex2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnRight },
	            'NEDVEX'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_style2.default.TypeFiltersBtn, _style2.default.New, this.isActive('new') && _style2.default.Active),
	            onClick: function onClick() {
	              _this2.formFilters({ new: 'true' });
	              _this2.handleButtonClick({ buttonName: 'novinki', isActive: _this2.isActive('new') });
	            }
	          },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnLeft },
	            _react2.default.createElement('img', { src: _iconNew2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnRight },
	            t('components.typeFilters.new')
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_style2.default.TypeFiltersBtn, _style2.default.Action, this.isActive('viewAction') && _style2.default.Active),
	            onClick: function onClick() {
	              _this2.formFilters({ viewAction: 'true' });
	              _this2.handleButtonClick({ buttonName: 'akcii', isActive: _this2.isActive('viewAction') });
	            }
	          },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnLeft },
	            _react2.default.createElement('img', { src: _iconAction2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnRight },
	            t('components.typeFilters.promo')
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_style2.default.TypeFiltersBtn, _style2.default.Popular, this.isActive('orderField') && _style2.default.Active),
	            onClick: function onClick() {
	              _this2.formFilters({ orderField: 'visit_day' });
	              _this2.handleButtonClick({
	                buttonName: 'populyarnoe',
	                isActive: _this2.isActive('orderField')
	              });
	            }
	          },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnLeft },
	            _react2.default.createElement('img', { src: _iconPopular2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.TypeFiltersBtnRight },
	            t('components.typeFilters.popular')
	          )
	        )
	      );
	    }
	  }]);
	
	  return TypeFilters;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(TypeFilters);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Avatar = __webpack_require__(1450);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avatar = function Avatar(_ref) {
	  var className = _ref.className,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Avatar2.default.Avatar, className) },
	    image ? _react2.default.createElement('img', {
	      className: _Avatar2.default.Image,
	      src: '' + image,
	      alt: 'avatar'
	    }) : _react2.default.createElement('img', { src: 'https://app.nedvx.ru/static/media/icon-user.553f82d8.svg', alt: '' })
	  );
	};
	
	exports.default = Avatar;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Input = __webpack_require__(1454);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Input = function Input(_ref) {
	  var className = _ref.className,
	      placeholder = _ref.placeholder,
	      icon = _ref.icon,
	      onKeyPress = _ref.onKeyPress,
	      onDirty = _ref.onDirty,
	      onChange = _ref.onChange,
	      onFocus = _ref.onFocus,
	      onBlur = _ref.onBlur,
	      onClick = _ref.onClick,
	      getRef = _ref.getRef,
	      defaultValue = _ref.defaultValue,
	      autofocus = _ref.autofocus,
	      onClickContainer = _ref.onClickContainer,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled,
	      rest = _objectWithoutProperties(_ref, ['className', 'placeholder', 'icon', 'onKeyPress', 'onDirty', 'onChange', 'onFocus', 'onBlur', 'onClick', 'getRef', 'defaultValue', 'autofocus', 'onClickContainer', 'disabled']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Input2.default.Container, onClick: onClickContainer },
	    icon ? icon : null,
	    _react2.default.createElement('input', {
	      onClick: onClick,
	      onKeyPress: onKeyPress,
	      onChange: onChange,
	      onBlur: onBlur,
	      onFocus: onFocus,
	      placeholder: placeholder,
	      className: (0, _classnames2.default)(_Input2.default.Input, className),
	      value: defaultValue || '',
	      ref: function ref(_input) {
	        return getRef && getRef(_input);
	      },
	      autoFocus: autofocus,
	      disabled: disabled
	    })
	  );
	};
	
	exports.default = Input;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(1456);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_Component) {
	  _inherits(Loader, _Component);
	
	  function Loader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Loader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loader.__proto__ || Object.getPrototypeOf(Loader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      remaining: 100
	    }, _this.handleTransitionEnd = function (e) {
	      if (_this.state.remaining <= 0 && e.propertyName === 'transform') {
	        _this.setState({
	          active: false
	        });
	        _this.bar.removeEventListener('transitionend', _this.handleTransitionEnd);
	      }
	    }, _this.start = function () {
	      _this.setState({
	        active: true,
	        remaining: _this.state.remaining || 100
	      });
	      _this.inc();
	    }, _this.inc = function () {
	      if (_this.state.remaining > 10) {
	        _this.setState({
	          remaining: _this.state.remaining - ~~(5 + Math.random() * _this.state.remaining / 5)
	        });
	      }
	
	      _this.timer = setTimeout(_this.inc, 150);
	    }, _this.done = function () {
	      clearTimeout(_this.timer);
	      _this.setState({ remaining: 0 }, function () {
	        _this.bar.addEventListener('transitionend', _this.handleTransitionEnd);
	      });
	    }, _this.getBarRef = function (r) {
	      _this.bar = r;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Loader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.active) {
	        this.start();
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.active && !this.props.active) {
	        this.start();
	      }
	      if (!nextProps.active && this.props.active) {
	        this.done();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _Loader2.default.loader, id: this.id },
	        _react2.default.createElement('div', {
	          ref: this.getBarRef,
	          className: _Loader2.default.bar,
	          style: {
	            opacity: this.state.active ? 1 : 0,
	            transform: 'translateX(-' + this.state.remaining + '%)',
	            transition: 'transform opacity ' + this.state.active && this.state.remaining < 100 ? '.3s' : '0s'
	          }
	        })
	      );
	    }
	  }]);
	
	  return Loader;
	}(_react.Component);
	
	exports.default = Loader;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(503);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Loader2.default;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = {
	  concierge: _i18n2.default.t('constants.features.concierge'),
	  elevator: _i18n2.default.t('constants.features.elevator'),
	  children_area: _i18n2.default.t('constants.features.children_area'),
	  landscape_decore: _i18n2.default.t('constants.features.landscape_decore'),
	  sport_area: _i18n2.default.t('constants.features.sport_area'),
	
	  is_children_room: _i18n2.default.t('constants.features.is_children_room'),
	  is_conference_hall: _i18n2.default.t('constants.features.is_conference_hall'),
	  is_wellness_building: _i18n2.default.t('constants.features.is_wellness_building'),
	  is_panoramic_glazing: _i18n2.default.t('constants.features.is_panoramic_glazing'),
	  is_beach: _i18n2.default.t('constants.features.is_beach'),
	  is_walking_area: _i18n2.default.t('constants.features.is_walking_area'),
	  is_operated_roof: _i18n2.default.t('constants.features.is_operated_roof'),
	  is_garage: _i18n2.default.t('constants.features.is_garage'),
	  is_acs_system: _i18n2.default.t('constants.features.is_acs_system'),
	  is_landscape_park: _i18n2.default.t('constants.features.is_landscape_park'),
	  is_management_company: _i18n2.default.t('constants.features.is_management_company'),
	
	  spa: _i18n2.default.t('constants.features.spa'),
	  fitness: _i18n2.default.t('constants.features.fitness'),
	  pool: _i18n2.default.t('constants.features.pool'),
	  kindergarten: _i18n2.default.t('constants.features.kindergarten'),
	  tennis_court: _i18n2.default.t('constants.features.tennis_court'),
	  recreation_zone: _i18n2.default.t('constants.features.recreation_zone'),
	  fountain: _i18n2.default.t('constants.features.fountain'),
	  garden: _i18n2.default.t('constants.features.garden'),
	  helicopter_landing_area: _i18n2.default.t('constants.features.helicopter_landing_area'),
	  commercial_property: _i18n2.default.t('constants.features.commercial_property'),
	  cctv_surveillance: _i18n2.default.t('constants.features.cctv_surveillance'),
	  kpp: _i18n2.default.t('constants.features.kpp'),
	  restaurant: _i18n2.default.t('constants.features.restaurant'),
	  billiards: _i18n2.default.t('constants.features.billiards'),
	  sauna: _i18n2.default.t('constants.features.sauna')
	};
	
	exports.default = features;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _loader = __webpack_require__(555);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _styles = __webpack_require__(1470);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Button = exports.Button = function Button(_ref) {
	  var _cn;
	
	  var _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
	      _ref$isDisabled = _ref.isDisabled,
	      isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
	      _ref$isPrimary = _ref.isPrimary,
	      isPrimary = _ref$isPrimary === undefined ? false : _ref$isPrimary,
	      children = _ref.children;
	
	  var handleClick = function handleClick() {
	    if (isLoading) {
	      return;
	    }
	
	    if (isDisabled) {
	      return;
	    }
	
	    onClick && onClick();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.Button, (_cn = {}, _defineProperty(_cn, _styles2.default.ButtonPrimary, isPrimary), _defineProperty(_cn, _styles2.default.ButtonStateDisabled, isDisabled), _defineProperty(_cn, _styles2.default.ButtonSecondary, !isPrimary), _cn)),
	      onClick: handleClick
	    },
	    isLoading ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement('img', { className: _styles2.default.Loader, src: _loader2.default }),
	      _react2.default.createElement('span', null)
	    ) : children
	  );
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Switcher = __webpack_require__(1154);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switcher2.default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStreets = exports.getBuildings = exports.getSubregions = exports.getRegions = exports.getSearchAutocomplete = exports.getSearchModalState = exports.getSearchRequestFetchStatus = exports.getSearchValueState = exports.getSearchValue = exports.getSearch = undefined;
	
	var _reselect = __webpack_require__(44);
	
	var _redux = __webpack_require__(137);
	
	var getSearch = exports.getSearch = (0, _redux.compose)(function (_ref) {
	  var search = _ref.search;
	  return search;
	}, function (state) {
	  return state;
	});
	
	var getSearchValue = exports.getSearchValue = (0, _redux.compose)(function (_ref2) {
	  var value = _ref2.value;
	  return value;
	}, getSearch);
	var getSearchValueState = exports.getSearchValueState = (0, _redux.compose)(function (_ref3) {
	  var isLoading = _ref3.isLoading;
	  return isLoading;
	}, getSearch);
	var getSearchRequestFetchStatus = exports.getSearchRequestFetchStatus = (0, _redux.compose)(function (_ref4) {
	  var isFetched = _ref4.isFetched;
	  return isFetched;
	}, getSearch);
	var getSearchModalState = exports.getSearchModalState = (0, _redux.compose)(function (_ref5) {
	  var isSearchModalOpen = _ref5.isSearchModalOpen;
	  return isSearchModalOpen;
	}, getSearch);
	
	var getSearchAutocomplete = exports.getSearchAutocomplete = (0, _redux.compose)(function (_ref6) {
	  var autocomplete = _ref6.autocomplete;
	  return autocomplete;
	}, getSearch);
	
	var getRegions = exports.getRegions = (0, _redux.compose)(function (_ref7) {
	  var regions = _ref7.regions;
	  return regions;
	}, getSearchAutocomplete);
	
	var getSubregions = exports.getSubregions = (0, _redux.compose)(function (_ref8) {
	  var subregions = _ref8.subregions;
	  return subregions;
	}, getSearchAutocomplete);
	
	var getBuildings = exports.getBuildings = (0, _redux.compose)(function (_ref9) {
	  var buildings = _ref9.buildings;
	  return buildings;
	}, getSearchAutocomplete);
	
	var getStreets = exports.getStreets = (0, _redux.compose)(function (_ref10) {
	  var streets = _ref10.streets;
	  return streets;
	}, getSearchAutocomplete);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(70)
	  , toLength  = __webpack_require__(74)
	  , toIndex   = __webpack_require__(168);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(20)
	  , hide         = __webpack_require__(95)
	  , redefineAll  = __webpack_require__(229)
	  , ctx          = __webpack_require__(79)
	  , strictNew    = __webpack_require__(231)
	  , defined      = __webpack_require__(94)
	  , forOf        = __webpack_require__(144)
	  , $iterDefine  = __webpack_require__(228)
	  , step         = __webpack_require__(326)
	  , ID           = __webpack_require__(146)('id')
	  , $has         = __webpack_require__(69)
	  , isObject     = __webpack_require__(29)
	  , setSpecies   = __webpack_require__(230)
	  , DESCRIPTORS  = __webpack_require__(73)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(144)
	  , classof = __webpack_require__(143);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide              = __webpack_require__(95)
	  , redefineAll       = __webpack_require__(229)
	  , anObject          = __webpack_require__(30)
	  , isObject          = __webpack_require__(29)
	  , strictNew         = __webpack_require__(231)
	  , forOf             = __webpack_require__(144)
	  , createArrayMethod = __webpack_require__(223)
	  , $has              = __webpack_require__(69)
	  , WEAK              = __webpack_require__(146)('weak')
	  , isExtensible      = Object.isExtensible || isObject
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for frozen keys
	var frozenStore = function(that){
	  return that._l || (that._l = new FrozenStore);
	};
	var FrozenStore = function(){
	  this.a = [];
	};
	var findFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	FrozenStore.prototype = {
	  get: function(key){
	    var entry = findFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this)['delete'](key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this).has(key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    if(!isExtensible(anObject(key))){
	      frozenStore(that).set(key, value);
	    } else {
	      $has(key, WEAK) || hide(key, WEAK, {});
	      key[WEAK][that._i] = value;
	    } return that;
	  },
	  frozenStore: frozenStore,
	  WEAK: WEAK
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29)
	  , document = __webpack_require__(34).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(30);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(70)
	  , getNames  = __webpack_require__(20).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34).document && document.documentElement;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(145)
	  , ITERATOR   = __webpack_require__(35)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(29)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(29)
	  , cof      = __webpack_require__(100)
	  , MATCH    = __webpack_require__(35)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(30);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(20)
	  , toIObject = __webpack_require__(70);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(20)
	  , ownKeys   = __webpack_require__(331)
	  , toIObject = __webpack_require__(70);
	
	module.exports = function define(target, mixin){
	  var keys   = ownKeys(toIObject(mixin))
	    , length = keys.length
	    , i = 0, key;
	  while(length > i)$.setDesc(target, key = keys[i++], $.getDesc(mixin, key));
	  return target;
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(20)
	  , toIObject = __webpack_require__(70)
	  , isEnum    = $.isEnum;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34);

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-string-pad-left-right
	var toLength = __webpack_require__(74)
	  , repeat   = __webpack_require__(529)
	  , defined  = __webpack_require__(94);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength)return S;
	  if(fillStr == '')fillStr = ' ';
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(169)
	  , defined   = __webpack_require__(94);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(79)
	  , invoke             = __webpack_require__(226)
	  , html               = __webpack_require__(516)
	  , cel                = __webpack_require__(513)
	  , global             = __webpack_require__(34)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(100)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(143)
	  , ITERATOR  = __webpack_require__(35)('iterator')
	  , Iterators = __webpack_require__(145);
	module.exports = __webpack_require__(62).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(142)
	  , step             = __webpack_require__(326)
	  , Iterators        = __webpack_require__(145)
	  , toIObject        = __webpack_require__(70);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(228)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"About__Button___2KBKu","About":"About__About___3ek8w","Client":"About__Client___2Uieb","PrintButton":"About__PrintButton___3Yx54","ImageWrap":"About__ImageWrap___3b4qD","FlatInfo":"About__FlatInfo___G7bnc","Chessfilter":"About__Chessfilter___u0az4","FlatReserved":"About__FlatReserved___3Rueh","FlatReservedImage":"About__FlatReservedImage___1O6F_","FlatReservedText":"About__FlatReservedText___yiwB9","Row":"About__Row____HfeB","Wide":"About__Wide___rgJX3","RomImage":"About__RomImage___1Y5vS","Floor":"About__Floor___3kN7K","FloorNumber":"About__FloorNumber___1IVLD","Sold":"About__Sold___2J155","Price":"About__Price___3EL1H","Small":"About__Small___2gzSt","Area":"About__Area___3koqS","Status":"About__Status___2Vq1S","Loader":"About__Loader___O9A-R","loader-scale":"About__loader-scale___1x2IH","ImageInner":"About__ImageInner___18vYy","Zoom":"About__Zoom___KAslx","popupFlat":"About__popupFlat___3su4C","popupFlatBg":"About__popupFlatBg___2VGeU","popupFlatContent":"About__popupFlatContent___135zt","PopUpOuter":"About__PopUpOuter___A9p5y","PopUpInner":"About__PopUpInner___1B3Ar","TopInfo":"About__TopInfo___15EOb","BottomInfo":"About__BottomInfo___2gwAA","LeftInfo":"About__LeftInfo___2bWjb","LoaderInfo":"About__LoaderInfo___2h8Jr","RightInfo":"About__RightInfo___2parM","SoldInfo":"About__SoldInfo___2-V5y","PopupFlatInfo":"About__PopupFlatInfo___1O0Z9","FlatNum":"About__FlatNum___2N_VL","PopupTagsWrap":"About__PopupTagsWrap___BzdQ3","PriceInfo":"About__PriceInfo___Ushfc","SmallInfo":"About__SmallInfo___3zeyY","SceneButton":"About__SceneButton___m4W8O","AboutWrap":"About__AboutWrap___1_7Dw","FlatOptions":"About__FlatOptions___3m2v9","PopupFlatOptions":"About__PopupFlatOptions___ik3_v","FlatOption":"About__FlatOption___23cTj","TotalArea":"About__TotalArea___Yvv3J","CollectionWrap":"About__CollectionWrap___331cs","Collection":"About__Collection___nmSTn","CollectionButton":"About__CollectionButton___1EaF8","CollectionButtonIcon":"About__CollectionButtonIcon___22kvG","CollectionText":"About__CollectionText___XveQz","RowReserved":"About__RowReserved___1kFkO","TagPromo":"About__TagPromo___3y1wg","TagReserve":"About__TagReserve___2xO6Z","TagAssign":"About__TagAssign___1T5RL","Print":"About__Print___2btx-"};

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___3R5kD","TarifTerm":"style__TarifTerm___3QPx7","Red":"style__Red___2s4t6","IconAlert":"style__IconAlert___1thdf","TarifName":"style__TarifName___3KlQk","TarifNameMain":"style__TarifNameMain___qjDp2","TarifCircle":"style__TarifCircle___1ehSc","TarifNameWorkers":"style__TarifNameWorkers___301Lx","PayForTarifBtn":"style__PayForTarifBtn___1qi5s","rect-auto":"style__rect-auto___2Bbuv","c100":"style__c100___1cgLm","p51":"style__p51___1ZQd5","slice":"style__slice___1vb9d","p52":"style__p52___2ZInN","p53":"style__p53___1n7Ui","p54":"style__p54___2XBPn","p55":"style__p55___2MPM9","p56":"style__p56___2qAiT","p57":"style__p57___2EwXr","p58":"style__p58___390je","p59":"style__p59___21icg","p60":"style__p60___30MbE","p61":"style__p61___1k_Pr","p62":"style__p62___l5i9A","p63":"style__p63___3HJ7R","p64":"style__p64___20MA3","p65":"style__p65___3OEbu","p66":"style__p66___17kd1","p67":"style__p67___3NK14","p68":"style__p68___3yJWM","p69":"style__p69___2I2ty","p70":"style__p70___AM4S8","p71":"style__p71___FARxR","p72":"style__p72___19gJU","p73":"style__p73___2fnD6","p74":"style__p74___wSOlO","p75":"style__p75___29CzN","p76":"style__p76___QulR3","p77":"style__p77___3aA9b","p78":"style__p78___3F_qA","p79":"style__p79___2OAQQ","p80":"style__p80___2bpHN","p81":"style__p81___1-dX8","p82":"style__p82___dfjM5","p83":"style__p83___UwNj6","p84":"style__p84___2m8sV","p85":"style__p85___2m9T5","p86":"style__p86___Hf3jb","p87":"style__p87___1LGIY","p88":"style__p88___1nsVH","p89":"style__p89___jOoby","p90":"style__p90___39AuG","p91":"style__p91___sZvep","p92":"style__p92___mBJas","p93":"style__p93___BGd74","p94":"style__p94___28yTV","p95":"style__p95___1y39W","p96":"style__p96___VM3Ft","p97":"style__p97___Jx696","p98":"style__p98___1HL7a","p99":"style__p99___pw-FY","p100":"style__p100___2y0Wk","pie":"style__pie___1Bs9A","bar":"style__bar___sz4JX","fill":"style__fill___gHAAc","pie-fill":"style__pie-fill___19q0G","p1":"style__p1___37aKj","p2":"style__p2___1KMGw","p3":"style__p3___O4jEF","p4":"style__p4___3twCq","p5":"style__p5___3ZtTT","p6":"style__p6___1YbUJ","p7":"style__p7___-tkFz","p8":"style__p8___2oaUr","p9":"style__p9___2P-Vn","p10":"style__p10___3T0wB","p11":"style__p11___1levs","p12":"style__p12___3P7cD","p13":"style__p13___3zZWs","p14":"style__p14___1e96b","p15":"style__p15___2Dcdt","p16":"style__p16___3aA8n","p17":"style__p17___3vPx2","p18":"style__p18___Z0jay","p19":"style__p19___hUznJ","p20":"style__p20___12_-k","p21":"style__p21___1IqFB","p22":"style__p22___EnJ8A","p23":"style__p23___1Upnt","p24":"style__p24___3_Ph-","p25":"style__p25___98W7l","p26":"style__p26___20tQq","p27":"style__p27___2LQQy","p28":"style__p28___35oHb","p29":"style__p29___Sr9g8","p30":"style__p30___2iT3I","p31":"style__p31___1cioe","p32":"style__p32___1xne_","p33":"style__p33___20up0","p34":"style__p34___3c4W_","p35":"style__p35___19Yhv","p36":"style__p36___VF4wJ","p37":"style__p37___6YeZh","p38":"style__p38___2lYH6","p39":"style__p39___3GnTU","p40":"style__p40___3RXvS","p41":"style__p41___243iU","p42":"style__p42___3HvF1","p43":"style__p43___kuIta","p44":"style__p44___2-Jzr","p45":"style__p45___3SNPP","p46":"style__p46___3XHuJ","p47":"style__p47___3Irs4","p48":"style__p48___1vytO","p49":"style__p49___2Hs_w","p50":"style__p50___2xGQP","TarifText":"style__TarifText___ZvNF1"};

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SearchModalOverlay":"style__SearchModalOverlay___23NYp","fadein":"style__fadein___1KX-o","root":"style__root___3CNv2","withContent":"style__withContent___1W4I9","searchAndFilters":"style__searchAndFilters___30IlZ","contentWrapper":"style__contentWrapper___3zrPb","content":"style__content___1lG15","spinner":"style__spinner___qnYff","close":"style__close___1SCCI","searchInput":"style__searchInput___28T0_","notFound":"style__notFound___38bva","notFoundImage":"style__notFoundImage___1nBgD","notFoundTitle":"style__notFoundTitle___2y25j","notFoundSubTitle":"style__notFoundSubTitle___3mNya"};

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PlaceInfo":"style__PlaceInfo___2LtEo","Medium":"style__Medium___Kyr4G","Flats":"style__Flats___2cbK9","FlatsCount":"style__FlatsCount___6A-f8","FlatsPrices":"style__FlatsPrices___4ohu-","arrowTop":"style__arrowTop___1Mp3N","arrowBottom":"style__arrowBottom___33_El","Loader":"style__Loader___1O3QS","loader-scale":"style__loader-scale___1cwLp","Header":"style__Header___X_VYe","ImageWrapper":"style__ImageWrapper___FNSpl","PrevButton":"style__PrevButton___UxAGO","NextButton":"style__NextButton___1_uKA","SmallImage":"style__SmallImage___SAJ1f","SmallImageHidden":"style__SmallImageHidden___1Mf1Y","BigImage":"style__BigImage___1ro3-","BigImageVisible":"style__BigImageVisible___1TlhO","Hidden":"style__Hidden___2x0Sg","WithoutPhoto":"style__WithoutPhoto___2GGFO","Address":"style__Address___34wCm","StatusTitle":"style__StatusTitle___2i1dZ","AlmostFinished":"style__AlmostFinished___SHh2h","StatusTitleNotFin":"style__StatusTitleNotFin___28MXf","PromoLabel":"style__PromoLabel___8jEel","IconButton":"style__IconButton___1OUkh","Body":"style__Body___29wOy","SoldOut":"style__SoldOut___3vYJG","Stopped":"style__Stopped___2sMWb","InfoBlock":"style__InfoBlock___5bOBO","BlockLabel":"style__BlockLabel___3bM14","BlockItem":"style__BlockItem___1K5wA","LabelWrapper":"style__LabelWrapper___2sON7","Label":"style__Label___RKHvW","Buttons":"style__Buttons___u-k2X","Favorites":"style__Favorites___1odyF","Collections":"style__Collections___nogo1","Button":"style__Button___3Y6qZ","iconPlus":"style__iconPlus___3jux6","forYourRequest":"style__forYourRequest___kpC7l","Blue":"style__Blue___3RJps","popupClose":"style__popupClose___G7Csj"};

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Landing":"Landing__Landing___t1QSj"};

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/alert.4cff03bd.svg";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/carousel-arrow-left.632c5d96.svg";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/close.a3529636.svg";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-heart-active-blue.c43bb922.svg";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-heart-active.3521ff10.svg";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-jpg.1b09cbb8.svg";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-link-dark.e6efd6db.svg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-photos.0d36d7c1.svg";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-search-map.d3e3d25d.svg";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-user.553f82d8.svg";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-verified.a360b8f3.svg";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-xls.bdd70c65.svg";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-blacklist.284f6bd0.svg";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-nedvex.2d093b5f.svg";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-new.bb07ccb8.svg";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/loader.adfc7800.svg";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/random_house.537abd05.svg";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(539);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _omit = __webpack_require__(561);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/forbid-prop-types */
	
	var mainStyle = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var style = {
	  width: 0,
	  height: 0,
	  left: 0,
	  top: 0,
	  backgroundColor: 'transparent',
	  position: 'absolute'
	};
	
	var GoogleMapMarkers = function (_Component) {
	  _inherits(GoogleMapMarkers, _Component);
	
	  function GoogleMapMarkers(props) {
	    _classCallCheck(this, GoogleMapMarkers);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this._getState = function () {
	      return {
	        children: _this.props.dispatcher.getChildren(),
	        updateCounter: _this.props.dispatcher.getUpdateCounter()
	      };
	    };
	
	    _this._onChangeHandler = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var prevChildCount = (_this.state.children || []).length;
	      var state = _this._getState();
	
	      _this.setState(state, function () {
	        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
	      });
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // click works only on hovered item
	          _this.props.onChildClick(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseDown = function () {
	      if (_this.props.onChildMouseDown) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // works only on hovered item
	          _this.props.onChildMouseDown(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function (hoverKey, childProps) {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      if (_this.props.onChildMouseEnter) {
	        _this.props.onChildMouseEnter(hoverKey, childProps);
	      }
	
	      _this.hoverChildProps_ = childProps;
	      _this.hoverKey_ = hoverKey;
	      _this.setState({ hoverKey: hoverKey });
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var hoverKey = _this.hoverKey_;
	      var childProps = _this.hoverChildProps_;
	
	      if (hoverKey !== undefined && hoverKey !== null) {
	        if (_this.props.onChildMouseLeave) {
	          _this.props.onChildMouseLeave(hoverKey, childProps);
	        }
	
	        _this.hoverKey_ = null;
	        _this.hoverChildProps_ = null;
	        _this.setState({ hoverKey: null });
	      }
	    };
	
	    _this._onMouseAllow = function (value) {
	      if (!value) {
	        _this._onChildMouseLeave();
	      }
	
	      _this.allowMouse_ = value;
	    };
	
	    _this._onMouseChangeHandler = function () {
	      if (_this.allowMouse_) {
	        _this._onMouseChangeHandlerRaf();
	      }
	    };
	
	    _this._onMouseChangeHandlerRaf = function () {
	      if (!_this.dimesionsCache_) {
	        return;
	      }
	
	      var mp = _this.props.dispatcher.getMousePosition();
	
	      if (mp) {
	        var distances = [];
	        var hoverDistance = _this.props.getHoverDistance();
	
	        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
	          if (!child) return;
	          // layers
	          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	            return;
	          }
	
	          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	          var dist = _this.props.distanceToMouse(_this.dimesionsCache_[childKey], mp, child.props);
	          if (dist < hoverDistance) {
	            distances.push({
	              key: childKey,
	              dist: dist,
	              props: child.props
	            });
	          }
	        });
	
	        if (distances.length) {
	          distances.sort(function (a, b) {
	            return a.dist - b.dist;
	          });
	          var hoverKey = distances[0].key;
	          var childProps = distances[0].props;
	
	          if (_this.hoverKey_ !== hoverKey) {
	            _this._onChildMouseLeave();
	
	            _this._onChildMouseEnter(hoverKey, childProps);
	          }
	        } else {
	          _this._onChildMouseLeave();
	        }
	      } else {
	        _this._onChildMouseLeave();
	      }
	    };
	
	    _this._getDimensions = function (key) {
	      var childKey = key;
	      return _this.dimesionsCache_[childKey];
	    };
	
	    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
	    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
	    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
	    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);
	
	    _this.dimesionsCache_ = {};
	    _this.hoverKey_ = null;
	    _this.hoverChildProps_ = null;
	    _this.allowMouse_ = true;
	
	    _this.state = _extends({}, _this._getState(), { hoverKey: null });
	    return _this;
	  }
	
	  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    if (this.props.experimental === true) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
	    }
	
	    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	  };
	
	  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
	    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
	    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
	    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);
	
	    this.dimesionsCache_ = null;
	  };
	
	  GoogleMapMarkers.prototype.render = function render() {
	    var _this2 = this;
	
	    var mainElementStyle = this.props.style || mainStyle;
	    this.dimesionsCache_ = {};
	
	    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
	      if (!child) return undefined;
	      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	        return _react2.default.cloneElement(child, {
	          $geoService: _this2.props.geoService,
	          $onMouseAllow: _this2._onMouseAllow,
	          $prerender: _this2.props.prerender
	        });
	      }
	
	      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };
	
	      var pt = _this2.props.geoService.project(latLng, _this2.props.projectFromLeftTop);
	
	      var stylePtPos = {
	        left: pt.x,
	        top: pt.y
	      };
	
	      var dx = 0;
	      var dy = 0;
	
	      if (!_this2.props.projectFromLeftTop) {
	        // center projection
	        if (_this2.props.geoService.hasSize()) {
	          dx = _this2.props.geoService.getWidth() / 2;
	          dy = _this2.props.geoService.getHeight() / 2;
	        }
	      }
	
	      // to prevent rerender on child element i need to pass
	      // const params $getDimensions and $dimensionKey instead of dimension object
	      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	
	      _this2.dimesionsCache_[childKey] = _extends({
	        x: pt.x + dx,
	        y: pt.y + dy
	      }, latLng);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: childKey,
	          style: _extends({}, style, stylePtPos),
	          className: child.props.$markerHolderClassName
	        },
	        _react2.default.cloneElement(child, {
	          $hover: childKey === _this2.state.hoverKey,
	          $getDimensions: _this2._getDimensions,
	          $dimensionKey: childKey,
	          $geoService: _this2.props.geoService,
	          $onMouseAllow: _this2._onMouseAllow,
	          $prerender: _this2.props.prerender
	        })
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { style: mainElementStyle },
	      markers
	    );
	  };
	
	  return GoogleMapMarkers;
	}(_react.Component);
	
	GoogleMapMarkers.propTypes = {
	  geoService: _propTypes2.default.any,
	  style: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  dispatcher: _propTypes2.default.any,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  getHoverDistance: _propTypes2.default.func,
	  projectFromLeftTop: _propTypes2.default.bool,
	  prerender: _propTypes2.default.bool
	};
	GoogleMapMarkers.defaultProps = {
	  projectFromLeftTop: false,
	  prerender: false
	};
	exports.default = GoogleMapMarkers;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _wrap2 = __webpack_require__(559);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LatLng = function () {
	  function LatLng(lat, lng) {
	    _classCallCheck(this, LatLng);
	
	    if (isNaN(lat) || isNaN(lng)) {
	      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	    }
	    this.lat = +lat;
	    this.lng = +lng;
	  }
	
	  LatLng.prototype.wrap = function wrap() {
	    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
	  };
	
	  return LatLng;
	}();
	
	LatLng.convert = function (a) {
	  if (a instanceof LatLng) {
	    return a;
	  }
	
	  if (Array.isArray(a)) {
	    return new LatLng(a[0], a[1]);
	  }
	
	  if ('lng' in a && 'lat' in a) {
	    return new LatLng(a.lat, a.lng);
	  }
	
	  return a;
	};
	
	exports.default = LatLng;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.wrap = wrap;
	/* eslint-disable import/prefer-default-export */
	
	function wrap(n, min, max) {
	  var d = max - min;
	  return n === max ? n : ((n - min) % d + d) % d + min;
	}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var log2 = Math.log2 ? Math.log2 : function (x) {
	  return Math.log(x) / Math.LN2;
	};
	
	exports.default = log2;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (key in rest) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(1616); // eslint-disable-line
	module.exports = utils;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1624);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }),
/* 564 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 565 */
[2406, 239, 1639],
/* 566 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = global.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	 * @example
	 *
	 * _.isFinite(10);
	 * // => true
	 *
	 * _.isFinite('10');
	 * // => false
	 *
	 * _.isFinite(true);
	 * // => false
	 *
	 * _.isFinite(Object(10));
	 * // => false
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(83);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1678),
	    isArguments = __webpack_require__(248),
	    isArray = __webpack_require__(75),
	    isBuffer = __webpack_require__(249),
	    isIndex = __webpack_require__(359),
	    isTypedArray = __webpack_require__(252);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(243),
	    eq = __webpack_require__(175);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1688);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(576),
	    toKey = __webpack_require__(174);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(246),
	    nativeKeys = __webpack_require__(1718);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(75),
	    isKey = __webpack_require__(360),
	    stringToPath = __webpack_require__(587),
	    toString = __webpack_require__(592);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1652),
	    arraySome = __webpack_require__(1657),
	    cacheHas = __webpack_require__(1681);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(585);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1648),
	    Map = __webpack_require__(356),
	    Promise = __webpack_require__(1650),
	    Set = __webpack_require__(1651),
	    WeakMap = __webpack_require__(1653),
	    baseGetTag = __webpack_require__(147),
	    toSource = __webpack_require__(588);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(103);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1717);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(574);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(244);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(570),
	    baseKeysIn = __webpack_require__(1669),
	    isArrayLike = __webpack_require__(176);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1679);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1756);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(880);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(1765),
	  T: __webpack_require__(1766),
	  __: __webpack_require__(1767),
	  add: __webpack_require__(254),
	  addIndex: __webpack_require__(1768),
	  adjust: __webpack_require__(596),
	  all: __webpack_require__(1769),
	  allPass: __webpack_require__(1770),
	  always: __webpack_require__(149),
	  and: __webpack_require__(597),
	  any: __webpack_require__(598),
	  anyPass: __webpack_require__(1771),
	  ap: __webpack_require__(366),
	  aperture: __webpack_require__(1772),
	  append: __webpack_require__(1773),
	  apply: __webpack_require__(599),
	  applySpec: __webpack_require__(1774),
	  ascend: __webpack_require__(1775),
	  assoc: __webpack_require__(255),
	  assocPath: __webpack_require__(600),
	  binary: __webpack_require__(1776),
	  bind: __webpack_require__(601),
	  both: __webpack_require__(1777),
	  call: __webpack_require__(1778),
	  chain: __webpack_require__(367),
	  clamp: __webpack_require__(1779),
	  clone: __webpack_require__(1780),
	  comparator: __webpack_require__(1781),
	  complement: __webpack_require__(1782),
	  compose: __webpack_require__(368),
	  composeK: __webpack_require__(602),
	  composeP: __webpack_require__(1783),
	  concat: __webpack_require__(369),
	  cond: __webpack_require__(1784),
	  construct: __webpack_require__(1785),
	  constructN: __webpack_require__(603),
	  contains: __webpack_require__(1786),
	  converge: __webpack_require__(604),
	  countBy: __webpack_require__(1787),
	  curry: __webpack_require__(256),
	  curryN: __webpack_require__(51),
	  dec: __webpack_require__(1788),
	  descend: __webpack_require__(1789),
	  defaultTo: __webpack_require__(605),
	  difference: __webpack_require__(606),
	  differenceWith: __webpack_require__(607),
	  dissoc: __webpack_require__(608),
	  dissocPath: __webpack_require__(1790),
	  divide: __webpack_require__(1791),
	  drop: __webpack_require__(609),
	  dropLast: __webpack_require__(1792),
	  dropLastWhile: __webpack_require__(1793),
	  dropRepeats: __webpack_require__(1794),
	  dropRepeatsWith: __webpack_require__(610),
	  dropWhile: __webpack_require__(1795),
	  either: __webpack_require__(1796),
	  empty: __webpack_require__(611),
	  eqBy: __webpack_require__(1797),
	  eqProps: __webpack_require__(1798),
	  equals: __webpack_require__(84),
	  evolve: __webpack_require__(1799),
	  filter: __webpack_require__(370),
	  find: __webpack_require__(1800),
	  findIndex: __webpack_require__(1801),
	  findLast: __webpack_require__(1802),
	  findLastIndex: __webpack_require__(1803),
	  flatten: __webpack_require__(1804),
	  flip: __webpack_require__(257),
	  forEach: __webpack_require__(1805),
	  forEachObjIndexed: __webpack_require__(1806),
	  fromPairs: __webpack_require__(1807),
	  groupBy: __webpack_require__(1808),
	  groupWith: __webpack_require__(1809),
	  gt: __webpack_require__(1810),
	  gte: __webpack_require__(1811),
	  has: __webpack_require__(1812),
	  hasIn: __webpack_require__(1813),
	  head: __webpack_require__(1814),
	  identical: __webpack_require__(612),
	  identity: __webpack_require__(371),
	  ifElse: __webpack_require__(1815),
	  inc: __webpack_require__(1816),
	  indexBy: __webpack_require__(1817),
	  indexOf: __webpack_require__(1818),
	  init: __webpack_require__(1819),
	  insert: __webpack_require__(1820),
	  insertAll: __webpack_require__(1821),
	  intersection: __webpack_require__(1856),
	  intersectionWith: __webpack_require__(1857),
	  intersperse: __webpack_require__(1858),
	  into: __webpack_require__(1859),
	  invert: __webpack_require__(1860),
	  invertObj: __webpack_require__(1861),
	  invoker: __webpack_require__(178),
	  is: __webpack_require__(627),
	  isArrayLike: __webpack_require__(179),
	  isEmpty: __webpack_require__(1862),
	  isNil: __webpack_require__(1863),
	  join: __webpack_require__(1864),
	  juxt: __webpack_require__(628),
	  keys: __webpack_require__(86),
	  keysIn: __webpack_require__(1865),
	  last: __webpack_require__(629),
	  lastIndexOf: __webpack_require__(1866),
	  length: __webpack_require__(630),
	  lens: __webpack_require__(263),
	  lensIndex: __webpack_require__(1867),
	  lensPath: __webpack_require__(1868),
	  lensProp: __webpack_require__(1869),
	  lift: __webpack_require__(264),
	  liftN: __webpack_require__(631),
	  lt: __webpack_require__(1870),
	  lte: __webpack_require__(1871),
	  map: __webpack_require__(63),
	  mapAccum: __webpack_require__(1872),
	  mapAccumRight: __webpack_require__(1873),
	  mapObjIndexed: __webpack_require__(1874),
	  match: __webpack_require__(1875),
	  mathMod: __webpack_require__(1876),
	  max: __webpack_require__(150),
	  maxBy: __webpack_require__(1877),
	  mean: __webpack_require__(632),
	  median: __webpack_require__(1878),
	  memoize: __webpack_require__(1879),
	  merge: __webpack_require__(1880),
	  mergeAll: __webpack_require__(1881),
	  mergeWith: __webpack_require__(1882),
	  mergeWithKey: __webpack_require__(633),
	  min: __webpack_require__(1883),
	  minBy: __webpack_require__(1884),
	  modulo: __webpack_require__(1885),
	  multiply: __webpack_require__(634),
	  nAry: __webpack_require__(265),
	  negate: __webpack_require__(1886),
	  none: __webpack_require__(1887),
	  not: __webpack_require__(635),
	  nth: __webpack_require__(180),
	  nthArg: __webpack_require__(1888),
	  objOf: __webpack_require__(636),
	  of: __webpack_require__(1889),
	  omit: __webpack_require__(1890),
	  once: __webpack_require__(1891),
	  or: __webpack_require__(637),
	  over: __webpack_require__(638),
	  pair: __webpack_require__(1892),
	  partial: __webpack_require__(1893),
	  partialRight: __webpack_require__(1894),
	  partition: __webpack_require__(1895),
	  path: __webpack_require__(151),
	  pathEq: __webpack_require__(1896),
	  pathOr: __webpack_require__(1897),
	  pathSatisfies: __webpack_require__(1898),
	  pick: __webpack_require__(1899),
	  pickAll: __webpack_require__(639),
	  pickBy: __webpack_require__(1900),
	  pipe: __webpack_require__(640),
	  pipeK: __webpack_require__(1901),
	  pipeP: __webpack_require__(641),
	  pluck: __webpack_require__(181),
	  prepend: __webpack_require__(642),
	  product: __webpack_require__(1902),
	  project: __webpack_require__(1903),
	  prop: __webpack_require__(376),
	  propEq: __webpack_require__(1904),
	  propIs: __webpack_require__(1905),
	  propOr: __webpack_require__(1906),
	  propSatisfies: __webpack_require__(1907),
	  props: __webpack_require__(1908),
	  range: __webpack_require__(1909),
	  reduce: __webpack_require__(87),
	  reduceBy: __webpack_require__(266),
	  reduceRight: __webpack_require__(643),
	  reduceWhile: __webpack_require__(1910),
	  reduced: __webpack_require__(1911),
	  reject: __webpack_require__(267),
	  remove: __webpack_require__(1912),
	  repeat: __webpack_require__(1913),
	  replace: __webpack_require__(1914),
	  reverse: __webpack_require__(268),
	  scan: __webpack_require__(1915),
	  sequence: __webpack_require__(644),
	  set: __webpack_require__(1916),
	  slice: __webpack_require__(123),
	  sort: __webpack_require__(1917),
	  sortBy: __webpack_require__(1918),
	  sortWith: __webpack_require__(1919),
	  split: __webpack_require__(1920),
	  splitAt: __webpack_require__(1921),
	  splitEvery: __webpack_require__(1922),
	  splitWhen: __webpack_require__(1923),
	  subtract: __webpack_require__(1924),
	  sum: __webpack_require__(645),
	  symmetricDifference: __webpack_require__(1925),
	  symmetricDifferenceWith: __webpack_require__(1926),
	  tail: __webpack_require__(377),
	  take: __webpack_require__(646),
	  takeLast: __webpack_require__(1927),
	  takeLastWhile: __webpack_require__(1928),
	  takeWhile: __webpack_require__(1929),
	  tap: __webpack_require__(1930),
	  test: __webpack_require__(1931),
	  times: __webpack_require__(647),
	  toLower: __webpack_require__(1932),
	  toPairs: __webpack_require__(1933),
	  toPairsIn: __webpack_require__(1934),
	  toString: __webpack_require__(182),
	  toUpper: __webpack_require__(1935),
	  transduce: __webpack_require__(1936),
	  transpose: __webpack_require__(1937),
	  traverse: __webpack_require__(1938),
	  trim: __webpack_require__(1939),
	  tryCatch: __webpack_require__(1940),
	  type: __webpack_require__(378),
	  unapply: __webpack_require__(1941),
	  unary: __webpack_require__(1942),
	  uncurryN: __webpack_require__(1943),
	  unfold: __webpack_require__(1944),
	  union: __webpack_require__(1945),
	  unionWith: __webpack_require__(1946),
	  uniq: __webpack_require__(379),
	  uniqBy: __webpack_require__(648),
	  uniqWith: __webpack_require__(380),
	  unless: __webpack_require__(1947),
	  unnest: __webpack_require__(1948),
	  until: __webpack_require__(1949),
	  update: __webpack_require__(649),
	  useWith: __webpack_require__(650),
	  values: __webpack_require__(651),
	  valuesIn: __webpack_require__(1950),
	  view: __webpack_require__(1951),
	  when: __webpack_require__(1952),
	  where: __webpack_require__(652),
	  whereEq: __webpack_require__(1953),
	  without: __webpack_require__(1954),
	  xprod: __webpack_require__(1955),
	  zip: __webpack_require__(1956),
	  zipObj: __webpack_require__(1957),
	  zipWith: __webpack_require__(1958)
	};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xany = __webpack_require__(624);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var _has = __webpack_require__(56);
	var _isArray = __webpack_require__(104);
	var _isInteger = __webpack_require__(620);
	var assoc = __webpack_require__(255);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(367);
	var compose = __webpack_require__(368);
	var map = __webpack_require__(63);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var curry = __webpack_require__(256);
	var nAry = __webpack_require__(265);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _map = __webpack_require__(262);
	var curryN = __webpack_require__(51);
	var max = __webpack_require__(150);
	var pluck = __webpack_require__(181);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared are compared
	 * in terms of value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(373);
	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xdrop = __webpack_require__(1843);
	var slice = __webpack_require__(123);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {[a]} list
	 * @return {[a]} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xdropRepeatsWith = __webpack_require__(625);
	var last = __webpack_require__(629);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _isArguments = __webpack_require__(619);
	var _isArray = __webpack_require__(104);
	var _isObject = __webpack_require__(622);
	var _isString = __webpack_require__(261);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(614);
	var type = __webpack_require__(378);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry2 = __webpack_require__(3);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(84);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(56);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ }),
/* 620 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(179);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var converge = __webpack_require__(604);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(180);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _isNumber = __webpack_require__(621);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduce = __webpack_require__(71);
	var ap = __webpack_require__(366);
	var curryN = __webpack_require__(51);
	var map = __webpack_require__(63);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var sum = __webpack_require__(645);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var _has = __webpack_require__(56);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object. The key
	 * will be excluded from the returned object if the resulting value is
	 * `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _pipe = __webpack_require__(1834);
	var reduce = __webpack_require__(87);
	var tail = __webpack_require__(377);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _pipeP = __webpack_require__(1835);
	var reduce = __webpack_require__(87);
	var tail = __webpack_require__(377);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to `reduce`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var ap = __webpack_require__(366);
	var map = __webpack_require__(63);
	var prepend = __webpack_require__(642);
	var reduceRight = __webpack_require__(643);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(254);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xtake = __webpack_require__(1854);
	var slice = __webpack_require__(123);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(1822);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. `R.equals` is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var adjust = __webpack_require__(596);
	var always = __webpack_require__(149);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _has = __webpack_require__(56);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as `filter` and `find`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(__, 10),
	 *        y: R.lt(__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(15), __webpack_require__(1183));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types", "clipboard"], factory);
		else if(typeof exports === 'object')
			exports["ReactClipboard"] = factory(require("react"), require("prop-types"), require("clipboard"));
		else
			root["ReactClipboard"] = factory(root["React"], root["PropTypes"], root["Clipboard"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClipboardButton = function (_React$Component) {
	  _inherits(ClipboardButton, _React$Component);
	
	  function ClipboardButton() {
	    _classCallCheck(this, ClipboardButton);
	
	    return _possibleConstructorReturn(this, (ClipboardButton.__proto__ || Object.getPrototypeOf(ClipboardButton)).apply(this, arguments));
	  }
	
	  _createClass(ClipboardButton, [{
	    key: 'propsWith',
	
	
	    /* Returns a object with all props that fulfill a certain naming pattern
	     *
	     * @param {RegExp} regexp - Regular expression representing which pattern
	     *                          you'll be searching for.
	     * @param {Boolean} remove - Determines if the regular expression should be
	     *                           removed when transmitting the key from the props
	     *                           to the new object.
	     *
	     * e.g:
	     *
	     * // Considering:
	     * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
	     *
	     * // *RegExps not using // so that this comment doesn't break up
	     * this.propsWith(option-*, true); // returns {foo: 1}
	     * this.propsWith(on*, true); // returns {Bar: 2}
	     * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
	     */
	    value: function propsWith(regexp) {
	      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var object = {};
	
	      Object.keys(this.props).forEach(function (key) {
	        if (key.search(regexp) !== -1) {
	          var objectKey = remove ? key.replace(regexp, '') : key;
	          object[objectKey] = this.props[key];
	        }
	      }, this);
	
	      return object;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clipboard && this.clipboard.destroy();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Support old API by trying to assign this.props.options first;
	      var options = this.props.options || this.propsWith(/^option-/, true);
	      var element = _react2.default.version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.element;
	      var Clipboard = __webpack_require__(3);
	      this.clipboard = new Clipboard(element, options);
	
	      var callbacks = this.propsWith(/^on/, true);
	      Object.keys(callbacks).forEach(function (callback) {
	        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attributes = _extends({
	        type: this.getType(),
	        className: this.props.className || '',
	        style: this.props.style || {},
	        ref: function ref(element) {
	          _this2.element = element;
	        },
	        onClick: this.props.onClick
	      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
	
	      return _react2.default.createElement(this.getComponent(), attributes, this.props.children);
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
	        return this.props.type || 'button';
	      } else {
	        return undefined;
	      }
	    }
	  }, {
	    key: 'getComponent',
	    value: function getComponent() {
	      return this.props.component || 'button';
	    }
	  }]);
	
	  return ClipboardButton;
	}(_react2.default.Component);
	
	ClipboardButton.propTypes = {
	  options: function options(props, propName, componentName) {
	    var options = props[propName];
	    if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || Array.isArray(options)) {
	      return new Error('Invalid props \'' + propName + '\' supplied to \'' + componentName + '\'. ' + ('\'' + propName + '\' is not an object.'));
	    }
	
	    if (props['option-text'] !== undefined) {
	      var optionText = props['option-text'];
	      if (typeof optionText !== 'function') {
	        return new Error('Invalid props \'option-text\' supplied to \'' + componentName + '\'. ' + '\'option-text\' is not a function.');
	      }
	    }
	  },
	  type: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  component: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])
	};
	ClipboardButton.defaultProps = {
	  onClick: function onClick() {} };
	exports.default = ClipboardButton;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nodesToString = nodesToString;
	exports.Trans = Trans;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(183));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(270));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _react = __webpack_require__(1);
	
	var _htmlParseStringify = _interopRequireDefault(__webpack_require__(1625));
	
	var _utils = __webpack_require__(269);
	
	var _defaults = __webpack_require__(381);
	
	var _i18nInstance = __webpack_require__(382);
	
	var _excluded = ["format"],
	    _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function hasChildren(node, checkLength) {
	  if (!node) return false;
	  var base = node.props ? node.props.children : node.children;
	  if (checkLength) return base.length > 0;
	  return !!base;
	}
	
	function getChildren(node) {
	  if (!node) return [];
	  return node.props ? node.props.children : node.children;
	}
	
	function hasValidReactChildren(children) {
	  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
	  return children.every(function (child) {
	    return (0, _react.isValidElement)(child);
	  });
	}
	
	function getAsArray(data) {
	  return Array.isArray(data) ? data : [data];
	}
	
	function mergeProps(source, target) {
	  var newTarget = _objectSpread({}, target);
	
	  newTarget.props = Object.assign(source.props, target.props);
	  return newTarget;
	}
	
	function nodesToString(children, i18nOptions) {
	  if (!children) return '';
	  var stringNode = '';
	  var childrenArray = getAsArray(children);
	  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
	  childrenArray.forEach(function (child, childIndex) {
	    if (typeof child === 'string') {
	      stringNode += "".concat(child);
	    } else if ((0, _react.isValidElement)(child)) {
	      var childPropsCount = Object.keys(child.props).length;
	      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
	      var childChildren = child.props.children;
	
	      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
	        stringNode += "<".concat(child.type, "/>");
	      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
	        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
	      } else if (child.props.i18nIsDynamicList) {
	        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
	      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
	        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
	      } else {
	        var content = nodesToString(childChildren, i18nOptions);
	        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
	      }
	    } else if (child === null) {
	      (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
	    } else if ((0, _typeof2["default"])(child) === 'object') {
	      var format = child.format,
	          clone = (0, _objectWithoutProperties2["default"])(child, _excluded);
	      var keys = Object.keys(clone);
	
	      if (keys.length === 1) {
	        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
	        stringNode += "{{".concat(value, "}}");
	      } else {
	        (0, _utils.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
	      }
	    } else {
	      (0, _utils.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
	    }
	  });
	  return stringNode;
	}
	
	function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
	  if (targetString === '') return [];
	  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
	  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
	  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
	  var data = {};
	
	  function getData(childs) {
	    var childrenArray = getAsArray(childs);
	    childrenArray.forEach(function (child) {
	      if (typeof child === 'string') return;
	      if (hasChildren(child)) getData(getChildren(child));else if ((0, _typeof2["default"])(child) === 'object' && !(0, _react.isValidElement)(child)) Object.assign(data, child);
	    });
	  }
	
	  getData(children);
	
	  var ast = _htmlParseStringify["default"].parse("<0>".concat(targetString, "</0>"));
	
	  var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);
	
	  function renderInner(child, node, rootReactNode) {
	    var childs = getChildren(child);
	    var mappedChildren = mapAST(childs, node.children, rootReactNode);
	    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
	  }
	
	  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
	    if (child.dummy) child.children = inner;
	    mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
	      key: i
	    }), isVoid ? undefined : inner));
	  }
	
	  function mapAST(reactNode, astNode, rootReactNode) {
	    var reactNodes = getAsArray(reactNode);
	    var astNodes = getAsArray(astNode);
	    return astNodes.reduce(function (mem, node, i) {
	      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
	
	      if (node.type === 'tag') {
	        var tmp = reactNodes[parseInt(node.name, 10)];
	        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
	        if (!tmp) tmp = {};
	        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
	          props: node.attrs
	        }, tmp) : tmp;
	        var isElement = (0, _react.isValidElement)(child);
	        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
	        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, _typeof2["default"])(child) === 'object' && child.dummy && !isElement;
	        var isKnownComponent = (0, _typeof2["default"])(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
	
	        if (typeof child === 'string') {
	          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
	          mem.push(value);
	        } else if (hasChildren(child) || isValidTranslationWithChildren) {
	            var inner = renderInner(child, node, rootReactNode);
	            pushTranslatedJSX(child, inner, mem, i);
	          } else if (isEmptyTransWithHTML) {
	          var _inner = mapAST(reactNodes, node.children, rootReactNode);
	
	          mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          }), _inner));
	        } else if (Number.isNaN(parseFloat(node.name))) {
	          if (isKnownComponent) {
	            var _inner2 = renderInner(child, node, rootReactNode);
	
	            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
	          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
	            if (node.voidElement) {
	              mem.push((0, _react.createElement)(node.name, {
	                key: "".concat(node.name, "-").concat(i)
	              }));
	            } else {
	              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
	
	              mem.push((0, _react.createElement)(node.name, {
	                key: "".concat(node.name, "-").concat(i)
	              }, _inner3));
	            }
	          } else if (node.voidElement) {
	            mem.push("<".concat(node.name, " />"));
	          } else {
	            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
	
	            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
	          }
	        } else if ((0, _typeof2["default"])(child) === 'object' && !isElement) {
	          var content = node.children[0] ? translationContent : null;
	          if (content) mem.push(content);
	        } else if (node.children.length === 1 && translationContent) {
	          mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          }), translationContent));
	        } else {
	          mem.push((0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
	            key: i
	          })));
	        }
	      } else if (node.type === 'text') {
	        var wrapTextNodes = i18nOptions.transWrapTextNodes;
	
	        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
	
	        if (wrapTextNodes) {
	          mem.push((0, _react.createElement)(wrapTextNodes, {
	            key: "".concat(node.name, "-").concat(i)
	          }, _content));
	        } else {
	          mem.push(_content);
	        }
	      }
	
	      return mem;
	    }, []);
	  }
	
	  var result = mapAST([{
	    dummy: true,
	    children: children || []
	  }], ast, getAsArray(children || []));
	  return getChildren(result[0]);
	}
	
	function Trans(_ref) {
	  var children = _ref.children,
	      count = _ref.count,
	      parent = _ref.parent,
	      i18nKey = _ref.i18nKey,
	      context = _ref.context,
	      _ref$tOptions = _ref.tOptions,
	      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
	      values = _ref.values,
	      defaults = _ref.defaults,
	      components = _ref.components,
	      ns = _ref.ns,
	      i18nFromProps = _ref.i18n,
	      tFromProps = _ref.t,
	      shouldUnescape = _ref.shouldUnescape,
	      additionalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
	  var i18n = i18nFromProps || (0, _i18nInstance.getI18n)();
	
	  if (!i18n) {
	    (0, _utils.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
	    return children;
	  }
	
	  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
	    return k;
	  };
	
	  if (context) tOptions.context = context;
	
	  var reactI18nextOptions = _objectSpread(_objectSpread({}, (0, _defaults.getDefaults)()), i18n.options && i18n.options.react);
	
	  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
	  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
	  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
	  var hashTransKey = reactI18nextOptions.hashTransKey;
	  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
	  var interpolationOverride = values ? tOptions.interpolation : {
	    interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
	      prefix: '#$?',
	      suffix: '?$#'
	    })
	  };
	
	  var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
	    count: count
	  }, values), interpolationOverride), {}, {
	    defaultValue: defaultValue,
	    ns: namespaces
	  });
	
	  var translation = key ? t(key, combinedTOpts) : defaultValue;
	  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
	  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
	  return useAsParent ? (0, _react.createElement)(useAsParent, additionalProps, content) : content;
	}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useSSR = useSSR;
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(152);
	
	function useSSR(initialI18nStore, initialLanguage) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var i18nFromProps = props.i18n;
	
	  var _ref = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref.i18n;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	  if (i18n.options && i18n.options.isClone) return;
	
	  if (initialI18nStore && !i18n.initializedStoreOnce) {
	    i18n.services.resourceStore.data = initialI18nStore;
	    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
	      Object.keys(lngResources).forEach(function (ns) {
	        if (mem.indexOf(ns) < 0) mem.push(ns);
	      });
	      return mem;
	    }, i18n.options.ns);
	    i18n.initializedStoreOnce = true;
	    i18n.isInitialized = true;
	  }
	
	  if (initialLanguage && !i18n.initializedLanguageOnce) {
	    i18n.changeLanguage(initialLanguage);
	    i18n.initializedLanguageOnce = true;
	  }
	}

/***/ }),
/* 656 */
[2406, 270, 1978],
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMap = function FaMap(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.3 0.6l-10.7 5.7q-0.2 0.1-0.4 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.4-0.6l10.7-5.7q0.2-0.1 0.3-0.1z m27.9 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.4 0.6l-10.7 5.7q-0.1 0.1-0.3 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.3-0.6l10.8-5.7q0.1-0.1 0.3-0.1z m-25 0q0.2 0 0.3 0.1l11.4 5.7q0.4 0.2 0.4 0.6v32.9q0 0.3-0.2 0.5t-0.5 0.2q-0.2 0-0.3-0.1l-11.4-5.7q-0.4-0.2-0.4-0.6v-32.9q0-0.3 0.2-0.5t0.5-0.2z' })
	        )
	    );
	};
	
	exports.default = FaMap;
	module.exports = exports['default'];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThList = function FaThList(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 27.9v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m0-11.5v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m28.6 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.6z m-28.6-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m28.6 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-21.5q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.5z m0-11.4v4.3q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaThList;
	module.exports = exports['default'];

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTh = function FaTh(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 27.9v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m0-11.5v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m-14.3-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m-14.3-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m0-11.4v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaTh;
	module.exports = exports['default'];

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// An infinite computer must be able to do the following things:
	//  1. getTotalScrollableHeight()
	//  2. getDisplayIndexStart()
	//  3. getDisplayIndexEnd()
	
	var InfiniteComputer = function () {
	  function InfiniteComputer(heightData, numberOfChildren) {
	    _classCallCheck(this, InfiniteComputer);
	
	    this.heightData = heightData;
	    this.numberOfChildren = numberOfChildren;
	  }
	
	  _createClass(InfiniteComputer, [{
	    key: 'getTotalScrollableHeight',
	    value: function getTotalScrollableHeight() {
	      if (false) {
	        throw new Error('getTotalScrollableHeight not implemented.');
	      }
	    }
	
	    /* eslint-disable no-unused-vars */
	
	  }, {
	    key: 'getDisplayIndexStart',
	    value: function getDisplayIndexStart(windowTop) {
	      /* eslint-enable no-unused-vars */
	      if (false) {
	        throw new Error('getDisplayIndexStart not implemented.');
	      }
	    }
	
	    /* eslint-disable no-unused-vars */
	
	  }, {
	    key: 'getDisplayIndexEnd',
	    value: function getDisplayIndexEnd(windowBottom) {
	      /* eslint-enable no-unused-vars */
	      if (false) {
	        throw new Error('getDisplayIndexEnd not implemented.');
	      }
	    }
	
	    // These are helper methods, and can be calculated from
	    // the above details.
	    /* eslint-disable no-unused-vars */
	
	  }, {
	    key: 'getTopSpacerHeight',
	    value: function getTopSpacerHeight(displayIndexStart) {
	      /* eslint-enable no-unused-vars */
	      if (false) {
	        throw new Error('getTopSpacerHeight not implemented.');
	      }
	    }
	
	    /* eslint-disable no-unused-vars */
	
	  }, {
	    key: 'getBottomSpacerHeight',
	    value: function getBottomSpacerHeight(displayIndexEnd) {
	      /* eslint-enable no-unused-vars */
	      if (false) {
	        throw new Error('getBottomSpacerHeight not implemented.');
	      }
	    }
	  }]);
	
	  return InfiniteComputer;
	}();
	
	module.exports = InfiniteComputer;

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  CONTAINER_HEIGHT_SCALE_FACTOR: 'containerHeightScaleFactor'
	};

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var win;
	
	if (typeof window !== 'undefined') {
	  win = window;
	} else if (typeof global !== 'undefined') {
	  win = global;
	} else if (typeof self !== 'undefined') {
	  win = self;
	} else {
	  win = {};
	}
	
	module.exports = win;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	
	var _warning = __webpack_require__(2392);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  if (globalElement) {
	    if (globalElement.removeAttribute) {
	      globalElement.removeAttribute("aria-hidden");
	    } else if (globalElement.length != null) {
	      globalElement.forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    } else {
	      document.querySelectorAll(globalElement).forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    }
	  }
	  globalElement = null;
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var check = globalElement || {};
	    console.log("ariaAppHider ----------");
	    console.log(check.nodeName, check.className, check.id);
	    console.log("end ariaAppHider ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  var el = appElement || globalElement;
	  if (el) {
	    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
	  } else {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return [];
	  }
	}
	
	function hide(appElement) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var el = _step.value;
	
	      el.setAttribute("aria-hidden", "true");
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function show(appElement) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var el = _step2.value;
	
	      el.removeAttribute("aria-hidden");
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.log = log;
	exports.resetState = resetState;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function log() {
	  console.log("portalOpenInstances ----------");
	  console.log(portalOpenInstances.openInstances.length);
	  portalOpenInstances.openInstances.forEach(function (p) {
	    return console.log(p);
	  });
	  console.log("end portalOpenInstances ----------");
	}
	
	/* istanbul ignore next */
	function resetState() {
	  portalOpenInstances = new PortalOpenInstances();
	}
	/* eslint-enable no-console */
	
	exports.default = portalOpenInstances;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object|iframe/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
	    // if 'overflow: visible' set, check if there is actually any overflow
	    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}
	
	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;
	
	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
	
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(36),__webpack_require__(170)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.infiniteQueryBehavior = infiniteQueryBehavior;
	exports.getNextPageParam = getNextPageParam;
	exports.getPreviousPageParam = getPreviousPageParam;
	exports.hasNextPage = hasNextPage;
	exports.hasPreviousPage = hasPreviousPage;
	
	var _retryer = __webpack_require__(186);
	
	var _utils = __webpack_require__(43);
	
	function infiniteQueryBehavior() {
	  return {
	    onFetch: function onFetch(context) {
	      context.fetchFn = function () {
	        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
	
	        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
	        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
	        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
	        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
	        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
	        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
	        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
	        var abortController = (0, _utils.getAbortController)();
	        var abortSignal = abortController == null ? void 0 : abortController.signal;
	        var newPageParams = oldPageParams;
	        var cancelled = false; // Get query function
	
	        var queryFn = context.options.queryFn || function () {
	          return Promise.reject('Missing queryFn');
	        };
	
	        var buildNewPages = function buildNewPages(pages, param, page, previous) {
	          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
	          return previous ? [page].concat(pages) : [].concat(pages, [page]);
	        }; // Create function to fetch a page
	
	
	        var fetchPage = function fetchPage(pages, manual, param, previous) {
	          if (cancelled) {
	            return Promise.reject('Cancelled');
	          }
	
	          if (typeof param === 'undefined' && !manual && pages.length) {
	            return Promise.resolve(pages);
	          }
	
	          var queryFnContext = {
	            queryKey: context.queryKey,
	            signal: abortSignal,
	            pageParam: param,
	            meta: context.meta
	          };
	          var queryFnResult = queryFn(queryFnContext);
	          var promise = Promise.resolve(queryFnResult).then(function (page) {
	            return buildNewPages(pages, param, page, previous);
	          });
	
	          if ((0, _retryer.isCancelable)(queryFnResult)) {
	            var promiseAsAny = promise;
	            promiseAsAny.cancel = queryFnResult.cancel;
	          }
	
	          return promise;
	        };
	
	        var promise; // Fetch first page?
	
	        if (!oldPages.length) {
	          promise = fetchPage([]);
	        } // Fetch next page?
	        else if (isFetchingNextPage) {
	            var manual = typeof pageParam !== 'undefined';
	            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
	            promise = fetchPage(oldPages, manual, param);
	          } // Fetch previous page?
	          else if (isFetchingPreviousPage) {
	              var _manual = typeof pageParam !== 'undefined';
	
	              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);
	
	              promise = fetchPage(oldPages, _manual, _param, true);
	            } // Refetch pages
	            else {
	                (function () {
	                  newPageParams = [];
	                  var manual = typeof context.options.getNextPageParam === 'undefined';
	                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
	
	                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
	
	                  var _loop = function _loop(i) {
	                    promise = promise.then(function (pages) {
	                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
	
	                      if (shouldFetchNextPage) {
	                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
	
	                        return fetchPage(pages, manual, _param2);
	                      }
	
	                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
	                    });
	                  };
	
	                  for (var i = 1; i < oldPages.length; i++) {
	                    _loop(i);
	                  }
	                })();
	              }
	
	        var finalPromise = promise.then(function (pages) {
	          return {
	            pages: pages,
	            pageParams: newPageParams
	          };
	        });
	        var finalPromiseAsAny = finalPromise;
	
	        finalPromiseAsAny.cancel = function () {
	          cancelled = true;
	          abortController == null ? void 0 : abortController.abort();
	
	          if ((0, _retryer.isCancelable)(promise)) {
	            promise.cancel();
	          }
	        };
	
	        return finalPromise;
	      };
	    }
	  };
	}
	
	function getNextPageParam(options, pages) {
	  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
	}
	
	function getPreviousPageParam(options, pages) {
	  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
	}
	/**
	 * Checks if there is a next page.
	 * Returns `undefined` if it cannot be determined.
	 */
	
	
	function hasNextPage(options, pages) {
	  if (options.getNextPageParam && Array.isArray(pages)) {
	    var nextPageParam = getNextPageParam(options, pages);
	    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
	  }
	}
	/**
	 * Checks if there is a previous page.
	 * Returns `undefined` if it cannot be determined.
	 */
	
	
	function hasPreviousPage(options, pages) {
	  if (options.getPreviousPageParam && Array.isArray(pages)) {
	    var previousPageParam = getPreviousPageParam(options, pages);
	    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
	  }
	}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.InfiniteQueryObserver = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _queryObserver = __webpack_require__(393);
	
	var _infiniteQueryBehavior = __webpack_require__(668);
	
	var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
	  (0, _inheritsLoose2.default)(InfiniteQueryObserver, _QueryObserver);
	
	  // Type override
	  // Type override
	  // Type override
	  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
	  function InfiniteQueryObserver(client, options) {
	    return _QueryObserver.call(this, client, options) || this;
	  }
	
	  var _proto = InfiniteQueryObserver.prototype;
	
	  _proto.bindMethods = function bindMethods() {
	    _QueryObserver.prototype.bindMethods.call(this);
	
	    this.fetchNextPage = this.fetchNextPage.bind(this);
	    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
	  };
	
	  _proto.setOptions = function setOptions(options, notifyOptions) {
	    _QueryObserver.prototype.setOptions.call(this, (0, _extends2.default)({}, options, {
	      behavior: (0, _infiniteQueryBehavior.infiniteQueryBehavior)()
	    }), notifyOptions);
	  };
	
	  _proto.getOptimisticResult = function getOptimisticResult(options) {
	    options.behavior = (0, _infiniteQueryBehavior.infiniteQueryBehavior)();
	    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
	  };
	
	  _proto.fetchNextPage = function fetchNextPage(options) {
	    var _options$cancelRefetc;
	
	    return this.fetch({
	      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
	      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
	      throwOnError: options == null ? void 0 : options.throwOnError,
	      meta: {
	        fetchMore: {
	          direction: 'forward',
	          pageParam: options == null ? void 0 : options.pageParam
	        }
	      }
	    });
	  };
	
	  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
	    var _options$cancelRefetc2;
	
	    return this.fetch({
	      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
	      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
	      throwOnError: options == null ? void 0 : options.throwOnError,
	      meta: {
	        fetchMore: {
	          direction: 'backward',
	          pageParam: options == null ? void 0 : options.pageParam
	        }
	      }
	    });
	  };
	
	  _proto.createResult = function createResult(query, options) {
	    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
	
	    var state = query.state;
	
	    var result = _QueryObserver.prototype.createResult.call(this, query, options);
	
	    return (0, _extends2.default)({}, result, {
	      fetchNextPage: this.fetchNextPage,
	      fetchPreviousPage: this.fetchPreviousPage,
	      hasNextPage: (0, _infiniteQueryBehavior.hasNextPage)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
	      hasPreviousPage: (0, _infiniteQueryBehavior.hasPreviousPage)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
	      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
	      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
	    });
	  };
	
	  return InfiniteQueryObserver;
	}(_queryObserver.QueryObserver);
	
	exports.InfiniteQueryObserver = InfiniteQueryObserver;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.getDefaultState = getDefaultState;
	exports.Mutation = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _logger = __webpack_require__(273);
	
	var _notifyManager = __webpack_require__(57);
	
	var _retryer = __webpack_require__(186);
	
	var _utils = __webpack_require__(43);
	
	// CLASS
	var Mutation = /*#__PURE__*/function () {
	  function Mutation(config) {
	    this.options = (0, _extends2.default)({}, config.defaultOptions, config.options);
	    this.mutationId = config.mutationId;
	    this.mutationCache = config.mutationCache;
	    this.observers = [];
	    this.state = config.state || getDefaultState();
	    this.meta = config.meta;
	  }
	
	  var _proto = Mutation.prototype;
	
	  _proto.setState = function setState(state) {
	    this.dispatch({
	      type: 'setState',
	      state: state
	    });
	  };
	
	  _proto.addObserver = function addObserver(observer) {
	    if (this.observers.indexOf(observer) === -1) {
	      this.observers.push(observer);
	    }
	  };
	
	  _proto.removeObserver = function removeObserver(observer) {
	    this.observers = this.observers.filter(function (x) {
	      return x !== observer;
	    });
	  };
	
	  _proto.cancel = function cancel() {
	    if (this.retryer) {
	      this.retryer.cancel();
	      return this.retryer.promise.then(_utils.noop).catch(_utils.noop);
	    }
	
	    return Promise.resolve();
	  };
	
	  _proto.continue = function _continue() {
	    if (this.retryer) {
	      this.retryer.continue();
	      return this.retryer.promise;
	    }
	
	    return this.execute();
	  };
	
	  _proto.execute = function execute() {
	    var _this = this;
	
	    var data;
	    var restored = this.state.status === 'loading';
	    var promise = Promise.resolve();
	
	    if (!restored) {
	      this.dispatch({
	        type: 'loading',
	        variables: this.options.variables
	      });
	      promise = promise.then(function () {
	        // Notify cache callback
	        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
	      }).then(function () {
	        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
	      }).then(function (context) {
	        if (context !== _this.state.context) {
	          _this.dispatch({
	            type: 'loading',
	            context: context,
	            variables: _this.state.variables
	          });
	        }
	      });
	    }
	
	    return promise.then(function () {
	      return _this.executeMutation();
	    }).then(function (result) {
	      data = result; // Notify cache callback
	
	      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
	    }).then(function () {
	      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
	    }).then(function () {
	      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
	    }).then(function () {
	      _this.dispatch({
	        type: 'success',
	        data: data
	      });
	
	      return data;
	    }).catch(function (error) {
	      // Notify cache callback
	      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
	
	      (0, _logger.getLogger)().error(error);
	      return Promise.resolve().then(function () {
	        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
	      }).then(function () {
	        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
	      }).then(function () {
	        _this.dispatch({
	          type: 'error',
	          error: error
	        });
	
	        throw error;
	      });
	    });
	  };
	
	  _proto.executeMutation = function executeMutation() {
	    var _this2 = this,
	        _this$options$retry;
	
	    this.retryer = new _retryer.Retryer({
	      fn: function fn() {
	        if (!_this2.options.mutationFn) {
	          return Promise.reject('No mutationFn found');
	        }
	
	        return _this2.options.mutationFn(_this2.state.variables);
	      },
	      onFail: function onFail() {
	        _this2.dispatch({
	          type: 'failed'
	        });
	      },
	      onPause: function onPause() {
	        _this2.dispatch({
	          type: 'pause'
	        });
	      },
	      onContinue: function onContinue() {
	        _this2.dispatch({
	          type: 'continue'
	        });
	      },
	      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
	      retryDelay: this.options.retryDelay
	    });
	    return this.retryer.promise;
	  };
	
	  _proto.dispatch = function dispatch(action) {
	    var _this3 = this;
	
	    this.state = reducer(this.state, action);
	
	    _notifyManager.notifyManager.batch(function () {
	      _this3.observers.forEach(function (observer) {
	        observer.onMutationUpdate(action);
	      });
	
	      _this3.mutationCache.notify(_this3);
	    });
	  };
	
	  return Mutation;
	}();
	
	exports.Mutation = Mutation;
	
	function getDefaultState() {
	  return {
	    context: undefined,
	    data: undefined,
	    error: null,
	    failureCount: 0,
	    isPaused: false,
	    status: 'idle',
	    variables: undefined
	  };
	}
	
	function reducer(state, action) {
	  switch (action.type) {
	    case 'failed':
	      return (0, _extends2.default)({}, state, {
	        failureCount: state.failureCount + 1
	      });
	
	    case 'pause':
	      return (0, _extends2.default)({}, state, {
	        isPaused: true
	      });
	
	    case 'continue':
	      return (0, _extends2.default)({}, state, {
	        isPaused: false
	      });
	
	    case 'loading':
	      return (0, _extends2.default)({}, state, {
	        context: action.context,
	        data: undefined,
	        error: null,
	        isPaused: false,
	        status: 'loading',
	        variables: action.variables
	      });
	
	    case 'success':
	      return (0, _extends2.default)({}, state, {
	        data: action.data,
	        error: null,
	        status: 'success',
	        isPaused: false
	      });
	
	    case 'error':
	      return (0, _extends2.default)({}, state, {
	        data: undefined,
	        error: action.error,
	        failureCount: state.failureCount + 1,
	        isPaused: false,
	        status: 'error'
	      });
	
	    case 'setState':
	      return (0, _extends2.default)({}, state, action.state);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.MutationCache = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _notifyManager = __webpack_require__(57);
	
	var _mutation = __webpack_require__(670);
	
	var _utils = __webpack_require__(43);
	
	var _subscribable = __webpack_require__(126);
	
	// CLASS
	var MutationCache = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(MutationCache, _Subscribable);
	
	  function MutationCache(config) {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	    _this.config = config || {};
	    _this.mutations = [];
	    _this.mutationId = 0;
	    return _this;
	  }
	
	  var _proto = MutationCache.prototype;
	
	  _proto.build = function build(client, options, state) {
	    var mutation = new _mutation.Mutation({
	      mutationCache: this,
	      mutationId: ++this.mutationId,
	      options: client.defaultMutationOptions(options),
	      state: state,
	      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
	      meta: options.meta
	    });
	    this.add(mutation);
	    return mutation;
	  };
	
	  _proto.add = function add(mutation) {
	    this.mutations.push(mutation);
	    this.notify(mutation);
	  };
	
	  _proto.remove = function remove(mutation) {
	    this.mutations = this.mutations.filter(function (x) {
	      return x !== mutation;
	    });
	    mutation.cancel();
	    this.notify(mutation);
	  };
	
	  _proto.clear = function clear() {
	    var _this2 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this2.mutations.forEach(function (mutation) {
	        _this2.remove(mutation);
	      });
	    });
	  };
	
	  _proto.getAll = function getAll() {
	    return this.mutations;
	  };
	
	  _proto.find = function find(filters) {
	    if (typeof filters.exact === 'undefined') {
	      filters.exact = true;
	    }
	
	    return this.mutations.find(function (mutation) {
	      return (0, _utils.matchMutation)(filters, mutation);
	    });
	  };
	
	  _proto.findAll = function findAll(filters) {
	    return this.mutations.filter(function (mutation) {
	      return (0, _utils.matchMutation)(filters, mutation);
	    });
	  };
	
	  _proto.notify = function notify(mutation) {
	    var _this3 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this3.listeners.forEach(function (listener) {
	        listener(mutation);
	      });
	    });
	  };
	
	  _proto.onFocus = function onFocus() {
	    this.resumePausedMutations();
	  };
	
	  _proto.onOnline = function onOnline() {
	    this.resumePausedMutations();
	  };
	
	  _proto.resumePausedMutations = function resumePausedMutations() {
	    var pausedMutations = this.mutations.filter(function (x) {
	      return x.state.isPaused;
	    });
	    return _notifyManager.notifyManager.batch(function () {
	      return pausedMutations.reduce(function (promise, mutation) {
	        return promise.then(function () {
	          return mutation.continue().catch(_utils.noop);
	        });
	      }, Promise.resolve());
	    });
	  };
	
	  return MutationCache;
	}(_subscribable.Subscribable);
	
	exports.MutationCache = MutationCache;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.MutationObserver = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _mutation = __webpack_require__(670);
	
	var _notifyManager = __webpack_require__(57);
	
	var _subscribable = __webpack_require__(126);
	
	// CLASS
	var MutationObserver = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(MutationObserver, _Subscribable);
	
	  function MutationObserver(client, options) {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	    _this.client = client;
	
	    _this.setOptions(options);
	
	    _this.bindMethods();
	
	    _this.updateResult();
	
	    return _this;
	  }
	
	  var _proto = MutationObserver.prototype;
	
	  _proto.bindMethods = function bindMethods() {
	    this.mutate = this.mutate.bind(this);
	    this.reset = this.reset.bind(this);
	  };
	
	  _proto.setOptions = function setOptions(options) {
	    this.options = this.client.defaultMutationOptions(options);
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {
	    if (!this.listeners.length) {
	      var _this$currentMutation;
	
	      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
	    }
	  };
	
	  _proto.onMutationUpdate = function onMutationUpdate(action) {
	    this.updateResult(); // Determine which callbacks to trigger
	
	    var notifyOptions = {
	      listeners: true
	    };
	
	    if (action.type === 'success') {
	      notifyOptions.onSuccess = true;
	    } else if (action.type === 'error') {
	      notifyOptions.onError = true;
	    }
	
	    this.notify(notifyOptions);
	  };
	
	  _proto.getCurrentResult = function getCurrentResult() {
	    return this.currentResult;
	  };
	
	  _proto.reset = function reset() {
	    this.currentMutation = undefined;
	    this.updateResult();
	    this.notify({
	      listeners: true
	    });
	  };
	
	  _proto.mutate = function mutate(variables, options) {
	    this.mutateOptions = options;
	
	    if (this.currentMutation) {
	      this.currentMutation.removeObserver(this);
	    }
	
	    this.currentMutation = this.client.getMutationCache().build(this.client, (0, _extends2.default)({}, this.options, {
	      variables: typeof variables !== 'undefined' ? variables : this.options.variables
	    }));
	    this.currentMutation.addObserver(this);
	    return this.currentMutation.execute();
	  };
	
	  _proto.updateResult = function updateResult() {
	    var state = this.currentMutation ? this.currentMutation.state : (0, _mutation.getDefaultState)();
	    var result = (0, _extends2.default)({}, state, {
	      isLoading: state.status === 'loading',
	      isSuccess: state.status === 'success',
	      isError: state.status === 'error',
	      isIdle: state.status === 'idle',
	      mutate: this.mutate,
	      reset: this.reset
	    });
	    this.currentResult = result;
	  };
	
	  _proto.notify = function notify(options) {
	    var _this2 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      // First trigger the mutate callbacks
	      if (_this2.mutateOptions) {
	        if (options.onSuccess) {
	          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
	          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
	        } else if (options.onError) {
	          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
	          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
	        }
	      } // Then trigger the listeners
	
	
	      if (options.listeners) {
	        _this2.listeners.forEach(function (listener) {
	          listener(_this2.currentResult);
	        });
	      }
	    });
	  };
	
	  return MutationObserver;
	}(_subscribable.Subscribable);
	
	exports.MutationObserver = MutationObserver;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueriesObserver = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _utils = __webpack_require__(43);
	
	var _notifyManager = __webpack_require__(57);
	
	var _queryObserver = __webpack_require__(393);
	
	var _subscribable = __webpack_require__(126);
	
	var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(QueriesObserver, _Subscribable);
	
	  function QueriesObserver(client, queries) {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	    _this.client = client;
	    _this.queries = [];
	    _this.result = [];
	    _this.observers = [];
	    _this.observersMap = {};
	
	    if (queries) {
	      _this.setQueries(queries);
	    }
	
	    return _this;
	  }
	
	  var _proto = QueriesObserver.prototype;
	
	  _proto.onSubscribe = function onSubscribe() {
	    var _this2 = this;
	
	    if (this.listeners.length === 1) {
	      this.observers.forEach(function (observer) {
	        observer.subscribe(function (result) {
	          _this2.onUpdate(observer, result);
	        });
	      });
	    }
	  };
	
	  _proto.onUnsubscribe = function onUnsubscribe() {
	    if (!this.listeners.length) {
	      this.destroy();
	    }
	  };
	
	  _proto.destroy = function destroy() {
	    this.listeners = [];
	    this.observers.forEach(function (observer) {
	      observer.destroy();
	    });
	  };
	
	  _proto.setQueries = function setQueries(queries, notifyOptions) {
	    this.queries = queries;
	    this.updateObservers(notifyOptions);
	  };
	
	  _proto.getCurrentResult = function getCurrentResult() {
	    return this.result;
	  };
	
	  _proto.getOptimisticResult = function getOptimisticResult(queries) {
	    return this.findMatchingObservers(queries).map(function (match) {
	      return match.observer.getOptimisticResult(match.defaultedQueryOptions);
	    });
	  };
	
	  _proto.findMatchingObservers = function findMatchingObservers(queries) {
	    var _this3 = this;
	
	    var prevObservers = this.observers;
	    var defaultedQueryOptions = queries.map(function (options) {
	      return _this3.client.defaultQueryObserverOptions(options);
	    });
	    var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
	      var match = prevObservers.find(function (observer) {
	        return observer.options.queryHash === defaultedOptions.queryHash;
	      });
	
	      if (match != null) {
	        return [{
	          defaultedQueryOptions: defaultedOptions,
	          observer: match
	        }];
	      }
	
	      return [];
	    });
	    var matchedQueryHashes = matchingObservers.map(function (match) {
	      return match.defaultedQueryOptions.queryHash;
	    });
	    var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
	      return !matchedQueryHashes.includes(defaultedOptions.queryHash);
	    });
	    var unmatchedObservers = prevObservers.filter(function (prevObserver) {
	      return !matchingObservers.some(function (match) {
	        return match.observer === prevObserver;
	      });
	    });
	    var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
	      if (options.keepPreviousData) {
	        // return previous data from one of the observers that no longer match
	        var previouslyUsedObserver = unmatchedObservers[index];
	
	        if (previouslyUsedObserver !== undefined) {
	          return {
	            defaultedQueryOptions: options,
	            observer: previouslyUsedObserver
	          };
	        }
	      }
	
	      return {
	        defaultedQueryOptions: options,
	        observer: _this3.getObserver(options)
	      };
	    });
	
	    var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
	      return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
	    };
	
	    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
	  };
	
	  _proto.getObserver = function getObserver(options) {
	    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
	    var currentObserver = this.observersMap[defaultedOptions.queryHash];
	    return currentObserver != null ? currentObserver : new _queryObserver.QueryObserver(this.client, defaultedOptions);
	  };
	
	  _proto.updateObservers = function updateObservers(notifyOptions) {
	    var _this4 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      var prevObservers = _this4.observers;
	
	      var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes
	
	
	      newObserverMatches.forEach(function (match) {
	        return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
	      });
	      var newObservers = newObserverMatches.map(function (match) {
	        return match.observer;
	      });
	      var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
	        return [observer.options.queryHash, observer];
	      }));
	      var newResult = newObservers.map(function (observer) {
	        return observer.getCurrentResult();
	      });
	      var hasIndexChange = newObservers.some(function (observer, index) {
	        return observer !== prevObservers[index];
	      });
	
	      if (prevObservers.length === newObservers.length && !hasIndexChange) {
	        return;
	      }
	
	      _this4.observers = newObservers;
	      _this4.observersMap = newObserversMap;
	      _this4.result = newResult;
	
	      if (!_this4.hasListeners()) {
	        return;
	      }
	
	      (0, _utils.difference)(prevObservers, newObservers).forEach(function (observer) {
	        observer.destroy();
	      });
	      (0, _utils.difference)(newObservers, prevObservers).forEach(function (observer) {
	        observer.subscribe(function (result) {
	          _this4.onUpdate(observer, result);
	        });
	      });
	
	      _this4.notify();
	    });
	  };
	
	  _proto.onUpdate = function onUpdate(observer, result) {
	    var index = this.observers.indexOf(observer);
	
	    if (index !== -1) {
	      this.result = (0, _utils.replaceAt)(this.result, index, result);
	      this.notify();
	    }
	  };
	
	  _proto.notify = function notify() {
	    var _this5 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this5.listeners.forEach(function (listener) {
	        listener(_this5.result);
	      });
	    });
	  };
	
	  return QueriesObserver;
	}(_subscribable.Subscribable);
	
	exports.QueriesObserver = QueriesObserver;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueryCache = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _utils = __webpack_require__(43);
	
	var _query = __webpack_require__(2017);
	
	var _notifyManager = __webpack_require__(57);
	
	var _subscribable = __webpack_require__(126);
	
	// CLASS
	var QueryCache = /*#__PURE__*/function (_Subscribable) {
	  (0, _inheritsLoose2.default)(QueryCache, _Subscribable);
	
	  function QueryCache(config) {
	    var _this;
	
	    _this = _Subscribable.call(this) || this;
	    _this.config = config || {};
	    _this.queries = [];
	    _this.queriesMap = {};
	    return _this;
	  }
	
	  var _proto = QueryCache.prototype;
	
	  _proto.build = function build(client, options, state) {
	    var _options$queryHash;
	
	    var queryKey = options.queryKey;
	    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utils.hashQueryKeyByOptions)(queryKey, options);
	    var query = this.get(queryHash);
	
	    if (!query) {
	      query = new _query.Query({
	        cache: this,
	        queryKey: queryKey,
	        queryHash: queryHash,
	        options: client.defaultQueryOptions(options),
	        state: state,
	        defaultOptions: client.getQueryDefaults(queryKey),
	        meta: options.meta
	      });
	      this.add(query);
	    }
	
	    return query;
	  };
	
	  _proto.add = function add(query) {
	    if (!this.queriesMap[query.queryHash]) {
	      this.queriesMap[query.queryHash] = query;
	      this.queries.push(query);
	      this.notify({
	        type: 'queryAdded',
	        query: query
	      });
	    }
	  };
	
	  _proto.remove = function remove(query) {
	    var queryInMap = this.queriesMap[query.queryHash];
	
	    if (queryInMap) {
	      query.destroy();
	      this.queries = this.queries.filter(function (x) {
	        return x !== query;
	      });
	
	      if (queryInMap === query) {
	        delete this.queriesMap[query.queryHash];
	      }
	
	      this.notify({
	        type: 'queryRemoved',
	        query: query
	      });
	    }
	  };
	
	  _proto.clear = function clear() {
	    var _this2 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this2.queries.forEach(function (query) {
	        _this2.remove(query);
	      });
	    });
	  };
	
	  _proto.get = function get(queryHash) {
	    return this.queriesMap[queryHash];
	  };
	
	  _proto.getAll = function getAll() {
	    return this.queries;
	  };
	
	  _proto.find = function find(arg1, arg2) {
	    var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2),
	        filters = _parseFilterArgs[0];
	
	    if (typeof filters.exact === 'undefined') {
	      filters.exact = true;
	    }
	
	    return this.queries.find(function (query) {
	      return (0, _utils.matchQuery)(filters, query);
	    });
	  };
	
	  _proto.findAll = function findAll(arg1, arg2) {
	    var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2),
	        filters = _parseFilterArgs2[0];
	
	    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
	      return (0, _utils.matchQuery)(filters, query);
	    }) : this.queries;
	  };
	
	  _proto.notify = function notify(event) {
	    var _this3 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this3.listeners.forEach(function (listener) {
	        listener(event);
	      });
	    });
	  };
	
	  _proto.onFocus = function onFocus() {
	    var _this4 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this4.queries.forEach(function (query) {
	        query.onFocus();
	      });
	    });
	  };
	
	  _proto.onOnline = function onOnline() {
	    var _this5 = this;
	
	    _notifyManager.notifyManager.batch(function () {
	      _this5.queries.forEach(function (query) {
	        query.onOnline();
	      });
	    });
	  };
	
	  return QueryCache;
	}(_subscribable.Subscribable);
	
	exports.QueryCache = QueryCache;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueryErrorResetBoundary = exports.useQueryErrorResetBoundary = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function createValue() {
	  var _isReset = false;
	  return {
	    clearReset: function clearReset() {
	      _isReset = false;
	    },
	    reset: function reset() {
	      _isReset = true;
	    },
	    isReset: function isReset() {
	      return _isReset;
	    }
	  };
	}
	
	var QueryErrorResetBoundaryContext = /*#__PURE__*/_react.default.createContext(createValue()); // HOOK
	
	
	var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
	  return _react.default.useContext(QueryErrorResetBoundaryContext);
	}; // COMPONENT
	
	
	exports.useQueryErrorResetBoundary = useQueryErrorResetBoundary;
	
	var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
	  var children = _ref.children;
	
	  var value = _react.default.useMemo(function () {
	    return createValue();
	  }, []);
	
	  return /*#__PURE__*/_react.default.createElement(QueryErrorResetBoundaryContext.Provider, {
	    value: value
	  }, typeof children === 'function' ? children(value) : children);
	};
	
	exports.QueryErrorResetBoundary = QueryErrorResetBoundary;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useBaseQuery = useBaseQuery;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _notifyManager = __webpack_require__(57);
	
	var _QueryErrorResetBoundary = __webpack_require__(675);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	var _utils = __webpack_require__(677);
	
	function useBaseQuery(options, Observer) {
	  var mountedRef = _react.default.useRef(false);
	
	  var _React$useState = _react.default.useState(0),
	      forceUpdate = _React$useState[1];
	
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	  var errorResetBoundary = (0, _QueryErrorResetBoundary.useQueryErrorResetBoundary)();
	  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
	
	  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
	
	  if (defaultedOptions.onError) {
	    defaultedOptions.onError = _notifyManager.notifyManager.batchCalls(defaultedOptions.onError);
	  }
	
	  if (defaultedOptions.onSuccess) {
	    defaultedOptions.onSuccess = _notifyManager.notifyManager.batchCalls(defaultedOptions.onSuccess);
	  }
	
	  if (defaultedOptions.onSettled) {
	    defaultedOptions.onSettled = _notifyManager.notifyManager.batchCalls(defaultedOptions.onSettled);
	  }
	
	  if (defaultedOptions.suspense) {
	    // Always set stale time when using suspense to prevent
	    // fetching again when directly mounting after suspending
	    if (typeof defaultedOptions.staleTime !== 'number') {
	      defaultedOptions.staleTime = 1000;
	    } // Set cache time to 1 if the option has been set to 0
	    // when using suspense to prevent infinite loop of fetches
	
	
	    if (defaultedOptions.cacheTime === 0) {
	      defaultedOptions.cacheTime = 1;
	    }
	  }
	
	  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
	    // Prevent retrying failed query if the error boundary has not been reset yet
	    if (!errorResetBoundary.isReset()) {
	      defaultedOptions.retryOnMount = false;
	    }
	  }
	
	  var _React$useState2 = _react.default.useState(function () {
	    return new Observer(queryClient, defaultedOptions);
	  }),
	      observer = _React$useState2[0];
	
	  var result = observer.getOptimisticResult(defaultedOptions);
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    errorResetBoundary.clearReset();
	    var unsubscribe = observer.subscribe(_notifyManager.notifyManager.batchCalls(function () {
	      if (mountedRef.current) {
	        forceUpdate(function (x) {
	          return x + 1;
	        });
	      }
	    })); // Update result to make sure we did not miss any query updates
	    // between creating the observer and subscribing to it.
	
	    observer.updateResult();
	    return function () {
	      mountedRef.current = false;
	      unsubscribe();
	    };
	  }, [errorResetBoundary, observer]);
	
	  _react.default.useEffect(function () {
	    // Do not notify on updates because of changes in the options because
	    // these changes should already be reflected in the optimistic result.
	    observer.setOptions(defaultedOptions, {
	      listeners: false
	    });
	  }, [defaultedOptions, observer]); // Handle suspense
	
	
	  if (defaultedOptions.suspense && result.isLoading) {
	    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
	      var data = _ref.data;
	      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
	      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
	    }).catch(function (error) {
	      errorResetBoundary.clearReset();
	      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
	      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
	    });
	  } // Handle error boundary
	
	
	  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utils.shouldThrowError)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
	    throw result.error;
	  } // Handle result property usage tracking
	
	
	  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
	    result = observer.trackResult(result, defaultedOptions);
	  }
	
	  return result;
	}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.shouldThrowError = shouldThrowError;
	
	function shouldThrowError(suspense, _useErrorBoundary, params) {
	  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
	  if (typeof _useErrorBoundary === 'function') {
	    return _useErrorBoundary.apply(void 0, params);
	  } // Allow useErrorBoundary to override suspense's throwing behavior
	
	
	  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
	
	  return !!suspense;
	}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	var _interopRequireWildcard = __webpack_require__(60)["default"];
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(352));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(2047);
	
	var _Subscription = __webpack_require__(395);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(396);
	
	var _Context = __webpack_require__(128);
	
	var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
	    _excluded2 = ["reactReduxForwardedRef"];
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	      export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = ConnectFunction.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(684));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(128);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(128);
	
	var _useReduxContext2 = __webpack_require__(680);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.setBatch = exports.getBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(2044));
	
	var _warning = _interopRequireDefault(__webpack_require__(685));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(274),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(563);__webpack_require__(15),__webpack_require__(306);var invariant=_interopDefault(__webpack_require__(462));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;
	
	var _Link = __webpack_require__(2051);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(2049);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Element = __webpack_require__(2050);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _scroller = __webpack_require__(275);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _scrollEvents = __webpack_require__(398);
	
	var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
	
	var _scrollSpy = __webpack_require__(400);
	
	var _scrollSpy2 = _interopRequireDefault(_scrollSpy);
	
	var _animateScroll = __webpack_require__(688);
	
	var _animateScroll2 = _interopRequireDefault(_animateScroll);
	
	var _scrollLink = __webpack_require__(399);
	
	var _scrollLink2 = _interopRequireDefault(_scrollLink);
	
	var _scrollElement = __webpack_require__(689);
	
	var _scrollElement2 = _interopRequireDefault(_scrollElement);
	
	var _Helpers = __webpack_require__(2052);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Link = _Link2.default;
	exports.Button = _Button2.default;
	exports.Element = _Element2.default;
	exports.scroller = _scroller2.default;
	exports.Events = _scrollEvents2.default;
	exports.scrollSpy = _scrollSpy2.default;
	exports.animateScroll = _animateScroll2.default;
	exports.ScrollLink = _scrollLink2.default;
	exports.ScrollElement = _scrollElement2.default;
	exports.Helpers = _Helpers2.default;
	exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(276);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _smooth = __webpack_require__(2054);
	
	var _smooth2 = _interopRequireDefault(_smooth);
	
	var _cancelEvents = __webpack_require__(2053);
	
	var _cancelEvents2 = _interopRequireDefault(_cancelEvents);
	
	var _scrollEvents = __webpack_require__(398);
	
	var _scrollEvents2 = _interopRequireDefault(_scrollEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Gets the easing type from the smooth prop within options.
	 */
	var getAnimationType = function getAnimationType(options) {
	  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
	};
	/*
	 * Function helper
	 */
	var functionWrapper = function functionWrapper(value) {
	  return typeof value === 'function' ? value : function () {
	    return value;
	  };
	};
	/*
	 * Wraps window properties to allow server side rendering
	 */
	var currentWindowProperties = function currentWindowProperties() {
	  if (typeof window !== 'undefined') {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
	  }
	};
	
	/*
	 * Helper function to never extend 60fps on the webpage.
	 */
	var requestAnimationFrameHelper = function () {
	  return currentWindowProperties() || function (callback, element, delay) {
	    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
	  };
	}();
	
	var makeData = function makeData() {
	  return {
	    currentPositionY: 0,
	    startPositionY: 0,
	    targetPositionY: 0,
	    progress: 0,
	    duration: 0,
	    cancel: false,
	
	    target: null,
	    containerElement: null,
	    to: null,
	    start: null,
	    deltaTop: null,
	    percent: null,
	    delayTimeout: null
	  };
	};
	
	var currentPositionY = function currentPositionY(options) {
	  var containerElement = options.data.containerElement;
	  if (containerElement && containerElement !== document && containerElement !== document.body) {
	    return containerElement.scrollTop;
	  } else {
	    var supportPageOffset = window.pageXOffset !== undefined;
	    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
	    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	  }
	};
	
	var scrollContainerHeight = function scrollContainerHeight(options) {
	  var containerElement = options.data.containerElement;
	  if (containerElement && containerElement !== document && containerElement !== document.body) {
	    return containerElement.scrollHeight - containerElement.offsetHeight;
	  } else {
	    var body = document.body;
	    var html = document.documentElement;
	
	    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	  }
	};
	
	var animateScroll = function animateScroll(easing, options, timestamp) {
	  var data = options.data;
	
	  // Cancel on specific events
	  if (!options.ignoreCancelEvents && data.cancel) {
	    if (_scrollEvents2.default.registered['end']) {
	      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
	    }
	    return;
	  };
	
	  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);
	
	  if (data.start === null) {
	    data.start = timestamp;
	  }
	
	  data.progress = timestamp - data.start;
	
	  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
	
	  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);
	
	  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
	    data.containerElement.scrollTop = data.currentPositionY;
	  } else {
	    window.scrollTo(0, data.currentPositionY);
	  }
	
	  if (data.percent < 1) {
	    var easedAnimate = animateScroll.bind(null, easing, options);
	    requestAnimationFrameHelper.call(window, easedAnimate);
	    return;
	  }
	
	  if (_scrollEvents2.default.registered['end']) {
	    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
	  }
	};
	
	var setContainer = function setContainer(options) {
	  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
	};
	
	var animateTopScroll = function animateTopScroll(y, options, to, target) {
	  options.data = options.data || makeData();
	
	  window.clearTimeout(options.data.delayTimeout);
	
	  _cancelEvents2.default.subscribe(function () {
	    options.data.cancel = true;
	  });
	
	  setContainer(options);
	
	  options.data.start = null;
	  options.data.cancel = false;
	  options.data.startPositionY = currentPositionY(options);
	  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;
	
	  if (options.data.startPositionY === options.data.targetPositionY) {
	    if (_scrollEvents2.default.registered['end']) {
	      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
	    }
	    return;
	  }
	
	  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);
	
	  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
	  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
	  options.data.to = to;
	  options.data.target = target;
	
	  var easing = getAnimationType(options);
	  var easedAnimate = animateScroll.bind(null, easing, options);
	
	  if (options && options.delay > 0) {
	    options.data.delayTimeout = window.setTimeout(function () {
	      if (_scrollEvents2.default.registered['begin']) {
	        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
	      }
	      requestAnimationFrameHelper.call(window, easedAnimate);
	    }, options.delay);
	    return;
	  }
	
	  if (_scrollEvents2.default.registered['begin']) {
	    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
	  }
	  requestAnimationFrameHelper.call(window, easedAnimate);
	};
	
	var proceedOptions = function proceedOptions(options) {
	  options = _extends({}, options);
	  options.data = options.data || makeData();
	  options.absolute = true;
	  return options;
	};
	
	var scrollToTop = function scrollToTop(options) {
	  animateTopScroll(0, proceedOptions(options));
	};
	
	var scrollTo = function scrollTo(toY, options) {
	  animateTopScroll(toY, proceedOptions(options));
	};
	
	var scrollToBottom = function scrollToBottom(options) {
	  options = proceedOptions(options);
	  setContainer(options);
	  animateTopScroll(scrollContainerHeight(options), options);
	};
	
	var scrollMore = function scrollMore(toY, options) {
	  options = proceedOptions(options);
	  setContainer(options);
	  animateTopScroll(currentPositionY(options) + toY, options);
	};
	
	exports.default = {
	  animateTopScroll: animateTopScroll,
	  getAnimationType: getAnimationType,
	  scrollToTop: scrollToTop,
	  scrollToBottom: scrollToBottom,
	  scrollTo: scrollTo,
	  scrollMore: scrollMore
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _scroller = __webpack_require__(275);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Component) {
	  var Element = function (_React$Component) {
	    _inherits(Element, _React$Component);
	
	    function Element(props) {
	      _classCallCheck(this, Element);
	
	      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
	
	      _this.childBindings = {
	        domNode: null
	      };
	      return _this;
	    }
	
	    _createClass(Element, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (typeof window === 'undefined') {
	          return false;
	        }
	        this.registerElems(this.props.name);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        if (this.props.name !== prevProps.name) {
	          this.registerElems(this.props.name);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (typeof window === 'undefined') {
	          return false;
	        }
	        _scroller2.default.unregister(this.props.name);
	      }
	    }, {
	      key: 'registerElems',
	      value: function registerElems(name) {
	        _scroller2.default.register(name, this.childBindings.domNode);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
	      }
	    }]);
	
	    return Element;
	  }(_react2.default.Component);
	
	  ;
	
	  Element.propTypes = {
	    name: _propTypes2.default.string,
	    id: _propTypes2.default.string
	  };
	
	  return Element;
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _passiveEventListeners = __webpack_require__(397);
	
	var _utils = __webpack_require__(276);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollHash = {
	  mountFlag: false,
	  initialized: false,
	  scroller: null,
	  containers: {},
	
	  mount: function mount(scroller) {
	    this.scroller = scroller;
	
	    this.handleHashChange = this.handleHashChange.bind(this);
	    window.addEventListener('hashchange', this.handleHashChange);
	
	    this.initStateFromHash();
	    this.mountFlag = true;
	  },
	  mapContainer: function mapContainer(to, container) {
	    this.containers[to] = container;
	  },
	  isMounted: function isMounted() {
	    return this.mountFlag;
	  },
	  isInitialized: function isInitialized() {
	    return this.initialized;
	  },
	  initStateFromHash: function initStateFromHash() {
	    var _this = this;
	
	    var hash = this.getHash();
	    if (hash) {
	      window.setTimeout(function () {
	        _this.scrollTo(hash, true);
	        _this.initialized = true;
	      }, 10);
	    } else {
	      this.initialized = true;
	    }
	  },
	  scrollTo: function scrollTo(to, isInit) {
	    var scroller = this.scroller;
	    var element = scroller.get(to);
	    if (element && (isInit || to !== scroller.getActiveLink())) {
	      var container = this.containers[to] || document;
	      scroller.scrollTo(to, { container: container });
	    }
	  },
	  getHash: function getHash() {
	    return _utils2.default.getHash();
	  },
	  changeHash: function changeHash(to) {
	    if (this.isInitialized() && _utils2.default.getHash() !== to) {
	      _utils2.default.pushHash(to);
	    }
	  },
	  handleHashChange: function handleHashChange() {
	    this.scrollTo(this.getHash());
	  },
	  unmount: function unmount() {
	    this.scroller = null;
	    this.containers = null;
	    window.removeEventListener('hashchange', this.handleHashChange);
	  }
	};
	
	exports.default = scrollHash;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(277);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(697);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(401);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(402);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(277);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(2057);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(405);
	var core = __webpack_require__(280);
	var ctx = __webpack_require__(2088);
	var hide = __webpack_require__(2091);
	var has = __webpack_require__(702);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(2087);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(2085);
	var IE8_DOM_DEFINE = __webpack_require__(2092);
	var toPrimitive = __webpack_require__(2105);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(188) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 705 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(703);
	var defined = __webpack_require__(700);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createAction;
	
	var _types = __webpack_require__(708);
	
	var id = 0;
	
	var identity = function identity(arg) {
	  return arg;
	};
	
	var normalize = function normalize(dispatchOrStore) {
	  if (dispatchOrStore && typeof dispatchOrStore.dispatch === 'function') {
	    return dispatchOrStore.dispatch;
	  } else {
	    return dispatchOrStore;
	  }
	};
	
	var normalizeAll = function normalizeAll(dispatchOrStores) {
	  if (Array.isArray(dispatchOrStores)) {
	    return dispatchOrStores.map(normalize);
	  } else {
	    return normalize(dispatchOrStores);
	  }
	};
	
	function createAction(description, payloadReducer, metaReducer) {
	  if (typeof description === 'function') {
	    metaReducer = payloadReducer;
	    payloadReducer = description;
	    description = undefined;
	  }
	
	  if (typeof payloadReducer !== 'function') {
	    payloadReducer = identity;
	  }
	
	  if (typeof metaReducer !== 'function') {
	    metaReducer = undefined;
	  }
	
	  var isSerializable = typeof description === 'string' && /^[0-9A-Z_]+$/.test(description);
	
	  if (isSerializable) {
	    (0, _types.check)(description);
	    (0, _types.add)(description);
	  } else {
	    ++id;
	  }
	
	  var type = isSerializable ? description : "[".concat(id, "]").concat(description ? ' ' + description : '');
	  var dispatchFunctions = undefined;
	
	  function makeAction() {
	    var payload = payloadReducer.apply(void 0, arguments);
	
	    if (metaReducer) {
	      return {
	        type: type,
	        payload: payload,
	        error: payload instanceof Error,
	        meta: metaReducer.apply(void 0, arguments)
	      };
	    }
	
	    return {
	      type: type,
	      payload: payload,
	      error: payload instanceof Error
	    };
	  }
	
	  var makeAndDispatch = function makeAndDispatch(dispatchs, isError) {
	    return function () {
	      var payloadedAction = makeAction.apply(void 0, arguments);
	
	      if (!payloadedAction.error) {
	        payloadedAction.error = isError;
	      }
	
	      if (Array.isArray(dispatchs)) {
	        return dispatchs.map(function (dispatch) {
	          return dispatch(payloadedAction);
	        });
	      } else if (dispatchs) {
	        return dispatchs(payloadedAction);
	      } else {
	        return payloadedAction;
	      }
	    };
	  };
	
	  function actionCreator() {
	    return makeAndDispatch(dispatchFunctions, false).apply(void 0, arguments);
	  }
	
	  actionCreator.asError = function () {
	    return makeAndDispatch(dispatchFunctions, true).apply(void 0, arguments);
	  };
	
	  actionCreator.getType = function () {
	    return type;
	  };
	
	  actionCreator.toString = function () {
	    return type;
	  };
	
	  actionCreator.raw = makeAction;
	
	  actionCreator.assignTo = function (dispatchOrStores) {
	    dispatchFunctions = normalizeAll(dispatchOrStores);
	    return actionCreator;
	  };
	
	  actionCreator.assigned = function () {
	    return !!dispatchFunctions;
	  };
	
	  actionCreator.bound = function () {
	    return false;
	  };
	
	  actionCreator.dispatched = actionCreator.assigned;
	
	  actionCreator.bindTo = function (dispatchOrStores) {
	    var boundActionCreator = makeAndDispatch(normalizeAll(dispatchOrStores, false));
	    boundActionCreator.asError = makeAndDispatch(normalizeAll(dispatchOrStores, true));
	    boundActionCreator.raw = makeAction;
	    boundActionCreator.getType = actionCreator.getType;
	    boundActionCreator.toString = actionCreator.toString;
	
	    boundActionCreator.assignTo = function () {
	      return boundActionCreator;
	    };
	
	    boundActionCreator.bindTo = function () {
	      return boundActionCreator;
	    };
	
	    boundActionCreator.assigned = function () {
	      return false;
	    };
	
	    boundActionCreator.bound = function () {
	      return true;
	    };
	
	    boundActionCreator.dispatched = boundActionCreator.bound;
	    return boundActionCreator;
	  };
	
	  return actionCreator;
	}
	
	;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.remove = remove;
	exports.has = has;
	exports.check = check;
	exports.all = all;
	exports.clear = clear;
	exports.enableChecking = enableChecking;
	exports.disableChecking = disableChecking;
	var types = {};
	var config = {
	  checkExisting: true
	};
	
	function add(name) {
	  types[name] = true;
	}
	
	function remove(name) {
	  types[name] = false;
	}
	
	function has(name) {
	  return !!types[name];
	}
	
	function check(name) {
	  if (config.checkExisting && has(name)) {
	    throw new TypeError("Duplicate action type: ".concat(name));
	  }
	}
	
	function all() {
	  return Object.keys(types).filter(has);
	}
	
	function clear() {
	  all().forEach(remove);
	}
	
	function enableChecking() {
	  config.checkExisting = true;
	}
	
	function disableChecking() {
	  config.checkExisting = false;
	}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = handleAction;
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(283));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(190));
	
	var _identity = _interopRequireDefault(__webpack_require__(408));
	
	var _isNil = _interopRequireDefault(__webpack_require__(714));
	
	var _isUndefined = _interopRequireDefault(__webpack_require__(2129));
	
	var _toString = _interopRequireDefault(__webpack_require__(716));
	
	var _constants = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type, reducer, defaultState) {
	  if (reducer === void 0) {
	    reducer = _identity.default;
	  }
	
	  var types = (0, _toString.default)(type).split(_constants.ACTION_TYPE_DELIMITER);
	  (0, _invariant.default)(!(0, _isUndefined.default)(defaultState), "defaultState for reducer handling " + types.join(', ') + " should be defined");
	  (0, _invariant.default)((0, _isFunction.default)(reducer) || (0, _isPlainObject.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil.default)(aReducer) ? _identity.default : aReducer;
	  }),
	      nextReducer = _ref[0],
	      throwReducer = _ref[1];
	
	  return function (state, action) {
	    if (state === void 0) {
	      state = defaultState;
	    }
	
	    var actionType = action.type;
	
	    if (!actionType || types.indexOf((0, _toString.default)(actionType)) === -1) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _toCamelCase = _interopRequireDefault(__webpack_require__(2385));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespacer = '/';
	
	var _default = function _default(type) {
	  return type.indexOf(namespacer) === -1 ? (0, _toCamelCase.default)(type) : type.split(namespacer).map(_toCamelCase.default).join(namespacer);
	};
	
	exports.default = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _constants = __webpack_require__(189);
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(409));
	
	var _get = _interopRequireDefault(__webpack_require__(712));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(predicate) {
	  return function flatten(map, _temp, partialFlatMap, partialFlatActionType) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$namespace = _ref.namespace,
	        namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	        prefix = _ref.prefix;
	
	    if (partialFlatMap === void 0) {
	      partialFlatMap = {};
	    }
	
	    if (partialFlatActionType === void 0) {
	      partialFlatActionType = '';
	    }
	
	    function connectNamespace(type) {
	      var _ref2;
	
	      if (!partialFlatActionType) return type;
	      var types = type.toString().split(_constants.ACTION_TYPE_DELIMITER);
	      var partials = partialFlatActionType.split(_constants.ACTION_TYPE_DELIMITER);
	      return (_ref2 = []).concat.apply(_ref2, partials.map(function (p) {
	        return types.map(function (t) {
	          return "" + p + namespace + t;
	        });
	      })).join(_constants.ACTION_TYPE_DELIMITER);
	    }
	
	    function connectPrefix(type) {
	      if (partialFlatActionType || !prefix || prefix && new RegExp("^" + prefix + namespace).test(type)) {
	        return type;
	      }
	
	      return "" + prefix + namespace + type;
	    }
	
	    (0, _ownKeys.default)(map).forEach(function (type) {
	      var nextNamespace = connectPrefix(connectNamespace(type));
	      var mapValue = (0, _get.default)(type, map);
	
	      if (predicate(mapValue)) {
	        flatten(mapValue, {
	          namespace: namespace,
	          prefix: prefix
	        }, partialFlatMap, nextNamespace);
	      } else {
	        partialFlatMap[nextNamespace] = mapValue;
	      }
	    });
	    return partialFlatMap;
	  };
	};
	
	exports.default = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = get;
	
	var _isMap = _interopRequireDefault(__webpack_require__(284));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(key, x) {
	  return (0, _isMap.default)(x) ? x.get(key) : x[key];
	}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value.length === 0;
	};
	
	exports.default = _default;

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === null || value === undefined;
	};
	
	exports.default = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'string';
	};
	
	exports.default = _default;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value.toString();
	};
	
	exports.default = _default;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.isSubmissionError = isSubmissionError;
	exports.SubmissionError = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _es6Error = _interopRequireDefault(__webpack_require__(1316));
	
	var __FLAG__ = '@@redux-form/submission-error-flag';
	
	var SubmissionError = /*#__PURE__*/function (_ExtendableError) {
	  (0, _inheritsLoose2["default"])(SubmissionError, _ExtendableError);
	
	  /** @private */
	  function SubmissionError(errors) {
	    var _this;
	
	    _this = _ExtendableError.call(this, 'Submit Validation Failed') || this;
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error["default"]);
	
	exports.SubmissionError = SubmissionError;
	SubmissionError.__FLAG__ = __FLAG__;
	
	function isSubmissionError(error) {
	  return (error && error.constructor && error.constructor.__FLAG__ === __FLAG__) === true;
	}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _actionTypes = __webpack_require__(410);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: {
	      form: form,
	      field: field,
	      from: from,
	      to: to
	    }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: {
	      form: form,
	      field: field,
	      index: index,
	      removeNum: removeNum
	    }
	  };
	
	  if (value !== undefined) {
	    action.payload = value;
	  }
	
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	
	  return {
	    type: _actionTypes.ARRAY_SWAP,
	    meta: {
	      form: form,
	      field: field,
	      indexA: indexA,
	      indexB: indexB
	    }
	  };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch
	    },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch,
	      persistentSubmitErrors: persistentSubmitErrors
	    },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
	  for (var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    fields[_key - 3] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.CLEAR_FIELDS,
	    meta: {
	      form: form,
	      keepTouched: keepTouched,
	      persistentSubmitErrors: persistentSubmitErrors,
	      fields: fields
	    }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    form[_key2] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty, otherMeta) {
	  if (otherMeta === void 0) {
	    otherMeta = {};
	  }
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: (0, _extends2["default"])({
	      form: form,
	      keepDirty: keepDirty
	    }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      type: type
	    }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var resetSection = function resetSection(form) {
	  for (var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    sections[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.RESET_SECTION,
	    meta: {
	      form: form,
	      sections: sections
	    }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    fields[_key6 - 1] = arguments[_key6];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var unregisterField = function unregisterField(form, name, destroyOnUnmount) {
	  if (destroyOnUnmount === void 0) {
	    destroyOnUnmount = true;
	  }
	
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      destroyOnUnmount: destroyOnUnmount
	    }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    fields[_key7 - 1] = arguments[_key7];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
	  if (syncErrors === void 0) {
	    syncErrors = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncErrors: syncErrors,
	      error: error
	    }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
	  if (syncWarnings === void 0) {
	    syncWarnings = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncWarnings: syncWarnings,
	      warning: warning
	    }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearFields: clearFields,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  resetSection: resetSection,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	var _default = actions;
	exports["default"] = _default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldProps;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return (0, _extends2["default"])({}, props, {
	      checked: !!value
	    });
	  }
	
	  if (type === 'radio') {
	    return (0, _extends2["default"])({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	
	  if (type === 'select-multiple') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || []
	    });
	  }
	
	  if (type === 'file') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || undefined
	    });
	  }
	
	  return props;
	};
	
	function createFieldProps(_ref, name, _ref2) {
	  var getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      deepEqual = _ref.deepEqual;
	  var asyncError = _ref2.asyncError,
	      asyncValidating = _ref2.asyncValidating,
	      onBlur = _ref2.onBlur,
	      onChange = _ref2.onChange,
	      onDrop = _ref2.onDrop,
	      onDragStart = _ref2.onDragStart,
	      dirty = _ref2.dirty,
	      dispatch = _ref2.dispatch,
	      onFocus = _ref2.onFocus,
	      form = _ref2.form,
	      format = _ref2.format,
	      initial = _ref2.initial,
	      parse = _ref2.parse,
	      pristine = _ref2.pristine,
	      props = _ref2.props,
	      state = _ref2.state,
	      submitError = _ref2.submitError,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      validate = _ref2.validate,
	      value = _ref2.value,
	      _value = _ref2._value,
	      warn = _ref2.warn,
	      custom = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: (0, _extends2["default"])({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: (0, _extends2["default"])({}, custom, {}, props)
	  };
	}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	
	  switch (trigger) {
	    case 'blur':
	    case 'change':
	      // blurring
	      return true;
	
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	
	    default:
	      return false;
	  }
	};
	
	var _default = defaultShouldAsyncValidate;
	exports["default"] = _default;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldError;
	exports["default"] = _default;

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldValidate;
	exports["default"] = _default;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldWarn;
	exports["default"] = _default;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getValue = _interopRequireDefault(__webpack_require__(2152));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(726));
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	  // read value from input
	  var value = (0, _getValue["default"])(event, _isReactNative["default"]); // parse value if we have a parser
	
	  if (parse) {
	    value = parse(value, name);
	  } // normalize value
	
	
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	var _default = onChangeValue;
	exports["default"] = _default;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(411));
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent["default"])(event);
	
	  if (is) {
	    event.preventDefault();
	  }
	
	  return is;
	};
	
	var _default = silenceEvent;
	exports["default"] = _default;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	var _default = isReactNative;
	exports["default"] = _default;

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsPristine;
	
	function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      if (fields && fields.length) {
	        return fields.every(function (field) {
	          var fieldInitial = getIn(formState, form + ".initial." + field);
	          var fieldValue = getIn(formState, form + ".values." + field);
	          return deepEqual(fieldInitial, fieldValue);
	        });
	      }
	
	      var initial = getIn(formState, form + ".initial") || empty;
	      var values = getIn(formState, form + ".values") || initial;
	      return deepEqual(initial, values);
	    };
	  };
	}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(590));
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  var propsEqual = (0, _isEqualWith2["default"])(instance.props, nextProps, customizer);
	  var stateEqual = (0, _isEqualWith2["default"])(instance.state, nextState, customizer);
	  return !propsEqual || !stateEqual;
	};
	
	var _default = shallowCompare;
	exports["default"] = _default;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObservable = void 0;
	var tslib_1 = __webpack_require__(2388);
	var rxjs_1 = __webpack_require__(414);
	var StateObservable = /** @class */ (function (_super) {
	    tslib_1.__extends(StateObservable, _super);
	    function StateObservable(input$, initialState) {
	        var _this = _super.call(this, function (subscriber) {
	            var subscription = _this.__notifier.subscribe(subscriber);
	            if (subscription && !subscription.closed) {
	                subscriber.next(_this.value);
	            }
	            return subscription;
	        }) || this;
	        _this.__notifier = new rxjs_1.Subject();
	        _this.value = initialState;
	        input$.subscribe(function (value) {
	            // We only want to update state$ if it has actually changed since
	            // redux requires reducers use immutability patterns.
	            // This is basically what distinctUntilChanged() does but it's so simple
	            // we don't need to pull that code in
	            if (value !== _this.value) {
	                _this.value = value;
	                _this.__notifier.next(value);
	            }
	        });
	        return _this;
	    }
	    return StateObservable;
	}(rxjs_1.Observable));
	exports.StateObservable = StateObservable;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.__FOR_TESTING__resetDeprecationsSeen = exports.ofType = exports.combineEpics = exports.StateObservable = exports.createEpicMiddleware = void 0;
	var createEpicMiddleware_1 = __webpack_require__(2205);
	Object.defineProperty(exports, "createEpicMiddleware", { enumerable: true, get: function () { return createEpicMiddleware_1.createEpicMiddleware; } });
	var StateObservable_1 = __webpack_require__(729);
	Object.defineProperty(exports, "StateObservable", { enumerable: true, get: function () { return StateObservable_1.StateObservable; } });
	var combineEpics_1 = __webpack_require__(2204);
	Object.defineProperty(exports, "combineEpics", { enumerable: true, get: function () { return combineEpics_1.combineEpics; } });
	var operators_1 = __webpack_require__(2206);
	Object.defineProperty(exports, "ofType", { enumerable: true, get: function () { return operators_1.ofType; } });
	// eslint-disable-next-line camelcase
	var console_1 = __webpack_require__(413);
	Object.defineProperty(exports, "__FOR_TESTING__resetDeprecationsSeen", { enumerable: true, get: function () { return console_1.resetDeprecationsSeen; } });


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BehaviorSubject = void 0;
	var Subject_1 = __webpack_require__(46);
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        var _this = _super.call(this) || this;
	        _this._value = _value;
	        return _this;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        !subscription.closed && subscriber.next(this._value);
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
	        if (hasError) {
	            throw thrownError;
	        }
	        this._throwIfClosed();
	        return _value;
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, (this._value = value));
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Scheduler = void 0;
	var dateTimestampProvider_1 = __webpack_require__(439);
	var Scheduler = (function () {
	    function Scheduler(schedulerActionCtor, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.schedulerActionCtor = schedulerActionCtor;
	        this.now = now;
	    }
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.schedulerActionCtor(this, work).schedule(state, delay);
	    };
	    Scheduler.now = dateTimestampProvider_1.dateTimestampProvider.now;
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindCallbackInternals = void 0;
	var isScheduler_1 = __webpack_require__(293);
	var Observable_1 = __webpack_require__(28);
	var subscribeOn_1 = __webpack_require__(197);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var observeOn_1 = __webpack_require__(196);
	var AsyncSubject_1 = __webpack_require__(415);
	function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler_1.isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler)
	                    .apply(this, args)
	                    .pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	            };
	        }
	    }
	    if (scheduler) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return bindCallbackInternals(isNodeStyle, callbackFunc)
	                .apply(this, args)
	                .pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	        };
	    }
	    return function () {
	        var _this = this;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var subject = new AsyncSubject_1.AsyncSubject();
	        var uninitialized = true;
	        return new Observable_1.Observable(function (subscriber) {
	            var subs = subject.subscribe(subscriber);
	            if (uninitialized) {
	                uninitialized = false;
	                var isAsync_1 = false;
	                var isComplete_1 = false;
	                callbackFunc.apply(_this, __spreadArray(__spreadArray([], __read(args)), [
	                    function () {
	                        var results = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            results[_i] = arguments[_i];
	                        }
	                        if (isNodeStyle) {
	                            var err = results.shift();
	                            if (err != null) {
	                                subject.error(err);
	                                return;
	                            }
	                        }
	                        subject.next(1 < results.length ? results : results[0]);
	                        isComplete_1 = true;
	                        if (isAsync_1) {
	                            subject.complete();
	                        }
	                    },
	                ]));
	                if (isComplete_1) {
	                    subject.complete();
	                }
	                isAsync_1 = true;
	            }
	            return subs;
	        });
	    };
	}
	exports.bindCallbackInternals = bindCallbackInternals;
	//# sourceMappingURL=bindCallbackInternals.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.interval = void 0;
	var async_1 = __webpack_require__(65);
	var timer_1 = __webpack_require__(132);
	function interval(period, scheduler) {
	    if (period === void 0) { period = 0; }
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    if (period < 0) {
	        period = 0;
	    }
	    return timer_1.timer(period, period, scheduler);
	}
	exports.interval = interval;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.never = exports.NEVER = void 0;
	var Observable_1 = __webpack_require__(28);
	var noop_1 = __webpack_require__(48);
	exports.NEVER = new Observable_1.Observable(noop_1.noop);
	function never() {
	    return exports.NEVER;
	}
	exports.never = never;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.raceInit = exports.race = void 0;
	var Observable_1 = __webpack_require__(28);
	var innerFrom_1 = __webpack_require__(23);
	var argsOrArgArray_1 = __webpack_require__(134);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function race() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    sources = argsOrArgArray_1.argsOrArgArray(sources);
	    return sources.length === 1 ? innerFrom_1.innerFrom(sources[0]) : new Observable_1.Observable(raceInit(sources));
	}
	exports.race = race;
	function raceInit(sources) {
	    return function (subscriber) {
	        var subscriptions = [];
	        var _loop_1 = function (i) {
	            subscriptions.push(innerFrom_1.innerFrom(sources[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (subscriptions) {
	                    for (var s = 0; s < subscriptions.length; s++) {
	                        s !== i && subscriptions[s].unsubscribe();
	                    }
	                    subscriptions = null;
	                }
	                subscriber.next(value);
	            })));
	        };
	        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
	            _loop_1(i);
	        }
	    };
	}
	exports.raceInit = raceInit;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throwError = void 0;
	var Observable_1 = __webpack_require__(28);
	var isFunction_1 = __webpack_require__(27);
	function throwError(errorOrErrorFactory, scheduler) {
	    var errorFactory = isFunction_1.isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
	    var init = function (subscriber) { return subscriber.error(errorFactory()); };
	    return new Observable_1.Observable(scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
	}
	exports.throwError = throwError;
	//# sourceMappingURL=throwError.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.auditTime = void 0;
	var async_1 = __webpack_require__(65);
	var audit_1 = __webpack_require__(421);
	var timer_1 = __webpack_require__(132);
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.buffer = void 0;
	var lift_1 = __webpack_require__(9);
	var noop_1 = __webpack_require__(48);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function buffer(closingNotifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var currentBuffer = [];
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return currentBuffer.push(value); }, function () {
	            subscriber.next(currentBuffer);
	            subscriber.complete();
	        }));
	        closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            var b = currentBuffer;
	            currentBuffer = [];
	            subscriber.next(b);
	        }, noop_1.noop));
	        return function () {
	            currentBuffer = null;
	        };
	    });
	}
	exports.buffer = buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferCount = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var arrRemove_1 = __webpack_require__(112);
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
	    return lift_1.operate(function (source, subscriber) {
	        var buffers = [];
	        var count = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a, e_2, _b;
	            var toEmit = null;
	            if (count++ % startBufferEvery === 0) {
	                buffers.push([]);
	            }
	            try {
	                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
	                    var buffer = buffers_1_1.value;
	                    buffer.push(value);
	                    if (bufferSize <= buffer.length) {
	                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
	                        toEmit.push(buffer);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            if (toEmit) {
	                try {
	                    for (var toEmit_1 = __values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
	                        var buffer = toEmit_1_1.value;
	                        arrRemove_1.arrRemove(buffers, buffer);
	                        subscriber.next(buffer);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }, function () {
	            var e_3, _a;
	            try {
	                for (var buffers_2 = __values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
	                    var buffer = buffers_2_1.value;
	                    subscriber.next(buffer);
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            subscriber.complete();
	        }, undefined, function () {
	            buffers = null;
	        }));
	    });
	}
	exports.bufferCount = bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferTime = void 0;
	var Subscription_1 = __webpack_require__(64);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var arrRemove_1 = __webpack_require__(112);
	var async_1 = __webpack_require__(65);
	var args_1 = __webpack_require__(66);
	var executeSchedule_1 = __webpack_require__(113);
	function bufferTime(bufferTimeSpan) {
	    var _a, _b;
	    var otherArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherArgs[_i - 1] = arguments[_i];
	    }
	    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
	    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
	    var maxBufferSize = otherArgs[1] || Infinity;
	    return lift_1.operate(function (source, subscriber) {
	        var bufferRecords = [];
	        var restartOnEmit = false;
	        var emit = function (record) {
	            var buffer = record.buffer, subs = record.subs;
	            subs.unsubscribe();
	            arrRemove_1.arrRemove(bufferRecords, record);
	            subscriber.next(buffer);
	            restartOnEmit && startBuffer();
	        };
	        var startBuffer = function () {
	            if (bufferRecords) {
	                var subs = new Subscription_1.Subscription();
	                subscriber.add(subs);
	                var buffer = [];
	                var record_1 = {
	                    buffer: buffer,
	                    subs: subs,
	                };
	                bufferRecords.push(record_1);
	                executeSchedule_1.executeSchedule(subs, scheduler, function () { return emit(record_1); }, bufferTimeSpan);
	            }
	        };
	        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
	            executeSchedule_1.executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
	        }
	        else {
	            restartOnEmit = true;
	        }
	        startBuffer();
	        var bufferTimeSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            var recordsCopy = bufferRecords.slice();
	            try {
	                for (var recordsCopy_1 = __values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
	                    var record = recordsCopy_1_1.value;
	                    var buffer = record.buffer;
	                    buffer.push(value);
	                    maxBufferSize <= buffer.length && emit(record);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
	                subscriber.next(bufferRecords.shift().buffer);
	            }
	            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
	            subscriber.complete();
	            subscriber.unsubscribe();
	        }, undefined, function () { return (bufferRecords = null); });
	        source.subscribe(bufferTimeSubscriber);
	    });
	}
	exports.bufferTime = bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferToggle = void 0;
	var Subscription_1 = __webpack_require__(64);
	var lift_1 = __webpack_require__(9);
	var innerFrom_1 = __webpack_require__(23);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	var arrRemove_1 = __webpack_require__(112);
	function bufferToggle(openings, closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var buffers = [];
	        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
	            var buffer = [];
	            buffers.push(buffer);
	            var closingSubscription = new Subscription_1.Subscription();
	            var emitBuffer = function () {
	                arrRemove_1.arrRemove(buffers, buffer);
	                subscriber.next(buffer);
	                closingSubscription.unsubscribe();
	            };
	            closingSubscription.add(innerFrom_1.innerFrom(closingSelector(openValue)).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, emitBuffer, noop_1.noop)));
	        }, noop_1.noop));
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            try {
	                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
	                    var buffer = buffers_1_1.value;
	                    buffer.push(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (buffers.length > 0) {
	                subscriber.next(buffers.shift());
	            }
	            subscriber.complete();
	        }));
	    });
	}
	exports.bufferToggle = bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bufferWhen = void 0;
	var lift_1 = __webpack_require__(9);
	var noop_1 = __webpack_require__(48);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	function bufferWhen(closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var buffer = null;
	        var closingSubscriber = null;
	        var openBuffer = function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            var b = buffer;
	            buffer = [];
	            b && subscriber.next(b);
	            innerFrom_1.innerFrom(closingSelector()).subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openBuffer, noop_1.noop)));
	        };
	        openBuffer();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return buffer === null || buffer === void 0 ? void 0 : buffer.push(value); }, function () {
	            buffer && subscriber.next(buffer);
	            subscriber.complete();
	        }, undefined, function () { return (buffer = closingSubscriber = null); }));
	    });
	}
	exports.bufferWhen = bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.catchError = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var lift_1 = __webpack_require__(9);
	function catchError(selector) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub = null;
	        var syncUnsub = false;
	        var handledResult;
	        innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
	            handledResult = innerFrom_1.innerFrom(selector(err, catchError(selector)(source)));
	            if (innerSub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                handledResult.subscribe(subscriber);
	            }
	            else {
	                syncUnsub = true;
	            }
	        }));
	        if (syncUnsub) {
	            innerSub.unsubscribe();
	            innerSub = null;
	            handledResult.subscribe(subscriber);
	        }
	    });
	}
	exports.catchError = catchError;
	//# sourceMappingURL=catchError.js.map

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineAll = void 0;
	var combineLatestAll_1 = __webpack_require__(422);
	exports.combineAll = combineLatestAll_1.combineLatestAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatest = void 0;
	var combineLatest_1 = __webpack_require__(418);
	var lift_1 = __webpack_require__(9);
	var argsOrArgArray_1 = __webpack_require__(134);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var pipe_1 = __webpack_require__(294);
	var args_1 = __webpack_require__(66);
	function combineLatest() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    return resultSelector
	        ? pipe_1.pipe(combineLatest.apply(void 0, __spreadArray([], __read(args))), mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector))
	        : lift_1.operate(function (source, subscriber) {
	            combineLatest_1.combineLatestInit(__spreadArray([source], __read(argsOrArgArray_1.argsOrArgArray(args))))(subscriber);
	        });
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineLatestWith = void 0;
	var combineLatest_1 = __webpack_require__(746);
	function combineLatestWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return combineLatest_1.combineLatest.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.combineLatestWith = combineLatestWith;
	//# sourceMappingURL=combineLatestWith.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concat = void 0;
	var lift_1 = __webpack_require__(9);
	var concatAll_1 = __webpack_require__(288);
	var args_1 = __webpack_require__(66);
	var from_1 = __webpack_require__(109);
	function concat() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    return lift_1.operate(function (source, subscriber) {
	        concatAll_1.concatAll()(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
	    });
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatMapTo = void 0;
	var concatMap_1 = __webpack_require__(423);
	var isFunction_1 = __webpack_require__(27);
	function concatMapTo(innerObservable, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? concatMap_1.concatMap(function () { return innerObservable; }, resultSelector) : concatMap_1.concatMap(function () { return innerObservable; });
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.concatWith = void 0;
	var concat_1 = __webpack_require__(748);
	function concatWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return concat_1.concat.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.concatWith = concatWith;
	//# sourceMappingURL=concatWith.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.count = void 0;
	var reduce_1 = __webpack_require__(154);
	function count(predicate) {
	    return reduce_1.reduce(function (total, value, i) { return (!predicate || predicate(value, i) ? total + 1 : total); }, 0);
	}
	exports.count = count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.debounce = void 0;
	var lift_1 = __webpack_require__(9);
	var noop_1 = __webpack_require__(48);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	function debounce(durationSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var lastValue = null;
	        var durationSubscriber = null;
	        var emit = function () {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            durationSubscriber = null;
	            if (hasValue) {
	                hasValue = false;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
	            hasValue = true;
	            lastValue = value;
	            durationSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, emit, noop_1.noop);
	            innerFrom_1.innerFrom(durationSelector(value)).subscribe(durationSubscriber);
	        }, function () {
	            emit();
	            subscriber.complete();
	        }, undefined, function () {
	            lastValue = durationSubscriber = null;
	        }));
	    });
	}
	exports.debounce = debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.debounceTime = void 0;
	var async_1 = __webpack_require__(65);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return lift_1.operate(function (source, subscriber) {
	        var activeTask = null;
	        var lastValue = null;
	        var lastTime = null;
	        var emit = function () {
	            if (activeTask) {
	                activeTask.unsubscribe();
	                activeTask = null;
	                var value = lastValue;
	                lastValue = null;
	                subscriber.next(value);
	            }
	        };
	        function emitWhenIdle() {
	            var targetTime = lastTime + dueTime;
	            var now = scheduler.now();
	            if (now < targetTime) {
	                activeTask = this.schedule(undefined, targetTime - now);
	                subscriber.add(activeTask);
	                return;
	            }
	            emit();
	        }
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            lastValue = value;
	            lastTime = scheduler.now();
	            if (!activeTask) {
	                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
	                subscriber.add(activeTask);
	            }
	        }, function () {
	            emit();
	            subscriber.complete();
	        }, undefined, function () {
	            lastValue = activeTask = null;
	        }));
	    });
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.delay = void 0;
	var async_1 = __webpack_require__(65);
	var delayWhen_1 = __webpack_require__(424);
	var timer_1 = __webpack_require__(132);
	function delay(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    var duration = timer_1.timer(due, scheduler);
	    return delayWhen_1.delayWhen(function () { return duration; });
	}
	exports.delay = delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.dematerialize = void 0;
	var Notification_1 = __webpack_require__(416);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function dematerialize() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (notification) { return Notification_1.observeNotification(notification, subscriber); }));
	    });
	}
	exports.dematerialize = dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinct = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	function distinct(keySelector, flushes) {
	    return lift_1.operate(function (source, subscriber) {
	        var distinctKeys = new Set();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var key = keySelector ? keySelector(value) : value;
	            if (!distinctKeys.has(key)) {
	                distinctKeys.add(key);
	                subscriber.next(value);
	            }
	        }));
	        flushes === null || flushes === void 0 ? void 0 : flushes.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return distinctKeys.clear(); }, noop_1.noop));
	    });
	}
	exports.distinct = distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.distinctUntilKeyChanged = void 0;
	var distinctUntilChanged_1 = __webpack_require__(425);
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.elementAt = void 0;
	var ArgumentOutOfRangeError_1 = __webpack_require__(825);
	var filter_1 = __webpack_require__(110);
	var throwIfEmpty_1 = __webpack_require__(200);
	var defaultIfEmpty_1 = __webpack_require__(194);
	var take_1 = __webpack_require__(199);
	function elementAt(index, defaultValue) {
	    if (index < 0) {
	        throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
	    }
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(filter_1.filter(function (v, i) { return i === index; }), take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError(); }));
	    };
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.endWith = void 0;
	var concat_1 = __webpack_require__(286);
	var of_1 = __webpack_require__(419);
	function endWith() {
	    var values = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        values[_i] = arguments[_i];
	    }
	    return function (source) { return concat_1.concat(source, of_1.of.apply(void 0, __spreadArray([], __read(values)))); };
	}
	exports.endWith = endWith;
	//# sourceMappingURL=endWith.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.every = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function every(predicate, thisArg) {
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            if (!predicate.call(thisArg, value, index++, source)) {
	                subscriber.next(false);
	                subscriber.complete();
	            }
	        }, function () {
	            subscriber.next(true);
	            subscriber.complete();
	        }));
	    });
	}
	exports.every = every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.exhaust = void 0;
	var exhaustAll_1 = __webpack_require__(426);
	exports.exhaust = exhaustAll_1.exhaustAll;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.expand = void 0;
	var lift_1 = __webpack_require__(9);
	var mergeInternals_1 = __webpack_require__(431);
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
	    return lift_1.operate(function (source, subscriber) {
	        return mergeInternals_1.mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
	    });
	}
	exports.expand = expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.finalize = void 0;
	var lift_1 = __webpack_require__(9);
	function finalize(callback) {
	    return lift_1.operate(function (source, subscriber) {
	        try {
	            source.subscribe(subscriber);
	        }
	        finally {
	            subscriber.add(callback);
	        }
	    });
	}
	exports.finalize = finalize;
	//# sourceMappingURL=finalize.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findIndex = void 0;
	var lift_1 = __webpack_require__(9);
	var find_1 = __webpack_require__(428);
	function findIndex(predicate, thisArg) {
	    return lift_1.operate(find_1.createFind(predicate, thisArg, 'index'));
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.first = void 0;
	var EmptyError_1 = __webpack_require__(133);
	var filter_1 = __webpack_require__(110);
	var take_1 = __webpack_require__(199);
	var defaultIfEmpty_1 = __webpack_require__(194);
	var throwIfEmpty_1 = __webpack_require__(200);
	var identity_1 = __webpack_require__(47);
	function first(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
	    };
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.flatMap = void 0;
	var mergeMap_1 = __webpack_require__(98);
	exports.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=flatMap.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.groupBy = void 0;
	var Observable_1 = __webpack_require__(28);
	var innerFrom_1 = __webpack_require__(23);
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function groupBy(keySelector, elementOrOptions, duration, connector) {
	    return lift_1.operate(function (source, subscriber) {
	        var element;
	        if (!elementOrOptions || typeof elementOrOptions === 'function') {
	            element = elementOrOptions;
	        }
	        else {
	            (duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector);
	        }
	        var groups = new Map();
	        var notify = function (cb) {
	            groups.forEach(cb);
	            cb(subscriber);
	        };
	        var handleError = function (err) { return notify(function (consumer) { return consumer.error(err); }); };
	        var activeGroups = 0;
	        var teardownAttempted = false;
	        var groupBySourceSubscriber = new OperatorSubscriber_1.OperatorSubscriber(subscriber, function (value) {
	            try {
	                var key_1 = keySelector(value);
	                var group_1 = groups.get(key_1);
	                if (!group_1) {
	                    groups.set(key_1, (group_1 = connector ? connector() : new Subject_1.Subject()));
	                    var grouped = createGroupedObservable(key_1, group_1);
	                    subscriber.next(grouped);
	                    if (duration) {
	                        var durationSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(group_1, function () {
	                            group_1.complete();
	                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
	                        }, undefined, undefined, function () { return groups.delete(key_1); });
	                        groupBySourceSubscriber.add(innerFrom_1.innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
	                    }
	                }
	                group_1.next(element ? element(value) : value);
	            }
	            catch (err) {
	                handleError(err);
	            }
	        }, function () { return notify(function (consumer) { return consumer.complete(); }); }, handleError, function () { return groups.clear(); }, function () {
	            teardownAttempted = true;
	            return activeGroups === 0;
	        });
	        source.subscribe(groupBySourceSubscriber);
	        function createGroupedObservable(key, groupSubject) {
	            var result = new Observable_1.Observable(function (groupSubscriber) {
	                activeGroups++;
	                var innerSub = groupSubject.subscribe(groupSubscriber);
	                return function () {
	                    innerSub.unsubscribe();
	                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
	                };
	            });
	            result.key = key;
	            return result;
	        }
	    });
	}
	exports.groupBy = groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isEmpty = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function isEmpty() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            subscriber.next(false);
	            subscriber.complete();
	        }, function () {
	            subscriber.next(true);
	            subscriber.complete();
	        }));
	    });
	}
	exports.isEmpty = isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinAllInternals = void 0;
	var identity_1 = __webpack_require__(47);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var pipe_1 = __webpack_require__(294);
	var mergeMap_1 = __webpack_require__(98);
	var toArray_1 = __webpack_require__(438);
	function joinAllInternals(joinFn, project) {
	    return pipe_1.pipe(toArray_1.toArray(), mergeMap_1.mergeMap(function (sources) { return joinFn(sources); }), project ? mapOneOrManyArgs_1.mapOneOrManyArgs(project) : identity_1.identity);
	}
	exports.joinAllInternals = joinAllInternals;
	//# sourceMappingURL=joinAllInternals.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.last = void 0;
	var EmptyError_1 = __webpack_require__(133);
	var filter_1 = __webpack_require__(110);
	var takeLast_1 = __webpack_require__(436);
	var throwIfEmpty_1 = __webpack_require__(200);
	var defaultIfEmpty_1 = __webpack_require__(194);
	var identity_1 = __webpack_require__(47);
	function last(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, takeLast_1.takeLast(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); }));
	    };
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.materialize = void 0;
	var Notification_1 = __webpack_require__(416);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function materialize() {
	    return lift_1.operate(function (source, subscriber) {
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            subscriber.next(Notification_1.Notification.createNext(value));
	        }, function () {
	            subscriber.next(Notification_1.Notification.createComplete());
	            subscriber.complete();
	        }, function (err) {
	            subscriber.next(Notification_1.Notification.createError(err));
	            subscriber.complete();
	        }));
	    });
	}
	exports.materialize = materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.max = void 0;
	var reduce_1 = __webpack_require__(154);
	var isFunction_1 = __webpack_require__(27);
	function max(comparer) {
	    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) > 0 ? x : y); } : function (x, y) { return (x > y ? x : y); });
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.merge = void 0;
	var lift_1 = __webpack_require__(9);
	var argsOrArgArray_1 = __webpack_require__(134);
	var mergeAll_1 = __webpack_require__(195);
	var args_1 = __webpack_require__(66);
	var from_1 = __webpack_require__(109);
	function merge() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var concurrent = args_1.popNumber(args, Infinity);
	    args = argsOrArgArray_1.argsOrArgArray(args);
	    return lift_1.operate(function (source, subscriber) {
	        mergeAll_1.mergeAll(concurrent)(from_1.from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
	    });
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeMapTo = void 0;
	var mergeMap_1 = __webpack_require__(98);
	var isFunction_1 = __webpack_require__(27);
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    if (isFunction_1.isFunction(resultSelector)) {
	        return mergeMap_1.mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
	    }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return mergeMap_1.mergeMap(function () { return innerObservable; }, concurrent);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeScan = void 0;
	var lift_1 = __webpack_require__(9);
	var mergeInternals_1 = __webpack_require__(431);
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Infinity; }
	    return lift_1.operate(function (source, subscriber) {
	        var state = seed;
	        return mergeInternals_1.mergeInternals(source, subscriber, function (value, index) { return accumulator(state, value, index); }, concurrent, function (value) {
	            state = value;
	        }, false, undefined, function () { return (state = null); });
	    });
	}
	exports.mergeScan = mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeWith = void 0;
	var merge_1 = __webpack_require__(773);
	function mergeWith() {
	    var otherSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherSources[_i] = arguments[_i];
	    }
	    return merge_1.merge.apply(void 0, __spreadArray([], __read(otherSources)));
	}
	exports.mergeWith = mergeWith;
	//# sourceMappingURL=mergeWith.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.min = void 0;
	var reduce_1 = __webpack_require__(154);
	var isFunction_1 = __webpack_require__(27);
	function min(comparer) {
	    return reduce_1.reduce(isFunction_1.isFunction(comparer) ? function (x, y) { return (comparer(x, y) < 0 ? x : y); } : function (x, y) { return (x < y ? x : y); });
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.onErrorResumeNext = void 0;
	var lift_1 = __webpack_require__(9);
	var innerFrom_1 = __webpack_require__(23);
	var argsOrArgArray_1 = __webpack_require__(134);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	function onErrorResumeNext() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    var nextSources = argsOrArgArray_1.argsOrArgArray(sources);
	    return lift_1.operate(function (source, subscriber) {
	        var remaining = __spreadArray([source], __read(nextSources));
	        var subscribeNext = function () {
	            if (!subscriber.closed) {
	                if (remaining.length > 0) {
	                    var nextSource = void 0;
	                    try {
	                        nextSource = innerFrom_1.innerFrom(remaining.shift());
	                    }
	                    catch (err) {
	                        subscribeNext();
	                        return;
	                    }
	                    var innerSub = OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, noop_1.noop, noop_1.noop);
	                    nextSource.subscribe(innerSub);
	                    innerSub.add(subscribeNext);
	                }
	                else {
	                    subscriber.complete();
	                }
	            }
	        };
	        subscribeNext();
	    });
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pairwise = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function pairwise() {
	    return lift_1.operate(function (source, subscriber) {
	        var prev;
	        var hasPrev = false;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var p = prev;
	            prev = value;
	            hasPrev && subscriber.next([p, value]);
	            hasPrev = true;
	        }));
	    });
	}
	exports.pairwise = pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pluck = void 0;
	var map_1 = __webpack_require__(111);
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return map_1.map(function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    });
	}
	exports.pluck = pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publish = void 0;
	var Subject_1 = __webpack_require__(46);
	var multicast_1 = __webpack_require__(290);
	var connect_1 = __webpack_require__(289);
	function publish(selector) {
	    return selector ? function (source) { return connect_1.connect(selector)(source); } : function (source) { return multicast_1.multicast(new Subject_1.Subject())(source); };
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishBehavior = void 0;
	var BehaviorSubject_1 = __webpack_require__(731);
	var ConnectableObservable_1 = __webpack_require__(285);
	function publishBehavior(initialValue) {
	    return function (source) {
	        var subject = new BehaviorSubject_1.BehaviorSubject(initialValue);
	        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
	    };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishLast = void 0;
	var AsyncSubject_1 = __webpack_require__(415);
	var ConnectableObservable_1 = __webpack_require__(285);
	function publishLast() {
	    return function (source) {
	        var subject = new AsyncSubject_1.AsyncSubject();
	        return new ConnectableObservable_1.ConnectableObservable(source, function () { return subject; });
	    };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.publishReplay = void 0;
	var ReplaySubject_1 = __webpack_require__(417);
	var multicast_1 = __webpack_require__(290);
	var isFunction_1 = __webpack_require__(27);
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
	    if (selectorOrScheduler && !isFunction_1.isFunction(selectorOrScheduler)) {
	        timestampProvider = selectorOrScheduler;
	    }
	    var selector = isFunction_1.isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
	    return function (source) { return multicast_1.multicast(new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.repeat = void 0;
	var empty_1 = __webpack_require__(77);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	var timer_1 = __webpack_require__(132);
	function repeat(countOrConfig) {
	    var _a;
	    var count = Infinity;
	    var delay;
	    if (countOrConfig != null) {
	        if (typeof countOrConfig === 'object') {
	            (_a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay);
	        }
	        else {
	            count = countOrConfig;
	        }
	    }
	    return count <= 0
	        ? function () { return empty_1.EMPTY; }
	        : lift_1.operate(function (source, subscriber) {
	            var soFar = 0;
	            var sourceSub;
	            var resubscribe = function () {
	                sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
	                sourceSub = null;
	                if (delay != null) {
	                    var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(soFar));
	                    var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                        notifierSubscriber_1.unsubscribe();
	                        subscribeToSource();
	                    });
	                    notifier.subscribe(notifierSubscriber_1);
	                }
	                else {
	                    subscribeToSource();
	                }
	            };
	            var subscribeToSource = function () {
	                var syncUnsub = false;
	                sourceSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                    if (++soFar < count) {
	                        if (sourceSub) {
	                            resubscribe();
	                        }
	                        else {
	                            syncUnsub = true;
	                        }
	                    }
	                    else {
	                        subscriber.complete();
	                    }
	                }));
	                if (syncUnsub) {
	                    resubscribe();
	                }
	            };
	            subscribeToSource();
	        });
	}
	exports.repeat = repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.repeatWhen = void 0;
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function repeatWhen(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub;
	        var syncResub = false;
	        var completions$;
	        var isNotifierComplete = false;
	        var isMainComplete = false;
	        var checkComplete = function () { return isMainComplete && isNotifierComplete && (subscriber.complete(), true); };
	        var getCompletionSubject = function () {
	            if (!completions$) {
	                completions$ = new Subject_1.Subject();
	                notifier(completions$).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                    if (innerSub) {
	                        subscribeForRepeatWhen();
	                    }
	                    else {
	                        syncResub = true;
	                    }
	                }, function () {
	                    isNotifierComplete = true;
	                    checkComplete();
	                }));
	            }
	            return completions$;
	        };
	        var subscribeForRepeatWhen = function () {
	            isMainComplete = false;
	            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, function () {
	                isMainComplete = true;
	                !checkComplete() && getCompletionSubject().next();
	            }));
	            if (syncResub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                syncResub = false;
	                subscribeForRepeatWhen();
	            }
	        };
	        subscribeForRepeatWhen();
	    });
	}
	exports.repeatWhen = repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.retry = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var identity_1 = __webpack_require__(47);
	var timer_1 = __webpack_require__(132);
	var innerFrom_1 = __webpack_require__(23);
	function retry(configOrCount) {
	    if (configOrCount === void 0) { configOrCount = Infinity; }
	    var config;
	    if (configOrCount && typeof configOrCount === 'object') {
	        config = configOrCount;
	    }
	    else {
	        config = {
	            count: configOrCount,
	        };
	    }
	    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
	    return count <= 0
	        ? identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            var soFar = 0;
	            var innerSub;
	            var subscribeForRetry = function () {
	                var syncUnsub = false;
	                innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                    if (resetOnSuccess) {
	                        soFar = 0;
	                    }
	                    subscriber.next(value);
	                }, undefined, function (err) {
	                    if (soFar++ < count) {
	                        var resub_1 = function () {
	                            if (innerSub) {
	                                innerSub.unsubscribe();
	                                innerSub = null;
	                                subscribeForRetry();
	                            }
	                            else {
	                                syncUnsub = true;
	                            }
	                        };
	                        if (delay != null) {
	                            var notifier = typeof delay === 'number' ? timer_1.timer(delay) : innerFrom_1.innerFrom(delay(err, soFar));
	                            var notifierSubscriber_1 = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                                notifierSubscriber_1.unsubscribe();
	                                resub_1();
	                            }, function () {
	                                subscriber.complete();
	                            });
	                            notifier.subscribe(notifierSubscriber_1);
	                        }
	                        else {
	                            resub_1();
	                        }
	                    }
	                    else {
	                        subscriber.error(err);
	                    }
	                }));
	                if (syncUnsub) {
	                    innerSub.unsubscribe();
	                    innerSub = null;
	                    subscribeForRetry();
	                }
	            };
	            subscribeForRetry();
	        });
	}
	exports.retry = retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.retryWhen = void 0;
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function retryWhen(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var innerSub;
	        var syncResub = false;
	        var errors$;
	        var subscribeForRetryWhen = function () {
	            innerSub = source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
	                if (!errors$) {
	                    errors$ = new Subject_1.Subject();
	                    notifier(errors$).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	                        return innerSub ? subscribeForRetryWhen() : (syncResub = true);
	                    }));
	                }
	                if (errors$) {
	                    errors$.next(err);
	                }
	            }));
	            if (syncResub) {
	                innerSub.unsubscribe();
	                innerSub = null;
	                syncResub = false;
	                subscribeForRetryWhen();
	            }
	        };
	        subscribeForRetryWhen();
	    });
	}
	exports.retryWhen = retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sampleTime = void 0;
	var async_1 = __webpack_require__(65);
	var sample_1 = __webpack_require__(434);
	var interval_1 = __webpack_require__(734);
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return sample_1.sample(interval_1.interval(period, scheduler));
	}
	exports.sampleTime = sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scan = void 0;
	var lift_1 = __webpack_require__(9);
	var scanInternals_1 = __webpack_require__(791);
	function scan(accumulator, seed) {
	    return lift_1.operate(scanInternals_1.scanInternals(accumulator, seed, arguments.length >= 2, true));
	}
	exports.scan = scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scanInternals = void 0;
	var OperatorSubscriber_1 = __webpack_require__(10);
	function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
	    return function (source, subscriber) {
	        var hasState = hasSeed;
	        var state = seed;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var i = index++;
	            state = hasState
	                ?
	                    accumulator(state, value, i)
	                :
	                    ((hasState = true), value);
	            emitOnNext && subscriber.next(state);
	        }, emitBeforeComplete &&
	            (function () {
	                hasState && subscriber.next(state);
	                subscriber.complete();
	            })));
	    };
	}
	exports.scanInternals = scanInternals;
	//# sourceMappingURL=scanInternals.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sequenceEqual = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function sequenceEqual(compareTo, comparator) {
	    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
	    return lift_1.operate(function (source, subscriber) {
	        var aState = createState();
	        var bState = createState();
	        var emit = function (isEqual) {
	            subscriber.next(isEqual);
	            subscriber.complete();
	        };
	        var createSubscriber = function (selfState, otherState) {
	            var sequenceEqualSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (a) {
	                var buffer = otherState.buffer, complete = otherState.complete;
	                if (buffer.length === 0) {
	                    complete ? emit(false) : selfState.buffer.push(a);
	                }
	                else {
	                    !comparator(a, buffer.shift()) && emit(false);
	                }
	            }, function () {
	                selfState.complete = true;
	                var complete = otherState.complete, buffer = otherState.buffer;
	                complete && emit(buffer.length === 0);
	                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
	            });
	            return sequenceEqualSubscriber;
	        };
	        source.subscribe(createSubscriber(aState, bState));
	        compareTo.subscribe(createSubscriber(bState, aState));
	    });
	}
	exports.sequenceEqual = sequenceEqual;
	function createState() {
	    return {
	        buffer: [],
	        complete: false,
	    };
	}
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.shareReplay = void 0;
	var ReplaySubject_1 = __webpack_require__(417);
	var share_1 = __webpack_require__(435);
	function shareReplay(configOrBufferSize, windowTime, scheduler) {
	    var _a, _b, _c;
	    var bufferSize;
	    var refCount = false;
	    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
	        (_a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler);
	    }
	    else {
	        bufferSize = (configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity);
	    }
	    return share_1.share({
	        connector: function () { return new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler); },
	        resetOnError: true,
	        resetOnComplete: false,
	        resetOnRefCountZero: refCount,
	    });
	}
	exports.shareReplay = shareReplay;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.single = void 0;
	var EmptyError_1 = __webpack_require__(133);
	var SequenceError_1 = __webpack_require__(828);
	var NotFoundError_1 = __webpack_require__(826);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function single(predicate) {
	    return lift_1.operate(function (source, subscriber) {
	        var hasValue = false;
	        var singleValue;
	        var seenValue = false;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            seenValue = true;
	            if (!predicate || predicate(value, index++, source)) {
	                hasValue && subscriber.error(new SequenceError_1.SequenceError('Too many matching values'));
	                hasValue = true;
	                singleValue = value;
	            }
	        }, function () {
	            if (hasValue) {
	                subscriber.next(singleValue);
	                subscriber.complete();
	            }
	            else {
	                subscriber.error(seenValue ? new NotFoundError_1.NotFoundError('No matching values') : new EmptyError_1.EmptyError());
	            }
	        }));
	    });
	}
	exports.single = single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skip = void 0;
	var filter_1 = __webpack_require__(110);
	function skip(count) {
	    return filter_1.filter(function (_, index) { return count <= index; });
	}
	exports.skip = skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipLast = void 0;
	var identity_1 = __webpack_require__(47);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function skipLast(skipCount) {
	    return skipCount <= 0
	        ?
	            identity_1.identity
	        : lift_1.operate(function (source, subscriber) {
	            var ring = new Array(skipCount);
	            var seen = 0;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                var valueIndex = seen++;
	                if (valueIndex < skipCount) {
	                    ring[valueIndex] = value;
	                }
	                else {
	                    var index = valueIndex % skipCount;
	                    var oldValue = ring[index];
	                    ring[index] = value;
	                    subscriber.next(oldValue);
	                }
	            }));
	            return function () {
	                ring = null;
	            };
	        });
	}
	exports.skipLast = skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipUntil = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	var noop_1 = __webpack_require__(48);
	function skipUntil(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        var taking = false;
	        var skipSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
	            taking = true;
	        }, noop_1.noop);
	        innerFrom_1.innerFrom(notifier).subscribe(skipSubscriber);
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return taking && subscriber.next(value); }));
	    });
	}
	exports.skipUntil = skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.skipWhile = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function skipWhile(predicate) {
	    return lift_1.operate(function (source, subscriber) {
	        var taking = false;
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return (taking || (taking = !predicate(value, index++))) && subscriber.next(value); }));
	    });
	}
	exports.skipWhile = skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.startWith = void 0;
	var concat_1 = __webpack_require__(286);
	var args_1 = __webpack_require__(66);
	var lift_1 = __webpack_require__(9);
	function startWith() {
	    var values = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        values[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(values);
	    return lift_1.operate(function (source, subscriber) {
	        (scheduler ? concat_1.concat(values, source, scheduler) : concat_1.concat(values, source)).subscribe(subscriber);
	    });
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchAll = void 0;
	var switchMap_1 = __webpack_require__(198);
	var identity_1 = __webpack_require__(47);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchMapTo = void 0;
	var switchMap_1 = __webpack_require__(198);
	var isFunction_1 = __webpack_require__(27);
	function switchMapTo(innerObservable, resultSelector) {
	    return isFunction_1.isFunction(resultSelector) ? switchMap_1.switchMap(function () { return innerObservable; }, resultSelector) : switchMap_1.switchMap(function () { return innerObservable; });
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.switchScan = void 0;
	var switchMap_1 = __webpack_require__(198);
	var lift_1 = __webpack_require__(9);
	function switchScan(accumulator, seed) {
	    return lift_1.operate(function (source, subscriber) {
	        var state = seed;
	        switchMap_1.switchMap(function (value, index) { return accumulator(state, value, index); }, function (_, innerValue) { return ((state = innerValue), innerValue); })(source).subscribe(subscriber);
	        return function () {
	            state = null;
	        };
	    });
	}
	exports.switchScan = switchScan;
	//# sourceMappingURL=switchScan.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeUntil = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	var noop_1 = __webpack_require__(48);
	function takeUntil(notifier) {
	    return lift_1.operate(function (source, subscriber) {
	        innerFrom_1.innerFrom(notifier).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () { return subscriber.complete(); }, noop_1.noop));
	        !subscriber.closed && source.subscribe(subscriber);
	    });
	}
	exports.takeUntil = takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.takeWhile = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function takeWhile(predicate, inclusive) {
	    if (inclusive === void 0) { inclusive = false; }
	    return lift_1.operate(function (source, subscriber) {
	        var index = 0;
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var result = predicate(value, index++);
	            (result || inclusive) && subscriber.next(value);
	            !result && subscriber.complete();
	        }));
	    });
	}
	exports.takeWhile = takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tap = void 0;
	var isFunction_1 = __webpack_require__(27);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var identity_1 = __webpack_require__(47);
	function tap(observerOrNext, error, complete) {
	    var tapObserver = isFunction_1.isFunction(observerOrNext) || error || complete
	        ?
	            { next: observerOrNext, error: error, complete: complete }
	        : observerOrNext;
	    return tapObserver
	        ? lift_1.operate(function (source, subscriber) {
	            var _a;
	            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	            var isUnsub = true;
	            source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                var _a;
	                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
	                subscriber.next(value);
	            }, function () {
	                var _a;
	                isUnsub = false;
	                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	                subscriber.complete();
	            }, function (err) {
	                var _a;
	                isUnsub = false;
	                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
	                subscriber.error(err);
	            }, function () {
	                var _a, _b;
	                if (isUnsub) {
	                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
	                }
	                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
	            }));
	        })
	        :
	            identity_1.identity;
	}
	exports.tap = tap;
	//# sourceMappingURL=tap.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throttleTime = void 0;
	var async_1 = __webpack_require__(65);
	var throttle_1 = __webpack_require__(437);
	var timer_1 = __webpack_require__(132);
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    var duration$ = timer_1.timer(duration, scheduler);
	    return throttle_1.throttle(function () { return duration$; }, config);
	}
	exports.throttleTime = throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TimeInterval = exports.timeInterval = void 0;
	var async_1 = __webpack_require__(65);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.asyncScheduler; }
	    return lift_1.operate(function (source, subscriber) {
	        var last = scheduler.now();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var now = scheduler.now();
	            var interval = now - last;
	            last = now;
	            subscriber.next(new TimeInterval(value, interval));
	        }));
	    });
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeoutWith = void 0;
	var async_1 = __webpack_require__(65);
	var isDate_1 = __webpack_require__(442);
	var timeout_1 = __webpack_require__(291);
	function timeoutWith(due, withObservable, scheduler) {
	    var first;
	    var each;
	    var _with;
	    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async_1.async;
	    if (isDate_1.isValidDate(due)) {
	        first = due;
	    }
	    else if (typeof due === 'number') {
	        each = due;
	    }
	    if (withObservable) {
	        _with = function () { return withObservable; };
	    }
	    else {
	        throw new TypeError('No observable provided to switch to');
	    }
	    if (first == null && each == null) {
	        throw new TypeError('No timeout provided.');
	    }
	    return timeout_1.timeout({
	        first: first,
	        each: each,
	        scheduler: scheduler,
	        with: _with,
	    });
	}
	exports.timeoutWith = timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timestamp = void 0;
	var dateTimestampProvider_1 = __webpack_require__(439);
	var map_1 = __webpack_require__(111);
	function timestamp(timestampProvider) {
	    if (timestampProvider === void 0) { timestampProvider = dateTimestampProvider_1.dateTimestampProvider; }
	    return map_1.map(function (value) { return ({ value: value, timestamp: timestampProvider.now() }); });
	}
	exports.timestamp = timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.window = void 0;
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	function window(windowBoundaries) {
	    return lift_1.operate(function (source, subscriber) {
	        var windowSubject = new Subject_1.Subject();
	        subscriber.next(windowSubject.asObservable());
	        var errorHandler = function (err) {
	            windowSubject.error(err);
	            subscriber.error(err);
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value); }, function () {
	            windowSubject.complete();
	            subscriber.complete();
	        }, errorHandler));
	        windowBoundaries.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function () {
	            windowSubject.complete();
	            subscriber.next((windowSubject = new Subject_1.Subject()));
	        }, noop_1.noop, errorHandler));
	        return function () {
	            windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
	            windowSubject = null;
	        };
	    });
	}
	exports.window = window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowCount = void 0;
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
	    return lift_1.operate(function (source, subscriber) {
	        var windows = [new Subject_1.Subject()];
	        var starts = [];
	        var count = 0;
	        subscriber.next(windows[0].asObservable());
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            try {
	                for (var windows_1 = __values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
	                    var window_1 = windows_1_1.value;
	                    window_1.next(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            var c = count - windowSize + 1;
	            if (c >= 0 && c % startEvery === 0) {
	                windows.shift().complete();
	            }
	            if (++count % startEvery === 0) {
	                var window_2 = new Subject_1.Subject();
	                windows.push(window_2);
	                subscriber.next(window_2.asObservable());
	            }
	        }, function () {
	            while (windows.length > 0) {
	                windows.shift().complete();
	            }
	            subscriber.complete();
	        }, function (err) {
	            while (windows.length > 0) {
	                windows.shift().error(err);
	            }
	            subscriber.error(err);
	        }, function () {
	            starts = null;
	            windows = null;
	        }));
	    });
	}
	exports.windowCount = windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowTime = void 0;
	var Subject_1 = __webpack_require__(46);
	var async_1 = __webpack_require__(65);
	var Subscription_1 = __webpack_require__(64);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var arrRemove_1 = __webpack_require__(112);
	var args_1 = __webpack_require__(66);
	var executeSchedule_1 = __webpack_require__(113);
	function windowTime(windowTimeSpan) {
	    var _a, _b;
	    var otherArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherArgs[_i - 1] = arguments[_i];
	    }
	    var scheduler = (_a = args_1.popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : async_1.asyncScheduler;
	    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
	    var maxWindowSize = otherArgs[1] || Infinity;
	    return lift_1.operate(function (source, subscriber) {
	        var windowRecords = [];
	        var restartOnClose = false;
	        var closeWindow = function (record) {
	            var window = record.window, subs = record.subs;
	            window.complete();
	            subs.unsubscribe();
	            arrRemove_1.arrRemove(windowRecords, record);
	            restartOnClose && startWindow();
	        };
	        var startWindow = function () {
	            if (windowRecords) {
	                var subs = new Subscription_1.Subscription();
	                subscriber.add(subs);
	                var window_1 = new Subject_1.Subject();
	                var record_1 = {
	                    window: window_1,
	                    subs: subs,
	                    seen: 0,
	                };
	                windowRecords.push(record_1);
	                subscriber.next(window_1.asObservable());
	                executeSchedule_1.executeSchedule(subs, scheduler, function () { return closeWindow(record_1); }, windowTimeSpan);
	            }
	        };
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            executeSchedule_1.executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
	        }
	        else {
	            restartOnClose = true;
	        }
	        startWindow();
	        var loop = function (cb) { return windowRecords.slice().forEach(cb); };
	        var terminate = function (cb) {
	            loop(function (_a) {
	                var window = _a.window;
	                return cb(window);
	            });
	            cb(subscriber);
	            subscriber.unsubscribe();
	        };
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            loop(function (record) {
	                record.window.next(value);
	                maxWindowSize <= ++record.seen && closeWindow(record);
	            });
	        }, function () { return terminate(function (consumer) { return consumer.complete(); }); }, function (err) { return terminate(function (consumer) { return consumer.error(err); }); }));
	        return function () {
	            windowRecords = null;
	        };
	    });
	}
	exports.windowTime = windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowToggle = void 0;
	var Subject_1 = __webpack_require__(46);
	var Subscription_1 = __webpack_require__(64);
	var lift_1 = __webpack_require__(9);
	var innerFrom_1 = __webpack_require__(23);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var noop_1 = __webpack_require__(48);
	var arrRemove_1 = __webpack_require__(112);
	function windowToggle(openings, closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var windows = [];
	        var handleError = function (err) {
	            while (0 < windows.length) {
	                windows.shift().error(err);
	            }
	            subscriber.error(err);
	        };
	        innerFrom_1.innerFrom(openings).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (openValue) {
	            var window = new Subject_1.Subject();
	            windows.push(window);
	            var closingSubscription = new Subscription_1.Subscription();
	            var closeWindow = function () {
	                arrRemove_1.arrRemove(windows, window);
	                window.complete();
	                closingSubscription.unsubscribe();
	            };
	            var closingNotifier;
	            try {
	                closingNotifier = innerFrom_1.innerFrom(closingSelector(openValue));
	            }
	            catch (err) {
	                handleError(err);
	                return;
	            }
	            subscriber.next(window.asObservable());
	            closingSubscription.add(closingNotifier.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, closeWindow, noop_1.noop, handleError)));
	        }, noop_1.noop));
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            var e_1, _a;
	            var windowsCopy = windows.slice();
	            try {
	                for (var windowsCopy_1 = __values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
	                    var window_1 = windowsCopy_1_1.value;
	                    window_1.next(value);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }, function () {
	            while (0 < windows.length) {
	                windows.shift().complete();
	            }
	            subscriber.complete();
	        }, handleError, function () {
	            while (0 < windows.length) {
	                windows.shift().unsubscribe();
	            }
	        }));
	    });
	}
	exports.windowToggle = windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.windowWhen = void 0;
	var Subject_1 = __webpack_require__(46);
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	function windowWhen(closingSelector) {
	    return lift_1.operate(function (source, subscriber) {
	        var window;
	        var closingSubscriber;
	        var handleError = function (err) {
	            window.error(err);
	            subscriber.error(err);
	        };
	        var openWindow = function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            window === null || window === void 0 ? void 0 : window.complete();
	            window = new Subject_1.Subject();
	            subscriber.next(window.asObservable());
	            var closingNotifier;
	            try {
	                closingNotifier = innerFrom_1.innerFrom(closingSelector());
	            }
	            catch (err) {
	                handleError(err);
	                return;
	            }
	            closingNotifier.subscribe((closingSubscriber = OperatorSubscriber_1.createOperatorSubscriber(subscriber, openWindow, openWindow, handleError)));
	        };
	        openWindow();
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) { return window.next(value); }, function () {
	            window.complete();
	            subscriber.complete();
	        }, handleError, function () {
	            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
	            window = null;
	        }));
	    });
	}
	exports.windowWhen = windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.withLatestFrom = void 0;
	var lift_1 = __webpack_require__(9);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var innerFrom_1 = __webpack_require__(23);
	var identity_1 = __webpack_require__(47);
	var noop_1 = __webpack_require__(48);
	var args_1 = __webpack_require__(66);
	function withLatestFrom() {
	    var inputs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        inputs[_i] = arguments[_i];
	    }
	    var project = args_1.popResultSelector(inputs);
	    return lift_1.operate(function (source, subscriber) {
	        var len = inputs.length;
	        var otherValues = new Array(len);
	        var hasValue = inputs.map(function () { return false; });
	        var ready = false;
	        var _loop_1 = function (i) {
	            innerFrom_1.innerFrom(inputs[i]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                otherValues[i] = value;
	                if (!ready && !hasValue[i]) {
	                    hasValue[i] = true;
	                    (ready = hasValue.every(identity_1.identity)) && (hasValue = null);
	                }
	            }, noop_1.noop));
	        };
	        for (var i = 0; i < len; i++) {
	            _loop_1(i);
	        }
	        source.subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	            if (ready) {
	                var values = __spreadArray([value], __read(otherValues));
	                subscriber.next(project ? project.apply(void 0, __spreadArray([], __read(values))) : values);
	            }
	        }));
	    });
	}
	exports.withLatestFrom = withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zip = void 0;
	var zip_1 = __webpack_require__(420);
	var lift_1 = __webpack_require__(9);
	function zip() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    return lift_1.operate(function (source, subscriber) {
	        zip_1.zip.apply(void 0, __spreadArray([source], __read(sources))).subscribe(subscriber);
	    });
	}
	exports.zip = zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zipAll = void 0;
	var zip_1 = __webpack_require__(420);
	var joinAllInternals_1 = __webpack_require__(769);
	function zipAll(project) {
	    return joinAllInternals_1.joinAllInternals(zip_1.zip, project);
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.zipWith = void 0;
	var zip_1 = __webpack_require__(816);
	function zipWith() {
	    var otherInputs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        otherInputs[_i] = arguments[_i];
	    }
	    return zip_1.zip.apply(void 0, __spreadArray([], __read(otherInputs)));
	}
	exports.zipWith = zipWith;
	//# sourceMappingURL=zipWith.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleAsyncIterable = void 0;
	var Observable_1 = __webpack_require__(28);
	var executeSchedule_1 = __webpack_require__(113);
	function scheduleAsyncIterable(input, scheduler) {
	    if (!input) {
	        throw new Error('Iterable cannot be null');
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	            var iterator = input[Symbol.asyncIterator]();
	            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                iterator.next().then(function (result) {
	                    if (result.done) {
	                        subscriber.complete();
	                    }
	                    else {
	                        subscriber.next(result.value);
	                    }
	                });
	            }, 0, true);
	        });
	    });
	}
	exports.scheduleAsyncIterable = scheduleAsyncIterable;
	//# sourceMappingURL=scheduleAsyncIterable.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleIterable = void 0;
	var Observable_1 = __webpack_require__(28);
	var iterator_1 = __webpack_require__(824);
	var isFunction_1 = __webpack_require__(27);
	var executeSchedule_1 = __webpack_require__(113);
	function scheduleIterable(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var iterator;
	        executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	            iterator = input[iterator_1.iterator]();
	            executeSchedule_1.executeSchedule(subscriber, scheduler, function () {
	                var _a;
	                var value;
	                var done;
	                try {
	                    (_a = iterator.next(), value = _a.value, done = _a.done);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (done) {
	                    subscriber.complete();
	                }
	                else {
	                    subscriber.next(value);
	                }
	            }, 0, true);
	        });
	        return function () { return isFunction_1.isFunction(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return(); };
	    });
	}
	exports.scheduleIterable = scheduleIterable;
	//# sourceMappingURL=scheduleIterable.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduled = void 0;
	var scheduleObservable_1 = __webpack_require__(2229);
	var schedulePromise_1 = __webpack_require__(2230);
	var scheduleArray_1 = __webpack_require__(2228);
	var scheduleIterable_1 = __webpack_require__(820);
	var scheduleAsyncIterable_1 = __webpack_require__(819);
	var isInteropObservable_1 = __webpack_require__(833);
	var isPromise_1 = __webpack_require__(835);
	var isArrayLike_1 = __webpack_require__(441);
	var isIterable_1 = __webpack_require__(834);
	var isAsyncIterable_1 = __webpack_require__(832);
	var throwUnobservableError_1 = __webpack_require__(838);
	var isReadableStreamLike_1 = __webpack_require__(443);
	var scheduleReadableStreamLike_1 = __webpack_require__(2231);
	function scheduled(input, scheduler) {
	    if (input != null) {
	        if (isInteropObservable_1.isInteropObservable(input)) {
	            return scheduleObservable_1.scheduleObservable(input, scheduler);
	        }
	        if (isArrayLike_1.isArrayLike(input)) {
	            return scheduleArray_1.scheduleArray(input, scheduler);
	        }
	        if (isPromise_1.isPromise(input)) {
	            return schedulePromise_1.schedulePromise(input, scheduler);
	        }
	        if (isAsyncIterable_1.isAsyncIterable(input)) {
	            return scheduleAsyncIterable_1.scheduleAsyncIterable(input, scheduler);
	        }
	        if (isIterable_1.isIterable(input)) {
	            return scheduleIterable_1.scheduleIterable(input, scheduler);
	        }
	        if (isReadableStreamLike_1.isReadableStreamLike(input)) {
	            return scheduleReadableStreamLike_1.scheduleReadableStreamLike(input, scheduler);
	        }
	    }
	    throw throwUnobservableError_1.createInvalidObservableTypeError(input);
	}
	exports.scheduled = scheduled;
	//# sourceMappingURL=scheduled.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrameProvider = void 0;
	var Subscription_1 = __webpack_require__(64);
	exports.animationFrameProvider = {
	    schedule: function (callback) {
	        var request = requestAnimationFrame;
	        var cancel = cancelAnimationFrame;
	        var delegate = exports.animationFrameProvider.delegate;
	        if (delegate) {
	            request = delegate.requestAnimationFrame;
	            cancel = delegate.cancelAnimationFrame;
	        }
	        var handle = request(function (timestamp) {
	            cancel = undefined;
	            callback(timestamp);
	        });
	        return new Subscription_1.Subscription(function () { return cancel === null || cancel === void 0 ? void 0 : cancel(handle); });
	    },
	    requestAnimationFrame: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.animationFrameProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
	    },
	    cancelAnimationFrame: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.animationFrameProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=animationFrameProvider.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeoutProvider = void 0;
	exports.timeoutProvider = {
	    setTimeout: function (handler, timeout) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        var delegate = exports.timeoutProvider.delegate;
	        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
	            return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
	        }
	        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
	    },
	    clearTimeout: function (handle) {
	        var delegate = exports.timeoutProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=timeoutProvider.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.iterator = exports.getSymbolIterator = void 0;
	function getSymbolIterator() {
	    if (typeof Symbol !== 'function' || !Symbol.iterator) {
	        return '@@iterator';
	    }
	    return Symbol.iterator;
	}
	exports.getSymbolIterator = getSymbolIterator;
	exports.iterator = getSymbolIterator();
	//# sourceMappingURL=iterator.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ArgumentOutOfRangeError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.ArgumentOutOfRangeError = createErrorClass_1.createErrorClass(function (_super) {
	    return function ArgumentOutOfRangeErrorImpl() {
	        _super(this);
	        this.name = 'ArgumentOutOfRangeError';
	        this.message = 'argument out of range';
	    };
	});
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NotFoundError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.NotFoundError = createErrorClass_1.createErrorClass(function (_super) {
	    return function NotFoundErrorImpl(message) {
	        _super(this);
	        this.name = 'NotFoundError';
	        this.message = message;
	    };
	});
	//# sourceMappingURL=NotFoundError.js.map

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ObjectUnsubscribedError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.ObjectUnsubscribedError = createErrorClass_1.createErrorClass(function (_super) {
	    return function ObjectUnsubscribedErrorImpl() {
	        _super(this);
	        this.name = 'ObjectUnsubscribedError';
	        this.message = 'object unsubscribed';
	    };
	});
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SequenceError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.SequenceError = createErrorClass_1.createErrorClass(function (_super) {
	    return function SequenceErrorImpl(message) {
	        _super(this);
	        this.name = 'SequenceError';
	        this.message = message;
	    };
	});
	//# sourceMappingURL=SequenceError.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UnsubscriptionError = void 0;
	var createErrorClass_1 = __webpack_require__(135);
	exports.UnsubscriptionError = createErrorClass_1.createErrorClass(function (_super) {
	    return function UnsubscriptionErrorImpl(errors) {
	        _super(this);
	        this.message = errors
	            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
	            : '';
	        this.name = 'UnsubscriptionError';
	        this.errors = errors;
	    };
	});
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.argsArgArrayOrObject = void 0;
	var isArray = Array.isArray;
	var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
	function argsArgArrayOrObject(args) {
	    if (args.length === 1) {
	        var first_1 = args[0];
	        if (isArray(first_1)) {
	            return { args: first_1, keys: null };
	        }
	        if (isPOJO(first_1)) {
	            var keys = getKeys(first_1);
	            return {
	                args: keys.map(function (key) { return first_1[key]; }),
	                keys: keys,
	            };
	        }
	    }
	    return { args: args, keys: null };
	}
	exports.argsArgArrayOrObject = argsArgArrayOrObject;
	function isPOJO(obj) {
	    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
	}
	//# sourceMappingURL=argsArgArrayOrObject.js.map

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createObject = void 0;
	function createObject(keys, values) {
	    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
	}
	exports.createObject = createObject;
	//# sourceMappingURL=createObject.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isAsyncIterable = void 0;
	var isFunction_1 = __webpack_require__(27);
	function isAsyncIterable(obj) {
	    return Symbol.asyncIterator && isFunction_1.isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
	}
	exports.isAsyncIterable = isAsyncIterable;
	//# sourceMappingURL=isAsyncIterable.js.map

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isInteropObservable = void 0;
	var observable_1 = __webpack_require__(292);
	var isFunction_1 = __webpack_require__(27);
	function isInteropObservable(input) {
	    return isFunction_1.isFunction(input[observable_1.observable]);
	}
	exports.isInteropObservable = isInteropObservable;
	//# sourceMappingURL=isInteropObservable.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isIterable = void 0;
	var iterator_1 = __webpack_require__(824);
	var isFunction_1 = __webpack_require__(27);
	function isIterable(input) {
	    return isFunction_1.isFunction(input === null || input === void 0 ? void 0 : input[iterator_1.iterator]);
	}
	exports.isIterable = isIterable;
	//# sourceMappingURL=isIterable.js.map

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = void 0;
	var isFunction_1 = __webpack_require__(27);
	function isPromise(value) {
	    return isFunction_1.isFunction(value === null || value === void 0 ? void 0 : value.then);
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.not = void 0;
	function not(pred, thisArg) {
	    return function (value, index) { return !pred.call(thisArg, value, index); };
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.reportUnhandledError = void 0;
	var config_1 = __webpack_require__(193);
	var timeoutProvider_1 = __webpack_require__(823);
	function reportUnhandledError(err) {
	    timeoutProvider_1.timeoutProvider.setTimeout(function () {
	        var onUnhandledError = config_1.config.onUnhandledError;
	        if (onUnhandledError) {
	            onUnhandledError(err);
	        }
	        else {
	            throw err;
	        }
	    });
	}
	exports.reportUnhandledError = reportUnhandledError;
	//# sourceMappingURL=reportUnhandledError.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createInvalidObservableTypeError = void 0;
	function createInvalidObservableTypeError(input) {
	    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
	}
	exports.createInvalidObservableTypeError = createInvalidObservableTypeError;
	//# sourceMappingURL=throwUnobservableError.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.mergeAll = exports.merge = exports.max = exports.materialize = exports.mapTo = exports.map = exports.last = exports.isEmpty = exports.ignoreElements = exports.groupBy = exports.first = exports.findIndex = exports.find = exports.finalize = exports.filter = exports.expand = exports.exhaustMap = exports.exhaustAll = exports.exhaust = exports.every = exports.endWith = exports.elementAt = exports.distinctUntilKeyChanged = exports.distinctUntilChanged = exports.distinct = exports.dematerialize = exports.delayWhen = exports.delay = exports.defaultIfEmpty = exports.debounceTime = exports.debounce = exports.count = exports.connect = exports.concatWith = exports.concatMapTo = exports.concatMap = exports.concatAll = exports.concat = exports.combineLatestWith = exports.combineLatest = exports.combineLatestAll = exports.combineAll = exports.catchError = exports.bufferWhen = exports.bufferToggle = exports.bufferTime = exports.bufferCount = exports.buffer = exports.auditTime = exports.audit = void 0;
	exports.timeInterval = exports.throwIfEmpty = exports.throttleTime = exports.throttle = exports.tap = exports.takeWhile = exports.takeUntil = exports.takeLast = exports.take = exports.switchScan = exports.switchMapTo = exports.switchMap = exports.switchAll = exports.subscribeOn = exports.startWith = exports.skipWhile = exports.skipUntil = exports.skipLast = exports.skip = exports.single = exports.shareReplay = exports.share = exports.sequenceEqual = exports.scan = exports.sampleTime = exports.sample = exports.refCount = exports.retryWhen = exports.retry = exports.repeatWhen = exports.repeat = exports.reduce = exports.raceWith = exports.race = exports.publishReplay = exports.publishLast = exports.publishBehavior = exports.publish = exports.pluck = exports.partition = exports.pairwise = exports.onErrorResumeNext = exports.observeOn = exports.multicast = exports.min = exports.mergeWith = exports.mergeScan = exports.mergeMapTo = exports.mergeMap = exports.flatMap = void 0;
	exports.zipWith = exports.zipAll = exports.zip = exports.withLatestFrom = exports.windowWhen = exports.windowToggle = exports.windowTime = exports.windowCount = exports.window = exports.toArray = exports.timestamp = exports.timeoutWith = exports.timeout = void 0;
	var audit_1 = __webpack_require__(421);
	Object.defineProperty(exports, "audit", { enumerable: true, get: function () { return audit_1.audit; } });
	var auditTime_1 = __webpack_require__(738);
	Object.defineProperty(exports, "auditTime", { enumerable: true, get: function () { return auditTime_1.auditTime; } });
	var buffer_1 = __webpack_require__(739);
	Object.defineProperty(exports, "buffer", { enumerable: true, get: function () { return buffer_1.buffer; } });
	var bufferCount_1 = __webpack_require__(740);
	Object.defineProperty(exports, "bufferCount", { enumerable: true, get: function () { return bufferCount_1.bufferCount; } });
	var bufferTime_1 = __webpack_require__(741);
	Object.defineProperty(exports, "bufferTime", { enumerable: true, get: function () { return bufferTime_1.bufferTime; } });
	var bufferToggle_1 = __webpack_require__(742);
	Object.defineProperty(exports, "bufferToggle", { enumerable: true, get: function () { return bufferToggle_1.bufferToggle; } });
	var bufferWhen_1 = __webpack_require__(743);
	Object.defineProperty(exports, "bufferWhen", { enumerable: true, get: function () { return bufferWhen_1.bufferWhen; } });
	var catchError_1 = __webpack_require__(744);
	Object.defineProperty(exports, "catchError", { enumerable: true, get: function () { return catchError_1.catchError; } });
	var combineAll_1 = __webpack_require__(745);
	Object.defineProperty(exports, "combineAll", { enumerable: true, get: function () { return combineAll_1.combineAll; } });
	var combineLatestAll_1 = __webpack_require__(422);
	Object.defineProperty(exports, "combineLatestAll", { enumerable: true, get: function () { return combineLatestAll_1.combineLatestAll; } });
	var combineLatest_1 = __webpack_require__(746);
	Object.defineProperty(exports, "combineLatest", { enumerable: true, get: function () { return combineLatest_1.combineLatest; } });
	var combineLatestWith_1 = __webpack_require__(747);
	Object.defineProperty(exports, "combineLatestWith", { enumerable: true, get: function () { return combineLatestWith_1.combineLatestWith; } });
	var concat_1 = __webpack_require__(748);
	Object.defineProperty(exports, "concat", { enumerable: true, get: function () { return concat_1.concat; } });
	var concatAll_1 = __webpack_require__(288);
	Object.defineProperty(exports, "concatAll", { enumerable: true, get: function () { return concatAll_1.concatAll; } });
	var concatMap_1 = __webpack_require__(423);
	Object.defineProperty(exports, "concatMap", { enumerable: true, get: function () { return concatMap_1.concatMap; } });
	var concatMapTo_1 = __webpack_require__(749);
	Object.defineProperty(exports, "concatMapTo", { enumerable: true, get: function () { return concatMapTo_1.concatMapTo; } });
	var concatWith_1 = __webpack_require__(750);
	Object.defineProperty(exports, "concatWith", { enumerable: true, get: function () { return concatWith_1.concatWith; } });
	var connect_1 = __webpack_require__(289);
	Object.defineProperty(exports, "connect", { enumerable: true, get: function () { return connect_1.connect; } });
	var count_1 = __webpack_require__(751);
	Object.defineProperty(exports, "count", { enumerable: true, get: function () { return count_1.count; } });
	var debounce_1 = __webpack_require__(752);
	Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return debounce_1.debounce; } });
	var debounceTime_1 = __webpack_require__(753);
	Object.defineProperty(exports, "debounceTime", { enumerable: true, get: function () { return debounceTime_1.debounceTime; } });
	var defaultIfEmpty_1 = __webpack_require__(194);
	Object.defineProperty(exports, "defaultIfEmpty", { enumerable: true, get: function () { return defaultIfEmpty_1.defaultIfEmpty; } });
	var delay_1 = __webpack_require__(754);
	Object.defineProperty(exports, "delay", { enumerable: true, get: function () { return delay_1.delay; } });
	var delayWhen_1 = __webpack_require__(424);
	Object.defineProperty(exports, "delayWhen", { enumerable: true, get: function () { return delayWhen_1.delayWhen; } });
	var dematerialize_1 = __webpack_require__(755);
	Object.defineProperty(exports, "dematerialize", { enumerable: true, get: function () { return dematerialize_1.dematerialize; } });
	var distinct_1 = __webpack_require__(756);
	Object.defineProperty(exports, "distinct", { enumerable: true, get: function () { return distinct_1.distinct; } });
	var distinctUntilChanged_1 = __webpack_require__(425);
	Object.defineProperty(exports, "distinctUntilChanged", { enumerable: true, get: function () { return distinctUntilChanged_1.distinctUntilChanged; } });
	var distinctUntilKeyChanged_1 = __webpack_require__(757);
	Object.defineProperty(exports, "distinctUntilKeyChanged", { enumerable: true, get: function () { return distinctUntilKeyChanged_1.distinctUntilKeyChanged; } });
	var elementAt_1 = __webpack_require__(758);
	Object.defineProperty(exports, "elementAt", { enumerable: true, get: function () { return elementAt_1.elementAt; } });
	var endWith_1 = __webpack_require__(759);
	Object.defineProperty(exports, "endWith", { enumerable: true, get: function () { return endWith_1.endWith; } });
	var every_1 = __webpack_require__(760);
	Object.defineProperty(exports, "every", { enumerable: true, get: function () { return every_1.every; } });
	var exhaust_1 = __webpack_require__(761);
	Object.defineProperty(exports, "exhaust", { enumerable: true, get: function () { return exhaust_1.exhaust; } });
	var exhaustAll_1 = __webpack_require__(426);
	Object.defineProperty(exports, "exhaustAll", { enumerable: true, get: function () { return exhaustAll_1.exhaustAll; } });
	var exhaustMap_1 = __webpack_require__(427);
	Object.defineProperty(exports, "exhaustMap", { enumerable: true, get: function () { return exhaustMap_1.exhaustMap; } });
	var expand_1 = __webpack_require__(762);
	Object.defineProperty(exports, "expand", { enumerable: true, get: function () { return expand_1.expand; } });
	var filter_1 = __webpack_require__(110);
	Object.defineProperty(exports, "filter", { enumerable: true, get: function () { return filter_1.filter; } });
	var finalize_1 = __webpack_require__(763);
	Object.defineProperty(exports, "finalize", { enumerable: true, get: function () { return finalize_1.finalize; } });
	var find_1 = __webpack_require__(428);
	Object.defineProperty(exports, "find", { enumerable: true, get: function () { return find_1.find; } });
	var findIndex_1 = __webpack_require__(764);
	Object.defineProperty(exports, "findIndex", { enumerable: true, get: function () { return findIndex_1.findIndex; } });
	var first_1 = __webpack_require__(765);
	Object.defineProperty(exports, "first", { enumerable: true, get: function () { return first_1.first; } });
	var groupBy_1 = __webpack_require__(767);
	Object.defineProperty(exports, "groupBy", { enumerable: true, get: function () { return groupBy_1.groupBy; } });
	var ignoreElements_1 = __webpack_require__(429);
	Object.defineProperty(exports, "ignoreElements", { enumerable: true, get: function () { return ignoreElements_1.ignoreElements; } });
	var isEmpty_1 = __webpack_require__(768);
	Object.defineProperty(exports, "isEmpty", { enumerable: true, get: function () { return isEmpty_1.isEmpty; } });
	var last_1 = __webpack_require__(770);
	Object.defineProperty(exports, "last", { enumerable: true, get: function () { return last_1.last; } });
	var map_1 = __webpack_require__(111);
	Object.defineProperty(exports, "map", { enumerable: true, get: function () { return map_1.map; } });
	var mapTo_1 = __webpack_require__(430);
	Object.defineProperty(exports, "mapTo", { enumerable: true, get: function () { return mapTo_1.mapTo; } });
	var materialize_1 = __webpack_require__(771);
	Object.defineProperty(exports, "materialize", { enumerable: true, get: function () { return materialize_1.materialize; } });
	var max_1 = __webpack_require__(772);
	Object.defineProperty(exports, "max", { enumerable: true, get: function () { return max_1.max; } });
	var merge_1 = __webpack_require__(773);
	Object.defineProperty(exports, "merge", { enumerable: true, get: function () { return merge_1.merge; } });
	var mergeAll_1 = __webpack_require__(195);
	Object.defineProperty(exports, "mergeAll", { enumerable: true, get: function () { return mergeAll_1.mergeAll; } });
	var flatMap_1 = __webpack_require__(766);
	Object.defineProperty(exports, "flatMap", { enumerable: true, get: function () { return flatMap_1.flatMap; } });
	var mergeMap_1 = __webpack_require__(98);
	Object.defineProperty(exports, "mergeMap", { enumerable: true, get: function () { return mergeMap_1.mergeMap; } });
	var mergeMapTo_1 = __webpack_require__(774);
	Object.defineProperty(exports, "mergeMapTo", { enumerable: true, get: function () { return mergeMapTo_1.mergeMapTo; } });
	var mergeScan_1 = __webpack_require__(775);
	Object.defineProperty(exports, "mergeScan", { enumerable: true, get: function () { return mergeScan_1.mergeScan; } });
	var mergeWith_1 = __webpack_require__(776);
	Object.defineProperty(exports, "mergeWith", { enumerable: true, get: function () { return mergeWith_1.mergeWith; } });
	var min_1 = __webpack_require__(777);
	Object.defineProperty(exports, "min", { enumerable: true, get: function () { return min_1.min; } });
	var multicast_1 = __webpack_require__(290);
	Object.defineProperty(exports, "multicast", { enumerable: true, get: function () { return multicast_1.multicast; } });
	var observeOn_1 = __webpack_require__(196);
	Object.defineProperty(exports, "observeOn", { enumerable: true, get: function () { return observeOn_1.observeOn; } });
	var onErrorResumeNext_1 = __webpack_require__(778);
	Object.defineProperty(exports, "onErrorResumeNext", { enumerable: true, get: function () { return onErrorResumeNext_1.onErrorResumeNext; } });
	var pairwise_1 = __webpack_require__(779);
	Object.defineProperty(exports, "pairwise", { enumerable: true, get: function () { return pairwise_1.pairwise; } });
	var partition_1 = __webpack_require__(2226);
	Object.defineProperty(exports, "partition", { enumerable: true, get: function () { return partition_1.partition; } });
	var pluck_1 = __webpack_require__(780);
	Object.defineProperty(exports, "pluck", { enumerable: true, get: function () { return pluck_1.pluck; } });
	var publish_1 = __webpack_require__(781);
	Object.defineProperty(exports, "publish", { enumerable: true, get: function () { return publish_1.publish; } });
	var publishBehavior_1 = __webpack_require__(782);
	Object.defineProperty(exports, "publishBehavior", { enumerable: true, get: function () { return publishBehavior_1.publishBehavior; } });
	var publishLast_1 = __webpack_require__(783);
	Object.defineProperty(exports, "publishLast", { enumerable: true, get: function () { return publishLast_1.publishLast; } });
	var publishReplay_1 = __webpack_require__(784);
	Object.defineProperty(exports, "publishReplay", { enumerable: true, get: function () { return publishReplay_1.publishReplay; } });
	var race_1 = __webpack_require__(2227);
	Object.defineProperty(exports, "race", { enumerable: true, get: function () { return race_1.race; } });
	var raceWith_1 = __webpack_require__(432);
	Object.defineProperty(exports, "raceWith", { enumerable: true, get: function () { return raceWith_1.raceWith; } });
	var reduce_1 = __webpack_require__(154);
	Object.defineProperty(exports, "reduce", { enumerable: true, get: function () { return reduce_1.reduce; } });
	var repeat_1 = __webpack_require__(785);
	Object.defineProperty(exports, "repeat", { enumerable: true, get: function () { return repeat_1.repeat; } });
	var repeatWhen_1 = __webpack_require__(786);
	Object.defineProperty(exports, "repeatWhen", { enumerable: true, get: function () { return repeatWhen_1.repeatWhen; } });
	var retry_1 = __webpack_require__(787);
	Object.defineProperty(exports, "retry", { enumerable: true, get: function () { return retry_1.retry; } });
	var retryWhen_1 = __webpack_require__(788);
	Object.defineProperty(exports, "retryWhen", { enumerable: true, get: function () { return retryWhen_1.retryWhen; } });
	var refCount_1 = __webpack_require__(433);
	Object.defineProperty(exports, "refCount", { enumerable: true, get: function () { return refCount_1.refCount; } });
	var sample_1 = __webpack_require__(434);
	Object.defineProperty(exports, "sample", { enumerable: true, get: function () { return sample_1.sample; } });
	var sampleTime_1 = __webpack_require__(789);
	Object.defineProperty(exports, "sampleTime", { enumerable: true, get: function () { return sampleTime_1.sampleTime; } });
	var scan_1 = __webpack_require__(790);
	Object.defineProperty(exports, "scan", { enumerable: true, get: function () { return scan_1.scan; } });
	var sequenceEqual_1 = __webpack_require__(792);
	Object.defineProperty(exports, "sequenceEqual", { enumerable: true, get: function () { return sequenceEqual_1.sequenceEqual; } });
	var share_1 = __webpack_require__(435);
	Object.defineProperty(exports, "share", { enumerable: true, get: function () { return share_1.share; } });
	var shareReplay_1 = __webpack_require__(793);
	Object.defineProperty(exports, "shareReplay", { enumerable: true, get: function () { return shareReplay_1.shareReplay; } });
	var single_1 = __webpack_require__(794);
	Object.defineProperty(exports, "single", { enumerable: true, get: function () { return single_1.single; } });
	var skip_1 = __webpack_require__(795);
	Object.defineProperty(exports, "skip", { enumerable: true, get: function () { return skip_1.skip; } });
	var skipLast_1 = __webpack_require__(796);
	Object.defineProperty(exports, "skipLast", { enumerable: true, get: function () { return skipLast_1.skipLast; } });
	var skipUntil_1 = __webpack_require__(797);
	Object.defineProperty(exports, "skipUntil", { enumerable: true, get: function () { return skipUntil_1.skipUntil; } });
	var skipWhile_1 = __webpack_require__(798);
	Object.defineProperty(exports, "skipWhile", { enumerable: true, get: function () { return skipWhile_1.skipWhile; } });
	var startWith_1 = __webpack_require__(799);
	Object.defineProperty(exports, "startWith", { enumerable: true, get: function () { return startWith_1.startWith; } });
	var subscribeOn_1 = __webpack_require__(197);
	Object.defineProperty(exports, "subscribeOn", { enumerable: true, get: function () { return subscribeOn_1.subscribeOn; } });
	var switchAll_1 = __webpack_require__(800);
	Object.defineProperty(exports, "switchAll", { enumerable: true, get: function () { return switchAll_1.switchAll; } });
	var switchMap_1 = __webpack_require__(198);
	Object.defineProperty(exports, "switchMap", { enumerable: true, get: function () { return switchMap_1.switchMap; } });
	var switchMapTo_1 = __webpack_require__(801);
	Object.defineProperty(exports, "switchMapTo", { enumerable: true, get: function () { return switchMapTo_1.switchMapTo; } });
	var switchScan_1 = __webpack_require__(802);
	Object.defineProperty(exports, "switchScan", { enumerable: true, get: function () { return switchScan_1.switchScan; } });
	var take_1 = __webpack_require__(199);
	Object.defineProperty(exports, "take", { enumerable: true, get: function () { return take_1.take; } });
	var takeLast_1 = __webpack_require__(436);
	Object.defineProperty(exports, "takeLast", { enumerable: true, get: function () { return takeLast_1.takeLast; } });
	var takeUntil_1 = __webpack_require__(803);
	Object.defineProperty(exports, "takeUntil", { enumerable: true, get: function () { return takeUntil_1.takeUntil; } });
	var takeWhile_1 = __webpack_require__(804);
	Object.defineProperty(exports, "takeWhile", { enumerable: true, get: function () { return takeWhile_1.takeWhile; } });
	var tap_1 = __webpack_require__(805);
	Object.defineProperty(exports, "tap", { enumerable: true, get: function () { return tap_1.tap; } });
	var throttle_1 = __webpack_require__(437);
	Object.defineProperty(exports, "throttle", { enumerable: true, get: function () { return throttle_1.throttle; } });
	var throttleTime_1 = __webpack_require__(806);
	Object.defineProperty(exports, "throttleTime", { enumerable: true, get: function () { return throttleTime_1.throttleTime; } });
	var throwIfEmpty_1 = __webpack_require__(200);
	Object.defineProperty(exports, "throwIfEmpty", { enumerable: true, get: function () { return throwIfEmpty_1.throwIfEmpty; } });
	var timeInterval_1 = __webpack_require__(807);
	Object.defineProperty(exports, "timeInterval", { enumerable: true, get: function () { return timeInterval_1.timeInterval; } });
	var timeout_1 = __webpack_require__(291);
	Object.defineProperty(exports, "timeout", { enumerable: true, get: function () { return timeout_1.timeout; } });
	var timeoutWith_1 = __webpack_require__(808);
	Object.defineProperty(exports, "timeoutWith", { enumerable: true, get: function () { return timeoutWith_1.timeoutWith; } });
	var timestamp_1 = __webpack_require__(809);
	Object.defineProperty(exports, "timestamp", { enumerable: true, get: function () { return timestamp_1.timestamp; } });
	var toArray_1 = __webpack_require__(438);
	Object.defineProperty(exports, "toArray", { enumerable: true, get: function () { return toArray_1.toArray; } });
	var window_1 = __webpack_require__(810);
	Object.defineProperty(exports, "window", { enumerable: true, get: function () { return window_1.window; } });
	var windowCount_1 = __webpack_require__(811);
	Object.defineProperty(exports, "windowCount", { enumerable: true, get: function () { return windowCount_1.windowCount; } });
	var windowTime_1 = __webpack_require__(812);
	Object.defineProperty(exports, "windowTime", { enumerable: true, get: function () { return windowTime_1.windowTime; } });
	var windowToggle_1 = __webpack_require__(813);
	Object.defineProperty(exports, "windowToggle", { enumerable: true, get: function () { return windowToggle_1.windowToggle; } });
	var windowWhen_1 = __webpack_require__(814);
	Object.defineProperty(exports, "windowWhen", { enumerable: true, get: function () { return windowWhen_1.windowWhen; } });
	var withLatestFrom_1 = __webpack_require__(815);
	Object.defineProperty(exports, "withLatestFrom", { enumerable: true, get: function () { return withLatestFrom_1.withLatestFrom; } });
	var zip_1 = __webpack_require__(816);
	Object.defineProperty(exports, "zip", { enumerable: true, get: function () { return zip_1.zip; } });
	var zipAll_1 = __webpack_require__(817);
	Object.defineProperty(exports, "zipAll", { enumerable: true, get: function () { return zipAll_1.zipAll; } });
	var zipWith_1 = __webpack_require__(818);
	Object.defineProperty(exports, "zipWith", { enumerable: true, get: function () { return zipWith_1.zipWith; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var ObjectUnsubscribedError_1 = __webpack_require__(303);
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        var _this = _super.call(this) || this;
	        _this._value = _value;
	        return _this;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var config_1 = __webpack_require__(297);
	var hostReportError_1 = __webpack_require__(458);
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) {
	        if (config_1.config.useDeprecatedSynchronousErrorHandling) {
	            throw err;
	        }
	        else {
	            hostReportError_1.hostReportError(err);
	        }
	    },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = function () { return Date.now(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscription_1 = __webpack_require__(45);
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        var _this = _super.call(this) || this;
	        _this.subject = subject;
	        _this.subscriber = subscriber;
	        _this.closed = false;
	        return _this;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var Observable_1 = __webpack_require__(24);
	var Subscriber_1 = __webpack_require__(14);
	var Subscription_1 = __webpack_require__(45);
	var refCount_1 = __webpack_require__(450);
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subjectFactory = subjectFactory;
	        _this._refCount = 0;
	        _this._isComplete = false;
	        return _this;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            this._isComplete = false;
	            connection = this._connection = new Subscription_1.Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	exports.connectableObservableDescriptor = (function () {
	    var connectableProto = ConnectableObservable.prototype;
	    return {
	        operator: { value: null },
	        _refCount: { value: 0, writable: true },
	        _subject: { value: null, writable: true },
	        _connection: { value: null, writable: true },
	        _subscribe: { value: connectableProto._subscribe },
	        _isComplete: { value: connectableProto._isComplete, writable: true },
	        getSubject: { value: connectableProto.getSubject },
	        connect: { value: connectableProto.connect },
	        refCount: { value: connectableProto.refCount }
	    };
	})();
	var ConnectableSubscriber = (function (_super) {
	    __extends(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        var _this = _super.call(this, destination) || this;
	        _this.connectable = connectable;
	        return _this;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this.connectable._isComplete = true;
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(Subject_1.SubjectSubscriber));
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        var _this = _super.call(this, destination) || this;
	        _this.connectable = connectable;
	        return _this;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var isScheduler_1 = __webpack_require__(90);
	var mergeAll_1 = __webpack_require__(449);
	var fromArray_1 = __webpack_require__(203);
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler_1.isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
	        return observables[0];
	    }
	    return mergeAll_1.mergeAll(concurrent)(fromArray_1.fromArray(observables, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var noop_1 = __webpack_require__(460);
	exports.NEVER = new Observable_1.Observable(noop_1.noop);
	function never() {
	    return exports.NEVER;
	}
	exports.never = never;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var isArray_1 = __webpack_require__(59);
	var fromArray_1 = __webpack_require__(203);
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    if (observables.length === 1) {
	        if (isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return fromArray_1.fromArray(observables, undefined).lift(new RaceOperator());
	}
	exports.race = race;
	var RaceOperator = (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	exports.RaceOperator = RaceOperator;
	var RaceSubscriber = (function (_super) {
	    __extends(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasFirst = false;
	        _this.observables = [];
	        _this.subscriptions = [];
	        return _this;
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len && !this.hasFirst; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult_1.subscribeToResult(this, observable, undefined, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                }
	                this.add(subscription);
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.RaceSubscriber = RaceSubscriber;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var async_1 = __webpack_require__(58);
	var isNumeric_1 = __webpack_require__(304);
	var isScheduler_1 = __webpack_require__(90);
	function timer(dueTime, periodOrScheduler, scheduler) {
	    if (dueTime === void 0) { dueTime = 0; }
	    var period = -1;
	    if (isNumeric_1.isNumeric(periodOrScheduler)) {
	        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
	    }
	    else if (isScheduler_1.isScheduler(periodOrScheduler)) {
	        scheduler = periodOrScheduler;
	    }
	    if (!isScheduler_1.isScheduler(scheduler)) {
	        scheduler = async_1.async;
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var due = isNumeric_1.isNumeric(dueTime)
	            ? dueTime
	            : (+dueTime - scheduler.now());
	        return scheduler.schedule(dispatch, due, {
	            index: 0, period: period, subscriber: subscriber
	        });
	    });
	}
	exports.timer = timer;
	function dispatch(state) {
	    var index = state.index, period = state.period, subscriber = state.subscriber;
	    subscriber.next(index);
	    if (subscriber.closed) {
	        return;
	    }
	    else if (period === -1) {
	        return subscriber.complete();
	    }
	    state.index = index + 1;
	    this.schedule(state, period);
	}
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function audit(durationSelector) {
	    return function auditOperatorFunction(source) {
	        return source.lift(new AuditOperator(durationSelector));
	    };
	}
	exports.audit = audit;
	var AuditOperator = (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	var AuditSubscriber = (function (_super) {
	    __extends(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.durationSelector = durationSelector;
	        _this.hasValue = false;
	        return _this;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = void 0;
	            try {
	                var durationSelector = this.durationSelector;
	                duration = durationSelector(value);
	            }
	            catch (err) {
	                return this.destination.error(err);
	            }
	            var innerSubscription = innerSubscribe_1.innerSubscribe(duration, new innerSubscribe_1.SimpleInnerSubscriber(this));
	            if (!innerSubscription || innerSubscription.closed) {
	                this.clearThrottle();
	            }
	            else {
	                this.add(this.throttled = innerSubscription);
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = undefined;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = undefined;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function () {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeAll_1 = __webpack_require__(449);
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeMap_1 = __webpack_require__(300);
	function concatMap(project, resultSelector) {
	    return mergeMap_1.mergeMap(project, resultSelector, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function distinctUntilChanged(compare, keySelector) {
	    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	var DistinctUntilChangedOperator = (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	var DistinctUntilChangedSubscriber = (function (_super) {
	    __extends(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.hasKey = false;
	        if (typeof compare === 'function') {
	            _this.compare = compare;
	        }
	        return _this;
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            var keySelector = this.keySelector;
	            key = keySelector ? keySelector(value) : value;
	        }
	        catch (err) {
	            return this.destination.error(err);
	        }
	        var result = false;
	        if (this.hasKey) {
	            try {
	                var compare = this.compare;
	                result = compare(this.key, key);
	            }
	            catch (err) {
	                return this.destination.error(err);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (!result) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
	}
	exports.find = find;
	var FindValueOperator = (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	exports.FindValueOperator = FindValueOperator;
	var FindValueSubscriber = (function (_super) {
	    __extends(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.yieldIndex = yieldIndex;
	        _this.thisArg = thisArg;
	        _this.index = 0;
	        return _this;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	        this.unsubscribe();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber_1.Subscriber));
	exports.FindValueSubscriber = FindValueSubscriber;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Subscription_1 = __webpack_require__(45);
	var Observable_1 = __webpack_require__(24);
	var Subject_1 = __webpack_require__(52);
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return function (source) {
	        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
	    };
	}
	exports.groupBy = groupBy;
	var GroupByOperator = (function () {
	    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
	    };
	    return GroupByOperator;
	}());
	var GroupBySubscriber = (function (_super) {
	    __extends(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.elementSelector = elementSelector;
	        _this.durationSelector = durationSelector;
	        _this.subjectSelector = subjectSelector;
	        _this.groups = null;
	        _this.attemptedToUnsubscribe = false;
	        _this.count = 0;
	        return _this;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = new Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            group = (this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject());
	            groups.set(key, group);
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber_1.Subscriber));
	var GroupDurationSubscriber = (function (_super) {
	    __extends(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        var _this = _super.call(this, group) || this;
	        _this.key = key;
	        _this.group = group;
	        _this.parent = parent;
	        return _this;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this.complete();
	    };
	    GroupDurationSubscriber.prototype._unsubscribe = function () {
	        var _a = this, parent = _a.parent, key = _a.key;
	        this.key = this.parent = null;
	        if (parent) {
	            parent.removeGroup(key);
	        }
	    };
	    return GroupDurationSubscriber;
	}(Subscriber_1.Subscriber));
	var GroupedObservable = (function (_super) {
	    __extends(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.groupSubject = groupSubject;
	        _this.refCountSubscription = refCountSubscription;
	        return _this;
	    }
	    GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable_1.Observable));
	exports.GroupedObservable = GroupedObservable;
	var InnerRefCountSubscription = (function (_super) {
	    __extends(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        parent.count++;
	        return _this;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription_1.Subscription));
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Notification_1 = __webpack_require__(296);
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        var _this = _super.call(this, destination) || this;
	        _this.scheduler = scheduler;
	        _this.delay = delay;
	        return _this;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        var destination = this.destination;
	        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	        this.unsubscribe();
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false
	};
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing)); };
	}
	exports.throttle = throttle;
	var ThrottleOperator = (function () {
	    function ThrottleOperator(durationSelector, leading, trailing) {
	        this.durationSelector = durationSelector;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
	    };
	    return ThrottleOperator;
	}());
	var ThrottleSubscriber = (function (_super) {
	    __extends(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.durationSelector = durationSelector;
	        _this._leading = _leading;
	        _this._trailing = _trailing;
	        _this._hasValue = false;
	        return _this;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        this._hasValue = true;
	        this._sendValue = value;
	        if (!this._throttled) {
	            if (this._leading) {
	                this.send();
	            }
	            else {
	                this.throttle(value);
	            }
	        }
	    };
	    ThrottleSubscriber.prototype.send = function () {
	        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
	        if (_hasValue) {
	            this.destination.next(_sendValue);
	            this.throttle(_sendValue);
	        }
	        this._hasValue = false;
	        this._sendValue = undefined;
	    };
	    ThrottleSubscriber.prototype.throttle = function (value) {
	        var duration = this.tryDurationSelector(value);
	        if (!!duration) {
	            this.add(this._throttled = innerSubscribe_1.innerSubscribe(duration, new innerSubscribe_1.SimpleInnerSubscriber(this)));
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        try {
	            return this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return null;
	        }
	    };
	    ThrottleSubscriber.prototype.throttlingDone = function () {
	        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
	        if (_throttled) {
	            _throttled.unsubscribe();
	        }
	        this._throttled = undefined;
	        if (_trailing) {
	            this.send();
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function () {
	        this.throttlingDone();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this.throttlingDone();
	    };
	    return ThrottleSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var isDate_1 = __webpack_require__(864);
	var innerSubscribe_1 = __webpack_require__(31);
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) {
	        var absoluteTimeout = isDate_1.isDate(due);
	        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	    };
	}
	exports.timeoutWith = timeoutWith;
	var TimeoutWithOperator = (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	var TimeoutWithSubscriber = (function (_super) {
	    __extends(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.absoluteTimeout = absoluteTimeout;
	        _this.waitFor = waitFor;
	        _this.withObservable = withObservable;
	        _this.scheduler = scheduler;
	        _this.scheduleTimeout();
	        return _this;
	    }
	    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
	        var withObservable = subscriber.withObservable;
	        subscriber._unsubscribeAndRecycle();
	        subscriber.add(innerSubscribe_1.innerSubscribe(withObservable, new innerSubscribe_1.SimpleInnerSubscriber(subscriber)));
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    TimeoutWithSubscriber.prototype._unsubscribe = function () {
	        this.action = undefined;
	        this.scheduler = null;
	        this.withObservable = null;
	    };
	    return TimeoutWithSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var scheduleObservable_1 = __webpack_require__(2353);
	var schedulePromise_1 = __webpack_require__(2354);
	var scheduleArray_1 = __webpack_require__(455);
	var scheduleIterable_1 = __webpack_require__(2352);
	var isInteropObservable_1 = __webpack_require__(2365);
	var isPromise_1 = __webpack_require__(865);
	var isArrayLike_1 = __webpack_require__(863);
	var isIterable_1 = __webpack_require__(2366);
	function scheduled(input, scheduler) {
	    if (input != null) {
	        if (isInteropObservable_1.isInteropObservable(input)) {
	            return scheduleObservable_1.scheduleObservable(input, scheduler);
	        }
	        else if (isPromise_1.isPromise(input)) {
	            return schedulePromise_1.schedulePromise(input, scheduler);
	        }
	        else if (isArrayLike_1.isArrayLike(input)) {
	            return scheduleArray_1.scheduleArray(input, scheduler);
	        }
	        else if (isIterable_1.isIterable(input) || typeof input === 'string') {
	            return scheduleIterable_1.scheduleIterable(input, scheduler);
	        }
	    }
	    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
	}
	exports.scheduled = scheduled;
	//# sourceMappingURL=scheduled.js.map

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsapAction_1 = __webpack_require__(2358);
	var AsapScheduler_1 = __webpack_require__(2359);
	exports.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	exports.asap = exports.asapScheduler;
	//# sourceMappingURL=asap.js.map

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var QueueAction_1 = __webpack_require__(2360);
	var QueueScheduler_1 = __webpack_require__(2361);
	exports.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	exports.queue = exports.queueScheduler;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TimeoutErrorImpl = (function () {
	    function TimeoutErrorImpl() {
	        Error.call(this);
	        this.message = 'Timeout has occurred';
	        this.name = 'TimeoutError';
	        return this;
	    }
	    TimeoutErrorImpl.prototype = Object.create(Error.prototype);
	    return TimeoutErrorImpl;
	})();
	exports.TimeoutError = TimeoutErrorImpl;
	//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnsubscriptionErrorImpl = (function () {
	    function UnsubscriptionErrorImpl(errors) {
	        Error.call(this);
	        this.message = errors ?
	            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
	        this.name = 'UnsubscriptionError';
	        this.errors = errors;
	        return this;
	    }
	    UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype);
	    return UnsubscriptionErrorImpl;
	})();
	exports.UnsubscriptionError = UnsubscriptionErrorImpl;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}
	exports.isDate = isDate;
	//# sourceMappingURL=isDate.js.map

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isPromise(value) {
	    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.subscribeToArray = function (array) { return function (subscriber) {
	    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
	        subscriber.next(array[i]);
	    }
	    subscriber.complete();
	}; };
	//# sourceMappingURL=subscribeToArray.js.map

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1762).enable();
	  window.Promise = __webpack_require__(1761);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2393);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(121);
	
	__webpack_require__(1184);


/***/ }),
/* 869 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(869);
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(874);
	} else {
	  module.exports = require("./emotion-is-prop-valid.cjs.dev.js");
	}


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var memoize = __webpack_require__(875);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var memoize__default = /*#__PURE__*/_interopDefault(memoize);
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var isPropValid = /* #__PURE__ */memoize__default["default"](function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports["default"] = isPropValid;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(876);
	} else {
	  module.exports = require("./emotion-memoize.cjs.dev.js");
	}


/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = Object.create(null);
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports["default"] = memoize;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(878);
	} else {
	  module.exports = require("./emotion-unitless.cjs.dev.js");
	}


/***/ }),
/* 878 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  aspectRatio: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports["default"] = unitlessKeys;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Queue = __webpack_require__(2384);
	
	module.exports = polylabel;
	module.exports.default = polylabel;
	
	function polylabel(polygon, precision, debug) {
	    precision = precision || 1.0;
	
	    // find the bounding box of the outer ring
	    var minX, minY, maxX, maxY;
	    for (var i = 0; i < polygon[0].length; i++) {
	        var p = polygon[0][i];
	        if (!i || p[0] < minX) minX = p[0];
	        if (!i || p[1] < minY) minY = p[1];
	        if (!i || p[0] > maxX) maxX = p[0];
	        if (!i || p[1] > maxY) maxY = p[1];
	    }
	
	    var width = maxX - minX;
	    var height = maxY - minY;
	    var cellSize = Math.min(width, height);
	    var h = cellSize / 2;
	
	    // a priority queue of cells in order of their "potential" (max distance to polygon)
	    var cellQueue = new Queue(null, compareMax);
	
	    if (cellSize === 0) return [minX, minY];
	
	    // cover polygon with initial cells
	    for (var x = minX; x < maxX; x += cellSize) {
	        for (var y = minY; y < maxY; y += cellSize) {
	            cellQueue.push(new Cell(x + h, y + h, h, polygon));
	        }
	    }
	
	    // take centroid as the first best guess
	    var bestCell = getCentroidCell(polygon);
	
	    // special case for rectangular polygons
	    var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
	    if (bboxCell.d > bestCell.d) bestCell = bboxCell;
	
	    var numProbes = cellQueue.length;
	
	    while (cellQueue.length) {
	        // pick the most promising cell from the queue
	        var cell = cellQueue.pop();
	
	        // update the best cell if we found a better one
	        if (cell.d > bestCell.d) {
	            bestCell = cell;
	            if (debug) console.log('found best %d after %d probes', Math.round(1e4 * cell.d) / 1e4, numProbes);
	        }
	
	        // do not drill down further if there's no chance of a better solution
	        if (cell.max - bestCell.d <= precision) continue;
	
	        // split the cell into four cells
	        h = cell.h / 2;
	        cellQueue.push(new Cell(cell.x - h, cell.y - h, h, polygon));
	        cellQueue.push(new Cell(cell.x + h, cell.y - h, h, polygon));
	        cellQueue.push(new Cell(cell.x - h, cell.y + h, h, polygon));
	        cellQueue.push(new Cell(cell.x + h, cell.y + h, h, polygon));
	        numProbes += 4;
	    }
	
	    if (debug) {
	        console.log('num probes: ' + numProbes);
	        console.log('best distance: ' + bestCell.d);
	    }
	
	    return [bestCell.x, bestCell.y];
	}
	
	function compareMax(a, b) {
	    return b.max - a.max;
	}
	
	function Cell(x, y, h, polygon) {
	    this.x = x; // cell center x
	    this.y = y; // cell center y
	    this.h = h; // half the cell size
	    this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
	    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
	}
	
	// signed distance from point to polygon outline (negative if point is outside)
	function pointToPolygonDist(x, y, polygon) {
	    var inside = false;
	    var minDistSq = Infinity;
	
	    for (var k = 0; k < polygon.length; k++) {
	        var ring = polygon[k];
	
	        for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
	            var a = ring[i];
	            var b = ring[j];
	
	            if ((a[1] > y !== b[1] > y) &&
	                (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;
	
	            minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
	        }
	    }
	
	    return (inside ? 1 : -1) * Math.sqrt(minDistSq);
	}
	
	// get polygon centroid
	function getCentroidCell(polygon) {
	    var area = 0;
	    var x = 0;
	    var y = 0;
	    var points = polygon[0];
	
	    for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	        var a = points[i];
	        var b = points[j];
	        var f = a[0] * b[1] - b[0] * a[1];
	        x += (a[0] + b[0]) * f;
	        y += (a[1] + b[1]) * f;
	        area += f * 3;
	    }
	    if (area === 0) return new Cell(points[0][0], points[0][1], 0, polygon);
	    return new Cell(x / area, y / area, 0, polygon);
	}
	
	// get squared distance from a point to a segment
	function getSegDistSq(px, py, a, b) {
	
	    var x = a[0];
	    var y = a[1];
	    var dx = b[0] - x;
	    var dy = b[1] - y;
	
	    if (dx !== 0 || dy !== 0) {
	
	        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
	
	        if (t > 1) {
	            x = b[0];
	            y = b[1];
	
	        } else if (t > 0) {
	            x += dx * t;
	            y += dy * t;
	        }
	    }
	
	    dx = px - x;
	    dy = py - y;
	
	    return dx * dx + dy * dy;
	}


/***/ }),
/* 880 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	var bind = __webpack_require__(466);
	var Axios = __webpack_require__(882);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance();
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return createInstance(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(897);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(888);
	var utils = __webpack_require__(67);
	var InterceptorManager = __webpack_require__(883);
	var dispatchRequest = __webpack_require__(884);
	var isAbsoluteURL = __webpack_require__(893);
	var combineURLs = __webpack_require__(891);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 */
	function Axios(defaultConfig) {
	  this.defaults = utils.merge(defaults, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(67);
	var transformData = __webpack_require__(887);
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter;
	
	  if (typeof config.adapter === 'function') {
	    // For custom adapter support
	    adapter = config.adapter;
	  } else if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(464);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(464);
	  }
	
	  return Promise.resolve(config)
	    // Wrap synchronous adapter errors and pass configuration
	    .then(adapter)
	    .then(function onFulfilled(response) {
	      // Transform response data
	      response.data = transformData(
	        response.data,
	        response.headers,
	        config.transformResponse
	      );
	
	      return response;
	    }, function onRejected(error) {
	      // Transform response data
	      if (error && error.response) {
	        error.response.data = transformData(
	          error.response.data,
	          error.response.headers,
	          config.transformResponse
	        );
	      }
	
	      return Promise.reject(error);
	    });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(465);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	var normalizeHeaderName = __webpack_require__(895);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ }),
/* 889 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 891 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 893 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(67);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 897 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBanner = getBanner;
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Config = __webpack_require__(16);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getBanner() {
	  return function (dispatch) {
	    try {
	      return _axios2.default.get(_Config.ROOT_URL + '/banner/get').then(function (_ref) {
	        var data = _ref.data.data;
	
	        dispatch({ type: types.SET_BANNER, payload: data });
	        return data;
	      });
	    } catch (error) {
	      console.error(error);
	      dispatch({ type: types.SET_BANNER, payload: [] });
	    }
	  };
	}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.is_management_company = exports.is_landscape_park = exports.is_acs_system = exports.is_garage = exports.is_operated_roof = exports.is_walking_area = exports.is_beach = exports.is_panoramic_glazing = exports.is_wellness_building = exports.is_conference_hall = exports.is_children_room = exports.kpp = exports.billiards = exports.restaurant = exports.sauna = exports.cctv_surveillance = exports.commercial_property = exports.helicopter_landing_area = exports.garden = exports.fountain = exports.recreation_zone = exports.tennis_court = exports.kindergarten = exports.pool = exports.fitness = exports.spa = exports.sport_area = exports.landscape_decore = exports.children_area = exports.elevator = exports.concierge = undefined;
	
	var _concierge = __webpack_require__(1493);
	
	var _concierge2 = _interopRequireDefault(_concierge);
	
	var _elevator = __webpack_require__(1494);
	
	var _elevator2 = _interopRequireDefault(_elevator);
	
	var _children_area = __webpack_require__(1491);
	
	var _children_area2 = _interopRequireDefault(_children_area);
	
	var _landscape_decore = __webpack_require__(1512);
	
	var _landscape_decore2 = _interopRequireDefault(_landscape_decore);
	
	var _sport_area = __webpack_require__(1518);
	
	var _sport_area2 = _interopRequireDefault(_sport_area);
	
	var _spa = __webpack_require__(1517);
	
	var _spa2 = _interopRequireDefault(_spa);
	
	var _fitness = __webpack_require__(1495);
	
	var _fitness2 = _interopRequireDefault(_fitness);
	
	var _pool = __webpack_require__(1513);
	
	var _pool2 = _interopRequireDefault(_pool);
	
	var _kindergarten = __webpack_require__(1510);
	
	var _kindergarten2 = _interopRequireDefault(_kindergarten);
	
	var _tennis_court = __webpack_require__(1519);
	
	var _tennis_court2 = _interopRequireDefault(_tennis_court);
	
	var _recreation_zone = __webpack_require__(1514);
	
	var _recreation_zone2 = _interopRequireDefault(_recreation_zone);
	
	var _fountain = __webpack_require__(1496);
	
	var _fountain2 = _interopRequireDefault(_fountain);
	
	var _garden = __webpack_require__(1497);
	
	var _garden2 = _interopRequireDefault(_garden);
	
	var _helicopter_landing_area = __webpack_require__(1498);
	
	var _helicopter_landing_area2 = _interopRequireDefault(_helicopter_landing_area);
	
	var _commercial_property = __webpack_require__(1492);
	
	var _commercial_property2 = _interopRequireDefault(_commercial_property);
	
	var _cctv_surveillance = __webpack_require__(1490);
	
	var _cctv_surveillance2 = _interopRequireDefault(_cctv_surveillance);
	
	var _sauna = __webpack_require__(1516);
	
	var _sauna2 = _interopRequireDefault(_sauna);
	
	var _billiards = __webpack_require__(1489);
	
	var _billiards2 = _interopRequireDefault(_billiards);
	
	var _restaurant = __webpack_require__(1515);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _kpp = __webpack_require__(1511);
	
	var _kpp2 = _interopRequireDefault(_kpp);
	
	var _is_children_room = __webpack_require__(1501);
	
	var _is_children_room2 = _interopRequireDefault(_is_children_room);
	
	var _is_conference_hall = __webpack_require__(1502);
	
	var _is_conference_hall2 = _interopRequireDefault(_is_conference_hall);
	
	var _is_wellness_building = __webpack_require__(1509);
	
	var _is_wellness_building2 = _interopRequireDefault(_is_wellness_building);
	
	var _is_panoramic_glazing = __webpack_require__(1507);
	
	var _is_panoramic_glazing2 = _interopRequireDefault(_is_panoramic_glazing);
	
	var _is_beach = __webpack_require__(1500);
	
	var _is_beach2 = _interopRequireDefault(_is_beach);
	
	var _is_walking_area = __webpack_require__(1508);
	
	var _is_walking_area2 = _interopRequireDefault(_is_walking_area);
	
	var _is_operated_roof = __webpack_require__(1506);
	
	var _is_operated_roof2 = _interopRequireDefault(_is_operated_roof);
	
	var _is_garage = __webpack_require__(1503);
	
	var _is_garage2 = _interopRequireDefault(_is_garage);
	
	var _is_acs_system = __webpack_require__(1499);
	
	var _is_acs_system2 = _interopRequireDefault(_is_acs_system);
	
	var _is_landscape_park = __webpack_require__(1504);
	
	var _is_landscape_park2 = _interopRequireDefault(_is_landscape_park);
	
	var _is_management_company = __webpack_require__(1505);
	
	var _is_management_company2 = _interopRequireDefault(_is_management_company);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.concierge = _concierge2.default;
	exports.elevator = _elevator2.default;
	exports.children_area = _children_area2.default;
	exports.landscape_decore = _landscape_decore2.default;
	exports.sport_area = _sport_area2.default;
	exports.spa = _spa2.default;
	exports.fitness = _fitness2.default;
	exports.pool = _pool2.default;
	exports.kindergarten = _kindergarten2.default;
	exports.tennis_court = _tennis_court2.default;
	exports.recreation_zone = _recreation_zone2.default;
	exports.fountain = _fountain2.default;
	exports.garden = _garden2.default;
	exports.helicopter_landing_area = _helicopter_landing_area2.default;
	exports.commercial_property = _commercial_property2.default;
	exports.cctv_surveillance = _cctv_surveillance2.default;
	exports.sauna = _sauna2.default;
	exports.restaurant = _restaurant2.default;
	exports.billiards = _billiards2.default;
	exports.kpp = _kpp2.default;
	exports.is_children_room = _is_children_room2.default;
	exports.is_conference_hall = _is_conference_hall2.default;
	exports.is_wellness_building = _is_wellness_building2.default;
	exports.is_panoramic_glazing = _is_panoramic_glazing2.default;
	exports.is_beach = _is_beach2.default;
	exports.is_walking_area = _is_walking_area2.default;
	exports.is_operated_roof = _is_operated_roof2.default;
	exports.is_garage = _is_garage2.default;
	exports.is_acs_system = _is_acs_system2.default;
	exports.is_landscape_park = _is_landscape_park2.default;
	exports.is_management_company = _is_management_company2.default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _AppointmentButton = __webpack_require__(1326);
	
	var _AppointmentButton2 = _interopRequireDefault(_AppointmentButton);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _environment = __webpack_require__(19);
	
	var _reactRedux = __webpack_require__(5);
	
	var _AppointmentDialog = __webpack_require__(901);
	
	var _AppointmentDialog2 = _interopRequireDefault(_AppointmentDialog);
	
	var _appointment = __webpack_require__(159);
	
	var _ButtonSpinner = __webpack_require__(164);
	
	var _constants = __webpack_require__(92);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var AppointmentButton = function AppointmentButton(_ref) {
	  var buildingId = _ref.buildingId,
	      profile = _ref.profile,
	      title = _ref.title,
	      objectType = _ref.objectType;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setIsLoading = _useState2[1];
	
	  var handleClick = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var dataOffline;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              (0, _ga.trackGA)(_ga.gaEvent.buildingRightMenuButtonsClick({
	                eventLabel: 'zapisatsya_na_pokaz',
	                eventContent: title,
	                productType: objectType,
	                productName: title,
	                productID: buildingId,
	                user_id: profile.id
	              }));
	
	              setIsLoading(true);
	              _context.prev = 2;
	              _context.next = 5;
	              return dispatch((0, _appointment.loadCalendar)({
	                building_id: buildingId,
	                type: _constants.OFFLINE_APPOINTMENT_TYPE
	              }));
	
	            case 5:
	              dataOffline = _context.sent;
	
	
	              if (dataOffline.data) {
	                dispatch((0, _environment.setPopUp)(_react2.default.createElement(_AppointmentDialog2.default, {
	                  data: dataOffline,
	                  buildingId: buildingId,
	                  profile: profile,
	                  buildingName: title,
	                  objectType: objectType
	                }), {
	                  closeStyleName: 'Default',
	                  contentStyleName: 'Default',
	                  closeIcon: 'default',
	                  lockScroll: false
	                }));
	              } else {
	                dispatch({ type: types.LOAD_CALENDAR_ERROR });
	              }
	              _context.next = 12;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](2);
	
	              console.error(_context.t0);
	
	            case 12:
	              _context.prev = 12;
	
	              setIsLoading(false);
	              return _context.finish(12);
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 9, 12, 15]]);
	    }));
	
	    return function handleClick() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'button',
	    { className: (0, _classnames2.default)(_AppointmentButton2.default.ActionBtn, _AppointmentButton2.default.AppointmentButton), onClick: handleClick },
	    isLoading ? _react2.default.createElement(_ButtonSpinner.ButtonSpinner, null) : t('components.appointment.appointmentButton.button')
	  );
	};
	
	exports.default = AppointmentButton;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _AppointmentDialog = __webpack_require__(1327);
	
	var _AppointmentDialog2 = _interopRequireDefault(_AppointmentDialog);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _DatePicker = __webpack_require__(903);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _AppointmentForm = __webpack_require__(902);
	
	var _AppointmentForm2 = _interopRequireDefault(_AppointmentForm);
	
	var _arrowLeft = __webpack_require__(1522);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _resultSuccess = __webpack_require__(1561);
	
	var _resultSuccess2 = _interopRequireDefault(_resultSuccess);
	
	var _resultError = __webpack_require__(1560);
	
	var _resultError2 = _interopRequireDefault(_resultError);
	
	var _reactRedux = __webpack_require__(5);
	
	var _appointment = __webpack_require__(159);
	
	var _constants = __webpack_require__(92);
	
	var _environment = __webpack_require__(19);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var AppointmentDialog = function AppointmentDialog(_ref) {
	  var data = _ref.data,
	      buildingId = _ref.buildingId,
	      buildingName = _ref.buildingName,
	      objectType = _ref.objectType,
	      profile = _ref.profile;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      step = _useState2[0],
	      setStep = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('offline'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activeTab = _useState4[0],
	      setActiveTab = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      isLoading = _useState6[0],
	      setIsLoading = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(data),
	      _useState8 = _slicedToArray(_useState7, 2),
	      offlineData = _useState8[0],
	      setOfflineData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      onlineData = _useState10[0],
	      setOnlineData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      selectedSlot = _useState12[0],
	      setSelectedSlot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectedDate = _useState14[0],
	      setSelectedDate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      resultStatus = _useState16[0],
	      setResultStatus = _useState16[1];
	
	  var isStepOne = step === 1;
	
	  var handleTrackEvent = function handleTrackEvent(_ref2) {
	    var eventLabel = _ref2.eventLabel;
	
	    (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogButtonsClick({
	      eventLabel: eventLabel,
	      eventContent: buildingName,
	      productType: objectType,
	      productName: buildingName,
	      productID: buildingId,
	      user_id: profile.id
	    }));
	  };
	
	  var handleTabChange = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(newTab) {
	      var eventLabel, dataOnline, dataOffline;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(newTab === activeTab)) {
	                _context.next = 2;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 2:
	              eventLabel = newTab === 'online' ? 'onlain' : 'offlain';
	
	
	              handleTrackEvent({ eventLabel: eventLabel });
	
	              setActiveTab(newTab);
	              setIsLoading(true);
	              _context.prev = 6;
	
	              if (!(newTab === 'online' && !onlineData)) {
	                _context.next = 14;
	                break;
	              }
	
	              _context.next = 10;
	              return dispatch((0, _appointment.loadCalendar)({
	                building_id: buildingId,
	                type: _constants.ONLINE_APPOINTMENT_TYPE
	              }));
	
	            case 10:
	              dataOnline = _context.sent;
	
	
	              if (dataOnline && dataOnline.data) {
	                setOnlineData(dataOnline);
	              } else {
	                dispatch({ type: types.LOAD_CALENDAR_ERROR });
	              }
	              _context.next = 19;
	              break;
	
	            case 14:
	              if (!(newTab === 'offline' && !offlineData)) {
	                _context.next = 19;
	                break;
	              }
	
	              _context.next = 17;
	              return dispatch((0, _appointment.loadCalendar)({
	                building_id: buildingId,
	                type: _constants.OFFLINE_APPOINTMENT_TYPE
	              }));
	
	            case 17:
	              dataOffline = _context.sent;
	
	
	              if (dataOffline && dataOffline.data) {
	                setOfflineData(dataOffline);
	              } else {
	                dispatch({ type: types.LOAD_CALENDAR_ERROR });
	              }
	
	            case 19:
	              _context.next = 24;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context['catch'](6);
	
	              console.error(_context.t0);
	
	            case 24:
	              _context.prev = 24;
	
	              setIsLoading(false);
	              return _context.finish(24);
	
	            case 27:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[6, 21, 24, 27]]);
	    }));
	
	    return function handleTabChange(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var handleSelectSlot = function handleSelectSlot(activeDate, slot) {
	    if (slot) {
	      setSelectedDate(activeDate);
	      setSelectedSlot(slot);
	    } else {
	      setSelectedDate(null);
	      setSelectedSlot(null);
	    }
	  };
	
	  var handleSetResult = function handleSetResult(result) {
	    if (result === 'success') {
	      (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogConfirmedResultShow({
	        eventContent: buildingName,
	        productType: objectType,
	        productName: buildingName,
	        productID: buildingId,
	        user_id: profile.id
	      }));
	    } else {
	      (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogRejectedResultShow({
	        eventContent: buildingName,
	        productType: objectType,
	        productName: buildingName,
	        productID: buildingId,
	        user_id: profile.id
	      }));
	    }
	
	    setResultStatus(result);
	  };
	
	  var toPrevStep = function toPrevStep() {
	    setSelectedSlot(null);
	    setSelectedDate(null);
	    setStep(1);
	    setResultStatus(null);
	  };
	
	  if (resultStatus) {
	    if (resultStatus === 'success') {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultDialog) },
	        _react2.default.createElement('img', { src: _resultSuccess2.default, alt: 'success-icon', className: _AppointmentDialog2.default.ResultIcon }),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentDialog2.default.ResultTitle },
	          t('components.appointment.appointmentDialog.resultSuccessTitle')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentDialog2.default.ResultText },
	          t('components.appointment.appointmentDialog.resultSuccessText')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentDialog2.default.ButtonsGroup },
	          _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultButton, 'button-primary', 'button-primary--md'),
	              onClick: function onClick() {
	                handleTrackEvent({ eventLabel: 'horosho' });
	                dispatch((0, _environment.setPopUp)());
	              }
	            },
	            t('components.appointment.appointmentDialog.resultSuccessGood')
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: '/profile?tab=appointments',
	              className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultButton, 'button-default', 'button-primary--md'),
	              onClick: function onClick() {
	                handleTrackEvent({ eventLabel: 'v_moi_zapisi' });
	                dispatch((0, _environment.setPopUp)());
	              }
	            },
	            t('components.appointment.appointmentDialog.resultSuccessToMyAppointment')
	          )
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultDialog) },
	      _react2.default.createElement('img', { src: _resultError2.default, alt: 'error-icon', className: _AppointmentDialog2.default.ResultIcon }),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentDialog2.default.ResultTitle },
	        t('components.appointment.appointmentDialog.resultErrorTitle')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentDialog2.default.ResultText },
	        t('components.appointment.appointmentDialog.resultErrorText')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentDialog2.default.ButtonsGroup },
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultButton, 'button-primary', 'button-primary--md'),
	            onClick: function onClick() {
	              (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogRejectedResultButtonClick({
	                eventLabel: 'perezapisatsya',
	                eventContent: buildingName,
	                productType: objectType,
	                productName: buildingName,
	                productID: buildingId,
	                user_id: profile.id
	              }));
	              toPrevStep();
	            }
	          },
	          t('components.appointment.appointmentDialog.resultErrorNewAppointment')
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_AppointmentDialog2.default.ResultButton, 'button-default', 'button-primary--md'),
	            onClick: function onClick() {
	              (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogRejectedResultButtonClick({
	                eventLabel: 'zakryt',
	                eventContent: buildingName,
	                productType: objectType,
	                productName: buildingName,
	                productID: buildingId,
	                user_id: profile.id
	              }));
	              dispatch((0, _environment.setPopUp)());
	            }
	          },
	          t('components.appointment.appointmentDialog.resultErrorClose')
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_AppointmentDialog2.default.Dialog, _defineProperty({}, _AppointmentDialog2.default.DialogStepOne, isStepOne)) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_AppointmentDialog2.default.Title, _defineProperty({}, _AppointmentDialog2.default.TitleStepOne, isStepOne)) },
	      !isStepOne && _react2.default.createElement(
	        'button',
	        { className: _AppointmentDialog2.default.BackButton, onClick: function onClick() {
	            return setStep(1);
	          } },
	        _react2.default.createElement('img', { src: _arrowLeft2.default, alt: 'back-icon' })
	      ),
	      isStepOne ? t('components.appointment.appointmentDialog.stepOneTitle') : t('components.appointment.appointmentDialog.stepTwoTitle')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_AppointmentDialog2.default.Content, _defineProperty({}, _AppointmentDialog2.default.ContentStepOne, isStepOne)) },
	      isStepOne ? _react2.default.createElement(_DatePicker2.default, {
	        data: activeTab === 'offline' ? offlineData && offlineData.data : onlineData && onlineData.data || [],
	        onTabChange: handleTabChange,
	        activeTab: activeTab,
	        isLoading: isLoading,
	        selectedSlot: selectedSlot,
	        onSelectSlot: handleSelectSlot
	      }) : _react2.default.createElement(_AppointmentForm2.default, {
	        selectedSlot: selectedSlot,
	        selectedDate: selectedDate,
	        buildingId: buildingId,
	        type: activeTab,
	        handleSetResult: handleSetResult,
	        buildingName: buildingName,
	        objectType: objectType
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_AppointmentDialog2.default.Footer, _defineProperty({}, _AppointmentDialog2.default.FooterStepOne, isStepOne)) },
	      isStepOne && _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(_AppointmentDialog2.default.NextButton, 'button-primary', 'button-primary--md'),
	          onClick: function onClick() {
	            handleTrackEvent({ eventLabel: 'dalee' });
	            setStep(2);
	          },
	          disabled: !selectedSlot
	        },
	        t('components.appointment.appointmentDialog.nextButton')
	      )
	    )
	  );
	};
	
	exports.default = AppointmentDialog;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentForm = __webpack_require__(1328);
	
	var _AppointmentForm2 = _interopRequireDefault(_AppointmentForm);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _appointment = __webpack_require__(159);
	
	var _ButtonSpinner = __webpack_require__(164);
	
	var _Notification = __webpack_require__(315);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var formatDateTime = function formatDateTime(dateString, timeString) {
	  var _dateString$split = dateString.split('.'),
	      _dateString$split2 = _slicedToArray(_dateString$split, 3),
	      day = _dateString$split2[0],
	      month = _dateString$split2[1],
	      year = _dateString$split2[2];
	
	  var formattedDate = year + '-' + month + '-' + day;
	
	  var date = new Date(formattedDate);
	
	  var formattedDateString = date.toLocaleDateString('ru-RU', {
	    day: 'numeric',
	    month: 'long',
	    year: 'numeric'
	  });
	
	  return formattedDateString + ', ' + timeString;
	};
	
	var AppointmentForm = function AppointmentForm(_ref) {
	  var selectedSlot = _ref.selectedSlot,
	      selectedDate = _ref.selectedDate,
	      buildingId = _ref.buildingId,
	      type = _ref.type,
	      handleSetResult = _ref.handleSetResult,
	      buildingName = _ref.buildingName,
	      objectType = _ref.objectType;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var formattedDateTime = formatDateTime(selectedDate, selectedSlot.from);
	  var profile = (0, _reactRedux.useSelector)(function (state) {
	    return state.profile;
	  });
	  var firstName = profile.firstName,
	      lastName = profile.lastName,
	      agencyName = profile.agencyName;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setIsLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    buildingId: buildingId,
	    type: type,
	    dateTimeFrom: formattedDateTime,
	    name: firstName + ' ' + lastName,
	    companyName: agencyName,
	    clientName: '',
	    clientNumber: '',
	    comment: ''
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      formValues = _useState4[0],
	      setFormValues = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    clientName: '',
	    clientNumber: ''
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      errors = _useState6[0],
	      setErrors = _useState6[1];
	
	  var validateForm = function validateForm() {
	    var newErrors = {};
	    var isValid = true;
	
	    if (!formValues.clientName.trim()) {
	      newErrors.clientName = t('components.appointment.appointmentDialog.appointmentForm.clientNameRequired');
	      isValid = false;
	    }
	
	    if (!/^\d{4}$/.test(formValues.clientNumber)) {
	      newErrors.clientNumber = t('components.appointment.appointmentDialog.appointmentForm.clientNumberRequired');
	      isValid = false;
	    }
	
	    setErrors(newErrors);
	    return isValid;
	  };
	
	  var handleInputChange = function handleInputChange(field) {
	    return function (event) {
	      var value = event.target.value;
	      var digitOnlyValue = value;
	
	      if (field === 'clientNumber') {
	        digitOnlyValue = value.replace(/\D/g, '');
	      }
	
	      setFormValues(function (prev) {
	        return _extends({}, prev, _defineProperty({}, field, digitOnlyValue));
	      });
	
	      setErrors(function (prevErrors) {
	        var updatedErrors = _extends({}, prevErrors);
	        if (field === 'clientName' && digitOnlyValue.trim().length >= 2) {
	          delete updatedErrors.clientName;
	        }
	        if (field === 'clientNumber' && /^\d{4}$/.test(digitOnlyValue)) {
	          delete updatedErrors.clientNumber;
	        }
	        return updatedErrors;
	      });
	    };
	  };
	
	  var handleSubmit = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(event) {
	      var appointmentData, result;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              event.preventDefault();
	
	              if (validateForm()) {
	                _context.next = 4;
	                break;
	              }
	
	              dispatch({
	                type: 'SHOW_NOTIFICATION',
	                payload: {
	                  message: '123',
	                  status: 1
	                }
	              });
	              return _context.abrupt('return');
	
	            case 4:
	
	              setIsLoading(true);
	
	              appointmentData = {
	                buildingId: buildingId,
	                type: type,
	                dateTimeFrom: selectedDate + ' ' + selectedSlot.from + ':00',
	                firstNameClient: formValues.clientName,
	                phoneClient: formValues.clientNumber,
	                comment: formValues.comment
	              };
	              _context.prev = 6;
	              _context.next = 9;
	              return dispatch((0, _appointment.createAppointment)(appointmentData));
	
	            case 9:
	              result = _context.sent;
	
	
	              if (result.data) {
	                handleSetResult('success');
	              } else {
	                handleSetResult('error');
	              }
	              _context.next = 16;
	              break;
	
	            case 13:
	              _context.prev = 13;
	              _context.t0 = _context['catch'](6);
	
	              console.error(_context.t0);
	
	            case 16:
	              _context.prev = 16;
	
	              setIsLoading(false);
	              return _context.finish(16);
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[6, 13, 16, 19]]);
	    }));
	
	    return function handleSubmit(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    { className: _AppointmentForm2.default.AppointmentForm },
	    _react2.default.createElement(
	      'form',
	      { className: _AppointmentForm2.default.InputGroup, onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.Title },
	        t('components.appointment.appointmentDialog.appointmentForm.generalInfo')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.InputWrap },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(_AppointmentForm2.default.Input),
	          type: 'text',
	          name: 'name',
	          value: formValues.name,
	          onChange: handleInputChange('name'),
	          disabled: true
	        })
	      ),
	      agencyName && _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.InputWrap },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(_AppointmentForm2.default.Input),
	          type: 'text',
	          name: 'companyName',
	          value: formValues.companyName,
	          onChange: handleInputChange('companyName'),
	          disabled: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.InputWrap },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(_AppointmentForm2.default.Input, _defineProperty({}, _AppointmentForm2.default.Error, !!errors.clientName)),
	          type: 'text',
	          name: 'clientName',
	          value: formValues.clientName,
	          onChange: handleInputChange('clientName'),
	          placeholder: t('components.appointment.appointmentDialog.appointmentForm.clientName') + '*',
	          maxLength: 20
	        }),
	        errors.clientName && _react2.default.createElement(
	          'label',
	          { className: _AppointmentForm2.default.ErrorLabel },
	          errors.clientName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.InputWrap },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(_AppointmentForm2.default.Input, _defineProperty({}, _AppointmentForm2.default.Error, !!errors.clientNumber)),
	          type: 'text',
	          name: 'clientNumber',
	          value: formValues.clientNumber,
	          onChange: handleInputChange('clientNumber'),
	          placeholder: t('components.appointment.appointmentDialog.appointmentForm.clientNumber') + '*',
	          maxLength: 4,
	          inputMode: 'numeric',
	          pattern: '[0-9]*'
	        }),
	        errors.clientNumber && _react2.default.createElement(
	          'label',
	          { className: _AppointmentForm2.default.ErrorLabel },
	          errors.clientNumber
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.InputWrap },
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(_AppointmentForm2.default.Input, _defineProperty({}, _AppointmentForm2.default.Touched, !!formValues.comment)),
	          type: 'text',
	          name: 'comment',
	          value: formValues.comment,
	          onChange: handleInputChange('comment'),
	          placeholder: t('components.appointment.appointmentDialog.appointmentForm.comment'),
	          maxLength: 250
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentForm2.default.SelectedDate },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentForm2.default.SelectedDateTitle },
	          t('components.appointment.appointmentDialog.appointmentForm.selectedDate')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentForm2.default.SelectedDateText },
	          formattedDateTime
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: function onClick() {
	            (0, _ga.trackGA)(_ga.gaEvent.appointmentDialogButtonsClick({
	              eventLabel: 'zapisatsya',
	              eventContent: buildingName,
	              productType: objectType,
	              productName: buildingName,
	              productID: buildingId,
	              user_id: profile.id
	            }));
	          },
	          type: 'submit',
	          className: (0, _classnames2.default)(_AppointmentForm2.default.SubmitButton, 'button-primary button-primary--md'),
	          disabled: isLoading
	        },
	        isLoading ? _react2.default.createElement(_ButtonSpinner.ButtonSpinner, null) : t('components.appointment.appointmentDialog.submitButton')
	      )
	    )
	  );
	};
	
	exports.default = AppointmentForm;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _DatePicker = __webpack_require__(1329);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ButtonSpinner = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var generateDates = function generateDates(startDate, data) {
	  var dates = [];
	  var baseDate = new Date(startDate);
	
	  for (var i = 0; i < 5; i++) {
	    var day = new Date(baseDate);
	    day.setDate(baseDate.getDate() + i);
	
	    var dayString = day.toLocaleDateString('ru-RU', {
	      day: '2-digit',
	      month: '2-digit',
	      year: 'numeric'
	    });
	    var slots = data[dayString] || [];
	
	    dates.push({
	      weekDay: day.toLocaleDateString('ru-RU', { weekday: 'short' }),
	      monthDay: day.getDate(),
	      isAvailable: slots.length > 0,
	      slots: slots.map(function (time) {
	        return {
	          from: time
	        };
	      })
	    });
	  }
	
	  return dates;
	};
	
	var DatePicker = function DatePicker(_ref) {
	  var data = _ref.data,
	      onTabChange = _ref.onTabChange,
	      activeTab = _ref.activeTab,
	      isLoading = _ref.isLoading,
	      selectedSlot = _ref.selectedSlot,
	      onSelectSlot = _ref.onSelectSlot;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var firstDateKey = data && Object.keys(data)[0];
	  var startDate = firstDateKey ? new Date(firstDateKey.split('.').reverse().join('-')) : new Date();
	
	  var dates = generateDates(startDate, data);
	
	  var _useState = (0, _react.useState)(startDate.getDate()),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeDate = _useState2[0],
	      setActiveDate = _useState2[1];
	
	  var handleChangeTab = function handleChangeTab(tab) {
	    if (tab !== activeTab) {
	      onTabChange(tab);
	      onSelectSlot();
	      setActiveDate(startDate.getDate());
	    }
	  };
	
	  var handleDateSelect = function handleDateSelect(day) {
	    setActiveDate(day.monthDay);
	    onSelectSlot();
	  };
	
	  var selectedDate = dates.find(function (date) {
	    return date.monthDay === activeDate;
	  });
	  var hasSlots = selectedDate && selectedDate.slots.length > 0;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _DatePicker2.default.DatePicker },
	    _react2.default.createElement(
	      'div',
	      { className: _DatePicker2.default.Tabs },
	      _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(_DatePicker2.default.TabButton, _defineProperty({}, _DatePicker2.default.Active, activeTab === 'offline')),
	          onClick: function onClick() {
	            return handleChangeTab('offline');
	          }
	        },
	        '\u041E\u0424\u0424\u041B\u0410\u0419\u041D'
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(_DatePicker2.default.TabButton, _defineProperty({}, _DatePicker2.default.Active, activeTab === 'online')),
	          onClick: function onClick() {
	            return handleChangeTab('online');
	          }
	        },
	        '\u041E\u041D\u041B\u0410\u0419\u041D'
	      )
	    ),
	    isLoading ? _react2.default.createElement(
	      'div',
	      { className: _DatePicker2.default.LoadingSkeleton },
	      _react2.default.createElement(_ButtonSpinner.ButtonSpinner, null)
	    ) : _react2.default.createElement(
	      'div',
	      { className: _DatePicker2.default.Calendar },
	      _react2.default.createElement(
	        'div',
	        { className: _DatePicker2.default.Dates },
	        dates.map(function (item) {
	          var _cn3;
	
	          return _react2.default.createElement(
	            'div',
	            { className: _DatePicker2.default.Date, key: item.monthDay },
	            _react2.default.createElement(
	              'div',
	              { className: _DatePicker2.default.WeekDay },
	              item.weekDay
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_DatePicker2.default.MonthDay, (_cn3 = {}, _defineProperty(_cn3, _DatePicker2.default.Available, item.isAvailable && activeDate !== item.monthDay), _defineProperty(_cn3, _DatePicker2.default.Selected, activeDate === item.monthDay), _cn3)),
	                onClick: function onClick() {
	                  return handleDateSelect(item);
	                }
	              },
	              item.monthDay
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _DatePicker2.default.Slots },
	        _react2.default.createElement(
	          'div',
	          { className: _DatePicker2.default.SlotsTitle },
	          hasSlots ? t('components.appointment.appointmentDialog.availableSlots') : _react2.default.createElement(
	            'div',
	            { className: _DatePicker2.default.NoSlots },
	            _react2.default.createElement(
	              'p',
	              { className: _DatePicker2.default.NoSlotsTitle },
	              t('components.appointment.appointmentDialog.noAvailableSlotsTitle')
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _DatePicker2.default.NoSlotsSubtitle },
	              t('components.appointment.appointmentDialog.noAvailableSlotsSubtitle')
	            )
	          )
	        ),
	        hasSlots && _react2.default.createElement(
	          'div',
	          { className: _DatePicker2.default.SlotTable },
	          selectedDate.slots.map(function (slot, index) {
	            return _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_DatePicker2.default.Slot, _defineProperty({}, _DatePicker2.default.Selected, selectedSlot && selectedSlot.from === slot.from)),
	                key: index,
	                onClick: function onClick() {
	                  var formattedDate = String(activeDate).padStart(2, '0') + '.' + String(startDate.getMonth() + 1).padStart(2, '0') + '.' + startDate.getFullYear();
	                  onSelectSlot(formattedDate, slot);
	                }
	              },
	              slot.from
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = DatePicker;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(92);
	
	var _utils = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PayForTarifBtn = __webpack_require__(214);
	
	var _PayForTarifBtn2 = _interopRequireDefault(_PayForTarifBtn);
	
	var _style = __webpack_require__(1330);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _environment = __webpack_require__(19);
	
	var _reactI18next = __webpack_require__(4);
	
	var _LeaveAgencyDialog = __webpack_require__(490);
	
	var _LeaveAgencyDialog2 = _interopRequireDefault(_LeaveAgencyDialog);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blocker = function Blocker() {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return { profile: state.profile };
	  }),
	      profile = _useSelector.profile;
	
	  var tariff = profile.tariff,
	      agencyName = profile.agencyName;
	
	  var role = (0, _utils.getUserRole)(profile);
	  var tarif = (0, _utils.getTarifPeriodName)(tariff.pricing);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleClick = function handleClick() {
	    (0, _ga.trackGA)(_ga.gaEvent.agencyNoAccessButtonsClick({
	      eventLabel: 'vyiti_iz_agentstva',
	      user_id: profile.id
	    }));
	
	    dispatch((0, _environment.setPopUp)(_react2.default.createElement(_LeaveAgencyDialog2.default, null), {
	      closeStyleName: 'Default',
	      contentStyleName: 'Default',
	      closeIcon: 'default',
	      lockScroll: false
	    }));
	  };
	
	  if (role === _constants.USER_ROLE.ADMIN) {
	    return _react2.default.createElement(
	      'div',
	      { className: _style2.default.BlockerWrap },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.Blocker },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.BlockerText, _style2.default.Wide) },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerTitle },
	            t('components.blocker.admin.title', { agencyName: agencyName })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerDescrip },
	            t('components.blocker.admin.description', { tarif: tarif })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerManager },
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:+79649450276' },
	              t('components.blocker.admin.manager.phone')
	            ),
	            t('components.blocker.admin.manager.name')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.BlockerImage },
	          _react2.default.createElement('img', { src: _nothingfound2.default, alt: '' })
	        )
	      )
	    );
	  }
	
	  if (role === _constants.USER_ROLE.WORKER) {
	    return _react2.default.createElement(
	      'div',
	      { className: _style2.default.BlockerWrap },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.Blocker },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.BlockerText, _style2.default.Wide) },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerTitle },
	            t('components.blocker.worker.title', { agencyName: agencyName })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerDescrip },
	            t('components.blocker.worker.description', { tarif: tarif, agencyName: agencyName })
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: '/logout',
	              onClick: function onClick() {
	                (0, _ga.trackGA)(_ga.gaEvent.agencyNoAccessButtonsClick({
	                  eventLabel: 'vyiti_iz_akkaunta',
	                  user_id: profile.id
	                }));
	              }
	            },
	            _react2.default.createElement(
	              'button',
	              { className: (0, _classnames2.default)(_style2.default.ButtonLogout, 'button-primary', 'button-primary--lg') },
	              t('components.profile.profileForm.logout')
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)(_style2.default.ButtonLeave, 'button-default', 'button-primary--lg'),
	              onClick: handleClick
	            },
	            t('components.profile.profileForm.leaveAgency')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.BlockerImage },
	          _react2.default.createElement('img', { src: _nothingfound2.default, alt: '' })
	        )
	      )
	    );
	  }
	
	  if (role === _constants.USER_ROLE.INDIVIDUAL) {
	    return _react2.default.createElement(
	      'div',
	      { className: _style2.default.BlockerWrap },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.Blocker },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.BlockerText },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerTitle },
	            t('components.blocker.individual.title')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.BlockerDescrip },
	            t('components.blocker.individual.description', { tarif: tarif })
	          ),
	          _react2.default.createElement(
	            _PayForTarifBtn2.default,
	            { className: _style2.default.PayForTarifBtn },
	            t('components.blocker.individual.pay')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.BlockerImage },
	          _react2.default.createElement('img', { src: _nothingfound2.default, alt: '' })
	        )
	      )
	    );
	  }
	  return null;
	};
	
	exports.default = Blocker;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Blocker = __webpack_require__(904);
	
	var _Blocker2 = _interopRequireDefault(_Blocker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Blocker2.default;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _utils = __webpack_require__(12);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _Switcher = __webpack_require__(507);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _Menu = __webpack_require__(166);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Dropdown = __webpack_require__(165);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Housing = __webpack_require__(910);
	
	var _Housing2 = _interopRequireDefault(_Housing);
	
	var _updateArrows = __webpack_require__(237);
	
	var _updateArrows2 = _interopRequireDefault(_updateArrows);
	
	var _th = __webpack_require__(659);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _thList = __webpack_require__(658);
	
	var _thList2 = _interopRequireDefault(_thList);
	
	var _iconListBlue = __webpack_require__(1546);
	
	var _iconListBlue2 = _interopRequireDefault(_iconListBlue);
	
	var _logoBlack = __webpack_require__(349);
	
	var _logoBlack2 = _interopRequireDefault(_logoBlack);
	
	var _reactI18next = __webpack_require__(4);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _BuildingBar = __webpack_require__(1331);
	
	var _BuildingBar2 = _interopRequireDefault(_BuildingBar);
	
	var _InaccuracyReport = __webpack_require__(468);
	
	var _InaccuracyReport2 = _interopRequireDefault(_InaccuracyReport);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import iconBack from 'assets/images/icons/icon-back.svg';
	
	
	var cx = _bind2.default.bind(_BuildingBar2.default);
	
	var BuildingBar = function (_Component) {
	  _inherits(BuildingBar, _Component);
	
	  function BuildingBar(props) {
	    _classCallCheck(this, BuildingBar);
	
	    var _this = _possibleConstructorReturn(this, (BuildingBar.__proto__ || Object.getPrototypeOf(BuildingBar)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel,
	          eventContent = _ref.eventContent,
	          eventContext = _ref.eventContext;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          data = _this$props.data;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || '',
	        eventContext: eventContext || '',
	        productType: objectType,
	        productName: data.title,
	        productID: data.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      onTop: true
	    };
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(BuildingBar, [{
	    key: 'supportsPassiveEventListener',
	    value: function supportsPassiveEventListener() {
	      var supportsPassiveOption = false;
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          get: function get() {
	            supportsPassiveOption = true;
	          }
	        });
	        window.addEventListener('test', null, opts);
	      } catch (e) {}
	      return supportsPassiveOption;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScroll, this.supportsPassiveEventListener() && { passive: true });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (_reactDom2.default.findDOMNode(this).scrollTop !== 0) {
	        _reactDom2.default.findDOMNode(this).scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      this.setState({ onTop: scrollTop === 0 });
	    }
	
	    // handleListSwitchClick = () => {
	    //   this.props.handleList(!this.props.isTable)
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          location = _props.location,
	          data = _props.data,
	          chessList = _props.chessList,
	          isTable = _props.isTable,
	          pavilions = _props.pavilions,
	          pavilionsFlat = _props.pavilionsFlat,
	          filters = _props.filters,
	          handleFilters = _props.handleFilters,
	          print = _props.print,
	          handleList = _props.handleList,
	          t = _props.t,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var _ref2 = data || {},
	          id = _ref2.id,
	          title = _ref2.title;
	
	      var section = ((0, _utils.parseQuery)(location.search).section || '0.0').split('.');
	      var sectionId = data && data.pavilions[section[0]].sectionIds[section[1]];
	
	      var _ref3 = chessList && chessList[sectionId] || {},
	          updated = _ref3.updated;
	
	      var isChess = !!~location.pathname.indexOf('chess');
	
	      var selectedSectionPath = filters.section;
	
	
	      var pavilion = void 0,
	          sectionCount = void 0,
	          selectedPavilion = void 0,
	          selectedSection = void 0,
	          deadline = void 0,
	          isFinished = void 0,
	          isOnlyOneSectionInSelectedPavilion = void 0;
	      if (pavilionsFlat && selectedSectionPath) {
	        var selectedPavilionId = selectedSectionPath[0];
	        selectedPavilion = pavilionsFlat[selectedPavilionId];
	        isOnlyOneSectionInSelectedPavilion = selectedPavilion.sections.length === 1;
	
	        var selectedSectionId = selectedSectionPath[1];
	        selectedSection = selectedPavilion.sections[selectedSectionId];
	
	        pavilion = pavilions.find(function (pavilion) {
	          return pavilion.id === selectedPavilion.id;
	        });
	        var _pavilion = pavilion,
	            finished = _pavilion.construction_finished,
	            year = _pavilion.year_built,
	            quarter = _pavilion.construction_ending;
	
	
	        deadline = finished ? t('components.building.bar.finished') : year !== 0 ? quarter ? quarter + ' / ' + year : year : t('components.building.bar.inProcess');
	        isFinished = finished;
	
	        sectionCount = pavilionsFlat.reduce(function (prev, cur) {
	          return prev + cur.sections.length;
	        }, 0);
	      }
	
	      var updateTime = void 0;
	      if (updated) {
	        if (print) {
	          updateTime = (0, _utils.updateStringPrint)(updated);
	        } else if ((0, _utils.updateString)(updated, print).indexOf('Сегодня') == 0) {
	          updateTime = t('components.building.bar.today');
	        } else {
	          updateTime = (0, _utils.updateString)(updated);
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cx(_BuildingBar2.default.Toolbar, className, _defineProperty({}, _BuildingBar2.default.ToolbarPrint, print), { ToolbarOnTop: this.state.onTop, ToolbarChess: isChess })
	        },
	        data && pavilionsFlat ? _react2.default.createElement(
	          'div',
	          { className: !isChess ? _BuildingBar2.default.Inner : (0, _bind2.default)(_BuildingBar2.default.Inner, _BuildingBar2.default.Wide) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _bind2.default)(_BuildingBar2.default.Left, _BuildingBar2.default.Title) },
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingBar2.default.DropdownWrap },
	              selectedSectionPath ? _react2.default.createElement(
	                'div',
	                { className: _BuildingBar2.default.DropdownContent },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _bind2.default)(_BuildingBar2.default.HousingInfo) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _BuildingBar2.default.HousingName },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.bar.pavilion') + ' ' + selectedPavilion.name + (isOnlyOneSectionInSelectedPavilion ? '' : ', ' + t('components.building.bar.section') + ' ' + selectedSection.name)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    {
	                      className: (0, _bind2.default)(isFinished ? _BuildingBar2.default.Green : _BuildingBar2.default.Yellow, _BuildingBar2.default.StatusBlock)
	                    },
	                    deadline
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: _BuildingBar2.default.ObjectName },
	                  title,
	                  print ? ', ' + data.address : null
	                )
	              ) : null,
	              sectionCount > 1 ? _react2.default.createElement(
	                _Dropdown2.default,
	                {
	                  leftShift: true,
	                  text: '',
	                  iconStyle: _BuildingBar2.default.DropdownIcon,
	                  chessfilter: 'Housing',
	                  buttonStyle: _BuildingBar2.default.DropdownButton,
	                  openByClick: true,
	                  onClick: function onClick() {
	                    return _this2.handleTrackEvent({
	                      eventName: 'buildingChessDropdownClick',
	                      eventLabel: 'vybor_korpusa',
	                      eventContext: 'shahmatka'
	                    });
	                  }
	                },
	                _react2.default.createElement(
	                  _Menu2.default,
	                  { leftArrow: true, pure: true, maxHeight: 'calc(100vh - 295px)' },
	                  _react2.default.createElement(_Housing2.default, {
	                    pavilions: pavilions,
	                    pavilionsFlat: pavilionsFlat,
	                    selectedSectionPath: selectedSectionPath,
	                    handleFilters: handleFilters,
	                    data: data,
	                    profile: profile,
	                    objectType: objectType
	                  })
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingBar2.default.Right },
	            updated ? _react2.default.createElement(
	              'div',
	              {
	                className: _BuildingBar2.default.UpdateTime,
	                'data-tip': t('components.building.bar.dateUpdated'),
	                'data-for': 'global'
	              },
	              print ? t('components.building.bar.dateFrom') : _react2.default.createElement('img', { alt: 'icon', src: _updateArrows2.default }),
	              _react2.default.createElement('span', { className: _BuildingBar2.default.TabletHidden }),
	              _react2.default.createElement(
	                'span',
	                { className: (0, _bind2.default)(_BuildingBar2.default.Time, _defineProperty({}, _BuildingBar2.default.Print, print)) },
	                updateTime
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingBar2.default.InaccuracyReportButtonWrap },
	              _react2.default.createElement(_InaccuracyReport2.default, {
	                building: data,
	                className: _BuildingBar2.default.InaccuracyReportWrap,
	                profile: profile,
	                objectType: objectType
	              })
	            ),
	            data.type_id != 2 && _react2.default.createElement(
	              'div',
	              { className: (0, _bind2.default)(_BuildingBar2.default.SwitcherInner) },
	              _react2.default.createElement(_Switcher2.default, {
	                defaultChecked: isTable,
	                events: {
	                  left: 'Web_List_Checkerboard',
	                  right: 'Web_List_Premises'
	                },
	                eventData: {
	                  id: id,
	                  name: title
	                },
	                gaEventName: 'buildingChessSwitcherClick',
	                gaEventData: {
	                  left: 'shahmatka',
	                  right: 'spisok'
	                },
	                profile: profile,
	                objectType: objectType,
	                buildingData: data,
	                rightText: t('components.building.bar.list'),
	                rightUrl: '/',
	                leftText: t('components.building.bar.chess'),
	                leftUrl: location.pathname + '/chess',
	                leftIcon: _react2.default.createElement(_th2.default, null),
	                rightIcon: _react2.default.createElement(_thList2.default, null),
	                leftTooltip: t('components.building.bar.listTooltip'),
	                rightTooltip: t('components.building.bar.chessTooltip'),
	                elementStyle: 'Round',
	                onClick: handleList,
	                className: _BuildingBar2.default.SwitcherButtons,
	                enabledStyle: _BuildingBar2.default.SwitcherEnabled,
	                enabledStyleChecked: _BuildingBar2.default.SwitcherEnabledChecked,
	                enabledStyleNotChecked: _BuildingBar2.default.SwitcherEnabledNotChecked,
	                textStyle: _BuildingBar2.default.SwitcherText
	              })
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                onClick: function onClick() {
	                  return _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    eventLabel: 'informaciya_o_zhk',
	                    eventContent: title
	                  });
	                },
	                to: '' + location.pathname.replace('/chess', ''),
	                className: (0, _bind2.default)(_BuildingBar2.default.ToInfoBtn, 'button-primary', 'button-primary--lg')
	              },
	              data.type_id === 2 ? t('components.building.bar.infoAboutKP') : t('components.building.bar.infoAboutJK')
	            )
	          ),
	          print ? _react2.default.createElement('img', { src: _logoBlack2.default, alt: '', className: _BuildingBar2.default.LogoPrint }) : null
	        ) : _react2.default.createElement(
	          'div',
	          { className: _BuildingBar2.default.WireframeToolbar },
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingBar2.default.WireframeTitle },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement('span', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return BuildingBar;
	}(_react.Component);
	
	var buildingDataSelector = function buildingDataSelector(state) {
	  return state.building.data;
	};
	var chessListSelector = function chessListSelector(state) {
	  return state.building.chessList;
	};
	
	var buildingBarSelector = (0, _reselect.createSelector)(buildingDataSelector, chessListSelector, function (buildingData, chessList) {
	  return {
	    data: buildingData,
	    chessList: chessList
	  };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(buildingBarSelector)(BuildingBar));

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BuildingBar = __webpack_require__(906);
	
	var _BuildingBar2 = _interopRequireDefault(_BuildingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BuildingBar2.default;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _lodash = __webpack_require__(355);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Filters = __webpack_require__(308);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _BuildingBar = __webpack_require__(907);
	
	var _BuildingBar2 = _interopRequireDefault(_BuildingBar);
	
	var _TableOptions = __webpack_require__(919);
	
	var _TableOptions2 = _interopRequireDefault(_TableOptions);
	
	var _RightMenu = __webpack_require__(915);
	
	var _RightMenu2 = _interopRequireDefault(_RightMenu);
	
	var _Table = __webpack_require__(917);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _List = __webpack_require__(912);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Loader = __webpack_require__(503);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _utils = __webpack_require__(12);
	
	var _apartments = __webpack_require__(219);
	
	var _apartments2 = _interopRequireDefault(_apartments);
	
	var _interiors = __webpack_require__(321);
	
	var _interiors2 = _interopRequireDefault(_interiors);
	
	var _arrowRightGray = __webpack_require__(1523);
	
	var _arrowRightGray2 = _interopRequireDefault(_arrowRightGray);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Chess = __webpack_require__(1332);
	
	var _Chess2 = _interopRequireDefault(_Chess);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _building = __webpack_require__(54);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(93);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import iconClock from 'assets/images/icons/icon-clock.svg';
	
	
	var MIN_SCALE = 0.5;
	var MAX_SCALE = 2;
	
	var Chess = function (_Component) {
	  _inherits(Chess, _Component);
	
	  function Chess(props) {
	    _classCallCheck(this, Chess);
	
	    var _this = _possibleConstructorReturn(this, (Chess.__proto__ || Object.getPrototypeOf(Chess)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventContent = _ref.eventContent;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building,
	          isTable = _this$props.isTable;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        eventContext: isTable ? 'shahmatka' : 'spisok',
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.handleCellClick = function (id, selected) {
	      var cell = selected.join('.');
	      _this.transitionTo({ cell: cell });
	    };
	
	    _this.handleFloorClick = function (selected) {
	      _this.handleCellClick(null, selected);
	    };
	
	    _this.zoomIn = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingChessFiltersClick',
	        eventContent: 'uvelichit'
	      });
	
	      _this.props.setZoom({ zoom: 1 });
	    };
	
	    _this.zoomOut = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingChessFiltersClick',
	        eventContent: 'umenshit'
	      });
	
	      _this.props.setZoom({ zoom: -1 });
	    };
	
	    _this.handleZoomChange = function (e) {
	      _this.props.setZoom({
	        zoomWithRange: true,
	        zoom: +e.target.value
	      });
	    };
	
	    _this.handleZoomMouseDown = function (e) {
	      e.stopPropagation();
	    };
	
	    _this.state = {
	      isSidebarHidden: false
	    };
	
	    _this.handleListClick = _this.handleListClick.bind(_this);
	    _this.handleExtendedClick = _this.handleExtendedClick.bind(_this);
	    _this.handleListSort = _this.handleListSort.bind(_this);
	    _this.handleToggleClick = _this.handleToggleClick.bind(_this);
	    _this.handleFilters = _this.handleFilters.bind(_this);
	    _this.handleTableScroll = _this.handleTableScroll.bind(_this);
	    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
	    _this.filteredIntersection = null;
	    return _this;
	  }
	
	  _createClass(Chess, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var _props = this.props,
	          pavilions = _props.building.pavilions,
	          updateChessState = _props.updateChessState,
	          location = _props.location;
	      var search = this.props.search;
	
	
	      var params = this.parseQuery(location.search);
	
	      var fromBuilding = params.fromBuilding,
	          restParams = _objectWithoutProperties(params, ['fromBuilding']);
	
	      if (search && search.request) {
	        var savedFilters = {
	          minPrice: search.request.minPrice || null,
	          maxPrice: search.request.maxPrice || null,
	          minCost: search.request.minCost || null,
	          maxCost: search.request.maxCost || null,
	          areaFrom: search.request.areaFrom || null,
	          areaTo: search.request.areaTo || null
	        };
	
	        this.transitionTo(savedFilters);
	
	        if (fromBuilding) {
	          updateChessState(Object.assign({}, restParams, savedFilters));
	        } else {
	          updateChessState(Object.assign({}, savedFilters, restParams));
	        }
	      } else {
	        updateChessState(restParams);
	      }
	
	      if (!pavilions) {
	        var _props2 = this.props,
	            _loadPavilions = _props2.loadPavilions,
	            match = _props2.match;
	
	        _loadPavilions(match.params.id);
	      }
	      if (!this.props.print) {
	        document.body.classList.toggle('chess', true);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.prepareChess(this.props, true);
	
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'prepareChess',
	    value: function prepareChess(props) {
	      var _this2 = this;
	
	      var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!props.building.isLoading || !props.isObjectsFetching) {
	        var location = props.location;
	        var prevLocation = this.props.location;
	
	        if (location !== prevLocation) {
	          var _updateChessState = this.props.updateChessState;
	
	          var params = this.parseQuery(location.search);
	          _updateChessState(params);
	          return;
	        }
	
	        var pavilions = props.building.pavilions;
	
	
	        if (pavilions) {
	          var _props$building = props.building,
	              chessList = _props$building.chessList,
	              cells = _props$building.cells,
	              selectedSectionPath = _props$building.filters.section;
	
	          var selectedSectionKey = selectedSectionPath.join('.');
	
	          var _selectedSectionPath = _slicedToArray(selectedSectionPath, 2),
	              pavilionId = _selectedSectionPath[0],
	              sectionId = _selectedSectionPath[1];
	
	          var selectedSectionId = pavilions[pavilionId].sections[sectionId].id;
	          var chess = chessList[selectedSectionId];
	          var filtersChanged = JSON.stringify(this.props.building.filters) !== JSON.stringify(props.building.filters);
	          // if ( !chess || filtersChanged || this.props.print) {
	          var isChessLoading = props.building.isChessLoading;
	
	          if (!isChessLoading || filtersChanged || this.props.print) {
	            var _loadChess = props.loadChess;
	
	            var updateCells = function updateCells(resp) {
	              var setCells = props.setCells;
	              var _resp$data$data = resp.data.data,
	                  rows = _resp$data$data.rows,
	                  cols = _resp$data$data.cols,
	                  cells = _resp$data$data.cells;
	
	              rows = rows || [];cols = cols || [];cells = cells || [];
	
	              var _getData = _this2.getData(rows, cols, cells),
	                  data = _getData.data,
	                  selected = _getData.selected;
	
	              setCells(selectedSectionKey, data, selected);
	            };
	
	            var filteredIntersection = null;
	            // FIXME: убрать это и вынести отсюда
	            if (chess) {
	              var interiorsInHouse = chess.cells.reduce(function (list, cell) {
	                if (cell.data.status === 'saleStatus' || (0, _helper.isReserved)(cell.data.status) || cell.data.status === 'assignmentStatus') {
	                  return list.includes(cell.data.interior) ? list : [cell.data.interior].concat(_toConsumableArray(list));
	                }
	                return list;
	              }, []);
	              var splitedInterior = props.building.filters.interior && props.building.filters.interior.length ? props.building.filters.interior.split(',') : [];
	              var interiorIntersection = (0, _lodash2.default)(interiorsInHouse, splitedInterior);
	              filteredIntersection = interiorIntersection.length ? interiorIntersection.join(',') : null;
	            }
	
	            if (initial || !chess || filtersChanged || this.filteredIntersection !== filteredIntersection) {
	              this.filteredIntersection = filteredIntersection;
	
	              _loadChess({
	                id: selectedSectionId,
	                costMin: props.building.filters.costMin,
	                costMax: props.building.filters.costMax,
	                priceMin: props.building.filters.priceMin,
	                priceMax: props.building.filters.priceMax,
	                areaFrom: props.building.filters.areaFrom,
	                areaTo: props.building.filters.areaTo,
	                stock: filteredIntersection,
	                view_type: props.building.filters.view_type
	                // `[${
	                //   (props.building.filters.interior||[]).split(',').map(a => '"a"').join(',')
	                // }]`,
	              }).then(updateCells);
	            }
	          }
	          // }
	          // else if ( ! cells[selectedSectionKey]) {
	          //
	          // }
	        }
	      }
	    }
	
	    // shouldComponentUpdate(nextProps) {
	    //   return !nextProps.building.isChessLoading
	    // }
	
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      this.prepareChess(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props3 = this.props,
	          setPrevLocation = _props3.setPrevLocation,
	          location = _props3.location;
	
	      setPrevLocation(location.search);
	
	      document.body.classList.remove('chess');
	    }
	  }, {
	    key: 'parseQuery',
	    value: function parseQuery(query) {
	      if (this.props.print) {
	        return this.props.queryParams || {};
	      }
	
	      var _parseQuery2 = (0, _utils.parseQuery)(query),
	          section = _parseQuery2.section,
	          table = _parseQuery2.table,
	          sort = _parseQuery2.sort,
	          cell = _parseQuery2.cell,
	          priceMin = _parseQuery2.priceMin,
	          priceMax = _parseQuery2.priceMax,
	          costMin = _parseQuery2.costMin,
	          costMax = _parseQuery2.costMax,
	          areaFrom = _parseQuery2.areaFrom,
	          areaTo = _parseQuery2.areaTo,
	          interior = _parseQuery2.interior,
	          view_type = _parseQuery2.view_type;
	
	      var selectedSectionKey = section || null;
	      var selectedSectionPath = selectedSectionKey ? selectedSectionKey.split('.').map(function (value) {
	        return Number(value);
	      }) : null;
	      var isTable = void 0,
	          isExtended = void 0;
	      switch (table) {
	        case 'common':
	          isTable = true;isExtended = false;break;
	        case 'extended':
	          isTable = true;isExtended = true;break;
	        case 'list':
	          isTable = false;isExtended = false;break;
	        default:
	          isTable = null;isExtended = null;
	      }
	      var listSortPath = null;
	      if (sort) {
	        var _sort$split = sort.split(':'),
	            _sort$split2 = _slicedToArray(_sort$split, 2),
	            column = _sort$split2[0],
	            direction = _sort$split2[1];
	
	        listSortPath = [column, direction !== 'desc'];
	      }
	      var selectedCelllPath = cell ? cell.split('.').map(function (value) {
	        return Number(value);
	      }) : null;
	
	      var _props$building2 = this.props.building,
	          prevIsTable = _props$building2.isTable,
	          prevIsExtended = _props$building2.isExtended,
	          prevSelected = _props$building2.selected,
	          prevFilters = _props$building2.filters,
	          prevSelectedSectionPath = _props$building2.filters.section,
	          prevListSort = _props$building2.listSort;
	
	      var prevSelectedSectionKey = prevSelectedSectionPath.join('.');
	
	      return {
	        isTable: this.props.client ? false : isTable != null ? isTable : prevIsTable,
	        isExtended: isExtended != null ? isExtended : prevIsExtended,
	        selected: selectedCelllPath != null ? _extends({}, prevSelected, _defineProperty({}, selectedSectionKey != null ? selectedSectionKey : prevSelectedSectionKey, selectedCelllPath)) : prevSelected,
	        filters: _extends({}, prevFilters, {
	          section: selectedSectionPath != null ? selectedSectionPath : prevSelectedSectionPath,
	          priceMin: priceMin,
	          priceMax: priceMax,
	          costMin: costMin,
	          costMax: costMax,
	          areaFrom: areaFrom,
	          areaTo: areaTo,
	          interior: interior,
	          view_type: view_type
	        }),
	        listSort: listSortPath != null ? listSortPath : prevListSort
	      };
	    }
	  }, {
	    key: 'transitionTo',
	    value: function transitionTo(queryParams) {
	      var _props4 = this.props,
	          history = _props4.history,
	          location = _props4.location;
	
	      var path = this.getPath(queryParams);
	
	      var _path$split = path.split('?'),
	          _path$split2 = _slicedToArray(_path$split, 2),
	          search = _path$split2[1];
	
	      if (location.search && location.search.length > 1 && location.search.slice(1) === search) {
	        return;
	      }
	
	      history.push(path);
	    }
	  }, {
	    key: 'getPath',
	    value: function getPath(queryParams) {
	      var _props5 = this.props,
	          match = _props5.match,
	          client = _props5.client,
	          print = _props5.print,
	          location = _props5.location;
	      var params = match.params;
	
	      var query = (0, _utils.compileQuery)(queryParams, location.search);
	      var search = query ? '?' + query : '';
	      if (client) {
	        return '/view/' + params.referal + '/building/' + params.id + search;
	      }
	      if (print) {
	        return '/print/' + params.id + search;
	      }
	      return '/building/' + params.id + '/chess' + search;
	    }
	  }, {
	    key: 'getData',
	    value: function getData(rows, cols, cells) {
	      var _this3 = this;
	
	      var rowLength = rows.length;
	      var colLength = cols.reduce(function (prev, cur) {
	        return prev + (Number(cur.colspan) || 1);
	      }, 0);
	      var data = Array(rowLength).fill(null).map(function () {
	        return { cells: Array(colLength) };
	      });
	
	      var selected = void 0,
	          imagelessSelected = void 0,
	          soldSelected = void 0;
	
	      cells.forEach(function (cell, index) {
	        var row = cell.row,
	            col = cell.col,
	            rowspan = cell.rowspan,
	            colspan = cell.colspan;
	
	
	        row = Number(row);
	        col = Number(col);
	
	        if (row > rowLength - 1 || col > colLength - 1) {
	          throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u0441\u044B\u043B\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 row \u0438\u043B\u0438 col');
	          // return;
	        }
	        if (data[row].cells[col] !== undefined) {
	          return;
	        }
	
	        colspan = !colspan || colspan === '0' ? 1 : Number(colspan);
	        rowspan = !rowspan || rowspan === '0' ? 1 : Number(rowspan);
	
	        if (rowspan > 1 || colspan > 1) {
	          for (var rowKey = row; rowKey < row + rowspan; ++rowKey) {
	            if (rowKey > rowLength - 1) {
	              throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u0438 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u0437\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0442\u0430\u0431\u043B\u0438\u0446\u044B');
	            }
	            for (var colKey = col; colKey < col + colspan; ++colKey) {
	              if (colKey > colLength - 1) {
	                throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0448\u0438\u0440\u043E\u043A\u0430\u044F \u0438 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u0437\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0442\u0430\u0431\u043B\u0438\u0446\u044B');
	              }
	              data[rowKey].cells[colKey] = null;
	            }
	          }
	        }
	
	        if (cell.data.disabled) {
	          data[row].cells[col] = null;
	          return;
	        }
	
	        var floorName = rows[cell.row].name;
	        var interiorName = _interiors2.default[cell.data.interior];
	        var apartmentsName = _apartments2.default[cell.data.cnt_apart];
	        var priceFormatted = (0, _utils.formatNumber)(cell.data.priceM);
	        var costFormatted = (0, _utils.formatNumber)(cell.data.priceAll);
	        var hidden = ['soldStatus', '0'].includes(cell.data.status) || !cell.data.area && !['fundStatus'].includes(cell.data.status);
	
	        var room = _extends({}, cell, {
	          data: _extends({}, cell.data, { interiorName: interiorName, floorName: floorName, apartmentsName: apartmentsName, priceFormatted: priceFormatted, costFormatted: costFormatted }),
	          row: row,
	          col: col,
	          rowspan: rowspan,
	          colspan: colspan,
	          hidden: hidden
	        });
	        room.content = {
	          common: hidden ? null : _this3.getCellContent(room),
	          extended: hidden ? null : _this3.getCellExtendedContent(room)
	        };
	
	        data[row].cells[col] = room;
	
	        if (!selected) {
	          if (room.planId && !room.hidden) {
	            selected = [row, col];
	          } else if (!imagelessSelected) {
	            if (!room.hidden) {
	              imagelessSelected = [row, col];
	            } else if (!soldSelected) {
	              soldSelected = [row, col];
	            }
	          }
	        }
	      });
	
	      return { data: data, selected: selected || imagelessSelected || soldSelected || null };
	    }
	  }, {
	    key: 'getCellContent',
	    value: function getCellContent(room) {
	      return room.data.area;
	    }
	  }, {
	    key: 'getCellExtendedContent',
	    value: function getCellExtendedContent(room) {
	      var reservation = (0, _helper.isReserved)(room.data.status);
	      if (this.props.print) {
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Chess2.default.ExtendedContent, _defineProperty({}, _Chess2.default.Reservation, reservation), _Chess2.default.ExtendedContentPrint) },
	          _react2.default.createElement(
	            'div',
	            { className: _Chess2.default.ExtendedContentLeft },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: _Chess2.default.PrintExtendedEmptySpan },
	                room.data.number
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                room.data.area
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Chess2.default.ExtendedContentRight },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                room.data.costFormatted
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                room.data.priceFormatted
	              )
	            )
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Chess2.default.ExtendedContent, _defineProperty({}, _Chess2.default.Reservation, reservation), _defineProperty({}, _Chess2.default.NotMatch, !room.mark)) },
	        _react2.default.createElement(
	          'div',
	          { className: _Chess2.default.ExtendedContentLeft },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _Chess2.default.ExtendedFlatNum },
	              '\u2116' + room.data.number
	            )
	          ),
	          room.data.apartmentsName ? _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              room.data.apartmentsName
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Chess2.default.ExtendedContentRight },
	          room.data.costFormatted && room.data.costFormatted == 0 ? null : _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _Chess2.default.ExtendedFlatPrice },
	              room.data.costFormatted
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              room.data.area,
	              room.data.priceFormatted == 0 ? null : _react2.default.createElement(
	                'span',
	                { className: _Chess2.default.Span },
	                ', ',
	                room.data.priceFormatted
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleFilters',
	    value: function handleFilters() {
	      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var selected = this.props.building.selected;
	      var selectedSectionPath = update.section,
	          prevSection = update.prevSection;
	
	      if (selectedSectionPath) {
	        var selectedSectionKey = selectedSectionPath.join('.');
	        var selectedCellPath = selected[selectedSectionKey];
	        var selectedCellKey = selectedCellPath ? selectedCellPath.join('.') : null;
	        this.prevSection = prevSection;
	        this.transitionTo({ section: selectedSectionKey, cell: selectedCellKey });
	      }
	    }
	  }, {
	    key: 'handleListClick',
	    value: function handleListClick(isTable) {
	      var table = void 0,
	          sort = null;
	      if (isTable) {
	        var isExtended = this.props.building.isExtended;
	
	        table = isExtended ? 'extended' : 'common';
	      } else {
	        var listSort = this.props.building.listSort;
	
	        table = 'list';
	        sort = [listSort[0], listSort[1] ? 'asc' : 'desc'].join(':');
	      }
	      this.transitionTo({ table: table, sort: sort });
	    }
	  }, {
	    key: 'handleExtendedClick',
	    value: function handleExtendedClick() {
	      var _props$building3 = this.props.building,
	          isExtended = _props$building3.isExtended,
	          data = _props$building3.data;
	
	      var table = isExtended ? 'common' : 'extended';
	
	      var _props$building$data = this.props.building.data,
	          id = _props$building$data.id,
	          title = _props$building$data.title;
	
	
	      _tracker2.default.sendEvent('Web_List_Filters_Extended_Activation', {
	        id: id,
	        name: title,
	        selected: !isExtended
	      });
	
	      this.handleTrackEvent({
	        eventName: 'buildingChessFiltersClick',
	        eventContent: 'rasshirennaya_shahmatka'
	      });
	
	      this.transitionTo({ table: table });
	    }
	  }, {
	    key: 'handleToggleClick',
	    value: function handleToggleClick() {
	      // TODO: Доделать если вернут возможность крывать/показывать правую сторону
	    }
	  }, {
	    key: 'handleListSort',
	    value: function handleListSort(col, dir) {
	      var sort = [col, dir ? 'asc' : 'desc'].join(':');
	      this.transitionTo({ sort: sort });
	    }
	  }, {
	    key: 'handleTableScroll',
	    value: function handleTableScroll(id, scrollTop, scrollLeft) {
	      var setTableScroll = this.props.setTableScroll;
	
	      setTableScroll(id, [scrollTop, scrollLeft]);
	    }
	  }, {
	    key: 'toggleSidebar',
	    value: function toggleSidebar() {
	      this.setState({ isSidebarHidden: !this.state.isSidebarHidden });
	    }
	
	    // zoom = (zoomIn, zoomFactor) => {
	    //   const newScale = this.props.zoom * (zoomIn ? zoomFactor : (1 / zoomFactor))
	    //
	    //   this.props.setZoom({
	    //     zoom: Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale))
	    //   })
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _React$createElement;
	
	      var _props6 = this.props,
	          client = _props6.client,
	          location = _props6.location,
	          page = _props6.page,
	          pageSize = _props6.pageSize,
	          isObjectsFetching = _props6.isObjectsFetching,
	          isBuildingLoading = _props6.isBuildingLoading,
	          _props6$building = _props6.building,
	          building = _props6$building.data,
	          pavilionsFlat = _props6$building.pavilions,
	          chessList = _props6$building.chessList,
	          filters = _props6$building.filters,
	          cells = _props6$building.cells,
	          selected = _props6$building.selected,
	          isTable = _props6$building.isTable,
	          isExtended = _props6$building.isExtended,
	          listSort = _props6$building.listSort,
	          tableScroll = _props6$building.tableScroll,
	          isDescriptionHide = _props6$building.isDescriptionHide,
	          isLoading = _props6$building.isLoading,
	          isChessLoading = _props6$building.isChessLoading,
	          zoom = _props6.zoom,
	          setZoom = _props6.setZoom,
	          t = _props6.t,
	          currency = _props6.currency,
	          profile = _props6.profile,
	          objectType = _props6.objectType;
	
	
	      if (isObjectsFetching || isLoading || isBuildingLoading) return null;
	
	      var isSidebarHidden = this.state.isSidebarHidden;
	      var selectedSectionPath = filters.section;
	
	      var sectionCells = null;
	      var chess = null;
	      var sectionId = void 0;
	      var selectedSectionKey = void 0;
	      var selectedCellPath = void 0;
	      var selectedCell = void 0;
	      var scrollKey = void 0;
	      var defaultScroll = [0, 0];
	      var sortKey = void 0;
	
	      if (building && pavilionsFlat) {
	        selectedSectionKey = selectedSectionPath.join('.');
	        selectedSectionKey = cells[selectedSectionKey] || !this.prevSection ? selectedSectionKey : this.prevSection.join('.');
	        sectionCells = cells[selectedSectionKey];
	
	        if (sectionCells) {
	          var _ref2 = cells[selectedSectionPath.join('.')] ? selectedSectionPath : this.prevSection,
	              _ref3 = _slicedToArray(_ref2, 2),
	              pavilionIndex = _ref3[0],
	              sectionIndex = _ref3[1];
	
	          sectionId = pavilionsFlat[pavilionIndex].sections[sectionIndex].id;
	          var chessRaw = chessList[sectionId];
	          var cols = chessRaw.cols.reduce(function (prev, cur) {
	            var colspan = cur.colspan;
	
	            colspan = Number(colspan) || 1;
	            var cols = Array(colspan).fill(null);
	            cols[0] = cur;
	            return prev.concat(cols);
	          }, []);
	          chess = _extends({}, chessRaw, { cols: cols });
	          selectedCellPath = selected[selectedSectionKey];
	
	          var _selectedCellPath = selectedCellPath,
	              _selectedCellPath2 = _slicedToArray(_selectedCellPath, 2),
	              row = _selectedCellPath2[0],
	              column = _selectedCellPath2[1];
	
	          selectedCell = selectedCellPath ? sectionCells[row].cells[column] : null;
	          scrollKey = [pavilionIndex, sectionIndex, isTable, isTable ? isExtended : null].filter(function (value) {
	            return value != null;
	          }).join('.');
	          sortKey = listSort.join('.');
	          defaultScroll = tableScroll[scrollKey] || [0, 0];
	          this.dataFlats = this.dataFlats !== undefined ? this.dataFlats : building.count_flats;
	        }
	      }
	      var print = this.props.print;
	
	      var isDataFlatsExists = this.dataFlats !== undefined ? !!this.dataFlats : !isChessLoading && !!this.dataFlats;
	      var id = building.id,
	          title = building.title;
	
	
	      return building ? _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            t('components.building.chess.title', { building: building.title })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Chess2.default.Building, _defineProperty({}, _Chess2.default.BuildingPrint, print)) },
	          _react2.default.createElement('div', { className: _Chess2.default.LandscapeOverlay }),
	          !client && _react2.default.createElement(_BuildingBar2.default, {
	            className: _Chess2.default.BuildingBar,
	            location: location,
	            isTable: isTable,
	            print: print,
	            handleList: this.handleListClick,
	            pavilions: building.pavilions,
	            pavilionsFlat: pavilionsFlat,
	            filters: filters,
	            handleFilters: this.handleFilters,
	            profile: profile,
	            buildingData: building,
	            objectType: objectType
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(client ? _Chess2.default.ContainerClient : _Chess2.default.Container, _defineProperty({}, _Chess2.default.DescriptionHide, isDescriptionHide)) },
	            _react2.default.createElement(_Loader2.default, { active: isLoading || isChessLoading }),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Chess2.default.TableWrap, _defineProperty({}, _Chess2.default.Wide, isSidebarHidden)) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Chess2.default.FiltersBarWrap, _defineProperty({}, _Chess2.default.Client, client)) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_Chess2.default.FiltersBar, _defineProperty({}, _Chess2.default.Client, client)) },
	                  sectionCells ? _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)(_Chess2.default.Filters, _Chess2.default.FiltersBBB) },
	                    _react2.default.createElement(_Filters2.default, {
	                      pavilions: building.pavilions,
	                      pavilionsFlat: pavilionsFlat,
	                      filters: filters,
	                      print: print,
	                      handleFilters: this.handleFilters,
	                      search: filters,
	                      cells: chess.cells,
	                      eventData: {
	                        id: id,
	                        name: title
	                      },
	                      currency: currency,
	                      profile: profile,
	                      buildingData: building,
	                      objectType: objectType,
	                      isTable: isTable
	                    })
	                  ) : _react2.default.createElement('div', { className: _Chess2.default.WireframeFilters }),
	                  sectionCells ? _react2.default.createElement(_TableOptions2.default, {
	                    className: (0, _classnames2.default)(_Chess2.default.TableOptions, _defineProperty({}, _Chess2.default.Client, client)),
	                    isTable: isTable,
	                    isExtended: isExtended,
	                    handleList: this.handleListClick,
	                    handleExtended: this.handleExtendedClick,
	                    client: client
	                  }) : _react2.default.createElement(
	                    'div',
	                    { className: _Chess2.default.WireframeTableOptions },
	                    _react2.default.createElement('div', { className: _Chess2.default.WireframeTableOptionsCheck })
	                  ),
	                  sectionCells && isTable ? _react2.default.createElement(
	                    'div',
	                    { className: _Chess2.default.ZoomButtons },
	                    _react2.default.createElement('div', { onClick: this.zoomOut, className: (0, _classnames2.default)(_Chess2.default.ZoomBtn, _Chess2.default.ZoomOut) }),
	                    _react2.default.createElement('input', { type: 'range', step: 0.25, value: zoom, min: MIN_SCALE, max: MAX_SCALE, onChange: this.handleZoomChange, onMouseDown: this.handleZoomMouseDown }),
	                    _react2.default.createElement('div', { onClick: this.zoomIn, className: (0, _classnames2.default)(_Chess2.default.ZoomBtn, _Chess2.default.ZoomIn) })
	                  ) : null
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Chess2.default.Table },
	                sectionCells ? isTable ? _react2.default.createElement(_Table2.default, {
	                  cells: chess.cells,
	                  print: print,
	                  client: client,
	                  key: scrollKey,
	                  cols: chess.cols || [],
	                  rows: chess.rows || [],
	                  page: page || 0,
	                  pageSize: pageSize || Number.MAX_SAFE_INTEGER,
	                  data: sectionCells,
	                  selected: selectedCellPath,
	                  building: building,
	                  content: isExtended ? 'extended' : 'common',
	                  wide: isExtended,
	                  zoom: zoom,
	                  setZoom: setZoom,
	                  defaultScroll: defaultScroll,
	                  handleCellClick: this.handleCellClick.bind(undefined, selectedSectionKey),
	                  handleScroll: this.handleTableScroll.bind(undefined, scrollKey),
	                  objectType: objectType,
	                  profile: profile
	                }) : _react2.default.createElement(_List2.default, {
	                  typeId: building.type_id,
	                  cells: chess.cells,
	                  client: client,
	                  key: scrollKey + sortKey,
	                  data: sectionCells,
	                  selected: selectedCellPath,
	                  sortColumn: listSort,
	                  defaultScroll: defaultScroll,
	                  handleCellClick: this.handleCellClick.bind(undefined, selectedSectionKey),
	                  handleSort: this.handleListSort,
	                  handleScroll: this.handleTableScroll.bind(undefined, scrollKey),
	                  isSidebarHidden: isSidebarHidden,
	                  isDataFlatsExists: isDataFlatsExists,
	                  isChessLoading: isChessLoading,
	                  objectType: objectType,
	                  profile: profile,
	                  building: building,
	                  pavilions: building.pavilions,
	                  location: location
	                }) : null
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Chess2.default.Description, _defineProperty({}, _Chess2.default.Hidden, isSidebarHidden)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Chess2.default.CollapseDescriptionBtn, onClick: this.toggleSidebar },
	                _react2.default.createElement('img', { src: _arrowRightGray2.default, alt: '' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Chess2.default.DescriptionContent, _defineProperty({}, _Chess2.default.Client, client)) },
	                sectionCells ? _react2.default.createElement(_RightMenu2.default, (_React$createElement = {
	                  handleCellClick: this.handleCellClick,
	                  building: building,
	                  data: selectedCell,
	                  sectionCells: sectionCells,
	                  rows: chess.rows,
	                  selectedCellPath: selectedCellPath,
	                  sectionId: sectionId,
	                  client: client,
	                  filters: filters,
	                  pavilionsFlat: pavilionsFlat,
	                  handleFilters: this.handleFilters,
	                  isChessLoading: isChessLoading,
	                  cells: chess.cells,
	                  objectType: objectType,
	                  profile: profile
	                }, _defineProperty(_React$createElement, 'building', building), _defineProperty(_React$createElement, 'isTable', isTable), _React$createElement)) : _react2.default.createElement(
	                  'div',
	                  { className: _Chess2.default.WireframeRightMenu },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Chess2.default.WireframeAbout },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Chess2.default.WireframeRow },
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeImage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Chess2.default.WireframeRow },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _Chess2.default.WireframeFirstSpan },
	                        _react2.default.createElement('div', { className: _Chess2.default.WireframeNum }),
	                        _react2.default.createElement('div', { className: _Chess2.default.WireframePrintBtn })
	                      ),
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeSecondSpan }),
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeThirdSpan }),
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeFourthSpan })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Chess2.default.WireframeGallery },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Chess2.default.WireframeRow },
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeFirstSpan })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Chess2.default.WireframeRow },
	                      _react2.default.createElement('div', { className: _Chess2.default.WireframeImage })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Chess;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isObjectsFetching: state.objects.isObjectsFetching,
	    zoom: state.building.zoom,
	    currency: state.profile.user_region.country_currency_symbol,
	    objectType: state.building.data && state.building.data.type_id == 1 ? 'zhk' : 'kp_i_th',
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(mapStateToProps, {
	  loadBuilding: _building.loadBuilding,
	  loadPavilions: _building.loadPavilions,
	  loadChess: _building.loadChess,
	  setCells: _building.setCells,
	  setFilters: _building.setFilters,
	  setZoom: _building.setZoom,
	  setChessTable: _building.setChessTable,
	  setChessExtended: _building.setChessExtended,
	  setChessDescriptionHide: _building.setChessDescriptionHide,
	  setListSort: _building.setListSort,
	  setTableScroll: _building.setTableScroll,
	  setSelected: _building.setSelected,
	  setPrevLocation: _building.setPrevLocation,
	  updateChessState: _building.updateChessState
	})((0, _reactRouterDom.withRouter)(Chess)));

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Filters = __webpack_require__(1333);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _lodash = __webpack_require__(355);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Menu = __webpack_require__(166);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Dropdown = __webpack_require__(165);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Area = __webpack_require__(477);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Price = __webpack_require__(479);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Interior = __webpack_require__(1010);
	
	var _Interior2 = _interopRequireDefault(_Interior);
	
	var _ViewType = __webpack_require__(480);
	
	var _ViewType2 = _interopRequireDefault(_ViewType);
	
	var _utils = __webpack_require__(12);
	
	var _lodash3 = __webpack_require__(41);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _helper = __webpack_require__(93);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filters = function (_Component) {
	  _inherits(Filters, _Component);
	
	  function Filters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Filters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filters.__proto__ || Object.getPrototypeOf(Filters)).call.apply(_ref, [this].concat(args))), _this), _this.getFilters = function () {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        interior: null,
	        costMin: null,
	        costMax: null,
	        priceMin: null,
	        priceMax: null,
	        areaFrom: null,
	        areaTo: null,
	        view_type: null
	      };
	      var request = arguments[1];
	      var _this$props = _this.props,
	          location = _this$props.location,
	          handleFilters = _this$props.handleFilters,
	          history = _this$props.history;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var query = (0, _utils.compileQuery)(filters, search);
	      var newSearch = query ? '?' + query : '';
	      var path = '' + pathname + newSearch;
	      history.push(path);
	
	      handleFilters(request);
	    }, _this.getFiltersDebounced = (0, _lodash4.default)(_this.getFilters, 1000), _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventContent = _ref2.eventContent;
	      var _this$props2 = _this.props,
	          profile = _this$props2.profile,
	          objectType = _this$props2.objectType,
	          buildingData = _this$props2.buildingData,
	          isTable = _this$props2.isTable;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        eventContext: isTable ? 'shahmatka' : 'spisok',
	        productType: objectType,
	        productName: buildingData.title,
	        productID: buildingData.id,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Filters, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          print = _props.print,
	          _props$search = _props.search,
	          search = _props$search === undefined ? {} : _props$search,
	          cells = _props.cells,
	          eventData = _props.eventData,
	          t = _props.t,
	          currency = _props.currency,
	          profile = _props.profile,
	          objectType = _props.objectType,
	          buildingData = _props.buildingData;
	
	
	      var mode = location.search.includes('table=common') ? 'shahmatka' : 'spisok';
	
	      var interiorsInHouse = cells.reduce(function (list, cell) {
	        if (cell.data.status === 'saleStatus' || (0, _helper.isReserved)(cell.data.status) || cell.data.status === 'assignmentStatus') {
	          return list.includes(cell.data.interior) ? list : [cell.data.interior].concat(_toConsumableArray(list));
	        }
	        return list;
	      }, []);
	      var splitedInterior = search.interior && search.interior.length ? search.interior.split(',') : [];
	      var interiorIntersection = (0, _lodash2.default)(interiorsInHouse, splitedInterior);
	      var filteredIntersection = interiorIntersection.length ? interiorIntersection.join(',') : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Filters2.default.Filters, _defineProperty({}, _Filters2.default.FiltersPrint, print), _Filters2.default.FiltersChess, className) },
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.building.filters.price'),
	            subtext: search.priceMin || search.priceMax || search.costMin || search.costMax ? (0, _Price.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _Filters2.default.FilterPrice, _defineProperty({}, _Filters2.default.Active, search.priceMin || search.priceMax || search.costMin || search.costMax)),
	            buttonStyle: _Filters2.default.Button,
	            iconStyle: _Filters2.default.DropdownIcon,
	            textStyle: _Filters2.default.Title,
	            chessfilter: true,
	            filter: true,
	            openByClick: true,
	            onClick: function onClick() {
	              _tracker2.default.sendEvent('Web_List_Filters_Price', eventData);
	              _this2.handleTrackEvent({
	                eventName: 'buildingChessFiltersClick',
	                eventContent: 'cena'
	              });
	            }
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { chessfilter: true },
	            _react2.default.createElement(_Price2.default, {
	              events: {
	                left: 'Web_List_Filters_Price_General',
	                right: 'Web_List_Filters_Price_Kv'
	              },
	              eventData: eventData,
	              dropdownData: this.getFiltersDebounced,
	              search: search,
	              chessfilter: true,
	              currency: currency,
	              profile: profile,
	              objectType: objectType,
	              mode: mode,
	              buildingData: buildingData
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.building.filters.area'),
	            subtext: search.areaFrom || search.areaTo ? (0, _Area.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _defineProperty({}, _Filters2.default.Active, search.areaFrom || search.areaTo)),
	            buttonStyle: _Filters2.default.Button,
	            iconStyle: _Filters2.default.DropdownIcon,
	            textStyle: _Filters2.default.Title,
	            chessfilter: true,
	            filter: true,
	            openByClick: true,
	            onClick: function onClick() {
	              _tracker2.default.sendEvent('Web_List_Filters_Square', eventData);
	              _this2.handleTrackEvent({
	                eventName: 'buildingChessFiltersClick',
	                eventContent: 'ploshchad'
	              });
	            }
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { chessfilter: true },
	            _react2.default.createElement(_Area2.default, {
	              dropdownData: this.getFiltersDebounced,
	              search: search,
	              chessfilter: true,
	              profile: profile,
	              objectType: objectType,
	              mode: mode,
	              buildingData: buildingData
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.building.filters.inter'),
	            subtext: search.interior ? (0, _Interior.subtext)({ interior: filteredIntersection }) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _defineProperty({}, _Filters2.default.Active, filteredIntersection)),
	            buttonStyle: _Filters2.default.Button,
	            iconStyle: _Filters2.default.DropdownIcon,
	            textStyle: _Filters2.default.Title
	            // rightShift
	            , chessfilter: true,
	            filter: true,
	            openByClick: true,
	            onClick: function onClick() {
	              _this2.handleTrackEvent({
	                eventName: 'buildingChessFiltersClick',
	                eventContent: 'otdelka'
	              });
	            }
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { chessfilter: true },
	            _react2.default.createElement(_Interior2.default, {
	              dropdownData: this.getFilters,
	              eventData: eventData,
	              search: search,
	              chessfilter: true,
	              cells: cells,
	              objectType: objectType,
	              profile: profile,
	              mode: mode,
	              buildingData: buildingData
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Dropdown2.default,
	          {
	            text: t('components.header.filtersBar.filters.viewTypes.title'),
	            subtext: search.view_type ? (0, _ViewType.subtext)(search) : null,
	            className: (0, _classnames2.default)(_Filters2.default.Filter, _defineProperty({}, _Filters2.default.Active, !!search.view_type)),
	            buttonStyle: _Filters2.default.Button,
	            iconStyle: _Filters2.default.DropdownIcon,
	            textStyle: _Filters2.default.Title
	            // rightShift
	            , chessfilter: true,
	            filter: true,
	            openByClick: true,
	            onClick: function onClick() {
	              _this2.handleTrackEvent({
	                eventName: 'buildingChessFiltersClick',
	                eventContent: 'vid_iz_okna'
	              });
	            }
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { chessfilter: true },
	            _react2.default.createElement(_ViewType2.default, {
	              dropdownData: this.getFilters,
	              eventData: eventData,
	              search: search,
	              chessfilter: true,
	              cells: cells,
	              objectType: objectType,
	              profile: profile,
	              mode: mode,
	              buildingData: buildingData
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Filters;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRouterDom.withRouter)(Filters));

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Housing = __webpack_require__(1334);
	
	var _Housing2 = _interopRequireDefault(_Housing);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Housing = function (_Component) {
	  _inherits(Housing, _Component);
	
	  function Housing(props) {
	    _classCallCheck(this, Housing);
	
	    var _this = _possibleConstructorReturn(this, (Housing.__proto__ || Object.getPrototypeOf(Housing)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventContent = _ref.eventContent;
	      var _this$props = _this.props,
	          data = _this$props.data,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var title = data.title,
	          id = data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.handleMenuItemClick = _this.handleMenuItemClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Housing, [{
	    key: 'handleMenuItemClick',
	    value: function handleMenuItemClick(section, prevSection) {
	      var _props = this.props,
	          handleFilters = _props.handleFilters,
	          pavilions = _props.pavilions;
	
	      var pavilionName = pavilions[section[0]].name;
	      this.handleTrackEvent({
	        eventName: 'buildingChessDropdownListItemClick',
	        eventContent: pavilionName
	      });
	      handleFilters({ section: section, prevSection: prevSection });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          pavilions = _props2.pavilions,
	          pavilionsFlat = _props2.pavilionsFlat,
	          selectedSectionPath = _props2.selectedSectionPath,
	          t = _props2.t;
	
	
	      var pavilionsList = {};
	      pavilions.forEach(function (pavilion) {
	        var id = pavilion.id,
	            construction_finished = pavilion.construction_finished,
	            construction_ending = pavilion.construction_ending,
	            year_built = pavilion.year_built;
	
	        pavilionsList[id] = { id: id, construction_finished: construction_finished, construction_ending: construction_ending, year_built: year_built };
	      });
	
	      var items = [];
	      pavilionsFlat.forEach(function (pavilion, pavilionIndex) {
	        var sections = pavilion.sections;
	
	        var isPavilionHasOnlyOneSection = sections.length === 1;
	
	        if (sections) {
	          sections.forEach(function (section, sectionIndex) {
	            var _pavilionsList$pavili = pavilionsList[pavilion.id],
	                construction_finished = _pavilionsList$pavili.construction_finished,
	                construction_ending = _pavilionsList$pavili.construction_ending,
	                year_built = _pavilionsList$pavili.year_built;
	
	            var readyClass = construction_finished ? 'Finished' : 'InProcess';
	            var active = selectedSectionPath[0] === pavilionIndex && selectedSectionPath[1] === sectionIndex;
	            items.push(_react2.default.createElement(
	              'div',
	              {
	                key: section.id,
	                className: (0, _classnames2.default)(_Housing2.default.HousingMenuItem, _defineProperty({}, _Housing2.default.HousingMenuActive, active)),
	                onClick: _this2.handleMenuItemClick.bind(undefined, [pavilionIndex, sectionIndex], selectedSectionPath)
	              },
	              _react2.default.createElement(
	                'i',
	                { className: (0, _classnames2.default)(_Housing2.default.RadioIcon, _defineProperty({}, _Housing2.default.Active, active)) },
	                _react2.default.createElement('i', null)
	              ),
	              t('components.building.filters.housing.pavilion') + ' ' + pavilion.name + (isPavilionHasOnlyOneSection ? '' : ', ' + t('components.building.filters.housing.section') + ' ' + section.name),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Housing2.default.Status, _Housing2.default[readyClass], _defineProperty({}, _Housing2.default.UnderConstr, year_built == 0)) },
	                construction_finished ? t('components.building.filters.housing.finished') : year_built === 0 ? t('components.building.filters.housing.inProgress') : construction_ending + ' / ' + (year_built || '')
	              )
	            ));
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Housing2.default.HousingMenu },
	        _react2.default.createElement(
	          'div',
	          { className: _Housing2.default.HousingMenuTitle },
	          t('components.building.filters.housing.finished')
	        ),
	        items
	      );
	    }
	  }]);
	
	  return Housing;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Housing);

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NoBuildings = __webpack_require__(473);
	
	var _NoBuildings2 = _interopRequireDefault(_NoBuildings);
	
	var _List = __webpack_require__(1335);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _angleUp = __webpack_require__(1980);
	
	var _angleUp2 = _interopRequireDefault(_angleUp);
	
	var _iconLock = __webpack_require__(235);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _helper = __webpack_require__(93);
	
	var _utils = __webpack_require__(12);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	  Мы должны уметь сортировать в следующем порядке следующие значения:
	    A B -004 -1 0 0 00 1 1.1 1.2 1.11 2 +3 +004 004 04 11
	  Подвох:
	    1 2 11, не 1 11 2, и при этом 1.1 1.2 1.11, не 1.1 1.11 1.2
	  В таком же ключе должны уметь сортировать строки содержащие точку, цифры и
	  буквы в перемешку:
	    A12.A A12.11 В1.M6 В1.M7 233.1
	*/
	var split = /([^0-9\-\+]+|[\-\+]?[0-9]+|[\-\+])/g;
	var digit = /[\-\+]?[0-9]+/;
	var stringCompare = function stringCompare(a, b) {
	  var partsA = a.match(split) || [];
	  var partsB = b.match(split) || [];
	  for (var i = 0; i < Math.max(partsA.length, partsB.length); ++i) {
	    var partA = partsA[i] || '';
	    var partB = partsB[i] || '';
	    if (partA === partB) {
	      continue;
	    }
	    var typeA = digit.test(partA) ? 1 : 0;
	    var typeB = digit.test(partB) ? 1 : 0;
	    if (typeA !== typeB) {
	      return typeA - typeB;
	    } else if (typeA === 1) {
	      return Number(partA) - Number(partB) || (partA > partB ? 1 : -1);
	    }
	    var lowerA = partA.toLowerCase();
	    var lowerB = partB.toLowerCase();
	    return lowerA === lowerB ? partA > partB ? 1 : -1 : lowerA > lowerB ? 1 : -1;
	  }
	  return 0;
	};
	
	var stringCompareWithNullsFirst = function stringCompareWithNullsFirst(a, b) {
	  if (a === null && b === null) {
	    return 0;
	  }
	  if (a === null) {
	    return -1;
	  }
	  if (b === null) {
	    return 1;
	  }
	  return stringCompare(a, b);
	};
	
	var numberCompare = function numberCompare(a, b) {
	  return Number(a) - Number(b);
	};
	
	var valuesCompare = function valuesCompare(list, a, b) {
	  return list.indexOf(a) - list.indexOf(b);
	};
	
	var cols = {
	  number: {
	    name: _i18n2.default.t('components.building.list.number'),
	    nameSm: _i18n2.default.t('components.building.list.numberS'),
	    sort: function sort(a, b) {
	      return stringCompareWithNullsFirst(a.data.number, b.data.number);
	    },
	    headerClassName: _List2.default.HeaderNumber
	  },
	  title: {
	    name: _i18n2.default.t('components.building.list.name'),
	    nameSm: _i18n2.default.t('components.building.list.nameS'),
	    sort: function sort(a, b) {
	      return stringCompare(a.data.number, b.data.number);
	    },
	    headerClassName: _List2.default.HeaderNumber
	  },
	  area: {
	    name: _i18n2.default.t('components.building.list.area'),
	    nameSm: _i18n2.default.t('components.building.list.areaS'),
	    sort: function sort(a, b) {
	      return numberCompare(a.data.area, b.data.area);
	    },
	    headerClassName: _List2.default.HeaderArea
	  },
	  cost: {
	    name: _i18n2.default.t('components.building.list.cost'),
	    nameSm: _i18n2.default.t('components.building.list.costS'),
	    sort: function sort(a, b) {
	      return numberCompare(a.data.priceAll, b.data.priceAll);
	    },
	    headerClassName: _List2.default.HeaderCost
	  },
	  price: {
	    name: _i18n2.default.t('components.building.list.price'),
	    nameSm: _i18n2.default.t('components.building.list.priceS'),
	    sort: function sort(a, b) {
	      return numberCompare(a.data.priceM, b.data.priceM);
	    },
	    headerClassName: _List2.default.HeaderCostMeter
	  },
	  interior: {
	    name: _i18n2.default.t('components.building.list.interior'),
	    nameSm: _i18n2.default.t('components.building.list.interiorS'),
	    sort: function sort(a, b) {
	      return valuesCompare(['zeroInt', 'chernInt', 'predChistInt', 'chistInt', 'remInt', 'chastRemInt', 'whiteBox', 'repair'], a.data.interior, b.data.interior);
	    },
	    headerClassName: _List2.default.HeaderInterior
	  },
	  apartments: {
	    name: _i18n2.default.t('components.building.list.apartments'),
	    nameSm: _i18n2.default.t('components.building.list.apartmentsS'),
	    sort: function sort(a, b) {
	      return valuesCompare(['studioAp', 'oneAp', 'twoAp', 'threeAp', 'allAp', 'penthaus'], a.data.cnt_apart, b.data.cnt_apart);
	    },
	    headerClassName: _List2.default.HeaderRooms
	  },
	  floor: {
	    name: _i18n2.default.t('components.building.list.floor'),
	    nameSm: _i18n2.default.t('components.building.list.floorS'),
	    sort: function sort(a, b) {
	      return stringCompare(a.data.floorName, b.data.floorName);
	    },
	    headerClassName: _List2.default.HeaderFloorNumber
	  },
	  floorKp: {
	    name: _i18n2.default.t('components.building.list.floorKp'),
	    nameSm: _i18n2.default.t('components.building.list.floorKpS'),
	    sort: function sort(a, b) {
	      return stringCompare(a.data.floorName, b.data.floorName);
	    },
	    headerClassName: _List2.default.HeaderFloorNumber
	  },
	  status: {
	    name: '',
	    nameSm: '',
	    sort: false,
	    headerClassName: _List2.default.HeaderStatus
	  }
	};
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          cell = _ref.cell,
	          sortField = _ref.sortField,
	          eventContext = _ref.eventContext,
	          pavilionName = _ref.pavilionName;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building;
	
	
	      var eventContent = void 0;
	
	      if (cell) {
	        var _cell$data = cell.data,
	            number = _cell$data.number,
	            costFormatted = _cell$data.costFormatted,
	            area = _cell$data.area,
	            priceFormatted = _cell$data.priceFormatted;
	
	        eventContent = number + ' | ' + costFormatted + ' | ' + area + ' | ' + priceFormatted;
	      } else {
	        eventContent = sortField;
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: pavilionName || eventContent,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    var data = props.data,
	        sortColumn = props.sortColumn;
	
	    var cells = _this.getCells(data, sortColumn);
	    var otherCells = _this.getCells(data, sortColumn, true);
	
	    _this.state = {
	      cells: cells,
	      otherCells: otherCells,
	      selected: 'defaultSelected' in props ? props.defaultSelected : null
	    };
	
	    _this.handleCellClick = _this.handleCellClick.bind(_this);
	    _this.handleHeaderCellClick = _this.handleHeaderCellClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          defaultScroll = _props.defaultScroll,
	          isChessLoading = _props.isChessLoading,
	          pavilions = _props.pavilions,
	          location = _props.location;
	
	      var list = _reactDom2.default.findDOMNode(this);
	      list.scrollTop = defaultScroll[0];
	      list.scrollLeft = defaultScroll[1];
	
	      var _state = this.state,
	          _state$cells = _state.cells,
	          cells = _state$cells === undefined ? [] : _state$cells,
	          _state$otherCells = _state.otherCells,
	          otherCells = _state$otherCells === undefined ? [] : _state$otherCells;
	
	      var cellWithoutReserved = cells;
	      var otherCellsWithoutReserved = otherCells;
	
	      if (!isChessLoading && cellWithoutReserved.length === 0 && otherCellsWithoutReserved.length === 0) {
	        var searchParams = new URLSearchParams(location.search);
	        var sectionValue = searchParams.get('section');
	        var pavilionIndex = sectionValue ? sectionValue.split('.')[0] : 0;
	        var pavilionName = pavilions[pavilionIndex].name;
	
	        this.handleTrackEvent({
	          eventName: 'buildingChessListSoldOutCardShow',
	          pavilionName: pavilionName
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var handleScroll = this.props.handleScroll;
	
	      var list = _reactDom2.default.findDOMNode(this);
	      var scrollTop = list.scrollTop,
	          scrollLeft = list.scrollLeft;
	
	      handleScroll(scrollTop, scrollLeft);
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var sortColumn = nextProps.sortColumn,
	          data = nextProps.data;
	      var _props2 = this.props,
	          prevSortColumn = _props2.sortColumn,
	          prevData = _props2.data;
	
	
	      if (sortColumn !== prevSortColumn || data !== prevData) {
	        var _data = nextProps.data;
	
	        var cells = this.getCells(_data, sortColumn);
	        var otherCells = this.getCells(_data, sortColumn, true);
	        this.setState({ cells: cells, otherCells: otherCells });
	      }
	    }
	  }, {
	    key: 'getCells',
	    value: function getCells(data, sortColumn, other) {
	      var cells = [];
	      data.forEach(function (row) {
	        row.cells.filter(function (cell) {
	          return cell && !cell.hidden && (other ? cell.mark === false : cell.mark !== false);
	        }).forEach(function (cell) {
	          cells.push(cell);
	        });
	      });
	
	      var _sortColumn = _slicedToArray(sortColumn, 2),
	          sortField = _sortColumn[0],
	          sortOrder = _sortColumn[1];
	
	      cells.sort(function (a, b) {
	        return cols[sortField].sort(a, b) * (sortOrder ? 1 : -1);
	      });
	      return cells;
	    }
	  }, {
	    key: 'handleCellClick',
	    value: function handleCellClick(row, column, cell) {
	      var handleCellClick = this.props.handleCellClick;
	
	      this.handleTrackEvent({
	        eventName: 'buildingChessLotClick',
	        cell: cell,
	        eventContext: 'spisok'
	      });
	      handleCellClick([row, column]);
	    }
	  }, {
	    key: 'handleHeaderCellClick',
	    value: function handleHeaderCellClick(field) {
	      var _props$sortColumn = _slicedToArray(this.props.sortColumn, 2),
	          sortField = _props$sortColumn[0],
	          sortOrder = _props$sortColumn[1];
	
	      if (sortField === field) {
	        sortOrder = !sortOrder;
	      } else {
	        sortField = field;
	        sortOrder = true;
	      }
	
	      var sortFieldForEvent = void 0;
	
	      switch (sortField) {
	        case 'number':
	          sortFieldForEvent = 'nomer';
	          break;
	        case 'area':
	          sortFieldForEvent = 'ploshchad';
	          break;
	        case 'cost':
	          sortFieldForEvent = 'cena';
	          break;
	        case 'price':
	          sortFieldForEvent = 'za_m';
	          break;
	        case 'interior':
	          sortFieldForEvent = 'otdelka';
	          break;
	        case 'apartments':
	          sortFieldForEvent = 'komnat';
	          break;
	        case 'floor':
	          sortFieldForEvent = 'etazh';
	          break;
	        default:
	          return '';
	      }
	
	      this.handleTrackEvent({
	        eventName: 'buildingChessListSortButtonsClick',
	        sortField: sortFieldForEvent,
	        eventContext: sortOrder ? 'po_vozrastaniyu' : 'po_ubyvaniyu'
	      });
	
	      var handleSort = this.props.handleSort;
	
	      handleSort(sortField, sortOrder);
	    }
	  }, {
	    key: 'renderHeaderItem',
	    value: function renderHeaderItem(colKey) {
	      var _props3 = this.props,
	          _props3$sortColumn = _slicedToArray(_props3.sortColumn, 2),
	          sortField = _props3$sortColumn[0],
	          sortOrder = _props3$sortColumn[1],
	          typeId = _props3.typeId;
	
	      var col = cols[colKey];
	      var style = col.name ? {} : { cursor: 'default' };
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)(_List2.default.HeaderItem, col.headerClassName),
	          onClick: col.name ? this.handleHeaderCellClick.bind(undefined, colKey) : null
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _List2.default.HeaderText },
	          _react2.default.createElement(
	            'span',
	            { className: _List2.default.TabletHidden },
	            col.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _List2.default.TabletVisible },
	            col.nameSm
	          )
	        ),
	        col.sort ? _react2.default.createElement(
	          'div',
	          { className: _List2.default.HeaderSort },
	          _react2.default.createElement(_angleUp2.default, { className: (0, _classnames2.default)(_defineProperty({}, _List2.default.Sorted, colKey === sortField && sortOrder === true)) }),
	          _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_defineProperty({}, _List2.default.Sorted, colKey === sortField && sortOrder === false)) })
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _props4 = this.props,
	          client = _props4.client,
	          isSidebarHidden = _props4.isSidebarHidden,
	          typeId = _props4.typeId;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_List2.default.Header, _defineProperty({}, _List2.default.Client, client), _defineProperty({}, _List2.default.Wide, isSidebarHidden)) },
	        _react2.default.createElement(
	          'div',
	          { className: _List2.default.HeaderContent },
	          this.renderHeaderItem(typeId == 2 ? 'title' : 'number'),
	          this.renderHeaderItem('area'),
	          this.renderHeaderItem('cost'),
	          this.renderHeaderItem('price'),
	          this.renderHeaderItem('interior'),
	          this.renderHeaderItem('apartments'),
	          this.renderHeaderItem(typeId == 2 ? 'floorKp' : 'floor'),
	          this.renderHeaderItem('status')
	        )
	      );
	    }
	  }, {
	    key: 'renderCell',
	    value: function renderCell(cell) {
	      var _props5 = this.props,
	          selected = _props5.selected,
	          typeId = _props5.typeId,
	          t = _props5.t;
	      var row = cell.row,
	          col = cell.col;
	
	      var isSelected = selected && selected[0] === row && selected[1] === col;
	
	      var isPromo = false;
	      var isReserve = true;
	
	      return _react2.default.createElement(
	        'div',
	        { key: row + ':' + col, className: (0, _classnames2.default)(_List2.default.Cell) },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: this.handleCellClick.bind(undefined, row, col, cell),
	            className: (0, _classnames2.default)(_List2.default.CellContent, _defineProperty({}, _List2.default.Selected, isSelected), _defineProperty({}, _List2.default.Promo, isPromo), _defineProperty({}, _List2.default.Reserve, isReserve))
	          },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellNumber) },
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _utils.printNumber)(cell.data.number)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellArea) },
	            _react2.default.createElement(
	              'span',
	              null,
	              cell.data.status !== 'fundStatus' && cell.data.area
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellCost) },
	            _react2.default.createElement(
	              'span',
	              null,
	              cell.data.status !== 'fundStatus' && +cell.data.costFormatted !== 0 ? cell.data.costFormatted : ''
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellPrice) },
	            _react2.default.createElement(
	              'span',
	              null,
	              cell.data.status !== 'fundStatus' && +cell.data.priceFormatted !== 0 ? cell.data.priceFormatted : ''
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellDecoration) },
	            _react2.default.createElement(
	              'span',
	              null,
	              cell.data.status !== 'fundStatus' && cell.data.interiorName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellRoomCount) },
	            _react2.default.createElement(
	              'span',
	              null,
	              cell.data.status !== 'fundStatus' && cell.data.apartmentsName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellFloorNumber) },
	            _react2.default.createElement(
	              'span',
	              null,
	              typeId == 2 ? cell.data.floors : cell.data.floorName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.CellItem, _List2.default.CellStatus) },
	            cell.data.status === 'fundStatus' ? _react2.default.createElement('img', { src: _iconLock2.default, alt: '', className: _List2.default.iconFund }) : _react2.default.createElement(
	              'span',
	              null,
	              cell.data.view_action === '1' ? _react2.default.createElement(
	                'span',
	                { className: _List2.default.TagPromo },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _i18n2.default.t('components.building.list.promo')
	                )
	              ) : null,
	              (0, _helper.isReserved)(cell.data.status) ? _react2.default.createElement(
	                'span',
	                { className: _List2.default.TagReserv },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _i18n2.default.t('components.building.list.reserv')
	                )
	              ) : null,
	              cell.data.status === 'assignmentStatus' ? _react2.default.createElement(
	                'span',
	                { className: _List2.default.TagAssign },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _i18n2.default.t('components.building.list.assign')
	                )
	              ) : null
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRows',
	    value: function renderRows() {
	      var _this2 = this;
	
	      var cells = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      return cells.map(function (cell) {
	        return _this2.renderCell(cell);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          className = _props6.className,
	          client = _props6.client,
	          isChessLoading = _props6.isChessLoading,
	          t = _props6.t;
	      var _state2 = this.state,
	          _state2$cells = _state2.cells,
	          cells = _state2$cells === undefined ? [] : _state2$cells,
	          _state2$otherCells = _state2.otherCells,
	          otherCells = _state2$otherCells === undefined ? [] : _state2$otherCells;
	
	      var cellWithoutReserved = cells;
	      var otherCellsWithoutReserved = otherCells;
	
	      if (!isChessLoading && cellWithoutReserved.length === 0 && otherCellsWithoutReserved.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: _List2.default.FlatsSoldWrap },
	          _react2.default.createElement(
	            'div',
	            { className: _List2.default.FlatsSold },
	            _react2.default.createElement(
	              'p',
	              { className: _List2.default.FlatsSoldTitle },
	              t('components.building.list.soldOutTitle')
	            ),
	            _react2.default.createElement('img', { src: _nothingfound2.default, className: _List2.default.FlatsSoldImage, alt: t('components.building.list.soldOutAlt') })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_List2.default.Table, className, client ? _List2.default.TableClient : '') },
	        this.renderHeader(),
	        _react2.default.createElement('div', { className: _List2.default.InnerBumper }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_List2.default.Inner, _defineProperty({}, _List2.default.Client, client), 'custom-scrollbar') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_List2.default.Data, 'custom-scrollbar') },
	            cellWithoutReserved.length && otherCells.length ? _react2.default.createElement(
	              'div',
	              { className: _List2.default.RowsTitle },
	              t('components.building.list.cellWithoutReserved', {
	                cellWithoutReserved: cellWithoutReserved.length
	              })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _List2.default.Rows },
	              this.renderRows(cellWithoutReserved)
	            ),
	            otherCellsWithoutReserved.length && otherCells.length ? _react2.default.createElement(
	              'div',
	              { className: _List2.default.RowsTitle },
	              t('components.building.list.otherCells', {
	                otherCells: otherCells.length
	              })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _List2.default.Rows },
	              this.renderRows(otherCellsWithoutReserved)
	            )
	          )
	        )
	      );
	      /* return (
	        cellWithoutReserved.length === 0 ?
	          <NoFlats
	            className={styles.NoFlats}
	            classNameInfo={styles.NoFlatsInfo}
	            title={
	              <span className={styles.NoFlatsTitle}>
	              Нет подходящих квартир
	            </span>
	          }
	            text={
	              <span className={styles.NoFlatsText}>
	              В этом доме нету квартир, подходящих под ваши критерии
	            </span>
	          }
	            buttonText="Сбросить фильтры"
	          /> :
	          <div className={cn(styles.Table, className, (client ? styles.TableClient : ''))}>
	            {this.renderHeader()}
	            <div className={styles.InnerBumper}></div>
	            <div className={cn(styles.Inner, { [styles.Client]: client }, 'custom-scrollbar')}>
	              <div className={cn(styles.Data, 'custom-scrollbar')}>
	                {
	                (cellWithoutReserved.length && otherCells.length) ?
	                  <div className={styles.RowsTitle}>
	                  Квартиры под запрос ({cellWithoutReserved.length})
	                </div> : null
	              }
	                <div className={styles.Rows}>
	                  {this.renderRows(cellWithoutReserved)}
	                </div>
	                {
	                (otherCellsWithoutReserved.length && otherCells.length) ?
	                  <div className={styles.RowsTitle}>
	                  Остальные квартиры ({otherCells.length})
	                </div> : null
	              }
	                <div className={styles.Rows}>
	                  {this.renderRows(otherCellsWithoutReserved)}
	                </div>
	              </div>
	            </div>
	          </div>
	      ); */
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(List);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(911);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List2.default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RightMenu = __webpack_require__(1337);
	
	var _RightMenu2 = _interopRequireDefault(_RightMenu);
	
	var _About = __webpack_require__(213);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Gallery = __webpack_require__(467);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RightMenu = function (_Component) {
	  _inherits(RightMenu, _Component);
	
	  function RightMenu() {
	    _classCallCheck(this, RightMenu);
	
	    return _possibleConstructorReturn(this, (RightMenu.__proto__ || Object.getPrototypeOf(RightMenu)).apply(this, arguments));
	  }
	
	  _createClass(RightMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rows = _props.rows,
	          sectionCells = _props.sectionCells,
	          data = _props.data,
	          building = _props.building,
	          client = _props.client,
	          sectionId = _props.sectionId,
	          handleCellClick = _props.handleCellClick,
	          selectedCellPath = _props.selectedCellPath,
	          filters = _props.filters,
	          pavilionsFlat = _props.pavilionsFlat,
	          handleFilters = _props.handleFilters,
	          isChessLoading = _props.isChessLoading,
	          cells = _props.cells,
	          objectType = _props.objectType,
	          profile = _props.profile,
	          isTable = _props.isTable;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_RightMenu2.default.RightMenu, _defineProperty({}, _RightMenu2.default.Client, client)) },
	        _react2.default.createElement(_About2.default, {
	          data: data,
	          building: building,
	          client: client,
	          sectionId: sectionId,
	          objectType: objectType,
	          profile: profile,
	          isTable: isTable
	        }),
	        _react2.default.createElement(_Gallery2.default, {
	          handleCellClick: handleCellClick,
	          sectionCells: sectionCells,
	          rows: rows,
	          row: selectedCellPath[0],
	          selectedCellPath: selectedCellPath,
	          data: data,
	          building: building,
	          client: client,
	          sectionId: sectionId,
	          filters: filters,
	          pavilionsFlat: pavilionsFlat,
	          handleFilters: handleFilters,
	          isChessLoading: isChessLoading,
	          cells: cells,
	          objectType: objectType,
	          profile: profile,
	          isTable: isTable
	        })
	      );
	    }
	  }]);
	
	  return RightMenu;
	}(_react.Component);
	
	exports.default = RightMenu;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewType = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1338);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewTypes = {
	  intoYard: _i18n2.default.t('constants.view_type.rightMenu.intoYard'),
	  toMountains: _i18n2.default.t('constants.view_type.rightMenu.toMountains'),
	  onSea: _i18n2.default.t('constants.view_type.rightMenu.onSea'),
	  toPark: _i18n2.default.t('constants.view_type.rightMenu.toPark'),
	  toGarden: _i18n2.default.t('constants.view_type.rightMenu.toGarden'),
	  toForest: _i18n2.default.t('constants.view_type.rightMenu.toForest'),
	  onSocialObjects: _i18n2.default.t('constants.view_type.rightMenu.onSocialObjects'),
	  panoramicView: _i18n2.default.t('constants.view_type.rightMenu.panoramicView')
	};
	
	var ViewType = exports.ViewType = function ViewType(_ref) {
	  var view_type = _ref.view_type;
	
	  if (!view_type) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.Wrapper },
	    _react2.default.createElement(
	      'span',
	      { className: _styles2.default.Container },
	      ViewTypes[view_type]
	    )
	  );
	};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RightMenu = __webpack_require__(913);
	
	var _RightMenu2 = _interopRequireDefault(_RightMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RightMenu2.default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Table = __webpack_require__(1339);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _iconLock = __webpack_require__(235);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	var _helper = __webpack_require__(93);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPAN_PERCENT = 100;
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          cell = _ref.cell,
	          eventContext = _ref.eventContext;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building;
	      var _cell$data = cell.data,
	          number = _cell$data.number,
	          costFormatted = _cell$data.costFormatted,
	          area = _cell$data.area,
	          priceFormatted = _cell$data.priceFormatted;
	
	      var eventContent = number + ' | ' + costFormatted + ' | ' + area + ' | ' + priceFormatted;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.setState({ dragging: true });
	      // Set coords
	      _this.coords = {
	        x: e.pageX,
	        y: e.pageY
	      };
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ dragging: false });
	      _this.coords = {};
	    };
	
	    _this.handleMouseMove = function (e) {
	      if (!_this.state.dragging) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleMove(e);
	    };
	
	    _this.handleMove = function (e) {
	      _this.setState({
	        x: e.movementX,
	        y: e.movementY
	      });
	
	      _this.handleScroll();
	    };
	
	    _this.handleScroll = function () {
	      _this.refs.table.scrollTop = _this.refs.table.scrollTop - _this.state.y;
	      _this.refs.table.scrollLeft = _this.refs.table.scrollLeft - _this.state.x;
	    };
	
	    _this.state = {
	      dragging: false,
	      x: 0,
	      y: 0,
	      hoverId: null
	    };
	    _this.handleCellClick = _this.handleCellClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var defaultScroll = this.props.defaultScroll;
	
	      var table = _reactDom2.default.findDOMNode(this);
	      table.scrollTop = defaultScroll[0];
	      table.scrollLeft = defaultScroll[1];
	
	      document.addEventListener('mousemove', this.handleMouseMove, false);
	      document.addEventListener('mouseup', this.handleMouseUp, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var handleScroll = this.props.handleScroll;
	
	      var table = _reactDom2.default.findDOMNode(this);
	      var scrollTop = table.scrollTop,
	          scrollLeft = table.scrollLeft;
	
	      handleScroll(scrollTop, scrollLeft);
	
	      document.removeEventListener('mousemove', this.handleMouseMove, false);
	      document.removeEventListener('mouseup', this.handleMouseUp, false);
	    }
	  }, {
	    key: 'handleCellClick',
	    value: function handleCellClick(row, column, cell) {
	      var handleCellClick = this.props.handleCellClick;
	
	      this.handleTrackEvent({
	        eventName: 'buildingChessLotClick',
	        cell: cell,
	        eventContext: 'shahmatka'
	      });
	      handleCellClick([row, column]);
	    }
	  }, {
	    key: 'renderHeaderCells',
	    value: function renderHeaderCells() {
	      var _props = this.props,
	          cols = _props.cols,
	          page = _props.page,
	          pageSize = _props.pageSize;
	
	      return cols.map(function (column, index) {
	        if (!column) {
	          return _react2.default.createElement('div', { key: index, className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.HeaderCell) });
	        }
	
	        var colspan = column.colspan;
	
	        colspan = Number(colspan) || 1;
	        var style = { width: colspan * SPAN_PERCENT + '%' };
	        return _react2.default.createElement(
	          'div',
	          { key: index, className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.HeaderCell) },
	          _react2.default.createElement(
	            'div',
	            { className: _Table2.default.Stretch, style: style },
	            _react2.default.createElement(
	              'div',
	              { className: _Table2.default.CellContent },
	              _react2.default.createElement(
	                'span',
	                null,
	                column.name.length > 3 ? column.name[0] == 'К' ? column.name : column.name[0] : column.name
	              )
	            )
	          )
	        );
	      }).slice(page * pageSize, (page + 1) * pageSize);
	    }
	  }, {
	    key: 'renderRowNumCell',
	    value: function renderRowNumCell(row) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.RowNumCell) },
	        _react2.default.createElement(
	          'div',
	          { className: _Table2.default.CellContent },
	          row.name.length > 3 ? row.name[0] : row.name
	        )
	      );
	    }
	  }, {
	    key: 'renderFantomCell',
	    value: function renderFantomCell(col) {
	      return _react2.default.createElement('div', { key: col, className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.Cell, _Table2.default.CellFantom) });
	    }
	  }, {
	    key: 'renderHiddenCell',
	    value: function renderHiddenCell(col) {
	      return _react2.default.createElement(
	        'div',
	        { key: col, className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.Cell) },
	        _react2.default.createElement('div', { className: (0, _classnames2.default)(_Table2.default.CellContent, _Table2.default.Hidden) })
	      );
	    }
	  }, {
	    key: 'renderCellContent',
	    value: function renderCellContent(cell, stretched) {
	      var _this2 = this,
	          _cn,
	          _ref2;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          selected = _props2.selected,
	          print = _props2.print;
	      var row = cell.row,
	          col = cell.col;
	
	      var isSelected = selected && selected[0] === row && selected[1] === col;
	      var cellContent = cell.content[content],
	          hidden = cell.hidden;
	
	      var reservation = (0, _helper.isReserved)(cell.data.status);
	      var borderTop = cell.data.view_action === '1'; /* isAction */
	      var isFund = cell.data.status === 'fundStatus';
	
	      var hoverId = 'cell-' + cell.id;
	      var handleMouseEnter = function handleMouseEnter() {
	        _this2.setState({ hoverId: hoverId });
	        _this2.handleTrackEvent({
	          eventName: 'buildingChessLotHover',
	          cell: cell
	        });
	      };
	      var handleMouseLeave = function handleMouseLeave() {
	        return _this2.setState({ hoverId: null });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_Table2.default.CellContent, _Table2.default.CellTooltip, (_cn = {}, _defineProperty(_cn, _Table2.default.Selected, isSelected), _defineProperty(_cn, _Table2.default.Hidden, hidden), _cn), isFund ? _Table2.default.Fund : (_ref2 = {}, _defineProperty(_ref2, _Table2.default.Reservation, reservation), _defineProperty(_ref2, _Table2.default.BorderTop, borderTop && !hidden), _ref2)),
	          onClick: this.handleCellClick.bind(undefined, row, col, cell),
	          onMouseEnter: handleMouseEnter,
	          onMouseLeave: handleMouseLeave
	        },
	        print && reservation ? stretched ? _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)(_Table2.default.PrintReservPattern, _Table2.default.Stretched) },
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null)
	        ) : _react2.default.createElement(
	          'span',
	          { className: _Table2.default.PrintReservPattern },
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null),
	          _react2.default.createElement('i', null)
	        ) : null,
	        cell.data.status === 'fundStatus' ? _react2.default.createElement(
	          'span',
	          { 'data-status': cell.data.status, 'data-area': cell.data.area },
	          _react2.default.createElement('img', { src: _iconLock2.default, alt: '' })
	        ) : _react2.default.createElement(
	          'span',
	          { 'data-status': cell.data.status, 'data-area': cell.data.area },
	          cellContent
	        ),
	        hoverId === this.state.hoverId && !cell.hidden && !this.props.wide && !(cell.data.status === 'fundStatus') && cell.data.costFormatted != 0 && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Table2.default.CellTooltipText), id: hoverId },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Table2.default.TooltipContent, _defineProperty({}, _Table2.default.Action, borderTop), _defineProperty({}, _Table2.default.Reserve, reservation)) },
	            _react2.default.createElement(
	              'div',
	              { className: _Table2.default.TooltipContentLeft },
	              _react2.default.createElement(
	                'span',
	                { className: _Table2.default.FlatNum },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u2116',
	                  cell.data.number
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  cell.data.apartmentsName
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Table2.default.TooltipContentRight },
	              _react2.default.createElement(
	                'span',
	                { className: _Table2.default.Price },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  cell.data.costFormatted,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  cell.data.area,
	                  ', ',
	                  cell.data.priceFormatted
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderStretchedCell',
	    value: function renderStretchedCell(cell) {
	      var col = cell.col,
	          colspan = cell.colspan,
	          rowspan = cell.rowspan,
	          mark = cell.mark;
	
	      var style = void 0;
	      if (colspan || rowspan) {
	        style = {};
	        if (colspan > 1) {
	          style.width = colspan * SPAN_PERCENT + '%';
	        }
	        if (rowspan > 1) {
	          style.height = rowspan * SPAN_PERCENT + '%';
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { key: col, className: (0, _classnames2.default)(_Table2.default.CellMaster, _defineProperty({}, _Table2.default.NotMatch, !mark)) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Table2.default.Stretch, _Table2.default.Cell), style: style },
	          this.renderCellContent(cell, true)
	        )
	      );
	    }
	  }, {
	    key: 'renderCell',
	    value: function renderCell(cell) {
	      var col = cell.col,
	          mark = cell.mark;
	
	      return _react2.default.createElement(
	        'div',
	        { key: col, className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.Cell, _defineProperty({}, _Table2.default.NotMatch, !mark)) },
	        this.renderCellContent(cell)
	      );
	    }
	  }, {
	    key: 'renderRows',
	    value: function renderRows() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          rows = _props3.rows,
	          page = _props3.page,
	          pageSize = _props3.pageSize;
	
	
	      return rows.map(function (row, rowIndex) {
	        return _react2.default.createElement(
	          'div',
	          { key: rowIndex, className: _Table2.default.Row },
	          _this3.renderRowNumCell(row),
	          data[rowIndex].cells.map(function (cell, columnIndex) {
	            if (cell == null) {
	              return _this3.renderFantomCell(columnIndex);
	            } else if (cell.colspan > 1 || cell.rowspan > 1) {
	              return _this3.renderStretchedCell(cell);
	            }
	            return _this3.renderCell(cell);
	          }).slice(page * pageSize, (page + 1) * pageSize)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          wide = _props4.wide,
	          rows = _props4.rows,
	          cols = _props4.cols,
	          print = _props4.print,
	          zoom = _props4.zoom;
	
	
	      var zoomStyle = {
	        transform: 'scale(' + zoom + ')',
	        position: 'relative',
	        transformOrigin: '0 0'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseDown: this.handleMouseDown,
	          style: {
	            cursor: this.state.dragging ? '-webkit-grabbing' : 'default'
	          },
	          className: (0, _classnames2.default)(_Table2.default.Table, 'custom-scrollbar', _defineProperty({}, _Table2.default.TablePrint, print), className),
	          ref: 'table'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Table2.default.Inner, _defineProperty({}, _Table2.default.Wide, wide)), style: zoomStyle },
	          _react2.default.createElement(
	            'div',
	            { className: _Table2.default.Header },
	            rows.length || cols.length ? _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Table2.default.CellMaster, _Table2.default.Appendicitis) },
	              _react2.default.createElement('div', { className: _Table2.default.CellContent })
	            ) : null,
	            this.renderHeaderCells()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Table2.default.Data },
	            _react2.default.createElement(
	              'div',
	              { className: _Table2.default.Rows },
	              this.renderRows()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	exports.default = Table;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Table = __webpack_require__(916);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table2.default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TableOptions = __webpack_require__(1340);
	
	var _TableOptions2 = _interopRequireDefault(_TableOptions);
	
	var _Switcher = __webpack_require__(507);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _th = __webpack_require__(659);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _thList = __webpack_require__(658);
	
	var _thList2 = _interopRequireDefault(_thList);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableOptions = function (_Component) {
	  _inherits(TableOptions, _Component);
	
	  function TableOptions() {
	    _classCallCheck(this, TableOptions);
	
	    return _possibleConstructorReturn(this, (TableOptions.__proto__ || Object.getPrototypeOf(TableOptions)).apply(this, arguments));
	  }
	
	  _createClass(TableOptions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          handleList = _props.handleList,
	          handleExtended = _props.handleExtended,
	          isTable = _props.isTable,
	          isExtended = _props.isExtended,
	          client = _props.client,
	          t = _props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_TableOptions2.default.TableOptions, className) },
	        _react2.default.createElement(
	          'div',
	          {
	            className: _TableOptions2.default.Checkbox,
	            'data-tip': t('components.building.tableOptions.tip'),
	            'data-for': 'global'
	          },
	          isTable ? _react2.default.createElement(_Checkbox2.default, {
	            innerStyle: _TableOptions2.default.ChessCheckInner,
	            text: t('components.building.tableOptions.checkbox'),
	            handle: handleExtended,
	            checked: isExtended,
	            classNameClone: 'ExtendedChess'
	          }) : ''
	        ),
	        client ? _react2.default.createElement(
	          'div',
	          { className: _TableOptions2.default.Switcher },
	          _react2.default.createElement(_Switcher2.default, {
	            defaultChecked: isTable,
	            leftIcon: _react2.default.createElement(_th2.default, null),
	            rightIcon: _react2.default.createElement(_thList2.default, null),
	            elementStyle: 'Round',
	            onClick: handleList
	          })
	        ) : null
	      );
	    }
	  }]);
	
	  return TableOptions;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(TableOptions);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableOptions = __webpack_require__(918);
	
	var _TableOptions2 = _interopRequireDefault(_TableOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TableOptions2.default;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Chess = __webpack_require__(908);
	
	var _Chess2 = _interopRequireDefault(_Chess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chess2.default;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _InaccuracyReportDialog = __webpack_require__(1342);
	
	var _InaccuracyReportDialog2 = _interopRequireDefault(_InaccuracyReportDialog);
	
	var _environment = __webpack_require__(19);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _building = __webpack_require__(54);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reselect = __webpack_require__(44);
	
	var _ga = __webpack_require__(7);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InaccuracyReportDialog = function (_Component) {
	  _inherits(InaccuracyReportDialog, _Component);
	
	  function InaccuracyReportDialog(props) {
	    _classCallCheck(this, InaccuracyReportDialog);
	
	    var _this = _possibleConstructorReturn(this, (InaccuracyReportDialog.__proto__ || Object.getPrototypeOf(InaccuracyReportDialog)).call(this, props));
	
	    _this.trackGAEvent = function () {
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building;
	      var inaccuracyReportText = _this.state.inaccuracyReportText;
	
	
	      if (inaccuracyReportText.length >= 2) {
	        (0, _ga.trackGA)(_ga.gaEvent.buildingInaccuracyReportInput({
	          eventContent: building.title,
	          productType: objectType,
	          productName: building.title,
	          productID: building.id,
	          user_id: profile.id
	        }));
	      }
	    };
	
	    _this.handleTextChange = function (event) {
	      var value = event.target.value;
	
	      if (value.length <= 500) {
	        _this.setState({
	          inaccuracyReportText: value
	        });
	      }
	      _this.debouncedTrackGA();
	    };
	
	    _this.handleCreateReportClick = function (e) {
	      e.preventDefault();
	      var _this$props2 = _this.props,
	          building = _this$props2.building,
	          phone = _this$props2.phone;
	      var inaccuracyReportText = _this.state.inaccuracyReportText;
	
	
	      _tracker2.default.sendEvent('Web_Card_Report_About_Inaccuracy', { телефон: phone });
	      _this.handleTrackButtonClickEvent({ buttonName: 'otpravit' });
	
	      if (building && inaccuracyReportText) {
	        _this.props.createInaccuracyReport({
	          id: building.id,
	          message: inaccuracyReportText
	        }).then(function () {
	          _this.setState({ reportSendedSuccess: true });
	        }).catch(function (error) {
	          console.error(error);
	        });
	      }
	    };
	
	    _this.handleClosePopup = function () {
	      _this.props.setPopUp();
	    };
	
	    _this.handleTrackButtonClickEvent = function (_ref) {
	      var buttonName = _ref.buttonName;
	      var _this$props3 = _this.props,
	          profile = _this$props3.profile,
	          objectType = _this$props3.objectType,
	          building = _this$props3.building;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.buildingInaccuracyReportButtonsClick({
	        eventLabel: buttonName,
	        eventContent: building.title,
	        productType: objectType,
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.initialState = {
	      inaccuracyReportText: '',
	      reportSendedSuccess: false
	    };
	    _this.state = _this.initialState;
	    _this.debouncedTrackGA = (0, _lodash2.default)(_this.trackGAEvent, 3000);
	    return _this;
	  }
	
	  _createClass(InaccuracyReportDialog, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props = this.props,
	          profile = _props.profile,
	          objectType = _props.objectType,
	          building = _props.building;
	
	
	      if (!this.state.reportSendedSuccess) {
	        (0, _ga.trackGA)(_ga.gaEvent.buildingInaccuracyReportButtonsClick({
	          eventLabel: 'zakryt',
	          eventContent: building.title,
	          productType: objectType,
	          productName: building.title,
	          productID: building.id,
	          user_id: profile.id
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var t = this.props.t;
	      var _state = this.state,
	          inaccuracyReportText = _state.inaccuracyReportText,
	          reportSendedSuccess = _state.reportSendedSuccess;
	
	      var textLength = inaccuracyReportText.length;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _InaccuracyReportDialog2.default.PopupContent },
	          reportSendedSuccess ? _react2.default.createElement(
	            'div',
	            { className: _InaccuracyReportDialog2.default.DoneWrap },
	            _react2.default.createElement(
	              'div',
	              { className: _InaccuracyReportDialog2.default.DoneTitle },
	              t('components.building.main.inaccuracyReportDialog.reportSended')
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: (0, _classnames2.default)(_InaccuracyReportDialog2.default.ActionBtn, _InaccuracyReportDialog2.default.InaccuracyReportButton, 'button-primary', 'button-primary--md'),
	                onClick: function onClick() {
	                  _this2.handleClosePopup();
	                }
	              },
	              t('components.building.main.inaccuracyReportDialog.done')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _InaccuracyReportDialog2.default.PopupTitle },
	              t('components.building.main.inaccuracyReportDialog.title')
	            ),
	            _react2.default.createElement('div', { className: _InaccuracyReportDialog2.default.Divider }),
	            _react2.default.createElement(
	              'div',
	              { className: _InaccuracyReportDialog2.default.PopupSubtitle },
	              t('components.building.main.inaccuracyReportDialog.subtitle')
	            ),
	            _react2.default.createElement(
	              'form',
	              {
	                className: (0, _classnames2.default)(_InaccuracyReportDialog2.default.InaccuracyReportForm),
	                onSubmit: this.handleCreateReportClick
	              },
	              _react2.default.createElement('textarea', {
	                className: (0, _classnames2.default)(_InaccuracyReportDialog2.default.InaccuracyReportTextArea),
	                placeholder: t('components.building.main.inaccuracyReportDialog.textAreaPlaceholder'),
	                onChange: this.handleTextChange,
	                maxLength: 500,
	                onInput: function onInput(e) {
	                  e.target.style.height = 'auto';
	                  e.target.style.height = e.target.scrollHeight + 'px';
	                },
	                rows: 2
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_InaccuracyReportDialog2.default.ReportHelperText) },
	                textLength >= 500 ? t('components.building.main.inaccuracyReportDialog.noCharsLeft') : ''
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: (0, _classnames2.default)(_InaccuracyReportDialog2.default.ActionBtn, _InaccuracyReportDialog2.default.InaccuracyReportButton, 'button-primary', 'button-primary--md'),
	                  disabled: textLength < 10
	                },
	                t('components.building.main.inaccuracyReportDialog.button')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InaccuracyReportDialog;
	}(_react.Component);
	
	var userSelector = (0, _reselect.createSelector)(function (state) {
	  return state.profile;
	}, function (profile) {
	  return _extends({}, profile);
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(userSelector, {
	  setPopUp: _environment.setPopUp,
	  createInaccuracyReport: _building.createInaccuracyReport
	})(InaccuracyReportDialog));

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InaccuracyReportDialog = __webpack_require__(921);
	
	var _InaccuracyReportDialog2 = _interopRequireDefault(_InaccuracyReportDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InaccuracyReportDialog2.default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _About = __webpack_require__(1343);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var checkIsNotEmty = function checkIsNotEmty(data) {
	  if (!data) {
	    return false;
	  }
	
	  return data.name !== undefined && data.name !== null;
	};
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, About);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = About.__proto__ || Object.getPrototypeOf(About)).call.apply(_ref, [this].concat(args))), _this), _this.handleTrackEvent = function (_ref2) {
	      var eventLabel = _ref2.eventLabel;
	      var _this$props = _this.props,
	          building = _this$props.building,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.buildingInfoBlocksShow({
	        eventLabel: eventLabel,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(About, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleTrackEvent({ eventLabel: 'obshchie_harakteristiki' });
	      this.handleTrackEvent({ eventLabel: 'kommunikacii' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          building = _props.building,
	          client = _props.client,
	          print = _props.print,
	          t = _props.t,
	          currency = _props.currency;
	      var data = building.data;
	
	
	      function renderParking() {
	        var _data$parking = data.parking,
	            house_parking = _data$parking.house_parking,
	            parking_underground = _data$parking.parking_underground,
	            parking_multilevel = _data$parking.parking_multilevel,
	            parking_type_roofed = _data$parking.parking_type_roofed;
	
	        var arr = [];
	
	        house_parking ? arr.push(t('components.building.main.about.houseParking')) : null;
	        parking_underground ? arr.push(t('components.building.main.about.parkingUnderground')) : null;
	        parking_multilevel ? arr.push(t('components.building.main.about.parkingMultilevel')) : null;
	        parking_type_roofed ? arr.push(t('components.building.main.about.parkingTypeRoofed')) : null;
	
	        if (arr.length === 0) {
	          return null;
	        }
	
	        var text = arr.join(', ');
	        text = text[0].toUpperCase() + text.slice(1);
	
	        return text;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_About2.default.About, className, _defineProperty({}, _About2.default.Client, this.props.client), _defineProperty({}, _About2.default.Print, print)) },
	        _react2.default.createElement(
	          'div',
	          { className: client ? _About2.default.InnerClient : _About2.default.Inner },
	          (0, _helper.isSectionAllowed)('characteristics') && _react2.default.createElement(
	            'div',
	            { className: client ? _About2.default.InfoBlockClient : _About2.default.InfoBlock },
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.AboutTitle },
	              client ? _react2.default.createElement(
	                'span',
	                null,
	                t('components.building.main.about.commonInfo')
	              ) : _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.NotMobile },
	                  t('components.building.main.about.commonInfo')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.OnlyMobile },
	                  t('components.building.main.about.info')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.InfoBlockInner },
	              checkIsNotEmty(data.class) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.class')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.class.name
	                )
	              ),
	              checkIsNotEmty(data.material) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.material')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.material.name
	                )
	              ),
	              data.type_id != 2 && checkIsNotEmty(data.types) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.type')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.types.name
	                )
	              ),
	              checkIsNotEmty(data.houseRoad) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.houseRoad')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.houseRoad.name
	                )
	              ),
	              renderParking() && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.parking')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.Park },
	                    renderParking()
	                  )
	                )
	              ),
	              data.house_territory && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.territory')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.house_territory
	                )
	              ),
	              !!data.distance_sea && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.distanceSea')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.distance_sea,
	                  '  ',
	                  t('components.building.main.about.meters')
	                )
	              ),
	              !!data.ceiling_height && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.cealingHeight')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.ceiling_height,
	                  ' ',
	                  t('components.building.main.about.meters')
	                )
	              ),
	              !!data.service_cost && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.serviceCost')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.service_cost,
	                  ' ',
	                  t('components.building.main.about.cost', { currency: currency })
	                )
	              )
	            )
	          ),
	          this.props.children,
	          (0, _helper.isSectionAllowed)('communications') && _react2.default.createElement(
	            'div',
	            { className: client ? _About2.default.InfoBlockClient : _About2.default.InfoBlock },
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.AboutTitle },
	              t('components.building.main.about.communication')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.InfoBlockInner },
	              checkIsNotEmty(data.gas) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.gas')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.gas && data.gas.name || '-'
	                )
	              ),
	              checkIsNotEmty(data.heating) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.heating')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.heating && data.heating.name || '-'
	                )
	              ),
	              checkIsNotEmty(data.electricity) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.electricity')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.electricity && data.electricity.name || '-'
	                )
	              ),
	              checkIsNotEmty(data.sewage) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.sewage')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.sewage && data.sewage.name || '-'
	                )
	              ),
	              checkIsNotEmty(data.water) && _react2.default.createElement(
	                'div',
	                { className: client ? _About2.default.InfoItemClient : _About2.default.InfoItem },
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Title },
	                  t('components.building.main.about.water')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _About2.default.Description },
	                  data.water && data.water.name || '-'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	;
	
	exports.default = (0, _reactI18next.withTranslation)()(About);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _utils = __webpack_require__(12);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _ChessLink = __webpack_require__(1344);
	
	var _ChessLink2 = _interopRequireDefault(_ChessLink);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChessLink = function (_Component) {
	  _inherits(ChessLink, _Component);
	
	  function ChessLink() {
	    _classCallCheck(this, ChessLink);
	
	    return _possibleConstructorReturn(this, (ChessLink.__proto__ || Object.getPrototypeOf(ChessLink)).apply(this, arguments));
	  }
	
	  _createClass(ChessLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          prevLocation = _props.prevLocation,
	          _props$match = _props.match,
	          match = _props$match === undefined ? {} : _props$match,
	          data = _props.building.data,
	          t = _props.t;
	      var url = match.url;
	
	      var prev = (0, _utils.parseQuery)(prevLocation);
	      var filters = sessionStorage.getItem('filtersUrl');
	
	      var _ref = filters ? (0, _utils.parseQuery)(filters.slice(2)) : {},
	          priceMin = _ref.priceMin,
	          priceMax = _ref.priceMax,
	          costMin = _ref.costMin,
	          costMax = _ref.costMax,
	          areaFrom = _ref.areaFrom,
	          areaTo = _ref.areaTo,
	          interior = _ref.interior,
	          view_type = _ref.view_type;
	
	      var fromBuilding = true;
	      var table = data.type_id == 2 ? 'list' : 'common';
	      var from = 'building';
	      var filtersSearch = (0, _utils.compileQuery)(_extends({ priceMin: priceMin, priceMax: priceMax, costMin: costMin, costMax: costMax, areaFrom: areaFrom, interior: interior, areaTo: areaTo, view_type: view_type }, prev, { fromBuilding: fromBuilding, table: table, from: from }));
	
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        { className: (0, _classnames2.default)(_ChessLink2.default.ChessBtn, className, 'button-primary', 'button-primary--lg'), to: url + '/chess?' + filtersSearch },
	        _react2.default.createElement(
	          'span',
	          { className: _ChessLink2.default.Hide1024 },
	          data.type_id !== 2 ? t('components.building.main.chessLink.seeChess') : t('components.building.main.chessLink.seeList')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _ChessLink2.default.Show1024 },
	          data.type_id !== 2 ? t('components.building.main.chessLink.chess') : t('components.building.main.chessLink.list')
	        )
	      );
	    }
	  }]);
	
	  return ChessLink;
	}(_react.Component);
	
	var prevLocationSelector = function prevLocationSelector(state) {
	  return state.building.prevLocation;
	};
	
	var chessLinkSelector = (0, _reselect.createSelector)(prevLocationSelector, function (prevLocation) {
	  return {
	    prevLocation: prevLocation
	  };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(chessLinkSelector)(ChessLink));

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChessLink = __webpack_require__(924);
	
	var _ChessLink2 = _interopRequireDefault(_ChessLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ChessLink2.default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChessLinkContainer(_ref) {
	  var className = _ref.className,
	      prevLocation = _ref.prevLocation,
	      _ref$match = _ref.match,
	      match = _ref$match === undefined ? {} : _ref$match,
	      children = _ref.children,
	      query = _ref.query;
	  var url = match.url;
	
	  var prev = (0, _utils.parseQuery)(prevLocation);
	  var filters = sessionStorage.getItem('filtersUrl');
	
	  var _ref2 = filters ? (0, _utils.parseQuery)(filters.slice(2)) : {},
	      priceMin = _ref2.priceMin,
	      priceMax = _ref2.priceMax,
	      costMin = _ref2.costMin,
	      costMax = _ref2.costMax,
	      areaFrom = _ref2.areaFrom,
	      areaTo = _ref2.areaTo,
	      interior = _ref2.interior,
	      view_type = _ref2.view_type;
	
	  var filtersSearch = (0, _utils.compileQuery)(_extends({
	    priceMin: priceMin,
	    priceMax: priceMax,
	    costMin: costMin,
	    costMax: costMax,
	    areaFrom: areaFrom,
	    areaTo: areaTo,
	    interior: interior,
	    view_type: view_type
	  }, prev));
	  return _react2.default.createElement(
	    _reactRouterDom.Link,
	    { className: className, to: url + '/chess?' + query + '&' + filtersSearch },
	    children
	  );
	}
	
	var prevLocationSelector = function prevLocationSelector(state) {
	  return state.building.prevLocation;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    prevLocation: prevLocationSelector(state)
	  };
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(ChessLinkContainer));

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChessLinkContainer = __webpack_require__(926);
	
	var _ChessLinkContainer2 = _interopRequireDefault(_ChessLinkContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ChessLinkContainer2.default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _collections = __webpack_require__(49);
	
	var _environment = __webpack_require__(19);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collections = __webpack_require__(1345);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _CollectionsDialog = __webpack_require__(162);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collections = function (_Component) {
	  _inherits(Collections, _Component);
	
	  function Collections() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Collections);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Collections.__proto__ || Object.getPrototypeOf(Collections)).call.apply(_ref, [this].concat(args))), _this), _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          building = _this$props.building;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || building.data.title,
	        productType: objectType,
	        productName: building.data.title,
	        productID: building.data.id,
	        user_id: profile.id
	      }));
	    }, _this.handleClick = function () {
	      var _this$props2 = _this.props,
	          onClick = _this$props2.onClick,
	          profile = _this$props2.profile,
	          objectType = _this$props2.objectType;
	
	
	      if (onClick) {
	        onClick();
	      }
	
	      _this.props.setPopUp(_react2.default.createElement(_CollectionsDialog2.default, {
	        building: _this.props.building,
	        profile: profile,
	        objectType: objectType
	      }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false,
	        onClose: function onClose() {
	          return _this.handleTrackEvent({
	            eventName: 'buildingCollectionDialogButtonsClick',
	            eventLabel: 'zakryt'
	          });
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Collections, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Collections2.default.Collections, className) },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _Collections2.default.ButtonAddToCollection,
	            onClick: this.handleClick,
	            'data-tip': t('components.building.main.collections.add'),
	            'data-for': 'global'
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', null),
	            _react2.default.createElement('i', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Collections;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return state.profile;
	}, {
	  createCollection: _collections.createCollection,
	  setPopUp: _environment.setPopUp
	})(Collections));

/***/ }),
/* 929 */
[2395, 928],
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _collections = __webpack_require__(49);
	
	var _environment = __webpack_require__(19);
	
	var _reselect = __webpack_require__(44);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CollectionsDialog = __webpack_require__(1346);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _ScrollLock = __webpack_require__(163);
	
	var _ScrollLock2 = _interopRequireDefault(_ScrollLock);
	
	var _Config = __webpack_require__(16);
	
	var _reactI18next = __webpack_require__(4);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _ga = __webpack_require__(7);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collections = function (_Component) {
	  _inherits(Collections, _Component);
	
	  function Collections(props) {
	    _classCallCheck(this, Collections);
	
	    var _this = _possibleConstructorReturn(this, (Collections.__proto__ || Object.getPrototypeOf(Collections)).call(this, props));
	
	    _this.handleBackClick = function (e) {
	      _this.setState({
	        newCollection: false
	      });
	    };
	
	    _this.handleNewCollectionClick = function (e) {
	      var _this$props = _this.props,
	          chessId = _this$props.chessId,
	          building = _this$props.building;
	
	
	      _this.handleTrackEvent({
	        eventName: 'buildingCollectionDialogButtonsClick',
	        eventLabel: 'sozdat_podborku'
	      });
	
	      if (chessId) {
	        _tracker2.default.sendEvent('Web_Lots_AddToNewCollection', {
	          id: building.data.id,
	          title: building.data.title
	        });
	      }
	
	      _this.setState({
	        newCollection: true
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var collectionName = e.target.value;
	
	      _this.setState({
	        collectionName: collectionName
	      });
	
	      if (collectionName.length >= 2) {
	        _this.debouncedTrackEventInput();
	      } else {
	        _this.debouncedTrackEventInput.cancel();
	      }
	    };
	
	    _this.handleCreateClick = function (e) {
	      e.preventDefault();
	      _this.props.createCollection({
	        // userUid: this.props.userUid,
	        name: _this.state.collectionName
	      });
	      _this.setState(_this.initialState);
	    };
	
	    _this.handleReadyClick = function (e) {
	      _this.props.setPopUp();
	      _this.handleTrackEvent({
	        eventName: 'buildingCollectionDialogButtonsClick',
	        eventLabel: 'gotovo'
	      });
	    };
	
	    _this.handleClick = function (_ref) {
	      var isChecked = _ref.isChecked,
	          referal = _ref.referal,
	          collectionName = _ref.collectionName;
	      var _this$props2 = _this.props,
	          chessId = _this$props2.chessId,
	          building = _this$props2.building,
	          profile = _this$props2.profile;
	      var userUid = _this.props.userUid;
	      var buildingId = building.data.id;
	
	
	      var meta = {
	        collectionName: collectionName,
	        buildingName: building.data.title,
	        data: building.data,
	        profileId: profile.id
	      };
	
	      var data = {
	        referal: referal,
	        userUid: userUid,
	        buildingId: buildingId
	      };
	
	      if (chessId) {
	        data.chessId = chessId;
	      }
	
	      if (!isChecked) {
	        _this.props.addToCollection(data, meta).then(function () {
	          return _this.props.loadCollections({ userUid: userUid }, true);
	        });
	        _this.handleTrackEvent({
	          eventName: 'buildingPickCollectionButtonClick',
	          eventContent: [collectionName, ' | on']
	        });
	        return;
	      }
	
	      if (chessId) {
	        _this.props.removeChessFromCollection(data, meta).then(function () {
	          return _this.props.loadCollections({ userUid: userUid }, true);
	        });
	        return;
	      }
	
	      _this.props.removeFromCollection(data, meta).then(function () {
	        return _this.props.loadCollections({ userUid: userUid }, true);
	      });
	      _this.handleTrackEvent({
	        eventName: 'buildingPickCollectionButtonClick',
	        eventContent: [collectionName, ' | off']
	      });
	    };
	
	    _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent;
	      var _this$props3 = _this.props,
	          profile = _this$props3.profile,
	          objectType = _this$props3.objectType,
	          building = _this$props3.building;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || building.data.title,
	        productType: objectType,
	        productName: building.data.title,
	        productID: building.data.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.initialState = {
	      buildingChecked: false,
	      newCollection: false,
	      collectionName: ''
	    };
	    _this.state = _this.initialState;
	
	    _this.debouncedTrackEventInput = (0, _lodash2.default)(function () {
	      return _this.handleTrackEvent({
	        eventName: 'buildingCollectionDialogInput',
	        eventLabel: 'novaya_podborka'
	      });
	    }, 3000);
	    return _this;
	  }
	
	  _createClass(Collections, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          userUid = _props.userUid,
	          chessId = _props.chessId;
	
	      this.props.loadCollections({ userUid: userUid }).then(function () {
	        var data = {
	          buildingId: _this2.props.building.data.id
	        };
	
	        if (chessId) {
	          data.chessId = chessId;
	        }
	
	        return _this2.props.checkBuilding(data);
	      }).then(function () {
	        return _this2.setState({
	          buildingChecked: true
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dialogClosed();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          collections = _props2.collections,
	          building = _props2.building,
	          t = _props2.t;
	      var status = building.data.status;
	
	
	      var pavilions = building.data.pavilions;
	      var statusClass = void 0;
	      var deadline = void 0;
	
	      if (pavilions) {
	        var year = void 0,
	            quarter = void 0;
	        var check = 20994; // 2099 г. 4 кв.
	        var finished = (pavilions || []).some(function (pavilion) {
	          var construction_finished = pavilion.construction_finished,
	              year_built = pavilion.year_built,
	              construction_ending = pavilion.construction_ending;
	
	          var current = Number('' + year_built + construction_ending);
	          if (year_built && construction_ending && check > current) {
	            check = current;
	            year = year_built;quarter = construction_ending;
	          }
	          return construction_finished;
	        });
	        deadline = finished ? t('components.building.main.collectionDialog.finished') : year === 0 ? t('components.building.main.collectionDialog.inProgress') : year && quarter ? quarter + ' / ' + year : '';
	        statusClass = finished ? _CollectionsDialog2.default.Finished : _CollectionsDialog2.default.NotFinished;
	      } else {
	        var year_built = building.data.year_built;
	        var construction_ending = building.data.construction_ending;
	        var construction_finished = building.data.construction_finished;
	        statusClass = construction_finished ? _CollectionsDialog2.default.Finished : _CollectionsDialog2.default.NotFinished;
	        deadline = construction_finished ? t('components.building.main.collectionDialog.finishedBIG') : '' + (year_built !== 0 ? (construction_ending ? construction_ending + ' / ' : '') + year_built : t('components.building.main.collectionDialog.inProgress'));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        collections ? Object.keys(collections).length ? _react2.default.createElement(
	          'div',
	          { className: _CollectionsDialog2.default.PopupContent },
	          _react2.default.createElement(
	            'div',
	            { className: _CollectionsDialog2.default.PopupTitle },
	            t('components.building.main.collectionDialog.add')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _CollectionsDialog2.default.ObjectInfo },
	            building.data.image ? _react2.default.createElement(
	              'div',
	              { className: _CollectionsDialog2.default.ObjectInfoImage },
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + building.data.image.id + '&size=small',
	                alt: ''
	              })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _CollectionsDialog2.default.ObjectInfoText },
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ObjectInfoTitle },
	                building.data.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ObjectInfoAddress },
	                building.data.subregion ? building.data.subregion.name : building.data.microregion,
	                ', ',
	                building.data.address
	              )
	            ),
	            status == 3 ? _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_CollectionsDialog2.default.ObjectInfoStatus, _CollectionsDialog2.default.AlmostFinished) },
	              t('components.building.main.collectionDialog.almostFinished')
	            ) : _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_CollectionsDialog2.default.ObjectInfoStatus, statusClass) },
	              deadline
	            )
	          ),
	          _react2.default.createElement(
	            _ScrollLock2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_CollectionsDialog2.default.PopupCollections, _defineProperty({}, _CollectionsDialog2.default.NewCollection, this.state.newCollection), 'custom-scrollbar') },
	              this.state.buildingChecked || true ? Object.values(collections).sort(function (a, b) {
	                return +a.id < +b.id ? 1 : -1;
	              }).map(function (_ref3) {
	                var id = _ref3.id,
	                    referal = _ref3.referal,
	                    name = _ref3.name,
	                    photos = _ref3.photos,
	                    includesCurrentBuilding = _ref3.includesCurrentBuilding,
	                    _ref3$total = _ref3.total,
	                    total = _ref3$total === undefined ? 0 : _ref3$total;
	                return _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_CollectionsDialog2.default.CheckItem), key: id },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _CollectionsDialog2.default.Checkbox },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      classNameClone: 'CheckboxClonePrint',
	                      text: _react2.default.createElement(
	                        'span',
	                        null,
	                        name
	                      ),
	                      checked: includesCurrentBuilding,
	                      handle: function handle() {
	                        return _this3.handleClick({
	                          collectionName: name,
	                          isChecked: includesCurrentBuilding,
	                          referal: referal
	                        });
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _CollectionsDialog2.default.TotalObjects },
	                    t('components.building.main.collectionDialog.total', { total: total })
	                  )
	                );
	              }) : _react2.default.createElement('div', { className: _CollectionsDialog2.default.Loader })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _CollectionsDialog2.default.PopupActions },
	            this.state.newCollection ? _react2.default.createElement(
	              'form',
	              { className: _CollectionsDialog2.default.ActionCreateCollection, onSubmit: this.handleCreateClick },
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionCreateCollectionTop },
	                t('components.building.main.collectionDialog.createNew'),
	                _react2.default.createElement(
	                  'span',
	                  { className: _CollectionsDialog2.default.ActionBack, onClick: this.handleBackClick },
	                  _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionCreateCollectionBottom },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: _CollectionsDialog2.default.CreateCollectionInput,
	                  placeholder: t('components.building.main.collectionDialog.enterName'),
	                  onChange: this.handleChange
	                }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: (0, _classnames2.default)(_CollectionsDialog2.default.ActionBtn, _CollectionsDialog2.default.CreateCollectionButton, 'button-primary', 'button-primary--md'),
	                    disabled: !this.state.collectionName
	                  },
	                  t('components.building.main.collectionDialog.button')
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionCreateButton },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.handleNewCollectionClick },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', null),
	                    _react2.default.createElement('i', null)
	                  ),
	                  t('components.building.main.collectionDialog.button')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionDone },
	                _react2.default.createElement(
	                  'button',
	                  { className: (0, _classnames2.default)(_CollectionsDialog2.default.ActionBtn, 'button-primary', 'button-primary--md'), onClick: this.handleReadyClick },
	                  t('components.building.main.collectionDialog.done')
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_CollectionsDialog2.default.PopupContent, _CollectionsDialog2.default.NoCollections) },
	          _react2.default.createElement(
	            'div',
	            { className: _CollectionsDialog2.default.NoCollectionsContent },
	            _react2.default.createElement('img', { className: (0, _classnames2.default)(_CollectionsDialog2.default.NoCollectionsImage), src: _nothingfound2.default, alt: 'nothing found' }),
	            _react2.default.createElement(
	              'div',
	              { className: _CollectionsDialog2.default.NoCollectionsTitle },
	              t('components.building.main.collectionDialog.empty')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _CollectionsDialog2.default.NoCollectionsText },
	              t('components.building.main.collectionDialog.description')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_CollectionsDialog2.default.PopupActions, _CollectionsDialog2.default.NoCollections) },
	            _react2.default.createElement(
	              'form',
	              { className: _CollectionsDialog2.default.ActionCreateCollection, onSubmit: this.handleCreateClick },
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionCreateCollectionTop },
	                t('components.building.main.collectionDialog.createNew')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _CollectionsDialog2.default.ActionCreateCollectionBottom },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: (0, _classnames2.default)(_CollectionsDialog2.default.CreateCollectionInput),
	                  placeholder: t('components.building.main.collectionDialog.enterName'),
	                  onChange: this.handleChange
	                }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: (0, _classnames2.default)(_CollectionsDialog2.default.ActionBtn, _CollectionsDialog2.default.CreateCollectionButton, 'button-primary', 'button-primary--md'),
	                    disabled: !this.state.collectionName
	                  },
	                  t('components.building.main.collectionDialog.button')
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement('div', { className: _CollectionsDialog2.default.Loader })
	      );
	    }
	  }]);
	
	  return Collections;
	}(_react.Component);
	
	var collectionsDialogSelector = (0, _reselect.createSelector)(function (state) {
	  return state.profile;
	}, function (state) {
	  return state.collections.data;
	}, function (profile, collections) {
	  return {
	    userUid: profile.hash,
	    collections: collections
	  };
	});
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(collectionsDialogSelector, {
	  loadCollections: _collections.loadCollections,
	  createCollection: _collections.createCollection,
	  addToCollection: _collections.addToCollection,
	  removeFromCollection: _collections.removeFromCollection,
	  removeChessFromCollection: _collections.removeChessFromCollection,
	  checkBuilding: _collections.checkBuilding,
	  setPopUp: _environment.setPopUp,
	  dialogClosed: function dialogClosed() {
	    return { type: 'CLOSE_COLLECTIONS_DIALOG' };
	  }
	})(Collections));

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Contacts = __webpack_require__(1347);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _environment = __webpack_require__(19);
	
	var _utils = __webpack_require__(12);
	
	var _iconUser = __webpack_require__(549);
	
	var _iconUser2 = _interopRequireDefault(_iconUser);
	
	var _iconLink = __webpack_require__(1545);
	
	var _iconLink2 = _interopRequireDefault(_iconLink);
	
	var _telegramIcon = __webpack_require__(1562);
	
	var _telegramIcon2 = _interopRequireDefault(_telegramIcon);
	
	var _whatsappIcon = __webpack_require__(1570);
	
	var _whatsappIcon2 = _interopRequireDefault(_whatsappIcon);
	
	var _reactI18next = __webpack_require__(4);
	
	var _AppointmentButton = __webpack_require__(900);
	
	var _AppointmentButton2 = _interopRequireDefault(_AppointmentButton);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ga = __webpack_require__(7);
	
	var _building = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var renderContactList = function renderContactList(official_site, link, list, t, print) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Contacts2.default.List, _defineProperty({}, _Contacts2.default.ContactsPrint, print)) },
	    _react2.default.createElement(
	      'div',
	      { className: _Contacts2.default.Header },
	      t('components.building.main.contacts.contacts')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Contacts2.default.InnerWrap },
	      list,
	      official_site ? _react2.default.createElement(
	        'a',
	        { href: link, className: (0, _classnames2.default)(_Contacts2.default.SiteLink, _Contacts2.default.OnlyMobile), target: '_blank' },
	        t('components.building.main.contacts.site'),
	        _react2.default.createElement('img', { src: _iconLink2.default, alt: '' })
	      ) : ''
	    )
	  );
	};
	
	var Contacts = function Contacts(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      print = _ref.print,
	      objectType = _ref.objectType,
	      profile = _ref.profile;
	  var _building$data = building.data,
	      official_site = _building$data.official_site,
	      availability_record = _building$data.availability_record,
	      sales_offices = _building$data.sales_offices,
	      title = _building$data.title,
	      id = _building$data.id;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var hasValidContacts = Array.isArray(sales_offices) && sales_offices.length > 0 && sales_offices.some(function (office) {
	    return Array.isArray(office.users) && office.users.some(function (user) {
	      return user.phone || user.telegram || user.whatsapp;
	    });
	  });
	
	  var handleTrackEvent = function handleTrackEvent(_ref2) {
	    var eventLabel = _ref2.eventLabel;
	
	    (0, _ga.trackGA)(_ga.gaEvent.contactsDialogButtonsClick({
	      eventLabel: eventLabel,
	      eventContent: title,
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  var list = sales_offices.flatMap(function (office, index) {
	    return office.users.map(function (user, userIndex) {
	      return _react2.default.createElement(
	        'div',
	        { className: _Contacts2.default.Inner, key: index + '-' + userIndex },
	        _react2.default.createElement(
	          'div',
	          { className: _Contacts2.default.Top },
	          _react2.default.createElement(
	            'div',
	            { className: _Contacts2.default.Avatar },
	            _react2.default.createElement('img', { alt: 'contact-men', src: _iconUser2.default, className: _Contacts2.default.IconContact })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Contacts2.default.Column },
	            _react2.default.createElement(
	              'div',
	              { className: _Contacts2.default.Name },
	              user.first_name,
	              ' ',
	              user.last_name || ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Contacts2.default.Label },
	              user.position
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Contacts2.default.ContactGroup },
	          user.phone && _react2.default.createElement(
	            'a',
	            {
	              href: 'tel:' + user.phone.replace(/-|\s/g, ''),
	              className: _Contacts2.default.Phone,
	              onClick: function onClick() {
	                return handleTrackEvent({ eventLabel: 'telefon' });
	              }
	            },
	            (0, _utils.formatPhoneNumber)(user.phone)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Contacts2.default.IconGroup },
	            !print && user.telegram && _react2.default.createElement(
	              'a',
	              {
	                href: user.telegram,
	                target: '_blank',
	                rel: 'noopener noreferrer',
	                onClick: function onClick() {
	                  return handleTrackEvent({ eventLabel: 'telegram' });
	                }
	              },
	              _react2.default.createElement('img', { alt: 'telegram-icon', src: _telegramIcon2.default, className: _Contacts2.default.ContactIcon })
	            ),
	            !print && user.whatsapp && _react2.default.createElement(
	              'a',
	              {
	                href: user.whatsapp,
	                target: '_blank',
	                rel: 'noopener noreferrer',
	                onClick: function onClick() {
	                  return handleTrackEvent({ eventLabel: 'whatsapp' });
	                }
	              },
	              _react2.default.createElement('img', { alt: 'whatsapp-icon', src: _whatsappIcon2.default, className: _Contacts2.default.ContactIcon })
	            )
	          )
	        ),
	        user.email && _react2.default.createElement(
	          'div',
	          { className: _Contacts2.default.Item },
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + user.email, className: _Contacts2.default.Mail },
	            user.email
	          )
	        )
	      );
	    });
	  });
	
	  var link = 'http://' + official_site.replace(/http(s)?:\/\//, '');
	
	  var handleShowContacts = function handleShowContacts() {
	    (0, _ga.trackGA)(_ga.gaEvent.buildingRightMenuButtonsClick({
	      eventLabel: 'pokazat_kontakty',
	      eventContent: title,
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	
	    dispatch((0, _building.clickContact)({ objectId: id, userId: Number(profile.id) }));
	
	    dispatch((0, _environment.setPopUp)(renderContactList(official_site, link, list, t, false), {
	      closeStyleName: 'Default',
	      contentStyleName: 'Default',
	      closeIcon: 'default',
	      lockScroll: false
	    }));
	  };
	
	  if (print) {
	    return renderContactList(official_site, link, list, t, true);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Contacts2.default.Contacts, className, _defineProperty({}, _Contacts2.default.ContactsPrint, print)) },
	    _react2.default.createElement(
	      'h3',
	      { className: _Contacts2.default.Title },
	      t('components.building.main.contacts.contacts'),
	      official_site ? _react2.default.createElement(
	        'a',
	        { href: link, className: (0, _classnames2.default)(_Contacts2.default.SiteLink, _Contacts2.default.NotMobile), target: '_blank' },
	        t('components.building.main.contacts.site'),
	        _react2.default.createElement('img', { src: _iconLink2.default, alt: '' })
	      ) : ''
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Contacts2.default.Subtitle },
	      '\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430 \u0438 \u043E\u0442\u0434\u0435\u043B\u0430 \u043F\u0440\u043E\u0434\u0430\u0436'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Contacts2.default.ButtonsGroup },
	      hasValidContacts && _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)('button-primary', _Contacts2.default.ShowContactsButton),
	          onClick: handleShowContacts
	        },
	        t('components.building.main.contacts.showContacts')
	      ),
	      availability_record && _react2.default.createElement(_AppointmentButton2.default, {
	        buildingId: building.data.id,
	        profile: profile,
	        title: title,
	        objectType: objectType
	      }),
	      !hasValidContacts && !availability_record && _react2.default.createElement(
	        'div',
	        { className: _Contacts2.default.NotFound },
	        _react2.default.createElement(
	          'div',
	          { className: _Contacts2.default.NotFoundText },
	          t('components.building.main.contacts.empty')
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contacts;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Description = __webpack_require__(1348);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _helper = __webpack_require__(55);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = function (_Component) {
	  _inherits(Description, _Component);
	
	  function Description(props) {
	    _classCallCheck(this, Description);
	
	    var _this = _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel,
	          eventContent = _ref.eventContent;
	      var _this$props = _this.props,
	          building = _this$props.building,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      isHidden: true
	    };
	
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Description, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleTrackEvent({
	        eventName: 'buildingInfoBlocksShow',
	        eventLabel: 'opisanie'
	      });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick() {
	      var isHidden = this.state.isHidden;
	
	      this.handleTrackEvent({
	        eventName: 'buildingInfoBlocksExpand',
	        eventLabel: isHidden ? 'podrobnee' : 'svernut',
	        eventContent: 'opisanie'
	      });
	      this.setState({ isHidden: !isHidden });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          building = _props.building,
	          client = _props.client,
	          print = _props.print,
	          t = _props.t;
	      var _building$data2 = building.data,
	          description = _building$data2.description,
	          type_id = _building$data2.type_id;
	      var isHidden = this.state.isHidden;
	
	
	      return description ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Description2.default.DescriptionWrap, _defineProperty({}, _Description2.default.DescriptionWrapClient, client), _defineProperty({}, _Description2.default.DescriptionWrapPrint, print)) },
	        client ? _react2.default.createElement(
	          'p',
	          { className: _Description2.default.ClientDescriptionTitle },
	          t('components.building.main.description.about', { type: (0, _helper.getBuildingType)(type_id) })
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Description2.default.OnlyMobile, _Description2.default.DescriptionTitle) },
	          t('components.building.main.description.about', { type: (0, _helper.getBuildingType)(type_id) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: client ? _Description2.default.DescriptionClient : (0, _classnames2.default)(_Description2.default.Description, className) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Description2.default.Inner, _defineProperty({}, _Description2.default.isHidden, isHidden)) },
	            _react2.default.createElement('div', { className: _Description2.default.Text, dangerouslySetInnerHTML: { __html: description } }),
	            this.props.children
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: client ? (0, _classnames2.default)(_Description2.default.Button, _Description2.default.Button) : _Description2.default.Button, onClick: this.handleButtonClick },
	            _react2.default.createElement(
	              'span',
	              null,
	              isHidden ? client ? t('components.building.main.description.readMore') : t('components.building.main.description.more') : t('components.building.main.description.minimize'),
	              ' ',
	              _react2.default.createElement('i', { className: isHidden ? null : _Description2.default.Opened })
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Description;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Description);

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Developer = __webpack_require__(1349);
	
	var _Developer2 = _interopRequireDefault(_Developer);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Developer = function Developer(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      print = _ref.print;
	  var _building$data = building.data,
	      builder = _building$data.builder,
	      contractor = _building$data.contractor,
	      commission = _building$data.commission,
	      count_flats = _building$data.count_flats,
	      commission_note = _building$data.commission_note;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var renderRow = function renderRow(person, title) {
	    return person ? person.filter(function (_ref2) {
	      var name = _ref2.name;
	      return name;
	    }).map(function (_ref3) {
	      var name = _ref3.name;
	      return _react2.default.createElement(
	        'div',
	        { key: name, className: _Developer2.default.Row },
	        _react2.default.createElement(
	          'div',
	          { className: _Developer2.default.Name },
	          name
	        ),
	        title && _react2.default.createElement(
	          'div',
	          { className: _Developer2.default.Label },
	          title
	        )
	      );
	    }) : [];
	  };
	
	  var arr = [].concat(_toConsumableArray(renderRow(builder)), _toConsumableArray(renderRow(contractor, t('components.building.main.developer.contractor'))));
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_defineProperty({}, _Developer2.default.DeveloperPrintWrap, print)) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Developer2.default.Developer, className, _defineProperty({}, _Developer2.default.DeveloperPrint, print)) },
	      _react2.default.createElement(
	        'h3',
	        { className: _Developer2.default.Title },
	        t('components.building.main.developer.developer')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Developer2.default.Inner },
	        arr.length ? arr : _react2.default.createElement(
	          'div',
	          { className: _Developer2.default.Row },
	          _react2.default.createElement(
	            'div',
	            { className: _Developer2.default.Label },
	            t('components.building.main.developer.noInfo')
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      commission_note ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Developer2.default.Developer, className, _defineProperty({}, _Developer2.default.DeveloperPrint, print)) },
	        _react2.default.createElement(
	          'h3',
	          { className: _Developer2.default.Title },
	          t('components.building.main.developer.note')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Developer2.default.CommissionInner },
	          _react2.default.createElement(
	            'div',
	            { className: _Developer2.default.Row },
	            _react2.default.createElement(
	              'div',
	              { style: { whiteSpace: 'pre-wrap' }, className: (0, _classnames2.default)(_Developer2.default.Name, _Developer2.default.Commission) },
	              commission_note
	            )
	          )
	        )
	      ) : null
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      commission && count_flats ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Developer2.default.Developer, className, _defineProperty({}, _Developer2.default.DeveloperPrint, print)) },
	        _react2.default.createElement(
	          'h3',
	          { className: _Developer2.default.Title },
	          t('components.building.main.developer.commission')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Developer2.default.CommissionInner },
	          _react2.default.createElement(
	            'div',
	            { className: _Developer2.default.Row },
	            _react2.default.createElement(
	              'div',
	              { style: { whiteSpace: 'pre-wrap' }, className: (0, _classnames2.default)(_Developer2.default.Name, _Developer2.default.Commission) },
	              commission
	            )
	          )
	        )
	      ) : null
	    )
	  );
	};
	
	exports.default = Developer;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Documents = __webpack_require__(1350);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _building = __webpack_require__(54);
	
	var _Config = __webpack_require__(16);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var icons = {
	  pdf: __webpack_require__(1548),
	  doc: __webpack_require__(341),
	  docx: __webpack_require__(341),
	  xls: __webpack_require__(551),
	  xlsx: __webpack_require__(551),
	  txt: __webpack_require__(1557),
	  png: __webpack_require__(1552),
	  jpg: __webpack_require__(545),
	  jpeg: __webpack_require__(545)
	};
	
	var extension = /\.([0-9a-z]+)$/i;
	
	var getExtensionIcon = function getExtensionIcon(path) {
	  var match = path.toLowerCase().match(extension);
	  var ext = match ? match[1] : null;
	  return icons[ext] || __webpack_require__(341);
	};
	
	var Documents = function (_Component) {
	  _inherits(Documents, _Component);
	
	  function Documents() {
	    _classCallCheck(this, Documents);
	
	    return _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).apply(this, arguments));
	  }
	
	  _createClass(Documents, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.isDocumentsLoading) {
	        this.props.loadDocuments(this.props.params.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          building = _props.building,
	          isDocumentsLoading = _props.isDocumentsLoading,
	          client = _props.client,
	          t = _props.t,
	          profile = _props.profile,
	          location = _props.location,
	          objectType = _props.objectType;
	      var documents = building.documents,
	          data = building.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Documents2.default.Documents, className) },
	        documents && documents.length > 0 ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            { className: client ? _Documents2.default.TitleClient : _Documents2.default.Title },
	            t('components.building.main.documents.title')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Documents2.default.DocumentsList },
	            documents && documents.map(function (_ref) {
	              var id = _ref.id,
	                  path = _ref.path,
	                  name = _ref.name;
	              return _react2.default.createElement(
	                'a',
	                {
	                  className: _Documents2.default.Document,
	                  target: '_blank',
	                  href: _Config.DOCUMENT_BASE_URL + '/' + path,
	                  key: id,
	                  onClick: function onClick() {
	                    return (0, _ga.trackGA)(_ga.gaEvent.documentClick({
	                      screenName: location.pathname,
	                      productType: objectType,
	                      productName: data.title,
	                      productID: data.id,
	                      user_id: profile.id
	                    }));
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Documents2.default.DocumentIcon },
	                  _react2.default.createElement('img', { src: getExtensionIcon(path), alt: '' })
	                ),
	                name
	              );
	            })
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return Documents;
	}(_react.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    isDocumentsLoading: state.building.isDocumentsLoading,
	    profile: state.profile
	  };
	}, { loadDocuments: _building.loadDocuments })(Documents)));

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Features = __webpack_require__(1351);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _updateArrows = __webpack_require__(237);
	
	var _updateArrows2 = _interopRequireDefault(_updateArrows);
	
	var _utils = __webpack_require__(12);
	
	var _features = __webpack_require__(899);
	
	var featureIcons = _interopRequireWildcard(_features);
	
	var _Features3 = __webpack_require__(505);
	
	var _Features4 = _interopRequireDefault(_Features3);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var eps = 10;
	
	var Features = function (_Component) {
	  _inherits(Features, _Component);
	
	  function Features(props) {
	    _classCallCheck(this, Features);
	
	    var _this = _possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).call(this, props));
	
	    _this.getRef = function (ref) {
	      _this.ref = ref;
	      if (_this.ref) {
	        setTimeout(_this.checkIfTruncated, 500);
	      }
	    };
	
	    _this.checkIfTruncated = function () {
	      if (_this.ref && _this.ref.scrollHeight - eps > _this.ref.clientHeight) {
	        _this.setState({
	          truncated: true
	        });
	      }
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel,
	          eventContent = _ref.eventContent;
	      var _this$props = _this.props,
	          building = _this$props.building,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      isHidden: true
	    };
	
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Features, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleTrackEvent({ eventName: 'buildingInfoBlocksShow', eventLabel: 'preimushchestva' });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick() {
	      var isHidden = this.state.isHidden;
	
	      this.handleTrackEvent({
	        eventName: 'buildingInfoBlocksExpand',
	        eventLabel: isHidden ? 'podrobnee' : 'svernut',
	        eventContent: 'preimushchestva'
	      });
	      this.setState({ isHidden: !isHidden });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          building = _props.building,
	          client = _props.client,
	          print = _props.print,
	          t = _props.t;
	      var data = building.data;
	      var isHidden = this.state.isHidden;
	
	      var _ref2 = building.data || {},
	          update = _ref2.update;
	
	      var updateTime = void 0;
	      if (update) {
	        if ((0, _utils.updateString)(update).indexOf('Сегодня') == 0) {
	          updateTime = t('components.building.main.features.today');
	        } else {
	          updateTime = (0, _utils.updateString)(update);
	        }
	      }
	
	      var list = Object.keys(data.additional).filter(function (item) {
	        return ['black_list', 'new', 'nedvex'].includes(item) ? null : data.additional[item];
	      }).map(function (item, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Features2.default.CheckItem, key: i },
	          print ? _Features4.default[item] + ', ' : _react2.default.createElement(
	            'div',
	            { className: _Features2.default.CheckItemInner },
	            _react2.default.createElement(
	              'div',
	              { className: _Features2.default.Image },
	              _react2.default.createElement('img', { alt: 'icon', src: featureIcons[item] })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Features2.default.Text },
	              _Features4.default[item]
	            )
	          )
	        );
	      });
	
	      return list.length ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Features2.default.FeaturesWrap, _defineProperty({}, _Features2.default.FeaturesWrapClient, client), _defineProperty({}, _Features2.default.FeaturesWrapPrint, print)) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Features2.default.FeaturesTitle) },
	          t('components.building.main.features.advantages'),
	          client ? _react2.default.createElement(
	            'div',
	            {
	              className: _Features2.default.UpdatedTime,
	              'data-tip': t('components.building.main.features.date'),
	              'data-for': 'global'
	            },
	            _react2.default.createElement('img', { alt: 'icon', src: _updateArrows2.default }),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                t('components.building.main.features.updated'),
	                ' '
	              ),
	              ' ' + updateTime
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Features2.default.CheckBlockWrap },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(client ? _Features2.default.CheckBlock : _Features2.default.CheckBlock, this.props.className, _defineProperty({}, _Features2.default.isHidden, isHidden)),
	              ref: this.getRef
	            },
	            list
	          ),
	          this.state.truncated && _react2.default.createElement(
	            'div',
	            { className: _Features2.default.ButtonMore, onClick: this.handleButtonClick },
	            _react2.default.createElement(
	              'span',
	              null,
	              isHidden ? t('components.building.main.features.showAll') : t('components.building.main.features.minimize'),
	              ' ',
	              _react2.default.createElement('i', { className: isHidden ? null : _Features2.default.Opened })
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Features;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Features);

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Features = __webpack_require__(935);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Features2.default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Formalization = __webpack_require__(1352);
	
	var _Formalization2 = _interopRequireDefault(_Formalization);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var roomTypes = {
	  apartmentRoom: _i18n2.default.t('components.building.main.formalization.apartmentRoom'),
	  apartRoom: _i18n2.default.t('components.building.main.formalization.apartRoom'),
	  zhiloeRoom: _i18n2.default.t('components.building.main.formalization.zhiloeRoom'),
	  partFlat: _i18n2.default.t('components.building.main.formalization.partFlat'),
	  nezhiloeRoom: _i18n2.default.t('components.building.main.formalization.nezhiloeRoom'),
	  zhiloeHouse: _i18n2.default.t('components.building.main.formalization.zhiloeHouse'),
	  commercialPremises: _i18n2.default.t('components.building.main.formalization.commercialPremises'),
	  hotelRoom: _i18n2.default.t('components.building.main.formalization.hotelRoom'),
	  parking: _i18n2.default.t('components.building.main.formalization.parking'),
	  storageRoom: _i18n2.default.t('components.building.main.formalization.storageRoom')
	};
	
	var Formalization = function Formalization(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      client = _ref.client,
	      print = _ref.print,
	      objectType = _ref.objectType,
	      profile = _ref.profile;
	  var _building$data = building.data,
	      roomType = _building$data.room_types,
	      count_flats = _building$data.count_flats;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var roomTypeNames = [];
	  if (roomType) {
	    roomTypeNames = roomType.filter(function (type) {
	      return roomTypes[type];
	    }).map(function (type) {
	      return t('components.building.main.formalization.' + type);
	    }).sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	  }
	
	  var handleTrackEvent = function handleTrackEvent() {
	    var _building$data2 = building.data,
	        title = _building$data2.title,
	        id = _building$data2.id;
	
	
	    (0, _ga.trackGA)(_ga.gaEvent.buildingInfoBlocksShow({
	      eventLabel: 'oformlenie',
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    handleTrackEvent();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Formalization2.default.Formalization, _defineProperty({}, _Formalization2.default.Client, client), className, _defineProperty({}, _Formalization2.default.FormalizationPrint, print)) },
	    _react2.default.createElement(
	      'h3',
	      { className: client ? _Formalization2.default.TitleClient : _Formalization2.default.Title },
	      t('components.building.main.formalization.title')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: client ? _Formalization2.default.InnerClient : _Formalization2.default.Inner },
	      _react2.default.createElement(
	        'div',
	        { className: _Formalization2.default.Row },
	        _react2.default.createElement(
	          'div',
	          { className: _Formalization2.default.Label },
	          t('components.building.main.formalization.label')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Formalization2.default.Name },
	          ' ',
	          (building.data.checkout ? '' + building.data.checkout : '') + ' ' + building.data.checkout2,
	          ' '
	        )
	      ),
	      count_flats && roomTypeNames.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: _Formalization2.default.Row },
	        _react2.default.createElement(
	          'div',
	          { className: _Formalization2.default.Label },
	          t('components.building.main.formalization.type')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Formalization2.default.Name, _Formalization2.default.RoomTypes) },
	          roomTypeNames.map(function (name, index) {
	            return _react2.default.createElement(
	              _react2.default.Fragment,
	              { key: index },
	              index > 0 && _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                name
	              )
	            );
	          })
	        )
	      ) : null
	    )
	  );
	};
	
	exports.default = Formalization;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageGallery = __webpack_require__(470);
	
	var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
	
	var _map = __webpack_require__(657);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Gallery = __webpack_require__(1353);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _iconPhotos = __webpack_require__(547);
	
	var _iconPhotos2 = _interopRequireDefault(_iconPhotos);
	
	var _bannerPlaceholder = __webpack_require__(173);
	
	var _bannerPlaceholder2 = _interopRequireDefault(_bannerPlaceholder);
	
	var _FilterLabel = __webpack_require__(311);
	
	var _FilterLabel2 = _interopRequireDefault(_FilterLabel);
	
	var _map3 = __webpack_require__(1583);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _YMap = __webpack_require__(319);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Gallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function () {
	      var _this$props = _this.props,
	          openPopUp = _this$props.openPopUp,
	          setAlbumFromGalleryData = _this$props.setAlbumFromGalleryData,
	          galleryData = _this$props.galleryData;
	
	      var index = _this._imageGallery.getCurrentIndex();
	
	      _this.handleTrackEvent({
	        eventName: 'buildingGalleryButtonsClick',
	        eventLabel: 'posmotret_vse_foto'
	      });
	
	      openPopUp(index, 0);
	      setAlbumFromGalleryData(index, galleryData);
	    }, _this.handleShowMapClick = function () {
	      var _this$props2 = _this.props,
	          openPopUp = _this$props2.openPopUp,
	          onMap = _this$props2.onMap;
	
	
	      _this.handleTrackEvent({
	        eventName: 'buildingGalleryButtonsClick',
	        eventLabel: 'na_karte'
	      });
	
	      openPopUp(0);
	      onMap();
	    }, _this.renderMap = function (options) {
	      var building = _this.props.building;
	      var _building$data = building.data,
	          latitude = _building$data.latitude,
	          longitude = _building$data.longitude,
	          pavilions = _building$data.pavilions;
	
	
	      var finished = (pavilions || []).some(function (pavilion) {
	        return pavilion.construction_finished;
	      });
	
	      var city = _this.props.cities.find(function (city) {
	        return city.areas.map(function (region) {
	          return region.id;
	        }).includes(_this.props.building.data.region.id);
	      });
	      var region = city.areas.find(function (reg) {
	        return reg.id === _this.props.building.data.region.id;
	      });
	
	      var _region$subareas$find = region.subareas.find(function (reg) {
	        return reg.id === _this.props.building.data.subregion.id;
	      }),
	          name = _region$subareas$find.name,
	          lat = _region$subareas$find.latitude,
	          lng = _region$subareas$find.longitude;
	
	      return _react2.default.createElement(
	        _YMap.YMap,
	        {
	          defaultState: {
	            center: [latitude, longitude],
	            zoom: 17
	          },
	          defaultZoom: 17
	        },
	        _react2.default.createElement(_YMap.YMapPoint, { lat: latitude, lng: longitude, contexuality: finished ? 'success' : 'warningSuccess' }),
	        _react2.default.createElement(_YMap.YCaption, { name: name, lat: lat, lng: lng })
	      );
	    }, _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent;
	      var _this$props3 = _this.props,
	          building = _this$props3.building,
	          profile = _this$props3.profile,
	          objectType = _this$props3.objectType;
	      var _building$data2 = building.data,
	          title = _building$data2.title,
	          id = _building$data2.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || title,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Gallery, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          building = _props.building,
	          galleryData = _props.galleryData,
	          onMap = _props.onMap,
	          openPopUp = _props.openPopUp,
	          renderItem = _props.renderItem,
	          t = _props.t,
	          profile = _props.profile,
	          objectType = _props.objectType;
	      var _building$data3 = building.data,
	          latitude = _building$data3.latitude,
	          longitude = _building$data3.longitude;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Gallery2.default.Gallery, className) },
	        galleryData.itemsForGallery && galleryData.itemsForGallery.length ? _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Inner },
	          _react2.default.createElement(
	            'div',
	            { className: _Gallery2.default.Slider },
	            _react2.default.createElement(_ImageGallery2.default, { isShort: true, ref: function ref(i) {
	                return _this2._imageGallery = i;
	              }, onClick: this.handleOnClick, showIndex: false, slideOnThumbnailHover: false, showBullets: false, infinite: true, lazyLoad: true, showThumbnails: false, showFullscreenButton: false, showGalleryFullscreenButton: false, showPlayButton: false, showGalleryPlayButton: false, showNav: true, slideInterval: 2000, items: galleryData.itemsForGallery, defaultImage: _bannerPlaceholder2.default, renderItem: renderItem, galleryData: galleryData, profile: profile, buildingData: building.data, objectType: objectType }),
	            _react2.default.createElement(_FilterLabel2.default, { isBlackList: this.props.building.data.additional.black_list, isNew: this.props.building.data.additional.new, isNedvex: this.props.building.data.additional.nedvex }),
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.GalleryButtons },
	              _react2.default.createElement(
	                'div',
	                { onClick: this.handleOnClick, className: _Gallery2.default.GalleryButton },
	                _react2.default.createElement('img', { src: _iconPhotos2.default, alt: '' }),
	                t('components.building.main.gallery.showAll'),
	                ' (',
	                galleryData.itemsForGallery.length,
	                ')'
	              ),
	              _react2.default.createElement(
	                'div',
	                { onClick: this.handleShowMapClick, className: _Gallery2.default.GalleryButton },
	                _react2.default.createElement('img', { src: _map4.default, alt: '' }),
	                ' ',
	                t('components.building.main.gallery.showOnMap')
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Inner },
	          _react2.default.createElement(
	            'div',
	            { style: { width: '100%' } },
	            latitude && longitude ? _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Gallery2.default.MiniPreview, _Gallery2.default.MapPreview) },
	              this.renderMap(),
	              _react2.default.createElement(
	                'div',
	                {
	                  onClick: function onClick() {
	                    openPopUp(0);
	                    onMap();
	                  },
	                  className: (0, _classnames2.default)(_Gallery2.default.MapCover)
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.Div },
	                  _react2.default.createElement(_map2.default, { className: _Gallery2.default.MapIcon }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    t('components.building.main.gallery.showOnMap')
	                  )
	                )
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    cities: state.building.cities
	  };
	}, { setPopUp: _environment.setPopUp })(Gallery));

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Housing = __webpack_require__(1354);
	
	var _Housing2 = _interopRequireDefault(_Housing);
	
	var _utils = __webpack_require__(12);
	
	var _ChessLinkContainer = __webpack_require__(927);
	
	var _ChessLinkContainer2 = _interopRequireDefault(_ChessLinkContainer);
	
	var _iconArrow = __webpack_require__(1535);
	
	var _iconArrow2 = _interopRequireDefault(_iconArrow);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var digits = function digits(number) {
	  return number ? (0, _utils.formatNumber)(number) : '...';
	};
	
	var Housing = function Housing(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      print = _ref.print,
	      client = _ref.client,
	      profile = _ref.profile,
	      objectType = _ref.objectType;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _building$data = building.data,
	      pavilions = _building$data.pavilions,
	      status = _building$data.status,
	      country = _building$data.country;
	  var currency = country.country_currency_symbol;
	
	
	  var handleTrackEvent = function handleTrackEvent(_ref2) {
	    var eventName = _ref2.eventName,
	        eventLabel = _ref2.eventLabel,
	        eventContent = _ref2.eventContent;
	    var _building$data2 = building.data,
	        title = _building$data2.title,
	        id = _building$data2.id;
	
	
	    (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    handleTrackEvent({
	      eventName: 'buildingInfoBlocksShow',
	      eventLabel: 'korpusa'
	    });
	  }, []);
	
	  var list = pavilions.map(function (pavilion, index) {
	    var name = pavilion.name,
	        construction_finished = pavilion.construction_finished,
	        construction_ending = pavilion.construction_ending,
	        year_built = pavilion.year_built,
	        count_flats = pavilion.count_flats,
	        cost_min = pavilion.cost_min,
	        cost_max = pavilion.cost_max,
	        min_square_housing = pavilion.min_square_housing,
	        max_square_housing = pavilion.max_square_housing;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Housing2.default.Inner, _defineProperty({}, _Housing2.default.InnerPrint, print)), key: index },
	      _react2.default.createElement(
	        'div',
	        { className: _Housing2.default.InnerLeft },
	        _react2.default.createElement(
	          'div',
	          { className: _Housing2.default.Name },
	          t('components.building.main.housing.name', { name: name || '' }),
	          print ? status === 2 ? _react2.default.createElement(
	            'div',
	            { className: _Housing2.default.Stopped },
	            _react2.default.createElement(
	              'span',
	              null,
	              t('components.building.main.housing.stopped')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: _Housing2.default.RoomCount },
	            _react2.default.createElement(
	              'span',
	              null,
	              count_flats ? '(' + count_flats + ' ' + (0, _utils.pluralize)(count_flats, t('components.building.main.housing.flat1'), t('components.building.main.housing.flat2'), t('components.building.main.housing.flat3')) + ')' : ''
	            )
	          ) : null,
	          print ? null : _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_Housing2.default.Status, _defineProperty({}, _Housing2.default.StatusFinished, !!construction_finished))
	            },
	            _react2.default.createElement(
	              'span',
	              { className: _Housing2.default.Text },
	              construction_finished ? t('components.building.main.housing.finished') : year_built == 0 ? t('components.building.main.housing.inProgress') : construction_ending + ' / ' + year_built
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Housing2.default.FlatsInfo },
	          count_flats && status === 2 ? _react2.default.createElement(
	            'div',
	            { className: _Housing2.default.Stopped },
	            _react2.default.createElement(
	              'span',
	              null,
	              t('components.building.main.housing.stopped')
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            count_flats ? count_flats + ' ' + (0, _utils.pluralize)(count_flats, t('components.building.main.housing.flat1'), t('components.building.main.housing.flat2'), t('components.building.main.housing.flat3')) : ''
	          ),
	          status !== 2 ? _react2.default.createElement(
	            'span',
	            null,
	            count_flats ? _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(_Housing2.default.Prices, _defineProperty({}, _Housing2.default.PricesStopped, status === 0)) },
	              ', ',
	              t('components.building.main.housing.prices', {
	                costMin: digits(cost_min),
	                costMax: digits(cost_max),
	                areaMin: digits(min_square_housing),
	                areaMax: digits(max_square_housing),
	                currency: currency
	              })
	            ) : _react2.default.createElement(
	              'span',
	              { className: _Housing2.default.Prices },
	              _react2.default.createElement(
	                'div',
	                { className: _Housing2.default.Message },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  status === 2 ? t('components.building.main.housing.stopped') : building.data.type_id === 2 ? t('components.building.main.housing.soldAllHouses') : t('components.building.main.housing.soldAllFlats')
	                )
	              )
	            )
	          ) : ''
	        )
	      ),
	      !client ? _react2.default.createElement(
	        'div',
	        {
	          className: _Housing2.default.InnerRight,
	          onClick: function onClick() {
	            return handleTrackEvent({
	              eventName: 'buildingChessLinkClick',
	              eventContent: 'korpus_' + name
	            });
	          }
	        },
	        _react2.default.createElement(
	          _ChessLinkContainer2.default,
	          { query: 'section=' + index + '.0', className: _Housing2.default.ChessLink },
	          _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)(_Housing2.default.TabletHidden, _Housing2.default.MobileVisible) },
	            t('components.building.main.housing.see')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)(_Housing2.default.TabletVisible, _Housing2.default.MobileHidden) },
	            t('components.building.main.housing.see1')
	          ),
	          ' ',
	          t('components.building.main.housing.chess'),
	          _react2.default.createElement('img', { src: _iconArrow2.default, alt: '' })
	        )
	      ) : null
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_Housing2.default.Housing, className, _defineProperty({}, _Housing2.default.HousingClient, client), _defineProperty({}, _Housing2.default.HousingPrint, print))
	    },
	    _react2.default.createElement(
	      'h3',
	      { className: (0, _classnames2.default)(_Housing2.default.Title, _defineProperty({}, _Housing2.default.TitlePrint, print)) },
	      t('components.building.main.housing.corps', {
	        number: print ? '' : '(' + pavilions.length + ')'
	      })
	    ),
	    list
	  );
	};
	
	exports.default = Housing;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Info = __webpack_require__(1355);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _utils = __webpack_require__(12);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = function Info(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      client = _ref.client;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _building$data = building.data,
	      count_flats = _building$data.count_flats,
	      status = _building$data.status,
	      pavilions = _building$data.pavilions,
	      min_square = _building$data.min_square,
	      max_square = _building$data.max_square,
	      type_id = _building$data.type_id,
	      country = _building$data.country;
	  var currency = country.country_currency_symbol;
	
	  var minPrice = 0,
	      minCost = 0;
	  pavilions.forEach(function (pavilion) {
	    var min_area_cost = pavilion.min_area_cost,
	        cost_min = pavilion.cost_min;
	
	    min_area_cost = Number(min_area_cost);
	    cost_min = Number(cost_min);
	    if (min_area_cost) {
	      minPrice = minPrice ? Math.min(minPrice, min_area_cost) : min_area_cost;
	    }
	    if (cost_min) {
	      minCost = minCost ? Math.min(minCost, cost_min) : cost_min;
	    }
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: client ? _Info2.default.InfoClient : (0, _classnames2.default)(_Info2.default.Info, className) },
	    count_flats ? _react2.default.createElement(
	      'div',
	      null,
	      status === 2 ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Info2.default.Inner, _Info2.default.Message) },
	        _react2.default.createElement(
	          'span',
	          null,
	          t('components.building.main.info.paused')
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: _Info2.default.Inner },
	        _react2.default.createElement(
	          'div',
	          { className: _Info2.default.Column },
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Count },
	            count_flats
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Name },
	            type_id == 2 ? (0, _utils.pluralize)(count_flats, t('components.building.main.info.house'), t('components.building.main.info.house1'), t('components.building.main.info.house2')) : (0, _utils.pluralize)(count_flats, t('components.building.main.info.flat'), t('components.building.main.info.flat1'), t('components.building.main.info.flat2'))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Info2.default.Column },
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Count },
	            t('components.building.main.info.minPrice', {
	              minPrice: (0, _utils.formatNumber)(minPrice),
	              currency: currency
	            })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Name },
	            t('components.building.main.info.price')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Info2.default.Column },
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Count },
	            t('components.building.main.info.minPrice', {
	              minPrice: (0, _utils.formatNumber)(minCost),
	              currency: currency
	            })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Name },
	            t('components.building.main.info.cost')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Info2.default.Column },
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Count },
	            min_square,
	            ' - ',
	            max_square
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _Info2.default.Name },
	            t('components.building.main.info.area')
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Info2.default.Inner, _Info2.default.Message) },
	      _react2.default.createElement(
	        'span',
	        null,
	        status === 2 ? t('components.building.main.info.paused') : type_id === 2 ? t('components.building.main.info.soldAllHouses') : t('components.building.main.info.soldAllFlats')
	      )
	    )
	  );
	};
	
	exports.default = Info;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Wireframe = __webpack_require__(1356);
	
	var _Wireframe2 = _interopRequireDefault(_Wireframe);
	
	var _RightWireframe = __webpack_require__(471);
	
	var _RightWireframe2 = _interopRequireDefault(_RightWireframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wireframe = function (_Component) {
	  _inherits(Wireframe, _Component);
	
	  function Wireframe() {
	    _classCallCheck(this, Wireframe);
	
	    return _possibleConstructorReturn(this, (Wireframe.__proto__ || Object.getPrototypeOf(Wireframe)).apply(this, arguments));
	  }
	
	  _createClass(Wireframe, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          client = _props.client,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        client ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.NavLinks },
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.NavLink },
	              t('components.building.main.leftWireframe.photo')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.NavLink },
	              t('components.building.main.leftWireframe.info')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.NavLink },
	              t('components.building.main.leftWireframe.flats')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Info },
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.InfoInner },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 48 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 138 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name, style: { width: 108 } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 167 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name, style: { width: 167 } })
	              )
	            ),
	            _react2.default.createElement(_RightWireframe2.default, { className: (0, _classnames2.default)(_Wireframe2.default.RightRow, _Wireframe2.default.MobileOnly) }),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.FeaturesWrap },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Wireframe2.default.Title, _Wireframe2.default.MobileOnly) },
	                t('components.building.main.leftWireframe.advantages')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Features },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Feature },
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                  _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: _Wireframe2.default.MoreLink }),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.About },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Inner },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileHidden },
	                      t('components.building.main.leftWireframe.commonAbout')
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileOnly },
	                      t('components.building.main.leftWireframe.about')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Class) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Material) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Type) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Parking) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Territory) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.ToSea) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Height) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    t('components.building.main.leftWireframe.com')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Heating) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Electricity) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Sewerage) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Water) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Inner },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileHidden },
	                      t('components.building.main.leftWireframe.decor')
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileOnly },
	                      t('components.building.main.leftWireframe.about')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Class) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Material) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Type) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Parking) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Territory) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.ToSea) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Height) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    t('components.building.main.leftWireframe.pay')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Heating) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Electricity) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Sewerage) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Water) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.Housing },
	              _react2.default.createElement('div', { className: _Wireframe2.default.HousingTitle }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.HousingInner })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Wireframe2.default.Gallery) },
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.Inner },
	              _react2.default.createElement('div', { className: _Wireframe2.default.Slider })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Info },
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.InfoInner },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 48 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 138 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name, style: { width: 108 } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Column },
	                _react2.default.createElement('span', { className: _Wireframe2.default.Count, style: { width: 167 } }),
	                _react2.default.createElement('span', { className: _Wireframe2.default.Name, style: { width: 167 } })
	              )
	            ),
	            _react2.default.createElement(_RightWireframe2.default, { className: (0, _classnames2.default)(_Wireframe2.default.RightRow, _Wireframe2.default.MobileOnly) }),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.DescriptionFeatures },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Description },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_Wireframe2.default.Title, _Wireframe2.default.TitleDescrip) },
	                  t('components.building.main.leftWireframe.aboutHouse')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Lines },
	                  _react2.default.createElement('span', { className: _Wireframe2.default.Line }),
	                  _react2.default.createElement('span', { className: _Wireframe2.default.Line }),
	                  _react2.default.createElement('span', { className: _Wireframe2.default.Line })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.FeaturesWrap },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_Wireframe2.default.Title) },
	                  t('components.building.main.leftWireframe.advantages')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.Features },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.Feature },
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.Feature },
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.Feature },
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureName })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.Feature },
	                    _react2.default.createElement('div', { className: _Wireframe2.default.FeatureImg }),
	                    _react2.default.createElement('div', { className: (0, _classnames2.default)(_Wireframe2.default.FeatureName) })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.About },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Inner },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileHidden },
	                      t('components.building.main.leftWireframe.commonAbout')
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Wireframe2.default.MobileOnly },
	                      t('components.building.main.leftWireframe.about')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Class) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Material) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Type) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Parking) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Territory) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.ToSea) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Height) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    t('components.building.main.leftWireframe.com')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Heating) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Electricity) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Sewerage) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Water) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.About },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.Inner },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    t('components.building.main.leftWireframe.decor')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Class) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Material) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Type) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Parking) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Wireframe2.default.InfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.AboutTitle },
	                    t('components.building.main.leftWireframe.pay')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.InfoBlockInner },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Wireframe2.default.InfoItem, _Wireframe2.default.Gas) },
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Description }),
	                      _react2.default.createElement('div', { className: _Wireframe2.default.Title })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.Housing },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.HousingTitle },
	                t('components.building.main.leftWireframe.corp'),
	                _react2.default.createElement('span', null)
	              ),
	              _react2.default.createElement('div', { className: _Wireframe2.default.HousingInner })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Wireframe;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Wireframe);

/***/ }),
/* 942 */
[2396, 941],
/* 943 */
[2397, 1357],
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScroll = __webpack_require__(687);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Config = __webpack_require__(16);
	
	var _ClientHeader = __webpack_require__(313);
	
	var _ClientHeader2 = _interopRequireDefault(_ClientHeader);
	
	var _BuildingTitle = __webpack_require__(476);
	
	var _BuildingTitle2 = _interopRequireDefault(_BuildingTitle);
	
	var _RealtorCard = __webpack_require__(497);
	
	var _RealtorCard2 = _interopRequireDefault(_RealtorCard);
	
	var _FlatsList = __webpack_require__(999);
	
	var _FlatsList2 = _interopRequireDefault(_FlatsList);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Gallery = __webpack_require__(938);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Info = __webpack_require__(940);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _About = __webpack_require__(923);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Features = __webpack_require__(936);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Housing = __webpack_require__(939);
	
	var _Housing2 = _interopRequireDefault(_Housing);
	
	var _Description = __webpack_require__(932);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Developer = __webpack_require__(933);
	
	var _Developer2 = _interopRequireDefault(_Developer);
	
	var _Suggestions = __webpack_require__(953);
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	var _Formalization = __webpack_require__(937);
	
	var _Formalization2 = _interopRequireDefault(_Formalization);
	
	var _Contacts = __webpack_require__(931);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Payment = __webpack_require__(948);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _Nav = __webpack_require__(946);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Documents = __webpack_require__(934);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _News = __webpack_require__(947);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _Popup = __webpack_require__(950);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _List = __webpack_require__(949);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LeftWireframe = __webpack_require__(942);
	
	var _LeftWireframe2 = _interopRequireDefault(_LeftWireframe);
	
	var _RightWireframe = __webpack_require__(471);
	
	var _RightWireframe2 = _interopRequireDefault(_RightWireframe);
	
	var _SuggestionsWireframe = __webpack_require__(955);
	
	var _SuggestionsWireframe2 = _interopRequireDefault(_SuggestionsWireframe);
	
	var _ImageGallery = __webpack_require__(470);
	
	var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
	
	var _ProgressiveImage = __webpack_require__(1107);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	var _NoPage = __webpack_require__(475);
	
	var _NoPage2 = _interopRequireDefault(_NoPage);
	
	var _closePopupGallery = __webpack_require__(1528);
	
	var _closePopupGallery2 = _interopRequireDefault(_closePopupGallery);
	
	var _ScrollLock = __webpack_require__(163);
	
	var _ScrollLock2 = _interopRequireDefault(_ScrollLock);
	
	var _reactStickyEl = __webpack_require__(187);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	var _map = __webpack_require__(657);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _iconPhotos = __webpack_require__(547);
	
	var _iconPhotos2 = _interopRequireDefault(_iconPhotos);
	
	var _Loader = __webpack_require__(943);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _noFloor = __webpack_require__(238);
	
	var _noFloor2 = _interopRequireDefault(_noFloor);
	
	var _YMap = __webpack_require__(319);
	
	var _Main = __webpack_require__(1358);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _mapPreview = __webpack_require__(1582);
	
	var _mapPreview2 = _interopRequireDefault(_mapPreview);
	
	var _helper = __webpack_require__(55);
	
	var _Features3 = __webpack_require__(505);
	
	var _Features4 = _interopRequireDefault(_Features3);
	
	var _InaccuracyReport = __webpack_require__(469);
	
	var _InaccuracyReport2 = _interopRequireDefault(_InaccuracyReport);
	
	var _ga = __webpack_require__(7);
	
	var _collections = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var monthToString = function monthToString(n) {
	  switch (n) {
	    case 1:
	      return _i18n2.default.t('components.building.main.main.month.1');
	    case 2:
	      return _i18n2.default.t('components.building.main.main.month.2');
	    case 3:
	      return _i18n2.default.t('components.building.main.main.month.3');
	    case 4:
	      return _i18n2.default.t('components.building.main.main.month.4');
	    case 5:
	      return _i18n2.default.t('components.building.main.main.month.5');
	    case 6:
	      return _i18n2.default.t('components.building.main.main.month.6');
	    case 7:
	      return _i18n2.default.t('components.building.main.main.month.7');
	    case 8:
	      return _i18n2.default.t('components.building.main.main.month.8');
	    case 9:
	      return _i18n2.default.t('components.building.main.main.month.9');
	    case 10:
	      return _i18n2.default.t('components.building.main.main.month.10');
	    case 11:
	      return _i18n2.default.t('components.building.main.main.month.11');
	    case 12:
	      return _i18n2.default.t('components.building.main.main.month.12');
	    default:
	      return '';
	  }
	};
	
	var Main = (_temp = _class = function (_Component) {
	  _inherits(Main, _Component);
	
	  function Main(props) {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      isPopUp: false,
	      currentAlbum: 0,
	      currentPhoto: 0,
	      currentAlbumPhoto: 0,
	      isMap: null,
	
	      // for stats
	      photoClicks: 0,
	      mapClicks: 0,
	      phoneClicks: 0
	    };
	
	    _this.isFirstSend = { current: true };
	    _this.intervalId = null;
	    _this.visitTime = Date.now();
	
	    _this.changePopUpState = _this.changePopUpState.bind(_this);
	    _this.setAlbumFromGalleryData = _this.setAlbumFromGalleryData.bind(_this);
	    _this.changeCurrentPhoto = _this.changeCurrentPhoto.bind(_this);
	    _this.togglePopUpRender = _this.togglePopUpRender.bind(_this);
	    _this.handleGalleryClick = _this.handleGalleryClick.bind(_this);
	    _this._onSlide = _this._onSlide.bind(_this);
	
	    _this.sessionUuid = _this.getSessionUuid();
	    return _this;
	  }
	
	  _createClass(Main, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.scrollTop = 0;
	
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if ((prevProps.selection !== this.props.selection || prevProps.building !== this.props.building) && this.props.selection && this.props.building) {
	        this.startSending();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.intervalId) {
	        clearInterval(this.intervalId);
	      }
	    }
	  }, {
	    key: 'getSessionUuid',
	    value: function getSessionUuid() {
	      var uuid = sessionStorage.getItem('sessionUuid');
	      if (!uuid) {
	        uuid = crypto.randomUUID();
	        sessionStorage.setItem('sessionUuid', uuid);
	      }
	      return uuid;
	    }
	  }, {
	    key: 'changePopUpState',
	    value: function changePopUpState(isPopUp, isMap, currentPhoto, currentAlbum, currentAlbumPhoto) {
	      this.setState({
	        isPopUp: isPopUp,
	        isMap: isMap
	      });
	
	      if (typeof currentPhoto === 'number') {
	        this.setState({
	          currentPhoto: currentPhoto
	        });
	      }
	      if (typeof currentAlbum === 'number') {
	        this.setState({
	          currentAlbum: currentAlbum
	        });
	      }
	      if (typeof currentAlbumPhoto === 'number') {
	        this.setState({
	          currentAlbumPhoto: currentAlbumPhoto
	        });
	      }
	    }
	  }, {
	    key: 'changeCurrentPhoto',
	    value: function changeCurrentPhoto(currentPhoto, currentAlbumPhoto, cb) {
	      this.setState({ currentPhoto: currentPhoto }, cb);
	
	      if (currentAlbumPhoto) {
	        this.setState({ currentAlbumPhoto: currentAlbumPhoto }, cb);
	      }
	    }
	  }, {
	    key: 'togglePopUpRender',
	    value: function togglePopUpRender(isMap) {
	      this.setState({ isMap: isMap });
	    }
	  }, {
	    key: '_onSlide',
	    value: function _onSlide(galleryData, index) {
	      this.setAlbumFromGalleryData(index, galleryData);
	    }
	  }, {
	    key: 'setAlbumFromGalleryData',
	    value: function setAlbumFromGalleryData(index) {
	      var _this2 = this;
	
	      var galleryData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.changeCurrentPhoto(index);
	
	      galleryData.metaForGallery.meta.forEach(function (a, i) {
	        if (a.first <= index && index < a.last) {
	          _this2.setState({
	            currentAlbum: i,
	            currentAlbumPhoto: index - a.first
	          });
	        }
	      });
	    }
	  }, {
	    key: 'genItemsForGallery',
	    value: function genItemsForGallery(albums) {
	      return albums && albums.rows ? albums.rows.reduce(function (p, c) {
	        var images = c.images ? c.images.map(function (img) {
	          var fullDefaultSize = 'original';
	          // const smallDefaultSize = 'medium';
	
	          return {
	            thumbnail: function thumbnail() {
	              return _Config.ROOT_URL + '/image?id=' + img.id + '&size=' + fullDefaultSize;
	            },
	            original: function original() {
	              return _Config.ROOT_URL + '/wimage?id=' + img.id + '&size=' + fullDefaultSize;
	            }
	          };
	        }) : {};
	        return [].concat(_toConsumableArray(p), _toConsumableArray(images));
	      }, []) : [];
	    }
	  }, {
	    key: 'genMetaForGallery',
	    value: function genMetaForGallery(albums) {
	      return albums && albums.rows ? albums.rows.reduce(function (p, c) {
	        return {
	          total: p.total + (c.images ? c.images.length : 0),
	          meta: [].concat(_toConsumableArray(p.meta), [{
	            name: c.type.name,
	            year: c.year,
	            month: monthToString(c.month),
	            first: p.total,
	            last: p.total + (c.images ? c.images.length : 0)
	          }])
	        };
	      }, { total: 0, meta: [] }) : [];
	    }
	  }, {
	    key: 'renderPopupMapContent',
	    value: function renderPopupMapContent(latitude, longitude, finished, onClose) {
	      var _props = this.props,
	          selection = _props.selection,
	          building = _props.building,
	          t = _props.t;
	
	
	      var contexuality = void 0;
	      // У нашего бекендера где-то это строка, где-то цифра. Хер проссышь.
	      if (Number(building.data.count_flats) === 0) {
	        contexuality = 'disabled';
	      } else {
	        contexuality = building.data.status == 3 ? 'almostFinished' : finished ? 'success' : 'warningSuccess';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Main2.default.PopUpMap },
	        _react2.default.createElement(
	          'div',
	          { className: _Main2.default.Header },
	          _react2.default.createElement(
	            'h3',
	            { className: _Main2.default.Title },
	            selection && selection.showInfo === '0' ? null : building.data.title + ' / ',
	            _react2.default.createElement(
	              'span',
	              { className: _Main2.default.Bold },
	              t('components.building.main.main.onMap')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Main2.default.Close, onClick: onClose },
	              _react2.default.createElement('img', { alt: 'close', src: _closePopupGallery2.default })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ScrollLock2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Main2.default.MapWrapper },
	            this.renderMap(latitude, longitude, contexuality)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMap',
	    value: function renderMap(latitude, longitude, contexuality) {
	      var _this3 = this;
	
	      var city = this.props.cities.find(function (city) {
	        return city.areas.map(function (region) {
	          return region.id;
	        }).includes(_this3.props.building.data.region.id);
	      });
	      var region = city.areas.find(function (reg) {
	        return reg.id === _this3.props.building.data.region.id;
	      });
	
	      var _region$subareas$find = region.subareas.find(function (reg) {
	        return reg.id === _this3.props.building.data.subregion.id;
	      }),
	          name = _region$subareas$find.name,
	          lat = _region$subareas$find.latitude,
	          lng = _region$subareas$find.longitude;
	
	      var showPoint = !this.props.selection || this.props.selection && this.props.selection.showInfo === '1';
	
	      return _react2.default.createElement(
	        _YMap.YMap,
	        {
	          defaultState: {
	            center: [latitude - 0.00019, longitude + 0.00015],
	            zoom: showPoint ? 17 : 12
	          }
	        },
	        showPoint ? _react2.default.createElement(_YMap.YMapPoint, { lat: latitude, lng: longitude, contexuality: contexuality }) : null,
	        _react2.default.createElement(_YMap.YCaption, { lat: lat, lng: lng, name: name })
	      );
	    }
	  }, {
	    key: 'makeRenderGalleryItem',
	    value: function makeRenderGalleryItem() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Main2.default.GalleryImage },
	          _react2.default.createElement(_ProgressiveImage2.default, {
	            className: props.popupGallery ? _Main2.default.ProgressiveImageBigGallery : '',
	            isPopup: !!props.popupGallery,
	            getSmallImageSrc: item.thumbnail,
	            getBigImageSrc: item.original,
	            width: props.width || null,
	            imageItem: item
	          }),
	          item.description ? _react2.default.createElement(
	            'span',
	            { className: _Main2.default.GalleryDescription },
	            item.description
	          ) : null
	        );
	      };
	    }
	  }, {
	    key: 'handleGalleryClick',
	    value: function handleGalleryClick() {
	      this._imagePopUpGallery.slideToIndex(this._imagePopUpGallery.getCurrentIndex() + 1);
	    }
	  }, {
	    key: 'renderPopup',
	    value: function renderPopup(building) {
	      var _this4 = this;
	
	      var _building$data = building.data,
	          latitude = _building$data.latitude,
	          longitude = _building$data.longitude,
	          pavilions = _building$data.pavilions,
	          albums = _building$data.albums;
	
	
	      var finished = (pavilions || []).some(function (pavilion) {
	        var construction_finished = pavilion.construction_finished;
	
	        return construction_finished;
	      });
	
	      var galleryData = {
	        itemsForGallery: this.genItemsForGallery(albums),
	        metaForGallery: this.genMetaForGallery(albums)
	      };
	
	      return _react2.default.createElement(_Popup2.default, {
	        isOpen: this.state.isPopUp,
	        className: (0, _classnames2.default)(this.state.isPopUp ? _Main2.default.OpenPopup : '', this.state.isMap ? _Main2.default.OpenPopupMap : ''),
	        render: function render() {
	          return _this4.state.isMap ? _this4.renderPopupMapContent(latitude, longitude, finished, _this4.changePopUpState.bind(_this4, false)) : _this4.renderGallery(galleryData, albums, _this4.state.currentAlbum, albums.length === 1, _this4.changePopUpState.bind(_this4, false));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          client = _props2.client,
	          print = _props2.print;
	
	
	      if (client) {
	        return this.renderForClient();
	      }
	
	      if (print) {
	        return this.renderForPrint();
	      }
	
	      return this.renderForManager();
	    }
	  }]);
	
	  return Main;
	}(_react.Component), _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.map = null;
	
	  this.handleAddStats = function (statType) {
	    _this5.setState(function (prevState) {
	      return _defineProperty({}, statType, prevState[statType] + 1);
	    });
	  };
	
	  this.startSending = function () {
	    if (_this5.intervalId) return;
	
	    var sendData = function sendData() {
	      if (document.hidden || !_this5.props.selection.id) return;
	
	      (0, _collections.sendCollectionBuildingStats)({
	        sessionUuid: _this5.sessionUuid,
	        collectionId: Number(_this5.props.selection.id),
	        buildingId: Number(_this5.props.building.data.id),
	        views: _this5.isFirstSend.current ? 1 : 0,
	        timeSpent: 3,
	        photoClicks: _this5.state.photoClicks,
	        mapClicks: _this5.state.mapClicks,
	        phoneClicks: _this5.state.phoneClicks
	      }).catch(function (error) {
	        console.error('Error sending data:', error);
	      });
	
	      _this5.setState({
	        photoClicks: 0,
	        mapClicks: 0,
	        phoneClicks: 0
	      });
	
	      _this5.isFirstSend.current = false;
	    };
	
	    var startSendingInterval = function startSendingInterval() {
	      if (_this5.intervalId) return;
	
	      sendData();
	      _this5.intervalId = setInterval(sendData, 3000);
	    };
	
	    var stopSending = function stopSending() {
	      if (_this5.intervalId) {
	        clearInterval(_this5.intervalId);
	        _this5.intervalId = null;
	      }
	    };
	
	    _this5.handleVisibilityChange = function () {
	      if (!document.hidden) {
	        startSendingInterval();
	      } else {
	        stopSending();
	      }
	    };
	
	    document.addEventListener('visibilitychange', _this5.handleVisibilityChange);
	    startSendingInterval();
	  };
	
	  this.renderGallery = function (galleryData, albums, currentAlbum, one, onClose) {
	    var album = albums.rows[currentAlbum];
	    var _props3 = _this5.props,
	        t = _props3.t,
	        profile = _props3.profile,
	        objectType = _props3.objectType,
	        building = _props3.building;
	    var name = album.type.name;
	
	    var hasAlbums = albums.rows.length > 1;
	    var months = [t('components.building.main.main.month.1'), t('components.building.main.main.month.2'), t('components.building.main.main.month.3'), t('components.building.main.main.month.4'), t('components.building.main.main.month.5'), t('components.building.main.main.month.6'), t('components.building.main.main.month.7'), t('components.building.main.main.month.8'), t('components.building.main.main.month.9'), t('components.building.main.main.month.10'), t('components.building.main.main.month.11'), t('components.building.main.main.month.12')];
	
	    var handleTrackEvent = function handleTrackEvent() {
	      var _building$data2 = building.data,
	          title = _building$data2.title,
	          id = _building$data2.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.buildingGalleryAlbumsButtonsClick({
	        eventContent: 'zakryt',
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Main2.default.PopUpGallery, _defineProperty({}, _Main2.default.WithAlbums, hasAlbums)) },
	      _react2.default.createElement(
	        'style',
	        null,
	        '\n              html {\n                overflow: hidden;\n              }\n            '
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _Main2.default.PopUpGalleryInner,
	          onClick: function onClick() {
	            return _this5.handleAddStats('photoClicks');
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _Main2.default.Header },
	          _react2.default.createElement(
	            'h3',
	            { className: _Main2.default.Title },
	            !(_this5.props.selection && _this5.props.selection.showInfo === '0') && _this5.props.building.data.title + ' / ',
	            _react2.default.createElement(
	              'span',
	              { className: _Main2.default.Bold },
	              album.type.name === 'Ход строительства' ? ' ' + months[album.month - 1] + ' ' + album.year : name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Main2.default.Close, onClick: onClose },
	              _react2.default.createElement('img', { alt: 'close', src: _closePopupGallery2.default, onClick: handleTrackEvent })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Main2.default.Count, _Main2.default.ShowMobile) },
	            t('components.building.main.main.photo', {
	              number: _this5.state.currentAlbumPhoto ? _this5.state.currentAlbumPhoto + 1 : 1,
	              allNumber: album.images.length
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Main2.default.Slider },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Main2.default.Count, _Main2.default.HideMobile) },
	            t('components.building.main.main.photo', {
	              number: _this5.state.currentAlbumPhoto ? _this5.state.currentAlbumPhoto + 1 : 1,
	              allNumber: album.images.length
	            })
	          ),
	          _react2.default.createElement(_ImageGallery2.default, {
	            ref: function ref(i) {
	              return _this5._imagePopUpGallery = i;
	            },
	            showIndex: false,
	            startIndex: _this5.state.currentPhoto,
	            onClick: _this5.handleGalleryClick,
	            onSlide: _this5._onSlide.bind(_this5, galleryData),
	            slideOnThumbnailHover: false,
	            showBullets: false,
	            lazyLoad: true,
	            infinite: true,
	            isShort: _this5.state.isPopUp,
	            showThumbnails: true,
	            showFullscreenButton: false,
	            showGalleryFullscreenButton: false,
	            showPlayButton: false,
	            showGalleryPlayButton: false,
	            showNav: true,
	            renderItem: _this5.makeRenderGalleryItem({ popupGallery: true }),
	            items: galleryData.itemsForGallery,
	            galleryData: galleryData,
	            profile: profile,
	            buildingData: building.data,
	            objectType: objectType,
	            isModal: true
	          })
	        ),
	        hasAlbums ? _react2.default.createElement(
	          'div',
	          { className: _Main2.default.ListContainer },
	          _react2.default.createElement(
	            _ScrollLock2.default,
	            null,
	            _react2.default.createElement(_List2.default, {
	              galleryData: galleryData,
	              albums: albums,
	              currentAlbum: currentAlbum,
	              onImage: _this5.changePopUpState.bind(_this5, true, false, undefined, undefined, undefined),
	              galleryRef: _this5._imagePopUpGallery,
	              profile: profile,
	              buildingData: building.data,
	              objectType: objectType
	            })
	          )
	        ) : null
	      )
	    );
	  };
	
	  this.renderGalleryComponent = function (props) {
	    var galleryData = {
	      itemsForGallery: _this5.genItemsForGallery(props.building.data.albums),
	      metaForGallery: _this5.genMetaForGallery(props.building.data.albums)
	    };
	
	    return _react2.default.createElement(_Gallery2.default, _extends({}, props, {
	      className: _Main2.default.GalleryComponent,
	      galleryData: galleryData,
	      setAlbumFromGalleryData: _this5.setAlbumFromGalleryData,
	      changeCurrentPhoto: _this5.changeCurrentPhoto,
	      openPopUp: _this5.changePopUpState.bind(_this5, true, false),
	      onImage: _this5.togglePopUpRender.bind(_this5, false),
	      onMap: _this5.togglePopUpRender.bind(_this5, true),
	      renderItem: _this5.makeRenderGalleryItem(),
	      objectType: _this5.props.objectType
	    }));
	  };
	
	  this.renderHeaderMap = function () {
	    var selection = _this5.props.selection;
	
	    var showMapWithPoint = !!selection && selection.showInfo === '1';
	
	    return _react2.default.createElement(
	      'div',
	      { className: _Main2.default.HeaderMap, onClick: function onClick() {
	          return _this5.handleAddStats('mapClicks');
	        } },
	      _react2.default.createElement('img', {
	        alt: '',
	        src: showMapWithPoint ? _mapPreview2.default : _mapPreview2.default,
	        style: {
	          width: '100%',
	          height: '100%',
	          objectFit: 'cover',
	          objectPosition: 'center center'
	        }
	      })
	    );
	  };
	
	  this.handleClientGalleryClick = function (i, galleryData) {
	    _this5.setAlbumFromGalleryData(i, galleryData);
	    _this5.changePopUpState.bind(_this5, true, false)();
	  };
	
	  this.renderImages = function (galleryData, max) {
	    return galleryData.itemsForGallery.slice(0, max).map(function (_ref2, i) {
	      var original = _ref2.original;
	      return _react2.default.createElement('img', {
	        ref: 'image_' + i,
	        src: original(_this5.refs['image_' + i]),
	        alt: '',
	        key: i,
	        onClick: _this5.handleClientGalleryClick.bind(_this5, i, galleryData)
	      });
	    });
	  };
	
	  this.renderMaxHeaderImages = function (max) {
	    var _ref3 = _this5.props.building.data || {},
	        _ref3$albums = _ref3.albums,
	        albums = _ref3$albums === undefined ? [] : _ref3$albums;
	
	    var galleryData = {
	      itemsForGallery: _this5.genItemsForGallery(albums),
	      metaForGallery: _this5.genMetaForGallery(albums)
	    };
	    if (galleryData.itemsForGallery.length <= 3 || max <= 3) {
	      return _react2.default.createElement(
	        'div',
	        { className: _Main2.default.GalleryHeaderInnerBlur },
	        _react2.default.createElement(
	          'svg',
	          { height: '100', width: '100' },
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement(
	              'filter',
	              { id: 'blur', x: '0', y: '0' },
	              _react2.default.createElement('feGaussianBlur', { 'in': 'SourceGraphic', stdDeviation: '14' })
	            )
	          )
	        ),
	        _react2.default.createElement('img', {
	          src: galleryData.itemsForGallery[0] ? galleryData.itemsForGallery[0].original : '',
	          alt: '',
	          key: 'thumb',
	          onClick: _this5.handleClientGalleryClick.bind(_this5, 0),
	          className: _Main2.default.BlurredImage
	        }),
	        _this5.renderImages(galleryData, Math.min(3, max))
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: _Main2.default.GalleryHeaderInner },
	      _this5.renderImages(galleryData, max)
	    );
	  };
	
	  this.renderHeaderImages = this.renderMaxHeaderImages.bind(this, 6);
	  this.renderHeaderImage = this.renderMaxHeaderImages.bind(this, 1);
	
	  this.renderForClient = function () {
	    var rest = _objectWithoutProperties(_this5.props, []);
	
	    var _props4 = _this5.props,
	        building = _props4.building,
	        user = _props4.user,
	        selection = _props4.selection,
	        match = _props4.match,
	        noPageExist = _props4.noPageExist,
	        t = _props4.t;
	    var params = match.params;
	
	    var _ref4 = building.data || {},
	        region = _ref4.region,
	        subregion = _ref4.subregion,
	        comment = _ref4.comment;
	
	    if (noPageExist) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Main2.default.Building, _Main2.default.Client) },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            t('components.building.main.main.title', {
	              title: selection.showInfo === '1' ? _this5.props.building.data.title + ' -' : ''
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _ClientHeader2.default,
	          { params: params },
	          _react2.default.createElement(_NoPage2.default, null)
	        )
	      );
	    }
	
	    var galleryImagesCount = 0;
	    var pavilions = void 0,
	        deadline = void 0,
	        finished = void 0;
	    if (building.data) {
	      if (building.data.albums.rows) {
	        for (var i = 0; i < building.data.albums.rows.length; i++) {
	          galleryImagesCount += building.data.albums.rows[i].images ? building.data.albums.rows[i].images.length : 0;
	        }
	      }
	
	      var year = void 0,
	          quarter = void 0;
	      pavilions = building.data.pavilions;
	      var check = 20994; // 2099 г. 4 кв.
	      finished = (pavilions || []).some(function (pavilion) {
	        var construction_finished = pavilion.construction_finished,
	            year_built = pavilion.year_built,
	            construction_ending = pavilion.construction_ending;
	
	        var current = Number('' + year_built + construction_ending);
	        if (year_built && construction_ending && check > current) {
	          check = current;
	          year = year_built;
	          quarter = construction_ending;
	        }
	        return construction_finished;
	      });
	      deadline = finished ? t('components.building.main.main.finished') : year === 0 ? t('components.building.main.main.inProgress') : year && quarter ? quarter + ' / ' + year : '';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Main2.default.Building, _Main2.default.Client) },
	      building.isLoading || !building.data ? _react2.default.createElement(_Loader2.default, { className: _Main2.default.ObjectPageLoader }) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            (0, _helper.isSectionAllowed)('nameAddress') ? t('components.building.main.main.title', {
	              title: selection.showInfo === '1' ? _this5.props.building.data.title + ' -' : ''
	            }) : 'Nedvex'
	          )
	        ),
	        _react2.default.createElement(
	          _ClientHeader2.default,
	          { params: params },
	          _react2.default.createElement(
	            'div',
	            { className: _Main2.default.ContainerWrapper },
	            _react2.default.createElement(
	              _reactScroll.Element,
	              { name: 'photo' },
	              _react2.default.createElement(
	                'div',
	                { className: _Main2.default.GalleryHeader },
	                galleryImagesCount ? _react2.default.createElement(
	                  'button',
	                  {
	                    className: _Main2.default.GalleryButton,
	                    onClick: _this5.changePopUpState.bind(_this5, true, false)
	                  },
	                  _react2.default.createElement('img', { src: _iconPhotos2.default, alt: '' }),
	                  ' ',
	                  t('components.building.main.main.allOnMap', { galleryImagesCount: galleryImagesCount })
	                ) : null,
	                _this5.props.client && galleryImagesCount === 0 ? _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.GalleryEmptyHeaderInner },
	                  _react2.default.createElement('img', { src: _noFloor2.default, alt: '' }),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    t('components.building.main.main.noViews')
	                  )
	                ) : _this5.renderHeaderImages(),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.Status },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: (0, _classnames2.default)(finished ? _Main2.default.Green : _Main2.default.Yellow, _Main2.default.StatusBlock)
	                    },
	                    deadline
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Main2.default.Container, id: 'container-main' },
	              _react2.default.createElement(
	                'div',
	                { className: _Main2.default.LeftRow },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.NavWrapper },
	                  _react2.default.createElement(_Nav2.default, rest)
	                ),
	                comment && _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.CommentBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Main2.default.CommentAuthor },
	                    _react2.default.createElement('img', {
	                      src: user.avatarId ? _Config.ROOT_URL + '/image/get?id=' + user.avatarId + '&preset=profile_avatar' : 'https://nedvex.ru/static/media/icon-user.553f82d8.svg',
	                      alt: ''
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Main2.default.CommentAuthorName },
	                      user.firstName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Main2.default.CommentMain },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _Main2.default.CommentText },
	                      _react2.default.createElement('span', { className: _Main2.default.Arrow }),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        comment
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(_BuildingTitle2.default, _extends({}, rest, { client: true, showInfo: selection.showInfo })),
	                _react2.default.createElement(
	                  _reactScroll.Element,
	                  { name: 'info' },
	                  _react2.default.createElement(_Info2.default, _extends({}, rest, { client: true }))
	                ),
	                (0, _helper.isSectionAllowed)('description') && (building.data.description || Object.keys(_Features4.default).some(function (feature) {
	                  return building.data[feature];
	                })) && _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.DescriptionAndFeatures },
	                  selection.showInfo === '1' && _react2.default.createElement(_Description2.default, _extends({}, rest, { className: _Main2.default.Description })),
	                  _react2.default.createElement(_Features2.default, _extends({}, rest, { className: (0, _classnames2.default)(_Main2.default.Features) }))
	                ),
	                ((0, _helper.isSectionAllowed)('characteristics') || (0, _helper.isSectionAllowed)('communications')) && _react2.default.createElement(_About2.default, rest),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.FormalizationAndPaymentWrap },
	                  (0, _helper.isSectionAllowed)('checkout') && _react2.default.createElement(_Formalization2.default, rest),
	                  (0, _helper.isSectionAllowed)('payment') && building.data.count_flats ? _react2.default.createElement(_Payment2.default, rest) : null
	                ),
	                (0, _helper.isSectionAllowed)('nameAddress') && _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.MapBlockWrap },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _Main2.default.MapBlockTitle },
	                    region.name,
	                    ', ',
	                    subregion.name
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: _Main2.default.MapBlock,
	                      onClick: _this5.changePopUpState.bind(_this5, true, true)
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)(_Main2.default.MapCover) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _Main2.default.Div },
	                        _react2.default.createElement(_map2.default, { className: _Main2.default.MapIcon }),
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          t('components.building.main.main.lookOnMap')
	                        )
	                      )
	                    ),
	                    _this5.renderHeaderMap()
	                  )
	                ),
	                building.data.type_id != 2 && _react2.default.createElement(_Housing2.default, _extends({}, rest, { client: true })),
	                (0, _helper.getLotsType)() > 0 && _react2.default.createElement(
	                  _reactScroll.Element,
	                  { name: 'flats' },
	                  _react2.default.createElement(_FlatsList2.default, _extends({}, rest, {
	                    selectionId: Number(_this5.props.selection.id),
	                    sessionId: _this5.sessionUuid
	                  }))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Main2.default.RightRow, _Main2.default.NotMobile) },
	                _react2.default.createElement(
	                  _reactStickyEl2.default,
	                  {
	                    stickyClassName: _Main2.default.stickyEl,
	                    boundaryElement: '#container-main',
	                    bottomOffset: 90
	                  },
	                  user && _react2.default.createElement(_RealtorCard2.default, _extends({}, user, {
	                    onPhoneClick: function onPhoneClick() {
	                      return _this5.handleAddStats('phoneClicks');
	                    }
	                  }))
	                )
	              ),
	              _this5.renderPopup(building)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  this.renderForManager = function () {
	    var _props5 = _this5.props,
	        data = _props5.data,
	        isBuildingLoading = _props5.isBuildingLoading,
	        t = _props5.t,
	        objectType = _props5.objectType,
	        rest = _objectWithoutProperties(_props5, ['data', 'isBuildingLoading', 't', 'objectType']);
	
	    var building = rest.building,
	        withClient = rest.withClient,
	        profile = rest.profile;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _Main2.default.Building },
	      isBuildingLoading || !building.data ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _Main2.default.Container },
	          _react2.default.createElement(_LeftWireframe2.default, { className: _Main2.default.LeftRow }),
	          _react2.default.createElement(_RightWireframe2.default, { className: _Main2.default.RightRow })
	        ),
	        _react2.default.createElement(_SuggestionsWireframe2.default, null)
	      ) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_BuildingTitle2.default, _extends({}, rest, { isBuildingLoading: isBuildingLoading })),
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            t('components.building.main.main.title', {
	              title: _this5.props.building.data.title + ' -'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Main2.default.ContainerWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _Main2.default.Container },
	              _react2.default.createElement(
	                'div',
	                { className: _Main2.default.LeftRow },
	                _this5.renderGalleryComponent(rest),
	                _react2.default.createElement(_Info2.default, rest),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_Main2.default.RightRow, _Main2.default.OnlyMobile) },
	                  !withClient && _react2.default.createElement(_News2.default, rest),
	                  !withClient && _react2.default.createElement(_Developer2.default, rest),
	                  !withClient && _react2.default.createElement(_Contacts2.default, _extends({}, rest, { objectType: objectType })),
	                  _react2.default.createElement(_Documents2.default, rest),
	                  !withClient && _react2.default.createElement(_InaccuracyReport2.default, {
	                    building: building.data,
	                    withText: true,
	                    className: _Main2.default.InaccuracyReportWrap,
	                    profile: profile,
	                    objectType: objectType
	                  })
	                ),
	                building.data && building.data.description && _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.DescriptionTitle },
	                  t('components.building.main.main.about', {
	                    type: (0, _helper.getBuildingType)(building.data.type_id)
	                  })
	                ),
	                _react2.default.createElement(_Description2.default, _extends({}, rest, { className: _Main2.default.Description })),
	                _react2.default.createElement(_Features2.default, _extends({}, rest, { className: (0, _classnames2.default)(_Main2.default.Features) })),
	                _react2.default.createElement(_About2.default, rest),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Main2.default.FormalizationAndPaymentWrap },
	                  _react2.default.createElement(_Formalization2.default, rest),
	                  building.data.count_flats ? _react2.default.createElement(_Payment2.default, rest) : null
	                ),
	                building.data.type_id != 2 && _react2.default.createElement(_Housing2.default, rest)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Main2.default.RightRow, _Main2.default.NotMobile) },
	                !withClient && _react2.default.createElement(_News2.default, rest),
	                !withClient && _react2.default.createElement(_Developer2.default, rest),
	                !withClient && _react2.default.createElement(_Contacts2.default, _extends({}, rest, { objectType: objectType })),
	                _react2.default.createElement(_Documents2.default, rest),
	                _react2.default.createElement('div', { className: _Main2.default.Divider }),
	                !withClient && !isBuildingLoading && _react2.default.createElement(_InaccuracyReport2.default, {
	                  building: building.data,
	                  withText: true,
	                  className: _Main2.default.InaccuracyReportWrap,
	                  profile: profile,
	                  objectType: objectType
	                })
	              ),
	              _this5.renderPopup(building)
	            )
	          ),
	          _react2.default.createElement(_Suggestions2.default, rest)
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  this.renderForPrint = function () {
	    var _props6 = _this5.props,
	        print = _props6.print,
	        t = _props6.t,
	        rest = _objectWithoutProperties(_props6, ['print', 't']);
	
	    var building = rest.building;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_Main2.default.Building, _Main2.default.BuildingPrint) },
	      _react2.default.createElement(
	        'div',
	        { className: _Main2.default.PrintLoaderWrap },
	        _react2.default.createElement('div', { className: _Main2.default.PrintLoader }),
	        _react2.default.createElement(
	          'div',
	          { className: _Main2.default.PrintLoaderText },
	          t('components.building.main.main.print')
	        )
	      ),
	      building.isLoading || !building.data ? _react2.default.createElement('div', { className: _Main2.default.Container }) : _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Main2.default.Container, _Main2.default.PrintContainer) },
	        print.desc && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Main2.default.LeftRow, _Main2.default.PrintSection, _Main2.default.PrintSectionDesc) },
	          _react2.default.createElement(_BuildingTitle2.default, _extends({}, rest, { print: print })),
	          _react2.default.createElement(_Description2.default, _extends({}, rest, { print: print }))
	        ),
	        print.info && _react2.default.createElement(
	          'div',
	          { className: _Main2.default.PrintSectionInfoWrapper },
	          _react2.default.createElement(_BuildingTitle2.default, _extends({}, rest, { print: print })),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Main2.default.PrintSectionInfo) },
	            _react2.default.createElement(
	              'div',
	              { className: _Main2.default.LeftRow },
	              _react2.default.createElement(
	                'div',
	                { className: _Main2.default.LeftRowPrintLeft },
	                _react2.default.createElement(_About2.default, _extends({}, rest, { print: print })),
	                _react2.default.createElement(_Features2.default, _extends({}, rest, { print: print }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Main2.default.LeftRowPrintRight },
	                _react2.default.createElement(_Formalization2.default, _extends({}, rest, { print: print })),
	                building.data.count_flats ? _react2.default.createElement(_Payment2.default, _extends({}, rest, { print: print })) : null
	              )
	            ),
	            building.data.type_id != 2 && _react2.default.createElement(
	              'div',
	              { className: _Main2.default.RightRow },
	              _react2.default.createElement(_Housing2.default, _extends({}, rest, { print: print }))
	            )
	          )
	        ),
	        print.contacts && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Main2.default.PrintSection, _Main2.default.PrintSectionContacts) },
	          _react2.default.createElement(_BuildingTitle2.default, _extends({}, rest, { print: print })),
	          _react2.default.createElement(_Developer2.default, _extends({}, rest, { print: print })),
	          _react2.default.createElement(_Contacts2.default, _extends({}, rest, { print: print, objectType: objectType }))
	        )
	      )
	    );
	  };
	}, _temp);
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    cities: state.building.cities,
	    profile: state.profile,
	    objectType: state.building.data && state.building.data.type_id == 1 ? 'zhk' : 'kp_i_th'
	  };
	})(Main));

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScroll = __webpack_require__(687);
	
	var _reactI18next = __webpack_require__(4);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1359);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _utils = __webpack_require__(12);
	
	var _updateArrows = __webpack_require__(237);
	
	var _updateArrows2 = _interopRequireDefault(_updateArrows);
	
	var _helper = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	  }
	
	  _createClass(Nav, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _reactScroll.Events.scrollEvent.register('begin', function (to, element) {
	        console.log('begin', arguments);
	      });
	
	      _reactScroll.Events.scrollEvent.register('end', function (to, element) {
	        console.log('end', arguments);
	      });
	
	      _reactScroll.scrollSpy.update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactScroll.Events.scrollEvent.remove('begin');
	      _reactScroll.Events.scrollEvent.remove('end');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var update = this.props.building.data.update;
	
	      var updateTime = void 0;
	      if (update) {
	        if ((0, _utils.updateString)(update).indexOf('Сегодня') == 0) {
	          updateTime = 'cегодня';
	        } else {
	          updateTime = (0, _utils.updateString)(update);
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.ObjectNav },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ObjectNavInner },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.ObjectNavBtns },
	            _react2.default.createElement(
	              _reactScroll.Link,
	              {
	                to: 'photo',
	                className: (0, _classnames2.default)(_styles2.default.ObjectNavBtn, _styles2.default.Active),
	                activeClass: _styles2.default.Active,
	                offset: -80,
	                duration: 500,
	                smooth: true
	              },
	              t('components.building.main.nav.photo')
	            ),
	            _react2.default.createElement(
	              _reactScroll.Link,
	              {
	                to: 'info',
	                className: _styles2.default.ObjectNavBtn,
	                activeClass: _styles2.default.Active,
	                offset: -80,
	                duration: 500,
	                smooth: true
	              },
	              t('components.building.main.nav.info')
	            ),
	            (0, _helper.getLotsType)() > 0 && _react2.default.createElement(
	              _reactScroll.Link,
	              {
	                to: 'flats',
	                className: _styles2.default.ObjectNavBtn,
	                activeClass: _styles2.default.Active,
	                offset: -80,
	                duration: 500,
	                smooth: true
	              },
	              t('components.building.main.nav.flats')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: _styles2.default.UpdatedTime,
	              'data-tip': t('components.building.main.nav.tip'),
	              'data-for': 'global'
	            },
	            _react2.default.createElement('img', { alt: 'icon', src: _updateArrows2.default }),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Hide1180 },
	                t('components.building.main.nav.updated')
	              ),
	              ' ',
	              updateTime
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Nav;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Nav);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Nav = __webpack_require__(945);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Nav2.default;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ScrollLock = __webpack_require__(163);
	
	var _ScrollLock2 = _interopRequireDefault(_ScrollLock);
	
	var _News = __webpack_require__(1360);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _arrowRight = __webpack_require__(1524);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _utils = __webpack_require__(12);
	
	var _building = __webpack_require__(54);
	
	var _environment = __webpack_require__(19);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var News = function (_Component) {
	  _inherits(News, _Component);
	
	  function News() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, News);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = News.__proto__ || Object.getPrototypeOf(News)).call.apply(_ref, [this].concat(args))), _this), _this.handleShowNewsText = function (dateUpdate, name) {
	      var _this$props = _this.props,
	          building = _this$props.building,
	          t = _this$props.t;
	
	
	      _this.handleTrackEvent({ eventName: 'buildingNewsLinksClick' });
	
	      _this.props.setPopUp(_react2.default.createElement(
	        'div',
	        { className: _News2.default.NewsPopupWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _News2.default.PopupTitle },
	          _react2.default.createElement(
	            'span',
	            null,
	            t('components.building.main.news.titleBig', {
	              title: building.data.title
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _ScrollLock2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_News2.default.PopupNewsList, 'custom-scrollbar') },
	            _react2.default.createElement(
	              'div',
	              { className: _News2.default.PopupNewsItem, key: dateUpdate },
	              _react2.default.createElement(
	                'time',
	                { className: _News2.default.PopupNewsItemDate },
	                (0, _utils.formatDate)(dateUpdate)
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _News2.default.PopupNewsItemText },
	                (0, _helper.linkifyText)(name)
	              )
	            )
	          )
	        )
	      ), {
	        className: _News2.default.NewsPopup,
	        contentClassName: _News2.default.NewsPopupContent,
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false,
	        onClose: function onClose() {
	          return _this.handleTrackEvent({ eventName: 'buildingNewsDialogClose' });
	        }
	      });
	    }, _this.handleMoreClick = function (e) {
	      e.preventDefault();
	      var _this$props2 = _this.props,
	          building = _this$props2.building,
	          t = _this$props2.t;
	      var news = building.news;
	
	
	      _this.handleTrackEvent({ eventName: 'buildingNewsLinksClick' });
	
	      _this.props.setPopUp(_react2.default.createElement(
	        'div',
	        { className: _News2.default.NewsPopupWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _News2.default.PopupTitle },
	          _react2.default.createElement(
	            'span',
	            null,
	            t('components.building.main.news.titleBig', {
	              title: building.data.title
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _ScrollLock2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_News2.default.PopupNewsList, 'custom-scrollbar') },
	            news.map(function (_ref2, i) {
	              var dateUpdate = _ref2.dateUpdate,
	                  name = _ref2.name;
	
	              var message = (0, _helper.linkifyText)(name);
	
	              return _react2.default.createElement(
	                'div',
	                { className: _News2.default.PopupNewsItem, key: i + '-' + dateUpdate + '-' + name },
	                _react2.default.createElement(
	                  'time',
	                  { className: _News2.default.PopupNewsItemDate },
	                  (0, _utils.formatDate)(dateUpdate)
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: _News2.default.PopupNewsItemText },
	                  message
	                )
	              );
	            })
	          )
	        )
	      ), {
	        className: _News2.default.NewsPopup,
	        contentClassName: _News2.default.NewsPopupContent,
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false,
	        onClose: function onClose() {
	          return _this.handleTrackEvent({ eventName: 'buildingNewsDialogClose' });
	        }
	      });
	    }, _this.handleTrackEvent = function (_ref3) {
	      var eventName = _ref3.eventName;
	      var _this$props3 = _this.props,
	          building = _this$props3.building,
	          profile = _this$props3.profile,
	          objectType = _this$props3.objectType;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(News, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      if (!this.props.isNewsLoading) {
	        this.props.loadNews(this.props.params.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          building = _props.building,
	          client = _props.client,
	          t = _props.t;
	      var news = building.news;
	
	
	      var sortedNews = news && news.sort(function (a, b) {
	        if (a.dateUpdate > b.dateUpdate) return -1;
	        if (a.dateUpdate < b.dateUpdate) return 1;
	        return 0;
	      });
	
	      return news && news.length ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_News2.default.News, className) },
	        _react2.default.createElement(
	          'h3',
	          { className: client ? _News2.default.TitleClient : _News2.default.Title },
	          t('components.building.main.news.title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _News2.default.NewsList },
	          sortedNews.slice(0, 3).map(function (_ref4, i) {
	            var dateUpdate = _ref4.dateUpdate,
	                name = _ref4.name;
	            return _react2.default.createElement(
	              'div',
	              { className: _News2.default.NewsItem, key: dateUpdate + '-' + name + '-' + i },
	              _react2.default.createElement(
	                'time',
	                { className: _News2.default.NewsItemDate },
	                (0, _utils.formatDate)(dateUpdate)
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _News2.default.NewsItemText },
	                (0, _helper.linkifyText)(name, 100)
	              ),
	              name.length > 100 ? _react2.default.createElement(
	                'span',
	                {
	                  onClick: function onClick() {
	                    return _this2.handleShowNewsText(dateUpdate, name);
	                  },
	                  className: _News2.default.NewsItemLink
	                },
	                t('components.building.main.news.readMore')
	              ) : null
	            );
	          }),
	          news.length > 3 ? _react2.default.createElement(
	            'span',
	            { className: _News2.default.AllNews, onClick: this.handleMoreClick },
	            t('components.building.main.news.seeAll'),
	            ' (',
	            news.length,
	            ')',
	            ' ',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: '' })
	          ) : ''
	        )
	      ) : null;
	    }
	  }]);
	
	  return News;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    isNewsLoading: state.building.isNewsLoading
	  };
	}, { loadNews: _building.loadNews, setPopUp: _environment.setPopUp })(News));

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Payment = __webpack_require__(1361);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _utils = __webpack_require__(12);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable */
	
	
	var checkIcon = __webpack_require__(339);
	var noIcon = __webpack_require__(1547);
	
	var checkIconPrint = __webpack_require__(1527);
	var noIconPrint = __webpack_require__(340);
	
	var digits = function digits(number) {
	  return number ? (0, _utils.formatNumber)(number) : 0;
	};
	
	var icon = function icon(factor, print) {
	  return _react2.default.createElement(
	    'div',
	    { className: _Payment2.default.Image },
	    print ? _react2.default.createElement('img', { alt: 'icon', src: factor ? checkIconPrint : noIconPrint }) : _react2.default.createElement('img', { alt: 'icon', src: factor ? checkIcon : noIcon })
	  );
	};
	
	var Payment = function Payment(_ref) {
	  var className = _ref.className,
	      building = _ref.building,
	      client = _ref.client,
	      print = _ref.print,
	      profile = _ref.profile,
	      objectType = _ref.objectType;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _building$data = building.data,
	      payment = _building$data.payment,
	      instalment_payments_conditions = _building$data.instalment_payments_conditions,
	      gas_surcharge_price = _building$data.gas_surcharge_price,
	      surcharge_balcony = _building$data.surcharge_balcony,
	      surcharge_communications = _building$data.surcharge_communications,
	      surcharge_docs = _building$data.surcharge_docs,
	      surcharge_trash = _building$data.surcharge_trash,
	      balcony_surcharge_price = _building$data.balcony_surcharge_price,
	      communications_surcharge_price = _building$data.communications_surcharge_price,
	      docs_surcharge_price = _building$data.docs_surcharge_price,
	      trash_surcharge_price = _building$data.trash_surcharge_price,
	      country = _building$data.country;
	  var currency = country.country_currency_symbol;
	  var ipoteka = payment.ipoteka,
	      military_ipoteka = payment.military_ipoteka,
	      mat_capital = payment.mat_capital,
	      installments = payment.installments,
	      cash = payment.cash,
	      taxes = payment.taxes,
	      is_ipoteka_family = payment.is_ipoteka_family,
	      is_ipoteka_state_support = payment.is_ipoteka_state_support,
	      is_ipoteka_it = payment.is_ipoteka_it,
	      is_ipoteka_tranche = payment.is_ipoteka_tranche,
	      is_ipoteka_subsidized = payment.is_ipoteka_subsidized,
	      is_ipoteka_preferential = payment.is_ipoteka_preferential;
	
	
	  var arr = [{
	    text: t('components.building.main.payment.taxes'),
	    value: icon(taxes, print),
	    check: taxes,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.military_ipoteka'),
	    value: icon(military_ipoteka, print),
	    check: military_ipoteka,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.ipoteka'),
	    value: icon(ipoteka, print),
	    check: ipoteka,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_it'),
	    value: icon(is_ipoteka_it, print),
	    check: is_ipoteka_it,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_family'),
	    value: icon(is_ipoteka_family, print),
	    check: is_ipoteka_family,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_state_support'),
	    value: icon(is_ipoteka_state_support, print),
	    check: is_ipoteka_state_support,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_subsidized'),
	    value: icon(is_ipoteka_subsidized, print),
	    check: is_ipoteka_subsidized,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_tranche'),
	    value: icon(is_ipoteka_tranche, print),
	    check: is_ipoteka_tranche,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.is_ipoteka_preferential'),
	    value: icon(is_ipoteka_preferential, print),
	    check: is_ipoteka_preferential,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.mat_capital'),
	    value: icon(mat_capital, print),
	    check: mat_capital,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.cash'),
	    value: icon(cash, print),
	    check: cash,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.installments'),
	    subtext: instalment_payments_conditions,
	    value: icon(installments, print),
	    check: installments,
	    shouldDisplay: true
	  }, {
	    text: t('components.building.main.payment.surcharge_balcony'),
	    value: t('components.building.main.payment.price', { price: (0, _utils.formatNumber)(balcony_surcharge_price), currency: currency }),
	    shouldDisplay: surcharge_balcony
	  }, {
	    text: t('components.building.main.payment.surcharge_communications'),
	    value: t('components.building.main.payment.price', { price: (0, _utils.formatNumber)(communications_surcharge_price), currency: currency }),
	    shouldDisplay: surcharge_communications
	  }, {
	    text: t('components.building.main.payment.surcharge_docs'),
	    value: t('components.building.main.payment.price', { price: (0, _utils.formatNumber)(docs_surcharge_price), currency: currency }),
	    shouldDisplay: surcharge_docs
	  }, {
	    text: t('components.building.main.payment.surcharge_trash'),
	    value: t('components.building.main.payment.price', { price: (0, _utils.formatNumber)(trash_surcharge_price), currency: currency }),
	    shouldDisplay: surcharge_trash
	  }];
	
	  var gas = digits(gas_surcharge_price);
	  if (gas !== 0) {
	    arr.push({
	      text: t('components.building.main.payment.gas'),
	      value: _react2.default.createElement(
	        'span',
	        null,
	        t('components.building.main.payment.price', { price: gas, currency: currency })
	      ),
	      shouldDisplay: true
	    });
	  }
	
	  var handleTrackEvent = function handleTrackEvent() {
	    var _building$data2 = building.data,
	        title = _building$data2.title,
	        id = _building$data2.id;
	
	
	    (0, _ga.trackGA)(_ga.gaEvent.buildingInfoBlocksShow({
	      eventLabel: 'oplata',
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    handleTrackEvent();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Payment2.default.Payment, _defineProperty({}, _Payment2.default.Client, client), className, _defineProperty({}, _Payment2.default.PaymentPrint, print)) },
	    _react2.default.createElement(
	      'h3',
	      { className: client ? _Payment2.default.TitleClient : _Payment2.default.Title },
	      t('components.building.main.payment.pay')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: client ? _Payment2.default.InnerClient : _Payment2.default.Inner },
	      arr.map(function (row, index) {
	        if (row.check) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: (0, _classnames2.default)(_Payment2.default.Row, row.text == 'Доплата за газ' ? _Payment2.default.RowGas : null) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Payment2.default.Label, _defineProperty({}, _Payment2.default.LabelActive, row.check)) },
	              _react2.default.createElement(
	                'span',
	                null,
	                row.text
	              ),
	              row.subtext ? _react2.default.createElement(
	                'span',
	                { className: _Payment2.default.Subtext },
	                row.subtext
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Payment2.default.Name },
	              row.value
	            )
	          );
	        }
	      })
	    )
	  );
	};
	
	exports.default = Payment;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _List = __webpack_require__(1362);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Config = __webpack_require__(16);
	
	var _bannerPlaceholder = __webpack_require__(173);
	
	var _bannerPlaceholder2 = _interopRequireDefault(_bannerPlaceholder);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_List2.default);
	
	var addDefaultSrc = function addDefaultSrc(ev) {
	  ev.target.src = _bannerPlaceholder2.default;
	};
	
	var itemCards = function itemCards(galleryData, galleryRef, albums, onImage, currentAlbum, profile, buildingData, objectType) {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var handleTrackEvent = function handleTrackEvent(_ref) {
	    var eventContent = _ref.eventContent;
	    var title = buildingData.title,
	        id = buildingData.id;
	
	
	    (0, _ga.trackGA)(_ga.gaEvent.buildingGalleryAlbumsButtonsClick({
	      eventContent: eventContent,
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  return albums.rows.map(function (a, i) {
	    return a.images ? _react2.default.createElement(
	      'div',
	      {
	        onClick: function onClick() {
	          onImage.bind(undefined, galleryData.metaForGallery.meta[i].first, i)();
	          galleryRef.slideToIndex(galleryData.metaForGallery.meta[i].first);
	          handleTrackEvent({
	            eventContent: galleryData.metaForGallery.meta[i].month && galleryData.metaForGallery.meta[i].year ? '' + (galleryData.metaForGallery.meta[i].month ? galleryData.metaForGallery.meta[i].month + ' ' + (galleryData.metaForGallery.meta[i].year !== 0 ? galleryData.metaForGallery.meta[i].year : '') : '') : '' + a.type.name
	          });
	        },
	        onMouseUp: function onMouseUp() {
	          onImage.bind(undefined, galleryData.metaForGallery.meta[i].first, i)();
	          galleryRef.slideToIndex(galleryData.metaForGallery.meta[i].first);
	        },
	        className: cx(_List2.default.Item, { ActiveItem: i === currentAlbum }),
	        key: i
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _List2.default.Image },
	        _react2.default.createElement('img', {
	          onError: addDefaultSrc,
	          alt: 'preview album',
	          src: _Config.ROOT_URL + '/image?id=' + a.images[0].id + '&size=medium'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _List2.default.Text },
	        _react2.default.createElement(
	          'div',
	          { className: _List2.default.Name },
	          galleryData.metaForGallery.meta[i].month && galleryData.metaForGallery.meta[i].year ? '' + (galleryData.metaForGallery.meta[i].month ? galleryData.metaForGallery.meta[i].month + ' ' + (galleryData.metaForGallery.meta[i].year !== 0 ? galleryData.metaForGallery.meta[i].year : '') : '') : '' + a.type.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _List2.default.Label },
	          a.images ? a.images.length : 0,
	          ' ',
	          t('components.building.main.popup.photo')
	        )
	      )
	    ) : null;
	  });
	};
	
	var List = function List(_ref2) {
	  var className = _ref2.className,
	      galleryData = _ref2.galleryData,
	      galleryRef = _ref2.galleryRef,
	      albums = _ref2.albums,
	      onImage = _ref2.onImage,
	      currentAlbum = _ref2.currentAlbum,
	      profile = _ref2.profile,
	      buildingData = _ref2.buildingData,
	      objectType = _ref2.objectType;
	  return albums.rows.length > 1 ? _react2.default.createElement(
	    'div',
	    { className: (0, _bind2.default)(_List2.default.List, className) },
	    itemCards(galleryData, galleryRef, albums, onImage, currentAlbum, profile, buildingData, objectType)
	  ) : null;
	};
	
	exports.default = List;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Popup = __webpack_require__(1363);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Popup = function Popup(_ref) {
	  var className = _ref.className,
	      isOpen = _ref.isOpen,
	      render = _ref.render;
	  return isOpen ? _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_Popup2.default.Popup, className) },
	    _react2.default.createElement(
	      'div',
	      { className: _Popup2.default.Content },
	      render ? render() : null
	    )
	  ) : null;
	};
	
	exports.default = Popup;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Wireframe = __webpack_require__(1364);
	
	var _Wireframe2 = _interopRequireDefault(_Wireframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wireframe = function (_Component) {
	  _inherits(Wireframe, _Component);
	
	  function Wireframe() {
	    _classCallCheck(this, Wireframe);
	
	    return _possibleConstructorReturn(this, (Wireframe.__proto__ || Object.getPrototypeOf(Wireframe)).apply(this, arguments));
	  }
	
	  _createClass(Wireframe, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          client = _props.client,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Wireframe2.default.RightRow, this.props.className) },
	        client ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.RealtorCard },
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.RealtorInfo },
	              _react2.default.createElement('div', { className: _Wireframe2.default.Avatar }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.Name }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.Position })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.RealtorContacts },
	              _react2.default.createElement('div', { className: _Wireframe2.default.RealtorContact }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.RealtorContact })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.RealtorSocial },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.RealtorSocialTitle },
	                t('components.building.main.rightWireframe.social')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.SocialLinks },
	                _react2.default.createElement('div', null),
	                _react2.default.createElement('div', null),
	                _react2.default.createElement('div', null),
	                _react2.default.createElement('div', null),
	                _react2.default.createElement('div', null)
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Section },
	            _react2.default.createElement(
	              'h3',
	              { className: _Wireframe2.default.Title },
	              t('components.building.main.rightWireframe.builder')
	            ),
	            _react2.default.createElement('div', { className: _Wireframe2.default.InnerBuilder })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Section },
	            _react2.default.createElement(
	              'h3',
	              { className: _Wireframe2.default.Title },
	              t('components.building.main.rightWireframe.commission')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.Inner },
	              _react2.default.createElement('div', { className: _Wireframe2.default.TextLine }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.TextLine }),
	              _react2.default.createElement('div', { className: _Wireframe2.default.TextLine })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Section },
	            _react2.default.createElement(
	              'h3',
	              { className: _Wireframe2.default.Title },
	              t('components.building.main.rightWireframe.contacts')
	            ),
	            _react2.default.createElement('div', { className: _Wireframe2.default.InnerContacts })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Wireframe2.default.Section },
	            _react2.default.createElement(
	              'h3',
	              { className: _Wireframe2.default.Title },
	              t('components.building.main.rightWireframe.docs')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Wireframe2.default.Inner },
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.DocumentRow },
	                _react2.default.createElement('div', { className: _Wireframe2.default.Label }),
	                _react2.default.createElement('div', { className: _Wireframe2.default.Name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.DocumentRow },
	                _react2.default.createElement('div', { className: _Wireframe2.default.Label }),
	                _react2.default.createElement('div', { className: _Wireframe2.default.Name })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Wireframe;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Wireframe);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSlick = __webpack_require__(2061);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactI18next = __webpack_require__(4);
	
	var _BuildingCard = __webpack_require__(310);
	
	var _BuildingCard2 = _interopRequireDefault(_BuildingCard);
	
	var _Config = __webpack_require__(16);
	
	var _building = __webpack_require__(54);
	
	var _Suggestions = __webpack_require__(1365);
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Suggestions = function (_Component) {
	  _inherits(Suggestions, _Component);
	
	  function Suggestions(props) {
	    _classCallCheck(this, Suggestions);
	
	    var _this = _possibleConstructorReturn(this, (Suggestions.__proto__ || Object.getPrototypeOf(Suggestions)).call(this, props));
	
	    _this.componentWillUnmount = function () {
	      _this._buildingRequest && clearTimeout(_this._buildingRequest);
	      _this._buildingRequest = null;
	    };
	
	    _this.renderItem = function (index, key) {
	      return _react2.default.createElement(
	        'div',
	        { className: _Suggestions2.default.Item, key: key },
	        _react2.default.createElement(_BuildingCard2.default, _extends({}, _this.state.buildings[index], { currency: _this.props.currency }))
	      );
	    };
	
	    _this.handleNextClick = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingSuggestionsButtonsClick',
	        eventContent: 'vpravo'
	      });
	
	      _this.slider.slickNext();
	    };
	
	    _this.handlePrevClick = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingSuggestionsButtonsClick',
	        eventContent: 'vlevo'
	      });
	
	      _this.slider.slickPrev();
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventContent = _ref.eventContent;
	      var _this$props = _this.props,
	          building = _this$props.building,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      buildings: []
	    };
	    return _this;
	  }
	
	  _createClass(Suggestions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var search = {
	        limit: 20,
	        orderDirection: 'DESC',
	        orderField: 'date_update',
	        subregion: [this.props.building.data.subregion.id]
	      };
	      if (this.props.building.data.type_id == 2) {
	        search.typeId = 2;
	      }
	      this._buildingRequest = setTimeout(function () {
	        _axios2.default.post(_Config.ROOT_URL + '/buildings/search', search).then(function (res) {
	          _this2._buildingRequest && _this2.setState({
	            buildings: res.data.data.rows.filter(function (building) {
	              return building.id !== _this2.props.building.data.id;
	            })
	          });
	        });
	      }, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var settings = {
	        dots: false,
	        arrows: false,
	        infinite: false,
	        speed: 500,
	        slidesToScroll: 5,
	        slidesToShow: 5,
	        responsive: [{ breakpoint: 960, settings: { slidesToShow: 3, slidesToScroll: 3 } }, { breakpoint: 1366, settings: { slidesToShow: 4, slidesToScroll: 4 } }]
	      };
	      var _props = this.props,
	          building = _props.building,
	          t = _props.t,
	          currency = _props.currency,
	          profile = _props.profile,
	          location = _props.location;
	
	      return this.state.buildings.length ? _react2.default.createElement(
	        'div',
	        { className: _Suggestions2.default.SectionCarousel },
	        _react2.default.createElement(
	          'div',
	          { className: _Suggestions2.default.Container },
	          _react2.default.createElement(
	            'p',
	            { className: _Suggestions2.default.SectionCarouselTitle },
	            building.data.type_id == 2 ? t('components.building.main.suggestions.jk', {
	              subregion: this.props.building.data.subregion.name
	            }) : t('components.building.main.suggestions.kp', {
	              subregion: this.props.building.data.subregion.name
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Suggestions2.default.Carousel },
	            this.state.buildings.length > 3 ? _react2.default.createElement(
	              'div',
	              { className: _Suggestions2.default.CarouselArrows },
	              _react2.default.createElement('div', { onClick: this.handlePrevClick, className: (0, _classnames2.default)(_Suggestions2.default.CarouselArrow, _Suggestions2.default.Prev) }),
	              _react2.default.createElement('div', { onClick: this.handleNextClick, className: (0, _classnames2.default)(_Suggestions2.default.CarouselArrow, _Suggestions2.default.Next) })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _Suggestions2.default.Slides },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                _extends({ ref: function ref(c) {
	                    return _this3.slider = c;
	                  } }, settings),
	                this.state.buildings.map(function (building) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: building.id },
	                    _react2.default.createElement(_BuildingCard2.default, _extends({}, building, {
	                      currency: currency,
	                      profile: profile,
	                      location: location
	                    }))
	                  );
	                })
	              )
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Suggestions;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(null, { search: _building.search })(Suggestions));

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Suggestions = __webpack_require__(952);
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Suggestions2.default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wireframe = __webpack_require__(1366);
	
	var _Wireframe2 = _interopRequireDefault(_Wireframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wireframe = function (_Component) {
	    _inherits(Wireframe, _Component);
	
	    function Wireframe() {
	        _classCallCheck(this, Wireframe);
	
	        return _possibleConstructorReturn(this, (Wireframe.__proto__ || Object.getPrototypeOf(Wireframe)).apply(this, arguments));
	    }
	
	    _createClass(Wireframe, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _Wireframe2.default.SuggestionsWireframe },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Wireframe2.default.Container },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Wireframe2.default.SuggestionsTitle },
	                        _react2.default.createElement('div', { className: _Wireframe2.default.Title })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Wireframe2.default.SuggestionsCards },
	                        _react2.default.createElement('div', { className: _Wireframe2.default.SuggestionsCard }),
	                        _react2.default.createElement('div', { className: _Wireframe2.default.SuggestionsCard }),
	                        _react2.default.createElement('div', { className: _Wireframe2.default.SuggestionsCard }),
	                        _react2.default.createElement('div', { className: _Wireframe2.default.SuggestionsCard })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Wireframe;
	}(_react.Component);
	
	exports.default = Wireframe;

/***/ }),
/* 955 */
[2396, 954],
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Main = __webpack_require__(944);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckMain = function (_Component) {
	  _inherits(CheckMain, _Component);
	
	  function CheckMain() {
	    _classCallCheck(this, CheckMain);
	
	    return _possibleConstructorReturn(this, (CheckMain.__proto__ || Object.getPrototypeOf(CheckMain)).apply(this, arguments));
	  }
	
	  _createClass(CheckMain, [{
	    key: 'render',
	    value: function render() {
	      var rest = _objectWithoutProperties(this.props, []);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Main2.default, rest)
	      );
	    }
	  }]);
	
	  return CheckMain;
	}(_react.Component);
	
	exports.default = CheckMain;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Print = __webpack_require__(1367);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _iconPrint = __webpack_require__(1553);
	
	var _iconPrint2 = _interopRequireDefault(_iconPrint);
	
	var _environment = __webpack_require__(19);
	
	var _building = __webpack_require__(54);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _PrintDialog = __webpack_require__(959);
	
	var _PrintDialog2 = _interopRequireDefault(_PrintDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var Print = function (_Component) {
	  _inherits(Print, _Component);
	
	  function Print() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Print);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Print.__proto__ || Object.getPrototypeOf(Print)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onPrintClick = _this.props.onPrintClick;
	
	      if (onPrintClick) {
	        onPrintClick();
	      }
	      if (!_this.props.href) {
	        e.preventDefault();
	        var _this$props = _this.props,
	            _loadPavilions = _this$props.loadPavilions,
	            params = _this$props.params,
	            buildingInfo = _this$props.buildingInfo,
	            profile = _this$props.profile,
	            objectType = _this$props.objectType;
	
	        _loadPavilions(params.id).then(function () {
	          var _this$props$building = _this.props.building,
	              pavilions = _this$props$building.pavilions,
	              chessList = _this$props$building.chessList;
	
	          if (!pavilions) return;
	          _this.props.setPopUp(_react2.default.createElement(_PrintDialog2.default, {
	            params: params,
	            buildingInfo: buildingInfo,
	            building: _this.props.building,
	            profile: profile,
	            objectType: objectType
	          }), {
	            closeStyleName: 'Default',
	            contentStyleName: 'Default',
	            contentClassName: _Print2.default.PrintPopupContent,
	            closeIcon: 'default',
	            lockScroll: false
	          });
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Print, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          pure = _props.pure,
	          _props$href = _props.href,
	          href = _props$href === undefined ? '#' : _props$href,
	          tooltip = _props.tooltip;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Print2.default.PrintWrap, className, _defineProperty({}, _Print2.default.Pure, pure)), 'data-tip': tooltip, 'data-for': 'global' },
	        _react2.default.createElement(
	          'a',
	          { className: _Print2.default.ButtonPrint, href: href, target: '_blank', onClick: this.handleClick.bind(this) },
	          _react2.default.createElement('img', { src: _iconPrint2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return Print;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  setPopUp: _environment.setPopUp,
	  loadPavilions: _building.loadPavilions
	})(Print);

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PrintDialog = __webpack_require__(1368);
	
	var _PrintDialog2 = _interopRequireDefault(_PrintDialog);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _ScrollLock = __webpack_require__(163);
	
	var _ScrollLock2 = _interopRequireDefault(_ScrollLock);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _building = __webpack_require__(54);
	
	var _environment = __webpack_require__(19);
	
	var _utils = __webpack_require__(12);
	
	var _Config = __webpack_require__(16);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintDialog = function (_Component) {
	  _inherits(PrintDialog, _Component);
	
	  function PrintDialog(props) {
	    _classCallCheck(this, PrintDialog);
	
	    var _this = _possibleConstructorReturn(this, (PrintDialog.__proto__ || Object.getPrototypeOf(PrintDialog)).call(this, props));
	
	    _this.getGroup = function (group, val) {
	      switch (group) {
	        case 'chess':
	          {
	            return _this.props.pavilions.reduce(function (pavilions, p) {
	              return pavilions.concat(p.sections);
	            }, []).reduce(function (sections, section) {
	              sections['' + group + section.id] = val;return sections;
	            }, {});
	          }
	        case 'plans':
	          {
	            return Object.keys(_this.state.plansData).reduce(function (plans, planId) {
	              plans['' + group + planId] = val;return plans;
	            }, {});
	          }
	        default:
	          {
	            return {};
	          }
	      }
	    };
	
	    _this.handlePrintClick = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingPrintButtonsClick',
	        eventLabel: 'raspechatat'
	      });
	      _this.props.setPopUp();
	    };
	
	    _this.handlePrintSectionClick = function (group) {
	      _this.setState(_defineProperty({}, group, _this.getGroup(group, !Object.values(_this.state[group]).some(_this.id))));
	      var isChecked = Object.values(_this.state[group]).some(function (item) {
	        return item === true;
	      });
	
	      var name = '';
	      switch (group) {
	        case 'chess':
	          name = 'шахматки';
	          break;
	        case 'plans':
	          name = 'планировки';
	          break;
	        default:
	          break;
	      }
	
	      _this.handleTrackEvent({
	        eventName: 'buildingPrintCheckboxesPick',
	        eventContent: name + ' | ' + (isChecked ? 'off' : 'on')
	      });
	    };
	
	    _this.handlePrintItemClick = function (name, group, text, title) {
	      var isChecked = group ? _this.state[group]['' + group + name] : _this.state.query[name];
	
	      _this.handleTrackEvent({
	        eventName: 'buildingPrintCheckboxesPick',
	        eventContent: text + '_' + title + ' | ' + (isChecked ? 'off' : 'on')
	      });
	
	      if (group) {
	        _this.setState(_defineProperty({}, group, _extends({}, _this.state[group], _defineProperty({}, '' + group + name, !_this.state[group]['' + group + name]))));
	      } else {
	        _this.setState({
	          query: _extends({}, _this.state.query, _defineProperty({}, name, !_this.state.query[name]))
	        });
	      }
	    };
	
	    _this.id = function (_) {
	      return _;
	    };
	
	    _this.not = function (_) {
	      return !_;
	    };
	
	    _this.renderPrintItem = function (_ref) {
	      var title = _ref.title,
	          name = _ref.name,
	          group = _ref.group,
	          text = _ref.text;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: group ? _PrintDialog2.default.CheckItemInner : _PrintDialog2.default.CheckItem,
	          key: name
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _PrintDialog2.default.Checkbox },
	          _react2.default.createElement(_Checkbox2.default, {
	            innerStyle: group ? _PrintDialog2.default.ChessCheckInner : _PrintDialog2.default.ChessCheckInner,
	            classNameClone: 'CheckboxClonePrint',
	            text: _react2.default.createElement(
	              'span',
	              null,
	              title
	            ),
	            checked: group ? _this.state[group]['' + group + name] : _this.state.query[name],
	            handle: _this.handlePrintItemClick.bind(_this, name, group, text, title)
	          })
	        )
	      );
	    };
	
	    _this.getRanges = function (array) {
	      var ranges = [],
	          rstart = void 0,
	          rend = void 0;
	      for (var i = 0; i < array.length; i++) {
	        rstart = array[i];
	        rend = rstart;
	        while (array[i + 1] - array[i] === 1) {
	          rend = array[i + 1]; // increment the index if the numbers sequential
	          i++;
	        }
	        ranges.push(rstart === rend ? '' + rstart : rstart + '\u200A\u2014\u200A' + rend);
	      }
	      return ranges;
	    };
	
	    _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent;
	      var _this$props = _this.props,
	          building = _this$props.building,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType;
	      var _building$data = building.data,
	          title = _building$data.title,
	          id = _building$data.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || title,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      query: {},
	      chess: {},
	      plans: {},
	      didReceiveSections: false
	    };
	    return _this;
	  }
	
	  _createClass(PrintDialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        chess: this.getGroup('chess', false)
	      });
	      // awkward code to load all chess sections
	      this.sections = this.props.pavilions.reduce(function (sections, pavilion) {
	        return _extends({}, sections, pavilion.sections.reduce(function (sections, section) {
	          return _extends({}, sections, _defineProperty({}, section.id, _extends({}, section, { pavilionName: pavilion.name })));
	        }, {}));
	      }, {});
	
	      Object.keys(this.sections).map(function (sectionId) {
	        return _this2.props.loadChess({ id: sectionId });
	      });
	
	      this.checkSections(this.props);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleTrackEvent({
	        eventName: 'buildingPrintButtonsClick',
	        eventLabel: 'zakryt'
	      });
	    }
	  }, {
	    key: 'checkSections',
	    value: function checkSections(props) {
	      var _this3 = this;
	
	      if (!this.state.didReceiveSections && Object.keys(this.sections).every(function (sectionId) {
	        return props.chessList[sectionId];
	      })) {
	        var plans = {};
	        Object.keys(props.chessList).forEach(function (sectionId) {
	          return props.chessList[sectionId].cells.forEach(function (_ref3) {
	            var planId = _ref3.planId,
	                row = _ref3.row;
	
	            if (planId) {
	              var plan = plans[planId] || { floor: new Set() };
	              var floor = plan.floor.add(row + 1);
	              plans[planId] = _extends({}, plan, { floor: floor, section: sectionId });
	            }
	          });
	        });
	
	        this.setState({
	          didReceiveSections: true,
	          plansData: plans
	        }, function () {
	          _this3.setState({
	            plans: _this3.getGroup('plans', false)
	          });
	        });
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      this.checkSections(nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          pavilions = _props.pavilions,
	          params = _props.params,
	          buildingInfo = _props.buildingInfo,
	          description = _props.building.data.description,
	          t = _props.t;
	
	      var isDescriptionExists = !!description.length;
	      var items = [];
	      pavilions.forEach(function (pavilion) {
	        var sections = pavilion.sections;
	
	        if (sections) {
	          sections.forEach(function (section) {
	            items.push(_this4.renderPrintItem({
	              title: t('components.building.main.printDialog.item', {
	                pavilion: pavilion.name,
	                section: section.name
	              }),
	              name: '' + section.id,
	              group: 'chess',
	              text: 'шахматка'
	            }));
	          });
	        }
	      });
	
	      var year = void 0,
	          quarter = void 0;
	      var check = 20994; // 2099 г. 4 кв.
	      var finished = (pavilions || []).some(function (pavilion) {
	        var construction_finished = pavilion.construction_finished,
	            year_built = pavilion.year_built,
	            construction_ending = pavilion.construction_ending;
	
	        var current = Number('' + year_built + construction_ending);
	        if (year_built && construction_ending && check > current) {
	          check = current;
	          year = year_built;quarter = construction_ending;
	        }
	        return construction_finished;
	      });
	      var deadline = finished ? t('components.building.main.printDialog.finished') : year === 0 ? t('components.building.main.printDialog.inProgress') : year && quarter ? quarter + ' / ' + year : '';
	      var statusClass = finished ? _PrintDialog2.default.Finished : _PrintDialog2.default.NotFinished;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.pavilions && !this.state.plansData ? _react2.default.createElement('div', { className: _PrintDialog2.default.Loader }) : _react2.default.createElement(
	          'div',
	          { className: _PrintDialog2.default.PopupContent },
	          _react2.default.createElement(
	            'div',
	            { className: _PrintDialog2.default.PopupHeader },
	            t('components.building.main.printDialog.print')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _PrintDialog2.default.ObjectInfo },
	            buildingInfo.imageId ? _react2.default.createElement(
	              'div',
	              { className: _PrintDialog2.default.ObjectInfoImage },
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + buildingInfo.imageId + '&size=small',
	                alt: ''
	              })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _PrintDialog2.default.ObjectInfoText },
	              _react2.default.createElement(
	                'div',
	                { className: _PrintDialog2.default.ObjectInfoTitle },
	                buildingInfo.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _PrintDialog2.default.ObjectInfoAddress },
	                buildingInfo.subregion,
	                ', ',
	                buildingInfo.address
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_PrintDialog2.default.ObjectInfoStatus, statusClass) },
	              deadline
	            )
	          ),
	          _react2.default.createElement(
	            _ScrollLock2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_PrintDialog2.default.PrintPopupContent, 'custom-scrollbar') },
	              this.renderPrintItem({
	                title: t('components.building.main.printDialog.info'),
	                name: 'info',
	                text: 'информация'
	              }),
	              isDescriptionExists && this.renderPrintItem({
	                title: t('components.building.main.printDialog.about'),
	                name: 'desc',
	                text: 'описание'
	              }),
	              this.renderPrintItem({
	                title: t('components.building.main.printDialog.contacts'),
	                name: 'contacts',
	                text: 'контакты'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_PrintDialog2.default.CheckItem, _PrintDialog2.default.WithInner), key: 'chess' },
	                _react2.default.createElement(
	                  'div',
	                  { className: _PrintDialog2.default.Checkbox },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    innerStyle: _PrintDialog2.default.ChessCheckInner,
	                    classNameClone: 'CheckboxClonePrint',
	                    text: _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.main.printDialog.chess')
	                    ),
	                    checked: !Object.values(this.state.chess).some(this.not),
	                    partialChecked: Object.values(this.state.chess).some(this.id),
	                    handle: this.handlePrintSectionClick.bind(this, 'chess')
	                  })
	                ),
	                items
	              ),
	              this.state.plansData && Object.keys(this.state.plansData).length ? _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_PrintDialog2.default.CheckItem, _PrintDialog2.default.WithInner), key: 'plans' },
	                _react2.default.createElement(
	                  'div',
	                  { className: _PrintDialog2.default.Checkbox },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    innerStyle: _PrintDialog2.default.ChessCheckInner,
	                    classNameClone: 'CheckboxClonePrint',
	                    text: _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.building.main.printDialog.planning')
	                    ),
	                    checked: !Object.values(this.state.plans).some(this.not),
	                    partialChecked: Object.values(this.state.plans).some(this.id),
	                    handle: this.handlePrintSectionClick.bind(this, 'plans')
	                  })
	                ),
	                Object.keys(this.state.plansData).map(function (planId) {
	                  var plan = _this4.state.plansData[planId];
	                  return _this4.renderPrintItem({
	                    title: t('components.building.main.printDialog.plans', {
	                      pavilionName: _this4.sections[plan.section].pavilionName,
	                      section: _this4.sections[plan.section].name,
	                      floor: _this4.getRanges([].concat(_toConsumableArray(plan.floor))).join(', ')
	                    }),
	                    name: '' + planId,
	                    group: 'plans',
	                    text: 'план'
	                  });
	                })
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _PrintDialog2.default.PopupFooter },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '/print/' + params.id + '/?' + (0, _utils.compileQuery)(_extends({}, this.state.query, this.state.chess, this.state.plans)),
	                className: (0, _classnames2.default)(_PrintDialog2.default.PopupPrintBtn, 'button-primary', 'button-primary--md'),
	                onClick: this.handlePrintClick,
	                target: '_blank'
	              },
	              t('components.building.main.printDialog.print1')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PrintDialog;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    pavilions: state.building.pavilions,
	    chessList: state.building.chessList
	  };
	}, { setPopUp: _environment.setPopUp, loadChess: _building.loadChess })(PrintDialog));

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintDialog = __webpack_require__(958);
	
	var _PrintDialog2 = _interopRequireDefault(_PrintDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PrintDialog2.default;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _utils = __webpack_require__(12);
	
	var _iconDelete = __webpack_require__(1537);
	
	var _iconDelete2 = _interopRequireDefault(_iconDelete);
	
	var _no_photo_favourite = __webpack_require__(1591);
	
	var _no_photo_favourite2 = _interopRequireDefault(_no_photo_favourite);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BuildingCard = __webpack_require__(1369);
	
	var _BuildingCard2 = _interopRequireDefault(_BuildingCard);
	
	var _reactLazyload = __webpack_require__(1996);
	
	var _FilterLabel = __webpack_require__(311);
	
	var _FilterLabel2 = _interopRequireDefault(_FilterLabel);
	
	var _noFloor = __webpack_require__(238);
	
	var _noFloor2 = _interopRequireDefault(_noFloor);
	
	var _Config = __webpack_require__(16);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildingCard = function (_Component) {
	  _inherits(BuildingCard, _Component);
	
	  function BuildingCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BuildingCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BuildingCard.__proto__ || Object.getPrototypeOf(BuildingCard)).call.apply(_ref, [this].concat(args))), _this), _this.handleDeleteClick = function (data) {
	      var id = data.id,
	          title = data.title;
	
	      _tracker2.default.sendEvent('Web_Favorites_Delete', { id: id, name: title });
	
	      _this.handleTrackEvent({
	        eventName: 'favoritesBuildingCardButtonsClick',
	        eventLabel: 'udalit_iz_izbrannogo',
	        eventContent: title
	      });
	
	      _this.props.handleDeleteClick(data);
	    }, _this.handleGoToBuilding = function () {
	      var _this$props = _this.props,
	          location = _this$props.location,
	          id = _this$props.id,
	          title = _this$props.title;
	
	      var objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
	      var mode = location.search.includes('view=map') ? 'karta' : 'spisok';
	
	      _this.handleTrackEvent({
	        eventName: 'buildingCardClick',
	        eventLabel: 'obyekt',
	        eventContext: mode,
	        productType: objectType,
	        productName: title,
	        productID: id
	      });
	    }, _this.handleTrackEvent = function (_ref2) {
	      var eventName = _ref2.eventName,
	          eventLabel = _ref2.eventLabel,
	          eventContent = _ref2.eventContent,
	          eventContext = _ref2.eventContext,
	          productType = _ref2.productType,
	          productName = _ref2.productName,
	          productID = _ref2.productID;
	      var _this$props2 = _this.props,
	          profile = _this$props2.profile,
	          location = _this$props2.location;
	
	      var screenName = location.pathname === '/' ? '/' : location.pathname + '/';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        screenName: screenName,
	        eventLabel: eventLabel,
	        eventContent: eventContent,
	        eventContext: eventContext,
	        productType: productType,
	        productName: productName,
	        productID: productID,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BuildingCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          location = _props.location,
	          id = _props.id,
	          title = _props.title,
	          year_built = _props.year_built,
	          construction_ending = _props.construction_ending,
	          construction_finished = _props.construction_finished,
	          status = _props.status;
	
	      var objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
	      var mode = location.search.includes('view=map') ? 'karta' : 'spisok';
	      var labels = [];
	
	      if (status === 3) {
	        labels.push('chastichno_sdan');
	      } else if (construction_finished) {
	        labels.push('sdan');
	      } else if (construction_ending) {
	        labels.push(construction_ending + '/' + year_built);
	      }
	
	      var eventContent = labels.sort().join(' | ');
	
	      this.handleTrackEvent({
	        eventName: 'buildingCardShow',
	        eventContent: eventContent,
	        eventContext: mode,
	        productType: objectType,
	        productName: title,
	        productID: id
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var t = this.props.t;
	      var _props2 = this.props,
	          target = _props2.target,
	          _props2$url = _props2.url,
	          url = _props2$url === undefined ? '/building/' : _props2$url,
	          className = _props2.className,
	          handleDeleteClick = _props2.handleDeleteClick,
	          _props2$deleteText = _props2.deleteText,
	          deleteText = _props2$deleteText === undefined ? t('components.buildingCard.delete') : _props2$deleteText,
	          withClient = _props2.withClient,
	          id = _props2.id,
	          title = _props2.title,
	          image = _props2.image,
	          address = _props2.address,
	          microregion = _props2.microregion,
	          year_built = _props2.year_built,
	          construction_ending = _props2.construction_ending,
	          checkout = _props2.checkout,
	          checkout2 = _props2.checkout2,
	          military_ipoteka = _props2.military_ipoteka,
	          mat_capital = _props2.mat_capital,
	          ipoteka = _props2.ipoteka,
	          installments = _props2.installments,
	          costMin = _props2.cost_min,
	          minAreaCost = _props2.min_area_cost,
	          isFinished = _props2.construction_finished,
	          flatsCount = _props2.count_flats,
	          collection = _props2.collection,
	          status = _props2.status,
	          withDetails = _props2.withDetails,
	          client = _props2.client,
	          type_id = _props2.type_id,
	          _props2$showStatus = _props2.showStatus,
	          showStatus = _props2$showStatus === undefined ? true : _props2$showStatus,
	          profileCurrency = _props2.profileCurrency,
	          buildingCurrency = _props2.buildingCurrency;
	
	
	      var currency = client ? buildingCurrency : profileCurrency;
	
	      return collection ? _react2.default.createElement(
	        _reactRouterDom.Link,
	        _extends({
	          to: '' + url + id }, target && { target: target }, {
	          className: (0, _classnames2.default)(_BuildingCard2.default.ObjectCard, _BuildingCard2.default.ObjectCardCollection, _defineProperty({}, _BuildingCard2.default.WithDetails, withDetails), className)
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _BuildingCard2.default.ObjectCardImage },
	          !client && _react2.default.createElement(_FilterLabel2.default, { isBlackList: this.props.black_list, isNew: this.props.new, isNedvex: this.props.nedvex }),
	          image ? _react2.default.createElement('img', {
	            src: _Config.ROOT_URL + '/image?id=' + image.id + '&size=medium', alt: '',
	            style: { objectFit: 'cover', width: '100%', height: '100%' }
	          }) : _react2.default.createElement('img', { className: _BuildingCard2.default.noFloor, src: client ? _noFloor2.default : _no_photo_favourite2.default, alt: '' }),
	          showStatus && (status == 3 ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.AlmostFinished) },
	            t('components.buildingCard.almostFinished')
	          ) : isFinished ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.Finished) },
	            t('components.buildingCard.finished')
	          ) : _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.InProcess) },
	            construction_ending + ' / ' + (year_built || '')
	          ))
	        ),
	        _react2.default.createElement('div', { className: _BuildingCard2.default.Gradient }),
	        withDetails ? _react2.default.createElement(
	          'div',
	          { className: _BuildingCard2.default.ObjectCardDescrip },
	          flatsCount ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _defineProperty({}, _BuildingCard2.default.Stopped, status === 2)) },
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.FlatsCount },
	              flatsCount + ' ' + (0, _utils.pluralize)(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3'))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.ObjectTitle },
	              title || t('components.buildingCard.lot', { id: id })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: _BuildingCard2.default.ObjectAddress
	              },
	              microregion,
	              !withClient && address ? ', ' + address : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.FlatsPriceAll },
	              status === 2 ? t('common.stopped') : t('components.buildingCard.fromFull', {
	                costMin: (0, _utils.formatNumber)(costMin),
	                minAreaCost: (0, _utils.formatNumber)(minAreaCost),
	                currency: currency
	              })
	            )
	          ) : _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _BuildingCard2.default.Stopped) },
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.ObjectTitle },
	              title || t('components.buildingCard.lot', { id: id })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: _BuildingCard2.default.ObjectAddress
	              },
	              microregion,
	              !withClient && address ? ', ' + address : ''
	            ),
	            _react2.default.createElement(
	              'strong',
	              null,
	              status === 2 ? t('common.stopped') : type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats')
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: _BuildingCard2.default.ObjectCardDescrip },
	          flatsCount ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _defineProperty({}, _BuildingCard2.default.Stopped, status === 2)) },
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.FlatsCount },
	              flatsCount + ' ' + (0, _utils.pluralize)(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3'))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.FlatsPrice },
	              status === 2 ? t('common.stopped') : t('components.buildingCard.costMin', { costMin: (0, _utils.formatNumber)(costMin), currency: currency })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.FlatsPriceMeter },
	              t('components.buildingCard.minAreaCost', { minAreaCost: (0, _utils.formatNumber)(minAreaCost), currency: currency })
	            )
	          ) : _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _BuildingCard2.default.Stopped) },
	            _react2.default.createElement(
	              'strong',
	              null,
	              status === 2 ? t('common.stopped') : type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats')
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_BuildingCard2.default.ObjectCard, className) },
	        _react2.default.createElement(
	          'div',
	          { className: _BuildingCard2.default.ObjectCardImage },
	          _react2.default.createElement(_FilterLabel2.default, { isBlackList: this.props.black_list, isNew: this.props.new, isNedvex: this.props.nedvex }),
	          image ? _react2.default.createElement('img', { src: _Config.ROOT_URL + '/image?id=' + image.id + '&size=medium', style: { width: '100%' }, alt: '' }) : _react2.default.createElement('img', { className: _BuildingCard2.default.noMainImage, src: _no_photo_favourite2.default }),
	          status == 3 ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.AlmostFinished) },
	            t('components.buildingCard.almostFinished')
	          ) : isFinished ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.Finished) },
	            t('components.buildingCard.finished')
	          ) : _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Status, _BuildingCard2.default.InProcess) },
	            construction_ending + ' / ' + (year_built || '')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingCard2.default.Hover },
	            handleDeleteClick && _react2.default.createElement(
	              'span',
	              {
	                className: (0, _classnames2.default)(_BuildingCard2.default.HoverIcon, _BuildingCard2.default.HoverIconDelete),
	                onClick: this.handleDeleteClick.bind(this, this.props)
	              },
	              _react2.default.createElement('img', { src: _iconDelete2.default, alt: '' }),
	              _react2.default.createElement(
	                'span',
	                { className: _BuildingCard2.default.Tooltip },
	                deleteText
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              _extends({
	                onClick: function onClick() {
	                  _tracker2.default.sendEvent('Web_Favorites_Go_Object', { id: id, name: title });
	
	                  _this2.handleTrackEvent({
	                    eventName: 'favoritesBuildingCardButtonsClick',
	                    eventLabel: 'pereiti_k_zhk',
	                    eventContent: title
	                  });
	
	                  _this2.handleGoToBuilding();
	                },
	                to: '' + url + id
	              }, target && { target: target }),
	              t('components.buildingCard.goToObject')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BuildingCard2.default.ObjectCardDescrip },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              { className: _BuildingCard2.default.Name },
	              title || t('components.buildingCard.lot', { id: id })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _BuildingCard2.default.Location },
	              microregion,
	              !withClient && address ? ', ' + address : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingCard2.default.ObjectCardFeatures },
	              checkout ? _react2.default.createElement(
	                'span',
	                { className: _BuildingCard2.default.BlockItem },
	                checkout
	              ) : null,
	              checkout2 ? _react2.default.createElement(
	                'span',
	                { className: _BuildingCard2.default.BlockItem },
	                checkout2
	              ) : null
	            )
	          ),
	          flatsCount ? _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _defineProperty({}, _BuildingCard2.default.Stopped, status === 2)) },
	            _react2.default.createElement(
	              'strong',
	              null,
	              status === 2 ? t('common.stopped') : t('components.buildingCard.costMin', { costMin: (0, _utils.formatNumber)(costMin), currency: currency })
	            ),
	            status !== 2 ? flatsCount + ' ' + (0, _utils.pluralize)(flatsCount, t('components.buildingCard.flat1'), t('components.buildingCard.flat2'), t('components.buildingCard.flat3')) + ', ' + t('components.buildingCard.minAreaCost', { minAreaCost: (0, _utils.formatNumber)(minAreaCost), currency: currency }) : null
	          ) : _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)(_BuildingCard2.default.Prices, _BuildingCard2.default.Stopped) },
	            _react2.default.createElement(
	              'strong',
	              null,
	              status === 2 ? t('common.stopped') : type_id == 2 ? t('components.buildingCard.soldHouses') : t('components.buildingCard.soldFlats')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BuildingCard;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    privacy: state.privacy,
	    profileCurrency: state.profile && state.profile.user_region ? state.profile.user_region.country_currency_symbol : ''
	
	  };
	})((0, _reactLazyload.lazyload)({
	  once: true,
	  height: 383,
	  offset: 600
	  // overflow: true,
	})(BuildingCard)));

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _List = __webpack_require__(965);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _NoBuildings = __webpack_require__(473);
	
	var _NoBuildings2 = _interopRequireDefault(_NoBuildings);
	
	var _News = __webpack_require__(967);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _Dropdown = __webpack_require__(216);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Menu = __webpack_require__(217);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _iconSearchMap = __webpack_require__(548);
	
	var _iconSearchMap2 = _interopRequireDefault(_iconSearchMap);
	
	var _list = __webpack_require__(1559);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _close = __webpack_require__(542);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Buildings = __webpack_require__(1370);
	
	var _Buildings2 = _interopRequireDefault(_Buildings);
	
	var _utils = __webpack_require__(12);
	
	var _Filters = __webpack_require__(478);
	
	var _search = __webpack_require__(68);
	
	var _TypeFilters = __webpack_require__(1098);
	
	var _TypeFilters2 = _interopRequireDefault(_TypeFilters);
	
	var _objects = __webpack_require__(99);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	var _withObservePayments = __webpack_require__(221);
	
	var _withObservePayments2 = _interopRequireDefault(_withObservePayments);
	
	var _YMap = __webpack_require__(312);
	
	var _YMap2 = _interopRequireDefault(_YMap);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _WarningRow = __webpack_require__(1100);
	
	var _WarningRow2 = _interopRequireDefault(_WarningRow);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sorts = {
	  'date_update DESC': {
	    text: _i18n2.default.t('components.buildings.buildings.sorts.date_updateDESC'),
	    orderField: 'date_update',
	    orderDirection: 'DESC',
	    key: 'dateDesc',
	    event: 'Web_Sort_Date',
	    gaEvent: 'po_date'
	  },
	  'cost_min ASC': {
	    text: _i18n2.default.t('components.buildings.buildings.sorts.cost_minASC'),
	    orderField: 'cost_min',
	    orderDirection: 'ASC',
	    key: 'costAsc',
	    event: 'Web_Sort_Price_Cheaper',
	    gaEvent: 'po_uvelicheniyu_ceny'
	  },
	  'cost_min DESC': {
	    text: _i18n2.default.t('components.buildings.buildings.sorts.cost_minDESC'),
	    orderField: 'cost_min',
	    orderDirection: 'DESC',
	    key: 'costDesc',
	    event: 'Web_Sort_Price_Expensive',
	    gaEvent: 'po_umensheniyu_ceny'
	  }
	};
	
	var getSort = function getSort(query) {
	  var view = query.view;
	
	  if (!view || view === 'map') {
	    return {};
	  }
	
	  var sortKey = Object.keys(sorts).find(function (key) {
	    return sorts[key].key === view;
	  });
	  if (!sortKey) {
	    return {};
	  }
	
	  var sort = sorts[sortKey];
	  var orderField = sort.orderField,
	      orderDirection = sort.orderDirection;
	
	  return { orderField: orderField, orderDirection: orderDirection };
	};
	
	var sortKeys = Object.keys(sorts);
	
	var typeFilters = ['nedvex', 'new', 'viewAction', 'orderField', 'blackList'];
	var newOrderFields = ['visit_day', 'visit_week', 'visit_month'];
	var typeFiltersInfo = [{
	  key: 'nedvex',
	  text: _i18n2.default.t('components.buildings.buildings.typeFiltersInfo.nedvex')
	}, {
	  key: 'new',
	  text: _i18n2.default.t('components.buildings.buildings.typeFiltersInfo.nedvex')
	}, {
	  key: 'viewAction',
	  text: _i18n2.default.t('components.buildings.buildings.typeFiltersInfo.promo')
	}, {
	  key: 'orderField',
	  text: _i18n2.default.t('components.buildings.buildings.typeFiltersInfo.orderField')
	}];
	
	var getFilterTypeByRequest = function getFilterTypeByRequest(request) {
	  var filter = Object.keys(request).filter(function (k) {
	    if (request[k]) {
	      if (typeFilters.includes(k)) {
	        if (k === 'orderField') {
	          if (newOrderFields.includes(request[k])) return true;
	          return false;
	        }
	        return true;
	      }
	    }
	  })[0];
	  return typeFiltersInfo.find(function (info) {
	    return info.key === filter;
	  });
	};
	
	var Buildings = (_dec = (0, _withValidTrafic2.default)(), (0, _withObservePayments2.default)(_class = _dec(_class = function (_Component) {
	  _inherits(Buildings, _Component);
	
	  function Buildings(props) {
	    _classCallCheck(this, Buildings);
	
	    var _this = _possibleConstructorReturn(this, (Buildings.__proto__ || Object.getPrototypeOf(Buildings)).call(this, props));
	
	    _this.getStateFromSearch = function () {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          initialRequest = _this$props.request,
	          location = _this$props.location,
	          changeFilters = _this$props.changeFilters;
	
	      var query = (0, _utils.parseQuery)(location.search);
	      var isPopularFilter = query.orderField ? newOrderFields.includes(query.orderField) : false;
	
	      if (isPopularFilter) {
	        var request = _extends({}, initialRequest, (0, _Filters.getRequest)(query), { orderDirection: 'DESC' });
	        changeFilters(request);
	      } else {
	        var _request = _extends({}, initialRequest, (0, _Filters.getRequest)(query), getSort(query));
	        changeFilters(_request);
	      }
	    };
	
	    _this.handleBackButton = function () {
	      _this.getStateFromSearch();
	    };
	
	    _this.renderControls = function (isList, hasFilters, total, sortKey) {
	      var isCottegesPage = _this.state.isCottegesPage;
	      var _this$props2 = _this.props,
	          t = _this$props2.t,
	          profile = _this$props2.profile;
	      var user_region = profile.user_region;
	      var country_name = user_region.country_name,
	          city = user_region.city;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Buildings2.default.Controls, _defineProperty({}, _Buildings2.default.OverMap, !isList)), key: 'controls' },
	        isList && _react2.default.createElement(
	          'div',
	          { className: _Buildings2.default.SearchTitle },
	          _react2.default.createElement(
	            'p',
	            null,
	            hasFilters ? t('components.buildings.buildings.searchResults') : isCottegesPage ? t('components.buildings.buildings.cottegesPage', {
	              conjunction: 'в',
	              city: country_name + ', ' + city
	            }) : t('components.buildings.buildings.new', {
	              conjunction: 'в',
	              city: country_name + ', ' + city
	            }),
	            hasFilters ? _react2.default.createElement(
	              'button',
	              { className: _Buildings2.default.ResetAllFilters, onClick: _this.handleResetFiltersClick },
	              _react2.default.createElement('img', { src: _close2.default }),
	              ' ',
	              t('components.buildings.buildings.clear'),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: _Buildings2.default.Hide1080 },
	                t('components.buildings.buildings.filters')
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            (0, _utils.pluralize)(total, t('components.buildings.buildings.search1'), t('components.buildings.buildings.search2'), t('components.buildings.buildings.search3')) + ' ' + (total || '0') + '\n              ' + (!isCottegesPage ? (0, _utils.pluralize)(total, t('components.buildings.buildings.new1'), t('components.buildings.buildings.new2'), t('components.buildings.buildings.new3')) : (0, _utils.pluralize)(total, t('components.buildings.buildings.object1'), t('components.buildings.buildings.object2'), t('components.buildings.buildings.object3')))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Buildings2.default.Order },
	          _react2.default.createElement(
	            'p',
	            { className: _Buildings2.default.PreOrderText },
	            t('components.buildings.buildings.by')
	          ),
	          _react2.default.createElement(
	            _Dropdown2.default,
	            {
	              className: (0, _classnames2.default)(_Buildings2.default.Dropdown),
	              buttonStyle: _Buildings2.default.DropdownButton,
	              textStyle: _Buildings2.default.DropdownText,
	              iconStyle: _Buildings2.default.DropdownIcon,
	              text: sorts[sortKey].text,
	              'data-tip': t('components.buildings.buildings.sortList'),
	              'data-for': 'tooltip',
	              topShift: true
	            },
	            _react2.default.createElement(
	              _Menu2.default,
	              { rightArrow: true, pure: true },
	              _react2.default.createElement(
	                'div',
	                { className: _Buildings2.default.OrderMenu },
	                sortKeys.map(function (key) {
	                  var sort = sorts[key];
	                  var orderField = sort.orderField,
	                      orderDirection = sort.orderDirection;
	
	                  return _react2.default.createElement(
	                    'div',
	                    {
	                      key: key,
	                      className: (0, _classnames2.default)(_Buildings2.default.OrderMenuItem, _defineProperty({}, _Buildings2.default.OrderMenuActive, key === sortKey)),
	                      onClick: _this.handleSortClick.bind(undefined, orderField, orderDirection)
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      sort.text
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Buildings2.default.SwitcherWrapper },
	            _react2.default.createElement(
	              'button',
	              { className: _Buildings2.default.OpenMapBtn, onClick: _this.handleListToggleClick },
	              isList ? _react2.default.createElement('img', { src: _iconSearchMap2.default, alt: '' }) : _react2.default.createElement('img', { src: _list2.default, alt: '' }),
	              isList ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: _Buildings2.default.Hide1024 },
	                  t('components.buildings.buildings.searchOnMap')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Buildings2.default.Show1024 },
	                  t('components.buildings.buildings.onMap')
	                )
	              ) : t('components.buildings.buildings.searchOnList')
	            )
	          )
	        )
	      );
	    };
	
	    _this.getFilters = function (filters, request) {
	      var _this$props3 = _this.props,
	          location = _this$props3.location,
	          history = _this$props3.history,
	          changeFilters = _this$props3.changeFilters;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var query = (0, _utils.compileQuery)(filters, search);
	      var newSearch = query ? '?' + query : '';
	      var path = '' + pathname + newSearch;
	      history.push(path);
	      changeFilters(request);
	    };
	
	    _this.renderTypeFiltersControls = function (_ref) {
	      var isList = _ref.isList,
	          request = _ref.request,
	          total = _ref.total,
	          sortKey = _ref.sortKey;
	      var t = _this.props.t;
	      var isCottegesPage = _this.state.isCottegesPage;
	
	      var filter = getFilterTypeByRequest(request);
	      var key = filter.key,
	          text = filter.text;
	
	      var isOrderField = key === 'orderField';
	      var orderField = request.orderField;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Buildings2.default.Controls, _defineProperty({}, _Buildings2.default.OverMap, !isList)), key: 'controls' },
	        isList && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Buildings2.default.SearchTitle, isOrderField && _Buildings2.default.IsOrderField) },
	          _react2.default.createElement(
	            'p',
	            null,
	            text
	          ),
	          !isOrderField ? _react2.default.createElement(
	            'small',
	            null,
	            (!isOrderField ? '' + (0, _utils.pluralize)(total, t('components.buildings.buildings.search1'), t('components.buildings.buildings.search2'), t('components.buildings.buildings.search3')) : '') + ' ' + (total || '0') + ' ' + (!isCottegesPage ? (0, _utils.pluralize)(total, t('components.buildings.buildings.new1'), t('components.buildings.buildings.new2'), t('components.buildings.buildings.new3')) : (0, _utils.pluralize)(total, t('components.buildings.buildings.object1'), t('components.buildings.buildings.object2'), t('components.buildings.buildings.object3')))
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Buildings2.default.Order },
	          isOrderField && _react2.default.createElement(
	            'div',
	            { className: _Buildings2.default.OrderButtons },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_Buildings2.default.OrderBtn, orderField === 'visit_day' && _Buildings2.default.Active),
	                onClick: function onClick() {
	                  return _this.getFilters({ orderField: 'visit_day' }, { orderField: 'visit_day' });
	                }
	              },
	              t('components.buildings.buildings.day')
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_Buildings2.default.OrderBtn, orderField === 'visit_week' && _Buildings2.default.Active),
	                onClick: function onClick() {
	                  return _this.getFilters({ orderField: 'visit_week' }, { orderField: 'visit_week' });
	                }
	              },
	              t('components.buildings.buildings.week')
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_Buildings2.default.OrderBtn, orderField === 'visit_month' && _Buildings2.default.Active),
	                onClick: function onClick() {
	                  return _this.getFilters({ orderField: 'visit_month' }, { orderField: 'visit_month' });
	                }
	              },
	              t('components.buildings.buildings.month')
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleResize = function () {
	      if (_this.scrollContainer) {
	        _this.setState({
	          containerHeight: _this.scrollContainer.clientHeight
	        });
	      }
	    };
	
	    _this.getScrollContainer = function (ref) {
	      _this.scrollContainer = ref;
	      _this.handleResize();
	    };
	
	    _this.handleListToggleClick = _this.handleListToggleClick.bind(_this);
	    _this.handleSortClick = _this.handleSortClick.bind(_this);
	    _this.handleResetFiltersClick = _this.handleResetFiltersClick.bind(_this);
	    _this.state = {
	      containerHeight: 1000
	    };
	    return _this;
	  }
	
	  _createClass(Buildings, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      document.body.classList.toggle('index', true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          ui = _props.objects.ui,
	          dispatch = _props.dispatch,
	          pathname = _props.location.pathname;
	      // if (!ui.scrollTop) {
	
	      this.getStateFromSearch();
	      // }
	
	      _tracker2.default.sendEventOnce('Web_Launch_First_Time');
	
	      window.onpopstate = this.handleBackButton;
	      window.addEventListener('resize', this.handleResize);
	      document.getElementsByTagName('html')[0].classList.toggle('objectsListPage', true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.getElementsByTagName('html')[0].classList.remove('objectsListPage');
	      window.removeEventListener('resize', this.handleResize);
	      document.body.classList.toggle('index', false);
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var search = nextProps.location.search,
	          request = nextProps.request,
	          isCottegesPage = nextProps.isCottegesPage;
	      var _props2 = this.props,
	          prevSearch = _props2.location.search,
	          prevRequest = _props2.request,
	          location = _props2.location,
	          dispatch = _props2.dispatch;
	
	      var v1 = (0, _utils.parseQuery)(search).view;
	      var v2 = (0, _utils.parseQuery)(prevSearch).view;
	      this.setState({ isCottegesPage: !!isCottegesPage });
	
	      if (request !== prevRequest || v1 !== v2 || isCottegesPage !== this.props.isCottegesPage) {
	        try {
	          var city = this.props.cities.find(function (cities) {
	            return String(cities.id) === String(nextProps.cityId);
	          });
	          var region = city ? city.areas.map(function (_ref2) {
	            var id = _ref2.id;
	            return id;
	          }) : null;
	          dispatch((0, _objects.loadData)(this.isList(search), _extends({}, request, {
	            limit: request.limit || 10,
	            typeId: location.pathname.includes('cottages') ? 2 : 1,
	            region: request.region || region
	          }), true));
	          document.body.scrollTop = 0;
	        } catch (e) {
	          console.log(e);
	        }
	      }
	    }
	  }, {
	    key: 'isList',
	    value: function isList(search) {
	      var location = this.props.location;
	
	      var query = (0, _utils.parseQuery)(search || location.search);
	      return !query.view || query.view !== 'map';
	    }
	  }, {
	    key: 'handleListToggleClick',
	    value: function handleListToggleClick() {
	      var _props3 = this.props,
	          location = _props3.location,
	          history = _props3.history,
	          profile = _props3.profile,
	          objectType = _props3.objectType,
	          mode = _props3.mode;
	      var search = location.search;
	
	      var view = void 0;
	      if (this.isList()) {
	        _tracker2.default.sendEvent('Web_Map');
	        view = 'map';
	      } else {
	        var _props$request = this.props.request,
	            orderField = _props$request.orderField,
	            orderDirection = _props$request.orderDirection;
	
	        _tracker2.default.sendEvent('Web_Map_Object_List');
	        view = sorts[orderField + ' ' + orderDirection].key;
	      }
	      var eventLabel = location.search.includes('view=map') ? 'spisok' : 'karta';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterListModeSwitchClick({
	        eventLabel: eventLabel,
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      var query = (0, _utils.compileQuery)({ view: view }, search);
	      history.push('/' + (location.pathname.includes('cottages') ? 'cottages' : '') + '?' + query);
	    }
	  }, {
	    key: 'handleSortClick',
	    value: function handleSortClick(orderField, orderDirection) {
	      var _props4 = this.props,
	          profile = _props4.profile,
	          objectType = _props4.objectType,
	          mode = _props4.mode;
	
	      var sort = sorts[orderField + ' ' + orderDirection];
	      var _props5 = this.props,
	          location = _props5.location,
	          history = _props5.history;
	      var search = location.search;
	
	      var query = (0, _utils.compileQuery)({ view: sort.key }, search);
	
	      if (sort.event) {
	        _tracker2.default.sendEvent(sort.event);
	      }
	
	      if (sort.gaEvent) {
	        (0, _ga.trackGA)(_ga.gaEvent.filterSortByButtonsClick({
	          eventContent: sort.gaEvent,
	          eventContext: mode,
	          productType: objectType,
	          user_id: profile.id
	        }));
	      }
	
	      history.push('/' + (location.pathname.includes('cottages') ? 'cottages' : '') + '?' + query);
	
	      var changeFilters = this.props.changeFilters;
	
	      changeFilters({ orderField: orderField, orderDirection: orderDirection });
	    }
	  }, {
	    key: 'handleResetFiltersClick',
	    value: function handleResetFiltersClick() {
	      var _props6 = this.props,
	          location = _props6.location,
	          history = _props6.history,
	          resetFilters = _props6.resetFilters;
	      var pathname = location.pathname;
	
	      var path = '' + pathname;
	      history.push(path);
	      resetFilters();
	    }
	  }, {
	    key: 'renderData',
	    value: function renderData(objects, request, hasFilters, dispatch, pathname) {
	      var _props7 = this.props,
	          isTypeFilters = _props7.isTypeFilters,
	          isOrderFieldTypeFilter = _props7.isOrderFieldTypeFilter,
	          profile = _props7.profile,
	          objectType = _props7.objectType,
	          mode = _props7.mode,
	          banner = _props7.banner;
	      var ui = objects.ui,
	          points = objects.points;
	
	      var isList = this.isList();
	
	      var _ref3 = isList ? objects.objects : objects.pins,
	          data = _ref3.data,
	          total = _ref3.total;
	
	      var orderField = request.orderField,
	          orderDirection = request.orderDirection;
	
	      var sortKey = orderField + ' ' + orderDirection;
	      var isAction = request.viewAction === 'true';
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Buildings2.default.ObjectsInner, ref: this.getScrollContainer },
	        Boolean(banner.text) && _react2.default.createElement(
	          _WarningRow2.default,
	          { color: banner.color_banner, backgroundColor: banner.color_topic },
	          banner.text
	        ),
	        !isList ? isTypeFilters ? this.renderTypeFiltersControls({ isList: isList, total: total, request: request, sortKey: sortKey }) : this.renderControls(isList, hasFilters, total, sortKey) : null,
	        isList ? _react2.default.createElement(
	          _List2.default,
	          {
	            dispatch: dispatch,
	            scrollTop: ui.scrollTop,
	            isFinished: ui.isFinished || isOrderFieldTypeFilter,
	            isInfiniteLoading: ui.isInfiniteLoading,
	            isTypeFilterAction: isAction,
	            request: request,
	            data: data,
	            containerHeight: this.state.containerHeight,
	            scrollContainer: this.scrollContainer,
	            isCottegesPage: this.state.isCottegesPage
	          },
	          _react2.default.createElement(_TypeFilters2.default, {
	            isCottegesPage: this.state.isCottegesPage,
	            profile: profile,
	            objectType: objectType,
	            mode: mode
	          }),
	          isTypeFilters ? this.renderTypeFiltersControls({ isList: isList, total: total, request: request, sortKey: sortKey }) : this.renderControls(isList, hasFilters, total, sortKey)
	        ) : data && _react2.default.createElement(_YMap2.default, { dispatch: dispatch, data: data, points: points })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          className = _props8.className,
	          dispatch = _props8.dispatch,
	          pathname = _props8.pathname,
	          request = _props8.request,
	          objects = _props8.objects,
	          hasFilters = _props8.hasFilters,
	          withClient = _props8.withClient,
	          t = _props8.t,
	          objectType = _props8.objectType,
	          mode = _props8.mode;
	
	      var isList = this.isList();
	
	      var _ref4 = isList ? objects.objects : objects.pins,
	          data = _ref4.data;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            '' + (hasFilters ? t('components.buildings.buildings.searchResults') : t('components.buildings.buildings.newShort')) + (isList ? '' : ' - ' + t('components.buildings.buildings.map')) + ' - Nedvex'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Buildings2.default.Wrapper, withClient && _Buildings2.default.withClient) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Buildings2.default.Objects, className) },
	            data && data.length === 0 ? _react2.default.createElement(_NoBuildings2.default, { dispatch: dispatch }) : this.renderData(objects, request, hasFilters, dispatch, pathname)
	          ),
	          !withClient && _react2.default.createElement(_News2.default, { objectType: objectType, mode: mode })
	        )
	      );
	    }
	  }]);
	
	  return Buildings;
	}(_react.Component)) || _class) || _class);
	
	
	var getBuildings = (0, _reselect.createSelector)(function (state) {
	  return state.objects;
	}, function (state) {
	  return state.search.request;
	}, function (state) {
	  return state.search.hasFilters;
	}, function (state) {
	  return state.privacy.withClient;
	}, function (state) {
	  return state.search.isTypeFilters;
	}, function (state) {
	  return state.search.isOrderFieldTypeFilter;
	}, function (state) {
	  return state.profile.cityId;
	}, function (state) {
	  return state.building.cities;
	}, function (state) {
	  return state.banner;
	}, function (_, ownProps) {
	  return ownProps.location.pathname;
	}, function (_, ownProps) {
	  return ownProps.location.search;
	}, function (objects, request, hasFilters, withClient, isTypeFilters, isOrderFieldTypeFilter, cityId, cities, banner, pathname, search) {
	  var objectType = pathname === '/' ? 'zhk' : 'kp_i_th';
	  var mode = search.includes('view=map') ? 'karta' : 'spisok';
	
	  return {
	    objects: objects,
	    request: request,
	    hasFilters: hasFilters,
	    withClient: withClient,
	    isTypeFilters: isTypeFilters,
	    isOrderFieldTypeFilter: isOrderFieldTypeFilter,
	    cityId: cityId,
	    cities: cities,
	    objectType: objectType,
	    mode: mode,
	    banner: banner
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    changeFilters: function changeFilters(filters) {
	      return dispatch((0, _search.changeFilters)(filters));
	    },
	    resetFilters: function resetFilters() {
	      return dispatch((0, _search.changeFilters)(null, { reset: true }));
	    },
	    dispatch: dispatch
	  };
	};
	
	var mergeProps = function mergeProps(stateProps, dispatchProps, otherProps) {
	  var changeFilters = function changeFilters(filters) {
	    if (otherProps.isCottegesPage) {
	      dispatchProps.changeFilters(_extends({}, filters, { typeId: 2 }));
	    } else {
	      dispatchProps.changeFilters(_extends({}, filters, { typeId: 1 }));
	    }
	  };
	
	  return _extends({}, stateProps, dispatchProps, otherProps, {
	    changeFilters: changeFilters
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(getBuildings, mapDispatchToProps, mergeProps)((0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()(Buildings)));

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1371);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _iconNedvex = __webpack_require__(553);
	
	var _iconNedvex2 = _interopRequireDefault(_iconNedvex);
	
	var _iconNew = __webpack_require__(554);
	
	var _iconNew2 = _interopRequireDefault(_iconNew);
	
	var _iconBlacklist = __webpack_require__(552);
	
	var _iconBlacklist2 = _interopRequireDefault(_iconBlacklist);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterLabel = function (_Component) {
	  _inherits(FilterLabel, _Component);
	
	  function FilterLabel() {
	    _classCallCheck(this, FilterLabel);
	
	    return _possibleConstructorReturn(this, (FilterLabel.__proto__ || Object.getPrototypeOf(FilterLabel)).apply(this, arguments));
	  }
	
	  _createClass(FilterLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isPopularList = _props.isPopularList,
	          index = _props.index,
	          isBlackList = _props.isBlackList,
	          isNew = _props.isNew,
	          isNedvex = _props.isNedvex,
	          t = _props.t;
	
	      if (isPopularList) {
	        return _react2.default.createElement(
	          'div',
	          { className: _style2.default.FilterLabel },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_style2.default.index, _style2.default['index' + index]) },
	            index
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _style2.default.FilterLabel },
	        !!isBlackList && _react2.default.createElement(
	          'div',
	          {
	            className: _style2.default.blackList,
	            'data-tip': t('components.buildings.filterLabel.blackList'),
	            'data-for': 'global'
	          },
	          _react2.default.createElement('img', { src: _iconBlacklist2.default, alt: '' })
	        ),
	        !!isNew && _react2.default.createElement(
	          'div',
	          { className: _style2.default.new, 'data-tip': t('components.buildings.filterLabel.new'), 'data-for': 'global' },
	          _react2.default.createElement('img', { src: _iconNew2.default, alt: '' })
	        ),
	        !!isNedvex && !isNew && _react2.default.createElement(
	          'div',
	          { className: _style2.default.nedvex, 'data-tip': t('components.buildings.filterLabel.nedvex'), 'data-for': 'global' },
	          _react2.default.createElement('img', { src: _iconNedvex2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return FilterLabel;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(FilterLabel);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Config = __webpack_require__(16);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _bannerPlaceholder = __webpack_require__(173);
	
	var _bannerPlaceholder2 = _interopRequireDefault(_bannerPlaceholder);
	
	var _iconHeartWhite = __webpack_require__(1543);
	
	var _iconHeartWhite2 = _interopRequireDefault(_iconHeartWhite);
	
	var _iconVerified = __webpack_require__(550);
	
	var _iconVerified2 = _interopRequireDefault(_iconVerified);
	
	var _iconHeartActive = __webpack_require__(544);
	
	var _iconHeartActive2 = _interopRequireDefault(_iconHeartActive);
	
	var _iconHeartActiveRed = __webpack_require__(1542);
	
	var _iconHeartActiveRed2 = _interopRequireDefault(_iconHeartActiveRed);
	
	var _eyeOutline = __webpack_require__(1531);
	
	var _eyeOutline2 = _interopRequireDefault(_eyeOutline);
	
	var _nonPhoto = __webpack_require__(350);
	
	var _nonPhoto2 = _interopRequireDefault(_nonPhoto);
	
	var _calendar = __webpack_require__(1525);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _Item = __webpack_require__(1372);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(12);
	
	var _favorites = __webpack_require__(160);
	
	var _environment = __webpack_require__(19);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _CollectionsDialog = __webpack_require__(162);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _FilterLabel = __webpack_require__(311);
	
	var _FilterLabel2 = _interopRequireDefault(_FilterLabel);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	var _news = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_PureComponent) {
	  _inherits(Item, _PureComponent);
	
	  function Item(props) {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));
	
	    _this.handleCardClick = function () {
	      _this.handleTrackEvent({
	        eventName: 'buildingCardClick',
	        eventLabel: 'obyekt'
	      });
	    };
	
	    _this.handleAddToCollectionClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      var _this$props = _this.props,
	          item = _this$props.item,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType;
	      var id = item.id,
	          name = item.title;
	
	
	      _tracker2.default.sendEvent('Web_Add_To_Collection', { id: id, name: name, mode: 'list' });
	
	      _this.handleTrackEvent({
	        eventName: 'buildingCardClick',
	        eventLabel: 'v_podborku'
	      });
	
	      _this.props.setPopUp(_react2.default.createElement(_CollectionsDialog2.default, {
	        building: { data: _this.props.item },
	        profile: profile,
	        objectType: objectType
	      }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    };
	
	    _this.handleAddToFavoritesClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      var _this$props2 = _this.props,
	          item = _this$props2.item,
	          profile = _this$props2.profile;
	      var buildingId = item.id,
	          buildingName = item.title,
	          favorite = item.favorite;
	
	      var userUid = localStorage.getItem('public');
	
	      _tracker2.default.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'list'
	      });
	
	      _this.handleTrackEvent({
	        eventName: 'buildingCardClick',
	        eventLabel: 'v_izbrannoe'
	      });
	
	      _this.props.favoritesNews({ limit: 20, offset: 0 });
	
	      _this.props[favorite ? 'removeFromFavorites' : 'addToFavorites']({ buildingId: buildingId, userUid: userUid }, { buildingName: buildingName, data: _this.props });
	    };
	
	    _this.handleGoToChess = function (e) {
	      e.stopPropagation();
	      _this.handleTrackEvent({
	        eventName: 'buildingCardClick',
	        eventLabel: 'shahmatka'
	      });
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel,
	          eventContent = _ref.eventContent;
	      var _this$props3 = _this.props,
	          item = _this$props3.item,
	          profile = _this$props3.profile;
	      var id = item.id,
	          title = item.title;
	
	      var objectType = location.pathname === '/' ? 'zhk' : 'kp_i_th';
	      var eventContext = location.search.includes('view=map') ? 'karta' : 'spisok';
	      var screenName = location.pathname === '/' ? '/' : location.pathname + '/';
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        screenName: screenName,
	        eventLabel: eventLabel,
	        eventContent: eventContent,
	        eventContext: eventContext,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      onSmallImageLoad: null,
	      onBigImageLoad: null,
	      smallImageLoaded: false,
	      bigImageLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.item.image) {
	        this.followSmallImage();
	      }
	      _reactTooltip2.default.rebuild();
	
	      var item = this.props.item;
	      var checkout = item.checkout,
	          military_ipoteka = item.military_ipoteka,
	          mat_capital = item.mat_capital,
	          ipoteka = item.ipoteka,
	          installments = item.installments,
	          status = item.status,
	          construction_finished = item.construction_finished,
	          construction_ending = item.construction_ending,
	          year_built = item.year_built,
	          view_action = item.view_action;
	
	
	      var labels = [];
	
	      if (view_action) {
	        labels.push('akciya');
	      }
	      if (status === 3) {
	        labels.push('chastichno_sdan');
	      } else if (construction_finished) {
	        labels.push('sdan');
	      } else if (construction_ending) {
	        labels.push(construction_ending + '/' + year_built);
	      }
	      if (checkout) {
	        labels.push('fz-214');
	      }
	      if (military_ipoteka) {
	        labels.push('voennaya_ipoteka');
	      }
	      if (mat_capital) {
	        labels.push('materinskii_kapital');
	      }
	      if (ipoteka) {
	        labels.push('ipoteka');
	      }
	      if (installments) {
	        labels.push('rassrochka');
	      }
	
	      var eventContent = labels.sort().join(' | ');
	
	      setTimeout(function () {
	        return _this2.handleTrackEvent({
	          eventName: 'buildingCardShow',
	          eventContent: eventContent
	        });
	      }, Math.floor(Math.random() * 5000));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _state = this.state,
	          smallImageLoaded = _state.smallImageLoaded,
	          bigImageLoaded = _state.bigImageLoaded,
	          onBigImageLoad = _state.onBigImageLoad;
	
	      if (smallImageLoaded && !bigImageLoaded && !onBigImageLoad) {
	        this.followBigImage();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state2 = this.state,
	          onSmallImageLoad = _state2.onSmallImageLoad,
	          onBigImageLoad = _state2.onBigImageLoad;
	
	      if (onSmallImageLoad) {
	        var smallImg = _reactDom2.default.findDOMNode(this.refs.smallImg);
	        smallImg.removeEventListener('load', onSmallImageLoad);
	      }
	      if (onBigImageLoad) {
	        var bigImg = _reactDom2.default.findDOMNode(this.refs.bigImg);
	        bigImg.removeEventListener('load', onBigImageLoad);
	      }
	    }
	  }, {
	    key: 'followSmallImage',
	    value: function followSmallImage() {
	      var _this3 = this;
	
	      var image = _reactDom2.default.findDOMNode(this.refs.smallImg);
	      if (image.complete) {
	        this.setState({ smallImageLoaded: true });
	        return;
	      }
	
	      var onSmallImageLoad = function onSmallImageLoad() {
	        _this3.setState({ onSmallImageLoad: null, smallImageLoaded: true }, function () {
	          image.removeEventListener('load', onSmallImageLoad);
	        });
	      };
	      this.setState({ onSmallImageLoad: onSmallImageLoad }, function () {
	        image.addEventListener('load', onSmallImageLoad);
	      });
	    }
	  }, {
	    key: 'followBigImage',
	    value: function followBigImage() {
	      var _this4 = this;
	
	      var image = _reactDom2.default.findDOMNode(this.refs.bigImg);
	      if (image.complete) {
	        this.setState({ bigImageLoaded: true });
	        return;
	      }
	
	      var onBigImageLoad = function onBigImageLoad() {
	        _this4.setState({ onBigImageLoad: null, bigImageLoaded: true }, function () {
	          image.removeEventListener('load', onBigImageLoad);
	        });
	      };
	      this.setState({ onBigImageLoad: onBigImageLoad }, function () {
	        image.addEventListener('load', onBigImageLoad);
	      });
	    }
	  }, {
	    key: 'addDefaultSrc',
	    value: function addDefaultSrc(placeholder, event) {
	      event.target.src = placeholder;
	    }
	  }, {
	    key: 'renderFlatsCount',
	    value: function renderFlatsCount() {
	      var searchFlats = !!this.props.item.flats_by_search;
	      var t = this.props.t;
	      var _props$item = this.props.item,
	          status = _props$item.status,
	          flatsCount = _props$item.count_flats,
	          flatsBySearch = _props$item.flats_by_search,
	          type_id = _props$item.type_id;
	      var isTypeFilterAction = this.props.isTypeFilterAction;
	
	      var count = searchFlats && flatsBySearch ? flatsBySearch.total : flatsCount;
	      var countText = type_id == 2 ? (0, _utils.formatNumber)(count) + ' ' + (0, _utils.pluralize)(count, t('components.buildings.list.house1'), t('components.buildings.list.house2'), t('components.buildings.list.house3')) : (0, _utils.formatNumber)(count) + ' ' + (0, _utils.pluralize)(count, t('components.buildings.list.flat1'), t('components.buildings.list.flat2'), t('components.buildings.list.flat3'));
	
	      return status === 2 ? _react2.default.createElement(
	        'p',
	        { className: _Item2.default.Appartments },
	        t('components.buildings.list.stopped')
	      ) : _react2.default.createElement(
	        'p',
	        { className: (0, _classnames2.default)(_Item2.default.Appartments, _defineProperty({}, _Item2.default.ForYouRequest, searchFlats)) },
	        searchFlats ? isTypeFilterAction ? t('components.buildings.list.byPromo') : t('components.buildings.list.byQuery') : '',
	        _react2.default.createElement(
	          'b',
	          null,
	          countText
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this,
	          _cn3;
	
	      var _state3 = this.state,
	          smallImageLoaded = _state3.smallImageLoaded,
	          bigImageLoaded = _state3.bigImageLoaded;
	      var _props = this.props,
	          className = _props.className,
	          url = _props.url,
	          item = _props.item,
	          chessUrl = _props.chessUrl,
	          isOrderFieldTypeFilter = _props.isOrderFieldTypeFilter,
	          index = _props.index,
	          orderField = _props.orderField,
	          t = _props.t,
	          currency = _props.currency;
	      var id = item.id,
	          title = item.title,
	          address = item.address,
	          microregion = item.microregion,
	          image = item.image,
	          status = item.status,
	          _item$flats_by_search = item.flats_by_search,
	          flatsBySearch = _item$flats_by_search === undefined ? {} : _item$flats_by_search,
	          flatsCount = item.count_flats,
	          hasPromo = item.view_action,
	          costMin = item.cost_min,
	          minAreaCost = item.min_area_cost,
	          minSquare = item.min_square,
	          maxSquare = item.max_square,
	          year_built = item.year_built,
	          construction_ending = item.construction_ending,
	          construction_finished = item.construction_finished,
	          checkout = item.checkout,
	          checkout2 = item.checkout2,
	          military_ipoteka = item.military_ipoteka,
	          mat_capital = item.mat_capital,
	          ipoteka = item.ipoteka,
	          installments = item.installments,
	          favorite = item.favorite,
	          type_id = item.type_id,
	          is_verified = item.is_verified,
	          promo = item.promo,
	          availability_record = item.availability_record;
	
	      var searchFlats = !!this.props.item.flats_by_search;
	      var flats = flatsBySearch.rows,
	          searchFlatsCount = flatsBySearch.total;
	
	      var chessUrlWithQuery = chessUrl + 'from=main';
	
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        {
	          onClick: function onClick() {
	            _tracker2.default.sendEvent('Web_Click', { id: id, name: title, mode: 'list' });
	            _this5.handleCardClick();
	          },
	          to: url,
	          className: (0, _classnames2.default)(_Item2.default.Item, className)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _Item2.default.ImageContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _Item2.default.Hover },
	            _react2.default.createElement(
	              'div',
	              { className: _Item2.default.HoverButtons },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: _Item2.default.HoverButton,
	                  onClick: this.handleAddToFavoritesClick,
	                  'data-tip': favorite ? t('components.buildings.list.removeFromFavorites') : t('components.buildings.list.addToFavorites'),
	                  'data-for': 'global'
	                },
	                favorite ? _react2.default.createElement('img', { src: _iconHeartActive2.default, alt: '', className: _Item2.default.Active }) : _react2.default.createElement('img', { src: _iconHeartWhite2.default, alt: '' }),
	                favorite ? t('components.buildings.list.alreadyInFavorites') : t('components.buildings.list.addTo')
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: (0, _classnames2.default)(_Item2.default.HoverButton, 'tooltip'),
	                  onClick: this.handleAddToCollectionClick,
	                  'data-tip': t('components.buildings.list.addToCollection'),
	                  'data-for': 'global'
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement('i', null),
	                  _react2.default.createElement('i', null)
	                ),
	                t('components.buildings.list.toCollection')
	              )
	            )
	          ),
	          availability_record && _react2.default.createElement(
	            'div',
	            { className: _Item2.default.Appointment },
	            _react2.default.createElement('img', { src: _calendar2.default, alt: 'calendar-icon' })
	          ),
	          favorite && _react2.default.createElement(
	            'div',
	            { className: _Item2.default.InFavorites },
	            _react2.default.createElement('img', { src: _iconHeartActiveRed2.default, alt: '' })
	          ),
	          image ? [smallImageLoaded ? _react2.default.createElement('img', { key: 'bigImg', ref: 'bigImg', alt: 'house', onError: this.addDefaultSrc.bind(this, _bannerPlaceholder2.default), src: _Config.ROOT_URL + '/image?id=' + image.id + '&size=medium', className: _Item2.default.BigImage }) : null, _react2.default.createElement('img', { key: 'smallImg', ref: 'smallImg', alt: 'house', onError: this.addDefaultSrc.bind(this, _bannerPlaceholder2.default), src: _Config.ROOT_URL + '/image?id=' + image.id + '&size=small', className: (0, _classnames2.default)(_Item2.default.SmallImage, _defineProperty({}, _Item2.default.SmallImageHide, bigImageLoaded)) })] : _react2.default.createElement('img', { src: _nonPhoto2.default, style: { maxWidth: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Item2.default.Main },
	          _react2.default.createElement(
	            'div',
	            { className: _Item2.default.Inner },
	            _react2.default.createElement(
	              'div',
	              { className: _Item2.default.AddressBlock },
	              _react2.default.createElement(
	                'div',
	                { className: _Item2.default.Title },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  title
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Item2.default.Status },
	                  is_verified && _react2.default.createElement('img', {
	                    className: _Item2.default.Verified,
	                    alt: t('components.buildings.list.verified'),
	                    title: t('components.buildings.list.verified'),
	                    src: _iconVerified2.default
	                  }),
	                  hasPromo ? _react2.default.createElement(
	                    'span',
	                    { className: _Item2.default.PromoLabel },
	                    t('components.buildings.list.promo')
	                  ) : null,
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: (0, _classnames2.default)(_Item2.default.StatusTitle, (_cn3 = {}, _defineProperty(_cn3, _Item2.default.StatusTitleFinished, !!construction_finished && status !== 3), _defineProperty(_cn3, _Item2.default.StatusTitleAlmostFinished, status == 3), _cn3))
	                    },
	                    status == 3 ? t('components.buildings.list.almostFinished') : construction_finished ? t('components.buildings.list.finished') : '' + (year_built !== 0 ? (construction_ending ? construction_ending + ' / ' : '') + year_built : t('components.buildings.list.inProgress'))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Item2.default.WrapperAddress },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Item2.default.Address },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _Item2.default.TextAddress },
	                    microregion + ', ' + address
	                  )
	                )
	              )
	            ),
	            orderField === 'visit_day' && _react2.default.createElement(
	              'p',
	              { className: _Item2.default.popularLaberl },
	              _react2.default.createElement('img', { src: _eyeOutline2.default }),
	              item.visit_day
	            ),
	            orderField === 'visit_week' && _react2.default.createElement(
	              'p',
	              { className: _Item2.default.popularLaberl },
	              _react2.default.createElement('img', { src: _eyeOutline2.default }),
	              item.visit_week
	            ),
	            orderField === 'visit_month' && _react2.default.createElement(
	              'p',
	              { className: _Item2.default.popularLaberl },
	              _react2.default.createElement('img', { src: _eyeOutline2.default }),
	              item.visit_month
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Item2.default.InfoBlock },
	              _react2.default.createElement(
	                'div',
	                { className: _Item2.default.Block },
	                checkout2 ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  checkout2 === 'Предварительный договор' ? t('components.buildings.list.beforeAgr') : checkout2
	                ) : null,
	                checkout ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  checkout
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Item2.default.Block },
	                military_ipoteka ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  t('components.buildings.list.military_ipoteka')
	                ) : null,
	                mat_capital ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  t('components.buildings.list.mat_capital')
	                ) : null,
	                ipoteka ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  t('components.buildings.list.ipoteka')
	                ) : null,
	                installments ? _react2.default.createElement(
	                  'p',
	                  { className: _Item2.default.BlockItem },
	                  t('components.buildings.list.installments')
	                ) : null
	              )
	            ),
	            promo && _react2.default.createElement(
	              'div',
	              { className: _Item2.default.PromoAds },
	              _react2.default.createElement(
	                'p',
	                null,
	                t('components.buildings.list.promoAds')
	              )
	            )
	          )
	        ),
	        flatsCount ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Item2.default.Price, _defineProperty({}, _Item2.default.Stopped, status === 2)) },
	          status === 2 ? _react2.default.createElement(
	            'div',
	            { className: _Item2.default.Message },
	            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: t('components.buildings.list.paused') } })
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            this.renderFlatsCount(),
	            _react2.default.createElement(
	              'div',
	              { className: _Item2.default.PriceBlock },
	              _react2.default.createElement(
	                'p',
	                { className: _Item2.default.StartPrice },
	                t('components.buildings.list.costMin', {
	                  costMin: (0, _utils.formatNumber)(searchFlats ? Math.min.apply(null, flats.map(function (f) {
	                    return f.cost;
	                  })) : costMin),
	                  currency: currency
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _Item2.default.PricePerMeter },
	                t('components.buildings.list.minAreaCost', {
	                  minAreaCost: (0, _utils.formatNumber)(searchFlats ? Math.min.apply(null, flats.map(function (f) {
	                    return f.price;
	                  })) : minAreaCost),
	                  currency: currency
	                })
	              )
	            ),
	            (searchFlats ? searchFlatsCount : flatsCount) === 1 ? _react2.default.createElement(
	              'p',
	              { className: _Item2.default.Area },
	              t('components.buildings.list.square', {
	                square: (0, _utils.formatNumber)(searchFlats ? Math.min.apply(null, flats.map(function (f) {
	                  return f.area;
	                })) : minSquare)
	              })
	            ) : _react2.default.createElement(
	              'p',
	              { className: _Item2.default.Area },
	              t('components.buildings.list.square12', {
	                square1: (0, _utils.formatNumber)(searchFlats ? Math.min.apply(null, flats.map(function (f) {
	                  return f.area;
	                })) : minSquare),
	                square2: (0, _utils.formatNumber)(searchFlats ? Math.max.apply(null, flats.map(function (f) {
	                  return f.area;
	                })) : maxSquare)
	              })
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                to: chessUrlWithQuery,
	                className: _Item2.default.ChessLink,
	                onClick: function onClick(e) {
	                  return _this5.handleGoToChess(e);
	                }
	              },
	              t('components.buildings.list.chess'),
	              ' ',
	              _react2.default.createElement('i', null)
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Item2.default.Price, _Item2.default.Empty) },
	          _react2.default.createElement(
	            'div',
	            { className: _Item2.default.Message },
	            status === 2 ? t('components.buildings.list.stopped2') : _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: type_id == 2 ? t('components.buildings.list.soldHouses') : t('components.buildings.list.soldFlats') } })
	          )
	        ),
	        _react2.default.createElement(_FilterLabel2.default, { isPopularList: isOrderFieldTypeFilter, index: index, isBlackList: item.black_list, isNew: item.new, isNedvex: item.nedvex })
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.PureComponent);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    isOrderFieldTypeFilter: state.search.isOrderFieldTypeFilter,
	    orderField: state.search.request.orderField,
	    profile: state.profile
	  };
	}, { setPopUp: _environment.setPopUp, addToFavorites: _favorites.addToFavorites, removeFromFavorites: _favorites.removeFromFavorites, favoritesNews: _news.favoritesNews })(Item));

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Item = __webpack_require__(963);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Item2.default;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _List = __webpack_require__(1373);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _reactInfinite = __webpack_require__(1986);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _objects = __webpack_require__(99);
	
	var _utils = __webpack_require__(12);
	
	var _iconUp = __webpack_require__(1558);
	
	var _iconUp2 = _interopRequireDefault(_iconUp);
	
	var _Item = __webpack_require__(964);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED = 60;
	
	var List = (0, _reactRouterDom.withRouter)(_class = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.scrollToTop = function () {
	      _this.scrollContainer.scrollTop = 0;
	    };
	
	    _this.handleInfintityScroll = function () {
	      var isShown = _this.state.isScrollTopBtnShown;
	      if (_this.scrollContainer.scrollTop >= HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED && !isShown) {
	        _this.setState({ isScrollTopBtnShown: true });
	      }
	      if (_this.scrollContainer.scrollTop < HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED && isShown) {
	        _this.setState({ isScrollTopBtnShown: false });
	      }
	    };
	
	    _this.state = {
	      isScrollTopBtnShown: false
	    };
	
	    _this.renderList = _this.renderList.bind(_this);
	    _this.elementInfiniteLoad = _this.elementInfiniteLoad.bind(_this);
	    _this.handleInfinityLoad = _this.handleInfinityLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          scrollTop = _props.scrollTop;
	
	      if (data && scrollTop != null) {
	        this.scrollContainer.scrollTop = scrollTop;
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var dispatch = this.props.dispatch;
	
	      if (this.scrollContainer) {
	        dispatch((0, _objects.setScrollTop)(this.scrollContainer.scrollTop));
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.isCottegesPage !== this.props.isCottegesPage && this.scrollContainer) {
	        this.scrollContainer.scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(data) {
	      var _props2 = this.props,
	          _props2$request = _props2.request,
	          priceMin = _props2$request.priceMin,
	          priceMax = _props2$request.priceMax,
	          costMin = _props2$request.costMin,
	          costMax = _props2$request.costMax,
	          areaFrom = _props2$request.areaFrom,
	          areaTo = _props2$request.areaTo,
	          view_type = _props2$request.view_type,
	          isTypeFilterAction = _props2.isTypeFilterAction,
	          currency = _props2.currency,
	          location = _props2.location,
	          profile = _props2.profile;
	
	      var query = (0, _utils.compileQuery)({ priceMin: priceMin, priceMax: priceMax, costMin: costMin, costMax: costMax, areaFrom: areaFrom, areaTo: areaTo, view_type: view_type });
	      return data ? [this.props.children].concat(data.map(function (building, i) {
	        return _react2.default.createElement(_Item2.default, {
	          url: '/building/' + building.id,
	          chessUrl: '/building/' + building.id + '/chess?' + query,
	          key: building.id,
	          item: building,
	          index: i + 1,
	          isTypeFilterAction: isTypeFilterAction,
	          currency: currency,
	          location: location
	        });
	      })) : null;
	    }
	  }, {
	    key: 'renderWireframe',
	    value: function renderWireframe() {
	      return _react2.default.createElement(
	        'div',
	        { className: _List2.default.WireframeWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _List2.default.WireframeControls },
	          _react2.default.createElement('div', { className: _List2.default.WireframeControlsTitle }),
	          _react2.default.createElement('div', { className: _List2.default.WireframeControlsSubtitle })
	        ),
	        this.renderWireframeList()
	      );
	    }
	  }, {
	    key: 'renderWireframeList',
	    value: function renderWireframeList() {
	      return [{}, {}, {}, {}, {}, {}].map(function (o, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _List2.default.WireframeList, key: i },
	          _react2.default.createElement(
	            'div',
	            { className: _List2.default.WireframeItem },
	            _react2.default.createElement('div', { className: _List2.default.WireframeImage }),
	            _react2.default.createElement(
	              'div',
	              { className: _List2.default.WireframeMain },
	              _react2.default.createElement(
	                'div',
	                { className: _List2.default.WireframeInner },
	                _react2.default.createElement(
	                  'div',
	                  { className: _List2.default.WireframeAddressBlock },
	                  _react2.default.createElement('div', { className: _List2.default.WireframeTitle }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _List2.default.WireframeWrapperAddress },
	                    _react2.default.createElement('div', { className: _List2.default.WireframeAddress })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _List2.default.WireframeInfoBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _List2.default.WireframeBlock },
	                    _react2.default.createElement('div', { className: _List2.default.WireframeBlockItem })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _List2.default.WireframeBlock },
	                    _react2.default.createElement('div', { className: _List2.default.WireframeBlockItem }),
	                    _react2.default.createElement('div', { className: _List2.default.WireframeBlockItem })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _List2.default.WireframeStatus },
	                _react2.default.createElement('div', { className: _List2.default.WireframeStatusTitle })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _List2.default.WireframePrice },
	              _react2.default.createElement('div', { className: _List2.default.WireframeAppartments }),
	              _react2.default.createElement(
	                'div',
	                { className: _List2.default.WireframePriceBlock },
	                _react2.default.createElement('div', { className: _List2.default.WireframeStartPrice }),
	                _react2.default.createElement('div', { className: _List2.default.WireframePricePerMeter })
	              ),
	              _react2.default.createElement('div', { className: _List2.default.WireframeArea })
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'elementInfiniteLoad',
	    value: function elementInfiniteLoad() {
	      return _react2.default.createElement(
	        'div',
	        { className: _List2.default.LoaderWrapper },
	        _react2.default.createElement('div', { className: _List2.default.Loader })
	      );
	    }
	  }, {
	    key: 'handleInfinityLoad',
	    value: function handleInfinityLoad() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          isFinished = _props3.isFinished,
	          pathname = _props3.location.pathname;
	      // Не инициируем загрузку данных когда их еще не передавали (первоначальная
	      // загрузка инициирутеся в родителе), а так же, если достигнут конец списка.
	
	      if (!data || isFinished) {
	        return;
	      }
	      var _props4 = this.props,
	          dispatch = _props4.dispatch,
	          request = _props4.request;
	
	      var region = this.props.cities.find(function (cities) {
	        return cities.id === _this2.props.cityId;
	      }).areas.map(function (_ref) {
	        var id = _ref.id;
	        return id;
	      });
	
	      dispatch((0, _objects.loadData)(true, _extends({}, request, { offset: data.length, typeId: pathname.includes('cottages') ? 2 : 1, region: request.region || region })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          className = _props5.className,
	          data = _props5.data,
	          isFinished = _props5.isFinished,
	          isInfiniteLoading = _props5.isInfiniteLoading,
	          containerHeight = _props5.containerHeight;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_List2.default.Container, className) },
	        data ? _react2.default.createElement(
	          _reactInfinite2.default,
	          {
	            className: (0, _classnames2.default)(_List2.default.ListContainer, 'custom-scrollbar'),
	            isInfiniteLoading: isInfiniteLoading
	            // loadingSpinnerDelegate={this.elementInfiniteLoad()}
	            , infiniteLoadBeginEdgeOffset: isFinished ? undefined : 800,
	            onInfiniteLoad: this.handleInfinityLoad,
	            elementHeight: 192,
	            preloadBatchSize: 2400,
	            preloadAdditionalHeight: 2400,
	            containerHeight: containerHeight,
	            handleScroll: this.handleInfintityScroll,
	            ref: function ref(_ref2) {
	              _this3.scrollContainer = _ref2;
	            }
	          },
	          this.renderList(data)
	        ) : this.renderWireframe([{}, {}, {}, {}, {}, {}]),
	        this.state.isScrollTopBtnShown && _react2.default.createElement(
	          'div',
	          { className: _List2.default.GoToTop, onClick: this.scrollToTop },
	          _react2.default.createElement('img', { src: _iconUp2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent)) || _class;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cityId: state.profile.cityId,
	    cities: state.building.cities,
	    currency: state.profile.user_region.country_currency_symbol
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(List);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _News = __webpack_require__(1375);
	
	var _News2 = _interopRequireDefault(_News);
	
	var _lodash = __webpack_require__(354);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(568);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactStickyEl = __webpack_require__(187);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _news = __webpack_require__(212);
	
	var _utils = __webpack_require__(12);
	
	var _Config = __webpack_require__(16);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	var _logoNedvexChar = __webpack_require__(1580);
	
	var _logoNedvexChar2 = _interopRequireDefault(_logoNedvexChar);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var News = function (_Component) {
	  _inherits(News, _Component);
	
	  function News(props) {
	    _classCallCheck(this, News);
	
	    var _this = _possibleConstructorReturn(this, (News.__proto__ || Object.getPrototypeOf(News)).call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.props.allNews({ limit: 20, offset: 0 });
	      _this.props.nedvexNews({ limit: 20, offset: 0 });
	      _this.props.favoritesNews({ limit: 20, offset: 0 });
	      _this.ref.addEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.componentWillUnmount = function () {
	      _this.ref.removeEventListener('scroll', _this.handleScroll);
	    };
	
	    _this.newsDidMount = function (ref) {
	      _this.ref = ref;
	    };
	
	    _this.handleEvent = function (eventName, item) {
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType;
	      var mode = _this.state.mode;
	
	
	      var newsMode = void 0;
	      switch (mode) {
	        case 'allNewsData':
	          newsMode = 'vse';
	          break;
	        case 'favoritesNewsData':
	          newsMode = 'izbrannoe';
	          break;
	        case 'nedvexNewsData':
	          newsMode = 'ot_servisa';
	          break;
	        default:
	          break;
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        screenName: '/',
	        eventContext: newsMode,
	        eventContent: item.building ? item.building.name : '',
	        productType: objectType,
	        productName: item.building ? item.building.name : '',
	        productID: item.building ? item.building.id : '',
	        user_id: profile.id
	      }));
	    };
	
	    _this.handleLinkClick = function (e, item) {
	      e.stopPropagation();
	      _this.handleEvent('newsCardObjectLinkClick', item);
	    };
	
	    _this.handlePopupLinkClick = function () {
	      _this.props.setPopUp(undefined);
	    };
	
	    _this.handleScroll = function (e) {
	      var _this$props$_this$sta = _this.props[_this.state.mode],
	          loading = _this$props$_this$sta.loading,
	          finished = _this$props$_this$sta.finished;
	
	      if ((e.currentTarget.scrollHeight > e.currentTarget.scrollWidth ? e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight < 200 : e.currentTarget.scrollWidth - e.currentTarget.scrollLeft - e.currentTarget.clientWidth < 200) && !loading && !finished) {
	        _this.loadNews(_this.state.mode);
	      }
	    };
	
	    _this.loadNews = function (mode) {
	      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var offset = _this.state.offset;
	
	      var newOffset = reset ? 0 : offset;
	
	      switch (mode) {
	        case 'allNewsData':
	          _this.props.allNews({ limit: 20, offset: newOffset });
	          break;
	        case 'nedvexNewsData':
	          _this.props.nedvexNews({ limit: 20, offset: newOffset });
	          break;
	        case 'favoritesNewsData':
	          _this.props.favoritesNews({ limit: 20, offset: newOffset });
	          break;
	        default:
	          break;
	      }
	
	      if (reset) {
	        _this.setState({ offset: 20 });
	      } else {
	        _this.setState({ offset: offset + 20 });
	      }
	    };
	
	    _this.handleModeChange = function (mode) {
	      _this.setState({ mode: mode, offset: 0 }, function () {
	        _this.loadNews(mode, true);
	      });
	    };
	
	    _this.handleMoreClick = function (item) {
	      _this.handleEvent('newsCardClick', item);
	
	      _this.props.setPopUp(_react2.default.createElement(
	        'div',
	        { className: _News2.default.NewsPopupWrap },
	        _this.renderPopupTitle(item),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_News2.default.PopupNewsList, 'custom-scrollbar') },
	          _react2.default.createElement(
	            'div',
	            { className: _News2.default.PopupNewsItem },
	            _react2.default.createElement(
	              'time',
	              { className: _News2.default.PopupNewsItemDate },
	              (0, _utils.formatDate)(item.dateUpdate),
	              ', ',
	              (0, _utils.formatTime)(item.dateUpdate)
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _News2.default.PopupNewsItemText },
	              (0, _helper.linkifyText)(item.name)
	            )
	          )
	        )
	      ), {
	        className: _News2.default.NewsPopup,
	        contentClassName: _News2.default.NewsPopupContent,
	        closeStyleName: 'Default',
	        closeClassName: _News2.default.NewsPopupClose,
	        contentStyleName: 'Default',
	        closeIcon: 'default'
	      });
	    };
	
	    _this.renderPopupTitle = function (item) {
	      return _react2.default.createElement(
	        'div',
	        { className: _News2.default.PopupTitle, onClick: function onClick(e) {
	            return _this.handleLinkClick(e, item);
	          } },
	        item.building ? item.building.image ? _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: '/building/' + item.building.id, onClick: _this.handlePopupLinkClick.bind(_this) },
	          _react2.default.createElement('img', {
	            src: _Config.ROOT_URL + '/image?id=' + item.building.image.id + '&size=small',
	            className: _News2.default.PopupTitleImg,
	            alt: ''
	          })
	        ) : null : _react2.default.createElement('img', { src: _logoNedvexChar2.default, className: _News2.default.PopupTitleNedvexImg, alt: '' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          item.building ? _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/building/' + item.building.id, onClick: _this.handlePopupLinkClick.bind(_this) },
	            item.building.name
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            '\u041E\u0422 NEDVEX'
	          )
	        )
	      );
	    };
	
	    _this.handleNewsCardShow = function (_ref) {
	      var newsId = _ref.newsId,
	          newsTitle = _ref.newsTitle,
	          productName = _ref.productName,
	          productID = _ref.productID;
	
	      if (!_this.state.shownNews.has(newsId)) {
	        _this.handleEvent('newsCardShow', {
	          name: newsTitle,
	          building: { name: productName, id: productID }
	        });
	
	        _this.setState(function (prevState) {
	          var updatedShownNews = new Set(prevState.shownNews);
	          updatedShownNews.add(newsId);
	          return { shownNews: updatedShownNews };
	        });
	      }
	    };
	
	    _this.handleButtonClick = function (_ref2) {
	      var buttonName = _ref2.buttonName;
	      var _this$props2 = _this.props,
	          profile = _this$props2.profile,
	          mode = _this$props2.mode,
	          objectType = _this$props2.objectType;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.newsButtonsClick({
	        eventLabel: buttonName,
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      mode: 'allNewsData',
	      offset: 0,
	      shownNews: new Set()
	    };
	    return _this;
	  }
	
	  _createClass(News, [{
	    key: 'renderNewsTitle',
	    value: function renderNewsTitle(item) {
	      var building = item.building;
	
	
	      this.handleNewsCardShow({
	        newsId: item.id,
	        newsTitle: item ? item.name : '',
	        productName: building ? building.name : '',
	        productID: building ? building.id : ''
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: _News2.default.NewsHeader },
	        item.building ? item.building.image && _react2.default.createElement('img', {
	          src: _Config.ROOT_URL + '/image?id=' + item.building.image.id + '&size=small',
	          className: _News2.default.NewsHeaderImg,
	          alt: ''
	        }) : _react2.default.createElement('img', { src: _logoNedvexChar2.default, className: _News2.default.NewsHeaderImg, alt: '' }),
	        _react2.default.createElement(
	          'div',
	          { className: _News2.default.NewsHeaderRight },
	          _react2.default.createElement(
	            'p',
	            { className: _News2.default.ObjectName },
	            item.building ? item.building.name : 'ОТ NEDVEX'
	          ),
	          _react2.default.createElement(
	            'time',
	            { className: _News2.default.NewsTime },
	            (0, _utils.formatDate)(item.dateUpdate),
	            ', ',
	            (0, _utils.formatTime)(item.dateUpdate)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mode = this.state.mode;
	      var t = this.props.t;
	      var data = this.props[mode].data;
	
	      var groupedData = data && data.length ? (0, _lodash4.default)((0, _lodash2.default)(data, function (_ref3) {
	        var dateUpdate = _ref3.dateUpdate;
	        return dateUpdate.split(' ')[0];
	      })).sort(function (a, b) {
	        return a[0] < b[0] ? 1 : -1;
	      }) : [];
	
	      var items = groupedData.map(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2),
	            date = _ref5[0],
	            array = _ref5[1];
	
	        return [_react2.default.createElement(
	          _reactStickyEl2.default,
	          {
	            key: date,
	            scrollElement: '.scrollarea',
	            stickyClassName: _News2.default.stickyEl,
	            className: _News2.default.NewsFeedItemDate
	          },
	          (0, _utils.formatDate)(date)
	        ),
	        // <div className={styles.NewsFeedItemDate}>
	        //   {formatDate(date)}
	        // </div>,
	        array.map(function (item) {
	          var _cn;
	
	          return _react2.default.createElement(
	            'div',
	            {
	              key: item.id,
	              className: (0, _classnames2.default)(_News2.default.NewsFeedItem, (_cn = {}, _defineProperty(_cn, _News2.default.Marked, false), _defineProperty(_cn, _News2.default.Nedvex, !item.building), _cn)),
	              onClick: function onClick() {
	                return _this2.handleMoreClick(item);
	              }
	            },
	            item.building ? _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                to: '/building/' + item.building.id,
	                className: _News2.default.NewsLink
	                // onClick={(e) => this.handleLinkClick(e, item)}
	              },
	              _this2.renderNewsTitle(item)
	            ) : _this2.renderNewsTitle(item),
	            _react2.default.createElement(
	              'div',
	              { className: _News2.default.NewsText },
	              (0, _helper.linkifyText)(item.name, 100)
	            ),
	            item.name.length > 100 ? _react2.default.createElement(
	              'span',
	              { className: _News2.default.ReadMore },
	              t('components.buildings.news.readMore')
	            ) : null
	          );
	        })];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: _News2.default.NewsFeedWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _News2.default.NewsFeed },
	          _react2.default.createElement(
	            'p',
	            { className: _News2.default.NewsFeedTitle },
	            t('components.buildings.news.title')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _News2.default.ButtonGroup },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_defineProperty({}, _News2.default.ActiveMode, mode === 'allNewsData')),
	                onClick: function onClick() {
	                  _tracker2.default.sendEvent('Web_List_News_All');
	                  _this2.handleModeChange('allNewsData');
	                  _this2.handleButtonClick({ buttonName: 'vse' });
	                }
	              },
	              t('components.buildings.news.all')
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_defineProperty({}, _News2.default.ActiveMode, mode === 'favoritesNewsData')),
	                onClick: function onClick() {
	                  _tracker2.default.sendEvent('Web_List_News_Favorites');
	                  _this2.handleModeChange('favoritesNewsData');
	                  _this2.handleButtonClick({ buttonName: 'izbrannoe' });
	                }
	              },
	              t('components.buildings.news.favorite')
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_defineProperty({}, _News2.default.ActiveMode, mode === 'nedvexNewsData')),
	                onClick: function onClick() {
	                  _tracker2.default.sendEvent('Web_List_News_From_Service');
	                  _this2.handleModeChange('nedvexNewsData');
	                  _this2.handleButtonClick({ buttonName: 'ot_servisa' });
	                }
	              },
	              t('components.buildings.news.fromService')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_News2.default.scrollArea, 'scrollarea', 'custom-scrollbar'),
	              ref: this.newsDidMount
	            },
	            items
	          )
	        )
	      );
	    }
	  }]);
	
	  return News;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(function (state) {
	  return {
	    allNewsData: state.allNews,
	    nedvexNewsData: state.nedvexNews,
	    favoritesNewsData: state.favoritesNews,
	    profile: state.profile
	  };
	}, { setPopUp: _environment.setPopUp, allNews: _news.allNews, nedvexNews: _news.nedvexNews, favoritesNews: _news.favoritesNews })(News));

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _News = __webpack_require__(966);
	
	var _News2 = _interopRequireDefault(_News);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _News2.default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _NoBuildings = __webpack_require__(1376);
	
	var _NoBuildings2 = _interopRequireDefault(_NoBuildings);
	
	var _search = __webpack_require__(68);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoBuildings = function (_Component) {
	  _inherits(NoBuildings, _Component);
	
	  function NoBuildings(props) {
	    _classCallCheck(this, NoBuildings);
	
	    var _this = _possibleConstructorReturn(this, (NoBuildings.__proto__ || Object.getPrototypeOf(NoBuildings)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(NoBuildings, [{
	    key: 'onClick',
	    value: function onClick() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          location = _props.location,
	          history = _props.history;
	      var pathname = location.pathname;
	
	      var path = '' + pathname;
	      history.push(path);
	      dispatch((0, _search.changeFilters)(null, { reset: true }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var _props2 = this.props,
	          className = _props2.className,
	          classNameInfo = _props2.classNameInfo,
	          text = _props2.text,
	          title = _props2.title,
	          _props2$buttonText = _props2.buttonText,
	          buttonText = _props2$buttonText === undefined ? t('components.buildings.noBuildings.startNewSearch') : _props2$buttonText,
	          onClick = _props2.onClick;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_NoBuildings2.default.NoBuildings) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_NoBuildings2.default.Rectangle, className) },
	          _react2.default.createElement('img', { className: (0, _classnames2.default)(_NoBuildings2.default.Image), src: _nothingfound2.default, alt: 'nothing found' }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_NoBuildings2.default.Info, classNameInfo) },
	            _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(_NoBuildings2.default.InfoTitle) },
	              title || t('components.buildings.noBuildings.notFound')
	            ),
	            text || _react2.default.createElement('span', {
	              className: (0, _classnames2.default)(_NoBuildings2.default.InfoSubTitle),
	              dangerouslySetInnerHTML: { __html: t('components.buildings.noBuildings.notFoundFull') }
	            }),
	            _react2.default.createElement(
	              'button',
	              { className: (0, _classnames2.default)(_NoBuildings2.default.Button), onClick: onClick || this.onClick },
	              buttonText
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NoBuildings;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRouterDom.withRouter)(NoBuildings));

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactStickyEl = __webpack_require__(187);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	var _lodash = __webpack_require__(354);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(568);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _collections = __webpack_require__(49);
	
	var _ClientHeader = __webpack_require__(313);
	
	var _ClientHeader2 = _interopRequireDefault(_ClientHeader);
	
	var _BuildingCard = __webpack_require__(310);
	
	var _BuildingCard2 = _interopRequireDefault(_BuildingCard);
	
	var _RealtorCard = __webpack_require__(497);
	
	var _RealtorCard2 = _interopRequireDefault(_RealtorCard);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Dropdown = __webpack_require__(216);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Menu = __webpack_require__(217);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Loader = __webpack_require__(970);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _NoPage = __webpack_require__(475);
	
	var _NoPage2 = _interopRequireDefault(_NoPage);
	
	var _ClientCollection = __webpack_require__(1377);
	
	var _ClientCollection2 = _interopRequireDefault(_ClientCollection);
	
	var _iconSearchMap = __webpack_require__(548);
	
	var _iconSearchMap2 = _interopRequireDefault(_iconSearchMap);
	
	var _YMap = __webpack_require__(312);
	
	var _YMap2 = _interopRequireDefault(_YMap);
	
	var _objects = __webpack_require__(99);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _helper = __webpack_require__(55);
	
	var _collections2 = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sorts = {
	  'district DESC': {
	    text: _i18n2.default.t('components.clientCollection.district'),
	    orderField: 'district',
	    orderDirection: 'DESC',
	    key: 'districtDesc'
	  },
	  'costMin ASC': {
	    text: _i18n2.default.t('components.clientCollection.costMinASC'),
	    orderField: 'costMin',
	    orderDirection: 'ASC',
	    key: 'costAsc'
	  },
	  'costMin DESC': {
	    text: _i18n2.default.t('components.clientCollection.costMinDESC'),
	    orderField: 'costMin',
	    orderDirection: 'DESC',
	    key: 'costDesc'
	  }
	};
	
	var sortKeys = Object.keys(sorts);
	
	var Collection = function Collection(props) {
	  var _useState = (0, _react.useState)({
	    orderField: 'district',
	    orderDirection: 'DESC',
	    showMap: false
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      state = _useState2[0],
	      setState = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectionLoadedHere = _useState4[0],
	      setSelectionLoadedHere = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    var _props$match$params = props.match.params,
	        base64 = _props$match$params.base64,
	        referal = _props$match$params.referal;
	
	    if (base64) {
	      (0, _helper.getParams)(base64).then(function (data) {
	        return props.loadCollection({ referal: data.r });
	      });
	      setSelectionLoadedHere(true);
	    } else {
	      props.loadCollection({ referal: referal });
	      setSelectionLoadedHere(true);
	    }
	
	    props.loadData(false, {
	      limit: 10,
	      orderField: 'date_update',
	      orderDirection: 'DESC',
	      region: ['1', '2', '3', '4', '5', '6'],
	      deadlineEnd: false,
	      typeId: 1
	    }, true);
	  }, []);
	
	  var handleSortClick = function handleSortClick(orderField, orderDirection) {
	    setState({
	      orderField: orderField,
	      orderDirection: orderDirection
	    });
	  };
	
	  var renderCard = function renderCard(building) {
	    var _props$match$params2 = props.match.params,
	        base64 = _props$match$params2.base64,
	        referal = _props$match$params2.referal;
	
	
	    var makeUrl = function makeUrl() {
	      if (referal) {
	        return '/view/' + props.match.params.referal + '/building/';
	      }
	
	      return '/ncollection/' + base64 + '/';
	    };
	
	    return (
	      // image={building.albums.rows && building.albums.rows[0] && building.albums.rows[0].images[0]}
	      _react2.default.createElement(_BuildingCard2.default, _extends({}, building, {
	        className: _ClientCollection2.default.BuildingCard,
	        title: props.selection.showInfo === '0' ? null : building.title,
	        address: props.selection.showInfo === '0' ? null : building.address,
	        url: makeUrl()
	        // target="_blank"
	        , key: building.id,
	        collection: 'true',
	        withDetails: (0, _helper.isSectionAllowed)('nameAddress'),
	        showStatus: (0, _helper.isSectionAllowed)('nameAddress'),
	        client: true,
	        buildingCurrency: building.country.country_currency_symbol,
	        profile: props.profile,
	        location: props.location
	      }))
	    );
	  };
	
	  var handleShowMapClick = function handleShowMapClick() {
	    setState(function (prevState) {
	      return _extends({}, prevState, {
	        showMap: true
	      });
	    });
	  };
	
	  var handleClose = function handleClose() {
	    setState(function (prevState) {
	      return _extends({}, prevState, {
	        showMap: false
	      });
	    });
	  };
	
	  var buildings = props.buildings,
	      user = props.user,
	      dispatch = props.dispatch,
	      params = props.match.params,
	      _props$selection = props.selection,
	      name = _props$selection.name,
	      showInfo = _props$selection.showInfo,
	      noPageExist = props.noPageExist,
	      t = props.t,
	      selection = props.selection,
	      _props$objects = props.objects,
	      objects = _props$objects === undefined ? {} : _props$objects;
	  var points = objects.points;
	
	
	  var sortKey = state.orderField + ' ' + state.orderDirection;
	
	  var visitTime = new Date().toISOString();
	  var isFirstSend = (0, _react.useRef)(true);
	  var intervalId = (0, _react.useRef)(null);
	
	  var getSessionUuid = function getSessionUuid() {
	    var uuid = sessionStorage.getItem('sessionUuid');
	    if (!uuid) {
	      uuid = crypto.randomUUID();
	      sessionStorage.setItem('sessionUuid', uuid);
	    }
	    return uuid;
	  };
	
	  var sessionUuid = getSessionUuid();
	
	  (0, _react.useEffect)(function () {
	    if (!selectionLoadedHere || !selection || !selection.id) return;
	
	    var sendData = function sendData() {
	      if (document.hidden) return;
	
	      (0, _collections2.sendCollectionStats)({
	        sessionUuid: sessionUuid,
	        collectionId: Number(selection.id),
	        totalViews: isFirstSend.current ? 1 : 0,
	        lastVisitStart: visitTime
	      });
	
	      isFirstSend.current = false;
	    };
	
	    var startSending = function startSending() {
	      if (intervalId.current) return;
	      sendData();
	      intervalId.current = setInterval(sendData, 3000);
	    };
	
	    var stopSending = function stopSending() {
	      if (intervalId.current) {
	        clearInterval(intervalId.current);
	        intervalId.current = null;
	      }
	    };
	
	    var handleVisibilityChange = function handleVisibilityChange() {
	      if (!document.hidden) {
	        startSending();
	      } else {
	        stopSending();
	      }
	    };
	
	    document.addEventListener('visibilitychange', handleVisibilityChange);
	    startSending();
	
	    return function () {
	      stopSending();
	      document.removeEventListener('visibilitychange', handleVisibilityChange);
	    };
	  }, [selectionLoadedHere, selection]);
	
	  if (noPageExist) {
	    return _react2.default.createElement(
	      _ClientHeader2.default,
	      { params: params },
	      _react2.default.createElement(_NoPage2.default, null)
	    );
	  }
	
	  return _react2.default.createElement(
	    _ClientHeader2.default,
	    { params: params },
	    buildings ? _react2.default.createElement(
	      'div',
	      { className: _ClientCollection2.default.ClientCollectionWrap },
	      _react2.default.createElement(
	        'div',
	        { className: _ClientCollection2.default.ClientCollection },
	        _react2.default.createElement(
	          'div',
	          { className: 'ContainerWrap' },
	          _react2.default.createElement(
	            'div',
	            { className: _ClientCollection2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _ClientCollection2.default.ClientCollectionLeft },
	              _react2.default.createElement(
	                'div',
	                { className: _ClientCollection2.default.ClientCollectionTitle },
	                name,
	                _react2.default.createElement(
	                  'div',
	                  { className: _ClientCollection2.default.SortBy },
	                  _react2.default.createElement(
	                    _Dropdown2.default,
	                    {
	                      className: (0, _classnames2.default)(_ClientCollection2.default.Dropdown),
	                      buttonStyle: _ClientCollection2.default.DropdownButton,
	                      textStyle: _ClientCollection2.default.DropdownText,
	                      iconStyle: _ClientCollection2.default.DropdownIcon,
	                      text: sorts[sortKey].text,
	                      'data-tip': t('components.clientCollection.sort'),
	                      'data-for': 'tooltip',
	                      topShift: true
	                    },
	                    _react2.default.createElement(
	                      _Menu2.default,
	                      { rightArrow: true, pure: true },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _ClientCollection2.default.OrderMenu },
	                        sortKeys.map(function (key) {
	                          var sort = sorts[key];
	                          var orderField = sort.orderField,
	                              orderDirection = sort.orderDirection;
	
	                          return _react2.default.createElement(
	                            'div',
	                            {
	                              key: key,
	                              className: (0, _classnames2.default)(_ClientCollection2.default.OrderMenuItem, _defineProperty({}, _ClientCollection2.default.OrderMenuActive, key === sortKey)),
	                              onClick: handleSortClick.bind(undefined, orderField, orderDirection)
	                            },
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              sort.text
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                ),
	                showInfo === '1' && (0, _helper.isSectionAllowed)('nameAddress') ? _react2.default.createElement(
	                  'div',
	                  { className: _ClientCollection2.default.OpenMapBtn, onClick: handleShowMapClick },
	                  _react2.default.createElement('img', { src: _iconSearchMap2.default, alt: '' }),
	                  ' ',
	                  t('components.clientCollection.searchOnMap')
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _ClientCollection2.default.ClientCollectionList },
	                buildings && (state.orderField === 'district' ? (0, _lodash4.default)((0, _lodash2.default)(buildings, 'microregion')).map(function (_ref) {
	                  var _ref2 = _slicedToArray(_ref, 2),
	                      district = _ref2[0],
	                      array = _ref2[1];
	
	                  return [(0, _helper.isSectionAllowed)('nameAddress') ? _react2.default.createElement(
	                    'p',
	                    { className: _ClientCollection2.default.CollectionListTitle },
	                    district
	                  ) : null, array.map(renderCard)];
	                }) : buildings.sort(function (b1, b2) {
	                  return (b1.cost_min - b2.cost_min) * (state.orderDirection === 'ASC' ? 1 : -1);
	                }).map(renderCard))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ClientCollection2.default.ClientCollectionRight },
	              _react2.default.createElement(
	                _reactStickyEl2.default,
	                {
	                  className: _ClientCollection2.default.stickyElNotFixed,
	                  stickyClassName: _ClientCollection2.default.stickyEl,
	                  boundaryElement: '.ContainerWrap',
	                  bottomOffset: 80
	                },
	                user && _react2.default.createElement(_RealtorCard2.default, _extends({}, user, { className: _ClientCollection2.default.RealtorBlock }))
	              )
	            ),
	            _react2.default.createElement(
	              _Modal2.default,
	              {
	                isOpen: state.showMap,
	                handleClose: handleClose,
	                title: t('components.clientCollection.map'),
	                contentStyle: {
	                  width: '80vw',
	                  height: '80vh'
	                }
	              },
	              _react2.default.createElement(_YMap2.default, {
	                className: _ClientCollection2.default.Map,
	                dispatch: dispatch,
	                data: buildings,
	                infoType: 'medium',
	                points: points
	              })
	            )
	          )
	        )
	      )
	    ) : _react2.default.createElement(_Loader2.default, { className: _ClientCollection2.default.ClientCollectionLoader })
	  );
	};
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var collection = _ref3.collection,
	      objects = _ref3.objects,
	      profile = _ref3.profile;
	  return _extends({}, collection, {
	    objects: objects,
	    profile: profile
	  });
	};
	
	var mapDispatchToProps = { loadCollection: _collections.loadCollection, loadData: _objects.loadData };
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Collection));

/***/ }),
/* 970 */
[2397, 1378],
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClientCollection = __webpack_require__(969);
	
	var _ClientCollection2 = _interopRequireDefault(_ClientCollection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ClientCollection2.default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ClientHeader = __webpack_require__(313);
	
	var _ClientHeader2 = _interopRequireDefault(_ClientHeader);
	
	var _ClientMap = __webpack_require__(1380);
	
	var _ClientMap2 = _interopRequireDefault(_ClientMap);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	var _YMap = __webpack_require__(312);
	
	var _YMap2 = _interopRequireDefault(_YMap);
	
	var _objects = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collection = (_dec = (0, _withValidTrafic2.default)(), _dec(_class = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection() {
	    _classCallCheck(this, Collection);
	
	    return _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).apply(this, arguments));
	  }
	
	  _createClass(Collection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var loadData = this.props.loadData;
	
	
	      loadData(false, {
	        limit: 10,
	        orderField: 'date_update',
	        orderDirection: 'DESC',
	        region: ['1', '2', '3', '4', '5', '6'],
	        deadlineEnd: false,
	        typeId: 1
	      }, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          buildings = _props.buildings,
	          params = _props.match.params;
	
	
	      return _react2.default.createElement(
	        _ClientHeader2.default,
	        { params: params },
	        _react2.default.createElement(
	          'div',
	          { className: _ClientMap2.default.ClientMap },
	          buildings && _react2.default.createElement(_YMap2.default, {
	            dispatch: dispatch,
	            data: buildings,
	            infoType: 'medium'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Collection;
	}(_react.Component)) || _class);
	exports.default = (0, _reactRedux.connect)(function (_ref) {
	  var collection = _ref.collection,
	      objects = _ref.objects;
	  return {
	    collection: collection,
	    objects: objects
	  };
	}, {
	  loadData: _objects.loadData
	})(Collection);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClientMap = __webpack_require__(972);
	
	var _ClientMap2 = _interopRequireDefault(_ClientMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ClientMap2.default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _CollectionItem = __webpack_require__(977);
	
	var _CollectionItem2 = _interopRequireDefault(_CollectionItem);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _reactClipboard = __webpack_require__(653);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collection = __webpack_require__(1381);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _nothingfound2x = __webpack_require__(351);
	
	var _nothingfound2x2 = _interopRequireDefault(_nothingfound2x);
	
	var _iconLinkDark = __webpack_require__(546);
	
	var _iconLinkDark2 = _interopRequireDefault(_iconLinkDark);
	
	var _checkIcon = __webpack_require__(339);
	
	var _checkIcon2 = _interopRequireDefault(_checkIcon);
	
	var _arrowDropdown = __webpack_require__(1521);
	
	var _arrowDropdown2 = _interopRequireDefault(_arrowDropdown);
	
	var _checkGreen = __webpack_require__(1526);
	
	var _checkGreen2 = _interopRequireDefault(_checkGreen);
	
	var _collections = __webpack_require__(49);
	
	var _environment = __webpack_require__(19);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	var _Select = __webpack_require__(482);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var StatsInfoField = function StatsInfoField(_ref) {
	  var title = _ref.title,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'div',
	    { className: _Collection2.default.StatsInfoField },
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.StatsInfoFieldTitle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.SendCollectionBtnText },
	      text
	    )
	  );
	};
	
	var formatTime = function formatTime(seconds) {
	  var hours = Math.floor(seconds / 3600);
	  var minutes = Math.floor(seconds % 3600 / 60);
	  var remainingSeconds = seconds % 60;
	
	  var parts = [];
	  if (hours > 0) parts.push(hours + ' \u0447');
	  if (minutes > 0) parts.push(minutes + ' \u043C\u0438\u043D');
	  if (remainingSeconds > 0) parts.push(remainingSeconds + ' \u0441\u0435\u043A');
	
	  return parts.join(' ');
	};
	
	var formatDate = function formatDate(dateStr, t) {
	  var date = new Date(dateStr);
	
	  var hours = String(date.getHours()).padStart(2, '0');
	  var minutes = String(date.getMinutes()).padStart(2, '0');
	  var day = date.getDate();
	  var month = t('utils.monthToString.' + date.getMonth());
	  var year = date.getFullYear();
	
	  return {
	    formattedTime: hours + ':' + minutes,
	    formattedDate: day + ' ' + month + ' ' + year,
	    date: date
	  };
	};
	
	var formatVisitDates = function formatVisitDates(start, end, t) {
	  var startFormatted = formatDate(start, t);
	  var endFormatted = formatDate(end, t);
	
	  if (!startFormatted || !endFormatted) {
	    return '';
	  }
	
	  if (startFormatted.date.toDateString() === endFormatted.date.toDateString()) {
	    return startFormatted.formattedTime + ' \u2013 ' + endFormatted.formattedTime + ', ' + startFormatted.formattedDate;
	  }
	  return startFormatted.formattedTime + ', ' + startFormatted.formattedDate + ' \u2013 ' + endFormatted.formattedTime + ', ' + endFormatted.formattedDate;
	};
	
	var Collection = function Collection(props) {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showModal = _useState2[0],
	      setShowModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      showNotification = _useState4[0],
	      setShowNotification = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    nameAddress: true,
	    description: true,
	    characteristics: true,
	    communications: true,
	    checkout: true,
	    payment: true,
	    map: true,
	    lots: _helper.LotsValues[0]
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      values = _useState6[0],
	      setValues = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isOpen = _useState8[0],
	      setIsOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      selectedSession = _useState10[0],
	      setSelectedSession = _useState10[1];
	
	  var sessionItems = props && props.selection && props.selection.sessions && props.selection.sessions.items ? props.selection.sessions.items : [];
	
	  var sessionTotal = props && props.selection && props.selection.sessions && props.selection.sessions.total ? props.selection.sessions.total : {};
	
	  var dropdownRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var handleClickOutside = function handleClickOutside(event) {
	      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
	        setIsOpen(false);
	      }
	    };
	
	    document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      return document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, []);
	
	  var toggleDropdown = function toggleDropdown() {
	    return setIsOpen(function (prev) {
	      return !prev;
	    });
	  };
	
	  var handleSelect = function handleSelect(value) {
	    setIsOpen(false);
	    setSelectedSession(value);
	  };
	
	  var dropdownOptions = [{ label: 'Все сессии', value: 'total' }].concat(_toConsumableArray(sessionItems.map(function (item, index) {
	    return {
	      label: '\u0421\u0435\u0441\u0441\u0438\u044F ' + (index + 1),
	      value: item.session_uuid
	    };
	  })));
	
	  var getCurrentSessionStats = function getCurrentSessionStats() {
	    if (!selectedSession || selectedSession === 'total') {
	      return sessionTotal;
	    }
	
	    return sessionItems.find(function (item) {
	      return item.session_uuid === selectedSession;
	    });
	  };
	
	  var handleTrackEvent = function handleTrackEvent(_ref2) {
	    var eventName = _ref2.eventName,
	        eventLabel = _ref2.eventLabel,
	        eventContent = _ref2.eventContent,
	        eventContext = _ref2.eventContext;
	    var profile = props.profile;
	
	    (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	      eventLabel: eventLabel,
	      eventContent: eventContent,
	      eventContext: eventContext,
	      user_id: profile.id
	    }));
	  };
	
	  var handleChange = function handleChange(name, value) {
	    if (name === 'lots') {
	      var event = value === 'Показывать все лоты' ? 'Web_ShareCollectionDialog_Lots_0' : value === 'Только отобранные лоты' ? 'Web_ShareCollectionDialog_Lots_1' : 'Web_ShareCollectionDialog_Lots_2';
	
	      _tracker2.default.sendEvent(event);
	    } else {
	      _tracker2.default.sendEvent('Web_ShareCollectionDialog_' + (0, _helper.firstLetterToUpper)(name), {
	        selectedSession: value
	      });
	    }
	
	    setValues(function (prevState) {
	      return _extends({}, prevState, _defineProperty({}, name, value));
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _collections.loadCollection)({ referal: props.match.params.referal }));
	
	    (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	      screenName: location.pathname
	    }));
	  }, []);
	
	  var handleClipboardClick = function handleClipboardClick() {
	    _tracker2.default.sendEvent('Web_ShareCollectionDialog_CopyButton');
	
	    handleTrackEvent({
	      eventName: 'collectionShareDialogButtonsClick',
	      eventLabel: 'skopirovat',
	      eventContext: props.selection.name
	    });
	
	    setShowNotification(true);
	    setTimeout(function () {
	      return setShowNotification(false);
	    }, 5000);
	  };
	
	  var handleClose = function handleClose() {
	    handleTrackEvent({
	      eventName: 'collectionShareDialogButtonsClick',
	      eventLabel: 'zakryt',
	      eventContext: props.selection.name
	    });
	
	    setShowModal(false);
	  };
	
	  var showLinkModal = function showLinkModal() {
	    _tracker2.default.sendEvent('Web_Selections_Share');
	
	    handleTrackEvent({
	      eventName: 'collectionShareButtonClick',
	      eventContext: props.selection.name
	    });
	
	    setShowModal(true);
	  };
	
	  var handleInputFocus = function handleInputFocus(e) {
	    e.target.selectionStart = 0;
	    e.target.selectionEnd = e.target.value.length;
	    _tracker2.default.sendEvent('Web_ShareCollectionDialog_Link');
	  };
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      shareUrl = _useState12[0],
	      setShareUrl = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    (0, _helper.makeBase64)({
	      r: props.match.params.referal,
	      values: values
	    }).then(function (hash) {
	      return setShareUrl(location.origin + '/ncollection/' + hash);
	    });
	  }, [values]);
	
	  var className = props.className,
	      buildings = props.buildings,
	      name = props.selection.name;
	
	
	  (0, _react.useEffect)(function () {
	    if (name && !buildings.length) {
	      handleTrackEvent({
	        eventName: 'collectionEmptyCardShow',
	        eventContext: props.selection.name
	      });
	    }
	  }, [buildings]);
	
	  var currentStats = getCurrentSessionStats();
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        t('components.collection.title', { name: name })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.CollectionWrap },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Collection2.default.Collection, className) },
	        _react2.default.createElement(
	          'div',
	          { className: _Collection2.default.Container },
	          _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.TitleBlock },
	            _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.TitleBlockLeft },
	              _react2.default.createElement(
	                'p',
	                { className: _Collection2.default.Title },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/collections' },
	                  t('components.collection.myCollections')
	                ),
	                ' / ',
	                name
	              ),
	              buildings && _react2.default.createElement(
	                'span',
	                { className: _Collection2.default.ObjectsCount },
	                buildings.length || 0,
	                ' ',
	                t('common.jk')
	              )
	            ),
	            buildings && _react2.default.createElement(
	              'div',
	              {
	                onClick: showLinkModal,
	                className: (0, _classnames2.default)(_Collection2.default.SendCollectionBtn, 'button-primary', 'button-primary--lg')
	              },
	              t('components.collection.sendCollection')
	            ),
	            _react2.default.createElement(
	              _Modal2.default,
	              {
	                handleClose: handleClose,
	                isOpen: showModal,
	                title: t('components.collection.sendCollection'),
	                contentStyle: {
	                  width: '583px',
	                  margin: 'auto'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.Modal },
	                _react2.default.createElement(_Select.Select, {
	                  style: { marginBottom: 16, width: 280 },
	                  id: 'lots',
	                  inputStyle: { fontSize: 15 },
	                  placeholder: '\u2014',
	                  value: values.lots,
	                  options: _helper.LotsValues,
	                  onChange: function onChange(value) {
	                    return handleChange('lots', value);
	                  },
	                  onClick: function onClick() {
	                    return handleTrackEvent({
	                      eventName: 'collectionShareDialogDropdownClick',
	                      eventContext: props.selection.name
	                    });
	                  }
	                }),
	                _react2.default.createElement(
	                  'p',
	                  { className: _Collection2.default.ModalDescription },
	                  '\u041A\u0430\u043A\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u0438\u0434\u043D\u044B \u043F\u043E \u0441\u0441\u044B\u043B\u043A\u0435'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collection2.default.ModalCheckboxes },
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.nameAddress,
	                    handle: function handle(value) {
	                      handleChange('nameAddress', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Название и адрес', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Название и адрес'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.description,
	                    handle: function handle(value) {
	                      handleChange('description', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Описание и преимущества', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Описание и преимущества'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.characteristics,
	                    handle: function handle(value) {
	                      handleChange('characteristics', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Общие характеристики', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Общие характеристики'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.communications,
	                    handle: function handle(value) {
	                      handleChange('communications', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Коммуникации', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Коммуникации'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.checkout,
	                    handle: function handle(value) {
	                      handleChange('checkout', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Оформление', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Оформление'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.payment,
	                    handle: function handle(value) {
	                      handleChange('payment', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Оплата', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Оплата'
	                  }),
	                  _react2.default.createElement(_Checkbox2.default, {
	                    checked: values.map,
	                    handle: function handle(value) {
	                      handleChange('map', value);
	                      handleTrackEvent({
	                        eventName: 'collectionShareDialogCheckboxesPick',
	                        eventContent: ['Карта', ' | ' + (value ? 'on' : 'off')],
	                        eventContext: props.selection.name
	                      });
	                    },
	                    text: 'Карта'
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: _Collection2.default.ModalDescription },
	                  t('components.collection.sendLink')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collection2.default.SendCollectionInputWrap },
	                  _react2.default.createElement('img', { src: _iconLinkDark2.default, alt: '' }),
	                  _react2.default.createElement('input', {
	                    readOnly: true,
	                    value: shareUrl,
	                    className: _Collection2.default.SendCollectionInput,
	                    onFocus: handleInputFocus
	                  })
	                ),
	                _react2.default.createElement(
	                  _reactClipboard2.default,
	                  {
	                    className: (0, _classnames2.default)(_Collection2.default.SendCollectionBtn, 'button-primary', 'button-primary--sm'),
	                    'data-clipboard-text': shareUrl,
	                    onClick: handleClipboardClick
	                  },
	                  t('components.collection.copy')
	                ),
	                showNotification && _react2.default.createElement(
	                  'span',
	                  { className: _Collection2.default.ModalNotification },
	                  _react2.default.createElement('img', { src: _checkIcon2.default, alt: t('components.collection.copied') }),
	                  ' ',
	                  t('components.collection.copied')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.CollectionItemsContainer },
	            _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.StatsContainer },
	              _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.StatsSessions, onClick: toggleDropdown, ref: dropdownRef },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Collection2.default.SelectedSession },
	                  function () {
	                    var found = dropdownOptions.find(function (opt) {
	                      return opt.value === selectedSession;
	                    });
	                    return found ? found.label : 'Все сессии';
	                  }(),
	                  _react2.default.createElement('img', { src: _arrowDropdown2.default, alt: 'arrow', className: !isOpen && _Collection2.default.ArrowDown })
	                ),
	                isOpen && _react2.default.createElement(
	                  'ul',
	                  {
	                    className: _Collection2.default.Options + ' ' + (dropdownOptions.length > 10 ? _Collection2.default.Scroll : '')
	                  },
	                  dropdownOptions.map(function (option) {
	                    return _react2.default.createElement(
	                      'li',
	                      {
	                        key: option.value,
	                        className: _Collection2.default.Option,
	                        onClick: function onClick(e) {
	                          e.stopPropagation();
	                          e.preventDefault();
	                          handleSelect(option.value);
	                        }
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        option.label
	                      ),
	                      option.value === selectedSession && _react2.default.createElement('img', { src: _checkGreen2.default, alt: 'check' })
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.StatsCard },
	                _react2.default.createElement(StatsInfoField, {
	                  title: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432',
	                  text: currentStats.total_views || '-'
	                }),
	                _react2.default.createElement(StatsInfoField, {
	                  title: '\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F',
	                  text: currentStats.total_time_spent ? formatTime(currentStats.total_time_spent) : '-'
	                }),
	                _react2.default.createElement(StatsInfoField, {
	                  title: '\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0434\u0430\u0442\u0430 \u0432\u0438\u0437\u0438\u0442\u0430',
	                  text: currentStats.last_visit_start && currentStats.last_visit_end ? formatVisitDates(currentStats.last_visit_start, currentStats.last_visit_end, t) : '-'
	                })
	              )
	            ),
	            buildings && buildings.length ? buildings.length ? _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.CollectionItems },
	              buildings && buildings.map(function (building, i) {
	                return _react2.default.createElement(_CollectionItem2.default, {
	                  building: building,
	                  key: building.id + (building.comment || i),
	                  sessionId: selectedSession === 'total' ? null : selectedSession
	                });
	              })
	            ) : null : _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.NotFoundBlock },
	              _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.NotFoundMain },
	                _react2.default.createElement(
	                  'p',
	                  { className: _Collection2.default.NotFoundTitle },
	                  t('components.collection.emptyCollection')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: _Collection2.default.NotFoundText },
	                  t('components.collection.description')
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    to: '/',
	                    className: (0, _classnames2.default)(_Collection2.default.NotFoundBtn, 'button-primary', 'button-primary--md'),
	                    onClick: function onClick() {
	                      return handleTrackEvent({
	                        eventName: 'collectionEmptyCardButtonClick',
	                        eventContext: props.selection.name
	                      });
	                    }
	                  },
	                  t('components.collection.goToList')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.NotFoundImage },
	                _react2.default.createElement('img', { src: _nothingfound2x2.default, alt: 'nothing found' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.collection, {
	    collections: state.collections.data,
	    profile: state.profile
	  });
	}, { loadCollection: _collections.loadCollection, switchInfoAccess: _collections.switchInfoAccess, setPopUp: _environment.setPopUp })((0, _reactI18next.withTranslation)()(Collection));

/***/ }),
/* 975 */
[2399, 974],
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collection = __webpack_require__(1382);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _no_photo_150px = __webpack_require__(1590);
	
	var _no_photo_150px2 = _interopRequireDefault(_no_photo_150px);
	
	var _arrowBlue = __webpack_require__(1520);
	
	var _arrowBlue2 = _interopRequireDefault(_arrowBlue);
	
	var _collections = __webpack_require__(49);
	
	var _Config = __webpack_require__(16);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatTimeSpent = function formatTimeSpent(seconds) {
	  var hours = Math.floor(seconds / 3600);
	  var minutes = Math.floor(seconds % 3600 / 60);
	  var remainingSeconds = seconds % 60;
	
	  var parts = [];
	  if (hours > 0) parts.push(hours + ' \u0447');
	  if (minutes > 0) parts.push(minutes + ' \u043C\u0438\u043D');
	  if (remainingSeconds > 0) parts.push(remainingSeconds + ' \u0441\u0435\u043A');
	
	  return parts.join(' ');
	};
	
	var StatsInfoField = function StatsInfoField(_ref) {
	  var title = _ref.title,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'div',
	    { className: _Collection2.default.StatsInfoField },
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.StatsInfoFieldTitle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.SendCollectionBtnText },
	      text
	    )
	  );
	};
	
	var BuildingStats = function BuildingStats(_ref2) {
	  var stats = _ref2.stats;
	
	  if (!stats) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Collection2.default.Stats },
	    _react2.default.createElement(StatsInfoField, { title: '\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u044B', text: stats.views || '-' }),
	    _react2.default.createElement(StatsInfoField, { title: '\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F', text: formatTimeSpent(stats.time_spent) }),
	    _react2.default.createElement(StatsInfoField, { title: '\u041D\u0430\u0436\u0430\u043B\u0438 \u043D\u0430 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438', text: stats.photo_clicks || '-' }),
	    _react2.default.createElement(StatsInfoField, { title: '\u041D\u0430\u0436\u0430\u043B\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443', text: stats.map_clicks || '-' }),
	    _react2.default.createElement(StatsInfoField, { title: '\u041D\u0430\u0436\u0430\u043B\u0438 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440', text: stats.phone_clicks || '-' })
	  );
	};
	var LotItem = function LotItem(_ref3) {
	  var lot = _ref3.lot;
	  return _react2.default.createElement(
	    'div',
	    { className: _Collection2.default.LotItem },
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.LotMainInfo },
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotMainTop },
	        _react2.default.createElement(
	          'div',
	          { className: _Collection2.default.LotArea },
	          lot.area,
	          ' \u043C\xB2'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Collection2.default.LotNumber },
	          '\u041B\u041E\u0422 ',
	          lot.number
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotMainBottom },
	        _react2.default.createElement('div', { className: _Collection2.default.LotMainBottomDot }),
	        _react2.default.createElement(
	          'div',
	          null,
	          '\u041A\u043E\u0440\u043F\u0443\u0441 ',
	          lot.house_body.name,
	          ', \u0441\u0435\u043A\u0446\u0438\u044F ',
	          lot.house_body.section.name
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.LotRow },
	      lot.row,
	      ' \u044D\u0442\u0430\u0436'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.LotPrice },
	      (0, _utils.formatNumber)(lot.price),
	      ' \u20BD'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.LotClicks },
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotClicksTitle },
	        '\u041D\u0430\u0436\u0430\u043B\u0438 \u043D\u0430 \u043B\u043E\u0442'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotClicksValue },
	        lot.views
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Collection2.default.LotClicks },
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotClicksTitle },
	        '\u041D\u0430\u0436\u0430\u043B\u0438 \u043D\u0430 \u043B\u0430\u0439\u043A'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Collection2.default.LotClicksValue },
	        lot.likes
	      )
	    )
	  );
	};
	
	var Collection = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props));
	
	    _this.handleChange = function (e) {
	      if (e.target.value.length > 2) {
	        _this.debouncedTrackEventInput();
	      }
	      _this.setState({
	        comment: e.target.value
	      });
	    };
	
	    _this.getInputRef = function (ref) {
	      _this.input = ref;
	    };
	
	    _this.handleEditClick = function () {
	      _tracker2.default.sendEvent('Web_Selections_Edit_Comment');
	      _this.setState({
	        editing: true,
	        comment: _this.props.building.comment
	      });
	      _this.input.focus();
	    };
	
	    _this.handleCancleClick = function () {
	      _this.handleTrackEvent({
	        eventName: 'collectionListItemCommentButtonsClick',
	        eventLabel: 'otmenit'
	      });
	
	      _this.setState({
	        editing: false,
	        comment: _this.props.building.comment
	      });
	    };
	
	    _this.handleCommentClick = function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	      _tracker2.default.sendEvent('Web_Selections_Add_Comment');
	      _this.setState({
	        editing: !_this.state.editing
	      });
	      _this.input.focus();
	    };
	
	    _this.handleCommentSubmit = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          addComment = _this$props.addComment,
	          referal = _this$props.referal,
	          building = _this$props.building;
	
	      addComment({
	        referal: referal,
	        buildingId: building.id,
	        comment: _this.state.comment
	      });
	      _this.setState({
	        editing: false
	      });
	    };
	
	    _this.handleRemoveClick = function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	      var _this$props2 = _this.props,
	          removeFromCollection = _this$props2.removeFromCollection,
	          referal = _this$props2.referal,
	          building = _this$props2.building,
	          collectionName = _this$props2.collectionName,
	          profile = _this$props2.profile;
	
	      _tracker2.default.sendEvent('Web_Selections_Delete_Comment', {
	        id: building.id,
	        name: building.title
	      });
	
	      _this.handleTrackEvent({
	        eventName: 'collectionListItemButtonsClick',
	        eventLabel: 'udalit'
	      });
	
	      removeFromCollection({
	        referal: referal,
	        buildingId: building.id
	      }, {
	        collectionName: collectionName,
	        buildingName: building.title,
	        data: building,
	        profileId: profile.id
	      });
	    };
	
	    _this.handleTrackEvent = function (_ref4) {
	      var eventName = _ref4.eventName,
	          eventLabel = _ref4.eventLabel;
	      var _this$props3 = _this.props,
	          profile = _this$props3.profile,
	          collectionName = _this$props3.collectionName,
	          building = _this$props3.building;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContext: collectionName,
	        productType: building.type_id === 1 ? 'zhk' : 'kp_i_th',
	        productName: building.title,
	        productID: building.id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.fetchLotsStats = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.lotsOffset;
	        var building, lotsStats, response, newLots;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                building = _this.props.building;
	                lotsStats = _this.state.lotsStats;
	
	                if (!_this.state.lotsLoading) {
	                  _context.next = 4;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 4:
	
	                _this.setState({ lotsLoading: true });
	
	                _context.prev = 5;
	                _context.next = 8;
	                return _this.props.loadCollectionBuildingLots({
	                  building_id: building.id,
	                  session_id: _this.props.sessionId || null,
	                  limit: 10,
	                  offset: offset
	                });
	
	              case 8:
	                response = _context.sent;
	
	
	                if (response && response.data && response.data.lots) {
	                  newLots = response.data.lots;
	
	                  _this.setState({
	                    lotsStats: append ? [].concat(_toConsumableArray(lotsStats), _toConsumableArray(newLots)) : newLots,
	                    lotsOffset: offset + newLots.length,
	                    lotsHasMore: newLots.length === 10,
	                    lotsLoading: false
	                  });
	                } else {
	                  _this.setState({ lotsHasMore: false, lotsLoading: false });
	                }
	                _context.next = 16;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](5);
	
	                console.error('Ошибка при загрузке лотов:', _context.t0);
	                _this.setState({ lotsLoading: false });
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[5, 12]]);
	      }));
	
	      return function () {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.handleLotsScroll = function (e) {
	      var _this$state = _this.state,
	          lotsHasMore = _this$state.lotsHasMore,
	          lotsLoading = _this$state.lotsLoading;
	
	      var bottomReached = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
	
	      if (bottomReached && lotsHasMore && !lotsLoading) {
	        _this.fetchLotsStats(true);
	      }
	    };
	
	    _this.getCurrentSessionStats = function () {
	      var _this$props4 = _this.props,
	          building = _this$props4.building,
	          sessionId = _this$props4.sessionId;
	
	
	      if (!building.sessions) {
	        return null;
	      }
	
	      if (!sessionId || sessionId === 'total') {
	        return building.sessions.total || null;
	      }
	
	      return building.sessions.items && building.sessions.items.find(function (item) {
	        return item.session_uuid === sessionId;
	      }) || null;
	    };
	
	    _this.prepareStatsForBuilding = function () {
	      var sessionId = _this.props.sessionId;
	
	      var stats = _this.getCurrentSessionStats();
	
	      if (!stats) {
	        return {};
	      }
	
	      var isTotalSession = !sessionId || sessionId === 'total';
	
	      return {
	        views: isTotalSession ? stats.total_views : stats.views,
	        time_spent: isTotalSession ? stats.total_time_spent : stats.time_spent,
	        photo_clicks: isTotalSession ? stats.total_photo_clicks : stats.photo_clicks,
	        map_clicks: isTotalSession ? stats.total_map_clicks : stats.map_clicks,
	        phone_clicks: isTotalSession ? stats.total_phone_clicks : stats.phone_clicks
	      };
	    };
	
	    _this.resetLots = function () {
	      _this.setState({
	        lotsOffset: 0,
	        lotsStats: [],
	        lotsHasMore: true,
	        lotsLoading: false
	      });
	    };
	
	    _this.toggleShowLots = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        return {
	          showLots: !prevState.showLots
	        };
	      });
	    };
	
	    _this.state = {
	      editing: false,
	      comment: props.building.comment,
	      lotsStats: [],
	      showLots: false,
	      lotsOffset: 0,
	      lotsHasMore: true,
	      lotsLoading: false
	    };
	
	    _this.debouncedTrackEventInput = (0, _lodash2.default)(function () {
	      return _this.handleTrackEvent({
	        eventName: 'collectionListItemCommentInput',
	        eventLabel: 'dobavit_kommentarii'
	      });
	    }, 3000);
	    return _this;
	  }
	
	  _createClass(Collection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchLotsStats();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.sessionId !== this.props.sessionId || prevProps.building.id !== this.props.building.id) {
	        this.resetLots();
	        this.fetchLotsStats(false, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var _props$building = this.props.building,
	          title = _props$building.title,
	          address = _props$building.address,
	          comment = _props$building.comment,
	          image = _props$building.image,
	          buildingId = _props$building.id,
	          isFinished = _props$building.construction_finished,
	          quater = _props$building.construction_ending,
	          year = _props$building.year_built,
	          status = _props$building.status;
	      var _state = this.state,
	          showLots = _state.showLots,
	          lotsStats = _state.lotsStats;
	
	
	      var imageId = image && image.id;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_Collection2.default.ItemWrap, _defineProperty({}, _Collection2.default.ItemActive, comment || this.state.comment || this.state.editing))
	        },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: '/building/' + buildingId,
	            className: _Collection2.default.Item,
	            onClick: function onClick() {
	              _this3.handleTrackEvent({
	                eventName: 'collectionListItemButtonsClick',
	                eventLabel: 'obyekt'
	              });
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Collection2.default.ItemImage, _defineProperty({}, _Collection2.default.ItemImageNoImage, !image)) },
	            image ? _react2.default.createElement('img', { src: _Config.ROOT_URL + '/image?id=' + imageId + '&size=medium', alt: '' }) : _react2.default.createElement('img', { src: _no_photo_150px2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _Collection2.default.ItemTitle },
	            _react2.default.createElement(
	              'span',
	              null,
	              title
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: _Collection2.default.LotTag },
	              t('components.collectionItem.lot', { buildingId: buildingId })
	            ),
	            status == 3 ? _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(_Collection2.default.ItemStatus, _Collection2.default.AlmostFinished) },
	              t('components.collectionItem.almostFinished')
	            ) : _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(_Collection2.default.ItemStatus, _defineProperty({}, _Collection2.default.Finished, isFinished)) },
	              isFinished ? t('components.collectionItem.finished') : quater + ' / ' + (year || '')
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _Collection2.default.ItemAddress },
	            _react2.default.createElement(
	              'span',
	              null,
	              address
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.ItemCommentButton, onClick: this.handleCommentClick },
	            _react2.default.createElement(
	              'span',
	              {
	                className: _Collection2.default.TabletHidden,
	                onClick: function onClick() {
	                  _this3.handleTrackEvent({
	                    eventName: 'collectionListItemButtonsClick',
	                    eventLabel: 'dobavit_kommentarii'
	                  });
	                }
	              },
	              t('components.collectionItem.addComment')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Collection2.default.TabletOnly },
	              t('components.collectionItem.comment')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.ItemDelete, onClick: this.handleRemoveClick },
	            t('components.collectionItem.delete')
	          ),
	          _react2.default.createElement(BuildingStats, { stats: this.prepareStatsForBuilding() }),
	          lotsStats.length ? _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.LotsList },
	            _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.LotsTitle, onClick: this.toggleShowLots },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043B\u043E\u0442\u044B'
	              ),
	              _react2.default.createElement('img', { src: _arrowBlue2.default, alt: 'arrow', className: showLots && _Collection2.default.Arrow })
	            ),
	            showLots && _react2.default.createElement(
	              'div',
	              {
	                className: _Collection2.default.LotList,
	                style: { maxHeight: '400px', overflowY: 'auto' },
	                onScroll: this.handleLotsScroll
	              },
	              lotsStats.map(function (lot) {
	                return _react2.default.createElement(LotItem, { key: lot.id, lot: lot });
	              }),
	              this.state.lotsLoading && _react2.default.createElement(
	                'div',
	                { className: _Collection2.default.LotsLoading },
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	              )
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: _Collection2.default.ItemComment, onSubmit: this.handleCommentSubmit },
	          _react2.default.createElement('input', {
	            placeholder: this.state.editing ? t('components.collectionItem.writeComment') : '',
	            value: this.state.comment || '',
	            className: _Collection2.default.CommentInput,
	            onChange: this.handleChange,
	            ref: this.getInputRef
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _Collection2.default.CommentButtons },
	            this.state.editing ? _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.CommentButton, onClick: this.handleCancleClick },
	              t('components.collectionItem.cancel')
	            ) : _react2.default.createElement(
	              'div',
	              { className: _Collection2.default.CommentButton, onClick: this.handleEditClick },
	              t('components.collectionItem.edit')
	            ),
	            this.state.editing && this.state.comment !== comment && _react2.default.createElement(
	              'button',
	              {
	                className: _Collection2.default.CommentButton,
	                onClick: function onClick() {
	                  _this3.handleTrackEvent({
	                    eventName: 'collectionListItemCommentButtonsClick',
	                    eventLabel: 'sohranit'
	                  });
	                }
	              },
	              t('components.collectionItem.save')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Collection;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    referal: state.collection.selection.referal,
	    collectionName: state.collection.selection.name,
	    profile: state.profile
	  };
	}, { removeFromCollection: _collections.removeFromCollection, addComment: _collections.addComment, loadCollectionBuildingLots: _collections.loadCollectionBuildingLots })((0, _reactI18next.withTranslation)()(Collection));

/***/ }),
/* 977 */
[2399, 976],
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collections = __webpack_require__(1383);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _CollectionsItem = __webpack_require__(981);
	
	var _CollectionsItem2 = _interopRequireDefault(_CollectionsItem);
	
	var _CollectionsPopup = __webpack_require__(983);
	
	var _CollectionsPopup2 = _interopRequireDefault(_CollectionsPopup);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _collections = __webpack_require__(49);
	
	var _nothingfound2x = __webpack_require__(351);
	
	var _nothingfound2x2 = _interopRequireDefault(_nothingfound2x);
	
	var _iconSearchDark = __webpack_require__(1554);
	
	var _iconSearchDark2 = _interopRequireDefault(_iconSearchDark);
	
	var _utils = __webpack_require__(12);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collections = (_dec = (0, _withValidTrafic2.default)(), _dec(_class = function (_Component) {
	  _inherits(Collections, _Component);
	
	  function Collections(props) {
	    _classCallCheck(this, Collections);
	
	    var _this = _possibleConstructorReturn(this, (Collections.__proto__ || Object.getPrototypeOf(Collections)).call(this, props));
	
	    _this.setPopUp = function () {
	      var _this$props = _this.props,
	          setPopUp = _this$props.setPopUp,
	          profile = _this$props.profile;
	
	      _tracker2.default.sendEvent('Web_Current_Add_To_Collection');
	
	      _this.handleTrackEvent({
	        eventName: 'collectionsCreateButtonClick'
	      });
	
	      setPopUp(_react2.default.createElement(_CollectionsPopup2.default, { profile: profile }), {
	        // className: styles.NewsPopup,
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        onClose: function onClose() {
	          return _this.handleTrackEvent({
	            eventName: 'collectionsCreateDialogButtonsClick',
	            eventLabel: 'zakryt'
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        newCollectionName: e.target.value
	      });
	    };
	
	    _this.handleAddCollectionClick = function (e) {
	      e.preventDefault();
	      _tracker2.default.sendEvent('Web_Current_Add_To_Collection');
	      _this.props.createCollection({
	        name: _this.state.newCollectionName
	        // userUid: this.props.userUid,
	      });
	      _this.state.newCollectionName = '';
	      _this.props.setPopUp();
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel;
	      var profile = _this.props.profile;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      newCollectionName: ''
	    };
	    return _this;
	  }
	
	  _createClass(Collections, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      this.props.loadCollections({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          collections = _props.collections,
	          t = _props.t,
	          profile = _props.profile;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            t('components.collections.title')
	          )
	        ),
	        collections ? _react2.default.createElement(
	          'div',
	          null,
	          Object.values(collections).length ? _react2.default.createElement(
	            'div',
	            { className: _Collections2.default.CollectionsWrap },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Collections2.default.Collections, className) },
	              _react2.default.createElement(
	                'div',
	                { className: _Collections2.default.Container },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collections2.default.TitleBlock },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _Collections2.default.Title },
	                    t('components.collections.myCollections'),
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Collections2.default.CollectionsCount },
	                      Object.values(collections).length,
	                      ' ',
	                      (0, _utils.pluralize)(Object.values(collections).length, t('components.collections.collection1'), t('components.collections.collection2'), t('components.collections.collection3'))
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Collections2.default.CollectionsActions },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: (0, _classnames2.default)(_Collections2.default.CreateButton, 'button-primary', 'button-primary--lg'),
	                        onClick: this.setPopUp
	                      },
	                      t('components.collections.create')
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collections2.default.List },
	                  collections && Object.values(collections).map(function (collection) {
	                    return _react2.default.createElement(_CollectionsItem2.default, _extends({}, collection, {
	                      key: collection.referal,
	                      profile: profile
	                    }));
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	          ) : _react2.default.createElement(
	            'div',
	            { className: _Collections2.default.CollectionsWrap },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Collections2.default.Collections, _Collections2.default.NoCollections, className) },
	              _react2.default.createElement(
	                'div',
	                { className: _Collections2.default.Container },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collections2.default.TitleBlock },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _Collections2.default.Title },
	                    t('components.collections.myCollections')
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Collections2.default.NotFoundBlock },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Collections2.default.NotFoundMain },
	                    _react2.default.createElement(
	                      'p',
	                      { className: _Collections2.default.NotFoundTitle },
	                      t('components.collections.noCollections')
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: _Collections2.default.NotFoundText },
	                      t('components.collections.share')
	                    ),
	                    _react2.default.createElement(
	                      'form',
	                      {
	                        onSubmit: this.handleAddCollectionClick,
	                        className: _Collections2.default.CreateCollection
	                      },
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        className: _Collections2.default.CreateCollectionInput,
	                        placeholder: t('components.collections.enterName'),
	                        onChange: this.handleChange
	                      }),
	                      _react2.default.createElement('input', {
	                        type: 'submit',
	                        className: (0, _classnames2.default)(_Collections2.default.CreateCollectionBtn, 'button-primary', 'button-primary--md'),
	                        disabled: this.state.newCollectionName === '',
	                        value: t('components.collections.create')
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Collections2.default.NotFoundImage },
	                    _react2.default.createElement('img', { src: _nothingfound2x2.default, alt: 'nothing found' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: _Collections2.default.Wireframe },
	          _react2.default.createElement(
	            'div',
	            { className: _Collections2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _Collections2.default.TitleBlock },
	              _react2.default.createElement(
	                'p',
	                { className: _Collections2.default.Title },
	                t('components.collections.myCollections')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Collections2.default.WireframeLoaderWrap },
	              _react2.default.createElement('div', { className: _Collections2.default.WireframeLoader })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Collections;
	}(_react.Component)) || _class);
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    collections: state.collections.data,
	    userUid: state.profile.hash,
	    profile: state.profile
	  };
	}, { setPopUp: _environment.setPopUp, loadCollections: _collections.loadCollections, createCollection: _collections.createCollection })((0, _reactI18next.withTranslation)()(Collections));

/***/ }),
/* 979 */
[2395, 978],
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _SingleInputForm = __webpack_require__(1112);
	
	var _SingleInputForm2 = _interopRequireDefault(_SingleInputForm);
	
	var _iconPencil = __webpack_require__(1549);
	
	var _iconPencil2 = _interopRequireDefault(_iconPencil);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1384);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _no_buildings_90px = __webpack_require__(1589);
	
	var _no_buildings_90px2 = _interopRequireDefault(_no_buildings_90px);
	
	var _no_photo_small = __webpack_require__(1592);
	
	var _no_photo_small2 = _interopRequireDefault(_no_photo_small);
	
	var _reactRedux = __webpack_require__(5);
	
	var _collections = __webpack_require__(49);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Config = __webpack_require__(16);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collections = function (_Component) {
	  _inherits(Collections, _Component);
	
	  function Collections(props) {
	    _classCallCheck(this, Collections);
	
	    var _this = _possibleConstructorReturn(this, (Collections.__proto__ || Object.getPrototypeOf(Collections)).call(this, props));
	
	    _this.handleDupClick = function () {
	      _tracker2.default.sendEvent('Web_Selections_Duplicate');
	      _this.props.dupCollection({
	        referal: _this.props.referal,
	        userUid: _this.props.userUid
	      });
	    };
	
	    _this.handleDeleteClick = function () {
	      _tracker2.default.sendEvent('Web_Selections_Delete');
	
	      _this.handleTrackEvent({
	        eventName: 'collectionsDeleteDialogButtonsClick',
	        eventLabel: 'udalit'
	      });
	
	      _this.props.deleteCollection({
	        referal: _this.props.referal,
	        userUid: _this.props.userUid
	      }, _this.props.profile.id);
	    };
	
	    _this.handleRename = function (name) {
	      _this.props.renameCollection({
	        referal: _this.props.referal,
	        userUid: _this.props.userUid,
	        name: name
	      });
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel,
	          eventContent = _ref.eventContent;
	      var profile = _this.props.profile;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        eventContent: eventContent || '',
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Collections, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var name = this.props.name;
	
	      this.handleTrackEvent({
	        eventName: 'collectionsListItemShow',
	        eventContent: name
	      });
	    }
	  }, {
	    key: 'renderNoPhotos',
	    value: function renderNoPhotos() {
	      var _props$total = this.props.total,
	          total = _props$total === undefined ? 0 : _props$total;
	
	
	      if (!total) {
	        return _react2.default.createElement('img', { src: _no_buildings_90px2.default, alt: '' });
	      }
	
	      return Array(total).fill(undefined).map(function (value, index) {
	        return _react2.default.createElement(
	          'span',
	          { className: _styles2.default.ItemImage, style: { background: '#fff' }, key: index },
	          _react2.default.createElement('img', { className: _styles2.default.ItemImageNoPhoto, src: _no_photo_small2.default, alt: '' })
	        );
	      }).slice(0, 4);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          referal = _props.referal,
	          _props$total2 = _props.total,
	          total = _props$total2 === undefined ? 0 : _props$total2,
	          photos = _props.photos,
	          t = _props.t,
	          profile = _props.profile;
	
	
	      var hasPhotos = photos && photos.length;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: _styles2.default.ListItem,
	          key: referal,
	          onClick: function onClick(e) {
	            _reactTooltip2.default.hide(_this2.pancelEditEl);
	            if (e.defaultPrevented) {
	              _this2.handleTrackEvent({
	                eventName: 'collectionsListItemButtonsClick',
	                eventLabel: 'podborka'
	              });
	            }
	          }
	        },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: '/collection/manage/' + referal,
	            className: _styles2.default.ItemPhotos
	          },
	          hasPhotos ? photos.slice(0, 4).map(function (_ref2) {
	            var id = _ref2.id;
	            return _react2.default.createElement(
	              'span',
	              {
	                className: _styles2.default.ItemImage,
	                key: id
	              },
	              _react2.default.createElement('img', { src: _Config.ROOT_URL + '/image?id=' + id + '&size=small', alt: '' })
	            );
	          }) : this.renderNoPhotos()
	        ),
	        _react2.default.createElement(_reactRouterDom.Link, { to: '/collection/manage/' + referal, className: _styles2.default.MainLink }),
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.ItemMain },
	          _react2.default.createElement(
	            _SingleInputForm2.default,
	            {
	              className: _styles2.default.ItemName,
	              value: name,
	              onSubmit: this.handleRename,
	              linkTo: '/collection/manage/' + referal,
	              trackEventData: {
	                eventName: 'collectionsListItemRenameInput',
	                eventContent: name,
	                user_id: profile.id
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              {
	                className: _styles2.default.NameEdit,
	                'data-tip': t('components.collectionsItem.rename'),
	                'data-for': 'global',
	                ref: function ref(pancelEditEl) {
	                  _this2.pancelEditEl = pancelEditEl;
	                },
	                onMouseEnter: function onMouseEnter() {
	                  return _reactTooltip2.default.show(_this2.pancelEditEl);
	                },
	                onMouseLeave: function onMouseLeave() {
	                  return _reactTooltip2.default.hide(_this2.pancelEditEl);
	                },
	                onClick: function onClick() {
	                  _reactTooltip2.default.hide(_this2.pancelEditEl);
	                  _tracker2.default.sendEvent('Web_Selections_Edit');
	                  _this2.handleTrackEvent({
	                    eventName: 'collectionsListItemButtonsClick',
	                    eventLabel: 'pereimenovat'
	                  });
	                }
	              },
	              _react2.default.createElement('img', { alt: 'icon', src: _iconPencil2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.ItemDescrip },
	            t('components.collectionsItem.description', { total: total })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ItemHover },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)(_styles2.default.HoverIcon, _styles2.default.HoverIconDuplicate),
	              onClick: function onClick() {
	                _this2.handleDupClick(referal);
	                _this2.handleTrackEvent({
	                  eventName: 'collectionsListItemButtonsClick',
	                  eventLabel: 'dublirovat'
	                });
	              }
	            },
	            t('components.collectionsItem.dup')
	          ),
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)(_styles2.default.HoverIcon, _styles2.default.HoverIconDelete),
	              onClick: function onClick() {
	                _this2.setState({ showModal: true });
	                _this2.handleTrackEvent({
	                  eventName: 'collectionsListItemButtonsClick',
	                  eventLabel: 'udalit'
	                });
	              }
	            },
	            t('components.collectionsItem.del')
	          )
	        ),
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            title: t('components.collectionsItem.deleteCollection'),
	            isOpen: this.state.showModal,
	            handleClose: function handleClose() {
	              return _this2.setState({ showModal: false }, function () {
	                _this2.handleTrackEvent({
	                  eventName: 'collectionsDeleteDialogButtonsClick',
	                  eventLabel: 'zakryt'
	                });
	              });
	            },
	            contentStyle: {
	              minWidth: '736px',
	              minHeight: '120px'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Dialog },
	            t('components.collectionsItem.sure', { name: name }),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.Buttons },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: (0, _classnames2.default)(_styles2.default.DeleteButton, 'button-primary', 'button-primary--md'),
	                  onClick: function onClick() {
	                    return _this2.handleDeleteClick(referal);
	                  }
	                },
	                t('components.collectionsItem.del')
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: _styles2.default.ButtonCancel,
	                  onClick: function onClick() {
	                    return _this2.setState({ showModal: false }, function () {
	                      _this2.handleTrackEvent({
	                        eventName: 'collectionsDeleteDialogButtonsClick',
	                        eventLabel: 'otmena'
	                      });
	                    });
	                  }
	                },
	                t('components.collectionsItem.cancel')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Collections;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    userUid: state.profile.hash,
	    collections: state.collections.data
	  };
	}, { dupCollection: _collections.dupCollection, deleteCollection: _collections.deleteCollection, renameCollection: _collections.renameCollection })((0, _reactI18next.withTranslation)()(Collections));

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CollectionsItem = __webpack_require__(980);
	
	var _CollectionsItem2 = _interopRequireDefault(_CollectionsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CollectionsItem2.default;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1385);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _collections = __webpack_require__(49);
	
	var _reactI18next = __webpack_require__(4);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionsPopup = function (_Component) {
	  _inherits(CollectionsPopup, _Component);
	
	  function CollectionsPopup(props) {
	    _classCallCheck(this, CollectionsPopup);
	
	    var _this = _possibleConstructorReturn(this, (CollectionsPopup.__proto__ || Object.getPrototypeOf(CollectionsPopup)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        newCollectionName: e.target.value
	      });
	
	      if (e.target.value.length >= 2) {
	        _this.debouncedTrackEvent();
	      }
	    };
	
	    _this.handleAddCollectionClick = function (e) {
	      e.preventDefault();
	      _this.props.createCollection({
	        // userUid: this.props.userUid,
	        name: _this.state.newCollectionName
	      });
	      _this.props.setPopUp();
	    };
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel;
	      var profile = _this.props.profile;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      newCollectionName: ''
	    };
	
	    _this.debouncedTrackEvent = (0, _lodash2.default)(function () {
	      return _this.handleTrackEvent({
	        eventName: 'collectionsCreateDialogInput'
	      });
	    }, 3000);
	    return _this;
	  }
	
	  _createClass(CollectionsPopup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.PopUpOuter },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.PopUpInner },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.PopupContent },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.PopupTitle },
	              t('components.collectionsPopup.title')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.PopupBody },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.CreateCollectionForm },
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: this.handleAddCollectionClick },
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    className: _styles2.default.CreateCollectionInput,
	                    placeholder: t('components.collectionsPopup.enter'),
	                    onChange: this.handleChange
	                  }),
	                  _react2.default.createElement('input', {
	                    type: 'submit',
	                    className: (0, _classnames2.default)(_styles2.default.CreateCollectionButton, 'button-primary', 'button-primary--md'),
	                    disabled: this.state.newCollectionName === '',
	                    value: t('components.collectionsPopup.add'),
	                    onClick: function onClick() {
	                      return _this2.handleTrackEvent({
	                        eventName: 'collectionsCreateDialogButtonsClick',
	                        eventLabel: 'sohranit'
	                      });
	                    }
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollectionsPopup;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    userUid: state.profile.hash
	  };
	}, { setPopUp: _environment.setPopUp, createCollection: _collections.createCollection })((0, _reactI18next.withTranslation)()(CollectionsPopup));

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CollectionsPopup = __webpack_require__(982);
	
	var _CollectionsPopup2 = _interopRequireDefault(_CollectionsPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CollectionsPopup2.default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buildings = __webpack_require__(474);
	
	var _Buildings2 = _interopRequireDefault(_Buildings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cotteges(props) {
	  return _react2.default.createElement(_Buildings2.default, _extends({}, props, { isCottegesPage: true }));
	}
	
	exports.default = Cotteges;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cotteges = __webpack_require__(984);
	
	var _Cotteges2 = _interopRequireDefault(_Cotteges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cotteges2.default;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1386);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _BuildingCard = __webpack_require__(310);
	
	var _BuildingCard2 = _interopRequireDefault(_BuildingCard);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(124);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _favorites = __webpack_require__(160);
	
	var _nothingfound2x = __webpack_require__(351);
	
	var _nothingfound2x2 = _interopRequireDefault(_nothingfound2x);
	
	var _utils = __webpack_require__(12);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Favorites = (_dec = (0, _withValidTrafic2.default)(), _dec(_class = function (_Component) {
	  _inherits(Favorites, _Component);
	
	  function Favorites() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Favorites);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Favorites.__proto__ || Object.getPrototypeOf(Favorites)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
	      _this.setState({
	        newCollectionName: e.target.value
	      });
	    }, _this.handleDeleteClick = function (building) {
	      var profile = _this.props.profile;
	      var id = building.id,
	          title = building.title;
	
	      _this.props.removeFromFavorites({
	        buildingId: id,
	        userUid: _this.props.userUid
	      }, {
	        buildingName: title,
	        data: building,
	        profileId: profile.id,
	        eventLocation: 'favorites'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Favorites, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.loadFavorites({
	        userUid: this.props.userUid
	      });
	
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          favorites = _props.favorites,
	          t = _props.t,
	          location = _props.location,
	          profile = _props.profile;
	
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            t('components.favorites.title')
	          )
	        ),
	        favorites ? _react2.default.createElement(
	          'div',
	          null,
	          favorites.length ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_styles2.default.Collections, className) },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.Container },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.TitleBlock },
	                _react2.default.createElement(
	                  'p',
	                  { className: _styles2.default.Title },
	                  t('components.favorites.titleBlock')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _styles2.default.FavoritesCount },
	                  favorites.length,
	                  ' ',
	                  (0, _utils.pluralize)(favorites.length, t('components.favorites.titleBlock'), t('components.favorites.titleBlock'), t('components.favorites.titleBlock'))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.List },
	                favorites && favorites.map(function (favorite) {
	                  return _react2.default.createElement(_BuildingCard2.default, _extends({}, favorite, {
	                    key: favorite.id,
	                    className: _styles2.default.BuildingCard,
	                    deleteText: t('components.favorites.remove'),
	                    handleDeleteClick: _this2.handleDeleteClick,
	                    withLabels: true,
	                    location: location,
	                    profile: profile
	                  }));
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_styles2.default.Collections, className) },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.Container },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.TitleBlock },
	                _react2.default.createElement(
	                  'p',
	                  { className: _styles2.default.Title },
	                  t('components.favorites.titleBlock')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.NotFoundBlock },
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.NotFoundMain },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.NotFoundTitle },
	                    t('components.favorites.empty')
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.NotFoundText },
	                    t('components.favorites.notFound')
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.NotFoundImage },
	                  _react2.default.createElement('img', { src: _nothingfound2x2.default, alt: 'nothing found' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Footer2.default, null)
	        ) : _react2.default.createElement(
	          'div',
	          { className: _styles2.default.Wireframe },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.TitleBlock },
	              _react2.default.createElement(
	                'p',
	                { className: _styles2.default.Title },
	                t('components.favorites.titleBlock')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.WireframeLoaderWrap },
	              _react2.default.createElement('div', { className: _styles2.default.WireframeLoader })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Favorites;
	}(_react.Component)) || _class);
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    userUid: state.profile.hash,
	    favorites: state.favorites.buildings
	  };
	}, { setPopUp: _environment.setPopUp, loadFavorites: _favorites.loadFavorites, removeFromFavorites: _favorites.removeFromFavorites })((0, _reactI18next.withTranslation)()(Favorites));

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Favorites = __webpack_require__(986);
	
	var _Favorites2 = _interopRequireDefault(_Favorites);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Favorites2.default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dropdown = __webpack_require__(216);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Menu = __webpack_require__(217);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _styles = __webpack_require__(171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filters = function (_Component) {
	  _inherits(Filters, _Component);
	
	  function Filters() {
	    _classCallCheck(this, Filters);
	
	    return _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).apply(this, arguments));
	  }
	
	  _createClass(Filters, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          priceFrom = _props.priceFrom,
	          priceTo = _props.priceTo,
	          areaFrom = _props.areaFrom,
	          areaTo = _props.areaTo,
	          handleChange = _props.handleChange,
	          handleDropdownClick = _props.handleDropdownClick,
	          interiors = _props.interiors,
	          interior = _props.interior,
	          t = _props.t,
	          currency = _props.currency;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.FlatsFilters },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.FlatsFilter },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'price-from' },
	            t('components.flatsList.filters.price', { currency: currency })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatsFilterInputs },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.InputWrap },
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'price-from',
	                name: 'priceFrom',
	                value: priceFrom || '',
	                className: (0, _classnames2.default)(_styles2.default.Input, _styles2.default.InputPrice, _defineProperty({}, _styles2.default.Filled, priceFrom)),
	                onChange: handleChange
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Prefix },
	                t('components.flatsList.filters.from')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.InputWrap },
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'priceTo',
	                value: priceTo || '',
	                className: (0, _classnames2.default)(_styles2.default.Input, _styles2.default.InputPrice, _defineProperty({}, _styles2.default.Filled, priceTo)),
	                onChange: handleChange
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Prefix },
	                t('components.flatsList.filters.to')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.FlatsFilter },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'area-from' },
	            t('components.flatsList.filters.area')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatsFilterInputs },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.InputWrap },
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'area-from',
	                name: 'areaFrom',
	                value: areaFrom || '',
	                className: (0, _classnames2.default)(_styles2.default.Input, _styles2.default.InputArea, _defineProperty({}, _styles2.default.Filled, areaFrom)),
	                onChange: handleChange
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Prefix },
	                t('components.flatsList.filters.from')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.InputWrap },
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'areaTo',
	                value: areaTo || '',
	                className: (0, _classnames2.default)(_styles2.default.Input, _styles2.default.InputArea, _defineProperty({}, _styles2.default.Filled, areaTo)),
	                onChange: handleChange
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Prefix },
	                t('components.flatsList.filters.to')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_styles2.default.FlatsFilter, _styles2.default.Interior) },
	          _react2.default.createElement(
	            'label',
	            null,
	            t('components.flatsList.filters.interior')
	          ),
	          _react2.default.createElement(
	            _Dropdown2.default,
	            {
	              className: (0, _classnames2.default)(_styles2.default.DropdownInterior),
	              buttonStyle: _styles2.default.DropdownInteriorButton,
	              textStyle: _styles2.default.DropdownInteriorText,
	              iconStyle: _styles2.default.DropdownInteriorIcon,
	              text: interiors[interior],
	              topShift: true
	            },
	            _react2.default.createElement(
	              _Menu2.default,
	              { noArrow: true, pure: true, className: _styles2.default.DropdownInteriorMenu },
	              ['all', 'chernInt', 'chistInt', 'predChistInt', 'remInt', 'chastRemInt'].map(function (key) {
	                return _react2.default.createElement(
	                  'span',
	                  { onClick: function onClick() {
	                      return handleDropdownClick(key);
	                    }, className: _styles2.default.InteriorMenuItem, key: key },
	                  interiors[key]
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Filters;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Filters);

/***/ }),
/* 989 */
[2394, 988],
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatsListItem = __webpack_require__(996);
	
	var _FlatsListItem2 = _interopRequireDefault(_FlatsListItem);
	
	var _styles = __webpack_require__(171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flats = function (_Component) {
	  _inherits(Flats, _Component);
	
	  function Flats() {
	    _classCallCheck(this, Flats);
	
	    return _possibleConstructorReturn(this, (Flats.__proto__ || Object.getPrototypeOf(Flats)).apply(this, arguments));
	  }
	
	  _createClass(Flats, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          finished = _props.finished,
	          data = _props.data,
	          active = _props.active,
	          handleMoreClick = _props.handleMoreClick,
	          handleFlatClick = _props.handleFlatClick,
	          pavilions = _props.pavilions,
	          building = _props.building,
	          showInfo = _props.showInfo,
	          buildingForGallery = _props.buildingForGallery,
	          t = _props.t,
	          currency = _props.currency,
	          selectionId = _props.selectionId,
	          userUid = _props.userUid,
	          sessionId = _props.sessionId;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.FlatsList },
	        data.filter(function (flat) {
	          return flat.status !== 'fundStatus' && flat.data.disabled != 1;
	        }).map(function (flat) {
	          return _react2.default.createElement(_FlatsListItem2.default, _extends({}, flat, {
	            key: flat.flatId,
	            handleFlatClick: handleFlatClick,
	            active: flat.flatId === active,
	            pavilions: pavilions,
	            building: building,
	            showInfo: showInfo,
	            buildingForGallery: buildingForGallery,
	            currency: currency,
	            selectionId: selectionId,
	            userUid: userUid,
	            sessionId: sessionId
	          }));
	        }),
	        !finished && _react2.default.createElement(
	          'button',
	          { className: _styles2.default.FlatsListShowMore, onClick: handleMoreClick },
	          t('components.flatsList.flats.showMore')
	        )
	      );
	    }
	  }]);
	
	  return Flats;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Flats);

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Flats = __webpack_require__(990);
	
	var _Flats2 = _interopRequireDefault(_Flats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Flats2.default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _building = __webpack_require__(54);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _interiors = __webpack_require__(321);
	
	var _interiors2 = _interopRequireDefault(_interiors);
	
	var _utils = __webpack_require__(12);
	
	var _lodash3 = __webpack_require__(354);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _Filters = __webpack_require__(989);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _SubFilters = __webpack_require__(998);
	
	var _SubFilters2 = _interopRequireDefault(_SubFilters);
	
	var _Flats = __webpack_require__(991);
	
	var _Flats2 = _interopRequireDefault(_Flats);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _styles = __webpack_require__(171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash5 = __webpack_require__(355);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	var _apartments = __webpack_require__(219);
	
	var _apartments2 = _interopRequireDefault(_apartments);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _helper = __webpack_require__(55);
	
	var _lodash7 = __webpack_require__(566);
	
	var _lodash8 = _interopRequireDefault(_lodash7);
	
	var _helper2 = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sorts = {
	  'priceAll ASC': {
	    text: _i18n2.default.t('components.flatsList.flatsList.sorts.priceAllAsc'),
	    orderField: 'price_all',
	    orderDirection: 'ASC',
	    key: 'priceAllAsc'
	  },
	  'priceAll DESC': {
	    text: _i18n2.default.t('components.flatsList.flatsList.sorts.priceAllDesc'),
	    orderField: 'price_all',
	    orderDirection: 'DESC',
	    key: 'priceAllDesc'
	  },
	  'area ASC': {
	    text: _i18n2.default.t('components.flatsList.flatsList.sorts.priceAllAsc'),
	    orderField: 'area_all',
	    orderDirection: 'ASC',
	    key: 'areaAsc'
	  },
	  'area DESC': {
	    text: _i18n2.default.t('components.flatsList.flatsList.sorts.priceAllAsc'),
	    orderField: 'area_all',
	    orderDirection: 'DESC',
	    key: 'areaDesc'
	  }
	};
	var sortKeys = Object.keys(sorts);
	var initState = {
	  priceFrom: 0,
	  priceTo: 0,
	  areaFrom: 0,
	  areaTo: 0,
	  interior: 'all'
	};
	var FlatsList = (_temp = _class = function (_Component) {
	  _inherits(FlatsList, _Component);
	
	  function FlatsList(props) {
	    _classCallCheck(this, FlatsList);
	
	    var _this = _possibleConstructorReturn(this, (FlatsList.__proto__ || Object.getPrototypeOf(FlatsList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.searchChess = (0, _lodash2.default)(_this.searchChess, 500).bind(_this);
	    _this.state = _extends({}, initState, {
	      sort: 'priceAll ASC',
	      active: null,
	      isFirstTimeFetching: true,
	      defaultTotal: 0
	    });
	    return _this;
	  }
	
	  _createClass(FlatsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchChess();
	      this.prepareChess(this.props, true);
	      this.pavilions = (0, _lodash4.default)(this.props.building.data.pavilions, 'id');
	      (0, _building.loadPavilions)(this.props.building.data.id);
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      this.prepareChess(nextProps);
	    }
	  }, {
	    key: 'getCellContent',
	    value: function getCellContent(room) {
	      return room.data.area;
	    }
	  }, {
	    key: 'setDefaultTotalFlats',
	    value: function setDefaultTotalFlats(total) {
	      if (this.state.isFirstTimeFetching) {
	        this.setState({ isFirstTimeFetching: false });
	        this.setState({ defaultTotal: total });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          total = _props.total,
	          finished = _props.finished,
	          showInfo = _props.selection.showInfo,
	          building = _props.building,
	          buildingForGallery = _props.buildingForGallery,
	          t = _props.t,
	          selectionId = _props.selectionId,
	          sessionId = _props.sessionId;
	      var currency = building.data.country.country_currency_symbol;
	      var _state = this.state,
	          priceTo = _state.priceTo,
	          priceFrom = _state.priceFrom,
	          areaFrom = _state.areaFrom,
	          areaTo = _state.areaTo,
	          interior = _state.interior,
	          sort = _state.sort,
	          active = _state.active,
	          defaultTotal = _state.defaultTotal;
	
	      var isFlatsExistsByDefalut = defaultTotal > 0;
	      var isFlatsExists = total > 0;
	
	      if (!isFlatsExistsByDefalut && !isFlatsExists && (0, _helper.getLotsType)() === 1) {
	        return null;
	      }
	
	      if (data) {
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.FlatsWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatsTitle },
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _utils.pluralize)(total, t('components.flatsList.flatsList.flat1'), t('components.flatsList.flatsList.flat2'), t('components.flatsList.flatsList.flat3')),
	              ' ',
	              '(',
	              total,
	              ')'
	            )
	          ),
	          isFlatsExistsByDefalut && _react2.default.createElement(_Filters2.default, {
	            priceFrom: priceFrom,
	            priceTo: priceTo,
	            areaFrom: areaFrom,
	            areaTo: areaTo,
	            handleChange: this.handleChange,
	            handleDropdownClick: this.handleDropdownClick,
	            handlePavilionChange: this.handlePavilionChange,
	            interiors: _interiors2.default,
	            interior: interior,
	            pavilions: building.data.pavilions,
	            pavilion: this.state.pavilion,
	            currency: currency
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatsListWrap },
	            isFlatsExistsByDefalut && _react2.default.createElement(_SubFilters2.default, {
	              sorts: sorts,
	              sortKeys: sortKeys,
	              sort: sort,
	              total: total,
	              handleSortChange: this.handleSortChange
	            }),
	            isFlatsExistsByDefalut ? isFlatsExists ? _react2.default.createElement(_Flats2.default, {
	              finished: finished,
	              data: data,
	              active: active,
	              handleMoreClick: this.handleMoreClick,
	              handleFlatClick: this.handleFlatClick,
	              pavilions: this.pavilions,
	              building: building.data,
	              showInfo: showInfo,
	              buildingForGallery: buildingForGallery,
	              currency: currency,
	              selectionId: selectionId,
	              sessionId: sessionId
	            }) : _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_styles2.default.badMessageContainer, _styles2.default.alignTop) },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.badMessageLeft },
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.badMessageTitle },
	                  t('components.flatsList.flatsList.notFound')
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.startNewSearch, className: _styles2.default.badMessageBtn },
	                  t('components.flatsList.flatsList.startNewSearch')
	                )
	              ),
	              _react2.default.createElement('img', {
	                src: _nothingfound2.default,
	                className: _styles2.default.badMessageImage,
	                alt: t('components.flatsList.flatsList.soldOut')
	              })
	            ) : _react2.default.createElement(
	              'div',
	              { className: _styles2.default.badMessageContainer },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.badMessageLeft },
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.badMessageTitle },
	                  t('components.flatsList.flatsList.noForSale')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.badMessageSubtitle },
	                  building.data.type_id == 2 ? t('components.flatsList.flatsList.soldAllHouses') : t('components.flatsList.flatsList.soldAllFlats')
	                )
	              ),
	              _react2.default.createElement('img', {
	                src: _nothingfound2.default,
	                className: _styles2.default.badMessageImage,
	                alt: t('components.flatsList.flatsList.soldOut')
	              })
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return FlatsList;
	}(_react.Component), _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.parseQuery = function (query) {
	    if (_this2.props.print) {
	      return _this2.props.queryParams || {};
	    }
	
	    var _parseQuery = (0, _utils.parseQuery)(query),
	        section = _parseQuery.section,
	        table = _parseQuery.table,
	        sort = _parseQuery.sort,
	        cell = _parseQuery.cell,
	        priceMin = _parseQuery.priceMin,
	        priceMax = _parseQuery.priceMax,
	        costMin = _parseQuery.costMin,
	        costMax = _parseQuery.costMax,
	        areaFrom = _parseQuery.areaFrom,
	        areaTo = _parseQuery.areaTo,
	        interior = _parseQuery.interior,
	        view_type = _parseQuery.view_type;
	
	    var selectedSectionKey = section || null;
	    var selectedSectionPath = selectedSectionKey ? selectedSectionKey.split('.').map(function (value) {
	      return Number(value);
	    }) : null;
	    var isTable = void 0,
	        isExtended = void 0;
	    switch (table) {
	      case 'common':
	        isTable = true;
	        isExtended = false;
	        break;
	      case 'extended':
	        isTable = true;
	        isExtended = true;
	        break;
	      case 'list':
	        isTable = false;
	        isExtended = false;
	        break;
	      default:
	        isTable = null;
	        isExtended = null;
	    }
	    var listSortPath = null;
	    if (sort) {
	      var _sort$split = sort.split(':'),
	          _sort$split2 = _slicedToArray(_sort$split, 2),
	          column = _sort$split2[0],
	          direction = _sort$split2[1];
	
	      listSortPath = [column, direction !== 'desc'];
	    }
	    var selectedCelllPath = cell ? cell.split('.').map(function (value) {
	      return Number(value);
	    }) : null;
	
	    var _props$buildingForGal = _this2.props.buildingForGallery,
	        prevIsTable = _props$buildingForGal.isTable,
	        prevIsExtended = _props$buildingForGal.isExtended,
	        prevSelected = _props$buildingForGal.selected,
	        prevFilters = _props$buildingForGal.filters,
	        prevSelectedSectionPath = _props$buildingForGal.filters.section,
	        prevListSort = _props$buildingForGal.listSort;
	
	    var prevSelectedSectionKey = prevSelectedSectionPath.join('.');
	
	    return {
	      isTable: _this2.props.client ? false : isTable != null ? isTable : prevIsTable,
	      isExtended: isExtended != null ? isExtended : prevIsExtended,
	      selected: selectedCelllPath != null ? _extends({}, prevSelected, _defineProperty({}, selectedSectionKey != null ? selectedSectionKey : prevSelectedSectionKey, selectedCelllPath)) : prevSelected,
	      filters: _extends({}, prevFilters, {
	        section: selectedSectionPath != null ? selectedSectionPath : prevSelectedSectionPath,
	        priceMin: priceMin,
	        priceMax: priceMax,
	        costMin: costMin,
	        costMax: costMax,
	        areaFrom: areaFrom,
	        areaTo: areaTo,
	        interior: interior,
	        view_type: view_type
	      }),
	      listSort: listSortPath != null ? listSortPath : prevListSort
	    };
	  };
	
	  this.prepareChess = function (props) {
	    var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!props.buildingForGallery.isLoading) {
	      var pavilions = props.buildingForGallery.pavilions;
	      var location = props.location;
	      var prevLocation = _this2.props.location;
	
	      if (location !== prevLocation) {
	        var _updateChessState = _this2.props.updateChessState;
	
	        var params = _this2.parseQuery(location.search);
	        _updateChessState(params);
	        return;
	      }
	
	      if (pavilions) {
	        var _props$buildingForGal2 = props.buildingForGallery,
	            chessList = _props$buildingForGal2.chessList,
	            selectedSectionPath = _props$buildingForGal2.filters.section;
	
	
	        var selectedSectionKey = selectedSectionPath.join('.');
	
	        var _selectedSectionPath = _slicedToArray(selectedSectionPath, 2),
	            pavilionId = _selectedSectionPath[0],
	            sectionId = _selectedSectionPath[1];
	
	        var selectedSectionId = pavilions[pavilionId].sections[sectionId].id;
	        var chess = chessList[selectedSectionId];
	        var filtersChanged = JSON.stringify(_this2.props.buildingForGallery.filters) !== JSON.stringify(props.buildingForGallery.filters);
	        var isChessLoading = props.buildingForGallery.isChessLoading;
	
	        if (!isChessLoading || filtersChanged) {
	          var _loadChess = props.loadChess;
	
	          var updateCells = function updateCells(resp) {
	            var setCells = props.setCells;
	            var _resp$data$data = resp.data.data,
	                rows = _resp$data$data.rows,
	                cols = _resp$data$data.cols,
	                cells = _resp$data$data.cells;
	
	            rows = rows || [];
	            cols = cols || [];
	            cells = cells || [];
	
	            var _getData = _this2.getData(rows, cols, cells),
	                data = _getData.data,
	                selected = _getData.selected;
	
	            setCells(selectedSectionKey, data, selected);
	          };
	
	          var filteredIntersection = null;
	          // FIXME: убрать это и вынести отсюда
	          if (chess) {
	            var interiorsInHouse = chess.cells.reduce(function (list, cell) {
	              if (cell.data.status === 'saleStatus' || (0, _helper2.isReserved)(cell.data.status) || cell.data.status === 'assignmentStatus') {
	                return list.includes(cell.data.interior) ? list : [cell.data.interior].concat(_toConsumableArray(list));
	              }
	              return list;
	            }, []);
	            var splitedInterior = props.buildingForGallery.filters.interior && props.buildingForGallery.filters.interior.length ? props.buildingForGallery.filters.interior.split(',') : [];
	            var interiorIntersection = (0, _lodash6.default)(interiorsInHouse, splitedInterior);
	            filteredIntersection = interiorIntersection.length ? interiorIntersection.join(',') : null;
	          }
	
	          if (initial || !chess || filtersChanged || _this2.filteredIntersection !== filteredIntersection) {
	            _this2.filteredIntersection = filteredIntersection;
	            _loadChess({
	              id: selectedSectionId,
	              costMin: props.buildingForGallery.filters.costMin,
	              costMax: props.buildingForGallery.filters.costMax,
	              areaFrom: props.buildingForGallery.filters.areaFrom,
	              areaTo: props.buildingForGallery.filters.areaTo,
	              stock: filteredIntersection
	            }).then(updateCells);
	          }
	        }
	      }
	    }
	  };
	
	  this.getData = function (rows, cols, cells) {
	    var rowLength = rows.length;
	    var colLength = cols.reduce(function (prev, cur) {
	      return prev + (Number(cur.colspan) || 1);
	    }, 0);
	    var data = Array(rowLength).fill(null).map(function () {
	      return { cells: Array(colLength) };
	    });
	
	    var selected = void 0,
	        imagelessSelected = void 0,
	        soldSelected = void 0;
	
	    cells.forEach(function (cell, index) {
	      var row = cell.row,
	          col = cell.col,
	          rowspan = cell.rowspan,
	          colspan = cell.colspan;
	
	
	      row = Number(row);
	      col = Number(col);
	
	      if (row > rowLength - 1 || col > colLength - 1) {
	        throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u0441\u044B\u043B\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 row \u0438\u043B\u0438 col');
	        // return;
	      }
	      if (data[row].cells[col] !== undefined) {
	        return;
	      }
	
	      colspan = !colspan || colspan === '0' ? 1 : Number(colspan);
	      rowspan = !rowspan || rowspan === '0' ? 1 : Number(rowspan);
	
	      if (rowspan > 1 || colspan > 1) {
	        for (var rowKey = row; rowKey < row + rowspan; ++rowKey) {
	          if (rowKey > rowLength - 1) {
	            throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u0438 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u0437\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0442\u0430\u0431\u043B\u0438\u0446\u044B');
	          }
	          for (var colKey = col; colKey < col + colspan; ++colKey) {
	            if (colKey > colLength - 1) {
	              throw new Error('\u042F\u0447\u0435\u0439\u043A\u0430 \u043F\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441\u043E\u043C ' + index + ' \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0448\u0438\u0440\u043E\u043A\u0430\u044F \u0438 \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u0437\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0442\u0430\u0431\u043B\u0438\u0446\u044B');
	            }
	            data[rowKey].cells[colKey] = null;
	          }
	        }
	      }
	
	      if (cell.data.disabled) {
	        data[row].cells[col] = null;
	        return;
	      }
	
	      var floorName = rows[cell.row].name;
	      var interiorName = _interiors2.default[cell.data.interior];
	      var apartmentsName = _apartments2.default[cell.data.cnt_apart];
	      var priceFormatted = (0, _utils.formatNumber)(cell.data.priceM);
	      var costFormatted = (0, _utils.formatNumber)(cell.data.priceAll);
	      var hidden = ['soldStatus', '0'].includes(cell.data.status) || !cell.data.area && !['fundStatus'].includes(cell.data.status);
	
	      var room = _extends({}, cell, {
	        data: _extends({}, cell.data, {
	          interiorName: interiorName,
	          floorName: floorName,
	          apartmentsName: apartmentsName,
	          priceFormatted: priceFormatted,
	          costFormatted: costFormatted
	        }),
	        row: row,
	        col: col,
	        rowspan: rowspan,
	        colspan: colspan,
	        hidden: hidden
	      });
	      room.content = {
	        common: hidden ? null : _this2.getCellContent(room),
	        extended: hidden ? null : _this2.getCellExtendedContent(room)
	      };
	
	      data[row].cells[col] = room;
	
	      if (!selected) {
	        if (room.planId && !room.hidden) {
	          selected = [row, col];
	        } else if (!imagelessSelected) {
	          if (!room.hidden) {
	            imagelessSelected = [row, col];
	          } else if (!soldSelected) {
	            soldSelected = [row, col];
	          }
	        }
	      }
	    });
	
	    return { data: data, selected: selected || imagelessSelected || soldSelected || null };
	  };
	
	  this.getCellExtendedContent = function (room) {
	    var t = _this2.props.t;
	
	
	    var reservation = (0, _helper2.isReserved)(room.data.status);
	    if (_this2.props.print) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles2.default.ExtendedContent, _defineProperty({}, _styles2.default.Reservation, reservation), _styles2.default.ExtendedContentPrint)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ExtendedContentLeft },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('span', { className: _styles2.default.PrintExtendedEmptySpan })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              room.data.area
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ExtendedContentRight },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              room.data.costFormatted
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              room.data.priceFormatted
	            )
	          )
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.ExtendedContent, _defineProperty({}, _styles2.default.Reservation, reservation), _defineProperty({}, _styles2.default.NotMatch, !room.mark))
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.ExtendedContentLeft },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.ExtendedFlatNum },
	            '\u2116' + room.data.number
	          )
	        ),
	        room.data.apartmentsName ? _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            room.data.apartmentsName
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.ExtendedContentRight },
	        room.data.costFormatted && room.data.costFormatted == 0 ? null : _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.ExtendedFlatPrice },
	            room.data.costFormatted
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            t('components.flatsList.flatsList.area', { area: room.data.area }),
	            room.data.priceFormatted == 0 ? null : _react2.default.createElement(
	              'span',
	              { className: _styles2.default.Span },
	              ', ',
	              t('components.flatsList.flatsList.price', { price: room.data.priceFormatted })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  this.searchChess = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var filter = _extends({
	      offset: 0,
	      limit: 10,
	      buildingId: ~~_this2.props.building.data.id,
	      userUid: _this2.props.userUid,
	      priceFrom: _this2.state.priceFrom,
	      priceTo: _this2.state.priceTo,
	      areaFrom: _this2.state.areaFrom,
	      areaTo: _this2.state.areaTo,
	      interior: _this2.state.interior === 'all' ? [] : [_this2.state.interior],
	      pavilionId: _this2.state.pavilion,
	      orderField: sorts[_this2.state.sort].orderField,
	      orderDirection: sorts[_this2.state.sort].orderDirection
	    }, params);
	
	    var chessIds = _this2.props.building.data.chessIds || [];
	
	    if ((0, _helper.getLotsType)() === 1) {
	      filter.ids = chessIds.length ? chessIds : [-1];
	      filter.limit = chessIds.length;
	    }
	
	    _this2.props.searchChess(filter).then(function (response) {
	      _this2.setDefaultTotalFlats(response.response.data.data.total);
	    });
	  };
	
	  this.handleChange = function (e) {
	    _this2.setState(_defineProperty({}, e.target.name, e.target.value), _this2.searchChess);
	  };
	
	  this.handleDropdownClick = function (interior) {
	    _this2.setState({
	      interior: interior
	    }, _this2.searchChess);
	  };
	
	  this.handlePavilionChange = function (id) {
	    _this2.setState({
	      pavilion: id
	    }, _this2.searchChess);
	  };
	
	  this.handleSortChange = function (sort) {
	    _this2.setState({ sort: sort }, _this2.searchChess);
	  };
	
	  this.handleMoreClick = function () {
	    if (!_this2.props.loading && !_this2.props.finished) {
	      _this2.searchChess({ offset: _this2.props.offset });
	    }
	  };
	
	  this.handleFlatClick = function (flatId) {
	    _this2.setState({
	      active: _this2.state.active === flatId ? null : flatId
	    });
	  };
	
	  this.startNewSearch = function () {
	    _this2.setState(_extends({}, _this2.state, initState), function () {
	      return _this2.searchChess();
	    });
	  };
	}, _temp);
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state.flats;
	}, {
	  searchChess: _building.searchChess,
	  updateChessState: _building.updateChessState,
	  loadChess: _building.loadChess,
	  setCells: _building.setCells,
	  loadPavilions: _building.loadPavilions
	})((0, _reactI18next.withTranslation)()(FlatsList));

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactModal = __webpack_require__(184);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _SpinnerImage = __webpack_require__(218);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	var _apartments = __webpack_require__(219);
	
	var _apartments2 = _interopRequireDefault(_apartments);
	
	var _noFloor = __webpack_require__(238);
	
	var _noFloor2 = _interopRequireDefault(_noFloor);
	
	var _iconZoom = __webpack_require__(343);
	
	var _iconZoom2 = _interopRequireDefault(_iconZoom);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _utils = __webpack_require__(12);
	
	var _interiors = __webpack_require__(321);
	
	var _interiors2 = _interopRequireDefault(_interiors);
	
	var _About = __webpack_require__(534);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Gallery = __webpack_require__(994);
	
	var _collectionLotFavorite = __webpack_require__(1530);
	
	var _collectionLotFavorite2 = _interopRequireDefault(_collectionLotFavorite);
	
	var _collectionLotFavoriteActive = __webpack_require__(1529);
	
	var _collectionLotFavoriteActive2 = _interopRequireDefault(_collectionLotFavoriteActive);
	
	var _styles = __webpack_require__(171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(93);
	
	var _ViewType = __webpack_require__(995);
	
	var _collections = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var digits = function digits(number) {
	  return number ? (0, _utils.formatNumber)(number) : '...';
	};
	
	var FlatsListItem = (_dec = (0, _reactRedux.connect)(null, { setPopUp: _environment.setPopUp }), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
	  _inherits(FlatsListItem, _Component);
	
	  function FlatsListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FlatsListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlatsListItem.__proto__ || Object.getPrototypeOf(FlatsListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showPopup: false, isFavorite: false }, _this.state = {}, _this.handleShowPlanClick = function (e) {
	      e.stopPropagation();
	      _this.setState({
	        showModal: 'FLOOR_PLAN'
	      });
	    }, _this.handleCloseClick = function () {
	      _this.setState({
	        showModal: false
	      });
	    }, _this.toggleFavorite = function (e) {
	      e.stopPropagation();
	
	      var _this$props = _this.props,
	          flatId = _this$props.flatId,
	          active = _this$props.active,
	          handleFlatClick = _this$props.handleFlatClick;
	
	
	      if (!active && handleFlatClick) {
	        handleFlatClick(flatId);
	      }
	
	      _this.setState(function (prevState) {
	        var newFavorite = !prevState.isFavorite;
	        _this.handleSendStats(flatId, newFavorite);
	        return { isFavorite: newFavorite };
	      });
	    }, _this.setPopUp = function () {
	      var _this$props2 = _this.props,
	          setPopUp = _this$props2.setPopUp,
	          data = _this$props2.data,
	          building = _this$props2.building,
	          showInfo = _this$props2.showInfo,
	          t = _this$props2.t,
	          currency = _this$props2.currency;
	
	      var costFormatted = (0, _utils.formatNumber)(data.priceAll);
	      var priceFormatted = (0, _utils.formatNumber)(data.priceM);
	
	      var isReserved = (0, _helper.isReserved)(data.status);
	
	      setPopUp(_react2.default.createElement(
	        'div',
	        { className: _About2.default.PopUpOuter },
	        _react2.default.createElement(
	          'div',
	          { className: _About2.default.PopUpInner },
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.TopInfo },
	            _react2.default.createElement(
	              'span',
	              null,
	              '' + (showInfo == 1 ? building.title + ' / ' : '') + t('components.flatsList.flatListItem.number', { number: data.row }) + ' / \u2116' + data.number
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.BottomInfo },
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.LeftInfo },
	              _react2.default.createElement(_SpinnerImage2.default, {
	                className: _About2.default.ImageInfo,
	                imageSrc: _Config.ROOT_URL + '/image/polygon?id=' + data.poligon_id + '&preset=800',
	                imageAlt: 'Room',
	                spinner: _react2.default.createElement('div', { className: _About2.default.LoaderInfo })
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _About2.default.RightInfo },
	              data.hidden ? isReserved ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement('span', {
	                  dangerouslySetInnerHTML: {
	                    __html: t('components.flatsList.flatListItem.reserved')
	                  }
	                })
	              ) : _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.flatsList.flatListItem.sold')
	                )
	              ) : isReserved && costFormatted == 0 ? _react2.default.createElement(
	                'div',
	                { className: _About2.default.SoldInfo },
	                _react2.default.createElement('span', {
	                  dangerouslySetInnerHTML: {
	                    __html: t('components.flatsList.flatListItem.reserved')
	                  }
	                })
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.PopupFlatInfo },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.FlatNum },
	                    '\u2116',
	                    data.number
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.PopupTagsWrap },
	                    data.view_action === '1' && !(data.status === 'soldStatus') ? _react2.default.createElement(
	                      'span',
	                      { className: _About2.default.TagPromo },
	                      t('components.flatsList.flatListItem.promo')
	                    ) : null,
	                    isReserved ? _react2.default.createElement(
	                      'span',
	                      { className: _About2.default.TagReserve },
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        t('components.flatsList.flatListItem.reserve')
	                      )
	                    ) : null
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.PriceInfo },
	                  costFormatted + ' ' + currency,
	                  _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.SmallInfo },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.flatsList.flatListItem.priceFormatted', {
	                        priceFormatted: priceFormatted,
	                        currency: currency
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)(_About2.default.FlatOptions, _About2.default.PopupFlatOptions) },
	                  data.area ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.flatsList.flatListItem.area', { area: data.area })
	                    )
	                  ) : '',
	                  data.apartmentsName ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    data.apartmentsName
	                  ) : '',
	                  data.interior == 'predChistInt' ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      t('components.flatsList.flatListItem.predChistInt')
	                    )
	                  ) : data.interiorName ? _react2.default.createElement(
	                    'div',
	                    { className: _About2.default.FlatOption },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      data.interiorName
	                    )
	                  ) : ''
	                )
	              )
	            )
	          )
	        )
	      ), {
	        className: _About2.default.popupFlat,
	        backgroundClassName: _About2.default.popupFlatBg,
	        contentClassName: _About2.default.popupFlatContent,
	        closeIcon: 'gallery',
	        hideCloseIcon: true
	      });
	    }, _this.handleClose = function () {
	      _this.setState({
	        showPopup: false
	      });
	    }, _this.setFloorPopUp = function (e) {
	      e.stopPropagation();
	      _this.setState({ showPopup: true });
	    }, _this.handleCellClick = function (id, selected) {
	      var cell = selected.join('.');
	      _this.transitionTo({ cell: cell });
	    }, _this.handleFilters = function () {
	      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var selected = _this.props.buildingForGallery.selected;
	      var selectedSectionPath = update.section,
	          prevSection = update.prevSection;
	
	      if (selectedSectionPath) {
	        var selectedSectionKey = selectedSectionPath.join('.');
	        var selectedCellPath = selected[selectedSectionKey];
	        var selectedCellKey = selectedCellPath ? selectedCellPath.join('.') : null;
	        _this.prevSection = prevSection;
	        _this.transitionTo({ section: selectedSectionKey, cell: selectedCellKey });
	      }
	    }, _this.renderFloorPopup = function () {
	      var _this$props3 = _this.props,
	          setPopUp = _this$props3.setPopUp,
	          data = _this$props3.data,
	          planId = _this$props3.planId,
	          flatId = _this$props3.flatId,
	          buildingForGallery = _this$props3.buildingForGallery,
	          building = _this$props3.building,
	          pointers = _this$props3.pointers;
	      var chessList = buildingForGallery.chessList,
	          filters = buildingForGallery.filters,
	          cells = buildingForGallery.cells,
	          selected = buildingForGallery.selected,
	          isTable = buildingForGallery.isTable,
	          isExtended = buildingForGallery.isExtended,
	          listSort = buildingForGallery.listSort,
	          tableScroll = buildingForGallery.tableScroll;
	
	
	      var pavilionsFlat = _this.props.buildingForGallery.pavilions;
	
	      var selectedSectionPath = filters.section;
	
	      var sectionCells = null;
	      var chess = null;
	      var sectionId = void 0;
	      var selectedSectionKey = void 0;
	      var selectedCellPath = void 0;
	      var selectedCell = void 0;
	      var scrollKey = void 0;
	      var defaultScroll = [0, 0];
	      var sortKey = void 0;
	
	      if (building && pavilionsFlat) {
	        selectedSectionKey = selectedSectionPath.join('.');
	        selectedSectionKey = cells[selectedSectionKey] || !_this.prevSection ? selectedSectionKey : _this.prevSection.join('.');
	        sectionCells = cells[selectedSectionKey];
	
	        if (sectionCells) {
	          var _ref2 = cells[selectedSectionPath.join('.')] ? selectedSectionPath : _this.prevSection,
	              _ref3 = _slicedToArray(_ref2, 2),
	              pavilionIndex = _ref3[0],
	              sectionIndex = _ref3[1];
	
	          sectionId = pavilionsFlat[pavilionIndex].sections[sectionIndex].id;
	          var chessRaw = chessList[sectionId];
	          var cols = chessRaw.cols.reduce(function (prev, cur) {
	            var colspan = cur.colspan;
	
	            colspan = Number(colspan) || 1;
	            var cols = Array(colspan).fill(null);
	            cols[0] = cur;
	            return prev.concat(cols);
	          }, []);
	          chess = _extends({}, chessRaw, { cols: cols });
	          selectedCellPath = selected[selectedSectionKey];
	
	          var _selectedCellPath = selectedCellPath,
	              _selectedCellPath2 = _slicedToArray(_selectedCellPath, 2),
	              row = _selectedCellPath2[0],
	              column = _selectedCellPath2[1];
	
	          selectedCell = selectedCellPath ? sectionCells[row].cells[column] : null;
	          scrollKey = [pavilionIndex, sectionIndex, isTable, isTable ? isExtended : null].filter(function (value) {
	            return value != null;
	          }).join('.');
	          sortKey = listSort.join('.');
	          defaultScroll = tableScroll[scrollKey] || [0, 0];
	          _this.dataFlats = _this.dataFlats !== undefined ? _this.dataFlats : building.count_flats;
	        }
	      }
	      var rows = chess && chess.rows || [];
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          isOpen: _this.state.showPopup,
	          onRequestClose: _this.handleClose,
	          contentLabel: 'Modal',
	          style: {
	            overlay: {
	              backgroundColor: 'rgba(0, 0, 0, 0.75)',
	              zIndex: 10
	            },
	            content: {
	              padding: 0,
	              border: 'none',
	              width: '950px',
	              height: '650px',
	              top: '50%',
	              left: '50%',
	              transform: 'translate3d(-50%, -50%, 0)'
	            }
	          }
	        },
	        _react2.default.createElement(_Gallery.ChessGalleryPopupWithRouter, _extends({}, _this.props, {
	          rows: rows // этажи
	          , row: rows.length - +data.row // текущий этаж
	          , sectionCells: sectionCells // выбор точек для отрисовки overlay
	          , data: selectedCell // информация о текщуем этаже для отрисовки свг
	          , filters: filters,
	          pavilionsFlat: pavilionsFlat // нужен для фильтров
	          , cells: chess.cells // мб кваритры
	          , onClose: _this.handleClose,
	          handleCellClick: _this.handleCellClick,
	          handleFilters: _this.handleFilters,
	          planId: planId,
	          flatId: flatId,
	          floor: data.row,
	          roomData: data,
	          pointers: pointers,
	          isClientView: true
	        }))
	      );
	    }, _this.handleSendStats = function (flatId) {
	      var favoriteChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var payload = {
	        sessionUuid: _this.props.sessionId,
	        collectionId: _this.props.selectionId,
	        buildingId: _this.props.building.id,
	        chessId: Number(flatId)
	      };
	
	      if (favoriteChanged !== null) {
	        payload.likes = favoriteChanged ? 1 : 0;
	        payload.views = _this.props.active ? 0 : 1;
	      } else {
	        payload.views = 1;
	      }
	
	      (0, _collections.sendCollectionBuildingLotStats)(payload);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FlatsListItem, [{
	    key: 'renderVectorOverlay',
	    value: function renderVectorOverlay() {
	      var _this2 = this;
	
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$all = _ref4.all,
	          all = _ref4$all === undefined ? false : _ref4$all;
	
	      var _props = this.props,
	          row = _props.row,
	          data = _props.data,
	          sectionCells = _props.sectionCells;
	
	      if (data.pointers) {
	        var _data$pointers$split = data.pointers.split(':'),
	            _data$pointers$split2 = _slicedToArray(_data$pointers$split, 2),
	            width = _data$pointers$split2[0],
	            height = _data$pointers$split2[1];
	
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.Plan },
	          _react2.default.createElement(
	            'div',
	            { className: 'lol' },
	            _react2.default.createElement(
	              'svg',
	              {
	                xmlns: 'http://www.w3.org/2000/svg',
	                height: height,
	                width: width,
	                viewBox: '0 0 ' + width + ' ' + height
	              },
	              _react2.default.createElement(
	                'g',
	                null,
	                (all ? sectionCells[row].cells : [data]).filter(function (cell) {
	                  return cell && cell.pointers;
	                }).map(function (cell) {
	                  var coordinates = cell.pointers.split(':')[2];
	                  var cs = coordinates.split(',');
	                  var path = cs.reduce(function (path, c, i) {
	                    return path.concat(i % 2 === 1 ? c + ' L ' : c + ' ');
	                  }, 'M ').replace(/L $/, 'Z');
	                  return [_react2.default.createElement('path', {
	                    className: (0, _classnames2.default)(_styles2.default.Flat, _defineProperty({}, _styles2.default.SelectedFlat, cell.id === data.id)),
	                    d: path,
	                    key: cell.id,
	                    onMouseEnter: function onMouseEnter() {
	                      _this2.setState({ hoverCellId: cell.id });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                      if (_this2.state.hoverCellId === cell.id) {
	                        _this2.setState({ hoverCellId: null });
	                      }
	                    }
	                  })];
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'transitionTo',
	    value: function transitionTo(queryParams) {
	      var history = this.props.history;
	
	      var path = this.getPath(queryParams);
	      history.push(path);
	      return path;
	    }
	  }, {
	    key: 'getPath',
	    value: function getPath(queryParams) {
	      var _props2 = this.props,
	          match = _props2.match,
	          client = _props2.client,
	          print = _props2.print,
	          location = _props2.location;
	      var params = match.params;
	
	      var query = (0, _utils.compileQuery)(queryParams, location.search);
	      var search = query ? '?' + query : '';
	      if (client) {
	        return '/view/' + params.referal + '/building/' + params.id + search;
	      }
	      if (print) {
	        return '/print/' + params.id + search;
	      }
	      return '/building/' + params.id + '/chess' + search;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          flatId = _props3.flatId,
	          planId = _props3.planId,
	          pavilionName = _props3.pavilionName,
	          sectionName = _props3.sectionName,
	          pavilionId = _props3.pavilionId,
	          pavilions = _props3.pavilions,
	          t = _props3.t,
	          currency = _props3.currency,
	          _props3$data = _props3.data,
	          number = _props3$data.number,
	          row = _props3$data.row,
	          area = _props3$data.area,
	          priceAll = _props3$data.priceAll,
	          priceM = _props3$data.priceM,
	          cnt_apart = _props3$data.cnt_apart,
	          interior = _props3$data.interior,
	          status = _props3$data.status,
	          poligon_id = _props3$data.poligon_id,
	          view_action = _props3$data.view_action,
	          objectType = _props3$data.objectType,
	          profile = _props3$data.profile,
	          mode = _props3$data.mode,
	          buildingData = _props3$data.buildingData;
	      var _pavilions$pavilionId = pavilions[pavilionId][0],
	          construction_ending = _pavilions$pavilionId.construction_ending,
	          year_built = _pavilions$pavilionId.year_built,
	          construction_finished = _pavilions$pavilionId.construction_finished;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles2.default.FlatsListItem, _defineProperty({}, _styles2.default.Active, this.props.active)),
	          onClick: function onClick() {
	            _this3.props.handleFlatClick(flatId);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: _styles2.default.FlatsListItemContent,
	            onClick: function onClick(e) {
	              if (!e.target.closest('.' + _styles2.default.Favorite) && !_this3.props.active) {
	                _this3.handleSendStats(_this3.props.flatId, null);
	              }
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Left },
	            poligon_id ? _react2.default.createElement(
	              'div',
	              { className: _styles2.default.FlatPlan },
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image/polygon?id=' + poligon_id + '&preset=100',
	                alt: '',
	                className: _styles2.default.FlatPlanImage
	              })
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_styles2.default.FlatTitle, _defineProperty({}, _styles2.default.WithoutPLan, !poligon_id)) },
	              _react2.default.createElement(
	                'p',
	                null,
	                t('components.flatsList.flatListItem.area', { area: area }),
	                ' \xB7 ',
	                _apartments2.default[cnt_apart],
	                view_action === '1' && _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)(_styles2.default.TagPromo, _styles2.default.MobileHide) },
	                  t('components.flatsList.flatListItem.promo')
	                ),
	                (0, _helper.isReserved)(status) && _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)(_styles2.default.TagReserve, _styles2.default.MobileHide) },
	                  t('components.flatsList.flatListItem.reserve')
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(_ViewType.ViewType, {
	                  viewType: this.props.data.view_type,
	                  objectType: objectType,
	                  profile: profile,
	                  mode: mode,
	                  buildingData: buildingData
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: (0, _classnames2.default)(_styles2.default.FlatHousing, _defineProperty({}, _styles2.default.Done, construction_finished)) },
	                t('components.flatsList.flatListItem.housing', { pavilionName: pavilionName, sectionName: sectionName })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_styles2.default.PriceMobile, _styles2.default.OnlyMobile) },
	                digits(priceAll),
	                ' ',
	                currency
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Floor },
	            t('components.flatsList.flatListItem.number', { number: row })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Price },
	            digits(priceAll),
	            ' ',
	            currency
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_styles2.default.Right, _styles2.default.OnlyMobile) },
	            view_action === '1' && _react2.default.createElement(
	              'span',
	              { className: _styles2.default.TagPromo },
	              t('components.flatsList.flatListItem.promo')
	            ),
	            (0, _helper.isReserved)(status) && _react2.default.createElement(
	              'span',
	              { className: _styles2.default.TagReserve },
	              t('components.flatsList.flatListItem.reserve')
	            ),
	            _react2.default.createElement('span', null),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.RightFloor },
	              t('components.flatsList.flatListItem.number', { number: row })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Favorite, onClick: this.toggleFavorite },
	            _react2.default.createElement('img', {
	              src: this.state.isFavorite ? _collectionLotFavoriteActive2.default : _collectionLotFavorite2.default,
	              alt: t('components.header.menu.favorites')
	            })
	          )
	        ),
	        this.props.active && _react2.default.createElement(
	          'div',
	          { className: _styles2.default.FlatsListItemHidden },
	          poligon_id ? _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatPlanBig, onClick: this.setPopUp },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.FlatPlanHover },
	              _react2.default.createElement('img', { alt: 'zoom', src: _iconZoom2.default })
	            ),
	            _react2.default.createElement('img', {
	              className: _styles2.default.FlatPlanImage,
	              src: _Config.ROOT_URL + '/image/polygon?id=' + poligon_id + '&preset=400',
	              alt: ''
	            })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.FlatInfo },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.FlatInfoItem },
	              _react2.default.createElement(
	                'span',
	                null,
	                t('components.flatsList.flatListItem.flatNumber')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                number
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.FlatInfoItem },
	              _react2.default.createElement(
	                'span',
	                null,
	                t('components.flatsList.flatListItem.price')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                digits(priceM),
	                ' ',
	                currency
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.FlatInfoItem },
	              _react2.default.createElement(
	                'span',
	                null,
	                t('components.flatsList.flatListItem.inner')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _interiors2.default[interior]
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_styles2.default.FlatStatus, _styles2.default.ShowMd, _defineProperty({}, _styles2.default.Done, construction_finished)) },
	              construction_finished ? t('components.flatsList.flatListItem.finished') : construction_ending + ' / ' + year_built
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_styles2.default.FlatStatus, _styles2.default.HiddenMd, _defineProperty({}, _styles2.default.Done, construction_finished)) },
	            construction_finished ? t('components.flatsList.flatListItem.finished') : construction_ending + ' / ' + year_built
	          )
	        ),
	        this.state.showPopup && this.renderFloorPopup(),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: !!this.state.showModal,
	            onRequestClose: this.handleCloseClick,
	            contentLabel: 'Modal',
	            className: _styles2.default.ModalContent,
	            style: {
	              overlay: {
	                backgroundColor: 'rgba(0, 0, 0, 0.5)',
	                zIndex: 7
	              },
	              content: {
	                padding: '30px',
	                background: '#fff',
	                border: 'none',
	                top: '6rem',
	                right: '15rem',
	                bottom: '6rem',
	                left: '15rem'
	              }
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.ModalClose, onClick: this.handleCloseClick },
	            _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            _SpinnerImage2.default,
	            {
	              key: flatId,
	              className: (0, _classnames2.default)(_styles2.default.ImageInner, _defineProperty({}, _styles2.default.ImagePrint, print)),
	              imageClassName: _styles2.default.SpinnerImage,
	              imageSrc: this.state.showModal === 'FLAT_PLAN' ? _Config.ROOT_URL + '/image/polygon?id=' + poligon_id + '&preset=900' : _Config.ROOT_URL + '/image/plan?id=' + planId + '&preset=900',
	              imageAlt: 'Floor preview',
	              handleImageLoad: this.handleImageLoad,
	              handleImageError: this.props.handleImageError,
	              spinner: _react2.default.createElement('div', { className: _styles2.default.Loader }),
	              placeholder: _react2.default.createElement(
	                'div',
	                { className: _styles2.default.PlaceholderOuter },
	                _react2.default.createElement('img', { className: _styles2.default.PlaceholderImage, src: _noFloor2.default, alt: 'Not found' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.PlaceholderText },
	                  t('components.flatsList.flatListItem.emptyPlan')
	                )
	              )
	            },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_styles2.default.Zoom), onClick: this.setPopUp },
	              this.renderVectorOverlay()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FlatsListItem;
	}(_react.Component)) || _class) || _class);
	exports.default = (0, _reactI18next.withTranslation)()(FlatsListItem);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChessGalleryPopupWithRouter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _normalizeWheel = __webpack_require__(593);
	
	var _normalizeWheel2 = _interopRequireDefault(_normalizeWheel);
	
	var _Config = __webpack_require__(16);
	
	var _SpinnerImage = __webpack_require__(218);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	var _Filters = __webpack_require__(308);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _About = __webpack_require__(213);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Gallery = __webpack_require__(1387);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_SCALE = 1;
	var MAX_SCALE = 5;
	var WHEEL_FACTOR = 1.05;
	var CLICK_FACTOR = 1.5;
	
	var ChessGalleryPopup = function (_Component) {
	  _inherits(ChessGalleryPopup, _Component);
	
	  function ChessGalleryPopup(props) {
	    _classCallCheck(this, ChessGalleryPopup);
	
	    var _this = _possibleConstructorReturn(this, (ChessGalleryPopup.__proto__ || Object.getPrototypeOf(ChessGalleryPopup)).call(this, props));
	
	    _this.isNegative = function (n) {
	      return ((n = +n) || 1 / n) < 0;
	    };
	
	    _this.handleMouseWheel = function (e) {
	      e.preventDefault();
	      var normalized = (0, _normalizeWheel2.default)(e);
	      _this.zoom(_this.isNegative(normalized.pixelY), WHEEL_FACTOR);
	    };
	
	    _this.zoom = function (zoomIn, zoomFactor) {
	      var newScale = _this.state.scale * (zoomIn ? zoomFactor : 1 / zoomFactor);
	
	      _this.setState({
	        scale: Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale))
	      });
	    };
	
	    _this.zoomIn = function () {
	      _this.zoom(true, CLICK_FACTOR);
	    };
	
	    _this.zoomOut = function () {
	      _this.zoom(false, CLICK_FACTOR);
	    };
	
	    _this.handleZoomChange = function (e) {
	      _this.setState({
	        scale: e.target.value
	      });
	    };
	
	    _this.handleZoomMouseDown = function (e) {
	      e.stopPropagation();
	    };
	
	    _this.getZoomPercent = function () {
	      return (_this.state.scale - MIN_SCALE) / (MAX_SCALE - MIN_SCALE);
	    };
	
	    _this.adjustFloorScroll = function (e) {
	      // this.setState({
	      //   showFloorScroll: this.floors.clientHeight < this.floors.scrollHeight
	      // })
	    };
	
	    _this.handleTouchStart = function (e) {
	      _this.handleMouseDown(e.touches[0]);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.setState({ dragging: true });
	      // Set coords
	      _this.coords = {
	        x: e.pageX,
	        y: e.pageY
	      };
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ dragging: false });
	      _this.coords = {};
	    };
	
	    _this.handleTouchMove = function (e) {
	      _this.handleMove(e.touches[0]);
	    };
	
	    _this.handleMouseMove = function (e) {
	      if (!_this.state.dragging) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleMove(e);
	    };
	
	    _this.handleMove = function (e) {
	      var xDiff = _this.coords.x - e.pageX;
	      var yDiff = _this.coords.y - e.pageY;
	      // Update to our new coordinates
	      _this.coords.x = e.pageX;
	      _this.coords.y = e.pageY;
	
	      _this.setState({
	        x: _this.state.x - xDiff,
	        y: _this.state.y - yDiff
	      });
	    };
	
	    _this.handleFloorClick = function (row) {
	      _this.setState({
	        row: row
	      });
	    };
	
	    _this.handleNextFloorClick = function (row) {
	      // this.floors.scrollTop += this.floors.clientHeight
	    };
	
	    _this.handlePrevFloorClick = function (row) {
	      // this.floors.scrollTop -= this.floors.clientHeight
	    };
	
	    _this.renderRow = function (_ref, i) {
	      var _cn;
	
	      var name = _ref.name;
	
	      var disabled = _this.props.sectionCells[i].cells.filter(function (cell) {
	        return cell && !cell.hidden && cell.pointers && cell.mark !== false;
	      }).length === 0;
	      return _react2.default.createElement(
	        'div',
	        {
	          key: i,
	          className: (0, _classnames2.default)(_Gallery2.default.FloorItem, (_cn = {}, _defineProperty(_cn, _Gallery2.default.Active, i === _this.state.row), _defineProperty(_cn, _Gallery2.default.Light, disabled), _cn)),
	          onClick: _this.handleFloorClick.bind(_this, i)
	        },
	        ' ',
	        name,
	        ' '
	      );
	    };
	
	    _this.state = {
	      hoverCellId: null,
	      dragging: false,
	      scale: 1,
	      x: 0,
	      y: 0,
	      row: props.row,
	      showFloorScroll: false
	    };
	    return _this;
	  }
	
	  _createClass(ChessGalleryPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousemove', this.handleMouseMove, false);
	      document.addEventListener('mouseup', this.handleMouseUp, false);
	      document.addEventListener('touchmove', this.handleTouchMove, false);
	      document.addEventListener('touchend', this.handleMouseUp, false);
	      window.addEventListener('resize', this.adjustFloorScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.handleMouseMove, false);
	      document.removeEventListener('mouseup', this.handleMouseUp, false);
	      document.removeEventListener('touchmove', this.handleTouchMove, false);
	      document.removeEventListener('touchend', this.handleMouseUp, false);
	      window.removeEventListener('resize', this.adjustFloorScroll);
	    }
	  }, {
	    key: 'renderVectorOverlay',
	    value: function renderVectorOverlay() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$all = _ref2.all,
	          all = _ref2$all === undefined ? false : _ref2$all;
	
	      var rowData = arguments[1];
	      var _props = this.props,
	          row = _props.row,
	          sectionCells = _props.sectionCells,
	          selected = _props.data,
	          pointers = _props.pointers;
	      // const data = rowData;
	
	      if (pointers) {
	        var _pointers$split = pointers.split(':'),
	            _pointers$split2 = _slicedToArray(_pointers$split, 2),
	            width = _pointers$split2[0],
	            height = _pointers$split2[1];
	
	        var coordinates = pointers.split(':')[2];
	        var cs = coordinates.split(',');
	        var path = cs.reduce(function (path, c, i) {
	          return path.concat(i % 2 === 1 ? c + ' L ' : c + ' ');
	        }, 'M ').replace(/L $/, 'Z');
	        return _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.Plan },
	          _react2.default.createElement(
	            'div',
	            { className: 'lol' },
	            _react2.default.createElement(
	              'svg',
	              {
	                xmlns: 'http://www.w3.org/2000/svg',
	                height: height,
	                width: width,
	                viewBox: '0 0 ' + width + ' ' + height
	              },
	              _react2.default.createElement(
	                'g',
	                null,
	                _react2.default.createElement('path', {
	                  className: (0, _classnames2.default)(_Gallery2.default.Flat, _Gallery2.default.SelectedFlat),
	                  d: path
	                })
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          building = _props2.building,
	          room = _props2.data,
	          rows = _props2.rows,
	          client = _props2.client,
	          sectionId = _props2.sectionId,
	          filters = _props2.filters,
	          pavilionsFlat = _props2.pavilionsFlat,
	          handleFilters = _props2.handleFilters,
	          sectionCells = _props2.sectionCells,
	          cells = _props2.cells,
	          isClientView = _props2.isClientView,
	          planId = _props2.planId,
	          floor = _props2.floor,
	          roomData = _props2.roomData,
	          t = _props2.t;
	
	      var rowCells = sectionCells[this.state.row].cells.filter(function (cell) {
	        return cell && cell.pointers;
	      });
	
	      var _split = (rowCells[0] && rowCells[0].pointers || '0:0').split(':'),
	          _split2 = _slicedToArray(_split, 2),
	          width = _split2[0],
	          height = _split2[1];
	
	      var _state = this.state,
	          scale = _state.scale,
	          x = _state.x,
	          y = _state.y;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Gallery2.default.PopUpOuter },
	        _react2.default.createElement(
	          'div',
	          { className: _Gallery2.default.PopUpInner },
	          _react2.default.createElement(
	            'div',
	            { className: _Gallery2.default.FloorPlanWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanTop },
	              !isClientView ? _react2.default.createElement(_Filters2.default, {
	                pavilions: building.pavilions,
	                pavilionsFlat: pavilionsFlat,
	                filters: filters,
	                handleFilters: handleFilters,
	                search: filters,
	                chessfilter: 'true',
	                cells: cells
	              }) : _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.ModalName },
	                t('components.flatsList.flatListItem.gallery.modalName')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.Close, onClick: this.props.onClose },
	                _react2.default.createElement('img', { src: _cross2.default, alt: 'close' })
	              )
	            ),
	            !isClientView && _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanLeft },
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.SelectFloor },
	                this.state.showFloorScroll && _react2.default.createElement('div', {
	                  className: (0, _classnames2.default)(_Gallery2.default.SelectFloorArrow, _Gallery2.default.Top),
	                  onClick: this.handlePrevFloorClick
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Gallery2.default.Floors },
	                  rows.map(this.renderRow)
	                ),
	                this.state.showFloorScroll && _react2.default.createElement('div', {
	                  className: (0, _classnames2.default)(_Gallery2.default.SelectFloorArrow, _Gallery2.default.Bottom),
	                  onClick: this.handleNextFloorClick
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Gallery2.default.FloorPlanRight },
	              _react2.default.createElement(_About2.default, {
	                data: { data: roomData },
	                building: building,
	                client: client,
	                sectionId: sectionId,
	                withImage: false,
	                chessfilter: true,
	                isClientView: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: _Gallery2.default.FloorPlan,
	                onWheel: this.handleMouseWheel,
	                onMouseDown: this.handleMouseDown,
	                onTouchStart: this.handleTouchStart,
	                style: {
	                  cursor: this.state.dragging ? '-webkit-grabbing' : 'default'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.FloorTitle },
	                t('components.flatsList.flatListItem.gallery.floor', { floor: floor })
	              ),
	              (isClientView || !!rowCells[0]) && _react2.default.createElement(
	                'div',
	                { className: _Gallery2.default.ZoomButtons },
	                _react2.default.createElement('div', { onClick: this.zoomOut, className: (0, _classnames2.default)(_Gallery2.default.ZoomBtn, _Gallery2.default.ZoomOut) }),
	                _react2.default.createElement('input', { type: 'range', value: this.state.scale, step: 0.01, min: MIN_SCALE, max: MAX_SCALE, onChange: this.handleZoomChange, onMouseDown: this.handleZoomMouseDown }),
	                _react2.default.createElement('div', { onClick: this.zoomIn, className: (0, _classnames2.default)(_Gallery2.default.ZoomBtn, _Gallery2.default.ZoomIn) })
	              ),
	              _react2.default.createElement(
	                _SpinnerImage2.default,
	                {
	                  key: this.state.row,
	                  className: _Gallery2.default.ImageInfo
	                  // imageSrc={`${ROOT_URL}/image/plan?id=${rowCells[0] ? rowCells[0].planId : null}&preset=1000`}
	                  , imageSrc: _Config.ROOT_URL + '/image/plan?id=' + (planId || null) + '&preset=1000',
	                  imageAlt: 'Room',
	                  spinner: _react2.default.createElement('div', { className: _Gallery2.default.LoaderInfo }),
	                  blur: this.props.isChessLoading,
	                  style: _extends({}, height && width && {
	                    width: Math.min(69, 54 * width / height) + 'vmin',
	                    height: Math.min(54, 69 * height / width) + 'vmin',
	                    transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')'
	                  }, this.state.dragging && { transition: '0s' })
	                },
	                this.renderVectorOverlay({ all: true }, rowCells[0])
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChessGalleryPopup;
	}(_react.Component);
	
	var ChessGalleryPopupWithRouter = exports.ChessGalleryPopupWithRouter = (0, _reactRouterDom.withRouter)(ChessGalleryPopup);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewType = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1388);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewType = exports.ViewType = function ViewType(_ref) {
	  var viewType = _ref.viewType;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  if (!viewType) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: _styles2.default.Container },
	    viewType !== 'panoramicView' ? 'ВИД НА ' : '',
	    t('constants.view_type.filter.' + viewType)
	  );
	};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FlatsListItem = __webpack_require__(993);
	
	var _FlatsListItem2 = _interopRequireDefault(_FlatsListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatsListItem2.default;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(12);
	
	var _Dropdown = __webpack_require__(216);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Menu = __webpack_require__(217);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _styles = __webpack_require__(171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubFilters = function (_Component) {
	  _inherits(SubFilters, _Component);
	
	  function SubFilters() {
	    _classCallCheck(this, SubFilters);
	
	    return _possibleConstructorReturn(this, (SubFilters.__proto__ || Object.getPrototypeOf(SubFilters)).apply(this, arguments));
	  }
	
	  _createClass(SubFilters, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          sorts = _props.sorts,
	          sort = _props.sort,
	          sortKeys = _props.sortKeys,
	          total = _props.total,
	          handleSortChange = _props.handleSortChange,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.FlatsListTitle },
	        _react2.default.createElement(
	          'p',
	          null,
	          total,
	          ' ',
	          (0, _utils.pluralize)(total, t('components.flatsList.subFilters.flat1'), t('components.flatsList.subFilters.flat2'), t('components.flatsList.subFilters.flat3'))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.FlatsListSort },
	          _react2.default.createElement(
	            _Dropdown2.default,
	            {
	              className: (0, _classnames2.default)(_styles2.default.Dropdown),
	              buttonStyle: _styles2.default.DropdownButton,
	              iconStyle: _styles2.default.DropdownIcon,
	              text: t('components.flatsList.subFilters.sort', {
	                sort: sorts[sort].text
	              }),
	              textStyle: _styles2.default.DropdownText,
	              topShift: true
	            },
	            _react2.default.createElement(
	              _Menu2.default,
	              { rightArrow: true, pure: true, className: _styles2.default.DropdownMenu },
	              sortKeys.map(function (key) {
	                return _react2.default.createElement(
	                  'span',
	                  {
	                    onClick: function onClick() {
	                      return handleSortChange(key);
	                    },
	                    className: _styles2.default.DropdownMenuItem,
	                    key: key
	                  },
	                  sorts[key].text
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubFilters;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(SubFilters);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubFilters = __webpack_require__(997);
	
	var _SubFilters2 = _interopRequireDefault(_SubFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SubFilters2.default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FlatsList = __webpack_require__(992);
	
	var _FlatsList2 = _interopRequireDefault(_FlatsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatsList2.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _style = __webpack_require__(1389);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = _react2.default.memo(function () {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _style2.default.Footer },
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: t('components.footer.innKpp') } }),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: t('components.footer.address') } }),
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.FooterDeveloper },
	      _react2.default.createElement('a', {
	        href: 'https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip',
	        target: '__blank',
	        dangerouslySetInnerHTML: { __html: t('components.footer.softDeveloper') }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        t('components.footer.copied')
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://app.nedvex.ru/policy', target: '__blank' },
	          t('components.footer.docs')
	        )
	      )
	    )
	  );
	});
	
	exports.default = Footer;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _favorites = __webpack_require__(160);
	
	var _updateArrows = __webpack_require__(237);
	
	var _updateArrows2 = _interopRequireDefault(_updateArrows);
	
	var _utils = __webpack_require__(12);
	
	var _ChessLink = __webpack_require__(925);
	
	var _ChessLink2 = _interopRequireDefault(_ChessLink);
	
	var _Print = __webpack_require__(472);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _ShareButton = __webpack_require__(1093);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _Collections = __webpack_require__(929);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Loader = __webpack_require__(504);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _BuildingTitle = __webpack_require__(1390);
	
	var _BuildingTitle2 = _interopRequireDefault(_BuildingTitle);
	
	var _iconHeart = __webpack_require__(342);
	
	var _iconHeart2 = _interopRequireDefault(_iconHeart);
	
	var _iconHeartActive = __webpack_require__(544);
	
	var _iconHeartActive2 = _interopRequireDefault(_iconHeartActive);
	
	var _iconVerified = __webpack_require__(550);
	
	var _iconVerified2 = _interopRequireDefault(_iconVerified);
	
	var _logoBlack = __webpack_require__(349);
	
	var _logoBlack2 = _interopRequireDefault(_logoBlack);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	var _InaccuracyReport = __webpack_require__(469);
	
	var _InaccuracyReport2 = _interopRequireDefault(_InaccuracyReport);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Marker from 'react-icons/lib/fa/map-marker';
	
	var BuildingTitle = function (_Component) {
	  _inherits(BuildingTitle, _Component);
	
	  function BuildingTitle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BuildingTitle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BuildingTitle.__proto__ || Object.getPrototypeOf(BuildingTitle)).call.apply(_ref, [this].concat(args))), _this), _this.sendEvent = function (event) {
	      var _ref2 = _this.props.data || {},
	          id = _ref2.id,
	          title = _ref2.title;
	
	      _tracker2.default.sendEvent(event, {
	        id: id, name: title
	      });
	    }, _this.handleTrackEvent = function (_ref3) {
	      var eventName = _ref3.eventName,
	          buttonName = _ref3.buttonName;
	      var _this$props = _this.props,
	          profile = _this$props.profile,
	          objectType = _this$props.objectType,
	          data = _this$props.data;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: buttonName,
	        eventContent: data.title,
	        productType: objectType,
	        productName: data.title,
	        productID: data.id,
	        user_id: profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BuildingTitle, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      this.setState({ onTop: scrollTop === 0 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isBuildingLoading = _props.isBuildingLoading,
	          data = _props.data,
	          client = _props.client,
	          userUid = _props.userUid,
	          print = _props.print,
	          showInfo = _props.showInfo,
	          t = _props.t,
	          profile = _props.profile,
	          objectType = _props.objectType,
	          rest = _objectWithoutProperties(_props, ['isBuildingLoading', 'data', 'client', 'userUid', 'print', 'showInfo', 't', 'profile', 'objectType']);
	
	      var _ref4 = data || {},
	          id = _ref4.id,
	          title = _ref4.title,
	          address = _ref4.address,
	          subregion = _ref4.subregion,
	          pavilions = _ref4.pavilions,
	          favorite = _ref4.favorite,
	          update = _ref4.update;
	
	      var year = void 0,
	          quarter = void 0;
	
	      if (isBuildingLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(client ? _BuildingTitle2.default.BuildingTitleClient : _BuildingTitle2.default.BuildingTitle, _defineProperty({}, _BuildingTitle2.default.BuildingTitlePrint, print)) },
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingTitle2.default.WireframeTop },
	              _react2.default.createElement('span', null),
	              _react2.default.createElement('span', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingTitle2.default.WireframeBottom },
	              _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonCollections }),
	              _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonFavor }),
	              _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonPrint }),
	              _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonChess })
	            )
	          ),
	          _react2.default.createElement(_Loader2.default, { active: this.props.building.isLoading })
	        );
	      }
	
	      var building = rest.building;
	
	      var buildingInfo = {
	        pavilions: data.pavilions,
	        title: data.title,
	        address: data.address,
	        subregion: data.subregion.name,
	        imageId: data.image ? data.image.id : null,
	        is_verified: data.is_verified,
	        status: data.status
	      };
	
	      var check = 20994; // 2099 г. 4 кв.
	      var finished = (pavilions || []).some(function (pavilion) {
	        var construction_finished = pavilion.construction_finished,
	            year_built = pavilion.year_built,
	            construction_ending = pavilion.construction_ending;
	
	        var current = Number('' + year_built + construction_ending);
	        if (year_built && construction_ending && check > current) {
	          check = current;
	          year = year_built;quarter = construction_ending;
	        }
	        return construction_finished;
	      });
	      var deadline = buildingInfo.status == 3 ? t('components.header.buildingTitle.almostFinished') : finished ? t('components.header.buildingTitle.finished') : year === 0 ? t('components.header.buildingTitle.inProgress') : year && quarter ? quarter + ' / ' + year : '';
	
	      var updateTime = void 0;
	      if (update) {
	        if (print) {
	          updateTime = (0, _utils.updateStringPrint)(update);
	        } else if ((0, _utils.updateString)(update).indexOf('Сегодня') == 0) {
	          updateTime = t('components.header.buildingTitle.today');
	        } else {
	          updateTime = (0, _utils.updateString)(update);
	        }
	      }
	
	      var renderInfo = function renderInfo() {
	        return (0, _helper.isSectionAllowed)('nameAddress') ? _react2.default.createElement(
	          'div',
	          { className: _BuildingTitle2.default.LeftInfo },
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.ObjectName },
	            _react2.default.createElement(
	              'span',
	              null,
	              showInfo === '0' ? t('components.header.buildingTitle.lot', { id: id }) : title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingTitle2.default.Status },
	              buildingInfo.is_verified && _react2.default.createElement('img', {
	                className: _BuildingTitle2.default.Verified,
	                alt: t('components.header.buildingTitle.verified'),
	                title: t('components.header.buildingTitle.verified'),
	                src: _iconVerified2.default
	              }),
	              data.view_action ? _react2.default.createElement(
	                'div',
	                { className: _BuildingTitle2.default.PromoLabel },
	                t('components.header.buildingTitle.promo')
	              ) : null,
	              deadline && _react2.default.createElement(
	                'div',
	                { className: (0, _bind2.default)(buildingInfo.status == 3 ? _BuildingTitle2.default.AlmostFinished : finished ? _BuildingTitle2.default.Green : _BuildingTitle2.default.Yellow, _BuildingTitle2.default.StatusBlock) },
	                deadline
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _bind2.default)(_BuildingTitle2.default.ObjectAddress, _defineProperty({}, _BuildingTitle2.default.ObjectAddressShare, location.href.includes('/nbref/') || location.href.includes('/ncollection/')))
	            },
	            '' + (subregion ? subregion.name + (address && showInfo !== '0' ? ', ' : '') : '') + (address && showInfo !== '0' ? address : '')
	          )
	        ) : null;
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bind2.default)(client ? _BuildingTitle2.default.BuildingTitleClient : _BuildingTitle2.default.BuildingTitle, _defineProperty({}, _BuildingTitle2.default.BuildingTitlePrint, print)) },
	        _react2.default.createElement(
	          'div',
	          { className: _BuildingTitle2.default.Container },
	          data ? client ? _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.Inner },
	            renderInfo()
	          ) : renderInfo() : _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.WireframeTop },
	            _react2.default.createElement('span', null),
	            _react2.default.createElement('span', null)
	          ),
	          data ? _react2.default.createElement(
	            'div',
	            {
	              className: _BuildingTitle2.default.UpdatedTime,
	              'data-tip': t('components.header.buildingTitle.updatedAt'),
	              'data-for': 'global'
	            },
	            !print ? _react2.default.createElement('img', { alt: 'icon', src: _updateArrows2.default }) : null,
	            _react2.default.createElement(
	              'span',
	              null,
	              print ? _react2.default.createElement(
	                'span',
	                { className: _BuildingTitle2.default.UpdatedTimeTextPrint },
	                t('components.header.buildingTitle.updatedFrom')
	              ) : null,
	              updateTime
	            )
	          ) : null,
	          data ? !client && _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.Buttons },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _BuildingTitle2.default.InaccuracyReportButtonWrap,
	                onClick: function onClick() {
	                  return _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    buttonName: 'soobshchit_o_netochnosti'
	                  });
	                }
	              },
	              _react2.default.createElement(_InaccuracyReport2.default, {
	                building: data,
	                className: _BuildingTitle2.default.InaccuracyReportWrap,
	                profile: profile,
	                objectType: objectType
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _BuildingTitle2.default.AddToFavoritesButtonWrap },
	              _react2.default.createElement(_Collections2.default, {
	                onClick: function onClick() {
	                  _this2.sendEvent('Web_Card_Add_Selection');
	                  _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    buttonName: 'v_podborku'
	                  });
	                },
	                building: building,
	                className: _BuildingTitle2.default.CollectionWrap,
	                profile: profile,
	                objectType: objectType
	              }),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: (0, _bind2.default)(_BuildingTitle2.default.AddToFavoritesButton, _defineProperty({}, _BuildingTitle2.default.Active, favorite)),
	                  onClick: function onClick() {
	                    _this2.props[favorite ? 'removeFromFavorites' : 'addToFavorites']({ buildingId: id, userUid: userUid }, { buildingName: title, data: data }, { profileId: profile.id, objectType: objectType });
	                    _this2.sendEvent(favorite ? 'Web_Card_Remove_Favorites' : 'Web_Card_Add_Favorites');
	                    _this2.handleTrackEvent({
	                      eventName: 'buildingTitleButtonsClick',
	                      buttonName: 'v_izbrannoe'
	                    });
	                  },
	                  'data-tip': t('components.header.buildingTitle.addToFavorites'),
	                  'data-for': 'global'
	                },
	                favorite ? _react2.default.createElement('img', { src: _iconHeartActive2.default, alt: '' }) : _react2.default.createElement('img', { src: _iconHeart2.default, alt: '' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _bind2.default)(_BuildingTitle2.default.ShareButtonWrap, _BuildingTitle2.default.Hide1120) },
	              _react2.default.createElement(_ShareButton2.default, {
	                onClick: function onClick() {
	                  _this2.sendEvent('Web_Card_Share');
	                  _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    buttonName: 'podelitsya'
	                  });
	                },
	                building: this.props.building,
	                profile: profile,
	                objectType: objectType,
	                tooltip: t('components.header.buildingTitle.share')
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _bind2.default)(_BuildingTitle2.default.PrintButtonWrap, _BuildingTitle2.default.Hide1120),
	                onClick: function onClick() {
	                  _this2.sendEvent('Web_Card_Print');
	                  _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    buttonName: 'pechat_informacii'
	                  });
	                }
	              },
	              _react2.default.createElement(_Print2.default, _extends({}, rest, {
	                buildingInfo: buildingInfo,
	                profile: profile,
	                objectType: objectType,
	                tooltip: t('components.header.buildingTitle.print')
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: _BuildingTitle2.default.ChessLinkWrap,
	                onClick: function onClick() {
	                  _this2.sendEvent('Web_Card_Checkerboard');
	                  _this2.handleTrackEvent({
	                    eventName: 'buildingTitleButtonsClick',
	                    buttonName: 'shahmatka'
	                  });
	                }
	              },
	              _react2.default.createElement(_ChessLink2.default, _extends({}, rest, { className: _BuildingTitle2.default.ChessLink }))
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: _BuildingTitle2.default.WireframeBottom },
	            _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonCollections }),
	            _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonFavor }),
	            _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonPrint }),
	            _react2.default.createElement('div', { className: _BuildingTitle2.default.WireframeButtonChess })
	          )
	        ),
	        _react2.default.createElement(_Loader2.default, { active: this.props.building.isLoading })
	      );
	    }
	  }]);
	
	  return BuildingTitle;
	}(_react.Component);
	
	var buildingTitleSelector = (0, _reselect.createSelector)(function (state, props) {
	  return props.building.data || state.building.data;
	}, function (state) {
	  return state.profile.hash;
	}, function (state) {
	  return state.privacy.withClient;
	}, function (data, userUid, withClient) {
	  return {
	    data: data,
	    userUid: userUid,
	    withClient: withClient
	  };
	});
	
	exports.default = (0, _reactRedux.connect)(buildingTitleSelector, { addToFavorites: _favorites.addToFavorites, removeFromFavorites: _favorites.removeFromFavorites })((0, _reactI18next.withTranslation)()(BuildingTitle));

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ClientHeader = __webpack_require__(1391);
	
	var _ClientHeader2 = _interopRequireDefault(_ClientHeader);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Config = __webpack_require__(16);
	
	var _collections = __webpack_require__(49);
	
	var _environment = __webpack_require__(19);
	
	var _RealtorPopup = __webpack_require__(498);
	
	var _RealtorPopup2 = _interopRequireDefault(_RealtorPopup);
	
	var _Avatar = __webpack_require__(1101);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Footer = __webpack_require__(1003);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(1018);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _iconInfo = __webpack_require__(1544);
	
	var _iconInfo2 = _interopRequireDefault(_iconInfo);
	
	var _iconBackWhite = __webpack_require__(1536);
	
	var _iconBackWhite2 = _interopRequireDefault(_iconBackWhite);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router-dom'
	
	// import { formatPhoneNumber } from 'utils'
	
	
	var ClientHeader = function (_Component) {
	  _inherits(ClientHeader, _Component);
	
	  function ClientHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClientHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClientHeader.__proto__ || Object.getPrototypeOf(ClientHeader)).call.apply(_ref, [this].concat(args))), _this), _this.showPopup = function () {
	      _this.props.setPopUp(_react2.default.createElement(_RealtorPopup2.default, _this.props.user), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        closeClassName: _ClientHeader2.default.PopupCompanyClose,
	        backgroundClassName: _ClientHeader2.default.PopupCompanyBg,
	        contentClassName: _ClientHeader2.default.PopupCompanyContent,
	        lockScroll: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClientHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$user = _props.user,
	          user = _props$user === undefined ? {} : _props$user,
	          t = _props.t;
	      var _user$agency = user.agency,
	          agency = _user$agency === undefined ? {} : _user$agency;
	      var name = agency.name,
	          logoId = agency.logoId,
	          _agency$color = agency.color,
	          color = _agency$color === undefined ? '#2B313B' : _agency$color;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ClientHeader2.default.ClientWrapper },
	        _react2.default.createElement(
	          'style',
	          null,
	          '#root > div {padding-top: 0;}'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_ClientHeader2.default.HeaderCollections), style: { background: color }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _ClientHeader2.default.Container },
	            name ? _react2.default.createElement(
	              'div',
	              { className: _ClientHeader2.default.AgencyBlock },
	              _react2.default.createElement(
	                'div',
	                { className: _ClientHeader2.default.AgencyAvatar },
	                _react2.default.createElement(_Avatar2.default, {
	                  className: _ClientHeader2.default.AgencyAvatarImage,
	                  image: logoId ? _Config.ROOT_URL + '/image/get?id=' + logoId + '&preset=profile_avatar' : null
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _ClientHeader2.default.AgencyName },
	                name
	              )
	            ) : null,
	            (
	            // Бугага!
	            document.location.pathname.includes('map') || document.location.pathname.includes('building')) && _react2.default.createElement(
	              'div',
	              { className: _ClientHeader2.default.BackToList },
	              _react2.default.createElement(
	                'a',
	                { href: '/collection/view/' + this.props.params.referal },
	                _react2.default.createElement('img', { src: _iconBackWhite2.default, alt: '' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('components.header.clientHeader.backToList')
	                )
	              )
	            )
	          )
	        ),
	        this.props.children,
	        _react2.default.createElement(_Footer2.default, {
	          agency: agency
	        })
	      );
	    }
	  }]);
	
	  return ClientHeader;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.collection);
	}, { loadCollection: _collections.loadCollection, setPopUp: _environment.setPopUp })((0, _reactI18next.withTranslation)()(ClientHeader));

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1392);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactRedux = __webpack_require__(5);
	
	var _utils = __webpack_require__(12);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionsFooter = function (_Component) {
	  _inherits(CollectionsFooter, _Component);
	
	  function CollectionsFooter() {
	    _classCallCheck(this, CollectionsFooter);
	
	    return _possibleConstructorReturn(this, (CollectionsFooter.__proto__ || Object.getPrototypeOf(CollectionsFooter)).apply(this, arguments));
	  }
	
	  _createClass(CollectionsFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          agency = _props.agency,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.CollectionsFooterWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.CollectionsFooter },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.CollectionsFooterLeft },
	            agency.office ? _react2.default.createElement(
	              'div',
	              null,
	              agency.name ? _react2.default.createElement(
	                'p',
	                { className: _styles2.default.CollectionsFooterTitle },
	                agency.name
	              ) : '',
	              agency.office[0].address ? _react2.default.createElement(
	                'p',
	                { className: _styles2.default.CollectionsFooterText },
	                t('components.header.clientHeader.address'),
	                ': ',
	                agency.office[0].address
	              ) : '',
	              agency.office[0].phone ? _react2.default.createElement(
	                'p',
	                { className: _styles2.default.CollectionsFooterText },
	                t('components.header.clientHeader.phone'),
	                ': ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:' + agency.office[0].phone },
	                  (0, _utils.formatPhoneNumber)(agency.office[0].phone)
	                )
	              ) : '',
	              agency.office[0].mail ? _react2.default.createElement(
	                'p',
	                { className: _styles2.default.CollectionsFooterText },
	                t('components.header.clientHeader.mail'),
	                ': ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:' + agency.office[0].mail },
	                  agency.office[0].mail
	                )
	              ) : '',
	              agency.website ? _react2.default.createElement(
	                'p',
	                { className: _styles2.default.CollectionsFooterText },
	                t('components.header.clientHeader.website'),
	                ': ',
	                _react2.default.createElement(
	                  'a',
	                  { href: (0, _utils.addUrlProtocol)(agency.website, 'http'), target: '_blank' },
	                  agency.website
	                )
	              ) : ''
	            ) : ''
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollectionsFooter;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null)((0, _reactI18next.withTranslation)()(CollectionsFooter));

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _style = __webpack_require__(1393);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  prkng: { param: 'prkng', key: 'parking', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.parking'), event: 'Web_Filters_Parking' },
	  elvtr: { param: 'elvtr', key: 'elevator', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.elevator'), event: 'Web_Filters_Recreation_Elevator' },
	  cncrg: { param: 'cncrg', key: 'concierge', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.concierge'), event: 'Web_Filters_Concierge' },
	  chldrn: { param: 'chldrn', key: 'children_area', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.childrenArea'), event: 'Web_Filters_Children_Playground' },
	  rcrtzn: { param: 'rcrtzn', key: 'recreation_zone', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.recreationZone'), event: 'Web_Filters_Recreation_Area' },
	  pool: { param: 'pool', key: 'pool', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.pool'), event: 'Web_Filters_Swimming_Pool' },
	  housetrr: { param: 'housetrr', key: 'houseTerritory', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.houseTerritory'), event: 'Web_Filters_House_Territory' },
	  spa: { param: 'spa', key: 'spa', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.spa'), event: 'Web_Filters_SPA' },
	  cctv: { param: 'cctv_surveillance', key: 'cctv_surveillance', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.cctv'), event: 'Web_Filters_CCTV' },
	  commerc: { param: 'commerc', key: 'commercial_property', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.commercialProperty'), event: 'Web_Filters_Commercial_Property' },
	  kpp: { param: 'kpp', key: 'kpp', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.kpp'), event: 'Web_Filters_KPP' },
	  wlns: { param: 'wlns', key: 'is_wellness_building', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.wellnessBuilding'), event: 'Web_Filters_Wellness_Building' },
	  beach: { param: 'beach', key: 'is_beach', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.beach'), event: 'Web_Filters_Beach' },
	  walk: { param: 'walk', key: ' is_walking_area', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.walkingArea'), event: 'Web_Filters_Walking_Area' },
	  rstrnt: { param: 'rstrnt', key: 'restaurant', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.restaurant'), event: 'Web_Filters_Restaurant' },
	  sport: { param: 'sport', key: 'sport_area', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.sportArea'), event: 'Web_Filters_Sport_Area' },
	  roof: { param: 'roof', key: 'is_operated_roof', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.operatedRoof'), event: 'Web_Filters_Operated_Roof' },
	  zbbq: { param: 'zbbq', key: 'zone_bbq', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.zbbq'), event: 'Web_Filters_Zone_Bbq' },
	  nw: { param: 'nw', key: 'new', text: _i18n2.default.t('components.header.filtersBar.filters.advantages.new'), event: 'Web_Filters_New' }
	};
	
	var checkIsOnePropDefined = function checkIsOnePropDefined(arr) {
	  return arr.length > 0;
	};
	
	var countDefinedProps = function countDefinedProps(arr) {
	  return arr.length;
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var advantages = search.advantages;
	
	  if (!advantages) {
	    return { advantages: [] };
	  }
	  var keys = advantages.split(',');
	  return {
	    advantages: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.advantages;
	
	  if (!keys.length) {
	    return { advantages: undefined };
	  }
	
	  return {
	    advantages: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var advantages = data.advantages;
	
	  return { advantages: advantages.length ? advantages : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var Advantages = function (_Component) {
	  _inherits(Advantages, _Component);
	
	  function Advantages(props) {
	    _classCallCheck(this, Advantages);
	
	    var _this = _possibleConstructorReturn(this, (Advantages.__proto__ || Object.getPrototypeOf(Advantages)).call(this, props));
	
	    _this.state = {
	      isExpanded: false
	    };
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    _this.toggleExpand = _this.toggleExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(Advantages, [{
	    key: 'handleClearClick',
	    value: function handleClearClick(e) {
	      e.stopPropagation();
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { advantages: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'eshchyo',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch = parseSearch(search),
	          keys = _parseSearch.advantages;
	
	      var advantages = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (advantages.includes(key) !== add) {
	        if (add) {
	          advantages.push(key);
	        } else {
	          advantages.splice(advantages.indexOf(key), 1);
	        }
	      }
	
	      var data = { advantages: advantages };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch2 = parseSearch(search),
	          advantages = _parseSearch2.advantages;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _style2.default.Checkbox,
	        innerStyle: _style2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: advantages.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        additional: additional,
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'toggleExpand',
	    value: function toggleExpand() {
	      this.setState(function (prevState) {
	        return { isExpanded: !prevState.isExpanded };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          search = _props4.search,
	          isCottegePage = _props4.isCottegePage,
	          t = _props4.t;
	
	      var _parseSearch3 = parseSearch(search),
	          advantages = _parseSearch3.advantages;
	
	      var isAdvatagesDefiend = checkIsOnePropDefined(advantages);
	      var isExpanded = this.state.isExpanded;
	
	      var selectedCount = countDefinedProps(advantages);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.Menu, className, _defineProperty({}, _style2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Header, onClick: this.toggleExpand },
	          _react2.default.createElement(
	            'span',
	            { className: _style2.default.Title },
	            t('components.header.filtersBar.filters.advantages.title'),
	            selectedCount > 0 && ' (' + selectedCount + ')',
	            _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_style2.default.Icon, _defineProperty({}, _style2.default.Active, isExpanded)) })
	          ),
	          additional && isAdvatagesDefiend && _react2.default.createElement(
	            _Button2.default,
	            { className: _style2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.advantages.clear')
	          )
	        ),
	        isExpanded && _react2.default.createElement(
	          'div',
	          null,
	          isCottegePage ? _react2.default.createElement(
	            'div',
	            { className: _style2.default.Checkboxes },
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.FirstColumn },
	              this.checkbox('spa'),
	              this.checkbox('chldrn'),
	              this.checkbox('cncrg'),
	              this.checkbox('nw'),
	              this.checkbox('walk'),
	              this.checkbox('roof')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.SecondColumn },
	              this.checkbox('pool'),
	              this.checkbox('zbbq'),
	              this.checkbox('kpp'),
	              this.checkbox('wlns'),
	              this.checkbox('rstrnt')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.ThirdColumn },
	              this.checkbox('cctv'),
	              this.checkbox('commerc'),
	              this.checkbox('elvtr'),
	              this.checkbox('beach'),
	              this.checkbox('sport')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: _style2.default.Checkboxes },
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.FirstColumn },
	              this.checkbox('spa'),
	              this.checkbox('chldrn'),
	              this.checkbox('cncrg'),
	              this.checkbox('nw'),
	              this.checkbox('walk'),
	              this.checkbox('roof')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.SecondColumn },
	              this.checkbox('pool'),
	              this.checkbox('zbbq'),
	              this.checkbox('kpp'),
	              this.checkbox('wlns'),
	              this.checkbox('rstrnt')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.ThirdColumn },
	              this.checkbox('cctv'),
	              this.checkbox('commerc'),
	              this.checkbox('elvtr'),
	              this.checkbox('beach'),
	              this.checkbox('sport')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Advantages;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Advantages);

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BuildingClass = __webpack_require__(1395);
	
	var _BuildingClass2 = _interopRequireDefault(_BuildingClass);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  1: { param: '1', key: '1', text: _i18n2.default.t('components.header.filtersBar.filters.buildingClass.variant1'), event: 'Web_Filters_Economy' },
	  2: { param: '2', key: '2', text: _i18n2.default.t('components.header.filtersBar.filters.buildingClass.variant2'), event: 'Web_Filters_Comfort' },
	  3: { param: '3', key: '3', text: _i18n2.default.t('components.header.filtersBar.filters.buildingClass.variant3'), event: 'Web_Filters_Business' },
	  4: { param: '4', key: '4', text: _i18n2.default.t('components.header.filtersBar.filters.buildingClass.variant4'), event: 'Web_Filters_Elite' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var buildingClass = search.buildingClass;
	
	  if (!buildingClass) {
	    return { buildingClass: [] };
	  }
	  var keys = buildingClass.split(',');
	  return {
	    buildingClass: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.buildingClass;
	
	  if (!keys.length) {
	    return { buildingClass: undefined };
	  }
	
	  return {
	    buildingClass: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var buildingClass = data.buildingClass;
	
	  return { buildingClass: buildingClass.length ? buildingClass : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.buildingClass;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.buildingClass.notSelected');
	};
	
	var BuildingClass = function (_Component) {
	  _inherits(BuildingClass, _Component);
	
	  function BuildingClass(props) {
	    _classCallCheck(this, BuildingClass);
	
	    var _this = _possibleConstructorReturn(this, (BuildingClass.__proto__ || Object.getPrototypeOf(BuildingClass)).call(this, props));
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BuildingClass, [{
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { buildingClass: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick('building');
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'eshchyo',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.buildingClass;
	
	      var buildingClass = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (buildingClass.includes(key) !== add) {
	        if (add) {
	          buildingClass.push(key);
	        } else {
	          buildingClass.splice(buildingClass.indexOf(key), 1);
	        }
	      }
	
	      var data = { buildingClass: buildingClass };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch3 = parseSearch(search),
	          buildingClass = _parseSearch3.buildingClass;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _BuildingClass2.default.Checkbox,
	        innerStyle: _BuildingClass2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: buildingClass.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        additional: additional,
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          search = _props4.search,
	          t = _props4.t;
	
	      var _parseSearch4 = parseSearch(search),
	          buildingClass = _parseSearch4.buildingClass;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_BuildingClass2.default.Menu, className, _defineProperty({}, _BuildingClass2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'p',
	          { className: _BuildingClass2.default.Title },
	          t('components.header.filtersBar.filters.buildingClass.title'),
	          !additional ? !!buildingClass.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _BuildingClass2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.buildingClass.clear')
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _BuildingClass2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingClass2.default.FirstColumn },
	            this.checkbox('1'),
	            this.checkbox('2')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _BuildingClass2.default.SecondColumn },
	            this.checkbox('3'),
	            this.checkbox('4')
	          )
	        ),
	        additional ? _react2.default.createElement(
	          'div',
	          { className: _BuildingClass2.default.ButtonWrap },
	          !!buildingClass.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _BuildingClass2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.buildingClass.clear')
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return BuildingClass;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)(BuildingClass);

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Deadline = __webpack_require__(1396);
	
	var _Deadline2 = _interopRequireDefault(_Deadline);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var variants = [{
	  key: 'deadlineEnd',
	  text: _i18n2.default.t('components.header.filtersBar.filters.deadline.finished'),
	  event: 'Web_Filters_Passed'
	}, {
	  key: '2024/1/2/3/4',
	  text: '2024',
	  event: 'Web_Filters_2024'
	}, {
	  key: '2025/1/2/3/4',
	  text: '2025',
	  event: 'Web_Filters_2025'
	}, {
	  key: '2026/1/2/3/4',
	  text: '2026',
	  event: 'Web_Filters_2026'
	}, {
	  key: '2027/1/2/3/4',
	  text: '2027',
	  event: 'Web_Filters_2027'
	}, {
	  key: '2028/1/2/3/4',
	  text: '2028',
	  event: 'Web_Filters_2028'
	}, {
	  key: '2029/1/2/3/4',
	  text: '2029',
	  event: 'Web_Filters_2029'
	}, {
	  key: '2030/1/2/3/4',
	  text: '2030',
	  event: 'Web_Filters_2030'
	}];
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var deadline = search.deadline;
	
	  if (!deadline) {
	    return { deadline: [] };
	  }
	  return { deadline: deadline.split(',') };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.deadline;
	
	  if (!keys.length) {
	    return { deadline: undefined };
	  }
	  return {
	    deadline: keys.join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var keys = data.deadline;
	
	  var deadline = [].concat(_toConsumableArray(keys));
	  var deadlineEnd = false;
	  if (deadline.includes('deadlineEnd')) {
	    deadline.splice(deadline.indexOf('deadlineEnd'), 1);
	    deadlineEnd = true;
	  }
	  return { deadline: deadline.length ? deadline : undefined, deadlineEnd: deadlineEnd };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.deadline;
	
	  var deadline = [].concat(_toConsumableArray(keys));
	
	  var subtext = deadline.map(function (key) {
	    var oldDate = key.split('/');
	    var newDate = oldDate.slice(1);
	    if (oldDate.length > 1) {
	      return _i18n2.default.t('components.header.filtersBar.filters.deadline.quarter', {
	        data: '`' + oldDate[0] + ' - ' + newDate.join(', ')
	      });
	    }
	    return variants.find(function (variant) {
	      return variant.key === key;
	    }).text;
	  });
	  return subtext.join(', ') || _i18n2.default.t('components.header.filtersBar.filters.deadline.notSelected');
	};
	
	function isIncludes(_ref) {
	  var deadline = _ref.deadline,
	      key = _ref.key;
	
	  return deadline.some(function (date) {
	    var splitedDate = date.split('/');
	    var splitedKey = key.split('/');
	    return splitedKey.every(function (elem) {
	      return splitedDate.includes(elem);
	    });
	  });
	}
	
	function removeFromDeadline(_ref2) {
	  var deadline = _ref2.deadline,
	      key = _ref2.key,
	      isGroup = _ref2.isGroup;
	
	  var newDeadline = [];
	  deadline.forEach(function (date) {
	    var splitedDate = date.split('/');
	    var splitedKey = key.split('/');
	
	    if (splitedKey.every(function (elem) {
	      return splitedDate.includes(elem);
	    })) {
	      if (!isGroup) {
	        delete splitedKey[0];
	        var newDeadlineDate = splitedDate.filter(function (val) {
	          return !splitedKey.includes(val);
	        });
	
	        if (newDeadlineDate.length > 1) {
	          return newDeadline.push(newDeadlineDate.join('/'));
	        }
	        return;
	      }
	      return;
	    }
	    return newDeadline.push(date);
	  });
	
	  return newDeadline;
	}
	
	function addToDeadline(_ref3) {
	  var deadline = _ref3.deadline,
	      key = _ref3.key,
	      isGroup = _ref3.isGroup;
	
	  var newDeadline = [];
	  var splitedKey = key.split('/');
	  var nooneDateStartsWithKey = true;
	
	  deadline.forEach(function (date) {
	    var splitedDate = date.split('/');
	    if (splitedDate[0] === splitedKey[0]) {
	      nooneDateStartsWithKey = false;
	      if (isGroup) {
	        return newDeadline.push(key);
	      }
	      splitedDate.push(splitedKey[1]);
	      return newDeadline.push(splitedDate.join('/'));
	    }
	    return newDeadline.push(date);
	  });
	
	  if (nooneDateStartsWithKey) {
	    newDeadline = [].concat(_toConsumableArray(deadline), [key]);
	  }
	
	  return newDeadline;
	}
	
	function isGroupPartialChecked(_ref4) {
	  var deadline = _ref4.deadline,
	      key = _ref4.key;
	
	  return deadline.some(function (date) {
	    var splitedDate = date.split('/');
	    var splitedKey = key.split('/');
	    return splitedDate.includes(splitedKey[0]);
	  });
	}
	
	var Deadline = function (_Component) {
	  _inherits(Deadline, _Component);
	
	  function Deadline(props) {
	    _classCallCheck(this, Deadline);
	
	    var _this = _possibleConstructorReturn(this, (Deadline.__proto__ || Object.getPrototypeOf(Deadline)).call(this, props));
	
	    _this.handleCheckboxForNonNumValueClick = function (key, add) {
	      var _this$props = _this.props,
	          search = _this$props.search,
	          dropdownData = _this$props.dropdownData,
	          mode = _this$props.mode,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.deadline;
	
	      var deadline = [].concat(_toConsumableArray(keys));
	      if (deadline.includes(key) !== add) {
	        if (add) {
	          deadline.push(key);
	        } else {
	          deadline.splice(deadline.indexOf(key), 1);
	        }
	      }
	
	      _tracker2.default.sendEvent('Web_Filters_Passed', {
	        mode: window.location.search.includes('view=map') ? 'map' : 'list',
	        checked: add
	      });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : null;
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      var data = { deadline: deadline };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    };
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    _this.handleToggleSectionClick = _this.handleToggleSectionClick.bind(_this);
	
	    _this.state = {
	      isToggle2024: false,
	      isToggle2025: false,
	      isToggle2026: false,
	      isToggle2027: false,
	      isToggle2028: false,
	      isToggle2029: false,
	      isToggle2030: false
	    };
	    return _this;
	  }
	
	  _createClass(Deadline, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var search = this.props.search;
	
	      var _parseSearch3 = parseSearch(search),
	          deadline = _parseSearch3.deadline;
	
	      if (deadline.length) {
	        for (var i = 0; i < deadline.length; i++) {
	          if (~deadline[i].indexOf('2024')) {
	            this.setState({ isToggle2024: true });
	          }
	          if (~deadline[i].indexOf('2025')) {
	            this.setState({ isToggle2025: true });
	          }
	          if (~deadline[i].indexOf('2026')) {
	            this.setState({ isToggle2026: true });
	          }
	          if (~deadline[i].indexOf('2027')) {
	            this.setState({ isToggle2027: true });
	          }
	          if (~deadline[i].indexOf('2028')) {
	            this.setState({ isToggle2028: true });
	          }
	          if (~deadline[i].indexOf('2029')) {
	            this.setState({ isToggle2029: true });
	          }
	          if (~deadline[i].indexOf('2030')) {
	            this.setState({ isToggle2030: true });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { deadline: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick && this.props.onClearClick('deadline');
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'srok_sdachi',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(_ref5, add) {
	      var key = _ref5.key,
	          isGroup = _ref5.isGroup;
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch4 = parseSearch(search),
	          keys = _parseSearch4.deadline;
	
	      var deadline = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var splitKey = key.split('/');
	      var year = splitKey[0];
	      var variantSubnume = splitKey[0] + '/' + splitKey[1];
	      var isChecked = add ? 'on' : 'off';
	
	      var eventContent = void 0;
	
	      var isFullQuarterFormat = splitKey.length === 5 && splitKey[1] === '1' && splitKey[2] === '2' && splitKey[3] === '3' && splitKey[4] === '4';
	
	      if (isFullQuarterFormat) {
	        eventContent = [year, ' | ' + isChecked];
	      } else {
	        eventContent = [variantSubnume + '_\u043A\u0432\u0430\u0440\u0442\u0430\u043B', ' | ' + isChecked];
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: eventContent,
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (isIncludes({ deadline: deadline, key: key, isGroup: isGroup }) !== add) {
	        if (add) {
	          deadline = deadline.length ? addToDeadline({ deadline: deadline, key: key, isGroup: isGroup }) : [key];
	        } else {
	          deadline = removeFromDeadline({ deadline: deadline, key: key, isGroup: isGroup });
	        }
	      }
	      var data = { deadline: deadline };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key, isGroup) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional,
	          t = _props3.t;
	
	      var _parseSearch5 = parseSearch(search),
	          deadline = _parseSearch5.deadline;
	
	      var date = key.split('/');
	      var year = date[0];
	      var period = date[1];
	
	      var isChecked = isIncludes({ deadline: deadline, key: key, isGroup: isGroup });
	      var checkboxProps = {};
	      if (isGroup) {
	        checkboxProps.partialChecked = isGroupPartialChecked({ deadline: deadline, key: key });
	      }
	
	      return _react2.default.createElement(_Checkbox2.default, _extends({
	        className: _Deadline2.default.Checkbox,
	        innerStyle: _Deadline2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: isChecked
	      }, checkboxProps, {
	        additional: additional,
	        handle: this.handleCheckboxClick.bind(undefined, { key: key, isGroup: isGroup }),
	        text: date.length < 5 ? t('components.header.filtersBar.filters.deadline.quarter', { data: period }) : year
	      }));
	    }
	  }, {
	    key: 'handleToggleSectionClick',
	    value: function handleToggleSectionClick(year) {
	      if (this.state[year]) {
	        this.setState(_defineProperty({}, year, false));
	      } else {
	        this.setState(_defineProperty({}, year, true));
	      }
	
	      // this.setState(prevState => ({
	      //   [year]: !prevState[year]
	      // }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          className = _props4.className,
	          search = _props4.search,
	          additional = _props4.additional,
	          t = _props4.t;
	
	      var _parseSearch6 = parseSearch(search),
	          deadline = _parseSearch6.deadline;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Deadline2.default.Menu, className, _defineProperty({}, _Deadline2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Deadline2.default.Title },
	          t('components.header.filtersBar.filters.deadline.title'),
	          !!deadline.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Deadline2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.deadline.clear')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Deadline2.default.Checkboxes },
	          _react2.default.createElement(_Checkbox2.default, {
	            className: _Deadline2.default.Checkbox,
	            innerStyle: _Deadline2.default.FiltersCheckInner,
	            classNameClone: 'CheckboxCloneFilters',
	            checked: deadline.includes('deadlineEnd'),
	            additional: additional,
	            handle: this.handleCheckboxForNonNumValueClick.bind(undefined, 'deadlineEnd'),
	            text: t('components.header.filtersBar.filters.deadline.finished')
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2024/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2024)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2024');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2024)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2024/1'),
	                this.checkbox('2024/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2024/2'),
	                this.checkbox('2024/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2025/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2025)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2025');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2025)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2025/1'),
	                this.checkbox('2025/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2025/2'),
	                this.checkbox('2025/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2026/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2026)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2026');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2026)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2026/1'),
	                this.checkbox('2026/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2026/2'),
	                this.checkbox('2026/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2027/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2027)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2027');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2027)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2027/1'),
	                this.checkbox('2027/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2027/2'),
	                this.checkbox('2027/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2028/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2028)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2028');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2028)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2028/1'),
	                this.checkbox('2028/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2028/2'),
	                this.checkbox('2028/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2029/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2029)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2029');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2029)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2029/1'),
	                this.checkbox('2029/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2029/2'),
	                this.checkbox('2029/4')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Deadline2.default.DeadlineSection },
	            _react2.default.createElement(
	              'div',
	              { className: _Deadline2.default.DeadlineSectionHead },
	              this.checkbox('2030/1/2/3/4', true),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionToggle, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2030)), onClick: function onClick() {
	                    return _this2.handleToggleSectionClick('isToggle2030');
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Plus },
	                  '+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Deadline2.default.Minus },
	                  '-'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Deadline2.default.DeadlineSectionBody, _defineProperty({}, _Deadline2.default.Active, this.state.isToggle2030)) },
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.FirstColumn },
	                this.checkbox('2030/1'),
	                this.checkbox('2030/3')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Deadline2.default.SecondColumn },
	                this.checkbox('2030/2'),
	                this.checkbox('2030/4')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Deadline;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Deadline);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _style = __webpack_require__(1397);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var variants = {
	  chernInt: { param: 'chernInt', key: 'chernInt', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.chernInt'), event: 'Web_Filters_Chern_Int' },
	  chistInt: { param: 'chistInt', key: 'chistInt', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.chistInt'), event: 'Web_Filters_Сhist_Int' },
	  predChistInt: { param: 'predChistInt', key: 'predChistInt', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.predChistInt'), event: 'Web_Filters_Pred_Сhist_Int' },
	  remInt: { param: 'remInt', key: 'remInt', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.remInt'), event: 'Web_Filters_Rem_Int' },
	  whiteBox: { param: 'whiteBox', key: 'whiteBox', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.whiteBox'), event: 'Web_Filters_White_Box' },
	  repair: { param: 'repair', key: 'repair', text: _i18n2.default.t('components.header.filtersBar.filters.decoration.repair'), event: 'Web_Filters_Repair'
	    // 'chastRemInt': { param: 'chastRemInt', key: 'chastRemInt', text: i18n.t('components.header.filtersBar.filters.decoration.chastRemInt') }
	  } };
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var interior = search.interior;
	
	  if (!interior) {
	    return { interior: [] };
	  }
	  var keys = interior.split(',');
	  return {
	    interior: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.interior;
	
	  if (!keys || !keys.length) {
	    return { interior: undefined };
	  }
	
	  return {
	    interior: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var interior = data.interior;
	
	  return { interior: interior.length ? interior : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var countDefinedProps = function countDefinedProps(obj) {
	  return Object.values(obj).filter(function (value) {
	    return value;
	  }).length;
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.interior;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.decoration.notSelected');
	};
	
	var Decoration = function Decoration(props) {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var handleClearClick = function handleClearClick(e) {
	    e.stopPropagation();
	    var dropdownData = props.dropdownData;
	
	    var data = { interior: [] };
	    var compiledSearch = compileSearch(data);
	    var compiledRequest = compileRequest(data);
	    dropdownData(compiledSearch, compiledRequest);
	    props.onClearClick && props.onClearClick('interior');
	
	    (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	      eventContent: 'eshchyo',
	      eventContext: props.mode,
	      productType: props.objectType,
	      user_id: props.profile.id
	    }));
	  };
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isExpanded = _useState2[0],
	      setIsExpanded = _useState2[1];
	
	  var handleCheckboxClick = function handleCheckboxClick(key, add) {
	    var search = props.search,
	        dropdownData = props.dropdownData,
	        eventData = props.eventData,
	        mode = props.mode,
	        objectType = props.objectType,
	        profile = props.profile;
	
	    var _parseSearch2 = parseSearch(search),
	        keys = _parseSearch2.interior;
	
	    var interior = [].concat(_toConsumableArray(keys));
	
	    _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	    var variant = variants[Object.keys(variants).find(function (v) {
	      return variants[v].key === key;
	    })];
	    var variantName = variant ? variant.text : 'Unknown variant';
	    var isChecked = add ? 'on' : 'off';
	
	    (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	      eventContent: [variantName, ' | ' + isChecked],
	      eventContext: mode,
	      productType: objectType,
	      user_id: profile.id
	    }));
	
	    if (interior.includes(key) !== add) {
	      if (add) {
	        interior.push(key);
	      } else {
	        interior.splice(interior.indexOf(key), 1);
	      }
	    }
	
	    var data = { interior: interior };
	    var compiledSearch = compileSearch(data);
	    var compiledRequest = compileRequest(data);
	    dropdownData(compiledSearch, compiledRequest);
	  };
	
	  var checkbox = function checkbox(key) {
	    var search = props.search,
	        additional = props.additional;
	
	    var _parseSearch3 = parseSearch(search),
	        interior = _parseSearch3.interior;
	
	    var variant = variants[key];
	    return _react2.default.createElement(_Checkbox2.default, {
	      className: _style2.default.Checkbox,
	      innerStyle: _style2.default.FiltersCheckInner,
	      classNameClone: 'CheckboxCloneFilters',
	      checked: interior.includes(variant.key),
	      handle: function handle(value) {
	        return handleCheckboxClick(variant.key, value);
	      },
	      additional: additional,
	      text: variant.text
	    });
	  };
	
	  var className = props.className,
	      additional = props.additional,
	      search = props.search,
	      isCottegePage = props.isCottegePage;
	
	  var _parseSearch4 = parseSearch(search),
	      interior = _parseSearch4.interior;
	
	  var name = isCottegePage ? t('components.header.filtersBar.filters.decoration.title') : t('components.header.filtersBar.filters.decoration.titleFull');
	  var selectedCount = interior.length;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_style2.default.Menu, className, _defineProperty({}, _style2.default.Additional, additional)) },
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.Header, onClick: function onClick() {
	          return setIsExpanded(!isExpanded);
	        } },
	      _react2.default.createElement(
	        'span',
	        { className: _style2.default.Title },
	        name,
	        selectedCount > 0 && ' (' + selectedCount + ')',
	        _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_style2.default.Icon, _defineProperty({}, _style2.default.Active, isExpanded)) })
	      ),
	      additional && interior.length > 0 && _react2.default.createElement(
	        _Button2.default,
	        { className: _style2.default.Button, onClick: handleClearClick },
	        t('components.header.filtersBar.filters.decoration.clear')
	      )
	    ),
	    isExpanded && _react2.default.createElement(
	      'div',
	      { className: _style2.default.Checkboxes },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.FirstColumn },
	        checkbox('whiteBox'),
	        checkbox('repair')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.SecondColumn },
	        checkbox('predChistInt'),
	        checkbox('chernInt')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.ThirdColumn },
	        checkbox('remInt'),
	        checkbox('chistInt')
	      )
	    )
	  );
	};
	
	exports.default = Decoration;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _RadioMenu = __webpack_require__(1108);
	
	var _RadioMenu2 = _interopRequireDefault(_RadioMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var subregion = search.subregion,
	      region = search.region;
	
	  return {
	    subregion: subregion ? subregion.split(',') : [],
	    region: region ? region.split(',') : []
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var subregion = data.subregion,
	      region = data.region;
	
	  return { subregion: subregion.length ? subregion.sort(function (a, b) {
	      return a - b;
	    }).join(',') : undefined, region: region.length ? region.sort(function (a, b) {
	      return a - b;
	    }).join(',') : undefined };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var subregion = data.subregion,
	      region = data.region;
	
	  return { subregion: subregion.length ? subregion : undefined, region: region.length ? region : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var District = function (_Component) {
	  _inherits(District, _Component);
	
	  function District(props) {
	    _classCallCheck(this, District);
	
	    var _this = _possibleConstructorReturn(this, (District.__proto__ || Object.getPrototypeOf(District)).call(this, props));
	
	    _this.state = {
	      areas: []
	    };
	
	    _this.handleCheckbox = _this.handleCheckbox.bind(_this);
	    return _this;
	  }
	
	  _createClass(District, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props$cities$find = this.props.cities.find(function (_ref) {
	        var id = _ref.id;
	        return String(_this2.props.cityId) === String(id);
	      }),
	          areas = _props$cities$find.areas;
	
	      this.setState({ areas: areas });
	    }
	  }, {
	    key: 'handleCheckbox',
	    value: function handleCheckbox(keys) {
	      var dropdownData = this.props.dropdownData;
	
	
	      var regionIds = this.state.areas.reduce(function (acc, region) {
	        for (var i = 0; i < region.subareas.length; i++) {
	          var subRegion = region.subareas[i];
	
	          if (keys.includes(subRegion.id)) {
	            acc.push(region.id);
	          }
	        }
	        return [].concat(_toConsumableArray(new Set(acc)));
	      }, []);
	
	      var data = { subregion: keys, region: [].concat(_toConsumableArray(regionIds)) };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          search = _props.search,
	          className = _props.className,
	          objectType = _props.objectType,
	          profile = _props.profile,
	          mode = _props.mode;
	
	      var _parseSearch = parseSearch(search),
	          subregion = _parseSearch.subregion,
	          region = _parseSearch.region;
	
	      var regionsMenu = this.state.areas.map(function (region) {
	        return {
	          regionId: region.id,
	          tabText: region.name,
	          checkboxes: region.subareas.reduce(function (acc, item) {
	            acc[item.id] = item.name;
	            return acc;
	          }, {})
	        };
	      });
	
	      return regionsMenu.length > 0 && _react2.default.createElement(_RadioMenu2.default, {
	        className: className,
	        menus: regionsMenu,
	        checked: subregion,
	        handle: this.handleCheckbox,
	        objectType: objectType,
	        profile: profile,
	        mode: mode
	      });
	    }
	  }]);
	
	  return District;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cityId: state.profile.cityId,
	    cities: state.building.cities
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(District);

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FederalLaw = __webpack_require__(1398);
	
	var _FederalLaw2 = _interopRequireDefault(_FederalLaw);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  fz214: { param: 'fz214', key: 'ФЗ-214', text: _i18n2.default.t('components.header.filtersBar.filters.registration.fz214'), event: 'Web_Filters_FZ-214' },
	  fz215: { param: 'fz215', key: 'ФЗ-215', text: _i18n2.default.t('components.header.filtersBar.filters.registration.fz215'), event: 'Web_Filters_FZ-215' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var federal_law = search.federal_law;
	
	  if (!federal_law) {
	    return { federal_law: [] };
	  }
	  var keys = federal_law.split(',');
	  return {
	    federal_law: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.federal_law;
	
	  if (!keys.length) {
	    return { federal_law: undefined };
	  }
	
	  return {
	    federal_law: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var federal_law = data.federal_law;
	
	  return { federal_law: federal_law.length ? federal_law : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.federal_law;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.federalLaw.notSelected');
	};
	
	var FederalLaw = function (_Component) {
	  _inherits(FederalLaw, _Component);
	
	  function FederalLaw(props) {
	    _classCallCheck(this, FederalLaw);
	
	    var _this = _possibleConstructorReturn(this, (FederalLaw.__proto__ || Object.getPrototypeOf(FederalLaw)).call(this, props));
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FederalLaw, [{
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var dropdownData = this.props.dropdownData;
	
	      var data = { federal_law: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props = this.props,
	          search = _props.search,
	          dropdownData = _props.dropdownData,
	          eventData = _props.eventData;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.federal_law;
	
	      var federal_law = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      if (federal_law.includes(key) !== add) {
	        if (add) {
	          federal_law.push(key);
	        } else {
	          federal_law.splice(federal_law.indexOf(key), 1);
	        }
	      }
	
	      var data = { federal_law: federal_law };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var search = this.props.search;
	
	      var _parseSearch3 = parseSearch(search),
	          federal_law = _parseSearch3.federal_law;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _FederalLaw2.default.Checkbox,
	        innerStyle: _FederalLaw2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: federal_law.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        text: variants[key].text
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          additional = _props2.additional,
	          search = _props2.search,
	          t = _props2.t;
	
	      var _parseSearch4 = parseSearch(search),
	          federal_law = _parseSearch4.federal_law;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_FederalLaw2.default.Menu, className, _defineProperty({}, _FederalLaw2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'p',
	          { className: _FederalLaw2.default.Title },
	          t('components.header.filtersBar.filters.federalLaw.title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _FederalLaw2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _FederalLaw2.default.FirstColumn },
	            this.checkbox('fz214')
	          )
	        )
	      );
	    }
	  }]);
	
	  return FederalLaw;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(FederalLaw);

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Interior = __webpack_require__(1400);
	
	var _Interior2 = _interopRequireDefault(_Interior);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(93);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  chernInt: { param: 'chernInt', key: 'chernInt', text: _i18n2.default.t('components.header.filtersBar.filters.interior.chernInt'), event: 'Web_List_Filters_Rough' },
	  chistInt: { param: 'chistInt', key: 'chistInt', text: _i18n2.default.t('components.header.filtersBar.filters.interior.chistInt'), event: 'Web_List_Filters_Finishing' },
	  predChistInt: { param: 'predChistInt', key: 'predChistInt', text: _i18n2.default.t('components.header.filtersBar.filters.interior.predChistInt'), event: 'Web_List_Filters_Pre_Finishing' },
	  remInt: { param: 'remInt', key: 'remInt', text: _i18n2.default.t('components.header.filtersBar.filters.interior.remInt'), event: 'Web_List_Filters_Repair' },
	  chastRemInt: { param: 'chastRemInt', key: 'chastRemInt', text: _i18n2.default.t('components.header.filtersBar.filters.interior.chastRemInt'), event: 'Web_List_Filters_Partial_Repair' },
	  whiteBox: { param: 'whiteBox', key: 'whiteBox', text: _i18n2.default.t('components.header.filtersBar.filters.interior.whiteBox'), event: 'Web_List_Filters_WhiteBox' },
	  repair: { param: 'repair', key: 'repair', text: _i18n2.default.t('components.header.filtersBar.filters.interior.repair'), event: 'Web_List_Filters_RMT' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var interior = search.interior;
	
	
	  if (!interior) {
	    return { interior: [] };
	  }
	  var keys = interior.split(',');
	  return {
	    interior: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.interior;
	
	  if (!keys || !keys.length) {
	    return { interior: undefined };
	  }
	
	  return {
	    interior: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var interior = data.interior;
	
	  return { interior: interior.length ? interior : undefined }; // Room
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.interior;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.interior.notSelected');
	};
	
	var Interior = function (_Component) {
	  _inherits(Interior, _Component);
	
	  function Interior(props) {
	    _classCallCheck(this, Interior);
	
	    var _this = _possibleConstructorReturn(this, (Interior.__proto__ || Object.getPrototypeOf(Interior)).call(this, props));
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Interior, [{
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var dropdownData = this.props.dropdownData;
	
	      var data = { interior: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props = this.props,
	          search = _props.search,
	          dropdownData = _props.dropdownData,
	          eventData = _props.eventData,
	          mode = _props.mode,
	          objectType = _props.objectType,
	          profile = _props.profile,
	          buildingData = _props.buildingData;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.interior;
	
	      var interior = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      if (interior.includes(key) !== add) {
	        if (add) {
	          interior.push(key);
	        } else {
	          interior.splice(interior.indexOf(key), 1);
	        }
	      }
	
	      var data = { interior: interior };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.buildingChessFilterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        productName: buildingData.title,
	        productID: buildingData.id,
	        user_id: profile.id
	      }));
	
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var search = this.props.search;
	
	      var _parseSearch3 = parseSearch(search),
	          interior = _parseSearch3.interior;
	
	      var variant = variants[key];
	
	      return this.list.has(key) ? _react2.default.createElement(_Checkbox2.default, {
	        className: _Interior2.default.Checkbox,
	        innerStyle: _Interior2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: interior.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        text: variant.text
	      }) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          additional = _props2.additional,
	          search = _props2.search,
	          chessfilter = _props2.chessfilter,
	          cells = _props2.cells,
	          t = _props2.t;
	
	      var _parseSearch4 = parseSearch(search),
	          interior = _parseSearch4.interior;
	
	      this.list = cells.reduce(function (list, cell) {
	        return cell.data.status === 'saleStatus' || (0, _helper.isReserved)(cell.data.status) || cell.data.status === 'assignmentStatus' ? list.add(cell.data.interior) : list;
	      }, new Set());
	
	      if (!this.list.size) {
	        this.list.add('chernInt');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Interior2.default.Menu, className, _defineProperty({}, _Interior2.default.Additional, additional), _defineProperty({}, _Interior2.default.MenuChessfilter, chessfilter)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Interior2.default.Title },
	          t('components.header.filtersBar.filters.interior.title'),
	          !!interior.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Interior2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.interior.clear')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Interior2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _Interior2.default.FirstColumn },
	            this.checkbox('whiteBox'),
	            this.checkbox('predChistInt'),
	            this.checkbox('remInt'),
	            this.checkbox('repair')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Interior2.default.SecondColumn },
	            this.checkbox('chastRemInt'),
	            this.checkbox('chernInt'),
	            this.checkbox('chistInt')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Interior;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Interior);

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Payment = __webpack_require__(1401);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  mrt: { param: 'mrt', key: 'ipoteka', text: _i18n2.default.t('components.header.filtersBar.filters.payment.ipoteka'), event: 'Web_Filters_Mortgage' },
	  inst: { param: 'inst', key: 'installments', text: _i18n2.default.t('components.header.filtersBar.filters.payment.installments'), event: 'Web_Filters_Installment' },
	  mil: { param: 'mil', key: 'military_ipoteka', text: _i18n2.default.t('components.header.filtersBar.filters.payment.military_ipoteka'), event: 'Web_Filters_Military_Mortgage' },
	  capt: { param: 'capt', key: 'mat_capital', text: _i18n2.default.t('components.header.filtersBar.filters.payment.mat_capital'), event: 'Web_Filters_Maternity_Capital' },
	  taxes: { param: 'taxes', key: 'taxes', text: _i18n2.default.t('components.header.filtersBar.filters.payment.taxes'), event: 'Web_Filters_Taxes' },
	  cash: { param: 'cash', key: 'cash', text: _i18n2.default.t('components.header.filtersBar.filters.payment.cash'), event: 'Web_Filters_Cash' },
	
	  fmly: { param: 'fmly', key: 'is_ipoteka_family', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_family'), event: 'Web_Filters_Ipoteka_Family' },
	  sup: { param: 'sup', key: 'is_ipoteka_state_support', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_state_support'), event: 'Web_Filters_Ipoteka_State_Support' },
	  it: { param: 'it', key: 'is_ipoteka_it', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_it'), event: 'Web_Filters_Ipoteka_It' },
	  trnch: { param: 'trnch', key: 'is_ipoteka_tranche', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_tranche'), event: 'Web_Filters_Ipoteka_Tranche' },
	  sbsdy: { param: 'sbsdy', key: 'is_ipoteka_subsidized', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_subsidized'), event: 'Web_Filters_Ipoteka_Subsidized' },
	  prfntl: { param: 'prfntl', key: 'is_ipoteka_preferential', text: _i18n2.default.t('components.header.filtersBar.filters.payment.is_ipoteka_preferential'), event: 'Web_Filters_Ipoteka_Preferential' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var payment = search.payment;
	
	  if (!payment) {
	    return { payment: [] };
	  }
	  var keys = payment.split(',');
	  return {
	    payment: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.payment;
	
	  if (!keys.length) {
	    return { payment: undefined };
	  }
	
	  return {
	    payment: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var payment = data.payment;
	
	  return { paymentOptions: payment.length ? payment : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.payment;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.payment.notSelected');
	};
	
	var Payment = function (_Component) {
	  _inherits(Payment, _Component);
	
	  function Payment(props) {
	    _classCallCheck(this, Payment);
	
	    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Payment, [{
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { payment: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick('payment');
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'varianty_oplaty',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.payment;
	
	      var payment = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (payment.includes(key) !== add) {
	        if (add) {
	          payment.push(key);
	        } else {
	          payment.splice(payment.indexOf(key), 1);
	        }
	      }
	
	      var data = { payment: payment };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch3 = parseSearch(search),
	          payment = _parseSearch3.payment;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _Payment2.default.Checkbox,
	        innerStyle: _Payment2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: payment.includes(variant.key),
	        additional: additional,
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          search = _props4.search,
	          t = _props4.t;
	
	      var _parseSearch4 = parseSearch(search),
	          payment = _parseSearch4.payment;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Payment2.default.Menu, className, _defineProperty({}, _Payment2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Payment2.default.Title },
	          t('components.header.filtersBar.filters.payment.title'),
	          !additional ? !!payment.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Payment2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.payment.clear')
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Payment2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _Payment2.default.FirstColumn },
	            this.checkbox('taxes'),
	            this.checkbox('cash'),
	            this.checkbox('mrt'),
	            this.checkbox('mil'),
	            this.checkbox('fmly'),
	            this.checkbox('sup')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Payment2.default.SecondColumn },
	            this.checkbox('capt'),
	            this.checkbox('inst'),
	            this.checkbox('it'),
	            this.checkbox('trnch'),
	            this.checkbox('sbsdy'),
	            this.checkbox('prfntl')
	          )
	        ),
	        additional ? _react2.default.createElement(
	          'div',
	          { className: _Payment2.default.ButtonWrap },
	          !!payment.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Payment2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.payment.clear')
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Payment;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Payment);

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Registration = __webpack_require__(1403);
	
	var _Registration2 = _interopRequireDefault(_Registration);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// key - name
	// 1  Юстиция
	// 2  Предварительный договор
	// 3  Договор инвестирования
	// 4  Паевой взнос
	// 5  Договор бронирования
	// 6  Договор займа
	// 7  Договор простого товарищества
	// 8  Договор переуступки
	// 9  Договор купли-продажи
	// 10  Договор паенакопления
	// 11  Договор о намерениях
	// 12  Договор задатка
	// 13  Договор подряда
	// 14  ДДУ / ФЗ-214 (бывш. Договор долевого участия)
	
	var variants = {
	  part: { param: 'part', key: 14, text: _i18n2.default.t('components.header.filtersBar.filters.registration.part'), event: 'Web_Filters_Part' },
	  loan: { param: 'loan', key: 6, text: _i18n2.default.t('components.header.filtersBar.filters.registration.loan'), event: 'Web_Filters_Loan' },
	  inv: { param: 'inv', key: 3, text: _i18n2.default.t('components.header.filtersBar.filters.registration.inv'), event: 'Web_Filters_Inv' },
	  buySale: { param: 'buySale', key: 9, text: _i18n2.default.t('components.header.filtersBar.filters.registration.buySale'), event: 'Web_Filters_Buy_Sale' },
	  contract: { param: 'contract', key: 13, text: _i18n2.default.t('components.header.filtersBar.filters.registration.contract'), event: 'Web_Filters_Contract' },
	  prec: { param: 'prec', key: 2, text: _i18n2.default.t('components.header.filtersBar.filters.registration.prec'), event: 'Web_Filters_Prec' },
	  ust: { param: 'ust', key: 1, text: _i18n2.default.t('components.header.filtersBar.filters.registration.ust'), event: 'Web_Filters_Justice' },
	  shared: { param: 'shared', key: 4, text: _i18n2.default.t('components.header.filtersBar.filters.registration.shared') },
	  reserv: { param: 'reserv', key: 5, text: _i18n2.default.t('components.header.filtersBar.filters.registration.reserv') },
	  partnership: { param: 'partnership', key: 7, text: _i18n2.default.t('components.header.filtersBar.filters.registration.partnership') },
	  assignment: { param: 'assignment', key: 8, text: _i18n2.default.t('components.header.filtersBar.filters.registration.assignment') }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var registrations = search.registrations;
	
	  if (!registrations) {
	    return { registrations: [] };
	  }
	  var keys = registrations.split(',');
	  return {
	    registrations: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.registrations;
	
	  if (!keys.length) {
	    return { registrations: undefined, federalLaw: undefined };
	  }
	
	  var compiled = {
	    registrations: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	
	  // Добавляем параметр federalLaw если выбран ключ 14
	  if (keys.includes(14)) {
	    compiled.federalLaw = 'ФЗ-214';
	  } else {
	    compiled.federalLaw = undefined;
	  }
	
	  return compiled;
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var registrations = data.registrations;
	
	  var request = { registrations: registrations.length ? registrations : undefined };
	
	  // Добавляем параметр federalLaw если выбран ключ 14
	  if (registrations.includes(14)) {
	    request.federalLaw = ['ФЗ-214'];
	  } else {
	    request.federalLaw = undefined;
	  }
	
	  return request;
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.registrations;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || null;
	  // .join(', ') || i18n.t('components.header.filtersBar.filters.registration.notSelected');
	};
	
	var Registration = function (_Component) {
	  _inherits(Registration, _Component);
	
	  function Registration(props) {
	    _classCallCheck(this, Registration);
	
	    var _this = _possibleConstructorReturn(this, (Registration.__proto__ || Object.getPrototypeOf(Registration)).call(this, props));
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Registration, [{
	    key: 'handleClearClick',
	    value: function handleClearClick() {
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          profile = _props.profile,
	          mode = _props.mode,
	          objectType = _props.objectType;
	
	      var data = { registrations: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'oformlenie',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.registrations;
	
	      var registrations = [].concat(_toConsumableArray(keys));
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (registrations.includes(key) !== add) {
	        if (add) {
	          registrations.push(key);
	        } else {
	          registrations.splice(registrations.indexOf(key), 1);
	        }
	      }
	
	      var data = { registrations: registrations };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var search = this.props.search;
	
	      var _parseSearch3 = parseSearch(search),
	          registrations = _parseSearch3.registrations;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _Registration2.default.Checkbox,
	        innerStyle: _Registration2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: registrations.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        text: variants[key].text
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          additional = _props3.additional,
	          search = _props3.search,
	          t = _props3.t;
	
	      var _parseSearch4 = parseSearch(search),
	          registrations = _parseSearch4.registrations;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Registration2.default.Menu, className, _defineProperty({}, _Registration2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'p',
	          { className: _Registration2.default.Title },
	          t('components.header.filtersBar.filters.registration.title'),
	          !!registrations.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Registration2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.registration.clear')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Registration2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _Registration2.default.FirstColumn },
	            this.checkbox('part'),
	            this.checkbox('loan'),
	            this.checkbox('inv'),
	            this.checkbox('buySale')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Registration2.default.SecondColumn },
	            this.checkbox('contract'),
	            this.checkbox('prec'),
	            this.checkbox('ust')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Registration;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Registration);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Sea = __webpack_require__(1404);
	
	var _Sea2 = _interopRequireDefault(_Sea);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  500: { param: '500', key: '500', text: _i18n2.default.t('components.header.filtersBar.filters.sea.500'), event: 'Web_Filters_Up_To_500' },
	  1500: { param: '1500', key: '1500', text: _i18n2.default.t('components.header.filtersBar.filters.sea.1500'), event: 'Web_Filters_Up_To_1500' },
	  3000: { param: '3000', key: '3000', text: _i18n2.default.t('components.header.filtersBar.filters.sea.3000'), event: 'Web_Filters_Up_To_3000' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var sea = search.sea;
	
	  return { sea: sea };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var sea = data.sea;
	
	  return { sea: sea };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var sea = data.sea;
	
	  return { distanceToSea: sea };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      sea = _parseSearch.sea;
	
	  return sea && sea.text || _i18n2.default.t('components.header.filtersBar.filters.sea.notSelected');
	};
	
	var Sea = function (_Component) {
	  _inherits(Sea, _Component);
	
	  function Sea(props) {
	    _classCallCheck(this, Sea);
	
	    var _this = _possibleConstructorReturn(this, (Sea.__proto__ || Object.getPrototypeOf(Sea)).call(this, props));
	
	    _this.state = {
	      isExpanded: false
	    };
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    _this.toggleExpand = _this.toggleExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(Sea, [{
	    key: 'handleClearClick',
	    value: function handleClearClick(e) {
	      e.stopPropagation();
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { sea: undefined };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick('sea');
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'eshchyo',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, checked) {
	      var _props2 = this.props,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var data = { sea: checked ? key : undefined };
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: checked, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = checked ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch2 = parseSearch(search),
	          sea = _parseSearch2.sea;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _Sea2.default.Checkbox,
	        innerStyle: _Sea2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: sea === key,
	        type: 'radio',
	        additional: additional,
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'toggleExpand',
	    value: function toggleExpand() {
	      this.setState(function (prevState) {
	        return { isExpanded: !prevState.isExpanded };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          search = _props4.search,
	          t = _props4.t;
	
	      var _parseSearch3 = parseSearch(search),
	          sea = _parseSearch3.sea;
	
	      var isExpanded = this.state.isExpanded;
	
	      var selectedCount = sea ? 1 : 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Sea2.default.Menu, className, _defineProperty({}, _Sea2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'div',
	          { className: _Sea2.default.Header, onClick: this.toggleExpand },
	          _react2.default.createElement(
	            'span',
	            { className: _Sea2.default.Title },
	            t('components.header.filtersBar.filters.sea.title'),
	            selectedCount > 0 && ' (' + selectedCount + ')',
	            _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_Sea2.default.Icon, _defineProperty({}, _Sea2.default.Active, isExpanded)) })
	          ),
	          additional && sea && _react2.default.createElement(
	            _Button2.default,
	            { className: _Sea2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.sea.clear')
	          )
	        ),
	        isExpanded && _react2.default.createElement(
	          'div',
	          { className: _Sea2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _Sea2.default.FirstColumn },
	            this.checkbox('500')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Sea2.default.SecondColumn },
	            this.checkbox('1500')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Sea2.default.ThirdColumn },
	            this.checkbox('3000')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Sea;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Sea);

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subtext = exports.getRequest = exports.compileRequest = exports.compileSearch = exports.parseSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _Type = __webpack_require__(1405);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var variants = {
	  flat: { param: 'flat', key: 'apartmentRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.flat'), event: 'Web_Filters_Flat' },
	  apt: { param: 'apt', key: 'apartRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.apt'), event: 'Web_Filters_Apartments' },
	  lvn: { param: 'lvn', key: 'zhiloeRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.lvn'), event: 'Web_Filters_Zhiloe_Room' },
	  nlvn: { param: 'nlvn', key: 'nezhiloeRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.nlvn'), event: 'Web_Filters_Nezhiloe_Room' },
	  hotelRoom: { param: 'hotel', key: 'hotelRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.hotelRoom'), event: 'Web_Filters_Hotel_Room' },
	  zhiloeHouse: { param: 'lvnh', key: 'zhiloeHouse', text: _i18n2.default.t('components.header.filtersBar.filters.type.zhiloeHouse'), event: 'Web_Filters_Zhiloe_House' },
	  storageRoom: { param: 'strg', key: 'storageRoom', text: _i18n2.default.t('components.header.filtersBar.filters.type.storageRoom'), event: 'Web_Filters_Storage_Room' }
	};
	
	var parseSearch = exports.parseSearch = function parseSearch(search) {
	  var type = search.type;
	
	  if (!type) {
	    return { type: [] };
	  }
	  var keys = type.split(',');
	  return {
	    type: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.param)) {
	        prev.push(variant.key);
	      }
	      return prev;
	    }, [])
	  };
	};
	
	var compileSearch = exports.compileSearch = function compileSearch(data) {
	  var keys = data.type;
	
	  if (!keys || !keys.length) {
	    return { type: undefined };
	  }
	
	  return {
	    type: Object.keys(variants).reduce(function (prev, cur) {
	      var variant = variants[cur];
	      if (keys.includes(variant.key)) {
	        prev.push(variant.param);
	      }
	      return prev;
	    }, []).join(',') || undefined
	  };
	};
	
	var compileRequest = exports.compileRequest = function compileRequest(data) {
	  var type = data.type;
	
	  return { typeRoom: type.length ? type : undefined };
	};
	
	var getRequest = exports.getRequest = function getRequest(search) {
	  return compileRequest(parseSearch(search));
	};
	
	var countDefinedProps = function countDefinedProps(obj) {
	  return Object.values(obj).filter(function (value) {
	    return value;
	  }).length;
	};
	
	var subtext = exports.subtext = function subtext(search) {
	  var _parseSearch = parseSearch(search),
	      keys = _parseSearch.type;
	
	  return Object.keys(variants).reduce(function (prev, cur) {
	    var variant = variants[cur];
	    if (keys.includes(variant.key)) {
	      prev.push(variant.text);
	    }
	    return prev;
	  }, []).join(', ') || _i18n2.default.t('components.header.filtersBar.filters.type.notSelected');
	};
	
	var Type = function (_Component) {
	  _inherits(Type, _Component);
	
	  function Type(props) {
	    _classCallCheck(this, Type);
	
	    var _this = _possibleConstructorReturn(this, (Type.__proto__ || Object.getPrototypeOf(Type)).call(this, props));
	
	    _this.state = {
	      isExpanded: true
	    };
	
	    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
	    _this.handleClearClick = _this.handleClearClick.bind(_this);
	    _this.toggleExpand = _this.toggleExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(Type, [{
	    key: 'handleClearClick',
	    value: function handleClearClick(e) {
	      e.stopPropagation();
	      var _props = this.props,
	          dropdownData = _props.dropdownData,
	          mode = _props.mode,
	          profile = _props.profile,
	          objectType = _props.objectType;
	
	      var data = { type: [] };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	      this.props.onClearClick('type');
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	        eventContent: 'eshchyo',
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(key, add) {
	      var _props2 = this.props,
	          search = _props2.search,
	          dropdownData = _props2.dropdownData,
	          eventData = _props2.eventData,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	
	      var _parseSearch2 = parseSearch(search),
	          keys = _parseSearch2.type;
	
	      var type = [].concat(_toConsumableArray(keys));
	
	      _tracker2.default.sendVariantEvent({ variants: variants, key: key, selected: add, eventData: eventData });
	
	      var variant = variants[Object.keys(variants).find(function (v) {
	        return variants[v].key === key;
	      })];
	      var variantName = variant ? variant.text : 'Unknown variant';
	      var isChecked = add ? 'on' : 'off';
	
	      (0, _ga.trackGA)(_ga.gaEvent.filterCheckboxesClick({
	        eventContent: [variantName, ' | ' + isChecked],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	
	      if (type.includes(key) !== add) {
	        if (add) {
	          type.push(key);
	        } else {
	          type.splice(type.indexOf(key), 1);
	        }
	      }
	
	      var data = { type: type };
	      var compiledSearch = compileSearch(data);
	      var compiledRequest = compileRequest(data);
	      dropdownData(compiledSearch, compiledRequest);
	    }
	  }, {
	    key: 'checkbox',
	    value: function checkbox(key) {
	      var _props3 = this.props,
	          search = _props3.search,
	          additional = _props3.additional;
	
	      var _parseSearch3 = parseSearch(search),
	          type = _parseSearch3.type;
	
	      var variant = variants[key];
	      return _react2.default.createElement(_Checkbox2.default, {
	        className: _Type2.default.Checkbox,
	        innerStyle: _Type2.default.FiltersCheckInner,
	        classNameClone: 'CheckboxCloneFilters',
	        checked: type.includes(variant.key),
	        handle: this.handleCheckboxClick.bind(undefined, variant.key),
	        additional: additional,
	        text: variant.text
	      });
	    }
	  }, {
	    key: 'toggleExpand',
	    value: function toggleExpand() {
	      this.setState(function (prevState) {
	        return { isExpanded: !prevState.isExpanded };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          additional = _props4.additional,
	          search = _props4.search,
	          t = _props4.t;
	
	      var _parseSearch4 = parseSearch(search),
	          type = _parseSearch4.type;
	
	      var isExpanded = this.state.isExpanded;
	
	      var selectedCount = countDefinedProps(type);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Type2.default.Menu, className, _defineProperty({}, _Type2.default.Additional, additional)) },
	        _react2.default.createElement(
	          'div',
	          { className: _Type2.default.Header, onClick: this.toggleExpand },
	          _react2.default.createElement(
	            'span',
	            { className: _Type2.default.Title },
	            t('components.header.filtersBar.filters.type.title'),
	            selectedCount > 0 && ' (' + selectedCount + ')',
	            _react2.default.createElement(_angleDown2.default, { className: (0, _classnames2.default)(_Type2.default.Icon, _defineProperty({}, _Type2.default.Active, isExpanded)) })
	          ),
	          additional && !!type.length && _react2.default.createElement(
	            _Button2.default,
	            { className: _Type2.default.Button, onClick: this.handleClearClick },
	            t('components.header.filtersBar.filters.type.clear')
	          )
	        ),
	        isExpanded && _react2.default.createElement(
	          'div',
	          { className: _Type2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _Type2.default.FirstColumn },
	            this.checkbox('apt'),
	            this.checkbox('zhiloeHouse'),
	            this.checkbox('nlvn')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Type2.default.SecondColumn },
	            this.checkbox('hotelRoom'),
	            this.checkbox('flat')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Type2.default.ThirdColumn },
	            this.checkbox('lvn'),
	            this.checkbox('storageRoom')
	          )
	        )
	      );
	    }
	  }]);
	
	  return Type;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(Type);

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Loader = __webpack_require__(504);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Filters = __webpack_require__(478);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _FiltersBar = __webpack_require__(1407);
	
	var _FiltersBar2 = _interopRequireDefault(_FiltersBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoading: state.objects.isObjectsFetching,
	    withClient: state.privacy.withClient,
	    currency: state.profile.user_region.country_currency_symbol
	  };
	};
	
	var FiltersBar = function FiltersBar(_ref) {
	  var className = _ref.className,
	      isLoading = _ref.isLoading,
	      withClient = _ref.withClient,
	      currency = _ref.currency;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_FiltersBar2.default.FiltersBar, className, withClient && _FiltersBar2.default.withClient) },
	    _react2.default.createElement(_Filters2.default, { currency: currency }),
	    _react2.default.createElement(_Loader2.default, { active: isLoading })
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FiltersBar);

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FiltersBar = __webpack_require__(1015);
	
	var _FiltersBar2 = _interopRequireDefault(_FiltersBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FiltersBar2.default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Header = __webpack_require__(1408);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logo = __webpack_require__(481);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Search = __webpack_require__(1023);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _User = __webpack_require__(1026);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _FiltersBar = __webpack_require__(1016);
	
	var _FiltersBar2 = _interopRequireDefault(_FiltersBar);
	
	var _headerItemBuilding = __webpack_require__(1532);
	
	var _headerItemBuilding2 = _interopRequireDefault(_headerItemBuilding);
	
	var _headerItemCollections = __webpack_require__(1533);
	
	var _headerItemCollections2 = _interopRequireDefault(_headerItemCollections);
	
	var _headerItemFavorites = __webpack_require__(1534);
	
	var _headerItemFavorites2 = _interopRequireDefault(_headerItemFavorites);
	
	var _webPageHome = __webpack_require__(1569);
	
	var _webPageHome2 = _interopRequireDefault(_webPageHome);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	var _withObservePayments = __webpack_require__(221);
	
	var _withObservePayments2 = _interopRequireDefault(_withObservePayments);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Region = __webpack_require__(1022);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_Header2.default);
	
	var NEW_HOUSES = 'NEW_HOUSES';
	var COTTAGESS = 'COTTAGESS';
	
	var Header = (_dec = (0, _withValidTrafic2.default)(true), (0, _withObservePayments2.default)(_class = _dec(_class = function (_PureComponent) {
	  _inherits(Header, _PureComponent);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.isCollectionsLinkActive = function (match, location) {
	      return location.pathname.match(/collection(s)?/);
	    };
	
	    _this.onBuildingClick = function (e) {
	      e.preventDefault();
	      var filters = sessionStorage.getItem('filtersUrl');
	      var _this$props = _this.props,
	          location = _this$props.location,
	          history = _this$props.history,
	          profile = _this$props.profile,
	          to = _this$props.to;
	
	
	      _tracker2.default.sendEvent('Web_ZHK');
	      (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({
	        eventLabel: 'zhilye_kompleksy',
	        user_id: profile.id
	      }));
	
	      var currentQueryParams = new URLSearchParams(location.search);
	      var isMap = currentQueryParams.get('view') === 'map';
	
	      var targetPath = filters.includes('/cottages') ? to || '/' : sessionStorage.getItem('filtersUrl') || to || '/';
	
	      if (isMap) {
	        targetPath = targetPath + '?view=map';
	      }
	
	      history.push(targetPath);
	    };
	
	    _this.onCottegesClick = function (e) {
	      e.preventDefault();
	      var _this$props2 = _this.props,
	          location = _this$props2.location,
	          history = _this$props2.history,
	          profile = _this$props2.profile;
	
	
	      _tracker2.default.sendEvent('Web_KP');
	      (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({
	        eventLabel: 'kp_i_th',
	        user_id: profile.id
	      }));
	
	      var currentQueryParams = new URLSearchParams(location.search);
	      var isMap = currentQueryParams.get('view') === 'map';
	
	      var targetPath = '/cottages';
	
	      if (isMap) {
	        targetPath = targetPath + '?view=map';
	      }
	
	      history.push(targetPath);
	    };
	
	    _this.state = {
	      headerIsPin: true
	    };
	
	    _this.pinHandler = _this.pinHandler.bind(_this);
	    _this.unpinHandler = _this.unpinHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var currentBuilding = nextProps.currentBuilding,
	          isCurrentBuildingLoading = nextProps.isCurrentBuildingLoading,
	          pathname = nextProps.location.pathname;
	
	      var isSingleBuildingPage = /building\/\d*/g.test(pathname);
	      var isCurrentBuildingTypeIsCottage = currentBuilding ? currentBuilding.type_id === 2 : false;
	
	      if (isSingleBuildingPage) {
	        if (!isCurrentBuildingLoading && currentBuilding) {
	          if (!isCurrentBuildingTypeIsCottage && (location.pathname === '/' || location.pathname.match(/building/))) {
	            this.setState({ activeLink: NEW_HOUSES });
	          } else if (isCurrentBuildingTypeIsCottage || location.pathname === '/cottages' || !!location.pathname.match(/cottages/)) {
	            this.setState({ activeLink: COTTAGESS });
	          } else {
	            this.setState({ activeLink: null });
	          }
	        }
	      } else if (location.pathname === '/' || location.pathname.match(/building/)) {
	        this.setState({ activeLink: NEW_HOUSES });
	      } else if (location.pathname === '/cottages' || !!location.pathname.match(/cottages/)) {
	        this.setState({ activeLink: COTTAGESS });
	      } else {
	        this.setState({ activeLink: null });
	      }
	    }
	  }, {
	    key: 'pinHandler',
	    value: function pinHandler(whatever) {
	      this.setState({ headerIsPin: true });
	    }
	  }, {
	    key: 'unpinHandler',
	    value: function unpinHandler(whatever) {
	      this.setState({ headerIsPin: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          authentication = _props.authentication,
	          profile = _props.profile,
	          isBlocked = _props.isBlocked,
	          t = _props.t;
	      var activeLink = this.state.activeLink;
	
	
	      var handleLinkClick = function handleLinkClick(linkName) {
	        (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({ eventLabel: linkName, user_id: profile.id }));
	      };
	
	      return authentication.authenticated ? _react2.default.createElement(
	        'div',
	        { className: _Header2.default.HeaderMainWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _Header2.default.HeaderWrap },
	          _react2.default.createElement(
	            'div',
	            { className: cx(_Header2.default.Header, className, 'global-header-class') },
	            _react2.default.createElement(_Logo2.default, { className: _Header2.default.Logo }),
	            (location.pathname === '/' || location.pathname === '/cottages') && _react2.default.createElement(_Region2.default, { profile: profile }),
	            authentication.authenticated && !isBlocked ? _react2.default.createElement(_Search2.default, { className: _Header2.default.Search }) : null,
	            _react2.default.createElement(
	              'div',
	              { className: _Header2.default.LinksUser },
	              !isBlocked && _react2.default.createElement(
	                'div',
	                { className: _Header2.default.HeaderLinks },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#',
	                    className: cx(_defineProperty({}, _Header2.default.active, activeLink === NEW_HOUSES)),
	                    onClick: this.onBuildingClick
	                  },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: _headerItemBuilding2.default, alt: t('components.header.menu.building') })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    t('components.header.menu.building')
	                  )
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#',
	                    className: cx(_defineProperty({}, _Header2.default.active, activeLink === COTTAGESS)),
	                    onClick: this.onCottegesClick
	                  },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: _webPageHome2.default, alt: t('components.header.menu.kpAndTh') })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    t('components.header.menu.kpAndTh')
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    to: '/collections',
	                    activeClassName: _Header2.default.active,
	                    isActive: this.isCollectionsLinkActive,
	                    onClick: function onClick() {
	                      _tracker2.default.sendEvent('Web_Selections');
	                      handleLinkClick('podborki');
	                    }
	                  },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: _headerItemCollections2.default, alt: t('components.header.menu.collections') })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    t('components.header.menu.collections')
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    to: '/favorites',
	                    activeClassName: _Header2.default.active,
	                    onClick: function onClick() {
	                      return handleLinkClick('izbrannoe');
	                    }
	                  },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: _headerItemFavorites2.default, alt: t('components.header.menu.favorites') })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    t('components.header.menu.favorites')
	                  )
	                )
	              ),
	              authentication.authenticated && _react2.default.createElement(_User2.default, { className: _Header2.default.User, isBlocked: isBlocked })
	            )
	          )
	        ),
	        !isBlocked && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _FiltersBar2.default }),
	        !isBlocked && _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/cottages', component: _FiltersBar2.default })
	      ) : null;
	    }
	  }]);
	
	  return Header;
	}(_react.PureComponent)) || _class) || _class);
	
	
	var headerSelector = (0, _reselect.createSelector)(function (state) {
	  return state.authentication;
	}, function (state) {
	  return state.building.data;
	}, function (state) {
	  return state.building.isLoading;
	}, function (authentication, currentBuilding, isCurrentBuildingLoading) {
	  return {
	    authentication: authentication,
	    currentBuilding: currentBuilding,
	    isCurrentBuildingLoading: isCurrentBuildingLoading
	  };
	});
	
	exports.default = (0, _reactRedux.connect)(headerSelector)((0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()(Header)));

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Logo = __webpack_require__(481);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Logo2.default;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Region = __webpack_require__(1410);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _profile = __webpack_require__(40);
	
	var _reactI18next = __webpack_require__(4);
	
	var _angleDown = __webpack_require__(107);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _RegionPopup = __webpack_require__(1021);
	
	var _RegionPopup2 = _interopRequireDefault(_RegionPopup);
	
	var _environment = __webpack_require__(19);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Region = function (_Component) {
	  _inherits(Region, _Component);
	
	  function Region() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Region);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Region.__proto__ || Object.getPrototypeOf(Region)).call.apply(_ref, [this].concat(args))), _this), _this.setPopUp = function () {
	      var _this$props = _this.props,
	          setPopUp = _this$props.setPopUp,
	          cities = _this$props.cities,
	          profile = _this$props.profile;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({ eventLabel: 'lokaciya', user_id: profile.id }));
	
	      setPopUp(_react2.default.createElement(_RegionPopup2.default, { cities: cities, profile: profile }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Region, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          profile = _props.profile,
	          cities = _props.cities;
	      var user_region = profile.user_region;
	      var country_name = user_region.country_name,
	          city = user_region.city;
	
	
	      if (cities.length < 2) {
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Region2.default.Region, className) },
	          _react2.default.createElement(
	            'div',
	            { className: _Region2.default.Text },
	            _react2.default.createElement(
	              'span',
	              null,
	              country_name + ', ' + city
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_Region2.default.Region, className), onClick: this.setPopUp },
	        _react2.default.createElement(
	          'div',
	          { className: _Region2.default.Text },
	          _react2.default.createElement(
	            'span',
	            null,
	            country_name + ', ' + city
	          ),
	          _react2.default.createElement(_angleDown2.default, { className: _Region2.default.Icon })
	        )
	      );
	    }
	  }]);
	
	  return Region;
	}(_react.Component);
	
	var regionSelector = (0, _reselect.createSelector)(function (state) {
	  return state.building.cities;
	}, function (cities) {
	  return {
	    cities: cities
	  };
	});
	
	exports.default = Region = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(regionSelector, { setPopUp: _environment.setPopUp, loadProfile: _profile.loadProfile })((0, _reactRouterDom.withRouter)(Region)));

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegionPopup = __webpack_require__(1411);
	
	var _RegionPopup2 = _interopRequireDefault(_RegionPopup);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	var _reactI18next = __webpack_require__(4);
	
	var _checkMark = __webpack_require__(1486);
	
	var _checkMark2 = _interopRequireDefault(_checkMark);
	
	var _profile = __webpack_require__(40);
	
	var _news = __webpack_require__(212);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getRegionList = function getRegionList(cities, profile, handleSelectRegionClick) {
	  return cities.map(function (city) {
	    var country = city.country;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        key: city.id,
	        className: _RegionPopup2.default.RegionItem,
	        onClick: function onClick() {
	          return handleSelectRegionClick(city, profile);
	        }
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        country.name + ', ' + city.name
	      ),
	      String(city.id) === String(profile.cityId) && _react2.default.createElement('img', { className: _RegionPopup2.default.CheckMark, src: _checkMark2.default })
	    );
	  });
	};
	
	var RegionPopup = function RegionPopup(_ref) {
	  var t = _ref.t,
	      cities = _ref.cities,
	      profile = _ref.profile,
	      updateProfileRegion = _ref.updateProfileRegion,
	      setPopUp = _ref.setPopUp;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleSelectRegionClick = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(city, profile) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(city.id !== profile.cityId)) {
	                _context.next = 16;
	                break;
	              }
	
	              (0, _ga.trackGA)(_ga.gaEvent.locationDialogButtonsClick({
	                eventContent: [city.country.name, city.name],
	                user_id: profile.id
	              }));
	
	              _context.prev = 2;
	              _context.next = 5;
	              return updateProfileRegion(_extends({}, profile, { cityId: city.id }));
	
	            case 5:
	              _context.next = 7;
	              return dispatch((0, _news.allNews)({ limit: 20, offset: 0 }));
	
	            case 7:
	              _context.next = 9;
	              return dispatch((0, _news.nedvexNews)({ limit: 20, offset: 0 }));
	
	            case 9:
	              _context.next = 11;
	              return dispatch((0, _news.favoritesNews)({ limit: 20, offset: 0 }));
	
	            case 11:
	              _context.next = 16;
	              break;
	
	            case 13:
	              _context.prev = 13;
	              _context.t0 = _context['catch'](2);
	
	              console.error(_context.t0);
	
	            case 16:
	              setPopUp();
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 13]]);
	    }));
	
	    return function handleSelectRegionClick(_x, _x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    { className: _RegionPopup2.default.PopUpOuter },
	    _react2.default.createElement(
	      'div',
	      { className: _RegionPopup2.default.PopUpInner },
	      _react2.default.createElement(
	        'div',
	        { className: _RegionPopup2.default.PopupContent },
	        _react2.default.createElement(
	          'div',
	          { className: _RegionPopup2.default.PopupTitle },
	          t('components.header.regionPopup.title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _RegionPopup2.default.PopupBody },
	          _react2.default.createElement(
	            'div',
	            { className: _RegionPopup2.default.RegionList },
	            getRegionList(cities, profile, handleSelectRegionClick)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    userUid: state.profile.hash
	  };
	}, { setPopUp: _environment.setPopUp, updateProfileRegion: _profile.updateProfileRegion })((0, _reactI18next.withTranslation)()(RegionPopup));

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RegionPopup = __webpack_require__(1020);
	
	var _RegionPopup2 = _interopRequireDefault(_RegionPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RegionPopup2.default;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Region = __webpack_require__(1019);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Region2.default;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _search = __webpack_require__(1981);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Input = __webpack_require__(502);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Spinner = __webpack_require__(318);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _SearchItem = __webpack_require__(1025);
	
	var _SearchItem2 = _interopRequireDefault(_SearchItem);
	
	var _Districts = __webpack_require__(320);
	
	var _Districts2 = _interopRequireDefault(_Districts);
	
	var _search3 = __webpack_require__(68);
	
	var _SearchFullscreen = __webpack_require__(1091);
	
	var _SearchFullscreen2 = _interopRequireDefault(_SearchFullscreen);
	
	var _search4 = __webpack_require__(508);
	
	var _styles = __webpack_require__(1413);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.onChange = function (event) {
	      var value = event.target.value;
	      // this.setState({ searchValue: value });
	
	      _this.setSearchValue(value);
	      console.log(3);
	    };
	
	    _this.setSearchValue = function (value) {
	      return _this.props.setSearchValue(value);
	    };
	
	    _this.handleIconClick = function (event) {
	      var forcedSearchChange = _this.props.forcedSearchChange;
	
	      forcedSearchChange(event.target.value);
	      console.log(2);
	    };
	
	    _this.handleKeyPress = function (event) {
	      if (event.key === 'Enter') {
	        var _forcedSearchChange = _this.props.forcedSearchChange;
	        var value = event.target.value;
	        // this.setState({ searchValue: value });
	
	        _forcedSearchChange(value);
	        document.activeElement.blur();
	      }
	    };
	
	    _this.handleWheel = function (event) {
	      var deltaY = event.deltaY;
	
	      var menu = _reactDom2.default.findDOMNode(_this.menuEl);
	      var clientHeight = menu.clientHeight,
	          scrollHeight = menu.scrollHeight,
	          scrollTop = menu.scrollTop;
	
	
	      var moveUp = deltaY < 0;
	      var stop = void 0;
	      if (moveUp) {
	        stop = scrollTop <= 0;
	      } else {
	        stop = scrollHeight - clientHeight - scrollTop <= 0;
	      }
	      if (stop) {
	        event.preventDefault();
	      }
	    };
	
	    _this.onFocus = function (e) {
	      e.stopPropagation();
	      // this.setState({ isFocused: true });
	      _this.props.setSearchModalState(true);
	
	      _this.searchEl.blur();
	    };
	
	    _this.onBlur = function () {
	      // const { dispatch } = this.props;
	      // // TODO Такое ощущение, что будто бы автокомплит пропадает раньше, чем
	      // // срабатывает onClick на одном из его пунктов меню.
	      // setTimeout(() => dispatch(changeFocus(false)), 300);
	      // this.setState({ isFocused: false });
	    };
	
	    _this.state = {
	      // searchValue: ''
	      // isFocused: false
	    };
	
	    _this.setSearchValue = (0, _lodash2.default)(_this.setSearchValue, 500);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          search = _props.search,
	          searchValue = _props.searchValue,
	          t = _props.t,
	          profile = _props.profile;
	      var isLoading = search.isLoading,
	          autocomplete = search.autocomplete;
	      // const isFocused = this.state.isFocused;
	      // const { searchValue } = this.state;
	
	      var searchInputProps = {
	        // onChange: this.onChange,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onClickContainer: this.onFocus,
	        getRef: function getRef(searchEl) {
	          _this2.searchEl = searchEl;
	        },
	        onClick: this.onFocus,
	        icon: _react2.default.createElement(_search2.default, {
	          onClick: this.handleIconClick,
	          className: (0, _classnames2.default)(_styles2.default.Icon)
	        }),
	        defaultValue: searchValue,
	        disabled: false
	      };
	      var isBuildingsExists = autocomplete.buildings.length;
	      var isSubregionsExists = autocomplete.subregions.length;
	      var isRegionsExists = autocomplete.regions.length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, _styles2.default.ContainerOuter) },
	        _react2.default.createElement(_SearchFullscreen2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ContainerInner },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Search },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.OnlyMobile },
	              _react2.default.createElement(
	                'div',
	                { onClick: this.onFocus },
	                _react2.default.createElement(_search2.default, {
	                  onClick: this.handleIconClick,
	                  className: (0, _classnames2.default)(_styles2.default.Icon)
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.MobileHidden },
	              _react2.default.createElement(_Input2.default, _extends({}, searchInputProps, {
	                placeholder: t('components.header.search.title'),
	                className: _styles2.default.Input,
	                onFocus: function onFocus() {
	                  _tracker2.default.sendEvent('Web_Search');
	                  (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({ eventLabel: 'poisk', user_id: profile.id }));
	                }
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    search: (0, _search4.getSearch)(state),
	    searchValue: (0, _search4.getSearchValue)(state),
	    profile: state.profile
	  };
	};
	
	var mapDispatchToProps = {
	  setSearchValue: _search3.setSearchValue,
	  forcedSearchChange: _search3.forcedSearchChange,
	  setSearchModalState: _search3.setSearchModalState
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(Search));

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _search = __webpack_require__(68);
	
	var _styles = __webpack_require__(1412);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchItem = function SearchItem(props) {
	  var className = props.className,
	      titleStyle = props.titleStyle,
	      subregionStyle = props.subregionStyle,
	      addressStyle = props.addressStyle,
	      title = props.title,
	      address = props.address,
	      subregion = props.subregion,
	      id = props.id,
	      ids = props.ids,
	      isFilter = props.isFilter,
	      changeFilters = props.changeFilters;
	
	
	  return isFilter ? _react2.default.createElement(
	    _reactRouterDom.Link,
	    { to: '/?subregion=' + ids.join(','), className: (0, _classnames2.default)(className, _styles2.default.SearchItem) },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(titleStyle, _styles2.default.Title),
	        onClick: function onClick() {
	          return changeFilters({ subregion: ids });
	        }
	      },
	      title
	    )
	  ) : _react2.default.createElement(
	    _reactRouterDom.Link,
	    { to: '/building/' + id, className: (0, _classnames2.default)(className, _styles2.default.SearchItem) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(titleStyle, _styles2.default.Title) },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.SubTitle },
	      subregion && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(subregionStyle, _styles2.default.Subregion) },
	        subregion,
	        ', '
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(addressStyle, _styles2.default.Address) },
	        ' ' + address
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(null, { changeFilters: _search.changeFilters })(SearchItem);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchItem = __webpack_require__(1024);
	
	var _SearchItem2 = _interopRequireDefault(_SearchItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchItem2.default;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _User = __webpack_require__(1414);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Avatar = __webpack_require__(501);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Dropdown = __webpack_require__(165);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _UserInfo = __webpack_require__(1027);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _profile = __webpack_require__(40);
	
	var _Config = __webpack_require__(16);
	
	var _iconUser = __webpack_require__(549);
	
	var _iconUser2 = _interopRequireDefault(_iconUser);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_Component) {
	  _inherits(User, _Component);
	
	  function User() {
	    _classCallCheck(this, User);
	
	    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
	  }
	
	  _createClass(User, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          withClient = _props.withClient,
	          avatarId = _props.avatarId,
	          firstName = _props.firstName,
	          lastName = _props.lastName,
	          roleName = _props.roleName,
	          isBlocked = _props.isBlocked,
	          profile = _props.profile,
	          t = _props.t;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_User2.default.User, className)
	        },
	        _react2.default.createElement(_Avatar2.default, {
	          className: (0, _classnames2.default)(_User2.default.Avatar, _defineProperty({}, _User2.default.WithClient, withClient)),
	          image: avatarId ? _Config.ROOT_URL + '/image/get?id=' + avatarId + '&preset=profile_avatar' : _iconUser2.default
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_User2.default.UserDropdownWrap, _defineProperty({}, _User2.default.WithClient, withClient)) },
	          _react2.default.createElement(
	            _Dropdown2.default,
	            {
	              buttonStyle: _User2.default.Dropdown,
	              textStyle: _User2.default.DropdownText,
	              text: (firstName || '') + ' ' + (lastName || ''),
	              iconStyle: _User2.default.DropdownIcon,
	              rightShift: true,
	              onClick: function onClick() {
	                return (0, _ga.trackGA)(_ga.gaEvent.headerButtonsClick({
	                  eventLabel: 'profil',
	                  user_id: profile.id
	                }));
	              }
	            },
	            _react2.default.createElement(_UserInfo2.default, { roleName: roleName, isBlocked: isBlocked, profile: profile })
	          ),
	          withClient ? _react2.default.createElement(
	            'span',
	            { className: _User2.default.UserStatus },
	            t('components.header.user.withClient2')
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return User;
	}(_react.Component);
	
	var userSelector = (0, _reselect.createSelector)(function (state) {
	  return state.profile;
	}, function (state) {
	  return state.privacy;
	}, function (profile, privacy) {
	  return _extends({}, privacy, profile, {
	    profile: profile
	  });
	});
	
	exports.default = User = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(userSelector, { loadProfile: _profile.loadProfile })((0, _reactRouterDom.withRouter)(User)));

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _UserInfo = __webpack_require__(1415);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _ActionTypes = __webpack_require__(26);
	
	var _constants = __webpack_require__(92);
	
	var _utils = __webpack_require__(12);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _userDropdownClientMode = __webpack_require__(1565);
	
	var _userDropdownClientMode2 = _interopRequireDefault(_userDropdownClientMode);
	
	var _userDropdownProfile = __webpack_require__(1568);
	
	var _userDropdownProfile2 = _interopRequireDefault(_userDropdownProfile);
	
	var _userDropdownCompanyProfile = __webpack_require__(1566);
	
	var _userDropdownCompanyProfile2 = _interopRequireDefault(_userDropdownCompanyProfile);
	
	var _userDropdownExit = __webpack_require__(1567);
	
	var _userDropdownExit2 = _interopRequireDefault(_userDropdownExit);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserInfo = function (_Component) {
	  _inherits(UserInfo, _Component);
	
	  function UserInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).call.apply(_ref, [this].concat(args))), _this), _this.handleClientModeClick = function () {
	      _tracker2.default.sendEvent('Web_Profile_With_Client', {
	        selected: !_this.props.privacy.withClient
	      });
	      _this.trackEvent({ eventLabel: 'ya_s_klientom' });
	      _this.props.dispatch({ type: _ActionTypes.SWITCH_WITH_CLIENT });
	    }, _this.trackEvent = function (_ref2) {
	      var eventLabel = _ref2.eventLabel;
	
	      (0, _ga.trackGA)(_ga.gaEvent.profileDropdownButtonsClick({
	        eventLabel: eventLabel,
	        user_id: _this.props.profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserInfo, [{
	    key: 'getNumEnding',
	
	
	    /* FIXME: move to react-intl */
	    value: function getNumEnding(iNumber, aEndings) {
	      var sEnding = void 0,
	          i = void 0;
	      iNumber %= 100;
	      if (iNumber >= 11 && iNumber <= 19) {
	        sEnding = aEndings[2];
	      } else {
	        i = iNumber % 10;
	        switch (i) {
	          case 1:
	            sEnding = aEndings[0];break;
	          case 2:
	          case 3:
	          case 4:
	            sEnding = aEndings[1];break;
	          default:
	            sEnding = aEndings[2];
	        }
	      }
	      return sEnding;
	    }
	  }, {
	    key: 'getUserTarifTab',
	    value: function getUserTarifTab() {
	      var _props = this.props,
	          profile = _props.profile,
	          t = _props.t;
	
	
	      if (profile.tariff) {
	        var role = (0, _utils.getUserRole)(profile);
	        var tarif = (0, _utils.getTarifName)(profile.tariff.pricing);
	        return _react2.default.createElement(
	          'div',
	          { className: _UserInfo2.default.TarifBlock },
	          _react2.default.createElement(
	            'div',
	            { className: _UserInfo2.default.TarifName },
	            role === _constants.USER_ROLE.WORKER ? _react2.default.createElement(
	              'div',
	              null,
	              profile.agencyName
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              t('components.header.user.tarif', { tarif: tarif })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_UserInfo2.default.TarifTime, _defineProperty({}, _UserInfo2.default.Red, profile.tariff.countDay < 6)) },
	            profile.tariff.countDay,
	            ' ',
	            this.getNumEnding(profile.tariff.countDay, [t('components.header.user.day1'), t('components.header.user.day2'), t('components.header.user.day3')])
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          isBlocked = _props2.isBlocked,
	          t = _props2.t;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_UserInfo2.default.UserInfo) },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getUserTarifTab()
	          ),
	          !isBlocked && _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_UserInfo2.default.Link, _defineProperty({}, _UserInfo2.default.Active, this.props.privacy.withClient)), onClick: this.handleClientModeClick },
	            _react2.default.createElement('img', { src: _userDropdownClientMode2.default, className: _UserInfo2.default.LinkImage, alt: t('components.header.user.withClient') }),
	            _react2.default.createElement(
	              'span',
	              { className: _UserInfo2.default.LinkText },
	              t('components.header.user.withClient'),
	              _react2.default.createElement(
	                'span',
	                { className: (0, _classnames2.default)(_UserInfo2.default.ClientModeSwitcher, _defineProperty({}, _UserInfo2.default.Enabled, this.props.privacy.withClient)) },
	                _react2.default.createElement('span', { className: _UserInfo2.default.Marker })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              onClick: function onClick() {
	                _tracker2.default.sendEvent(_this2.props.roleName === 'owner' ? 'Web_My_Profile' : 'Web_Profile');
	                _this2.trackEvent({ eventLabel: 'profil' });
	              },
	              className: _UserInfo2.default.Link, to: '/profile'
	            },
	            _react2.default.createElement('img', { src: _userDropdownProfile2.default, className: _UserInfo2.default.LinkImage, alt: t('components.header.user.profile') }),
	            _react2.default.createElement(
	              'span',
	              { className: _UserInfo2.default.LinkText },
	              this.props.roleName === 'owner' ? t('components.header.user.myProfile') : t('components.header.user.profile')
	            )
	          ),
	          this.props.roleName === 'owner' && _react2.default.createElement(
	            _reactRouterDom.Link,
	            { onClick: function onClick() {
	                return _tracker2.default.sendEvent('Web_Profile_Company');
	              }, className: _UserInfo2.default.Link, to: '/company' },
	            _react2.default.createElement('img', { src: _userDropdownCompanyProfile2.default, className: _UserInfo2.default.LinkImage, alt: t('components.header.user.companyProfile') }),
	            _react2.default.createElement(
	              'span',
	              { className: _UserInfo2.default.LinkText },
	              t('components.header.user.companyProfile')
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              className: _UserInfo2.default.Link,
	              to: '/logout',
	              onClick: function onClick() {
	                return _this2.trackEvent({ eventLabel: 'vyiti' });
	              }
	            },
	            _react2.default.createElement('img', { src: _userDropdownExit2.default, className: _UserInfo2.default.LinkImage, alt: t('components.header.user.logout') }),
	            _react2.default.createElement(
	              'span',
	              { className: _UserInfo2.default.LinkText },
	              t('components.header.user.logout')
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: _UserInfo2.default.Arrow })
	      );
	    }
	  }]);
	
	  return UserInfo;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    privacy: state.privacy,
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(UserInfo));

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1017);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _random_house = __webpack_require__(556);
	
	var _random_house2 = _interopRequireDefault(_random_house);
	
	var _FormInvite = __webpack_require__(1416);
	
	var _FormInvite2 = _interopRequireDefault(_FormInvite);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reduxForm = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_FormInvite2.default);
	
	var FormInvite = function (_Component) {
	  _inherits(FormInvite, _Component);
	
	  function FormInvite() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FormInvite);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormInvite.__proto__ || Object.getPrototypeOf(FormInvite)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (data) {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          inviteFormSending = _this$props.inviteFormSending;
	
	      dispatch(inviteFormSending(data));
	    }, _this.renderField = function (_ref2) {
	      var meta = _ref2.meta,
	          input = _ref2.input,
	          placeholder = _ref2.placeholder;
	      return _react2.default.createElement(
	        'div',
	        { className: cx(_FormInvite2.default.InnerInput, { FormError: meta.touched && meta.invalid }) },
	        _react2.default.createElement('input', _extends({ className: _FormInvite2.default.Input, placeholder: placeholder }, input)),
	        meta.touched && meta.error && _react2.default.createElement(
	          'div',
	          { className: null },
	          meta.error
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FormInvite, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.onSubmit) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bind2.default)(_FormInvite2.default.FormInvite, className) },
	          _react2.default.createElement(
	            'div',
	            { className: _FormInvite2.default.Top },
	            _react2.default.createElement(
	              'div',
	              { className: _FormInvite2.default.Left },
	              _react2.default.createElement(
	                'div',
	                { className: _FormInvite2.default.Title },
	                '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _FormInvite2.default.Image },
	                _react2.default.createElement('img', { alt: 'house', src: _random_house2.default })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _FormInvite2.default.Right },
	              _react2.default.createElement(_reduxForm.Field, { type: 'text', name: 'firstName', component: this.renderField, placeholder: '\u0412\u0430\u0448\u0435 \u0438\u043C\u044F' }),
	              _react2.default.createElement(_reduxForm.Field, { type: 'text', name: 'lastName', component: this.renderField, placeholder: '\u0412\u0430\u0448\u0430 \u0444\u0430\u043C\u0438\u043B\u0438\u044F' }),
	              _react2.default.createElement(_reduxForm.Field, { type: 'text', name: 'company', component: this.renderField, placeholder: '\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F' }),
	              _react2.default.createElement(_reduxForm.Field, { type: 'text', name: 'position', component: this.renderField, placeholder: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C' }),
	              _react2.default.createElement(_reduxForm.Field, { type: 'text', name: 'number', component: this.renderField, placeholder: '\u0422\u0435\u043B\u0435\u0444\u043E\u043D' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _FormInvite2.default.Bottom },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: _FormInvite2.default.Enter },
	              ' \u0412\u043E\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442 '
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'submit', className: _FormInvite2.default.Button },
	              '\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormInvite;
	}(_react.Component);
	
	function validate(values) {
	  var errors = {};
	
	  if (!values.firstName) {
	    errors.firstName = 'Это поле нельзя оставлять пустым';
	  }
	
	  if (!values.lastName) {
	    errors.lastName = 'Это поле нельзя оставлять пустым';
	  }
	
	  if (!values.company) {
	    errors.company = 'Это поле нельзя оставлять пустым';
	  }
	
	  if (!values.position) {
	    errors.position = 'Это поле нельзя оставлять пустым';
	  }
	
	  if (!values.number) {
	    errors.number = 'Это поле нельзя оставлять пустым';
	  }
	
	  return errors;
	}
	
	exports.default = FormInvite = (0, _reduxForm.reduxForm)({
	  form: 'formInvite',
	  // fields: [ 'firstName', 'lastName', 'company', 'position', 'number' ],
	  validate: validate
	}, null, null)(FormInvite);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormInvite = __webpack_require__(1029);
	
	var _FormInvite2 = _interopRequireDefault(_FormInvite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormInvite2.default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _random_house = __webpack_require__(556);
	
	var _random_house2 = _interopRequireDefault(_random_house);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormNotConnected = __webpack_require__(1417);
	
	var _FormNotConnected2 = _interopRequireDefault(_FormNotConnected);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormNotConnected = function FormNotConnected(_ref) {
	  var className = _ref.className,
	      reconnectFormSending = _ref.reconnectFormSending;
	
	  function handleButtonClick() {
	    reconnectFormSending();
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_FormNotConnected2.default.FormNotConnected, className) },
	    _react2.default.createElement(
	      'div',
	      { className: _FormNotConnected2.default.Title },
	      'NEDVEX'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _FormNotConnected2.default.Image },
	      _react2.default.createElement('img', { alt: 'house', src: _random_house2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _FormNotConnected2.default.Label },
	      '\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { className: _FormNotConnected2.default.Button, onClick: handleButtonClick },
	      '\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443'
	    )
	  );
	};
	
	exports.default = FormNotConnected;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormNotConnected = __webpack_require__(1031);
	
	var _FormNotConnected2 = _interopRequireDefault(_FormNotConnected);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormNotConnected2.default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactInputMask = __webpack_require__(385);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _FormNumber = __webpack_require__(1418);
	
	var _FormNumber2 = _interopRequireDefault(_FormNumber);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormNumber = function (_Component) {
	  _inherits(FormNumber, _Component);
	
	  function FormNumber(props) {
	    _classCallCheck(this, FormNumber);
	
	    var _this = _possibleConstructorReturn(this, (FormNumber.__proto__ || Object.getPrototypeOf(FormNumber)).call(this, props));
	
	    _this.state = {
	      number: '',
	      isButtonDisabled: true
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FormNumber, [{
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      var value = event.target.value;
	
	      this.setState({ number: value, isButtonDisabled: value.length <= 4 });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick(e) {
	      var numberFormSending = this.props.numberFormSending;
	      var number = this.state.number;
	
	      try {
	        _tracker2.default.sendEvent('Web_Phone_Number_Entered');
	        numberFormSending(number.replace(/\s+|\+/g, ''));
	      } catch (e) {
	        console.log(e);
	      }
	      e.preventDefault();
	    }
	  }, {
	    key: 'printError',
	    value: function printError(error) {
	      var t = this.props.t;
	
	
	      if (!error) {
	        return '';
	      }
	
	      if (error === 'USER_NOT_FOUND') {
	        return t('components.login.formNumber.userNotFound');
	      }
	
	      return t('components.login.formNumber.serverError');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isLoading = _props.isLoading,
	          numberError = _props.numberError,
	          t = _props.t;
	      var _state = this.state,
	          number = _state.number,
	          isButtonDisabled = _state.isButtonDisabled;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _FormNumber2.default.FormInner },
	        _react2.default.createElement(
	          'div',
	          { className: _FormNumber2.default.Title },
	          _react2.default.createElement(
	            'span',
	            null,
	            t('components.login.formNumber.title')
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { role: 'form' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_FormNumber2.default.Input, numberError && _FormNumber2.default.InputError) },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'FormNumber-phone' },
	              this.printError(numberError)
	            ),
	            _react2.default.createElement(_reactInputMask2.default, {
	              type: 'tel',
	              id: 'FormNumber-phone',
	              value: number,
	              placeholder: '+7 (999) 999 99 99',
	              onChange: this.handleInputChange,
	              mask: '+7 999 999 99 99',
	              maskChar: ''
	            })
	          ),
	          isLoading ? _react2.default.createElement(
	            'div',
	            { className: _FormNumber2.default.Wrapper },
	            _react2.default.createElement('div', { className: _FormNumber2.default.Loader })
	          ) : _react2.default.createElement(
	            'div',
	            { style: { width: '100%' } },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: _FormNumber2.default.SubmitButton,
	                disabled: isLoading || isButtonDisabled,
	                onClick: this.handleButtonClick
	              },
	              t('components.login.formNumber.button')
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: _FormNumber2.default.BlueButton, onClick: function onClick() {
	                  return _this2.props.onOpenRegistration();
	                } },
	              t('components.login.formNumber.registration')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormNumber;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(FormNumber);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormNumber = __webpack_require__(1033);
	
	var _FormNumber2 = _interopRequireDefault(_FormNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormNumber2.default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormPasswordRestore = __webpack_require__(1419);
	
	var _FormPasswordRestore2 = _interopRequireDefault(_FormPasswordRestore);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Spinner = __webpack_require__(318);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormPasswordRestore = function (_Component) {
	  _inherits(FormPasswordRestore, _Component);
	
	  function FormPasswordRestore(props) {
	    _classCallCheck(this, FormPasswordRestore);
	
	    var _this = _possibleConstructorReturn(this, (FormPasswordRestore.__proto__ || Object.getPrototypeOf(FormPasswordRestore)).call(this, props));
	
	    _this.state = {
	      email: '',
	      error: false,
	      isButtonActive: false
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FormPasswordRestore, [{
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      var _this2 = this;
	
	      this.setState({ email: event.target.value, error: false }, function () {
	        if (_this2.state.email.length > 10) {
	          _this2.setState({ isButtonActive: true });
	        } else {
	          _this2.setState({ isButtonActive: false });
	        }
	      });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick() {
	      if (this.state.isButtonActive) {
	        this.props.numberFormSending(this.state.email);
	        this.setState({ isButtonActive: false, error: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_FormPasswordRestore2.default.FormPasswordRestore, className) },
	        _react2.default.createElement(
	          'div',
	          { className: _FormPasswordRestore2.default.FormInner },
	          _react2.default.createElement(
	            'div',
	            { className: _FormPasswordRestore2.default.Logo },
	            'NEDVEX'
	          ),
	          !this.state.error ? _react2.default.createElement(
	            'div',
	            { className: _FormPasswordRestore2.default.Label },
	            '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B'
	          ) : _react2.default.createElement(
	            'div',
	            { className: _FormPasswordRestore2.default.LabelErr },
	            '\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u043E\u0442\u0441\u0443\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0431\u0430\u0437\u0435'
	          ),
	          !this.props.otherForms.isLoading ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _FormPasswordRestore2.default.Input },
	              _react2.default.createElement('input', {
	                type: 'text',
	                maxLength: '20',
	                placeholder: 'mail@example.com',
	                value: this.state.email,
	                onChange: this.handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: (0, _classnames2.default)(_FormPasswordRestore2.default.Button, this.state.isButtonActive ? _FormPasswordRestore2.default.ButtonActive : ''), onClick: this.handleButtonClick },
	              '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: _FormPasswordRestore2.default.Spinner },
	            _react2.default.createElement(_Spinner2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _FormPasswordRestore2.default.Footer },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: _FormPasswordRestore2.default.Blue },
	              '\u041D\u0435\u0442 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F?'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: _FormPasswordRestore2.default.Blue },
	              '\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormPasswordRestore;
	}(_react.Component);
	
	exports.default = FormPasswordRestore;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormPasswordRestore = __webpack_require__(1035);
	
	var _FormPasswordRestore2 = _interopRequireDefault(_FormPasswordRestore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormPasswordRestore2.default;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactInputMask = __webpack_require__(385);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _environment = __webpack_require__(19);
	
	var _FormRegistration = __webpack_require__(1420);
	
	var _FormRegistration2 = _interopRequireDefault(_FormRegistration);
	
	var _Select = __webpack_require__(482);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ga = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var workOptions = [_i18n2.default.t('components.login.formRegistration.workOptions1'), _i18n2.default.t('components.login.formRegistration.workOptions2'), _i18n2.default.t('components.login.formRegistration.workOptions3')];
	
	var FormRegistration = function (_Component) {
	  _inherits(FormRegistration, _Component);
	
	  function FormRegistration(props) {
	    _classCallCheck(this, FormRegistration);
	
	    var _this = _possibleConstructorReturn(this, (FormRegistration.__proto__ || Object.getPrototypeOf(FormRegistration)).call(this, props));
	
	    _this.state = {
	      isLoading: '',
	      isButtonDisabled: true,
	      name: '',
	      nameError: false,
	      surName: '',
	      surNameError: false,
	      currentWork: '',
	      currentWorkError: false,
	      phoneNumber: props.phone || '',
	      phoneNumberError: false,
	      email: '',
	      emailError: false,
	      city: 'Сочи'
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	
	    _this.debouncedEnterNameEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'imya'), 3000);
	    _this.debouncedEnterSurnameEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'familiya'), 3000);
	    _this.debouncedEnterPhoneEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'telefon'), 3000);
	    _this.debouncedEnterEmailEvent = (0, _lodash2.default)(_this.trackInputEvent.bind(_this, 'email'), 3000);
	    return _this;
	  }
	
	  _createClass(FormRegistration, [{
	    key: 'handleInputChange',
	    value: function handleInputChange(_ref) {
	      var _this2 = this;
	
	      var target = _ref.target;
	      var value = target.value;
	      var key = target.dataset.key;
	
	
	      var minLength = key === 'phoneNumber' ? 6 : 3;
	
	      switch (key) {
	        case 'name':
	          this.debouncedEnterNameEvent.cancel();
	          break;
	        case 'surName':
	          this.debouncedEnterSurnameEvent.cancel();
	          break;
	        case 'phoneNumber':
	          this.debouncedEnterPhoneEvent.cancel();
	          break;
	        case 'email':
	          this.debouncedEnterEmailEvent.cancel();
	          break;
	        default:
	          break;
	      }
	
	      this.setState(_defineProperty({}, key, value), function () {
	        if (value.length >= minLength) {
	          switch (key) {
	            case 'name':
	              _this2.debouncedEnterNameEvent();
	              break;
	            case 'surName':
	              _this2.debouncedEnterSurnameEvent();
	              break;
	            case 'phoneNumber':
	              _this2.debouncedEnterPhoneEvent();
	              break;
	            case 'email':
	              _this2.debouncedEnterEmailEvent();
	              break;
	            default:
	              break;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick(e) {
	      var _state = this.state,
	          name = _state.name,
	          surName = _state.surName,
	          phoneNumber = _state.phoneNumber,
	          email = _state.email,
	          currentWork = _state.currentWork,
	          city = _state.city;
	
	      var nameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(name);
	      var surNameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(surName);
	      var emailError = !emailReg.test(email.toLowerCase());
	      var phoneNumberError = phoneNumber.length < 16;
	      var currentWorkError = currentWork.length === 0;
	      var isError = nameError || surNameError || emailError || phoneNumberError || currentWorkError;
	
	      (0, _ga.trackGA)(_ga.gaEvent.registrationButtonsClick({ eventLabel: 'otpravit' }));
	
	      e.preventDefault();
	      if (isError) {
	        this.setState({
	          nameError: nameError,
	          surNameError: surNameError,
	          phoneNumberError: phoneNumberError,
	          emailError: emailError,
	          currentWorkError: currentWorkError
	        });
	
	        if (emailError) {
	          (0, _ga.trackGA)(_ga.gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnyi_email' }));
	        }
	        if (nameError) {
	          (0, _ga.trackGA)(_ga.gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnoe_imya' }));
	        }
	        if (surNameError) {
	          (0, _ga.trackGA)(_ga.gaEvent.registrationErrorsShow({ eventLabel: 'nekorrektnaya_familiya' }));
	        }
	      } else {
	        _tracker2.default.sendEvent('Web_User_Registration');
	        (0, _ga.trackGA)(_ga.gaEvent.registrationSuccess());
	        this.sendEmail({ name: name, surName: surName, phoneNumber: phoneNumber, email: email, currentWork: currentWork, city: city });
	      }
	    }
	  }, {
	    key: 'sendEmail',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(userInfo) {
	        var _this3 = this;
	
	        var referral, BITRIX_URL, t;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                referral = localStorage.getItem('ref');
	                BITRIX_URL = 'https://bitned.ru/rest/1/gv41cfcxbxhxwn28/crm.lead.add.json?FIELDS[TITLE]=\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E ' + userInfo.phoneNumber + '&FIELDS[NAME]=' + userInfo.name + '&FIELDS[LAST_NAME]=' + userInfo.surName + '&FIELDS[EMAIL][0][VALUE]=' + userInfo.email + '&FIELDS[EMAIL][0][VALUE_TYPE]=WORK&FIELDS[PHONE][0][VALUE]=' + userInfo.phoneNumber + '&FIELDS[PHONE][0][VALUE_TYPE]=WORK&FIELDS[COMMENTS]=\u041C\u0435\u0441\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B: ' + userInfo.currentWork + '; \u0413\u043E\u0440\u043E\u0434: ' + userInfo.city + ', \u0420\u0435\u0444\u0435\u0440\u0430\u043B: ' + referral + '&FIELDS[SOURCE_ID]=9683008522&FIELDS[SOURCE_DESCRIPTION]=\u0412\u0441\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u044B_\u0421\u0430\u0439\u0442_app.nedvex.ru_\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0432 Nedvex App';
	
	
	                this.setState({ isLoading: true });
	                t = this.props.t;
	                _context.prev = 4;
	                _context.next = 7;
	                return fetch(BITRIX_URL);
	
	              case 7:
	                this.props.handleRegistrationSuccessfully();
	                this.props.setPopUp(_react2.default.createElement(
	                  'div',
	                  { className: _FormRegistration2.default.RegisterSuccessPopup },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _FormRegistration2.default.RegisterSuccessTitle },
	                    t('epics.registrationSuccessTitle')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _FormRegistration2.default.RegisterSuccessSubtitle },
	                    t('epics.registrationSuccessSubtitle')
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: (0, _classnames2.default)(_FormRegistration2.default.OkBtn, 'button-primary', 'button-primary--lg'),
	                      onClick: function onClick() {
	                        return _this3.props.setPopUp();
	                      }
	                    },
	                    'OK'
	                  )
	                ), {
	                  closeStyleName: 'Default',
	                  contentStyleName: 'Default',
	                  contentClassName: _FormRegistration2.default.PrintPopupContent,
	                  disableBackgroundClick: true,
	                  hideCloseIcon: true
	                });
	                // dispatch({ type: 'REGISTRATION_SUCCESS' });
	                _context.next = 14;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context['catch'](4);
	
	                this.props.handleRegistrationError(_context.t0);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[4, 11]]);
	      }));
	
	      function sendEmail(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return sendEmail;
	    }()
	  }, {
	    key: 'trackInputEvent',
	    value: function trackInputEvent(inputName) {
	      (0, _ga.trackGA)(_ga.gaEvent.registrationFormInput({ eventLabel: inputName }));
	    }
	  }, {
	    key: 'trackDropdownClickEvent',
	    value: function trackDropdownClickEvent(dropdownName) {
	      (0, _ga.trackGA)(_ga.gaEvent.registrationDropdownClick({ eventLabel: dropdownName }));
	    }
	  }, {
	    key: 'trackDropdownOptionClickEvent',
	    value: function trackDropdownOptionClickEvent(_ref3) {
	      var dropdownName = _ref3.dropdownName;
	      var _state2 = this.state,
	          city = _state2.city,
	          currentWork = _state2.currentWork;
	
	      var trackOption = void 0;
	
	      if (dropdownName === 'mesto_raboty') {
	        switch (currentWork) {
	          case 'Частный агент':
	            trackOption = 'chastnyi_agent';
	            break;
	          case 'Работаю в агентстве недвижимости':
	            trackOption = 'agentstvo_nedvizhimosti';
	            break;
	          case 'Хочу подключить свое агентство':
	            trackOption = 'svoe_agentstvo';
	            break;
	          default:
	            break;
	        }
	      } else {
	        switch (city) {
	          case 'Сочи':
	            trackOption = 'sochi';
	            break;
	          case 'Краснодар':
	            trackOption = 'krasnodar';
	            break;
	          case 'Анталья':
	            trackOption = 'antaliya';
	            break;
	          case 'Бали':
	            trackOption = 'bali';
	            break;
	          case 'Анапа':
	            trackOption = 'anapa';
	            break;
	          default:
	            break;
	        }
	      }
	
	      (0, _ga.trackGA)(_ga.gaEvent.registrationDropdownOptionClick({
	        eventLabel: trackOption,
	        eventContent: dropdownName
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          handleCloseModal = _props.handleCloseModal,
	          t = _props.t;
	      var _state3 = this.state,
	          isLoading = _state3.isLoading,
	          name = _state3.name,
	          nameError = _state3.nameError,
	          surName = _state3.surName,
	          surNameError = _state3.surNameError,
	          currentWork = _state3.currentWork,
	          currentWorkError = _state3.currentWorkError,
	          phoneNumber = _state3.phoneNumber,
	          phoneNumberError = _state3.phoneNumberError,
	          email = _state3.email,
	          emailError = _state3.emailError,
	          city = _state3.city;
	
	
	      var isButtonDisabled = !city || name.length === 0 || surName.length === 0 || phoneNumber.length === 0 || email.length === 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _FormRegistration2.default.Overlay },
	        _react2.default.createElement(
	          'div',
	          { className: _FormRegistration2.default.Modal },
	          _react2.default.createElement('div', {
	            className: _FormRegistration2.default.CloseButton,
	            onClick: function onClick() {
	              handleCloseModal();
	              (0, _ga.trackGA)(_ga.gaEvent.registrationButtonsClick({ eventLabel: 'zakryt' }));
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: _FormRegistration2.default.Title },
	            t('components.login.formRegistration.title')
	          ),
	          _react2.default.createElement(
	            'form',
	            { role: 'form' },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_FormRegistration2.default.Input, nameError && _FormRegistration2.default.InputError) },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'name' },
	                nameError ? t('components.login.formRegistration.nameError') : ''
	              ),
	              _react2.default.createElement(_reactInputMask2.default, {
	                id: 'name',
	                'data-key': 'name',
	                value: name,
	                placeholder: t('components.login.formRegistration.name'),
	                onChange: this.handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_FormRegistration2.default.Input, surNameError && _FormRegistration2.default.InputError) },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'surName' },
	                surNameError ? t('components.login.formRegistration.surNameError') : ''
	              ),
	              _react2.default.createElement(_reactInputMask2.default, {
	                id: 'surName',
	                value: surName,
	                'data-key': 'surName',
	                placeholder: t('components.login.formRegistration.surName'),
	                onChange: this.handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _FormRegistration2.default.WorkTypeSpan },
	              t('components.login.formRegistration.currentWork')
	            ),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'currentWork' },
	              currentWorkError ? t('components.login.formRegistration.currentWorkError') : ''
	            ),
	            _react2.default.createElement(_Select.Select, {
	              style: { marginBottom: '5px' },
	              id: 'currentWork',
	              'data-key': 'currentWork',
	              isError: currentWorkError,
	              placeholder: '\u2014',
	              value: currentWork,
	              options: workOptions,
	              onChange: function onChange(value) {
	                _this4.setState({ currentWork: value }, function () {
	                  _this4.trackDropdownOptionClickEvent({ dropdownName: 'mesto_raboty' });
	                });
	              },
	              onClick: function onClick() {
	                return _this4.trackDropdownClickEvent('mesto_raboty');
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_FormRegistration2.default.Input, phoneNumberError && _FormRegistration2.default.InputError) },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'FormNumber-phone' },
	                phoneNumberError ? t('components.login.formRegistration.phoneNumberError') : ''
	              ),
	              _react2.default.createElement(_reactInputMask2.default, {
	                type: 'tel',
	                id: 'FormNumber-phone',
	                'data-key': 'phoneNumber',
	                value: phoneNumber,
	                placeholder: '+7 (999) 999 99 99',
	                onChange: this.handleInputChange,
	                mask: '+7 999 999 99 99',
	                maskChar: ''
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_FormRegistration2.default.Input, emailError && _FormRegistration2.default.InputError) },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'email' },
	                emailError ? t('components.login.formRegistration.emailError') : ''
	              ),
	              _react2.default.createElement(_reactInputMask2.default, {
	                type: 'email',
	                id: 'email',
	                'data-key': 'email',
	                value: email,
	                placeholder: t('components.login.formRegistration.email'),
	                onChange: this.handleInputChange,
	                mask: '',
	                maskChar: ''
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _FormRegistration2.default.Politician },
	              t('components.login.formRegistration.agree'),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: 'policy', className: _FormRegistration2.default.PoliticianLink, target: '_blank' },
	                t('components.login.formRegistration.politicianLink')
	              ),
	              ' и ',
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: 'eula', className: _FormRegistration2.default.PoliticianLink, target: '_blank' },
	                t('components.login.formRegistration.eulaLink')
	              )
	            ),
	            isLoading ? _react2.default.createElement(
	              'div',
	              { className: _FormRegistration2.default.Wrapper },
	              _react2.default.createElement('div', { className: _FormRegistration2.default.Loader })
	            ) : _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: _FormRegistration2.default.SubmitButton,
	                disabled: isLoading || isButtonDisabled,
	                onClick: this.handleButtonClick
	              },
	              t('components.login.formRegistration.send')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormRegistration;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  setPopUp: _environment.setPopUp
	})((0, _reactI18next.withTranslation)()(FormRegistration));

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormSMS = __webpack_require__(1422);
	
	var _FormSMS2 = _interopRequireDefault(_FormSMS);
	
	var _dot = __webpack_require__(1597);
	
	var _dot2 = _interopRequireDefault(_dot);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DELAY_SMS = 30;
	
	var Dot = function Dot() {
	  return _react2.default.createElement('img', { alt: 'mask', src: _dot2.default });
	};
	// eslint-disable-next-line react/no-array-index-key
	var getMask = function getMask() {
	  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	  return new Array(length).fill('').map(function (_, index) {
	    return _react2.default.createElement(Dot, { key: length - index });
	  });
	};
	
	var FormSMS = function (_Component) {
	  _inherits(FormSMS, _Component);
	
	  function FormSMS(props) {
	    _classCallCheck(this, FormSMS);
	
	    var _this = _possibleConstructorReturn(this, (FormSMS.__proto__ || Object.getPrototypeOf(FormSMS)).call(this, props));
	
	    _this.state = {
	      code: '',
	      mask: getMask(),
	      remainingTime: 0
	    };
	
	    _this.timerRef = null;
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
	    _this.handleResendClick = _this.handleResendClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FormSMS, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleStartTimer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timerRef) clearInterval(this.timerRef);
	    }
	  }, {
	    key: 'handleStartTimer',
	    value: function handleStartTimer() {
	      var _this2 = this;
	
	      this.setState({ remainingTime: DELAY_SMS });
	      this.timerRef = setInterval(function () {
	        if (_this2.state.remainingTime === 0) {
	          clearInterval(_this2.timerRef);
	          _this2.timerRef = null;
	        } else {
	          _this2.setState(function (prev) {
	            return { remainingTime: prev.remainingTime - 1 };
	          });
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      var target = event.target;
	
	
	      var codeArray = target.value.split('').map(function (letter) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          letter
	        );
	      });
	      var newMask = [].concat(_toConsumableArray(codeArray), _toConsumableArray(getMask(5 - codeArray.length)));
	
	      this.setState({ code: target.value, mask: newMask });
	    }
	  }, {
	    key: 'handleButtonClick',
	    value: function handleButtonClick(e) {
	      var _props = this.props,
	          smsFormSending = _props.smsFormSending,
	          number = _props.number;
	      var code = this.state.code;
	      // tracker.sendEvent('Web_Sms_Code_Entered');
	
	      smsFormSending(number, code);
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleResendClick',
	    value: function handleResendClick() {
	      var _props2 = this.props,
	          numberFormSending = _props2.numberFormSending,
	          number = _props2.number;
	
	      this.setState({ code: '', mask: getMask() });
	      numberFormSending(number.replace(/\s+/g, ''));
	      this.handleStartTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isLoading = _props3.isLoading,
	          smsError = _props3.smsError,
	          t = _props3.t;
	      var _state = this.state,
	          code = _state.code,
	          remainingTime = _state.remainingTime;
	
	
	      var isButtonDisabled = code.length <= 4;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _FormSMS2.default.FormInner },
	        _react2.default.createElement(
	          'div',
	          { className: _FormSMS2.default.Title },
	          t('components.login.formSMS.title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_FormSMS2.default.Description, smsError && _FormSMS2.default.LabelErr) },
	          smsError ? t('components.login.formSMS.smsError') : t('components.login.formSMS.sms')
	        ),
	        _react2.default.createElement(
	          'form',
	          { role: 'form' },
	          isLoading ? _react2.default.createElement(
	            'div',
	            { className: _FormSMS2.default.LoaderWrapper },
	            _react2.default.createElement('div', { className: _FormSMS2.default.Loader })
	          ) : _react2.default.createElement(
	            'div',
	            { className: _FormSMS2.default.InputWrap },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_FormSMS2.default.Input, smsError && _FormSMS2.default.InputError) },
	              _react2.default.createElement(
	                'div',
	                { className: _FormSMS2.default.Mask },
	                this.state.mask
	              ),
	              _react2.default.createElement('input', {
	                step: '10',
	                maxLength: '5',
	                ref: function ref(_ref) {
	                  if (_ref) _ref.focus();
	                },
	                value: code,
	                onChange: this.handleInputChange
	              })
	            ),
	            remainingTime > 0 ? _react2.default.createElement(
	              'div',
	              { className: _FormSMS2.default.AwaitSMS },
	              t('components.login.formSMS.remainingTime', { remainingTime: remainingTime })
	            ) : _react2.default.createElement(
	              _Button2.default,
	              { className: _FormSMS2.default.Blue, onClick: this.handleResendClick },
	              t('components.login.formSMS.resend')
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'submit', className: _FormSMS2.default.SubmitButton, disabled: isLoading || isButtonDisabled, onClick: this.handleButtonClick },
	              t('components.login.formSMS.submit')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormSMS;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()((0, _reactRouterDom.withRouter)(FormSMS));

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormSMS = __webpack_require__(1038);
	
	var _FormSMS2 = _interopRequireDefault(_FormSMS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FormSMS2.default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ramda = __webpack_require__(595);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _loginForms = __webpack_require__(161);
	
	var _index = __webpack_require__(222);
	
	var _utils = __webpack_require__(12);
	
	var _profile = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var profile = _ref.profile;
	  return {
	    profile: profile
	  };
	};
	
	var mapDispatchToProps = {
	  loadProfile: _profile.loadProfile
	};
	
	var ObserveErrors = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactRouterDom.withRouter)(_class = _dec(_class = function (_Component) {
	  _inherits(ObserveErrors, _Component);
	
	  function ObserveErrors() {
	    _classCallCheck(this, ObserveErrors);
	
	    return _possibleConstructorReturn(this, (ObserveErrors.__proto__ || Object.getPrototypeOf(ObserveErrors)).apply(this, arguments));
	  }
	
	  _createClass(ObserveErrors, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      _axios2.default.interceptors.response.use(null, function (error) {
	        if (_ramda2.default.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NO_PAID_SERVICE') {
	          _this2.props.history.push('/');
	          if (_this2.props.profile.tariff && !_this2.props.profile.isLoading) {
	            _this2.props.loadProfile().then(function () {
	              _this2.props.history.push('/');
	            });
	          }
	        }
	        if (_ramda2.default.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NOT_PERMISSION') {
	          // WTF ?
	          _index.store.getState().authentication.authenticated = false;
	          _index.store.getState().loginForms.isLoading = false;
	          _index.store.getState().loginForms.loginState = 'Number';
	          localStorage.removeItem('token');
	          (0, _utils.initAxios)();
	          _index.store.dispatch((0, _loginForms.userLogout)());
	        }
	        return Promise.reject(error);
	      });
	
	      return null;
	    }
	  }]);
	
	  return ObserveErrors;
	}(_react.Component)) || _class) || _class);
	exports.default = ObserveErrors;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ObserveErrors = __webpack_require__(1040);
	
	var _ObserveErrors2 = _interopRequireDefault(_ObserveErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ObserveErrors2.default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PayForTarifBtn = __webpack_require__(214);
	
	var _PayForTarifBtn2 = _interopRequireDefault(_PayForTarifBtn);
	
	var _style = __webpack_require__(1426);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _iconError = __webpack_require__(1540);
	
	var _iconError2 = _interopRequireDefault(_iconError);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FailPage = function (_Component) {
	  _inherits(FailPage, _Component);
	
	  function FailPage() {
	    _classCallCheck(this, FailPage);
	
	    return _possibleConstructorReturn(this, (FailPage.__proto__ || Object.getPrototypeOf(FailPage)).apply(this, arguments));
	  }
	
	  _createClass(FailPage, [{
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _style2.default.PayResultWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.PayResult },
	          _react2.default.createElement('img', { src: _iconError2.default, alt: '', className: _style2.default.PayResultIcon }),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.PayResultTitle },
	            t('components.payments.failPage.title')
	          ),
	          _react2.default.createElement('div', {
	            className: _style2.default.PayResultText,
	            dangerouslySetInnerHTML: { __html: t('components.payments.failPage.description') }
	          }),
	          _react2.default.createElement(
	            _PayForTarifBtn2.default,
	            { className: _style2.default.PayResultButton },
	            t('components.payments.failPage.tryMore')
	          )
	        )
	      );
	    }
	  }]);
	
	  return FailPage;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(FailPage);

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FailPage = __webpack_require__(1042);
	
	var _FailPage2 = _interopRequireDefault(_FailPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FailPage2.default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _constants = __webpack_require__(92);
	
	var _utils = __webpack_require__(12);
	
	var _utils2 = __webpack_require__(487);
	
	var _payments = __webpack_require__(307);
	
	var _PayForTarifBtn = __webpack_require__(214);
	
	var _PayForTarifBtn2 = _interopRequireDefault(_PayForTarifBtn);
	
	var _alert = __webpack_require__(540);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _style = __webpack_require__(535);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _style3 = __webpack_require__(1427);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _withObservePayments = __webpack_require__(221);
	
	var _withObservePayments2 = _interopRequireDefault(_withObservePayments);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var profile = _ref.profile,
	      payments = _ref.payments;
	  return {
	    profile: profile,
	    isShown: payments.isNotificationShown
	  };
	};
	
	var Notification = (_dec = (0, _reactRedux.connect)(mapStateToProps, { hideNotification: _payments.hideNotification }), (0, _withObservePayments2.default)(_class = _dec(_class = function (_Component) {
	  _inherits(Notification, _Component);
	
	  function Notification() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Notification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref2, [this].concat(args))), _this), _this.close = function () {
	      _this.props.hideNotification();
	    }, _this.getTarif = function (pricing) {
	      var t = _this.props.t;
	
	      switch (pricing) {
	        case _constants.TARIFFS.COMPANY:
	          return t('components.payments.notification.company');
	        case _constants.TARIFFS.PERSONAL:
	          return t('components.payments.notification.personal');
	        case _constants.TARIFFS.COMPANY_TEST:
	          return t('components.payments.notification.company_test');
	        case _constants.TARIFFS.PERSONAL_TEST:
	          return t('components.payments.notification.personal_test');
	        default:
	          console.warn('No such tarif name: ', name);
	          return t('components.payments.notification.default');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Notification, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          profile = _props.profile,
	          isShown = _props.isShown,
	          t = _props.t;
	
	      if (!isShown) return null;
	      var tariff = profile.tariff,
	          agencyName = profile.agencyName;
	
	      var role = (0, _utils.getUserRole)(profile);
	      var tarif = this.getTarif(tariff.pricing);
	      var classes = (0, _classnames2.default)(_style2.default.root, className, _style4.default.root);
	      var isIndividual = role === _constants.USER_ROLE.INDIVIDUAL;
	      var countDay = tariff.countDay;
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.TarifTerm, _style4.default.text) },
	          _react2.default.createElement('img', { src: _alert2.default, alt: '', className: _style2.default.IconAlert }),
	          _react2.default.createElement(
	            'span',
	            null,
	            t('components.payments.notification.title', {
	              days: countDay + ' ' + (0, _utils2.getNumEnding)(countDay, [t('components.payments.notification.day1'), t('components.payments.notification.day2'), t('components.payments.notification.day3')]),
	              tarif: tarif,
	              agencyName: isIndividual ? '' : '\xAB' + agencyName + '\xBB'
	            })
	          )
	        ),
	        isIndividual && _react2.default.createElement(_PayForTarifBtn2.default, {
	          className: _style2.default.PayForTarifBtn,
	          onClick: this.close
	        })
	        // :
	        // <ShowTarifBtn />
	        ,
	        _react2.default.createElement('img', { onClick: this.close, className: _style4.default.close, src: '/static/media/cross.87a14b4c.svg', alt: '' })
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component)) || _class) || _class);
	exports.default = (0, _reactI18next.withTranslation)()(Notification);

/***/ }),
/* 1045 */
[2400, 1044],
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1428);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _FormTechnicalProblem = __webpack_require__(483);
	
	var _FormTechnicalProblem2 = _interopRequireDefault(_FormTechnicalProblem);
	
	var _Config = __webpack_require__(16);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tariffs = [{ id: 1, name: 'tarifSolo', months: 1, price: '1 999 ₽' }, { id: 106, name: 'tarifSolo', months: 3, price: '4 999 ₽', fullPrice: '6 999 ₽', pricePerMonth: '1 666 ₽/мес', discount: '-17%' }, { id: 51, name: 'tarifSolo', months: 12, price: '16 999 ₽', fullPrice: '23 999 ₽', pricePerMonth: '1 416 ₽/мес', discount: '-33%', label: 'popular' }];
	
	var PayForTarif = function (_Component) {
	  _inherits(PayForTarif, _Component);
	
	  function PayForTarif(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PayForTarif);
	
	    var _this = _possibleConstructorReturn(this, (PayForTarif.__proto__ || Object.getPrototypeOf(PayForTarif)).call(this, props));
	
	    _this.handlePayClick = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var response, confirmationUrl;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _tracker2.default.sendEvent('Web_Profile_Renew_Subscription');
	
	              _context.prev = 1;
	              _context.next = 4;
	              return _axios2.default.post(_Config.ROOT_URL + '/payments', { tariffId: _this.state.selectedTarif });
	
	            case 4:
	              response = _context.sent;
	              confirmationUrl = response.data.data.confirmationUrl;
	
	
	              window.open(confirmationUrl, '_blank');
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              console.error('Ошибка при обработке платежа:', _context.t0);
	              _this.setState({ showError: true });
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[1, 9]]);
	    }));
	
	    _this.showRequestForm = function () {
	      _this.props.showRequestForm();
	    };
	
	    _this.selectTarif = function (tariffId) {
	      _this.setState({ selectedTarif: tariffId });
	    };
	
	    _this.state = {
	      showError: false,
	      selectedTarif: null
	    };
	    return _this;
	  }
	
	  _createClass(PayForTarif, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var _state = this.state,
	          showError = _state.showError,
	          selectedTarif = _state.selectedTarif;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _style2.default.TarifPay },
	        showError && _react2.default.createElement(_FormTechnicalProblem2.default, {
	          handleCloseModal: function handleCloseModal() {
	            return _this3.setState({ showError: false });
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.TarifPayHead },
	          t('components.payments.payForTarif.title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.TarifPaySubtitle },
	          t('components.payments.payForTarif.subtitle')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Tarifs },
	          tariffs.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              {
	                key: item.id,
	                className: (0, _classnames2.default)(_style2.default.TarifCard, _defineProperty({}, _style2.default.selected, selectedTarif === item.id)),
	                onClick: function onClick() {
	                  return _this3.selectTarif(item.id);
	                }
	              },
	              item.label && _react2.default.createElement(
	                'div',
	                { className: _style2.default.Label },
	                t('components.payments.payForTarif.' + item.label)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _style2.default.TarifCardTitle },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.TarifCardName },
	                  t('components.payments.payForTarif.' + item.name)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.TarifCardMonths },
	                  t('components.payments.payForTarif.months.' + item.months)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _style2.default.Content },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.ContentPrice },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _style2.default.Price },
	                    item.price
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _style2.default.FullPrice },
	                    item.fullPrice
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.ContentRight },
	                  item.discount && _react2.default.createElement(
	                    'div',
	                    { className: _style2.default.Discount },
	                    item.discount
	                  ),
	                  item.pricePerMonth && _react2.default.createElement(
	                    'div',
	                    { className: _style2.default.PricePerMonth },
	                    item.pricePerMonth
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.TarifCardFooter },
	          _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)(_style2.default.FooterButton, 'button-primary', 'button-primary--md'),
	              onClick: this.handlePayClick,
	              disabled: !selectedTarif
	            },
	            t('components.payments.payForTarif.button')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PayForTarif;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(PayForTarif);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PayForTarif = __webpack_require__(1046);
	
	var _PayForTarif2 = _interopRequireDefault(_PayForTarif);
	
	var _environment = __webpack_require__(19);
	
	var _RequestToConnect = __webpack_require__(1051);
	
	var _RequestToConnect2 = _interopRequireDefault(_RequestToConnect);
	
	var _redux = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userId: state.profile.id
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closePopup: function closePopup() {
	      return dispatch((0, _environment.setPopUp)());
	    },
	    showRequestForm: function showRequestForm() {
	      return dispatch((0, _environment.setPopUp)(_react2.default.createElement(_RequestToConnect2.default, null), { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false }));
	    }
	  };
	};
	
	var mergeProps = function mergeProps(stateProps, dispatchProps, otherProps) {
	  return _extends({
	    shopSuccessUrl:  false ? 'http://portaldev.nedvx.ru/pay/success' : 'https://nedvex.ru/pay/success',
	    shopFailUrl:  false ? 'http://portaldev.nedvx.ru/pay/fail' : 'https://nedvex.ru/pay/fail'
	  }, stateProps, dispatchProps, otherProps);
	};
	
	exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps))(_PayForTarif2.default);

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PayForTarifContainer = __webpack_require__(1047);
	
	var _PayForTarifContainer2 = _interopRequireDefault(_PayForTarifContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PayForTarifContainer2.default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _environment = __webpack_require__(19);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PayForTarif = __webpack_require__(1048);
	
	var _PayForTarif2 = _interopRequireDefault(_PayForTarif);
	
	var _style = __webpack_require__(1429);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PayForTarifBtn = (_dec = (0, _reactRedux.connect)(null, { setPopUp: _environment.setPopUp }), _dec(_class = function (_Component) {
	  _inherits(PayForTarifBtn, _Component);
	
	  function PayForTarifBtn() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PayForTarifBtn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PayForTarifBtn.__proto__ || Object.getPrototypeOf(PayForTarifBtn)).call.apply(_ref, [this].concat(args))), _this), _this.payForTarif = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var setPopUp;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _tracker2.default.sendEvent('Web_Profile_Renew_Subscription');
	
	              setPopUp = _this.props.setPopUp;
	
	              setPopUp(_react2.default.createElement(_PayForTarif2.default, null), { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PayForTarifBtn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          t = _props.t;
	
	      var classes = (0, _classnames2.default)(className, _style2.default.root, 'button-primary', 'button-primary--lg');
	      return _react2.default.createElement(
	        'button',
	        { className: classes, onClick: this.payForTarif },
	        this.props.children || t('components.payments.payForTarif.button')
	      );
	    }
	  }]);
	
	  return PayForTarifBtn;
	}(_react.Component)) || _class);
	exports.default = (0, _reactI18next.withTranslation)()(PayForTarifBtn);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reduxForm = __webpack_require__(130);
	
	var _Select = __webpack_require__(1110);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _InputForm = __webpack_require__(1104);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _validate = __webpack_require__(1052);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _style = __webpack_require__(1430);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var options = [{ value: 'до 10', label: 'до 10' }, { value: 'до 20', label: 'до 20' }, { value: 'до 30', label: 'до 30' }, { value: 'до 50', label: 'до 50' }, { value: 'до 75', label: 'до 75' }, { value: 'до 100', label: 'до 100' }];
	
	var RequestToConnect = function (_Component) {
	  _inherits(RequestToConnect, _Component);
	
	  function RequestToConnect() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RequestToConnect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RequestToConnect.__proto__ || Object.getPrototypeOf(RequestToConnect)).call.apply(_ref, [this].concat(args))), _this), _this.checkbox = function (_ref2) {
	      var input = _ref2.input,
	          text = _ref2.text,
	          _ref2$meta = _ref2.meta,
	          touched = _ref2$meta.touched,
	          error = _ref2$meta.error;
	      return _react2.default.createElement(
	        'div',
	        { className: _style2.default.rules },
	        _react2.default.createElement(_Checkbox2.default, _extends({
	          innerStyle: _style2.default.rulesCheckbox,
	          text: text,
	          checked: input.value
	        }, input)),
	        touched && error && _react2.default.createElement(
	          'div',
	          { className: _style2.default.error },
	          error
	        )
	      );
	    }, _this.select = function (options) {
	      return _react2.default.createElement(_Select2.default, options);
	    }, _this.submit = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                data.countUsers = data.countUsers.value;
	                _context.next = 3;
	                return _this.props.onSubmit(data);
	
	              case 3:
	                _this.props.setPopUp();
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref3.apply(this, arguments);
	      };
	    }(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RequestToConnect, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'form',
	        { className: _style2.default.root, onSubmit: this.props.handleSubmit(function (data) {
	            return _this3.submit(data);
	          }) },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.head },
	          '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.fields },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.basic },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'companyName',
	              component: _InputForm2.default,
	              label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438',
	              placeholder: '\u0410\u0432\u0438 \u0418\u043D\u0432\u0435\u0441\u0442',
	              className: _style2.default.input,
	              required: true
	            }),
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'countUsers',
	              component: this.select,
	              label: '\u041A\u043E\u043B-\u0432\u043E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432',
	              placeholder: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435...',
	              className: _style2.default.input,
	              options: options,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.informationWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.h },
	              '\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.information },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'name',
	                component: _InputForm2.default,
	                label: '\u0418\u043C\u044F',
	                placeholder: '\u0415\u0432\u0433\u0435\u043D\u0438\u0439',
	                className: (0, _classnames2.default)(_style2.default.input, _style2.default.inputSpace),
	                required: true
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'soname',
	                component: _InputForm2.default,
	                label: '\u0424\u0430\u043C\u0438\u043B\u0438\u044F',
	                placeholder: '\u041F\u0435\u0442\u0440\u043E\u0432',
	                className: (0, _classnames2.default)(_style2.default.input, _style2.default.inputSpace),
	                required: true
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'position',
	                component: _InputForm2.default,
	                label: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C',
	                placeholder: '\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442 \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0430\u043C',
	                className: _style2.default.input,
	                required: true
	              }),
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'phone',
	                component: _InputForm2.default,
	                label: '+7 (000) 000-00-00',
	                placeholder: '\u0422\u0435\u043B\u0435\u0444\u043E\u043D',
	                className: _style2.default.input,
	                required: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.bottom },
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'rules',
	            component: this.checkbox,
	            text: _react2.default.createElement(
	              'span',
	              null,
	              '\u042F \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445'
	            ),
	            required: true
	          }),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: _style2.default.btn },
	            '\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RequestToConnect;
	}(_react.Component);
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'RequestToConnect',
	  validate: _validate2.default
	})(RequestToConnect);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RequestToConnect = __webpack_require__(1050);
	
	var _RequestToConnect2 = _interopRequireDefault(_RequestToConnect);
	
	var _payments = __webpack_require__(307);
	
	var _reactRedux = __webpack_require__(5);
	
	var _environment = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reactRedux.connect)(null, { setPopUp: _environment.setPopUp, onSubmit: _payments.requestToConnect })(_RequestToConnect2.default);

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.phone) {
	    errors.phone = 'Введите телефон';
	  } else if (values.phone.replace(/\D/g, '').length < 11) {
	    errors.phone = 'Неверный телефон';
	  }
	  if (!values.name) {
	    errors.name = 'Введите имя';
	  }
	  if (!values.companyName) {
	    errors.companyName = 'Введите название компании';
	  }
	  if (!values.soname) {
	    errors.soname = 'Введите фамилию';
	  }
	  if (!values.company) {
	    errors.company = 'Введите название компании';
	  }
	  if (!values.countUsers) {
	    errors.countUsers = 'Выберите кол-во сотрудников';
	  }
	  if (!values.rules) {
	    errors.rules = 'Согласитесь с правилами';
	  }
	  if (!values.position) {
	    errors.position = 'Введите должность';
	  } else if (values.position.length > 30) {
	    errors.position = 'Слишком длинная должность';
	  }
	  return errors;
	};
	
	exports.default = validate;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _constants = __webpack_require__(92);
	
	var _utils = __webpack_require__(12);
	
	var _utils2 = __webpack_require__(487);
	
	var _profile = __webpack_require__(40);
	
	var _PayForTarifBtn = __webpack_require__(214);
	
	var _PayForTarifBtn2 = _interopRequireDefault(_PayForTarifBtn);
	
	var _alert = __webpack_require__(540);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _style = __webpack_require__(535);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _reactI18next = __webpack_require__(4);
	
	var _TariffModal = __webpack_require__(1069);
	
	var _helpers = __webpack_require__(496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SubscriptionBar = function SubscriptionBar(_ref) {
	  var className = _ref.className;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showModal = _useState2[0],
	      setShowModal = _useState2[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (_ref2) {
	    var profile = _ref2.profile,
	        profiles = _ref2.profiles,
	        company = _ref2.company;
	    return {
	      profile: profile,
	      company: company.data,
	      workersCount: profiles.data ? profiles.data.length : 0
	    };
	  }),
	      company = _useSelector.company,
	      profile = _useSelector.profile,
	      workersCount = _useSelector.workersCount;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _profile.loadCompanyProfiles)({}));
	  }, []);
	
	  var tariff = profile.tariff;
	
	  var role = (0, _utils.getUserRole)(profile);
	  var tarif = (0, _utils.getTarifName)(tariff.pricing);
	  var classes = (0, _classnames2.default)(_style2.default.root, className);
	  var isIndividual = role === _constants.USER_ROLE.INDIVIDUAL;
	  var countDay = tariff.countDay;
	  var workersPercent = Math.round(workersCount / tariff.countPeople * 100);
	  var workersPercClass = 'p' + (workersPercent > 100 ? 100 : workersPercent);
	
	  var countPeople = tariff.countPeople ? tariff.countPeople > 30 ? '30+' : tariff.countPeople : '';
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_style2.default.TarifTerm, _defineProperty({}, _style2.default.Red, countDay == 0)) },
	      countDay < 6 && _react2.default.createElement('img', { src: _alert2.default, alt: '', className: _style2.default.IconAlert }),
	      countDay > 0 ? _react2.default.createElement(
	        'span',
	        null,
	        t('components.payments.subscriptionBar.title', {
	          countDay: countDay + ' ' + (0, _utils2.getNumEnding)(countDay, [t('components.payments.subscriptionBar.day1'), t('components.payments.subscriptionBar.day2'), t('components.payments.subscriptionBar.day3')]),
	          left: (0, _utils2.getNumEnding)(countDay, [t('components.payments.subscriptionBar.left1'), t('components.payments.subscriptionBar.left2'), t('components.payments.subscriptionBar.left3')])
	        })
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        t('components.payments.subscriptionBar.ended')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.TarifName },
	      !isIndividual ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.TarifCircle, _style2.default.c100, _style2.default[workersPercClass]) },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.slice },
	          _react2.default.createElement('div', { className: _style2.default.bar }),
	          _react2.default.createElement('div', { className: _style2.default.fill })
	        )
	      ) : null,
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.TarifNameMain },
	        _react2.default.createElement(
	          'div',
	          null,
	          t('components.payments.subscriptionBar.tarif', { tarif: tarif })
	        ),
	        !isIndividual && _react2.default.createElement(
	          'div',
	          { className: _style2.default.TarifNameWorkers },
	          t('components.payments.subscriptionBar.workers', {
	            workersCount: workersCount,
	            countPeople: countPeople
	          })
	        )
	      )
	    ),
	    isIndividual ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement('div', {
	        className: _style2.default.TarifText,
	        dangerouslySetInnerHTML: { __html: t('components.payments.subscriptionBar.text') }
	      }),
	      _react2.default.createElement(_PayForTarifBtn2.default, { className: (0, _classnames2.default)(_style2.default.PayForTarifBtn, 'button-primary', 'button-primary--lg') })
	    ) : _helpers.isTariffsEnabled && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      showModal && _react2.default.createElement(_TariffModal.TariffModal, { onClose: function onClose() {
	          return setShowModal(false);
	        } }),
	      _react2.default.createElement(
	        'button',
	        { className: (0, _classnames2.default)(_style2.default.PayForTarifBtn, 'button-default', 'button-primary--lg'), onClick: function onClick() {
	            return setShowModal(true);
	          } },
	        '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0430\u0440\u0438\u0444'
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactI18next.withTranslation)()(SubscriptionBar);

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _style = __webpack_require__(1431);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _iconSuccess = __webpack_require__(1556);
	
	var _iconSuccess2 = _interopRequireDefault(_iconSuccess);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessPage = function SuccessPage() {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _style2.default.PayResultWrap },
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.PayResult },
	      _react2.default.createElement('img', { src: _iconSuccess2.default, alt: '', className: _style2.default.PayResultIcon }),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.PayResultTitle },
	        t('components.payments.successPage.title')
	      ),
	      _react2.default.createElement('div', {
	        className: _style2.default.PayResultText,
	        dangerouslySetInnerHTML: { __html: t('components.payments.successPage.description') }
	      }),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/', className: _style2.default.PayResultButton },
	        t('components.payments.successPage.goToMain')
	      )
	    )
	  );
	};
	
	exports.default = SuccessPage;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SuccessPage = __webpack_require__(1054);
	
	var _SuccessPage2 = _interopRequireDefault(_SuccessPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SuccessPage2.default;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentCard = __webpack_require__(1432);
	
	var _AppointmentCard2 = _interopRequireDefault(_AppointmentCard);
	
	var _Appointments = __webpack_require__(316);
	
	var _ga = __webpack_require__(7);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppointmentCard = function AppointmentCard(_ref) {
	  var appointment = _ref.appointment,
	      activeTabIndex = _ref.activeTabIndex,
	      profileId = _ref.profileId,
	      onShowInfo = _ref.onShowInfo;
	
	  var hasTrackedShowEvent = (0, _react.useRef)(false);
	
	  (0, _react.useEffect)(function () {
	    if (!hasTrackedShowEvent.current) {
	      var statusName = activeTabIndex === 1 ? appointment.status === 0 ? 'v_rabote' : 'naznachen' : appointment.status === 2 ? 'proveden' : 'otmenen';
	
	      var eventContent = statusName + ' | ' + appointment.type;
	
	      (0, _ga.trackGA)(_ga.gaEvent.profileAppointmentCardShow({
	        eventContent: eventContent,
	        productName: appointment.buildingName,
	        productID: appointment.buildingId,
	        user_id: profileId
	      }));
	
	      hasTrackedShowEvent.current = true;
	    }
	  }, [activeTabIndex, appointment, profileId]);
	
	  var handleShowInfo = function handleShowInfo() {
	    var eventContent = appointment.status === 0 || appointment.status === 1 ? 'budushchie_zapisi' : 'proshedshie_zapisi';
	
	    (0, _ga.trackGA)(_ga.gaEvent.profileAppointmentButtonClick({
	      eventContent: eventContent,
	      // productType,
	      productName: appointment.buildingName,
	      productID: appointment.buildingId,
	      user_id: profileId
	    }));
	
	    onShowInfo(appointment);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _AppointmentCard2.default.AppointmentCard },
	    _react2.default.createElement(
	      'div',
	      { className: _AppointmentCard2.default.CardStatus },
	      (0, _Appointments.getStatusLabel)(appointment.status),
	      (0, _Appointments.getTypeLabel)(appointment.type)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _AppointmentCard2.default.CardContent },
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentCard2.default.AppointmentInfo },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentCard2.default.BuildingName },
	          appointment.buildingName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentCard2.default.Data },
	          (0, _Appointments.formatAppointmentDate)(appointment.dateTimeFrom)
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(_AppointmentCard2.default.ShowAppointmentButton, 'button-default', 'button-primary--lg'),
	          onClick: handleShowInfo
	        },
	        '\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C'
	      )
	    )
	  );
	};
	
	exports.default = AppointmentCard;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentInfoDialog = __webpack_require__(1433);
	
	var _AppointmentInfoDialog2 = _interopRequireDefault(_AppointmentInfoDialog);
	
	var _Appointments = __webpack_require__(316);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppointmentInfoDialog = function AppointmentInfoDialog(_ref) {
	  var appointment = _ref.appointment;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _AppointmentInfoDialog2.default.AppointmentInfoDialog },
	    _react2.default.createElement(
	      'div',
	      { className: _AppointmentInfoDialog2.default.Header },
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.Labels },
	        (0, _Appointments.getStatusLabel)(appointment.status),
	        (0, _Appointments.getTypeLabel)(appointment.type)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.Title },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.ObjectName },
	          appointment.buildingName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.Address },
	          appointment.buildingAddress
	        )
	      )
	    ),
	    _react2.default.createElement('div', { className: _AppointmentInfoDialog2.default.Divider }),
	    _react2.default.createElement(
	      'div',
	      { className: _AppointmentInfoDialog2.default.Content },
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.dateAndTime')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          (0, _Appointments.formatAppointmentDate)(appointment.dateTimeFrom)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.clientName')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          appointment.firstNameClient
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.clientDate')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          appointment.phoneClient
	        )
	      ),
	      appointment.comment && _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.comment')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          appointment.comment
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.agentName')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          appointment.firstNameAgent,
	          ' ',
	          appointment.lastNameAgent
	        )
	      ),
	      appointment.agencyName && _react2.default.createElement(
	        'div',
	        { className: _AppointmentInfoDialog2.default.InfoField },
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldName },
	          t('components.profile.appointments.agency')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppointmentInfoDialog2.default.FieldText },
	          appointment.agencyName
	        )
	      )
	    )
	  );
	};
	
	exports.default = AppointmentInfoDialog;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageCrop = __webpack_require__(1983);
	
	var _reactImageCrop2 = _interopRequireDefault(_reactImageCrop);
	
	__webpack_require__(1320);
	
	var _style = __webpack_require__(1436);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _utils = __webpack_require__(1059);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvatarUploader = function (_Component) {
	  _inherits(AvatarUploader, _Component);
	
	  function AvatarUploader(props) {
	    _classCallCheck(this, AvatarUploader);
	
	    var _this = _possibleConstructorReturn(this, (AvatarUploader.__proto__ || Object.getPrototypeOf(AvatarUploader)).call(this, props));
	
	    _this.handleSaveClick = function () {
	      _this.props.onSave(_this.state.cropedImg || _this.props.file);
	    };
	
	    _this.onCropComplete = function (crop) {
	      var cropedImg = (0, _utils.cropToImgFile)({ crop: crop, image: _this.state.image });
	      _this.setState({ cropedImg: cropedImg });
	    };
	
	    _this.state = {
	      preview: props.preview
	    };
	    return _this;
	  }
	
	  _createClass(AvatarUploader, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (!nextState.cropedImg !== this.state.cropedImg) return false;
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var _this2 = this;
	
	      var image = new Image();
	      image.addEventListener('load', function () {
	        _this2.setState({ image: image });
	      });
	
	      image.src = this.props.preview;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	
	      var crop = {
	        aspect: 1,
	        width: 300,
	        height: 300
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: _style2.default.UploadPhotoPopup },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.UploadPhotoPopupHeader },
	          t('components.profile.avatarUploader.update')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.cropContainer },
	          _react2.default.createElement(_reactImageCrop2.default, {
	            src: this.state.preview,
	            onComplete: this.onCropComplete,
	            crop: crop,
	            maxHeight: 400,
	            maxWidth: 300,
	            keepSelection: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.buttons },
	          _react2.default.createElement(
	            'button',
	            {
	              className: _style2.default.saveButton,
	              onClick: this.handleSaveClick
	            },
	            t('components.profile.avatarUploader.button')
	          )
	        )
	      );
	    }
	  }]);
	
	  return AvatarUploader;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(AvatarUploader);

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dataURItoBlob = exports.dataURItoBlob = function dataURItoBlob(dataURI) {
	    // convert base64/URLEncoded data component to raw binary data held in a string
	    var byteString;
	    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);
	    // separate out the mime component
	    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	    // write the bytes of the string to a typed array
	    var ia = new Uint8Array(byteString.length);
	    for (var i = 0; i < byteString.length; i++) {
	        ia[i] = byteString.charCodeAt(i);
	    }
	    return new Blob([ia], { type: mimeString });
	};
	
	var cropToImgFile = exports.cropToImgFile = function cropToImgFile(_ref) {
	    var crop = _ref.crop,
	        image = _ref.image;
	
	    var imageWidth = image.width;
	    var imageHeight = image.height;
	
	    var cropX = crop.x / 100 * imageWidth;
	    var cropY = crop.y / 100 * imageHeight;
	
	    var cropWidth = crop.width / 100 * imageWidth;
	    var cropHeight = crop.height / 100 * imageHeight;
	
	    var canvas = document.createElement('canvas');
	    canvas.width = cropWidth;
	    canvas.height = cropHeight;
	    var ctx = canvas.getContext('2d');
	
	    ctx.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
	
	    var src = canvas.toDataURL('image/jpeg');
	    return new File([dataURItoBlob(src)], 'newImage', { type: 'image/jpeg', lastModified: Date.now() });
	};

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reduxForm = __webpack_require__(130);
	
	var _profile = __webpack_require__(40);
	
	var _reactStickyEl = __webpack_require__(187);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	var _Config = __webpack_require__(16);
	
	var _styles = __webpack_require__(337);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Avatar = __webpack_require__(488);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Social = __webpack_require__(495);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _EmployersList = __webpack_require__(1064);
	
	var _EmployersList2 = _interopRequireDefault(_EmployersList);
	
	var _SubscriptionBar = __webpack_require__(486);
	
	var _SubscriptionBar2 = _interopRequireDefault(_SubscriptionBar);
	
	var _AvatarUploader = __webpack_require__(489);
	
	var _AvatarUploader2 = _interopRequireDefault(_AvatarUploader);
	
	var _environment = __webpack_require__(19);
	
	var _Input = __webpack_require__(491);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Textarea = __webpack_require__(492);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helpers = __webpack_require__(496);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.name) {
	    errors.name = _i18n2.default.t('components.profile.company.validate.name');
	  } else if (values.name.length > 30) {
	    errors.name = _i18n2.default.t('components.profile.company.validate.nameError');
	  }
	  if (_helpers.isTariffsEnabled) {
	    if (!values.inn || values.inn.length < 10 || values.inn.length > 12 || !values.inn) {
	      errors.inn = _i18n2.default.t('components.profile.company.validate.inn');
	    }
	  }
	
	  if (!values.kpp || values.kpp.length !== 9) {
	    errors.kpp = _i18n2.default.t('components.profile.company.validate.kpp');
	  }
	  if (values.description && values.description.length > 500) {
	    errors.description = _i18n2.default.t('components.profile.company.validate.description');
	  }
	  if (values.office && values.office.length) {
	    var officeErrors = {};
	    values.office.forEach(function (o, index) {
	      if (!o.name) {
	        officeErrors.name = _i18n2.default.t('components.profile.company.validate.officeErrors1');
	      } else if (o.name.length > 30) {
	        officeErrors.name = _i18n2.default.t('components.profile.company.validate.officeErrors2');
	      }
	      if (!o.address) {
	        officeErrors.address = _i18n2.default.t('components.profile.company.validate.address');
	      }
	      if (!o.phone) {
	        officeErrors.phone = _i18n2.default.t('components.profile.company.validate.phone');
	      }
	      if (!o.mail) {
	        officeErrors.mail = _i18n2.default.t('components.profile.company.validate.email');
	      } else if (o.mail.length > 30) {
	        officeErrors.mail = _i18n2.default.t('components.profile.company.validate.emailError');
	      }
	      if (officeErrors) {
	        errors.office = errors.office || [];
	        errors.office[index] = officeErrors;
	      }
	    });
	  }
	
	  return errors;
	};
	
	var Input = function Input(props) {
	  return _react2.default.createElement(_Input2.default, _extends({}, props, { className: _styles2.default.InputWrapper }));
	};
	
	var OfficeInputs = function OfficeInputs(_ref) {
	  var fields = _ref.fields;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    fields.map(function (ofc, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.OfficeBlock, key: i },
	        _react2.default.createElement(
	          'p',
	          { className: _styles2.default.SectionTitle },
	          i === 0 ? t('components.profile.company.mainOffice') : t('components.profile.company.anotherOffice')
	        ),
	        _react2.default.createElement(_reduxForm.Field, { name: ofc + '.name', component: Input, label: t('components.profile.company.officeName'), placeholder: t('components.profile.company.officeNamePlaceholder'), required: true }),
	        _react2.default.createElement(_reduxForm.Field, { name: ofc + '.address', component: Input, label: t('components.profile.company.officeAddress'), placeholder: t('components.profile.company.officeAddressPlaceholder'), required: true }),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.PairInputs },
	          _react2.default.createElement(_reduxForm.Field, { name: ofc + '.phone', component: Input, label: t('components.profile.company.officePhone'), placeholder: '8 (800) 000 0000', required: true }),
	          _react2.default.createElement(_reduxForm.Field, { name: ofc + '.mail', component: Input, label: t('components.profile.company.officeEmail'), placeholder: 'welcome@mail.com', required: true })
	        )
	      );
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.AddOfficeBtnWrap },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _styles2.default.AddOfficeBtn,
	          onClick: function onClick() {
	            fields.push({});
	          }
	        },
	        t('components.profile.company.plusOffice')
	      )
	    )
	  );
	};
	
	var TextInput = function TextInput(props) {
	  return _react2.default.createElement(_Textarea2.default, _extends({}, props, { className: _styles2.default.TextareaWrapper }));
	};
	
	var Company = function (_Component) {
	  _inherits(Company, _Component);
	
	  function Company(props) {
	    _classCallCheck(this, Company);
	
	    var _this = _possibleConstructorReturn(this, (Company.__proto__ || Object.getPrototypeOf(Company)).call(this, props));
	
	    _this.onLoadPhoto = function (_ref2) {
	      var preview = _ref2.preview,
	          file = _ref2.file;
	      var _this$props = _this.props,
	          uploadLogo = _this$props.uploadLogo,
	          setPopUp = _this$props.setPopUp;
	
	      setPopUp(_react2.default.createElement(_AvatarUploader2.default, {
	        file: file,
	        preview: preview,
	        onSave: function onSave(file) {
	          var data = new FormData();
	          data.append('file', file);
	          setPopUp();
	          uploadLogo(data);
	        }
	      }), { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
	    };
	
	    _this.state = {
	      list: false
	    };
	    return _this;
	  }
	
	  _createClass(Company, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var loadCompany = this.props.loadCompany;
	
	
	      loadCompany({});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          updateCompany = _props.updateCompany,
	          initialValues = _props.initialValues,
	          logoId = _props.logoId,
	          agencyId = _props.agencyId,
	          path = _props.match.path,
	          profile = _props.profile,
	          t = _props.t;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.ProfileCompanyWrap, _defineProperty({}, _styles2.default.ProfileCompanyAdmin, profile.roleId === '15')) },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.ProfileCompany },
	          initialValues && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.Title },
	              t('components.profile.company.title')
	            ),
	            profile.roleName === 'owner' && _react2.default.createElement(_SubscriptionBar2.default, { className: _styles2.default.SubscriptionBar }),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.Inner },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Nav },
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    exact: true,
	                    to: '/company',
	                    className: _styles2.default.NavLink,
	                    activeClassName: _styles2.default.Active
	                  },
	                  t('components.profile.company.commonInfo')
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  {
	                    exact: true,
	                    to: '/company/employees',
	                    className: _styles2.default.NavLink,
	                    activeClassName: _styles2.default.Active
	                  },
	                  t('components.profile.company.workers')
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Switch,
	                null,
	                _react2.default.createElement(_reactRouterDom.Route, {
	                  exact: true,
	                  path: path + '/employees',
	                  component: _EmployersList2.default
	                }),
	                _react2.default.createElement(_reactRouterDom.Route, {
	                  exact: true,
	                  path: '' + path,
	                  render: function render() {
	                    return _react2.default.createElement(
	                      'form',
	                      {
	                        className: _styles2.default.InnerContent,
	                        onSubmit: handleSubmit(function (props) {
	                          return updateCompany(_extends({}, props, { logoId: logoId, agencyId: agencyId }));
	                        })
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.AvatarWrap },
	                        _react2.default.createElement(_Avatar2.default, {
	                          src: logoId ? _Config.ROOT_URL + '/image/get?id=' + logoId + '&preset=avatar_edit' : null,
	                          onLoadPhoto: _this2.onLoadPhoto
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.InputsWrap },
	                        _react2.default.createElement(_reduxForm.Field, {
	                          name: 'name',
	                          component: Input,
	                          label: t('components.profile.company.form.name'),
	                          placeholder: 'Leto Realty',
	                          id: 'company-name',
	                          required: true,
	                          disabled: true
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                          name: 'website',
	                          component: Input,
	                          label: t('components.profile.company.form.website'),
	                          placeholder: 'www.web-site.com',
	                          id: 'website'
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                          name: 'description',
	                          component: TextInput,
	                          label: t('components.profile.company.form.description'),
	                          placeholder: t('components.profile.company.form.description'), id: 'description',
	                          maxLength: 500
	                        }),
	                        _helpers.isTariffsEnabled && _react2.default.createElement(
	                          'div',
	                          { className: _styles2.default.Columns },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_reduxForm.Field, {
	                              name: 'inn',
	                              type: 'number',
	                              component: Input,
	                              label: t('components.profile.company.form.inn'),
	                              inputProps: {
	                                maxLength: 12,
	                                inputType: 'number'
	                              },
	                              placeholder: '',
	                              id: 'inn',
	                              required: true
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_reduxForm.Field, {
	                              name: 'kpp',
	                              component: Input,
	                              label: t('components.profile.company.form.kpp'),
	                              inputProps: {
	                                maxLength: 9,
	                                inputType: 'number'
	                              },
	                              placeholder: '',
	                              id: 'kpp',
	                              required: true
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(_reduxForm.FieldArray, { name: 'office', component: OfficeInputs }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: _styles2.default.SectionSocial },
	                          _react2.default.createElement(
	                            'p',
	                            { className: _styles2.default.SectionTitle },
	                            t('components.profile.company.socialNets')
	                          ),
	                          _react2.default.createElement(_Social2.default, null)
	                        ),
	                        _react2.default.createElement(
	                          _reactStickyEl2.default,
	                          { mode: 'bottom', stickyClassName: _styles2.default.SaveButtonWrapSticky, className: _styles2.default.SaveButtonWrap },
	                          _react2.default.createElement(
	                            'button',
	                            { className: (0, _classnames2.default)(_styles2.default.Button, _styles2.default.ButtonSave, 'button-primary', 'button-primary--lg') },
	                            t('components.profile.company.save')
	                          )
	                        )
	                      )
	                    );
	                  }
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Company;
	}(_react.Component);
	
	exports.default = Company = (0, _reactRedux.connect)(function (_ref3) {
	  var company = _ref3.company,
	      profile = _ref3.profile,
	      profiles = _ref3.profiles;
	
	  var res = {
	    initialValues: undefined,
	    logoId: company.data && company.data.logoId,
	    agencyId: company.data && company.data.id,
	    loading: company.loading,
	    profile: profile,
	    workersCount: profiles.data ? profiles.data.length : 0
	  };
	
	  if (company.loading) {
	    return res;
	  }
	  return _extends({}, res, {
	    initialValues: company.data
	  });
	}, { uploadLogo: _profile.uploadLogo, loadCompany: _profile.loadCompany, updateCompany: _profile.updateCompany, setPopUp: _environment.setPopUp })((0, _reduxForm.reduxForm)({
	  form: 'CompanyForm',
	  validate: validate
	})((0, _reactI18next.withTranslation)()(Company)));

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProfileForm = __webpack_require__(493);
	
	var _ProfileForm2 = _interopRequireDefault(_ProfileForm);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _styles = __webpack_require__(337);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Notification = __webpack_require__(315);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemberPopup = function MemberPopup(_ref) {
	  var agentId = _ref.agentId,
	      onClose = _ref.onClose,
	      onChangeAgentId = _ref.onChangeAgentId;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.PopUpOuter },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.PopUpInner },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.PopupClose, onClick: onClose },
	        _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.PopupHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.PopupTitle },
	          agentId ? t('components.profile.employerInteraction.edit') : t('components.profile.employerInteraction.new')
	        )
	      ),
	      _react2.default.createElement(_Notification2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.PopupContent },
	        agentId ? _react2.default.createElement(_ProfileForm2.default, { agentId: agentId, popup: true, onSave: onClose }) : _react2.default.createElement(_ProfileForm2.default, { isNew: true, popup: true, onSave: onClose, onGoToEdit: onChangeAgentId })
	      )
	    )
	  );
	};
	
	exports.default = MemberPopup;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(184);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(12);
	
	var _Config = __webpack_require__(16);
	
	var _iconUserSq = __webpack_require__(236);
	
	var _iconUserSq2 = _interopRequireDefault(_iconUserSq);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _styles = __webpack_require__(337);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _EmployerInteraction = __webpack_require__(1061);
	
	var _EmployerInteraction2 = _interopRequireDefault(_EmployerInteraction);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmployeeList = function (_Component) {
	  _inherits(EmployeeList, _Component);
	
	  function EmployeeList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmployeeList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmployeeList.__proto__ || Object.getPrototypeOf(EmployeeList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showPopup: false
	    }, _this.handleEditProfile = function (agentId) {
	      _this.setState(_extends({
	        showPopup: true
	      }, agentId ? { agentId: agentId } : { agentId: null }));
	    }, _this.handleClose = function () {
	      _this.setState({
	        showPopup: false,
	        agentId: null
	      });
	    }, _this.handleDeleteClick = function (id) {
	      _this.props.deleteProfile({ userId: id });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmployeeList, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      this.props.loadCompanyProfiles({});
	    }
	  }, {
	    key: 'UNSAFE_componentWillUpdate',
	    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
	      if (nextState.showPopup) {
	        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
	      } else {
	        document.getElementsByTagName('html')[0].style.overflow = 'initial';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          profiles = _props.profiles,
	          tariff = _props.tariff,
	          workersCount = _props.workersCount,
	          t = _props.t,
	          isEnoughMembers = _props.isEnoughMembers;
	
	      var employers = profiles.data ? profiles.data.sort(function (e1, e2) {
	        return e2.id - e1.id;
	      }) : [];
	      var isProfileLoaded = !!employers.length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.MembersContent },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.AddEmployee },
	          _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)(_styles2.default.Button, _styles2.default.ButtonNewMember, 'button-primary', 'button-primary--lg'),
	              onClick: function onClick() {
	                return _this2.handleEditProfile(null);
	              },
	              disabled: !isProfileLoaded || isEnoughMembers || tariff && tariff.countDay === 0
	            },
	            t('components.profile.employeeList.new')
	          ),
	          !isProfileLoaded && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.AddEmployeeText },
	            isEnoughMembers || tariff && tariff.countDay === 0 ? t('components.profile.employeeList.deny') : t('components.profile.employeeList.allow', { countPeople: (tariff && tariff.countPeople || 0) - workersCount })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.MembersList },
	          employers.map(function (_ref2) {
	            var firstName = _ref2.firstName,
	                lastName = _ref2.lastName,
	                position = _ref2.position,
	                phone = _ref2.phone,
	                avatarId = _ref2.avatarId,
	                hash = _ref2.hash,
	                roleName = _ref2.roleName,
	                id = _ref2.id;
	            return (
	              // if (!hash) console.log(firstName, lastName, id);
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Member, key: id },
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.MemberAvatar },
	                  _react2.default.createElement('img', {
	                    src: avatarId ? _Config.ROOT_URL + '/image/get?id=' + avatarId + '&preset=profile_avatar' : _iconUserSq2.default,
	                    alt: ''
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.MemberInfo },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.MemberName },
	                    firstName,
	                    ' ',
	                    lastName,
	                    ' ',
	                    roleName == 'owner' ? _react2.default.createElement(
	                      'span',
	                      { className: _styles2.default.AdminTag },
	                      t('components.profile.employeeList.admin')
	                    ) : null
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.MemberPosition },
	                    position
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'tel:+' + phone, className: _styles2.default.MemberPhone },
	                    (0, _utils.formatPhoneNumber)(phone)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.MemberHover },
	                  roleName !== 'admin' && roleName !== 'owner' && _react2.default.createElement(
	                    'button',
	                    {
	                      className: (0, _classnames2.default)(_styles2.default.MemberAction, _styles2.default.Edit),
	                      onClick: function onClick() {
	                        return _this2.handleEditProfile(id);
	                      }
	                    },
	                    t('components.profile.employeeList.edit')
	                  ),
	                  roleName !== 'admin' && roleName !== 'owner' && _react2.default.createElement(
	                    'button',
	                    {
	                      className: (0, _classnames2.default)(_styles2.default.MemberAction, _styles2.default.Delete)
	                      // onClick={() => this.setState({ deletingEmployee: hash })}
	                      , onClick: function onClick() {
	                        return _this2.setState({ deletingEmployee: id });
	                      }
	                    },
	                    t('components.profile.employeeList.delete')
	                  ),
	                  _react2.default.createElement(
	                    _Modal2.default,
	                    {
	                      title: t('components.profile.employeeList.deleteWorker')
	                      // isOpen={hash === this.state.deletingEmployee}
	                      , isOpen: id == _this2.state.deletingEmployee,
	                      handleClose: function handleClose() {
	                        return _this2.setState({ deletingEmployee: null });
	                      },
	                      contentStyle: {
	                        minWidth: '736px',
	                        minHeight: '120px'
	                      }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _styles2.default.Dialog },
	                      t('components.profile.employeeList.areYouSure', {
	                        firstName: firstName,
	                        lastName: lastName
	                      }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.Buttons },
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: (0, _classnames2.default)(_styles2.default.Button, 'button-primary', 'button-primary--lg')
	                            // onClick={this.handleDeleteClick.bind(this, hash)}
	                            , onClick: function onClick() {
	                              return _this2.handleDeleteClick(id);
	                            }
	                          },
	                          t('components.profile.employeeList.delete')
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: _styles2.default.ButtonCancel,
	                            onClick: function onClick() {
	                              return _this2.setState({ deletingEmployee: null });
	                            }
	                          },
	                          t('components.profile.employeeList.cancel')
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: this.state.showPopup,
	            onRequestClose: this.handleClose,
	            contentLabel: 'Modal',
	            className: _styles2.default.ModalContent,
	            style: {
	              overlay: {
	                zIndex: 10,
	                backgroundColor: 'rgba(0, 0, 0, 0.5)'
	              }
	            }
	          },
	          _react2.default.createElement(_EmployerInteraction2.default, _extends({}, profiles, {
	            key: this.state.agentId,
	            agentId: this.state.agentId,
	            onClose: this.handleClose,
	            onChangeAgentId: function onChangeAgentId(_ref3) {
	              var agentId = _ref3.agentId,
	                  agencyId = _ref3.agencyId;
	              return _this2.setState({ agentId: agentId, agencyId: agencyId });
	            }
	          }))
	        )
	      );
	    }
	  }]);
	
	  return EmployeeList;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(EmployeeList);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(5);
	
	var _EmployersList = __webpack_require__(1062);
	
	var _EmployersList2 = _interopRequireDefault(_EmployersList);
	
	var _profile = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var profiles = _ref.profiles,
	      tariff = _ref.profile.tariff;
	
	  var workersCount = profiles.data ? profiles.data.length : 0;
	  var isEnoughMembers = tariff ? tariff.countPeople <= workersCount : false;
	
	  return {
	    profiles: profiles,
	    isLoading: profiles.loading,
	    workersCount: workersCount,
	    tariff: tariff,
	    isEnoughMembers: isEnoughMembers
	  };
	};
	
	var mapDispatchToProps = {
	  loadCompanyProfiles: _profile.loadCompanyProfiles,
	  deleteProfile: _profile.deleteProfile,
	  updateAgentProfile: _profile.updateAgentProfile
	};
	
	// const mapDispatchToProps = {
	//
	// };
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmployersList2.default);

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmployersListContainer = __webpack_require__(1063);
	
	var _EmployersListContainer2 = _interopRequireDefault(_EmployersListContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EmployersListContainer2.default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InformPopupContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InformPopup = __webpack_require__(1437);
	
	var _InformPopup2 = _interopRequireDefault(_InformPopup);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _environment = __webpack_require__(19);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InformPopupContent = exports.InformPopupContent = function InformPopupContent(_ref) {
	  var type = _ref.type,
	      onOkButtonClick = _ref.onOkButtonClick;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleButtonClick = function handleButtonClick() {
	    dispatch((0, _environment.setPopUp)());
	    if (type === 'userAlreadyExists') {
	      onOkButtonClick();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _InformPopup2.default.PopupContent },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _InformPopup2.default.PopupTitle },
	          t('components.profile.profileForm.informPopup.' + type + 'Title')
	        ),
	        _react2.default.createElement('div', { className: _InformPopup2.default.Divider }),
	        _react2.default.createElement(
	          'div',
	          { className: _InformPopup2.default.PopupSubtitle },
	          t('components.profile.profileForm.informPopup.' + type + 'Subtitle')
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)(_InformPopup2.default.ActionBtn, _InformPopup2.default.LeaveAgencyButton, 'button-primary', 'button-primary--md'),
	            onClick: handleButtonClick
	          },
	          t('components.profile.profileForm.informPopup.' + type + 'Button')
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _Profile = __webpack_require__(172);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ProfileForm = __webpack_require__(493);
	
	var _ProfileForm2 = _interopRequireDefault(_ProfileForm);
	
	var _SubscriptionBar = __webpack_require__(486);
	
	var _SubscriptionBar2 = _interopRequireDefault(_SubscriptionBar);
	
	var _constants = __webpack_require__(92);
	
	var _utils = __webpack_require__(12);
	
	var _withObservePayments = __webpack_require__(221);
	
	var _withObservePayments2 = _interopRequireDefault(_withObservePayments);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	var _ButtonSpinner = __webpack_require__(164);
	
	var _appointment = __webpack_require__(159);
	
	var _Appointments = __webpack_require__(316);
	
	var _Appointments2 = _interopRequireDefault(_Appointments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileEvents = _react2.default.memo(function (_ref) {
	  var profile = _ref.profile;
	
	  var isSent = (0, _react.useRef)(false);
	  var firstName = profile.firstName,
	      lastName = profile.lastName,
	      phone = profile.phone,
	      tariff = profile.tariff;
	
	
	  (0, _react.useEffect)(function () {
	    if (!firstName || !lastName || !phone) {
	      return;
	    }
	
	    if (isSent.current) {
	      return;
	    }
	
	    isSent.current = true;
	
	    var countDay = tariff.countDay,
	        datePay = tariff.datePay;
	
	
	    _tracker2.default.sendEvent('SUBSCRIPTION', {
	      телефон: phone ? phone[0] + ' (' + phone.slice(1, 4) + ') ' + phone.slice(4, 7) + ' ' + phone.slice(7, 9) + ' ' + phone.slice(9) : '',
	      имя_пользователя: firstName + ' ' + lastName,
	      дата_подписки: datePay ? datePay.slice(0, 10).split('-').reverse().join('/') : '',
	      оставшиеся_дни: countDay
	    });
	  }, [firstName, lastName, phone]);
	
	  return null;
	});
	
	var Profile = (0, _withObservePayments2.default)(_class = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.getActiveTabFromQuery = function () {
	      var params = new URLSearchParams(_this.props.location.search);
	      return params.get('tab') || 'profile';
	    };
	
	    _this.handleSwitchContent = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(tab) {
	        var _this$props, history, profile, eventLabel;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, history = _this$props.history, profile = _this$props.profile;
	                eventLabel = tab === 'profile' ? 'moi_dannye' : 'moi_zapisi';
	
	
	                (0, _ga.trackGA)(_ga.gaEvent.profileTabsClick({
	                  eventLabel: eventLabel,
	                  user_id: profile.id
	                }));
	
	                if (!(tab === _this.state.activeTab)) {
	                  _context.next = 5;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 5:
	
	                history.push('/profile?tab=' + tab);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      activeTab: _this.getActiveTabFromQuery()
	    };
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	        screenName: this.props.location.pathname
	      }));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.search !== this.props.location.search) {
	        this.setState({ activeTab: this.getActiveTabFromQuery() });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          roleName = _props.roleName,
	          agencyId = _props.agencyId,
	          profile = _props.profile,
	          t = _props.t;
	      var _state = this.state,
	          activeTab = _state.activeTab,
	          isAppointmentsLoading = _state.isAppointmentsLoading;
	
	      var role = (0, _utils.getUserRole)(profile);
	      var hasNoPermission = roleName && agencyId && roleName !== 'admin' && roleName !== 'owner';
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Profile2.default.ProfileWrap },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_Profile2.default.Profile, _defineProperty({}, _Profile2.default.HasNotification, hasNoPermission)) },
	          hasNoPermission && _react2.default.createElement(
	            'div',
	            { className: _Profile2.default.PermissionNotification },
	            t('components.profile.profile.noPermission')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Profile2.default.Container },
	            _react2.default.createElement(
	              'div',
	              { className: _Profile2.default.Title },
	              t('components.profile.profile.title')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Profile2.default.ButtonGroup },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: (0, _classnames2.default)(_Profile2.default.TabButton, _defineProperty({}, _Profile2.default.Active, activeTab === 'profile')),
	                  onClick: function onClick() {
	                    return _this3.handleSwitchContent('profile');
	                  }
	                },
	                t('components.profile.profile.profileTab')
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: (0, _classnames2.default)(_Profile2.default.TabButton, _defineProperty({}, _Profile2.default.Active, activeTab === 'appointments')),
	                  onClick: function onClick() {
	                    return _this3.handleSwitchContent('appointments');
	                  }
	                },
	                t('components.profile.profile.appointmentsTab'),
	                isAppointmentsLoading && _react2.default.createElement(_ButtonSpinner.ButtonSpinner, null)
	              )
	            ),
	            activeTab === 'profile' ? _react2.default.createElement(
	              _react.Fragment,
	              null,
	              role === _constants.USER_ROLE.INDIVIDUAL && _react2.default.createElement(_SubscriptionBar2.default, { className: _Profile2.default.SubscriptionBarInProfile }),
	              _react2.default.createElement(_ProfileForm2.default, null)
	            ) : _react2.default.createElement(_Appointments2.default, { profile: profile })
	          )
	        ),
	        _react2.default.createElement(ProfileEvents, { profile: profile }),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component)) || _class;
	
	exports.default = (0, _reactRedux.connect)(function (_ref3) {
	  var profile = _ref3.profile;
	  return {
	    roleName: profile && profile.roleName,
	    agencyId: profile && profile.agencyId,
	    profile: profile
	  };
	}, function (dispatch) {
	  return {
	    dispatch: dispatch,
	    loadAppointmentStatuses: _appointment.loadAppointmentStatuses
	  };
	})((0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()(Profile)));

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _redux = __webpack_require__(137);
	
	var _reduxForm = __webpack_require__(130);
	
	var _reactStickyEl = __webpack_require__(187);
	
	var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);
	
	var _profile = __webpack_require__(40);
	
	var _Config = __webpack_require__(16);
	
	var _Profile = __webpack_require__(172);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Avatar = __webpack_require__(488);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Social = __webpack_require__(495);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _environment = __webpack_require__(19);
	
	var _AvatarUploader = __webpack_require__(489);
	
	var _AvatarUploader2 = _interopRequireDefault(_AvatarUploader);
	
	var _iconUserSq = __webpack_require__(236);
	
	var _iconUserSq2 = _interopRequireDefault(_iconUserSq);
	
	var _utils = __webpack_require__(494);
	
	var _Input = __webpack_require__(491);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Textarea = __webpack_require__(492);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _validate = __webpack_require__(1068);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _reactI18next = __webpack_require__(4);
	
	var _LeaveAgencyDialog = __webpack_require__(490);
	
	var _LeaveAgencyDialog2 = _interopRequireDefault(_LeaveAgencyDialog);
	
	var _loader = __webpack_require__(1572);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _profile2 = __webpack_require__(40);
	
	var _InformPopup = __webpack_require__(1065);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveButton = function (_Component) {
	  _inherits(SaveButton, _Component);
	
	  function SaveButton() {
	    _classCallCheck(this, SaveButton);
	
	    return _possibleConstructorReturn(this, (SaveButton.__proto__ || Object.getPrototypeOf(SaveButton)).apply(this, arguments));
	  }
	
	  _createClass(SaveButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          t = _props.t,
	          profile = _props.profile,
	          onProfileSave = _props.onProfileSave;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(_Profile2.default.ButtonSave, 'button-primary', 'button-primary--lg'),
	          onClick: function onClick() {
	            if (profile) {
	              (0, _ga.trackGA)(_ga.gaEvent.profileButtonsClick({
	                eventLabel: 'sohranit_izmeneniya',
	                user_id: profile.id
	              }));
	            }
	            onProfileSave();
	          }
	        },
	        t('components.profile.profileForm.saveButton')
	      );
	    }
	  }]);
	
	  return SaveButton;
	}(_react.Component);
	
	var ProfileFormSaveButton = (0, _reactRedux.connect)(function (_ref) {
	  var form = _ref.form;
	  return form.ProfileForm && form.ProfileForm.values || {};
	})((0, _reactI18next.withTranslation)()(SaveButton));
	
	var LeaveAgencyButton = function (_Component2) {
	  _inherits(LeaveAgencyButton, _Component2);
	
	  function LeaveAgencyButton() {
	    var _ref2;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, LeaveAgencyButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = LeaveAgencyButton.__proto__ || Object.getPrototypeOf(LeaveAgencyButton)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleClick = function (profile) {
	      (0, _ga.trackGA)(_ga.gaEvent.profileButtonsClick({
	        eventLabel: 'vyiti_iz_agentstva',
	        user_id: profile.id
	      }));
	
	      _this2.props.setPopUp(_react2.default.createElement(_LeaveAgencyDialog2.default, null), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(LeaveAgencyButton, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          t = _props2.t,
	          profile = _props2.profile;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: (0, _classnames2.default)(_Profile2.default.ButtonSave, 'button-default', 'button-primary--lg'),
	          onClick: function onClick() {
	            return _this3.handleClick(profile);
	          }
	        },
	        t('components.profile.profileForm.leaveAgency')
	      );
	    }
	  }]);
	
	  return LeaveAgencyButton;
	}(_react.Component);
	
	var mapDispatchToPropsLeaveAgency = {
	  leaveProfileAgency: _profile.leaveProfileAgency,
	  setPopUp: _environment.setPopUp
	};
	
	var mapStateToPropsLeaveAgency = function mapStateToPropsLeaveAgency(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	var ProfileFormLeaveAgencyButton = (0, _reactRedux.connect)(mapStateToPropsLeaveAgency, mapDispatchToPropsLeaveAgency)((0, _reactI18next.withTranslation)()(LeaveAgencyButton));
	
	var Profile = function (_Component3) {
	  _inherits(Profile, _Component3);
	
	  function Profile(props) {
	    var _this5 = this;
	
	    _classCallCheck(this, Profile);
	
	    var _this4 = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this4.handleAddPhoneClick = function () {
	      return _this4.setState({ phones: _this4.state.phones + 1 });
	    };
	
	    _this4.onLoadPhoto = function (_ref3) {
	      var preview = _ref3.preview,
	          file = _ref3.file;
	      var _this4$props = _this4.props,
	          uploadPhoto = _this4$props.uploadPhoto,
	          setPopUp = _this4$props.setPopUp,
	          profileForm = _this4$props.profileForm;
	      var avatarId = _this4.state.avatarId;
	
	      setPopUp(_react2.default.createElement(_AvatarUploader2.default, {
	        file: file,
	        preview: preview,
	        onSave: function onSave(file) {
	          var data = new FormData();
	          data.append('file', file);
	          setPopUp();
	
	          _this4.props.uploadPhoto(data).then(function (res) {
	            var avatarId = res.response.data.data.imageId;
	            _this4.setState({ avatarId: avatarId });
	            // this.submitFormAsAdditionalData(avatarId);
	          });
	        }
	      }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    };
	
	    _this4.onLoadHashPhoto = function (_ref4) {
	      var preview = _ref4.preview,
	          file = _ref4.file;
	      var _this4$props2 = _this4.props,
	          uploadAgentPhoto = _this4$props2.uploadAgentPhoto,
	          setPopUp = _this4$props2.setPopUp,
	          profileForm = _this4$props2.profileForm;
	      var avatarId = _this4.state.avatarId;
	
	      setPopUp(_react2.default.createElement(_AvatarUploader2.default, {
	        file: file,
	        preview: preview,
	        onSave: function onSave(file) {
	          var data = new FormData();
	          data.append('file', file);
	          setPopUp();
	
	          _this4.props.uploadAgentPhoto(data).then(function (res) {
	            var avatarId = res.response.data.data.imageId;
	            _this4.setState({ avatarId: avatarId });
	            // this.submitFormAsAdditionalData(avatarId);
	          });
	        }
	      }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    };
	
	    _this4.handleInputChange = function (e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	
	      if (!_this4.props.popup && value.length >= 2) {
	        switch (name) {
	          case 'firstName':
	            _this4.debouncedEnterNameEvent();
	            break;
	          case 'lastName':
	            _this4.debouncedEnterSurnameEvent();
	            break;
	          case 'email':
	            _this4.debouncedEnterEmailEvent();
	            break;
	          case 'position':
	            _this4.debouncedEnterPositionEvent();
	            break;
	          case 'company':
	            _this4.debouncedEnterCompanyEvent();
	            break;
	          case 'description':
	            _this4.debouncedEnterDescriptionEvent();
	            break;
	          default:
	            break;
	        }
	      } else {
	        switch (name) {
	          case 'firstName':
	            _this4.debouncedEnterNameEvent.cancel();
	            break;
	          case 'lastName':
	            _this4.debouncedEnterSurnameEvent.cancel();
	            break;
	          case 'email':
	            _this4.debouncedEnterEmailEvent.cancel();
	            break;
	          case 'position':
	            _this4.debouncedEnterPositionEvent.cancel();
	            break;
	          case 'company':
	            _this4.debouncedEnterCompanyEvent.cancel();
	            break;
	          case 'description':
	            _this4.debouncedEnterDescriptionEvent.cancel();
	            break;
	          default:
	            break;
	        }
	      }
	    };
	
	    _this4.handleProfileSave = function () {
	      var profileForm = _this4.props.profileForm;
	
	
	      if (profileForm && profileForm.syncErrors) {
	        var errorFields = Object.keys(profileForm.syncErrors);
	
	        // if (errorFields.length) {
	        //   this.profileErrorsShow('polya_zapolneny_nekorrektno');
	        // }
	
	        errorFields.forEach(function (field) {
	          var errorEventLabel = void 0;
	
	          switch (field) {
	            case 'firstName':
	              errorEventLabel = 'nevernoe_imya';
	              break;
	            case 'lastName':
	              errorEventLabel = 'nevernaya_familiya';
	              break;
	            case 'email':
	              errorEventLabel = 'nevernyi_email';
	              break;
	            case 'phone':
	              errorEventLabel = 'nevernyi_telefon';
	              break;
	            case 'position':
	              errorEventLabel = 'nevernoe_zvanie';
	              break;
	            case 'company':
	              errorEventLabel = 'nekorrektnaya_kompaniya';
	              break;
	            case 'description':
	              errorEventLabel = 'nekorrektnoe_opisanie';
	              break;
	            default:
	              errorEventLabel = 'nekorrektnoe_pole';
	              break;
	          }
	
	          _this4.profileErrorsShow(errorEventLabel);
	        });
	      }
	    };
	
	    _this4.checkUserPhone = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var result, _result$data, active, includedToAgency, _this4$props3, _setPopUp, dispatch, agencyId, popupParams, setAgentDataIntoForm;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this4.setState({ isChecking: true });
	
	                _context2.prev = 1;
	                _context2.next = 4;
	                return _this4.props.checkUserPhone(data);
	
	              case 4:
	                result = _context2.sent;
	                _result$data = result.data, active = _result$data.active, includedToAgency = _result$data.includedToAgency;
	                _this4$props3 = _this4.props, _setPopUp = _this4$props3.setPopUp, dispatch = _this4$props3.dispatch, agencyId = _this4$props3.agencyId;
	                popupParams = {
	                  closeStyleName: 'Default',
	                  contentStyleName: 'Default',
	                  closeIcon: 'default',
	                  lockScroll: false
	                };
	
	                setAgentDataIntoForm = function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var id, onGoToEdit;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            id = result.data.user.id;
	                            onGoToEdit = _this4.props.onGoToEdit;
	
	                            onGoToEdit({ agentId: id, agencyId: agencyId });
	
	                          case 3:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this5);
	                  }));
	
	                  return function setAgentDataIntoForm() {
	                    return _ref6.apply(this, arguments);
	                  };
	                }();
	
	                if (active) {
	                  if (includedToAgency) {
	                    _setPopUp(_react2.default.createElement(_InformPopup.InformPopupContent, { type: 'userBindedToAgency' }), popupParams);
	                    dispatch((0, _reduxForm.change)('ProfileForm', 'phone', ''));
	                  } else {
	                    _setPopUp(_react2.default.createElement(_InformPopup.InformPopupContent, {
	                      type: 'userAlreadyExists',
	                      onOkButtonClick: setAgentDataIntoForm
	                    }), popupParams);
	                  }
	                }
	                _context2.next = 15;
	                break;
	
	              case 12:
	                _context2.prev = 12;
	                _context2.t0 = _context2['catch'](1);
	
	                console.error(_context2.t0);
	
	              case 15:
	                _context2.prev = 15;
	
	                _this4.setState({ isChecking: false, isPhoneChecked: true });
	                return _context2.finish(15);
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this5, [[1, 12, 15, 18]]);
	      }));
	
	      return function (_x) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this4.updateAgentProfileWithUpdatingList = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref8) {
	        var userHash = _ref8.userHash,
	            avatarId = _ref8.avatarId,
	            other = _objectWithoutProperties(_ref8, ['userHash', 'avatarId']);
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _this4.props.updateAgentProfile(_extends({}, other, { avatarId: avatarId, userId: userHash }));
	
	              case 2:
	                // FIXME: move it to redux
	                _this4.props.loadCompanyProfiles({});
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this5);
	      }));
	
	      return function (_x2) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this4.createAgentProfileWithUpdatingList = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(_ref10) {
	        var agencyId = _ref10.agencyId,
	            avatarId = _ref10.avatarId,
	            other = _objectWithoutProperties(_ref10, ['agencyId', 'avatarId']);
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return _this4.props.createProfile(_extends({}, other, { avatarId: avatarId, agencyId: agencyId, roleId: '13' }));
	
	              case 2:
	                // FIXME: move it to redux
	                _this4.props.loadCompanyProfiles({});
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this5);
	      }));
	
	      return function (_x3) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this4.state = {
	      phones: 1,
	      avatarId: props.avatarId,
	      isChecking: false,
	      isPhoneChecked: false,
	      userActive: true,
	      userIncludedToAgency: _reduxForm.formValues
	    };
	
	    _this4.debouncedTrackGA = (0, _lodash2.default)(_this4.trackInputEvent, 3000);
	
	    _this4.debouncedEnterNameEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'imya'), 3000);
	    _this4.debouncedEnterSurnameEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'familiya'), 3000);
	    _this4.debouncedEnterPhoneEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'telefon'), 3000);
	    _this4.debouncedEnterEmailEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'email'), 3000);
	    _this4.debouncedEnterPositionEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'dolzhnost'), 3000);
	    _this4.debouncedEnterCompanyEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'kompaniya'), 3000);
	    _this4.debouncedEnterDescriptionEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'o_sebe'), 3000);
	
	    _this4.debouncedEnterVkEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'vkontakte'), 3000);
	    _this4.debouncedEnterOkEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'odnoklassniki'), 3000);
	    _this4.debouncedEnterFbEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'facebook'), 3000);
	    _this4.debouncedEnterInstEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'instagram'), 3000);
	    _this4.debouncedEnterYtEvent = (0, _lodash2.default)(_this4.trackInputEvent.bind(_this4, 'youtube'), 3000);
	    return _this4;
	  }
	
	  _createClass(Profile, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var agentId = this.props.agentId;
	
	      if (agentId) {
	        this.props.loadAgentProfile({ hash: agentId });
	      } else {
	        this.props.loadProfile({});
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.avatarId && nextProps.avatarId !== this.state.avatarId) {
	        this.setState({ avatarId: nextProps.avatarId });
	      }
	      if (nextProps.isLoaded && !this.props.isLoaded && nextProps.agentId) {
	        this.props.dispatch((0, _reduxForm.change)('ProfileForm', 'agencyId', nextProps.profile.agencyId));
	        this.props.dispatch((0, _reduxForm.change)('ProfileForm', 'agencyName', nextProps.profile.agencyName));
	      }
	    }
	  }, {
	    key: 'trackInputEvent',
	    value: function trackInputEvent(inputName) {
	      (0, _ga.trackGA)(_ga.gaEvent.profileFormInput({ eventLabel: inputName, user_id: this.props.profile.id }));
	    }
	  }, {
	    key: 'profileErrorsShow',
	    value: function profileErrorsShow(errorName) {
	      (0, _ga.trackGA)(_ga.gaEvent.profileSaveSuccessAndErrorsShow({
	        eventContent: errorName,
	        eventLabel: 'oshibka',
	        user_id: this.props.profile.id
	      }));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          profileForm = _props3.profileForm,
	          agencyId = _props3.agencyId;
	
	
	      if (profileForm && profileForm.values) {
	        var _profileForm$values = profileForm.values,
	            phone = _profileForm$values.phone,
	            vk = _profileForm$values.vk,
	            ok = _profileForm$values.ok,
	            facebok = _profileForm$values.facebok,
	            instagram = _profileForm$values.instagram,
	            youtube = _profileForm$values.youtube;
	
	
	        if (phone && prevProps.profileForm && prevProps.profileForm.values) {
	          if (phone !== prevProps.profileForm.values.phone) {
	            if (phone.length >= 3) {
	              this.debouncedEnterPhoneEvent();
	            } else {
	              this.debouncedEnterPhoneEvent.cancel();
	            }
	            if (phone.length === 11) {
	              this.setState({ isPhoneChecked: false }, function () {
	                if (!_this6.state.isPhoneChecked) {
	                  _this6.checkUserPhone({ phone: phone, agencyId: agencyId });
	                }
	              });
	            }
	          }
	          if (vk && vk !== prevProps.profileForm.values.vk && vk.length >= 2) {
	            this.debouncedEnterVkEvent();
	          } else {
	            this.debouncedEnterVkEvent.cancel();
	          }
	          if (ok && ok !== prevProps.profileForm.values.ok && ok.length >= 2) {
	            this.debouncedEnterOkEvent();
	          } else {
	            this.debouncedEnterOkEvent.cancel();
	          }
	          if (facebok && facebok !== prevProps.profileForm.values.facebok && facebok.length >= 2) {
	            this.debouncedEnterFbEvent();
	          } else {
	            this.debouncedEnterFbEvent.cancel();
	          }
	          if (instagram && instagram !== prevProps.profileForm.values.instagram && instagram.length >= 2) {
	            this.debouncedEnterInstEvent();
	          } else {
	            this.debouncedEnterInstEvent.cancel();
	          }
	          if (youtube && youtube !== prevProps.profileForm.values.youtube && youtube.length >= 2) {
	            this.debouncedEnterYtEvent();
	          } else {
	            this.debouncedEnterYtEvent.cancel();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'submitFormAsAdditionalData',
	    value: function submitFormAsAdditionalData(avatarId) {
	      var _props4 = this.props,
	          isNew = _props4.isNew,
	          agentId = _props4.agentId,
	          agencyId = _props4.agencyId,
	          updateProfile = _props4.updateProfile,
	          updateAgentProfile = _props4.updateAgentProfile,
	          createProfile = _props4.createProfile,
	          profileForm = _props4.profileForm;
	
	      this.setState({ avatarId: avatarId });
	
	      var values = profileForm.values;
	
	      if (isNew) {
	        this.createAgentProfileWithUpdatingList(_extends({}, values, { avatarId: avatarId, agencyId: agencyId }));
	      } else if (agentId) {
	        this.updateAgentProfileWithUpdatingList(_extends({}, values, { avatarId: avatarId, userHash: agentId }));
	      } else {
	        updateProfile(_extends({}, values, { avatarId: avatarId }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props5 = this.props,
	          handleSubmit = _props5.handleSubmit,
	          updateProfile = _props5.updateProfile,
	          updateAgentProfile = _props5.updateAgentProfile,
	          createProfile = _props5.createProfile,
	          initialValues = _props5.initialValues,
	          agentId = _props5.agentId,
	          isLoaded = _props5.isLoaded,
	          isNew = _props5.isNew,
	          agencyId = _props5.agencyId,
	          roleName = _props5.roleName,
	          popup = _props5.popup,
	          onSave = _props5.onSave,
	          t = _props5.t,
	          profile = _props5.profile,
	          profileForm = _props5.profileForm;
	      var _state = this.state,
	          avatarId = _state.avatarId,
	          isChecking = _state.isChecking;
	
	      var hasPermission = isNew || agentId || roleName === 'admin' || roleName === 'owner' || !agencyId;
	
	      if (isNew || initialValues && isLoaded) {
	        return _react2.default.createElement(
	          'form',
	          {
	            onSubmit: handleSubmit(function (props) {
	              return (isNew ? _this7.createAgentProfileWithUpdatingList(_extends({}, props, { avatarId: avatarId, agencyId: agencyId })) : agentId ? _this7.updateAgentProfileWithUpdatingList(_extends({}, props, { avatarId: avatarId, userHash: agentId })) : updateProfile(_extends({}, props, { avatarId: avatarId }))).then(function () {
	                onSave && onSave();
	              });
	            }),
	            className: (0, _classnames2.default)(_Profile2.default.Inner, _defineProperty({}, _Profile2.default.PopupInner, popup))
	          },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Profile2.default.FormInner, _defineProperty({}, _Profile2.default.PopupFormInner, popup), 'custom-scrollbar') },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _Profile2.default.AvatarWrapper,
	                onClick: function onClick() {
	                  if (profile) {
	                    (0, _ga.trackGA)(_ga.gaEvent.profileButtonsClick({
	                      eventLabel: 'obnovit_foto',
	                      user_id: _this7.props.profile.id
	                    }));
	                  }
	                }
	              },
	              _react2.default.createElement(_Avatar2.default, {
	                src: avatarId ? _Config.ROOT_URL + '/image/get?id=' + avatarId + '&preset=avatar_edit' : _iconUserSq2.default,
	                onLoadPhoto: agentId || isNew ? this.onLoadHashPhoto : this.onLoadPhoto,
	                popup: popup
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Profile2.default.Section, _Profile2.default.SectionInputs) },
	              _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.InputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'firstName',
	                  component: _Input2.default,
	                  label: t('components.profile.profileForm.firstName'),
	                  placeholder: t('components.profile.profileForm.firstNameLabel'),
	                  id: 'name',
	                  required: true,
	                  disabled: !hasPermission,
	                  onChange: this.handleInputChange
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.InputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'lastName',
	                  component: _Input2.default,
	                  label: t('components.profile.profileForm.lastName'),
	                  placeholder: t('components.profile.profileForm.lastNameLabel'),
	                  id: 'surname',
	                  required: true,
	                  disabled: !hasPermission,
	                  onChange: this.handleInputChange
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.PhoneInputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'phone',
	                  component: _Input2.default,
	                  type: 'tel',
	                  label: t('components.profile.profileForm.phone'),
	                  placeholder: '+7',
	                  mask: '+\\7 (111) 111-11-11',
	                  id: 'phone',
	                  required: true,
	                  disabled: !isNew && popup,
	                  normalize: _utils.normalizePhone,
	                  onChange: this.handleInputChange
	                }),
	                isChecking && _react2.default.createElement('img', { className: _Profile2.default.Loader, src: _loader2.default })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.InputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'email',
	                  component: _Input2.default,
	                  type: 'email',
	                  label: t('components.profile.profileForm.email'),
	                  placeholder: 'example@gmail.com',
	                  id: 'email',
	                  required: true,
	                  disabled: !hasPermission,
	                  onChange: this.handleInputChange
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.InputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: 'position',
	                  component: _Input2.default,
	                  label: t('components.profile.profileForm.position'),
	                  placeholder: t('components.profile.profileForm.positionPlaceholder'),
	                  id: 'position',
	                  required: true,
	                  disabled: !hasPermission,
	                  onChange: this.handleInputChange
	                })
	              ),
	              !isNew && _react2.default.createElement(
	                'div',
	                { className: _Profile2.default.InputWrap },
	                _react2.default.createElement(_reduxForm.Field, {
	                  name: agencyId ? 'agencyName' : 'company',
	                  component: _Input2.default,
	                  label: t('components.profile.profileForm.company'),
	                  placeholder: t('components.profile.profileForm.companyPlaceholder'),
	                  required: true,
	                  disabled: !!agencyId,
	                  onChange: this.handleInputChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Profile2.default.Section, _Profile2.default.SectionTextarea) },
	              _react2.default.createElement(_reduxForm.Field, {
	                name: 'description',
	                component: _Textarea2.default,
	                label: t('components.profile.profileForm.about'),
	                placeholder: t('components.profile.profileForm.aboutPlaceholder'),
	                id: 'description',
	                maxLength: 250,
	                onChange: this.handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_Profile2.default.Section, _Profile2.default.SectionSocial) },
	              _react2.default.createElement(_Social2.default, null)
	            )
	          ),
	          popup ? _react2.default.createElement(ProfileFormSaveButton, { popup: true }) : _react2.default.createElement(
	            _reactStickyEl2.default,
	            { mode: 'bottom', className: _Profile2.default.ButtonsWrap, stickyClassName: _Profile2.default.ButtonsWrapSticky },
	            agencyId && _react2.default.createElement(ProfileFormLeaveAgencyButton, { popup: true }),
	            _react2.default.createElement(ProfileFormSaveButton, {
	              popup: true,
	              profile: profile,
	              onProfileSave: this.handleProfileSave
	            })
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref11, _ref12) {
	  var profile = _ref11.profile,
	      agentProfile = _ref11.agentProfile,
	      form = _ref11.form;
	  var agentId = _ref12.agentId,
	      isNew = _ref12.isNew,
	      agencyId = _ref12.agencyId;
	
	  var passProfile = agentId ? agentProfile : profile;
	
	  var res = isNew ? {
	    agencyId: passProfile && passProfile.agencyId
	  } : {
	    initialValues: undefined,
	    avatarId: passProfile && passProfile.avatarId,
	    isLoaded: passProfile && passProfile.isLoaded,
	    agencyId: passProfile && passProfile.agencyId,
	    roleName: passProfile && passProfile.roleName,
	    profile: profile
	  };
	  if (!passProfile.isLoaded || agentId && passProfile.id !== agentId) {
	    return _extends({}, res, {
	      profileForm: form.ProfileForm
	    });
	  }
	  return _extends({}, res, {
	    initialValues: isNew ? {} : passProfile,
	    profileForm: form.ProfileForm
	  });
	};
	
	var mapDispatchToProps = {
	  setPopUp: _environment.setPopUp,
	  loadProfile: _profile.loadProfile,
	  updateProfile: _profile.updateProfile,
	  uploadPhoto: _profile.uploadPhoto,
	  loadAgentProfile: _profile.loadAgentProfile,
	  updateAgentProfile: _profile.updateAgentProfile,
	  uploadAgentPhoto: _profile.uploadAgentPhoto,
	  createProfile: _profile.createProfile,
	  loadCompanyProfiles: _profile.loadCompanyProfiles,
	  checkUserPhone: _profile2.checkUserPhone
	};
	
	exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reduxForm.reduxForm)({
	  form: 'ProfileForm',
	  validate: _validate2.default
	}))((0, _reactI18next.withTranslation)()(Profile));

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	  var errors = {};
	  if (!values.firstName) {
	    errors.firstName = _i18n2.default.t('components.profile.profileForm.validate.firstName');
	  } else if (values.firstName.length > 20) {
	    errors.firstName = _i18n2.default.t('components.profile.profileForm.validate.firstNameError');
	  }
	  if (!values.lastName) {
	    errors.lastName = _i18n2.default.t('components.profile.profileForm.validate.lastName');
	  } else if (values.lastName.length > 20) {
	    errors.lastName = _i18n2.default.t('components.profile.profileForm.validate.lastNameError');
	  }
	  if (!values.phone) {
	    errors.phone = _i18n2.default.t('components.profile.profileForm.validate.phone');
	  } else if (values.phone.replace(/\D/g, '').length < 11) {
	    errors.phone = _i18n2.default.t('components.profile.profileForm.validate.phoneError');
	  }
	  if (!values.email) {
	    errors.email = _i18n2.default.t('components.profile.profileForm.validate.email');
	  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(values.email)) {
	    errors.email = _i18n2.default.t('components.profile.profileForm.validate.emailError');
	  } else if (values.email.length > 50) {
	    errors.email = _i18n2.default.t('components.profile.profileForm.validate.emailError1');
	  }
	  if (!values.position) {
	    errors.position = _i18n2.default.t('components.profile.profileForm.validate.position');
	  } else if (values.position.length > 30) {
	    errors.position = _i18n2.default.t('components.profile.profileForm.validate.positionError');
	  }
	  if (values.description && values.description.length > 250) {
	    errors.description = _i18n2.default.t('components.profile.profileForm.validate.positionError1');
	  }
	  return errors;
	};
	
	exports.default = validate;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TariffModal = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var readBlobAsync = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(blob) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', new Promise(function (resolve, reject) {
	              var reader = new FileReader();
	
	              reader.onload = function (event) {
	                var text = event.target.result;
	                resolve(text);
	              };
	
	              reader.onerror = function (event) {
	                reject(event.target.error);
	              };
	
	              // Начать чтение Blob как текст
	              reader.readAsText(blob);
	            }));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function readBlobAsync(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checked = __webpack_require__(1487);
	
	var _checked2 = _interopRequireDefault(_checked);
	
	var _notChecked = __webpack_require__(1488);
	
	var _notChecked2 = _interopRequireDefault(_notChecked);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _loader = __webpack_require__(555);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _styles = __webpack_require__(1439);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Modal = __webpack_require__(314);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Config = __webpack_require__(16);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var periods = {
	  0: '1 меc.',
	  1: '6 мес.',
	  2: '12 мес.'
	};
	
	var data = {
	  '10 человек': {
	    0: {
	      id: 96,
	      price: '10 000 ₽',
	      altPrice: ''
	    },
	    1: {
	      id: 99,
	      price: '48 000 ₽',
	      altPrice: ''
	    },
	    2: {
	      id: 102,
	      price: '96 000 ₽',
	      altPrice: ''
	    }
	  },
	  '10-30 человек': {
	    0: {
	      id: 97,
	      price: '15 000 ₽',
	      altPrice: ''
	    },
	    1: {
	      id: 100,
	      price: '72 000 ₽',
	      altPrice: '90 000 ₽'
	    },
	    2: {
	      id: 103,
	      price: '144 000 ₽',
	      altPrice: '180 000 ₽'
	    }
	  },
	  '30+ человек': {
	    0: {
	      id: 98,
	      price: '15 990 ₽',
	      altPrice: '20 000 ₽'
	    },
	    1: {
	      id: 101,
	      price: '96 000 ₽',
	      altPrice: '120 000 ₽'
	    },
	    2: {
	      id: 104,
	      price: '192 000 ₽',
	      altPrice: '240 000 ₽'
	    }
	  }
	};
	
	var getCards = function getCards(period) {
	  return Object.keys(data).map(function (count) {
	    return _extends({
	      count: count
	    }, data[count][period]);
	  });
	};
	
	var infoModalClasses = {
	  titleClassName: _styles2.default.ModalTitle,
	  bodyClassName: _styles2.default.ModalBody,
	  closeClassName: _styles2.default.ModalClose
	};
	
	var infoModalStyle = {
	  maxWidth: '623px',
	  width: 'calc(100% - 40px)'
	};
	
	var isCountPeopleError = function isCountPeopleError(countPeople, index) {
	  if (index === 0) {
	    return countPeople > 10;
	  }
	
	  if (index === 1) {
	    return countPeople > 30;
	  }
	
	  return false;
	};
	var TariffModal = exports.TariffModal = function TariffModal(_ref2) {
	  var onClose = _ref2.onClose;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (_ref3) {
	    var company = _ref3.company,
	        profile = _ref3.profile;
	    return { company: company, profile: profile };
	  }),
	      company = _useSelector.company,
	      profile = _useSelector.profile;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isLoading = _useState2[0],
	      setIsLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      error = _useState4[0],
	      setError = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectedIndex = _useState6[0],
	      setSelectedIndex = _useState6[1];
	
	  var _company$data = company.data,
	      inn = _company$data.inn,
	      kpp = _company$data.kpp,
	      tariffId = _company$data.tariffId;
	
	  var _useState7 = (0, _react.useState)(tariffId ? +tariffId : 0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      selectedId = _useState8[0],
	      setSelectedId = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(function () {
	    return Object.keys(data).reduce(function (acc, index) {
	      if (acc !== null) {
	        return acc;
	      }
	
	      Object.keys(data[index]).forEach(function (cardIndex) {
	        if (data[index][cardIndex].id === selectedId) {
	          acc = cardIndex;
	        }
	      });
	
	      return acc;
	    }, null) || 0;
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      time = _useState10[0],
	      selectedTime = _useState10[1];
	
	  var cards = getCards(time);
	
	  var countPeople = profile.tariff.countPeople;
	
	
	  if (error) {
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isOpen: true,
	        handleClose: onClose,
	        classNames: infoModalClasses,
	        title: t('components.profile.tariffModal.error.title'),
	        contentStyle: infoModalStyle
	      },
	      t('components.profile.tariffModal.error.' + error, {
	        count: selectedIndex === 0 ? 10 : 30
	      })
	    );
	  }
	
	  if (!inn || !kpp) {
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        isOpen: true,
	        handleClose: onClose,
	        classNames: infoModalClasses,
	        title: t('components.profile.tariffModal.emptyInnOrKpp.title'),
	        contentStyle: infoModalStyle
	      },
	      t('components.profile.tariffModal.emptyInnOrKpp.body')
	    );
	  }
	
	  var handleClick = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var response, blob, objectUrl, a;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(isLoading || !selectedId)) {
	                _context2.next = 2;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 2:
	              if (!isCountPeopleError(countPeople, selectedIndex)) {
	                _context2.next = 5;
	                break;
	              }
	
	              setError("count");
	              return _context2.abrupt('return');
	
	            case 5:
	              _context2.prev = 5;
	
	              setIsLoading(true);
	              _context2.next = 9;
	              return axios.get(_Config.ROOT_URL + '/payments/invoice', {
	                responseType: 'blob',
	                params: {
	                  inn: inn,
	                  kpp: kpp,
	                  tariffId: selectedId
	                }
	              });
	
	            case 9:
	              response = _context2.sent;
	              blob = new Blob([response.data], { type: response.headers['content-type'] });
	              objectUrl = URL.createObjectURL(blob);
	              a = document.createElement('a');
	
	
	              a.href = objectUrl;
	              a.download = 'счет.pdf';
	              document.body.appendChild(a);
	              a.click();
	              document.body.removeChild(a);
	              URL.revokeObjectURL(objectUrl);
	              _context2.next = 24;
	              break;
	
	            case 21:
	              _context2.prev = 21;
	              _context2.t0 = _context2['catch'](5);
	
	              try {
	                readBlobAsync(_context2.t0.response.data).then(function (result) {
	                  return JSON.parse(result);
	                }).then(function (response) {
	                  if (response.error.messages.includes('Can not find Contractor')) {
	                    setError("data");
	                    return;
	                  }
	
	                  setError("default");
	                });
	              } catch (blobReadErr) {
	                setError("default");
	              }
	
	            case 24:
	              setIsLoading(false);
	
	            case 25:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[5, 21]]);
	    }));
	
	    return function handleClick() {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      isOpen: true,
	      title: t('components.profile.tariffModal.title'),
	      handleClose: onClose,
	      classNames: {
	        titleClassName: _styles2.default.MainModalTitle
	      },
	      footer: _react2.default.createElement(
	        'div',
	        { className: _styles2.default.ButtonContainer },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: handleClick,
	            className: (0, _classnames2.default)(_styles2.default.Button, _styles2.default.ButtonSave, 'button-primary', 'button-primary--lg', _defineProperty({}, _styles2.default.ButtonBlocked, isLoading || !selectedId))
	          },
	          isLoading ? _react2.default.createElement('img', { src: _loader2.default }) : t('components.profile.tariffModal.button')
	        )
	      )
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Container },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.TimeSelector },
	        Object.keys(periods).map(function (key) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: 'time-' + key,
	              onClick: function onClick() {
	                selectedTime(key);
	              },
	              className: (0, _classnames2.default)(_defineProperty({}, _styles2.default.TimeSelectorActive, key == time))
	            },
	            periods[key]
	          );
	        })
	      ),
	      cards.map(function (card, index) {
	        var isActive = card.id === (tariffId ? +tariffId : 0);
	        var isSelected = card.id === selectedId;
	        return _react2.default.createElement(
	          'div',
	          {
	            key: time + '-' + index,
	            className: (0, _classnames2.default)(_styles2.default.Taraff, _defineProperty({}, _styles2.default.TaraffActive, isSelected)),
	            onClick: function onClick() {
	              setSelectedId(card.id);
	              setSelectedIndex(index);
	            }
	          },
	          isActive && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.TaraffActiveHint },
	            t('components.profile.tariffModal.current')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.TaraffFirstColumn },
	            _react2.default.createElement(
	              'div',
	              null,
	              '\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u043B\u044F'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              card.count
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.TaraffSecondColumn },
	            _react2.default.createElement(
	              'div',
	              null,
	              card.altPrice ? _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    card.altPrice
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  card.price
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: _styles2.default.TaraffPrice },
	                card.price
	              )
	            ),
	            isSelected ? _react2.default.createElement('img', { src: _checked2.default, alt: 'checked' }) : _react2.default.createElement('img', { src: _notChecked2.default, alt: 'notChecked' })
	          )
	        );
	      })
	    )
	  );
	};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Profile = __webpack_require__(1066);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Profile2.default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1440);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _RealtorPopup = __webpack_require__(498);
	
	var _RealtorPopup2 = _interopRequireDefault(_RealtorPopup);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _utils = __webpack_require__(12);
	
	var _iconPhoneBlack = __webpack_require__(1550);
	
	var _iconPhoneBlack2 = _interopRequireDefault(_iconPhoneBlack);
	
	var _iconPhoneBlue = __webpack_require__(1551);
	
	var _iconPhoneBlue2 = _interopRequireDefault(_iconPhoneBlue);
	
	var _iconEmailBlack = __webpack_require__(1538);
	
	var _iconEmailBlack2 = _interopRequireDefault(_iconEmailBlack);
	
	var _iconEmailBlue = __webpack_require__(1539);
	
	var _iconEmailBlue2 = _interopRequireDefault(_iconEmailBlue);
	
	var _socialVk = __webpack_require__(347);
	
	var _socialVk2 = _interopRequireDefault(_socialVk);
	
	var _socialOk = __webpack_require__(346);
	
	var _socialOk2 = _interopRequireDefault(_socialOk);
	
	var _socialFb = __webpack_require__(344);
	
	var _socialFb2 = _interopRequireDefault(_socialFb);
	
	var _socialInst = __webpack_require__(345);
	
	var _socialInst2 = _interopRequireDefault(_socialInst);
	
	var _socialYoutube = __webpack_require__(348);
	
	var _socialYoutube2 = _interopRequireDefault(_socialYoutube);
	
	var _iconUserSq = __webpack_require__(236);
	
	var _iconUserSq2 = _interopRequireDefault(_iconUserSq);
	
	var _reactI18next = __webpack_require__(4);
	
	var _helper = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RealtorCard = function (_Component) {
	  _inherits(RealtorCard, _Component);
	
	  function RealtorCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RealtorCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RealtorCard.__proto__ || Object.getPrototypeOf(RealtorCard)).call.apply(_ref, [this].concat(args))), _this), _this.showPopup = function () {
	      _this.props.setPopUp(_react2.default.createElement(_RealtorPopup2.default, { agency: _this.props.agency }), {
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        closeClassName: _styles2.default.PopupCompanyClose,
	        backgroundClassName: _styles2.default.PopupCompanyBg,
	        contentClassName: _styles2.default.PopupCompanyContent,
	        lockScroll: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RealtorCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          firstName = _props.firstName,
	          lastName = _props.lastName,
	          position = _props.position,
	          agency = _props.agency,
	          description = _props.description,
	          phone = _props.phone,
	          email = _props.email,
	          vk = _props.vk,
	          ok = _props.ok,
	          facebok = _props.facebok,
	          instagram = _props.instagram,
	          youtube = _props.youtube,
	          avatarId = _props.avatarId,
	          company = _props.company,
	          t = _props.t,
	          onPhoneClick = _props.onPhoneClick;
	
	
	      var links = [{ url: vk, icon: _socialVk2.default }, { url: ok, icon: _socialOk2.default }, { url: facebok, icon: _socialFb2.default }, { url: instagram, icon: _socialInst2.default }, { url: youtube, icon: _socialYoutube2.default }].filter(function (_ref2) {
	        var url = _ref2.url;
	        return url;
	      });
	
	      return firstName ? _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.RealtorBlock, className) },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.RealtorInfo },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.RealtorAvatar },
	            _react2.default.createElement('img', {
	              src: avatarId ? _Config.ROOT_URL + '/image/get?id=' + avatarId + '&preset=profile_avatar' : _iconUserSq2.default,
	              alt: ''
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _styles2.default.RealtorName },
	            firstName,
	            ' ',
	            lastName
	          ),
	          agency && _react2.default.createElement(
	            'p',
	            { className: _styles2.default.RealtorPosition },
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.Position },
	              position
	            ),
	            (agency.name || company) && t('components.realtorCard.in'),
	            agency.website ? _react2.default.createElement(
	              'a',
	              {
	                href: agency.website.startsWith('http://') || agency.website.startsWith('https://') ? agency.website : 'https://' + agency.website,
	                className: _styles2.default.AgencyName,
	                target: '_blank'
	              },
	              '\xA0',
	              agency.name || company
	            ) : _react2.default.createElement(
	              'span',
	              {
	                // onClick={agency.name ? this.showPopup : (_) => _}
	                className: _styles2.default.AgencyNameNoLink
	              },
	              '\xA0',
	              agency.name || company
	            )
	          ),
	          description && _react2.default.createElement(
	            'p',
	            { className: _styles2.default.RealtorDescrip },
	            (0, _helper.linkifyText)(description, 10000)
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _styles2.default.RealtorContacts },
	          _react2.default.createElement(
	            'li',
	            { onClick: onPhoneClick },
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + phone },
	              _react2.default.createElement('img', { src: _iconPhoneBlack2.default, alt: '', className: _styles2.default.RealtorContactsIcon }),
	              (0, _utils.formatPhoneNumber)(phone)
	            )
	          ),
	          email ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' + email },
	              _react2.default.createElement('img', { src: _iconEmailBlack2.default, alt: '', className: _styles2.default.RealtorContactsIcon }),
	              email
	            )
	          ) : null
	        ),
	        links.length ? _react2.default.createElement(
	          'div',
	          { className: _styles2.default.RealtorSocial },
	          _react2.default.createElement(
	            'p',
	            { className: _styles2.default.RealtorSocialTitle },
	            t('components.realtorCard.title')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.RealtorSocialLinks },
	            links.map(function (_ref3) {
	              var url = _ref3.url,
	                  icon = _ref3.icon;
	              return _react2.default.createElement(
	                'a',
	                {
	                  href: (0, _utils.addUrlProtocol)(url),
	                  key: icon,
	                  className: _styles2.default.RealtorSocialLink,
	                  target: '_blank'
	                },
	                _react2.default.createElement('img', { src: icon, alt: '' })
	              );
	            })
	          )
	        ) : null
	      ) : null;
	    }
	  }]);
	
	  return RealtorCard;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { setPopUp: _environment.setPopUp })((0, _reactI18next.withTranslation)()(RealtorCard));

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1441);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _googleMapReact = __webpack_require__(1610);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _utils = __webpack_require__(562);
	
	var _MapPoint = __webpack_require__(1105);
	
	var _MapPoint2 = _interopRequireDefault(_MapPoint);
	
	var _Config = __webpack_require__(16);
	
	var _utils2 = __webpack_require__(12);
	
	var _socialVk = __webpack_require__(347);
	
	var _socialVk2 = _interopRequireDefault(_socialVk);
	
	var _socialOk = __webpack_require__(346);
	
	var _socialOk2 = _interopRequireDefault(_socialOk);
	
	var _socialFb = __webpack_require__(344);
	
	var _socialFb2 = _interopRequireDefault(_socialFb);
	
	var _socialInst = __webpack_require__(345);
	
	var _socialInst2 = _interopRequireDefault(_socialInst);
	
	var _socialYoutube = __webpack_require__(348);
	
	var _socialYoutube2 = _interopRequireDefault(_socialYoutube);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OfficePin = function OfficePin(props) {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var phone = props.phone,
	      address = props.address,
	      mail = props.mail,
	      _props$name = props.name,
	      name = _props$name === undefined ? t('components.realtorPopup.in') : _props$name;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_MapPoint2.default, {
	      className: _styles2.default.MapPoint,
	      onClick: props.handleShowInfo
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.MapTooltip },
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.MapTooltipTitle },
	        name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.MapTooltipAddress },
	        address
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'tel:' + phone, className: _styles2.default.MapTooltipPhone },
	        (0, _utils2.formatPhoneNumber)(phone)
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:' + mail, className: _styles2.default.MapTooltipEmail },
	        mail
	      )
	    )
	  );
	};
	
	var size = {
	  width: 600,
	  height: 600
	};
	
	var RealtorPopup = function (_Component) {
	  _inherits(RealtorPopup, _Component);
	
	  function RealtorPopup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RealtorPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RealtorPopup.__proto__ || Object.getPrototypeOf(RealtorPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isMapOpened: false
	    }, _this.handleMapButtonClick = function () {
	      _this.setState({
	        isMapOpened: !_this.state.isMapOpened
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RealtorPopup, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      if (this.props.agency) {
	        this.mapProps = this.fitBounds(this.props.agency.office.filter(function (_ref2) {
	          var latitude = _ref2.latitude,
	              longitude = _ref2.longitude;
	          return latitude && longitude;
	        }).map(function (o) {
	          return _extends({}, o, {
	            latitude: parseFloat(o.latitude) - 0.0008,
	            longitude: parseFloat(o.longitude)
	          });
	        }));
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var popupHeight = document.getElementById('CompanyDialogWrap').clientHeight;
	      this.setState({ popupHeight: popupHeight });
	    }
	  }, {
	    key: 'fitBounds',
	    value: function fitBounds(data) {
	      var maxLat = 0,
	          minLat = 1000,
	          maxLng = 0,
	          minLng = 1000;
	
	      if (data.length > 1) {
	        data.forEach(function (item, i) {
	          var latitude = item.latitude,
	              longitude = item.longitude;
	
	          if (latitude > maxLat) maxLat = latitude;
	          if (latitude < minLat) minLat = latitude;
	          if (longitude > maxLng) maxLng = longitude;
	          if (longitude < minLng) minLng = longitude;
	        });
	      } else {
	        var _data$ = data[0],
	            latitude = _data$.latitude,
	            longitude = _data$.longitude;
	
	        maxLat = latitude + 0.005;
	        minLat = latitude - 0.005;
	        maxLng = longitude + 0.005;
	        minLng = longitude - 0.005;
	      }
	
	      var bounds = {
	        nw: {
	          lat: maxLat,
	          lng: minLng
	        },
	        se: {
	          lat: minLat,
	          lng: maxLng
	        }
	      };
	
	      return (0, _utils.fitBounds)(bounds, size);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          agency = _props.agency,
	          t = _props.t;
	      var name = agency.name,
	          description = agency.description,
	          vk = agency.vk,
	          ok = agency.ok,
	          facebok = agency.facebok,
	          instagram = agency.instagram,
	          youtube = agency.youtube,
	          _agency$office = agency.office,
	          office = _agency$office === undefined ? [] : _agency$office,
	          logoId = agency.logoId,
	          website = agency.website,
	          backgroundId = agency.backgroundId;
	
	
	      var isOfficeCoords = true;
	      for (var i = 0; i < office.length; i++) {
	        if (!office[i].latitude && !office[i].longitude) {
	          isOfficeCoords = false;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.CompanyDialogWrap, _defineProperty({}, _styles2.default.WithoutMap, !isOfficeCoords), _defineProperty({}, _styles2.default.MapOpened, this.state.isMapOpened)), id: 'CompanyDialogWrap', style: { height: this.state.popupHeight } },
	        isOfficeCoords ? _react2.default.createElement(
	          'div',
	          { className: _styles2.default.CompanyDialogMap, style: { height: this.state.popupHeight } },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.MapHeader },
	            t('components.realtorPopup.onMap')
	          ),
	          _react2.default.createElement(
	            _googleMapReact2.default,
	            {
	              options: function options(maps) {
	                return {
	                  panControl: _this2.state.isMapOpened,
	                  zoomControl: _this2.state.isMapOpened,
	                  streetViewControl: _this2.state.isMapOpened,
	                  mapTypeControl: false,
	                  scrollwheel: true,
	                  panControlOptions: {
	                    position: maps.ControlPosition.TOP_RIGHT
	                  },
	                  styles: [{
	                    featureType: 'all',
	                    stylers: [{ visibility: 'on' }]
	                  }]
	                };
	              },
	              bootstrapURLKeys: {
	                key: _Config.MAP_API_KEY,
	                language: 'ru',
	                region: 'ru'
	              },
	              center: this.mapProps.center,
	              defaultZoom: this.mapProps.zoom
	            },
	            office.map(function (ofc) {
	              return ofc.latitude && ofc.longitude ? _react2.default.createElement(OfficePin, _extends({}, ofc, {
	                key: ofc.id,
	                lat: parseFloat(ofc.latitude),
	                lng: parseFloat(ofc.longitude)
	              })) : null;
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: _styles2.default.CompanyDialogMapButton, onClick: this.handleMapButtonClick },
	            this.state.isMapOpened ? t('components.realtorPopup.minMap') : t('components.realtorPopup.showMap')
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          {
	            className: _styles2.default.CompanyDialogHeader,
	            style: { backgroundImage: 'url(' + _Config.ROOT_URL + '/image/get?id=' + backgroundId + '&preset=background)' }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.CompanyLogo },
	            logoId ? _react2.default.createElement('img', { src: _Config.ROOT_URL + '/image/get?id=' + logoId + '&preset=profile_avatar', alt: '' }) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.CompanyDialogBody },
	          _react2.default.createElement(
	            'p',
	            { className: _styles2.default.CompanyName },
	            name
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)(_styles2.default.CompanyDescription, 'custom-scrollbar') },
	            description
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.CompanySocial },
	            [{ url: vk, icon: _socialVk2.default }, { url: ok, icon: _socialOk2.default }, { url: facebok, icon: _socialFb2.default }, { url: instagram, icon: _socialInst2.default }, { url: youtube, icon: _socialYoutube2.default }].filter(function (_ref3) {
	              var url = _ref3.url;
	              return url;
	            }).map(function (_ref4) {
	              var url = _ref4.url,
	                  icon = _ref4.icon;
	              return _react2.default.createElement(
	                'a',
	                { href: (0, _utils2.addUrlProtocol)(url), className: _styles2.default.CompanySocialLink, target: '_blank' },
	                _react2.default.createElement('img', { src: icon, alt: '' })
	              );
	            })
	          ),
	          office.slice(0, 1).map(function (_ref5) {
	            var id = _ref5.id,
	                phone = _ref5.phone,
	                address = _ref5.address,
	                mail = _ref5.mail;
	            return _react2.default.createElement(
	              'div',
	              { className: _styles2.default.CompanyContacts },
	              (phone || address) && (mail || website) ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.CompanyContactsInner },
	                (phone || address) && _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.CompanyContactsLeft, key: id },
	                  phone && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.CompanyContactsItem },
	                    _react2.default.createElement(
	                      'p',
	                      { className: _styles2.default.Label },
	                      t('components.realtorPopup.phone')
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'tel:' + phone, className: _styles2.default.Text },
	                      (0, _utils2.formatPhoneNumber)(phone)
	                    )
	                  ),
	                  address && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.CompanyContactsItem },
	                    _react2.default.createElement(
	                      'p',
	                      { className: _styles2.default.Label },
	                      t('components.realtorPopup.address')
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: _styles2.default.Text },
	                      address
	                    )
	                  )
	                ),
	                (mail || website) && _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.CompanyContactsRight },
	                  mail && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.CompanyContactsItem },
	                    _react2.default.createElement(
	                      'p',
	                      { className: _styles2.default.Label },
	                      t('components.realtorPopup.email')
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:' + mail, className: (0, _classnames2.default)(_styles2.default.Link) },
	                      mail
	                    )
	                  ),
	                  website && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.CompanyContactsItem },
	                    _react2.default.createElement(
	                      'p',
	                      { className: _styles2.default.Label },
	                      t('components.realtorPopup.website')
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: (0, _utils2.addUrlProtocol)(website, 'http'), target: '_blank', className: (0, _classnames2.default)(_styles2.default.Link) },
	                      website
	                    )
	                  )
	                )
	              ) : phone || address ? _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_styles2.default.CompanyContactsLeft, _styles2.default.Wide), key: id },
	                phone && _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.CompanyContactsItem },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.Label },
	                    t('components.realtorPopup.phone')
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'tel:' + phone, className: _styles2.default.Text },
	                    (0, _utils2.formatPhoneNumber)(phone)
	                  )
	                ),
	                address && _react2.default.createElement(
	                  'div',
	                  { className: _styles2.default.CompanyContactsItem },
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.Label },
	                    t('components.realtorPopup.address')
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: _styles2.default.Text },
	                    address
	                  )
	                )
	              ) : null
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return RealtorPopup;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(RealtorPopup);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _search = __webpack_require__(68);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _utils = __webpack_require__(215);
	
	var _style = __webpack_require__(234);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Buildings = (_dec = (0, _reactRedux.connect)(null, { changeFilters: _search.changeFilters }), _dec(_class = function (_Component) {
	  _inherits(Buildings, _Component);
	
	  function Buildings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Buildings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Buildings.__proto__ || Object.getPrototypeOf(Buildings)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function () {
	      _this.props.closeModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Buildings, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          items = _props.items,
	          isShown = _props.isShown,
	          highlight = _props.highlight;
	
	
	      if (isShown && items.length) {
	        return _react2.default.createElement(
	          'div',
	          { className: _style2.default.resultSection },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.resultSectionTitle },
	            name,
	            ' (',
	            items.length,
	            ')'
	          ),
	          items.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              {
	                onClick: _this2.onItemClick,
	                key: item.id,
	                className: _style2.default.resultItemWrap
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: '/building/' + item.id,
	                  className: _style2.default.resultItem
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.resultItemTitle },
	                  (0, _utils.getHighlightedText)(item.name, highlight)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.resultItemDescrip },
	                  item.subregion && _react2.default.createElement(
	                    'div',
	                    null,
	                    item.subregion,
	                    ', '
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    ' ' + item.address
	                  )
	                )
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Buildings;
	}(_react.Component)) || _class);
	exports.default = Buildings;

/***/ }),
/* 1074 */
[2398, 1073],
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _search = __webpack_require__(68);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _Districts = __webpack_require__(320);
	
	var _Districts2 = _interopRequireDefault(_Districts);
	
	var _utils = __webpack_require__(215);
	
	var _style = __webpack_require__(234);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _helpers = __webpack_require__(499);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Regions = (_dec = (0, _reactRedux.connect)(null, { changeFilters: _search.changeFilters }), _dec(_class = function (_Component) {
	  _inherits(Regions, _Component);
	
	  function Regions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Regions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Regions.__proto__ || Object.getPrototypeOf(Regions)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function (ids) {
	      _this.props.changeFilters({ subregion: ids });
	      _this.props.closeModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Regions, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          items = _props.items,
	          isShown = _props.isShown,
	          highlight = _props.highlight;
	
	
	      if (isShown && items.length && (0, _helpers.hasRegionsInside)(items)) {
	        return _react2.default.createElement(
	          'div',
	          { className: _style2.default.resultSection },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.resultSectionTitle },
	            name,
	            ' (',
	            items.length,
	            ')'
	          ),
	          items.map(function (item) {
	            if (!_Districts2.default[item.id - 1]) {
	              return null;
	            }
	
	            var ids = Object.keys(_Districts2.default[item.id - 1].checkboxes);
	            return _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                to: '/?subregion=' + ids.join(','),
	                key: item.id,
	                className: _style2.default.resultItemRegion
	              },
	              _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                    return _this2.onItemClick(ids);
	                  }, className: _style2.default.resultItemTitleRegion },
	                (0, _utils.getHighlightedText)(item.name, highlight)
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Regions;
	}(_react.Component)) || _class);
	exports.default = Regions;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Regions = __webpack_require__(1075);
	
	var _Regions2 = _interopRequireDefault(_Regions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Regions2.default;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _search = __webpack_require__(68);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _utils = __webpack_require__(215);
	
	var _style = __webpack_require__(234);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Streets = (_dec = (0, _reactRedux.connect)(null, { changeFilters: _search.changeFilters }), _dec(_class = function (_Component) {
	  _inherits(Streets, _Component);
	
	  function Streets() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Streets);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streets.__proto__ || Object.getPrototypeOf(Streets)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function () {
	      _this.props.closeModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Streets, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          items = _props.items,
	          isShown = _props.isShown,
	          changeFilters = _props.changeFilters,
	          highlight = _props.highlight;
	
	
	      if (isShown && items.length) {
	        return _react2.default.createElement(
	          'div',
	          { className: _style2.default.resultSection },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.resultSectionTitle },
	            name
	          ),
	          items.map(function (item) {
	            return _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                key: item.id,
	                className: _style2.default.resultItem,
	                to: '/building/' + item.id,
	                onClick: _this2.onItemClick
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _style2.default.resultItemTitle },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.resultItemTitle },
	                  (0, _utils.getHighlightedText)(item.address, highlight)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.resultItemDescrip },
	                  item.name
	                )
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Streets;
	}(_react.Component)) || _class);
	exports.default = Streets;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Streets = __webpack_require__(1077);
	
	var _Streets2 = _interopRequireDefault(_Streets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Streets2.default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _search = __webpack_require__(68);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _utils = __webpack_require__(215);
	
	var _style = __webpack_require__(234);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubRegions = (_dec = (0, _reactRedux.connect)(null, { changeFilters: _search.changeFilters }), _dec(_class = function (_Component) {
	  _inherits(SubRegions, _Component);
	
	  function SubRegions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubRegions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubRegions.__proto__ || Object.getPrototypeOf(SubRegions)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function (ids) {
	      _this.props.changeFilters({ subregion: ids });
	      _this.props.closeModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubRegions, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          items = _props.items,
	          isShown = _props.isShown,
	          highlight = _props.highlight;
	
	
	      if (isShown && items.length) {
	        return _react2.default.createElement(
	          'div',
	          { className: _style2.default.resultSection },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.resultSectionTitle },
	            name,
	            ' (',
	            items.length,
	            ')'
	          ),
	          items.map(function (item) {
	            var ids = [item.id];
	            return _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                to: '/?subregion=' + ids.join(','),
	                key: item.id,
	                className: _style2.default.resultItemRegion
	              },
	              _react2.default.createElement(
	                'div',
	                { onClick: function onClick() {
	                    return _this2.onItemClick(ids);
	                  }, className: _style2.default.resultItemTitleRegion },
	                (0, _utils.getHighlightedText)(item.name, highlight)
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SubRegions;
	}(_react.Component)) || _class);
	exports.default = SubRegions;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubRegions = __webpack_require__(1079);
	
	var _SubRegions2 = _interopRequireDefault(_SubRegions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SubRegions2.default;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Streets = exports.Buildings = exports.SubRegions = exports.Regions = undefined;
	
	var _Regions = __webpack_require__(1076);
	
	var _Regions2 = _interopRequireDefault(_Regions);
	
	var _SubRegions = __webpack_require__(1080);
	
	var _SubRegions2 = _interopRequireDefault(_SubRegions);
	
	var _Buildings = __webpack_require__(1074);
	
	var _Buildings2 = _interopRequireDefault(_Buildings);
	
	var _Streets = __webpack_require__(1078);
	
	var _Streets2 = _interopRequireDefault(_Streets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Regions = _Regions2.default;
	exports.SubRegions = _SubRegions2.default;
	exports.Buildings = _Buildings2.default;
	exports.Streets = _Streets2.default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1442);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Filter(_ref) {
	  var _cx;
	
	  var className = _ref.className,
	      _onClick = _ref.onClick,
	      name = _ref.name,
	      text = _ref.text,
	      filter = _ref.filter,
	      isBlocked = _ref.isBlocked;
	
	  var classes = (0, _classnames2.default)(_style2.default.root, className, (_cx = {}, _defineProperty(_cx, _style2.default.blocked, isBlocked), _defineProperty(_cx, _style2.default.active, filter === name), _cx));
	  return _react2.default.createElement(
	    'div',
	    { className: classes, onClick: function onClick() {
	        return !isBlocked && _onClick(name);
	      } },
	    text
	  );
	}
	
	exports.default = Filter;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filter = __webpack_require__(1082);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Filter2.default;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Filter = __webpack_require__(1083);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _constants = __webpack_require__(317);
	
	var _style = __webpack_require__(1443);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapFilterToEventLabel = function mapFilterToEventLabel(filter) {
	  var filterMapping = {
	    ALL: 'vse',
	    BUILDINGS: 'novostroiki',
	    REGIONS: 'raiony',
	    SUB_REGIONS: 'mikroraiony',
	    STREETS: 'ulicy'
	  };
	
	  return filterMapping[filter] || 'unknown';
	};
	
	var Filters = function (_Component) {
	  _inherits(Filters, _Component);
	
	  function Filters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Filters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filters.__proto__ || Object.getPrototypeOf(Filters)).call.apply(_ref, [this].concat(args))), _this), _this.setFilter = function (filter) {
	      _this.props.setFilter(filter);
	      (0, _ga.trackGA)(_ga.gaEvent.searchButtonsClick({
	        eventLabel: mapFilterToEventLabel(filter),
	        user_id: _this.props.profile.id
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Filters, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          filter = _props.filter,
	          areRegionsBlocked = _props.areRegionsBlocked,
	          areSubregionsBlocked = _props.areSubregionsBlocked,
	          areBuildingsBlocked = _props.areBuildingsBlocked,
	          areStreetsBlocked = _props.areStreetsBlocked,
	          isUserStartsSearching = _props.isUserStartsSearching,
	          t = _props.t;
	
	
	      var defaultProps = {
	        filter: filter,
	        onClick: this.setFilter
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.filtersWrap, _defineProperty({}, _style2.default.withResults, isUserStartsSearching)) },
	        _react2.default.createElement(_Filter2.default, _extends({
	          name: _constants.FILTERS.ALL,
	          text: t('components.searchFullscreen.filters.all')
	        }, defaultProps)),
	        _react2.default.createElement(_Filter2.default, _extends({
	          name: _constants.FILTERS.BUILDINGS,
	          text: t('components.searchFullscreen.filters.buildings'),
	          isBlocked: areBuildingsBlocked
	        }, defaultProps)),
	        _react2.default.createElement(_Filter2.default, _extends({
	          name: _constants.FILTERS.REGIONS,
	          text: t('components.searchFullscreen.filters.areas'),
	          isBlocked: areRegionsBlocked
	        }, defaultProps)),
	        _react2.default.createElement(_Filter2.default, _extends({
	          name: _constants.FILTERS.SUB_REGIONS,
	          text: t('components.searchFullscreen.filters.neighborhoods')
	        }, defaultProps, {
	          isBlocked: areSubregionsBlocked
	        })),
	        _react2.default.createElement(_Filter2.default, _extends({
	          name: _constants.FILTERS.STREETS,
	          text: t('components.searchFullscreen.filters.streets')
	        }, defaultProps, {
	          isBlocked: areStreetsBlocked
	        }))
	      );
	    }
	  }]);
	
	  return Filters;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(Filters));

/***/ }),
/* 1085 */
[2394, 1084],
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Input = __webpack_require__(1102);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _style = __webpack_require__(1444);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.handleInputChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.setState({ searchValue: value });
	      _this.setSearchValue(value);
	    };
	
	    _this.setSearchValue = _this.props.setSearchValue;
	
	
	    _this.state = {
	      searchValue: props.defaultValue || ''
	    };
	
	    _this.setSearchValue = (0, _lodash2.default)(_this.setSearchValue, 500);
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.inputEl.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          placeholder = _props.placeholder,
	          autofocus = _props.autofocus;
	
	      var classes = (0, _classnames2.default)(_style2.default.root, className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Hide1180 },
	          _react2.default.createElement(_Input2.default, {
	            onChange: this.handleInputChange,
	            placeholder: placeholder[0],
	            defaultValue: this.state.searchValue,
	            getRef: function getRef(inputEl) {
	              _this2.inputEl = inputEl;
	            },
	            autofocus: autofocus
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Show1180 },
	          _react2.default.createElement(_Input2.default, {
	            onChange: this.handleInputChange,
	            placeholder: placeholder[1],
	            defaultValue: this.state.searchValue,
	            getRef: function getRef(inputEl) {
	              _this2.inputEl = inputEl;
	            },
	            autofocus: autofocus
	          })
	        )
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	exports.default = Input;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(5);
	
	var _search = __webpack_require__(68);
	
	var _Input = __webpack_require__(1086);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  setSearchValue: _search.setSearchValue
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Input2.default);

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InputContainer = __webpack_require__(1087);
	
	var _InputContainer2 = _interopRequireDefault(_InputContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InputContainer2.default;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(317);
	
	var _Spinner = __webpack_require__(318);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _Input = __webpack_require__(1088);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Filters = __webpack_require__(1085);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _Content = __webpack_require__(1081);
	
	var _style = __webpack_require__(536);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _nothingfound = __webpack_require__(118);
	
	var _nothingfound2 = _interopRequireDefault(_nothingfound);
	
	var _helpers = __webpack_require__(499);
	
	var _reactI18next = __webpack_require__(4);
	
	var _ga = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchFullscreen = function (_Component) {
	  _inherits(SearchFullscreen, _Component);
	
	  function SearchFullscreen() {
	    _classCallCheck(this, SearchFullscreen);
	
	    return _possibleConstructorReturn(this, (SearchFullscreen.__proto__ || Object.getPrototypeOf(SearchFullscreen)).apply(this, arguments));
	  }
	
	  _createClass(SearchFullscreen, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          searchValue = _props.searchValue,
	          isFetched = _props.isFetched,
	          regions = _props.regions,
	          subregions = _props.subregions,
	          buildings = _props.buildings,
	          streets = _props.streets,
	          profile = _props.profile;
	
	
	      if (prevProps.isFetched === false && isFetched && searchValue.length >= 2) {
	        var totalResults = regions.length + subregions.length + buildings.length + streets.length;
	
	        var debouncedSearchEvent = (0, _lodash2.default)(function () {
	          (0, _ga.trackGA)(_ga.gaEvent.searchInput({
	            eventLabel: totalResults ? totalResults + '_results' : 'nichego_ne_naideno',
	            eventContent: totalResults,
	            eventContext: searchValue,
	            user_id: profile.id
	          }));
	        }, 3000);
	
	        debouncedSearchEvent();
	      }
	    }
	  }, {
	    key: 'getResulsByFilter',
	    value: function getResulsByFilter() {
	      var _props2 = this.props,
	          filter = _props2.filter,
	          regions = _props2.regions,
	          subregions = _props2.subregions,
	          buildings = _props2.buildings,
	          streets = _props2.streets;
	
	      switch (filter) {
	        case _constants.FILTERS.ALL:
	          return regions.length || subregions.length || buildings.length || streets.length;
	        case _constants.FILTERS.REGIONS:
	          return regions.length;
	        case _constants.FILTERS.SUB_REGIONS:
	          return subregions.length;
	        case _constants.FILTERS.BUILDINGS:
	          return buildings.length;
	        case _constants.FILTERS.STREETS:
	          return streets.length;
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          searchValue = _props3.searchValue,
	          setFilter = _props3.setFilter,
	          filter = _props3.filter,
	          isLoading = _props3.isLoading,
	          regions = _props3.regions,
	          subregions = _props3.subregions,
	          buildings = _props3.buildings,
	          streets = _props3.streets,
	          closeModal = _props3.closeModal,
	          isFetched = _props3.isFetched,
	          t = _props3.t,
	          profile = _props3.profile;
	
	
	      var isUserStartsSearching = !!searchValue.length;
	      var areResults = this.getResulsByFilter();
	
	      var classes = (0, _classnames2.default)(_style2.default.root, _defineProperty({}, _style2.default.withContent, isUserStartsSearching));
	      var defaultContentProps = {
	        highlight: searchValue,
	        closeModal: closeModal
	      };
	      var isFiltersCanBeBlocked = isFetched && !!searchValue.length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          {
	            className: _style2.default.close,
	            onClick: function onClick() {
	              closeModal();
	              (0, _ga.trackGA)(_ga.gaEvent.searchButtonsClick({
	                eventLabel: 'zakryt',
	                user_id: profile.id
	              }));
	            }
	          },
	          _react2.default.createElement('img', { src: _cross2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.searchAndFilters },
	          _react2.default.createElement(_Input2.default, {
	            defaultValue: searchValue,
	            placeholder: _constants.filtersPlaceholder.get(filter),
	            className: _style2.default.searchInput,
	            autofocus: true
	          }),
	          _react2.default.createElement(_Filters2.default, {
	            setFilter: setFilter,
	            filter: filter,
	            areRegionsBlocked: isFiltersCanBeBlocked ? regions.length === 0 || (0, _helpers.hasRegionsInside)(regions) === false : false,
	            areSubregionsBlocked: isFiltersCanBeBlocked ? subregions.length === 0 : false,
	            areBuildingsBlocked: isFiltersCanBeBlocked ? buildings.length === 0 : false,
	            areStreetsBlocked: isFiltersCanBeBlocked ? streets.length === 0 : false,
	            isUserStartsSearching: true
	          })
	        ),
	        isUserStartsSearching && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.contentWrapper, 'custom-scrollbar') },
	          _react2.default.createElement(
	            _Spinner2.default,
	            {
	              isLoading: isLoading && isUserStartsSearching,
	              className: _style2.default.spinner,
	              noFadeIn: true
	            },
	            areResults ? _react2.default.createElement(
	              'div',
	              { className: _style2.default.content },
	              _react2.default.createElement(_Content.Buildings, _extends({
	                name: t('components.searchFullscreen.buildings'),
	                items: buildings,
	                isShown: _constants.FILTERS.BUILDINGS === filter || _constants.FILTERS.ALL === filter
	              }, defaultContentProps)),
	              _react2.default.createElement(_Content.Regions, _extends({
	                name: t('components.searchFullscreen.areas'),
	                items: regions,
	                isShown: _constants.FILTERS.REGIONS === filter || _constants.FILTERS.ALL === filter
	              }, defaultContentProps)),
	              _react2.default.createElement(_Content.SubRegions, _extends({
	                name: t('components.searchFullscreen.neighborhoods'),
	                items: subregions,
	                isShown: _constants.FILTERS.SUB_REGIONS === filter || _constants.FILTERS.ALL === filter
	              }, defaultContentProps)),
	              _react2.default.createElement(_Content.Streets, _extends({
	                name: t('components.searchFullscreen.streets'),
	                items: streets,
	                isShown: _constants.FILTERS.STREETS === filter || _constants.FILTERS.ALL === filter
	              }, defaultContentProps))
	            ) : isFetched ? _react2.default.createElement(
	              'div',
	              { className: _style2.default.notFound },
	              _react2.default.createElement('img', { src: _nothingfound2.default, alt: t('components.searchFullscreen.emptyResults'), className: _style2.default.notFoundImage }),
	              _react2.default.createElement(
	                'p',
	                { className: _style2.default.notFoundTitle },
	                t('components.searchFullscreen.emptyResults')
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _style2.default.notFoundSubTitle },
	                t('components.searchFullscreen.emptyResultsDescription')
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchFullscreen;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(SearchFullscreen));

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactModal = __webpack_require__(184);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _constants = __webpack_require__(317);
	
	var _search = __webpack_require__(68);
	
	var _search2 = __webpack_require__(508);
	
	var _SearchFullscreen = __webpack_require__(1089);
	
	var _SearchFullscreen2 = _interopRequireDefault(_SearchFullscreen);
	
	var _style = __webpack_require__(536);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    searchValue: (0, _search2.getSearchValue)(state),
	    isLoading: (0, _search2.getSearchValueState)(state),
	    regions: (0, _search2.getRegions)(state),
	    subregions: (0, _search2.getSubregions)(state),
	    buildings: (0, _search2.getBuildings)(state),
	    streets: (0, _search2.getStreets)(state),
	    isSearchModalOpen: (0, _search2.getSearchModalState)(state),
	    isFetched: (0, _search2.getSearchRequestFetchStatus)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setSearchModalState: _search.setSearchModalState
	};
	
	var SearchFullscreenContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	  _inherits(SearchFullscreenContainer, _Component);
	
	  function SearchFullscreenContainer(props) {
	    _classCallCheck(this, SearchFullscreenContainer);
	
	    var _this = _possibleConstructorReturn(this, (SearchFullscreenContainer.__proto__ || Object.getPrototypeOf(SearchFullscreenContainer)).call(this, props));
	
	    _this.setFilter = function (filter) {
	      return _this.setState({ filter: filter });
	    };
	
	    _this.closeModal = function () {
	      return _this.props.setSearchModalState(false);
	    };
	
	    _this.state = {
	      filter: _constants.FILTERS.ALL
	    };
	    return _this;
	  }
	
	  _createClass(SearchFullscreenContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isSearchModalOpen = _props.isSearchModalOpen,
	          other = _objectWithoutProperties(_props, ['isSearchModalOpen']);
	
	      return _react2.default.createElement(
	        _reactModal2.default,
	        {
	          isOpen: isSearchModalOpen,
	          contentLabel: 'Modal',
	          style: _constants.modalStyles,
	          className: _style2.default.SearchModal,
	          overlayClassName: _style2.default.SearchModalOverlay,
	          onRequestClose: this.closeModal
	        },
	        _react2.default.createElement(_SearchFullscreen2.default, _extends({
	          setFilter: this.setFilter,
	          filter: this.state.filter,
	          closeModal: this.closeModal
	        }, other))
	      );
	    }
	  }]);
	
	  return SearchFullscreenContainer;
	}(_react.Component)) || _class);
	exports.default = SearchFullscreenContainer;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchFullscreenContainer = __webpack_require__(1090);
	
	var _SearchFullscreenContainer2 = _interopRequireDefault(_SearchFullscreenContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchFullscreenContainer2.default;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _collections = __webpack_require__(49);
	
	var _environment = __webpack_require__(19);
	
	var _iconShare = __webpack_require__(1555);
	
	var _iconShare2 = _interopRequireDefault(_iconShare);
	
	var _ShareDialog = __webpack_require__(1095);
	
	var _ShareDialog2 = _interopRequireDefault(_ShareDialog);
	
	var _ShareButton = __webpack_require__(1445);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var ShareButton = function (_Component) {
	  _inherits(ShareButton, _Component);
	
	  function ShareButton(props) {
	    _classCallCheck(this, ShareButton);
	
	    var _this = _possibleConstructorReturn(this, (ShareButton.__proto__ || Object.getPrototypeOf(ShareButton)).call(this, props));
	
	    _this.handleClick = function (e) {
	      e.preventDefault();
	
	      var _this$props = _this.props,
	          shareBuilding = _this$props.shareBuilding,
	          building = _this$props.building,
	          onClick = _this$props.onClick;
	
	
	      if (onClick) {
	        onClick();
	      }
	
	      shareBuilding({ buildingId: building.data.id }).then(function (res) {
	        _this.setState({
	          modalIsOpen: true,
	          shareId: res.data.data.selectionReferal
	        });
	      });
	    };
	
	    _this.handleModalClose = function () {
	      _this.setState({
	        modalIsOpen: false,
	        shareId: null
	      });
	    };
	
	    _this.state = {
	      modalIsOpen: false,
	      shareId: null
	    };
	    return _this;
	  }
	
	  _createClass(ShareButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          pure = _props.pure,
	          _props$href = _props.href,
	          href = _props$href === undefined ? '#' : _props$href,
	          tooltip = _props.tooltip,
	          building = _props.building,
	          objectType = _props.objectType,
	          profile = _props.profile;
	      var _state = this.state,
	          modalIsOpen = _state.modalIsOpen,
	          shareId = _state.shareId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_ShareButton2.default.PrintWrap, className, _defineProperty({}, _ShareButton2.default.Pure, pure)), 'data-tip': tooltip, 'data-for': 'global' },
	        _react2.default.createElement(
	          'a',
	          { className: _ShareButton2.default.ButtonPrint, href: href, target: '_blank', onClick: this.handleClick.bind(this) },
	          _react2.default.createElement('img', { src: _iconShare2.default, alt: '' })
	        ),
	        modalIsOpen ? _react2.default.createElement(_ShareDialog2.default, {
	          building: building,
	          shareId: shareId,
	          onClose: this.handleModalClose,
	          objectType: objectType,
	          profile: profile
	        }) : null
	      );
	    }
	  }]);
	
	  return ShareButton;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  setPopUp: _environment.setPopUp,
	  shareBuilding: _collections.shareBuilding
	})(ShareButton);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShareButton = __webpack_require__(1092);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ShareButton2.default;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClipboard = __webpack_require__(653);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _iconLinkDark = __webpack_require__(546);
	
	var _iconLinkDark2 = _interopRequireDefault(_iconLinkDark);
	
	var _checkIcon = __webpack_require__(339);
	
	var _checkIcon2 = _interopRequireDefault(_checkIcon);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ShareDialog = __webpack_require__(1446);
	
	var _ShareDialog2 = _interopRequireDefault(_ShareDialog);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Checkbox = __webpack_require__(115);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _helper = __webpack_require__(55);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _Config = __webpack_require__(16);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ShareDialog = function ShareDialog(_ref) {
	  var onClose = _ref.onClose,
	      shareId = _ref.shareId,
	      building = _ref.building,
	      objectType = _ref.objectType,
	      profile = _ref.profile;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showNotification = _useState2[0],
	      setShowNotification = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    nameAddress: true,
	    description: true,
	    characteristics: true,
	    communications: true,
	    checkout: true,
	    payment: true,
	    lots: true
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      values = _useState4[0],
	      setValues = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      url = _useState6[0],
	      setUrl = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      hash = _useState8[0],
	      setHash = _useState8[1];
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var handleTrackEvent = function handleTrackEvent(_ref2) {
	    var eventName = _ref2.eventName,
	        eventLabel = _ref2.eventLabel,
	        eventContent = _ref2.eventContent;
	    var _building$data = building.data,
	        title = _building$data.title,
	        id = _building$data.id;
	
	    (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	      eventLabel: eventLabel,
	      eventContent: eventContent || title,
	      productType: objectType,
	      productName: title,
	      productID: id,
	      user_id: profile.id
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      handleTrackEvent({
	        eventName: 'buildingShareButtonsClick',
	        eventLabel: 'zakryt'
	      });
	    };
	  }, []);
	
	  var handleInputFocus = function handleInputFocus(e) {
	    e.target.selectionStart = 0;
	    e.target.selectionEnd = e.target.value.length;
	
	    _tracker2.default.sendEvent('Web_ShareDialog_Link');
	  };
	
	  var handleClipboardClick = function handleClipboardClick() {
	    setShowNotification(true);
	    _tracker2.default.sendEvent('Web_ShareDialog_CopyButton');
	
	    handleTrackEvent({
	      eventName: 'buildingShareButtonsClick',
	      eventLabel: 'skopirovat'
	    });
	
	    setTimeout(function () {
	      return undefined.setState({ showNotification: false });
	    }, 5000);
	  };
	
	  var handlePdfClick = function handlePdfClick() {
	    _tracker2.default.sendEvent('Web_ShareDialog_SavePdf', {
	      id: building.data.id,
	      name: building.data.title
	    });
	
	    handleTrackEvent({
	      eventName: 'buildingShareButtonsClick',
	      eventLabel: 'skachat_prezentaciyu'
	    });
	
	    var link = document.createElement('a');
	    link.href = _Config.ROOT_URL + '/share-building/pdf/' + hash;
	    link.download = 'file.pdf';
	    link.target = '__blank';
	    link.dispatchEvent(new MouseEvent('click'));
	    link.remove();
	  };
	
	  var handleChange = function handleChange(name, value, text) {
	    _tracker2.default.sendEvent('Web_ShareDialog_' + (0, _helper.firstLetterToUpper)(name), {
	      selected: value
	    });
	
	    handleTrackEvent({
	      eventName: 'buildingShareCheckboxesPick',
	      eventContent: [text, ' | ' + (value ? 'on' : 'off')]
	    });
	
	    setValues(function (prevState) {
	      return _extends({}, prevState, _defineProperty({}, name, value));
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    (0, _helper.makeBase64)({
	      id: shareId,
	      values: values
	    }).then(function (hashValue) {
	      setHash(hashValue);
	      setUrl(window.location.origin + '/nbref/' + hashValue);
	    });
	  }, [values]);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      isOpen: true,
	      handleClose: onClose,
	      title: t('components.shareDialog.sendObject'),
	      contentStyle: {
	        width: '583px',
	        margin: 'auto'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _ShareDialog2.default.Modal },
	      _react2.default.createElement(
	        'p',
	        { className: _ShareDialog2.default.ModalDescription },
	        t('components.shareDialog.title')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _ShareDialog2.default.ModalCheckboxes },
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.nameAddress,
	          handle: function handle(value) {
	            return handleChange('nameAddress', value, 'Название и адрес');
	          },
	          text: 'Название и адрес'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.description,
	          handle: function handle(value) {
	            return handleChange('description', value, 'Описание и преимущества');
	          },
	          text: 'Описание и преимущества'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.characteristics,
	          handle: function handle(value) {
	            return handleChange('characteristics', value, 'Общие характеристики');
	          },
	          text: 'Общие характеристики'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.communications,
	          handle: function handle(value) {
	            return handleChange('communications', value, 'Коммуникации');
	          },
	          text: 'Коммуникации'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.checkout,
	          handle: function handle(value) {
	            return handleChange('checkout', value, 'Оформление');
	          },
	          text: 'Оформление'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.payment,
	          handle: function handle(value) {
	            return handleChange('payment', value, 'Оплата');
	          },
	          text: 'Оплата'
	        }),
	        _react2.default.createElement(_Checkbox2.default, {
	          checked: values.lots,
	          handle: function handle(value) {
	            return handleChange('lots', value, 'Лоты');
	          },
	          text: 'Лоты'
	        })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _ShareDialog2.default.SendLink },
	        t('components.shareDialog.hint')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _ShareDialog2.default.SendCollectionInputWrap },
	        _react2.default.createElement('img', { src: _iconLinkDark2.default, alt: '' }),
	        _react2.default.createElement('input', { readOnly: true, value: url, className: _ShareDialog2.default.SendCollectionInput, onFocus: handleInputFocus })
	      ),
	      _react2.default.createElement(
	        _reactClipboard2.default,
	        { className: (0, _classnames2.default)(_ShareDialog2.default.SendCollectionBtn, 'button-primary', 'button-primary--sm'), 'data-clipboard-text': url, onClick: handleClipboardClick },
	        t('components.shareDialog.copy')
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: (0, _classnames2.default)(_ShareDialog2.default.SendPdf), onClick: handlePdfClick },
	        t('components.shareDialog.savePdfFile')
	      ),
	      showNotification ? _react2.default.createElement(
	        'span',
	        { className: _ShareDialog2.default.ModalNotification },
	        _react2.default.createElement('img', { src: _checkIcon2.default, alt: t('components.shareDialog.copied') }),
	        ' ',
	        t('components.shareDialog.copied')
	      ) : null
	    )
	  );
	};
	
	exports.default = _react2.default.memo(ShareDialog);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShareDialog = __webpack_require__(1094);
	
	var _ShareDialog2 = _interopRequireDefault(_ShareDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ShareDialog2.default;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _style = __webpack_require__(1447);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _support = __webpack_require__(1601);
	
	var _support2 = _interopRequireDefault(_support);
	
	var _email = __webpack_require__(1600);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _telegram = __webpack_require__(1602);
	
	var _telegram2 = _interopRequireDefault(_telegram);
	
	var _whatsup = __webpack_require__(1603);
	
	var _whatsup2 = _interopRequireDefault(_whatsup);
	
	var _arrow = __webpack_require__(1599);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _arrowRight = __webpack_require__(1598);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _reactRouter = __webpack_require__(274);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deniedUrls = ['nbref', 'ncollection', 'rates'];
	
	var Support = _react2.default.memo(function () {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var authenticated = (0, _reactRedux.useSelector)(function (state) {
	    return state.authentication.authenticated;
	  }, _reactRedux.shallowEqual);
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var location = (0, _reactRouter.useLocation)();
	
	  var handleTrackEvent = function handleTrackEvent(_ref) {
	    var eventName = _ref.eventName,
	        eventLabel = _ref.eventLabel,
	        profileId = _ref.profileId;
	
	    var screenName = location.pathname;
	    (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	      screenName: screenName,
	      eventLabel: eventLabel,
	      user_id: profileId
	    }));
	  };
	
	  if (!authenticated) {
	    return null;
	  }
	
	  if (deniedUrls.find(function (url) {
	    return location.pathname.includes(url);
	  })) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _style2.default.SupportContainer },
	    _react2.default.createElement(
	      'span',
	      {
	        onClick: function onClick() {
	          setIsOpen(function (prev) {
	            return !prev;
	          });
	          handleTrackEvent({
	            eventName: 'supportClick'
	          });
	        },
	        className: _style2.default.SupportContainerButton,
	        title: t('components.support.title')
	      },
	      isOpen ? _react2.default.createElement('img', { style: { transform: 'rotate(90deg)' }, src: _arrowRight2.default }) : _react2.default.createElement('img', { alt: '', src: _support2.default })
	    ),
	    isOpen && _react2.default.createElement(
	      'div',
	      { className: _style2.default.SupportTable },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_style2.default.SupportTableTitle, _style2.default.Border) },
	        t('components.support.title')
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://api.whatsapp.com/send/?phone=79683000112',
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          className: _style2.default.SupportTableRow,
	          onClick: function onClick() {
	            return handleTrackEvent({
	              eventName: 'supportDialogButtonsClick',
	              eventLabel: 'whatsup'
	            });
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { alt: '', src: _whatsup2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Border },
	          t('components.support.whatsup')
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://t.me/Nedvex_App',
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          className: _style2.default.SupportTableRow,
	          onClick: function onClick() {
	            return handleTrackEvent({
	              eventName: 'supportDialogButtonsClick',
	              eventLabel: 'telegram'
	            });
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { alt: '', src: _telegram2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.Border },
	          t('components.support.telegram')
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'mailto:content@nedvex.ru?Subject=\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443',
	          className: _style2.default.SupportTableRow,
	          onClick: function onClick() {
	            return handleTrackEvent({
	              eventName: 'supportDialogButtonsClick',
	              eventLabel: 'pochta'
	            });
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { alt: '', src: _email2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          t('components.support.email')
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.SupportTableArrow },
	        _react2.default.createElement('img', { alt: '', src: _arrow2.default })
	      )
	    )
	  );
	});
	
	exports.default = Support;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _search = __webpack_require__(68);
	
	var _TypeFilters = __webpack_require__(500);
	
	var _TypeFilters2 = _interopRequireDefault(_TypeFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = { changeFilters: _search.changeFilters };
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(null, mapDispatchToProps)(_TypeFilters2.default));

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TypeFiltersContainer = __webpack_require__(1097);
	
	var _TypeFiltersContainer2 = _interopRequireDefault(_TypeFiltersContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TypeFiltersContainer2.default;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1449);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _helper = __webpack_require__(55);
	
	var _ga = __webpack_require__(7);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var handleTrackEvent = function handleTrackEvent(_ref) {
	  var eventName = _ref.eventName,
	      screenName = _ref.screenName,
	      eventContent = _ref.eventContent,
	      user_id = _ref.user_id;
	
	  (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	    screenName: screenName,
	    eventContent: eventContent,
	    user_id: user_id
	  }));
	};
	
	var WarningRow = function (_Component) {
	  _inherits(WarningRow, _Component);
	
	  function WarningRow() {
	    _classCallCheck(this, WarningRow);
	
	    return _possibleConstructorReturn(this, (WarningRow.__proto__ || Object.getPrototypeOf(WarningRow)).apply(this, arguments));
	  }
	
	  _createClass(WarningRow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          children = _props.children,
	          profile = _props.profile;
	
	
	      var debouncedTrackEvent = (0, _lodash2.default)(function () {
	        handleTrackEvent({
	          eventName: 'infoBannerShow',
	          screenName: location.pathname,
	          eventContent: children,
	          user_id: profile.id
	        });
	      }, 2000);
	
	      debouncedTrackEvent();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          color = _props2.color,
	          backgroundColor = _props2.backgroundColor,
	          profile = _props2.profile;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: _styles2.default.WarningRow,
	          style: { color: color, backgroundColor: backgroundColor },
	          onClick: function onClick() {
	            return handleTrackEvent({
	              eventName: 'infoBannerClick',
	              screenName: location.pathname,
	              eventContent: children,
	              user_id: profile.id
	            });
	          }
	        },
	        (0, _helper.linkifyText)(children)
	      );
	    }
	  }]);
	
	  return WarningRow;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(mapStateToProps, null)(WarningRow)));

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WarningRow = __webpack_require__(1099);
	
	var _WarningRow2 = _interopRequireDefault(_WarningRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WarningRow2.default;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Avatar = __webpack_require__(501);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 1102 */
[2401, 502],
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1455);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InputForm(_ref) {
	  var className = _ref.className,
	      label = _ref.label,
	      input = _ref.input,
	      required = _ref.required,
	      placeholder = _ref.placeholder,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error;
	
	  var classes = (0, _classnames2.default)(_style2.default.root, className, touched && error && _style2.default.error);
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.label },
	      label,
	      required && _react2.default.createElement(
	        'sup',
	        null,
	        '*'
	      )
	    ),
	    _react2.default.createElement('input', _extends({
	      placeholder: placeholder
	    }, input)),
	    touched && error && _react2.default.createElement(
	      'span',
	      { className: _style2.default.message },
	      error
	    )
	  );
	}
	
	exports.default = InputForm;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InputForm = __webpack_require__(1103);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InputForm2.default;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapPoint = __webpack_require__(1457);
	
	var _MapPoint2 = _interopRequireDefault(_MapPoint);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapPoint = function MapPoint(props) {
	  var contexuality = props.contexuality,
	      className = props.className,
	      onClick = props.onClick;
	
	  return _react2.default.createElement('span', { className: (0, _classnames2.default)(_MapPoint2.default.MapPoint, contexuality ? _MapPoint2.default[contexuality] : null, className), onClick: onClick });
	};
	
	exports.default = MapPoint;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProgressiveImage = __webpack_require__(1459);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressiveImage = function (_Component) {
	  _inherits(ProgressiveImage, _Component);
	
	  function ProgressiveImage(props) {
	    _classCallCheck(this, ProgressiveImage);
	
	    var _this = _possibleConstructorReturn(this, (ProgressiveImage.__proto__ || Object.getPrototypeOf(ProgressiveImage)).call(this, props));
	
	    _this.state = {
	      onSmallImageLoad: null,
	      onBigImageLoad: null,
	      smallImageLoaded: false,
	      bigImageLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(ProgressiveImage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.followSmallImage();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _state = this.state,
	          smallImageLoaded = _state.smallImageLoaded,
	          bigImageLoaded = _state.bigImageLoaded,
	          onBigImageLoad = _state.onBigImageLoad;
	
	      if (smallImageLoaded && !bigImageLoaded && !onBigImageLoad) {
	        this.followBigImage();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state2 = this.state,
	          onSmallImageLoad = _state2.onSmallImageLoad,
	          onBigImageLoad = _state2.onBigImageLoad;
	
	      if (onSmallImageLoad) {
	        var smallImage = _reactDom2.default.findDOMNode(this.refs.smallImage);
	        smallImage.removeEventListener('load', onSmallImageLoad);
	      }
	      if (onBigImageLoad) {
	        var bigImage = _reactDom2.default.findDOMNode(this.refs.bigImage);
	        bigImage.removeEventListener('load', onBigImageLoad);
	      }
	    }
	  }, {
	    key: 'followSmallImage',
	    value: function followSmallImage() {
	      var _this2 = this;
	
	      var handleSmallImageLoad = this.props.handleSmallImageLoad;
	
	
	      var image = _reactDom2.default.findDOMNode(this.refs.smallImage);
	      if (image.complete) {
	        this.setState({ smallImageLoaded: true });
	        if (handleSmallImageLoad) {
	          handleSmallImageLoad();
	        }
	        return;
	      }
	
	      var onSmallImageLoad = function onSmallImageLoad() {
	        _this2.setState({ onSmallImageLoad: null, smallImageLoaded: true }, function () {
	          image.removeEventListener('load', onSmallImageLoad);
	          if (handleSmallImageLoad) {
	            handleSmallImageLoad();
	          }
	        });
	      };
	      this.setState({ onSmallImageLoad: onSmallImageLoad }, function () {
	        image.addEventListener('load', onSmallImageLoad);
	      });
	    }
	  }, {
	    key: 'followBigImage',
	    value: function followBigImage() {
	      var _this3 = this;
	
	      var handleBigImageLoad = this.props.handleBigImageLoad;
	
	
	      var image = _reactDom2.default.findDOMNode(this.refs.bigImage);
	      if (image.complete) {
	        this.setState({ bigImageLoaded: true });
	        if (handleBigImageLoad) {
	          handleBigImageLoad();
	        }
	        return;
	      }
	
	      var onBigImageLoad = function onBigImageLoad() {
	        _this3.setState({ onBigImageLoad: null, bigImageLoaded: true }, function () {
	          image.removeEventListener('load', onBigImageLoad);
	          if (handleBigImageLoad) {
	            handleBigImageLoad();
	          }
	        });
	      };
	      this.setState({ onBigImageLoad: onBigImageLoad }, function () {
	        image.addEventListener('load', onBigImageLoad);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state3 = this.state,
	          smallImageLoaded = _state3.smallImageLoaded,
	          bigImageLoaded = _state3.bigImageLoaded;
	      var _props = this.props,
	          className = _props.className,
	          smallImageClassName = _props.smallImageClassName,
	          bigImageClassName = _props.bigImageClassName,
	          getSmallImageSrc = _props.getSmallImageSrc,
	          handleSmallImageError = _props.handleSmallImageError,
	          getBigImageSrc = _props.getBigImageSrc,
	          handleBigImageError = _props.handleBigImageError,
	          imageAlt = _props.imageAlt,
	          width = _props.width,
	          isPopup = _props.isPopup;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(isPopup ? _ProgressiveImage2.default.ImageContainer : _ProgressiveImage2.default.ImageContainerShort, className), style: { width: width }, ref: 'ImageContainerRef' },
	        smallImageLoaded && _react2.default.createElement('img', {
	          ref: 'bigImage',
	          className: (0, _classnames2.default)(_ProgressiveImage2.default.BigImage, bigImageClassName, _defineProperty({}, _ProgressiveImage2.default.BigImageShow, smallImageLoaded)),
	          alt: imageAlt,
	          onError: handleBigImageError,
	          src: getBigImageSrc(this.refs.bigImage)
	        }),
	        _react2.default.createElement('img', {
	          ref: 'smallImage',
	          className: (0, _classnames2.default)(_ProgressiveImage2.default.SmallImage, smallImageClassName, _defineProperty({}, _ProgressiveImage2.default.SmallImageHide, bigImageLoaded)),
	          alt: imageAlt,
	          src: getSmallImageSrc(this.refs.smallImage),
	          onError: handleSmallImageError
	        })
	      );
	    }
	  }]);
	
	  return ProgressiveImage;
	}(_react.Component);
	
	exports.default = ProgressiveImage;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressiveImage = __webpack_require__(1106);
	
	var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProgressiveImage2.default;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactI18next = __webpack_require__(4);
	
	var _RadioMenu = __webpack_require__(1460);
	
	var _RadioMenu2 = _interopRequireDefault(_RadioMenu);
	
	var _Menu = __webpack_require__(166);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Checkbox = __webpack_require__(61);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Button = __webpack_require__(33);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioMenu = function (_Component) {
	  _inherits(RadioMenu, _Component);
	
	  function RadioMenu(props) {
	    _classCallCheck(this, RadioMenu);
	
	    var _this = _possibleConstructorReturn(this, (RadioMenu.__proto__ || Object.getPrototypeOf(RadioMenu)).call(this, props));
	
	    _this.state = {
	      activeTabIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(RadioMenu, [{
	    key: 'onMouseEnter',
	    value: function onMouseEnter(key, e) {
	      this.setState({ activeTabIndex: key });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(keys, add) {
	      var _props = this.props,
	          handle = _props.handle,
	          checked = _props.checked,
	          menus = _props.menus,
	          profile = _props.profile,
	          mode = _props.mode,
	          objectType = _props.objectType;
	
	      var values = [].concat(_toConsumableArray(checked));
	      keys.forEach(function (key) {
	        var include = values.includes(key);
	        if (include !== add) {
	          if (add) {
	            values.push(key);
	          } else {
	            values.splice(values.indexOf(key), 1);
	          }
	        }
	
	        if (keys.length === 1) {
	          for (var i = 0; i < menus.length; i++) {
	            var checkboxes = menus[i].checkboxes;
	
	            if (checkboxes[key]) {
	              (0, _ga.trackGA)(_ga.gaEvent.filterMicrodistrictButtonsClick({
	                eventContent: [checkboxes[key], ' | ' + (add ? 'on' : 'off')],
	                eventContext: mode,
	                productType: objectType,
	                user_id: profile.id
	              }));
	            }
	          }
	        }
	      });
	      handle(values);
	    }
	  }, {
	    key: 'handleGroupSelect',
	    value: function handleGroupSelect(key, bool) {
	      var _props2 = this.props,
	          menus = _props2.menus,
	          mode = _props2.mode,
	          objectType = _props2.objectType,
	          profile = _props2.profile;
	      var checkboxes = menus[key].checkboxes;
	
	      var keys = Object.keys(checkboxes);
	      this.handleSelect(keys, bool);
	
	      var selectedDistrictName = menus[key].tabText;
	      (0, _ga.trackGA)(_ga.gaEvent.filterDistrictButtonsClick({
	        eventContent: [selectedDistrictName, ' | ' + (bool ? 'on' : 'off')],
	        eventContext: mode,
	        productType: objectType,
	        user_id: profile.id
	      }));
	    }
	  }, {
	    key: 'isGroupChecked',
	    value: function isGroupChecked(key) {
	      var _props3 = this.props,
	          menus = _props3.menus,
	          checked = _props3.checked;
	      var checkboxes = menus[key].checkboxes;
	
	      var keys = Object.keys(checkboxes);
	      return keys.every(function (key) {
	        return checked.includes(key);
	      });
	    }
	  }, {
	    key: 'isGroupPartialChecked',
	    value: function isGroupPartialChecked(key) {
	      var _props4 = this.props,
	          menus = _props4.menus,
	          checked = _props4.checked;
	      var checkboxes = menus[key].checkboxes;
	
	      var keys = Object.keys(checkboxes);
	      return keys.some(function (key) {
	        return checked.includes(key);
	      });
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this2 = this;
	
	      var activeTabIndex = this.state.activeTabIndex;
	      var _props5 = this.props,
	          menus = _props5.menus,
	          checked = _props5.checked,
	          className = _props5.className,
	          t = _props5.t;
	      var checkboxes = menus[activeTabIndex].checkboxes;
	
	      var keys = Object.keys(checkboxes);
	      var firstColumnCount = Math.floor(keys.length % 2 != 0 ? keys.length / 2 + 1 : keys.length / 2);
	      var firstColumn = keys.slice(0, firstColumnCount);
	      var secondColumn = keys.slice(firstColumnCount);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_RadioMenu2.default.Menu, className) },
	        _react2.default.createElement(
	          'div',
	          { className: _RadioMenu2.default.Checkboxes },
	          _react2.default.createElement(
	            'div',
	            { className: _RadioMenu2.default.FirstColumn },
	            firstColumn.map(function (key) {
	              return _react2.default.createElement(_Checkbox2.default, {
	                key: key,
	                className: _RadioMenu2.default.Checkbox,
	                text: checkboxes[key],
	                checked: checked.includes(key),
	                handle: _this2.handleSelect.bind(_this2, [key])
	              });
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _RadioMenu2.default.SecondColumn },
	            secondColumn.map(function (key) {
	              return _react2.default.createElement(_Checkbox2.default, {
	                key: key,
	                className: _RadioMenu2.default.Checkbox,
	                text: checkboxes[key],
	                checked: checked.includes(key),
	                handle: _this2.handleSelect.bind(_this2, [key])
	              });
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _RadioMenu2.default.Buttons },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: _RadioMenu2.default.Button, onClick: this.handleSelect.bind(this, keys, true) },
	            t('components.common.radioMenu.selectAll')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs() {
	      var _this3 = this;
	
	      var activeTabIndex = this.state.activeTabIndex;
	      var menus = this.props.menus;
	
	
	      return menus.map(function (menu, i) {
	        var tabText = menu.tabText;
	
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: (0, _classnames2.default)(_RadioMenu2.default.Tab, _defineProperty({}, _RadioMenu2.default.TabActive, activeTabIndex === i)), onMouseEnter: _this3.onMouseEnter.bind(_this3, i) },
	          _react2.default.createElement(_Checkbox2.default, {
	            className: _RadioMenu2.default.Checkbox,
	            checked: _this3.isGroupChecked(i),
	            partialChecked: _this3.isGroupPartialChecked(i),
	            handle: _this3.handleGroupSelect.bind(_this3, i),
	            text: tabText
	          })
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props6 = this.props,
	          menus = _props6.menus,
	          checked = _props6.checked,
	          t = _props6.t,
	          mode = _props6.mode,
	          objectType = _props6.objectType,
	          profile = _props6.profile;
	
	      var keys = Array.prototype.concat.apply([], menus.map(function (menu) {
	        return Object.keys(menu.checkboxes);
	      }));
	      return _react2.default.createElement(
	        _Menu2.default,
	        { className: _RadioMenu2.default.FiltersMenu },
	        _react2.default.createElement(
	          'p',
	          { className: _RadioMenu2.default.Title },
	          t('components.common.radioMenu.select'),
	          !!checked.length && _react2.default.createElement(
	            _Button2.default,
	            {
	              className: (0, _classnames2.default)(_RadioMenu2.default.Button, _RadioMenu2.default.ButtonReset),
	              onClick: function onClick() {
	                _this4.handleSelect(keys, false);
	                (0, _ga.trackGA)(_ga.gaEvent.filterClearButtonsClick({
	                  eventContent: 'raion',
	                  eventContext: mode,
	                  productType: objectType,
	                  user_id: profile.id
	                }));
	              }
	            },
	            t('components.common.radioMenu.clear')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _RadioMenu2.default.Container },
	          _react2.default.createElement(
	            'div',
	            { className: _RadioMenu2.default.Tabs },
	            this.renderTabs()
	          ),
	          this.renderMenu()
	        )
	      );
	    }
	  }]);
	
	  return RadioMenu;
	}(_react.Component);
	
	exports.default = (0, _reactI18next.withTranslation)()(RadioMenu);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1461);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _reactSelect = __webpack_require__(2056);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(1321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Часть стилей находтся в assets/style.css в самом низу (они не работают с sass cssModules)
	function InputForm(_ref) {
	  var className = _ref.className,
	      label = _ref.label,
	      options = _ref.options,
	      _ref$input = _ref.input,
	      _onBlur = _ref$input.onBlur,
	      value = _ref$input.value,
	      other = _objectWithoutProperties(_ref$input, ['onBlur', 'value']),
	      required = _ref.required,
	      placeholder = _ref.placeholder,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error;
	
	  var classes = (0, _classnames2.default)(_style2.default.root, className, touched && error && _style2.default.error);
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'div',
	      { className: _style2.default.label },
	      label,
	      required && _react2.default.createElement(
	        'sup',
	        null,
	        '*'
	      )
	    ),
	    _react2.default.createElement(_reactSelect2.default, _extends({
	      placeholder: placeholder,
	      options: options,
	      onBlur: function onBlur() {
	        return _onBlur(value);
	      },
	      value: value || '',
	      optionClassName: _style2.default.options
	    }, other)),
	    touched && error && _react2.default.createElement(
	      'span',
	      { className: _style2.default.message },
	      error
	    )
	  );
	}
	
	exports.default = InputForm;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Select = __webpack_require__(1109);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Select2.default;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickoutside = __webpack_require__(667);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Input = __webpack_require__(1462);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.getInputRef = function (ref) {
	      _this.input = ref;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({ value: e.target.value });
	      _this.props.onChange && _this.props.onChange(e);
	
	      if (e.target.value.length >= 2) {
	        _this.debouncedTrackEvent();
	      }
	    };
	
	    _this.handleSubmit = function (e) {
	      e && e.preventDefault();
	      _this.setState({ editing: false });
	      _this.props.onSubmit(_this.state.value);
	    };
	
	    _this.UNSAFE_componentWillReceiveProps = function (_ref) {
	      var value = _ref.value;
	
	      if (value !== _this.props.value) {
	        _this.setState({ value: value });
	      }
	    };
	
	    _this.handleEditClick = function () {
	      _this.setState({
	        editing: true
	      }, function () {
	        _this.input.focus();
	      });
	    };
	
	    _this.handleClickOutside = function () {
	      if (_this.state.editing) {
	        _this.handleSubmit();
	      }
	    };
	
	    _this.handleTrackEvent = function () {
	      var _this$props$trackEven = _this.props.trackEventData,
	          eventName = _this$props$trackEven.eventName,
	          eventContent = _this$props$trackEven.eventContent,
	          user_id = _this$props$trackEven.user_id;
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventContent: eventContent,
	        user_id: user_id
	      }));
	    };
	
	    _this.state = {
	      value: props.value,
	      editing: false
	    };
	
	    _this.debouncedTrackEvent = (0, _lodash2.default)(_this.handleTrackEvent, 3000);
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ editing: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          placeholder = _props.placeholder,
	          onKeyPress = _props.onKeyPress,
	          onDirty = _props.onDirty,
	          onChange = _props.onChange,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          linkTo = _props.linkTo;
	
	      return _react2.default.createElement(
	        'form',
	        { className: (0, _classnames2.default)(_Input2.default.Container, className), onSubmit: this.handleSubmit },
	        _react2.default.createElement('input', {
	          value: this.state.value,
	          ref: this.getInputRef,
	          className: _Input2.default.Input,
	          onChange: this.handleChange,
	          placeholder: placeholder,
	          readOnly: !this.state.editing,
	          style: {
	            display: this.state.editing ? 'block' : 'none',
	            width: this.state.value.length + 'em'
	          }
	        }),
	        !this.state.editing ? linkTo ? _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: linkTo, className: _Input2.default.FakeInput },
	          this.state.value
	        ) : _react2.default.createElement(
	          'span',
	          { className: _Input2.default.FakeInput },
	          this.state.value
	        ) : null,
	        !this.state.editing && _react2.default.createElement(
	          'div',
	          { onClick: this.handleEditClick },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(Input);

/***/ }),
/* 1112 */
[2401, 1111],
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SpinnerImage = __webpack_require__(1464);
	
	var _SpinnerImage2 = _interopRequireDefault(_SpinnerImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpinnerImage = function (_Component) {
	  _inherits(SpinnerImage, _Component);
	
	  function SpinnerImage(props) {
	    _classCallCheck(this, SpinnerImage);
	
	    var _this = _possibleConstructorReturn(this, (SpinnerImage.__proto__ || Object.getPrototypeOf(SpinnerImage)).call(this, props));
	
	    _this.state = {
	      loadingState: null
	    };
	
	    _this.handleImageLoad = _this.handleImageLoad.bind(_this);
	    _this.handleImageError = _this.handleImageError.bind(_this);
	    return _this;
	  }
	
	  _createClass(SpinnerImage, [{
	    key: 'handleImageLoad',
	    value: function handleImageLoad(event) {
	      var handleImageLoad = this.props.handleImageLoad;
	
	      this.setState({ loadingState: true }, function () {
	        if (handleImageLoad) {
	          handleImageLoad(event);
	        }
	      });
	    }
	  }, {
	    key: 'handleImageError',
	    value: function handleImageError(event) {
	      var handleImageError = this.props.handleImageError;
	
	      this.setState({ loadingState: false }, function () {
	        if (handleImageError) {
	          handleImageError(event);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          spinner = _props.spinner,
	          placeholder = _props.placeholder,
	          className = _props.className,
	          style = _props.style,
	          imageSrc = _props.imageSrc,
	          imageAlt = _props.imageAlt,
	          imageClassName = _props.imageClassName,
	          blur = _props.blur;
	      var loadingState = this.state.loadingState;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_SpinnerImage2.default.Container, className), style: style },
	        loadingState == null || blur ? spinner : null,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_SpinnerImage2.default.BlurContainer, _defineProperty({}, _SpinnerImage2.default.BluredContainer, blur)) },
	          loadingState === false ? placeholder : _react2.default.createElement('img', {
	            className: (0, _classnames2.default)(_SpinnerImage2.default.Image, imageClassName, _defineProperty({}, _SpinnerImage2.default.Hidden, !loadingState)),
	            alt: imageAlt,
	            src: imageSrc,
	            onLoad: this.handleImageLoad,
	            onError: this.handleImageError
	          }),
	          loadingState !== null && this.props.children
	        )
	      );
	    }
	  }]);
	
	  return SpinnerImage;
	}(_react.Component);
	
	exports.default = SpinnerImage;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _StatelessSwitcher = __webpack_require__(1465);
	
	var _StatelessSwitcher2 = _interopRequireDefault(_StatelessSwitcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_StatelessSwitcher2.default);
	
	var StatelessSwitcher = function (_Component) {
	  _inherits(StatelessSwitcher, _Component);
	
	  function StatelessSwitcher(props) {
	    _classCallCheck(this, StatelessSwitcher);
	
	    var _this = _possibleConstructorReturn(this, (StatelessSwitcher.__proto__ || Object.getPrototypeOf(StatelessSwitcher)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(StatelessSwitcher, [{
	    key: 'renderButton',
	    value: function renderButton(icon, text, url, elementStyle, textStyle, tooltip, isChecked, style) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cx(_defineProperty({ Button: true }, elementStyle, true)),
	          style: style,
	          'data-tip': tooltip,
	          'data-for': 'global'
	        },
	        icon,
	        _react2.default.createElement(
	          'span',
	          { className: (0, _bind2.default)(_StatelessSwitcher2.default.Text, textStyle) },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          isChecked = _props.isChecked;
	
	      if (onClick) onClick(isChecked);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          elementStyle = _props2.elementStyle,
	          textStyle = _props2.textStyle,
	          leftIcon = _props2.leftIcon,
	          rightIcon = _props2.rightIcon,
	          leftText = _props2.leftText,
	          rightText = _props2.rightText,
	          leftUrl = _props2.leftUrl,
	          rightUrl = _props2.rightUrl,
	          isChecked = _props2.isChecked,
	          leftTooltip = _props2.leftTooltip,
	          rightTooltip = _props2.rightTooltip,
	          enabledStyle = _props2.enabledStyle,
	          enabledStyleChecked = _props2.enabledStyleChecked,
	          enabledStyleNotChecked = _props2.enabledStyleNotChecked;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cx(className, _StatelessSwitcher2.default.Buttons),
	          onClick: this.handleClick
	        },
	        this.renderButton(leftIcon, leftText, leftUrl, elementStyle, textStyle, leftTooltip, isChecked, {
	          color: !isChecked ? 'rgba(0, 0, 0, 0.5)' : '#085286',
	          opacity: !isChecked ? '.5' : 1,
	          transition: '.25s ease-in-out',
	          transitionDelay: '.25s'
	        }),
	        this.renderButton(rightIcon, rightText, rightUrl, elementStyle, textStyle, rightTooltip, !isChecked, {
	          color: isChecked ? 'rgba(0, 0, 0, 0.5)' : '#085286',
	          opacity: isChecked ? '.5' : 1,
	          transition: '.25s ease-in-out',
	          transitionDelay: '.25s'
	        }),
	        _react2.default.createElement('div', { className: (0, _bind2.default)(_StatelessSwitcher2.default.EnabledElement, enabledStyle, isChecked ? enabledStyleChecked : enabledStyleNotChecked),
	          style: {
	            left: (isChecked ? 0 : 6.5) + '%',
	            WebkitTransform: 'translate3d(' + (isChecked ? 0 : 100) + '%, 0, 0)',
	            transform: 'translate3d(' + (isChecked ? 0 : 100) + '%, 0, 0)',
	            width: (isChecked ? 55 : 47) + '%',
	            transition: '.5s'
	          }
	        })
	      );
	    }
	  }]);
	
	  return StatelessSwitcher;
	}(_react.Component);
	
	exports.default = StatelessSwitcher;
	;
	
	// <Motion style={{x: spring(isChecked ? 1 : 0.5)}}>
	//   {({x}) =>
	//       this.renderButton(leftIcon, leftText, leftUrl, elementStyle, textStyle, isChecked, {
	//         color: x < 0.75 ? 'rgba(0, 0, 0, 0.5)' : '#085286',
	//         opacity: x
	//       })
	//   }
	// </Motion>
	// <Motion style={{x: spring(isChecked ? 0.5 : 1)}}>
	//   {({x}) =>
	//       this.renderButton(rightIcon, rightText, rightUrl, elementStyle, textStyle, !isChecked, {
	//         color: x < 0.75 ? 'rgba(0, 0, 0, 0.5)' : '#085286',
	//         opacity: x
	//       })
	//   }
	// </Motion>
	// <Motion style={{x: spring(isChecked ? 0 : 100)}}>
	//   {({x}) =>
	//     <div className={cn(styles.EnabledElement)}
	//       style={{
	//         left: 0,
	//         WebkitTransform: `translate3d(${x}%, 0, 0)`,
	//         transform: `translate3d(${x}%, 0, 0)`,
	//       }} />
	//   }
	// </Motion>

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StatelessSwitcher = __webpack_require__(1114);
	
	var _StatelessSwitcher2 = _interopRequireDefault(_StatelessSwitcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StatelessSwitcher2.default;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(78);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Switcher = __webpack_require__(1466);
	
	var _Switcher2 = _interopRequireDefault(_Switcher);
	
	var _reactMotion = __webpack_require__(2013);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_Switcher2.default);
	
	var Switcher = function (_Component) {
	  _inherits(Switcher, _Component);
	
	  function Switcher(props) {
	    _classCallCheck(this, Switcher);
	
	    var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props));
	
	    _this.state = {
	      isChecked: 'defaultChecked' in _this.props ? _this.props.defaultChecked : true
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Switcher, [{
	    key: 'renderButton',
	    value: function renderButton(icon, text, elementStyle, textStyle, isChecked, style) {
	      return _react2.default.createElement(
	        'div',
	        { className: cx(_defineProperty({ Button: true }, elementStyle, true)), style: style },
	        icon,
	        _react2.default.createElement(
	          'span',
	          { className: cx(_defineProperty({}, textStyle, true)) },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onClick = _props.onClick,
	          events = _props.events,
	          eventData = _props.eventData;
	
	
	      this.setState({ isChecked: !this.state.isChecked }, function () {
	        _tracker2.default.sendEvent(_this2.state.isChecked ? events.left : events.right, eventData);
	        onClick(_this2.state.isChecked);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          enabledElemStyle = _props2.enabledElemStyle,
	          enabledColor = _props2.enabledColor,
	          elementStyle = _props2.elementStyle,
	          textStyle = _props2.textStyle,
	          leftIcon = _props2.leftIcon,
	          rightIcon = _props2.rightIcon,
	          leftText = _props2.leftText,
	          rightText = _props2.rightText,
	          tooltipLeft = _props2.tooltipLeft,
	          tooltipRight = _props2.tooltipRight,
	          chessfilter = _props2.chessfilter;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: cx(className, _Switcher2.default.Buttons, _defineProperty({}, _Switcher2.default.ButtonsСhessfilter, chessfilter)),
	          onClick: this.handleClick,
	          'data-tip': this.state.isChecked ? tooltipLeft : tooltipRight,
	          'data-for': 'global'
	        },
	        chessfilter ? this.renderButton(leftIcon, leftText, elementStyle, textStyle, this.state.isChecked, {
	          color: this.state.isChecked ? enabledColor || 'white' : 'rgba(0, 0, 0, 0.8)',
	          opacity: 1
	        }) : _react2.default.createElement(
	          _reactMotion.Motion,
	          { style: { x: (0, _reactMotion.spring)(this.state.isChecked ? 1 : 0.5) } },
	          function (_ref) {
	            var x = _ref.x;
	            return _this3.renderButton(leftIcon, leftText, elementStyle, textStyle, _this3.state.isChecked, {
	              color: x < 0.75 ? 'rgba(55, 45, 45, 0.5)' : enabledColor || 'white',
	              opacity: 1
	            });
	          }
	        ),
	        chessfilter ? this.renderButton(rightIcon, rightText, elementStyle, textStyle, !this.state.isChecked, {
	          color: !this.state.isChecked ? enabledColor || 'white' : 'rgba(0, 0, 0, 0.8)',
	          opacity: 1
	        }) : _react2.default.createElement(
	          _reactMotion.Motion,
	          { style: { x: (0, _reactMotion.spring)(this.state.isChecked ? 0.5 : 1) } },
	          function (_ref2) {
	            var x = _ref2.x;
	            return _this3.renderButton(rightIcon, rightText, elementStyle, textStyle, !_this3.state.isChecked, {
	              color: x < 0.75 ? 'rgba(55, 45, 45, 0.5)' : enabledColor || 'white',
	              opacity: 1
	            });
	          }
	        ),
	        chessfilter ? _react2.default.createElement('div', {
	          className: cx(enabledElemStyle, _Switcher2.default.EnabledElement),
	          style: {
	            left: 0,
	            WebkitTransform: 'translate3d(' + (this.state.isChecked ? '100' : 0) + '%, 0, 0)',
	            transform: 'translate3d(' + (this.state.isChecked ? '100' : 0) + '%, 0, 0)'
	          }
	        }) : _react2.default.createElement(
	          _reactMotion.Motion,
	          { style: { x: (0, _reactMotion.spring)(this.state.isChecked ? 0 : 100) } },
	          function (_ref3) {
	            var x = _ref3.x;
	            return _react2.default.createElement('div', {
	              className: cx(enabledElemStyle, _Switcher2.default.EnabledElement),
	              style: {
	                left: 0,
	                WebkitTransform: 'translate3d(' + x + '%, 0, 0)',
	                transform: 'translate3d(' + x + '%, 0, 0)'
	              }
	            });
	          }
	        )
	      );
	    }
	  }]);
	
	  return Switcher;
	}(_react.Component);
	
	exports.default = Switcher;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactYandexMaps = __webpack_require__(278);
	
	var _caption = __webpack_require__(1485);
	
	var _caption2 = _interopRequireDefault(_caption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YCaption = _react2.default.memo(function (_ref) {
	  var lat = _ref.lat,
	      lng = _ref.lng,
	      name = _ref.name;
	  return _react2.default.createElement(_reactYandexMaps.Placemark, {
	    geometry: [+lat, +lng],
	    properties: {
	      iconContent: '<div class="Caption">' + name + '</div'
	    },
	    options: {
	      iconLayout: 'default#imageWithContent',
	      iconImageSize: [30, 42],
	      iconImageOffset: [-15, -21],
	      iconImageHref: _caption2.default
	    }
	  });
	});
	
	exports.default = YCaption;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactYandexMaps = __webpack_require__(278);
	
	var _cluster = __webpack_require__(1585);
	
	var _cluster2 = _interopRequireDefault(_cluster);
	
	__webpack_require__(1325);
	
	var _Point = __webpack_require__(1467);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _reactRedux = __webpack_require__(5);
	
	var _objects = __webpack_require__(99);
	
	var _Config = __webpack_require__(16);
	
	var _nonPhoto = __webpack_require__(350);
	
	var _nonPhoto2 = _interopRequireDefault(_nonPhoto);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var truncateString = function truncateString(str) {
	  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
	  return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
	};
	
	var YClusterPoint = _react2.default.memo(function (_ref) {
	  var lat = _ref.lat,
	      lng = _ref.lng,
	      pointCount = _ref.pointCount,
	      onClick = _ref.onClick,
	      item = _ref.item;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var profile = (0, _reactRedux.useSelector)(function (state) {
	    return state.profile;
	  });
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      hovered = _useState2[0],
	      setHovered = _useState2[1];
	
	  var clusterPointIds = item.properties.clusteredPoints.map(function (obj) {
	    return Number(obj.id);
	  }) || [];
	
	  var longLat = lng + '-' + lat;
	  var longLatPoint = (0, _reactRedux.useSelector)(function (state) {
	    return state.objects.pointsList[longLat];
	  });
	
	  var handleMouseEnter = function handleMouseEnter() {
	    setHovered(true);
	    if (!longLatPoint) {
	      dispatch((0, _objects.loadPointList)(clusterPointIds, longLat));
	    }
	  };
	
	  var handleMouseLeave = function handleMouseLeave() {
	    setHovered(false);
	  };
	
	  var pointData = longLatPoint ? longLatPoint[0] : {};
	
	  var imageUrl = pointData ? pointData.image ? _Config.ROOT_URL + '/image?id=' + pointData.image.id + '&size=small' : _nonPhoto2.default : '';
	
	  return _react2.default.createElement(_reactYandexMaps.Placemark, {
	    geometry: [+lat, +lng],
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    properties: {
	      iconContent: '\n        <div style="position: relative; display: flex; flex-direction: column; align-items: center;">\n          ' + (hovered ? longLatPoint ? '<div class="' + _Point2.default.iconContent + '">\n                  <div class="' + _Point2.default.header + '">\n                    <div class="' + _Point2.default.imageContainer + '">\n                      ' + (imageUrl ? '<img \n                              alt="house" \n                              class="' + _Point2.default.image + '" \n                              src="' + imageUrl + '"\n                              />' : '') + '\n                    </div>\n                    <div class="' + _Point2.default.headerInfo + '">\n                      <div class="' + _Point2.default.title + '">\n                        ' + (pointData && pointData.title ? truncateString(pointData.title, 23) : '') + '\n                      </div>\n                      <div class="' + _Point2.default.subtitle + '">\n                        ' + (pointData && pointData.address ? truncateString(pointData.address, 27) : '') + '\n                      </div>\n                      <div class="' + _Point2.default.labels + '">\n                        ' + (pointData.view_action ? '<div class="' + _Point2.default.promo + '">\u0410\u043A\u0446\u0438\u044F</div>' : '') + '\n                        ' + (pointData.status === 3 ? '<div class="' + _Point2.default.almostFinished + '">\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u0441\u0434\u0430\u043D</div>' : pointData.construction_finished ? '<div class="' + _Point2.default.finished + '">\u0421\u0434\u0430\u043D</div>' : '<div class="' + _Point2.default.endDate + '">\n                                ' + pointData.construction_ending + ' / ' + pointData.year_built + '\n                              </div>') + '\n                      </div>\n                    </div>\n                  </div>\n                  <div class="' + _Point2.default.footer + '">\n                  ' + (pointData.count_flats ? '<div class="' + _Point2.default.footerLeft + '">\n                      <div class="' + _Point2.default.flats + '">\n                        ' + pointData.count_flats + ' ' + (0, _utils.pluralize)(pointData.count_flats, 'Квартира', 'Квартиры', 'Квартир') + '\n                      </div>\n                      <div class="' + _Point2.default.areas + '">\n                        ' + pointData.min_square + ' \u043C\xB2 - ' + pointData.max_square + ' \u043C\xB2\n                      </div>\n                    </div>\n                    <div class="' + _Point2.default.footerRight + '">\n                      <div class="' + _Point2.default.priceFrom + '">\n                        \u041E\u0442 ' + (0, _utils.formatNumber)(pointData.cost_min) + ' ' + profile.user_region.country_currency_symbol + '\n                      </div>\n                      <div class="' + _Point2.default.pricePerMeter + '">\n                        ' + (0, _utils.formatNumber)(pointData.min_area_cost) + ' ' + profile.user_region.country_currency_symbol + ' \u0437\u0430 \u043C\xB2\n                      </div>\n                    </div>' : '<div class="' + _Point2.default.soldOut + '">\u0412\u0441\u0435 \u043B\u043E\u0442\u044B \u043F\u0440\u043E\u0434\u0430\u043D\u044B</div>') + '\n                  </div>  \n                  <div class="' + _Point2.default.objectCount + '">\n                   \u0438 \u0435\u0449\u0435 ' + (pointCount - 1) + ' ' + (0, _utils.pluralize)(pointCount - 1, 'объект', 'объекта', 'объектов') + '\n                  </div>\n                </div>' : '<div  class="' + _Point2.default.iconContentLoading + '">\n                <span class="' + _Point2.default.loader + '"></span>\n              </div>' : '') + '\n          <div class="ClusterPoint" \n            style="display: flex; align-items: center; justify-content: center;\n            width: 34px; height: 34px; border: 3px solid #FFF; border-radius: 34px;\n            background-color: #085286; text-align: center; line-height: 28px;\n            font-size: 1.2rem; font-weight: 700; color: #FFF;\n            box-shadow: 0 0 0.2rem rgba(0,0,0,0.3); transition: all 0.25s ease-in-out;">\n            ' + pointCount + '\n          </div>\n        </div>'
	    },
	    onClick: onClick,
	    options: {
	      iconLayout: 'default#imageWithContent',
	      iconImageSize: [34, 34],
	      iconImageOffset: [-17, -17],
	      iconImageHref: _cluster2.default
	    }
	  });
	});
	
	exports.default = YClusterPoint;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactYandexMaps = __webpack_require__(278);
	
	var _warningSuccess = __webpack_require__(1588);
	
	var _warningSuccess2 = _interopRequireDefault(_warningSuccess);
	
	var _almostFinished = __webpack_require__(1584);
	
	var _almostFinished2 = _interopRequireDefault(_almostFinished);
	
	var _disabled = __webpack_require__(1586);
	
	var _disabled2 = _interopRequireDefault(_disabled);
	
	var _success = __webpack_require__(1587);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _Point = __webpack_require__(1468);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _objects = __webpack_require__(99);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Config = __webpack_require__(16);
	
	var _nonPhoto = __webpack_require__(350);
	
	var _nonPhoto2 = _interopRequireDefault(_nonPhoto);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var truncateString = function truncateString(str) {
	  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
	  return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
	};
	
	var getIcon = function getIcon(contexuality) {
	  if (contexuality === 'almostFinished') {
	    return _almostFinished2.default;
	  }
	
	  if (contexuality === 'success') {
	    return _success2.default;
	  }
	
	  if (contexuality === 'warningSuccess' || contexuality === 'warningActive') {
	    return _warningSuccess2.default;
	  }
	
	  return _disabled2.default;
	};
	
	var size = [20, 20];
	var activeSize = [26, 26];
	
	var YMapPoint = _react2.default.memo(function (_ref) {
	  var id = _ref.id,
	      lat = _ref.lat,
	      lng = _ref.lng,
	      _onClick = _ref.onClick,
	      contexuality = _ref.contexuality,
	      isActive = _ref.isActive;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var pointData = (0, _reactRedux.useSelector)(function (state) {
	    return state.objects.points[id];
	  });
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      hovered = _useState2[0],
	      setHovered = _useState2[1];
	
	  var handleMouseEnter = function handleMouseEnter() {
	    setHovered(true);
	    if (!pointData) {
	      dispatch((0, _objects.loadPoint)(id));
	    }
	  };
	
	  var handleMouseLeave = function handleMouseLeave() {
	    setHovered(false);
	  };
	
	  var imageUrl = pointData ? pointData.image ? _Config.ROOT_URL + '/image?id=' + pointData.image.id + '&size=small' : _nonPhoto2.default : '';
	
	  return _react2.default.createElement(_reactYandexMaps.Placemark, {
	    geometry: [+lat, +lng],
	    onClick: function onClick() {
	      return _onClick(id, pointData);
	    },
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    properties: {
	      iconContent: hovered ? pointData ? '\n                <div class="' + _Point2.default.iconContent + '">\n                  <div class="' + _Point2.default.header + '">\n                    <div class="' + _Point2.default.imageContainer + '">\n                      ' + (imageUrl ? '<img \n                              alt="house" \n                              class="' + _Point2.default.image + '" \n                              src="' + imageUrl + '"\n                            />' : '') + '\n                    </div>\n                    <div class="' + _Point2.default.headerInfo + '">\n                      <div class="' + _Point2.default.title + '">\n                        ' + (pointData && pointData.title ? truncateString(pointData.title, 23) : '') + '\n                      </div>\n                      <div class="' + _Point2.default.subtitle + '">\n                        ' + (pointData && pointData.address ? truncateString(pointData.address, 27) : '') + '\n                      </div>\n                      <div class="' + _Point2.default.labels + '">\n                      ' + (pointData.view_action ? '<div class="' + _Point2.default.promo + '">\u0410\u043A\u0446\u0438\u044F</div>' : '') + '\n                      ' + (pointData.status === 3 ? '<div class="' + _Point2.default.almostFinished + '">\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u0441\u0434\u0430\u043D</div>' : pointData.construction_finished ? '<div class="' + _Point2.default.finished + '">\u0421\u0434\u0430\u043D</div>' : '<div class="' + _Point2.default.endDate + '">\n                              ' + pointData.construction_ending + ' / ' + pointData.year_built + '\n                            </div>') + '\n                      </div>\n                    </div>\n                  </div>\n                  <div class="' + _Point2.default.footer + '">\n                    ' + (pointData.count_flats ? '\n                          <div class="' + _Point2.default.footerLeft + '">\n                            <div class="' + _Point2.default.flats + '">\n                              ' + pointData.count_flats + ' ' + (0, _utils.pluralize)(pointData.count_flats, 'Квартира', 'Квартиры', 'Квартир') + '\n                            </div>\n                            <div class="' + _Point2.default.areas + '">\n                              ' + pointData.min_square + ' \u043C\xB2 - ' + pointData.max_square + ' \u043C\xB2\n                            </div>\n                          </div>\n                          <div class="' + _Point2.default.footerRight + '">\n                            <div class="' + _Point2.default.priceFrom + '">\n                              \u041E\u0442 ' + (0, _utils.formatNumber)(pointData.cost_min) + ' ' + (pointData.country && pointData.country.country_currency_symbol || '') + '\n                            </div>\n                            <div class="' + _Point2.default.pricePerMeter + '">\n                              ' + (0, _utils.formatNumber)(pointData.min_area_cost) + ' ' + (pointData.country && pointData.country.country_currency_symbol || '') + ' \u0437\u0430 \u043C\xB2\n                            </div>\n                          </div>' : '<div class="' + _Point2.default.soldOut + '">\u0412\u0441\u0435 \u043B\u043E\u0442\u044B \u043F\u0440\u043E\u0434\u0430\u043D\u044B</div>') + '\n                  </div>\n                </div>' : '<div class="' + _Point2.default.iconContentLoading + '">\n                  <span class="' + _Point2.default.loader + '"></span>\n                </div>' : ''
	    },
	    options: {
	      iconLayout: 'default#imageWithContent',
	      iconImageSize: isActive ? activeSize : size,
	      iconImageOffset: isActive ? [-13, -13] : [-10, -10],
	      iconImageHref: getIcon(contexuality)
	    }
	  });
	});
	
	exports.default = YMapPoint;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _style = __webpack_require__(537);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _utils = __webpack_require__(12);
	
	var _favorites = __webpack_require__(160);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _CollectionsDialog = __webpack_require__(162);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _carouselArrowLeft = __webpack_require__(541);
	
	var _carouselArrowLeft2 = _interopRequireDefault(_carouselArrowLeft);
	
	var _iconClose = __webpack_require__(340);
	
	var _iconClose2 = _interopRequireDefault(_iconClose);
	
	var _iconHeart = __webpack_require__(342);
	
	var _iconHeart2 = _interopRequireDefault(_iconHeart);
	
	var _iconHeartActiveBlue = __webpack_require__(543);
	
	var _iconHeartActiveBlue2 = _interopRequireDefault(_iconHeartActiveBlue);
	
	var _bannerPlaceholder = __webpack_require__(173);
	
	var _bannerPlaceholder2 = _interopRequireDefault(_bannerPlaceholder);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _classnames2.default.bind(_style2.default);
	
	var addDefaultSrc = function addDefaultSrc(ev) {
	  ev.target.src = _bannerPlaceholder2.default;
	};
	
	var PlaceInfo = function (_Component) {
	  _inherits(PlaceInfo, _Component);
	
	  function PlaceInfo(props) {
	    _classCallCheck(this, PlaceInfo);
	
	    var _this = _possibleConstructorReturn(this, (PlaceInfo.__proto__ || Object.getPrototypeOf(PlaceInfo)).call(this, props));
	
	    _this.handleBigImageLoad = function (index) {
	      _this.setState(function (prevState) {
	        var newBigImageLoaded = [].concat(_toConsumableArray(prevState.bigImageLoaded));
	        newBigImageLoaded[index] = true;
	        return { bigImageLoaded: newBigImageLoaded };
	      });
	    };
	
	    _this.prevImage = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        var albums = _this.props.point.albums;
	
	        if (!albums || albums.length === 0) return { currentImageIndex: 0 };
	
	        return {
	          currentImageIndex: (prevState.currentImageIndex - 1 + albums.length) % albums.length
	        };
	      });
	    };
	
	    _this.nextImage = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        var albums = _this.props.point.albums;
	
	        if (!albums || albums.length === 0) return { currentImageIndex: 0 };
	
	        return {
	          currentImageIndex: (prevState.currentImageIndex + 1) % albums.length
	        };
	      });
	    };
	
	    _this.handleAddToCollectionClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      var _this$props = _this.props,
	          point = _this$props.point,
	          profile = _this$props.profile;
	      var buildingId = point.id,
	          buildingName = point.title;
	
	
	      _tracker2.default.sendEvent('Web_Add_To_Collection', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	
	      _this.props.setPopUp(_react2.default.createElement(_CollectionsDialog2.default, {
	        building: { data: _this.props.point },
	        profile: profile,
	        objectType: point.type_id === 1 ? 'zhk' : 'kp_i_th'
	      }), {
	        // closeClassName: styles.popupClose,
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    };
	
	    _this.handleAddToFavoritesClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      var point = _this.props.point;
	      var buildingId = point.id,
	          buildingName = point.title,
	          favorite = point.favorite;
	
	      var userUid = localStorage.getItem('public');
	
	      _tracker2.default.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	
	      _this.props[favorite ? 'removeFromFavorites' : 'addToFavorites']({ buildingId: buildingId, userUid: userUid }, { buildingName: buildingName, data: _this.props });
	    };
	
	    _this.handleClick = function () {
	      var point = _this.props.point;
	      var buildingId = point.id,
	          buildingName = point.title;
	
	
	      _tracker2.default.sendEvent('Web_Click', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	    };
	
	    _this.state = {
	      bigImageLoaded: [],
	      currentImageIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(PlaceInfo, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          point = _props.point,
	          style = _props.style,
	          infoType = _props.infoType;
	      var _state = this.state,
	          bigImageLoaded = _state.bigImageLoaded,
	          currentImageIndex = _state.currentImageIndex;
	
	
	      if (!point) {
	        return _react2.default.createElement(
	          'div',
	          { style: style, className: _style2.default.PlaceInfo },
	          _react2.default.createElement('div', { className: _style2.default.Loader })
	        );
	      }
	
	      var _props2 = this.props,
	          onClose = _props2.onClose,
	          t = _props2.t;
	      var title = point.title,
	          address = point.address,
	          albums = point.albums,
	          microregion = point.microregion,
	          favorite = point.favorite,
	          image = point.image,
	          flatsCount = point.count_flats,
	          costMin = point.cost_min,
	          minAreaCost = point.min_area_cost,
	          minSquare = point.min_square,
	          maxSquare = point.max_square,
	          construction_ending = point.construction_ending,
	          construction_finished = point.construction_finished,
	          year_built = point.year_built,
	          status = point.status,
	          view_action = point.view_action,
	          type_id = point.type_id,
	          country = point.country;
	
	
	      var hasMultipleImages = albums && albums.length > 1;
	      var currentImage = albums.length ? albums[currentImageIndex] : null;
	      var isBigImageLoaded = bigImageLoaded[currentImageIndex];
	
	      var currency = country.country_currency_symbol;
	
	      return _react2.default.createElement(
	        'a',
	        {
	          style: style,
	          onClick: this.handleClick,
	          className: cx(_style2.default.PlaceInfo, infoType === 'medium' ? _style2.default.Medium : null),
	          href: infoType !== 'medium' ? '/building/' + point.id : '/view/' + location.href.replace(/.*\//, '') + '/building/' + point.id,
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.Header, _defineProperty({}, _style2.default.WithoutPhoto, !image)) },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.ImageWrapper },
	            hasMultipleImages && _react2.default.createElement(
	              'button',
	              { className: _style2.default.PrevButton, onClick: this.prevImage },
	              _react2.default.createElement('img', { src: _carouselArrowLeft2.default, alt: 'Previous' })
	            ),
	            currentImage ? _react2.default.createElement(
	              _react.Fragment,
	              { key: currentImage ? currentImage.id : 'placeholder' },
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + currentImage.id + '&size=small',
	                alt: 'house',
	                className: (0, _classnames2.default)(_style2.default.SmallImage, _defineProperty({}, _style2.default.SmallImageHidden, isBigImageLoaded)),
	                onLoad: function onLoad() {
	                  return _this2.handleSmallImageLoad(currentImageIndex);
	                },
	                onError: addDefaultSrc
	              }),
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + currentImage.id + '&size=original',
	                alt: 'house',
	                className: (0, _classnames2.default)(_style2.default.BigImage, _defineProperty({}, _style2.default.BigImageVisible, isBigImageLoaded)),
	                onLoad: function onLoad() {
	                  return _this2.handleBigImageLoad(currentImageIndex);
	                },
	                onError: addDefaultSrc
	              })
	            ) : _react2.default.createElement('img', {
	              src: image ? _Config.ROOT_URL + '/image?id=' + image.name + '&size=original' : _bannerPlaceholder2.default,
	              alt: 'placeholder',
	              className: _style2.default.WithoutPhoto
	            }),
	            hasMultipleImages && _react2.default.createElement(
	              'button',
	              { className: _style2.default.NextButton, onClick: this.nextImage },
	              _react2.default.createElement('img', { src: _carouselArrowLeft2.default, alt: 'Next', style: { transform: 'rotate(180deg)' } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: _style2.default.Address },
	              microregion + ', ' + address
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              view_action ? _react2.default.createElement(
	                'span',
	                { className: _style2.default.PromoLabel },
	                t('components.common.yPlaceInfo.promo')
	              ) : null,
	              status == 3 ? _react2.default.createElement(
	                'span',
	                { className: _style2.default.AlmostFinished },
	                t('components.common.yPlaceInfo.almostFinished')
	              ) : _react2.default.createElement(
	                'span',
	                {
	                  className: construction_finished ? _style2.default.StatusTitle : _style2.default.StatusTitleNotFin
	                },
	                construction_finished ? t('components.common.yPlaceInfo.finished') : year_built !== 0 ? ' ' + construction_ending + ' / ' + (year_built !== '0' ? year_built : '') : t('components.common.yPlaceInfo.inProgress')
	              )
	            )
	          ),
	          _react2.default.createElement('img', { src: _iconClose2.default, alt: '', onClick: onClose, className: _style2.default.IconButton })
	        ),
	        flatsCount ? _react2.default.createElement(
	          'div',
	          { className: _style2.default.Flats },
	          status === 2 ? _react2.default.createElement(
	            'div',
	            { className: _style2.default.Stopped },
	            t('components.common.yPlaceInfo.promo')
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            infoType == 'medium' ? _react2.default.createElement(
	              'div',
	              { className: _style2.default.FlatsCount },
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                flatsCount,
	                ' ',
	                (0, _utils.pluralize)(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                flatsCount,
	                ' ',
	                (0, _utils.pluralize)(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                t('components.common.yPlaceInfo.square', { minSquare: minSquare, maxSquare: maxSquare })
	              )
	            )
	          ),
	          infoType == 'medium' ? _react2.default.createElement(
	            'div',
	            { className: _style2.default.FlatsPrices },
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              t('components.common.yPlaceInfo.costMin', {
	                costMin: (0, _utils.formatNumber)(costMin),
	                currency: currency
	              }) + ', ' + t('components.common.yPlaceInfo.minAreaCost', {
	                minAreaCost: (0, _utils.formatNumber)(minAreaCost),
	                currency: currency
	              })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              t('components.common.yPlaceInfo.costMin', {
	                costMin: (0, _utils.formatNumber)(costMin),
	                currency: currency
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('components.common.yPlaceInfo.minAreaCost', {
	                minAreaCost: (0, _utils.formatNumber)(minAreaCost),
	                currency: currency
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.Flats, _style2.default.SoldOut) },
	          status === 2 ? t('components.common.yPlaceInfo.stopped') : type_id == 2 ? t('components.common.yPlaceInfo.soldHouses') : t('components.common.yPlaceInfo.soldFlats')
	        ),
	        infoType !== 'medium' && _react2.default.createElement(
	          'div',
	          { className: _style2.default.Buttons },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_style2.default.Button, _style2.default.Favorites),
	              onClick: this.handleAddToFavoritesClick
	            },
	            _react2.default.createElement('img', { src: favorite ? _iconHeartActiveBlue2.default : _iconHeart2.default, alt: '' }),
	            favorite ? t('components.common.yPlaceInfo.inFavorite') : t('components.common.yPlaceInfo.addToFavorite')
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_style2.default.Button, _style2.default.Collections),
	              onClick: this.handleAddToCollectionClick
	            },
	            _react2.default.createElement(
	              'span',
	              { className: _style2.default.iconPlus },
	              _react2.default.createElement('i', null),
	              _react2.default.createElement('i', null)
	            ),
	            t('components.common.yPlaceInfo.addToCollection')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlaceInfo;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setPopUp: _environment.setPopUp, addToFavorites: _favorites.addToFavorites, removeFromFavorites: _favorites.removeFromFavorites })((0, _reactI18next.withTranslation)()(PlaceInfo));

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _style = __webpack_require__(537);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _utils = __webpack_require__(12);
	
	var _favorites = __webpack_require__(160);
	
	var _environment = __webpack_require__(19);
	
	var _Config = __webpack_require__(16);
	
	var _CollectionsDialog = __webpack_require__(162);
	
	var _CollectionsDialog2 = _interopRequireDefault(_CollectionsDialog);
	
	var _carouselArrowLeft = __webpack_require__(541);
	
	var _carouselArrowLeft2 = _interopRequireDefault(_carouselArrowLeft);
	
	var _iconHeart = __webpack_require__(342);
	
	var _iconHeart2 = _interopRequireDefault(_iconHeart);
	
	var _iconHeartActiveBlue = __webpack_require__(543);
	
	var _iconHeartActiveBlue2 = _interopRequireDefault(_iconHeartActiveBlue);
	
	var _bannerPlaceholder = __webpack_require__(173);
	
	var _bannerPlaceholder2 = _interopRequireDefault(_bannerPlaceholder);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _reactI18next = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _classnames2.default.bind(_style2.default);
	
	var addDefaultSrc = function addDefaultSrc(ev) {
	  ev.target.src = _bannerPlaceholder2.default;
	};
	
	var PlaceInfoList = function (_Component) {
	  _inherits(PlaceInfoList, _Component);
	
	  function PlaceInfoList(props) {
	    _classCallCheck(this, PlaceInfoList);
	
	    var _this = _possibleConstructorReturn(this, (PlaceInfoList.__proto__ || Object.getPrototypeOf(PlaceInfoList)).call(this, props));
	
	    _this.handleBigImageLoad = function (index) {
	      _this.setState(function (prevState) {
	        var newBigImageLoaded = [].concat(_toConsumableArray(prevState.bigImageLoaded));
	        newBigImageLoaded[index] = true;
	        return { bigImageLoaded: newBigImageLoaded };
	      });
	    };
	
	    _this.prevImage = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        var albums = _this.props.point.albums;
	
	        if (!albums || albums.length === 0) return { currentImageIndex: 0 };
	
	        return {
	          currentImageIndex: (prevState.currentImageIndex - 1 + albums.length) % albums.length
	        };
	      });
	    };
	
	    _this.nextImage = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        var albums = _this.props.point.albums;
	
	        if (!albums || albums.length === 0) return { currentImageIndex: 0 };
	
	        return {
	          currentImageIndex: (prevState.currentImageIndex + 1) % albums.length
	        };
	      });
	    };
	
	    _this.handleAddToCollectionClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      var _this$props = _this.props,
	          point = _this$props.point,
	          profile = _this$props.profile;
	      var buildingId = point.id,
	          buildingName = point.title;
	
	
	      _tracker2.default.sendEvent('Web_Add_To_Collection', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	
	      _this.props.setPopUp(_react2.default.createElement(_CollectionsDialog2.default, {
	        building: { data: _this.props.point },
	        profile: profile,
	        objectType: point.type_id === 1 ? 'zhk' : 'kp_i_th'
	      }), {
	        // closeClassName: styles.popupClose,
	        closeStyleName: 'Default',
	        contentStyleName: 'Default',
	        closeIcon: 'default',
	        lockScroll: false
	      });
	    };
	
	    _this.handleAddToFavoritesClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      var _this$props2 = _this.props,
	          point = _this$props2.point,
	          longLat = _this$props2.longLat;
	      var buildingId = point.id,
	          buildingName = point.title,
	          favorite = point.favorite;
	
	      var userUid = localStorage.getItem('public');
	
	      _tracker2.default.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	
	      _this.props[favorite ? 'removeFromFavorites' : 'addToFavorites']({ buildingId: buildingId, userUid: userUid, longLat: longLat }, { buildingName: buildingName, data: _this.props });
	    };
	
	    _this.handleClick = function () {
	      var point = _this.props.point;
	      var buildingId = point.id,
	          buildingName = point.title;
	
	
	      _tracker2.default.sendEvent('Web_Click', {
	        id: buildingId,
	        name: buildingName,
	        mode: 'map'
	      });
	    };
	
	    _this.state = {
	      bigImageLoaded: [],
	      currentImageIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(PlaceInfoList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          point = _props.point,
	          style = _props.style,
	          infoType = _props.infoType;
	      var _state = this.state,
	          bigImageLoaded = _state.bigImageLoaded,
	          currentImageIndex = _state.currentImageIndex;
	
	
	      if (!point) {
	        return _react2.default.createElement(
	          'div',
	          { style: style, className: _style2.default.PlaceInfo },
	          _react2.default.createElement('div', { className: _style2.default.Loader })
	        );
	      }
	
	      var _props2 = this.props,
	          t = _props2.t,
	          profile = _props2.profile;
	      var title = point.title,
	          address = point.address,
	          albums = point.albums,
	          favorite = point.favorite,
	          image = point.image,
	          flatsCount = point.count_flats,
	          costMin = point.cost_min,
	          minAreaCost = point.min_area_cost,
	          minSquare = point.min_square,
	          maxSquare = point.max_square,
	          construction_ending = point.construction_ending,
	          construction_finished = point.construction_finished,
	          year_built = point.year_built,
	          status = point.status,
	          view_action = point.view_action,
	          type_id = point.type_id,
	          country = point.country;
	
	
	      var hasMultipleImages = albums && albums.length > 1;
	      var currentImage = albums.length ? albums[currentImageIndex] : null;
	      var isBigImageLoaded = bigImageLoaded[currentImageIndex];
	
	      var currency = profile.user_region.country_currency_symbol;
	
	      return _react2.default.createElement(
	        'a',
	        {
	          style: style,
	          onClick: this.handleClick,
	          className: cx(_style2.default.PlaceInfo, infoType === 'medium' ? _style2.default.Medium : null),
	          href: infoType !== 'medium' ? '/building/' + point.id : '/view/' + location.href.replace(/.*\//, '') + '/building/' + point.id,
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_style2.default.Header, _defineProperty({}, _style2.default.WithoutPhoto, !image)),
	            style: { marginTop: 0, paddingTop: '16px' }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.ImageWrapper },
	            hasMultipleImages && _react2.default.createElement(
	              'button',
	              { className: _style2.default.PrevButton, onClick: this.prevImage },
	              _react2.default.createElement('img', { src: _carouselArrowLeft2.default, alt: 'Previous' })
	            ),
	            currentImage ? _react2.default.createElement(
	              _react.Fragment,
	              { key: currentImage ? currentImage.id : 'placeholder' },
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + currentImage.id + '&size=small',
	                alt: 'house',
	                className: (0, _classnames2.default)(_style2.default.SmallImage, _defineProperty({}, _style2.default.SmallImageHidden, isBigImageLoaded)),
	                onLoad: function onLoad() {
	                  return _this2.handleSmallImageLoad(currentImageIndex);
	                },
	                onError: addDefaultSrc
	              }),
	              _react2.default.createElement('img', {
	                src: _Config.ROOT_URL + '/image?id=' + currentImage.id + '&size=original',
	                alt: 'house',
	                className: (0, _classnames2.default)(_style2.default.BigImage, _defineProperty({}, _style2.default.BigImageVisible, isBigImageLoaded)),
	                onLoad: function onLoad() {
	                  return _this2.handleBigImageLoad(currentImageIndex);
	                },
	                onError: addDefaultSrc
	              })
	            ) : _react2.default.createElement('img', {
	              src: image ? _Config.ROOT_URL + '/image?id=' + image.name + '&size=original' : _bannerPlaceholder2.default,
	              alt: 'placeholder',
	              className: _style2.default.WithoutPhoto
	            }),
	            hasMultipleImages && _react2.default.createElement(
	              'button',
	              { className: _style2.default.NextButton, onClick: this.nextImage },
	              _react2.default.createElement('img', { src: _carouselArrowLeft2.default, alt: 'Next', style: { transform: 'rotate(180deg)' } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: _style2.default.Address },
	              '' + address
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              view_action ? _react2.default.createElement(
	                'span',
	                { className: _style2.default.PromoLabel },
	                t('components.common.yPlaceInfo.promo')
	              ) : null,
	              status == 3 ? _react2.default.createElement(
	                'span',
	                { className: _style2.default.AlmostFinished },
	                t('components.common.yPlaceInfo.almostFinished')
	              ) : _react2.default.createElement(
	                'span',
	                {
	                  className: construction_finished ? _style2.default.StatusTitle : _style2.default.StatusTitleNotFin
	                },
	                construction_finished ? t('components.common.yPlaceInfo.finished') : year_built !== 0 ? ' ' + construction_ending + ' / ' + (year_built !== '0' ? year_built : '') : t('components.common.yPlaceInfo.inProgress')
	              )
	            )
	          )
	        ),
	        flatsCount ? _react2.default.createElement(
	          'div',
	          { className: _style2.default.Flats },
	          status === 2 ? _react2.default.createElement(
	            'div',
	            { className: _style2.default.Stopped },
	            t('components.common.yPlaceInfo.promo')
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            infoType == 'medium' ? _react2.default.createElement(
	              'div',
	              { className: _style2.default.FlatsCount },
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                flatsCount,
	                ' ',
	                (0, _utils.pluralize)(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                flatsCount,
	                ' ',
	                (0, _utils.pluralize)(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                t('components.common.yPlaceInfo.square', { minSquare: minSquare, maxSquare: maxSquare })
	              )
	            )
	          ),
	          infoType == 'medium' ? _react2.default.createElement(
	            'div',
	            { className: _style2.default.FlatsPrices },
	            _react2.default.createElement(
	              'p',
	              null,
	              ' ',
	              t('components.common.yPlaceInfo.costMin', {
	                costMin: (0, _utils.formatNumber)(costMin),
	                currency: currency
	              }) + ', ' + t('components.common.yPlaceInfo.minAreaCost', {
	                minAreaCost: (0, _utils.formatNumber)(minAreaCost),
	                currency: currency
	              })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              t('components.common.yPlaceInfo.costMin', {
	                costMin: (0, _utils.formatNumber)(costMin),
	                currency: currency
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              t('components.common.yPlaceInfo.minAreaCost', {
	                minAreaCost: (0, _utils.formatNumber)(minAreaCost),
	                currency: currency
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_style2.default.Flats, _style2.default.SoldOut) },
	          status === 2 ? t('components.common.yPlaceInfo.stopped') : type_id == 2 ? t('components.common.yPlaceInfo.soldHouses') : t('components.common.yPlaceInfo.soldFlats')
	        ),
	        infoType !== 'medium' && _react2.default.createElement(
	          'div',
	          { className: _style2.default.Buttons },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_style2.default.Button, _style2.default.Favorites),
	              onClick: this.handleAddToFavoritesClick
	            },
	            _react2.default.createElement('img', { src: favorite ? _iconHeartActiveBlue2.default : _iconHeart2.default, alt: '' }),
	            favorite ? t('components.common.yPlaceInfo.inFavorite') : t('components.common.yPlaceInfo.addToFavorite')
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_style2.default.Button, _style2.default.Collections),
	              onClick: this.handleAddToCollectionClick
	            },
	            _react2.default.createElement(
	              'span',
	              { className: _style2.default.iconPlus },
	              _react2.default.createElement('i', null),
	              _react2.default.createElement('i', null)
	            ),
	            t('components.common.yPlaceInfo.addToCollection')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlaceInfoList;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: state.profile
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { setPopUp: _environment.setPopUp, addToFavorites: _favorites.addToFavorites, removeFromFavorites: _favorites.removeFromFavorites })((0, _reactI18next.withTranslation)()(PlaceInfoList));

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactYandexMaps = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YMap = _react2.default.memo(function (_ref) {
	  var instanceRef = _ref.instanceRef,
	      onLoad = _ref.onLoad,
	      options = _ref.options,
	      defaultOptions = _ref.defaultOptions,
	      defaultState = _ref.defaultState,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _reactYandexMaps.YMaps,
	    { query: { load: 'package.full', apikey: '1df3cd36-78ca-4ff8-be76-d4a72252e228' } },
	    _react2.default.createElement(
	      _reactYandexMaps.Map,
	      {
	        onLoad: onLoad,
	        instanceRef: instanceRef,
	        width: '100%',
	        height: '100%',
	        defaultState: defaultState,
	        options: options,
	        defaultOptions: defaultOptions
	      },
	      children
	    )
	  );
	});
	
	exports.default = YMap;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reselect = __webpack_require__(44);
	
	var _reactQuery = __webpack_require__(394);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _environment = __webpack_require__(19);
	
	var _App = __webpack_require__(1469);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactTooltip = __webpack_require__(129);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Header = __webpack_require__(1028);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Buildings = __webpack_require__(474);
	
	var _Buildings2 = _interopRequireDefault(_Buildings);
	
	var _Cotteges = __webpack_require__(985);
	
	var _Cotteges2 = _interopRequireDefault(_Cotteges);
	
	var _Favorites = __webpack_require__(987);
	
	var _Favorites2 = _interopRequireDefault(_Favorites);
	
	var _Collections = __webpack_require__(979);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Collection = __webpack_require__(975);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _ClientMap = __webpack_require__(973);
	
	var _ClientMap2 = _interopRequireDefault(_ClientMap);
	
	var _ClientCollection = __webpack_require__(971);
	
	var _ClientCollection2 = _interopRequireDefault(_ClientCollection);
	
	var _Profile = __webpack_require__(1070);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Company = __webpack_require__(1060);
	
	var _Company2 = _interopRequireDefault(_Company);
	
	var _ClientBuilding = __webpack_require__(1127);
	
	var _ClientBuilding2 = _interopRequireDefault(_ClientBuilding);
	
	var _PrintBuilding = __webpack_require__(1145);
	
	var _PrintBuilding2 = _interopRequireDefault(_PrintBuilding);
	
	var _Building = __webpack_require__(1125);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _Logout = __webpack_require__(1139);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	var _Login = __webpack_require__(1136);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _PopUp = __webpack_require__(1143);
	
	var _PopUp2 = _interopRequireDefault(_PopUp);
	
	var _FailPage = __webpack_require__(1043);
	
	var _FailPage2 = _interopRequireDefault(_FailPage);
	
	var _SuccessPage = __webpack_require__(1055);
	
	var _SuccessPage2 = _interopRequireDefault(_SuccessPage);
	
	var _Notification = __webpack_require__(1045);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _Notification3 = __webpack_require__(315);
	
	var _Notification4 = _interopRequireDefault(_Notification3);
	
	var _ObserveErrors = __webpack_require__(1041);
	
	var _ObserveErrors2 = _interopRequireDefault(_ObserveErrors);
	
	var _PublicOffer = __webpack_require__(1147);
	
	var _PublicOffer2 = _interopRequireDefault(_PublicOffer);
	
	var _Politika = __webpack_require__(1141);
	
	var _Politika2 = _interopRequireDefault(_Politika);
	
	var _Soglashenie = __webpack_require__(1153);
	
	var _Soglashenie2 = _interopRequireDefault(_Soglashenie);
	
	var _building = __webpack_require__(54);
	
	var _Support = __webpack_require__(1096);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _Rates = __webpack_require__(1151);
	
	var _Rates2 = _interopRequireDefault(_Rates);
	
	var _WebaskProvider = __webpack_require__(1155);
	
	var _ga = __webpack_require__(7);
	
	var _banner = __webpack_require__(898);
	
	var _PrivacyPolicy = __webpack_require__(1128);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
	
	var _UserAgreement = __webpack_require__(1129);
	
	var _UserAgreement2 = _interopRequireDefault(_UserAgreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  dispatch: _propTypes2.default.func.isRequired,
	  isMobile: _propTypes2.default.bool,
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  popUp: _propTypes2.default.object
	};
	
	var queryClient = new _reactQuery.QueryClient({
	  defaultOptions: {
	    queries: {
	      enabled: false,
	      retry: false,
	      refetchOnWindowFocus: false,
	      cacheTime: 0
	    }
	  }
	});
	
	var authenticatedSelector = function authenticatedSelector(state) {
	  return state.authentication.authenticated;
	};
	
	var NedvexRoute = function NedvexRoute(_ref) {
	  var component = _ref.component,
	      _ref$requireAuth = _ref.requireAuth,
	      requireAuth = _ref$requireAuth === undefined ? false : _ref$requireAuth,
	      rest = _objectWithoutProperties(_ref, ['component', 'requireAuth']);
	
	  var authenticated = (0, _reactRedux.useSelector)(function (state) {
	    return state.authentication.authenticated;
	  }, _reactRedux.shallowEqual);
	  var Component = component;
	
	  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
	    render: function render(matchProps) {
	      if (requireAuth && !authenticated) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
	      }
	
	      if (!requireAuth && authenticated) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	      }
	
	      return _react2.default.createElement(Component, matchProps);
	    }
	  }));
	};
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          location = _props.location;
	
	      (0, _ga.trackPageview)(window.location.pathname + window.location.search);
	      dispatch((0, _environment.initEnvironment)());
	
	      if (location.pathname !== '/login') {
	        dispatch((0, _building.getCities)());
	      }
	
	      dispatch((0, _banner.getBanner)());
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props2 = this.props,
	          dispatch = _props2.dispatch,
	          location = _props2.location;
	
	      if (location.pathname !== prevProps.location.pathname) {
	        (0, _ga.trackPageview)(location.pathname + location.search);
	
	        if (location.pathname !== '/login' && prevProps.location.pathname === '/login') {
	          dispatch((0, _building.getCities)());
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // TODO: Нужно бы List и Map подключать напрямую, не через Buildings
	      var _props3 = this.props,
	          dispatch = _props3.dispatch,
	          popUp = _props3.popUp,
	          popUpProps = _props3.popUpProps,
	          authenticated = _props3.authenticated,
	          profile = _props3.profile;
	
	
	      return _react2.default.createElement(
	        _reactQuery.QueryClientProvider,
	        { client: queryClient },
	        _react2.default.createElement(
	          _WebaskProvider.WebaskProvider,
	          { profile: profile },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_App2.default.Sticky, _defineProperty({}, _App2.default.hasHeader, authenticated && !location.href.includes('/rates')))
	            },
	            _react2.default.createElement(_Notification4.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: _App2.default.StickyInner },
	              _react2.default.createElement(_ObserveErrors2.default, null),
	              _react2.default.createElement(
	                _reactRouterDom.Switch,
	                null,
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/collection/view/:referal', component: _ClientCollection2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/view/:referal/building/:id', component: _ClientBuilding2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/bref/:referal', component: _ClientBuilding2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/ncollection/:base64/:id', component: _ClientBuilding2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/ncollection/:base64', component: _ClientCollection2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/nbref/:base64', component: _ClientBuilding2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/eula', component: _UserAgreement2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/policy', component: _PrivacyPolicy2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/rates', component: _Rates2.default }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _App2.default.StickyInnerInner },
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/', component: _Header2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/profile', component: _Profile2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/company', component: _Company2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/', exact: true, component: _Buildings2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/collections', component: _Collections2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/favorites', component: _Favorites2.default }),
	                  _react2.default.createElement(NedvexRoute, {
	                    requireAuth: true,
	                    path: '/collection/manage/:referal',
	                    component: _Collection2.default
	                  }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/print/:id', component: _PrintBuilding2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/building/:id', component: _Building2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/logout', component: _Logout2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: false, path: '/login', component: _Login2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: false, path: '/common', component: _Login2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/cottages', component: _Cotteges2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/pay/success', component: _SuccessPage2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/pay/fail', component: _FailPage2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/oferta', component: _PublicOffer2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/politika', component: _Politika2.default }),
	                  _react2.default.createElement(NedvexRoute, { requireAuth: true, path: '/soglashenie', component: _Soglashenie2.default })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactTooltip2.default, {
	                'class': _App2.default.Tooltip,
	                id: 'global',
	                effect: 'solid',
	                place: 'bottom',
	                type: 'dark',
	                delayShow: 300
	              })
	            ),
	            _react2.default.createElement(_Support2.default, null),
	            _react2.default.createElement(_Notification2.default, null)
	          ),
	          popUp ? _react2.default.createElement(_PopUp2.default, _extends({ content: popUp, dispatch: dispatch }, popUpProps)) : null
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = propTypes;
	
	var appSelector = (0, _reselect.createSelector)(authenticatedSelector, function (state) {
	  return state.environment.popUp;
	}, function (state) {
	  return state.environment.popUpProps;
	}, function (state) {
	  return state.search.request;
	}, function (state) {
	  return state.profile;
	}, function (authenticated, popUp, popUpProps, request, profile) {
	  return {
	    popUp: popUp,
	    popUpProps: popUpProps,
	    authenticated: authenticated,
	    request: request,
	    profile: profile
	  };
	});
	
	exports.default = (0, _reactRedux.connect)(appSelector)((0, _reactRouterDom.withRouter)(App));

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _building = __webpack_require__(54);
	
	var _Building = __webpack_require__(309);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Building = (_dec = (0, _withValidTrafic2.default)(), _dec(_class = function (_Component) {
	  _inherits(Building, _Component);
	
	  function Building() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Building);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Building.__proto__ || Object.getPrototypeOf(Building)).call.apply(_ref, [this].concat(args))), _this), _this.state = { loaded: false }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Building, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var _props = this.props,
	          loadBuilding = _props.loadBuilding,
	          params = _props.match.params;
	
	      loadBuilding(params.id);
	    }
	  }, {
	    key: 'UNSAFE_componentWillUpdate',
	    value: function UNSAFE_componentWillUpdate(nextProps) {
	      var _props2 = this.props,
	          loadBuilding = _props2.loadBuilding,
	          params = _props2.match.params;
	      var nextParams = nextProps.match.params;
	
	      if (!nextProps.building.isLoading && !this.state.loaded) {
	        this.setState({ loaded: true });
	      }
	      if (params.id !== nextParams.id) {
	        loadBuilding(nextParams.id);
	        document.body.scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          dispatch = _props3.dispatch,
	          building = _props3.building,
	          _props3$match = _props3.match,
	          params = _props3$match.params,
	          path = _props3$match.path,
	          match = _props3.match,
	          search = _props3.search;
	      // console.log(building, this.state);
	      // if (building.isLoading || !this.state.loaded) return null;
	
	      var isBuildingLoading = building.isLoading || !this.state.loaded;
	
	      return _react2.default.createElement(_reactRouterDom.Route, {
	        render: function render(matchProps) {
	          return _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: path + '/chess',
	              render: function render() {
	                return _react2.default.createElement(_Building2.default.Chess, _extends({}, matchProps, {
	                  dispatch: dispatch,
	                  match: match,
	                  params: params,
	                  search: search,
	                  building: building,
	                  isBuildingLoading: isBuildingLoading
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              render: function render() {
	                return _react2.default.createElement(_Building2.default.Main, _extends({}, matchProps, {
	                  dispatch: dispatch,
	                  match: match,
	                  params: params,
	                  building: building,
	                  withClient: _this2.props.privacy.withClient,
	                  isBuildingLoading: isBuildingLoading
	                }));
	              }
	            })
	          );
	        }
	      });
	    }
	  }]);
	
	  return Building;
	}(_react.Component)) || _class);
	
	
	var buildingSelector = (0, _reselect.createSelector)(function (state) {
	  return state.building;
	}, function (state) {
	  return state.privacy;
	}, function (state) {
	  return state.search;
	}, function (building, privacy, search) {
	  return { building: building, privacy: privacy, search: search };
	});
	
	exports.default = (0, _reactRedux.connect)(buildingSelector, { loadBuilding: _building.loadBuilding })(Building);

/***/ }),
/* 1125 */
[2402, 1124],
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _collections = __webpack_require__(49);
	
	var _Building = __webpack_require__(309);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _building = __webpack_require__(54);
	
	var _helper = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Building = function (_Component) {
	  _inherits(Building, _Component);
	
	  function Building() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Building);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Building.__proto__ || Object.getPrototypeOf(Building)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      params: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Building, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          loadCollectionBuilding = _props.loadCollectionBuilding,
	          loadRefBuilding = _props.loadRefBuilding,
	          loadBuilding = _props.loadBuilding,
	          params = _props.match.params;
	
	
	      if (params.base64) {
	        try {
	          (0, _helper.getParams)(params.base64).then(function (data) {
	            if (params.id) {
	              loadCollectionBuilding({
	                buildingId: params.id,
	                referal: data.r
	              });
	            } else {
	              loadRefBuilding({
	                selectionReferal: data.id
	              });
	            }
	          });
	        } catch (e) {
	          window.location = '/';
	        }
	      } else if (params.id) {
	        loadCollectionBuilding({
	          buildingId: params.id,
	          referal: params.referal
	        });
	      } else {
	        loadRefBuilding({
	          selectionReferal: params.referal
	        });
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillUpdate',
	    value: function UNSAFE_componentWillUpdate(nextProps) {
	      var _props2 = this.props,
	          loadCollectionBuilding = _props2.loadCollectionBuilding,
	          params = _props2.match.params;
	      var nextParams = nextProps.match.params;
	
	      if (params.id !== nextParams.id) {
	        loadCollectionBuilding(nextParams.id);
	        document.body.scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          buildingForGallery = _props3.buildingForGallery,
	          dispatch = _props3.dispatch,
	          building = _props3.building,
	          user = _props3.user,
	          selection = _props3.selection,
	          match = _props3.match,
	          params = _props3.match.params,
	          noPageExist = _props3.noPageExist;
	
	      return _react2.default.createElement(_reactRouterDom.Route, {
	        render: function render(matchProps) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, {
	              render: function render() {
	                return _react2.default.createElement(_Building2.default.Main, _extends({}, matchProps, {
	                  dispatch: dispatch,
	                  match: match,
	                  params: params,
	                  building: building,
	                  buildingForGallery: buildingForGallery,
	                  user: user,
	                  selection: selection,
	                  noPageExist: noPageExist,
	                  client: true
	                }));
	              }
	            })
	          );
	        }
	      });
	    }
	  }]);
	
	  return Building;
	}(_react.Component);
	
	var mapStateToProps = (0, _reselect.createSelector)(function (state) {
	  return state.building;
	}, function (state) {
	  return state.collection.building;
	}, function (state) {
	  return state.collection.user;
	}, function (state) {
	  return state.collection.selection;
	}, function (state) {
	  return state.collection.noPageExist;
	}, function (state) {
	  return state.building.data;
	}, function (buildingForGallery, building, user, selection, noPageExist, building2) {
	  return {
	    buildingForGallery: buildingForGallery,
	    building: {
	      data: building || building2
	    },
	    user: user,
	    selection: selection,
	    noPageExist: noPageExist
	  };
	});
	
	var mapDispatchToProps = {
	  loadCollectionBuilding: _collections.loadCollectionBuilding,
	  loadRefBuilding: _collections.loadRefBuilding,
	  loadBuilding: _building.loadBuilding
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Building);

/***/ }),
/* 1127 */
[2402, 1126],
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Landing = __webpack_require__(538);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPolicy = function PrivacyPolicy() {
	  return _react2.default.createElement(
	    'div',
	    { className: _Landing2.default.Landing },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\u041F\u041E\u041B\u0418\u0422\u0418\u041A\u0410 \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0418 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u042B\u0425 \u0414\u0410\u041D\u041D\u042B\u0425 (\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438)'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 (\u0434\u0430\u043B\u0435\u0435 \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u2013 \xAB\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\xBB) \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0444\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0437\u0430\u043A\u043E\u043D\u0430\u043C\u0438 \u0438 \u043F\u043E\u0434\u0437\u0430\u043A\u043E\u043D\u043D\u044B\u043C\u0438 \u0430\u043A\u0442\u0430\u043C\u0438 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u044E\u0449\u0438\u043C\u0438 \u0441\u043B\u0443\u0447\u0430\u0438 \u0438 \u043E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0442\u0430\u043A\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438. \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0442\u043E\u043C, \u043A\u0430\u043A NEDVEX \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0438 \u0437\u0430\u0449\u0438\u0442\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '1. \u041E\u0411\u0429\u0418\u0415 \u041F\u041E\u041B\u041E\u0416\u0415\u041D\u0418\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0432\u0441\u0435\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0432 \u043F\u043E\u043D\u0438\u043C\u0430\u043D\u0438\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\xBB), \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB (\u0434\u0430\u043B\u0435\u0435 \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 - \u0421\u0435\u0440\u0432\u0438\u0441) \u0438/\u0438\u043B\u0438 \u0435\u0433\u043E \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043B\u0438\u0446\u0430, \u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u0442 \u043B\u0438\u0446, \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u0434\u043B\u044F \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432 (\u0434\u0430\u043B\u0435\u0435 \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u2013 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C), \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0445\u043E\u0434\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB / \u0435\u0433\u043E \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438 \u043B\u044E\u0431\u044B\u0445 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439 \u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432, \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u043C\u043E\u0436\u0435\u0442 \u0442\u0430\u043A\u0436\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0442 \u0441\u0432\u043E\u0438\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B\xBB), \u0441\u0430\u0439\u0442\u043E\u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C, \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u0438\u043B\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0438 \u0438\u0437 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 \u0441 \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C, \u0438 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432 \u043C\u0435\u0436\u0434\u0443 \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u0438 \u043A\u0430\u0436\u0434\u044B\u043C \u0438\u0437 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.2. \u041F\u043E\u0434 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u043E\u0442 27.07.2006 \u0433. \u2116 152-\u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0438\u043B\u0438 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439, \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u043C\u044B\u0445 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u0431\u043E\u0440, \u0437\u0430\u043F\u0438\u0441\u044C, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E, \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435 (\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435), \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 (\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435, \u0434\u043E\u0441\u0442\u0443\u043F) \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435, \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.3. \u0414\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0435\u0441\u0442\u0432\u043E\u043C \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0439 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u044E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB, \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u043E\u0435 \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: 354207, \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433\u043E\u0440\u043E\u0434 \u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u0443\u043B. \u041B\u0435\u0442\u043D\u044F\u044F, \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 15/2, \u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441: 354000, \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433. \u0421\u043E\u0447\u0438, \u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0439\u043E\u043D, \u043F\u0435\u0440. \u041C\u043E\u0440\u0441\u043A\u043E\u0439, \u0434.1/1\u0430, \u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001, \u041E\u0413\u0420\u041D 1162366056830.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.4. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u043E\u0439 \u0447\u0430\u0441\u0442\u044C\u044E',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://app.nedvex.ru/eula' },
	        '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F'
	      ),
	      ', \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u0445 \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0435\u043C\u044B\u0445 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438 NEDVEX, \u043A\u043E\u0433\u0434\u0430 \u044D\u0442\u043E \u043F\u0440\u044F\u043C\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u0438\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.5. \u0414\u043B\u044F \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433 \u0421\u0435\u0440\u0432\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0434\u043E\u043F\u043E\u043B\u043D\u044F\u044E\u0449\u0438\u0435 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0443\u044E \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0443.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.6. \u0421\u0435\u0440\u0432\u0438\u0441 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0438 \u043D\u0435\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.7. \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0435 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.8. \u0411\u0438\u043E\u043C\u0435\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0435 \u0441\u043E\u0431\u0438\u0440\u0430\u044E\u0442\u0441\u044F \u0438 \u043D\u0435 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '2. \u0426\u0415\u041B\u042C \u041D\u0410\u0421\u0422\u041E\u042F\u0429\u0415\u0419 \u041F\u041E\u041B\u0418\u0422\u0418\u041A\u0418'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1. \u041F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443\u0435\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u043F\u0440\u0438\u043D\u0446\u0438\u043F\u0430\u043C\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1.1. \u0421\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u0435 \u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u043E\u043D\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1.2. \u0421\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u0435 \u0446\u0435\u043B\u0435\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u043C, \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u043F\u0440\u0438 \u0441\u0431\u043E\u0440\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1.3. \u041E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1.4. \u0421\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u043E\u0431\u044A\u0435\u043C\u0430 \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u0432 \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438, \u0446\u0435\u043B\u044F\u043C \u0441\u0443\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2. \u041F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443\u0435\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u043C\u0438 \u0430\u043A\u0442\u0430\u043C\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2.1. \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u044F \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2.2. \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2.3. \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0437\u0430\u043A\u043E\u043D \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u043E\u0442 27 \u0438\u044E\u043B\u044F 2006 \u0433. \u2116 152-\u0424\u0417;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2.4. \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E-\u043F\u0440\u0430\u0432\u043E\u0432\u044B\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u044B \u0438 \u0438\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u0440\u0430\u0437\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u044B\u0435 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2.5. \u0418\u043D\u044B\u0435 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0430\u043A\u0442\u044B \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0441\u0430\u043C\u043E\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0432\u043B\u0430\u0441\u0442\u0438 \u0420\u0424 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3. \u0425\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u043E\u043C \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u0430 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u043E\u0442 27.07.2006 \u2116 152-\u0424\u0417 \u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0425\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0441 \u0443\u0447\u0435\u0442\u043E\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u043A \u0441\u0440\u043E\u043A\u0430\u043C \u0438 \u043F\u043E\u0440\u044F\u0434\u043A\u0443 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u043A \u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u0424.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.4. \u0417\u0430\u0449\u0438\u0442\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0447\u0440\u0435\u0437\u0432\u044B\u0447\u0430\u0439\u043D\u043E \u0432\u0430\u0436\u043D\u044B \u0434\u043B\u044F \u041D\u0415\u0414\u0412\u0415\u041A\u0421. \u041F\u043E\u044D\u0442\u043E\u043C\u0443 \u043F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0437\u0430\u0449\u0438\u0449\u0430\u0435\u0442 \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0441\u0442\u0440\u043E\u0433\u043E\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.5. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439, \u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E \u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0443\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0430\u0441\u043F\u0435\u043A\u0442\u0430\u0445:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      { type: 'a' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0437\u0430\u0447\u0435\u043C \u0438 \u043A\u0430\u043A \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442 \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 (\xAB\u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\xBB) \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u0433\u0434\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043A\u0430\u043A\u043E\u0432\u0430 \u0440\u043E\u043B\u044C \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043A\u0430\u043A \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430, \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u044E\u0449\u0435\u0433\u043E \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043E \u0442\u043E\u043C, \u0437\u0430\u0447\u0435\u043C \u0438 \u043A\u0430\u043A \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043A\u0430\u043A\u0438\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u0435\u043C\u0430 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u043C\u043E\u0439 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043A\u0430\u043A\u043E\u0432\u044B \u043F\u0440\u0430\u0432\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043C\u043E\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '3. \u041F\u0415\u0420\u0415\u0427\u0415\u041D\u042C \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u0418 \u0421\u041E\u0411\u0418\u0420\u0410\u0415\u041C\u041E\u0419 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u041E \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u0415'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.1. \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u0441\u043E\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u0440\u0430\u0431\u043E\u0442\u044B \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043C\u043E\u0436\u0435\u0442 \u0440\u0430\u0437\u043B\u0438\u0447\u0430\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0438\u043C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0438\u043B\u0438 \u043D\u0435\u0442. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043D\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0443\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0441\u0443\u0434\u0438\u0442\u044C \u043E \u0435\u0435 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0441\u0442\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E \u0442\u043E\u043C, \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0439 \u043F\u0440\u0430\u0432\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C\u044E \u0434\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0438\u0437 \u0442\u043E\u0433\u043E, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0443\u044E \u0438 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0443\u044E \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u0442 \u0435\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.2. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0431\u0438\u0440\u0430\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      { type: 'i' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 (\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438), \u0442\u0430\u043A\u0430\u044F \u043A\u0430\u043A \u0438\u043C\u044F (\u0424\u0418\u041E), \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0430\u0434\u0440\u0435\u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u0434\u0440\u0443\u0433\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u043E\u043C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435\u0441\u044F \u0432 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445, \u043F\u0438\u0441\u044C\u043C\u0430\u0445, \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u0445 \u0438 \u0438\u043D\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0445'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 (HTTP-\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0438, IP-\u0430\u0434\u0440\u0435\u0441, \u0444\u0430\u0439\u043B\u044B cookie, \u0432\u0435\u0431-\u043C\u0430\u044F\u043A\u0438/\u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u044B\u0435 \u0442\u0435\u0433\u0438, \u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430, \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u043D\u043E\u043C \u0438 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u043C \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0438, \u0434\u0430\u043D\u043D\u044B\u0435 \u0441\u0435\u0442\u0438 wi-fi);'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0412\u0430\u0448\u0435\u0439 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0438\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432, \u0434\u0430\u043D\u043D\u044B\u0435 \u043E \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0434\u0430\u043D\u043D\u044B\u0435 \u043E \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0430\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0442\u0435\u043D\u0438\u044F;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0433\u0435\u043E\u043B\u043E\u043A\u0430\u0446\u0438\u0438;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430\u044F \u0434\u043B\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043E\u0442 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439, \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C, \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439, \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u043C\u0435\u0436\u0434\u0443 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0445 \u043A\u0430\u0440\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0438\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u0430\u044F \u043E\u0442 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432 \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u043B\u0438\u0446, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0422\u0430\u043A\u0436\u0435 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0444\u0430\u0439\u043B\u044B cookie \u0438 \u0432\u0435\u0431-\u043C\u0430\u044F\u043A\u0438 (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u044B\u0435 \u0442\u0435\u0433\u0438) \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u0441\u0432\u044F\u0437\u044B\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u043E\u0439 \u043B\u0438\u0447\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u043C \u0438 \u0432\u0435\u0431-\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u043E\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.3. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043D\u0435 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0435 \u0441 \u0446\u0435\u043B\u044C\u044E \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \xAB\u043F\u043E\u0440\u0442\u0440\u0435\u0442\u0430\xBB \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0442\u043E\u0439 \u0441\u0442\u0435\u043F\u0435\u043D\u0438, \u043F\u0440\u0438 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u043F\u043E\u0432\u043B\u0438\u044F\u0442\u044C \u043D\u0430 \u043F\u0440\u0430\u0432\u0430 \u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '4. \u0426\u0415\u041B\u0418 \u0418 \u041F\u0420\u0410\u0412\u041E\u0412\u042B\u0415 \u041E\u0421\u041D\u041E\u0412\u0410\u041D\u0418\u042F \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0418 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u041E\u0419 \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u0418 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.1. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0431\u0435\u0437 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u044B\u0445 \u043D\u0430 \u0442\u043E \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u0445 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0439. \u041F\u043E\u044D\u0442\u043E\u043C\u0443 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0442\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      { type: 'i' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u041D\u0415\u0414\u0412\u0415\u041A\u0421,'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0434\u043B\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043A\u043E\u0433\u0434\u0430 \u044D\u0442\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C, \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043D\u0435 \u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0432\u043B\u0438\u044F\u043D\u0438\u044F \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0435\u0433\u043E \u0444\u0443\u043D\u0434\u0430\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u044B. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043F\u0440\u043E\u0441\u0438\u0442 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0447\u0442\u043E \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438, \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0441\u0442\u0440\u0435\u043C\u0438\u0442\u044C\u0441\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441 \u043C\u0435\u0436\u0434\u0443 \u0441\u0432\u043E\u0438\u043C\u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u043C\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u043C\u0438 \u0438 \u0437\u0430\u0449\u0438\u0442\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        '\u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0432\u043E\u0438\u0445 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445:',
	        _react2.default.createElement(
	          'ol',
	          { type: 'a' },
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u0414\u043B\u044F \u043F\u043E\u043D\u0438\u043C\u0430\u043D\u0438\u044F, \u043A\u0430\u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442\u0435 \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C;'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u0421 \u0446\u0435\u043B\u044C\u044E \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u0441\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u0438\u043D\u043E\u0433\u043E \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u0445 \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439;'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u0414\u043B\u044F \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u044B \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435, \u0438\u0441\u0445\u043E\u0434\u044F \u0438\u0437 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043C\u043E\u0433\u0443\u0442 \u0437\u0430\u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F (\u0442. \u0435. \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0440\u0435\u043A\u043B\u0430\u043C\u0443, \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0449\u0443\u044E \u0435\u0433\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u044B);'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0434\u043B\u044F \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0445 \u0446\u0435\u043B\u0435\u0439, \u043B\u0438\u0431\u043E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u0443\u0435\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442, \u0447\u0442\u043E \u0443 \u043D\u0435\u0433\u043E \u043D\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043A\u0430\u043A\u043E\u0439-\u043B\u0438\u0431\u043E \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0438 \u0442\u0430\u043A\u043E\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u043E \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0439 \u0432\u043E\u043B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u0412\u043C\u0435\u0441\u0442\u0435 \u0441 \u0442\u0435\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u043E\u0437\u043D\u0430\u0435\u0442, \u0447\u0442\u043E \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C, \u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0431\u0443\u0434\u0435\u0442 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E \u0438/\u0438\u043B\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0446\u0435\u043B\u0435\u0439:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      { type: 'i' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043A \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0432\u044F\u0437\u0438 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u043B\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439, \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043E\u0442\u043D\u043E\u0441\u044F\u0449\u0435\u0439\u0441\u044F \u043A \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0439 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u0438 \u0437\u0430\u044F\u0432\u043E\u043A \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u044B \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0441 \u0443\u0447\u0435\u0442\u043E\u043C \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0442\u0435\u043D\u0438\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u043F\u043E\u0438\u0441\u043A\u0430 \u0438 \u0434\u0440\u0443\u0433\u043E\u0439 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439 \u041D\u0415\u0414\u0412\u0415\u041A\u0421;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u0435 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0434\u043B\u044F \u043F\u043E\u043A\u0430\u0437\u0430 \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0440\u0435\u043B\u0435\u0432\u0430\u043D\u0442\u043D\u044B\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E\u0438\u0441\u043A\u0430 \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0431\u043E\u043B\u0435\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u043B\u044F \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432, \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432 \u041D\u0415\u0414\u0412\u0415\u041A\u0421;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u044B\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432, \u0443\u0442\u0438\u043B\u0438\u0442 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u041D\u0415\u0414\u0412\u0415\u041A\u0421;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0437\u0430\u0449\u0438\u0442\u0430 \u043F\u0440\u0430\u0432 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043F\u0440\u0430\u0432 \u041D\u0415\u0414\u0412\u0415\u041A\u0421;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0441\u0431\u043E\u0440, \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0431\u043E\u043B\u044C\u0448\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0432\u044B\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0433\u0440\u043E\u0437 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438/\u0438\u043B\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u0440\u0438\u0435\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0442\u043E\u0432\u0430\u0440\u043E\u0432 \u0438 \u0443\u0441\u043B\u0443\u0433 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3. \u0412 \u0441\u043E\u0441\u0442\u0430\u0432 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0435\u0435 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432 \u0432\u0445\u043E\u0434\u0438\u0442 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u2013 \u042F\u043D\u0434\u0435\u043A\u0441. \u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u0438 Google Analytics (\u0434\u0430\u043B\u0435\u0435 \u2013 \xAB\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\xBB). \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0433\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u044B \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://yandex.ru/legal/metrica_termsofuse/' },
	        'https://yandex.ru/legal/metrica_termsofuse/'
	      ),
	      ' ',
	      '\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://support.google.com/analytics/answer/4597324?hl=ru' },
	        'https://support.google.com/analytics/answer/4597324?hl=ru'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '5. \u0417\u0410\u0429\u0418\u0422\u0410 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u041E\u0419 \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u0418 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1. \u0412 \u0431\u043E\u043B\u044C\u0448\u0438\u043D\u0441\u0442\u0432\u0435 \u0441\u043B\u0443\u0447\u0430\u0435\u0432 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0431\u0435\u0437 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0435\u0439 \u043A\u043E\u0433\u043E-\u043B\u0438\u0431\u043E \u0438\u0437 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u041D\u0415\u0414\u0412\u0415\u041A\u0421. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F, \u0442\u043E \u043E\u043D \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u0435\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0443\u0436\u0434\u0430\u044E\u0442\u0441\u044F \u0432 \u044D\u0442\u043E\u043C \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0441\u0432\u043E\u0438\u0445 \u0437\u0430\u0434\u0430\u0447. \u0414\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u044B \u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0441\u0435 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438. \u041E\u043D\u0438 \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u043B\u0436\u043D\u044B \u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435\u043C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u043C \u043C\u0435\u0440\u0430\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0434\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u044B \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0442\u0430\u043A\u0436\u0435 \u0432\u043D\u0435\u0434\u0440\u0438\u043B \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u044B\u0435 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u043C\u0435\u0440\u044B \u0434\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u044B \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0442 \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E, \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u043E\u0433\u043E \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u044F, \u043F\u043E\u0442\u0435\u0440\u0438, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u043D\u0435\u0434\u043E\u0431\u0440\u043E\u0441\u043E\u0432\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0438\u043B\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u0445 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0444\u043E\u0440\u043C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438. \u0414\u0430\u043D\u043D\u044B\u0435 \u043C\u0435\u0440\u044B \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0431\u044B\u043B\u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u044B \u0441 \u0443\u0447\u0435\u0442\u043E\u043C \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438, \u0440\u0438\u0441\u043A\u043E\u0432, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u043E\u043C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '6. \u0414\u041E\u0421\u0422\u0423\u041F \u041A \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u041E\u0419 \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u0418 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F \u0418 \u0415\u0415 \u041F\u0415\u0420\u0415\u0414\u0410\u0427\u0410'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.1. \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u041D\u0415\u0414\u0412\u0415\u041A\u0421',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0432\u043E\u0438\u043C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C (\u0432 \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439). \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0432\u043E\u0438\u043C \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043B\u0438\u0446\u0430\u043C.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0415\u0441\u043B\u0438 \u0438\u043D\u043E\u0435 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u0432\u043E \u0432\u0441\u0435\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439, \u0438\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 4 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.2. \u0412\u043D\u0435 \u041D\u0415\u0414\u0412\u0415\u041A\u0421',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0446\u0435\u043B\u0435\u0439, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 5 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041A \u0442\u0430\u043A\u0438\u043C \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u044C\u0441\u044F:',
	      _react2.default.createElement(
	        'ol',
	        { type: 'i' },
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B, \u0442\u0430\u043A\u0438\u0435 \u043A\u0430\u043A \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0441\u0430\u0439\u0442\u043E\u0432 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439, \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u0435 \u0441\u0435\u0442\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0435 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0443\u0441\u043B\u0443\u0433\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u043C \u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043C \u0440\u0435\u043A\u043B\u0430\u043C\u044B \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u0442\u0430\u043A\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C \u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0438\u043C\u0438;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0440\u0435\u043A\u043B\u0430\u043C\u043E\u0434\u0430\u0442\u0435\u043B\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442 \u0434\u043B\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u0443 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u043B\u0438\u0446\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0434\u043B\u044F \u0432\u044B\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438/\u0438\u043B\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u043B\u0438\u0446\u0430, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0438\u0435\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 (\u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u044B, \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0445 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432, \u0431\u0430\u043D\u043A\u0438 \u0438 \u0438\u043D\u044B\u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0442.\u0434.).'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.3. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C:',
	      _react2.default.createElement(
	        'ol',
	        { type: 'i' },
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0430 \u0443\u0441\u0442\u0443\u043F\u043A\u0430 \u043F\u0440\u0430\u0432 \u0438\u043B\u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0435\u0439 \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u0438\u043B\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u044E\u0442 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0438\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C \u043D\u0430\u0434 \u043B\u0438\u0446\u0430\u043C\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u044B, \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0445 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u044F (\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446, \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430, \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 \u0438 \u0438\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C);'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u043B\u044E\u0431\u043E\u043C\u0443 \u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0438/\u0438\u043B\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u043C\u0443 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0435\u043C\u0443 \u043E\u0440\u0433\u0430\u043D\u0443, \u043F\u0440\u0430\u0432\u043E\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C, \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u0438\u043B\u0438 \u043C\u0435\u0441\u0442\u043D\u044B\u043C \u0438\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C \u0432\u043B\u0430\u0441\u0442\u0438, \u0434\u0440\u0443\u0433\u0438\u043C \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u043C \u0438\u043B\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C \u0438\u043B\u0438 \u0441\u0443\u0434\u0430\u043C, \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u044F\u0437\u0430\u043D \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u043F\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u044B\u0440\u0430\u0437\u0438\u043B \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0441\u0432\u043E\u0435\u0439 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043B\u0438\u0431\u043E \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430, \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u043B\u044E\u0431\u043E\u043C\u0443 \u0442\u0440\u0435\u0442\u044C\u0435\u043C\u0443 \u043B\u0438\u0446\u0443 \u0432 \u0446\u0435\u043B\u044F\u0445 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0432\u043E\u0432\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u044B \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u043B\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446 \u043F\u0440\u0438 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438, \u043B\u0438\u0431\u043E \u0432 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0438, \u043A\u043E\u0433\u0434\u0430 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0443\u0433\u0440\u043E\u0437\u0430 \u0442\u0430\u043A\u043E\u0433\u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '7. \u041F\u041E\u0420\u042F\u0414\u041E\u041A \u0425\u0420\u0410\u041D\u0415\u041D\u0418\u042F \u0418 \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0418 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u041E\u0419 \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u0418 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '7.1. \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0441\u044F \u0432 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '7.2. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u044C, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E, \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435 (\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435), \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445, \u043D\u0430\u0445\u043E\u0434\u044F\u0449\u0438\u0445\u0441\u044F \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '8. \u041A\u0410\u041A \u0414\u041E\u041B\u0413\u041E \u0421\u0415\u0420\u0412\u0418\u0421 \u0425\u0420\u0410\u041D\u0418\u0422 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u0423\u042E \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u042E \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.1. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0445\u0440\u0430\u043D\u0438\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438, \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u044D\u0442\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0446\u0435\u043B\u0438, \u0434\u043B\u044F \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0441\u043E\u0431\u0440\u0430\u043D\u0430, \u0438\u043B\u0438 \u0434\u043B\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u0445 \u0430\u043A\u0442\u043E\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.2. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0445\u043E\u0447\u0435\u0442, \u0447\u0442\u043E\u0431\u044B \u043A\u0430\u043A\u0430\u044F-\u043B\u0438\u0431\u043E \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0431\u0430\u0437 \u0434\u0430\u043D\u043D\u044B\u0445 \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0447\u0435\u0440\u0435\u0437 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 (\u0433\u0434\u0435 \u044D\u0442\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E).'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '9. \u041F\u0420\u0410\u0412\u0410 \u0418 \u041E\u0411\u042F\u0417\u0410\u041D\u041D\u041E\u0421\u0422\u0418 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.1. \u041A\u0430\u043A\u0438\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438 \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u044D\u0442\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0435\u0439 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u043E\u0439 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u0447\u0438\u0442\u0430\u0435\u0442, \u0447\u0442\u043E \u043A\u0430\u043A\u0430\u044F-\u043B\u0438\u0431\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0445\u0440\u0430\u043D\u0438\u0442 \u043E \u043D\u0435\u043C, \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0438\u043B\u0438 \u043D\u0435\u043F\u043E\u043B\u043D\u0430\u044F, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0432\u043E\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0438 \u0438\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0415\u0441\u043B\u0438 \u044D\u0442\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442\u0435 \u043F\u0440\u0430\u0432\u043E:',
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0445\u0440\u0430\u043D\u0438\u0442 \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u0435\u0435 \u0447\u0430\u0441\u0442\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0442\u0437\u044B\u0432\u0430\u0442\u044C \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0432\u043E\u0437\u0440\u0430\u0436\u0430\u0442\u044C \u043F\u0440\u043E\u0442\u0438\u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0435\u0441\u043B\u0438 \u044D\u0442\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.'
	        )
	      ),
	      '\u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0412 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442\u0435 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u043B\u0430\u0434\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438, \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C\u0438 \u0432\u044B\u0448\u0435.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F c \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0432\u044B\u0440\u0430\u0436\u0430\u044E\u0449\u0435\u0433\u043E \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u0443\u044E \u0432\u043E\u043B\u044E \u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, (\u0432 \u0447\u0430\u0441\u0442\u043D\u043E\u0441\u0442\u0438, \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u041D\u0415\u0414\u0412\u0415\u041A\u0421) \u0438 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u044C\u044E \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u0443.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.2. \u041E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F',
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u0421\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0434\u043B\u044F \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0432 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u0438/\u0438\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u044F\u0445'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.3 \u041A\u0430\u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0438 \u043F\u0440\u0430\u0432\u0430',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0414\u043B\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0430\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0432\u043E\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0430 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u044F \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u0432 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0435 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u041D\u0415\u0414\u0412\u0415\u041A\u0421.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0435\u043D \u0442\u0435\u043C, \u043A\u0430\u043A \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u0430 \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0432 \u0441\u0432\u043E\u044E \u043E\u0447\u0435\u0440\u0435\u0434\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442 \u0432 \u0440\u0430\u0437\u0443\u043C\u043D\u044B\u0435 \u0441\u0440\u043E\u043A\u0438. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0435\u043D \u043E\u0442\u0432\u0435\u0442\u043E\u043C \u041D\u0415\u0414\u0412\u0415\u041A\u0421, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u0430\u0442\u044C \u0436\u0430\u043B\u043E\u0431\u0443 \u0432 \u043A\u043E\u043C\u043F\u0435\u0442\u0435\u043D\u0442\u043D\u044B\u0439 \u043E\u0440\u0433\u0430\u043D.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '10. \u041E\u0411\u041D\u041E\u0412\u041B\u0415\u041D\u0418\u0415 \u041D\u0410\u0421\u0422\u041E\u042F\u0429\u0415\u0419 \u041F\u041E\u041B\u0418\u0422\u0418\u041A\u0418'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.1. \u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0443\u044E \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0443 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0432\u043D\u0435\u0441\u0435\u043D\u044B \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435, \u043D\u043E \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044F\u0441\u044C, \u0432 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u043A\u043E\u0433\u0434\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0432\u044F\u0437\u0430\u043D\u044B \u0441 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C\u0438 \u0432 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043A\u043E\u0433\u0434\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0432\u044F\u0437\u0430\u043D\u044B \u0441 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C\u0438 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.2. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435 \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439, \u043D\u0435 \u043D\u0430\u043B\u0430\u0433\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043E\u0431\u0440\u0435\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0438\u043B\u0438 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u0430\u0432 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u0431\u0435\u0437 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0431\u0443\u0434\u0443\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u044B \u043E \u0442\u0430\u043A\u0438\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0445. \u0421\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044B \u0421\u0435\u0440\u0432\u0438\u0441\u0435 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0447\u0435\u0440\u0435\u0437 \u0432\u0441\u043F\u043B\u044B\u0432\u0430\u044E\u0449\u0435\u0435 \u043E\u043A\u043D\u043E \u0438\u043B\u0438 \u0431\u0430\u043D\u043D\u0435\u0440) \u0434\u043E \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0442\u0430\u043A\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u0441\u0438\u043B\u0443, \u0438\u043B\u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E \u0434\u0440\u0443\u0433\u0438\u043C \u043A\u0430\u043D\u0430\u043B\u0430\u043C \u0441\u0432\u044F\u0437\u0438 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435, \u0435\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435).'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '11. \u0417\u0410\u041A\u041B\u042E\u0427\u0418\u0422\u0415\u041B\u042C\u041D\u042B\u0415 \u041F\u041E\u041B\u041E\u0416\u0415\u041D\u0418\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.1. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043F\u043E\u0434\u043B\u0435\u0436\u0438\u0442 \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u0424, \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0435\u0433\u043E \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.2. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u043F\u043E \u0442\u0435\u043C \u0438\u043B\u0438 \u0438\u043D\u044B\u043C \u043F\u0440\u0438\u0447\u0438\u043D\u0430\u043C \u043E\u0434\u043D\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u041F\u0440\u0430\u0432\u0438\u043B \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u044B \u0441\u0443\u0434\u043E\u043C \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0438\u043B\u0438 \u043D\u0435 \u0438\u043C\u0435\u044E\u0449\u0438\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0441\u0438\u043B\u044B, \u044D\u0442\u043E \u043D\u0435 \u0432\u043B\u0435\u0447\u0435\u0442 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.3. \u041D\u0415\u0414\u0412\u0415\u041A\u0421 \u043F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u043A\u0430\u0441\u0430\u044E\u0449\u0438\u0435\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0441\u044F \u0441 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u043C \u043A\u0430\u0441\u0430\u0435\u043C\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C\u0443 \u043D\u0438\u0436\u0435. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u044D\u0442\u0438\u043C \u0430\u0434\u0440\u0435\u0441\u043E\u043C \u0434\u043B\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043E \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432 \u0438\u043B\u0438 \u0436\u0430\u043B\u043E\u0431 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0441\u0442\u0438 \u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u043E\u0441\u0442\u0438 \u0435\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u0418\u041D\u041D 2318043183'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'E-mail: content@nedvex.ru'
	    )
	  );
	};
	
	exports.default = PrivacyPolicy;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Landing = __webpack_require__(538);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserAgreement = function UserAgreement() {
	  return _react2.default.createElement(
	    'div',
	    { className: _Landing2.default.Landing },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042C\u0421\u041A\u041E\u0415 \u0421\u041E\u0413\u041B\u0410\u0428\u0415\u041D\u0418\u0415'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB (\u0418\u041D\u041D: 2318043183 \u041E\u0413\u0420\u041D: 1162366056830) \u0432 \u043B\u0438\u0446\u0435 \u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0425\u043B\u0443\u0434\u043D\u0435\u0432\u043E\u0439 \u042E\u043B\u0438\u0438 \u0410\u0440\u0442\u0443\u0440\u043E\u0432\u043D\u044B, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430 (\u0434\u0430\u043B\u0435\u0435 \u2013 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C) \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u043B\u044E\u0431\u043E\u043C\u0443 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u043C\u0443 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0446\u0443, \u0438 (\u0438\u043B\u0438) \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044E, \u0438 (\u0438\u043B\u0438) \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0446\u0443 (\u0434\u0430\u043B\u0435\u0435 \u2013 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E), \u043F\u0440\u0430\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432 NEDVEX.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u043E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 \u0438 \u043D\u0435 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041E\u0431\u044A\u0435\u043C \u0412\u0430\u0448\u0438\u0445 \u043F\u0440\u0430\u0432 (\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439) \u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432 NEDVEX \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0430\u043A\u0446\u0435\u043F\u0442\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0422\u0430\u0440\u0438\u0444\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0430\u0442\u044C\u0435\u0439 438 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0434\u0435\u043A\u0441\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 (\u0413\u041A \u0420\u0424), \u0431\u0435\u0437\u0443\u0441\u043B\u043E\u0432\u043D\u044B\u043C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435\u043C (\u0430\u043A\u0446\u0435\u043F\u0442\u043E\u043C) \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u043F\u0443\u0442\u0435\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0438 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u0444\u0435\u0440\u0442\u0430, \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0435\u043C\u0430\u044F \u043F\u0443\u0442\u0435\u043C \u0430\u043A\u0446\u0435\u043F\u0442\u0430, \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0433\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0432\u0441\u0435 \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      '\u0421\u0422\u041E\u0420\u041E\u041D\u042B \u0417\u0410\u041A\u041B\u042E\u0427\u0410\u042E\u0422 \u041F\u0423\u0411\u041B\u0418\u0427\u041D\u0423\u042E \u041E\u0424\u0415\u0420\u0422\u0423 \u041D\u0410 \u0421\u041B\u0415\u0414\u0423\u042E\u0429\u0418\u0425 \u0423\u0421\u041B\u041E\u0412\u0418\u042F\u0425:'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '1. \u0422\u0435\u0440\u043C\u0438\u043D\u044B \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1. \u0412 \u0446\u0435\u043B\u044F\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u0442\u0435\u0440\u043C\u0438\u043D\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.1. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0421\u0430\u0439\u0442 Nedvex (\u0438\u043B\u0438 \u0441\u0430\u0439\u0442) '
	      ),
	      '\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0432 \u0441\u0435\u0442\u0438 \xAB\u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442\xBB \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0432\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u043E \u0432\u043E\u0441\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u043C\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C \u043A \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E-\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u043C \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438): https://app.nedvex.ru/, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u0441\u0435 \u0443\u0440\u043E\u0432\u043D\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0434\u043E\u043C\u0435\u043D\u043E\u0432, \u043A\u0430\u043A \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043D\u0430 \u0434\u0430\u0442\u0443 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0442\u0430\u043A \u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0435\u043C\u044B\u0445 \u0438 \u0432\u0432\u043E\u0434\u0438\u043C\u044B\u0445 \u0432 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u044E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0432\u0441\u0435\u0433\u043E \u0441\u0440\u043E\u043A\u0430 \u0435\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.2. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX (\u0438\u043B\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C/\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F) '
	      ),
	      '\u2013 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432 \u043E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u043A\u043E\u043C\u0430\u043D\u0434, \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u042D\u0412\u041C \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0432\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u043E \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432 \u0432\u0438\u0434\u0435 \u0432\u043D\u0435\u0448\u043D\u0438\u0445 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u043E\u0432, \u0432 \u0446\u0435\u043B\u044F\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0411\u0430\u0437\u043E\u0439 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438\u043D\u044B\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u043A\u043E\u043C\u0430\u043D\u0434 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0438\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C, \u0432 \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u0445 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C. \u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u0424 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B \u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0432 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043B\u0443\u0436\u0431\u0435 \u043F\u043E \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (\u0420\u043E\u0441\u043F\u0430\u0442\u0435\u043D\u0442\u0435).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.3. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX (\u0438\u043B\u0438 \u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445) '
	      ),
	      '\u2013 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0432 \u043E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0445 \u0438 \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u043E\u0431 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0433\u043E \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0430\u044F\u0441\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0442\u0430\u043A\u0438\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C, \u0447\u0442\u043E \u044D\u0442\u0438 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043D\u0430\u0439\u0434\u0435\u043D\u044B \u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u042D\u0412\u041C. \u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0411\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u0424 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B \u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0432 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043B\u0443\u0436\u0431\u0435 \u043F\u043E \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (\u0420\u043E\u0441\u043F\u0430\u0442\u0435\u043D\u0442\u0435).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.4. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0421\u0435\u0440\u0432\u0438\u0441 (\u0421\u0435\u0440\u0432\u0438\u0441\u044B NEDVEX) '
	      ),
	      '\u2013 \u0440\u0435\u0441\u0443\u0440\u0441, \u0441\u043E\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0438\u0437 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u0438 (\u0430) \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX, (\u0431) \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0438 (\u0432) \u0421\u0430\u0439\u0442\u0430 Nedvex.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.5. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C '
	      ),
	      '\u2013 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0435 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E \u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0435 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u043E\u0448\u0435\u043B \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.6. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442 '
	      ),
	      '\u2013 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0432\u0432\u043E\u0434\u0430 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.7. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0423\u0441\u043B\u0443\u0433\u0438 '
	      ),
	      '\u2013 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.8. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C/\u043F\u0440\u043E\u0444\u0438\u043B\u044C '
	      ),
	      '\u2013 \u0435\u0434\u0438\u043D\u0430\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0447\u0430\u0441\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438: (\u0430) \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430; (\u0431) \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0438 \u0411\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0434\u043B\u044F \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u043C\u044B\u0445 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C \u0438\u0445 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E; (\u0432) \u043E\u0431\u043C\u0435\u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439 \u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043C\u0438 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C; (\u0433) \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u0437\u0430 \u0445\u043E\u0434\u043E\u043C \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX; (\u0434) \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u0443\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438/\u043F\u0440\u043E\u0444\u0438\u043B\u044E \u0438 \u0435\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E\u0441\u043B\u0435 \u0435\u0433\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.9. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C '
	      ),
	      '\u2013 \u041E\u041E\u041E "\u041D\u0415\u0414\u0412\u0415\u041A\u0421", \u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001, \u041E\u0413\u0420\u041D 1162366056830. \u0410\u0434\u0440\u0435\u0441: 354207, \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433\u043E\u0440\u043E\u0434 \u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u0443\u043B. \u041B\u0435\u0442\u043D\u044F\u044F, \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 15/2. \u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 \u043D\u0430 \u0421\u0435\u0440\u0432\u0438\u0441.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.10. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0422\u0430\u0440\u0438\u0444 '
	      ),
	      '\u2013 \u0442\u0430\u0440\u0438\u0444\u043D\u044B\u0439 \u043F\u043B\u0430\u043D, \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u0437 \u0421\u043F\u0438\u0441\u043A\u0430 \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0432\u043E\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0438\u043C. \u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438): ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '. \u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0446\u0435\u043D\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u043C\u0438, \u043E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u043C\u043E\u043C\u0435\u043D\u0442 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u044F\u0432\u043A\u0438 \u043D\u0430 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u0442\u0430\u0440\u0438\u0444\u0430. \u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0449\u0435\u0439 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0442\u0430\u043A\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438): ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.11. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0421\u0442\u043E\u0440\u043E\u043D\u044B '
	      ),
	      '\u2013 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.12. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 '
	      ),
	      '\u2013 \u0442\u0435\u043A\u0441\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F (\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u0444\u0435\u0440\u0442\u0430 \u043D\u0430 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430 NEDVEX) \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0439 \u0432\u0441\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0438 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.13. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F '
	      ),
	      '\u2013 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0449\u0430\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0438 (\u0438\u043B\u0438) \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E, \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.14. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0414\u0435\u043C\u043E-\u0432\u0435\u0440\u0441\u0438\u044F '
	      ),
	      '\u2013 \u043F\u0440\u0430\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX, \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u043F\u043E \u0441\u0440\u043E\u043A\u0443 \u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u043C\u0438, \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u043E\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0441 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.1.15. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 '
	      ),
	      '\u2013 \u0442\u0435\u043A\u0441\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043F\u0440\u0430\u0432\u0438\u043B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1.2. \u0412 \u0423\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u044B \u0442\u0435\u0440\u043C\u0438\u043D\u044B, \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u0432 \u043F. 1.1 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F. \u0412 \u044D\u0442\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0435 \u0442\u043E\u043B\u043A\u043E\u0432\u0430\u043D\u0438\u0435 \u0442\u0430\u043A\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0435\u043A\u0441\u0442\u043E\u043C \u0423\u0441\u043B\u043E\u0432\u0438\u0439. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u044F \u043E\u0434\u043D\u043E\u0437\u043D\u0430\u0447\u043D\u043E\u0433\u043E \u0442\u043E\u043B\u043A\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0435\u0440\u043C\u0438\u043D\u0430 \u0432 \u0442\u0435\u043A\u0441\u0442\u0435 \u0423\u0441\u043B\u043E\u0432\u0438\u0439 \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043B\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0442\u0435\u0440\u043C\u0438\u043D\u0430, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u0437\u0430\u0442\u0435\u043C \u2014 \u0441\u043B\u043E\u0436\u0438\u0432\u0448\u0438\u043C\u0441\u044F (\u043E\u0431\u0449\u0435\u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0438\u043C\u044B\u043C) \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '2. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.1. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0430\u0432\u0430 \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F. \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F \u0442\u0430\u043A\u0436\u0435 \u043D\u0430 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u043F\u0440\u0430\u0432\u0430\u043C\u0438 \u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u043C\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u043C\u0438\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u043E \u0447\u044C\u0438 \u043F\u0440\u0430\u0432\u0430 \u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0437\u0430\u0442\u0440\u043E\u043D\u0443\u0442\u044B \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.2. \u041F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u0440\u0430\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u0445, \u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0437\u0430 \u044D\u0442\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0422\u0430\u0440\u0438\u0444\u043E\u043C. \u041A \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043E\u0442\u043D\u043E\u0441\u044F\u0442\u0441\u044F \u043B\u044E\u0431\u044B\u0435 \u0438\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 (\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B), \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438):',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3. \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0443\u0441\u043B\u0443\u0433\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3.1. \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0438\u0441\u043A\u0430 \u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043D\u0438\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3.2. \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u0441\u0441\u044B\u043B\u043A\u0443 \u0441 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u044E \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043D\u0435\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3.3. \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0431 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.3.4. \u0438\u043D\u044B\u0435 \u0432\u0438\u0434\u044B \u0443\u0441\u043B\u0443\u0433, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.4. \u0410\u043A\u0446\u0435\u043F\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438\u043B\u0438 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0431\u0435\u0437 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0442\u043E\u0439 \u043C\u0435\u0440\u0435, \u0432 \u043A\u0430\u043A\u043E\u0439 \u044D\u0442\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0431\u0435\u0437 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430. \u0410\u043A\u0446\u0435\u043F\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442, \u0447\u0442\u043E \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u0443 \u0435\u0433\u043E \u044E\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u0438 \u043E\u043D \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0439 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C\u044E \u0434\u043B\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.5. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u043C \u0438 \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C. \u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0430\u044F \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438):',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u0435\u0434\u043C\u0435\u0442 \u0438\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0438/\u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438/\u0438\u043B\u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u043E\u0441\u043B\u0435 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0438/\u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442 \u0431\u0435\u0437\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0447\u043D\u043E\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u0438 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 (\u0430\u043A\u0446\u0435\u043F\u0442) \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0441 \u0442\u0430\u043A\u0438\u043C\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C\u0438 \u0438/\u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043C\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.6. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0431\u0435\u0437 \u043A\u0430\u043A\u043E\u0433\u043E-\u043B\u0438\u0431\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431 \u044D\u0442\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u041D\u043E\u0432\u0430\u044F \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u044F \u041F\u0440\u0430\u0432\u0438\u043B \u0432\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0438\u0445 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F, \u0435\u0441\u043B\u0438 \u0432 \u0442\u0435\u043A\u0441\u0442\u0435 \u041F\u0440\u0430\u0432\u0438\u043B \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0438\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u0441\u0438\u043B\u0443 \u043D\u043E\u0432\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u0439.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.7. \u041A\u043E\u043F\u0438\u0440\u0443\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443, \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u044F \u0435\u0451 \u043D\u0430 \u0441\u0432\u043E\u0435 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u043B\u044E\u0431\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u044B\u0440\u0430\u0436\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438 \u0431\u0435\u0437\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0447\u043D\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441\u043E \u0432\u0441\u0435\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.8. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0432 \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u0446\u0435\u043B\u044F\u0445. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0441 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435\u043C (\u043D\u0435\u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C) \u043A\u0430\u043A\u043E\u0433\u043E-\u043B\u0438\u0431\u043E \u0438\u0437 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u2013 \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.9. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0441 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.10. \u0414\u043B\u044F \u0442\u043E\u0433\u043E \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u043C\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0439\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0434\u043B\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0438\u043C\u0435\u0442\u044C \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u0447\u0438\u0441\u043B\u043E \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u0439 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435. \u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u0439 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0432\u044B\u0433\u043E\u0434\u044B \u043F\u0443\u0442\u0435\u043C \u0432\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0439 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0435 \u0432\u0441\u0435\u0445 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043A \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u0441\u0435\u0445 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445/\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043D\u043E\u043C\u0435\u0440\u043E\u0432 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432/\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0445 \u0430\u0434\u0440\u0435\u0441\u043E\u0432/\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u0430\u0440\u0442 \u0442\u0430\u043A\u043E\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11. \u041F\u043E\u0440\u044F\u0434\u043E\u043A \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.1. \u0414\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0443\u044E \u0438 \u043F\u043E\u043B\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0441\u0435\u0431\u0435 \u043F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u043C \u0432 \u0444\u043E\u0440\u043C\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0432 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0438. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0435\u0432\u0435\u0440\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0438\u043B\u0438 \u0443 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0435\u0441\u0442\u044C \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0430\u0433\u0430\u0442\u044C, \u0447\u0442\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043D\u0435\u043F\u043E\u043B\u043D\u0430\u044F \u0438/\u0438\u043B\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0430, \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043B\u0438\u0431\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0441\u0432\u043E\u0438\u0445 \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432 (\u043B\u0438\u0431\u043E \u0438\u0445 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u0439). \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0435\u0441\u043B\u0438 \u0438\u043C\u0435\u044E\u0442\u0441\u044F \u043E\u0431\u043E\u0441\u043D\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u043C\u043D\u0435\u043D\u0438\u044F \u0432 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u043D\u0435\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0445 \u0438 (\u0438\u043B\u0438) \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.2. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443) \u0438 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435. \u0414\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u043D\u0435\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u044B\u0445, \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0438\u0440\u0430\u0432\u043D\u0435\u043D\u043E \u043A \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0438\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0445, \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u043C, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435, \u043A\u043E\u0433\u0434\u0430 \u0434\u0430\u043D\u043D\u044B\u0435, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.3. \u0421\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0431\u0443\u0434\u0435\u0442 \u044F\u0432\u043B\u044F\u0442\u044C\u0441\u044F: \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C, \u0432\u044B\u0441\u044B\u043B\u0430\u0435\u043C\u044B\u0439 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043F\u043E \u0421\u041C\u0421 (SMS) \u0438/\u0438\u043B\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0447\u0435\u0442\u044B\u0440\u0435 \u0446\u0438\u0444\u0440\u044B \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0432\u0445\u043E\u0434\u044F\u0449\u0435\u0433\u043E \u0437\u0432\u043E\u043D\u043A\u0430 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0438/\u0438\u043B\u0438 \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043E\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043F\u0435\u0440\u0435\u0447\u0435\u043D\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438\u043C \u0422\u0430\u0440\u0438\u0444\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.5. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0443\u0441\u0442\u043E\u0439\u0447\u0438\u0432\u043E\u0441\u0442\u044C \u043A \u0443\u0433\u0430\u0434\u044B\u0432\u0430\u043D\u0438\u044E) \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u043D\u043E\u0441\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u0438\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442 \u0438\u0445 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.6. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0432\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u0412\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u043C\u0438 \u0441\u0430\u043C\u0438\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.7. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0442\u044C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u043E \u043B\u044E\u0431\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E (\u043D\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u043E\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C) \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438/\u0438\u043B\u0438 \u043E \u043B\u044E\u0431\u043E\u043C \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 (\u043F\u043E\u0434\u043E\u0437\u0440\u0435\u043D\u0438\u044F\u0445 \u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438) \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0441\u0432\u043E\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0443\u044E \u043F\u043E\u0442\u0435\u0440\u044E \u0438\u043B\u0438 \u043F\u043E\u0440\u0447\u0443 \u0434\u0430\u043D\u043D\u044B\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u044F \u043B\u044E\u0431\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0442\u0438 \u0438\u0437-\u0437\u0430 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.11.8. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0437\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043A\u0430\u043A\u043E\u0439-\u043B\u0438\u0431\u043E \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0438 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0431\u0435\u0437 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0447\u0438\u043D, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0435\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043B\u0441\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0431\u043E\u043B\u0435\u0435 12 \u043C\u0435\u0441\u044F\u0446\u0435\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.12. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430 \u043F\u0443\u0442\u0435\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u0441\u043B\u0435\u0434\u0443\u044F \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C \u0432 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.13. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u0432\u043E\u0435 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 (\u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u044F\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0435\u0441\u043B\u0438 \u044D\u0442\u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438) \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0435\u0433\u043E \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438\u043B\u0438 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u0440\u0438 \u043D\u0435\u043E\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u043E\u043C \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u043B\u0438\u0431\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0438\u043D\u044B\u0435 \u043C\u0435\u0440\u044B \u0441 \u0446\u0435\u043B\u044C\u044E \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438\u043B\u0438 \u043F\u0440\u0430\u0432 \u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.14. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u0430\u0435\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0438 \u0435\u0433\u043E \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043B\u0438\u0446\u0430\u043C \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u0430\u043A \u044D\u0442\u043E\u0442 \u0442\u0435\u0440\u043C\u0438\u043D \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D \u0432 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0434\u043B\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0446\u0435\u043B\u0435\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u0440\u0430\u0432\u043D\u043E \u043A\u0430\u043A \u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0442\u0430\u043A\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0442 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u043B\u0438\u0446 \u0434\u043B\u044F \u0442\u0435\u0445 \u0436\u0435 \u0446\u0435\u043B\u0435\u0439, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u043E\u043D\u043E\u043C, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0432 \u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u0435\u0442 \u043B\u0438\u0448\u044C \u0442\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0434\u043B\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0446\u0435\u043B\u0438. \u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C\u043E\u0439, \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0439 \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u043E\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u043E\u0439 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      ', \u0432 \u0447\u0430\u0441\u0442\u0438, \u043D\u0435 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u0440\u0435\u0447\u0430\u0449\u0435\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.14.1. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E, \u0441\u0432\u043E\u0435\u0439 \u0432\u043E\u043B\u0435\u0439 \u0438 \u0432 \u0441\u0432\u043E\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u0432\u043E\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0434\u043B\u044F \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.14.2. \u041F\u043E\u0434 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u043E\u0442 27.07.2006 \u0433. \u2116 152-\u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0438\u043B\u0438 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439, \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u043C\u044B\u0445 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u0431\u043E\u0440, \u0437\u0430\u043F\u0438\u0441\u044C, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E, \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435 (\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435), \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 (\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435, \u0434\u043E\u0441\u0442\u0443\u043F) \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435, \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.14.3. \u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.15. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D, \u043F\u043E\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u043F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0435\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F: \u0412\u0435\u0440\u0441\u0438\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430, IP address, \u0442\u0438\u043F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0434\u0430\u043D\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u043E\u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 (\u0435\u0441\u043B\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E), \u0438\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u0430\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u043C\u0430\u044F \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u0430\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0440\u0430\u0441\u043F\u043E\u0440\u044F\u0436\u0430\u0442\u044C\u0441\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u0441 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.16. \u0414\u043B\u044F \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F, \u043E\u043F\u0442\u0438\u043C\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0438\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0446\u0435\u043B\u044F\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043E \u0441\u0432\u043E\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430\u0445, \u043F\u0440\u043E\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433, \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0440\u043E\u0441\u043E\u0432, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 (\u0442\u0430\u0440\u0433\u0435\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439) \u0440\u0435\u043A\u043B\u0430\u043C\u044B, \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u044B\u0445 \u0430\u043A\u0446\u0438\u0439, \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438, \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u0443\u0441\u043B\u0443\u0433, \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438, \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0430\u043D\u0430\u043B\u0438\u0437\u0430 \u0442\u0430\u043A\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0438 \u043F\u043E\u0440\u0443\u0447\u0430\u0435\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u043E\u0440\u0443\u0447\u0430\u0442\u044C \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043B\u0438\u0446\u0430\u043C \u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0441 \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0434\u0430\u043D\u043D\u044B\u0445, \u0432 \u0442.\u0447. \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0442\u0430\u043A\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0432\u0438\u0434\u0435 \u0446\u0435\u043B\u043E\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u0438/\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0445 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u0432, \u0438\u0445 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043B\u0438\u0446\u0430\u043C \u0438/\u0438\u043B\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C \u0432\u043E \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0442\u0430\u043A\u043E\u0433\u043E \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0441\u0431\u043E\u0440 (\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435) \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u0438\u043D\u044B\u0445 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0442 \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043B\u0438\u0446 \u0438/\u0438\u043B\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.17. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0431\u0435\u0437 \u043A\u0430\u043A\u043E\u0433\u043E-\u043B\u0438\u0431\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431 \u044D\u0442\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u041D\u043E\u0432\u0430\u044F \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u044F \u041F\u0440\u0430\u0432\u0438\u043B \u0432\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0435\u0451 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043D\u0430 \u0421\u0430\u0439\u0442\u0435, \u0435\u0441\u043B\u0438 \u0432 \u0442\u0435\u043A\u0441\u0442\u0435 \u041F\u0440\u0430\u0432\u0438\u043B \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0438\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u0441\u0438\u043B\u0443 \u043D\u043E\u0432\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u0439.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.18. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0431\u0435\u0440\u0435\u0442 \u043D\u0430 \u0441\u0435\u0431\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 \u0423\u0441\u043B\u0443\u0433, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u0443, \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0438 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.19. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445, \u043E\u043F\u0438\u0441\u0430\u043D\u043D\u044B\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '2.20. \u0414\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u0441\u0435\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u0438\u043C\u0435\u0442\u044C \u0432\u0435\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0443\u044E \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '3. \u041E\u041F\u041B\u0410\u0422\u0410 \u0423\u0421\u041B\u0423\u0413'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.1. \u041E\u043F\u043B\u0430\u0442\u0430 \u0443\u0441\u043B\u0443\u0433 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u043F\u043E\u0441\u043B\u0435 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.2. \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0442\u0430\u0440\u0438\u0444\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043E\u0431\u044A\u0435\u043C \u0443\u0441\u043B\u0443\u0433 (\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439) \u0438 \u043F\u0435\u0440\u0438\u043E\u0434, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043E\u043D \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.3. \u041E\u043F\u043B\u0430\u0442\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0430 (\u043F\u0440\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438) \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0438 (\u0438\u043B\u0438) \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u043C \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0440\u0430\u0431\u043E\u0442\u044B \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u0442 \u0422\u0430\u0440\u0438\u0444 \u0438 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B. \u041F\u043E\u0441\u043B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0435\u0440\u0435\u0430\u0434\u0440\u0435\u0441\u043E\u0432\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441, \u0433\u0434\u0435 \u0435\u043C\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0430\u044F \u0444\u0430\u043A\u0442 \u043E\u043F\u043B\u0430\u0442\u044B.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.5. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F, \u0447\u0442\u043E \u0432\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u043C\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.6. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E \u0432\u044B\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u043C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u0447\u0435\u0442\u0430\u043C, \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0442\u0430\u0440\u0438\u0444\u0430 \u0438 \u0435\u0433\u043E \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u043C\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0441 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.7. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u2013 \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u043A\u043E\u043F\u0438\u0435\u0439 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B\u0441\u044B\u043B\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.8. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0435\u0434 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0437\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435/\u0431\u0435\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B (\u0431\u0430\u043D\u043A\u0430) \u043F\u0440\u0438 \u043E\u043F\u043B\u0430\u0442\u0435 \u0437\u0430 \u0422\u0430\u0440\u0438\u0444 \u0438 \u0438\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0437\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u043D\u043E\u0441\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0445 \u043E \u0435\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u0435, \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.9. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432\u0437\u0438\u043C\u0430\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B (\u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E) \u0437\u0430 \u0441\u0432\u043E\u0438 \u0443\u0441\u043B\u0443\u0433\u0438. \u0421\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0441\u0431\u043E\u0440\u044B \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.10. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F, \u0447\u0442\u043E \u0432\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u043C \u043D\u043E\u043C\u0435\u0440\u0430 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043F\u0440\u0438\u043C\u0435\u0440: \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0432 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043D\u043E \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044F\u0441\u044C \u044D\u0442\u0438\u043C), \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u043C\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.11. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441 \u0444\u0430\u043A\u0442\u043E\u043C \u0438/\u0438\u043B\u0438 \u0441\u0443\u043C\u043C\u043E\u0439 \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u043F\u043E \u0438\u043D\u044B\u043C \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u0444\u043E\u0440\u043C\u0443 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 https:// content@nedvex.ru, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 14 \u0434\u043D\u0435\u0439 \u0441\u043E \u0434\u043D\u044F \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0438\u043B\u0438 \u0441\u043E\u0431\u044B\u0442\u0438\u0439, \u043F\u043E\u0441\u043B\u0443\u0436\u0438\u0432\u0448\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D\u043E\u0439 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u043F\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043F\u043E \u0442\u0430\u043A\u043E\u043C\u0443 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0435 \u0441\u0443\u043C\u043C\u044B \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0438\u043B\u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0431\u044B\u043B\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0430 \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430. \u041F\u043E\u0440\u044F\u0434\u043E\u043A \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441 \u0443\u0447\u0430\u0441\u0442\u0438\u0435\u043C \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 \u043F\u043E \u043F\u0440\u0438\u0435\u043C\u0443 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u0438\u043B\u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0445 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432, \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432, \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E-\u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0438 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C, \u0431\u0430\u043D\u043A\u043E\u0432 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B) \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E, \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 10 (\u0434\u0435\u0441\u044F\u0442\u0438) \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0445 \u0434\u043D\u0435\u0439 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.12. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0438\u043C \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C, \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u044D\u0442\u0438\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0438\u0435, \u043D\u0435\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u044B\u0445, \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0438\u0440\u0430\u0432\u043D\u0435\u043D\u043E \u043A \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u044F, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.13. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u044C \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0430\u043A\u0446\u0438\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u043A\u0438\u0434\u043A\u0438 \u0438 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430\u0445 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438. \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0442\u0430\u043A\u0438\u0445 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u044B\u0445 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F\u0445 \u0438 \u0438\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0440\u0430\u0437\u043C\u0435\u0449\u0430\u044E\u0442\u0441\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.14. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430\u0440\u0438\u0444\u043E\u0432, \u043E \u0447\u0435\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u0443\u0442\u0435\u043C \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0437\u0430 3 (\u0442\u0440\u0438) \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u044F \u0434\u043E \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u043E\u0439 \u0434\u0430\u0442\u044B \u0432\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438):',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.15. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F, \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442 \u0432 \u0410\u043A\u043A\u0430\u0443\u043D\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435 (\u0434\u043D\u044F\u0445) \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u0430;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0442\u0430\u0440\u0438\u0444\u0430;'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.16. \u041F\u043E \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043C\u0443 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u043C\u0443 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043F\u043E \u0435\u0433\u043E \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443, \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30 (\u0422\u0440\u0438\u0434\u0446\u0430\u0442\u0438) \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439 \u0441 \u0434\u0430\u0442\u044B \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0430\u043A\u043E\u0433\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u043E-\u043F\u0435\u0440\u0435\u0434\u0430\u0442\u043E\u0447\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 (\u0423\u041F\u0414). \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u0432 \u0442\u0430\u043A\u043E\u043C \u0437\u0430\u043F\u0440\u043E\u0441\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D \u0441\u0440\u043E\u043A, \u0437\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 1 (\u043E\u0434\u0438\u043D) \u0433\u043E\u0434, \u043F\u0440\u0435\u0434\u0448\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u0434\u0430\u0442\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.17. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043D\u0435\u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430, \u043E\u0441\u0442\u0430\u044E\u0449\u0438\u0435\u0441\u044F \u043D\u0430 \u0434\u0430\u0442\u0443 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.18. \u0423\u0441\u043B\u0443\u0433\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041D\u0414\u0421 \u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F (\u043F.2, \u0441\u0442.346.11, \u0433\u043B.26.2 \u041D\u041A \u0420\u0424).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.19. \u0420\u0430\u0441\u0447\u0435\u0442 \u043C\u0435\u0436\u0434\u0443 \u0421\u0442\u043E\u0440\u043E\u043D\u0430\u043C\u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '3.20. '
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '4. \u041F\u0440\u0435\u0434\u0435\u043B\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.1.',
	      ' ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430:'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.1.1 \u043F\u0440\u0430\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 (\u0438\u043B\u0438) \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0438\u0445 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0438\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0442\u044C \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442. \u041F\u0440\u0430\u0432\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A \u0411\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u043C\u043E\u0436\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0441 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435\u043C \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.1.2 \u043F\u0440\u0430\u0432\u043E \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u043D\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445; \u041E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C \u0432\u0445\u043E\u0434 \u0432 \u0441\u0435\u0440\u0432\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0441 \u0432\u0435\u0431\u0441\u0430\u0439\u0442\u0430 \u0438 \u043E\u0434\u0438\u043D \u0441 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.1.3. \u043F\u0440\u0430\u0432\u043E \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0433\u043E \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430 \u0438\u0437 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0438 \u0438\u0445 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u043B\u0438\u0447\u043D\u044B\u0445 \u043D\u0435\u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 \u0438/\u0438\u043B\u0438 \u0441 \u0446\u0435\u043B\u044C\u044E \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0433\u043E \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430, \u0441 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u043D\u0430 \u0411\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435:'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2.1. \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C, \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0442\u044C, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0438 \u043F\u0435\u0440\u0435\u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0438/\u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u0430 \u0438\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043A\u043E\u0433\u0434\u0430 \u0442\u0430\u043A\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0431\u044B\u043B\u0438 \u043F\u0440\u044F\u043C\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2.2. \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0442\u044C, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0438 \u043F\u0435\u0440\u0435\u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0434\u0438\u0437\u0430\u0439\u043D\u0430 \u0438\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C NEDVEX;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2.3. \u043F\u0435\u0440\u0435\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C \u0438/\u0438\u043B\u0438 \u0411\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX, \u0432 \u043F\u0440\u0435\u0434\u0435\u043B\u0430\u0445, \u043F\u0440\u044F\u043C\u043E \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2.4. \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0423\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.2.5. \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u042D\u0412\u041C \u0438/\u0438\u043B\u0438 \u0411\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0438\u043D\u044B\u043C\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0432\u044B\u0445\u043E\u0434\u044F\u0449\u0438\u043C\u0438 \u0437\u0430 \u0440\u0430\u043C\u043A\u0438 \u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C, \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0421\u0430\u0439\u0442\u0430 NEDVEX \u0432 \u0446\u0435\u043B\u043E\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F:'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3.1. \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u0430\u043A\u0446\u0435\u043F\u0442\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0422\u0430\u0440\u0438\u0444\u0430;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3.2. \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0432\u0441\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0438/\u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043A \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 \u0447\u0435\u043C \u0437\u0430 5 (\u043F\u044F\u0442\u044C) \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439 \u0434\u043E \u043D\u0430\u0447\u0430\u043B\u0430 \u0438\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3.3. \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0432\u0441\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0438/\u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0432 \u0421\u043F\u0438\u0441\u043A\u0435 \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 \u0447\u0435\u043C \u0437\u0430 3 (\u0442\u0440\u0438) \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u044F \u0434\u043E \u043D\u0430\u0447\u0430\u043B\u0430 \u0438\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.3.4. \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u0445 \u0435\u0433\u043E \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435, \u043D\u0435\u0437\u0430\u043C\u0435\u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u0442\u044C \u043E\u0431 \u044D\u0442\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u0443\u0442\u0435\u043C \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u043E\u0432\u044B\u0445 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438)',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4. ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '\u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435:'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.1. \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.2. \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u043B\u0438 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u0443\u0442\u0435\u043C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0435\u0439. \u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u043F\u0443\u043D\u043A\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0431\u0435\u0437 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u0441\u043B\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.2.1. \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0438\u0437-\u0437\u0430 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0445, \u0442\u043E\u043F\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u0435\u0441\u0442\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0438\u0439;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.2.2. \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u0435 \u0443\u043F\u043B\u0430\u0442\u044B \u0437\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.2.3. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u043E \u0438\u043B\u0438 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043D\u0430\u043D\u043E\u0441\u044F \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u0443\u0449\u0435\u0440\u0431 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0438/\u0438\u043B\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.2.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u0442 \u0438\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435, \u043F\u043E \u043C\u043D\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.3. \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.4. \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0435\u0433\u043E \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435 \u0438\u043B\u0438 \u0445\u0440\u0430\u043D\u044F\u0449\u0438\u0435\u0441\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B, \u043B\u044E\u0431\u044B\u0435 \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.5. \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435, \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043A\u0430\u0441\u0430\u044E\u0449\u0438\u0435\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.6. \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u044F\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 (\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0439\u0441\u044F \u0432 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F), \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0440\u0443\u0448\u0430\u0435\u0442 \u0438/\u0438\u043B\u0438 \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0440\u0443\u0448\u0430\u0442\u044C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0420\u0424, \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u043F\u0440\u0430\u0432\u0430 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C, \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u0442\u044C \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0430\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E \u0432\u0441\u0435\u043C \u0438\u043B\u0438 \u043A \u043B\u044E\u0431\u043E\u043C\u0443 \u0438\u0437 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.7. \u0423\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0442\u0430\u043A\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.8 \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443 \u0438 \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0438\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0438 (\u0432 \u0442.\u0447. \u043D\u043E \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044F\u0441\u044C \u043F\u0443\u0448-\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F), \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438 \u0441 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C, \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0432\u0438\u0434\u043E\u0432 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      { type: 'a' },
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0441\u043B\u0443\u0436\u0435\u0431\u043D\u044B\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u041F\u0440\u043E\u0444\u0438\u043B\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0446\u0435\u043B\u043E\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044E \u043F\u0430\u0440\u043E\u043B\u044F, \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 (\u043F\u043E \u043C\u0435\u0440\u0435 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F);'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0438\u0437 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430\u043C\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u2014 \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430;'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u0421\u043E\u0433\u043B\u0430\u0441\u0438\u0435\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0441\u044B\u043B\u043E\u043A \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 (\u0430\u043A\u0446\u0435\u043F\u0442) \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0441\u044B\u043B\u043E\u043A, \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0432 \u0442\u0435\u043A\u0441\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0445 \u043E\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0432\u0448\u0438\u0441\u044C \u043A \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E, \u0447\u0435\u0440\u0435\u0437 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0412 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 10 (\u0434\u0435\u0441\u044F\u0442\u0438) \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0432\u0438\u0434\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0432 \u0435\u0433\u043E \u0430\u0434\u0440\u0435\u0441.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.9. \u043F\u0440\u0438 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0438 \u0435\u043C\u0443 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043F\u0443\u0442\u0435\u043C \u043F\u0440\u0435\u0434\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u0441\u043B\u0443\u0436\u0431\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u2014 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u0431\u0440\u0430\u0442\u0438\u0432\u0448\u0435\u043C\u0443\u0441\u044F \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u043E\u0432\u0430\u044F \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0441 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '4.4.10. \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0438\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u0435\u043C\u0443 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '5. \u041F\u0440\u0430\u0432\u0430 \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.1 \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0421\u043F\u0438\u0441\u043A\u043E\u043C \u0442\u0430\u0440\u0438\u0444\u043E\u0432 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 (\u0430\u043A\u0446\u0435\u043F\u0442\u0430) \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.2 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F, \u0438\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438, \u0432\u0441\u0435\u0445 \u0435\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0445 \u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.3 \u0441\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E, \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0430\u043A\u0446\u0435\u043F\u0442\u043E\u0432\u0430\u043D\u043D\u043E\u043C\u0443 \u0438\u043C \u0422\u0430\u0440\u0438\u0444\u0443;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.4 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043F\u0440\u0430\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u043A\u0430\u043A\u043E\u043C\u0443-\u043B\u0438\u0431\u043E \u0442\u0440\u0435\u0442\u044C\u0435\u043C\u0443 \u043B\u0438\u0446\u0443 \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.5 \u043D\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0438/\u0438\u043B\u0438 \u0441\u0438\u0441\u0442\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432 \u043F\u043E \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044E \u0441\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u043C\u0438 \u0434\u043B\u044F \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.6 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0443\u044E \u0442\u0430\u0439\u043D\u0443, \u0441\u0442\u0430\u0432\u0448\u0443\u044E \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.7 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u043E \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.8 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0435\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.9 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u043A\u0430\u043A\u043E\u043C\u0443-\u043B\u0438\u0431\u043E \u0442\u0440\u0435\u0442\u044C\u0435\u043C\u0443 \u043B\u0438\u0446\u0443 \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.1.10 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u0438 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u043F\u0440\u0435\u0449\u0430\u0435\u0442\u0441\u044F:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2.1. \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2.2. \u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C, \u0445\u0440\u0430\u043D\u0438\u0442\u044C, \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0438\u043B\u0438 \u0438\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u0438\u0440\u0443\u0441\u044B, \u0442\u0440\u043E\u044F\u043D\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2.3. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0437 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043D\u0430 \u0442\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u0440\u0438\u043F\u0442\u044B (\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B) \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438/\u0438\u043B\u0438 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0438 \u0435\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043E\u043C;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.2.4. \u041B\u044E\u0431\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435, \u043D\u043E \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044F\u0441\u044C, \u043F\u0443\u0442\u0435\u043C \u043E\u0431\u043C\u0430\u043D\u0430, \u0437\u043B\u043E\u0443\u043F\u043E\u0442\u0440\u0435\u0431\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0432\u0435\u0440\u0438\u0435\u043C, \u0432\u0437\u043B\u043E\u043C\u0430, \u043F\u044B\u0442\u0430\u0442\u044C\u0441\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438\u043B\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C \u0434\u0440\u0443\u0433\u0438\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.3. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.3.1. \u043E\u0431\u0440\u0430\u0449\u0430\u0442\u044C\u0441\u044F \u0437\u0430 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u043E\u0439 \u043A \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '5.3.1. \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043F\u0440\u0430\u0432\u0430\u043C\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u0435\u043C\u0443 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '6. \u0422\u0415\u0420\u0420\u0418\u0422\u041E\u0420\u0418\u042F \u0418 \u0421\u0420\u041E\u041A \u0414\u0415\u0419\u0421\u0422\u0412\u0418\u042F \u041D\u0410\u0421\u0422\u041E\u042F\u0429\u0415\u0413\u041E \u0421\u041E\u0413\u041B\u0410\u0428\u0415\u041D\u0418\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.1. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u043E\u043F\u0438\u0441\u0430\u043D\u043D\u044B\u043C\u0438 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438, \u043D\u0430 \u0432\u0441\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u043D\u044B\u0445 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F\u0445, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043E\u043D\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0438\u043C \u0447\u0435\u0440\u0435\u0437 \u0421\u0435\u0440\u0432\u0438\u0441\u044B \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438 (\u0438\u043B\u0438) \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.2. \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.2.1. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0443\u0441\u043B\u0443\u0433 \u0434\u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E \u0422\u0430\u0440\u0438\u0444\u0443.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.2.2. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438 \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0433\u043E \u043E\u0431\u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043E\u0442\u043A\u0430\u0437\u0430 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433\u0438 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0433\u0440\u043E\u0437\u0443 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0438 \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u044E \u043B\u044E\u0434\u0435\u0439;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u0432\u0438\u0434\u0443 \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445, \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u0435\u0441\u0442\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0438\u0439;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043D\u0430 \u0438\u043D\u044B\u0445 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F\u0445, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.2.3. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F (\u0438\u043B\u0438 \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C) \u0438 \u0431\u0435\u0437 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0447\u0438\u043D \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442\u044C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u0432\u043D\u0435\u0441\u0443\u0434\u0435\u0431\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0441 \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u044B\u043C \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0435\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432 \u0438 \u0431\u0435\u0437 \u0432\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u0437\u0430\u0442\u0440\u0430\u0442, \u0443\u0431\u044B\u0442\u043A\u043E\u0432 \u0438\u043B\u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E, \u0432 \u0441\u043B\u0443\u0447\u0430\u0435:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043B\u044E\u0431\u043E\u0433\u043E, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043E\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u043E\u0433\u043E, \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438\u043D\u044B\u0445 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u043D\u0430 \u0421\u0430\u0439\u0442\u0435 NEDVEX, \u0438 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043B\u044E\u0431\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043F\u043E\u0432\u043B\u0435\u043A\u0448\u0438\u0445 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0441\u0431\u043E\u0439 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u0433\u043E \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u043A \u043D\u0438\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u0430 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435, \u0437\u0430\u043A\u0440\u044B\u0442\u0438\u044F \u0421\u0430\u0439\u0442\u0430 Nedvex);'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0445 \u0443\u0441\u043B\u0443\u0433 \u0432 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.3. \u041C\u043E\u043C\u0435\u043D\u0442\u043E\u043C \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0441\u044F \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0435\u043C\u0443 \u0434\u0435\u043D\u0435\u0436\u043D\u043E\u0433\u043E \u044D\u043A\u0432\u0438\u0432\u0430\u043B\u0435\u043D\u0442\u0430 \u043D\u0435\u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432, \u043F\u0440\u0438 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043F\u043E \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F\u043C, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.5. \u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u043D\u0430\u044F \u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0432\u0441\u0442\u0443\u043F\u0438\u0432\u0448\u0438\u043C \u0432 \u0441\u0438\u043B\u0443 \u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C \u0441\u0443\u0434\u0430, \u043D\u0435 \u0432\u043B\u0435\u0447\u0435\u0442 \u0434\u043B\u044F \u0421\u0442\u043E\u0440\u043E\u043D \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u0446\u0435\u043B\u043E\u043C. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u0438\u044F \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u0431\u044F\u0437\u0443\u044E\u0442\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0432\u0437\u044F\u0442\u044B\u0435 \u043D\u0430 \u0441\u0435\u0431\u044F \u043F\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0431\u043B\u0438\u0437\u043A\u0438\u043C \u043A \u0442\u0430\u043A\u043E\u0432\u043E\u043C\u0443 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u043C \u0438/\u0438\u043B\u0438 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.6. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0438 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u0435\u0433\u043E \u0421\u0442\u043E\u0440\u043E\u043D \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.7. \u0412 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0444\u043E\u0440\u043C\u044B \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043D\u043E\u0440\u043C\u044B \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0434\u0435\u043A\u0441\u0430 \u0420\u0424, \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043F\u0443\u0442\u0435\u043C \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.8. \u0412\u0441\u0435 \u0441\u043F\u043E\u0440\u044B \u0438 \u0440\u0430\u0437\u043D\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0421\u0442\u043E\u0440\u043E\u043D \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043F\u043E\u0434\u043B\u0435\u0436\u0430\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044E \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0438 \u0438 \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0443\u0434\u0435\u0431\u043D\u043E\u0433\u043E (\u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u043E\u043D\u043D\u043E\u0433\u043E) \u043F\u043E\u0440\u044F\u0434\u043A\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u0441\u043F\u043E\u0440\u044B \u0438 \u0440\u0430\u0437\u043D\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432, \u043E\u043D\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435 \u0410\u0440\u0431\u0438\u0442\u0440\u0430\u0436\u043D\u043E\u0433\u043E \u0441\u0443\u0434\u0430 \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u043E\u0433\u043E \u043A\u0440\u0430\u044F, \u0430 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043B\u0438\u0446\u043E\u043C \u2013 \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435 \u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0430\u0439\u043E\u043D\u043D\u043E\u0433\u043E \u0441\u0443\u0434\u0430 \u0433\u043E\u0440\u043E\u0434\u0430 \u0421\u043E\u0447\u0438 \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u043E\u0433\u043E \u043A\u0440\u0430\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '6.9. \u041F\u043E \u0432\u0441\u0435\u043C \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u043D\u0435 \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '7. \u0423\u0421\u041B\u041E\u0412\u0418\u042F \u0418\u0421\u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u041D\u0418\u042F \u041E\u0422\u0414\u0415\u041B\u042C\u041D\u042B\u0425 \u0424\u0423\u041D\u041A\u0426\u0418\u0419 \u0421\u0415\u0420\u0412\u0418\u0421\u0410'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '7.1. \u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u0438 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442 \u0442\u0430\u043A\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0438 \u043F\u043E \u0442\u0430\u0440\u0438\u0444\u0430\u043C \u0441\u0432\u043E\u0435\u0433\u043E \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0432\u044F\u0437\u0438 \u0438\u043B\u0438 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '7.2. \u0414\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u044F\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0439\u0442\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0440\u0430\u043D\u0435\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E, \u043D\u0435 \u043F\u0440\u043E\u0448\u0435\u0434\u0448\u0435\u043C\u0443 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '8. \u041E\u0422\u0412\u0415\u0422\u0421\u0422\u0412\u0415\u041D\u041D\u041E\u0421\u0422\u042C \u0418 \u041E\u0413\u0420\u0410\u041D\u0418\u0427\u0415\u041D\u0418\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.1. \u0417\u0430 \u043D\u0435\u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u043D\u0435\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043D\u0435\u0441\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.2. \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \xAB\u043A\u0430\u043A \u0435\u0441\u0442\u044C\xBB (as is). \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0431\u0435\u0437\u043E\u0448\u0438\u0431\u043E\u0447\u043D\u043E\u0439 \u0438 \u0431\u0435\u0441\u043F\u0435\u0440\u0435\u0431\u043E\u0439\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u043B\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0435\u0451 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432 \u0438/\u0438\u043B\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0439, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0446\u0435\u043B\u044F\u043C \u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043D\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0438\u043D\u044B\u0445 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439, \u043F\u0440\u044F\u043C\u043E \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.3. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0443\u0449\u0435\u0440\u0431 \u043B\u044E\u0431\u043E\u0433\u043E \u0440\u043E\u0434\u0430, \u043F\u043E\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.4. \u0412 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u043E\u0433\u043E \u0438 \u0438\u043D\u043E\u0433\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F, \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u0441\u0432\u044F\u0437\u0438 \u0438/\u0438\u043B\u0438 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C, \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u0445 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u043F\u0440\u0438 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0438 \u0423\u0441\u043B\u0443\u0433, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438, \u043F\u0440\u0435\u0440\u044B\u0432\u0430\u043D\u0438\u044F, \u043F\u0440\u044F\u043C\u043E\u0439 \u0438 \u043A\u043E\u0441\u0432\u0435\u043D\u043D\u044B\u0439 \u0443\u0449\u0435\u0440\u0431 \u0438\u043B\u0438 \u043F\u043E\u0442\u0435\u0440\u0438, \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0438\u0437 \u0437\u0430 \u0434\u0435\u0444\u0435\u043A\u0442\u043E\u0432 \u0432 \u043B\u044E\u0431\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0438\u043B\u0438 \u043C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0438 \u0438/\u0438\u043B\u0438 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430\u0445 \u0434\u043B\u044F \u042D\u0412\u041C, \u043B\u0438\u0431\u043E \u0432\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0435 \u0438\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0438\u043B\u0438 \u0431\u0435\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446, \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438, \u043F\u0435\u0440\u0435\u0431\u043E\u0435\u0432 \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0438\u0442\u0430\u043D\u0438\u0438, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u043D\u0435 \u043F\u043E \u0432\u0438\u043D\u0435 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.5. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435: (\u0430) \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0442\u0435\u0445 \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C \u0438 \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 NEDVEX \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u043E\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0439 \u0438 \u0432\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F (\u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0438\u0438) \u043F\u0440\u0438\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0442\u0430\u043A\u0438\u043C \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435\u043C \u0443\u0431\u044B\u0442\u043A\u043E\u0432 \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435 \u0438/\u0438\u043B\u0438 (\u0431) \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442\u044C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0441 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435. \u041F\u0440\u0438 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u043F\u0443\u043D\u043A\u0442\u0443, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0434\u0435\u043D\u0435\u0436\u043D\u043E\u0433\u043E \u044D\u043A\u0432\u0438\u0432\u0430\u043B\u0435\u043D\u0442\u0430 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.6. \u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0437\u0430 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.7. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0441\u0440\u043E\u043A\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u0423\u0441\u043B\u0443\u0433, \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0441\u0432\u043E\u0438\u0445 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0438\u043B\u0438 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.8. \u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u0443\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u043D\u0435\u0441\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0432\u0448\u0438\u0439 \u0434\u0430\u043D\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.9. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0437\u0430 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0441\u0442\u044C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.10. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435\u0441\u0435\u0442 \u0432\u0441\u044E \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0420\u0424 \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u044F, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0435 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u043C \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0439 \u0438 (\u0438\u043B\u0438) \u0437\u0430\u0432\u0435\u0434\u043E\u043C\u043E \u043B\u043E\u0436\u043D\u043E\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0438 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432 \u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043B\u0438\u0446 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0442\u0430\u043A\u0438\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.11. \u041F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0438\u0437 \u0442\u043E\u0433\u043E, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u043F\u043E\u043B\u043D\u044B\u0435, \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0435 \u0438 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445; \u0441\u0443\u0431\u044A\u0435\u043A\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 (\u0432 \u0442.\u0447. \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.12. \u0417\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u043E\u0431\u044A\u0435\u043C\u0430\u0445 \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u043F\u0440\u044F\u043C\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C, \u0434\u0435\u043A\u043E\u043C\u043F\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u0434\u0438\u0437\u0430\u0441\u0441\u0435\u043C\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u0434\u0435\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u0442\u044C \u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u043D\u044B\u043C \u043A\u043E\u0434\u043E\u043C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u0438\u043C\u0435\u044E\u0449\u0438\u0435 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0430\u043B\u0433\u043E\u0440\u0438\u0442\u043C\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0445 \u0432 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u043D\u044B\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C (\u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0442\u044C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C) \u0438\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u0431\u0435\u0437 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.13. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0437\u0430 \u043F\u043B\u0430\u0442\u0443), \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u0441\u0431\u043E\u0440\u043D\u0438\u043A\u043E\u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432, \u0431\u0435\u0437 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.14. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0432 \u0432\u0438\u0434\u0435, \u043E\u0442\u043B\u0438\u0447\u043D\u043E\u043C \u043E\u0442 \u0442\u043E\u0433\u043E, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u043E\u043D \u0435\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B, \u0431\u0435\u0437 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.15. \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C\u0441\u044F) \u043F\u043E\u0434 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435\u043C: \xABNedvex\xBB. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438/\u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u044F\u0442\u044C \u0437\u043D\u0430\u043A \u043E\u0445\u0440\u0430\u043D\u044B \u0430\u0432\u0442\u043E\u0440\u0441\u043A\u043E\u0433\u043E \u043F\u0440\u0430\u0432\u0430 (copyright notice) \u0438\u043B\u0438 \u0438\u043D\u043E\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u043D\u0430 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '8.16. \u0412\u043E \u0432\u0441\u0435\u043C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u043E\u043C, \u0447\u0442\u043E \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u0431\u0443\u0434\u0443\u0442 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '9. \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0410 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u042B\u0425 \u0414\u0410\u041D\u041D\u042B\u0425'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.1. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441 NEDVEX, \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u044B \u0438/\u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u044F\u0441\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C (\u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430) \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E, \u0441\u0432\u043E\u0435\u0439 \u0432\u043E\u043B\u0435\u0439 \u0438 \u0432 \u0441\u0432\u043E\u0435\u043C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u0432\u043E\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u0434\u043B\u044F \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.2. \u041F\u043E\u0434 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0435 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u043E\u0442 27.07.2006 \u0433. \u2116 152-\u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0438\u043B\u0438 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439, \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u043C\u044B\u0445 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u0431\u043E\u0440, \u0437\u0430\u043F\u0438\u0441\u044C, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E, \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435 (\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435), \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 (\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435, \u0434\u043E\u0441\u0442\u0443\u043F) \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435, \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '9.3. \u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u043C\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 (\u0434\u043E\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u043C\u0435\u043D\u0438):',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://app.nedvex.ru/' },
	        'https://app.nedvex.ru/'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '10. \u0424\u041E\u0420\u0421\u2013\u041C\u0410\u0416\u041E\u0420'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.1. \u041A\u0430\u0436\u0434\u0430\u044F \u0438\u0437 \u0421\u0442\u043E\u0440\u043E\u043D \u043E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u0435 \u0438\u043B\u0438 \u043F\u043E\u043B\u043D\u043E\u0435 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E, \u0435\u0441\u043B\u0438 \u043E\u043D\u0430 \u0434\u043E\u043A\u0430\u0436\u0435\u0442, \u0447\u0442\u043E \u043E\u043D\u043E \u044F\u0432\u0438\u043B\u043E\u0441\u044C \u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0435\u043C \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0445 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0447\u0440\u0435\u0437\u0432\u044B\u0447\u0430\u0439\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430, \u0442\u0430\u043A\u0438\u0445 \u043A\u0430\u043A: \u043F\u043E\u0436\u0430\u0440, \u0432\u0437\u0440\u044B\u0432, \u043D\u0430\u0432\u043E\u0434\u043D\u0435\u043D\u0438\u0435, \u0437\u0435\u043C\u043B\u0435\u0442\u0440\u044F\u0441\u0435\u043D\u0438\u0435, \u0437\u0430\u0431\u0430\u0441\u0442\u043E\u0432\u043A\u0430, \u0431\u043E\u0435\u0432\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438\u043B\u0438 \u041F\u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0442\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u0444\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0445 \u0438 \u043C\u0435\u0441\u0442\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0432\u043B\u0430\u0441\u0442\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0421\u0442\u043E\u0440\u043E\u043D\u0430 \u043D\u0435 \u043C\u043E\u0433\u043B\u0430 \u043D\u0438 \u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u0442\u044C, \u043D\u0438 \u043F\u0440\u0435\u0434\u043E\u0442\u0432\u0440\u0430\u0442\u0438\u0442\u044C, \u043D\u0438 \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0432 \u0440\u0430\u0441\u0447\u0435\u0442 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.2. \u041E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u043B\u0438\u0448\u044C \u043D\u0430 \u0442\u043E\u0442 \u043F\u0435\u0440\u0438\u043E\u0434, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u0438 \u0438\u0445 \u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.3. \u0421\u0442\u043E\u0440\u043E\u043D\u0430, \u0441\u0441\u044B\u043B\u0430\u044E\u0449\u0430\u044F\u0441\u044F \u043D\u0430 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u043E\u0431\u044F\u0437\u0430\u043D\u0430 \u043D\u0435\u0437\u0430\u043C\u0435\u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u0443\u044E \u0421\u0442\u043E\u0440\u043E\u043D\u0443 \u043E \u043D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0438 \u043E\u0431 \u0438\u0445 \u0432\u043B\u0438\u044F\u043D\u0438\u0438 \u043D\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0421\u0442\u043E\u0440\u043E\u043D\u043E\u0439 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u0432 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.4. \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u043E\u0442\u043E\u0434\u0432\u0438\u0433\u0430\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0430 \u0441\u0440\u043E\u043A, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0438\u043C\u0435\u0435\u0442 \u043C\u0435\u0441\u0442\u043E \u0442\u0430\u043A\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435. \u041F\u043E \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u0431\u044F\u0437\u0430\u043D\u044B \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u043A \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E \u0441\u0432\u043E\u0438\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '10.5. \u041D\u0430\u043B\u0438\u0447\u0438\u0435 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u0438\u0445 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u044B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u043D\u044B\u043C \u043B\u0438\u0446\u043E\u043C \u043A\u043E\u043C\u043F\u0435\u0442\u0435\u043D\u0442\u043D\u043E\u0433\u043E \u043E\u0440\u0433\u0430\u043D\u0430 \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u0435\u043C \u0421\u0442\u043E\u0440\u043E\u043D\u044B.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '11. \u0418\u0421\u041A\u041B\u042E\u0427\u0418\u0422\u0415\u041B\u042C\u041D\u041E\u0415 \u041F\u0420\u0410\u0412\u041E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.1. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442, \u0447\u0442\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0435 \u043A\u043E\u0434\u044B, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0434\u043B\u044F \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E, \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.2. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442 \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0432\u0441\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B \u0430\u0432\u0442\u043E\u0440\u0441\u043A\u0438\u043C \u043F\u0440\u0430\u0432\u043E\u043C, \u043F\u0440\u0430\u0432\u043E\u043C \u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u043D\u044B\u0439 \u0437\u043D\u0430\u043A \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438 \u043D\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0438 \u0447\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0438 \u043E\u0445\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F \u0432\u043E \u0432\u0441\u0435\u0445 \u0444\u043E\u0440\u043C\u0430\u0445, \u043D\u0430 \u0432\u0441\u0435\u0445 \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F\u0445 \u0438 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0432\u0441\u0435\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439, \u043A\u0430\u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F, \u0442\u0430\u043A \u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0438. \u041D\u0438\u043A\u0430\u043A\u0438\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u043B\u044E\u0431\u043E\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442 \u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.3. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043D\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0435 \u043F\u0440\u0430\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.3.1. \u041F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u043F\u043E \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E, \u0432 \u0446\u0435\u043B\u044F\u0445 \u0447\u0435\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u0435\u0435 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443 (\u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435) \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E(-\u0432\u0430) \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043D\u0430 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0435 \u0447\u0438\u0441\u043B\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432. \u041F\u0440\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0435 \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043A\u0430\u0436\u0434\u043E\u0439 \u043A\u043E\u043F\u0438\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u0440\u0438\u0441\u0432\u0430\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0441\u043E\u043E\u0431\u0449\u0430\u0435\u0442\u0441\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.3.2. \u0412\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0432 \u043D\u0435\u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 (\u0431\u0435\u0437\u0432\u043E\u0437\u043C\u0435\u0437\u0434\u043D\u043E).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435: \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435, \u0421\u0435\u0440\u0432\u0438\u0441, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438\u0445 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u043E\u0434 \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u0435\u043A\u043E\u043C\u043F\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0441 \u0446\u0435\u043B\u044C\u044E \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B, \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438, \u043A\u043E\u043D\u0446\u0435\u043F\u0446\u0438\u0438 \u0438 \u043C\u0435\u0442\u043E\u0434\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u0423\u0441\u043B\u0443\u0433, \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438/\u0438\u043B\u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u043A\u0430\u043A\u0438\u0435-\u043B\u0438\u0431\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0430\u0432, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B, \u0432\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B, \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0442\u043E\u0432\u0430\u0440\u043D\u044B\u0445 \u0437\u043D\u0430\u043A\u043E\u0432, \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u044B, \u0431\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445, \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0438, \u0442\u0435\u043A\u0441\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0438\u0437\u0430\u0439\u043D, \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443, \u0432\u044B\u0431\u043E\u0440, \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0446\u0438\u044E, \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434, \u043E\u0431\u0449\u0438\u0439 \u0441\u0442\u0438\u043B\u044C \u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u044F, \u0432\u0445\u043E\u0434\u044F\u0449\u0435\u0433\u043E \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430), \u043A\u0440\u043E\u043C\u0435 \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043A\u043E\u0433\u0434\u0430 \u0442\u0430\u043A\u0430\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u044F \u043F\u0440\u044F\u043C\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0430 (\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0430) \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043B\u0438\u0431\u043E \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u0443\u044E \u0447\u0430\u0441\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u0433\u043E \u0434\u0438\u0437\u0430\u0439\u043D.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.5. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u043F\u0440\u0430\u0432\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0433\u043E \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F, \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E \u0435\u0433\u043E \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '11.6. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0430\u0432 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '12. \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u041E\u041D\u041D\u0410\u042F \u0411\u0415\u0417\u041E\u041F\u0410\u0421\u041D\u041E\u0421\u0422\u042C \u0421\u0415\u0420\u0412\u0418\u0421\u0410'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.1. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435 \u043D\u0430\u0440\u0443\u0448\u0430\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0447\u0442\u043E \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.1.1. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043B\u044E\u0431\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043D\u0435 \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u043E\u0439 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u043E\u0434 \u043B\u043E\u0433\u0438\u043D\u043E\u043C (\u043D\u043E\u043C\u0435\u0440\u043E\u043C \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430), \u043D\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u043C \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.1.2. \u041F\u043E\u043F\u044B\u0442\u043A\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0443\u044F\u0437\u0432\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0431\u0435\u0437 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.1.3. \u041F\u043E\u043F\u044B\u0442\u043A\u0438 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043E\u043C\u0435\u0445\u0438 \u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C, \u0447\u0442\u043E \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0445 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C, \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435, \u0438\u0441\u043A\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u0443\u044E \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0435\u0439\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043F\u0435\u0440\u0435\u0441\u044B\u043B\u043A\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0440\u0432\u0435\u0440 \u0441\u0430\u0439\u0442\u0430, \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0443\u044E \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u0431\u043E\u043B\u044C\u0448\u043E\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0438/\u0438\u043B\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u0441 \u0446\u0435\u043B\u044C\u044E \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u043E \u0432\u044B\u0432\u0435\u0441\u0442\u0438 \u0441\u0435\u0440\u0432\u0435\u0440 \u0441\u0430\u0439\u0442\u0430 \u0438\u0437 \u0441\u0442\u0440\u043E\u044F \u0438 \u0442\u043E\u043C\u0443 \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0432\u044B\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0437\u0430 \u0440\u0430\u043C\u043A\u0438 \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0446\u0435\u043B\u0435\u0432\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u043D\u044B\u0435 \u0443\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u043E \u0438\u043B\u0438 \u043F\u043E \u043D\u0435\u043E\u0441\u0442\u043E\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0441\u0431\u043E\u0438 \u0432 \u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0442\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.2. \u041D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u043E\u0439 \u0441\u0435\u0442\u0438 \u0432\u043B\u0435\u0447\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0443\u044E \u0438 \u0443\u0433\u043E\u043B\u043E\u0432\u043D\u0443\u044E \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0441\u043B\u0443\u0447\u0430\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0433\u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0441\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0432 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0435 \u0441 \u043A\u043E\u043C\u043F\u0435\u0442\u0435\u043D\u0442\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u0440\u0435\u0441\u0435\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u0434\u043E\u0431\u043D\u043E\u0439 \u0437\u043B\u043E\u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.3. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0435\u0442 \u0432\u0441\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u0443\u0441\u0438\u043B\u0438\u044F \u0434\u043B\u044F \u0442\u043E\u0433\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u0431\u0435\u0436\u0430\u0442\u044C \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.4. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u0435\u0434\u0448\u0435\u0435 \u0438\u0437-\u0437\u0430:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.4.1. \u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u043C \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0438, \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445 \u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u044B\u0445 \u0441\u0435\u0442\u044F\u0445, \u043D\u0430\u0445\u043E\u0434\u044F\u0449\u0438\u0445\u0441\u044F \u0432\u043D\u0435 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.4.2. \u041F\u0435\u0440\u0435\u0431\u043E\u0435\u0432 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u043C \u0438\u043B\u0438 \u043D\u0435\u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043F\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438;'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.4.3. \u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043F\u0430\u0440\u043E\u043B\u0435\u0439 \u0438\u043B\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0434\u0440\u0443\u0433\u0438\u043C \u043B\u0438\u0446\u0430\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '12.5. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0435 \u043D\u0435\u0446\u0435\u043B\u0435\u0432\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438\u043B\u0438 \u0438\u043D\u044B\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u0431\u0435\u0437 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F \u0441 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '13. \u041E\u0411\u041D\u041E\u0412\u041B\u0415\u041D\u0418\u042F/\u041D\u041E\u0412\u042B\u0415 \u0412\u0415\u0420\u0421\u0418\u0418'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '13.1. \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0432\u0441\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F/\u043D\u043E\u0432\u044B\u0435 \u0432\u0435\u0440\u0441\u0438\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043D\u044B\u0445 \u0447\u0430\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044F\u0441\u044C \u0441 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u043E\u0439 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F/\u043D\u043E\u0432\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439/\u043D\u043E\u0432\u044B\u0445 \u0432\u0435\u0440\u0441\u0438\u0439 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u0435\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435/\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438 \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043D\u0435 \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u0435\u0442\u0441\u044F \u0438\u043D\u044B\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '13.2. \u0412 \u0441\u043E\u0441\u0442\u0430\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u0435\u0435 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432 \u0432\u0445\u043E\u0434\u0438\u0442 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u2013 \u042F\u043D\u0434\u0435\u043A\u0441. \u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u0438 Google Analytics. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0433\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u044B \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://yandex.ru/legal/metrica_termsofuse/' },
	        'https://yandex.ru/legal/metrica_termsofuse/'
	      ),
	      ' ',
	      '\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://support.google.com/analytics/answer/4597324?hl=ru' },
	        'https://support.google.com/analytics/answer/4597324?hl=ru'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '14. \u0418\u041D\u042B\u0415 \u041F\u041E\u041B\u041E\u0416\u0415\u041D\u0418\u042F'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.1. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0434\u0430\u0435\u0442 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439 \u0438 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043D\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u043E\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0423\u0441\u043B\u0443\u0433 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0446\u0435\u043B\u044F\u043C \u0438/\u0438\u043B\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043B\u0438\u0448\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u0440\u043E\u0431\u043D\u043E\u0433\u043E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430, \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0432 \u0435\u0433\u043E \u043E\u0431 \u044D\u0442\u043E\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u043E \u0441\u0435\u0431\u0435 \u0432 \u041B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.2. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D \u0438 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u0435, \u0447\u0442\u043E \u0432\u0441\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043E\u0447\u0435\u0440\u0435\u0434\u0438, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u0442\u044C \u044D\u0442\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0435 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.3. \u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E C\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0431\u0440\u0430\u0449\u0430\u0442\u044C\u0441\u044F \u043A \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E. \u0412\u0441\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u044B \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043B\u0438\u0431\u043E \u043D\u0430 \u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043D\u0438\u0436\u0435. \u0424\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0438\u043D\u044B\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439 \u043A \u041F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.4. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0438 \u0442\u043E\u043B\u043A\u0443\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438. \u0412\u043E\u043F\u0440\u043E\u0441\u044B, \u043D\u0435 \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u043F\u043E\u0434\u043B\u0435\u0436\u0430\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.5. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435, \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0440\u0443\u0441\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435, \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C, \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u0441\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0430\u0434\u0440\u0435\u0441\u043E\u0432\u0430\u043D\u0430 \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u043C\u0443 \u043A\u0440\u0443\u0433\u0443 \u043B\u0438\u0446.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '14.6. \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0432 \u0434\u0430\u043D\u043D\u043E\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0438 \u0432\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443 \u0441 01 \u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F 2024 \u0433\u043E\u0434\u0430.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      '\u041F\u0420\u0410\u0412\u041E\u041E\u0411\u041B\u0410\u0414\u0410\u0422\u0415\u041B\u042C:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB',
	      _react2.default.createElement('br', null),
	      '\u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001, \u041E\u0413\u0420\u041D: 1162366056830',
	      _react2.default.createElement('br', null),
	      '\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441: 354207, \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433. \u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u0443\u043B. \u041B\u0435\u0442\u043D\u044F\u044F, \u0441\u0442\u0440. \u211615/2',
	      _react2.default.createElement('br', null),
	      '\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441: 354000, \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433. \u0421\u043E\u0447\u0438, \u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0439\u043E\u043D, \u043F\u0435\u0440. \u041C\u043E\u0440\u0441\u043A\u043E\u0439, \u0434.1/1\u0430',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      '\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B:',
	      _react2.default.createElement('br', null),
	      '\u0440/\u0441\u0447 40702810012250003417',
	      _react2.default.createElement('br', null),
	      '\u0432 \u0424\u0438\u043B\u0438\u0430\u043B\u0435 \u042E\u0436\u043D\u044B\u0439 \u041F\u0410\u041E \u0411\u0430\u043D\u043A\u0430 \xAB\u0424\u041A \u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435\xBB',
	      _react2.default.createElement('br', null),
	      '\u0411\u0418\u041A 046015061',
	      _react2.default.createElement('br', null),
	      '\u043A/\u0441\u0447 30101810560150000061',
	      _react2.default.createElement('br', null)
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'E-mail: ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto: https://content@nedvex.ru/' },
	        'content@nedvex.ru'
	      )
	    )
	  );
	};
	
	exports.default = UserAgreement;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Code = undefined;
	
	var _regenerator = __webpack_require__(39);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactQuery = __webpack_require__(394);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactInputVerificationCode = __webpack_require__(1994);
	
	var _reactInputVerificationCode2 = _interopRequireDefault(_reactInputVerificationCode);
	
	var _loginForms = __webpack_require__(161);
	
	var _styles = __webpack_require__(338);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Config = __webpack_require__(16);
	
	var _Timer = __webpack_require__(1133);
	
	var _Timer2 = _interopRequireDefault(_Timer);
	
	var _Button = __webpack_require__(506);
	
	var _common = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var sendCode = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref2) {
	    var phone = _ref2.phone,
	        code = _ref2.code,
	        type = _ref2.type;
	
	    var url, _axios$post, response;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            url = type === _common.Types.Call ? _Config.ROOT_URL + '/calls/checkpin ' : _Config.ROOT_URL + '/user/sms/login';
	            _context.prev = 1;
	            _context.next = 4;
	            return _axios2.default.post(url, (_axios$post = {
	              phone: phone.match(/\d+/g).join('')
	            }, _defineProperty(_axios$post, type === _common.Types.Call ? 'pin' : 'code', code), _defineProperty(_axios$post, 'platform', 'web'), _axios$post));
	
	          case 4:
	            response = _context.sent;
	            return _context.abrupt('return', response.data.data);
	
	          case 8:
	            _context.prev = 8;
	            _context.t0 = _context['catch'](1);
	            return _context.abrupt('return', Promise.reject(_context.t0.response.data.error['error-code']));
	
	          case 11:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[1, 8]]);
	  }));
	
	  return function sendCode(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var Code = exports.Code = function Code(_ref3) {
	  var _cn;
	
	  var phone = _ref3.phone,
	      type = _ref3.type,
	      goToPhoneStep = _ref3.goToPhoneStep;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      code = _useState2[0],
	      setCode = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isResending = _useState4[0],
	      setIsResending = _useState4[1];
	
	  var _useQuery = (0, _reactQuery.useQuery)(['code', { phone: phone, code: code, type: type, isResending: isResending }], function () {
	    return sendCode({ phone: phone, code: code, type: type });
	  }, {
	    enabled: false,
	    retry: 0,
	    onError: function onError(error) {
	      if (error === 'ERROR_INVALID_PIN' || error === 'USER_NOT_FOUND') {
	        setTimeout(function () {
	          try {
	            setCode('');
	          } catch (e) {}
	        }, 7000);
	      }
	    }
	  }),
	      data = _useQuery.data,
	      codeError = _useQuery.error,
	      isLoadingCode = _useQuery.isLoading,
	      postCode = _useQuery.refetch;
	
	  (0, _react.useEffect)(function () {
	    if (!data) {
	      return;
	    }
	
	    dispatch((0, _loginForms.login)(data));
	  }, [data]);
	
	  var getError = function getError(error) {
	    if (!error) {
	      return null;
	    }
	
	    if (error === 'USER_NOT_FOUND') {
	      return t('containers.logIn.error-code-sms');
	    }
	
	    if (error === 'ERROR_INVALID_PIN') {
	      return t('containers.logIn.error-code-phone');
	    }
	
	    return t('components.login.formNumber.serverError');
	  };
	
	  var handleReset = function handleReset() {
	    setIsResending(true);
	    return (0, _common.sendPhone)({ phone: phone, type: type }).finally(function () {
	      setIsResending(false);
	    });
	  };
	  var error = getError(codeError);
	
	  (0, _react.useEffect)(function () {
	    var handleEnter = function handleEnter(e) {
	      if (e.key !== 'Enter') {
	        return;
	      }
	
	      if (isLoadingCode) {
	        return;
	      }
	
	      if (isResending) {
	        return;
	      }
	
	      var isValid = code.length === (type === _common.Types.Call ? 4 : 5);
	
	      if (!isValid) {
	        return;
	      }
	
	      postCode();
	    };
	
	    document.addEventListener('keypress', handleEnter);
	
	    return function () {
	      document.removeEventListener('keypress', handleEnter);
	    };
	  }, [code, isResending, isLoadingCode]);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.CodeInputContainer, (_cn = {}, _defineProperty(_cn, _styles2.default.CodeInputContainerPhone, type === _common.Types.Call), _defineProperty(_cn, _styles2.default.CodeInputContainerSMS, type === _common.Types.Sms), _defineProperty(_cn, _styles2.default.CodeInputContainerError, !!error), _cn))
	      },
	      _react2.default.createElement(_reactInputVerificationCode2.default, {
	        autoFocus: true,
	        length: type === _common.Types.Call ? 4 : 5,
	        placeholder: '',
	        value: code,
	        onChange: setCode
	      })
	    ),
	    _react2.default.createElement('div', {
	      className: (0, _classnames2.default)(_styles2.default.LoginFormHint, _defineProperty({}, _styles2.default.LoginFormHintError, error)),
	      dangerouslySetInnerHTML: { __html: error || t('containers.logIn.hint-code-' + type) }
	    }),
	    _react2.default.createElement(_Timer2.default, {
	      textLocale: type === _common.Types.Call ? 'containers.logIn.recall' : 'containers.logIn.resend',
	      resetLocale: type === _common.Types.Call ? 'containers.logIn.doRecall' : 'containers.logIn.doResend',
	      secondsLimit: 60,
	      onReset: handleReset
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.LoginFormButtons },
	      _react2.default.createElement(
	        _Button.Button,
	        {
	          onClick: postCode,
	          isPrimary: true,
	          isLoading: isLoadingCode,
	          isDisabled: !code || code.length < (type === _common.Types.Call ? 4 : 5) || isResending
	        },
	        t('containers.logIn.buttons.enter')
	      ),
	      _react2.default.createElement(
	        _Button.Button,
	        { isDisabled: isLoadingCode, onClick: goToPhoneStep },
	        t('containers.logIn.buttons.back')
	      )
	    )
	  );
	};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Phone = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQuery = __webpack_require__(394);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactInputMask = __webpack_require__(385);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(338);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Button = __webpack_require__(506);
	
	var _common = __webpack_require__(220);
	
	var _ga = __webpack_require__(7);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Phone = exports.Phone = function Phone(_ref) {
	  var goToPhoneStep = _ref.goToPhoneStep,
	      showErrorModal = _ref.showErrorModal,
	      goToCodeStep = _ref.goToCodeStep,
	      type = _ref.type,
	      setType = _ref.setType,
	      setPhone = _ref.setPhone,
	      showRegistration = _ref.showRegistration,
	      phone = _ref.phone;
	
	  var refInput = (0, _react.useRef)();
	
	  var _useQuery = (0, _reactQuery.useQuery)(['code', phone, type], function () {
	    return (0, _common.sendPhone)({ phone: phone, type: type });
	  }, {
	    onSuccess: function onSuccess() {
	      goToCodeStep();
	      setPhone(phone);
	    },
	    onError: function onError(error) {
	      if (error === 'ERROR_SEND_CALL') {
	        showErrorModal();
	        return;
	      }
	
	      if (error === 'INTERNAL_ERROR') {
	        showErrorModal();
	        return;
	      }
	
	      if (error === 'USER_NOT_FOUND') {
	        goToPhoneStep();
	        showRegistration();
	      }
	    }
	  }),
	      phoneError = _useQuery.error,
	      isLoadingPhone = _useQuery.isLoading,
	      postPhone = _useQuery.refetch;
	
	  (0, _react.useEffect)(function () {
	    if (!refInput.current) {
	      return;
	    }
	
	    var handleEnter = function handleEnter(e) {
	      if (e.key !== 'Enter') {
	        return;
	      }
	
	      if (isLoadingPhone) {
	        return;
	      }
	
	      if (phone.length !== 18) {
	        return;
	      }
	
	      postPhone();
	    };
	
	    document.addEventListener('keypress', handleEnter);
	
	    return function () {
	      document.removeEventListener('keypress', handleEnter);
	    };
	  }, [refInput.current, phone, isLoadingPhone]);
	
	  var debouncedEnterPhoneEvent = (0, _lodash2.default)(function () {
	    (0, _ga.trackGA)(_ga.gaEvent.loginPhoneInput());
	  }, 3000);
	
	  (0, _react.useEffect)(function () {
	    if (phone.length >= 7) {
	      debouncedEnterPhoneEvent();
	    }
	
	    return function () {
	      debouncedEnterPhoneEvent.cancel();
	    };
	  }, [phone]);
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var toggleType = function toggleType() {
	    setType(function (prev) {
	      return prev === _common.Types.Call ? _common.Types.Sms : _common.Types.Call;
	    });
	    (0, _ga.trackGA)(_ga.gaEvent.loginButtonsClick({ eventLabel: type === _common.Types.Call ? 'voiti_po_sms' : 'voiti_po_zvonku' }));
	  };
	  var getError = function getError(error) {
	    if (!error) {
	      return null;
	    }
	
	    if (error === 'USER_NOT_FOUND') {
	      return t('components.login.formNumber.userNotFound');
	    }
	
	    return t('components.login.formNumber.serverError');
	  };
	
	  var error = getError(phoneError);
	
	  var handleInputChange = function handleInputChange(_ref2) {
	    var target = _ref2.target;
	    var value = target.value;
	
	    setPhone(value);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactInputMask2.default, {
	      ref: refInput,
	      type: 'tel',
	      className: _styles2.default.PhoneInput,
	      'data-key': 'phoneNumber',
	      value: phone,
	      placeholder: '+7 (XXX) XXX XX-XX',
	      onChange: handleInputChange,
	      mask: '+7 (999) 999 99-99',
	      maskChar: ''
	    }),
	    _react2.default.createElement('div', {
	      className: (0, _classnames2.default)(_styles2.default.LoginFormHint, _defineProperty({}, _styles2.default.LoginFormHintError, error)),
	      dangerouslySetInnerHTML: { __html: error || t('containers.logIn.hint-phone-' + type) }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.LoginFormButtons },
	      _react2.default.createElement(
	        _Button.Button,
	        {
	          isLoading: isLoadingPhone,
	          isDisabled: phone.length !== 18,
	          onClick: function onClick() {
	            postPhone();
	            (0, _ga.trackGA)(_ga.gaEvent.loginButtonsClick({ eventLabel: 'prodolzhit' }));
	          },
	          isPrimary: true
	        },
	        t('containers.logIn.buttons.continue')
	      ),
	      _react2.default.createElement(
	        _Button.Button,
	        { isDisabled: isLoadingPhone, onClick: toggleType },
	        type === _common.Types.Call ? t('containers.logIn.buttons.bySms') : t('containers.logIn.buttons.byCall')
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.LoginFormRegistration },
	      _react2.default.createElement(
	        'span',
	        {
	          onClick: function onClick() {
	            showRegistration();
	            (0, _ga.trackGA)(_ga.gaEvent.loginButtonsClick({ eventLabel: 'zaregistriruites' }));
	          }
	        },
	        t('containers.logIn.registration')
	      )
	    )
	  );
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Modal = __webpack_require__(314);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _common = __webpack_require__(220);
	
	var _styles = __webpack_require__(1471);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TechnicalProblem(_ref) {
	  var handleCloseModal = _ref.handleCloseModal,
	      type = _ref.type;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      isOpen: true,
	      handleClose: handleCloseModal,
	      classNames: {
	        titleClassName: _styles2.default.ModalTitle,
	        bodyClassName: _styles2.default.ModalBody,
	        closeClassName: _styles2.default.ModalClose
	      },
	      title: t('containers.logIn.technicalProblem.title'),
	      contentStyle: {
	        maxWidth: '623px',
	        width: 'calc(100% - 40px)'
	      }
	    },
	    type === _common.Types.Call ? t('containers.logIn.technicalProblem.phone-call') : t('containers.logIn.technicalProblem.phone-sms')
	  );
	}
	
	exports.default = TechnicalProblem;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(4);
	
	var _resend = __webpack_require__(1579);
	
	var _resend2 = _interopRequireDefault(_resend);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1472);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Timer = function Timer(_ref) {
	  var _ref$secondsLimit = _ref.secondsLimit,
	      secondsLimit = _ref$secondsLimit === undefined ? 60 : _ref$secondsLimit,
	      textLocale = _ref.textLocale,
	      onReset = _ref.onReset,
	      resetLocale = _ref.resetLocale;
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var _useState = (0, _react.useState)(secondsLimit),
	      _useState2 = _slicedToArray(_useState, 2),
	      seconds = _useState2[0],
	      setSeconds = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isActive = _useState4[0],
	      setIsActive = _useState4[1];
	
	  var isLoading = (0, _react.useRef)(false);
	  var handleReset = function handleReset() {
	    if (isLoading.current) {
	      return;
	    }
	
	    isLoading.current = true;
	
	    onReset().finally(function () {
	      isLoading.current = false;
	      setSeconds(secondsLimit);
	      setIsActive(true);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (!isActive) {
	      return;
	    }
	
	    var timeout = void 0;
	    var runTimer = function runTimer() {
	      timeout = setTimeout(function () {
	        setSeconds(function (prevSeconds) {
	          if (prevSeconds >= 2) {
	            runTimer();
	            return prevSeconds - 1;
	          }
	
	          setIsActive(false);
	          return 0;
	        });
	      }, 1000);
	    };
	
	    runTimer();
	
	    return function () {
	      clearTimeout(timeout);
	    };
	  }, [isActive]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.TimerContainer, _defineProperty({}, _styles2.default.Resend, !isActive))
	    },
	    isActive ? t(textLocale, { sec: seconds }) : _react2.default.createElement(
	      'span',
	      { className: _styles2.default.Resend, onClick: handleReset },
	      _react2.default.createElement('img', { src: _resend2.default }),
	      ' ',
	      t(resetLocale)
	    )
	  );
	};
	
	exports.default = Timer;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Form = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(338);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactI18next = __webpack_require__(4);
	
	var _Phone = __webpack_require__(1131);
	
	var _Code = __webpack_require__(1130);
	
	var _common = __webpack_require__(220);
	
	var _Login = __webpack_require__(484);
	
	var _TechnicalProblem = __webpack_require__(1132);
	
	var _TechnicalProblem2 = _interopRequireDefault(_TechnicalProblem);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = exports.Form = function Form() {
	  var _useState = (0, _react.useState)(_common.Steps.Phone),
	      _useState2 = _slicedToArray(_useState, 2),
	      step = _useState2[0],
	      setStep = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(_common.Types.Call),
	      _useState4 = _slicedToArray(_useState3, 2),
	      type = _useState4[0],
	      setType = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      showRegistration = _useState6[0],
	      setShowRegistration = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      isTechnicalProblem = _useState8[0],
	      setIsTechnicalProblem = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      phone = _useState10[0],
	      setPhone = _useState10[1];
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var goToCodeStep = function goToCodeStep() {
	    return setStep(_common.Steps.Code);
	  };
	  var goToPhoneStep = function goToPhoneStep() {
	    return setStep(_common.Steps.Phone);
	  };
	
	  var toggleRegistration = function toggleRegistration() {
	    setShowRegistration(function (prev) {
	      return !prev;
	    });
	    (0, _ga.trackGA)(_ga.gaEvent.registrationPopupShow());
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.LoginForm },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.LoginFormTitle },
	        t('containers.logIn.title-' + step)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.LoginFormSubTitle },
	        t('containers.logIn.subtitle-' + step)
	      ),
	      step === _common.Steps.Phone ? _react2.default.createElement(_Phone.Phone, {
	        showRegistration: toggleRegistration,
	        goToCodeStep: goToCodeStep,
	        goToPhoneStep: goToPhoneStep,
	        type: type,
	        phone: phone,
	        setType: setType,
	        setPhone: setPhone,
	        showErrorModal: function showErrorModal() {
	          return setIsTechnicalProblem(true);
	        }
	      }) : _react2.default.createElement(_Code.Code, {
	        phone: phone,
	        type: type,
	        goToPhoneStep: goToPhoneStep
	      })
	    ),
	    showRegistration && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Registration },
	      _react2.default.createElement(_Login.FormRegistration, {
	        phone: phone,
	        handleRegistrationSuccessfully: function handleRegistrationSuccessfully() {
	          return setShowRegistration(false);
	        },
	        handleRegistrationError: function handleRegistrationError() {
	          return setIsTechnicalProblem(true);
	        },
	        handleCloseModal: function handleCloseModal() {
	          return setShowRegistration(false);
	        }
	      })
	    ),
	    isTechnicalProblem && _react2.default.createElement(_TechnicalProblem2.default, {
	      type: type,
	      handleCloseModal: function handleCloseModal() {
	        return setIsTechnicalProblem(false);
	      }
	    })
	  );
	};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Login = __webpack_require__(484);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _profile = __webpack_require__(40);
	
	var _loginForms = __webpack_require__(161);
	
	var _Login3 = __webpack_require__(1473);
	
	var _Login4 = _interopRequireDefault(_Login3);
	
	var _reactI18next = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _tariffs = __webpack_require__(1594);
	
	var _tariffs2 = _interopRequireDefault(_tariffs);
	
	var _Notification = __webpack_require__(485);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_PureComponent) {
	  _inherits(Login, _PureComponent);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.state = {
	      toggle: false,
	      isScrollButtonVisible: false,
	      isTechnicalProblem: false,
	      name: '',
	      surName: '',
	      currentWork: '',
	      phoneNumber: '',
	      email: ''
	    };
	
	    _this.handleRegistrationError = _this.handleRegistrationError.bind(_this);
	    _this.handleRegistrationSuccessfully = _this.handleRegistrationSuccessfully.bind(_this);
	    _this.handleScrollPage = _this.handleScrollPage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScrollPage);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScrollPage);
	    }
	  }, {
	    key: 'handleScrollPage',
	    value: function handleScrollPage() {
	      var isScrollButtonVisible = this.state.isScrollButtonVisible;
	
	      if (pageYOffset > 400 && !isScrollButtonVisible) {
	        this.setState({ isScrollButtonVisible: true });
	      } else if (pageYOffset <= 400 && isScrollButtonVisible) {
	        this.setState({ isScrollButtonVisible: false });
	      }
	    }
	  }, {
	    key: 'handleRegistrationSuccessfully',
	    value: function handleRegistrationSuccessfully() {
	      this.setState({ toggle: false });
	    }
	  }, {
	    key: 'handleRegistrationError',
	    value: function handleRegistrationError() {
	      this.setState({ toggle: false, isTechnicalProblem: true });
	    }
	  }, {
	    key: 'handleScrollToUp',
	    value: function handleScrollToUp() {
	      window.scroll({
	        top: 0,
	        behavior: 'smooth'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loginState = _props.loginState,
	          t = _props.t,
	          history = _props.history,
	          rest = _objectWithoutProperties(_props, ['loginState', 't', 'history']);
	
	      var _state = this.state,
	          isScrollButtonVisible = _state.isScrollButtonVisible,
	          toggle = _state.toggle,
	          isTechnicalProblem = _state.isTechnicalProblem;
	
	
	      var LoginComponent = _Login2.default['Form' + loginState];
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Login4.default.Login },
	        _react2.default.createElement(
	          'div',
	          { className: _Login4.default.Header },
	          _react2.default.createElement('div', { className: _Login4.default.Divider }),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://nedvex.ru/' },
	            _react2.default.createElement('div', { className: _Login4.default.Logo })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Login4.default.Telephones },
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + t('containers.login.phone1Link') },
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Telephone },
	                _react2.default.createElement('div', { className: _Login4.default.IconTelephone }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.phone1')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + t('containers.login.phone2Link') + '}' },
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Telephone },
	                _react2.default.createElement('div', { className: _Login4.default.IconTelephone }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.phone2')
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Login4.default.Content },
	          _react2.default.createElement(
	            'div',
	            { className: _Login4.default.Title },
	            _react2.default.createElement(
	              'h1',
	              null,
	              t('containers.login.title1')
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              t('containers.login.title2')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Login4.default.Info },
	            _react2.default.createElement(
	              'div',
	              { className: _Login4.default.Left },
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Description },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.description1')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.description2')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.ImagesGroup },
	                _react2.default.createElement('div', { className: _Login4.default.Background }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Login4.default.AppButtons },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://apps.apple.com/ru/app/nedvex/id1079767992', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement('div', { className: _Login4.default.AppStore })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://play.google.com/store/apps/details?id=ru.andrroider.apps.nedvex&hl=ru&gl=US', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement('div', { className: _Login4.default.GooglePlay })
	                  )
	                ),
	                _react2.default.createElement('div', { className: _Login4.default.MackBook })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Login4.default.Right },
	              _react2.default.createElement(LoginComponent, _extends({}, rest, { onOpenRegistration: function onOpenRegistration() {
	                  return _this2.setState({ toggle: true });
	                } }))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Login4.default.About },
	            _react2.default.createElement(
	              'div',
	              { className: _Login4.default.SubGroup },
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Item },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  '3 500'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.about1')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Item },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  '80%'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.about2')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Login4.default.SubGroup },
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Item },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  '2 000'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.about3')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Login4.default.Item },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  '50+'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('containers.login.about4')
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Login4.default.Footer },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Login4.default.SubGroup, _Login4.default.SubGroup1) },
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: t('containers.login.footer1') } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Login4.default.SubGroup, _Login4.default.SubGroup2) },
	            _react2.default.createElement('a', {
	              href: 'https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip',
	              target: '_blank',
	              dangerouslySetInnerHTML: { __html: t('containers.login.footer2') }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_Login4.default.SubGroup, _Login4.default.SubGroup3) },
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              t('containers.login.footer3'),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://app.nedvex.ru/policy', target: '_blank' },
	                t('containers.login.docs')
	              )
	            )
	          )
	        ),
	        isScrollButtonVisible && _react2.default.createElement(
	          'div',
	          { className: _Login4.default.ScrollButton, onClick: this.handleScrollToUp },
	          _react2.default.createElement('div', { className: _Login4.default.ScrollButtonIcon })
	        ),
	        '1',
	        toggle && _react2.default.createElement(_Login.FormRegistration, {
	          handleRegistrationSuccessfully: this.handleRegistrationSuccessfully,
	          handleRegistrationError: this.handleRegistrationError,
	          handleCloseModal: function handleCloseModal() {
	            return _this2.setState({ toggle: false });
	          }
	        }),
	        isTechnicalProblem && _react2.default.createElement(_Login.FormTechnicalProblem, { handleCloseModal: function handleCloseModal() {
	            return _this2.setState({ isTechnicalProblem: false });
	          } })
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state.loginForms;
	}, {
	  inviteFormSending: _loginForms.inviteFormSending,
	  numberFormSending: _loginForms.numberFormSending,
	  smsFormSending: _loginForms.smsFormSending,
	  restoreFormSending: _loginForms.restoreFormSending,
	  reconnectFormSending: _loginForms.reconnectFormSending,
	  userLogout: _loginForms.userLogout,
	  loadProfile: _profile.loadProfile
	})((0, _reactI18next.withTranslation)()((0, _reactRouterDom.withRouter)(Login)));

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(1576);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _img = __webpack_require__(1574);
	
	var _img2 = _interopRequireDefault(_img);
	
	var _laptop = __webpack_require__(1575);
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	var _appStore = __webpack_require__(1573);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _mobileLogo = __webpack_require__(1577);
	
	var _mobileLogo2 = _interopRequireDefault(_mobileLogo);
	
	var _play = __webpack_require__(1578);
	
	var _play2 = _interopRequireDefault(_play);
	
	var _reactI18next = __webpack_require__(4);
	
	var _styles = __webpack_require__(1474);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Form = __webpack_require__(1134);
	
	var _ga = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var year = new Date().getFullYear();
	
	var Login = function Login() {
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var location = (0, _reactRouterDom.useLocation)();
	
	  (0, _react.useEffect)(function () {
	    (0, _ga.trackGA)(_ga.gaEvent.pageShow({
	      screenName: location.pathname
	    }));
	
	    var params = new URLSearchParams(location.search);
	    var refLink = params.get('ref');
	    if (refLink) {
	      localStorage.setItem('ref', refLink);
	    }
	  }, []);
	
	  var handleLinkClick = function handleLinkClick(store) {
	    (0, _ga.trackGA)(_ga.gaEvent.downloadAppClick({ eventContent: store }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.Wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Container },
	      _react2.default.createElement(
	        'section',
	        { className: _styles2.default.LeftSide },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.LeftSideTitle },
	          _react2.default.createElement('img', { src: _logo2.default, alt: 'nedvex' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.LeftSideDescription },
	          _react2.default.createElement(
	            'div',
	            null,
	            t('containers.logIn.description.1')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            t('containers.logIn.description.2')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.LeftSideLaptop },
	          _react2.default.createElement('img', { src: _img2.default, alt: '' }),
	          _react2.default.createElement('img', { className: _styles2.default.LeftSideLaptopImg, src: _laptop2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.LeftSideStores },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '__blank',
	                href: 'https://apps.apple.com/ru/app/nedvex/id1079767992',
	                rel: 'noopener noreferrer',
	                onClick: function onClick() {
	                  return handleLinkClick('app_store');
	                }
	              },
	              _react2.default.createElement('img', { src: _appStore2.default, alt: 'app store' })
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://play.google.com/store/apps/details?id=ru.andrroider.apps.nedvex&hl=ru&gl=US',
	                rel: 'noopener noreferrer',
	                target: '_blank',
	                onClick: function onClick() {
	                  return handleLinkClick('google_play');
	                }
	              },
	              _react2.default.createElement('img', { src: _play2.default, alt: 'google play' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: _styles2.default.RightSide },
	        _react2.default.createElement('img', { className: _styles2.default.MobileLogo, src: _mobileLogo2.default }),
	        _react2.default.createElement(_Form.Form, null),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.RightSideFooter },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.RightSideFooterLinks },
	              _react2.default.createElement(
	                'a',
	                {
	                  target: '__blank',
	                  href: 'https://app.nedvex.ru/policy',
	                  onClick: function onClick() {
	                    return (0, _ga.trackGA)(_ga.gaEvent.loginButtonsClick({
	                      eventLabel: 'politika_konfidencialnosti'
	                    }));
	                  }
	                },
	                t('containers.logIn.footer.privacy')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '__blank', href: 'https://app.nedvex.ru/eula' },
	                t('containers.logIn.footer.eula')
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('containers.logIn.footer.inn')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              t('containers.logIn.footer.ogrn')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('containers.logIn.footer.copyright', {
	                year: year
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Login;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(1135);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Login2.default;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Login = __webpack_require__(1137);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _loginForms = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logout = function (_Component) {
	  _inherits(Logout, _Component);
	
	  function Logout() {
	    _classCallCheck(this, Logout);
	
	    return _possibleConstructorReturn(this, (Logout.__proto__ || Object.getPrototypeOf(Logout)).apply(this, arguments));
	  }
	
	  _createClass(Logout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.userLogout();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Login2.default, null);
	    }
	  }]);
	
	  return Logout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { userLogout: _loginForms.userLogout })(Logout);

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Logout = __webpack_require__(1138);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Logout2.default;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Politika = __webpack_require__(1475);
	
	var _Politika2 = _interopRequireDefault(_Politika);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Politika = function (_Component) {
	    _inherits(Politika, _Component);
	
	    function Politika() {
	        _classCallCheck(this, Politika);
	
	        return _possibleConstructorReturn(this, (Politika.__proto__ || Object.getPrototypeOf(Politika)).apply(this, arguments));
	    }
	
	    _createClass(Politika, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _Politika2.default.Politika },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Politika2.default.Container },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        '\u041F\u041E\u041B\u0418\u0422\u0418\u041A\u0410 \u0412 \u041E\u0422\u041D\u041E\u0428\u0415\u041D\u0418\u0418 \u041E\u0411\u0420\u0410\u0411\u041E\u0422\u041A\u0418 \u041F\u0415\u0420\u0421\u041E\u041D\u0410\u041B\u042C\u041D\u042B\u0425 \u0414\u0410\u041D\u041D\u042B\u0425 \u0412 \u041E\u041E\u041E "\u041D\u0415\u0414\u0412\u0415\u041A\u0421"'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '1. \u041E\u0431\u0449\u0438\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '1.1. \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 (\u0434\u0430\u043B\u0435\u0435 \u2014 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430) \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430 \u043D\u0430 \u0437\u0430\u0449\u0438\u0442\u0443 \u043F\u0440\u0430\u0432 \u0438 \u0441\u0432\u043E\u0431\u043E\u0434 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446, \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u041E\u041E\u041E "\u041D\u0415\u0414\u0412\u0415\u041A\u0421" (\u0434\u0430\u043B\u0435\u0435 \u2014 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440).',
	                        _react2.default.createElement('br', null),
	                        '1.2. \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F. 2 \u0447. 1 \u0441\u0442. 18.1 \u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u0430 \u043E\u0442 27 \u0438\u044E\u043B\u044F 2006 \u0433. \u2116 152-\u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB (\u0434\u0430\u043B\u0435\u0435 \u2014 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB).',
	                        _react2.default.createElement('br', null),
	                        '1.3. \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F, \u043F\u043E\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u0435 \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0447. 1 \u0441\u0442. 14 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB, \u0438 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '2. \u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0431 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0435'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '2.1. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0432\u0435\u0434\u0435\u0442 \u0441\u0432\u043E\u044E \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0439, \u0433. \u0421\u043E\u0447\u0438, \u041C\u043E\u0440\u0441\u043A\u043E\u0439 \u043F\u0435\u0440. 1/1a.',
	                        _react2.default.createElement('br', null),
	                        '2.2. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0420\u0435\u0448\u0435\u0442\u043E\u0432 \u0420\u043E\u043C\u0430\u043D \u0410\u043D\u0430\u0442\u043E\u043B\u044C\u0435\u0432\u0438\u0447 (\u0442\u0435\u043B\u0435\u0444\u043E\u043D +7 (967) 655-6576) \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C \u0437\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.',
	                        _react2.default.createElement('br', null),
	                        '2.3. \u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0435\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: 354000, \u0433. \u0421\u043E\u0447\u0438, \u043F\u0435\u0440. \u041C\u043E\u0440\u0441\u043A\u043E\u0439 1/1 \u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '3. \u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0431 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '3.1. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0437\u0430\u043A\u043E\u043D\u043D\u043E\u0439 \u0438 \u0441\u043F\u0440\u0430\u0432\u0435\u0434\u043B\u0438\u0432\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0432\u043E\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u0439, \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u0439 \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0435\u0439, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0432 \u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430, \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u043E\u0432 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 \u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446.',
	                        _react2.default.createElement('br', null),
	                        '3.2. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0443 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445.',
	                        _react2.default.createElement('br', null),
	                        '3.3. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0438 \u043D\u0435\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438, \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0438 \u0431\u0435\u0437 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432.',
	                        _react2.default.createElement('br', null),
	                        '3.4. \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0441\u0431\u043E\u0440, \u0437\u0430\u043F\u0438\u0441\u044C, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044E, \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435 (\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435), \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 (\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435, \u0434\u043E\u0441\u0442\u0443\u043F), \u043E\u0431\u0435\u0437\u043B\u0438\u0447\u0438\u0432\u0430\u043D\u0438\u0435, \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0438 \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435.',
	                        _react2.default.createElement('br', null),
	                        '3.5. \u0411\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0435\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '4. \u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '4.1. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u0440\u0430\u0432\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0439 \u0441 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u043C, \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0447\u0430\u0441\u0442\u044C\u044E \u0432\u0442\u043E\u0440\u043E\u0439 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0434\u0435\u043A\u0441\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u043E\u0442 26 \u044F\u043D\u0432\u0430\u0440\u044F 1996 \u0433. \u2116 14-\u0424\u0417, (\u0434\u0430\u043B\u0435\u0435 \u2014 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432).',
	                        _react2.default.createElement('br', null),
	                        '4.2. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0432 \u0446\u0435\u043B\u044F\u0445 \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F \u043D\u043E\u0440\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u0424, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441 \u0446\u0435\u043B\u044C\u044E:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E \u043D\u043E\u0432\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u0430\u0445, \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0430\u043A\u0446\u0438\u044F\u0445 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0445.',
	                        _react2.default.createElement('br', null),
	                        '4.3. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0441 \u0438\u0445 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0433\u043E \u043D\u0430 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u0441 \u043D\u0438\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432. \u0412 \u0441\u043B\u0443\u0447\u0430\u044F\u0445, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB, \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435. \u0412 \u0438\u043D\u044B\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u043C \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0438\u043B\u0438 \u043F\u0440\u0438 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u043A\u043E\u043D\u043A\u043B\u044E\u0434\u0435\u043D\u0442\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439.',
	                        _react2.default.createElement('br', null),
	                        '4.4. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u0440\u043E\u043A\u043E\u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u0441 \u043D\u0438\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u043E\u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u0441 \u043D\u0438\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u0440\u043E\u043A\u0430, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u043F. 5 \u0447. 3 \u0441\u0442. 24 \u0447\u0430\u0441\u0442\u0438 \u043F\u0435\u0440\u0432\u043E\u0439 \u041D\u041A \u0420\u0424, \u0447. 1 \u0441\u0442. 29 \u0424\u0417 \xAB\u041E \u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u043E\u043C \u0443\u0447\u0451\u0442\u0435\xBB \u0438 \u0438\u043D\u044B\u043C\u0438 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u043C\u0438 \u0430\u043A\u0442\u0430\u043C\u0438.',
	                        _react2.default.createElement('br', null),
	                        '4.5. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0424\u0430\u043C\u0438\u043B\u0438\u044F, \u0438\u043C\u044F, \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u043E;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u041D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u041C\u0435\u0441\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0431 \u043E\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433\u0430\u0445.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '5. \u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0431 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0438 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '5.1. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0437\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044E \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0435\u0439, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB \u0438 \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u043C\u0438 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0438\u043C \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u043C\u0438 \u0430\u043A\u0442\u0430\u043C\u0438.',
	                        _react2.default.createElement('br', null),
	                        '5.2. \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u0445, \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043C\u0435\u0440 \u043F\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0438\u0445 \u0437\u0430\u0449\u0438\u0442\u044B \u043E\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u043E\u043C\u0435\u0440\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435, \u043A\u043E\u043F\u0438\u044F \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0430 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 (\u043F\u0440\u0438 \u0435\u0433\u043E \u043D\u0430\u043B\u0438\u0447\u0438\u0438);',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0432\u043E \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0438 \u043F\u0440\u0438\u0432\u043E\u0434\u0438\u0442 \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \xAB\u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0431 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB (\u0434\u0430\u043B\u0435\u0435 \u2014 \u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435) \u0438 \u0438\u043D\u044B\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u043A\u0442\u044B;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442 \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u043E\u0432 \u0441 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u0438 \u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0434\u043E\u043F\u0443\u0441\u043A \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u043E\u0432 \u043A \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C, \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u044B\u043C \u0432 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043A \u0438\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u043C \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F\u043C \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0442\u0440\u0443\u0434\u043E\u0432\u044B\u0445 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0435\u0439;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0435\u0442 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C, \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C\u044B\u043C \u0432 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0438 \u0443\u0447\u0451\u0442 \u0432\u0441\u0435\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0441 \u043D\u0438\u043C\u0438;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442 \u043E\u0446\u0435\u043D\u043A\u0443 \u0432\u0440\u0435\u0434\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0435\u043D \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u0430\u043C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0443\u0433\u0440\u043E\u0437 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0438 \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0432 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0437\u0430\u0449\u0438\u0442\u044B \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u0444\u0430\u043A\u0442\u043E\u0432 \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C \u0438 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043C\u0435\u0440\u044B \u043F\u043E \u0440\u0435\u0430\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0432\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043D\u0438\u043C;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442 \u043E\u0446\u0435\u043D\u043A\u0443 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u043C\u044B\u0445 \u043C\u0435\u0440 \u043F\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043E \u0432\u0432\u043E\u0434\u0430 \u0432 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB, \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u043C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0438\u043C \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u043C \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u043C \u0430\u043A\u0442\u0430\u043C, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u043A \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435, \u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E \u0438 \u0438\u043D\u044B\u043C \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u043C \u0430\u043A\u0442\u0430\u043C, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0437\u0430 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u043C\u044B\u043C\u0438 \u043C\u0435\u0440\u0430\u043C\u0438 \u043F\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 \u0438\u0445 \u0443\u0440\u043E\u0432\u043D\u044F \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0432 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '6. \u041F\u0440\u0430\u0432\u0430 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '6.1. \u0421\u0443\u0431\u044A\u0435\u043A\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043E\u0442\u043D\u043E\u0441\u044F\u0449\u0438\u0445\u0441\u044F \u043A \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u0443, \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043A\u0430\u0441\u0430\u044E\u0449\u0435\u0439\u0441\u044F \u0438\u0445 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430 \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0435, \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u043B\u0438 \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435 \u0435\u0433\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u043E\u043D\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043F\u043E\u043B\u043D\u044B\u043C\u0438, \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u043C\u0438, \u043D\u0435\u0442\u043E\u0447\u043D\u044B\u043C\u0438, \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u043C\u0438 \u0438\u043B\u0438 \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u043C\u0438 \u0434\u043B\u044F \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u0446\u0435\u043B\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430 \u043E\u0442\u0437\u044B\u0432 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430 \u0437\u0430\u0449\u0438\u0442\u0443 \u0441\u0432\u043E\u0438\u0445 \u043F\u0440\u0430\u0432 \u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043D\u0430 \u0432\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u0443\u0431\u044B\u0442\u043A\u043E\u0432 \u0438 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0438\u044E \u043C\u043E\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u0434\u0430 \u0432 \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430 \u043E\u0431\u0436\u0430\u043B\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0438\u043B\u0438 \u0431\u0435\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430 \u0432 \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043E\u0440\u0433\u0430\u043D \u043F\u043E \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0440\u0430\u0432 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0432 \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435.',
	                        _react2.default.createElement('br', null),
	                        '6.2. \u0414\u043B\u044F \u0440\u0435\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0432\u043E\u0438\u0445 \u043F\u0440\u0430\u0432 \u0438 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432 \u0441\u0443\u0431\u044A\u0435\u043A\u0442\u044B \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0443 \u043B\u0438\u0431\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441 \u043B\u0438\u0447\u043D\u043E \u0438\u043B\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044F. \u0417\u0430\u043F\u0440\u043E\u0441 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0432 \u0447. 3 \u0441\u0442. 14 \u0424\u0417 \xAB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\xBB.'
	                    )
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return Politika;
	}(_react.Component);
	
	exports.default = Politika;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Politika = __webpack_require__(1140);
	
	var _Politika2 = _interopRequireDefault(_Politika);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Politika2.default;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PopUp = __webpack_require__(1476);
	
	var _PopUp2 = _interopRequireDefault(_PopUp);
	
	var _ScrollLock = __webpack_require__(163);
	
	var _ScrollLock2 = _interopRequireDefault(_ScrollLock);
	
	var _close = __webpack_require__(542);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _cross = __webpack_require__(96);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	var _environment = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PopUp = function (_Component) {
	  _inherits(PopUp, _Component);
	
	  function PopUp(props) {
	    _classCallCheck(this, PopUp);
	
	    var _this = _possibleConstructorReturn(this, (PopUp.__proto__ || Object.getPrototypeOf(PopUp)).call(this, props));
	
	    _this.handleBackgroundClick = _this.handleBackgroundClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(PopUp, [{
	    key: 'handleBackgroundClick',
	    value: function handleBackgroundClick(event) {
	      var _props = this.props,
	          onBackgroundClick = _props.onBackgroundClick,
	          dispatch = _props.dispatch,
	          onClose = _props.onClose,
	          disableBackgroundClick = _props.disableBackgroundClick;
	
	
	      if (disableBackgroundClick) {
	        return;
	      }
	
	      if (onClose) {
	        onClose();
	      }
	
	      dispatch((0, _environment.setPopUp)(undefined));
	
	      if (onBackgroundClick) {
	        onBackgroundClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          backgroundClassName = _props2.backgroundClassName,
	          contentClassName = _props2.contentClassName,
	          closeIcon = _props2.closeIcon,
	          closeClassName = _props2.closeClassName,
	          closeStyleName = _props2.closeStyleName,
	          content = _props2.content,
	          contentStyleName = _props2.contentStyleName,
	          _props2$lockScroll = _props2.lockScroll,
	          lockScroll = _props2$lockScroll === undefined ? true : _props2$lockScroll,
	          hideCloseIcon = _props2.hideCloseIcon;
	
	
	      var iconClose = void 0;
	      switch (closeIcon) {
	        case 'default':
	          iconClose = _cross2.default;
	          break;
	        case 'gallery':
	          iconClose = _close2.default;
	          break;
	        default:
	          iconClose = _cross2.default;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_PopUp2.default.PopUp, className) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_PopUp2.default.Background, backgroundClassName) },
	          _react2.default.createElement('div', { className: _PopUp2.default.BackgroundOverlay, onClick: this.handleBackgroundClick }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_PopUp2.default.Content, _PopUp2.default[contentStyleName], contentClassName) },
	            content && (lockScroll ? _react2.default.createElement(
	              _ScrollLock2.default,
	              null,
	              content
	            ) : content),
	            !hideCloseIcon && _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_PopUp2.default.Close, _PopUp2.default[closeStyleName], closeClassName),
	                onClick: this.handleBackgroundClick
	              },
	              _react2.default.createElement('img', { alt: 'close', src: iconClose })
	            )
	          ),
	          closeIcon != 'default' ? _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_PopUp2.default.Close, _PopUp2.default[closeStyleName], closeClassName),
	              onClick: this.handleBackgroundClick
	            },
	            _react2.default.createElement('img', { alt: 'close', src: iconClose })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return PopUp;
	}(_react.Component);
	
	exports.default = PopUp;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PopUp = __webpack_require__(1142);
	
	var _PopUp2 = _interopRequireDefault(_PopUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PopUp2.default;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reselect = __webpack_require__(44);
	
	var _building = __webpack_require__(54);
	
	var _lodash = __webpack_require__(41);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(12);
	
	var _Building = __webpack_require__(309);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _BuildingTitle = __webpack_require__(476);
	
	var _BuildingTitle2 = _interopRequireDefault(_BuildingTitle);
	
	var _About = __webpack_require__(213);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Gallery = __webpack_require__(467);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _withValidTrafic = __webpack_require__(116);
	
	var _withValidTrafic2 = _interopRequireDefault(_withValidTrafic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var Building = (_dec = (0, _withValidTrafic2.default)(), _dec(_class = function (_Component) {
	  _inherits(Building, _Component);
	
	  function Building() {
	    _classCallCheck(this, Building);
	
	    var _this = _possibleConstructorReturn(this, (Building.__proto__ || Object.getPrototypeOf(Building)).call(this));
	
	    _this.handleImageLoad = function () {
	      if (!_this.imageCounter) {
	        _this.imageCounter = 0;
	      }
	      _this.imageCounter += 1;
	      if (Object.keys(_this.state.plans).length === _this.imageCounter) {
	        _this.print();
	      }
	    };
	
	    _this.print = function () {
	      setTimeout(window.print, 3000);
	      _this.setState({ hasBeenPrinted: true });
	    };
	
	    _this.state = {
	      hasBeenPrinted: false,
	      chessLoaded: false
	    };
	    _this.print = (0, _lodash2.default)(_this.print, 2000);
	    return _this;
	  }
	
	  _createClass(Building, [{
	    key: 'UNSAFE_componentWillMount',
	    value: function UNSAFE_componentWillMount() {
	      var _props = this.props,
	          loadBuilding = _props.loadBuilding,
	          loadPavilions = _props.loadPavilions,
	          loadChess = _props.loadChess,
	          params = _props.match.params;
	
	      loadBuilding(params.id).then(function (resp) {
	        resp.data.data.pavilions.map(function (pavilion) {
	          var sectionReqs = pavilion.sectionIds
	          // .filter(sectionId => query[`chess${sectionId}`] === 'true')
	          .map(function (sectionId) {
	            return loadChess({ id: sectionId });
	          });
	          return Promise.all(sectionReqs);
	        });
	      });
	      loadPavilions(params.id);
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!this.sections && nextProps.building.pavilions) {
	        this.sections = nextProps.building.pavilions.reduce(function (sections, pavilion) {
	          return _extends({}, sections, pavilion.sections.reduce(function (sections, section) {
	            return _extends({}, sections, _defineProperty({}, section.id, _extends({}, section, { pavilionName: pavilion.name })));
	          }, {}));
	        }, {});
	      }
	      if (this.sections && Object.keys(this.sections).every(function (sectionId) {
	        return nextProps.building.chessList[sectionId];
	      })) {
	        var plans = {};
	        var query = (0, _utils.parseQuery)(location.search);
	        Object.keys(nextProps.building.chessList).forEach(function (sectionId) {
	          return nextProps.building.chessList[sectionId].cells.forEach(function (_ref) {
	            var planId = _ref.planId,
	                row = _ref.row;
	
	            if (planId && query['plans' + planId] === 'true') {
	              plans[planId] = _extends({}, plans[planId] || {}, { row: row, sectionId: sectionId });
	            }
	          });
	        });
	        this.setState({
	          didReceiveSections: true,
	          plans: plans
	        });
	      }
	      if (!this.state.hasBeenPrinted &&
	      // this.state.chessLoaded &&
	      !nextProps.building.isPavilionsLoading && !nextProps.building.isChessLoading && !nextProps.building.isLoading && nextProps.building.pavilions && nextProps.building.chessList && nextProps.building.data) {
	        var _query = (0, _utils.parseQuery)(location.search);
	        if (!_query.roomPlan && Object.keys(_query).filter(function (key) {
	          return key.includes('plans') && _query[key] === 'true';
	        }).length === 0 && Object.keys(_query).filter(function (key) {
	          return key.includes('chess') && _query[key] === 'true';
	        }).length <= Object.keys(nextProps.building.chessList).length) {
	          setTimeout(this.print, 1000);
	          this.setState({ hasBeenPrinted: true });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          dispatch = _props2.dispatch,
	          building = _props2.building,
	          match = _props2.match,
	          params = _props2.match.params,
	          location = _props2.location,
	          search = _props2.search;
	
	      var query = (0, _utils.parseQuery)(location.search);
	      return _react2.default.createElement(_reactRouterDom.Route, {
	        render: function render(matchProps) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, {
	              render: function render() {
	                return _react2.default.createElement(_Building2.default.Main, _extends({}, matchProps, { dispatch: dispatch, params: params, building: building, print: query }));
	              }
	            }),
	            building.data && building.data.pavilions.map(function (pavilion) {
	              return _react2.default.createElement(
	                'div',
	                { key: pavilion.id },
	                pavilion.sectionIds.filter(function (sectionId) {
	                  return query['chess' + sectionId] === 'true';
	                }).map(function (sectionId, sectionIndex) {
	                  return building.chessList[sectionId] ? Array(Math.ceil(building.chessList[sectionId].cols.length / PAGE_SIZE)).fill(0).map(function (_, page) {
	                    return _react2.default.createElement(_Building2.default.Chess, _extends({}, matchProps, {
	                      dispatch: dispatch,
	                      match: match,
	                      key: page,
	                      page: page,
	                      pageSize: PAGE_SIZE,
	                      search: search,
	                      building: _extends({}, building, {
	                        filters: {
	                          section: [building.data.pavilions.indexOf(pavilion), sectionIndex]
	                        },
	                        isExtended: true
	                      }),
	                      print: true
	                    }));
	                  }) : null;
	                })
	              );
	            }),
	            _this2.state.plans && Object.keys(_this2.state.plans).map(function (planId) {
	              var plan = _this2.state.plans[planId];
	              return _react2.default.createElement(_Gallery2.default, {
	                building: building,
	                data: {
	                  planId: planId,
	                  data: { floorName: plan.row + 1 }
	                },
	                print: true,
	                sectionName: _this2.sections[plan.sectionId].name,
	                pavilionName: _this2.sections[plan.sectionId].pavilionName,
	                handleImageLoad: _this2.handleImageLoad,
	                handleImageError: _this2.handleImageLoad
	              });
	            }),
	            query.roomPlan && building.chessList[query.sectionId] && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_BuildingTitle2.default, {
	                building: building,
	                print: true
	              }),
	              _react2.default.createElement(_About2.default, {
	                building: building,
	                data: building.chessList[query.sectionId].cells.filter(function (room) {
	                  return room.id === query.roomPlan;
	                })[0],
	                handleImageLoad: _this2.print,
	                handleImageError: _this2.print,
	                print: true
	              })
	            )
	          );
	        }
	      });
	    }
	  }]);
	
	  return Building;
	}(_react.Component)) || _class);
	
	
	var buildingSelector = (0, _reselect.createSelector)(function (state) {
	  return state.building;
	}, function (state) {
	  return state.search;
	}, function (building, search) {
	  return { building: building, search: search };
	});
	
	exports.default = (0, _reactRedux.connect)(buildingSelector, { loadBuilding: _building.loadBuilding, loadPavilions: _building.loadPavilions, loadChess: _building.loadChess })(Building);

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintBuilding = __webpack_require__(1144);
	
	var _PrintBuilding2 = _interopRequireDefault(_PrintBuilding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PrintBuilding2.default;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _PublicOffer = __webpack_require__(1477);
	
	var _PublicOffer2 = _interopRequireDefault(_PublicOffer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicOffer = function (_Component) {
	    _inherits(PublicOffer, _Component);
	
	    function PublicOffer() {
	        _classCallCheck(this, PublicOffer);
	
	        return _possibleConstructorReturn(this, (PublicOffer.__proto__ || Object.getPrototypeOf(PublicOffer)).apply(this, arguments));
	    }
	
	    _createClass(PublicOffer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _PublicOffer2.default.Oferta },
	                _react2.default.createElement(
	                    'div',
	                    { className: _PublicOffer2.default.Container },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        '\u041F\u0423\u0411\u041B\u0418\u0427\u041D\u0410\u042F \u041E\u0424\u0415\u0420\u0422\u0410 \u041D\u0410 \u0417\u0410\u041A\u041B\u042E\u0427\u0415\u041D\u0418\u0415 \u0414\u041E\u0413\u041E\u0412\u041E\u0420\u0410 \u041E\u041A\u0410\u0417\u0410\u041D\u0418\u042F \u0423\u0421\u041B\u0423\u0413 \u041F\u041E\u0421\u0420\u0415\u0414\u0421\u0422\u0412\u041E\u041C \u0421\u0415\u0420\u0412\u0418\u0421\u0410 nedvx.ru'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB \u0432 \u043B\u0438\u0446\u0435 \u0433\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0413\u0430\u043B\u0438\u043C\u043E\u0432\u043E\u0439 \u042E\u043B\u0438\u0438 \u0410\u0440\u0442\u0443\u0440\u043E\u0432\u043D\u044B, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430 (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C) \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u043B\u044E\u0431\u043E\u043C\u0443 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u043C\u0443 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0446\u0443 (\u0434\u0430\u043B\u0435\u0435 -  \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A), \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0443\u0441\u043B\u0443\u0433\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 nedvx.ru (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0421\u0435\u0440\u0432\u0438\u0441).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u043E\u0433\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u0442\u0430\u043B\u0430 \u043E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0433. \u0421\u043E\u0447\u0438 \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445 \u0438 \u043D\u0435 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0430\u0442\u044C\u0435\u0439 438 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0434\u0435\u043A\u0441\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 (\u0413\u041A \u0420\u0424), \u0431\u0435\u0437\u0443\u0441\u043B\u043E\u0432\u043D\u044B\u043C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435\u043C (\u0430\u043A\u0446\u0435\u043F\u0442\u043E\u043C) \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u043F\u0443\u0442\u0435\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0438 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B,  \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u0444\u0435\u0440\u0442\u0430, \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0435\u043C\u0430\u044F \u043F\u0443\u0442\u0435\u043C \u0430\u043A\u0446\u0435\u043F\u0442\u0430, \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0433\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0432\u0441\u0435 \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u044B.'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        '\u0421\u0422\u041E\u0420\u041E\u041D\u042B \u0417\u0410\u041A\u041B\u042E\u0427\u0410\u042E\u0422 \u041F\u0423\u0411\u041B\u0418\u0427\u041D\u0423\u042E \u041E\u0424\u0415\u0420\u0422\u0423 \u041D\u0410 \u0421\u041B\u0415\u0414\u0423\u042E\u0429\u0418\u0425 \u0423\u0421\u041B\u041E\u0412\u0418\u042F\u0425:'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '1. \u0422\u0435\u0440\u043C\u0438\u043D\u044B \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0421\u0435\u0440\u0432\u0438\u0441'
	                        ),
	                        ' \u2013 \u044D\u0442\u043E \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 (\u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0435), \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u043D\u0430\u044F \u0438 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C. \u0414\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u0441\u0430\u0439\u0442, \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: nedvx.ru, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u043D\u044B\u0435. \u0421\u0435\u0440\u0432\u0438\u0441 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u043E\u043C \u0438 \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A'
	                        ),
	                        ' \u2013 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u043E\u0448\u0435\u043B \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442'
	                        ),
	                        ' -  \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043C\u043E\u0436\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0432\u0432\u043E\u0434\u0430 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0423\u0441\u043B\u0443\u0433\u0438'
	                        ),
	                        ' \u2013 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C/\u043F\u0440\u043E\u0444\u0438\u043B\u044C'
	                        ),
	                        ' - \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0449\u0435\u0435 \u043D\u0430 \u043D\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441 \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u043C \u043A\u043E\u0434\u043E\u043C \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C'
	                        ),
	                        ' \u2013 \u041E\u041E\u041E "\u041D\u0415\u0414\u0412\u0415\u041A\u0421", \u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001, \u041E\u0413\u0420\u041D 1162366056830. \u0410\u0434\u0440\u0435\u0441: 354207, \u0433.\u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u043F.\u0414\u0430\u0433\u043E\u043C\u044B\u0441, \u0443\u043B.\u041B\u0435\u0442\u043D\u044F\u044F, \u0443\u0447. \u211615/2. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 \u043D\u0430 \u0421\u0435\u0440\u0432\u0438\u0441.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u041E\u0444\u0435\u0440\u0442\u0430'
	                        ),
	                        ' \u2013 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043F\u0435\u0440\u0435\u0447\u0435\u043D\u044C \u043D\u043E\u0440\u043C \u0438 \u043F\u0440\u0430\u0432\u0438\u043B, \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u0443\u0435\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0421\u0435\u0440\u0432\u0438\u0441, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u044F\u0442 \u0432\u0441\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0439 \u043C\u0435\u0436\u0434\u0443 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '2. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u041E\u0444\u0435\u0440\u0442\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '2.1. \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C, \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u0434\u043B\u044F \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0438 \u0437\u0430\u043A\u0430\u0437\u0430 \u0423\u0441\u043B\u0443\u0433.',
	                        _react2.default.createElement('br', null),
	                        '2.2. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0432\u0438\u0434\u044B \u0423\u0441\u043B\u0443\u0433:',
	                        _react2.default.createElement('br', null),
	                        '2.2.1. \u0423\u0441\u043B\u0443\u0433\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0431\u0430\u0437\u0435 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0438\u0441\u043A\u0430 \u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0438 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u0445 \u0432 \u043D\u0438\u0445.',
	                        _react2.default.createElement('br', null),
	                        '2.2.2. \u0423\u0441\u043B\u0443\u0433\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0441\u0432\u043E\u0438\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0438\u043C\u0435\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443 \u0438\u0437 \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u043A\u043B\u0438\u0435\u043D\u0442\u0443. \u041F\u043E \u0441\u0441\u044B\u043B\u043A\u0435 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430.',
	                        _react2.default.createElement('br', null),
	                        '2.2.3. \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0438 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043D\u0438\u0445 \u0432 \u0441\u043F\u0438\u0441\u043E\u043A \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E.',
	                        _react2.default.createElement('br', null),
	                        '2.2.4. \u0414\u0440\u0443\u0433\u0438\u0435 \u0432\u0438\u0434\u044B \u0423\u0441\u043B\u0443\u0433, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '2.3. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0431\u0435\u0440\u0435\u0442 \u043D\u0430 \u0441\u0435\u0431\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 \u0423\u0441\u043B\u0443\u0433, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u0443, \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0438 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.',
	                        _react2.default.createElement('br', null),
	                        '2.4. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C \u0438 \u0432 \u0441\u0440\u043E\u043A \u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0423\u0441\u043B\u0443\u0433\u0438.',
	                        _react2.default.createElement('br', null),
	                        '2.5. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445, \u043E\u043F\u0438\u0441\u0430\u043D\u043D\u044B\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435.',
	                        _react2.default.createElement('br', null),
	                        '2.6. \u0414\u043B\u044F \u043F\u043E\u043B\u043D\u043E\u0446\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0437\u0430\u043A\u0430\u0437\u0430 \u0423\u0441\u043B\u0443\u0433, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438 \u043E\u043F\u043B\u0430\u0442\u0443 \u0423\u0441\u043B\u0443\u0433, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u0443.',
	                        _react2.default.createElement('br', null),
	                        '2.7. \u041E\u043F\u043B\u0430\u0442\u0430 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0438 \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u0445 \u0423\u0441\u043B\u0443\u0433 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0438 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439.',
	                        _react2.default.createElement('br', null),
	                        '2.8. \u0423\u0441\u043B\u0443\u0433\u0438 \u043E\u043A\u0430\u0437\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '3. \u0410\u043A\u0446\u0435\u043F\u0442 \u041E\u0444\u0435\u0440\u0442\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '3.1. \u0410\u043A\u0446\u0435\u043F\u0442\u043E\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F:',
	                        _react2.default.createElement('br', null),
	                        '3.1.1. \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438;',
	                        _react2.default.createElement('br', null),
	                        '3.1.2. \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439 \u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '4. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '4.1. \u041F\u043E\u0441\u043B\u0435 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043F\u0440\u043E\u0431\u043D\u044B\u0439 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '4.2. \u041F\u0440\u043E\u0431\u043D\u044B\u0439 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 14 (\u0447\u0435\u0442\u044B\u0440\u043D\u0430\u0434\u0446\u0430\u0442\u044C) \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '4.3. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u043F\u043B\u0430\u0442\u044B \u0423\u0441\u043B\u0443\u0433 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E\u0441\u043B\u0435 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0431\u043D\u043E\u0433\u043E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430, \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0431\u043B\u043E\u043A\u0438\u0440\u0443\u0435\u0442 \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.',
	                        _react2.default.createElement('br', null),
	                        '4.4. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0423\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0432\u044B\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.',
	                        _react2.default.createElement('br', null),
	                        '4.5. \u041F\u043E\u0441\u043B\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u043F\u043B\u0430\u0442\u044B \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0423\u0441\u043B\u0443\u0433 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u0443, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0423\u0441\u043B\u0443\u0433\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043C\u043E\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u043E\u0442\u043A\u0430\u0437\u0430 \u043E\u0442 \u043F\u0440\u0438\u0435\u043C\u043A\u0438 \u0423\u0441\u043B\u0443\u0433 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 2 (\u0434\u0432\u0443\u0445) \u0434\u043D\u0435\u0439  \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u043E\u0433\u043E \u043C\u0435\u0441\u044F\u0446\u0430 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433, \u0442\u0430\u043A\u0438\u0435 \u0423\u0441\u043B\u0443\u0433\u0438 \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u043E\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C\u0438 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435 \u0438 \u043F\u0440\u0438\u043D\u044F\u0442\u044B\u043C\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C.',
	                        _react2.default.createElement('br', null),
	                        '4.6. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0438\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u043F\u0440\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0438\u0445 \u043D\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442, \u0442\u043E \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u0440\u0430\u0441\u0446\u0435\u043D\u0438\u0432\u0430\u0442\u044C \u044D\u0442\u043E \u043A\u0430\u043A \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '5. \u041F\u0440\u0430\u0432\u0430 \u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0421\u0442\u043E\u0440\u043E\u043D'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '5.1. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        '5.1.1. \u041A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0438 \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435 \u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0423\u0441\u043B\u0443\u0433\u0438 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '5.1.2. \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438 \u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u043D\u0430 \u043F\u0440\u043E\u0442\u044F\u0436\u0435\u043D\u0438\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '5.1.3. \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u0438 \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u043F\u043E\u0441\u043B\u0435 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 \u0423\u0441\u043B\u0443\u0433 (\u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0431\u043D\u043E\u0433\u043E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430).',
	                        _react2.default.createElement('br', null),
	                        '5.1.4. \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0442\u0430\u0440\u0438\u0444\u0430\u0445 \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433.',
	                        _react2.default.createElement('br', null),
	                        '5.1.5. \u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0443\u044E \u0442\u0430\u0439\u043D\u0443, \u0441\u0442\u0430\u0432\u0448\u0443\u044E \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '5.1.6. \u0421\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043E\u0431 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u0438 \u0441\u0440\u043E\u043A\u0430 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C.',
	                        _react2.default.createElement('br', null),
	                        '5.1.7. \u041E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0423\u0441\u043B\u0443\u0433\u0438 \u043C\u0435\u0442\u043E\u0434\u0430\u043C\u0438, \u043D\u0435\u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043D\u044B\u043C\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '5.2. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        '5.2.1. \u0418\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0438 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0423\u0441\u043B\u0443\u0433 \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0432 \u043E\u0431 \u044D\u0442\u043E\u043C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u043F\u0443\u0442\u0435\u043C \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u043E\u0432\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438 \u041E\u0444\u0435\u0440\u0442\u044B \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.',
	                        _react2.default.createElement('br', null),
	                        '5.2.2. \u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u043F\u043B\u0430\u0442\u044B \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0438 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0430\u0440\u0438\u0444\u0430.',
	                        _react2.default.createElement('br', null),
	                        '5.2.3. \u0422\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0442\u0430\u0440\u0438\u0444\u0443.',
	                        _react2.default.createElement('br', null),
	                        '5.2.4. \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u043F\u0438\u0441\u0435\u043C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '5.3. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        '5.3.1. \u0421\u0432\u043E\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u043E\u043F\u043B\u0430\u0442\u0443 \u0423\u0441\u043B\u0443\u0433 \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0438 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u041E\u0444\u0435\u0440\u0442\u043E\u0439.',
	                        _react2.default.createElement('br', null),
	                        '5.3.2. \u041F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u041E\u0444\u0435\u0440\u0442\u043E\u0439 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u0440\u043E\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438 \u0431\u0435\u0437\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0447\u043D\u043E\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u043E\u0440\u043C\u0430\u043C\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.',
	                        _react2.default.createElement('br', null),
	                        '5.3.3. \u041D\u0435 \u0440\u0435\u0436\u0435, \u0447\u0435\u043C \u0440\u0430\u0437 \u0432 \u0434\u0432\u0430 \u043C\u0435\u0441\u044F\u0446\u0430 \u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439 \u0438 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0438.',
	                        _react2.default.createElement('br', null),
	                        '5.3.4. \u041D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043A\u0430\u043A\u043E\u0435-\u043B\u0438\u0431\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435, \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u0438\u043D\u044B\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u0441 \u0446\u0435\u043B\u044C\u044E \u0432\u043C\u0435\u0448\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0432 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433.',
	                        _react2.default.createElement('br', null),
	                        '5.3.5. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u0435\u0433\u043E \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E.',
	                        _react2.default.createElement('br', null),
	                        '5.3.6. \u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0443\u044E \u0442\u0430\u0439\u043D\u0443, \u0441\u0442\u0430\u0432\u0448\u0443\u044E \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0439 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '5.4. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        '5.4.1. \u0422\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '6. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0423\u0441\u043B\u0443\u0433 \u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '6.1. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0438 \u0441\u0440\u043E\u043A \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435, \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0430\u0440\u0438\u0444\u0430.',
	                        _react2.default.createElement('br', null),
	                        '6.2. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0423\u0441\u043B\u0443\u0433 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '6.3. \u041F\u043E\u0441\u043B\u0435 \u0432\u044B\u0431\u043E\u0440\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0423\u0441\u043B\u0443\u0433, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0444\u043E\u0440\u043C\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441\u0447\u0435\u0442 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443 \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u0423\u0441\u043B\u0443\u0433.',
	                        _react2.default.createElement('br', null),
	                        '6.4. \u041E\u043F\u043B\u0430\u0442\u0430 \u0423\u0441\u043B\u0443\u0433 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0445 \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432).',
	                        _react2.default.createElement('br', null),
	                        '6.5. \u041F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u0423\u0441\u043B\u0443\u0433, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0423\u0441\u043B\u0443\u0433\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '6.6. \u0421\u043E\u0433\u043B\u0430\u0441\u0438\u0435\u043C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0446\u0435\u043D\u0430\u043C\u0438 \u0423\u0441\u043B\u0443\u0433 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0444\u0430\u043A\u0442 \u043E\u043F\u043B\u0430\u0442\u044B \u0442\u0430\u043A\u0438\u0445 \u0423\u0441\u043B\u0443\u0433 \u0441 \u0443\u0447\u0435\u0442\u043E\u043C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043D\u044B\u0445 \u0446\u0435\u043D. \u041F\u0440\u0438 \u043D\u0435\u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0441 \u043D\u043E\u0432\u044B\u043C\u0438 \u0446\u0435\u043D\u0430\u043C\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0432\u043F\u0440\u0430\u0432\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043E\u043F\u043B\u0430\u0442\u044B \u0423\u0441\u043B\u0443\u0433. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u041E\u0444\u0435\u0440\u0442\u0430 \u043C\u0435\u0436\u0434\u0443 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0438 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442\u044B\u043C \u0438 \u0442\u0435\u0440\u044F\u0435\u0442 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0441\u0438\u043B\u0443.',
	                        _react2.default.createElement('br', null),
	                        '6.7. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F \u041E\u0444\u0435\u0440\u0442\u044B \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043D\u0435\u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430, \u043E\u0441\u0442\u0430\u044E\u0449\u0438\u0435\u0441\u044F \u043D\u0430 \u0434\u0430\u0442\u0443 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u043D\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F.',
	                        _react2.default.createElement('br', null),
	                        '6.8. \u0423\u0441\u043B\u0443\u0433\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041D\u0414\u0421 \u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F (\u043F.2, \u0441\u0442.346.11, \u0433\u043B.26.2 \u041D\u041A \u0420\u0424).',
	                        _react2.default.createElement('br', null),
	                        '6.9. \u0420\u0430\u0441\u0447\u0435\u0442 \u043C\u0435\u0436\u0434\u0443 \u0421\u0442\u043E\u0440\u043E\u043D\u0430\u043C\u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '7. \u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0438 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F \u041E\u0444\u0435\u0440\u0442\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '7.1. \u041E\u0444\u0435\u0440\u0442\u0430 \u0432\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u0435\u0433\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C (\u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u041E\u0444\u0435\u0440\u0442\u044B), \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439, \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043E\u0442\u0437\u044B\u0432\u0430 \u041E\u0444\u0435\u0440\u0442\u044B \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C.',
	                        _react2.default.createElement('br', null),
	                        '7.2. \u041E\u0444\u0435\u0440\u0442\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u0438\u043B\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435.',
	                        _react2.default.createElement('br', null),
	                        '7.2.1. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0443\u0441\u043B\u0443\u0433 \u0434\u043E \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438.',
	                        _react2.default.createElement('br', null),
	                        '7.2.2. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443 \u0432 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438 \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0433\u043E \u043E\u0431\u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043E\u0442\u043A\u0430\u0437\u0430 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u044F\u0445:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433\u0438 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0433\u0440\u043E\u0437\u0443 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0438 \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u044E \u043B\u044E\u0434\u0435\u0439;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u0432\u0438\u0434\u0443 \u043A\u0430\u043A\u0438\u0445-\u043B\u0438\u0431\u043E \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445, \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0438\u043B\u0438 \u0438\u043D\u044B\u0445 \u0435\u0441\u0442\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0438\u0439.',
	                        _react2.default.createElement('br', null),
	                        '7.2.3. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443, \u0441 \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u0435\u043C \u041E\u0444\u0435\u0440\u0442\u044B \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u0432 \u0441\u043B\u0443\u0447\u0430\u044F\u0445:',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043A \u043D\u0435\u0439;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043B\u044E\u0431\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430, \u043F\u043E\u0432\u043B\u0435\u043A\u0448\u0438\u0445 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0441\u0431\u043E\u0439 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043A \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435;',
	                        _react2.default.createElement('br', null),
	                        '\u2014 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0445 \u0443\u0441\u043B\u0443\u0433 \u0432 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445.',
	                        _react2.default.createElement('br', null),
	                        '7.3. \u041F\u043E \u0432\u0441\u0435\u043C \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u043D\u0435 \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '8. \u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '8.1. \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043D\u0435\u0441\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u043D\u0435\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0432\u043E\u0438\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0435\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438, \u0430 \u0432 \u0447\u0430\u0441\u0442\u0438, \u043D\u0435 \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439 \u2013 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.',
	                        _react2.default.createElement('br', null),
	                        '8.2. \u0412 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u043E\u0433\u043E \u0438 \u0438\u043D\u043E\u0433\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F, \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u0441\u0432\u044F\u0437\u0438 \u0438/\u0438\u043B\u0438 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C \u0434\u043B\u044F \u042D\u0412\u041C, \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u0445 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u043F\u0440\u0438 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0438 \u0423\u0441\u043B\u0443\u0433, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438, \u043F\u0440\u0435\u0440\u044B\u0432\u0430\u043D\u0438\u044F, \u043F\u0440\u044F\u043C\u043E\u0439 \u0438 \u043A\u043E\u0441\u0432\u0435\u043D\u043D\u044B\u0439 \u0443\u0449\u0435\u0440\u0431 \u0438\u043B\u0438 \u043F\u043E\u0442\u0435\u0440\u0438, \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0438\u0437 \u0437\u0430 \u0434\u0435\u0444\u0435\u043A\u0442\u043E\u0432 \u0432 \u043B\u044E\u0431\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0438\u043B\u0438 \u043C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0438 \u0438/\u0438\u043B\u0438 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430\u0445 \u0434\u043B\u044F \u042D\u0412\u041C, \u043B\u0438\u0431\u043E \u0432\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0435 \u0438\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0438\u043B\u0438 \u0431\u0435\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446, \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438, \u043F\u0435\u0440\u0435\u0431\u043E\u0435\u0432 \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0438\u0442\u0430\u043D\u0438\u0438, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u043D\u0435 \u043F\u043E \u0432\u0438\u043D\u0435 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F.',
	                        _react2.default.createElement('br', null),
	                        '8.3. \u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F \u0437\u0430 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435.',
	                        _react2.default.createElement('br', null),
	                        '8.4. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0441\u0440\u043E\u043A\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u0423\u0441\u043B\u0443\u0433, \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0423\u0441\u043B\u0443\u0433 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0441\u0432\u043E\u0438\u0445 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0438\u043B\u0438 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '9. \u0424\u043E\u0440\u0441 \u2013\u043C\u0430\u0436\u043E\u0440'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '9.1. \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0430\u044E\u0442\u0441\u044F \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u0435 \u0438\u043B\u0438 \u043F\u043E\u043B\u043D\u043E\u0435 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u043E\u0435 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u044F\u0432\u0438\u043B\u043E\u0441\u044C \u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0435\u043C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0445 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u041E\u0444\u0435\u0440\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043D\u0435 \u043C\u043E\u0433\u043B\u0438 \u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u0442\u044C \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u043E\u0442\u0432\u0440\u0430\u0442\u0438\u0442\u044C.',
	                        _react2.default.createElement('br', null),
	                        '9.2. \u041A \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430\u043C \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u0442\u043D\u043E\u0441\u044F\u0442 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u0434\u0435\u043B\u0430\u044E\u0449\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0421\u0442\u043E\u0440\u043E\u043D\u043E\u0439 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u043C: \u0437\u0435\u043C\u043B\u0435\u0442\u0440\u044F\u0441\u0435\u043D\u0438\u044F, \u043D\u0430\u0432\u043E\u0434\u043D\u0435\u043D\u0438\u044F, \u0438\u043D\u044B\u0435 \u0441\u0442\u0438\u0445\u0438\u0439\u043D\u044B\u0435 \u0431\u0435\u0434\u0441\u0442\u0432\u0438\u044F, \u043F\u043E\u0436\u0430\u0440\u044B, \u044F\u0434\u0435\u0440\u043D\u044B\u0435 \u0438 \u0438\u043D\u044B\u0435 \u043F\u0440\u043E\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u044B\u0435 \u0430\u0432\u0430\u0440\u0438\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0437\u0430\u0431\u0430\u0441\u0442\u043E\u0432\u043A\u0438, \u0432\u043E\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0438\u0435 \u0431\u0435\u0441\u043F\u043E\u0440\u044F\u0434\u043A\u0438 \u043B\u0438\u0431\u043E \u0430\u043A\u0442\u044B \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432, \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u041E\u0444\u0435\u0440\u0442\u044B. \u0412\u0441\u0435 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0438\u044F \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E \u043E\u0442 \u0438\u0445 \u043F\u0440\u0438\u0440\u043E\u0434\u044B \u0438\u043B\u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u043E\u0439 \u043D\u0435 \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0442\u0435\u0445 \u043F\u0440\u0435\u043F\u044F\u0442\u0441\u0442\u0432\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u044B \u0421\u0442\u043E\u0440\u043E\u043D\u0430\u043C\u0438 \u043A\u0430\u043A \u0432\u044B\u0437\u0432\u0430\u043D\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043C \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B.',
	                        _react2.default.createElement('br', null),
	                        '9.3. \u0421\u0442\u043E\u0440\u043E\u043D\u0430, \u0441\u0441\u044B\u043B\u0430\u044E\u0449\u0430\u044F\u0441\u044F \u043D\u0430 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B, \u043E\u0431\u044F\u0437\u0430\u043D\u0430 \u043D\u0435\u0437\u0430\u043C\u0435\u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u0443\u044E \u0421\u0442\u043E\u0440\u043E\u043D\u0443 \u043E \u043D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0438 \u043E\u0431 \u0438\u0445 \u0432\u043B\u0438\u044F\u043D\u0438\u0438 \u043D\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0421\u0442\u043E\u0440\u043E\u043D\u043E\u0439 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435 \u0432 \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435.',
	                        _react2.default.createElement('br', null),
	                        '9.4. \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u043E\u0442\u043E\u0434\u0432\u0438\u0433\u0430\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0430 \u0441\u0440\u043E\u043A, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0438\u043C\u0435\u0435\u0442 \u043C\u0435\u0441\u0442\u043E \u0442\u0430\u043A\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435. \u041F\u043E \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u043D\u0435\u043F\u0440\u0435\u043E\u0434\u043E\u043B\u0438\u043C\u043E\u0439 \u0441\u0438\u043B\u044B \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043E\u0431\u044F\u0437\u0430\u043D\u044B \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u043A \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E \u0441\u0432\u043E\u0438\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432.',
	                        _react2.default.createElement('br', null),
	                        '9.5. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0444\u043E\u0440\u0441-\u043C\u0430\u0436\u043E\u0440\u043D\u044B\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0442\u043E\u0440\u0433\u043E\u0432\u043E-\u043F\u0440\u043E\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u0430\u044F \u043F\u0430\u043B\u0430\u0442\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0437\u0432\u0430\u043D\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u044D\u0442\u0438\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0438 \u0438\u0445 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '10. \u0410\u0440\u0431\u0438\u0442\u0440\u0430\u0436\u043D\u0430\u044F \u043E\u0433\u043E\u0432\u043E\u0440\u043A\u0430'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '10.1. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0440\u043E\u0432 \u043F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u043E\u0439 \u0438\u043B\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u043D\u0438\u043C, \u0421\u0442\u043E\u0440\u043E\u043D\u044B \u043F\u0440\u0438\u043C\u0443\u0442 \u0432\u0441\u0435 \u043C\u0435\u0440\u044B \u043A \u0438\u0445 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044E \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432.',
	                        _react2.default.createElement('br', null),
	                        '10.2. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0440\u043E\u0432 \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432 \u043E\u043D\u0438 \u0431\u0443\u0434\u0443\u0442 \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u0442\u044C\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.',
	                        _react2.default.createElement('br', null),
	                        '10.3. \u0412\u0441\u0435 \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0441\u043F\u043E\u0440\u044B \u043C\u0435\u0436\u0434\u0443 \u0421\u0442\u043E\u0440\u043E\u043D\u0430\u043C\u0438, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u043D\u0435 \u0431\u044B\u043B\u043E \u0434\u043E\u0441\u0442\u0438\u0433\u043D\u0443\u0442\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044E\u0442\u0441\u044F \u0432 \u043E\u0440\u0433\u0430\u043D\u0430\u0445 \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u0439 \u0432\u043B\u0430\u0441\u0442\u0438 \u043F\u043E \u043C\u0435\u0441\u0442\u043E\u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044E \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '11. \u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '11.1. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442, \u0447\u0442\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0435 \u043A\u043E\u0434\u044B, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0434\u043B\u044F \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0423\u0441\u043B\u0443\u0433 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435, \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F.',
	                        _react2.default.createElement('br', null),
	                        '11.2. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435 \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435, \u0421\u0435\u0440\u0432\u0438\u0441, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0435 \u043A\u043E\u0434\u044B \u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0438\u0445 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u043E\u0434 \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u0435\u043A\u043E\u043C\u043F\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0441 \u0446\u0435\u043B\u044C\u044E \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B, \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438, \u043A\u043E\u043D\u0446\u0435\u043F\u0446\u0438\u0438 \u0438 \u043C\u0435\u0442\u043E\u0434\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u0423\u0441\u043B\u0443\u0433.',
	                        _react2.default.createElement('br', null),
	                        '11.3. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u0432\u043F\u0440\u0430\u0432\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0433\u043E \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F, \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E \u0435\u0433\u043E \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '11.4. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u043F\u0440\u0430\u0432 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u041E\u0444\u0435\u0440\u0442\u044B, \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043D\u0435\u0441\u0451\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '12. \u0417\u0430\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '12.1. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043D\u0435 \u0434\u0430\u0435\u0442 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439 \u0438 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043D\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u043E\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0423\u0441\u043B\u0443\u0433 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0446\u0435\u043B\u044F\u043C \u0438/\u0438\u043B\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u043C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043B\u0438\u0448\u0438\u0442\u044C \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u043F\u0440\u043E\u0431\u043D\u043E\u0433\u043E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430, \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0432 \u0435\u0433\u043E \u043E\u0431 \u044D\u0442\u043E\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u043E \u0441\u0435\u0431\u0435 \u0432 \u041B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435.',
	                        _react2.default.createElement('br', null),
	                        '12.2. \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A \u043D\u0435 \u0432\u043F\u0440\u0430\u0432\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C (\u0443\u0441\u0442\u0443\u043F\u0430\u0442\u044C) \u043B\u044E\u0431\u043E\u0439 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u0435 \u0441\u0432\u043E\u0438 \u043F\u0440\u0430\u0432\u0430 \u0438/\u0438\u043B\u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u043E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u0435 \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044F.',
	                        _react2.default.createElement('br', null),
	                        '12.3. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u043B\u044E\u0431\u043E\u0435 \u0438\u0437 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0438/\u0438\u043B\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u043E \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C, \u0442\u043E \u044D\u0442\u043E \u043D\u0435 \u043F\u043E\u0432\u043B\u0435\u0447\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u0445 \u0435\u0433\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439/\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B \u0438 \u0435\u0435 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0432 \u0446\u0435\u043B\u043E\u043C, \u043A\u0430\u043A \u0435\u0441\u043B\u0438 \u0431\u044B \u0442\u0430\u043A\u043E\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u0435 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0431\u044B\u043B\u043E \u0447\u0430\u0441\u0442\u044C\u044E \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u041E\u0444\u0435\u0440\u0442\u044B.',
	                        _react2.default.createElement('br', null),
	                        '12.4. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u041E\u0444\u0435\u0440\u0442\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u043E\u0431\u043E\u0439 \u043F\u043E\u043B\u043D\u0443\u044E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0451\u043D\u043D\u043E\u0441\u0442\u044C \u043C\u0435\u0436\u0434\u0443 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u043E\u043C \u0438 \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u0435\u043C. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043D\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043D\u0430 \u0441\u0435\u0431\u044F \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430 \u041E\u0444\u0435\u0440\u0442\u044B, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u041E\u0444\u0435\u0440\u0442\u0435.',
	                        _react2.default.createElement('br', null),
	                        '12.5. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0430\u044F \u041E\u0444\u0435\u0440\u0442\u0430, \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u043D\u0430 \u0440\u0443\u0441\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435, \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C, \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u0441\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430  \u0438 \u0430\u0434\u0440\u0435\u0441\u043E\u0432\u0430\u043D\u0430 \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u043C\u0443 \u043A\u0440\u0443\u0433\u0443 \u043B\u0438\u0446.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u0414\u0430\u0442\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438: 28.06.2017\u0433.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            '\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C:'
	                        ),
	                        '\u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB ',
	                        _react2.default.createElement('br', null),
	                        '\u042E\u0440.\u0430\u0434\u0440\u0435\u0441: 354207, \u0433.\u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u043F.\u0414\u0430\u0433\u043E\u043C\u044B\u0441, \u0443\u043B.\u041B\u0435\u0442\u043D\u044F\u044F, \u0443\u0447. \u211615/2 ',
	                        _react2.default.createElement('br', null),
	                        '\u0424\u0430\u043A\u0442.\u0430\u0434\u0440\u0435\u0441: 354000, \u0433.\u0421\u043E\u0447\u0438, \u043F\u0435\u0440.\u041C\u043E\u0440\u0441\u043A\u043E\u0439, \u0434.1/1, 5 \u044D\u0442\u0430\u0436 ',
	                        _react2.default.createElement('br', null),
	                        '\u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001 ',
	                        _react2.default.createElement('br', null),
	                        '\u0412 \u0424\u0438\u043B\u0438\u0430\u043B\u0435 \u042E\u0436\u043D\u044B\u0439 \u041F\u0410\u041E \u0411\u0430\u043D\u043A\u0430 \xAB\u0424\u041A \u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435\xBB ',
	                        _react2.default.createElement('br', null),
	                        '\u0411\u0418\u041A 046029058'
	                    )
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return PublicOffer;
	}(_react.Component);
	
	exports.default = PublicOffer;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PublicOffer = __webpack_require__(1146);
	
	var _PublicOffer2 = _interopRequireDefault(_PublicOffer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PublicOffer2.default;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(1478);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RateCard = function RateCard(_ref) {
	  var title = _ref.title,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? [] : _ref$options,
	      price = _ref.price,
	      discount = _ref.discount,
	      altPrice = _ref.altPrice;
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.RateCard },
	    discount && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Discount },
	      '-',
	      discount
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.RateCardTitle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.RateCardInclude },
	        '\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0432 \u0442\u0430\u0440\u0438\u0444'
	      ),
	      options !== undefined && options.length > 0 && _react2.default.createElement(
	        'ul',
	        { className: _styles2.default.RateCardList },
	        options.map(function (option) {
	          return _react2.default.createElement(
	            'li',
	            { key: option },
	            option
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.RateCardPrice },
	      price,
	      ' ',
	      altPrice && _react2.default.createElement(
	        'span',
	        { className: _styles2.default.AltPrice },
	        altPrice
	      )
	    )
	  );
	};
	
	exports.default = _react2.default.memo(RateCard);

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mark = __webpack_require__(1571);
	
	var _mark2 = _interopRequireDefault(_mark);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1479);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Select = function Select(_ref) {
	  var value = _ref.value,
	      options = _ref.options,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var ref = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    if (!ref) {
	      return;
	    }
	    var handleDocumentClick = function handleDocumentClick(event) {
	      if (!ref.current.contains(event.target) && isOpen) {
	        setIsOpen(false);
	      }
	    };
	
	    document.addEventListener('click', handleDocumentClick);
	
	    return function () {
	      document.removeEventListener('click', handleDocumentClick);
	    };
	  }, [ref]);
	
	  var handleClick = function handleClick(selectedValue) {
	    if (value !== selectedValue) {
	      onChange(selectedValue);
	    }
	    setIsOpen(false);
	  };
	
	  var selectedText = Object.keys(options).reduce(function (acc, key) {
	    return value == key ? options[key] : acc;
	  }, '').slice(3);
	
	  return _react2.default.createElement(
	    'div',
	    { ref: ref, className: _styles2.default.Wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Container },
	      _react2.default.createElement(
	        'div',
	        { onClick: function onClick() {
	            return setIsOpen(function (value) {
	              return !value;
	            });
	          }, className: _styles2.default.Active },
	        '\u041D\u0430 ',
	        _react2.default.createElement(
	          'span',
	          null,
	          selectedText
	        ),
	        _react2.default.createElement('img', { src: _mark2.default, alt: '' })
	      ),
	      isOpen && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.List },
	        Object.keys(options).map(function (key) {
	          return _react2.default.createElement(
	            'div',
	            {
	              onClick: function onClick() {
	                return handleClick(key);
	              },
	              key: key + options[key],
	              className: (0, _classnames2.default)(_defineProperty({}, _styles2.default.SelectedItem, key == value))
	            },
	            options[key]
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = _react2.default.memo(Select);

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(1480);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Switch = function Switch(_ref) {
	  var onChange = _ref.onChange,
	      value = _ref.value,
	      options = _ref.options;
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.Container },
	    Object.keys(options).map(function (key) {
	      var isSelected = value == key;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: function onClick() {
	            return onChange(key);
	          },
	          key: key + options[key],
	          className: (0, _classnames2.default)(_defineProperty({}, _styles2.default.Selected, isSelected))
	        },
	        options[key],
	        isSelected && _react2.default.createElement('div', { className: _styles2.default.SelectedBlock })
	      );
	    })
	  );
	};
	
	exports.default = _react2.default.memo(Switch);

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _ratesLogo = __webpack_require__(1593);
	
	var _ratesLogo2 = _interopRequireDefault(_ratesLogo);
	
	var _RateCard = __webpack_require__(1148);
	
	var _RateCard2 = _interopRequireDefault(_RateCard);
	
	var _styles = __webpack_require__(1481);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Switch = __webpack_require__(1150);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _Select = __webpack_require__(1149);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _reactI18next = __webpack_require__(4);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options1 = ['Корпоративный доступ для агентств недвижимости', 'Кабинет администратор компании для управления сотрудниками', 'Подборки для клиентов в фирменном стиле компании'];
	
	var options2 = ['Индивидуальный доступ для частного агента по недвижимости', 'Одновременный доступ на 2 устройствах', 'Отправка персонализированных подборок клиентам'];
	
	var data = {
	  0: {
	    title: 'Для агенств',
	    periods: {
	      0: 'На 1 месяц',
	      1: 'На 6 месяцев',
	      2: 'На 12 месяцев'
	    },
	    cards: {
	      'До 10 людей': {
	        0: {
	          price: '10 000 ₽',
	          discount: '',
	          altPrice: ''
	        },
	        1: {
	          price: '48 000 ₽',
	          discount: '',
	          altPrice: ''
	        },
	        2: {
	          price: '96 000 ₽',
	          discount: '',
	          altPrice: ''
	        }
	      },
	      'Для 10-30 людей': {
	        0: {
	          price: '15 000 ₽',
	          discount: '',
	          altPrice: ''
	        },
	        1: {
	          price: '72 000 ₽',
	          discount: '20%',
	          altPrice: '90 000 ₽'
	        },
	        2: {
	          price: '144 000 ₽',
	          discount: '20%',
	          altPrice: '180 000 ₽'
	        }
	      },
	      'Для 30+ людей': {
	        0: {
	          price: '20 000 ₽',
	          discount: '',
	          altPrice: ''
	        },
	        1: {
	          price: '96 000 ₽',
	          discount: '20%',
	          altPrice: '120 000 ₽'
	        },
	        2: {
	          price: '192 000 ₽',
	          discount: '20%',
	          altPrice: '240 000 ₽'
	        }
	      }
	    },
	    options: options1
	  },
	  1: {
	    title: 'Для агентов',
	    periods: {
	      0: 'Нет'
	    },
	    cards: {
	      'Для 1 агента': {
	        0: {
	          price: '2 000 ₽/мес',
	          discount: '',
	          altPrice: ''
	        }
	      }
	    },
	    options: options2
	  }
	};
	
	var types = Object.keys(data).reduce(function (acc, key) {
	  acc[key] = data[key].title;
	
	  return acc;
	}, {});
	
	var Rates = function Rates() {
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      type = _useState2[0],
	      setType = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      period = _useState4[0],
	      setPeriod = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      cards = _useState6[0],
	      setCards = _useState6[1];
	
	  var _useTranslation = (0, _reactI18next.useTranslation)(),
	      t = _useTranslation.t;
	
	  var handleSetType = function handleSetType(value) {
	    if (value === type) {
	      return;
	    }
	
	    setType(value);
	    setPeriod(0);
	  };
	
	  (0, _react.useEffect)(function () {
	    var nextCards = Object.keys(data[type].cards).map(function (title) {
	      return _extends({
	        title: title,
	        options: data[type].options
	      }, data[type].cards[title][period]);
	    });
	    setCards(nextCards);
	  }, [type, period]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.WrapperContainer },
	    _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: 'html { background: #E8E9EB; }' } }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.Container },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.Header },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: '/' },
	          _react2.default.createElement('img', { src: _ratesLogo2.default, alt: '' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.Title },
	        '\u0422\u0430\u0440\u0438\u0444\u044B Nedvex'
	      ),
	      _react2.default.createElement(_Switch2.default, { value: type, onChange: handleSetType, options: types }),
	      data[type].periods[1] !== undefined && _react2.default.createElement(_Select2.default, { value: period, onChange: setPeriod, options: data[type].periods }),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.Tariffs },
	        cards.map(function (card) {
	          return _react2.default.createElement(_RateCard2.default, _extends({ key: card.title + period + type }, card));
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.Footer },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_styles2.default.SubGroup, _styles2.default.SubGroup1) },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: t('containers.login.footer1') } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_styles2.default.SubGroup, _styles2.default.SubGroup2) },
	          _react2.default.createElement('a', {
	            href: 'https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip',
	            target: '_blank',
	            dangerouslySetInnerHTML: { __html: t('containers.login.footer2') }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_styles2.default.SubGroup, _styles2.default.SubGroup3) },
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            t('containers.login.footer3'),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://app.nedvex.ru/policy', target: '_blank' },
	              t('containers.login.docs')
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Rates;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Soglashenie = __webpack_require__(1482);
	
	var _Soglashenie2 = _interopRequireDefault(_Soglashenie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Soglashenie = function (_Component) {
	    _inherits(Soglashenie, _Component);
	
	    function Soglashenie() {
	        _classCallCheck(this, Soglashenie);
	
	        return _possibleConstructorReturn(this, (Soglashenie.__proto__ || Object.getPrototypeOf(Soglashenie)).apply(this, arguments));
	    }
	
	    _createClass(Soglashenie, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _Soglashenie2.default.Oferta },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Soglashenie2.default.Container },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        '\u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042C\u0421\u041A\u041E\u0415 \u0421\u041E\u0413\u041B\u0410\u0428\u0415\u041D\u0418\u0415 \u0421\u0415\u0420\u0412\u0418\u0421\u0410 nedvx.ru ',
	                        _react2.default.createElement('br', null),
	                        '(\u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u043E\u0444\u0435\u0440\u0442\u0430)'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u041E\u041E\u041E \u201C\u041D\u0415\u0414\u0412\u0415\u041A\u0421\u201D \u0432 \u043B\u0438\u0446\u0435 \u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0413\u0430\u043B\u0438\u043C\u043E\u0432\u043E\u0439 \u042E\u043B\u0438\u0438 \u0410\u0440\u0442\u0443\u0440\u043E\u0432\u043D\u044B, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430 (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430) \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u043C\u0443 \u043B\u0438\u0446\u0443 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0446\u0443, \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044E \u0438\u043B\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u043B\u0438\u0446\u0443 (\u0434\u0430\u043B\u0435\u0435 \u2013 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C), \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0430\u0439\u0442, \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 nedvx.ru (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0421\u0435\u0440\u0432\u0438\u0441).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435) \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u043E\u0433\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u0442\u0430\u043B\u0430 \u043E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0433. \u0421\u043E\u0447\u0438 \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0438 \u043D\u0435 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0445 \u0446\u0435\u043B\u044F\u0445.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u043E\u0444\u0435\u0440\u0442\u043E\u0439. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0430\u0442\u044C\u0435\u0439 438 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0434\u0435\u043A\u0441\u0430 \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 (\u0413\u041A \u0420\u0424), \u0431\u0435\u0437\u0443\u0441\u043B\u043E\u0432\u043D\u044B\u043C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435\u043C (\u0430\u043A\u0446\u0435\u043F\u0442\u043E\u043C) \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043E\u0444\u0435\u0440\u0442\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u043F\u0443\u0442\u0435\u043C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0438 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F,  \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435, \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0435\u043C\u043E\u0435 \u043F\u0443\u0442\u0435\u043C \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043E\u0444\u0435\u0440\u0442\u044B, \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0433\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0438 \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0432\u0441\u0435 \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '1.   \u0422\u0415\u0420\u041C\u0418\u041D\u042B \u0418 \u041E\u041F\u0420\u0415\u0414\u0415\u041B\u0415\u041D\u0418\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0421\u0435\u0440\u0432\u0438\u0441'
	                        ),
	                        ' \u2013 \u044D\u0442\u043E \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 (\u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0435), \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u043D\u0430\u044F \u0438 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C. \u0414\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u0441\u0430\u0439\u0442, \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0432 \u0441\u0435\u0442\u0438 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: nedvx.ru, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u0433\u043E \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u043D\u044B\u0435. \u0421\u0435\u0440\u0432\u0438\u0441 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u043E\u043C',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C'
	                        ),
	                        ' \u2013 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u043E\u0448\u0435\u043B \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E  \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442'
	                        ),
	                        ' -  \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043C\u043E\u0436\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0432\u0432\u043E\u0434\u0430 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C/\u043F\u0440\u043E\u0444\u0438\u043B\u044C'
	                        ),
	                        ' \u2013 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0449\u0435\u0435 \u043D\u0430 \u043D\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441 \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u043C \u043A\u043E\u0434\u043E\u043C \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u041B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u041F\u0440\u0430\u0432\u0438\u043B\u0430'
	                        ),
	                        ' \u2013 \u043F\u0435\u0440\u0435\u0447\u0435\u043D\u044C \u043D\u043E\u0440\u043C \u0438 \u043F\u0440\u0430\u0432\u0438\u043B, \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u0443\u0435\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0421\u0435\u0440\u0432\u0438\u0441, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u044F\u0442 \u0432\u0441\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0439 \u043C\u0435\u0436\u0434\u0443 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435. \u0412 \u0441\u043E\u0441\u0442\u0430\u0432 \u0442\u0430\u043A\u0438\u0445 \u043F\u0440\u0430\u0432\u0438\u043B \u0432 \u0447\u0430\u0441\u0442\u043D\u043E\u0441\u0442\u0438 \u0432\u0445\u043E\u0434\u044F\u0442 \u2013 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435, \u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0445, \u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u043E\u0444\u0435\u0440\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u044B \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '2. \u041E\u0411\u0429\u0418\u0415 \u041F\u041E\u041D\u042F\u0422\u0418\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '2.1. \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0430\u0432\u0430 \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0438 \u0435\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '2.2. \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u0435\u0442 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '2.3. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0442\u0435\u043A\u0441\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u044F \u043E\u0431 \u044D\u0442\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u0443\u0442\u0435\u043C \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u043E\u0432\u043E\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.',
	                        _react2.default.createElement('br', null),
	                        '2.4. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u0432\u043D\u043E\u0441\u0438\u043C\u044B\u0435 \u0432 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u0441 \u043D\u043E\u0432\u043E\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0435\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0442\u043E \u043E\u043D \u043E\u0431\u044F\u0437\u0430\u043D \u043D\u0435\u0437\u0430\u043C\u0435\u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u043F\u043E\u0441\u043B\u0435 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u043E\u0432\u043E\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441, \u0442\u043E \u0442\u0430\u043A\u043E\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u043F\u043E\u043B\u043D\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u043D\u043E\u0432\u043E\u0439 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0435\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.',
	                        _react2.default.createElement('br', null),
	                        '2.5. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u0440\u043E\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438 \u0431\u0435\u0437\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0447\u043D\u043E\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u043E\u0440\u043C\u0430\u043C\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0420\u0424.',
	                        _react2.default.createElement('br', null),
	                        '2.6. \u0410\u043A\u0446\u0435\u043F\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438\u043B\u0438 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0431\u0435\u0437 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0442\u043E\u0439 \u043C\u0435\u0440\u0435, \u0432 \u043A\u0430\u043A\u043E\u0439 \u044D\u0442\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0431\u0435\u0437 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430. \u0410\u043A\u0446\u0435\u043F\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442, \u0447\u0442\u043E \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u0443 \u0435\u0433\u043E \u044E\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u0438 \u043E\u043D \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0439 \u0434\u0435\u0435\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C\u044E \u0434\u043B\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '3. \u0420\u0415\u0413\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F \u0412 \u0421\u0415\u0420\u0412\u0418\u0421\u0415 \u0418 \u0423\u0427\u0415\u0422\u041D\u0410\u042F \u0417\u0410\u041F\u0418\u0421\u042C \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '3.1. \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439, \u0442.\u043A. \u0421\u0435\u0440\u0432\u0438\u0441 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u043E\u0439.',
	                        _react2.default.createElement('br', null),
	                        '3.2. \u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0446\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u043E\u0439\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u0432\u043E\u044E \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0443\u044E \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C. \u041E\u0434\u0438\u043D \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0438\u043C\u0435\u0442\u044C \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0431\u043E\u043B\u0435\u0435 \u043E\u0434\u043D\u043E\u0439 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438.',
	                        _react2.default.createElement('br', null),
	                        '3.3. \u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C:',
	                        _react2.default.createElement('br', null),
	                        '3.3.1. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0437\u0430\u044F\u0432\u043A\u0443 \u0441\u043E \u0441\u0432\u043E\u0438\u043C\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438.',
	                        _react2.default.createElement('br', null),
	                        '3.3.2. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0437\u0430\u044F\u0432\u043A\u0438 \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0432 \u0437\u0430\u044F\u0432\u043A\u0435 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u041F\u0440\u0430\u0432\u0438\u043B.',
	                        _react2.default.createElement('br', null),
	                        '3.3.3. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0441\u043B\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0437\u0430\u044F\u0432\u043A\u0438 \u0438\u043C\u0435\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0438\u0442\u044C \u0432\u0445\u043E\u0434 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u0443\u0442\u0435\u043C \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0433\u043E \u043A\u043E\u0434\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430,  \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u043E\u0433\u043E \u043F\u0440\u0438 \u0432\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043D\u043E\u043C\u0435\u0440\u0430 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u043C \u043E\u043A\u043D\u0435 \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441. \u041D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u043D\u043E\u043C\u0435\u0440\u0443 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0432 \u0437\u0430\u044F\u0432\u043A\u0435.',
	                        _react2.default.createElement('br', null),
	                        '3.4. \u041F\u0440\u043E\u0445\u043E\u0434\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u0432 \u0441\u0442\u0440\u043E\u0433\u043E\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u044B \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438 \u0434\u043B\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '3.5. \u041F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0443\u044E \u0438 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F. \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0442\u044C \u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E.',
	                        _react2.default.createElement('br', null),
	                        '3.6. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0430\u043D \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0442\u044C \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0441\u0442\u044C \u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0441\u0432\u043E\u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u043A\u0430\u0436\u0434\u043E\u0439 \u0441\u0435\u0441\u0441\u0438\u0438 \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439 \u0432\u044B\u0445\u043E\u0434 \u0438\u0437 \u0441\u0432\u043E\u0435\u0439 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438. \u0412\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u043C\u044B\u0435 \u043F\u043E\u0434 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.',
	                        _react2.default.createElement('br', null),
	                        '3.7. \u0415\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0435\u0432\u0435\u0440\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0438\u043B\u0438 \u0443 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0435\u0441\u0442\u044C \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0430\u0433\u0430\u0442\u044C, \u0447\u0442\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043D\u0435\u043F\u043E\u043B\u043D\u0430\u044F \u0438\u043B\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u0430\u044F, \u0442\u043E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043B\u0438\u0431\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0437\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0431\u0435\u0437 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0447\u0438\u043D.',
	                        _react2.default.createElement('br', null),
	                        '3.8. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0438\u043C \u0432 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u0445 \u043D\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442, \u0442\u043E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043C\u043E\u0436\u0435\u0442 \u0440\u0430\u0441\u0446\u0435\u043D\u0438\u0432\u0430\u0442\u044C \u044D\u0442\u043E \u043A\u0430\u043A \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C.',
	                        _react2.default.createElement('br', null),
	                        '3.9. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043D\u0435\u043C \u0438 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0439 \u0438\u043C \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0442\u0441\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430.',
	                        _react2.default.createElement('br', null),
	                        '3.10. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0445 \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043F\u043E \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438\u043B\u0438 \u043F\u0440\u0438 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u0441\u0432\u043E\u044E \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C.',
	                        _react2.default.createElement('br', null),
	                        '3.11. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0432\u043F\u0440\u0430\u0432\u0435 \u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u0438 \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E \u0441\u0432\u043E\u0435\u043C\u0443 \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0442\u0430\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u043A\u0430\u043A \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u0438\u043B\u0438 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u0430\u044F \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A \u0441\u0432\u043E\u0435\u0439 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043A\u0430\u043A\u043E\u0433\u043E-\u043B\u0438\u0431\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0438/\u0438\u043B\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C\u0443 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0435\u0441\u043B\u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043E\u0442 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446 \u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u0445 \u043F\u0440\u0430\u0432 \u043F\u0440\u0438 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0421\u0435\u0440\u0432\u0438\u0441\u0430. \u041B\u044E\u0431\u044B\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u044B \u0442\u043E\u043B\u043A\u043E\u0432\u0430\u0442\u044C\u0441\u044F, \u043A\u0430\u043A \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u044C \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043C\u0435\u0440\u044B \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E.',
	                        _react2.default.createElement('br', null),
	                        '3.12. \u0412 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u0441\u0435\u0431\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u044F\u0442\u044C \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0440\u0430\u043D\u0435\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u0443\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '4. \u041F\u0420\u0410\u0412\u041E\u0412\u041E\u0419 \u0421\u0422\u0410\u0422\u0423\u0421 \u0410\u0414\u041C\u0418\u041D\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F \u0421\u0415\u0420\u0412\u0418\u0421\u0410'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '4.1. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E:',
	                        _react2.default.createElement('br', null),
	                        '4.1.1. \u0412 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0435\u0433\u043E \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435 \u0438\u043B\u0438 \u0445\u0440\u0430\u043D\u044F\u0449\u0438\u0435\u0441\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B, \u043B\u044E\u0431\u044B\u0435 \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E;',
	                        _react2.default.createElement('br', null),
	                        '4.1.2. \u041F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435, \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C\u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u0430\u043C\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043A\u0430\u0441\u0430\u044E\u0449\u0438\u0435\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '4.1.3. \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0437\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438;',
	                        _react2.default.createElement('br', null),
	                        '4.1.4. \u0418\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u044F\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 (\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0439\u0441\u044F \u0432 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F), \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0430\u0440\u0443\u0448\u0430\u0435\u0442 \u0438/\u0438\u043B\u0438 \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0440\u0443\u0448\u0430\u0442\u044C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0420\u0424, \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u043F\u0440\u0430\u0432\u0430 \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C, \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u0442\u044C \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0430\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E \u0432\u0441\u0435\u043C \u0438\u043B\u0438 \u043A \u043B\u044E\u0431\u043E\u043C\u0443 \u0438\u0437 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E;',
	                        _react2.default.createElement('br', null),
	                        '4.1.5. \u0417\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0442\u044C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0438 \u0432 \u043B\u044E\u0431\u043E\u0439 \u0444\u043E\u0440\u043C\u0435 \u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0438 \u043D\u0430 \u0442\u043E, \u0447\u0442\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0435 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0431\u0443\u0434\u0443\u0442 \u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0441\u044F \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C\u0438;',
	                        _react2.default.createElement('br', null),
	                        '4.1.6. \u0423\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0442\u0430\u043A\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F;',
	                        _react2.default.createElement('br', null),
	                        '4.1.7. \u0414\u0435\u043B\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F;',
	                        _react2.default.createElement('br', null),
	                        '4.1.8. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0439 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432, \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0417\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F;',
	                        _react2.default.createElement('br', null),
	                        '4.1.9. \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0438\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u0446\u0435\u043B\u044C\u044E \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '5. \u041F\u0420\u0410\u0412\u041E\u0412\u041E\u0419 \u0421\u0422\u0410\u0422\u0423\u0421 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '5.1. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E:',
	                        _react2.default.createElement('br', null),
	                        '5.1.1. \u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u043C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F, \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0443 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '5.1.2. \u041E\u0431\u0440\u0430\u0449\u0430\u0442\u044C\u0441\u044F \u043A \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0439 \u043F\u043E \u043F\u043E\u0432\u043E\u0434\u0443 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '5.1.3. \u0422\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u0433\u043E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '5.2. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F:',
	                        _react2.default.createElement('br', null),
	                        '5.2.1. \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0430\u0432\u0434\u0438\u0432\u044B\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u043F\u0440\u0430\u0432\u043A\u0438, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0431\u0443\u0434\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F, \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u043E\u043C \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '5.2.2. \u0421\u0442\u0440\u043E\u0433\u043E \u0438 \u0432 \u043F\u043E\u043B\u043D\u043E\u0439 \u043C\u0435\u0440\u0435 \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u044E\u0442 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '5.2.3. \u041D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u0438 \u0435\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0439 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0432 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u043F\u0440\u0430\u0432\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445 \u0438\u043B\u0438 \u0432 \u0446\u0435\u043B\u044F\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043A\u0430\u043A\u0438\u043C-\u043B\u0438\u0431\u043E \u043E\u0431\u0440\u0430\u0437\u043E\u043C \u043D\u0430\u043D\u0435\u0441\u0442\u0438 \u0443\u0449\u0435\u0440\u0431 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u0438/\u0438\u043B\u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C;',
	                        _react2.default.createElement('br', null),
	                        '5.2.4. \u041D\u0435 \u0440\u0430\u0437\u0433\u043B\u0430\u0448\u0430\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0441\u0442\u0430\u043B\u0430 \u0435\u043C\u0443 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430 \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0432\u0437\u0430\u0438\u043C\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0439 \u0441 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '5.2.5. \u041D\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435;',
	                        _react2.default.createElement('br', null),
	                        '5.2.6. \u041D\u0435 \u0440\u0435\u0436\u0435 \u0447\u0435\u043C \u0440\u0430\u0437 \u0432 2 (\u0434\u0432\u0430) \u043C\u0435\u0441\u044F\u0446\u0430 \u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u043C \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u0438\u043D\u044B\u0445 \u043F\u0440\u0430\u0432\u0438\u043B, \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '5.3. \u041F\u0440\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u043F\u0440\u0435\u0449\u0430\u0435\u0442\u0441\u044F:',
	                        _react2.default.createElement('br', null),
	                        '5.3.1. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441 \u043B\u044E\u0431\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u043C\u0435\u0448\u0430\u0442\u044C \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0435\u0433\u043E \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432;',
	                        _react2.default.createElement('br', null),
	                        '5.3.2. \u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C, \u0445\u0440\u0430\u043D\u0438\u0442\u044C, \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C, \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u0432\u0438\u0440\u0443\u0441\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '5.3.3. \u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C, \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0430\u0440\u0443\u0448\u0430\u0435\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0435 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0420\u0424;',
	                        _react2.default.createElement('br', null),
	                        '5.3.4. \u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u0434\u0435\u0441\u0442\u0430\u0431\u0438\u043B\u0438\u0437\u0430\u0446\u0438\u044E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0438 \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0438\u043B\u0438 \u0435\u0433\u043E \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0430\u043C (\u0440\u0430\u0437\u0434\u0435\u043B\u0430\u043C, \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430), \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u0438\u043D\u044B\u0435 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F;',
	                        _react2.default.createElement('br', null),
	                        '5.3.5. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u0440\u0438\u043F\u0442\u044B (\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B) \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0438/\u0438\u043B\u0438 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C;',
	                        _react2.default.createElement('br', null),
	                        '5.3.6. \u041B\u044E\u0431\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u0443\u0442\u0435\u043C \u0432\u0437\u043B\u043E\u043C\u0430, \u043F\u044B\u0442\u0430\u0442\u044C\u0441\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0443\u0436\u043E\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0432\u043E\u043F\u0440\u0435\u043A\u0438 \u0432\u043E\u043B\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u043E\u043D\u0430 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0438\u0442;',
	                        _react2.default.createElement('br', null),
	                        '5.3.7. \u041F\u0435\u0440\u0435\u0447\u0435\u043D\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439 \u0438 \u043E\u0431\u044F\u0437\u0430\u043D\u043D\u043E\u0441\u0442\u0435\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u043E\u043F\u0438\u0441\u0430\u043D\u043D\u044B\u0439 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0441\u0447\u0435\u0440\u043F\u044B\u0432\u0430\u044E\u0449\u0438\u043C.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '6. \u041B\u0418\u0427\u041D\u042B\u0419 \u041A\u0410\u0411\u0418\u041D\u0415\u0422 \u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '6.1. \u0412 \u043C\u043E\u043C\u0435\u043D\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0438 \u0435\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043E\u043C, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443. \u041F\u043E\u0434 \u041B\u0438\u0447\u043D\u044B\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u043E\u043C \u043F\u043E\u043D\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0434\u043B\u044F \u043F\u043E\u043B\u043D\u043E\u0446\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '6.2. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0432\u0432\u043E\u0434\u0430 \u0423\u0447\u0435\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F.',
	                        _react2.default.createElement('br', null),
	                        '6.3. \u0412 \u041B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u043D\u043E\u0439 \u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043C\u0435\u043D\u044E \u0441 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430.',
	                        _react2.default.createElement('br', null),
	                        '6.4. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u041B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u043E\u0431 \u044D\u0442\u043E\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u0431\u0435\u0437 \u0442\u0430\u043A\u043E\u0432\u043E\u0433\u043E.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '7. \u041E\u0422\u0412\u0415\u0422\u0421\u0422\u0412\u0415\u041D\u041D\u041E\u0421\u0422\u042C \u0421\u0422\u041E\u0420\u041E\u041D'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '7.1. \u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u0443\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435, \u043D\u0435\u0441\u0435\u0442 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0432\u0448\u0438\u0439 \u0434\u0430\u043D\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E.',
	                        _react2.default.createElement('br', null),
	                        '7.2. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0423\u0447\u0435\u0442\u043D\u0443\u044E \u0417\u0430\u043F\u0438\u0441\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u041F\u0440\u0430\u0432\u0438\u043B, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.',
	                        _react2.default.createElement('br', null),
	                        '7.3. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043F\u043E \u0432\u0441\u0435\u043C \u0432\u0438\u0434\u0430\u043C \u0441\u0434\u0435\u043B\u043E\u043A, \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0435\u043C\u044B\u0445 \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438, \u0435\u0441\u043B\u0438 \u0442\u0430\u043A\u0438\u0435 \u0431\u044B\u043B\u0438 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u044B.',
	                        _react2.default.createElement('br', null),
	                        '7.4. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0437\u0430 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0441\u0442\u044C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445  \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438.',
	                        _react2.default.createElement('br', null),
	                        '7.5. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043F\u043E \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430\u043C \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438 \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0432\u043E\u0437\u043D\u0438\u043A\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '7.6. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442, \u0447\u0442\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0435, \u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u044B\u0435 \u0441\u0435\u0442\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u043C \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B \u043E\u0442 \u043E\u0448\u0438\u0431\u043E\u043A \u0438 \u0432\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0445 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0441\u043B\u0443\u0447\u0430\u0435, \u0435\u0441\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u043E\u0432\u043B\u0435\u043A\u043B\u043E \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0443\u0442\u0440\u0430\u0442\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u043F\u043E\u0440\u0447\u0443 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F.',
	                        _react2.default.createElement('br', null),
	                        '7.7. \u0417\u0430 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443, \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0430\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D, \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D \u043D\u0430 \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0440\u043E\u043A. \u0414\u043E\u0441\u0442\u0443\u043F \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D \u043F\u043E \u043F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u043E\u043C\u0443 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u044E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '8. \u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u041E\u041D\u041D\u0410\u042F \u0411\u0415\u0417\u041E\u041F\u0410\u0421\u041D\u041E\u0421\u0422\u042C \u0421\u0415\u0420\u0412\u0418\u0421\u0410'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '8.1. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435 \u043D\u0430\u0440\u0443\u0448\u0430\u0442\u044C \u0438\u043B\u0438 \u043D\u0435 \u043F\u044B\u0442\u0430\u0442\u044C\u0441\u044F \u043D\u0430\u0440\u0443\u0448\u0430\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0447\u0442\u043E \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F:',
	                        _react2.default.createElement('br', null),
	                        '8.1.1. \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043B\u044E\u0431\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043D\u0435 \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u043E\u0439 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043B\u0438 \u0432\u0445\u043E\u0434 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u043E\u0434 \u043B\u043E\u0433\u0438\u043D\u043E\u043C (\u043D\u043E\u043C\u0435\u0440\u043E\u043C \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430), \u043D\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u043C \u0434\u0430\u043D\u043D\u043E\u043C\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E;',
	                        _react2.default.createElement('br', null),
	                        '8.1.2. \u041F\u043E\u043F\u044B\u0442\u043A\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0443\u044F\u0437\u0432\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0431\u0435\u0437 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '8.1.3. \u041F\u043E\u043F\u044B\u0442\u043A\u0438 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043E\u043C\u0435\u0445\u0438 \u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0434\u0440\u0443\u0433\u0438\u043C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C, \u0447\u0442\u043E \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0445 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C, \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435, \u0438\u0441\u043A\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u0443\u044E \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0435\u0439\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438, \u043F\u0435\u0440\u0435\u0441\u044B\u043B\u043A\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u0440\u0432\u0435\u0440 \u0441\u0430\u0439\u0442\u0430, \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0443\u044E \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u0431\u043E\u043B\u044C\u0448\u043E\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0438/\u0438\u043B\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043A \u0421\u0435\u0440\u0432\u0438\u0441\u0443 \u0441 \u0446\u0435\u043B\u044C\u044E \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u043E \u0432\u044B\u0432\u0435\u0441\u0442\u0438 \u0441\u0435\u0440\u0432\u0435\u0440 \u0441\u0430\u0439\u0442\u0430 \u0438\u0437 \u0441\u0442\u0440\u043E\u044F \u0438 \u0442\u043E\u043C\u0443 \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u0432\u044B\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0437\u0430 \u0440\u0430\u043C\u043A\u0438 \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0446\u0435\u043B\u0435\u0432\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0438 \u0441\u043F\u043E\u0441\u043E\u0431\u043D\u044B\u0435 \u0443\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u043E \u0438\u043B\u0438 \u043F\u043E \u043D\u0435\u043E\u0441\u0442\u043E\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0441\u0431\u043E\u0438 \u0432 \u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0442\u0435.',
	                        _react2.default.createElement('br', null),
	                        '8.2. \u041D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u043E\u0439 \u0441\u0435\u0442\u0438 \u0432\u043B\u0435\u0447\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0443\u044E \u0438 \u0443\u0433\u043E\u043B\u043E\u0432\u043D\u0443\u044E \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0441\u043B\u0443\u0447\u0430\u0438 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0433\u043E \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0441\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0432 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0435 \u0441 \u043A\u043E\u043C\u043F\u0435\u0442\u0435\u043D\u0442\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u0440\u0435\u0441\u0435\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u0434\u043E\u0431\u043D\u043E\u0439 \u0437\u043B\u043E\u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438.',
	                        _react2.default.createElement('br', null),
	                        '8.3. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0435\u0442 \u0432\u0441\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u0443\u0441\u0438\u043B\u0438\u044F \u0434\u043B\u044F \u0442\u043E\u0433\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u0431\u0435\u0436\u0430\u0442\u044C \u043D\u0435\u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.',
	                        _react2.default.createElement('br', null),
	                        '8.4. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u0435\u0434\u0448\u0435\u0435 \u0438\u0437-\u0437\u0430:',
	                        _react2.default.createElement('br', null),
	                        '8.4.1. \u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u043C \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u0438, \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445 \u0438\u043B\u0438 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u043D\u044B\u0445 \u0441\u0435\u0442\u044F\u0445, \u043D\u0430\u0445\u043E\u0434\u044F\u0449\u0438\u0445\u0441\u044F \u0432\u043D\u0435 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430;',
	                        _react2.default.createElement('br', null),
	                        '8.4.2. \u041F\u0435\u0440\u0435\u0431\u043E\u0435\u0432 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u043C \u0438\u043B\u0438 \u043D\u0435\u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043F\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0442\u0440\u0435\u0442\u044C\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438;',
	                        _react2.default.createElement('br', null),
	                        '8.4.3. \u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043F\u0430\u0440\u043E\u043B\u0435\u0439 \u0438\u043B\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0434\u0440\u0443\u0433\u0438\u043C \u043B\u0438\u0446\u0430\u043C.',
	                        _react2.default.createElement('br', null),
	                        '8.5. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0435 \u043D\u0435\u0446\u0435\u043B\u0435\u0432\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438\u043B\u0438 \u0438\u043D\u044B\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u0431\u0435\u0437 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0441 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u0435\u0437 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '9. \u0418\u041D\u0422\u0415\u041B\u041B\u0415\u041A\u0422\u0423\u0410\u041B\u042C\u041D\u0410\u042F \u0421\u041E\u0411\u0421\u0422\u0412\u0415\u041D\u041D\u041E\u0421\u0422\u042C \u0421\u0415\u0420\u0412\u0418\u0421\u0410'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '9.1. \u0421\u0435\u0440\u0432\u0438\u0441 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u0435 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0435\u0435 \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043B\u0438\u0446\u0430\u043C \u0438 \u0434\u0440\u0443\u0433\u0438\u043C \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441\u0442\u043E\u0440\u043E\u043D\u0430\u043C, \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044F\u043C, \u0432\u0441\u0435\u043C \u043F\u0440\u043E\u0447\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u043E\u0442 \u0438\u043C\u0435\u043D\u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.',
	                        _react2.default.createElement('br', null),
	                        '9.2. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0421\u0435\u0440\u0432\u0438\u0441, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442 \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0441\u044F \u0441 \u0442\u0435\u043C, \u0447\u0442\u043E \u0432\u0441\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u0421\u0435\u0440\u0432\u0438\u0441 \u0438 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B \u0430\u0432\u0442\u043E\u0440\u0441\u043A\u0438\u043C \u043F\u0440\u0430\u0432\u043E\u043C, \u043F\u0440\u0430\u0432\u043E\u043C \u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u043D\u044B\u0439 \u0437\u043D\u0430\u043A \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438 \u043D\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0438 \u0447\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0438 \u043E\u0445\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F \u0432\u043E \u0432\u0441\u0435\u0445 \u0444\u043E\u0440\u043C\u0430\u0445, \u043D\u0430 \u0432\u0441\u0435\u0445 \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F\u0445 \u0438 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0432\u0441\u0435\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439, \u043A\u0430\u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F, \u0442\u0430\u043A \u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043F\u043E\u0441\u043B\u0435\u0434\u0441\u0442\u0432\u0438\u0438. \u041D\u0438\u043A\u0430\u043A\u0438\u0435 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u043B\u044E\u0431\u043E\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442 \u043A \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0432 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F.',
	                        _react2.default.createElement('br', null),
	                        '9.3. \u0412\u043E \u0438\u0437\u0431\u0435\u0436\u0430\u043D\u0438\u0435 \u0441\u043E\u043C\u043D\u0435\u043D\u0438\u0439, \u043A\u0430\u043A \u0432 \u0446\u0435\u043B\u044F\u0445 \u0437\u0430\u0449\u0438\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0430\u0432, \u0442\u0430\u043A \u0438 \u0432 \u043B\u044E\u0431\u044B\u0445 \u0438\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0437\u0430\u043F\u0440\u0435\u0449\u0430\u0435\u0442\u0441\u044F:',
	                        _react2.default.createElement('br', null),
	                        '9.3.1. \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438/\u0438\u043B\u0438 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u0442\u044C \u043A\u0430\u043A\u0438\u0435-\u043B\u0438\u0431\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u0430\u0432, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435 (\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B, \u0432\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B, \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0442\u043E\u0432\u0430\u0440\u043D\u044B\u0445 \u0437\u043D\u0430\u043A\u043E\u0432, \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u044B, \u0431\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445, \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0438, \u0442\u0435\u043A\u0441\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0438\u0437\u0430\u0439\u043D, \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443, \u0432\u044B\u0431\u043E\u0440, \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0446\u0438\u044E, \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434, \u043E\u0431\u0449\u0438\u0439 \u0441\u0442\u0438\u043B\u044C \u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u044F,\xA0\u0432\u0445\u043E\u0434\u044F\u0449\u0435\u0433\u043E \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430), \u043A\u0440\u043E\u043C\u0435 \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043A\u043E\u0433\u0434\u0430 \u0442\u0430\u043A\u0430\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u044F \u043F\u0440\u044F\u043C\u043E \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0430 (\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0430) \u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0435;',
	                        _react2.default.createElement('br', null),
	                        '9.3.2. \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C, \u043B\u0438\u0431\u043E \u0438\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u0443\u044E \u0447\u0430\u0441\u0442\u044C \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0435\u0433\u043E \u0434\u0438\u0437\u0430\u0439\u043D.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '10. \u0420\u0410\u0417\u0420\u0415\u0428\u0415\u041D\u0418\u0415 \u0421\u041F\u041E\u0420\u041E\u0412'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '10.1. \u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0440\u0435\u0433\u0443\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0438 \u0442\u043E\u043B\u043A\u0443\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424.',
	                        _react2.default.createElement('br', null),
	                        '10.2. \u0412\u0441\u0435 \u0441\u043F\u043E\u0440\u044B, \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0438\u0435 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u0440\u0435\u0448\u0430\u044E\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432.',
	                        _react2.default.createElement('br', null),
	                        '10.3. \u041F\u0440\u0438 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0443\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u043F\u043E\u0440\u0430 \u043F\u0443\u0442\u0435\u043C \u043F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043E\u0432, \u0441\u043F\u043E\u0440 \u043F\u0435\u0440\u0435\u0434\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435 \u0441\u0443\u0434\u043E\u0432 \u043B\u044E\u0431\u043E\u0439 \u044E\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u0438 \u043F\u043E \u043C\u0435\u0441\u0442\u0443 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '11. \u0417\u0410\u041A\u041B\u042E\u0427\u0418\u0422\u0415\u041B\u042C\u041D\u042B\u0415 \u041F\u041E\u041B\u041E\u0416\u0415\u041D\u0418\u042F'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '11.1. \u0421\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043C\u0435\u0436\u0434\u0443 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u043E\u0440\u044F\u0434\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430, \u043D\u043E\u0441\u0438\u0442 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0430\u043A\u0446\u0435\u043F\u0442\u0430 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u043D\u0430 \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0440\u043E\u043A.',
	                        _react2.default.createElement('br', null),
	                        '11.2. \u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0421\u0435\u0440\u0432\u0438\u0441\u0430 \u0434\u043B\u044F \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439: it@nedvx.ru'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u0414\u0430\u0442\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438: 28.06.2017\u0433.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            '\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u0440\u0432\u0438\u0441\u0430:'
	                        ),
	                        '\u041E\u041E\u041E \xAB\u041D\u0415\u0414\u0412\u0415\u041A\u0421\xBB ',
	                        _react2.default.createElement('br', null),
	                        '\u042E\u0440.\u0430\u0434\u0440\u0435\u0441: 354207, \u0433.\u0421\u043E\u0447\u0438, \u041B\u0430\u0437\u0430\u0440\u0435\u0432\u0441\u043A\u0438\u0439 \u0440\u0430\u0439\u043E\u043D, \u043F.\u0414\u0430\u0433\u043E\u043C\u044B\u0441, \u0443\u043B.\u041B\u0435\u0442\u043D\u044F\u044F, \u0443\u0447. \u211615/2 ',
	                        _react2.default.createElement('br', null),
	                        '\u0424\u0430\u043A\u0442.\u0430\u0434\u0440\u0435\u0441: 354000, \u0433.\u0421\u043E\u0447\u0438, \u043F\u0435\u0440.\u041C\u043E\u0440\u0441\u043A\u043E\u0439, \u0434.1/1, 5 \u044D\u0442\u0430\u0436 ',
	                        _react2.default.createElement('br', null),
	                        '\u0418\u041D\u041D 2318043183, \u041A\u041F\u041F 231801001 ',
	                        _react2.default.createElement('br', null),
	                        '\u0412 \u0424\u0438\u043B\u0438\u0430\u043B\u0435 \u042E\u0436\u043D\u044B\u0439 \u041F\u0410\u041E \u0411\u0430\u043D\u043A\u0430 \xAB\u0424\u041A \u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435\xBB ',
	                        _react2.default.createElement('br', null),
	                        '\u0411\u0418\u041A 046029058'
	                    )
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return Soglashenie;
	}(_react.Component);
	
	exports.default = Soglashenie;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Soglashenie = __webpack_require__(1152);
	
	var _Soglashenie2 = _interopRequireDefault(_Soglashenie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Soglashenie2.default;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StatelessSwitcher = __webpack_require__(1115);
	
	var _StatelessSwitcher2 = _interopRequireDefault(_StatelessSwitcher);
	
	var _tracker = __webpack_require__(18);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switcher = function (_Component) {
	  _inherits(Switcher, _Component);
	
	  function Switcher(props) {
	    _classCallCheck(this, Switcher);
	
	    var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props));
	
	    _this.handleTrackEvent = function (_ref) {
	      var eventName = _ref.eventName,
	          eventLabel = _ref.eventLabel;
	      var _this$props = _this.props,
	          buildingData = _this$props.buildingData,
	          objectType = _this$props.objectType,
	          profile = _this$props.profile;
	      var title = buildingData.title,
	          id = buildingData.id;
	
	
	      (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	        eventLabel: eventLabel,
	        productType: objectType,
	        productName: title,
	        productID: id,
	        user_id: profile.id
	      }));
	    };
	
	    _this.state = {
	      isChecked: 'defaultChecked' in _this.props ? _this.props.defaultChecked : true
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Switcher, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onClick = _props.onClick,
	          events = _props.events,
	          eventData = _props.eventData,
	          gaEventName = _props.gaEventName,
	          gaEventData = _props.gaEventData;
	
	      this.setState({ isChecked: !this.state.isChecked }, function () {
	        _tracker2.default.sendEvent(_this2.state.isChecked ? events.left : events.right, eventData);
	        _this2.handleTrackEvent({
	          eventName: gaEventName,
	          eventLabel: _this2.state.isChecked ? gaEventData.left : gaEventData.right
	        });
	        onClick(_this2.state.isChecked);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_StatelessSwitcher2.default, _extends({}, this.props, {
	        onClick: this.handleClick,
	        isChecked: this.state.isChecked
	      }));
	    }
	  }]);
	
	  return Switcher;
	}(_react.Component);
	
	exports.default = Switcher;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebaskProvider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _profile = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WEBASK_ID = 'hi8kalb87';
	
	var WebaskProvider = exports.WebaskProvider = function WebaskProvider(_ref) {
	  var children = _ref.children,
	      profile = _ref.profile;
	
	  var timerRef = (0, _react.useRef)();
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    var needLoadScript = !(timerRef.current || !profile || !profile.isLoaded);
	
	    if (needLoadScript) {
	      if (!profile.survey && profile.tariff && profile.tariff.countDay > 0) {
	        timerRef.current = setTimeout(function () {
	          if (window.WebAsk && window.WebAsk.popup && !window.WebAsk.isAnswered(WEBASK_ID)) {
	            window.WebAsk.popup(WEBASK_ID);
	            var updatedProfile = _extends({}, profile, {
	              survey: true
	            });
	            dispatch((0, _profile.updateProfileSurvey)(updatedProfile));
	          }
	        }, 2 * 60 * 1000);
	      }
	    }
	  }, [profile]);
	
	  (0, _react.useEffect)(function () {
	    if (!window.WebAsk && profile.isLoaded && !profile.survey) {
	      (function (w, e, b, a, s, k) {
	        w[e] = w[e] || b;
	        w[e].b.push({
	          id: ['a26279', WEBASK_ID],
	          overlay: 'rgba(128, 128, 128, 0.3)',
	          type: 'popup'
	        });
	        a.async = true;
	        a.src = s + k;
	        document.querySelector('head').appendChild(a);
	      })(window, 'WebAsk', { b: [] }, document.createElement('script'), document.location.protocol === 'https:' ? 'https:' : 'http:', '//app.webask.io/static/api.js');
	    }
	  }, [profile]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    children
	  );
	};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxObservable = __webpack_require__(730);
	
	var _operators = __webpack_require__(2372);
	
	var _path = __webpack_require__(151);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _utils = __webpack_require__(12);
	
	var _index = __webpack_require__(222);
	
	var _i18n = __webpack_require__(21);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _rxjs = __webpack_require__(2255);
	
	var _ga = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleTrackEvent = function handleTrackEvent(_ref) {
	  var eventName = _ref.eventName,
	      eventContent = _ref.eventContent,
	      eventLabel = _ref.eventLabel,
	      user_id = _ref.user_id;
	
	  (0, _ga.trackGA)(_ga.gaEvent[eventName]({
	    eventLabel: eventLabel,
	    eventContent: eventContent,
	    user_id: user_id
	  }));
	};
	
	var noop = function noop() {
	  return { type: 'NOOP' };
	};
	
	var loginEpic = function loginEpic(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)('SMS_FORM_SENDING_SUCCESS'), (0, _operators.map)(function (response) {
	    localStorage.setItem('token', response.payload.token);
	    localStorage.setItem('public', response.payload.hash);
	    (0, _utils.initAxios)(response.payload.token);
	  }), (0, _operators.map)(function (payload) {
	    return _extends({}, payload, { type: 'USER_LOGIN' });
	  }));
	};
	
	var initEpic = function initEpic(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)('INIT_APP'), (0, _operators.map)(function () {
	    var token = '';
	    try {
	      token = localStorage.getItem('token');
	    } catch (e) {}
	    if (token) {
	      (0, _utils.initAxios)(token);
	    }
	  }), (0, _operators.map)(noop));
	};
	
	var logoutEpic = function logoutEpic(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)('USER_LOGOUT_SUCCESS'), (0, _operators.map)(function () {
	    localStorage.removeItem('token');
	    localStorage.removeItem('sendProfileInfo');
	    (0, _utils.initAxios)();
	  }), (0, _operators.map)(noop));
	};
	
	var notificationEpicCreator = function notificationEpicCreator(_ref2) {
	  var type = _ref2.type,
	      _ref2$hide = _ref2.hide,
	      hide = _ref2$hide === undefined ? false : _ref2$hide,
	      status = _ref2.status,
	      message = _ref2.message,
	      eventData = _ref2.eventData,
	      _ref2$filter = _ref2.filter1,
	      filter1 = _ref2$filter === undefined ? function (_) {
	    return _;
	  } : _ref2$filter;
	  return function (action$) {
	    return action$.pipe(_reduxObservable.ofType.apply(undefined, _toConsumableArray(Array.isArray(type) ? type : [type])), (0, _operators.filter)(filter1), (0, _operators.map)(function (a) {
	      return {
	        type: hide ? 'HIDE_NOTIFICATION' : 'SHOW_NOTIFICATION',
	        payload: {
	          message: typeof message === 'function' ? message(a, _index.store.getState()) : message,
	          eventData: _extends({}, eventData, a.meta),
	          cancel: (0, _path2.default)(['meta', 'cancel'], a),
	          status: status
	        }
	      };
	    }));
	  };
	};
	
	var getCollectionMessage = function getCollectionMessage(_ref3) {
	  var prevCount = _ref3.prevCount,
	      buildingName = _ref3.buildingName,
	      collectionName = _ref3.collectionName;
	
	  var name = buildingName || _i18n2.default.t('common.jk');
	  if (Math.abs(prevCount) > 1) {
	    return prevCount > 0 ? _i18n2.default.t('epics.addedToCollections1', { buildingName: name }) : _i18n2.default.t('epics.removeFromCollections1', { buildingName: name });
	  }
	
	  return prevCount > 0 ? _i18n2.default.t('epics.addedToCollections2', { buildingName: name, collectionName: collectionName }) : _i18n2.default.t('epics.removeFromCollections2', { buildingName: name, collectionName: collectionName });
	};
	var collectionNotificationEpicCreator = function collectionNotificationEpicCreator() {
	  return function (action$) {
	    return action$.pipe((0, _reduxObservable.ofType)('ADD_TO_COLLECTION_SUCCESS', 'REMOVE_FROM_COLLECTION_SUCCESS', 'CLOSE_COLLECTIONS_DIALOG', 'CANCELATION_SUCCESS'), (0, _operators.scan)(function (data, action) {
	      return action.type === 'CLOSE_COLLECTIONS_DIALOG' || action.type === 'CANCELATION_SUCCESS' ? _extends({}, data, action, {
	        count: 0,
	        prevCount: data.count,
	        finished: true,
	        cancel: data.count < 0 ? data.cancel : null
	      }) : _extends({}, data, action, {
	        count: data.count + (action.type === 'ADD_TO_COLLECTION_SUCCESS' ? 1 : -1),
	        prevCount: data.count,
	        cancel: (data.finished ? [] : data.cancel).concat((0, _path2.default)(['meta', 'cancel'], action)),
	        finished: false
	      });
	    }, { count: 0, prevCount: 0, meta: {}, finished: true }), (0, _operators.filter)(function (action) {
	      return action.type === 'CLOSE_COLLECTIONS_DIALOG' || action.type === 'CANCELATION_SUCCESS';
	    }), (0, _operators.map)(function (_ref4) {
	      var prevCount = _ref4.prevCount,
	          cancel = _ref4.cancel,
	          _ref4$meta = _ref4.meta,
	          _ref4$meta$buildingNa = _ref4$meta.buildingName,
	          buildingName = _ref4$meta$buildingNa === undefined ? null : _ref4$meta$buildingNa,
	          collectionName = _ref4$meta.collectionName;
	      return Math.abs(prevCount) > 0 ? {
	        type: 'SHOW_NOTIFICATION',
	        payload: {
	          message: getCollectionMessage({ buildingName: buildingName, prevCount: prevCount, collectionName: collectionName }),
	          status: prevCount < 0 ? 1 : 0,
	          cancel: cancel
	        }
	      } : noop;
	    }));
	  };
	};
	//   ({meta: {buildingName, collectionName}}) => (
	//     action$.ofType('CLOSE_COLLECTIONS_DIALOG').map(
	//       () => ({
	//         type: 'SHOW_NOTIFICATION',
	//         payload: {
	//           message: `${buildingName || 'ЖК'} ${act}`
	//         }
	//       })
	//     )
	//   )
	// )
	
	var handleProfileUpdate = function handleProfileUpdate(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)('CREATE_PROFILE_ERROR', 'UPDATE_PROFILE_ERROR', 'UPDATE_AGENT_PROFILE_ERROR', 'UPDATE_PROFILE_OK'), (0, _operators.mergeMap)(function (action) {
	    if (action.type === 'CREATE_PROFILE_ERROR' || action.type === 'UPDATE_PROFILE_ERROR' || action.type === 'UPDATE_AGENT_PROFILE_ERROR') {
	      var error = (0, _path2.default)(['payload', 'error', 'response', 'data', 'error'], action);
	
	      if (error && error['error-code']) {
	        var errorCode = error['error-code'];
	        var errorFields = {};
	
	        if (errorCode === 'ERROR_PHONE_ALREADY_USED') {
	          errorFields.phone = _i18n2.default.t('components.profile.profileForm.validate.phoneConflict');
	        } else if (errorCode === 'ERROR_EMAIL_ALREADY_USED') {
	          errorFields.email = _i18n2.default.t('components.profile.profileForm.validate.emailConflict');
	        }
	
	        return (0, _rxjs.of)({
	          type: '@@redux-form/UPDATE_SYNC_ERRORS',
	          meta: { form: 'ProfileForm' },
	          payload: {
	            syncErrors: errorFields
	          }
	        });
	      }
	    } else if (action.type === 'UPDATE_PROFILE_OK') {
	      handleTrackEvent({
	        eventName: 'profileSaveSuccessAndErrorsShow',
	        eventLabel: 'sohraneno',
	        user_id: action.payload.response.id
	      });
	    }
	
	    return _rxjs.EMPTY;
	  }));
	};
	
	var handleLeaveProfileAgency = function handleLeaveProfileAgency(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)('LEAVE_PROFILE_AGENCY_ERROR'), (0, _operators.mergeMap)(function (action) {
	    var error = (0, _path2.default)(['payload', 'error', 'response', 'data', 'error'], action);
	
	    if (error && error['error-code']) {
	      return (0, _rxjs.of)({
	        type: 'SHOW_NOTIFICATION',
	        payload: {
	          message: _i18n2.default.t('epics.leaveAgencyError'),
	          status: 1
	        }
	      });
	    }
	
	    return noop();
	  }));
	};
	
	var rootEpic = (0, _reduxObservable.combineEpics)(initEpic, loginEpic, logoutEpic, handleProfileUpdate, handleLeaveProfileAgency, _reduxObservable.combineEpics.apply(undefined, _toConsumableArray([{
	  type: '@@redux-form/SET_SUBMIT_FAILED',
	  filter: function filter(a) {
	    return (0, _path2.default)(['meta', 'form'])(a) === 'ProfileForm';
	  },
	  message: function message(action, state) {
	    var _ref5 = (0, _path2.default)(['form', 'ProfileForm', 'values'], state) || {},
	        firstName = _ref5.firstName,
	        lastName = _ref5.lastName,
	        email = _ref5.email,
	        phone = _ref5.phone,
	        position = _ref5.position;
	
	    if (!firstName || !lastName || !email || !phone || !position) {
	      return _i18n2.default.t('epics.emptyFieldsError');
	    }
	    return _i18n2.default.t('epics.fieldsError');
	  },
	  status: 1
	}, {
	  type: '@@redux-form/SET_SUBMIT_FAILED',
	  filter: function filter(a) {
	    return (0, _path2.default)(['meta', 'form'])(a) === 'CompanyForm';
	  },
	  message: function message(action, state) {
	    var values = (0, _path2.default)(['form', 'CompanyForm', 'values'], state) || {};
	    var requiredKeys = Object.keys(values).filter(function (key) {
	      return key === 'name' || key.includes('office');
	    });
	    if (requiredKeys.some(function (key) {
	      return !key;
	    })) {
	      return _i18n2.default.t('epics.emptyFieldsError');
	    }
	    return _i18n2.default.t('epics.fieldsError');
	  },
	  status: 1
	}, {
	  type: '@@redux-form/UPDATE_SYNC_ERRORS',
	  filter: function filter(a) {
	    return Object.values((0, _path2.default)(['meta', 'form'], a)).length;
	  },
	  hide: true
	}, {
	  type: 'CHECK_BUILDING_START',
	  hide: true
	}, {
	  type: 'SET_POPUP',
	  filter: function filter(a) {
	    return !a.popUp;
	  },
	  hide: true
	}, {
	  type: ['UPDATE_PROFILE_OK', 'UPDATE_AGENT_PROFILE_OK', 'UPDATE_COMPANY_OK'],
	  message: _i18n2.default.t('epics.savedInfo')
	}, {
	  type: ['LEAVE_PROFILE_AGENCY_OK'],
	  message: _i18n2.default.t('epics.leavedFromAgency')
	}, {
	  type: ['REGISTRATION_SUCCESS'],
	  message: _i18n2.default.t('epics.registrationSuccess')
	}, {
	  type: 'DELETE_COLLECTION_SUCCESS',
	  message: _i18n2.default.t('epics.deletedCollection'),
	  status: 1
	}, {
	  type: 'REMOVE_FROM_FAVORITES_SUCCESS',
	  message: function message(_ref6) {
	    var buildingName = _ref6.meta.buildingName;
	    return _i18n2.default.t('epics.deleteFromFavorites', {
	      buildingName: buildingName || _i18n2.default.t('common.jk')
	    });
	  },
	  status: 1
	}, {
	  type: 'REMOVE_FROM_COLLECTION_SUCCESS',
	  message: function message(_ref7) {
	    var _ref7$meta = _ref7.meta,
	        buildingName = _ref7$meta.buildingName,
	        collectionName = _ref7$meta.collectionName;
	    return _i18n2.default.t('epics.removeFromCollections2', {
	      buildingName: buildingName || _i18n2.default.t('common.jk'),
	      collectionName: collectionName
	    });
	  },
	  status: 1
	}, {
	  type: 'ADD_TO_COLLECTION_SUCCESS',
	  filter: function filter(a) {
	    return !(0, _path2.default)(['meta', 'cancelation'], a);
	  },
	  message: function message(_ref8) {
	    var _ref8$meta = _ref8.meta,
	        buildingName = _ref8$meta.buildingName,
	        collectionName = _ref8$meta.collectionName;
	    return _i18n2.default.t('epics.addedToCollections2', {
	      buildingName: buildingName || _i18n2.default.t('common.jk'),
	      collectionName: collectionName
	    });
	  }
	}, {
	  type: 'ADD_TO_FAVORITES_SUCCESS',
	  message: function message(_ref9) {
	    var buildingName = _ref9.meta.buildingName;
	    return _i18n2.default.t('epics.addedToFavorites', { buildingName: buildingName || _i18n2.default.t('common.jk') });
	  }
	}, {
	  type: 'LOAD_CALENDAR_ERROR',
	  message: _i18n2.default.t('epics.loadCalendarError'),
	  status: 1
	}, {
	  type: 'LOAD_APPOINTMENT_STATUSES_ERROR',
	  message: _i18n2.default.t('epics.loadAppointmentStatusesError'),
	  status: 1
	}, {
	  type: 'CREATE_APPOINTMENT_FORM_ERROR',
	  message: _i18n2.default.t('epics.fieldsError'),
	  status: 1
	}].map(notificationEpicCreator))), collectionNotificationEpicCreator());
	
	exports.default = rootEpic;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global localStorage */
	
	
	exports.default = authentication;
	
	var _ramda = __webpack_require__(595);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var token = '';
	
	try {
	  token = localStorage.getItem('token');
	} catch (e) {
	  console.error('No auth token found');
	}
	
	var removeToken = function removeToken() {
	  (0, _utils.initAxios)();
	  localStorage.removeItem('token');
	};
	
	var initialState = {
	  authenticated: !!token
	};
	
	function authentication() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.USER_LOGIN:
	      return _extends({}, state, { authenticated: true });
	    case types.USER_LOGOUT_START:
	      return _extends({}, state, { authenticated: false });
	    default:
	      if ((_ramda2.default.path(['payload', 'error', 'response', 'data', 'error', 'error-code'], action) || _ramda2.default.path(['payload', 'error', 'data', 'error', 'error-code'], action)) === 'USER_HAS_NOT_PERMISSION') {
	        removeToken(); // TODO: Move into separate middleware
	        return _extends({}, state, { authenticated: false });
	      }
	      return state;
	  }
	}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxAct = __webpack_require__(108);
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  text: null,
	  color_banner: '#FFFFFF',
	  color_topic: '#0D69F2'
	};
	
	var banner = (0, _reduxAct.createReducer)(_defineProperty({}, types.SET_BANNER, function (state, payload) {
	  return _extends({}, state, payload);
	}), initialState);
	
	exports.default = banner;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = building;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultState = {
	  cities: [],
	  isLoading: false,
	  data: null,
	  isPavilionsLoading: false,
	  pavilions: null,
	  isDocumentsLoading: false,
	  documents: null,
	  isNewsLoading: false,
	  news: null,
	  isChessLoading: false,
	  chessList: {},
	  cells: {},
	  selected: {},
	  filters: {
	    section: [0, 0],
	    priceMin: null,
	    priceMax: null,
	    costMin: null,
	    costMax: null
	  },
	  isTable: true,
	  isExtended: false,
	  listSort: ['number', true],
	  tableScroll: {},
	  prevLocation: '',
	  isDescriptionHide: false,
	  error: null,
	  zoom: 1.25
	};
	
	var zoomVariants = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
	
	var initialState = _extends({}, defaultState);
	
	function building() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case types.SET_CITIES:
	      return _extends({}, state, {
	        cities: payload
	      });
	    case types.LOAD_BUILDING_START:
	      return _extends({}, state, state.data && ~~payload.id === state.data.id ? {} : defaultState, {
	        zoom: state.zoom,
	        isLoading: true,
	        cities: state.cities
	      });
	    case types.LOAD_BUILDING_SUCCESS:
	      return _extends({}, state, { data: payload.data, prevLocation: '', isLoading: false });
	    case types.LOAD_BUILDING_ERROR:
	      return _extends({}, state, { error: payload, isLoading: false });
	
	    case types.LOAD_PAVILIONS_START:
	      return _extends({}, state, { pavilions: null, isPavilionsLoading: true });
	    case types.LOAD_PAVILIONS_SUCCESS:
	      return _extends({}, state, {
	        pavilions: payload.data,
	        isPavilionsLoading: false
	      });
	    case types.LOAD_PAVILIONS_ERROR:
	      return _extends({}, state, { error: payload, isPavilionsLoading: false });
	
	    case types.LOAD_DOCUMENTS_START:
	      return _extends({}, state, { isDocumentsLoading: true });
	    case types.LOAD_DOCUMENTS_SUCCESS:
	      return _extends({}, state, {
	        documents: payload.data,
	        isDocumentsLoading: false
	      });
	    case types.LOAD_DOCUMENTS_ERROR:
	      return _extends({}, state, { error: payload, isDocumentsLoading: false });
	
	    case types.LOAD_NEWS_START:
	      return _extends({}, state, { isNewsLoading: true });
	    case types.LOAD_NEWS_SUCCESS:
	      return _extends({}, state, {
	        news: payload.data.sort(function (a, b) {
	          return a.dateCreate < b.dateCreate;
	        }),
	        isNewsLoading: false
	      });
	    case types.LOAD_NEWS_ERROR:
	      return _extends({}, state, { error: payload, isNewsLoading: false });
	
	    case types.LOAD_CHESS_START:
	      return _extends({}, state, { isChessLoading: true });
	    case types.LOAD_CHESS_SUCCESS:
	      return _extends({}, state, {
	        chessList: _extends({}, state.chessList, _defineProperty({}, payload.id, payload.data)),
	        isChessLoading: false
	      });
	    case types.LOAD_CHESS_ERROR:
	      return _extends({}, state, { error: payload, isChessLoading: false });
	
	    case types.SET_CHESS_CELLS:
	      {
	        return _extends({}, state, {
	          cells: _extends({}, state.cells, _defineProperty({}, payload.id, payload.cells)),
	          selected: state.selected[payload.id] ? state.selected : _extends({}, state.selected, _defineProperty({}, payload.id, payload.selected))
	        });
	      }
	    case types.LOAD_OBJECTS_SUCCESS:
	      {
	        return _extends({}, initialState, {
	          cities: state.cities
	        });
	      }
	
	    case types.SET_CELL_SELECTED:
	      return _extends({}, state, { selected: _extends({}, state.selected, _defineProperty({}, payload.id, payload.selected)) });
	
	    case types.SET_CHESS_FILTERS:
	      return _extends({}, state, {
	        filters: _extends({}, state.filters, payload)
	      });
	
	    case types.SET_CHESS_TABLE:
	      return _extends({}, state, { isTable: payload });
	
	    case types.SET_CHESS_EXTENDED:
	      return _extends({}, state, { isExtended: !state.isExtended });
	    case types.SET_ZOOM:
	      {
	        if (payload.zoomWithRange) {
	          return _extends({}, state, { zoom: payload.zoom });
	        }
	        var currentZoomIndex = zoomVariants.findIndex(function (zoomVariant) {
	          return zoomVariant === state.zoom;
	        });
	        var nextZoomIndex = Math.min(zoomVariants.length - 1, Math.max(0, currentZoomIndex + payload.zoom));
	        return _extends({}, state, { zoom: zoomVariants[nextZoomIndex] });
	      }
	    case types.SET_LIST_SORT:
	      return _extends({}, state, { listSort: payload, tableScroll: {} });
	
	    case types.SET_CHESS_DESCRIPTION_HIDE:
	      return _extends({}, state, { isDescriptionHide: !state.isDescriptionHide });
	
	    case types.SET_TABLE_SCROLL:
	      return _extends({}, state, { tableScroll: _extends({}, state.tableScroll, _defineProperty({}, payload.id, payload.scroll)) });
	
	    case types.SET_PREV_LOCATION:
	      return _extends({}, state, { prevLocation: payload });
	
	    case types.UPDATE_CHESS_STATE:
	      return _extends({}, state, payload);
	
	    case types.ADD_TO_FAVORITES_START:
	      if (state.data) {
	        return _extends({}, state, { data: _extends({}, state.data, { favorite: true }) });
	      }
	      return state;
	
	    case types.REMOVE_FROM_FAVORITES_START:
	      if (state.data) {
	        return _extends({}, state, { data: _extends({}, state.data, { favorite: false }) });
	      }
	      return state;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profile;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _collections = __webpack_require__(49);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// import keyBy from 'lodash.keyby'
	//
	var errorsForNoPage = ['BUILDING_IN_SELECTION_NOT_FOUND', 'SELECTION_NOT_FOUND'];
	
	var initialState = {
	  selection: {
	    name: null
	  },
	  isLoading: false,
	  buildings: []
	};
	
	function profile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LOAD_COLLECTION_START:
	      return _extends({}, state, { isLoading: true });
	    case types.LOAD_COLLECTION_SUCCESS:
	      return _extends({}, state, action.payload.data, { buildings: action.payload.data.buildings || [], isLoading: false });
	    case types.LOAD_COLLECTION_ERROR:
	      return _extends({}, state, {
	        error: action.payload.error,
	        isLoading: false,
	        noPageExist: errorsForNoPage.includes(action.payload.error['error-code'])
	      });
	    case types.LOAD_COLLECTION_BUILDING_START:
	      return _extends({}, state, { isLoading: true });
	    case types.LOAD_COLLECTION_BUILDING_SUCCESS:
	      return _extends({}, state, {
	        user: action.payload.data.user,
	        building: action.payload.data.buildings,
	        selection: action.payload.data.selection || { showInfo: '1' },
	        isLoading: false
	      });
	    case types.LOAD_COLLECTION_BUILDING_ERROR:
	      return _extends({}, state, {
	        error: action.payload.error,
	        isLoading: false,
	        noPageExist: errorsForNoPage.includes(action.payload.error['error-code'])
	      });
	    case types.REMOVE_FROM_COLLECTION_SUCCESS:
	      if (action.payload.referal === state.selection.referal) {
	        return _extends({}, state, { buildings: state.buildings.filter(function (building) {
	            return +building.id !== +action.payload.buildingId;
	          }) });
	      }
	      return state;
	
	    case types.ADD_TO_COLLECTION_SUCCESS:
	      if (action.payload.referal === state.selection.referal) {
	        return _extends({}, state, { buildings: state.buildings.concat(action.meta.data) });
	      }
	      return state;
	
	    case types.COMMENT_COLLECTION_SUCCESS:
	      return _extends({}, state, { buildings: state.buildings.map(function (building) {
	          return +building.id === +action.payload.buildingId ? _extends({}, building, { comment: action.payload.comment }) : building;
	        }) });
	
	    case _collections.switchInfoAccess.request.toString():
	      return _extends({}, state, {
	        selection: _extends({}, state.selection, {
	          showInfo: action.payload.showInfo
	        })
	      });
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profile;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _lodash = __webpack_require__(1646);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  data: null
	};
	
	function profile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LOAD_COLLECTIONS_START:
	      return _extends({}, state);
	    case types.LOAD_COLLECTIONS_SUCCESS:
	      if (action.payload.updateOnlyTotal) {
	        var collections = (0, _lodash2.default)(action.payload.data, 'referal');
	        var newState = _extends({}, state, { data: _extends({}, state.data) });
	
	        Object.keys(collections).forEach(function (referal) {
	          if (newState.data[referal]) {
	            newState.data[referal].total = collections[referal].total;
	          }
	        });
	
	        return newState;
	      }
	
	      return _extends({}, state, { data: (0, _lodash2.default)(action.payload.data, 'referal') });
	    case types.LOAD_COLLECTIONS_ERROR:
	      return _extends({}, state, { error: action.payload.error });
	
	    case types.CREATE_COLLECTION_SUCCESS:
	      {
	        return _extends({}, state, {
	          data: _extends({}, state.data, _defineProperty({}, action.payload.data.referal, action.payload.data))
	        });
	      }
	
	    case types.CREATE_COLLECTION_ERROR:
	      return _extends({}, state, { error: action.payload.error });
	
	    case types.DUP_COLLECTION_SUCCESS:
	      return _extends({}, state, { data: _extends(_defineProperty({}, action.payload.data.referal, action.payload.data), state.data) });
	    case types.DUP_COLLECTION_ERROR:
	      return _extends({}, state, { error: action.payload.error });
	
	    case types.ADD_TO_COLLECTION_SUCCESS:
	      {
	        if (state.data) {
	          var collection = state.data[action.payload.referal];
	          state.data[action.payload.referal] = _extends({}, collection, { includesCurrentBuilding: true });
	          return _extends({}, state, { data: _extends({}, state.data) });
	        }
	        return state;
	      }
	
	    case types.REMOVE_FROM_COLLECTION_SUCCESS:
	      {
	        var _collection = state.data && state.data[action.payload.referal];
	        if (_collection) {
	          state.data[action.payload.referal] = _extends({}, _collection, { includesCurrentBuilding: false });
	          return _extends({}, state, { data: _extends({}, state.data) });
	        }
	        return state;
	      }
	
	    case types.DELETE_COLLECTION_SUCCESS:
	      delete state.data[action.payload.referal];
	      return _extends({}, state, { data: _extends({}, state.data) });
	
	    case types.DELETE_COLLECTION_ERROR:
	      return _extends({}, state, { error: action.payload.error });
	
	    case types.CHECK_BUILDING_SUCCESS:
	      var data = _extends({}, state.data);
	      if (action.payload.data.selection) {
	        action.payload.data.selection.forEach(function (_ref) {
	          var referal = _ref.referal;
	          data[referal].includesCurrentBuilding = true;
	        });
	      }
	      return _extends({}, state, { data: data });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _profile = __webpack_require__(40);
	
	var _reduxActAsync = __webpack_require__(279);
	
	var reducer = (0, _reduxActAsync.createReducerAsync)(_profile.loadCompany);
	
	reducer.on('UPLOAD_LOGO_OK', function (state, payload) {
	  return _extends({}, state, {
	    data: _extends({}, state.data, {
	      logoId: payload.response.imageId
	    })
	  });
	});
	
	exports.default = reducer;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = environment;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  isMobile: false,
	  height: null,
	  width: null,
	  popUp: undefined,
	  popUpProps: undefined
	};
	
	function environment() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.CHANGE_IS_MOBILE:
	      return Object.assign({}, state, {
	        isMobile: action.isMobile
	      });
	
	    case types.CHANGE_WIDTH_AND_HEIGHT:
	      return Object.assign({}, state, {
	        height: action.height,
	        width: action.width
	      });
	
	    case types.SET_POPUP:
	      return Object.assign({}, state, {
	        popUp: action.popUp,
	        popUpProps: action.popUpProps
	      });
	
	    case types.USER_LOGOUT_START:
	      return Object.assign({}, state, {
	        popUp: null
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profile;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// import keyBy from 'lodash.keyby'
	
	var initialState = {
	  isLoading: false,
	  buildings: null
	};
	
	function profile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.LOAD_FAVORITES_START:
	      return _extends({}, initialState, { isLoading: true });
	    case types.LOAD_FAVORITES_SUCCESS:
	      return _extends({}, state, { buildings: action.payload.data.rows }, { isLoading: false });
	    case types.LOAD_FAVORITES_ERROR:
	      return _extends({}, state, { error: action.payload.error, isLoading: false });
	
	    case types.REMOVE_FROM_FAVORITES_SUCCESS:
	      if (state.buildings) {
	        return _extends({}, state, {
	          buildings: state.buildings.filter(function (building) {
	            return building.id !== action.payload.buildingId;
	          })
	        });
	      }
	      return state;
	
	    case types.ADD_TO_FAVORITES_SUCCESS:
	      if (state.buildings) {
	        return _extends({}, state, { buildings: state.buildings.concat(action.meta.data) });
	      }
	      return state;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import { createPaginationReducer } from 'reducers/index.js'
	
	
	var _building = __webpack_require__(54);
	
	var _reduxAct = __webpack_require__(108);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var createPaginationReducer = function createPaginationReducer(action) {
	  var _createReducer;
	
	  var defaultsState = {
	    loading: false,
	    request: null,
	    data: null,
	    error: null,
	    offset: 0,
	    finished: false
	  };
	
	  return (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, action.request, function (state, payload) {
	    return _extends({}, state, {
	      request: payload,
	      loading: true,
	      error: null
	    });
	  }), _defineProperty(_createReducer, action.ok, function (state, payload) {
	    var data = payload.request[0].offset === 0 ? payload.response.rows : [].concat(_toConsumableArray(state.data), _toConsumableArray(payload.response.rows));
	    return _extends({}, state, {
	      loading: false,
	      finished: data.length >= payload.response.total,
	      offset: (payload.request[0].offset === 0 ? 0 : state.offset) + payload.request[0].limit,
	      total: payload.response.total,
	      data: data
	    });
	  }), _defineProperty(_createReducer, action.error, function (state, payload) {
	    return _extends({}, state, {
	      loading: false,
	      error: payload.error
	    });
	  }), _createReducer), defaultsState);
	};
	
	var reducer = createPaginationReducer(_building.searchChess);
	
	exports.default = reducer;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createPaginationReducer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(137);
	
	var _reduxAct = __webpack_require__(108);
	
	var _reduxActAsync = __webpack_require__(279);
	
	var _profile = __webpack_require__(40);
	
	var _environment = __webpack_require__(1163);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _objects = __webpack_require__(1170);
	
	var _objects2 = _interopRequireDefault(_objects);
	
	var _building = __webpack_require__(1159);
	
	var _building2 = _interopRequireDefault(_building);
	
	var _flats = __webpack_require__(1165);
	
	var _flats2 = _interopRequireDefault(_flats);
	
	var _favorites = __webpack_require__(1164);
	
	var _favorites2 = _interopRequireDefault(_favorites);
	
	var _collections = __webpack_require__(1161);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _collection = __webpack_require__(1160);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _search = __webpack_require__(1175);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _notification = __webpack_require__(1169);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _loginForms = __webpack_require__(1167);
	
	var _loginForms2 = _interopRequireDefault(_loginForms);
	
	var _authentication = __webpack_require__(1157);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _profile2 = __webpack_require__(1173);
	
	var _profiles = __webpack_require__(1174);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _company = __webpack_require__(1162);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _privacy = __webpack_require__(1172);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _news = __webpack_require__(1168);
	
	var _payments = __webpack_require__(1171);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _reduxForm = __webpack_require__(130);
	
	var _banner = __webpack_require__(1158);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var rootReducer = (0, _redux.combineReducers)({
	  authentication: _authentication2.default,
	  objects: _objects2.default,
	  building: _building2.default,
	  flats: _flats2.default,
	  favorites: _favorites2.default,
	  collections: _collections2.default,
	  collection: _collection2.default,
	  environment: _environment2.default,
	  search: _search2.default,
	  notification: _notification2.default,
	  loginForms: _loginForms2.default,
	  profile: _profile2.profile,
	  agentProfile: _profile2.agentProfile,
	  company: _company2.default,
	  profiles: _profiles2.default,
	  privacy: _privacy2.default,
	  allNews: _news.allNewsReducer,
	  nedvexNews: _news.nedvexNewsReducer,
	  favoritesNews: _news.favoritesNewsReducer,
	  payments: _payments2.default,
	  banner: _banner2.default,
	  form: _reduxForm.reducer // redux-form
	});
	
	exports.default = rootReducer;
	var createPaginationReducer = exports.createPaginationReducer = function createPaginationReducer(action) {
	  var _createReducer;
	
	  var defaultsState = {
	    loading: false,
	    request: null,
	    data: null,
	    error: null,
	    offset: 0,
	    finished: false
	  };
	
	  return (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, action.request, function (state, payload) {
	    return _extends({}, state, {
	      request: payload,
	      loading: true,
	      error: null
	    });
	  }), _defineProperty(_createReducer, action.ok, function (state, payload) {
	    return _extends({}, state, {
	      loading: false,
	      finished: payload.response.length < payload.request[0].limit,
	      offset: state.offset + payload.request[0].limit,
	      data: payload.request[0].offset === 0 ? payload.response : [].concat(_toConsumableArray(state.data), _toConsumableArray(payload.response))
	    });
	  }), _defineProperty(_createReducer, action.error, function (state, payload) {
	    return _extends({}, state, {
	      loading: false,
	      error: payload.error
	    });
	  }), _createReducer), defaultsState);
	};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = loginForms;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  loginState: 'Number',
	  number: null,
	  isLoading: false,
	  inviteData: null,
	  inviteError: null,
	  numberData: null,
	  numberError: null,
	  smsData: null,
	  smsError: null,
	  tokenData: null,
	  tokenError: null,
	  restoreData: null,
	  restoreError: null,
	  reconnectData: null,
	  reconnectError: null
	};
	
	function loginForms() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case types.INVITE_FORM_SENDING_START:
	      return _extends({}, state, { isLoading: true });
	    case types.INVITE_FORM_SENDING_SUCCESS:
	      return _extends({}, state, { isLoading: false, inviteData: payload });
	    case types.INVITE_FORM_SENDING_ERROR:
	      return _extends({}, state, { isLoading: false, inviteError: payload });
	
	    case types.NUMBER_FORM_SENDING_START:
	      return _extends({}, state, { isLoading: true, number: payload, smsError: null, smsData: null });
	    case types.NUMBER_FORM_SENDING_SUCCESS:
	      return _extends({}, state, { isLoading: false, numberData: payload, loginState: 'SMS' });
	    case types.NUMBER_FORM_SENDING_ERROR:
	      return _extends({}, state, { isLoading: false, numberError: payload });
	
	    case types.SMS_FORM_SENDING_START:
	      return _extends({}, state, { isLoading: true });
	    case types.SMS_FORM_SENDING_SUCCESS:
	      return _extends({}, state, { /*isLoading: false,*/smsData: payload, smsError: null });
	    case types.SMS_FORM_SENDING_ERROR:
	      return _extends({}, state, { isLoading: false, smsError: payload });
	
	    case types.REQUEST_TOKEN_START:
	      return _extends({}, state, { isLoading: true });
	    case types.REQUEST_TOKEN_SUCCESS:
	      return _extends({}, state, { isLoading: false, tokenData: payload });
	    case types.REQUEST_TOKEN_ERROR:
	      return _extends({}, state, { isLoading: false, tokenError: payload });
	
	    case types.RESTORE_FORM_SENDING_START:
	      return _extends({}, state, { isLoading: true });
	    case types.RESTORE_FORM_SENDING_SUCCESS:
	      return _extends({}, state, { isLoading: false, restoreData: payload });
	    case types.RESTORE_FORM_SENDING_ERROR:
	      return _extends({}, state, { isLoading: false, restoreError: payload });
	
	    case types.RECONNECT_FORM_SENDING_START:
	      return _extends({}, state, { isLoading: true });
	    case types.RECONNECT_FORM_SENDING_SUCCESS:
	      return _extends({}, state, { isLoading: false, reconnectData: payload });
	    case types.RECONNECT_FORM_SENDING_ERROR:
	      return _extends({}, state, { isLoading: false, reconnectError: payload });
	
	    case types.USER_LOGOUT_START:
	      return _extends({}, state, { isLoading: false, loginState: 'Number' });
	
	    default:
	      if (action.payload && action.payload.error) {
	        console.error(action.payload.error);
	      }
	      if (action.payload && action.payload.error && action.payload.error.response && action.payload.error.response.data.error['error-code'] === 'USER_HAS_NOT_PERMISSION') {
	        return _extends({}, state, { isLoading: false, loginState: 'Number' });
	      }
	      return state;
	  }
	}

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.favoritesNewsReducer = exports.nedvexNewsReducer = exports.allNewsReducer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import { createPaginationReducer } from 'reducers'
	
	
	var _news = __webpack_require__(212);
	
	var _reduxAct = __webpack_require__(108);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var createPaginationReducer = function createPaginationReducer(action) {
	  var _createReducer;
	
	  var defaultsState = {
	    loading: false,
	    request: null,
	    data: null,
	    error: null,
	    offset: 0,
	    finished: false
	  };
	
	  return (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, action.request, function (state, payload) {
	    return _extends({}, state, {
	      request: payload,
	      loading: true,
	      error: null,
	      offset: state.offset + payload.limit
	    });
	  }), _defineProperty(_createReducer, action.ok, function (state, payload) {
	    return _extends({}, state, {
	      loading: false,
	      finished: payload.response.length < payload.request[0].limit,
	      data: payload.request[0].offset === 0 ? payload.response : [].concat(_toConsumableArray(state.data), _toConsumableArray(payload.response))
	    });
	  }), _defineProperty(_createReducer, action.error, function (state, payload) {
	    return _extends({}, state, {
	      loading: false,
	      error: payload.error,
	      offset: state.offset - payload.request[0].limit
	    });
	  }), _createReducer), defaultsState);
	};
	
	var allNewsReducer = exports.allNewsReducer = createPaginationReducer(_news.allNews);
	var nedvexNewsReducer = exports.nedvexNewsReducer = createPaginationReducer(_news.nedvexNews);
	var favoritesNewsReducer = exports.favoritesNewsReducer = createPaginationReducer(_news.favoritesNews);

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxAct = __webpack_require__(108);
	
	var reducer = (0, _reduxAct.createReducer)({
	  SHOW_NOTIFICATION: function SHOW_NOTIFICATION(state, payload) {
	    return _extends({}, state, { cancel: false }, payload, { show: true });
	  },
	  HIDE_NOTIFICATION: function HIDE_NOTIFICATION(state, payload) {
	    return { show: false, status: state.status };
	  }
	}, { show: false });
	
	exports.default = reducer;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = objects;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  ui: {
	    isInfiniteLoading: true,
	    isFinished: false,
	    scrollTop: null,
	    isPointLoading: true
	  },
	  isMapLoading: false,
	  objects: {
	    data: null,
	    total: null
	  },
	  pins: {
	    data: null,
	    total: null
	  },
	  points: {},
	  pointsList: [],
	  errors: [],
	  isObjectsFetching: false
	};
	
	function objects() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SET_SCROLL_TOP:
	      return _extends({}, state, { ui: _extends({}, state.ui, { scrollTop: action.payload }) });
	
	    case types.LOAD_OBJECTS_START:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isInfiniteLoading: true, isFinished: false }),
	        isObjectsFetching: true
	      });
	    case types.LOAD_OBJECTS_SUCCESS:
	      {
	        var _action$payload = action.payload,
	            clear = _action$payload.clear,
	            data = _action$payload.data.data;
	
	        var rows = clear ? data.rows : [].concat(_toConsumableArray(state.objects.data || []), _toConsumableArray(data.rows));
	        var isFinished = rows.length >= data.total;
	        return _extends({}, state, {
	          ui: _extends({}, state.ui, { isInfiniteLoading: false, isFinished: isFinished }),
	          objects: {
	            data: rows,
	            total: data.total
	          },
	          isObjectsFetching: false
	        });
	      }
	
	    case types.ADD_TO_FAVORITES_SUCCESS:
	    case types.REMOVE_FROM_FAVORITES_SUCCESS:
	      {
	        var favorite = action.type === types.ADD_TO_FAVORITES_SUCCESS;
	        var buildingId = action.payload.buildingId;
	
	
	        if (state.objects.data || state.points) {
	          return _extends({}, state, {
	            objects: _extends({}, state.objects, {
	              data: state.objects.data && state.objects.data.map(function (building) {
	                return building.id === buildingId ? _extends({}, building, { favorite: favorite }) : building;
	              })
	            }),
	            points: _extends({}, state.points, _defineProperty({}, buildingId, _extends({}, state.points[buildingId], {
	              favorite: favorite
	            }))),
	            pointsList: Object.keys(state.pointsList).reduce(function (acc, longLat) {
	              acc[longLat] = state.pointsList[longLat].map(function (building) {
	                return building.id === buildingId ? _extends({}, building, { favorite: favorite }) : building;
	              });
	              return acc;
	            }, {})
	          });
	        }
	        return state;
	      }
	
	    case types.LOAD_OBJECTS_ERROR:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isInfiniteLoading: false }),
	        errors: [].concat(_toConsumableArray(state.errors), _toConsumableArray(action.payload)),
	        isObjectsFetching: false
	      });
	
	    case types.LOAD_PINS_START:
	      return _extends({}, state, {
	        isMapLoading: true,
	        isObjectsFetching: true
	      });
	
	    case types.LOAD_PINS_SUCCESS:
	      {
	        var _data = action.payload.data.data;
	
	        return _extends({}, state, {
	          isMapLoading: false,
	          isObjectsFetching: false,
	          pins: {
	            data: _data.rows,
	            total: _data.total
	          }
	        });
	      }
	
	    case types.LOAD_PINS_ERROR:
	      return _extends({}, state, {
	        isMapLoading: false,
	        errors: [].concat(_toConsumableArray(state.errors), _toConsumableArray(action.payload)),
	        isObjectsFetching: false
	      });
	
	    case types.LOAD_POINT_START:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isPointLoading: true })
	      });
	
	    case types.LOAD_POINT_SUCCESS:
	      {
	        var _action$payload2 = action.payload,
	            id = _action$payload2.id,
	            _data2 = _action$payload2.data.data;
	
	        return _extends({}, state, {
	          ui: _extends({}, state.ui, { isPointLoading: false }),
	          points: _extends({}, state.points, _defineProperty({}, id, _data2))
	        });
	      }
	
	    case types.LOAD_POINT_ERROR:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isInfiniteLoading: false }),
	        errors: [].concat(_toConsumableArray(state.errors), _toConsumableArray(action.payload))
	      });
	
	    case types.LOAD_POINT_LIST_START:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isPointListLoading: true })
	      });
	
	    case types.LOAD_POINT_LIST_SUCCESS:
	      {
	        var _action$payload3 = action.payload,
	            _id = _action$payload3.id,
	            _data3 = _action$payload3.data.data;
	
	        return _extends({}, state, {
	          ui: _extends({}, state.ui, { isPointListLoading: false }),
	          pointsList: _extends({}, state.pointsList, _defineProperty({}, _id, _data3))
	        });
	      }
	
	    case types.LOAD_POINT_LIST_ERROR:
	      return _extends({}, state, {
	        ui: _extends({}, state.ui, { isInfiniteLoading: false }),
	        errors: [].concat(_toConsumableArray(state.errors), _toConsumableArray(action.payload))
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(26);
	
	var t = _interopRequireWildcard(_ActionTypes);
	
	var _reduxActions = __webpack_require__(282);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  isNotificationShown: false
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, '' + t.SHOW_PAYMENT_NOTIFCATION, function undefined(state, _ref) {
	  var payload = _ref.payload;
	  return _extends({}, state, {
	    isNotificationShown: true
	  });
	}), _defineProperty(_handleActions, '' + t.HIDE_PAYMENT_NOTIFCATION, function undefined(state, _ref2) {
	  var payload = _ref2.payload;
	  return _extends({}, state, {
	    isNotificationShown: false
	  });
	}), _handleActions), initialState);

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profile;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var withClient = false;
	try {
	  withClient = localStorage.getItem('withClient');
	} catch (e) {
	  console.warn(e.message);
	}
	
	var initialState = {
	  withClient: withClient === 'true' ? true : withClient === 'false' ? false : null
	};
	
	function profile() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.SWITCH_WITH_CLIENT:
	      localStorage.setItem('withClient', !state.withClient);
	      return _extends({}, state, {
	        withClient: !state.withClient
	      });
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.profile = exports.agentProfile = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createProfileReducer = createProfileReducer;
	
	var _ActionTypes = __webpack_require__(26);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _profile = __webpack_require__(40);
	
	var _reduxAct = __webpack_require__(108);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var onProfileRequest = function onProfileRequest(state, payload) {
	  return _extends({}, state, { isLoaded: false, isLoading: true, isFirstTimeLoaded: true });
	};
	
	function createProfileReducer(actions) {
	  var _extends2, _extends3;
	
	  var defaultState = { isLoaded: false, isFirstTimeLoaded: false };
	  return (0, _reduxAct.createReducer)(_extends((_extends2 = {}, _defineProperty(_extends2, actions.load.request, onProfileRequest), _defineProperty(_extends2, actions.load.ok, function (state, payload) {
	    return _extends({}, state, payload.response, { isLoaded: true, isLoading: false, isFirstTimeLoaded: true });
	  }), _extends2), actions.update && _defineProperty({}, actions.update.ok, function (state, payload) {
	    return _extends({}, state, payload.response, { isLoaded: true, isLoading: false, isFirstTimeLoaded: true });
	  }), actions.photo && _defineProperty({}, actions.photo.ok, function (state, payload) {
	    return _extends({}, state, { avatarId: payload.response.imageId });
	  }), (_extends3 = {}, _defineProperty(_extends3, _profile.updateProfileRegion.ok, function (state, payload) {
	    return _extends({}, state, {
	      cityId: payload.response.cityId,
	      user_region: payload.response.user_region
	    });
	  }), _defineProperty(_extends3, types.USER_LOGOUT_START, function () {
	    return defaultState;
	  }), _extends3)), defaultState);
	}
	
	var agentProfile = exports.agentProfile = createProfileReducer({
	  load: _profile.loadAgentProfile,
	  update: _profile.updateAgentProfile,
	  photo: _profile.uploadAgentPhoto
	});
	
	var reducer = createProfileReducer({
	  load: _profile.loadProfile,
	  update: _profile.updateProfile,
	  photo: _profile.uploadPhoto,
	  region: _profile.updateProfileRegion
	});
	
	reducer.on('SMS_FORM_SENDING_START', onProfileRequest);
	
	reducer.on('USER_LOGIN', function (state, payload) {
	  return _extends({}, state, payload, { isLoaded: true });
	});
	
	reducer.on('UPLOAD_LOGO_OK', function (state, payload) {
	  return _extends({}, state, {
	    avatarId: payload.response.imageId
	  });
	});
	
	var profile = exports.profile = reducer;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _profile = __webpack_require__(40);
	
	var _reduxActAsync = __webpack_require__(279);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var reducer = (0, _reduxActAsync.createReducerAsync)(_profile.loadCompanyProfiles);
	
	reducer.on(_profile.deleteProfile.ok, function (state, payload) {
	  return _extends({}, state, {
	    data: state.data.filter(function (_ref) {
	      var id = _ref.id;
	      return id !== payload.request[0].userId;
	    })
	  });
	});
	
	reducer.on(_profile.updateProfile.ok, function (state, payload) {
	  return _extends({}, state, {
	    data: state.data && state.data.map(function (profile) {
	      return profile.id === payload.request[0].userId ? payload.response : profile;
	    })
	  });
	});
	
	reducer.on(_profile.createProfile.ok, function (state, payload) {
	  return _extends({}, state, {
	    data: [].concat(_toConsumableArray(state.data), [payload.response])
	  });
	});
	
	exports.default = reducer;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(26);
	
	var t = _interopRequireWildcard(_ActionTypes);
	
	var _reduxActions = __webpack_require__(282);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialRequest = {
	  limit: 10,
	  orderField: 'date_update',
	  orderDirection: 'DESC'
	};
	
	var typeFilters = ['new', 'viewAction', 'orderField', 'blackList'];
	var newOrderFields = ['visit_day', 'visit_week', 'visit_month'];
	
	var isTypeFilter = function isTypeFilter(_ref) {
	  var object = _ref.object,
	      key = _ref.key;
	
	  if (object[key]) {
	    if (typeFilters.includes(key)) {
	      if (key === 'orderField') {
	        if (newOrderFields.includes(object[key])) return true;
	        return false;
	      }
	      return true;
	    }
	  }
	  return false;
	};
	
	var getIsOrderFieldTypeFilter = function getIsOrderFieldTypeFilter(_ref2) {
	  var object = _ref2.object,
	      key = _ref2.key;
	
	  if (object[key]) {
	    if (typeFilters.includes(key)) {
	      if (key === 'orderField') {
	        if (newOrderFields.includes(object[key])) return true;
	        return false;
	      }
	      return false;
	    }
	  }
	  return false;
	};
	
	var typeFiltersInitialRequest = {
	  // new: false,
	  // viewAction: false,
	  orderField: initialRequest.initialRequest
	  // blackList: false,
	};
	
	var initialState = {
	  request: initialRequest,
	  autocomplete: {
	    buildings: [],
	    streets: [],
	    regions: [],
	    subregions: []
	  },
	  value: '',
	  autocompleteError: [],
	  isLoading: false,
	  isSearchModalOpen: false,
	  hasFilters: false,
	  isFetched: false,
	  parking: false,
	  elevator: false,
	  childrenArea: false,
	  concierge: false,
	  recreationZone: false,
	  pool: false,
	  houseTerritory: false,
	  isTypeFilters: false,
	  isOrderFieldTypeFilter: false
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, '' + t.SET_SEARCH_VALUE, function undefined(state, _ref3) {
	  var payload = _ref3.payload;
	  return _extends({}, state, {
	    value: payload
	  });
	}), _defineProperty(_handleActions, '' + t.FORCED_SEARCH_CHANGE, function undefined(state, _ref4) {
	  var payload = _ref4.payload;
	  return _extends({}, state, {
	    request: _extends({}, state.request, {
	      query: payload
	    })
	  });
	}), _defineProperty(_handleActions, 'UPDATE_PROFILE_REGION_OK', function UPDATE_PROFILE_REGION_OK(state, _ref5) {
	  var payload = _ref5.payload;
	  return _extends({}, state, {
	    request: _extends({}, state.request)
	  });
	}), _defineProperty(_handleActions, '' + t.CHANGE_FILTERS, function undefined(state, _ref6) {
	  var payload = _ref6.payload,
	      reset = _ref6.reset,
	      withoutTypeFilters = _ref6.withoutTypeFilters;
	
	  // FIXME Refactor whole search logic !!!
	  var newPayload = {};
	  if (reset) {
	    newPayload = payload && _extends({}, initialRequest, payload);
	  } else {
	    newPayload = payload && _extends({}, state.request, payload);
	  }
	  if (withoutTypeFilters) {
	    newPayload = _extends({}, newPayload, typeFiltersInitialRequest);
	  }
	  var isOrderFieldTypeFilter = payload && Object.keys(newPayload).some(function (k) {
	    return getIsOrderFieldTypeFilter({ object: newPayload, key: k });
	  });
	  if (payload && isOrderFieldTypeFilter) {
	    newPayload.orderDirection = 'DESC';
	    newPayload.limit = 25;
	  }
	  if (payload && !newPayload.orderField && !isOrderFieldTypeFilter) {
	    newPayload.orderField = 'date_update';
	    newPayload.orderDirection = 'DESC';
	  }
	  return _extends({}, state, {
	    request: payload ? newPayload : initialRequest,
	    hasFilters: !!(payload && Object.keys(newPayload).filter(function (k) {
	      if (k === 'typeId') {
	        return false;
	      }
	      return newPayload[k] && !initialRequest[k];
	    }).length),
	    isTypeFilters: payload && Object.keys(newPayload).some(function (k) {
	      return isTypeFilter({ object: newPayload, key: k });
	    }),
	    isOrderFieldTypeFilter: isOrderFieldTypeFilter
	  });
	}), _defineProperty(_handleActions, '' + t.SET_SEARCH_MODAL_STATE, function undefined(state, _ref7) {
	  var payload = _ref7.payload;
	  return _extends({}, state, {
	    isSearchModalOpen: payload
	  });
	}), _defineProperty(_handleActions, t.LOAD_AUTOCOMPLETE + '_FETCHING', function undefined(state, _ref8) {
	  var payload = _ref8.payload;
	  return _extends({}, state, {
	    isLoading: true,
	    isFetched: false
	  });
	}), _defineProperty(_handleActions, t.LOAD_AUTOCOMPLETE + '_SUCCESS', function undefined(state, _ref9) {
	  var payload = _ref9.payload;
	  var _payload$data = payload.data,
	      buildings = _payload$data.buildings,
	      regions = _payload$data.regions,
	      subregions = _payload$data.subregions,
	      streets = _payload$data.streets;
	
	  return _extends({}, state, {
	    autocomplete: {
	      buildings: buildings ? buildings.slice(0, 15) : [],
	      subregions: subregions ? subregions.slice(0, 5) : [],
	      regions: regions ? regions.slice(0, 5) : [],
	      streets: streets ? streets.slice(0, 15) : []
	    },
	    isLoading: false,
	    isFetched: true
	  });
	}), _defineProperty(_handleActions, t.LOAD_AUTOCOMPLETE + '_ERROR', function undefined(state, _ref10) {
	  var payload = _ref10.payload;
	  return _extends({}, state, {
	    autocompleteError: [].concat(_toConsumableArray(payload)),
	    isLoading: false
	  });
	}), _handleActions), initialState);

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transliterate;
	function transliterate(text) {
	  var lettersMap = {
	    а: 'a',
	    б: 'b',
	    в: 'v',
	    г: 'g',
	    д: 'd',
	    е: 'e',
	    ё: 'yo',
	    ж: 'zh',
	    з: 'z',
	    и: 'i',
	    й: 'i',
	    к: 'k',
	    л: 'l',
	    м: 'm',
	    н: 'n',
	    о: 'o',
	    п: 'p',
	    р: 'r',
	    с: 's',
	    т: 't',
	    у: 'u',
	    ф: 'f',
	    х: 'kh',
	    ц: 'c',
	    ч: 'ch',
	    ш: 'sh',
	    щ: 'sch',
	    ъ: '',
	    ы: 'y',
	    ь: '',
	    э: 'e',
	    ю: 'yu',
	    я: 'ya'
	  };
	
	  return text.toLowerCase().replace(/[ьъ]/g, '').replace(/[а-яё]/g, function (char) {
	    return lettersMap[char] || char;
	  }).replace(/ /g, '_');
	}

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var yaEventsMap = {
	  /* Действия в разделе "Регистрация в приложении Nedvex" */
	  Web_User_Registration: 'отправить',
	  Web_Phone_Number_Entered: 'подтвердить',
	
	  /* Подписка */
	  SUBSCRIPTION: 'подписка',
	
	  /* Действия в разделах "Новостройки" или "КП и ТХ" */
	  Web_KP: 'вкладка_кптх',
	  Web_ZHK: 'вкладка_новостройки',
	  Web_ZHK_Nedvex: 'жк_nedvex',
	  Web_New: 'новинки',
	  Web_Stock: 'акции',
	  Web_Popular: 'популярное',
	  Web_Search: 'поиск_на_списке',
	  Web_Sort_Date: 'сортировка_по_дате',
	  Web_Sort_Price_Cheaper: 'сортировка_по_увеличение_цены',
	  Web_Sort_Price_Expensive: 'сортировка_по_уменьшению_цены',
	  Web_Sort_Title: 'сортировка_по_названию',
	  Web_Filters_District: 'район',
	  Web_Filters_Price: 'цена',
	  Web_Filters_Price_General: 'общая_цена',
	  Web_Filters_Price_Kv: 'цена_за_метр',
	  Web_Filters_Square: 'площадь',
	  Web_Filters_Decoration: 'оформление',
	  'Web_Filters_FZ-214': 'фз214',
	  'Web_Filters_FZ-215': 'фз215',
	  Web_Filters_Part: 'договор_долевого_участия',
	  Web_Filters_Loan: 'договор_займа',
	  Web_Filters_Inv: 'договор_инвестирования',
	  Web_Filters_Buy_Sale: 'договор_купли_продажи',
	  Web_Filters_Contract: 'договор_подряда',
	  Web_Filters_Prec: 'предварительный_договор',
	  Web_Filters_Justice: 'юстиция',
	  Web_Filters_Delivery_Deadline: 'срок_сдачи',
	  Web_Filters_Passed: 'дом_сдан',
	  Web_Filters_2024: '2024',
	  Web_Filters_2025: '2025',
	  Web_Filters_2026: '2026',
	  Web_Filters_2027: '2027',
	  Web_Filters_2028: '2028',
	  Web_Filters_2029: '2029',
	  Web_Filters_2030: '2030',
	  Web_Filters_Payment_Options: 'варианты_оплаты',
	  Web_Filters_Taxes: 'возврат_ндс',
	  Web_Filters_Cash: 'наличный_расчет',
	  Web_Filters_Mortgage: 'ипотека',
	  Web_Filters_Installment: 'рассрочка',
	  Web_Filters_Military_Mortgage: 'военная_ипотека',
	  Web_Filters_Ipoteka_Family: 'ипотека_семейная',
	  Web_Filters_Ipoteka_State_Support: 'ипотека_с_господдержкой',
	  Web_Filters_Ipoteka_It: 'ипотека_it',
	  Web_Filters_Ipoteka_Tranche: 'ипотека_траншевая',
	  Web_Filters_Ipoteka_Subsidized: 'ипотека_субсидированная',
	  Web_Filters_Ipoteka_Preferential: 'ипотека_льготная',
	  Web_Filters_Maternity_Capital: 'материнский_капитал',
	  Web_Filters_Сhist_Int: 'чистовая',
	  Web_Filters_Chern_Int: 'черновая',
	  Web_Filters_Pred_Сhist_Int: 'предчистовая',
	  Web_Filters_Rem_Int: 'ремонт',
	  Web_Filters_White_Box: 'white_box',
	  Web_Filters_Repair: 'ремонт_мебель_техника',
	  Web_Filters_Flat: 'квартира',
	  Web_Filters_Apartments: 'апартаменты',
	  Web_Filters_Zhiloe_Room: 'жилое_помещение',
	  Web_Filters_Nezhiloe_Room: 'нежилое_помещение',
	  Web_Filters_Hotel_Room: 'гостиничный_номер',
	  Web_Filters_Zhiloe_House: 'жилой_дом',
	  Web_Filters_Storage_Room: 'кладовое_помещение',
	  Web_Filters_Up_To_500: 'до_500',
	  Web_Filters_Up_To_1500: 'до_1500',
	  Web_Filters_Up_To_3000: 'до_3000',
	  Web_Filters_Economy: 'эконом',
	  Web_Filters_Comfort: 'комфорт',
	  Web_Filters_Business: 'бизнес',
	  Web_Filters_Elite: 'элит',
	  Web_Filters_Parking: 'паркинг',
	  Web_Filters_Concierge: 'консьерж',
	  Web_Filters_Recreation_Area: 'зона_отдыха',
	  Web_Filters_Recreation_Elevator: 'лифт',
	  Web_Filters_Children_Playground: 'детская_площадка',
	  Web_Filters_Swimming_Pool: 'бассейн',
	  Web_Filters_House_Territory: 'закрытая_территория',
	  Web_Filters_SPA: 'spa',
	  Web_Filters_CCTV: 'видеонаблюдение',
	  Web_Filters_Commercial_Property: 'коммерческие_площади',
	  Web_Filters_KPP: 'кпп',
	  Web_Filters_Wellness_Building: 'оздоровительный_корпус',
	  Web_Filters_Beach: 'пляж',
	  Web_Filters_Walking_Area: 'прогулочные_зоны',
	  Web_Filters_Restaurant: 'ресторан',
	  Web_Filters_Sport_Area: 'спортивная_площадка',
	  Web_Filters_Operated_Roof: 'эксплуатационная_кровля',
	  Web_Filters_Zone_Bbq: 'зона_барбекю',
	  Web_Filters_New: 'новинка',
	  Web_Filters_Into_Yard: 'двор',
	  Web_Filters_To_Mountains: 'горы',
	  Web_Filters_On_Sea: 'море',
	  Web_Filters_To_Park: 'парк',
	  Web_Filters_To_Garden: 'сад',
	  Web_Filters_To_Forest: 'лес',
	  Web_Filters_On_Social_Objects: 'социальные_объекты',
	  Web_Filters_Panoramic_View: 'панорамный_вид',
	  Web_Map: 'искать_на_карте',
	  Web_Map_Object_List: 'искать_на_списке',
	  Web_Click: 'объект',
	  Web_Add_To_Collection: 'в_подборку',
	  Web_Add_To_Favorites: 'добавить_в_избранное',
	  Web_Remove_From_Favorites: 'удалить_из_избранного',
	  Web_List_News_All: 'новости_все',
	  Web_List_News_Favorites: 'новости_избранных_объектов',
	  Web_List_News_From_Service: 'новости_от_сервиса',
	
	  /* Действия в "Карточке объекта" */
	  Web_Card_Report_About_Inaccuracy: 'сообщить_о_неточности',
	  Web_Card_Add_Selection: 'добавить_жк_в_подборку',
	  Web_Card_Add_Favorites: 'добавить_жк_в_избранное',
	  Web_Card_Remove_Favorites: 'удалить_жк_из_избранного',
	  Web_Card_Share: 'поделиться_ссылкой',
	  Web_Card_Print: 'печать_информации',
	  Web_Card_Checkerboard: 'посмотреть_шахматку',
	
	  /* Действия в "Шахматке объекта" */
	  Web_List_Checkerboard: 'шахматка',
	  Web_List_Premises: 'список_лотов',
	  Web_List_Filters_Price: 'фильтр_цена_в_шахматке',
	  Web_List_Filters_Price_General: 'фильтр_общая_цена_в_шахматке',
	  Web_List_Filters_Price_Kv: 'фильтр_цена_за_метр_в_шахматке',
	  Web_List_Filters_Square: 'фильтр_площадь_в_шахматке',
	  Web_List_Filters_Finishing: 'фильтр_чистовая_в_объекте',
	  Web_List_Filters_WhiteBox: 'white_box_в_шахматке',
	  Web_List_Filters_RMT: 'рмт_в_шахматке',
	  Web_List_Filters_Repair: 'фильтр_ремонт_в_объекте',
	  Web_List_Filters_Rough: 'фильтр_черновая_в_объекте',
	  Web_List_Filters_Partial_Repair: 'фильтр_частичный_ремонт_в_объекте',
	  Web_List_Filters_Pre_Finishing: 'фильтр_пред_чистовая_в_объекте',
	  Web_List_Filters_Extended_Activation: 'фильтр_расширенная_шахматка',
	  Web_List_Filters_Into_Yard: 'двор_в_шахматке',
	  Web_List_Filters_To_Mountains: 'горы_в_шахматке',
	  Web_List_Filters_On_Sea: 'море_в_шахматке',
	  Web_List_Filters_To_Park: 'парк_в_шахматке',
	  Web_List_Filters_To_Garden: 'сад_в_шахматке',
	  Web_List_Filters_To_Forest: 'лес_в_шахматке',
	  Web_List_Filters_On_Social_Object: 'социцальные_объекты_в_шахматке',
	  Web_List_Filters_Panoramic_View: 'панорамный_в_шахматке',
	
	  /* Действия в разделе "Подборки" */
	  Web_Selections: 'подборки',
	  Web_Current_Add_To_Collection: 'создать_подборку',
	  Web_Selections_Duplicate: 'дублировать_в_подборке',
	  Web_Selections_Delete: 'удалить_в_подборке',
	  Web_Selections_Edit: 'переименовать_в_подборке',
	  Web_Selections_Share: 'отправить_подборку_в_подборке',
	  Web_Selections_Add_Comment: 'оставить_комеентарий_в_подборке',
	  Web_Selections_Edit_Comment: 'редактировать_комментарий_в_подборке',
	  Web_Selections_Delete_Comment: 'удалить_в_подборке',
	
	  /* Действия в разделе "Избранное" */
	  Web_Favorites_Delete: 'убрать_из_избранного',
	  Web_Favorites_Go_Object: 'перейти_в_жк',
	
	  /* Действия в разделе "Профиль" */
	  Web_Profile: 'профиль',
	  Web_My_Profile: 'мой_профиль',
	  Web_Profile_Company: 'профиль_компании',
	  Web_Profile_With_Client: 'я_с_клиентом',
	  Web_Profile_Renew_Subscription: 'оплатить',
	
	  /* Попап шаринга объекта */
	  Web_ShareDialog_NameAddress: 'название и адрес',
	  Web_ShareDialog_Description: 'описание и преимущества',
	  Web_ShareDialog_Characteristics: 'характеристики',
	  Web_ShareDialog_Communications: 'коммуникации',
	  Web_ShareDialog_Checkout: 'оформление_в_отправляемой_презентации',
	  Web_ShareDialog_Payment: 'оплата',
	  Web_ShareDialog_Lots: 'лоты',
	  Web_ShareDialog_Link: 'ссылка',
	  Web_ShareDialog_CopyButton: 'скопировать',
	  Web_ShareDialog_SavePdf: 'сохранить pdf-файл',
	
	  /* Попап шаринга подборки */
	
	  Web_ShareCollectionDialog_NameAddress: 'название и адрес в подборке',
	  Web_ShareCollectionDialog_Description: 'описание и преимущества в подборке',
	  Web_ShareCollectionDialog_Characteristics: 'характеристики в подборке',
	  Web_ShareCollectionDialog_Communications: 'коммуникации в подборке',
	  Web_ShareCollectionDialog_Checkout: 'оформление в подборке',
	  Web_ShareCollectionDialog_Payment: 'оплата в подборке',
	  Web_ShareCollectionDialog_Map: 'карта в подборке',
	  Web_ShareCollectionDialog_Lots_0: 'показывать все лоты',
	  Web_ShareCollectionDialog_Lots_1: 'только отобраннные лоты',
	  Web_ShareCollectionDialog_Lots_2: 'не отображать лоты',
	  Web_ShareCollectionDialog_Link: 'ссылка в подборке',
	  Web_ShareCollectionDialog_CopyButton: 'скопировать в подборке',
	  Web_Lots_AddToCollection: 'добавить_в_подборку',
	  Web_Lots_AddToNewCollection: 'создание_подборки_при_добавлении_лота',
	
	  Web_Profile_Payment_User: 'платящие_пользователи'
	};
	
	var keysMap = {
	  mode: {
	    title: 'вид',
	    values: {
	      map: 'карта',
	      list: 'список'
	    }
	  },
	  selected: {
	    title: 'режим',
	    values: {
	      true: 'установка',
	      false: 'снятие'
	    }
	  },
	  name: 'название'
	};
	
	var ymService = function () {
	  function ymService() {
	    _classCallCheck(this, ymService);
	  }
	
	  _createClass(ymService, [{
	    key: 'sendEvent',
	    value: function sendEvent(eventName) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var paramsKeys = Object.keys(params);
	      var newParams = paramsKeys.length ? paramsKeys.reduce(function (acc, paramName) {
	        var value = params[paramName];
	
	        if (!keysMap[paramName]) {
	          acc[paramName] = value;
	          return acc;
	        }
	
	        if (typeof keysMap[paramName] === 'string') {
	          var _name = keysMap[paramName];
	          acc[_name] = value;
	          return acc;
	        }
	
	        var name = keysMap[paramName].title;
	        acc[name] = keysMap[paramName].values[value];
	
	        return acc;
	      }, {}) : undefined;
	
	      var name = yaEventsMap[eventName];
	
	      ym(92364884, 'reachGoal', name, newParams ? _defineProperty({}, name, newParams) : undefined);
	
	      console.log('tracker: ymService', 'reachGoal', name, newParams ? _defineProperty({}, name, newParams) : undefined);
	    }
	  }]);
	
	  return ymService;
	}();
	
	exports.default = new ymService();

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(137);
	
	var _reduxObservable = __webpack_require__(730);
	
	var _reduxThunk = __webpack_require__(2251);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(1166);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _epics = __webpack_require__(1156);
	
	var _epics2 = _interopRequireDefault(_epics);
	
	var _reduxThrottle = __webpack_require__(2249);
	
	var _reduxThrottle2 = _interopRequireDefault(_reduxThrottle);
	
	var _reduxDebounced = __webpack_require__(2131);
	
	var _reduxDebounced2 = _interopRequireDefault(_reduxDebounced);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)();
	var debouncer = (0, _reduxDebounced2.default)();
	var throttle = (0, _reduxThrottle2.default)(300);
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var store = (0, _redux.createStore)(_reducers2.default, composeEnhancers((0, _redux.applyMiddleware)(epicMiddleware, _reduxThunk2.default, throttle, debouncer)));
	
	function configureStore() {
	  return store;
	}
	
	epicMiddleware.run(_epics2.default);

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1180);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(148)))

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(2376)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.container = options.container;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                this.container.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    this.container.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    this.container.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.trigger) {
	                    this.trigger.focus();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1182), __webpack_require__(2383), __webpack_require__(1605)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    container: this.container,
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	
	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;
	
	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });
	
	                return support;
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1306);
	__webpack_require__(1193);
	__webpack_require__(233);
	__webpack_require__(1195);
	__webpack_require__(531);
	__webpack_require__(1192);
	__webpack_require__(1194);
	__webpack_require__(1200);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1201);
	__webpack_require__(1197);
	__webpack_require__(1202);
	__webpack_require__(1203);
	__webpack_require__(1196);
	module.exports = __webpack_require__(62);

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(102)
	  , toIndex  = __webpack_require__(168)
	  , toLength = __webpack_require__(74);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , $$    = arguments
	    , end   = $$.length > 2 ? $$[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(102)
	  , toIndex  = __webpack_require__(168)
	  , toLength = __webpack_require__(74);
	module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , $$     = arguments
	    , $$len  = $$.length
	    , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
	    , end    = $$len > 2 ? $$[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var isObject = __webpack_require__(29)
	  , isArray  = __webpack_require__(323)
	  , SPECIES  = __webpack_require__(35)('species');
	module.exports = function(original, length){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length);
	};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(20);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(34)
	  , macrotask = __webpack_require__(530).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(100)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(30)
	  , aFunction = __webpack_require__(117)
	  , SPECIES   = __webpack_require__(35)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(29);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var global  = __webpack_require__(34)
	  , core    = __webpack_require__(62)
	  , $export = __webpack_require__(8)
	  , partial = __webpack_require__(332);
	// https://esdiscuss.org/topic/promise-returning-delay-function
	$export($export.G + $export.F, {
	  delay: function delay(time){
	    return new (core.Promise || global.Promise)(function(resolve){
	      setTimeout(partial.call(resolve, true), time);
	    });
	  }
	});

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(20)
	  , ctx         = __webpack_require__(79)
	  , $export     = __webpack_require__(8)
	  , createDesc  = __webpack_require__(101)
	  , assign      = __webpack_require__(330)
	  , keyOf       = __webpack_require__(521)
	  , aFunction   = __webpack_require__(117)
	  , forOf       = __webpack_require__(144)
	  , isIterable  = __webpack_require__(531)
	  , $iterCreate = __webpack_require__(324)
	  , step        = __webpack_require__(326)
	  , isObject    = __webpack_require__(29)
	  , toIObject   = __webpack_require__(70)
	  , DESCRIPTORS = __webpack_require__(73)
	  , has         = __webpack_require__(69)
	  , getKeys     = $.getKeys;
	
	// 0 -> Dict.forEach
	// 1 -> Dict.map
	// 2 -> Dict.filter
	// 3 -> Dict.some
	// 4 -> Dict.every
	// 5 -> Dict.find
	// 6 -> Dict.findKey
	// 7 -> Dict.mapPairs
	var createDictMethod = function(TYPE){
	  var IS_MAP   = TYPE == 1
	    , IS_EVERY = TYPE == 4;
	  return function(object, callbackfn, that /* = undefined */){
	    var f      = ctx(callbackfn, that, 3)
	      , O      = toIObject(object)
	      , result = IS_MAP || TYPE == 7 || TYPE == 2
	          ? new (typeof this == 'function' ? this : Dict) : undefined
	      , key, val, res;
	    for(key in O)if(has(O, key)){
	      val = O[key];
	      res = f(val, key, object);
	      if(TYPE){
	        if(IS_MAP)result[key] = res;            // map
	        else if(res)switch(TYPE){
	          case 2: result[key] = val; break;     // filter
	          case 3: return true;                  // some
	          case 5: return val;                   // find
	          case 6: return key;                   // findKey
	          case 7: result[res[0]] = res[1];      // mapPairs
	        } else if(IS_EVERY)return false;        // every
	      }
	    }
	    return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
	  };
	};
	var findKey = createDictMethod(6);
	
	var createDictIter = function(kind){
	  return function(it){
	    return new DictIterator(it, kind);
	  };
	};
	var DictIterator = function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._a = getKeys(iterated);   // keys
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	};
	$iterCreate(DictIterator, 'Dict', function(){
	  var that = this
	    , O    = that._t
	    , keys = that._a
	    , kind = that._k
	    , key;
	  do {
	    if(that._i >= keys.length){
	      that._t = undefined;
	      return step(1);
	    }
	  } while(!has(O, key = keys[that._i++]));
	  if(kind == 'keys'  )return step(0, key);
	  if(kind == 'values')return step(0, O[key]);
	  return step(0, [key, O[key]]);
	});
	
	function Dict(iterable){
	  var dict = $.create(null);
	  if(iterable != undefined){
	    if(isIterable(iterable)){
	      forOf(iterable, true, function(key, value){
	        dict[key] = value;
	      });
	    } else assign(dict, iterable);
	  }
	  return dict;
	}
	Dict.prototype = null;
	
	function reduce(object, mapfn, init){
	  aFunction(mapfn);
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , i      = 0
	    , memo, key;
	  if(arguments.length < 3){
	    if(!length)throw TypeError('Reduce of empty object with no initial value');
	    memo = O[keys[i++]];
	  } else memo = Object(init);
	  while(length > i)if(has(O, key = keys[i++])){
	    memo = mapfn(memo, O[key], key, object);
	  }
	  return memo;
	}
	
	function includes(object, el){
	  return (el == el ? keyOf(object, el) : findKey(object, function(it){
	    return it != it;
	  })) !== undefined;
	}
	
	function get(object, key){
	  if(has(object, key))return object[key];
	}
	function set(object, key, value){
	  if(DESCRIPTORS && key in Object)$.setDesc(object, key, createDesc(0, value));
	  else object[key] = value;
	  return object;
	}
	
	function isDict(it){
	  return isObject(it) && $.getProto(it) === Dict.prototype;
	}
	
	$export($export.G + $export.F, {Dict: Dict});
	
	$export($export.S, 'Dict', {
	  keys:     createDictIter('keys'),
	  values:   createDictIter('values'),
	  entries:  createDictIter('entries'),
	  forEach:  createDictMethod(0),
	  map:      createDictMethod(1),
	  filter:   createDictMethod(2),
	  some:     createDictMethod(3),
	  every:    createDictMethod(4),
	  find:     createDictMethod(5),
	  findKey:  findKey,
	  mapPairs: createDictMethod(7),
	  reduce:   reduce,
	  keyOf:    keyOf,
	  includes: includes,
	  has:      has,
	  get:      get,
	  set:      set,
	  isDict:   isDict
	});

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var path    = __webpack_require__(525)
	  , $export = __webpack_require__(8);
	
	// Placeholder
	__webpack_require__(62)._ = path._ = path._ || {};
	
	$export($export.P + $export.F, 'Function', {part: __webpack_require__(332)});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(30)
	  , get      = __webpack_require__(233);
	module.exports = __webpack_require__(62).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(20)
	  , global  = __webpack_require__(34)
	  , $export = __webpack_require__(8)
	  , log     = {}
	  , enabled = true;
	// Methods from https://github.com/DeveloperToolsWG/console-object/blob/master/api.md
	$.each.call((
	  'assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,' +
	  'info,isIndependentlyComposed,log,markTimeline,profile,profileEnd,table,' +
	  'time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn'
	).split(','), function(key){
	  log[key] = function(){
	    var $console = global.console;
	    if(enabled && $console && $console[key]){
	      return Function.apply.call($console[key], $console, arguments);
	    }
	  };
	});
	$export($export.G + $export.F, {log: __webpack_require__(330)(log.log, log, {
	  enable: function(){
	    enabled = true;
	  },
	  disable: function(){
	    enabled = false;
	  }
	})});

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(228)(Number, 'Number', function(iterated){
	  this._l = +iterated;
	  this._i = 0;
	}, function(){
	  var i    = this._i++
	    , done = !(i < this._l);
	  return {done: done, value: done ? undefined : i};
	});

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', {classof: __webpack_require__(143)});

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , define  = __webpack_require__(523);
	
	$export($export.S + $export.F, 'Object', {define: define});

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', {isObject: __webpack_require__(29)});

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , define  = __webpack_require__(523)
	  , create  = __webpack_require__(20).create;
	
	$export($export.S + $export.F, 'Object', {
	  make: function(proto, mixin){
	    return define(create(proto), mixin);
	  }
	});

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(333)(/[&<>"']/g, {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&apos;'
	});
	
	$export($export.P + $export.F, 'String', {escapeHTML: function escapeHTML(){ return $re(this); }});

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(333)(/&(?:amp|lt|gt|quot|apos);/g, {
	  '&amp;':  '&',
	  '&lt;':   '<',
	  '&gt;':   '>',
	  '&quot;': '"',
	  '&apos;': "'"
	});
	
	$export($export.P + $export.F, 'String', {unescapeHTML:  function unescapeHTML(){ return $re(this); }});

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(20)
	  , $export           = __webpack_require__(8)
	  , DESCRIPTORS       = __webpack_require__(73)
	  , createDesc        = __webpack_require__(101)
	  , html              = __webpack_require__(516)
	  , cel               = __webpack_require__(513)
	  , has               = __webpack_require__(69)
	  , cof               = __webpack_require__(100)
	  , invoke            = __webpack_require__(226)
	  , fails             = __webpack_require__(50)
	  , anObject          = __webpack_require__(30)
	  , aFunction         = __webpack_require__(117)
	  , isObject          = __webpack_require__(29)
	  , toObject          = __webpack_require__(102)
	  , toIObject         = __webpack_require__(70)
	  , toInteger         = __webpack_require__(169)
	  , toIndex           = __webpack_require__(168)
	  , toLength          = __webpack_require__(74)
	  , IObject           = __webpack_require__(227)
	  , IE_PROTO          = __webpack_require__(146)('__proto__')
	  , createArrayMethod = __webpack_require__(223)
	  , arrayIndexOf      = __webpack_require__(509)(false)
	  , ObjectProto       = Object.prototype
	  , ArrayProto        = Array.prototype
	  , arraySlice        = ArrayProto.slice
	  , arrayJoin         = ArrayProto.join
	  , defineProperty    = $.setDesc
	  , getOwnDescriptor  = $.getDesc
	  , defineProperties  = $.setDescs
	  , factories         = {}
	  , IE8_DOM_DEFINE;
	
	if(!DESCRIPTORS){
	  IE8_DOM_DEFINE = !fails(function(){
	    return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
	  });
	  $.setDesc = function(O, P, Attributes){
	    if(IE8_DOM_DEFINE)try {
	      return defineProperty(O, P, Attributes);
	    } catch(e){ /* empty */ }
	    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	    if('value' in Attributes)anObject(O)[P] = Attributes.value;
	    return O;
	  };
	  $.getDesc = function(O, P){
	    if(IE8_DOM_DEFINE)try {
	      return getOwnDescriptor(O, P);
	    } catch(e){ /* empty */ }
	    if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
	  };
	  $.setDescs = defineProperties = function(O, Properties){
	    anObject(O);
	    var keys   = $.getKeys(Properties)
	      , length = keys.length
	      , i = 0
	      , P;
	    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
	    return O;
	  };
	}
	$export($export.S + $export.F * !DESCRIPTORS, 'Object', {
	  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $.getDesc,
	  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	  defineProperty: $.setDesc,
	  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties
	});
	
	  // IE 8- don't enum bug keys
	var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
	            'toLocaleString,toString,valueOf').split(',')
	  // Additional keys for getOwnPropertyNames
	  , keys2 = keys1.concat('length', 'prototype')
	  , keysLen1 = keys1.length;
	
	// Create object with `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = cel('iframe')
	    , i      = keysLen1
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict.prototype[keys1[i]];
	  return createDict();
	};
	var createGetKeys = function(names, length){
	  return function(object){
	    var O      = toIObject(object)
	      , i      = 0
	      , result = []
	      , key;
	    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	    // Don't enum bug & hidden keys
	    while(length > i)if(has(O, key = names[i++])){
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	    return result;
	  };
	};
	var Empty = function(){};
	$export($export.S, 'Object', {
	  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	  getPrototypeOf: $.getProto = $.getProto || function(O){
	    O = toObject(O);
	    if(has(O, IE_PROTO))return O[IE_PROTO];
	    if(typeof O.constructor == 'function' && O instanceof O.constructor){
	      return O.constructor.prototype;
	    } return O instanceof Object ? ObjectProto : null;
	  },
	  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
	  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	  create: $.create = $.create || function(O, /*?*/Properties){
	    var result;
	    if(O !== null){
	      Empty.prototype = anObject(O);
	      result = new Empty();
	      Empty.prototype = null;
	      // add "__proto__" for Object.getPrototypeOf shim
	      result[IE_PROTO] = O;
	    } else result = createDict();
	    return Properties === undefined ? result : defineProperties(result, Properties);
	  },
	  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
	});
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }
	  return factories[len](F, args);
	};
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	$export($export.P, 'Function', {
	  bind: function bind(that /*, args... */){
	    var fn       = aFunction(this)
	      , partArgs = arraySlice.call(arguments, 1);
	    var bound = function(/* args... */){
	      var args = partArgs.concat(arraySlice.call(arguments));
	      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	    };
	    if(isObject(fn.prototype))bound.prototype = fn.prototype;
	    return bound;
	  }
	});
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * fails(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});
	$export($export.P + $export.F * (IObject != Object), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
	  }
	});
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	$export($export.S, 'Array', {isArray: __webpack_require__(323)});
	
	var createArrayReduce = function(isRight){
	  return function(callbackfn, memo){
	    aFunction(callbackfn);
	    var O      = IObject(this)
	      , length = toLength(O.length)
	      , index  = isRight ? length - 1 : 0
	      , i      = isRight ? -1 : 1;
	    if(arguments.length < 2)for(;;){
	      if(index in O){
	        memo = O[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if(isRight ? index < 0 : length <= index){
	        throw TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
	      memo = callbackfn(memo, O[index], index, this);
	    }
	    return memo;
	  };
	};
	
	var methodize = function($fn){
	  return function(arg1/*, arg2 = undefined */){
	    return $fn(this, arg1, arguments[1]);
	  };
	};
	
	$export($export.P, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: $.each = $.each || methodize(createArrayMethod(0)),
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: methodize(createArrayMethod(1)),
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: methodize(createArrayMethod(2)),
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: methodize(createArrayMethod(3)),
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: methodize(createArrayMethod(4)),
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: createArrayReduce(false),
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: createArrayReduce(true),
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: methodize(arrayIndexOf),
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
	    if(index < 0)index = toLength(length + index);
	    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
	    return -1;
	  }
	});
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	$export($export.S, 'Date', {now: function(){ return +new Date; }});
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(this))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(1185)});
	
	__webpack_require__(142)('copyWithin');

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {fill: __webpack_require__(1186)});
	
	__webpack_require__(142)('fill');

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(223)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(142)(KEY);

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(223)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(142)(KEY);

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(79)
	  , $export     = __webpack_require__(8)
	  , toObject    = __webpack_require__(102)
	  , call        = __webpack_require__(520)
	  , isArrayIter = __webpack_require__(517)
	  , toLength    = __webpack_require__(74)
	  , getIterFn   = __webpack_require__(233);
	$export($export.S + $export.F * !__webpack_require__(325)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(50)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , $$     = arguments
	      , $$len  = $$.length
	      , result = new (typeof this == 'function' ? this : Array)($$len);
	    while($$len > index)result[index] = $$[index++];
	    result.length = $$len;
	    return result;
	  }
	});

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(230)('Array');

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $             = __webpack_require__(20)
	  , isObject      = __webpack_require__(29)
	  , HAS_INSTANCE  = __webpack_require__(35)('hasInstance')
	  , FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = $.getProto(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	var setDesc    = __webpack_require__(20).setDesc
	  , createDesc = __webpack_require__(101)
	  , has        = __webpack_require__(69)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(73) && setDesc(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    var match = ('' + this).match(nameRE)
	      , name  = match ? match[1] : '';
	    has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
	    return name;
	  }
	});

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(510);
	
	// 23.1 Map Objects
	__webpack_require__(224)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8)
	  , log1p   = __webpack_require__(522)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	// V8 bug https://code.google.com/p/v8/issues/detail?id=3509
	$export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	$export($export.S, 'Math', {asinh: asinh});

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8)
	  , sign    = __webpack_require__(329);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {expm1: __webpack_require__(328)});

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(8)
	  , sign      = __webpack_require__(329)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum   = 0
	      , i     = 0
	      , $$    = arguments
	      , $$len = $$.length
	      , larg  = 0
	      , arg, div;
	    while(i < $$len){
	      arg = abs($$[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(50)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(522)});

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {sign: __webpack_require__(329)});

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(328)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(50)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(328)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(20)
	  , global      = __webpack_require__(34)
	  , has         = __webpack_require__(69)
	  , cof         = __webpack_require__(100)
	  , toPrimitive = __webpack_require__(1191)
	  , fails       = __webpack_require__(50)
	  , $trim       = __webpack_require__(232).trim
	  , NUMBER      = 'Number'
	  , $Number     = global[NUMBER]
	  , Base        = $Number
	  , proto       = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF  = cof($.create(proto)) == NUMBER
	  , TRIM        = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? new Base(toNumber(it)) : toNumber(it);
	  };
	  $.each.call(__webpack_require__(73) ? $.getNames(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), function(key){
	    if(has(Base, key) && !has($Number, key)){
	      $.setDesc($Number, key, $.getDesc(Base, key));
	    }
	  });
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(81)(global, NUMBER, $Number);
	}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(8)
	  , _isFinite = __webpack_require__(34).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(518)});

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(8)
	  , isInteger = __webpack_require__(518)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.12 Number.parseFloat(string)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {parseFloat: parseFloat});

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.13 Number.parseInt(string, radix)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {parseInt: parseInt});

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(330)});

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(70);
	
	__webpack_require__(80)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(80)('getOwnPropertyNames', function(){
	  return __webpack_require__(515).get;
	});

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(102);
	
	__webpack_require__(80)('getPrototypeOf', function($getPrototypeOf){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {is: __webpack_require__(526)});

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(102);
	
	__webpack_require__(80)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
	  };
	});

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(29);
	
	__webpack_require__(80)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(334).set});

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(143)
	  , test    = {};
	test[__webpack_require__(35)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(81)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(20)
	  , LIBRARY    = __webpack_require__(327)
	  , global     = __webpack_require__(34)
	  , ctx        = __webpack_require__(79)
	  , classof    = __webpack_require__(143)
	  , $export    = __webpack_require__(8)
	  , isObject   = __webpack_require__(29)
	  , anObject   = __webpack_require__(30)
	  , aFunction  = __webpack_require__(117)
	  , strictNew  = __webpack_require__(231)
	  , forOf      = __webpack_require__(144)
	  , setProto   = __webpack_require__(334).set
	  , same       = __webpack_require__(526)
	  , SPECIES    = __webpack_require__(35)('species')
	  , speciesConstructor = __webpack_require__(1190)
	  , asap       = __webpack_require__(1189)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(73)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(229)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(167)(P, PROMISE);
	__webpack_require__(230)(PROMISE);
	Wrapper = __webpack_require__(62)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(325)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export  = __webpack_require__(8)
	  , _apply   = Function.apply
	  , anObject = __webpack_require__(30);
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(target, thisArgument, anObject(argumentsList));
	  }
	});

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $         = __webpack_require__(20)
	  , $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(117)
	  , anObject  = __webpack_require__(30)
	  , isObject  = __webpack_require__(29)
	  , bind      = Function.bind || __webpack_require__(62).Function.prototype.bind;
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(50)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = $.create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var $        = __webpack_require__(20)
	  , $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(30);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(50)(function(){
	  Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    try {
	      $.setDesc(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(8)
	  , getDesc  = __webpack_require__(20).getDesc
	  , anObject = __webpack_require__(30);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = getDesc(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(30);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(324)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var $        = __webpack_require__(20)
	  , $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(30);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return $.getDesc(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(8)
	  , getProto = __webpack_require__(20).getProto
	  , anObject = __webpack_require__(30);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var $        = __webpack_require__(20)
	  , has      = __webpack_require__(69)
	  , $export  = __webpack_require__(8)
	  , isObject = __webpack_require__(29)
	  , anObject = __webpack_require__(30);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(8)
	  , anObject      = __webpack_require__(30)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(331)});

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(8)
	  , anObject           = __webpack_require__(30)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(8)
	  , setProto = __webpack_require__(334);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var $          = __webpack_require__(20)
	  , has        = __webpack_require__(69)
	  , $export    = __webpack_require__(8)
	  , createDesc = __webpack_require__(101)
	  , anObject   = __webpack_require__(30)
	  , isObject   = __webpack_require__(29);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = $.getDesc(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = $.getProto(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    $.setDesc(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(20)
	  , global   = __webpack_require__(34)
	  , isRegExp = __webpack_require__(519)
	  , $flags   = __webpack_require__(514)
	  , $RegExp  = global.RegExp
	  , Base     = $RegExp
	  , proto    = $RegExp.prototype
	  , re1      = /a/g
	  , re2      = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(73) && (!CORRECT_NEW || __webpack_require__(50)(function(){
	  re2[__webpack_require__(35)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
	      : CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
	  };
	  $.each.call($.getNames(Base), function(key){
	    key in $RegExp || $.setDesc($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  });
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(81)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(230)('RegExp');

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	var $ = __webpack_require__(20);
	if(__webpack_require__(73) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(514)
	});

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(225)('match', 1, function(defined, MATCH){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  };
	});

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(225)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  };
	});

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(225)('search', 1, function(defined, SEARCH){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  };
	});

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(225)('split', 2, function(defined, SPLIT, $split){
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return function split(separator, limit){
	    'use strict';
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined
	      ? fn.call(separator, O, limit)
	      : $split.call(String(O), separator, limit);
	  };
	});

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(510);
	
	// 23.2 Set Objects
	__webpack_require__(224)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(335)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(8)
	  , toLength  = __webpack_require__(74)
	  , context   = __webpack_require__(336)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(322)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , $$   = arguments
	      , endPosition = $$.length > 1 ? $$[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(8)
	  , toIndex        = __webpack_require__(168)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res   = []
	      , $$    = arguments
	      , $$len = $$.length
	      , i     = 0
	      , code;
	    while($$len > i){
	      code = +$$[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(8)
	  , context  = __webpack_require__(336)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(322)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(335)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(228)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(70)
	  , toLength  = __webpack_require__(74);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl   = toIObject(callSite.raw)
	      , len   = toLength(tpl.length)
	      , $$    = arguments
	      , $$len = $$.length
	      , res   = []
	      , i     = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < $$len)res.push(String($$[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(529)
	});

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(8)
	  , toLength    = __webpack_require__(74)
	  , context     = __webpack_require__(336)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(322)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , $$     = arguments
	      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(232)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(20)
	  , global         = __webpack_require__(34)
	  , has            = __webpack_require__(69)
	  , DESCRIPTORS    = __webpack_require__(73)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(81)
	  , $fails         = __webpack_require__(50)
	  , shared         = __webpack_require__(527)
	  , setToStringTag = __webpack_require__(167)
	  , uid            = __webpack_require__(146)
	  , wks            = __webpack_require__(35)
	  , keyOf          = __webpack_require__(521)
	  , $names         = __webpack_require__(515)
	  , enumKeys       = __webpack_require__(1188)
	  , isArray        = __webpack_require__(323)
	  , anObject       = __webpack_require__(30)
	  , toIObject      = __webpack_require__(70)
	  , createDesc     = __webpack_require__(101)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(327)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(20)
	  , redefine     = __webpack_require__(81)
	  , weak         = __webpack_require__(512)
	  , isObject     = __webpack_require__(29)
	  , has          = __webpack_require__(69)
	  , frozenStore  = weak.frozenStore
	  , WEAK         = weak.WEAK
	  , isExtensible = Object.isExtensible || isObject
	  , tmp          = {};
	
	// 23.3 WeakMap Objects
	var $WeakMap = __webpack_require__(224)('WeakMap', function(get){
	  return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      if(!isExtensible(key))return frozenStore(this).get(key);
	      if(has(key, WEAK))return key[WEAK][this._i];
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	}, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  $.each.call(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on leaky map
	      if(isObject(a) && !isExtensible(a)){
	        var result = frozenStore(this)[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(512);
	
	// 23.4 WeakSet Objects
	__webpack_require__(224)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(8)
	  , $includes = __webpack_require__(509)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(142)('includes');

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(511)('Map')});

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export  = __webpack_require__(8)
	  , $entries = __webpack_require__(524)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/WebReflection/9353781
	var $          = __webpack_require__(20)
	  , $export    = __webpack_require__(8)
	  , ownKeys    = __webpack_require__(331)
	  , toIObject  = __webpack_require__(70)
	  , createDesc = __webpack_require__(101);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , setDesc = $.setDesc
	      , getDesc = $.getDesc
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i){
	      D = getDesc(O, key = keys[i++]);
	      if(key in result)setDesc(result, key, createDesc(0, D));
	      else result[key] = D;
	    } return result;
	  }
	});

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export = __webpack_require__(8)
	  , $values = __webpack_require__(524)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8)
	  , $re     = __webpack_require__(333)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(511)('Set')});

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(335)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(528);
	
	$export($export.P, 'String', {
	  padLeft: function padLeft(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(528);
	
	$export($export.P, 'String', {
	  padRight: function padRight(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(232)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	});

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(232)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	});

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	// JavaScript 1.6 / Strawman array statics shim
	var $       = __webpack_require__(20)
	  , $export = __webpack_require__(8)
	  , $ctx    = __webpack_require__(79)
	  , $Array  = __webpack_require__(62).Array || Array
	  , statics = {};
	var setStatics = function(keys, length){
	  $.each.call(keys.split(','), function(key){
	    if(length == undefined && key in $Array)statics[key] = $Array[key];
	    else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
	  });
	};
	setStatics('pop,reverse,shift,keys,values,entries', 1);
	setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	           'reduce,reduceRight,copyWithin,fill');
	$export($export.S, 'Array', statics);

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(532);
	var global      = __webpack_require__(34)
	  , hide        = __webpack_require__(95)
	  , Iterators   = __webpack_require__(145)
	  , ITERATOR    = __webpack_require__(35)('iterator')
	  , NL          = global.NodeList
	  , HTC         = global.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype
	  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
	if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
	if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , $task   = __webpack_require__(530);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(34)
	  , $export    = __webpack_require__(8)
	  , invoke     = __webpack_require__(226)
	  , partial    = __webpack_require__(332)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1204);
	__webpack_require__(1287);
	__webpack_require__(1242);
	__webpack_require__(1250);
	__webpack_require__(1254);
	__webpack_require__(1255);
	__webpack_require__(1243);
	__webpack_require__(1253);
	__webpack_require__(1252);
	__webpack_require__(1248);
	__webpack_require__(1249);
	__webpack_require__(1247);
	__webpack_require__(1244);
	__webpack_require__(1246);
	__webpack_require__(1251);
	__webpack_require__(1245);
	__webpack_require__(1213);
	__webpack_require__(1212);
	__webpack_require__(1232);
	__webpack_require__(1233);
	__webpack_require__(1234);
	__webpack_require__(1235);
	__webpack_require__(1236);
	__webpack_require__(1237);
	__webpack_require__(1238);
	__webpack_require__(1239);
	__webpack_require__(1240);
	__webpack_require__(1241);
	__webpack_require__(1215);
	__webpack_require__(1216);
	__webpack_require__(1217);
	__webpack_require__(1218);
	__webpack_require__(1219);
	__webpack_require__(1220);
	__webpack_require__(1221);
	__webpack_require__(1222);
	__webpack_require__(1223);
	__webpack_require__(1224);
	__webpack_require__(1225);
	__webpack_require__(1226);
	__webpack_require__(1227);
	__webpack_require__(1228);
	__webpack_require__(1229);
	__webpack_require__(1230);
	__webpack_require__(1231);
	__webpack_require__(1280);
	__webpack_require__(1283);
	__webpack_require__(1286);
	__webpack_require__(1282);
	__webpack_require__(1278);
	__webpack_require__(1279);
	__webpack_require__(1281);
	__webpack_require__(1284);
	__webpack_require__(1285);
	__webpack_require__(1209);
	__webpack_require__(1210);
	__webpack_require__(532);
	__webpack_require__(1211);
	__webpack_require__(1205);
	__webpack_require__(1206);
	__webpack_require__(1208);
	__webpack_require__(1207);
	__webpack_require__(1271);
	__webpack_require__(1272);
	__webpack_require__(1273);
	__webpack_require__(1274);
	__webpack_require__(1275);
	__webpack_require__(1276);
	__webpack_require__(1256);
	__webpack_require__(1214);
	__webpack_require__(1277);
	__webpack_require__(1288);
	__webpack_require__(1289);
	__webpack_require__(1257);
	__webpack_require__(1258);
	__webpack_require__(1259);
	__webpack_require__(1260);
	__webpack_require__(1261);
	__webpack_require__(1264);
	__webpack_require__(1262);
	__webpack_require__(1263);
	__webpack_require__(1265);
	__webpack_require__(1266);
	__webpack_require__(1267);
	__webpack_require__(1268);
	__webpack_require__(1270);
	__webpack_require__(1269);
	__webpack_require__(1290);
	__webpack_require__(1297);
	__webpack_require__(1298);
	__webpack_require__(1299);
	__webpack_require__(1300);
	__webpack_require__(1301);
	__webpack_require__(1295);
	__webpack_require__(1293);
	__webpack_require__(1294);
	__webpack_require__(1292);
	__webpack_require__(1291);
	__webpack_require__(1296);
	__webpack_require__(1302);
	__webpack_require__(1305);
	__webpack_require__(1304);
	__webpack_require__(1303);
	module.exports = __webpack_require__(62);

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(1308);
	
	var emptyObject = __webpack_require__(1483);
	var _invariant = __webpack_require__(1484);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(1309);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }
	
	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }
	
	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }
	
	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1314);
	var each = __webpack_require__(533).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1312);
	var Util = __webpack_require__(533);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1313);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
1319,
/* 1321 */
1319,
/* 1322 */
1319,
/* 1323 */
1319,
/* 1324 */
1319,
/* 1325 */
1319,
/* 1326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AppointmentButton":"AppointmentButton__AppointmentButton___Wokcp"};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Dialog":"AppointmentDialog__Dialog___O2AVV","NoCollections":"AppointmentDialog__NoCollections___3nt5O","Title":"AppointmentDialog__Title___5VSO_","BackButton":"AppointmentDialog__BackButton___3VCGq","TitleStepOne":"AppointmentDialog__TitleStepOne___2n4uP","Content":"AppointmentDialog__Content___2MIz2","ContentStepOne":"AppointmentDialog__ContentStepOne___21wY2","Footer":"AppointmentDialog__Footer___x6nmO","NextButton":"AppointmentDialog__NextButton___3UyEw","SubmitButton":"AppointmentDialog__SubmitButton___1F6a1","FooterStepOne":"AppointmentDialog__FooterStepOne___kvWKx","DialogStepOne":"AppointmentDialog__DialogStepOne___2RLhA","ResultDialog":"AppointmentDialog__ResultDialog___1Uvdk","ResultIcon":"AppointmentDialog__ResultIcon___1W9lU","ResultTitle":"AppointmentDialog__ResultTitle___3ZvRM","ResultText":"AppointmentDialog__ResultText___1ubBv","ButtonsGroup":"AppointmentDialog__ButtonsGroup___3htVu","ResultButton":"AppointmentDialog__ResultButton___3QDeD"};

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AppointmentForm":"AppointmentForm__AppointmentForm___37b_E","Title":"AppointmentForm__Title___MO_VY","InputGroup":"AppointmentForm__InputGroup___1lnHZ","Input":"AppointmentForm__Input___3BWg6","SelectedDate":"AppointmentForm__SelectedDate___2RQFq","SelectedDateTitle":"AppointmentForm__SelectedDateTitle___3bU5w","SelectedDateText":"AppointmentForm__SelectedDateText___5TI5A","InputWrap":"AppointmentForm__InputWrap___2ranW","SubmitButton":"AppointmentForm__SubmitButton___1a8IN","Error":"AppointmentForm__Error___1of4e","ErrorLabel":"AppointmentForm__ErrorLabel___21kcp"};

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DatePicker":"DatePicker__DatePicker___3C4Qy","Tabs":"DatePicker__Tabs___-8csr","TabButton":"DatePicker__TabButton___2OKVw","Active":"DatePicker__Active___1DtLz","LoadingSkeleton":"DatePicker__LoadingSkeleton___PsuZx","Calendar":"DatePicker__Calendar___JDFN5","Dates":"DatePicker__Dates___3LTuV","Date":"DatePicker__Date___16VZb","WeekDay":"DatePicker__WeekDay___2gEV1","MonthDay":"DatePicker__MonthDay___2foDV","Selected":"DatePicker__Selected___QiJAX","Available":"DatePicker__Available___24AIE","Slots":"DatePicker__Slots___2SypW","SlotsTitle":"DatePicker__SlotsTitle___3maPL","NoSlots":"DatePicker__NoSlots___ftWth","NoSlotsTitle":"DatePicker__NoSlotsTitle___2KAhg","NoSlotsSubtitle":"DatePicker__NoSlotsSubtitle___2Evtg","SlotTable":"DatePicker__SlotTable___3d8z_","Slot":"DatePicker__Slot___3niiA"};

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___3L4lQ","BlockerWrap":"style__BlockerWrap___byWP6","Blocker":"style__Blocker___1ygxD","BlockerText":"style__BlockerText___28m0k","Wide":"style__Wide___ptGLl","BlockerImage":"style__BlockerImage___2ryKj","BlockerTitle":"style__BlockerTitle___3Nf78","BlockerDescrip":"style__BlockerDescrip___2DByp","PayForTarifBtn":"style__PayForTarifBtn___2q2Pk","ButtonLogout":"style__ButtonLogout____n-oB","ButtonLeave":"style__ButtonLeave___2faQh","BlockerManager":"style__BlockerManager___Mzc-H"};

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Toolbar":"BuildingBar__Toolbar___3XVny","ToolbarOnTop":"BuildingBar__ToolbarOnTop___3TIUi","ToolbarChess":"BuildingBar__ToolbarChess___3si4u","Inner":"BuildingBar__Inner___3wp6g","Wide":"BuildingBar__Wide___2kGbh","Hidden":"BuildingBar__Hidden___1Cdh-","TopName":"BuildingBar__TopName___i0kBr","Top":"BuildingBar__Top___1nIIn","WireframeTop":"BuildingBar__WireframeTop___15J-n","Status":"BuildingBar__Status___2yDz6","Bottom":"BuildingBar__Bottom___1wRHo","Switcher":"BuildingBar__Switcher___3VjId","StatusBlock":"BuildingBar__StatusBlock___1Wq4U","Green":"BuildingBar__Green___oO_Zd","Yellow":"BuildingBar__Yellow___2WvRM","WireframeBottom":"BuildingBar__WireframeBottom___1LUcQ","Button":"BuildingBar__Button___2wjqf","BackButton":"BuildingBar__BackButton___vJ_eJ","InaccuracyReportButtonWrap":"BuildingBar__InaccuracyReportButtonWrap___dojLI","InaccuracyReportWrap":"BuildingBar__InaccuracyReportWrap___1klsE","SwitcherInner":"BuildingBar__SwitcherInner___1_rWb","Right":"BuildingBar__Right____u0Hj","Title":"BuildingBar__Title___2zZkd","TitleHousing":"BuildingBar__TitleHousing___35ClN","ObjectName":"BuildingBar__ObjectName___3yXie","UpdateTime":"BuildingBar__UpdateTime___3HWFE","WireframeToolbar":"BuildingBar__WireframeToolbar___1OMxK","WireframeTitle":"BuildingBar__WireframeTitle___2Y2sa","WireframeTime":"BuildingBar__WireframeTime___1unV8","WireframeSwitcher":"BuildingBar__WireframeSwitcher___170zj","WireframeInfoButton":"BuildingBar__WireframeInfoButton___2B9_p","ListSwitcher":"BuildingBar__ListSwitcher___1j7Kq","ToolbarPrint":"BuildingBar__ToolbarPrint___2FC9d","ToInfoBtn":"BuildingBar__ToInfoBtn___3WqXt","DropdownWrap":"BuildingBar__DropdownWrap___27SDL","DropdownIcon":"BuildingBar__DropdownIcon___1yJ8P","Time":"BuildingBar__Time___1Dc1O","Print":"BuildingBar__Print___2zGPg","SwitcherButtons":"BuildingBar__SwitcherButtons___3oJuL","SwitcherEnabled":"BuildingBar__SwitcherEnabled___OM1KW","SwitcherText":"BuildingBar__SwitcherText___1ljp4","DropdownButton":"BuildingBar__DropdownButton___1a9Sy","DropdownContent":"BuildingBar__DropdownContent___1rvU0","HousingInfo":"BuildingBar__HousingInfo___2dmCq","HousingName":"BuildingBar__HousingName___3NXYn","Dropdown":"BuildingBar__Dropdown___2ZlTC","LogoPrint":"BuildingBar__LogoPrint___3llOt","TabletHidden":"BuildingBar__TabletHidden___1UbkE","SwitcherEnabledChecked":"BuildingBar__SwitcherEnabledChecked___3F4an","SwitcherEnabledNotChecked":"BuildingBar__SwitcherEnabledNotChecked___3lFdq"};

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Building":"Chess__Building___3nX9x","LandscapeOverlay":"Chess__LandscapeOverlay___3C2Y5","FiltersBarWrap":"Chess__FiltersBarWrap___1NlLg","Client":"Chess__Client___2WTYd","FiltersBar":"Chess__FiltersBar___3eErU","Filters":"Chess__Filters___1N0F_","TableOptions":"Chess__TableOptions___2j2l1","FiltersBBB":"Chess__FiltersBBB___1E2xj","Update":"Chess__Update___1vnIY","UpdateDate":"Chess__UpdateDate___1YA5J","ZoomBtn":"Chess__ZoomBtn___2S50c","ZoomIn":"Chess__ZoomIn___x5oD_","ZoomOut":"Chess__ZoomOut___3mAv9","ZoomBar":"Chess__ZoomBar___PkUxK","ZoomHandle":"Chess__ZoomHandle___Ca_DN","ZoomButtons":"Chess__ZoomButtons___2zNX9","Container":"Chess__Container___2Z80M","ContainerClient":"Chess__ContainerClient___2OPU9","TableWrap":"Chess__TableWrap___RjnL_","Table":"Chess__Table___1L2-S","Description":"Chess__Description___Ilepv","Toggle":"Chess__Toggle___1CVhj","Wide":"Chess__Wide___Z4hif","DescriptionHide":"Chess__DescriptionHide___3u_Hr","ToggleIcon":"Chess__ToggleIcon___3LAnI","Hidden":"Chess__Hidden___2Nwld","CollapseDescriptionBtn":"Chess__CollapseDescriptionBtn___2umYn","DescriptionContent":"Chess__DescriptionContent___3MTc4","ExtendedContentWrap":"Chess__ExtendedContentWrap___1TyPM","ExtendedContent":"Chess__ExtendedContent___240JE","Reservation":"Chess__Reservation___aUzEY","NotMatch":"Chess__NotMatch___Sl6Ps","ExtendedFlatPrice":"Chess__ExtendedFlatPrice___2sUI7","ExtendedFlatNum":"Chess__ExtendedFlatNum___1sFwz","ExtendedContentPrint":"Chess__ExtendedContentPrint___1-U7t","ExtendedContentLeft":"Chess__ExtendedContentLeft___2YBjv","ExtendedContentRight":"Chess__ExtendedContentRight___2dUcj","WireframeFilters":"Chess__WireframeFilters___D2mz4","WireframeFirst":"Chess__WireframeFirst___3T-AA","WireframeSecond":"Chess__WireframeSecond___1_Jfy","WireframeSwitchHousing":"Chess__WireframeSwitchHousing___Kq3Or","WireframeTableOptions":"Chess__WireframeTableOptions___oDN8h","WireframeTableOptionsCheck":"Chess__WireframeTableOptionsCheck___2s80D","WireframeRightMenu":"Chess__WireframeRightMenu___2VaZF","WireframeAbout":"Chess__WireframeAbout___5iv5a","WireframeRow":"Chess__WireframeRow___1vqrr","WireframeFirstSpan":"Chess__WireframeFirstSpan___4YB2T","WireframeSecondSpan":"Chess__WireframeSecondSpan___2yWJI","WireframeNum":"Chess__WireframeNum___3ugkA","WireframePrintBtn":"Chess__WireframePrintBtn___3TXeq","WireframeThirdSpan":"Chess__WireframeThirdSpan___ctE2d","WireframeFourthSpan":"Chess__WireframeFourthSpan___Vki30","WireframeImage":"Chess__WireframeImage___18zga","WireframeGallery":"Chess__WireframeGallery___2yjnI","BuildingPrint":"Chess__BuildingPrint___3C6UZ","Loader":"Chess__Loader___18l_9","PrintExtendedEmptySpan":"Chess__PrintExtendedEmptySpan___3qGqb","Span":"Chess__Span___2Q2K1","UpdateLabel":"Chess__UpdateLabel___raqqZ","HousingInfo":"Chess__HousingInfo___1WPoh","Icon":"Chess__Icon___37uvb"};

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Filters":"Filters__Filters___1scmc","FiltersChess":"Filters__FiltersChess___jDvJ5","Filter":"Filters__Filter___2TzHm","FilterPrice":"Filters__FilterPrice___3MCuV","HousingFilterWrap":"Filters__HousingFilterWrap___1nMzy","DropdownIcon":"Filters__DropdownIcon___3tfyN","Button":"Filters__Button___261aB","HousingInfo":"Filters__HousingInfo___26tAP","HousingInfoChess":"Filters__HousingInfoChess___3uqo_","StatusBlock":"Filters__StatusBlock___2P_Yi","HousingName":"Filters__HousingName___2kA-A","Green":"Filters__Green___EpljF","Yellow":"Filters__Yellow___1OnLV","Icon":"Filters__Icon___26yP1","Title":"Filters__Title___2K88l","Active":"Filters__Active___37pG_","Divider":"Filters__Divider___1JOLl","FiltersPrint":"Filters__FiltersPrint___1WkUe","MobileVisible":"Filters__MobileVisible___2R06L","HousingDropdown":"Filters__HousingDropdown___-NziQ","TabletHidden":"Filters__TabletHidden___177uL","Mobile":"Filters__Mobile___1-nZu","FiltersBar":"Filters__FiltersBar___wFITl","MobileHidden":"Filters__MobileHidden___2GOxI"};

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HousingMenuTitle":"Housing__HousingMenuTitle___2fN3B","HousingMenuItem":"Housing__HousingMenuItem___3BB66","RadioIcon":"Housing__RadioIcon___3tRu_","Active":"Housing__Active___hTr3T","Status":"Housing__Status___3n18Z","Finished":"Housing__Finished___2lD2z","InProcess":"Housing__InProcess___1xBP7"};

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"List__Table___3AjD3","TableClient":"List__TableClient___1BDmm","InnerBumper":"List__InnerBumper___2To-u","Inner":"List__Inner___3TCTw","Client":"List__Client___3JnlO","Data":"List__Data___16Bt7","Rows":"List__Rows___-vjIq","HeaderContent":"List__HeaderContent___3wIfd","CellContent":"List__CellContent___1EzLU","Header":"List__Header___297Zr","Wide":"List__Wide___2naaS","HeaderItem":"List__HeaderItem___7WlW-","HeaderText":"List__HeaderText___fxKxe","HeaderSort":"List__HeaderSort___1GahP","HeaderCostMeter":"List__HeaderCostMeter___1kxa7","HeaderNumber":"List__HeaderNumber___28qI7","Sorted":"List__Sorted___3qCf5","RowsTitle":"List__RowsTitle___2nZO1","Cell":"List__Cell___3mHYg","CellItem":"List__CellItem___3dP-E","CellNumber":"List__CellNumber___3VWje","CellStatus":"List__CellStatus___UUGsZ","HeaderStatus":"List__HeaderStatus___2cRny","Selected":"List__Selected___grbxp","Promo":"List__Promo___3CMF6","iconFund":"List__iconFund___2yixj","TagPromo":"List__TagPromo___377PS","TagReserv":"List__TagReserv___1DG8A","TagAssign":"List__TagAssign___hFc_u","NoFlats":"List__NoFlats___1eS-A","NoFlatsTitle":"List__NoFlatsTitle___2ERrC","NoFlatsText":"List__NoFlatsText___2DK7n","TabletVisible":"List__TabletVisible___3sZKi","FlatsSoldWrap":"List__FlatsSoldWrap___UVSNr","FlatsSold":"List__FlatsSold___2Z_nj","FlatsSoldTitle":"List__FlatsSoldTitle___3Wo2V","FlatsSoldImage":"List__FlatsSoldImage___6DPfn","HeaderArea":"List__HeaderArea___3HOZs","CellArea":"List__CellArea___27arc","HeaderCost":"List__HeaderCost___hg15Y","CellCost":"List__CellCost___3kEaD","CellPrice":"List__CellPrice___1PsPO","HeaderInterior":"List__HeaderInterior___3B_TH","CellDecoration":"List__CellDecoration___psAkt","HeaderRooms":"List__HeaderRooms___2qiG4","CellRoomCount":"List__CellRoomCount___2rdll","HeaderFloorNumber":"List__HeaderFloorNumber___1pWTx","CellFloorNumber":"List__CellFloorNumber___1djaf","NoFlatsInfo":"List__NoFlatsInfo___2YZHB","TabletHidden":"List__TabletHidden___ULJEZ"};

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Gallery":"Gallery__Gallery___3tYGc","Client":"Gallery__Client___24lT_","Print":"Gallery__Print___3uLEL","Slider":"Gallery__Slider___1J_m6","SliderArrows":"Gallery__SliderArrows___2rlCt","SliderArrow":"Gallery__SliderArrow___2WfQg","Prev":"Gallery__Prev___1URxd","FloorNumber":"Gallery__FloorNumber___I9cEt","FloorNumberPrint":"Gallery__FloorNumberPrint___24dnR","PrintHeader":"Gallery__PrintHeader___NbCpJ","PrintHeaderLeft":"Gallery__PrintHeaderLeft___2oX6S","PrintHeaderObjectName":"Gallery__PrintHeaderObjectName___2V8zz","LogoPrint":"Gallery__LogoPrint___2rEPh","MoveLeft":"Gallery__MoveLeft___Bb0BH","MoveRight":"Gallery__MoveRight___361r9","ImageOuter":"Gallery__ImageOuter___2o--c","ImageInner":"Gallery__ImageInner____RPUo","ImagePrint":"Gallery__ImagePrint___1gNxT","Loader":"Gallery__Loader___2bCtL","loader-scale":"Gallery__loader-scale___2Lp1F","ImageZoom":"Gallery__ImageZoom___2AtF3","popupGallery":"Gallery__popupGallery___fk0uN","popupGalleryBg":"Gallery__popupGalleryBg___1NSNH","popupGalleryContent":"Gallery__popupGalleryContent___1QR6_","PopUpOuter":"Gallery__PopUpOuter___2D3F4","PopUpInner":"Gallery__PopUpInner___6fkWt","FloorPlanWrapper":"Gallery__FloorPlanWrapper___3e-Ue","FloorPlanTop":"Gallery__FloorPlanTop___1rrzV","FloorPlanLeft":"Gallery__FloorPlanLeft___29nn-","FloorPlanRight":"Gallery__FloorPlanRight___viCld","SelectHousing":"Gallery__SelectHousing___ZdqWn","FilterItem":"Gallery__FilterItem____0eUN","SelectFloor":"Gallery__SelectFloor___2J33w","SelectFloorArrow":"Gallery__SelectFloorArrow___daSlJ","Top":"Gallery__Top___1zksP","Bottom":"Gallery__Bottom___3PjgN","FloorTitle":"Gallery__FloorTitle___1Ex0D","Floors":"Gallery__Floors___1arYZ","FloorItem":"Gallery__FloorItem___S108-","Light":"Gallery__Light___3loXn","Active":"Gallery__Active___1xY7s","FloorPlan":"Gallery__FloorPlan___3odon","ZoomButtons":"Gallery__ZoomButtons___2mRVG","ZoomBtn":"Gallery__ZoomBtn___kod3-","ZoomIn":"Gallery__ZoomIn___hiO30","ZoomOut":"Gallery__ZoomOut___1gYQY","ZoomBar":"Gallery__ZoomBar___1xUPl","ZoomHandle":"Gallery__ZoomHandle___Um1v9","ImageInfo":"Gallery__ImageInfo___3bzSQ","Plan":"Gallery__Plan___QZaJw","Flat":"Gallery__Flat___1IDjW","FilteredFlat":"Gallery__FilteredFlat___3uX3e","SelectedFlat":"Gallery__SelectedFlat___1YTKd","FlatPopup":"Gallery__FlatPopup___3QZkU","FlatPopupInner":"Gallery__FlatPopupInner___2qgy6","FlatNumber":"Gallery__FlatNumber___3R_WO","FlatCost":"Gallery__FlatCost___1jkYp","FlatType":"Gallery__FlatType___3qyu5","FlatAreaAndPrice":"Gallery__FlatAreaAndPrice___1xGoq","Reservation":"Gallery__Reservation___G_cQg","Promo":"Gallery__Promo___16jo-","Locked":"Gallery__Locked___3ECFy","FlatHover":"Gallery__FlatHover___1PXYU","FlatArea":"Gallery__FlatArea___1tLTq","LoaderInfo":"Gallery__LoaderInfo___JnIsr","PlaceholderOuter":"Gallery__PlaceholderOuter___24qqr","PlaceholderText":"Gallery__PlaceholderText___d8vCz","ImageWrap":"Gallery__ImageWrap___2X2Z9","Zoom":"Gallery__Zoom___1FPEJ","Close":"Gallery__Close___20WPx"};

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RightMenu":"RightMenu__RightMenu___3YHOj","Client":"RightMenu__Client___AaNpd"};

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"styles__Wrapper___1YCXI","Container":"styles__Container___R_zzQ"};

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"Table__Table___1eCyT","Inner":"Table__Inner___2r7-o","Header":"Table__Header___2G7T4","Row":"Table__Row___1PO98","Data":"Table__Data___1t_AF","CellMaster":"Table__CellMaster___3rexx","Wide":"Table__Wide___2jn73","RowNumCell":"Table__RowNumCell___3H7Zy","Appendicitis":"Table__Appendicitis___2R_v-","CellContent":"Table__CellContent___3bTl5","Fund":"Table__Fund___2npmb","Reservation":"Table__Reservation___MSvJT","ExtendedContent":"Table__ExtendedContent___1uerl","Cell":"Table__Cell___iQCcD","Selected":"Table__Selected___2H3-L","NotMatch":"Table__NotMatch___3Pidd","Stretch":"Table__Stretch___TU3WK","HeaderCell":"Table__HeaderCell___-K8FG","CellFantom":"Table__CellFantom___K0s6F","BorderTop":"Table__BorderTop___13c4d","PanoramaCell":"Table__PanoramaCell___2DqNK","Hidden":"Table__Hidden___1uXKL","Content":"Table__Content___1k84h","TablePrint":"Table__TablePrint___19ifh","PrintReservPattern":"Table__PrintReservPattern___1-eHg","Stretched":"Table__Stretched___EgMW0","Tooltip":"Table__Tooltip___hpyZR","TooltipContent":"Table__TooltipContent___3VO2r","Action":"Table__Action___gCFv3","Reserve":"Table__Reserve___3HaKI","Price":"Table__Price___3CSPN","FlatNum":"Table__FlatNum___30kso","TooltipContentLeft":"Table__TooltipContentLeft___2rdyi","TooltipContentRight":"Table__TooltipContentRight___3CDKP","CellTooltip":"Table__CellTooltip___102g9","CellTooltipText":"Table__CellTooltipText___2iXzH"};

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Checkbox":"TableOptions__Checkbox___2sGb_","ChessCheckInner":"TableOptions__ChessCheckInner___20cOw","Switcher":"TableOptions__Switcher___3UeDT","ChessSwitcherButton":"TableOptions__ChessSwitcherButton___2kzrV","ChessText":"TableOptions__ChessText___3kgcG"};

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"InaccuracyReport":"InaccuracyReport__InaccuracyReport___18Vdj","ButtonCreateInaccuracyReport":"InaccuracyReport__ButtonCreateInaccuracyReport___2f1HJ","ButtonContent":"InaccuracyReport__ButtonContent___2BoUd","ButtonIcon":"InaccuracyReport__ButtonIcon___clYlm","ButtonText":"InaccuracyReport__ButtonText___1vZwG","Hide1180":"InaccuracyReport__Hide1180___Ss3Xw","ButtonAddToCollection":"InaccuracyReport__ButtonAddToCollection___2HgKy","Title":"InaccuracyReport__Title___1Lbin","Row":"InaccuracyReport__Row___23jyc","Name":"InaccuracyReport__Name___3fnyH","Button":"InaccuracyReport__Button___1eUzG"};

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"InaccuracyReportDialog__PopupContent___2dUjV","NoCollections":"InaccuracyReportDialog__NoCollections___-SlPP","PopupTitle":"InaccuracyReportDialog__PopupTitle___GgkRP","Divider":"InaccuracyReportDialog__Divider___2phHb","PopupSubtitle":"InaccuracyReportDialog__PopupSubtitle___1Yu2i","InaccuracyReportForm":"InaccuracyReportDialog__InaccuracyReportForm___JxVl_","InaccuracyReportTextArea":"InaccuracyReportDialog__InaccuracyReportTextArea___3KFf2","ReportHelperText":"InaccuracyReportDialog__ReportHelperText___1lNRA","InaccuracyReportButton":"InaccuracyReportDialog__InaccuracyReportButton___24mx1","DoneWrap":"InaccuracyReportDialog__DoneWrap___1T8rS","DoneTitle":"InaccuracyReportDialog__DoneTitle___2gGnl","Loader":"InaccuracyReportDialog__Loader___2JDhH","loader10":"InaccuracyReportDialog__loader10___10oJh","PopupContentLeft":"InaccuracyReportDialog__PopupContentLeft___1FOuw","PopupCollections":"InaccuracyReportDialog__PopupCollections___3wGFR","PopupActions":"InaccuracyReportDialog__PopupActions___2u9VJ"};

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"About":"About__About___18_ND","Client":"About__Client___1-koJ","Inner":"About__Inner___1qVw0","InnerClient":"About__InnerClient___1TrOm","InfoBlock":"About__InfoBlock___xxTyZ","CheckBlock":"About__CheckBlock___3O7A0","InfoBlockClient":"About__InfoBlockClient___2OnQU","InfoItem":"About__InfoItem___1y6xB","Description":"About__Description___1gs00","InfoItemClient":"About__InfoItemClient___2AJCG","CheckItem":"About__CheckItem___1hY9t","Image":"About__Image___ASBSW","Text":"About__Text___36nUo","Column":"About__Column___2CBkw","Title":"About__Title___11u-O","Park":"About__Park___3iG4Z","AboutTitle":"About__AboutTitle___2maUk","Print":"About__Print___1N4sY","InfoBlockInner":"About__InfoBlockInner___38b3f","OnlyMobile":"About__OnlyMobile___6dWwW","NotMobile":"About__NotMobile___3RvII"};

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ChessBtn":"ChessLink__ChessBtn___1oElx","Show1024":"ChessLink__Show1024___aLtmk","Hide1024":"ChessLink__Hide1024___wUxUV"};

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Title":"Collections__Title___2oIra","Inner":"Collections__Inner___LbbBm","Row":"Collections__Row___2jWOP","NotFound":"Collections__NotFound___33t-e","NotFoundImage":"Collections__NotFoundImage___3egn0","NotFoundText":"Collections__NotFoundText___S2w8p","Label":"Collections__Label___2A19D","Name":"Collections__Name___ZOqIn","Commission":"Collections__Commission___HVzfq","Site":"Collections__Site___3-7gx","Collections":"Collections__Collections___1easL","ButtonAddToCollection":"Collections__ButtonAddToCollection___C688G","popupClose":"Collections__popupClose___35WPI","Hide1180":"Collections__Hide1180___wVCw6","ButtonIcon":"Collections__ButtonIcon___1VOso","Button":"Collections__Button___1zzKP"};

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"CollectionsDialog__PopupContent___1cM_K","NoCollections":"CollectionsDialog__NoCollections___31LD_","PopupTitle":"CollectionsDialog__PopupTitle___1hl0X","ObjectInfo":"CollectionsDialog__ObjectInfo___2_RDU","ObjectInfoImage":"CollectionsDialog__ObjectInfoImage___3s6LI","ObjectInfoText":"CollectionsDialog__ObjectInfoText___NPX-m","ObjectInfoTitle":"CollectionsDialog__ObjectInfoTitle___3y6w6","ObjectInfoAddress":"CollectionsDialog__ObjectInfoAddress___3JJGB","ObjectInfoStatus":"CollectionsDialog__ObjectInfoStatus___2ymBi","Finished":"CollectionsDialog__Finished___3wNZa","AlmostFinished":"CollectionsDialog__AlmostFinished___2uECT","NotFinished":"CollectionsDialog__NotFinished___Z8uM2","PopupCollections":"CollectionsDialog__PopupCollections___gi9-o","NewCollection":"CollectionsDialog__NewCollection___1XRHI","PopupCollection":"CollectionsDialog__PopupCollection___3Xn7m","PopupCollectionHover":"CollectionsDialog__PopupCollectionHover___1I6Lz","Added":"CollectionsDialog__Added___1Rw-B","IconAdded":"CollectionsDialog__IconAdded___29zum","PopupCollectionImages":"CollectionsDialog__PopupCollectionImages___2d1VE","PopupCollectionDescrip":"CollectionsDialog__PopupCollectionDescrip___EVsF7","IconAdd":"CollectionsDialog__IconAdd___1Be6l","PopupActions":"CollectionsDialog__PopupActions___3oRcB","PopupActionsTitle":"CollectionsDialog__PopupActionsTitle___3-mHV","ActionBtn":"CollectionsDialog__ActionBtn___2G7Jg","CreateCollectionButton":"CollectionsDialog__CreateCollectionButton___a9-fj","ActionCreateButton":"CollectionsDialog__ActionCreateButton___21mqk","ActionBack":"CollectionsDialog__ActionBack___2wdWY","ActionCreateCollection":"CollectionsDialog__ActionCreateCollection___1eTd2","ActionCreateCollectionTop":"CollectionsDialog__ActionCreateCollectionTop___11FpL","ActionCreateCollectionBottom":"CollectionsDialog__ActionCreateCollectionBottom___1C6ds","CreateCollectionInput":"CollectionsDialog__CreateCollectionInput___2sSis","CheckItem":"CollectionsDialog__CheckItem___G6NCm","TotalObjects":"CollectionsDialog__TotalObjects___2sTjX","NoCollectionsContent":"CollectionsDialog__NoCollectionsContent___1cM_U","NoCollectionsTitle":"CollectionsDialog__NoCollectionsTitle___1ZE_R","NoCollectionsText":"CollectionsDialog__NoCollectionsText___3CcMG","NoCollectionsImage":"CollectionsDialog__NoCollectionsImage___1pOlQ","Loader":"CollectionsDialog__Loader___30y2K","loader10":"CollectionsDialog__loader10___IsYxZ","PopupContentLeft":"CollectionsDialog__PopupContentLeft___2B3F-"};

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Contacts":"Contacts__Contacts___1AJ6n","Title":"Contacts__Title___3LZ5-","Subtitle":"Contacts__Subtitle___21KCu","SiteLink":"Contacts__SiteLink___Of_FO","ButtonsGroup":"Contacts__ButtonsGroup___bh87z","ShowContactsButton":"Contacts__ShowContactsButton___1V7CP","Inner":"Contacts__Inner___1cBcz","Top":"Contacts__Top___oNcc_","Item":"Contacts__Item___2HeCf","Avatar":"Contacts__Avatar___3d8Ov","Column":"Contacts__Column___3iJLc","Name":"Contacts__Name___2wEX9","Label":"Contacts__Label___hLag6","IconContact":"Contacts__IconContact___3Bubc","ContactGroup":"Contacts__ContactGroup___1BBWR","IconGroup":"Contacts__IconGroup___2X7l7","ContactIcon":"Contacts__ContactIcon___2JwdS","Phone":"Contacts__Phone___fhvky","Mail":"Contacts__Mail___2hS90","NotFound":"Contacts__NotFound___3g7sP","NotFoundImage":"Contacts__NotFoundImage___2TCv8","NotFoundText":"Contacts__NotFoundText___1rC2O","TelegramLink":"Contacts__TelegramLink___3JWCE","List":"Contacts__List___3gZS8","Header":"Contacts__Header___XVJwo","ContactsPrint":"Contacts__ContactsPrint___2EVrY","InnerWrap":"Contacts__InnerWrap___2xrIz","Left":"Contacts__Left___2c6rg","Right":"Contacts__Right___2bCvm","OnlyMobile":"Contacts__OnlyMobile___2gXFT","clear":"Contacts__clear___2gbvI","NotMobile":"Contacts__NotMobile___3mMrS"};

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"DescriptionWrap":"Description__DescriptionWrap___3dpHD","DescriptionWrapClient":"Description__DescriptionWrapClient___KS-_2","Description":"Description__Description___1c6Iu","Text":"Description__Text___3iN6F","DescriptionClient":"Description__DescriptionClient___QQZOg","ClientDescriptionTitle":"Description__ClientDescriptionTitle___30qbp","Inner":"Description__Inner___1mBnJ","isHidden":"Description__isHidden___ikyiB","Button":"Description__Button___3QgYF","Opened":"Description__Opened___2LPTB","ButtonClient":"Description__ButtonClient___3r9z9","DescriptionTitle":"Description__DescriptionTitle___2M5Cf","DescriptionWrapPrint":"Description__DescriptionWrapPrint___1svva","UpdatedTime":"Description__UpdatedTime___2bC4g","OnlyMobile":"Description__OnlyMobile___2YDib"};

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Developer":"Developer__Developer___1Y_eZ","Title":"Developer__Title___2m7wU","Inner":"Developer__Inner___1OfoJ","CommissionInner":"Developer__CommissionInner___3tVbS","Row":"Developer__Row___1xLfb","NotFound":"Developer__NotFound___3sd8v","NotFoundImage":"Developer__NotFoundImage___Z7szc","NotFoundText":"Developer__NotFoundText___bPQOH","Label":"Developer__Label___UlKTa","Name":"Developer__Name___1Wac3","Commission":"Developer__Commission___3C1oN","CommissionNote":"Developer__CommissionNote___1Omq1","CommissionTextarea":"Developer__CommissionTextarea___FkoMQ","Site":"Developer__Site___2saXo","DeveloperPrintWrap":"Developer__DeveloperPrintWrap___2Xxi7","DeveloperPrint":"Developer__DeveloperPrint___1Nzbi"};

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Documents":"Documents__Documents___3TxUI","Title":"Documents__Title___2Jf5f","TitleClient":"Documents__TitleClient___gFXsQ","DocumentsList":"Documents__DocumentsList___18eRA","Document":"Documents__Document___8uVSD","DocumentIcon":"Documents__DocumentIcon___wVGIM"};

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FeaturesWrap":"Features__FeaturesWrap___3IG61","FeaturesWrapClient":"Features__FeaturesWrapClient___3ZCEb","Inner":"Features__Inner___3rJWw","CheckBlockWrap":"Features__CheckBlockWrap___1BCNZ","CheckBlock":"Features__CheckBlock___2tIF_","isHidden":"Features__isHidden___W6STE","ButtonMore":"Features__ButtonMore___1MQ-4","Opened":"Features__Opened___2cVxA","CheckBlockClient":"Features__CheckBlockClient___1GRtl","CheckItem":"Features__CheckItem___1SQOB","Image":"Features__Image___QvEm_","Text":"Features__Text___2dfiN","CheckItemInner":"Features__CheckItemInner___17FvL","UpdatedTime":"Features__UpdatedTime___2guBn","FeaturesTitle":"Features__FeaturesTitle___KXJJI","FeaturesWrapPrint":"Features__FeaturesWrapPrint___3Wbq9","OnlyMobile":"Features__OnlyMobile___3Batc"};

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Formalization":"Formalization__Formalization___u5Tfz","Title":"Formalization__Title___7QHL6","TitleClient":"Formalization__TitleClient___2VdW_","InnerClient":"Formalization__InnerClient___2vyg_","Row":"Formalization__Row___3Yuzx","Label":"Formalization__Label___E3cd5","Name":"Formalization__Name___EbLQN","RoomTypes":"Formalization__RoomTypes___2XlZt","FormalizationPrint":"Formalization__FormalizationPrint___Xutj_","Inner":"Formalization__Inner___34iWz","Client":"Formalization__Client___2hrLi"};

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image-gallery-fullscreen-button":"Gallery__image-gallery-fullscreen-button___2FGi5","image-gallery-play-button":"Gallery__image-gallery-play-button___1vMVL","image-gallery-left-nav":"Gallery__image-gallery-left-nav___3ycT2","image-gallery-right-nav":"Gallery__image-gallery-right-nav___2wBRM","image-gallery":"Gallery__image-gallery___1roMQ","fullscreen-modal":"Gallery__fullscreen-modal___qJ8n6","image-gallery-content":"Gallery__image-gallery-content___qB-yU","fullscreen":"Gallery__fullscreen___3e5kJ","image-gallery-slide":"Gallery__image-gallery-slide___2etcu","image-gallery-slide-wrapper":"Gallery__image-gallery-slide-wrapper___11xHB","left":"Gallery__left___VU4mG","right":"Gallery__right___3y71l","image-gallery-rtl":"Gallery__image-gallery-rtl___3ZwUt","active":"Gallery__active___8K0PR","image-gallery-slides":"Gallery__image-gallery-slides___2KnEP","center":"Gallery__center___189Bn","image-gallery-description":"Gallery__image-gallery-description___1BhE8","image-gallery-bullets":"Gallery__image-gallery-bullets___36pXM","image-gallery-bullets-container":"Gallery__image-gallery-bullets-container___1s6go","image-gallery-bullet":"Gallery__image-gallery-bullet___3cf-M","image-gallery-thumbnails-wrapper":"Gallery__image-gallery-thumbnails-wrapper___1L6N6","thumbnails-wrapper-rtl":"Gallery__thumbnails-wrapper-rtl___dsMUs","image-gallery-thumbnails":"Gallery__image-gallery-thumbnails___8a_Eq","image-gallery-thumbnail":"Gallery__image-gallery-thumbnail___2pzOl","image-gallery-thumbnails-container":"Gallery__image-gallery-thumbnails-container___2gPkN","image-gallery-thumbnail-inner":"Gallery__image-gallery-thumbnail-inner___1jajr","image-gallery-thumbnail-label":"Gallery__image-gallery-thumbnail-label___3JV-h","image-gallery-index":"Gallery__image-gallery-index___36XJW","Gallery":"Gallery__Gallery___2QSVV","Inner":"Gallery__Inner___onD6n","Slider":"Gallery__Slider___3gkeS","Image":"Gallery__Image___1psxV","GalleryButtons":"Gallery__GalleryButtons___1CVq3","GalleryButton":"Gallery__GalleryButton___3duHP","SceneButtonWrapper":"Gallery__SceneButtonWrapper___3ozBM","SceneButton":"Gallery__SceneButton___33iq7","PopUpInner":"Gallery__PopUpInner___301ho","Preview":"Gallery__Preview___CAfBM","MiniPreview":"Gallery__MiniPreview___83_GT","MapPreview":"Gallery__MapPreview___1MH0v","MapCover":"Gallery__MapCover___2zjHQ","Div":"Gallery__Div___2naR1","MapIcon":"Gallery__MapIcon___3dUIs"};

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Housing":"Housing__Housing___1AgKS","HousingClient":"Housing__HousingClient___Pdhmk","Title":"Housing__Title___PTOCl","Inner":"Housing__Inner___1tC9-","InnerLeft":"Housing__InnerLeft___19ntU","InnerRight":"Housing__InnerRight___35rk2","Name":"Housing__Name___31vKB","Status":"Housing__Status___LgvW4","StatusFinished":"Housing__StatusFinished___26VKI","Icon":"Housing__Icon___1zy4m","FlatsInfo":"Housing__FlatsInfo___3aDw2","RoomCount":"Housing__RoomCount___1ANPd","Stopped":"Housing__Stopped___2FecT","Prices":"Housing__Prices___16Zh3","PriceInner":"Housing__PriceInner___siCco","StoppedPrice":"Housing__StoppedPrice___3ryY6","BigPrice":"Housing__BigPrice___1J5Bx","SmallPrice":"Housing__SmallPrice___3OZc1","Message":"Housing__Message___3vSyu","ChessLink":"Housing__ChessLink___2TRW3","HousingPrint":"Housing__HousingPrint___-CQqm","TitlePrint":"Housing__TitlePrint___W32hV","InnerPrint":"Housing__InnerPrint___29u29","HousingInfo":"Housing__HousingInfo___37rea","TabletVisible":"Housing__TabletVisible___3C5wv","TabletHidden":"Housing__TabletHidden___2Dwjy","Top":"Housing__Top___1h90x","Bottom":"Housing__Bottom___s3ToC","MobileHidden":"Housing__MobileHidden___1J38q","MobileVisible":"Housing__MobileVisible___2kxkv"};

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Info":"Info__Info___o1nPk","InfoClient":"Info__InfoClient___2ykcn","Inner":"Info__Inner___2S9fH","Header":"Info__Header___pOGDN","Title":"Info__Title___1a9TY","Update":"Info__Update___2xZuf","Column":"Info__Column___ijMXW","StoppedColumn":"Info__StoppedColumn___rVlVY","ColumnWrap":"Info__ColumnWrap___iq0z0","Stopped":"Info__Stopped___26qEm","Count":"Info__Count___4lEns","Name":"Info__Name___33DxX","Message":"Info__Message___riO84"};

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Gallery":"Wireframe__Gallery___3T7y6","Inner":"Wireframe__Inner___YZ55e","Slider":"Wireframe__Slider___syVDI","Preview":"Wireframe__Preview___2wRd4","Image":"Wireframe__Image___2-Kfp","MiniPreview":"Wireframe__MiniPreview___3gAeE","MapPreview":"Wireframe__MapPreview___2TOWX","NavLinks":"Wireframe__NavLinks___36g0N","NavLink":"Wireframe__NavLink____xZV9","Info":"Wireframe__Info___26ecx","Header":"Wireframe__Header___2w0Hj","ObjectNameWrap":"Wireframe__ObjectNameWrap___3LcBr","ObjectName":"Wireframe__ObjectName___3QIo5","ObjectFavoriteBtn":"Wireframe__ObjectFavoriteBtn___6-PsM","ObjectAddress":"Wireframe__ObjectAddress___1N40R","StatusUpdate":"Wireframe__StatusUpdate___1ZlNM","ObjectStatus":"Wireframe__ObjectStatus___32Q_J","ObjectTimeUpdate":"Wireframe__ObjectTimeUpdate___1M5oB","InfoTitle":"Wireframe__InfoTitle___rdUuh","Update":"Wireframe__Update___3kwpV","InfoInner":"Wireframe__InfoInner___2h5_9","MoreInfo":"Wireframe__MoreInfo___27jk7","Column":"Wireframe__Column___3FO1J","Count":"Wireframe__Count___2M7hw","Name":"Wireframe__Name___XHnhU","Lines":"Wireframe__Lines___NqSyn","Line":"Wireframe__Line___3YFFv","DescriptionFeatures":"Wireframe__DescriptionFeatures___1D7Ku","Description":"Wireframe__Description___lfGds","FeaturesWrap":"Wireframe__FeaturesWrap___AIlNd","Features":"Wireframe__Features___3argW","Feature":"Wireframe__Feature___2cPvx","FeatureImg":"Wireframe__FeatureImg___oAukP","FeatureName":"Wireframe__FeatureName___3LYuM","MoreLink":"Wireframe__MoreLink___1Tz5l","About":"Wireframe__About___LDIX4","InfoBlock":"Wireframe__InfoBlock___3ihgY","AboutTitle":"Wireframe__AboutTitle___18Dc5","InfoItem":"Wireframe__InfoItem___3_gS9","Class":"Wireframe__Class___3-BOD","Title":"Wireframe__Title___3GbaW","Material":"Wireframe__Material___zApBD","Type":"Wireframe__Type___ImrIP","Parking":"Wireframe__Parking___20KgK","Territory":"Wireframe__Territory___24I5Q","ToSea":"Wireframe__ToSea___2h05l","Height":"Wireframe__Height___3LYUK","Gas":"Wireframe__Gas___1OG_E","Heating":"Wireframe__Heating___ygM0P","Electricity":"Wireframe__Electricity___2_Bb8","Sewerage":"Wireframe__Sewerage___QqDOj","Water":"Wireframe__Water___36dDR","Housing":"Wireframe__Housing___1g0sp","HousingTitle":"Wireframe__HousingTitle___2jkFQ","HousingInner":"Wireframe__HousingInner___2A9Xd","DesktopHidden":"Wireframe__DesktopHidden___1m_lq","MobileOnly":"Wireframe__MobileOnly___2rDf8","TitleDescrip":"Wireframe__TitleDescrip___3WwHp","MobileHidden":"Wireframe__MobileHidden___2PbM7","RightRow":"Wireframe__RightRow___23BPW","InfoBlockInner":"Wireframe__InfoBlockInner___2OgAf"};

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Loader":"styles__Loader___1Upx4","loader10":"styles__loader10___3rQjD","Logo":"styles__Logo___2XJWp"};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image-gallery-fullscreen-button":"Main__image-gallery-fullscreen-button___2P-E_","image-gallery-play-button":"Main__image-gallery-play-button___36j9b","image-gallery-left-nav":"Main__image-gallery-left-nav___3LDqM","image-gallery-right-nav":"Main__image-gallery-right-nav___1muRq","image-gallery":"Main__image-gallery___3rSZA","fullscreen-modal":"Main__fullscreen-modal___3qyXr","image-gallery-content":"Main__image-gallery-content___1rryu","fullscreen":"Main__fullscreen___3d91Y","image-gallery-slide":"Main__image-gallery-slide___210Qz","image-gallery-slide-wrapper":"Main__image-gallery-slide-wrapper___26ZVH","left":"Main__left___3ddhv","right":"Main__right___IXpNA","image-gallery-rtl":"Main__image-gallery-rtl___2lxUg","active":"Main__active___3pX0g","image-gallery-slides":"Main__image-gallery-slides___1pdXQ","center":"Main__center___1MTOs","image-gallery-description":"Main__image-gallery-description___29DGz","image-gallery-bullets":"Main__image-gallery-bullets___B6Tk1","image-gallery-bullets-container":"Main__image-gallery-bullets-container___fD9AD","image-gallery-bullet":"Main__image-gallery-bullet___3TwrO","image-gallery-thumbnails-wrapper":"Main__image-gallery-thumbnails-wrapper___1tfjV","thumbnails-wrapper-rtl":"Main__thumbnails-wrapper-rtl___1wiZA","image-gallery-thumbnails":"Main__image-gallery-thumbnails___2TXRc","image-gallery-thumbnail":"Main__image-gallery-thumbnail___RHmbR","image-gallery-thumbnails-container":"Main__image-gallery-thumbnails-container___vJY1X","image-gallery-thumbnail-inner":"Main__image-gallery-thumbnail-inner___2MFUD","image-gallery-thumbnail-label":"Main__image-gallery-thumbnail-label___19oa3","image-gallery-index":"Main__image-gallery-index___1QLjo","ObjectPageLoader":"Main__ObjectPageLoader___1s34X","ContainerWrapper":"Main__ContainerWrapper___2KBVy","Container":"Main__Container___3mpvW","Image":"Main__Image___1GM8X","LeftRow":"Main__LeftRow___2Ha1i","RightRow":"Main__RightRow___y27Sq","OnlyMobile":"Main__OnlyMobile___1aF04","Map":"Main__Map___3NJSe","PopUpMap":"Main__PopUpMap___3V6pP","Header":"Main__Header___1Um3W","Title":"Main__Title___dUJ1K","Close":"Main__Close___RW9n8","MapWrapper":"Main__MapWrapper___2RD_O","Count":"Main__Count___39OGt","PopUpGallery":"Main__PopUpGallery___1Wz-M","Left":"Main__Left___Ivz_M","NotLeft":"Main__NotLeft___2WX99","Right":"Main__Right___2IJR0","List":"Main__List___1YG66","Bold":"Main__Bold___1j5wL","PopUpGalleryInner":"Main__PopUpGalleryInner___2J_zl","Slider":"Main__Slider___3ffbI","ListContainer":"Main__ListContainer___3S381","WithAlbums":"Main__WithAlbums___2ylUf","OpenPopup":"Main__OpenPopup___TPtl8","movein":"Main__movein___3reLq","OpenPopupMap":"Main__OpenPopupMap___1xpew","Client":"Main__Client___20ItO","About":"Main__About___3q-d4","FormalizationAndPaymentWrap":"Main__FormalizationAndPaymentWrap___5VrnR","PaymentAndFormalization":"Main__PaymentAndFormalization___2CNlA","Payment":"Main__Payment___UHSV3","Formalization":"Main__Formalization___2GYtq","GalleryHeaderInnerBlur":"Main__GalleryHeaderInnerBlur___3TTW6","GalleryEmptyHeaderInner":"Main__GalleryEmptyHeaderInner___3A8UL","stickyEl":"Main__stickyEl___3rB9x","MapBlockWrap":"Main__MapBlockWrap___3-r9L","MapBlockTitle":"Main__MapBlockTitle___2Gjgm","MapBlock":"Main__MapBlock___1Qa7f","MapCover":"Main__MapCover___1sSSH","Div":"Main__Div___326cu","MapIcon":"Main__MapIcon___2KEgr","LookFlatsBtn":"Main__LookFlatsBtn___o9Sr6","GalleryHeader":"Main__GalleryHeader___3KU0b","GalleryHeaderWithMap":"Main__GalleryHeaderWithMap___3pzDv","GalleryButton":"Main__GalleryButton___m6gvH","GalleryComponent":"Main__GalleryComponent___3Xxyh","BlurredImage":"Main__BlurredImage___HWdow","GalleryHeaderInner":"Main__GalleryHeaderInner___1NwMJ","HeaderMap":"Main__HeaderMap___34KFY","ProgressiveImageBigGallery":"Main__ProgressiveImageBigGallery___1ztD1","DescriptionTitle":"Main__DescriptionTitle___3jav2","UpdatedTime":"Main__UpdatedTime___13CJx","MobileChessColl":"Main__MobileChessColl___a4lPx","Description":"Main__Description___2R5kD","CommentBlock":"Main__CommentBlock___27tnB","CommentAuthor":"Main__CommentAuthor___W5mEp","CommentAuthorName":"Main__CommentAuthorName___24M1m","CommentMain":"Main__CommentMain___3_1zV","CommentText":"Main__CommentText___1LQNc","Arrow":"Main__Arrow___3QZFr","Decor1":"Main__Decor1___2zZm-","Decor2":"Main__Decor2___1vKtT","Decor3":"Main__Decor3___yQzWI","Decor4":"Main__Decor4___3lVJP","Bubble":"Main__Bubble___1a9Cn","TabletMobileVisible":"Main__TabletMobileVisible___dSyaG","PrintLoaderWrap":"Main__PrintLoaderWrap___1jy2R","PrintLoader":"Main__PrintLoader___YADMH","loader10":"Main__loader10___2MuRk","PrintLoaderText":"Main__PrintLoaderText___1NAm7","BuildingPrint":"Main__BuildingPrint___1zTqx","PrintSectionContacts":"Main__PrintSectionContacts___3kfpB","WireframeLeftClient":"Main__WireframeLeftClient___1WtQO","WireframeRightClient":"Main__WireframeRightClient___2xMXh","ContainerWireframe":"Main__ContainerWireframe___2P62G","GalleryWireframe":"Main__GalleryWireframe___25eZg","Status":"Main__Status___2RsJC","StatusBlock":"Main__StatusBlock___3F6Xn","Green":"Main__Green___12f0N","Yellow":"Main__Yellow___3TiHR","PromoLabel":"Main__PromoLabel___HSnhv","ObjectNavBtn":"Main__ObjectNavBtn___28cv7","ObjectNavInner":"Main__ObjectNavInner___1q8Qq","InputWrap":"Main__InputWrap____rOw7","InputPrice":"Main__InputPrice___2QhDP","InputArea":"Main__InputArea___3XRzq","Select":"Main__Select___3fVyb","TabletMobileHidden":"Main__TabletMobileHidden___1tCvk","DescriptionAndFeatures":"Main__DescriptionAndFeatures___2CQGi","RealtorBlock":"Main__RealtorBlock___1_71W","DescriptionAndFeaturesTitle":"Main__DescriptionAndFeaturesTitle___1imBt","NotMobile":"Main__NotMobile___2JMRB","Divider":"Main__Divider___1UFjT","InaccuracyReportWrap":"Main__InaccuracyReportWrap___eD0yc","PrintContainer":"Main__PrintContainer___1W51z","PrintSection":"Main__PrintSection___1OcLW","PrintSectionInfoWrapper":"Main__PrintSectionInfoWrapper___3u4Jg","PrintSectionDesc":"Main__PrintSectionDesc___2XnuQ","PrintSectionInfo":"Main__PrintSectionInfo___O9AtH","LeftRowPrintLeft":"Main__LeftRowPrintLeft___1Eiq-","LeftRowPrintRight":"Main__LeftRowPrintRight___rzcOo","ShowMobile":"Main__ShowMobile___1cvol","HideMobile":"Main__HideMobile___J_p8k","NavWrapper":"Main__NavWrapper___L0w6v"};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ObjectNav":"styles__ObjectNav___2t3bx","ObjectNavInner":"styles__ObjectNavInner___1dLev","ObjectNavBtns":"styles__ObjectNavBtns___1CnWa","ObjectNavBtn":"styles__ObjectNavBtn___18G8I","Active":"styles__Active___tZv_z","UpdatedTime":"styles__UpdatedTime___3aROD","Hide1180":"styles__Hide1180___1tWtc"};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"News":"News__News___1cvNP","Title":"News__Title___sXwM9","TitleClient":"News__TitleClient___2Dhms","NewsList":"News__NewsList___1lTUV","NewsItem":"News__NewsItem___26g6m","NewsItemDate":"News__NewsItemDate___1U50F","NewsItemText":"News__NewsItemText___1T1z3","NewsItemLink":"News__NewsItemLink___OWw-h","AllNews":"News__AllNews___HlR1d","NewsPopupContent":"News__NewsPopupContent___25Hoa","NewsPopupWrap":"News__NewsPopupWrap___2UiBj","popupClose":"News__popupClose___1BIbA","PopupTitle":"News__PopupTitle___2YWsB","PopupNewsList":"News__PopupNewsList___2zmmr","PopupNewsItem":"News__PopupNewsItem___1EU6r","PopupNewsItemDate":"News__PopupNewsItemDate___2el0Y","PopupNewsItemText":"News__PopupNewsItemText___EVik9"};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Payment":"Payment__Payment___7nbE3","Title":"Payment__Title___2J7GQ","TitleClient":"Payment__TitleClient___3avtJ","InnerClient":"Payment__InnerClient___FnYbw","Row":"Payment__Row___1pkFC","Label":"Payment__Label___3Je16","LabelActive":"Payment__LabelActive___-spe-","Subtext":"Payment__Subtext___1Dcw1","Name":"Payment__Name___2hHEo","Image":"Payment__Image___SiqF7","PaymentPrint":"Payment__PaymentPrint___3psaV","Inner":"Payment__Inner___vgjuQ","RowGas":"Payment__RowGas___3q5Pf","Client":"Payment__Client___1dx9r"};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"List":"List__List___3ZUij","Item":"List__Item___OJpTv","ActiveItem":"List__ActiveItem___1nYyr","Name":"List__Name___2XMyR","Image":"List__Image___3PL2T","Text":"List__Text___2A0jh","Label":"List__Label___3ZY3I"};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Popup":"Popup__Popup___Ja7ZC","Content":"Popup__Content___1IrmW","fadein":"Popup__fadein___PlNK4","Header":"Popup__Header___p4TFJ","Bold":"Popup__Bold___2YxJV","Count":"Popup__Count___1Zm8Z","Close":"Popup__Close___2HlWO"};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RightRow":"Wireframe__RightRow___AlbpF","Title":"Wireframe__Title___2m-Lv","Inner":"Wireframe__Inner___3TLBI","InnerBuilder":"Wireframe__InnerBuilder___3N0n5","InnerContacts":"Wireframe__InnerContacts___qRm1K","Row":"Wireframe__Row___3vQ2v","DocumentRow":"Wireframe__DocumentRow___-o2hy","Label":"Wireframe__Label___2Flt2","Name":"Wireframe__Name___2X_CU","ContactsRow":"Wireframe__ContactsRow___1Tpog","Ava":"Wireframe__Ava___3Roqj","Top":"Wireframe__Top___2u4Q0","Bottom":"Wireframe__Bottom___1n2OY","TextLine":"Wireframe__TextLine___2HVGg","RealtorCard":"Wireframe__RealtorCard___1OhOF","Avatar":"Wireframe__Avatar___2o1uk","Position":"Wireframe__Position___2Qlkx","RealtorInfo":"Wireframe__RealtorInfo___3n6c6","RealtorContacts":"Wireframe__RealtorContacts___18BmF","RealtorContact":"Wireframe__RealtorContact___VSnbt","RealtorSocial":"Wireframe__RealtorSocial___JLjWD","RealtorSocialTitle":"Wireframe__RealtorSocialTitle___1ncQl","SocialLinks":"Wireframe__SocialLinks___3HJHU","Buttons":"Wireframe__Buttons___a93Wo","BtnChess":"Wireframe__BtnChess___1cOgI","BtnCollection":"Wireframe__BtnCollection___1OPSj","Section":"Wireframe__Section___29UHB"};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Suggestions__Container___uWGXj","SectionCarousel":"Suggestions__SectionCarousel___2Kz_A","SectionCarouselTitle":"Suggestions__SectionCarouselTitle___3eiXS","Carousel":"Suggestions__Carousel___1OIwY","CarouselArrows":"Suggestions__CarouselArrows___1wodV","CarouselArrow":"Suggestions__CarouselArrow___3XuUI","Prev":"Suggestions__Prev___2yBxt","Next":"Suggestions__Next___Hqm1v","Disabled":"Suggestions__Disabled___1n_FF","Slides":"Suggestions__Slides___2Lt4z","Item":"Suggestions__Item___3b33Z","ObjectCardEmpty":"Suggestions__ObjectCardEmpty___3NKes"};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SuggestionsWireframe":"Wireframe__SuggestionsWireframe___3YfxG","Container":"Wireframe__Container___13pUl","SuggestionsTitle":"Wireframe__SuggestionsTitle___2VGpm","Title":"Wireframe__Title___3me9i","Arrows":"Wireframe__Arrows___3N8cY","SuggestionsCards":"Wireframe__SuggestionsCards___2Dcdy","SuggestionsCard":"Wireframe__SuggestionsCard___2QOng"};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PrintWrap":"Print__PrintWrap___3Vqhn","Pure":"Print__Pure___2U0rc","ButtonPrint":"Print__ButtonPrint___12ixn","PrintPopupContent":"Print__PrintPopupContent___3O95L","popupClose":"Print__popupClose___2WBqc"};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Loader":"PrintDialog__Loader___1LIJx","loader10":"PrintDialog__loader10___2IsVY","PopupContent":"PrintDialog__PopupContent___1Uxy5","PopupHeader":"PrintDialog__PopupHeader___3EEDw","ObjectInfo":"PrintDialog__ObjectInfo___2VqhZ","ObjectInfoImage":"PrintDialog__ObjectInfoImage___3zw2T","ObjectInfoText":"PrintDialog__ObjectInfoText___TpP04","ObjectInfoTitle":"PrintDialog__ObjectInfoTitle___1BNxK","ObjectInfoAddress":"PrintDialog__ObjectInfoAddress___1-YNI","ObjectInfoStatus":"PrintDialog__ObjectInfoStatus___NR52L","Finished":"PrintDialog__Finished___3dzPg","NotFinished":"PrintDialog__NotFinished___1eWHy","PopupFooter":"PrintDialog__PopupFooter___3VWQy","PopupPrintBtn":"PrintDialog__PopupPrintBtn___I8Eb4","PrintPopupContent":"PrintDialog__PrintPopupContent___grX7A","CheckItem":"PrintDialog__CheckItem___xRTu9","ChessCheckInner":"PrintDialog__ChessCheckInner___1_-em","CheckItemInner":"PrintDialog__CheckItemInner___JLDRq"};

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ObjectCard":"BuildingCard__ObjectCard___1F9fK","ObjectCardCollection":"BuildingCard__ObjectCardCollection___2LZ5Q","ObjectCardImage":"BuildingCard__ObjectCardImage___hb9ks","Status":"BuildingCard__Status___1HZkN","ObjectCardDescrip":"BuildingCard__ObjectCardDescrip___3p5sJ","Prices":"BuildingCard__Prices___3eYNg","Stopped":"BuildingCard__Stopped___CHZrp","Gradient":"BuildingCard__Gradient___2m0Lv","FlatsCount":"BuildingCard__FlatsCount___2qo3j","ObjectTitle":"BuildingCard__ObjectTitle___2hxhd","ObjectAddress":"BuildingCard__ObjectAddress___23moN","FlatsPriceAll":"BuildingCard__FlatsPriceAll___2jJsK","FlatsPrice":"BuildingCard__FlatsPrice___3Jv3P","FlatsPriceMeter":"BuildingCard__FlatsPriceMeter___3IwZL","Finished":"BuildingCard__Finished___3h3sJ","AlmostFinished":"BuildingCard__AlmostFinished___QE5nq","InProcess":"BuildingCard__InProcess___1xZ-M","Hover":"BuildingCard__Hover___3TVL9","HoverIcon":"BuildingCard__HoverIcon___2skAr","noMainImage":"BuildingCard__noMainImage___PXG_V","ObjectId":"BuildingCard__ObjectId___3U2cE","Name":"BuildingCard__Name___iZ16L","Location":"BuildingCard__Location___25aWe","ObjectCardFeatures":"BuildingCard__ObjectCardFeatures___OVM71","Tooltip":"BuildingCard__Tooltip___3ptnA","HoverIconDelete":"BuildingCard__HoverIconDelete___2Qk3R","noFloor":"BuildingCard__noFloor___6UIO-"};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"Buildings__Wrapper___3Iz_a","withClient":"Buildings__withClient___10VTN","Objects":"Buildings__Objects___2KSka","ObjectsInner":"Buildings__ObjectsInner___zo-vM","Order":"Buildings__Order___3NLc5","PreOrderText":"Buildings__PreOrderText___1Y4sH","Dropdown":"Buildings__Dropdown___7AUyf","DropdownIcon":"Buildings__DropdownIcon___jryUF","DropdownButton":"Buildings__DropdownButton___61zbX","DropdownText":"Buildings__DropdownText___2_zS0","OrderMenuItem":"Buildings__OrderMenuItem___30b9d","OrderMenuActive":"Buildings__OrderMenuActive___2k0d6","Controls":"Buildings__Controls___1-gvu","OverMap":"Buildings__OverMap___2xUyx","Switcher":"Buildings__Switcher___35KdN","SearchTitle":"Buildings__SearchTitle___6BHun","IsOrderField":"Buildings__IsOrderField___1uSNw","ResetAllFilters":"Buildings__ResetAllFilters___2ZiY8","OpenMapBtn":"Buildings__OpenMapBtn___30gpk","Show1024":"Buildings__Show1024___325Vu","BlacklistDescrip":"Buildings__BlacklistDescrip___1j4ox","OrderButtons":"Buildings__OrderButtons___31uvE","OrderBtn":"Buildings__OrderBtn___D8wL9","Active":"Buildings__Active___3PMjq","SwitcherWrapper":"Buildings__SwitcherWrapper___ZU1nZ","Hide1080":"Buildings__Hide1080___2oDJ5","Hide1024":"Buildings__Hide1024___14oA9"};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FilterLabel":"style__FilterLabel___36h46","blackList":"style__blackList___38tg-","nedvex":"style__nedvex___1K3Vj","new":"style__new___ynhyM","index":"style__index___3Lj5w","index1":"style__index1___1BwyC","index2":"style__index2___1hRcG","index3":"style__index3___2qKPz"};

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"popularLaberl":"Item__popularLaberl___UrpMh","Item":"Item__Item___-X6UB","Appointment":"Item__Appointment___1lAMc","InFavorites":"Item__InFavorites___2-gOR","Hover":"Item__Hover___1_aKh","Area":"Item__Area___Fen_u","ChessLink":"Item__ChessLink___K4o7i","Main":"Item__Main___xw4he","Inner":"Item__Inner___2puFQ","Verified":"Item__Verified___3nbW8","ImageContainer":"Item__ImageContainer___1lHgC","HoverButtons":"Item__HoverButtons___2paZ3","HoverButton":"Item__HoverButton___xSjbk","Active":"Item__Active___LTzDX","SmallImage":"Item__SmallImage___1chFY","BigImage":"Item__BigImage___O7u_t","SmallImageHide":"Item__SmallImageHide___1mSR3","Title":"Item__Title___36YMM","WrapperAddress":"Item__WrapperAddress___1q5df","Address":"Item__Address___wLR6_","IconAddress":"Item__IconAddress___1BEIw","TextAddress":"Item__TextAddress___3rm0H","InfoBlock":"Item__InfoBlock___2vOFS","Block":"Item__Block___1trLO","BlockLabel":"Item__BlockLabel___1ADRG","BlockItems":"Item__BlockItems___3LK04","BlockItem":"Item__BlockItem___2V-TT","LabelWrapper":"Item__LabelWrapper___1e3t-","Label":"Item__Label___1Kqgk","Status":"Item__Status___3O6hs","StatusTitle":"Item__StatusTitle___1WXSr","StatusTitleFinished":"Item__StatusTitleFinished___KYSLt","StatusTitleAlmostFinished":"Item__StatusTitleAlmostFinished___JZBdE","StatusIndicator":"Item__StatusIndicator___3hThd","StatusPending":"Item__StatusPending___3KGu9","Price":"Item__Price___MYnZ4","Appartments":"Item__Appartments___2y5RW","ForYouRequest":"Item__ForYouRequest___KP3dr","PriceBlock":"Item__PriceBlock___2Pw4W","Stoped":"Item__Stoped___1IX6h","StartPrice":"Item__StartPrice___3SmvH","PricePerMeter":"Item__PricePerMeter___1A55e","Stopped":"Item__Stopped___1mMWy","Empty":"Item__Empty___2gMRX","Message":"Item__Message___2t2Qm","PromoLabel":"Item__PromoLabel___39LnC","PromoAds":"Item__PromoAds___mjIz7"};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LoaderWrapper":"List__LoaderWrapper___2cEde","Loader":"List__Loader___2WU4s","loader10":"List__loader10___3YSFp","Container":"List__Container___bzR5B","Order":"List__Order___3clXx","PreOrderText":"List__PreOrderText___2hADl","Dropdown":"List__Dropdown___2NBmb","DropdownText":"List__DropdownText___3fpVV","DropdownIcon":"List__DropdownIcon___f2RJ5","List":"List__List___226EU","ListContainer":"List__ListContainer___3RGIc","GoToTop":"List__GoToTop___zSLAs","WireframeWrap":"List__WireframeWrap___3Rqsg","WireframeControls":"List__WireframeControls___3TZwX","WireframeControlsTitle":"List__WireframeControlsTitle___2VsuO","WireframeControlsSubtitle":"List__WireframeControlsSubtitle___1wi4I","WireframeList":"List__WireframeList___2cG-k","WireframeItem":"List__WireframeItem___Y-JI4","WireframeMain":"List__WireframeMain___sdG-6","WireframeInner":"List__WireframeInner___zKlUe","WireframeImage":"List__WireframeImage___2sDIb","WireframeTitle":"List__WireframeTitle___2fUNI","WireframeWrapperAddress":"List__WireframeWrapperAddress___1M6jk","WireframeAddress":"List__WireframeAddress___3CNF2","WireframeInfoBlock":"List__WireframeInfoBlock___22_1_","WireframeBlock":"List__WireframeBlock___1ALB1","WireframeBlockLabel":"List__WireframeBlockLabel___3UeSi","WireframeBlockItem":"List__WireframeBlockItem___28oXT","WireframeLabelWrapper":"List__WireframeLabelWrapper___2teAH","WireframeLabel":"List__WireframeLabel___2uli_","WireframeStatus":"List__WireframeStatus___dCZt6","WireframeStatusTitle":"List__WireframeStatusTitle___bMcOV","WireframePrice":"List__WireframePrice___3tvFK","WireframeAppartments":"List__WireframeAppartments___3BTbb","WireframePriceBlock":"List__WireframePriceBlock___lzkk5","WireframeStartPrice":"List__WireframeStartPrice___1Fm-k","WireframePricePerMeter":"List__WireframePricePerMeter___1yavB","WireframeArea":"List__WireframeArea___2AvWu"};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Map":"Map__Map___3t5NH","MapInfo":"Map__MapInfo___EXyFo","MapInfoList":"Map__MapInfoList___1adHk","CloseListButton":"Map__CloseListButton___2kiJl"};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"NewsFeedWrap":"News__NewsFeedWrap___1JiHd","NewsFeed":"News__NewsFeed___2Nq2q","ButtonGroup":"News__ButtonGroup___3Sh2D","scrollArea":"News__scrollArea___3cfh2","NewsFeedItem":"News__NewsFeedItem___2lMLQ","NewsFeedTitle":"News__NewsFeedTitle___20ANN","Marked":"News__Marked___1-edO","Nedvex":"News__Nedvex___2qZkk","NewsHeader":"News__NewsHeader___23iyP","ActiveMode":"News__ActiveMode___3g3st","NewsFeedItemDate":"News__NewsFeedItemDate___IAp_Y","NewsHeaderImg":"News__NewsHeaderImg___lD5vR","NewsHeaderRight":"News__NewsHeaderRight___QSgFp","ObjectName":"News__ObjectName___kqVfc","NewsTime":"News__NewsTime___3ziNO","NewsText":"News__NewsText___2n7Q6","ReadMore":"News__ReadMore___26mLL","NewsLink":"News__NewsLink___2qzjW","NewsPopupContent":"News__NewsPopupContent___2lqYC","NewsPopupWrap":"News__NewsPopupWrap___123j_","PopupTitle":"News__PopupTitle___34TQv","PopupTitleImg":"News__PopupTitleImg___1VfHH","PopupTitleNedvexImg":"News__PopupTitleNedvexImg___2yoqL","PopupNewsList":"News__PopupNewsList___1E4s2","PopupNewsItem":"News__PopupNewsItem___tk2-p","PopupNewsItemDate":"News__PopupNewsItemDate___1JLlz","PopupNewsItemText":"News__PopupNewsItemText___1FMTC","NewsPopupClose":"News__NewsPopupClose___2kq_2"};

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"NoBuildings":"NoBuildings__NoBuildings___2kQBL","Rectangle":"NoBuildings__Rectangle___3XHg0","InfoTitle":"NoBuildings__InfoTitle___1cP29","InfoSubTitle":"NoBuildings__InfoSubTitle___2Gniv","Info":"NoBuildings__Info___3dNwB","Button":"NoBuildings__Button___XumWJ","Order":"NoBuildings__Order___3wd3y"};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ClientCollectionLoader":"ClientCollection__ClientCollectionLoader___o6voO","ClientCollectionWrap":"ClientCollection__ClientCollectionWrap___wZMkD","ClientCollection":"ClientCollection__ClientCollection___2SSu3","Container":"ClientCollection__Container___3WVRl","ClientCollectionLeft":"ClientCollection__ClientCollectionLeft___1gV4L","ClientCollectionRight":"ClientCollection__ClientCollectionRight___2Nbpx","ClientCollectionTitle":"ClientCollection__ClientCollectionTitle___1QSlu","SortBy":"ClientCollection__SortBy___1kPiz","OpenMapBtn":"ClientCollection__OpenMapBtn___3qL4T","CollectionListTitle":"ClientCollection__CollectionListTitle___1CJJ1","ClientCollectionList":"ClientCollection__ClientCollectionList___N_0hP","BuildingCard":"ClientCollection__BuildingCard___14n2N","Dropdown":"ClientCollection__Dropdown___V6roB","DropdownIcon":"ClientCollection__DropdownIcon___2gGSa","DropdownButton":"ClientCollection__DropdownButton___34HsO","DropdownText":"ClientCollection__DropdownText___1PZy9","OrderMenu":"ClientCollection__OrderMenu___viFT6","OrderMenuItem":"ClientCollection__OrderMenuItem___2sfSR","OrderMenuActive":"ClientCollection__OrderMenuActive___7HIWc","stickyEl":"ClientCollection__stickyEl___oGP09","RealtorBlock":"ClientCollection__RealtorBlock___3LWui","Map":"ClientCollection__Map___1-VQY"};

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Loader":"styles__Loader___1H3bN","loader10":"styles__loader10___eCK19","Logo":"styles__Logo___2hfY4"};

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___3F4_9","Info":"style__Info___PWS07","InfoTitle":"style__InfoTitle___1WsOZ","InfoSubTitle":"style__InfoSubTitle___1qzSu","Rectangle":"style__Rectangle___3d1AG"};

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ClientMap":"ClientMap__ClientMap___2wcC7"};

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Collection":"Collection__Collection___2DH4X","Container":"Collection__Container___2cCBK","TitleBlock":"Collection__TitleBlock___IPzh-","Title":"Collection__Title___3OlV3","ModalCheckboxes":"Collection__ModalCheckboxes___3OafN","TitleBlockLeft":"Collection__TitleBlockLeft___1Di43","TitleBlockRight":"Collection__TitleBlockRight___3woMP","ObjectsCount":"Collection__ObjectsCount___3uXBz","SendCollectionInputWrap":"Collection__SendCollectionInputWrap___HzyQ-","SendCollectionInput":"Collection__SendCollectionInput___LjM9_","SendCollectionBtn":"Collection__SendCollectionBtn___GStmg","SubtitleBlock":"Collection__SubtitleBlock___1r0w2","ShowInfoCheckbox":"Collection__ShowInfoCheckbox___19sF-","CollectionCheckInner":"Collection__CollectionCheckInner___3Sami","UpdateTime":"Collection__UpdateTime___3NtwF","CollectionItemsContainer":"Collection__CollectionItemsContainer___1rq1j","StatsContainer":"Collection__StatsContainer___2B9nX","StatsSessions":"Collection__StatsSessions___3asgw","StatsCard":"Collection__StatsCard___12fZI","StatsInfoField":"Collection__StatsInfoField___30aGz","StatsInfoFieldTitle":"Collection__StatsInfoFieldTitle___3zCfn","SendCollectionBtnText":"Collection__SendCollectionBtnText___1f_hl","SelectedSession":"Collection__SelectedSession___12IuX","Selected":"Collection__Selected___2Svdz","Arrow":"Collection__Arrow___1oEhr","Options":"Collection__Options___28jId","Scroll":"Collection__Scroll___WKV4s","Option":"Collection__Option___1Schl","CheckIcon":"Collection__CheckIcon___10n0E","ArrowDown":"Collection__ArrowDown___3F9sw","CollectionItems":"Collection__CollectionItems___3nc6w","CollectionActions":"Collection__CollectionActions___1tfLI","ActionsTitle":"Collection__ActionsTitle___2g3rR","Action":"Collection__Action___FJtZR","ActionName":"Collection__ActionName___cUGGq","ActionIcon":"Collection__ActionIcon___3COTg","ActionShare":"Collection__ActionShare___1clXB","ActionShareTitle":"Collection__ActionShareTitle___1KHIG","ActionShareText":"Collection__ActionShareText___vm-C5","ActionDescrip":"Collection__ActionDescrip___BqPBC","ItemWrap":"Collection__ItemWrap___3e1j3","ItemActive":"Collection__ItemActive___1QNLE","ItemCommentButton":"Collection__ItemCommentButton___tohWS","Active":"Collection__Active___3kUNf","Item":"Collection__Item___1wbGu","ItemComment":"Collection__ItemComment___X28rA","ItemDelete":"Collection__ItemDelete___3Mt-v","ItemImage":"Collection__ItemImage___276QJ","ItemTitle":"Collection__ItemTitle___2KtE2","ItemAddress":"Collection__ItemAddress___1c9HW","IconAddress":"Collection__IconAddress___12Dis","ItemStatus":"Collection__ItemStatus___1IzgB","Finished":"Collection__Finished___M2g-k","InProcess":"Collection__InProcess___2SykF","AddCommentButton":"Collection__AddCommentButton___1wObB","CommentInput":"Collection__CommentInput___3ZOwa","InputWrap":"Collection__InputWrap___3AoAn","InputWrapIcon":"Collection__InputWrapIcon___3RMuP","Message":"Collection__Message___2c6_c","Visible":"Collection__Visible___3lj6W","MessageIcon":"Collection__MessageIcon___2WfD3","MessageClose":"Collection__MessageClose___3QGK8","NotFoundBlock":"Collection__NotFoundBlock___22vWW","NotFoundMain":"Collection__NotFoundMain___3GIWl","NotFoundTitle":"Collection__NotFoundTitle___1nxNp","NotFoundText":"Collection__NotFoundText___2kpqe","NotFoundImage":"Collection__NotFoundImage___gmGYs","NotFoundBtn":"Collection__NotFoundBtn___13Jq1","Modal":"Collection__Modal___WV8XO","ModalDescription":"Collection__ModalDescription___1FUFE","ModalNotification":"Collection__ModalNotification___3-csJ","popup":"Collection__popup___1EbQV","popupBG":"Collection__popupBG___2ow-Q","popupClose":"Collection__popupClose___Ttw6X","popupContent":"Collection__popupContent___1KqW5"};

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Collection":"Collection__Collection___1UtgM","TitleBlock":"Collection__TitleBlock___2sr72","Title":"Collection__Title___2ZMKt","TitleBackLink":"Collection__TitleBackLink___3KzL3","UpdateTime":"Collection__UpdateTime___1bLiu","CollectionItems":"Collection__CollectionItems___19SeO","CollectionActions":"Collection__CollectionActions___2JQUj","ActionsTitle":"Collection__ActionsTitle___1cA5m","Action":"Collection__Action___f9oVs","ActionName":"Collection__ActionName___1v8BY","ActionIcon":"Collection__ActionIcon___3YSLq","ActionDescrip":"Collection__ActionDescrip___1wLkZ","ItemWrap":"Collection__ItemWrap___3WmMX","ItemActive":"Collection__ItemActive___16dL0","ItemCommentButton":"Collection__ItemCommentButton___10U_E","Active":"Collection__Active___3D5X6","Item":"Collection__Item___9Aynm","ItemComment":"Collection__ItemComment___3i08a","ItemDelete":"Collection__ItemDelete___2Vxfr","ItemImage":"Collection__ItemImage___37Yth","ItemImageNoImage":"Collection__ItemImageNoImage___1vOsf","ItemTitle":"Collection__ItemTitle___38a_e","ItemAddress":"Collection__ItemAddress___1AKNy","IconAddress":"Collection__IconAddress___2HKFo","ItemStatus":"Collection__ItemStatus___3ou5V","Finished":"Collection__Finished___7XbGc","AlmostFinished":"Collection__AlmostFinished___2rhnv","Arrow":"Collection__Arrow___hV-BP","Stats":"Collection__Stats___2BAZ1","StatsInfoField":"Collection__StatsInfoField___30E0K","StatsInfoFieldTitle":"Collection__StatsInfoFieldTitle___1oCvv","SendCollectionBtnText":"Collection__SendCollectionBtnText___3sHzp","CommentButtons":"Collection__CommentButtons___2tQ8f","CommentButton":"Collection__CommentButton___2u6-e","CommentInput":"Collection__CommentInput___3uDeT","LotTag":"Collection__LotTag___1sdXk","LotsList":"Collection__LotsList___1zmtD","LotsTitle":"Collection__LotsTitle___3N1mx","LotList":"Collection__LotList___3xwn2","LotItem":"Collection__LotItem___2Mipb","LotMainInfo":"Collection__LotMainInfo___31P7J","LotMainTop":"Collection__LotMainTop___2H1Vt","LotArea":"Collection__LotArea___2pWrK","LotNumber":"Collection__LotNumber___2knRB","LotMainBottom":"Collection__LotMainBottom___1txPd","LotMainBottomDot":"Collection__LotMainBottomDot___3n75P","LotRow":"Collection__LotRow___3CE3g","LotPrice":"Collection__LotPrice___2zrcV","LotClicks":"Collection__LotClicks___3tf7C","LotClicksTitle":"Collection__LotClicksTitle___17sPT","LotClicksValue":"Collection__LotClicksValue___1LD9t","LotsLoading":"Collection__LotsLoading___3bbd-","TabletOnly":"Collection__TabletOnly___1PVJx","TabletHidden":"Collection__TabletHidden___2sZln"};

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Collections":"Collections__Collections___1w-Ld","TitleBlock":"Collections__TitleBlock___2XNvy","Title":"Collections__Title___3Sxc7","CollectionsCount":"Collections__CollectionsCount___rF1MT","CollectionsActions":"Collections__CollectionsActions___3CcXQ","CollectionsSearch":"Collections__CollectionsSearch___3-NpB","CollectionsSearchInput":"Collections__CollectionsSearchInput___1TG4o","CollectionsSearchIcon":"Collections__CollectionsSearchIcon___1gzV7","CreateButton":"Collections__CreateButton___2UIQL","Container":"Collections__Container___2xV6L","List":"Collections__List___1Vtjk","CreateCollectionForm":"Collections__CreateCollectionForm___3b4Y8","CreateCollectionInput":"Collections__CreateCollectionInput___GbFLV","NotFoundBlock":"Collections__NotFoundBlock___GzeLL","NotFoundMain":"Collections__NotFoundMain___3-2bn","NotFoundTitle":"Collections__NotFoundTitle___3brLy","NotFoundText":"Collections__NotFoundText___3P6Rl","NotFoundImage":"Collections__NotFoundImage___2DzMd","CreateCollectionBtn":"Collections__CreateCollectionBtn___LOJpJ","Wireframe":"Collections__Wireframe___QJWwu","WireframeLoaderWrap":"Collections__WireframeLoaderWrap___3sJcn","WireframeLoader":"Collections__WireframeLoader___2zCtx","loader10":"Collections__loader10___3LP7R"};

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ListItem":"styles__ListItem___1ERoW","ItemHover":"styles__ItemHover___22eUk","NameEdit":"styles__NameEdit___3qV2b","ItemPhotos":"styles__ItemPhotos___3nTTR","ItemTopHover":"styles__ItemTopHover___1s8YW","HoverText":"styles__HoverText___NDSHK","HoverIcon":"styles__HoverIcon___2CS25","HoverIconDuplicate":"styles__HoverIconDuplicate___2kAme","HoverIconDelete":"styles__HoverIconDelete___1ltd1","Tooltip":"styles__Tooltip___3Vm1M","ItemMain":"styles__ItemMain___3TC7S","ItemName":"styles__ItemName___Q8AeK","ItemDescrip":"styles__ItemDescrip___3a0dv","ItemImage":"styles__ItemImage___3qdHw","ItemImageNoPhoto":"styles__ItemImageNoPhoto___nZ9rZ","Dialog":"styles__Dialog____pckT","Buttons":"styles__Buttons___Or2Wg","DeleteButton":"styles__DeleteButton___1Txea","ButtonCancel":"styles__ButtonCancel___2INoY","MainLink":"styles__MainLink___igWBF","ItemTop":"styles__ItemTop___3dG9S","ItemBottom":"styles__ItemBottom___3gplJ"};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"styles__PopupContent___2jxJ4","PopupTitle":"styles__PopupTitle___VRBIl","PopupBody":"styles__PopupBody___1JE1k","PopupText":"styles__PopupText___2gxfw","CreateCollectionForm":"styles__CreateCollectionForm___3rrk6","CreateCollectionButton":"styles__CreateCollectionButton___2zQVl","CreateCollectionInput":"styles__CreateCollectionInput___1lRyF","NotFoundImage":"styles__NotFoundImage___es5q-"};

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Collections":"styles__Collections___2xNeN","TitleBlock":"styles__TitleBlock___1Rny-","Title":"styles__Title___14e6C","FavoritesCount":"styles__FavoritesCount___O9ka_","CreateButton":"styles__CreateButton___3RM7s","Container":"styles__Container___3_1C8","List":"styles__List___27b7d","PopupContent":"styles__PopupContent___19ift","PopupTitle":"styles__PopupTitle___1hAyD","PopupText":"styles__PopupText___24FZD","CreateCollectionForm":"styles__CreateCollectionForm___12Jm0","CreateCollectionInput":"styles__CreateCollectionInput___3OO1a","CreateCollectionButton":"styles__CreateCollectionButton___2kSeD","popupClose":"styles__popupClose___1-Lpr","BuildingCard":"styles__BuildingCard___3vQRa","NotFoundBlock":"styles__NotFoundBlock___axp3d","NotFoundMain":"styles__NotFoundMain___38JXS","NotFoundTitle":"styles__NotFoundTitle___19SEW","NotFoundText":"styles__NotFoundText___I0dgU","NotFoundImage":"styles__NotFoundImage___2aa0v","Wireframe":"styles__Wireframe___AMS0F","WireframeLoaderWrap":"styles__WireframeLoaderWrap___1DvoA","WireframeLoader":"styles__WireframeLoader___1KEQO","loader10":"styles__loader10___2Mb1o"};

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Gallery":"Gallery__Gallery___22PWI","Client":"Gallery__Client___15n6q","Print":"Gallery__Print___6fzxd","ModalName":"Gallery__ModalName___3kU7Q","Slider":"Gallery__Slider___3_RyQ","SliderArrows":"Gallery__SliderArrows___2QfxQ","SliderArrow":"Gallery__SliderArrow___1COvL","Prev":"Gallery__Prev___GefiE","FloorNumber":"Gallery__FloorNumber___3ZWe-","FloorNumberPrint":"Gallery__FloorNumberPrint___37tSE","PrintHeader":"Gallery__PrintHeader___2ndQk","PrintHeaderLeft":"Gallery__PrintHeaderLeft___19TgW","PrintHeaderObjectName":"Gallery__PrintHeaderObjectName___2s_M1","LogoPrint":"Gallery__LogoPrint___p6iEl","MoveLeft":"Gallery__MoveLeft___2A0_c","MoveRight":"Gallery__MoveRight___1-Mwt","ImageOuter":"Gallery__ImageOuter___1XbfE","ImageInner":"Gallery__ImageInner___AdZc6","ImagePrint":"Gallery__ImagePrint___1esNn","Loader":"Gallery__Loader___1LwIF","loader-scale":"Gallery__loader-scale___1ftJE","ImageZoom":"Gallery__ImageZoom___2n26I","popupGallery":"Gallery__popupGallery___2o2Vz","popupGalleryBg":"Gallery__popupGalleryBg___ytp61","popupGalleryContent":"Gallery__popupGalleryContent___2nZpD","PopUpOuter":"Gallery__PopUpOuter___3t9Ar","PopUpInner":"Gallery__PopUpInner___2G07I","FloorPlanWrapper":"Gallery__FloorPlanWrapper___2J09z","FloorPlanTop":"Gallery__FloorPlanTop___2Kbig","FloorPlanLeft":"Gallery__FloorPlanLeft___2cqK1","FloorPlanRight":"Gallery__FloorPlanRight___La55L","SelectHousing":"Gallery__SelectHousing___d3efD","FilterItem":"Gallery__FilterItem___2rZqU","SelectFloor":"Gallery__SelectFloor___zKX3I","SelectFloorArrow":"Gallery__SelectFloorArrow___d8cSa","Top":"Gallery__Top___1hIFL","Bottom":"Gallery__Bottom___1jG7w","FloorTitle":"Gallery__FloorTitle___2C9RW","Floors":"Gallery__Floors___1cylC","FloorItem":"Gallery__FloorItem___1xAar","Light":"Gallery__Light___39TK-","Active":"Gallery__Active___2VSSM","FloorPlan":"Gallery__FloorPlan___3sLZ_","ZoomButtons":"Gallery__ZoomButtons___1E1Vd","ZoomBtn":"Gallery__ZoomBtn___tG_qM","ZoomIn":"Gallery__ZoomIn___3EGOc","ZoomOut":"Gallery__ZoomOut___2xkIe","ZoomBar":"Gallery__ZoomBar___1J74a","ZoomHandle":"Gallery__ZoomHandle___1jjb0","ImageInfo":"Gallery__ImageInfo___3hzjI","Plan":"Gallery__Plan___3XCdJ","Flat":"Gallery__Flat___38IMi","FilteredFlat":"Gallery__FilteredFlat___2LTsg","SelectedFlat":"Gallery__SelectedFlat___3r7EQ","FlatPopup":"Gallery__FlatPopup___1hFgU","FlatPopupInner":"Gallery__FlatPopupInner___fHsUH","FlatNumber":"Gallery__FlatNumber___221UU","FlatCost":"Gallery__FlatCost___2dtg-","FlatType":"Gallery__FlatType___3A-JV","FlatAreaAndPrice":"Gallery__FlatAreaAndPrice___1WuCi","Reservation":"Gallery__Reservation___AKnYp","Promo":"Gallery__Promo___2j8SX","Locked":"Gallery__Locked___3ZskQ","FlatHover":"Gallery__FlatHover___1Db3H","FlatArea":"Gallery__FlatArea___1D183","LoaderInfo":"Gallery__LoaderInfo___3ZD43","PlaceholderOuter":"Gallery__PlaceholderOuter___3Zo0Q","PlaceholderText":"Gallery__PlaceholderText___3MxdH","ImageWrap":"Gallery__ImageWrap___2ihe_","Zoom":"Gallery__Zoom___1gQ8N","Close":"Gallery__Close___25LEE"};

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"styles__Container___3Dxad"};

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Footer":"style__Footer___3Y-3u","FooterLink":"style__FooterLink___26Q-E","FooterDeveloper":"style__FooterDeveloper___3N-q_"};

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"BuildingTitle":"BuildingTitle__BuildingTitle___2949R","BuildingTitleClient":"BuildingTitle__BuildingTitleClient___OcPsl","Container":"BuildingTitle__Container___29owJ","Inner":"BuildingTitle__Inner___1KaPz","ObjectAddress":"BuildingTitle__ObjectAddress___F-ABg","UpdatedTime":"BuildingTitle__UpdatedTime___1w6yu","Status":"BuildingTitle__Status___373uR","Buttons":"BuildingTitle__Buttons___3hGxW","ChessLinkWrap":"BuildingTitle__ChessLinkWrap___G8M4u","ChessLink":"BuildingTitle__ChessLink___mQAlt","InaccuracyReportButtonWrap":"BuildingTitle__InaccuracyReportButtonWrap___2PVne","InaccuracyReportWrap":"BuildingTitle__InaccuracyReportWrap___2nJBc","CollectionWrap":"BuildingTitle__CollectionWrap___2SUvq","Toolbar":"BuildingTitle__Toolbar___H1LKh","ToolbarOnTop":"BuildingTitle__ToolbarOnTop___3fvMz","ToolbarChess":"BuildingTitle__ToolbarChess___in9B0","Hidden":"BuildingTitle__Hidden___3jD7m","LeftInfo":"BuildingTitle__LeftInfo___3ocbe","Verified":"BuildingTitle__Verified___3MHen","ObjectName":"BuildingTitle__ObjectName___ioWQ-","ObjectAddressShare":"BuildingTitle__ObjectAddressShare___1AUJt","Top":"BuildingTitle__Top___2MfZi","TopClient":"BuildingTitle__TopClient___3nw_J","WireframeTop":"BuildingTitle__WireframeTop___3BRta","ShareButtonWrap":"BuildingTitle__ShareButtonWrap___21FbH","PrintButtonWrap":"BuildingTitle__PrintButtonWrap___10Dlp","StatusClient":"BuildingTitle__StatusClient___2G-x3","Bottom":"BuildingTitle__Bottom___1KpTQ","AddToFavoritesButton":"BuildingTitle__AddToFavoritesButton___12Vuh","Switcher":"BuildingTitle__Switcher___1XFPV","StatusBlock":"BuildingTitle__StatusBlock___3O1Fn","PromoLabel":"BuildingTitle__PromoLabel___23ItI","Green":"BuildingTitle__Green___2kHRm","AlmostFinished":"BuildingTitle__AlmostFinished___v2Vv6","Yellow":"BuildingTitle__Yellow___2e0qO","WireframeBottom":"BuildingTitle__WireframeBottom___2HZ-W","WireframeButtonCollections":"BuildingTitle__WireframeButtonCollections___3amnj","WireframeButtonFavor":"BuildingTitle__WireframeButtonFavor___3geLc","WireframeButtonPrint":"BuildingTitle__WireframeButtonPrint___1ezpp","WireframeButtonChess":"BuildingTitle__WireframeButtonChess___1D28C","Button":"BuildingTitle__Button___Uqsz8","BackButton":"BuildingTitle__BackButton___2GSCv","SwitcherInner":"BuildingTitle__SwitcherInner___1WeUl","Active":"BuildingTitle__Active___21Zky","StatusTime":"BuildingTitle__StatusTime___870Zi","BuildingTitlePrint":"BuildingTitle__BuildingTitlePrint___2Oqrx","UpdatedTimeTextPrint":"BuildingTitle__UpdatedTimeTextPrint___om_18","TopName":"BuildingTitle__TopName___-g6sA","PrintLogo":"BuildingTitle__PrintLogo___13ygF","AddToFavoritesButtonWrap":"BuildingTitle__AddToFavoritesButtonWrap___1SmhM","Hide1120":"BuildingTitle__Hide1120___2UwB9","Hide960":"BuildingTitle__Hide960___tdbQo"};

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"ClientHeader__Header___25r8D","HeaderCollections":"ClientHeader__HeaderCollections___3VUJa","Container":"ClientHeader__Container___12vP0","Search":"ClientHeader__Search___MoYtM","User":"ClientHeader__User___2Rggu","UserCollections":"ClientHeader__UserCollections___2SDCw","UserAvatar":"ClientHeader__UserAvatar___krqmY","UserName":"ClientHeader__UserName___1DWbG","UserPosition":"ClientHeader__UserPosition___8czay","LogoCollections":"ClientHeader__LogoCollections___12C4Z","Contacts":"ClientHeader__Contacts___1Igx1","Decor":"ClientHeader__Decor___2nT0R","ContactsLink":"ClientHeader__ContactsLink____LDvO","ContactsLinkIcon":"ClientHeader__ContactsLinkIcon___1O7Lr","BuildingComment":"ClientHeader__BuildingComment___2kN4-","CloseComment":"ClientHeader__CloseComment___2Z1HW","AgencyBlock":"ClientHeader__AgencyBlock___2aS9l","AgencyAvatar":"ClientHeader__AgencyAvatar___rG4fj","AgencyAvatarImage":"ClientHeader__AgencyAvatarImage___FQm3Q","AgencyName":"ClientHeader__AgencyName___g_1oq","AgencyInfo":"ClientHeader__AgencyInfo___1DVCk","BackToList":"ClientHeader__BackToList___dMbf6","PopupCompanyBg":"ClientHeader__PopupCompanyBg___2RFiG","PopupCompanyContent":"ClientHeader__PopupCompanyContent___W84LF","PopupCompanyClose":"ClientHeader__PopupCompanyClose___2fDJa","Logo":"ClientHeader__Logo___3m-Xg"};

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"CollectionsFooterWrap":"styles__CollectionsFooterWrap___cM-9x","CollectionsFooter":"styles__CollectionsFooter___1r_FC","CollectionsFooterLogo":"styles__CollectionsFooterLogo___1GNfm","CollectionsFooterTitle":"styles__CollectionsFooterTitle___1YNYA","CollectionsFooterText":"styles__CollectionsFooterText___2wapn","CollectionsFooterAgencyName":"styles__CollectionsFooterAgencyName___O7UIO","CollectionsFooterNote":"styles__CollectionsFooterNote___CWLHh","CollectionsFooterItems":"styles__CollectionsFooterItems___2hm_m"};

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"style__Menu___12vxd","Additional":"style__Additional___JQRdN","Title":"style__Title___1RmaY","Checkboxes":"style__Checkboxes___uRnt1","Checkbox":"style__Checkbox___1X8-h","Button":"style__Button___2mYdz","Header":"style__Header___2vbO-","Count":"style__Count___xiH_N","Icon":"style__Icon___2Oqxx","Active":"style__Active___3PxDk","FirstColumn":"style__FirstColumn___EWqkt","SecondColumn":"style__SecondColumn___2f7aU","ThirdColumn":"style__ThirdColumn___3iw5s","ButtonWrap":"style__ButtonWrap___2-fhw"};

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Area__Menu___3e_Cu","MenuChessfilter":"Area__MenuChessfilter___1yi6f","Title":"Area__Title___3-ydg","Inputs":"Area__Inputs___1EuTa","Input":"Area__Input___1wzXv","Dash":"Area__Dash___3aiwR","Button":"Area__Button___2XH38"};

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"BuildingClass__Menu___2COcB","Additional":"BuildingClass__Additional___1jaHt","Title":"BuildingClass__Title___1iW2z","Checkboxes":"BuildingClass__Checkboxes___2gRgV","Checkbox":"BuildingClass__Checkbox___V-v61","Button":"BuildingClass__Button___3AyTs","FirstColumn":"BuildingClass__FirstColumn___1l4cp","SecondColumn":"BuildingClass__SecondColumn___3pKog","ButtonWrap":"BuildingClass__ButtonWrap___3Af9x"};

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Deadline__Menu___MtiVn","Additional":"Deadline__Additional___oKIaD","Title":"Deadline__Title___C5REW","Checkboxes":"Deadline__Checkboxes___1FF0D","Button":"Deadline__Button___SI_ai","Checkbox":"Deadline__Checkbox___1ufUV","FirstColumn":"Deadline__FirstColumn___1QCX6","SecondColumn":"Deadline__SecondColumn___2hm-i","DeadlineSection":"Deadline__DeadlineSection___3mFgH","DeadlineSectionToggle":"Deadline__DeadlineSectionToggle___3C87U","Plus":"Deadline__Plus___Emo4Z","Minus":"Deadline__Minus___duQVF","Active":"Deadline__Active___S8omc","DeadlineSectionHead":"Deadline__DeadlineSectionHead___33iHR","DeadlineSectionBody":"Deadline__DeadlineSectionBody___1bCQi"};

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"style__Menu___2x5zB","Additional":"style__Additional___39WQU","Title":"style__Title___1DygX","Checkboxes":"style__Checkboxes___2mbZM","Checkbox":"style__Checkbox___2FCzd","Button":"style__Button___lV3T3","Header":"style__Header___1Ue7M","Icon":"style__Icon___3k8Dr","Active":"style__Active___2OMcu","FirstColumn":"style__FirstColumn___38yW-","SecondColumn":"style__SecondColumn___2V3id","ThirdColumn":"style__ThirdColumn___GKWrV","ButtonWrap":"style__ButtonWrap___133K7"};

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"FederalLaw__Menu___2XMEM","Additional":"FederalLaw__Additional____FlTk","Title":"FederalLaw__Title___17iAk","Checkboxes":"FederalLaw__Checkboxes___2g3RP","Checkbox":"FederalLaw__Checkbox___1r9_Q","Button":"FederalLaw__Button___2AsXB","FirstColumn":"FederalLaw__FirstColumn___1fWBE","SecondColumn":"FederalLaw__SecondColumn___2_C0f","ThirdColumn":"FederalLaw__ThirdColumn___R1K2F","ButtonWrap":"FederalLaw__ButtonWrap___edyRT"};

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Filters":"Filters__Filters___DDeYM","Filter":"Filters__Filter___2XSAH","Title":"Filters__Title___4OOqz","FilterAdditional":"Filters__FilterAdditional___2hHdw","Active":"Filters__Active___saBnD","FilterDistrict":"Filters__FilterDistrict___e9GTR","FilterPrice":"Filters__FilterPrice___1FaIX","FilterArea":"Filters__FilterArea___3suwD","FilterRegistration":"Filters__FilterRegistration___kg2fP","FilterDeadline":"Filters__FilterDeadline___j3l_g","FilterPayment":"Filters__FilterPayment___3zaAt","District":"Filters__District___2vUtc","Type":"Filters__Type___D0t1v","Button":"Filters__Button___29nXd","Divider":"Filters__Divider___1EaTx","AdditionalFiltersTitle":"Filters__AdditionalFiltersTitle___WzrwL","AdditionalFiltersClose":"Filters__AdditionalFiltersClose___20EVj","AdditionalFiltersBtns":"Filters__AdditionalFiltersBtns___32XR1","BtnCancel":"Filters__BtnCancel___16mTU","BtnApply":"Filters__BtnApply___3zn-4","AdditionalCount":"Filters__AdditionalCount___1mrvZ","AdditionalSea":"Filters__AdditionalSea___ckkoI","AdditionalDecoration":"Filters__AdditionalDecoration___2TrYa","AdditionalType":"Filters__AdditionalType___3b7CI","AdditionalAdvantages":"Filters__AdditionalAdvantages___3S4r8","Show850":"Filters__Show850___ttMFg","Hide850":"Filters__Hide850___3n0fI","Active850":"Filters__Active850___2aLMp","Show1200":"Filters__Show1200___1XADp","Hide1200":"Filters__Hide1200___10lgM","Active1200":"Filters__Active1200___7oQU9","Show1240":"Filters__Show1240___24HiP","Hide1240":"Filters__Hide1240___2vB3w","Active1240":"Filters__Active1240___27_SC","Show1500":"Filters__Show1500___1Pu8c","Show1640":"Filters__Show1640___3Q2eM","Hide1640":"Filters__Hide1640___1iYEL","Hide1500":"Filters__Hide1500___3wL1w","Active1500":"Filters__Active1500___3FDGZ","Show960":"Filters__Show960___Djg4M","Hide960":"Filters__Hide960___1MUml"};

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Interior__Menu___3AO7Z","Additional":"Interior__Additional___3NW-s","Title":"Interior__Title___H0sWf","Checkboxes":"Interior__Checkboxes___2o8_n","Button":"Interior__Button___1i2ID","MenuChessfilter":"Interior__MenuChessfilter___2ZWAR","FirstColumn":"Interior__FirstColumn___3X5MS","SecondColumn":"Interior__SecondColumn___1fkJh","Checkbox":"Interior__Checkbox___2xDsX","FiltersCheckInner":"Interior__FiltersCheckInner___3MqJb"};

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Payment__Menu___2fpjE","Additional":"Payment__Additional___LjbCg","Title":"Payment__Title___21gV1","Checkboxes":"Payment__Checkboxes___iQ_3O","Button":"Payment__Button___3p644","FirstColumn":"Payment__FirstColumn___3vDSX","SecondColumn":"Payment__SecondColumn___VRF_k","Checkbox":"Payment__Checkbox___369pn","ButtonWrap":"Payment__ButtonWrap___cZDDW"};

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Price__Menu___1-CFa","MenuChessfilter":"Price__MenuChessfilter___3irvx","Title":"Price__Title___1bkqO","Inner":"Price__Inner___2PUsY","Inputs":"Price__Inputs___2Ly_2","Input":"Price__Input___1RqHZ","Dash":"Price__Dash___f2Q7c","Switcher":"Price__Switcher___UOqOb","Button":"Price__Button___Ey7UF","Show768":"Price__Show768___T4624","Hide768":"Price__Hide768___r-M-q"};

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Registration__Menu___12zup","Additional":"Registration__Additional___rfbev","Title":"Registration__Title___3yjSq","Checkboxes":"Registration__Checkboxes___oGT-f","Button":"Registration__Button___eFnqN","FirstColumn":"Registration__FirstColumn___1HP8Q","SecondColumn":"Registration__SecondColumn___3DdAq","Checkbox":"Registration__Checkbox___3yrrD"};

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Sea__Menu___CHruG","Additional":"Sea__Additional___27-25","Title":"Sea__Title___1-Q5a","Checkboxes":"Sea__Checkboxes___2bCIE","Checkbox":"Sea__Checkbox___1dOJQ","Button":"Sea__Button___28lzB","Header":"Sea__Header___22uts","Icon":"Sea__Icon___19bNf","Active":"Sea__Active___2Hjd_","FirstColumn":"Sea__FirstColumn___2LE7J","SecondColumn":"Sea__SecondColumn___10yrz","ThirdColumn":"Sea__ThirdColumn___31HNU","ButtonWrap":"Sea__ButtonWrap___1K3lR"};

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Type__Menu___2TV87","Additional":"Type__Additional___22EcR","Title":"Type__Title___3gs4O","Checkboxes":"Type__Checkboxes___1e8zn","Checkbox":"Type__Checkbox___1jTHE","Button":"Type__Button___9uvvx","Header":"Type__Header___UUKwy","Icon":"Type__Icon____X9TT","Active":"Type__Active___2xOFq","FirstColumn":"Type__FirstColumn___2iO8L","SecondColumn":"Type__SecondColumn___1PirA","ThirdColumn":"Type__ThirdColumn___3nA4E","ButtonWrap":"Type__ButtonWrap___23zp-"};

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"style__Menu___20Zqx","Additional":"style__Additional___1ZcHi","Title":"style__Title___3IZSL","Checkboxes":"style__Checkboxes____tEfp","Checkbox":"style__Checkbox___1NhII","Button":"style__Button___105uL","Header":"style__Header___1Cptt","ChessFilterTitle":"style__ChessFilterTitle___3HkeS","Icon":"style__Icon___3tn8j","Active":"style__Active___24c90","CheckboxesInChess":"style__CheckboxesInChess___2Punw","FirstColumn":"style__FirstColumn___gbmpr","SecondColumn":"style__SecondColumn___V9JI8","ThirdColumn":"style__ThirdColumn___XcSJE","ButtonWrap":"style__ButtonWrap___3YMbu"};

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FiltersBar":"FiltersBar__FiltersBar___dfv8A","withClient":"FiltersBar__withClient___2e-Q6"};

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HeaderMainWrap":"Header__HeaderMainWrap___1dwzO","HeaderWrap":"Header__HeaderWrap___whhsl","Header":"Header__Header___1_1R8","HeaderCollections":"Header__HeaderCollections___203aA","Container":"Header__Container___2D_Yi","Logo":"Header__Logo___1xqts","Search":"Header__Search___16bgg","User":"Header__User___3Vd2o","HeaderLinks":"Header__HeaderLinks___39NZT","active":"Header__active___1Z5Aq","UserCollections":"Header__UserCollections___15piI","UserAvatar":"Header__UserAvatar___28Tt7","UserName":"Header__UserName___RfZsY","UserPosition":"Header__UserPosition___319M6","LogoCollections":"Header__LogoCollections___2pY0-","Contacts":"Header__Contacts___1YcRr","Decor":"Header__Decor___1Kpye","ContactsLink":"Header__ContactsLink___1jaDb","ContactsLinkIcon":"Header__ContactsLinkIcon___1Cn4x","LinksUser":"Header__LinksUser___19nNc"};

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Logo":"Logo__Logo___1xovT"};

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Region":"Region__Region___3zQBe","Text":"Region__Text___2ffDj","Icon":"Region__Icon___1eYEW","Dropdown":"Region__Dropdown___2OFEs"};

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"RegionPopup__PopupContent___KQNMT","PopupTitle":"RegionPopup__PopupTitle___3L-zR","PopupBody":"RegionPopup__PopupBody___3arxi","RegionItem":"RegionPopup__RegionItem___CIdYC"};

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SearchItem":"styles__SearchItem___Zt2mT","SubTitle":"styles__SubTitle___AZ0zb","Subregion":"styles__Subregion___1r1WU","Address":"styles__Address___2ZPio","Input":"styles__Input___1r8WC","Menu":"styles__Menu___5RgyM"};

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ContainerOuter":"styles__ContainerOuter___seEWU","ContainerInner":"styles__ContainerInner___2mBQp","Search":"styles__Search___2yY5s","SearchItems":"styles__SearchItems___2MA95","Input":"styles__Input___33lD3","Icon":"styles__Icon___r0UGF","IconMobile":"styles__IconMobile___3R9-9","IconFocus":"styles__IconFocus___ct8v1","Menu":"styles__Menu___2s4mn","MenuHide":"styles__MenuHide___32DdN","Spinner":"styles__Spinner___1nEXh","NewTitle":"styles__NewTitle___mKIRm","OnlyMobile":"styles__OnlyMobile___1xj7A","MobileHidden":"styles__MobileHidden___RRsfP","InputFocus":"styles__InputFocus___5TBK8"};

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"User":"User__User___JuDy7","Avatar":"User__Avatar___1FkwO","WithClient":"User__WithClient___1aqJZ","UserDropdownWrap":"User__UserDropdownWrap___3Fpx7","Dropdown":"User__Dropdown___xzS1W","UserStatus":"User__UserStatus___2EChL","DropdownText":"User__DropdownText___eK_eF"};

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"UserInfo":"UserInfo__UserInfo___6Dk8v","Link":"UserInfo__Link___uNQg5","LinkText":"UserInfo__LinkText___1rit_","LinkImage":"UserInfo__LinkImage___2CUfb","Active":"UserInfo__Active___1gacb","ClientModeSwitcher":"UserInfo__ClientModeSwitcher___24CW_","Marker":"UserInfo__Marker___1gRc-","Enabled":"UserInfo__Enabled___19Qbb","Checkbox":"UserInfo__Checkbox___3HJXw","CheckboxInner":"UserInfo__CheckboxInner___VoHbK","Arrow":"UserInfo__Arrow___3ewZl","TarifBlock":"UserInfo__TarifBlock___1KTiZ","TarifName":"UserInfo__TarifName___1ee0_","TarifTime":"UserInfo__TarifTime___1EEl8","Red":"UserInfo__Red___3hclt"};

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormInvite":"FormInvite__FormInvite___aMoAX","FormError":"FormInvite__FormError___1rXxI","Top":"FormInvite__Top___A-L6q","Bottom":"FormInvite__Bottom___23mn1","Title":"FormInvite__Title___249tj","Left":"FormInvite__Left___2Efzw","Right":"FormInvite__Right___2RRw6","Input":"FormInvite__Input___2v6wX","Button":"FormInvite__Button___1JuOo","Image":"FormInvite__Image___2BUA1"};

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormNotConnected":"FormNotConnected__FormNotConnected___3z_B9","Title":"FormNotConnected__Title___1Eca1","Button":"FormNotConnected__Button___ht8vr","Label":"FormNotConnected__Label___3Apmt","Image":"FormNotConnected__Image___1FrWm"};

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormInner":"FormNumber__FormInner___1BnuJ","Title":"FormNumber__Title___2uy7n","Input":"FormNumber__Input___OcGUS","InputError":"FormNumber__InputError___3HMim","Wrapper":"FormNumber__Wrapper___1A-Ea","Loader":"FormNumber__Loader___3I8V4","loader10":"FormNumber__loader10___1b3ga","SubmitButton":"FormNumber__SubmitButton___2Mvrv","BlueButton":"FormNumber__BlueButton___1E4sc"};

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormPasswordRestore":"FormPasswordRestore__FormPasswordRestore___pbIzE","FormInner":"FormPasswordRestore__FormInner___1mp1b","Logo":"FormPasswordRestore__Logo___IBmov","Title":"FormPasswordRestore__Title___2uj9u","Button":"FormPasswordRestore__Button___1MGbF","ButtonActive":"FormPasswordRestore__ButtonActive___2Xcl8","Label":"FormPasswordRestore__Label___2B47v","Input":"FormPasswordRestore__Input___JVzKY","Blue":"FormPasswordRestore__Blue___1IgSG","LabelErr":"FormPasswordRestore__LabelErr___bTho0","Spinner":"FormPasswordRestore__Spinner___3QeBZ","Footer":"FormPasswordRestore__Footer___20Tvw"};

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Overlay":"FormRegistration__Overlay___TRceN","Modal":"FormRegistration__Modal___3HhDj","CloseButton":"FormRegistration__CloseButton___3VJtJ","Title":"FormRegistration__Title___2PQV4","WorkTypeSpan":"FormRegistration__WorkTypeSpan___1B2vH","Input":"FormRegistration__Input___Rh_Tk","InputError":"FormRegistration__InputError___7_u5p","Wrapper":"FormRegistration__Wrapper___1GWGL","Loader":"FormRegistration__Loader___3L524","loader10":"FormRegistration__loader10___iXJuE","SubmitButton":"FormRegistration__SubmitButton___3eAka","Checkbox":"FormRegistration__Checkbox___3C66b","Politician":"FormRegistration__Politician___2LGM8","RegisterSuccessPopup":"FormRegistration__RegisterSuccessPopup___OWXcH","RegisterSuccessTitle":"FormRegistration__RegisterSuccessTitle___2kc6S","RegisterSuccessSubtitle":"FormRegistration__RegisterSuccessSubtitle___3IDMH","OkBtn":"FormRegistration__OkBtn___1Wq6c"};

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Select":"Select__Select___1cDpZ","Open":"Select__Open___3fR_J","Dropdown":"Select__Dropdown___2WIoc","Input":"Select__Input___2eAM8","Backdrop":"Select__Backdrop___2Oqy7","InputError":"Select__InputError___NJpyZ","List":"Select__List___3HdeT","Item":"Select__Item___3-OuS","selected":"Select__selected___3mv24","ChevronDown":"Select__ChevronDown___PPABm","ChevronUp":"Select__ChevronUp___yMf6s"};

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormInner":"FormSMS__FormInner___14m0I","Title":"FormSMS__Title___39Duf","Description":"FormSMS__Description___26DZx","LabelErr":"FormSMS__LabelErr___1T7Kw","InputWrap":"FormSMS__InputWrap___3JnPU","Input":"FormSMS__Input___VbDLO","Mask":"FormSMS__Mask___RUKcS","InputError":"FormSMS__InputError___2NwoR","AwaitSMS":"FormSMS__AwaitSMS___wBFiq","Blue":"FormSMS__Blue___1Netf","SubmitButton":"FormSMS__SubmitButton___1K5l4","LoaderWrapper":"FormSMS__LoaderWrapper___28jJU","Loader":"FormSMS__Loader___3JnSR","loader10":"FormSMS__loader10___3E5OA"};

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Overlay":"FormTechnicalProblem__Overlay___2SV3v","Modal":"FormTechnicalProblem__Modal___7uhnw","CloseButton":"FormTechnicalProblem__CloseButton___3mIW8"};

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Title":"styles__Title___3hi4-","Close":"styles__Close___3kVXi","Content":"styles__Content___JM1a1","Footer":"styles__Footer___3R8Xc","ModalContent":"styles__ModalContent___DKc-R","fadein":"styles__fadein___3fZbd"};

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"NotificationWrapper":"styles__NotificationWrapper___1VK-Q","LowerNotification":"styles__LowerNotification___MXVqp","Notification":"styles__Notification___3rSMe","Message":"styles__Message___1HmNC","Visible":"styles__Visible___1VE5S","MessageIcon":"styles__MessageIcon___eWqN2","MessageClose":"styles__MessageClose___2hOoX","Cancel":"styles__Cancel___3L5GC"};

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PayResultWrap":"style__PayResultWrap___23hQa","PayResult":"style__PayResult___2rEWI","PayResultIcon":"style__PayResultIcon___1xcAf","PayResultTitle":"style__PayResultTitle___2-Dtr","PayResultText":"style__PayResultText___2Kabn","PayResultButton":"style__PayResultButton___2BcMk"};

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___22Fqc","text":"style__text___3K1Bz","close":"style__close___1jhz6"};

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TarifSolo":"style__TarifSolo___3fJtO","TarifPay":"style__TarifPay___1AOmz","TarifPayHead":"style__TarifPayHead___ZSseD","TarifPaySubtitle":"style__TarifPaySubtitle___3dTBw","Tarifs":"style__Tarifs___2o6vQ","TarifCard":"style__TarifCard___27pIb","selected":"style__selected___253PW","Label":"style__Label___2lrVD","TarifCardTitle":"style__TarifCardTitle___18x7g","TarifCardName":"style__TarifCardName___3eRc6","TarifCardMonths":"style__TarifCardMonths___1USbr","Content":"style__Content___26Lp-","ContentRight":"style__ContentRight___11Jce","Discount":"style__Discount___1U84X","PricePerMonth":"style__PricePerMonth___3yUs0","ContentPrice":"style__ContentPrice___2aYOH","Price":"style__Price___2KT-E","FullPrice":"style__FullPrice___2L87e","TarifImage":"style__TarifImage___1ceRX","TarifName":"style__TarifName___3SfGX","TarifDescrip":"style__TarifDescrip___eg0MT","TarifPrice":"style__TarifPrice___2dDPE","TarifTerm":"style__TarifTerm___1iFCA","TarifBuyBtn":"style__TarifBuyBtn___1T5PM","TarifRequestBtn":"style__TarifRequestBtn___2HBuR","TarifText":"style__TarifText___3h59R","TarifCardFooter":"style__TarifCardFooter___1CKMW","FooterButton":"style__FooterButton___2bgXv"};

/***/ }),
/* 1429 */
1319,
/* 1430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___1EKEr","head":"style__head___31TOF","fields":"style__fields___38k9P","bottom":"style__bottom___4NhlG","basic":"style__basic___2LnbI","informationWrapper":"style__informationWrapper___1fpzG","h":"style__h___1-K9L","information":"style__information___2mJ_b","input":"style__input___2fm1d","inputSpace":"style__inputSpace___25-3-","btn":"style__btn___1DKlq"};

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PayResultWrap":"style__PayResultWrap___33sSx","PayResult":"style__PayResult___2qoS7","PayResultIcon":"style__PayResultIcon___16owh","PayResultTitle":"style__PayResultTitle___bxdUd","PayResultText":"style__PayResultText___sw3N4","PayResultButton":"style__PayResultButton___2vZdS"};

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AppointmentCard":"AppointmentCard__AppointmentCard___12_px","CardStatus":"AppointmentCard__CardStatus___3ISi-","CardContent":"AppointmentCard__CardContent___3SWVj","AppointmentInfo":"AppointmentCard__AppointmentInfo___yQ-la","BuildingName":"AppointmentCard__BuildingName___3OciZ","Data":"AppointmentCard__Data___oxlZw","ShowAppointmentButton":"AppointmentCard__ShowAppointmentButton___257gR"};

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AppointmentInfoDialog":"AppointmentInfoDialog__AppointmentInfoDialog___1uaCs","Header":"AppointmentInfoDialog__Header___1sHaL","Labels":"AppointmentInfoDialog__Labels___2TNuI","StatusLabel":"AppointmentInfoDialog__StatusLabel___2eOMq","assigned":"AppointmentInfoDialog__assigned___3I9CZ","canceled":"AppointmentInfoDialog__canceled___3Qtn2","Title":"AppointmentInfoDialog__Title___2yHPz","ObjectName":"AppointmentInfoDialog__ObjectName___1e5Hx","Subtitle":"AppointmentInfoDialog__Subtitle___1I_tf","Divider":"AppointmentInfoDialog__Divider___iqSGd","Content":"AppointmentInfoDialog__Content___FJ1y3","InfoField":"AppointmentInfoDialog__InfoField___3mJ_E","FieldName":"AppointmentInfoDialog__FieldName___1U6Ow","FieldText":"AppointmentInfoDialog__FieldText___1NMjx"};

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Appointments":"Appointments__Appointments___2WpwE","TabButtons":"Appointments__TabButtons___mFYSv","TabButton":"Appointments__TabButton___jRFyH","Active":"Appointments__Active___yrrle","AppointmentCards":"Appointments__AppointmentCards___2toGg","NoAppointments":"Appointments__NoAppointments___1XCHL","NoAppointmentsTitle":"Appointments__NoAppointmentsTitle___2vhLY","NoAppointmentsDescription":"Appointments__NoAppointmentsDescription___3yHcZ","StatusLabel":"Appointments__StatusLabel___1HdMw","assigned":"Appointments__assigned___1sMAT","canceled":"Appointments__canceled___2kIHt","inProgress":"Appointments__inProgress___H_sHa","completed":"Appointments__completed___1rBXN"};

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Avatar":"Avatar__Avatar___2BH2D","HasImage":"Avatar__HasImage___QlgW8","Img":"Avatar__Img___3uPEJ","Caption":"Avatar__Caption___oYIpr","Icon":"Avatar__Icon___1yqwm","InPopup":"Avatar__InPopup___rKieg"};

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"UploadPhotoPopup":"style__UploadPhotoPopup___2K3LB","UploadPhotoPopupHeader":"style__UploadPhotoPopupHeader___2cn3L","cropContainer":"style__cropContainer___4VfWX","buttons":"style__buttons___20xyb","saveButton":"style__saveButton___20aih"};

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"InformPopup__PopupContent___3W3hB","NoCollections":"InformPopup__NoCollections___2f97b","PopupTitle":"InformPopup__PopupTitle___2orAp","Divider":"InformPopup__Divider___1lVjD","PopupSubtitle":"InformPopup__PopupSubtitle___3gBnv","LeaveAgencyButton":"InformPopup__LeaveAgencyButton___2V5w8","DoneWrap":"InformPopup__DoneWrap___1uNHo","DoneTitle":"InformPopup__DoneTitle___3WWIC","Loader":"InformPopup__Loader___yE_n9","loader10":"InformPopup__loader10___39cna","PopupContentLeft":"InformPopup__PopupContentLeft___U88yQ","PopupCollections":"InformPopup__PopupCollections___R6HHR","PopupActions":"InformPopup__PopupActions___37X7c"};

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopupContent":"LeaveAgencyDialog__PopupContent___1yGB4","NoCollections":"LeaveAgencyDialog__NoCollections___HixJr","PopupTitle":"LeaveAgencyDialog__PopupTitle___vvR1Z","Divider":"LeaveAgencyDialog__Divider___1OPK1","PopupSubtitle":"LeaveAgencyDialog__PopupSubtitle___2fJK1","LeaveAgencyButton":"LeaveAgencyDialog__LeaveAgencyButton___1U-GF","DoneWrap":"LeaveAgencyDialog__DoneWrap___3hOc4","DoneTitle":"LeaveAgencyDialog__DoneTitle___SQTnk","Loader":"LeaveAgencyDialog__Loader___51i8O","loader10":"LeaveAgencyDialog__loader10___3cILW","PopupContentLeft":"LeaveAgencyDialog__PopupContentLeft___n-MDm","PopupCollections":"LeaveAgencyDialog__PopupCollections___2pZEW","PopupActions":"LeaveAgencyDialog__PopupActions___249JJ"};

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"styles__Container___10Px8","TimeSelector":"styles__TimeSelector___1Py1M","TimeSelectorActive":"styles__TimeSelectorActive___6frfh","Taraff":"styles__Taraff___3l4rA","TaraffFirstColumn":"styles__TaraffFirstColumn___Q3O0V","TaraffActive":"styles__TaraffActive___26DCx","TaraffActiveHint":"styles__TaraffActiveHint___JtJ6h","TaraffSecondColumn":"styles__TaraffSecondColumn___bqV6s","ButtonContainer":"styles__ButtonContainer___2u-Rv","Button":"styles__Button___1B94k","rotate":"styles__rotate___1We3P","ButtonBlocked":"styles__ButtonBlocked___1KHmO","ModalBody":"styles__ModalBody___2z0kC","ModalClose":"styles__ModalClose___cbqlo","ModalTitle":"styles__ModalTitle___22M5M","MainModalTitle":"styles__MainModalTitle___2qoyn"};

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RealtorBlock":"styles__RealtorBlock___2e5ua","RealtorInfo":"styles__RealtorInfo___G6nrG","RealtorAvatar":"styles__RealtorAvatar___W7u82","RealtorName":"styles__RealtorName___2ZJjH","RealtorPosition":"styles__RealtorPosition___1o8kw","Position":"styles__Position___i4Usk","AgencyName":"styles__AgencyName___33LXo","AgencyNameNoLink":"styles__AgencyNameNoLink___3ijYD","RealtorDescrip":"styles__RealtorDescrip___2rHuV","RealtorContacts":"styles__RealtorContacts___-5gjV","RealtorContactsIcon":"styles__RealtorContactsIcon___2dlft","Hover":"styles__Hover___38lXM","RealtorSocial":"styles__RealtorSocial___kTc1-","RealtorSocialTitle":"styles__RealtorSocialTitle___3Om8t","RealtorSocialLinks":"styles__RealtorSocialLinks___z62eb","RealtorSocialLink":"styles__RealtorSocialLink___1bhmQ","PopupCompanyBg":"styles__PopupCompanyBg___3dudC","PopupCompanyContent":"styles__PopupCompanyContent___2N2bR","PopupCompanyClose":"styles__PopupCompanyClose___1yDUU"};

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"CompanyDialogWrap":"styles__CompanyDialogWrap___vYovc","MapOpened":"styles__MapOpened___3KKdQ","CompanyDialogHeader":"styles__CompanyDialogHeader___v_kD5","CompanyDialogBody":"styles__CompanyDialogBody___1YYDe","MapTooltip":"styles__MapTooltip___nYlbc","WithoutMap":"styles__WithoutMap___3Zf2X","CompanyDialogMap":"styles__CompanyDialogMap___105ln","CompanyName":"styles__CompanyName___uRRX7","CompanyDescription":"styles__CompanyDescription___10O5f","CompanyLogo":"styles__CompanyLogo___w985b","CompanySocial":"styles__CompanySocial___16Rpd","CompanySocialLink":"styles__CompanySocialLink___334RO","CompanyContacts":"styles__CompanyContacts___3hpra","CompanyContactsInner":"styles__CompanyContactsInner___10B0B","CompanyContactsLeft":"styles__CompanyContactsLeft___3c7q6","Wide":"styles__Wide___2i6AK","CompanyContactsItem":"styles__CompanyContactsItem___1xa9m","CompanyContactsRight":"styles__CompanyContactsRight___24mRv","Label":"styles__Label___1fLFl","Text":"styles__Text___1IFm7","Link":"styles__Link___Ur3vr","CompanyDialogMapButton":"styles__CompanyDialogMapButton___RYKtL","MapHeader":"styles__MapHeader___1XwZ9","MapTooltipTitle":"styles__MapTooltipTitle___2alG8","MapTooltipAddress":"styles__MapTooltipAddress___1-PrW","MapTooltipPhone":"styles__MapTooltipPhone___1lXZA","MapTooltipEmail":"styles__MapTooltipEmail___2QnkA"};

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___zSzMN","blocked":"style__blocked___3Lcno","active":"style__active___1PJei"};

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filtersWrap":"style__filtersWrap___1aR-v","withResults":"style__withResults___2Hw_B"};

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Show1180":"style__Show1180___NDX3z","Hide1180":"style__Hide1180___a_cAs"};

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PrintWrap":"ShareButton__PrintWrap___2ZWp-","Pure":"ShareButton__Pure___3NTSu","ButtonPrint":"ShareButton__ButtonPrint___2C_-B","PrintPopupContent":"ShareButton__PrintPopupContent___2MoCe","popupClose":"ShareButton__popupClose___17jTa"};

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Modal":"ShareDialog__Modal___sCz68","ModalDescription":"ShareDialog__ModalDescription___3d8pc","ModalCheckboxes":"ShareDialog__ModalCheckboxes___tUCMX","SendLink":"ShareDialog__SendLink___KMkIv","ModalNotification":"ShareDialog__ModalNotification___10_LG","SendCollectionInputWrap":"ShareDialog__SendCollectionInputWrap___1_w5B","SendCollectionInput":"ShareDialog__SendCollectionInput___1Mfh1","SendCollectionBtn":"ShareDialog__SendCollectionBtn___LTvyT","SendPdf":"ShareDialog__SendPdf___2mmmL"};

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SupportContainer":"style__SupportContainer___1FyTG","SupportContainerButton":"style__SupportContainerButton___1EwFh","SupportTable":"style__SupportTable___3ovzL","SupportTableArrow":"style__SupportTableArrow___e9RFh","SupportTableTitle":"style__SupportTableTitle___ebUjZ","Border":"style__Border___3lgFs","SupportTableRow":"style__SupportTableRow___3d6lv"};

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TypeFiltersWrap":"style__TypeFiltersWrap___3uctQ","Active":"style__Active___qIqql","TypeFiltersBtn":"style__TypeFiltersBtn___1tZ6f","Nedvex":"style__Nedvex___17Yo4","New":"style__New___31iId","Action":"style__Action___3GTCD","Popular":"style__Popular___2hs9V","Blacklist":"style__Blacklist___pK6aQ","TypeFiltersBtnLeft":"style__TypeFiltersBtnLeft___3UDKN","TypeFiltersBtnRight":"style__TypeFiltersBtnRight___1acGf"};

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"WarningRow":"styles__WarningRow___3uQQ5"};

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Avatar":"Avatar__Avatar___1MwWs","Image":"Avatar__Image___3lxFH"};

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"Button__Button___22Ayz"};

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Checkbox":"Checkbox__Checkbox___3NOtt","Radio":"Checkbox__Radio___2A_Vi","CheckboxClone":"Checkbox__CheckboxClone___fFfDx","CheckboxInner":"Checkbox__CheckboxInner___1F1vd","ExtendedChess":"Checkbox__ExtendedChess___2u8qr","Collection":"Checkbox__Collection___6YvbO","CheckboxCloneFilters":"Checkbox__CheckboxCloneFilters___DL81z","CheckboxClonePrint":"Checkbox__CheckboxClonePrint___3zwDw","Checked":"Checkbox__Checked___2YDD5","Text":"Checkbox__Text___3jy96","PartialChecked":"Checkbox__PartialChecked___1dFtR","Additional":"Checkbox__Additional___dZRxa"};

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Dropdown":"Dropdown__Dropdown___1jUoQ","Subtext":"Dropdown__Subtext___s4mKR","Filter":"Dropdown__Filter___2gl_e","Text":"Dropdown__Text___3ZtIU","Active":"Dropdown__Active___1KDJ8","Icon":"Dropdown__Icon___I5J1z","DropdownChessfilter":"Dropdown__DropdownChessfilter___2FK0m","Text_Container":"Dropdown__Text_Container___1YMLj","Housing":"Dropdown__Housing___MfLZy","Button":"Dropdown__Button___1Wzq0","AdditionalCount":"Dropdown__AdditionalCount___3kkHA","Menu":"Dropdown__Menu___2mZkH","RightShift":"Dropdown__RightShift___39LoX","TopShift":"Dropdown__TopShift___1k9_9","LeftShift":"Dropdown__LeftShift___XnuqL","Fixed":"Dropdown__Fixed___3RB0J","AddFiltersDropdownMenu":"Dropdown__AddFiltersDropdownMenu___3K4h7","RegistrationDropdownMenu":"Dropdown__RegistrationDropdownMenu___vmcnL"};

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Input__Container___IMQ-S"};

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___3IZdN","label":"style__label___3qaE9","message":"style__message___1j-hO","error":"style__error___1mUtA"};

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"Loader__loader___2DLKy","bar":"Loader__bar___12onD"};

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"MapPoint":"MapPoint__MapPoint___1E6tX","disabled":"MapPoint__disabled___1JE8l","active":"MapPoint__active___3fjCm","warningActive":"MapPoint__warningActive___1S4Jk","warningSuccess":"MapPoint__warningSuccess___1gkcv","info":"MapPoint__info___L3R5y","approximate":"MapPoint__approximate___3jh5F"};

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"Menu__Menu___2-lTo","MenuChessfilter":"Menu__MenuChessfilter___3wIuO","scrollArea":"Menu__scrollArea___4REyF","Wrapper":"Menu__Wrapper___18uPO","Arrow":"Menu__Arrow___1kmSu","RightArrow":"Menu__RightArrow___2AF3c","RightArrowInCollection":"Menu__RightArrowInCollection___3jRsQ","AdditionalFilters":"Menu__AdditionalFilters___z8U51","FiltersMenu":"Menu__FiltersMenu___2omZS"};

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ImageContainer":"ProgressiveImage__ImageContainer___3aaT6","ImageContainerShort":"ProgressiveImage__ImageContainerShort___JldEZ","SmallImage":"ProgressiveImage__SmallImage___zz_wQ","BigImage":"ProgressiveImage__BigImage___12KlZ","BigImageShow":"ProgressiveImage__BigImageShow___1vA37"};

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"RadioMenu__Container___2rBKC","Tabs":"RadioMenu__Tabs___hiqgE","Tab":"RadioMenu__Tab___2pLAT","TabActive":"RadioMenu__TabActive___3a-4O","Checkbox":"RadioMenu__Checkbox___7JqEV","Menu":"RadioMenu__Menu___3XQip","Buttons":"RadioMenu__Buttons___BaZYm","Title":"RadioMenu__Title___1OmuD","Checkboxes":"RadioMenu__Checkboxes___3nFrf","FirstColumn":"RadioMenu__FirstColumn___2zu-D","SecondColumn":"RadioMenu__SecondColumn___3fFee","Button":"RadioMenu__Button___15XZB","ButtonReset":"RadioMenu__ButtonReset___J7xw4","FiltersMenu":"RadioMenu__FiltersMenu___R9TG4"};

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"style__root___1fYKd","label":"style__label___2Jycg","message":"style__message___1yI1-","options":"style__options___3MfAc","error":"style__error___3fSfH"};

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Input__Container___3lTg6","Input":"Input__Input___3ptAY","FakeInput":"Input__FakeInput___13w2c"};

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Spinner":"Spinner__Spinner___1pQ49","Blur":"Spinner__Blur___2f7ZN","doubleBounce":"Spinner__doubleBounce___3vxky","doubleBounce1":"Spinner__doubleBounce1___2vtrj","doubleBounce2":"Spinner__doubleBounce2___1c2rU","bounce":"Spinner__bounce___33Jal"};

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"SpinnerImage__Container___2C_h2","Image":"SpinnerImage__Image___2a9Yt","Hidden":"SpinnerImage__Hidden___WQ870","BlurContainer":"SpinnerImage__BlurContainer___16t-j","BluredContainer":"SpinnerImage__BluredContainer___2bGLb"};

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Buttons":"StatelessSwitcher__Buttons___1hTxM","Button":"StatelessSwitcher__Button___3IsuP","Text":"StatelessSwitcher__Text___1dFIz","Round":"StatelessSwitcher__Round___3mi6e","EnabledElement":"StatelessSwitcher__EnabledElement___1VxGm","ChessSwitcher":"StatelessSwitcher__ChessSwitcher___3OrjL"};

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Buttons":"Switcher__Buttons___2XwMx","ButtonsСhessfilter":"Switcher__ButtonsСhessfilter___1ct3F","Button":"Switcher__Button___1D6GF","EnabledElement":"Switcher__EnabledElement___2F3hz","Round":"Switcher__Round___3jEqi"};

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"iconContent":"Point__iconContent___gIWd1","header":"Point__header___bprSR","image":"Point__image___3w69l","headerInfo":"Point__headerInfo___qbDSD","title":"Point__title___3IMb8","subtitle":"Point__subtitle___oRp5r","labels":"Point__labels___3bQn0","promo":"Point__promo___232jO","finished":"Point__finished___23EH5","endDate":"Point__endDate___dkQjs","almostFinished":"Point__almostFinished___Tl63Y","footer":"Point__footer___3_DdN","footerLeft":"Point__footerLeft___39QSx","flats":"Point__flats___Aq-wo","areas":"Point__areas___3te4c","footerRight":"Point__footerRight___27z8r","priceFrom":"Point__priceFrom___3R7CT","pricePerMeter":"Point__pricePerMeter___3mLlR","loader":"Point__loader___2RYy3","rotation":"Point__rotation___xcqUN","iconContentLoading":"Point__iconContentLoading___LH6Ps","objectCount":"Point__objectCount___2aoyW","soldOut":"Point__soldOut____FMKx"};

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"iconContent":"Point__iconContent___26dle","header":"Point__header___3Iteg","image":"Point__image___2bDNk","headerInfo":"Point__headerInfo___21o68","title":"Point__title___3QDiL","subtitle":"Point__subtitle___3Ixun","labels":"Point__labels___336hv","promo":"Point__promo___6KaUt","finished":"Point__finished___jLVID","endDate":"Point__endDate___2tCu7","almostFinished":"Point__almostFinished___o6sKv","footer":"Point__footer___dXwoS","footerLeft":"Point__footerLeft___6aguS","flats":"Point__flats___yOoAK","areas":"Point__areas___xPO6T","footerRight":"Point__footerRight___3nLKw","priceFrom":"Point__priceFrom___xodIm","pricePerMeter":"Point__pricePerMeter___259S3","loader":"Point__loader___1ScF6","rotation":"Point__rotation___DMTg-","iconContentLoading":"Point__iconContentLoading___27QFj","soldOut":"Point__soldOut___36v4U"};

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Sticky":"App__Sticky___tvfax","StickyInner":"App__StickyInner___AEPOl","StickyInnerInner":"App__StickyInnerInner___1PNXM","hasHeader":"App__hasHeader___2d8Kw","Tooltip":"App__Tooltip___3xZ35"};

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"styles__Button___3AOkB","ButtonPrimary":"styles__ButtonPrimary___39Ql_","ButtonSecondary":"styles__ButtonSecondary___3jPko","ButtonStateDisabled":"styles__ButtonStateDisabled___3hHlq","Loader":"styles__Loader___s1H1K","rotate":"styles__rotate___yiE6w"};

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Modal":"styles__Modal___1t_S7","ModalBody":"styles__ModalBody___1WATl","ModalClose":"styles__ModalClose___2VY0g","ModalTitle":"styles__ModalTitle___2Kn9C"};

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TimerContainer":"styles__TimerContainer___2rtrW","Resend":"styles__Resend___2kw8T"};

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Login":"Login__Login___49-_a","Header":"Login__Header___2XI0W","Divider":"Login__Divider___32a37","Logo":"Login__Logo___242Pb","Tariffs":"Login__Tariffs___1S5VT","Telephones":"Login__Telephones___3PNi3","Telephone":"Login__Telephone___2MNGg","IconTelephone":"Login__IconTelephone___3M-nM","Content":"Login__Content___1j7pI","Title":"Login__Title___30JPS","Info":"Login__Info___JyaO0","Left":"Login__Left___3sltR","Description":"Login__Description___2wO0a","ImagesGroup":"Login__ImagesGroup___17fzl","AppButtons":"Login__AppButtons___an8nO","AppStore":"Login__AppStore___CH71Y","GooglePlay":"Login__GooglePlay___2E4Ur","MackBook":"Login__MackBook___1aNL7","Background":"Login__Background___CcJ62","Right":"Login__Right___2KcQ_","About":"Login__About___3NNuv","SubGroup":"Login__SubGroup___29zFC","Item":"Login__Item___1h9wX","Footer":"Login__Footer___BYVz7","SubGroup1":"Login__SubGroup1___2ZaGT","SubGroup2":"Login__SubGroup2___CIPjB","SubGroup3":"Login__SubGroup3___28wIZ","ScrollButton":"Login__ScrollButton___2QiD8","ScrollButtonIcon":"Login__ScrollButtonIcon___1s0R9"};

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"styles__Wrapper___1RyMV","Container":"styles__Container___2poHB","LeftSide":"styles__LeftSide___3FyuD","LeftSideTitle":"styles__LeftSideTitle___3gVEn","LeftSideDescription":"styles__LeftSideDescription___3ALss","LeftSideLaptop":"styles__LeftSideLaptop___1jF8P","LeftSideLaptopImg":"styles__LeftSideLaptopImg___2AQfq","LeftSideStores":"styles__LeftSideStores___NjyVj","RightSide":"styles__RightSide___2iKkD","MobileLogo":"styles__MobileLogo___3_8_Y","RightSideFooter":"styles__RightSideFooter___1jXcG","RightSideFooterLinks":"styles__RightSideFooterLinks___1Pyn6"};

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Politika__Container___dwO2W"};

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopUp":"PopUp__PopUp___1q-IN","Background":"PopUp__Background___1y3lX","BackgroundOverlay":"PopUp__BackgroundOverlay___2-N1P","Content":"PopUp__Content___2P9_S","fadein":"PopUp__fadein___26xvt","Default":"PopUp__Default___zenlk","Close":"PopUp__Close____QuMY","Inverted":"PopUp__Inverted___4Xe2X"};

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"PublicOffer__Container___6gWdD"};

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RateCard":"styles__RateCard___dQsBI","RateCardTitle":"styles__RateCardTitle___3JFw0","RateCardInclude":"styles__RateCardInclude___15KR9","RateCardList":"styles__RateCardList___13Tmz","RateCardPrice":"styles__RateCardPrice___2dmZa","Discount":"styles__Discount___cuqTP","AltPrice":"styles__AltPrice___2IZWv"};

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"styles__Wrapper___1gxn8","Container":"styles__Container___24Hb7","Active":"styles__Active___cRfyJ","List":"styles__List___1byLQ","SelectedItem":"styles__SelectedItem___z8GZX"};

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"styles__Container___3C19V","Selected":"styles__Selected___3DnAm","SelectedBlock":"styles__SelectedBlock___1Ol_d"};

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"WrapperContainer":"styles__WrapperContainer___1e9y2","Container":"styles__Container___3sYp_","Header":"styles__Header___33yW0","Title":"styles__Title___3BVp2","Tariffs":"styles__Tariffs___1EkHZ","Footer":"styles__Footer___HRYml","SubGroup1":"styles__SubGroup1___SBIK9","SubGroup2":"styles__SubGroup2___3OPsD","SubGroup3":"styles__SubGroup3___-em2x","SubGroup":"styles__SubGroup___2PPTU"};

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Soglashenie__Container___2VMAl"};

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/caption.877364a6.svg";

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check-mark.cbfbdf02.svg";

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/checked.b9bc4efe.svg";

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/notChecked.3e32e246.svg";

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/billiards.08565dcf.svg";

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cctv_surveillance.f427b043.svg";

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/children_area.f739a1dd.svg";

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/commercial_property.a2a486f0.svg";

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/concierge.9a6bd3c3.svg";

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/elevator.f8e75120.svg";

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fitness.889f5720.svg";

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fountain.4977af84.svg";

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/garden.6f817f1b.svg";

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/helicopter_landing_area.59238055.svg";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_acs_system.4b01f6d4.svg";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_beach.5ccfa9fa.svg";

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_children_room.a5b7fd4b.svg";

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_conference_hall.ada23f9a.svg";

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_garage.240da197.svg";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_landscape_park.7db67860.svg";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_management_company.3e6da1f4.svg";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_operated_roof.f64af54c.svg";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_panoramic_glazing.7955df39.svg";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_walking_area.6773ed5c.svg";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is_wellness_building.8bf505f7.svg";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kindergarten.87c8c937.svg";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kpp.822a6347.svg";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/landscape_decore.f039a44a.svg";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pool.d987087e.svg";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/recreation_zone.b5c85cc9.svg";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/restaurant.9ee0b034.svg";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sauna.ced815c1.svg";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/spa.8d0965dd.svg";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sport_area.c2a5d603.svg";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tennis_court.c9402731.svg";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-blue.1732bb64.svg";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-dropdown.2f623b58.svg";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-left.33e71fea.svg";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-right-gray.323f33c0.svg";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-right.f9f24497.svg";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/calendar.d5d8c269.svg";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check-green.7c6eaf4f.svg";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check.109ab399.svg";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/close-popup-gallery.ec2a1c09.svg";

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/collection-lot-favorite-active.4f2e8041.svg";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/collection-lot-favorite.f5db95f4.svg";

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/eye-outline.68b2dff7.svg";

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/header-item-building.f1619efa.svg";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/header-item-collections.98241e84.svg";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/header-item-favorites.b5e8d056.svg";

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-arrow.b1a040c8.svg";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-back-white.b1abc3b9.svg";

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-delete.c36af4a8.svg";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-email-black.6648f216.svg";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-email-blue.2048698f.svg";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-error.e1198242.svg";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-feedback.36b7cda7.svg";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-heart-active-red.a452521f.svg";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-heart-white.a6bcdc2c.svg";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-info.b53b9e83.svg";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-link.079d042a.svg";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-list-blue.770d6a0c.svg";

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-no.654fdbdd.svg";

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-pdf.57044fea.svg";

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-pencil.b7a2ca45.svg";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-phone-black.86d31fe4.svg";

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-phone-blue.2ae78f22.svg";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-png.dc624258.svg";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-print.6f739684.svg";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-search-dark.e281c84b.svg";

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-share.54ea8f51.svg";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-success.a3f97caf.svg";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-txt.58b0e70c.svg";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-up.991db586.svg";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/list.2b9a51c7.svg";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/result-error.a5988324.svg";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/result-success.290eec5f.svg";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/telegram-icon.43d3300d.svg";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-action.857a1330.svg";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-popular.463af1fc.svg";

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/user-dropdown-client-mode.534a8dc5.svg";

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/user-dropdown-company-profile.305653c5.svg";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/user-dropdown-exit.fbc17dd8.svg";

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/user-dropdown-profile.e7207182.svg";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/web-page-home.cdf32056.svg";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/whatsapp-icon.fb4190fc.svg";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mark2.a7e411f6.svg";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/loader.ab22e79e.svg";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/app-store.62f62760.svg";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img.201564a1.png";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/laptop.091f0aa0.svg";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.9adf1285.svg";

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mobile-logo.9827f2ea.svg";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/play.280fc343.svg";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/resend.1a674a81.svg";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo-nedvex-char.0d6aa3e3.svg";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.fccf7ec2.svg";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map-preview.1a479368.png";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/map.0f2d42c7.png";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/almostFinished.f2747c59.svg";

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cluster.5f3f1e2c.svg";

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/disabled.1d2d9356.svg";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/success.08a61b4b.svg";

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/warningSuccess.025b47cb.svg";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no_buildings_90px.925d4ee0.png";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no_photo_150px.b154fbe1.png";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no_photo_favourite.7da84c50.png";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no_photo_small.528b194e.png";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/rates-logo.d49d29e1.svg";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tariffs.a923d2c1.svg";

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/house.4bf41d83.svg";

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/total.d1dd5395.svg";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dot.1b2f8179.svg";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-right.38a2b484.svg";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow.ac2d80bb.svg";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/email.97a4ce3a.svg";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/support.e606d02a.svg";

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/telegram.3a3b78dd.svg";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/whatsup.e471c5ab.svg";

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var is = __webpack_require__(1604);
	var delegate = __webpack_require__(1310);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.optionsHeatmap = exports.generateHeatmap = undefined;
	
	var _fp = __webpack_require__(1734);
	
	var _fp2 = _interopRequireDefault(_fp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
	  var positions = _ref.positions;
	  return new instance.visualization.HeatmapLayer({
	    data: _fp2.default.reduce(function (acc, _ref2) {
	      var lat = _ref2.lat,
	          lng = _ref2.lng;
	
	      acc.push({
	        location: new instance.LatLng(lat, lng)
	      });
	      return acc;
	    }, [], positions)
	  });
	};
	
	var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
	  var options = _ref3.options;
	  return _fp2.default.map(function (option) {
	    return instance.set(option, options[option]);
	  }, Object.keys(options || {}));
	};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(539);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _marker_dispatcher = __webpack_require__(1611);
	
	var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);
	
	var _google_map_map = __webpack_require__(1608);
	
	var _google_map_map2 = _interopRequireDefault(_google_map_map);
	
	var _google_map_markers = __webpack_require__(557);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	var _google_map_markers_prerender = __webpack_require__(1609);
	
	var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);
	
	var _google_heatmap = __webpack_require__(1606);
	
	var _google_map_loader = __webpack_require__(1620);
	
	var _google_map_loader2 = _interopRequireDefault(_google_map_loader);
	
	var _detect = __webpack_require__(1613);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	var _geo = __webpack_require__(1615);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _array_helper = __webpack_require__(1612);
	
	var _array_helper2 = _interopRequireDefault(_array_helper);
	
	var _is_plain_object = __webpack_require__(1618);
	
	var _is_plain_object2 = _interopRequireDefault(_is_plain_object);
	
	var _pick = __webpack_require__(1621);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _raf = __webpack_require__(1622);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _log = __webpack_require__(560);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isNumber = __webpack_require__(1617);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _omit = __webpack_require__(561);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _detectElementResize = __webpack_require__(1614);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */
	
	
	var kEPS = 0.00001;
	var K_GOOGLE_TILE_SIZE = 256;
	// real minZoom calculated here _getMinZoom
	var K_IDLE_TIMEOUT = 100;
	var K_IDLE_CLICK_TIMEOUT = 300;
	var DEFAULT_MIN_ZOOM = 3;
	
	function defaultOptions_() /* maps */{
	  return {
	    overviewMapControl: false,
	    streetViewControl: false,
	    rotateControl: true,
	    mapTypeControl: false,
	    // disable poi
	    styles: [{
	      featureType: 'poi',
	      elementType: 'labels',
	      stylers: [{ visibility: 'off' }]
	    }],
	    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
	  };
	}
	
	var latLng2Obj = function latLng2Obj(latLng) {
	  return (0, _is_plain_object2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
	};
	
	var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
	  if (false) {
	    if (zoom < minZoom) {
	      console.warn('GoogleMap: ' + // eslint-disable-line
	      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
	    }
	  }
	
	  if (minZoom < zoom) {
	    return zoom;
	  }
	  return minZoom;
	};
	
	var isFullScreen = function isFullScreen() {
	  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  // eslint-disable-line
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this._getMinZoom = function () {
	      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
	        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
	        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
	        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
	        return Math.ceil((0, _log2.default)(maxTilesPerDim));
	      }
	      return DEFAULT_MIN_ZOOM;
	    };
	
	    _this._computeMinZoom = function (minZoom) {
	      if (minZoom !== undefined && minZoom !== null) {
	        return minZoom;
	      }
	      return _this._getMinZoom();
	    };
	
	    _this._mapDomResizeCallback = function () {
	      _this.resetSizeOnIdle_ = true;
	      if (_this.maps_) {
	        var originalCenter = _this.props.center || _this.props.defaultCenter;
	        var currentCenter = _this.map_.getCenter();
	        _this.maps_.event.trigger(_this.map_, 'resize');
	        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
	      }
	    };
	
	    _this._setLayers = function (layerTypes) {
	      layerTypes.forEach(function (layerType) {
	        _this.layers_[layerType] = new _this.maps_[layerType]();
	        _this.layers_[layerType].setMap(_this.map_);
	      });
	    };
	
	    _this._initMap = function () {
	      // only initialize the map once
	      if (_this.initialized_) {
	        return;
	      }
	      _this.initialized_ = true;
	
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	
	      _this._onBoundsChanged(); // now we can calculate map bounds center etc...
	
	      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);
	
	      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
	        if (!_this.mounted_) {
	          return;
	        }
	
	        var centerLatLng = _this.geoService_.getCenter();
	
	        var propsOptions = {
	          zoom: _this.props.zoom || _this.props.defaultZoom,
	          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
	        };
	
	        // Start Heatmap
	        if (_this.props.heatmap.positions) {
	          Object.assign(_this, {
	            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
	          });
	          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
	        }
	        // End Heatmap
	
	        // prevent to exapose full api
	        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
	        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
	        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
	        // "SymbolPath", "ZoomControlStyle",
	        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
	        // "DistanceMatrixStatus",
	        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
	        // "GeocoderStatus", "KmlLayerStatus",
	        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
	        // "TravelMode", "UnitSystem"
	        var mapPlainObjects = (0, _pick2.default)(maps, _is_plain_object2.default);
	        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
	        var defaultOptions = defaultOptions_(mapPlainObjects);
	
	        var draggableOptions = _this.props.draggable !== undefined && {
	          draggable: _this.props.draggable
	        };
	
	        var minZoom = _this._computeMinZoom(options.minZoom);
	        _this.minZoom_ = minZoom;
	
	        var preMapOptions = _extends({}, defaultOptions, {
	          minZoom: minZoom
	        }, options, propsOptions);
	
	        _this.defaultDraggableOption_ = preMapOptions.draggable !== undefined ? preMapOptions.draggable : _this.defaultDraggableOption_;
	
	        var mapOptions = _extends({}, preMapOptions, draggableOptions);
	
	        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);
	
	        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);
	
	        _this.map_ = map;
	        _this.maps_ = maps;
	
	        _this._setLayers(_this.props.layerTypes);
	
	        // render in overlay
	        var this_ = _this;
	        var overlay = Object.assign(new maps.OverlayView(), {
	          onAdd: function onAdd() {
	            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
	            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';
	
	            var div = document.createElement('div');
	            this.div = div;
	            div.style.backgroundColor = 'transparent';
	            div.style.position = 'absolute';
	            div.style.left = '0px';
	            div.style.top = '0px';
	            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
	            div.style.height = K_MAX_HEIGHT;
	
	            var panes = this.getPanes();
	            panes.overlayMouseTarget.appendChild(div);
	
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this_, _react2.default.createElement(_google_map_markers2.default, {
	              experimental: this_.props.experimental,
	              onChildClick: this_._onChildClick,
	              onChildMouseDown: this_._onChildMouseDown,
	              onChildMouseEnter: this_._onChildMouseEnter,
	              onChildMouseLeave: this_._onChildMouseLeave,
	              geoService: this_.geoService_,
	              projectFromLeftTop: true,
	              distanceToMouse: this_.props.distanceToMouse,
	              getHoverDistance: this_._getHoverDistance,
	              dispatcher: this_.markersDispatcher_
	            }), div,
	            // remove prerendered markers
	            function () {
	              return this_.setState({ overlayCreated: true });
	            });
	          },
	          onRemove: function onRemove() {
	            _reactDom2.default.unmountComponentAtNode(this.div);
	          },
	          draw: function draw() {
	            var div = overlay.div;
	            var overlayProjection = overlay.getProjection();
	            var bounds = map.getBounds();
	            var ne = bounds.getNorthEast();
	            var sw = bounds.getSouthWest();
	            var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	
	            // need round for safari still can't find what need for firefox
	            var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	            this_.updateCounter_++;
	            this_._onBoundsChanged(map, maps, !this_.props.debounced);
	
	            if (!this_.googleApiLoadedCalled_) {
	              this_._onGoogleApiLoaded({ map: map, maps: maps });
	              this_.googleApiLoadedCalled_ = true;
	            }
	
	            div.style.left = ptxRounded.x + 'px';
	            div.style.top = ptxRounded.y + 'px';
	            if (this_.markersDispatcher_) {
	              this_.markersDispatcher_.emit('kON_CHANGE');
	            }
	          }
	        });
	
	        _this.overlay_ = overlay;
	
	        overlay.setMap(map);
	        if (_this.props.heatmap.positions) {
	          _this.heatmap.setMap(map);
	        }
	
	        maps.event.addListener(map, 'zoom_changed', function () {
	          // recalc position at zoom start
	          if (this_.geoService_.getZoom() !== map.getZoom()) {
	            if (!this_.zoomAnimationInProgress_) {
	              this_.zoomAnimationInProgress_ = true;
	              this_._onZoomAnimationStart();
	            }
	
	            var TIMEOUT_ZOOM = 300;
	
	            if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
	              // there is strange Google Map Api behavior in chrome when zoom animation of map
	              // is started only on second raf call, if was click on zoom control
	              // or +- keys pressed, so i wait for two rafs before change state
	
	              // this does not fully prevent animation jump
	              // but reduce it's occurence probability
	              (0, _raf2.default)(function () {
	                return (0, _raf2.default)(function () {
	                  this_.updateCounter_++;
	                  this_._onBoundsChanged(map, maps);
	                });
	              });
	            } else {
	              this_.updateCounter_++;
	              this_._onBoundsChanged(map, maps);
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'idle', function () {
	          if (_this.resetSizeOnIdle_) {
	            _this._setViewSize();
	            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);
	
	            if (currMinZoom !== _this.minZoom_) {
	              _this.minZoom_ = currMinZoom;
	              map.setOptions({ minZoom: currMinZoom });
	            }
	
	            _this.resetSizeOnIdle_ = false;
	          }
	
	          if (this_.zoomAnimationInProgress_) {
	            this_.zoomAnimationInProgress_ = false;
	            this_._onZoomAnimationEnd();
	          }
	
	          this_.updateCounter_++;
	          this_._onBoundsChanged(map, maps);
	
	          if (_this.mouse_) {
	            var latLng = _this.geoService_.unproject(_this.mouse_, true);
	            _this.mouse_.lat = latLng.lat;
	            _this.mouse_.lng = latLng.lng;
	          }
	
	          _this._onChildMouseMove();
	
	          this_.dragTime_ = 0;
	
	          var div = overlay.div;
	          var overlayProjection = overlay.getProjection();
	          if (div && overlayProjection) {
	            var bounds = map.getBounds();
	            var ne = bounds.getNorthEast();
	            var sw = bounds.getSouthWest();
	            var ptx = overlayProjection.fromLatLngToDivPixel(new maps.LatLng(ne.lat(), sw.lng()));
	            // need round for safari still can't find what need for firefox
	            var ptxRounded = (0, _detect2.default)().isSafari ? { x: Math.round(ptx.x), y: Math.round(ptx.y) } : { x: ptx.x, y: ptx.y };
	
	            div.style.left = ptxRounded.x + 'px';
	            div.style.top = ptxRounded.y + 'px';
	          }
	
	          if (this_.markersDispatcher_) {
	            this_.markersDispatcher_.emit('kON_CHANGE');
	            if (this_.fireMouseEventOnIdle_) {
	              this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'mouseover', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = true;
	        });
	
	        // an alternative way to know the mouse is back within the map
	        // This would not fire when clicking/interacting with google maps
	        // own on-map countrols+markers. This handles an edge case for touch devices
	        // + 'draggable:false' custom option. See #332 for more details.
	        maps.event.addListener(map, 'click', function () {
	          this_.mouseInMap_ = true;
	        });
	
	        maps.event.addListener(map, 'mouseout', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = false;
	          this_.mouse_ = null;
	          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        });
	
	        maps.event.addListener(map, 'drag', function () {
	          this_.dragTime_ = new Date().getTime();
	          this_._onDrag();
	        });
	        // user choosing satellite vs roads, etc
	        maps.event.addListener(map, 'maptypeid_changed', function () {
	          this_._onMapTypeIdChange(map.getMapTypeId());
	        });
	      }).catch(function (e) {
	        // notify callback of load failure
	        _this._onGoogleApiLoaded({ map: null, maps: null });
	        console.error(e); // eslint-disable-line no-console
	        throw e;
	      });
	    };
	
	    _this._onGoogleApiLoaded = function () {
	      if (_this.props.onGoogleApiLoaded) {
	        var _this$props;
	
	        if (false) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
	        }
	
	        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
	      }
	    };
	
	    _this._getHoverDistance = function () {
	      return _this.props.hoverDistance;
	    };
	
	    _this._onDrag = function () {
	      var _this$props2;
	
	      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
	    };
	
	    _this._onMapTypeIdChange = function () {
	      var _this$props3;
	
	      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
	    };
	
	    _this._onZoomAnimationStart = function () {
	      var _this$props4;
	
	      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
	    };
	
	    _this._onZoomAnimationEnd = function () {
	      var _this$props5;
	
	      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        var _this$props6;
	
	        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseDown = function (hoverKey, childProps) {
	      _this.childMouseDownArgs_ = [hoverKey, childProps];
	      if (_this.props.onChildMouseDown) {
	        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
	      }
	    };
	
	    _this._onChildMouseUp = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseUp) {
	          var _this$props7;
	
	          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
	        }
	        _this.childMouseDownArgs_ = null;
	        _this.childMouseUpTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onChildMouseMove = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseMove) {
	          var _this$props8;
	
	          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function () {
	      if (_this.props.onChildMouseEnter) {
	        var _this$props9;
	
	        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (_this.props.onChildMouseLeave) {
	        var _this$props10;
	
	        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
	      }
	      return undefined;
	    };
	
	    _this._setViewSize = function () {
	      if (!_this.mounted_) return;
	      if (isFullScreen()) {
	        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
	      } else {
	        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
	        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
	      }
	      _this._onBoundsChanged();
	    };
	
	    _this._onWindowResize = function () {
	      _this.resetSizeOnIdle_ = true;
	    };
	
	    _this._onMapMouseMove = function (e) {
	      if (!_this.mouseInMap_) return;
	
	      var currTime = new Date().getTime();
	      var K_RECALC_CLIENT_RECT_MS = 50;
	
	      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
	        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
	      }
	      _this.mouseMoveTime_ = currTime;
	
	      var mousePosX = e.clientX - _this.boundingRect_.left;
	      var mousePosY = e.clientY - _this.boundingRect_.top;
	
	      if (!_this.mouse_) {
	        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
	      }
	
	      _this.mouse_.x = mousePosX;
	      _this.mouse_.y = mousePosY;
	
	      var latLng = _this.geoService_.unproject(_this.mouse_, true);
	      _this.mouse_.lat = latLng.lat;
	      _this.mouse_.lng = latLng.lng;
	
	      _this._onChildMouseMove();
	
	      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
	        _this.fireMouseEventOnIdle_ = true;
	      } else {
	        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        _this.fireMouseEventOnIdle_ = false;
	      }
	    };
	
	    _this._onClick = function () {
	      var _this$props11;
	
	      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
	    };
	
	    _this._onMapClick = function (event) {
	      if (_this.markersDispatcher_) {
	        // support touch events and recalculate mouse position on click
	        _this._onMapMouseMove(event);
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          if (_this.mouse_) {
	            _this._onClick(_extends({}, _this.mouse_, {
	              event: event
	            }));
	          }
	
	          _this.markersDispatcher_.emit('kON_CLICK', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownNative = function (event) {
	      if (!_this.mouseInMap_) return;
	
	      _this._onMapMouseDown(event);
	    };
	
	    _this._onMapMouseDown = function (event) {
	      if (_this.markersDispatcher_) {
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          // Hovered marker detected at mouse move could be deleted at mouse down time
	          // so it will be good to force hovered marker recalculation
	          _this._onMapMouseMove(event);
	          _this.markersDispatcher_.emit('kON_MDOWN', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        // to fix strange zoom in chrome
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onKeyDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._isCenterDefined = function (center) {
	      return center && ((0, _is_plain_object2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
	    };
	
	    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
	      if (map) {
	        var gmC = map.getCenter();
	        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
	      }
	
	      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
	        var zoom = _this.geoService_.getZoom();
	        var bounds = _this.geoService_.getBounds();
	        var centerLatLng = _this.geoService_.getCenter();
	
	        if (!(0, _array_helper2.default)(bounds, _this.prevBounds_, kEPS)) {
	          if (callExtBoundsChange !== false) {
	            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
	            if (_this.props.onBoundsChange) {
	              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
	            }
	
	            if (_this.props.onChange) {
	              _this.props.onChange({
	                center: _extends({}, centerLatLng),
	                zoom: zoom,
	                bounds: {
	                  nw: {
	                    lat: bounds[0],
	                    lng: bounds[1]
	                  },
	                  se: {
	                    lat: bounds[2],
	                    lng: bounds[3]
	                  },
	                  sw: {
	                    lat: bounds[4],
	                    lng: bounds[5]
	                  },
	                  ne: {
	                    lat: bounds[6],
	                    lng: bounds[7]
	                  }
	                },
	                marginBounds: {
	                  nw: {
	                    lat: marginBounds[0],
	                    lng: marginBounds[1]
	                  },
	                  se: {
	                    lat: marginBounds[2],
	                    lng: marginBounds[3]
	                  },
	                  sw: {
	                    lat: marginBounds[4],
	                    lng: marginBounds[5]
	                  },
	                  ne: {
	                    lat: marginBounds[6],
	                    lng: marginBounds[7]
	                  }
	                },
	
	                size: _this.geoService_.hasSize() ? {
	                  width: _this.geoService_.getWidth(),
	                  height: _this.geoService_.getHeight()
	                } : {
	                  width: 0,
	                  height: 0
	                }
	              });
	            }
	
	            _this.prevBounds_ = bounds;
	          }
	        }
	      }
	    };
	
	    _this._registerChild = function (ref) {
	      _this.googleMapDom_ = ref;
	    };
	
	    _this.mounted_ = false;
	    _this.initialized_ = false;
	    _this.googleApiLoadedCalled_ = false;
	
	    _this.map_ = null;
	    _this.maps_ = null;
	    _this.prevBounds_ = null;
	    _this.heatmap = null;
	
	    _this.layers_ = {};
	
	    _this.mouse_ = null;
	    _this.mouseMoveTime_ = 0;
	    _this.boundingRect_ = null;
	    _this.mouseInMap_ = true;
	
	    _this.dragTime_ = 0;
	    _this.fireMouseEventOnIdle_ = false;
	    _this.updateCounter_ = 0;
	
	    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
	    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
	    _this.centerIsObject_ = (0, _is_plain_object2.default)(_this.props.center);
	
	    _this.minZoom_ = DEFAULT_MIN_ZOOM;
	    _this.defaultDraggableOption_ = true;
	
	    _this.zoomControlClickTime_ = 0;
	
	    _this.childMouseDownArgs_ = null;
	    _this.childMouseUpTime_ = 0;
	
	    _this.googleMapDom_ = null;
	
	    if (false) {
	      if (_this.props.apiKey) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
	      }
	
	      if (_this.props.onBoundsChange) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
	      }
	
	      if (_this.props.center === undefined && _this.props.defaultCenter === undefined) {
	        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
	        );
	      }
	
	      if (_this.props.zoom === undefined && _this.props.defaultZoom === undefined) {
	        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
	        );
	      }
	    }
	
	    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	    }
	
	    _this.zoomAnimationInProgress_ = false;
	
	    _this.state = {
	      overlayCreated: false
	    };
	    return _this;
	  }
	
	  GoogleMap.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.mounted_ = true;
	    window.addEventListener('resize', this._onWindowResize);
	    window.addEventListener('keydown', this._onKeyDownCapture, true);
	    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	    // gmap can't prevent map drag if mousedown event already occured
	    // the only workaround I find is prevent mousedown native browser event
	    _reactDom2.default.findDOMNode(this.googleMapDom_).addEventListener('mousedown', this._onMapMouseDownNative, true);
	
	    window.addEventListener('mouseup', this._onChildMouseUp, false);
	
	    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);
	
	    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly
	
	    setTimeout(function () {
	      // to detect size
	      _this2._setViewSize();
	      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
	        _this2._initMap();
	      }
	    }, 0, this);
	    if (this.props.resetBoundsOnResize) {
	      var that = this;
	      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
	    }
	  };
	
	  GoogleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    if (false) {
	      if (this.props.defaultCenter !== nextProps.defaultCenter) {
	        console.warn('GoogleMap: defaultCenter prop changed. ' + // eslint-disable-line
	        "You can't change default props.");
	      }
	
	      if (this.props.defaultZoom !== nextProps.defaultZoom) {
	        console.warn('GoogleMap: defaultZoom prop changed. ' + // eslint-disable-line
	        "You can't change default props.");
	      }
	    }
	
	    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
	      setTimeout(function () {
	        return _this3._initMap();
	      }, 0);
	    }
	
	    if (this.map_) {
	      var centerLatLng = this.geoService_.getCenter();
	      if (this._isCenterDefined(nextProps.center)) {
	        var nextPropsCenter = latLng2Obj(nextProps.center);
	        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;
	
	        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
	          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
	            this.map_.panTo({
	              lat: nextPropsCenter.lat,
	              lng: nextPropsCenter.lng
	            });
	          }
	        }
	      }
	
	      if (nextProps.zoom !== undefined) {
	        // if zoom chaged by user
	        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
	          this.map_.setZoom(nextProps.zoom);
	        }
	      }
	
	      if (this.props.draggable !== undefined && nextProps.draggable === undefined) {
	        // reset to default
	        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
	      } else if (this.props.draggable !== nextProps.draggable) {
	        // also prevent this on window 'mousedown' event to prevent map move
	        this.map_.setOptions({ draggable: nextProps.draggable });
	      }
	
	      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
	      if (nextProps.options !== undefined && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
	        var mapPlainObjects = (0, _pick2.default)(this.maps_, _is_plain_object2.default);
	        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
	        // remove zoom, center and draggable options as these are managed by google-maps-react
	        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);
	
	        if ('minZoom' in options) {
	          var minZoom = this._computeMinZoom(options.minZoom);
	          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
	        }
	
	        this.map_.setOptions(options);
	      }
	
	      if (nextProps.layerTypes !== this.props.layerTypes) {
	        Object.keys(this.layers_).forEach(function (layerKey) {
	          _this3.layers_[layerKey].setMap(null);
	          delete _this3.layers_[layerKey];
	        });
	        this._setLayers(nextProps.layerTypes);
	      }
	    }
	  };
	
	  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // draggable does not affect inner components
	    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
	  };
	
	  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    this.markersDispatcher_.emit('kON_CHANGE');
	
	    if (this.props.hoverDistance !== prevProps.hoverDistance) {
	      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	    }
	  };
	
	  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.mounted_ = false;
	    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	    window.removeEventListener('resize', this._onWindowResize);
	    window.removeEventListener('keydown', this._onKeyDownCapture);
	    mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
	    window.removeEventListener('mouseup', this._onChildMouseUp, false);
	    if (this.props.resetBoundsOnResize) {
	      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
	    }
	
	    if (this.overlay_) {
	      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
	      this.overlay_.setMap(null);
	    }
	
	    if (this.maps_ && this.map_) {
	      // fix google, as otherwise listeners works even without map
	      this.map_.setOptions({ scrollwheel: false });
	      this.maps_.event.clearInstanceListeners(this.map_);
	    }
	
	    this.map_ = null;
	    this.maps_ = null;
	    this.markersDispatcher_.dispose();
	
	    this.resetSizeOnIdle_ = false;
	
	    delete this.map_;
	    delete this.markersDispatcher_;
	  };
	  // calc minZoom if map size available
	  // it's better to not set minZoom less than this calculation gives
	  // otherwise there is no homeomorphism between screen coordinates and map
	  // (one map coordinate can have different screen coordinates)
	
	
	  // this method works only if this.props.onChildMouseDown was called
	
	
	  // this method works only if this.props.onChildMouseDown was called
	
	
	  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough
	
	
	  // gmap can't prevent map drag if mousedown event already occured
	  // the only workaround I find is prevent mousedown native browser event
	
	
	  GoogleMap.prototype.render = function render() {
	    var mapMarkerPrerender = !this.state.overlayCreated ? _react2.default.createElement(_google_map_markers_prerender2.default, {
	      experimental: this.props.experimental,
	      onChildClick: this._onChildClick,
	      onChildMouseDown: this._onChildMouseDown,
	      onChildMouseEnter: this._onChildMouseEnter,
	      onChildMouseLeave: this._onChildMouseLeave,
	      geoService: this.geoService_,
	      projectFromLeftTop: false,
	      distanceToMouse: this.props.distanceToMouse,
	      getHoverDistance: this._getHoverDistance,
	      dispatcher: this.markersDispatcher_
	    }) : null;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: this.props.style,
	        onMouseMove: this._onMapMouseMove,
	        onMouseDownCapture: this._onMapMouseDownCapture,
	        onClick: this._onMapClick
	      },
	      _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
	      mapMarkerPrerender
	    );
	  };
	
	  return GoogleMap;
	}(_react.Component);
	
	GoogleMap.propTypes = {
	  apiKey: _propTypes2.default.string,
	  bootstrapURLKeys: _propTypes2.default.any,
	
	  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  defaultZoom: _propTypes2.default.number,
	  zoom: _propTypes2.default.number,
	  onBoundsChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseUp: _propTypes2.default.func,
	  onChildMouseMove: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onZoomAnimationStart: _propTypes2.default.func,
	  onZoomAnimationEnd: _propTypes2.default.func,
	  onDrag: _propTypes2.default.func,
	  onMapTypeIdChange: _propTypes2.default.func,
	  options: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  hoverDistance: _propTypes2.default.number,
	  debounced: _propTypes2.default.bool,
	  margin: _propTypes2.default.array,
	  googleMapLoader: _propTypes2.default.any,
	  onGoogleApiLoaded: _propTypes2.default.func,
	  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
	  draggable: _propTypes2.default.bool,
	  style: _propTypes2.default.any,
	  resetBoundsOnResize: _propTypes2.default.bool,
	  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string) // ['TransitLayer', 'TrafficLayer']
	};
	GoogleMap.defaultProps = {
	  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
	    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
	  },
	
	  hoverDistance: 30,
	  debounced: true,
	  options: defaultOptions_,
	  googleMapLoader: _google_map_loader2.default,
	  yesIWantToUseGoogleMapApiInternals: false,
	  style: {
	    width: '100%',
	    height: '100%',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	  layerTypes: [],
	  heatmap: {},
	  heatmapLibrary: false
	};
	GoogleMap.googleMapLoader = _google_map_loader2.default;
	exports.default = GoogleMap;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var GoogleMapMap = function (_Component) {
	  _inherits(GoogleMapMap, _Component);
	
	  function GoogleMapMap() {
	    _classCallCheck(this, GoogleMapMap);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false; // disable react on this div
	  };
	
	  GoogleMapMap.prototype.render = function render() {
	    var registerChild = this.props.registerChild;
	
	    return _react2.default.createElement('div', { ref: registerChild, style: style });
	  };
	
	  return GoogleMapMap;
	}(_react.Component);
	
	exports.default = GoogleMapMap;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_map_markers = __webpack_require__(557);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '50%',
	  height: '50%',
	  left: '50%',
	  top: '50%',
	  // backgroundColor: 'red',
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	  // opacity: 0.3
	};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _google_map = __webpack_require__(1607);
	
	var _google_map2 = _interopRequireDefault(_google_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _google_map2.default;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _eventemitter = __webpack_require__(1317);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerDispatcher = function (_EventEmitter) {
	  _inherits(MarkerDispatcher, _EventEmitter);
	
	  function MarkerDispatcher(gmapInstance) {
	    _classCallCheck(this, MarkerDispatcher);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.gmapInstance = gmapInstance;
	    return _this;
	  }
	
	  MarkerDispatcher.prototype.getChildren = function getChildren() {
	    return this.gmapInstance.props.children;
	  };
	
	  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
	    return this.gmapInstance.mouse_;
	  };
	
	  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
	    return this.gmapInstance.updateCounter_;
	  };
	
	  MarkerDispatcher.prototype.dispose = function dispose() {
	    this.gmapInstance = null;
	    this.removeAllListeners();
	  };
	
	  return MarkerDispatcher;
	}(_eventemitter2.default);
	
	exports.default = MarkerDispatcher;

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isArraysEqualEps;
	function isArraysEqualEps(arrayA, arrayB, eps) {
	  if (arrayA && arrayB) {
	    for (var i = 0; i !== arrayA.length; ++i) {
	      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
	        return false;
	      }
	    }
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = detectBrowser;
	// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
	var detectBrowserResult_ = null;
	
	function detectBrowser() {
	  if (detectBrowserResult_) {
	    return detectBrowserResult_;
	  }
	
	  if (typeof navigator !== 'undefined') {
	    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
	    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
	    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
	
	    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	    var isSafari = navigator.userAgent.indexOf('Safari') > -1;
	
	    if (isChrome && isSafari) {
	      isSafari = false;
	    }
	
	    if (isChrome && isOpera) {
	      isChrome = false;
	    }
	
	    detectBrowserResult_ = {
	      isExplorer: isExplorer,
	      isFirefox: isFirefox,
	      isOpera: isOpera,
	      isChrome: isChrome,
	      isSafari: isSafari
	    };
	    return detectBrowserResult_;
	  }
	
	  detectBrowserResult_ = {
	    isChrome: true,
	    isExplorer: false,
	    isFirefox: false,
	    isOpera: false,
	    isSafari: false
	  };
	
	  return detectBrowserResult_;
	}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	// Reliable `window` and `document` detection
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Check `document` and `window` in case of server-side rendering
	var _window;
	if (canUseDOM) {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (canUseDOM && !attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	
	  if (canUseDOM) {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (element.parentNode === undefined) {
	    var tempParentDiv = document.createElement('div');
	    element.parentNode = tempParentDiv;
	  }
	  element = element.parentNode;
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  element = element.parentNode;
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _pointGeometry = __webpack_require__(463);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(558);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _transform = __webpack_require__(1619);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Geo = function () {
	  function Geo(tileSize) {
	    _classCallCheck(this, Geo);
	
	    // left_top view пользует гугл
	    // super();
	    this.hasSize_ = false;
	    this.hasView_ = false;
	    this.transform_ = new _transform2.default(tileSize || 512);
	  }
	
	  Geo.prototype.setView = function setView(center, zoom, bearing) {
	    this.transform_.center = _lat_lng2.default.convert(center);
	    this.transform_.zoom = +zoom;
	    this.transform_.bearing = +bearing;
	    this.hasView_ = true;
	  };
	
	  Geo.prototype.setViewSize = function setViewSize(width, height) {
	    this.transform_.width = width;
	    this.transform_.height = height;
	    this.hasSize_ = true;
	  };
	
	  Geo.prototype.canProject = function canProject() {
	    return this.hasSize_ && this.hasView_;
	  };
	
	  Geo.prototype.hasSize = function hasSize() {
	    return this.hasSize_;
	  };
	
	  Geo.prototype.unproject = function unproject(ptXY, viewFromLeftTop) {
	    var ptRes = void 0;
	    if (viewFromLeftTop) {
	      var ptxy = _extends({}, ptXY);
	      ptxy.x -= this.transform_.width / 2;
	      ptxy.y -= this.transform_.height / 2;
	      ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));
	    } else {
	      ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptXY));
	    }
	
	    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
	    return ptRes;
	  };
	
	  Geo.prototype.project = function project(ptLatLng, viewFromLeftTop) {
	    if (viewFromLeftTop) {
	      var pt = this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	      pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);
	
	      pt.x += this.transform_.width / 2;
	      pt.y += this.transform_.height / 2;
	
	      return pt;
	    }
	
	    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	  };
	
	  Geo.prototype.getWidth = function getWidth() {
	    return this.transform_.width;
	  };
	
	  Geo.prototype.getHeight = function getHeight() {
	    return this.transform_.height;
	  };
	
	  Geo.prototype.getZoom = function getZoom() {
	    return this.transform_.zoom;
	  };
	
	  Geo.prototype.getCenter = function getCenter() {
	    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });
	
	    return ptRes;
	  };
	
	  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
	    var bndT = margins && margins[0] || 0;
	    var bndR = margins && margins[1] || 0;
	    var bndB = margins && margins[2] || 0;
	    var bndL = margins && margins[3] || 0;
	
	    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
	      var topLeftCorner = this.unproject({
	        x: bndL - this.getWidth() / 2,
	        y: bndT - this.getHeight() / 2
	      });
	      var bottomRightCorner = this.unproject({
	        x: this.getWidth() / 2 - bndR,
	        y: this.getHeight() / 2 - bndB
	      });
	
	      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
	      bottomRightCorner.lat, bottomRightCorner.lng, // SE
	      bottomRightCorner.lat, topLeftCorner.lng, // SW
	      topLeftCorner.lat, bottomRightCorner.lng];
	
	      if (roundFactor) {
	        res = res.map(function (r) {
	          return Math.round(r * roundFactor) / roundFactor;
	        });
	      }
	      return res;
	    }
	
	    return [0, 0, 0, 0];
	  };
	
	  return Geo;
	}();
	
	exports.default = Geo;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(1623);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumber;
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	var objectToString = Object.prototype.toString;
	
	function isNumber(value) {
	  var numberTag = '[object Number]';
	  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
	}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */
	
	
	var _pointGeometry = __webpack_require__(463);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(558);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _wrap = __webpack_require__(559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
	var Transform = function () {
	  function Transform(tileSize, minZoom, maxZoom) {
	    _classCallCheck(this, Transform);
	
	    this.tileSize = tileSize || 512; // constant
	
	    this._minZoom = minZoom || 0;
	    this._maxZoom = maxZoom || 52;
	
	    this.latRange = [-85.05113, 85.05113];
	
	    this.width = 0;
	    this.height = 0;
	    this.zoom = 0;
	    this.center = new _lat_lng2.default(0, 0);
	    this.angle = 0;
	  }
	
	  Transform.prototype.zoomScale = function zoomScale(zoom) {
	    return Math.pow(2, zoom);
	  };
	
	  Transform.prototype.scaleZoom = function scaleZoom(scale) {
	    return Math.log(scale) / Math.LN2;
	  };
	
	  Transform.prototype.project = function project(latlng, worldSize) {
	    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
	  };
	
	  Transform.prototype.unproject = function unproject(point, worldSize) {
	    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
	  };
	
	  // lat/lon <-> absolute pixel coords convertion
	  Transform.prototype.lngX = function lngX(lon, worldSize) {
	    return (180 + lon) * (worldSize || this.worldSize) / 360;
	  };
	
	  // latitude to absolute y coord
	
	
	  Transform.prototype.latY = function latY(lat, worldSize) {
	    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
	    return (180 - y) * (worldSize || this.worldSize) / 360;
	  };
	
	  Transform.prototype.xLng = function xLng(x, worldSize) {
	    return x * 360 / (worldSize || this.worldSize) - 180;
	  };
	
	  Transform.prototype.yLat = function yLat(y, worldSize) {
	    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
	    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	  };
	
	  Transform.prototype.locationPoint = function locationPoint(latlng) {
	    var p = this.project(latlng);
	    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
	  };
	
	  Transform.prototype.pointLocation = function pointLocation(p) {
	    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
	    return this.unproject(this.point.sub(p2));
	  };
	
	  _createClass(Transform, [{
	    key: 'minZoom',
	    get: function get() {
	      return this._minZoom;
	    },
	    set: function set(zoom) {
	      this._minZoom = zoom;
	      this.zoom = Math.max(this.zoom, zoom);
	    }
	  }, {
	    key: 'maxZoom',
	    get: function get() {
	      return this._maxZoom;
	    },
	    set: function set(zoom) {
	      this._maxZoom = zoom;
	      this.zoom = Math.min(this.zoom, zoom);
	    }
	  }, {
	    key: 'worldSize',
	    get: function get() {
	      return this.tileSize * this.scale;
	    }
	  }, {
	    key: 'centerPoint',
	    get: function get() {
	      return new _pointGeometry2.default(0, 0); // this.size._div(2);
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return new _pointGeometry2.default(this.width, this.height);
	    }
	  }, {
	    key: 'bearing',
	    get: function get() {
	      return -this.angle / Math.PI * 180;
	    },
	    set: function set(bearing) {
	      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
	    }
	  }, {
	    key: 'zoom',
	    get: function get() {
	      return this._zoom;
	    },
	    set: function set(zoom) {
	      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	      this._zoom = zoomV;
	      this.scale = this.zoomScale(zoomV);
	      this.tileZoom = Math.floor(zoomV);
	      this.zoomFraction = zoomV - this.tileZoom;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.lngX(this.center.lng);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.latY(this.center.lat);
	    }
	  }, {
	    key: 'point',
	    get: function get() {
	      return new _pointGeometry2.default(this.x, this.y);
	    }
	  }]);
	
	  return Transform;
	}();
	
	exports.default = Transform;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lodash = __webpack_require__(1744);
	
	/* eslint-disable no-console */
	var BASE_URL = 'https://maps';
	var DEFAULT_URL = BASE_URL + '.googleapis.com';
	
	var getUrl = function getUrl(region) {
	  if (region && region.toLowerCase() === 'cn') {
	    return BASE_URL + '.google.cn';
	  }
	  return DEFAULT_URL;
	};
	
	var $script_ = null;
	
	var loadPromise_ = void 0;
	
	var resolveCustomPromise_ = void 0;
	
	var _customPromise = new Promise(function (resolve) {
	  resolveCustomPromise_ = resolve;
	});
	
	// TODO add libraries language and other map options
	
	exports.default = function (bootstrapURLKeys, heatmapLibrary) {
	  if (!$script_) {
	    $script_ = __webpack_require__(2375); // eslint-disable-line
	  }
	
	  // call from outside google-map-react
	  // will be as soon as loadPromise_ resolved
	  if (!bootstrapURLKeys) {
	    return _customPromise;
	  }
	
	  if (loadPromise_) {
	    return loadPromise_;
	  }
	
	  loadPromise_ = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      reject(new Error('google map cannot be loaded outside browser env'));
	      return;
	    }
	
	    if (window.google && window.google.maps) {
	      resolve(window.google.maps);
	      return;
	    }
	
	    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
	      reject(new Error('google map initialization error'));
	    }
	
	    window._$_google_map_initialize_$_ = function () {
	      delete window._$_google_map_initialize_$_;
	      resolve(window.google.maps);
	    };
	
	    if (false) {
	      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
	        var message = '"callback" key in bootstrapURLKeys is not allowed,\n                          use onGoogleApiLoaded property instead';
	        console.error(message);
	        throw new Error(message);
	      }
	    }
	
	    var queryString = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
	      return r + '&' + key + '=' + bootstrapURLKeys[key];
	    }, '');
	
	    // if no version is defined, we want to get the release version
	    // and not the experimental version, to do so, we set v=3
	    // src: https://developers.google.com/maps/documentation/javascript/versions
	    if ((0, _lodash.isEmpty)(bootstrapURLKeys.v)) {
	      queryString += '&v=3.31';
	    }
	
	    var baseUrl = getUrl(bootstrapURLKeys.region);
	    var libraries = heatmapLibrary ? '&libraries=visualization' : '';
	
	    $script_(baseUrl + '/maps/api/js?callback=_$_google_map_initialize_$_' + queryString + libraries, function () {
	      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
	    });
	  });
	
	  resolveCustomPromise_(loadPromise_);
	
	  return loadPromise_;
	};

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = pick;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key]; // eslint-disable-line
	    }
	    return result;
	  }, {});
	}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = raf;
	function raf(callback) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(callback);
	  }
	
	  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	
	  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
	}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.convertNeSwToNwSe = convertNeSwToNwSe;
	exports.convertNwSeToNeSw = convertNwSeToNeSw;
	exports.fitBounds = fitBounds;
	exports.meters2ScreenPixels = meters2ScreenPixels;
	exports.tile2LatLng = tile2LatLng;
	exports.latLng2Tile = latLng2Tile;
	exports.getTilesIds = getTilesIds;
	
	var _log = __webpack_require__(560);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GOOGLE_TILE_SIZE = 256;
	
	function latLng2World(_ref) {
	  var lat = _ref.lat,
	      lng = _ref.lng;
	
	  var sin = Math.sin(lat * Math.PI / 180);
	  var x = lng / 360 + 0.5;
	  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
	
	  y = y < 0 // eslint-disable-line
	  ? 0 : y > 1 ? 1 : y;
	  return { x: x, y: y };
	}
	
	function world2LatLng(_ref2) {
	  var x = _ref2.x,
	      y = _ref2.y;
	
	  var n = Math.PI - 2 * Math.PI * y;
	
	  // TODO test that this is faster
	  // 360 * Math.atan(Math.exp((180 - y * 360) * Math.PI / 180)) / Math.PI - 90;
	  return {
	    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
	    lng: x * 360 - 180
	  };
	}
	
	// Thank you wiki https://en.wikipedia.org/wiki/Geographic_coordinate_system
	function latLng2MetersPerDegree(_ref3) {
	  var lat = _ref3.lat;
	
	  var phi = lat * Math.PI / 180;
	  var metersPerLatDegree = 111132.92 - 559.82 * Math.cos(2 * phi) + 1.175 * Math.cos(4 * phi) - 0.0023 * Math.cos(6 * phi);
	  var metersPerLngDegree = 111412.84 * Math.cos(phi) - 93.5 * Math.cos(3 * phi) + 0.118 * Math.cos(5 * phi);
	  return { metersPerLatDegree: metersPerLatDegree, metersPerLngDegree: metersPerLngDegree };
	}
	
	function meters2LatLngBounds(meters, _ref4) {
	  var lat = _ref4.lat,
	      lng = _ref4.lng;
	
	  var _latLng2MetersPerDegr = latLng2MetersPerDegree({
	    lat: lat
	  }),
	      metersPerLatDegree = _latLng2MetersPerDegr.metersPerLatDegree,
	      metersPerLngDegree = _latLng2MetersPerDegr.metersPerLngDegree;
	
	  var latDelta = 0.5 * meters / metersPerLatDegree;
	  var lngDelta = 0.5 * meters / metersPerLngDegree;
	
	  return {
	    nw: {
	      lat: lat - latDelta,
	      lng: lng - lngDelta
	    },
	    se: {
	      lat: lat + latDelta,
	      lng: lng + lngDelta
	    }
	  };
	}
	
	function meters2WorldSize(meters, _ref5) {
	  var lat = _ref5.lat,
	      lng = _ref5.lng;
	
	  var _meters2LatLngBounds = meters2LatLngBounds(meters, { lat: lat, lng: lng }),
	      nw = _meters2LatLngBounds.nw,
	      se = _meters2LatLngBounds.se;
	
	  var nwWorld = latLng2World(nw);
	  var seWorld = latLng2World(se);
	  var w = Math.abs(seWorld.x - nwWorld.x);
	  var h = Math.abs(seWorld.y - nwWorld.y);
	
	  return { w: w, h: h };
	}
	
	function fitNwSe(nw, se, width, height) {
	  var EPS = 0.000000001;
	  var nwWorld = latLng2World(nw);
	  var seWorld = latLng2World(se);
	  var dx = nwWorld.x < seWorld.x ? seWorld.x - nwWorld.x : 1 - nwWorld.x + seWorld.x;
	  var dy = seWorld.y - nwWorld.y;
	
	  if (dx <= 0 && dy <= 0) {
	    return null;
	  }
	
	  var zoomX = (0, _log2.default)(width / GOOGLE_TILE_SIZE / dx);
	  var zoomY = (0, _log2.default)(height / GOOGLE_TILE_SIZE / dy);
	  var zoom = Math.floor(EPS + Math.min(zoomX, zoomY));
	
	  // TODO find center just unproject middle world point
	  var middle = {
	    x: nwWorld.x < seWorld.x // eslint-disable-line
	    ? 0.5 * (nwWorld.x + seWorld.x) : nwWorld.x + seWorld.x - 1 > 0 ? 0.5 * (nwWorld.x + seWorld.x - 1) : 0.5 * (1 + nwWorld.x + seWorld.x),
	    y: 0.5 * (nwWorld.y + seWorld.y)
	  };
	
	  var scale = Math.pow(2, zoom);
	  var halfW = width / scale / GOOGLE_TILE_SIZE / 2;
	  var halfH = height / scale / GOOGLE_TILE_SIZE / 2;
	
	  var newNW = world2LatLng({
	    x: middle.x - halfW,
	    y: middle.y - halfH
	  });
	
	  var newSE = world2LatLng({
	    x: middle.x + halfW,
	    y: middle.y + halfH
	  });
	
	  return {
	    center: world2LatLng(middle),
	    zoom: zoom,
	    newBounds: {
	      nw: newNW,
	      se: newSE
	    }
	  };
	}
	
	function convertNeSwToNwSe(_ref6) {
	  var ne = _ref6.ne,
	      sw = _ref6.sw;
	
	  return {
	    nw: {
	      lat: ne.lat,
	      lng: sw.lng
	    },
	    se: {
	      lat: sw.lat,
	      lng: ne.lng
	    }
	  };
	}
	
	function convertNwSeToNeSw(_ref7) {
	  var nw = _ref7.nw,
	      se = _ref7.se;
	
	  return {
	    ne: {
	      lat: nw.lat,
	      lng: se.lng
	    },
	    sw: {
	      lat: se.lat,
	      lng: nw.lng
	    }
	  };
	}
	
	function fitBounds(_ref8, _ref9) {
	  var nw = _ref8.nw,
	      se = _ref8.se,
	      ne = _ref8.ne,
	      sw = _ref8.sw;
	  var width = _ref9.width,
	      height = _ref9.height;
	
	  var fittedData = void 0;
	
	  if (nw && se) {
	    fittedData = fitNwSe(nw, se, width, height);
	  } else {
	    var calculatedNwSe = convertNeSwToNwSe({ ne: ne, sw: sw });
	    fittedData = fitNwSe(calculatedNwSe.nw, calculatedNwSe.se, width, height);
	  }
	
	  return _extends({}, fittedData, {
	    newBounds: _extends({}, fittedData.newBounds, convertNwSeToNeSw(fittedData.newBounds))
	  });
	}
	
	// -------------------------------------------------------------------
	// Helpers to calc some markers size
	
	function meters2ScreenPixels(meters, _ref10, zoom) {
	  var lat = _ref10.lat,
	      lng = _ref10.lng;
	
	  var _meters2WorldSize = meters2WorldSize(meters, { lat: lat, lng: lng }),
	      w = _meters2WorldSize.w,
	      h = _meters2WorldSize.h;
	
	  var scale = Math.pow(2, zoom);
	  var wScreen = w * scale * GOOGLE_TILE_SIZE;
	  var hScreen = h * scale * GOOGLE_TILE_SIZE;
	  return {
	    w: wScreen,
	    h: hScreen
	  };
	}
	
	// --------------------------------------------------
	// Helper functions for working with svg tiles, (examples coming soon)
	
	function tile2LatLng(_ref11, zoom) {
	  var x = _ref11.x,
	      y = _ref11.y;
	
	  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, zoom);
	
	  return {
	    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
	    lng: x / Math.pow(2, zoom) * 360 - 180
	  };
	}
	
	function latLng2Tile(_ref12, zoom) {
	  var lat = _ref12.lat,
	      lng = _ref12.lng;
	
	  var worldCoords = latLng2World({ lat: lat, lng: lng });
	  var scale = Math.pow(2, zoom);
	
	  return {
	    x: Math.floor(worldCoords.x * scale),
	    y: Math.floor(worldCoords.y * scale)
	  };
	}
	
	function getTilesIds(_ref13, zoom) {
	  var from = _ref13.from,
	      to = _ref13.to;
	
	  var scale = Math.pow(2, zoom);
	
	  var ids = [];
	  for (var x = from.x; x !== (to.x + 1) % scale; x = (x + 1) % scale) {
	    for (var y = from.y; y !== (to.y + 1) % scale; y = (y + 1) % scale) {
	      ids.push([zoom, x, y]);
	    }
	  }
	
	  return ids;
	}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(2254)),valueEqual=_interopDefault(__webpack_require__(2390));__webpack_require__(306);var invariant=_interopDefault(__webpack_require__(462));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	var e,t=(e=__webpack_require__(2391))&&"object"==typeof e&&"default"in e?e.default:e,n=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function r(e){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=e.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],(t[i[1]]||"/"===e.charAt(e.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=e.indexOf("--\x3e");return{type:"comment",comment:-1!==s?e.slice(4,s):""}}for(var c=new RegExp(n),a=null;null!==(a=c.exec(e));)if(a[0].trim())if(a[1]){var o=a[1].trim(),u=[o,""];o.indexOf("=")>-1&&(u=o.split("=")),r.attrs[u[0]]=u[1],c.lastIndex--}else a[2]&&(r.attrs[a[2]]=a[3].trim().substring(1,a[3].length-1));return r}var i=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,s=/^\s*$/,c=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}module.exports={parse:function(e,t){t||(t={}),t.components||(t.components=c);var n,a=[],o=[],u=-1,l=!1;if(0!==e.indexOf("<")){var m=e.indexOf("<");a.push({type:"text",content:-1===m?e:e.substring(0,m)})}return e.replace(i,function(i,c){if(l){if(i!=="</"+n.name+">")return;l=!1}var m,d="/"!==i.charAt(1),f=i.startsWith("\x3c!--"),h=c+i.length,p=e.charAt(h);if(f){var v=r(i);return u<0?(a.push(v),a):((m=o[u]).children.push(v),a)}if(d&&(u++,"tag"===(n=r(i)).type&&t.components[n.name]&&(n.type="component",l=!0),n.voidElement||l||!p||"<"===p||n.children.push({type:"text",content:e.slice(h,e.indexOf("<",h))}),0===u&&a.push(n),(m=o[u-1])&&m.children.push(n),o[u]=n),(!d||n.voidElement)&&(u>-1&&(n.voidElement||n.name===i.slice(2,-1))&&(u--,n=-1===u?a:o[u]),!l&&"<"!==p&&p)){m=-1===u?a:o[u].children;var x=e.indexOf("<",h),g=e.slice(h,-1===x?void 0:x);s.test(g)&&(g=" "),(x>-1&&u+m.length>=0||" "!==g)&&m.push({type:"text",content:g})}}),a},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};
	//# sourceMappingURL=html-parse-stringify.js.map


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = __webpack_require__(239);
	var _classCallCheck = __webpack_require__(1629);
	var _createClass = __webpack_require__(1630);
	var _assertThisInitialized = __webpack_require__(564);
	var _inherits = __webpack_require__(1633);
	var _possibleConstructorReturn = __webpack_require__(1636);
	var _getPrototypeOf = __webpack_require__(1632);
	var _defineProperty = __webpack_require__(1631);
	var _toArray = __webpack_require__(1638);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
	var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
	var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
	var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
	var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
	var _toArray__default = /*#__PURE__*/_interopDefaultLegacy(_toArray);
	
	function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var consoleLogger = {
	  type: 'logger',
	  log: function log(args) {
	    this.output('log', args);
	  },
	  warn: function warn(args) {
	    this.output('warn', args);
	  },
	  error: function error(args) {
	    this.output('error', args);
	  },
	  output: function output(type, args) {
	    if (console && console[type]) console[type].apply(console, args);
	  }
	};
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    _classCallCheck__default["default"](this, Logger);
	    this.init(concreteLogger, options);
	  }
	  _createClass__default["default"](Logger, [{
	    key: "init",
	    value: function init(concreteLogger) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      this.prefix = options.prefix || 'i18next:';
	      this.logger = concreteLogger || consoleLogger;
	      this.options = options;
	      this.debug = options.debug;
	    }
	  }, {
	    key: "setDebug",
	    value: function setDebug(bool) {
	      this.debug = bool;
	    }
	  }, {
	    key: "log",
	    value: function log() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      return this.forward(args, 'log', '', true);
	    }
	  }, {
	    key: "warn",
	    value: function warn() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	      return this.forward(args, 'warn', '', true);
	    }
	  }, {
	    key: "error",
	    value: function error() {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	      return this.forward(args, 'error', '');
	    }
	  }, {
	    key: "deprecate",
	    value: function deprecate() {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
	    }
	  }, {
	    key: "forward",
	    value: function forward(args, lvl, prefix, debugOnly) {
	      if (debugOnly && !this.debug) return null;
	      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
	      return this.logger[lvl](args);
	    }
	  }, {
	    key: "create",
	    value: function create(moduleName) {
	      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
	        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
	      }), this.options));
	    }
	  }, {
	    key: "clone",
	    value: function clone(options) {
	      options = options || this.options;
	      options.prefix = options.prefix || this.prefix;
	      return new Logger(this.logger, options);
	    }
	  }]);
	  return Logger;
	}();
	var baseLogger = new Logger();
	
	var EventEmitter = function () {
	  function EventEmitter() {
	    _classCallCheck__default["default"](this, EventEmitter);
	    this.observers = {};
	  }
	  _createClass__default["default"](EventEmitter, [{
	    key: "on",
	    value: function on(events, listener) {
	      var _this = this;
	      events.split(' ').forEach(function (event) {
	        _this.observers[event] = _this.observers[event] || [];
	        _this.observers[event].push(listener);
	      });
	      return this;
	    }
	  }, {
	    key: "off",
	    value: function off(event, listener) {
	      if (!this.observers[event]) return;
	      if (!listener) {
	        delete this.observers[event];
	        return;
	      }
	      this.observers[event] = this.observers[event].filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: "emit",
	    value: function emit(event) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	      if (this.observers[event]) {
	        var cloned = [].concat(this.observers[event]);
	        cloned.forEach(function (observer) {
	          observer.apply(void 0, args);
	        });
	      }
	      if (this.observers['*']) {
	        var _cloned = [].concat(this.observers['*']);
	        _cloned.forEach(function (observer) {
	          observer.apply(observer, [event].concat(args));
	        });
	      }
	    }
	  }]);
	  return EventEmitter;
	}();
	
	function defer() {
	  var res;
	  var rej;
	  var promise = new Promise(function (resolve, reject) {
	    res = resolve;
	    rej = reject;
	  });
	  promise.resolve = res;
	  promise.reject = rej;
	  return promise;
	}
	function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	}
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	  function canNotTraverseDeeper() {
	    return !object || typeof object === 'string';
	  }
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (canNotTraverseDeeper()) return {};
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    if (Object.prototype.hasOwnProperty.call(object, key)) {
	      object = object[key];
	    } else {
	      object = {};
	    }
	  }
	  if (canNotTraverseDeeper()) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	    obj = _getLastOfPath.obj,
	    k = _getLastOfPath.k;
	  obj[k] = newValue;
	}
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	    obj = _getLastOfPath2.obj,
	    k = _getLastOfPath2.k;
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	    obj = _getLastOfPath3.obj,
	    k = _getLastOfPath3.k;
	  if (!obj) return undefined;
	  return obj[k];
	}
	function getPathWithDefaults(data, defaultData, key) {
	  var value = getPath(data, key);
	  if (value !== undefined) {
	    return value;
	  }
	  return getPath(defaultData, key);
	}
	function deepExtend(target, source, overwrite) {
	  for (var prop in source) {
	    if (prop !== '__proto__' && prop !== 'constructor') {
	      if (prop in target) {
	        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	          if (overwrite) target[prop] = source[prop];
	        } else {
	          deepExtend(target[prop], source[prop], overwrite);
	        }
	      } else {
	        target[prop] = source[prop];
	      }
	    }
	  }
	  return target;
	}
	function regexEscape(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	var _entityMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '/': '&#x2F;'
	};
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  }
	  return data;
	}
	var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
	var chars = [' ', ',', '?', '!', ';'];
	function looksLikeObjectPath(key, nsSeparator, keySeparator) {
	  nsSeparator = nsSeparator || '';
	  keySeparator = keySeparator || '';
	  var possibleChars = chars.filter(function (c) {
	    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
	  });
	  if (possibleChars.length === 0) return true;
	  var r = new RegExp("(".concat(possibleChars.map(function (c) {
	    return c === '?' ? '\\?' : c;
	  }).join('|'), ")"));
	  var matched = !r.test(key);
	  if (!matched) {
	    var ki = key.indexOf(keySeparator);
	    if (ki > 0 && !r.test(key.substring(0, ki))) {
	      matched = true;
	    }
	  }
	  return matched;
	}
	
	function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }
	function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function deepFind(obj, path) {
	  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
	  if (!obj) return undefined;
	  if (obj[path]) return obj[path];
	  var paths = path.split(keySeparator);
	  var current = obj;
	  for (var i = 0; i < paths.length; ++i) {
	    if (!current) return undefined;
	    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
	      return undefined;
	    }
	    if (current[paths[i]] === undefined) {
	      var j = 2;
	      var p = paths.slice(i, i + j).join(keySeparator);
	      var mix = current[p];
	      while (mix === undefined && paths.length > i + j) {
	        j++;
	        p = paths.slice(i, i + j).join(keySeparator);
	        mix = current[p];
	      }
	      if (mix === undefined) return undefined;
	      if (mix === null) return null;
	      if (path.endsWith(p)) {
	        if (typeof mix === 'string') return mix;
	        if (p && typeof mix[p] === 'string') return mix[p];
	      }
	      var joinedPath = paths.slice(i + j).join(keySeparator);
	      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
	      return undefined;
	    }
	    current = current[paths[i]];
	  }
	  return current;
	}
	var ResourceStore = function (_EventEmitter) {
	  _inherits__default["default"](ResourceStore, _EventEmitter);
	  var _super = _createSuper$3(ResourceStore);
	  function ResourceStore(data) {
	    var _this;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	      ns: ['translation'],
	      defaultNS: 'translation'
	    };
	    _classCallCheck__default["default"](this, ResourceStore);
	    _this = _super.call(this);
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default["default"](_this));
	    }
	    _this.data = data || {};
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	    if (_this.options.ignoreJSONStructure === undefined) {
	      _this.options.ignoreJSONStructure = true;
	    }
	    return _this;
	  }
	  _createClass__default["default"](ResourceStore, [{
	    key: "addNamespaces",
	    value: function addNamespaces(ns) {
	      if (this.options.ns.indexOf(ns) < 0) {
	        this.options.ns.push(ns);
	      }
	    }
	  }, {
	    key: "removeNamespaces",
	    value: function removeNamespaces(ns) {
	      var index = this.options.ns.indexOf(ns);
	      if (index > -1) {
	        this.options.ns.splice(index, 1);
	      }
	    }
	  }, {
	    key: "getResource",
	    value: function getResource(lng, ns, key) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
	      var path = [lng, ns];
	      if (key && typeof key !== 'string') path = path.concat(key);
	      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	      }
	      var result = getPath(this.data, path);
	      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
	      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
	    }
	  }, {
	    key: "addResource",
	    value: function addResource(lng, ns, key, value) {
	      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
	        silent: false
	      };
	      var keySeparator = this.options.keySeparator;
	      if (keySeparator === undefined) keySeparator = '.';
	      var path = [lng, ns];
	      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	        value = ns;
	        ns = path[1];
	      }
	      this.addNamespaces(ns);
	      setPath(this.data, path, value);
	      if (!options.silent) this.emit('added', lng, ns, key, value);
	    }
	  }, {
	    key: "addResources",
	    value: function addResources(lng, ns, resources) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	        silent: false
	      };
	      for (var m in resources) {
	        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
	          silent: true
	        });
	      }
	      if (!options.silent) this.emit('added', lng, ns, resources);
	    }
	  }, {
	    key: "addResourceBundle",
	    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
	      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
	        silent: false
	      };
	      var path = [lng, ns];
	      if (lng.indexOf('.') > -1) {
	        path = lng.split('.');
	        deep = resources;
	        resources = ns;
	        ns = path[1];
	      }
	      this.addNamespaces(ns);
	      var pack = getPath(this.data, path) || {};
	      if (deep) {
	        deepExtend(pack, resources, overwrite);
	      } else {
	        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
	      }
	      setPath(this.data, path, pack);
	      if (!options.silent) this.emit('added', lng, ns, resources);
	    }
	  }, {
	    key: "removeResourceBundle",
	    value: function removeResourceBundle(lng, ns) {
	      if (this.hasResourceBundle(lng, ns)) {
	        delete this.data[lng][ns];
	      }
	      this.removeNamespaces(ns);
	      this.emit('removed', lng, ns);
	    }
	  }, {
	    key: "hasResourceBundle",
	    value: function hasResourceBundle(lng, ns) {
	      return this.getResource(lng, ns) !== undefined;
	    }
	  }, {
	    key: "getResourceBundle",
	    value: function getResourceBundle(lng, ns) {
	      if (!ns) ns = this.options.defaultNS;
	      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
	      return this.getResource(lng, ns);
	    }
	  }, {
	    key: "getDataByLanguage",
	    value: function getDataByLanguage(lng) {
	      return this.data[lng];
	    }
	  }, {
	    key: "hasLanguageSomeTranslations",
	    value: function hasLanguageSomeTranslations(lng) {
	      var data = this.getDataByLanguage(lng);
	      var n = data && Object.keys(data) || [];
	      return !!n.find(function (v) {
	        return data[v] && Object.keys(data[v]).length > 0;
	      });
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.data;
	    }
	  }]);
	  return ResourceStore;
	}(EventEmitter);
	
	var postProcessor = {
	  processors: {},
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	    return value;
	  }
	};
	
	function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }
	function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var checkedLoadedFor = {};
	var Translator = function (_EventEmitter) {
	  _inherits__default["default"](Translator, _EventEmitter);
	  var _super = _createSuper$2(Translator);
	  function Translator(services) {
	    var _this;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    _classCallCheck__default["default"](this, Translator);
	    _this = _super.call(this);
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default["default"](_this));
	    }
	    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized__default["default"](_this));
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	    _this.logger = baseLogger.create('translator');
	    return _this;
	  }
	  _createClass__default["default"](Translator, [{
	    key: "changeLanguage",
	    value: function changeLanguage(lng) {
	      if (lng) this.language = lng;
	    }
	  }, {
	    key: "exists",
	    value: function exists(key) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	        interpolation: {}
	      };
	      if (key === undefined || key === null) {
	        return false;
	      }
	      var resolved = this.resolve(key, options);
	      return resolved && resolved.res !== undefined;
	    }
	  }, {
	    key: "extractFromKey",
	    value: function extractFromKey(key, options) {
	      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
	      if (nsSeparator === undefined) nsSeparator = ':';
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	      var namespaces = options.ns || this.options.defaultNS || [];
	      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
	      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
	      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
	        var m = key.match(this.interpolator.nestingRegexp);
	        if (m && m.length > 0) {
	          return {
	            key: key,
	            namespaces: namespaces
	          };
	        }
	        var parts = key.split(nsSeparator);
	        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
	        key = parts.join(keySeparator);
	      }
	      if (typeof namespaces === 'string') namespaces = [namespaces];
	      return {
	        key: key,
	        namespaces: namespaces
	      };
	    }
	  }, {
	    key: "translate",
	    value: function translate(keys, options, lastKey) {
	      var _this2 = this;
	      if (_typeof__default["default"](options) !== 'object' && this.options.overloadTranslationOptionHandler) {
	        options = this.options.overloadTranslationOptionHandler(arguments);
	      }
	      if (!options) options = {};
	      if (keys === undefined || keys === null) return '';
	      if (!Array.isArray(keys)) keys = [String(keys)];
	      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
	      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _this$extractFromKey.key,
	        namespaces = _this$extractFromKey.namespaces;
	      var namespace = namespaces[namespaces.length - 1];
	      var lng = options.lng || this.language;
	      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
	      if (lng && lng.toLowerCase() === 'cimode') {
	        if (appendNamespaceToCIMode) {
	          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	          if (returnDetails) {
	            return {
	              res: "".concat(namespace).concat(nsSeparator).concat(key),
	              usedKey: key,
	              exactUsedKey: key,
	              usedLng: lng,
	              usedNS: namespace
	            };
	          }
	          return "".concat(namespace).concat(nsSeparator).concat(key);
	        }
	        if (returnDetails) {
	          return {
	            res: key,
	            usedKey: key,
	            exactUsedKey: key,
	            usedLng: lng,
	            usedNS: namespace
	          };
	        }
	        return key;
	      }
	      var resolved = this.resolve(keys, options);
	      var res = resolved && resolved.res;
	      var resUsedKey = resolved && resolved.usedKey || key;
	      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
	      var resType = Object.prototype.toString.apply(res);
	      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
	      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
	      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
	        if (!options.returnObjects && !this.options.returnObjects) {
	          if (!this.options.returnedObjectHandler) {
	            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	          }
	          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
	            ns: namespaces
	          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
	          if (returnDetails) {
	            resolved.res = r;
	            return resolved;
	          }
	          return r;
	        }
	        if (keySeparator) {
	          var resTypeIsArray = resType === '[object Array]';
	          var copy = resTypeIsArray ? [] : {};
	          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
	          for (var m in res) {
	            if (Object.prototype.hasOwnProperty.call(res, m)) {
	              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
	              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
	                joinArrays: false,
	                ns: namespaces
	              }));
	              if (copy[m] === deepKey) copy[m] = res[m];
	            }
	          }
	          res = copy;
	        }
	      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
	        res = res.join(joinArrays);
	        if (res) res = this.extendTranslation(res, keys, options, lastKey);
	      } else {
	        var usedDefault = false;
	        var usedKey = false;
	        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	        var hasDefaultValue = Translator.hasDefaultValue(options);
	        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
	        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
	        if (!this.isValidLookup(res) && hasDefaultValue) {
	          usedDefault = true;
	          res = defaultValue;
	        }
	        if (!this.isValidLookup(res)) {
	          usedKey = true;
	          res = key;
	        }
	        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
	        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
	        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
	        if (usedKey || usedDefault || updateMissing) {
	          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
	          if (keySeparator) {
	            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
	              keySeparator: false
	            }));
	            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
	          }
	          var lngs = [];
	          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	            for (var i = 0; i < fallbackLngs.length; i++) {
	              lngs.push(fallbackLngs[i]);
	            }
	          } else if (this.options.saveMissingTo === 'all') {
	            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	          } else {
	            lngs.push(options.lng || this.language);
	          }
	          var send = function send(l, k, specificDefaultValue) {
	            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
	            if (_this2.options.missingKeyHandler) {
	              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
	            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
	              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
	            }
	            _this2.emit('missingKey', l, namespace, k, res);
	          };
	          if (this.options.saveMissing) {
	            if (this.options.saveMissingPlurals && needsPluralHandling) {
	              lngs.forEach(function (language) {
	                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
	                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
	                });
	              });
	            } else {
	              send(lngs, key, defaultValue);
	            }
	          }
	        }
	        res = this.extendTranslation(res, keys, options, resolved, lastKey);
	        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
	        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
	          if (this.options.compatibilityAPI !== 'v1') {
	            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
	          } else {
	            res = this.options.parseMissingKeyHandler(res);
	          }
	        }
	      }
	      if (returnDetails) {
	        resolved.res = res;
	        return resolved;
	      }
	      return res;
	    }
	  }, {
	    key: "extendTranslation",
	    value: function extendTranslation(res, key, options, resolved, lastKey) {
	      var _this3 = this;
	      if (this.i18nFormat && this.i18nFormat.parse) {
	        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
	          resolved: resolved
	        });
	      } else if (!options.skipInterpolation) {
	        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
	          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
	        }));
	        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
	        var nestBef;
	        if (skipOnVariables) {
	          var nb = res.match(this.interpolator.nestingRegexp);
	          nestBef = nb && nb.length;
	        }
	        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
	        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
	        if (skipOnVariables) {
	          var na = res.match(this.interpolator.nestingRegexp);
	          var nestAft = na && na.length;
	          if (nestBef < nestAft) options.nest = false;
	        }
	        if (options.nest !== false) res = this.interpolator.nest(res, function () {
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	          if (lastKey && lastKey[0] === args[0] && !options.context) {
	            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
	            return null;
	          }
	          return _this3.translate.apply(_this3, args.concat([key]));
	        }, options);
	        if (options.interpolation) this.interpolator.reset();
	      }
	      var postProcess = options.postProcess || this.options.postProcess;
	      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
	          i18nResolved: resolved
	        }, options) : options, this);
	      }
	      return res;
	    }
	  }, {
	    key: "resolve",
	    value: function resolve(keys) {
	      var _this4 = this;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var found;
	      var usedKey;
	      var exactUsedKey;
	      var usedLng;
	      var usedNS;
	      if (typeof keys === 'string') keys = [keys];
	      keys.forEach(function (k) {
	        if (_this4.isValidLookup(found)) return;
	        var extracted = _this4.extractFromKey(k, options);
	        var key = extracted.key;
	        usedKey = key;
	        var namespaces = extracted.namespaces;
	        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
	        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
	        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
	        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
	        namespaces.forEach(function (ns) {
	          if (_this4.isValidLookup(found)) return;
	          usedNS = ns;
	          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
	            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
	            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
	          }
	          codes.forEach(function (code) {
	            if (_this4.isValidLookup(found)) return;
	            usedLng = code;
	            var finalKeys = [key];
	            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
	              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
	            } else {
	              var pluralSuffix;
	              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
	              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
	              if (needsPluralHandling) {
	                finalKeys.push(key + pluralSuffix);
	                if (needsZeroSuffixLookup) {
	                  finalKeys.push(key + zeroSuffix);
	                }
	              }
	              if (needsContextHandling) {
	                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
	                finalKeys.push(contextKey);
	                if (needsPluralHandling) {
	                  finalKeys.push(contextKey + pluralSuffix);
	                  if (needsZeroSuffixLookup) {
	                    finalKeys.push(contextKey + zeroSuffix);
	                  }
	                }
	              }
	            }
	            var possibleKey;
	            while (possibleKey = finalKeys.pop()) {
	              if (!_this4.isValidLookup(found)) {
	                exactUsedKey = possibleKey;
	                found = _this4.getResource(code, ns, possibleKey, options);
	              }
	            }
	          });
	        });
	      });
	      return {
	        res: found,
	        usedKey: usedKey,
	        exactUsedKey: exactUsedKey,
	        usedLng: usedLng,
	        usedNS: usedNS
	      };
	    }
	  }, {
	    key: "isValidLookup",
	    value: function isValidLookup(res) {
	      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	    }
	  }, {
	    key: "getResource",
	    value: function getResource(code, ns, key) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
	      return this.resourceStore.getResource(code, ns, key, options);
	    }
	  }], [{
	    key: "hasDefaultValue",
	    value: function hasDefaultValue(options) {
	      var prefix = 'defaultValue';
	      for (var option in options) {
	        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }]);
	  return Translator;
	}(EventEmitter);
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck__default["default"](this, LanguageUtil);
	    this.options = options;
	    this.supportedLngs = this.options.supportedLngs || false;
	    this.logger = baseLogger.create('languageUtils');
	  }
	  _createClass__default["default"](LanguageUtil, [{
	    key: "getScriptPartFromCode",
	    value: function getScriptPartFromCode(code) {
	      if (!code || code.indexOf('-') < 0) return null;
	      var p = code.split('-');
	      if (p.length === 2) return null;
	      p.pop();
	      if (p[p.length - 1].toLowerCase() === 'x') return null;
	      return this.formatLanguageCode(p.join('-'));
	    }
	  }, {
	    key: "getLanguagePartFromCode",
	    value: function getLanguagePartFromCode(code) {
	      if (!code || code.indexOf('-') < 0) return code;
	      var p = code.split('-');
	      return this.formatLanguageCode(p[0]);
	    }
	  }, {
	    key: "formatLanguageCode",
	    value: function formatLanguageCode(code) {
	      if (typeof code === 'string' && code.indexOf('-') > -1) {
	        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	        var p = code.split('-');
	        if (this.options.lowerCaseLng) {
	          p = p.map(function (part) {
	            return part.toLowerCase();
	          });
	        } else if (p.length === 2) {
	          p[0] = p[0].toLowerCase();
	          p[1] = p[1].toUpperCase();
	          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        } else if (p.length === 3) {
	          p[0] = p[0].toLowerCase();
	          if (p[1].length === 2) p[1] = p[1].toUpperCase();
	          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	        }
	        return p.join('-');
	      }
	      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	    }
	  }, {
	    key: "isSupportedCode",
	    value: function isSupportedCode(code) {
	      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
	        code = this.getLanguagePartFromCode(code);
	      }
	      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
	    }
	  }, {
	    key: "getBestMatchFromCodes",
	    value: function getBestMatchFromCodes(codes) {
	      var _this = this;
	      if (!codes) return null;
	      var found;
	      codes.forEach(function (code) {
	        if (found) return;
	        var cleanedLng = _this.formatLanguageCode(code);
	        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
	      });
	      if (!found && this.options.supportedLngs) {
	        codes.forEach(function (code) {
	          if (found) return;
	          var lngOnly = _this.getLanguagePartFromCode(code);
	          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
	          found = _this.options.supportedLngs.find(function (supportedLng) {
	            if (supportedLng === lngOnly) return supportedLng;
	            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
	            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
	          });
	        });
	      }
	      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
	      return found;
	    }
	  }, {
	    key: "getFallbackCodes",
	    value: function getFallbackCodes(fallbacks, code) {
	      if (!fallbacks) return [];
	      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
	      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	      if (!code) return fallbacks["default"] || [];
	      var found = fallbacks[code];
	      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	      if (!found) found = fallbacks[this.formatLanguageCode(code)];
	      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
	      if (!found) found = fallbacks["default"];
	      return found || [];
	    }
	  }, {
	    key: "toResolveHierarchy",
	    value: function toResolveHierarchy(code, fallbackCode) {
	      var _this2 = this;
	      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	      var codes = [];
	      var addCode = function addCode(c) {
	        if (!c) return;
	        if (_this2.isSupportedCode(c)) {
	          codes.push(c);
	        } else {
	          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
	        }
	      };
	      if (typeof code === 'string' && code.indexOf('-') > -1) {
	        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
	        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
	        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	      } else if (typeof code === 'string') {
	        addCode(this.formatLanguageCode(code));
	      }
	      fallbackCodes.forEach(function (fc) {
	        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
	      });
	      return codes;
	    }
	  }]);
	  return LanguageUtil;
	}();
	
	var sets = [{
	  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
	  nr: [1, 2],
	  fc: 1
	}, {
	  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
	  nr: [1, 2],
	  fc: 2
	}, {
	  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
	  nr: [1],
	  fc: 3
	}, {
	  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
	  nr: [1, 2, 5],
	  fc: 4
	}, {
	  lngs: ['ar'],
	  nr: [0, 1, 2, 3, 11, 100],
	  fc: 5
	}, {
	  lngs: ['cs', 'sk'],
	  nr: [1, 2, 5],
	  fc: 6
	}, {
	  lngs: ['csb', 'pl'],
	  nr: [1, 2, 5],
	  fc: 7
	}, {
	  lngs: ['cy'],
	  nr: [1, 2, 3, 8],
	  fc: 8
	}, {
	  lngs: ['fr'],
	  nr: [1, 2],
	  fc: 9
	}, {
	  lngs: ['ga'],
	  nr: [1, 2, 3, 7, 11],
	  fc: 10
	}, {
	  lngs: ['gd'],
	  nr: [1, 2, 3, 20],
	  fc: 11
	}, {
	  lngs: ['is'],
	  nr: [1, 2],
	  fc: 12
	}, {
	  lngs: ['jv'],
	  nr: [0, 1],
	  fc: 13
	}, {
	  lngs: ['kw'],
	  nr: [1, 2, 3, 4],
	  fc: 14
	}, {
	  lngs: ['lt'],
	  nr: [1, 2, 10],
	  fc: 15
	}, {
	  lngs: ['lv'],
	  nr: [1, 2, 0],
	  fc: 16
	}, {
	  lngs: ['mk'],
	  nr: [1, 2],
	  fc: 17
	}, {
	  lngs: ['mnk'],
	  nr: [0, 1, 2],
	  fc: 18
	}, {
	  lngs: ['mt'],
	  nr: [1, 2, 11, 20],
	  fc: 19
	}, {
	  lngs: ['or'],
	  nr: [2, 1],
	  fc: 2
	}, {
	  lngs: ['ro'],
	  nr: [1, 2, 20],
	  fc: 20
	}, {
	  lngs: ['sl'],
	  nr: [5, 1, 2, 3],
	  fc: 21
	}, {
	  lngs: ['he', 'iw'],
	  nr: [1, 2, 20, 21],
	  fc: 22
	}];
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  },
	  22: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
	  }
	};
	var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
	var suffixesOrder = {
	  zero: 0,
	  one: 1,
	  two: 2,
	  few: 3,
	  many: 4,
	  other: 5
	};
	function createRules() {
	  var rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    _classCallCheck__default["default"](this, PluralResolver);
	    this.languageUtils = languageUtils;
	    this.options = options;
	    this.logger = baseLogger.create('pluralResolver');
	    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
	      this.options.compatibilityJSON = 'v3';
	      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
	    }
	    this.rules = createRules();
	  }
	  _createClass__default["default"](PluralResolver, [{
	    key: "addRule",
	    value: function addRule(lng, obj) {
	      this.rules[lng] = obj;
	    }
	  }, {
	    key: "getRule",
	    value: function getRule(code) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      if (this.shouldUseIntlApi()) {
	        try {
	          return new Intl.PluralRules(code, {
	            type: options.ordinal ? 'ordinal' : 'cardinal'
	          });
	        } catch (_unused) {
	          return;
	        }
	      }
	      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	    }
	  }, {
	    key: "needsPlural",
	    value: function needsPlural(code) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var rule = this.getRule(code, options);
	      if (this.shouldUseIntlApi()) {
	        return rule && rule.resolvedOptions().pluralCategories.length > 1;
	      }
	      return rule && rule.numbers.length > 1;
	    }
	  }, {
	    key: "getPluralFormsOfKey",
	    value: function getPluralFormsOfKey(code, key) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      return this.getSuffixes(code, options).map(function (suffix) {
	        return "".concat(key).concat(suffix);
	      });
	    }
	  }, {
	    key: "getSuffixes",
	    value: function getSuffixes(code) {
	      var _this = this;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var rule = this.getRule(code, options);
	      if (!rule) {
	        return [];
	      }
	      if (this.shouldUseIntlApi()) {
	        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
	          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
	        }).map(function (pluralCategory) {
	          return "".concat(_this.options.prepend).concat(pluralCategory);
	        });
	      }
	      return rule.numbers.map(function (number) {
	        return _this.getSuffix(code, number, options);
	      });
	    }
	  }, {
	    key: "getSuffix",
	    value: function getSuffix(code, count) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var rule = this.getRule(code, options);
	      if (rule) {
	        if (this.shouldUseIntlApi()) {
	          return "".concat(this.options.prepend).concat(rule.select(count));
	        }
	        return this.getSuffixRetroCompatible(rule, count);
	      }
	      this.logger.warn("no plural rule found for: ".concat(code));
	      return '';
	    }
	  }, {
	    key: "getSuffixRetroCompatible",
	    value: function getSuffixRetroCompatible(rule, count) {
	      var _this2 = this;
	      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	      var suffix = rule.numbers[idx];
	      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        if (suffix === 2) {
	          suffix = 'plural';
	        } else if (suffix === 1) {
	          suffix = '';
	        }
	      }
	      var returnSuffix = function returnSuffix() {
	        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
	      };
	      if (this.options.compatibilityJSON === 'v1') {
	        if (suffix === 1) return '';
	        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
	        return returnSuffix();
	      } else if (this.options.compatibilityJSON === 'v2') {
	        return returnSuffix();
	      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        return returnSuffix();
	      }
	      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
	    }
	  }, {
	    key: "shouldUseIntlApi",
	    value: function shouldUseIntlApi() {
	      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
	    }
	  }]);
	  return PluralResolver;
	}();
	
	function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    _classCallCheck__default["default"](this, Interpolator);
	    this.logger = baseLogger.create('interpolator');
	    this.options = options;
	    this.format = options.interpolation && options.interpolation.format || function (value) {
	      return value;
	    };
	    this.init(options);
	  }
	  _createClass__default["default"](Interpolator, [{
	    key: "init",
	    value: function init() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      if (!options.interpolation) options.interpolation = {
	        escapeValue: true
	      };
	      var iOpts = options.interpolation;
	      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
	      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
	      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
	      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
	      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
	      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
	      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
	      this.resetRegExp();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      if (this.options) this.init(this.options);
	    }
	  }, {
	    key: "resetRegExp",
	    value: function resetRegExp() {
	      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
	      this.regexp = new RegExp(regexpStr, 'g');
	      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
	      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
	      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	    }
	  }, {
	    key: "interpolate",
	    value: function interpolate(str, data, lng, options) {
	      var _this = this;
	      var match;
	      var value;
	      var replaces;
	      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
	      function regexSafe(val) {
	        return val.replace(/\$/g, '$$$$');
	      }
	      var handleFormat = function handleFormat(key) {
	        if (key.indexOf(_this.formatSeparator) < 0) {
	          var path = getPathWithDefaults(data, defaultData, key);
	          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
	            interpolationkey: key
	          })) : path;
	        }
	        var p = key.split(_this.formatSeparator);
	        var k = p.shift().trim();
	        var f = p.join(_this.formatSeparator).trim();
	        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
	          interpolationkey: k
	        }));
	      };
	      this.resetRegExp();
	      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
	      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
	      var todos = [{
	        regex: this.regexpUnescape,
	        safeValue: function safeValue(val) {
	          return regexSafe(val);
	        }
	      }, {
	        regex: this.regexp,
	        safeValue: function safeValue(val) {
	          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
	        }
	      }];
	      todos.forEach(function (todo) {
	        replaces = 0;
	        while (match = todo.regex.exec(str)) {
	          var matchedVar = match[1].trim();
	          value = handleFormat(matchedVar);
	          if (value === undefined) {
	            if (typeof missingInterpolationHandler === 'function') {
	              var temp = missingInterpolationHandler(str, match, options);
	              value = typeof temp === 'string' ? temp : '';
	            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
	              value = '';
	            } else if (skipOnVariables) {
	              value = match[0];
	              continue;
	            } else {
	              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
	              value = '';
	            }
	          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
	            value = makeString(value);
	          }
	          var safeValue = todo.safeValue(value);
	          str = str.replace(match[0], safeValue);
	          if (skipOnVariables) {
	            todo.regex.lastIndex += value.length;
	            todo.regex.lastIndex -= match[0].length;
	          } else {
	            todo.regex.lastIndex = 0;
	          }
	          replaces++;
	          if (replaces >= _this.maxReplaces) {
	            break;
	          }
	        }
	      });
	      return str;
	    }
	  }, {
	    key: "nest",
	    value: function nest(str, fc) {
	      var _this2 = this;
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var match;
	      var value;
	      var clonedOptions;
	      function handleHasOptions(key, inheritedOptions) {
	        var sep = this.nestingOptionsSeparator;
	        if (key.indexOf(sep) < 0) return key;
	        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
	        var optionsString = "{".concat(c[1]);
	        key = c[0];
	        optionsString = this.interpolate(optionsString, clonedOptions);
	        var matchedSingleQuotes = optionsString.match(/'/g);
	        var matchedDoubleQuotes = optionsString.match(/"/g);
	        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
	          optionsString = optionsString.replace(/'/g, '"');
	        }
	        try {
	          clonedOptions = JSON.parse(optionsString);
	          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
	        } catch (e) {
	          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
	          return "".concat(key).concat(sep).concat(optionsString);
	        }
	        delete clonedOptions.defaultValue;
	        return key;
	      }
	      while (match = this.nestingRegexp.exec(str)) {
	        var formatters = [];
	        clonedOptions = _objectSpread$3({}, options);
	        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
	        clonedOptions.applyPostProcessor = false;
	        delete clonedOptions.defaultValue;
	        var doReduce = false;
	        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
	          var r = match[1].split(this.formatSeparator).map(function (elem) {
	            return elem.trim();
	          });
	          match[1] = r.shift();
	          formatters = r;
	          doReduce = true;
	        }
	        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
	        if (value && match[0] === str && typeof value !== 'string') return value;
	        if (typeof value !== 'string') value = makeString(value);
	        if (!value) {
	          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
	          value = '';
	        }
	        if (doReduce) {
	          value = formatters.reduce(function (v, f) {
	            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
	              interpolationkey: match[1].trim()
	            }));
	          }, value.trim());
	        }
	        str = str.replace(match[0], value);
	        this.regexp.lastIndex = 0;
	      }
	      return str;
	    }
	  }]);
	  return Interpolator;
	}();
	
	function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function parseFormatStr(formatStr) {
	  var formatName = formatStr.toLowerCase().trim();
	  var formatOptions = {};
	  if (formatStr.indexOf('(') > -1) {
	    var p = formatStr.split('(');
	    formatName = p[0].toLowerCase().trim();
	    var optStr = p[1].substring(0, p[1].length - 1);
	    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
	      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
	    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
	      if (!formatOptions.range) formatOptions.range = optStr.trim();
	    } else {
	      var opts = optStr.split(';');
	      opts.forEach(function (opt) {
	        if (!opt) return;
	        var _opt$split = opt.split(':'),
	          _opt$split2 = _toArray__default["default"](_opt$split),
	          key = _opt$split2[0],
	          rest = _opt$split2.slice(1);
	        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
	        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
	        if (val === 'false') formatOptions[key.trim()] = false;
	        if (val === 'true') formatOptions[key.trim()] = true;
	        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
	      });
	    }
	  }
	  return {
	    formatName: formatName,
	    formatOptions: formatOptions
	  };
	}
	function createCachedFormatter(fn) {
	  var cache = {};
	  return function invokeFormatter(val, lng, options) {
	    var key = lng + JSON.stringify(options);
	    var formatter = cache[key];
	    if (!formatter) {
	      formatter = fn(lng, options);
	      cache[key] = formatter;
	    }
	    return formatter(val);
	  };
	}
	var Formatter = function () {
	  function Formatter() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    _classCallCheck__default["default"](this, Formatter);
	    this.logger = baseLogger.create('formatter');
	    this.options = options;
	    this.formats = {
	      number: createCachedFormatter(function (lng, opt) {
	        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
	        return function (val) {
	          return formatter.format(val);
	        };
	      }),
	      currency: createCachedFormatter(function (lng, opt) {
	        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
	          style: 'currency'
	        }));
	        return function (val) {
	          return formatter.format(val);
	        };
	      }),
	      datetime: createCachedFormatter(function (lng, opt) {
	        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
	        return function (val) {
	          return formatter.format(val);
	        };
	      }),
	      relativetime: createCachedFormatter(function (lng, opt) {
	        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
	        return function (val) {
	          return formatter.format(val, opt.range || 'day');
	        };
	      }),
	      list: createCachedFormatter(function (lng, opt) {
	        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
	        return function (val) {
	          return formatter.format(val);
	        };
	      })
	    };
	    this.init(options);
	  }
	  _createClass__default["default"](Formatter, [{
	    key: "init",
	    value: function init(services) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	        interpolation: {}
	      };
	      var iOpts = options.interpolation;
	      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	    }
	  }, {
	    key: "add",
	    value: function add(name, fc) {
	      this.formats[name.toLowerCase().trim()] = fc;
	    }
	  }, {
	    key: "addCached",
	    value: function addCached(name, fc) {
	      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
	    }
	  }, {
	    key: "format",
	    value: function format(value, _format, lng) {
	      var _this = this;
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var formats = _format.split(this.formatSeparator);
	      var result = formats.reduce(function (mem, f) {
	        var _parseFormatStr = parseFormatStr(f),
	          formatName = _parseFormatStr.formatName,
	          formatOptions = _parseFormatStr.formatOptions;
	        if (_this.formats[formatName]) {
	          var formatted = mem;
	          try {
	            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
	            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
	            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
	          } catch (error) {
	            _this.logger.warn(error);
	          }
	          return formatted;
	        } else {
	          _this.logger.warn("there was no format function for ".concat(formatName));
	        }
	        return mem;
	      }, value);
	      return result;
	    }
	  }]);
	  return Formatter;
	}();
	
	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }
	function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function removePending(q, name) {
	  if (q.pending[name] !== undefined) {
	    delete q.pending[name];
	    q.pendingCount--;
	  }
	}
	var Connector = function (_EventEmitter) {
	  _inherits__default["default"](Connector, _EventEmitter);
	  var _super = _createSuper$1(Connector);
	  function Connector(backend, store, services) {
	    var _this;
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    _classCallCheck__default["default"](this, Connector);
	    _this = _super.call(this);
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default["default"](_this));
	    }
	    _this.backend = backend;
	    _this.store = store;
	    _this.services = services;
	    _this.languageUtils = services.languageUtils;
	    _this.options = options;
	    _this.logger = baseLogger.create('backendConnector');
	    _this.waitingReads = [];
	    _this.maxParallelReads = options.maxParallelReads || 10;
	    _this.readingCalls = 0;
	    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
	    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
	    _this.state = {};
	    _this.queue = [];
	    if (_this.backend && _this.backend.init) {
	      _this.backend.init(services, options.backend, options);
	    }
	    return _this;
	  }
	  _createClass__default["default"](Connector, [{
	    key: "queueLoad",
	    value: function queueLoad(languages, namespaces, options, callback) {
	      var _this2 = this;
	      var toLoad = {};
	      var pending = {};
	      var toLoadLanguages = {};
	      var toLoadNamespaces = {};
	      languages.forEach(function (lng) {
	        var hasAllNamespaces = true;
	        namespaces.forEach(function (ns) {
	          var name = "".concat(lng, "|").concat(ns);
	          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
	            _this2.state[name] = 2;
	          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
	            if (pending[name] === undefined) pending[name] = true;
	          } else {
	            _this2.state[name] = 1;
	            hasAllNamespaces = false;
	            if (pending[name] === undefined) pending[name] = true;
	            if (toLoad[name] === undefined) toLoad[name] = true;
	            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
	          }
	        });
	        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
	      });
	      if (Object.keys(toLoad).length || Object.keys(pending).length) {
	        this.queue.push({
	          pending: pending,
	          pendingCount: Object.keys(pending).length,
	          loaded: {},
	          errors: [],
	          callback: callback
	        });
	      }
	      return {
	        toLoad: Object.keys(toLoad),
	        pending: Object.keys(pending),
	        toLoadLanguages: Object.keys(toLoadLanguages),
	        toLoadNamespaces: Object.keys(toLoadNamespaces)
	      };
	    }
	  }, {
	    key: "loaded",
	    value: function loaded(name, err, data) {
	      var s = name.split('|');
	      var lng = s[0];
	      var ns = s[1];
	      if (err) this.emit('failedLoading', lng, ns, err);
	      if (data) {
	        this.store.addResourceBundle(lng, ns, data);
	      }
	      this.state[name] = err ? -1 : 2;
	      var loaded = {};
	      this.queue.forEach(function (q) {
	        pushPath(q.loaded, [lng], ns);
	        removePending(q, name);
	        if (err) q.errors.push(err);
	        if (q.pendingCount === 0 && !q.done) {
	          Object.keys(q.loaded).forEach(function (l) {
	            if (!loaded[l]) loaded[l] = {};
	            var loadedKeys = q.loaded[l];
	            if (loadedKeys.length) {
	              loadedKeys.forEach(function (n) {
	                if (loaded[l][n] === undefined) loaded[l][n] = true;
	              });
	            }
	          });
	          q.done = true;
	          if (q.errors.length) {
	            q.callback(q.errors);
	          } else {
	            q.callback();
	          }
	        }
	      });
	      this.emit('loaded', loaded);
	      this.queue = this.queue.filter(function (q) {
	        return !q.done;
	      });
	    }
	  }, {
	    key: "read",
	    value: function read(lng, ns, fcName) {
	      var _this3 = this;
	      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
	      var callback = arguments.length > 5 ? arguments[5] : undefined;
	      if (!lng.length) return callback(null, {});
	      if (this.readingCalls >= this.maxParallelReads) {
	        this.waitingReads.push({
	          lng: lng,
	          ns: ns,
	          fcName: fcName,
	          tried: tried,
	          wait: wait,
	          callback: callback
	        });
	        return;
	      }
	      this.readingCalls++;
	      var resolver = function resolver(err, data) {
	        _this3.readingCalls--;
	        if (_this3.waitingReads.length > 0) {
	          var next = _this3.waitingReads.shift();
	          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
	        }
	        if (err && data && tried < _this3.maxRetries) {
	          setTimeout(function () {
	            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
	          }, wait);
	          return;
	        }
	        callback(err, data);
	      };
	      var fc = this.backend[fcName].bind(this.backend);
	      if (fc.length === 2) {
	        try {
	          var r = fc(lng, ns);
	          if (r && typeof r.then === 'function') {
	            r.then(function (data) {
	              return resolver(null, data);
	            })["catch"](resolver);
	          } else {
	            resolver(null, r);
	          }
	        } catch (err) {
	          resolver(err);
	        }
	        return;
	      }
	      return fc(lng, ns, resolver);
	    }
	  }, {
	    key: "prepareLoading",
	    value: function prepareLoading(languages, namespaces) {
	      var _this4 = this;
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var callback = arguments.length > 3 ? arguments[3] : undefined;
	      if (!this.backend) {
	        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	        return callback && callback();
	      }
	      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
	      if (typeof namespaces === 'string') namespaces = [namespaces];
	      var toLoad = this.queueLoad(languages, namespaces, options, callback);
	      if (!toLoad.toLoad.length) {
	        if (!toLoad.pending.length) callback();
	        return null;
	      }
	      toLoad.toLoad.forEach(function (name) {
	        _this4.loadOne(name);
	      });
	    }
	  }, {
	    key: "load",
	    value: function load(languages, namespaces, callback) {
	      this.prepareLoading(languages, namespaces, {}, callback);
	    }
	  }, {
	    key: "reload",
	    value: function reload(languages, namespaces, callback) {
	      this.prepareLoading(languages, namespaces, {
	        reload: true
	      }, callback);
	    }
	  }, {
	    key: "loadOne",
	    value: function loadOne(name) {
	      var _this5 = this;
	      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var s = name.split('|');
	      var lng = s[0];
	      var ns = s[1];
	      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
	        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
	        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
	        _this5.loaded(name, err, data);
	      });
	    }
	  }, {
	    key: "saveMissing",
	    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
	      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
	      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
	        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
	        return;
	      }
	      if (key === undefined || key === null || key === '') return;
	      if (this.backend && this.backend.create) {
	        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
	          isUpdate: isUpdate
	        });
	        var fc = this.backend.create.bind(this.backend);
	        if (fc.length < 6) {
	          try {
	            var r;
	            if (fc.length === 5) {
	              r = fc(languages, namespace, key, fallbackValue, opts);
	            } else {
	              r = fc(languages, namespace, key, fallbackValue);
	            }
	            if (r && typeof r.then === 'function') {
	              r.then(function (data) {
	                return clb(null, data);
	              })["catch"](clb);
	            } else {
	              clb(null, r);
	            }
	          } catch (err) {
	            clb(err);
	          }
	        } else {
	          fc(languages, namespace, key, fallbackValue, clb, opts);
	        }
	      }
	      if (!languages || !languages[0]) return;
	      this.store.addResource(languages[0], namespace, key, fallbackValue);
	    }
	  }]);
	  return Connector;
	}(EventEmitter);
	
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false,
	    supportedLngs: false,
	    nonExplicitSupportedLngs: false,
	    load: 'all',
	    preload: false,
	    simplifyPluralSuffix: true,
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	    partialBundledLanguages: false,
	    saveMissing: false,
	    updateMissing: false,
	    saveMissingTo: 'fallback',
	    saveMissingPlurals: true,
	    missingKeyHandler: false,
	    missingInterpolationHandler: false,
	    postProcess: false,
	    postProcessPassResolved: false,
	    returnNull: true,
	    returnEmptyString: true,
	    returnObjects: false,
	    joinArrays: false,
	    returnedObjectHandler: false,
	    parseMissingKeyHandler: false,
	    appendNamespaceToMissingKey: false,
	    appendNamespaceToCIMode: false,
	    overloadTranslationOptionHandler: function handle(args) {
	      var ret = {};
	      if (_typeof__default["default"](args[1]) === 'object') ret = args[1];
	      if (typeof args[1] === 'string') ret.defaultValue = args[1];
	      if (typeof args[2] === 'string') ret.tDescription = args[2];
	      if (_typeof__default["default"](args[2]) === 'object' || _typeof__default["default"](args[3]) === 'object') {
	        var options = args[3] || args[2];
	        Object.keys(options).forEach(function (key) {
	          ret[key] = options[key];
	        });
	      }
	      return ret;
	    },
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng, options) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      unescapePrefix: '-',
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      nestingOptionsSeparator: ',',
	      maxReplaces: 1000,
	      skipOnVariables: true
	    }
	  };
	}
	function transformOptions(options) {
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
	    options.supportedLngs = options.supportedLngs.concat(['cimode']);
	  }
	  return options;
	}
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function noop() {}
	function bindMemberFunctions(inst) {
	  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
	  mems.forEach(function (mem) {
	    if (typeof inst[mem] === 'function') {
	      inst[mem] = inst[mem].bind(inst);
	    }
	  });
	}
	var I18n = function (_EventEmitter) {
	  _inherits__default["default"](I18n, _EventEmitter);
	  var _super = _createSuper(I18n);
	  function I18n() {
	    var _this;
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments.length > 1 ? arguments[1] : undefined;
	    _classCallCheck__default["default"](this, I18n);
	    _this = _super.call(this);
	    if (isIE10) {
	      EventEmitter.call(_assertThisInitialized__default["default"](_this));
	    }
	    _this.options = transformOptions(options);
	    _this.services = {};
	    _this.logger = baseLogger;
	    _this.modules = {
	      external: []
	    };
	    bindMemberFunctions(_assertThisInitialized__default["default"](_this));
	    if (callback && !_this.isInitialized && !options.isClone) {
	      if (!_this.options.initImmediate) {
	        _this.init(options, callback);
	        return _possibleConstructorReturn__default["default"](_this, _assertThisInitialized__default["default"](_this));
	      }
	      setTimeout(function () {
	        _this.init(options, callback);
	      }, 0);
	    }
	    return _this;
	  }
	  _createClass__default["default"](I18n, [{
	    key: "init",
	    value: function init() {
	      var _this2 = this;
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 ? arguments[1] : undefined;
	      if (typeof options === 'function') {
	        callback = options;
	        options = {};
	      }
	      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
	        if (typeof options.ns === 'string') {
	          options.defaultNS = options.ns;
	        } else if (options.ns.indexOf('translation') < 0) {
	          options.defaultNS = options.ns[0];
	        }
	      }
	      var defOpts = get();
	      this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
	      if (this.options.compatibilityAPI !== 'v1') {
	        this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
	      }
	      if (options.keySeparator !== undefined) {
	        this.options.userDefinedKeySeparator = options.keySeparator;
	      }
	      if (options.nsSeparator !== undefined) {
	        this.options.userDefinedNsSeparator = options.nsSeparator;
	      }
	      function createClassOnDemand(ClassOrObject) {
	        if (!ClassOrObject) return null;
	        if (typeof ClassOrObject === 'function') return new ClassOrObject();
	        return ClassOrObject;
	      }
	      if (!this.options.isClone) {
	        if (this.modules.logger) {
	          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
	        } else {
	          baseLogger.init(null, this.options);
	        }
	        var formatter;
	        if (this.modules.formatter) {
	          formatter = this.modules.formatter;
	        } else if (typeof Intl !== 'undefined') {
	          formatter = Formatter;
	        }
	        var lu = new LanguageUtil(this.options);
	        this.store = new ResourceStore(this.options.resources, this.options);
	        var s = this.services;
	        s.logger = baseLogger;
	        s.resourceStore = this.store;
	        s.languageUtils = lu;
	        s.pluralResolver = new PluralResolver(lu, {
	          prepend: this.options.pluralSeparator,
	          compatibilityJSON: this.options.compatibilityJSON,
	          simplifyPluralSuffix: this.options.simplifyPluralSuffix
	        });
	        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
	          s.formatter = createClassOnDemand(formatter);
	          s.formatter.init(s, this.options);
	          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
	        }
	        s.interpolator = new Interpolator(this.options);
	        s.utils = {
	          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
	        };
	        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	        s.backendConnector.on('*', function (event) {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	          _this2.emit.apply(_this2, [event].concat(args));
	        });
	        if (this.modules.languageDetector) {
	          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
	        }
	        if (this.modules.i18nFormat) {
	          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
	          if (s.i18nFormat.init) s.i18nFormat.init(this);
	        }
	        this.translator = new Translator(this.services, this.options);
	        this.translator.on('*', function (event) {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	          _this2.emit.apply(_this2, [event].concat(args));
	        });
	        this.modules.external.forEach(function (m) {
	          if (m.init) m.init(_this2);
	        });
	      }
	      this.format = this.options.interpolation.format;
	      if (!callback) callback = noop;
	      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
	        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
	      }
	      if (!this.services.languageDetector && !this.options.lng) {
	        this.logger.warn('init: no languageDetector is used and no lng is defined');
	      }
	      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
	      storeApi.forEach(function (fcName) {
	        _this2[fcName] = function () {
	          var _this2$store;
	          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
	        };
	      });
	      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
	      storeApiChained.forEach(function (fcName) {
	        _this2[fcName] = function () {
	          var _this2$store2;
	          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
	          return _this2;
	        };
	      });
	      var deferred = defer();
	      var load = function load() {
	        var finish = function finish(err, t) {
	          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
	          _this2.isInitialized = true;
	          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
	          _this2.emit('initialized', _this2.options);
	          deferred.resolve(t);
	          callback(err, t);
	        };
	        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
	        _this2.changeLanguage(_this2.options.lng, finish);
	      };
	      if (this.options.resources || !this.options.initImmediate) {
	        load();
	      } else {
	        setTimeout(load, 0);
	      }
	      return deferred;
	    }
	  }, {
	    key: "loadResources",
	    value: function loadResources(language) {
	      var _this3 = this;
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	      var usedCallback = callback;
	      var usedLng = typeof language === 'string' ? language : this.language;
	      if (typeof language === 'function') usedCallback = language;
	      if (!this.options.resources || this.options.partialBundledLanguages) {
	        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
	        var toLoad = [];
	        var append = function append(lng) {
	          if (!lng) return;
	          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	          lngs.forEach(function (l) {
	            if (toLoad.indexOf(l) < 0) toLoad.push(l);
	          });
	        };
	        if (!usedLng) {
	          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	          fallbacks.forEach(function (l) {
	            return append(l);
	          });
	        } else {
	          append(usedLng);
	        }
	        if (this.options.preload) {
	          this.options.preload.forEach(function (l) {
	            return append(l);
	          });
	        }
	        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
	          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
	          usedCallback(e);
	        });
	      } else {
	        usedCallback(null);
	      }
	    }
	  }, {
	    key: "reloadResources",
	    value: function reloadResources(lngs, ns, callback) {
	      var deferred = defer();
	      if (!lngs) lngs = this.languages;
	      if (!ns) ns = this.options.ns;
	      if (!callback) callback = noop;
	      this.services.backendConnector.reload(lngs, ns, function (err) {
	        deferred.resolve();
	        callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "use",
	    value: function use(module) {
	      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
	      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
	      if (module.type === 'backend') {
	        this.modules.backend = module;
	      }
	      if (module.type === 'logger' || module.log && module.warn && module.error) {
	        this.modules.logger = module;
	      }
	      if (module.type === 'languageDetector') {
	        this.modules.languageDetector = module;
	      }
	      if (module.type === 'i18nFormat') {
	        this.modules.i18nFormat = module;
	      }
	      if (module.type === 'postProcessor') {
	        postProcessor.addPostProcessor(module);
	      }
	      if (module.type === 'formatter') {
	        this.modules.formatter = module;
	      }
	      if (module.type === '3rdParty') {
	        this.modules.external.push(module);
	      }
	      return this;
	    }
	  }, {
	    key: "setResolvedLanguage",
	    value: function setResolvedLanguage(l) {
	      if (!l || !this.languages) return;
	      if (['cimode', 'dev'].indexOf(l) > -1) return;
	      for (var li = 0; li < this.languages.length; li++) {
	        var lngInLngs = this.languages[li];
	        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
	        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
	          this.resolvedLanguage = lngInLngs;
	          break;
	        }
	      }
	    }
	  }, {
	    key: "changeLanguage",
	    value: function changeLanguage(lng, callback) {
	      var _this4 = this;
	      this.isLanguageChangingTo = lng;
	      var deferred = defer();
	      this.emit('languageChanging', lng);
	      var setLngProps = function setLngProps(l) {
	        _this4.language = l;
	        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
	        _this4.resolvedLanguage = undefined;
	        _this4.setResolvedLanguage(l);
	      };
	      var done = function done(err, l) {
	        if (l) {
	          setLngProps(l);
	          _this4.translator.changeLanguage(l);
	          _this4.isLanguageChangingTo = undefined;
	          _this4.emit('languageChanged', l);
	          _this4.logger.log('languageChanged', l);
	        } else {
	          _this4.isLanguageChangingTo = undefined;
	        }
	        deferred.resolve(function () {
	          return _this4.t.apply(_this4, arguments);
	        });
	        if (callback) callback(err, function () {
	          return _this4.t.apply(_this4, arguments);
	        });
	      };
	      var setLng = function setLng(lngs) {
	        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
	        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
	        if (l) {
	          if (!_this4.language) {
	            setLngProps(l);
	          }
	          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
	          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
	        }
	        _this4.loadResources(l, function (err) {
	          done(err, l);
	        });
	      };
	      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
	        setLng(this.services.languageDetector.detect());
	      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
	        if (this.services.languageDetector.detect.length === 0) {
	          this.services.languageDetector.detect().then(setLng);
	        } else {
	          this.services.languageDetector.detect(setLng);
	        }
	      } else {
	        setLng(lng);
	      }
	      return deferred;
	    }
	  }, {
	    key: "getFixedT",
	    value: function getFixedT(lng, ns, keyPrefix) {
	      var _this5 = this;
	      var fixedT = function fixedT(key, opts) {
	        var options;
	        if (_typeof__default["default"](opts) !== 'object') {
	          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	            rest[_key3 - 2] = arguments[_key3];
	          }
	          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
	        } else {
	          options = _objectSpread({}, opts);
	        }
	        options.lng = options.lng || fixedT.lng;
	        options.lngs = options.lngs || fixedT.lngs;
	        options.ns = options.ns || fixedT.ns;
	        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
	        var keySeparator = _this5.options.keySeparator || '.';
	        var resultKey;
	        if (options.keyPrefix && Array.isArray(key)) {
	          resultKey = key.map(function (k) {
	            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
	          });
	        } else {
	          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
	        }
	        return _this5.t(resultKey, options);
	      };
	      if (typeof lng === 'string') {
	        fixedT.lng = lng;
	      } else {
	        fixedT.lngs = lng;
	      }
	      fixedT.ns = ns;
	      fixedT.keyPrefix = keyPrefix;
	      return fixedT;
	    }
	  }, {
	    key: "t",
	    value: function t() {
	      var _this$translator;
	      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
	    }
	  }, {
	    key: "exists",
	    value: function exists() {
	      var _this$translator2;
	      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
	    }
	  }, {
	    key: "setDefaultNamespace",
	    value: function setDefaultNamespace(ns) {
	      this.options.defaultNS = ns;
	    }
	  }, {
	    key: "hasLoadedNamespace",
	    value: function hasLoadedNamespace(ns) {
	      var _this6 = this;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      if (!this.isInitialized) {
	        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
	        return false;
	      }
	      if (!this.languages || !this.languages.length) {
	        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
	        return false;
	      }
	      var lng = this.resolvedLanguage || this.languages[0];
	      var fallbackLng = this.options ? this.options.fallbackLng : false;
	      var lastLng = this.languages[this.languages.length - 1];
	      if (lng.toLowerCase() === 'cimode') return true;
	      var loadNotPending = function loadNotPending(l, n) {
	        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
	        return loadState === -1 || loadState === 2;
	      };
	      if (options.precheck) {
	        var preResult = options.precheck(this, loadNotPending);
	        if (preResult !== undefined) return preResult;
	      }
	      if (this.hasResourceBundle(lng, ns)) return true;
	      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
	      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
	      return false;
	    }
	  }, {
	    key: "loadNamespaces",
	    value: function loadNamespaces(ns, callback) {
	      var _this7 = this;
	      var deferred = defer();
	      if (!this.options.ns) {
	        if (callback) callback();
	        return Promise.resolve();
	      }
	      if (typeof ns === 'string') ns = [ns];
	      ns.forEach(function (n) {
	        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
	      });
	      this.loadResources(function (err) {
	        deferred.resolve();
	        if (callback) callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "loadLanguages",
	    value: function loadLanguages(lngs, callback) {
	      var deferred = defer();
	      if (typeof lngs === 'string') lngs = [lngs];
	      var preloaded = this.options.preload || [];
	      var newLngs = lngs.filter(function (lng) {
	        return preloaded.indexOf(lng) < 0;
	      });
	      if (!newLngs.length) {
	        if (callback) callback();
	        return Promise.resolve();
	      }
	      this.options.preload = preloaded.concat(newLngs);
	      this.loadResources(function (err) {
	        deferred.resolve();
	        if (callback) callback(err);
	      });
	      return deferred;
	    }
	  }, {
	    key: "dir",
	    value: function dir(lng) {
	      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
	      if (!lng) return 'rtl';
	      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
	      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
	      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
	    }
	  }, {
	    key: "cloneInstance",
	    value: function cloneInstance() {
	      var _this8 = this;
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	      var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
	        isClone: true
	      });
	      var clone = new I18n(mergedOptions);
	      if (options.debug !== undefined || options.prefix !== undefined) {
	        clone.logger = clone.logger.clone(options);
	      }
	      var membersToCopy = ['store', 'services', 'language'];
	      membersToCopy.forEach(function (m) {
	        clone[m] = _this8[m];
	      });
	      clone.services = _objectSpread({}, this.services);
	      clone.services.utils = {
	        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
	      };
	      clone.translator = new Translator(clone.services, clone.options);
	      clone.translator.on('*', function (event) {
	        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	          args[_key4 - 1] = arguments[_key4];
	        }
	        clone.emit.apply(clone, [event].concat(args));
	      });
	      clone.init(mergedOptions, callback);
	      clone.translator.options = clone.options;
	      clone.translator.backendConnector.services.utils = {
	        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
	      };
	      return clone;
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return {
	        options: this.options,
	        store: this.store,
	        language: this.language,
	        languages: this.languages,
	        resolvedLanguage: this.resolvedLanguage
	      };
	    }
	  }]);
	  return I18n;
	}(EventEmitter);
	_defineProperty__default["default"](I18n, "createInstance", function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var callback = arguments.length > 1 ? arguments[1] : undefined;
	  return new I18n(options, callback);
	});
	var instance = I18n.createInstance();
	instance.createInstance = I18n.createInstance;
	
	module.exports = instance;


/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1630 */
[2403, 565],
/* 1631 */
[2404, 565],
/* 1632 */
/***/ (function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1637);
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(239)["default"];
	var assertThisInitialized = __webpack_require__(564);
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(1628);
	var iterableToArray = __webpack_require__(1634);
	var unsupportedIterableToArray = __webpack_require__(1640);
	var nonIterableRest = __webpack_require__(1635);
	function _toArray(arr) {
	  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
	}
	module.exports = _toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1639 */
[2405, 239],
/* 1640 */
[2407, 1627],
/* 1641 */
/***/ (function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	module.exports = {
		"common": {
			"title": "Новостройки - Nedvex",
			"jk": "ЖК",
			"kp": "КП",
			"stopped": "Продажи остановлены"
		},
		"constants": {
			"view_type": {
				"filter": {
					"intoYard": "Двор",
					"toMountains": "Горы",
					"onSea": "Море",
					"toPark": "Парк",
					"toGarden": "Сад",
					"toForest": "Лес",
					"onSocialObjects": "Социальные объекты",
					"panoramicView": "Панорамный вид"
				},
				"rightMenu": {
					"intoYard": "Вид во двор",
					"toMountains": "Вид на горы",
					"onSea": "Вид на море",
					"toPark": "Вид на парк",
					"toGarden": "Вид на сад",
					"toForest": "Вид на лес",
					"onSocialObjects": "Вид на социальные объекты",
					"panoramicView": "Панорамный вид"
				}
			},
			"apartments": {
				"studioAp": "Студия",
				"oneAp": "1-к",
				"twoAp": "2-к",
				"threeAp": "3-к",
				"allAp": "4+",
				"penthaus": "Пентхаус"
			},
			"interiors": {
				"all": "Любая",
				"chernInt": "Черновая",
				"chistInt": "Чистовая",
				"whiteBox": "White box",
				"repair": "Ремонт, мебель, техника",
				"predChistInt": "Пред. чистовая",
				"remInt": "Ремонт",
				"chastRemInt": "Частичный ремонт"
			},
			"features": {
				"concierge": "Консьерж",
				"elevator": "Лифт",
				"children_area": "Детская площадка",
				"landscape_decore": "Ландшафтный дизайн",
				"sport_area": "Спортивная площадка",
				"spa": "SPA",
				"fitness": "Фитнес",
				"pool": "Бассейн",
				"kindergarten": "Детский сад",
				"tennis_court": "Теннисный корт",
				"recreation_zone": "Зона отдыха",
				"fountain": "Фонтан",
				"garden": "Сад",
				"helicopter_landing_area": "Вертолетная площадка",
				"commercial_property": "Коммерческие площади",
				"cctv_surveillance": "Видеонаблюдение",
				"kpp": "КПП",
				"restaurant": "Ресторан",
				"billiards": "Бильярд",
				"sauna": "Сауна",
				"is_children_room": "Детская комната",
				"is_conference_hall": "Конференц зал",
				"is_wellness_building": "Оздоровительный корпус",
				"is_panoramic_glazing": "Панорамное остекление",
				"is_beach": "Пляж",
				"is_walking_area": "Прогулочные зоны",
				"is_operated_roof": "Эксплуатируемая кровля",
				"is_garage": "Гараж",
				"is_acs_system": "Система СКУД",
				"is_landscape_park": "Ландшафтный парка",
				"is_management_company": "Управляющая компания"
			},
			"variants": {
				"selectMicro": "Выберите микрорайон",
				"central": {
					"title": "Центральный",
					"checkboxes": {
						"1": "Донская",
						"2": "Завокзальный",
						"3": "Заречный",
						"4": "КСМ",
						"5": "Макаренко",
						"6": "Мамайка низ",
						"7": "Мамайка верх",
						"8": "Новый Сочи",
						"9": "Клубничная",
						"10": "Центр"
					}
				},
				"hostinskii": {
					"title": "Хостинский",
					"checkboxes": {
						"11": "Ахун",
						"12": "Бытха",
						"13": "Кудепста пос.",
						"14": "Мацеста",
						"15": "Приморье",
						"16": "Раздольное",
						"17": "Светлана низ",
						"18": "Светлана верх",
						"19": "Соболевка",
						"20": "Фабрициуса",
						"21": "Хоста",
						"22": "Транспортная"
					}
				},
				"adler": {
					"title": "Адлерский",
					"checkboxes": {
						"23": "Адлер-центр",
						"24": "Блиново",
						"25": "Веселое село",
						"26": "Голубые Дали",
						"27": "Красная Поляна пос.",
						"28": "Курортный городок",
						"29": "Мирный",
						"30": "Молдовка село",
						"31": "Орел-Изумруд село",
						"32": "Южные культуры",
						"33": "Имеретинская низменность"
					}
				},
				"lazar": {
					"title": "Лазаревский",
					"checkboxes": {
						"34": "Лоо пос.",
						"35": "Дагомыс пос.",
						"36": "Лазаревское пос."
					}
				},
				"tuapse": {
					"title": "Туапсе",
					"checkboxes": {
						"37": "Туапсе"
					}
				}
			}
		},
		"components": {
			"support": {
				"title": "Техподдержка",
				"whatsup": "What’s App",
				"telegram": "Telegram",
				"email": "Написать на почту"
			},
			"blocker": {
				"admin": {
					"title": "Доступ для «{{agencyName}}» приостановлен",
					"description": "{{tarif}} период подошел к концу. Для восстановления доступа свяжитесь с менеджером Nedvex",
					"manager": {
						"phone": "+7 (968) 300-01-12",
						"name": "Техническая поддержка"
					}
				},
				"worker": {
					"title": "Доступ для «{{agencyName}}» приостановлен",
					"description": "{{tarif}} период подошел к концу. Для возобновления работы обратитесь к администратору «{{agencyName}}»."
				},
				"individual": {
					"title": "Доступ приостановлен",
					"description": "{{tarif}} период подошел к концу. Для восстановления доступа перейдите к оплате",
					"pay": "Перейти к оплате"
				}
			},
			"appointment": {
				"appointmentButton": {
					"button": "Записаться на показ"
				},
				"buildingAppointment": {
					"title": "Ближайшая запись на показ"
				},
				"appointmentDialog": {
					"stepOneTitle": "ВЫБЕРИТЕ ВРЕМЯ",
					"stepTwoTitle": "ЗАПОЛНИТЕ ДАННЫЕ",
					"nextButton": "Далее",
					"submitButton": "Записаться",
					"appointmentForm": {
						"generalInfo": "Общая информация",
						"clientName": "Имя клиента",
						"clientNumber": "Последние 4 цифры номера клиента",
						"comment": "Дополнительный комментарий (максимум 250 символов)",
						"selectedDate": "Выбранная дата",
						"clientNameRequired": "Введите имя клиента",
						"clientNumberRequired": "Введите последние 4 цифры номера клиента"
					},
					"availableSlots": "Свободное время",
					"noAvailableSlotsTitle": "Нет доступных слотов",
					"noAvailableSlotsSubtitle": "Воспользуйтесь записью в другой день или свяжитесь с менеджером отдела продаж",
					"resultSuccessTitle": "Мы отправили запрос на просмотр объекта",
					"resultSuccessText": "С вами свяжется застройщик в ближайшее время и согласует просмотр. После подтверждения вам придёт пуш-уведомление в приложении",
					"resultSuccessGood": "Хорошо",
					"resultSuccessToMyAppointment": "В мои записи",
					"resultErrorTitle": "Не удалось записаться",
					"resultErrorText": "Попробуйте ещё раз, если не поможет перезайдите попозже",
					"resultErrorNewAppointment": "Перезаписаться",
					"resultErrorClose": "Закрыть"
				}
			},
			"building": {
				"bar": {
					"finished": "сдан",
					"inProcess": "строится",
					"infoAboutKP": "Информация о КП",
					"infoAboutJK": "Информация о ЖК",
					"today": "Сегодня",
					"pavilion": "Корпус",
					"section": "секция",
					"dateUpdated": "Дата обновления шахматки",
					"dateFrom": "Шахматка от",
					"list": "Список",
					"listTooltip": "Посмотреть квартиры на шахматке",
					"chess": "Шахматка",
					"chessTooltip": "Посмотреть квартиры списком"
				},
				"filters": {
					"price": "Цена",
					"area": "Площадь",
					"inter": "Отделка",
					"housing": {
						"pavilion": "Корпус",
						"section": "секция",
						"finished": "СДАН",
						"inProgress": "СТРОИТСЯ",
						"selectPavilion": "Выбор корпуса"
					}
				},
				"list": {
					"number": "№",
					"numberS": "№",
					"name": "№",
					"nameS": "№",
					"area": "Площадь",
					"areaS": "S",
					"cost": "Цена",
					"costS": "Цена",
					"price": "За м²",
					"priceS": "За м²",
					"interior": "Отделка",
					"interiorS": "Отделка",
					"apartments": "Комнат",
					"apartmentsS": "Комн",
					"floor": "Этаж",
					"floorS": "Этаж",
					"floorKp": "Этаж",
					"floorKpS": "Этаж",
					"promo": "Акция",
					"reserv": "Бронь",
					"assign": "Переуступка",
					"soldOutTitle": "Все лоты проданы",
					"soldOutAlt": "Все квартиры проданы",
					"cellWithoutReserved": "Квартиры под запрос ({{cellWithoutReserved}})",
					"otherCells": "Остальные квартиры ({{otherCells}})"
				},
				"rightMenu": {
					"addToCollection": "В подборку",
					"attic": "Мансарда",
					"area": "{{area}} м²",
					"corps": "Корпус",
					"floor": "этаж",
					"cost": "{{costFormatted}} {{currency}}",
					"section": "секция",
					"reserved": "Квартира зарезервирована <br />застройщиком",
					"sold": "Квартира продана",
					"promo": "Акция",
					"reserve": "Бронь",
					"assign": "Переуступка",
					"price": "{{priceFormatted}} {{currency}}/м²",
					"predChistInt": "Пред. чистовая",
					"floorNumber": "{{number}} эт.",
					"flatReserved": "КВАРТИРА ЗАРЕЗЕРВИРОВАНА <br />застройщиком",
					"houseReserved": "ДОМ ЗАРЕЗЕРВИРОВАН <br />застройщиком",
					"zoomImg": "Увеличить планировку",
					"print": "Печать информации о квартире",
					"emptyPlanning": "Отсутствует планировка этажа",
					"priceForM2": "{{currency}}/м²",
					"totalArea": "{{totalArea}} сот. - площадь участка"
				},
				"tableOptions": {
					"tip": "Шахматка с подробной информацией о квартирах",
					"checkbox": "Расширенная шахматка"
				},
				"chess": {
					"title": "{{building}} - Квартиры в ЖК - Nedvex"
				},
				"main": {
					"about": {
						"houseParking": "придомовой",
						"parkingUnderground": "подземный",
						"parkingMultilevel": "многоуровневый",
						"parkingTypeRoofed": "закрытый",
						"noParking": "отсуствует",
						"commonInfo": "Общие характеристики",
						"info": "Характеристики",
						"class": "Класс дома",
						"material": "Материал здания",
						"type": "Тип дома",
						"houseRoad": "Подъезд к дому",
						"parking": "Паркинг",
						"territory": "Территория",
						"distanceSea": "Расстояние до моря",
						"meters": "м.",
						"cealingHeight": "Высота потолков",
						"serviceCost": "Стоимость обслуживания",
						"cost": "{{currency}} / м²",
						"communication": "Коммуникации",
						"gas": "Газ",
						"heating": "Отопление",
						"electricity": "Электричество",
						"sewage": "Канализация",
						"water": "Водоснабжение"
					},
					"chessLink": {
						"seeChess": "Шахматка",
						"seeList": "Шахматка",
						"chess": "Шахматка",
						"list": "Список домов"
					},
					"inaccuracyReport": {
						"add": "Сообщить о неточности"
					},
					"inaccuracyReportDialog": {
						"title": "СООБЩИТЬ О НЕТОЧНОСТИ",
						"subtitle": "Ваш комментарий",
						"textAreaPlaceholder": "Опишите подробнее неточность",
						"button": "Отправить",
						"noCharsLeft": "Осталось 0 символов",
						"reportSended": "Спасибо, Ваше обращение принято!",
						"done": "Хорошо"
					},
					"collections": {
						"add": "В подборку"
					},
					"collectionDialog": {
						"finished": "сдан",
						"almostFinished": "Частично сдан",
						"finishedBIG": "СДАН",
						"inProgress": "СТРОИТСЯ",
						"add": "Добавить в подборку",
						"total": "{{total}} ЖК",
						"createNew": "СОЗДАЙТЕ НОВУЮ ПОДБОРКУ",
						"enterName": "Введите название новой подборки",
						"button": "Создать подборку",
						"done": "Готово",
						"empty": "У вас еще нет подборок",
						"description": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты"
					},
					"contacts": {
						"empty": "Отсутствуют контакты застройщика",
						"contacts": "КОНТАКТЫ",
						"site": "Вебсайт",
						"showContacts": "Показать контакты"
					},
					"description": {
						"about": "О {{type}}",
						"readMore": "Читать дальше",
						"more": "Подробнее",
						"minimize": "Свернуть"
					},
					"developer": {
						"developer": "Застройщик",
						"contractor": "Ген. подрядчик",
						"noInfo": "Отсутствует информация о застройщике",
						"note": "Примечание",
						"commission": "Комиссия"
					},
					"documents": {
						"title": "Документы"
					},
					"features": {
						"today": "сегодня",
						"advantages": "Преимущества",
						"date": "Дата обновления информации о ЖК",
						"updated": "Обновлено",
						"showAll": "Показать все",
						"minimize": "Свернуть"
					},
					"formalization": {
						"zhiloeRoom": "Жилое помещение",
						"partFlat": "Доля в доме",
						"nezhiloeRoom": "Нежилое помещение",
						"apartmentRoom": "Квартира",
						"apartRoom": "Апартаменты",
						"zhiloeHouse": "Жилой дом",
						"commercialPremises": "Коммерческое помещение",
						"hotelRoom": "Гостиничный номер",
						"storageRoom": "Кладовое помещение",
						"parking": "Паркинг",
						"title": "Оформление",
						"label": "Варианты оформления",
						"type": "Тип недвижимости",
						"sum": "Сумма в договоре",
						"full": "Полная",
						"part": "Неполная"
					},
					"gallery": {
						"showAll": "Посмотреть все фото",
						"showOnMap": "На карте"
					},
					"housing": {
						"name": "Корпус {{name}}",
						"stopped": "Продажи остановлены",
						"soldAllHouses": "Проданы все дома от застройщика",
						"soldAllFlats": "Проданы все квартиры от застройщика",
						"flat1": "квартира",
						"flat2": "квартиры",
						"flat3": "квартир",
						"finished": "СДАН",
						"inProgress": "СТРОИТСЯ",
						"see": "Смотреть",
						"see1": "См.",
						"chess": "шахматку",
						"corps": "Корпуса {{number}}",
						"prices": "от {{areaMin}} м² до {{areaMax}} м², от {{costMin}} {{currency}} до {{costMax}} {{currency}}"
					},
					"info": {
						"paused": "Продажи приостановлены",
						"stopped": "Продажи остановлены",
						"house": "дом",
						"house1": "дома",
						"house2": "домов",
						"flat": "Квартира",
						"flat1": "Квартиры",
						"flat2": "Квартир",
						"soldAllHouses": "Все лоты проданы",
						"soldAllFlats": "Все лоты проданы",
						"minPrice": "{{minPrice}} {{currency}}",
						"price": "Мин. цена/м²",
						"cost": "Мин. цена",
						"area": "Площади, м²"
					},
					"leftWireframe": {
						"photo": "Фото",
						"info": "Информация о ЖК",
						"flats": "Квартиры",
						"advantages": "Преимущества",
						"commonAbout": "Общие характеристики",
						"about": "Характеристики",
						"com": "Коммуникации",
						"decor": "Оформление",
						"pay": "Оплата",
						"aboutHouse": "О ЖК",
						"corp": "Корпуса"
					},
					"nav": {
						"photo": "Фото",
						"info": "Информация о жк",
						"flats": "Квартиры",
						"tip": "Дата обновления информации о ЖК",
						"updated": "Обновлено"
					},
					"news": {
						"titleBig": "Новости {{title}}",
						"title": "Новости",
						"readMore": "Читать далее",
						"seeAll": "См. все новости"
					},
					"payment": {
						"ipoteka": "Ипотека",
						"installments": "Рассрочка",
						"military_ipoteka": "Военная ипотека",
						"mat_capital": "Материнский капитал",
						"taxes": "Возврат НДС",
						"cash": "Наличный расчет",
						"is_ipoteka_family": "Ипотека семейная",
						"is_ipoteka_state_support": "Ипотека с господдержкой",
						"is_ipoteka_it": "Ипотека IT",
						"is_ipoteka_tranche": "Ипотека траншевая",
						"is_ipoteka_subsidized": "Ипотека субсидированная",
						"is_ipoteka_preferential": "Ипотека льготная",
						"surcharge_balcony": "Доплата за балкон",
						"surcharge_communications": "Доплата за коммуникации",
						"surcharge_docs": "Доплата за документы",
						"surcharge_trash": "Доплата за вывоз мусора",
						"gas": "Доплата за газ",
						"pay": "Оплата",
						"price": "{{price}} {{currency}}"
					},
					"popup": {
						"photo": "фото"
					},
					"rightWireframe": {
						"social": "Я в социальных сетях",
						"builder": "Застройщик",
						"commission": "Комиссия",
						"contacts": "Контакты",
						"docs": "Документы"
					},
					"suggestions": {
						"jk": "Другие Объекты в микрорайоне {{subregion}}",
						"kp": "Другие ЖК в микрорайоне {{subregion}}"
					},
					"main": {
						"month": {
							"1": "Январь",
							"2": "Февраль",
							"3": "Март",
							"4": "Апрель",
							"5": "Май",
							"6": "Июнь",
							"7": "Июль",
							"8": "Август",
							"9": "Сентябрь",
							"10": "Октябрь",
							"11": "Ноябрь",
							"12": "Декабрь"
						},
						"onMap": "На карте",
						"lookOnMap": "Посмотреть на карте",
						"photo": "{{number}} из {{allNumber}}",
						"title": "{{title}} Информация о ЖК - Nedvex",
						"finished": "сдан",
						"inProgress": "СТРОИТСЯ",
						"allOnMap": "Посмотреть все фото ({{galleryImagesCount}})",
						"noViews": "Отсутствуют макеты жилого комплекса",
						"about": "Описание",
						"print": "Подготовка информации для печати..."
					},
					"printDialog": {
						"item": "Корпус {{pavilion}}, Секция {{section}}",
						"finished": "сдан",
						"inProgress": "СТРОИТСЯ",
						"print": "Печать",
						"info": "Информация о ЖК",
						"about": "Описание ЖК",
						"contacts": "Контакты застройщика",
						"chess": "Шахматки",
						"planning": "Планировки",
						"plans": "Корпус {{pavilionName}}, Секция {{section}}, этаж {{floor}}",
						"print1": "Распечатать"
					}
				}
			},
			"buildingCard": {
				"delete": "Удалить",
				"finished": "Сдан",
				"almostFinished": "Частично сдан",
				"flat1": "Квартира",
				"flat2": "Квартиры",
				"flat3": "Квартир",
				"lot": "Лот №{{id}}",
				"soldHouses": "Все лоты проданы",
				"soldFlats": "Все лоты проданы",
				"fromFull": "От {{costMin}} {{currency}}, от {{minAreaCost}} {{currency}} за м²",
				"costMin": "От {{costMin}} {{currency}}",
				"minAreaCost": "{{minAreaCost}} {{currency}} за м²",
				"goToObject": "Перейти к ЖК"
			},
			"buildings": {
				"filterLabel": {
					"blackList": "Объект самовольного строительства",
					"new": "Новинка",
					"nedvex": "Nedvex"
				},
				"list": {
					"verified": "Верифицированный Объект",
					"house1": "дом",
					"house2": "дома",
					"house3": "домов",
					"flat1": "квартира",
					"flat2": "квартиры",
					"flat3": "квартир",
					"stopped": "ПРОДАЖИ ОСТАНОВЛЕНЫ",
					"byPromo": "По акции",
					"byQuery": "Под ваш запрос",
					"removeFromFavorites": "Убрать ЖК из избранного",
					"addToFavorites": "Добавить ЖК в избранное",
					"alreadyInFavorites": "В избранном",
					"addTo": "В избранное",
					"addToCollection": "Добавить ЖК в подборку",
					"toCollection": "В подборку",
					"promo": "Акция",
					"promoAds": "Реклама",
					"finished": "СДАН",
					"almostFinished": "ЧАСТИЧНО СДАН",
					"inProgress": "СТРОИТСЯ",
					"beforeAgr": "Пред. договор",
					"military_ipoteka": "Воен. Ипот.",
					"mat_capital": "Мат. кап.",
					"ipoteka": "Ипотека",
					"installments": "Рассрочка",
					"paused": "Продажи<br />приостановлены",
					"costMin": "От {{costMin}} {{currency}}",
					"minAreaCost": "От {{minAreaCost}} {{currency}} за м²",
					"chess": "Шахматка",
					"square": "{{square}} м²",
					"square12": "{{square1}} м² - {{square2}} м²",
					"stopped2": "Продажи остановлены",
					"soldHouses": "Все дома<br />от застройщика<br />проданы",
					"soldFlats": "Все<br />лоты<br />проданы"
				},
				"news": {
					"title": "Лента новостей",
					"readMore": "Читать далее",
					"all": "Все",
					"favorite": "Избранное",
					"fromService": "От сервиса"
				},
				"noBuildings": {
					"startNewSearch": "Начать новый поиск",
					"notFound": "Не найдено объектов",
					"notFoundFull": "Мы не нашли объектов под ваш запрос. <br /> Попробуйте изменить ваш запрос или начните новый поиск"
				},
				"buildings": {
					"sorts": {
						"date_updateDESC": "дате",
						"cost_minASC": "увеличению цены",
						"cost_minDESC": "уменьшению цены",
						"title": "названию"
					},
					"typeFiltersInfo": {
						"nedvex": "NEDVEX",
						"new": "Новинки",
						"promo": "Акции",
						"orderField": "Популярные"
					},
					"searchResults": "Результаты поиска",
					"cottegesPage": "КП и ТХ {{conjunction}} {{city}}",
					"new": "Новостройки {{conjunction}} {{city}}",
					"newShort": "Новостройки",
					"map": "Карта",
					"clear": "Сбросить",
					"filters": "фильтры",
					"search1": "Найден",
					"search2": "Найдено",
					"search3": "Найдено",
					"new1": "объект",
					"new2": "объекта",
					"new3": "объектов",
					"object1": "объект",
					"object2": "объекта",
					"object3": "объектов",
					"by": "По",
					"sortList": "Сортировка списка ЖК",
					"searchOnMap": "Карта",
					"onMap": "На карте",
					"searchOnList": "Искать на списке",
					"day": "ДЕНЬ",
					"week": "НЕДЕЛЯ",
					"month": "МЕСЯЦ"
				}
			},
			"clientCollection": {
				"noPageTitle": "Страница была удалена или не существует",
				"noPageSubTitle": "Если вы получили эту ссылку для ознакомления - сообщите отправителю об ошибке.",
				"district": "району",
				"costMinASC": "увеличению цены",
				"costMinDESC": "уменьшению цены",
				"sort": "Сортировка списка ЖК",
				"searchOnMap": "Искать на карте",
				"map": "Карта"
			},
			"collection": {
				"title": "{{name}} - Подборка - Nedvex",
				"myCollections": "Мои подборки",
				"sendCollection": "Поделиться",
				"sendLink": "Отправляйте ссылку на подборку клиентам",
				"copy": "Скопировать",
				"copied": "Ссылка скопирована",
				"emptyCollection": "Пустая подборка",
				"description": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты",
				"goToList": "Перейти к списку объектов"
			},
			"collectionItem": {
				"lot": "Лот №{{buildingId}}",
				"finished": "Сдан",
				"almostFinished": "Частично сдан",
				"addComment": "Добавить комментарий",
				"comment": "Комментарий",
				"delete": "Удалить",
				"writeComment": "Введите текст комментария и нажмите Enter",
				"cancel": "Отменить",
				"edit": "Редактировать",
				"save": "Сохранить"
			},
			"collections": {
				"title": "Подборки - Nedvex",
				"myCollections": "Мои подборки",
				"create": "Создать подборку",
				"noCollections": "У вас еще нет подборок",
				"share": "Создайте подборки с новостройками для ваших клиентов и делитесь ими. В подборке будут видны только ваши контакты",
				"enterName": "Введите название подборки",
				"collection1": "подборка",
				"collection2": "подборки",
				"collection3": "подборок"
			},
			"collectionsItem": {
				"rename": "Переименовать",
				"description": "{{total}} ЖК",
				"dup": "Дублировать",
				"del": "Удалить",
				"cancel": "Отмена",
				"deleteCollection": "Удаление подборки",
				"sure": "Вы уверены, что хотите удалить подборку {{name}}?"
			},
			"collectionsPopup": {
				"title": "Создать подборку",
				"enter": "Введите название подборки",
				"add": "Сохранить"
			},
			"common": {
				"radioMenu": {
					"select": "Выберите район",
					"clear": "СБРОСИТЬ",
					"selectAll": "ВЫБРАТЬ ВСЕ"
				},
				"yPlaceInfo": {
					"promo": "Акция",
					"stopped": "Продажи остановлены",
					"addToCollection": "В подборку",
					"finished": "СДАН",
					"almostFinished": "ЧАСТИЧНО СДАН",
					"inProgress": "СТРОИТСЯ",
					"flat1": "Квартира",
					"flat2": "Квартиры",
					"flat3": "Квартир",
					"square": "{{minSquare}} м² - {{maxSquare}} м²",
					"costMin": "От {{costMin}} {{currency}}",
					"minAreaCost": "{{minAreaCost}} {{currency}} за м²",
					"soldHouses": "Все лоты проданы",
					"soldFlats": "Все лоты проданы",
					"inFavorite": "В избранном",
					"addToFavorite": "В избранное"
				}
			},
			"favorites": {
				"title": "Избранное - Nedvex",
				"titleBlock": "Избранное",
				"count1": "новостройка",
				"count2": "новостройки",
				"count3": "новостроек",
				"remove": "Удалить из избранного",
				"empty": "У вас в избранном еще ничего нет",
				"notFound": "Добавляйте новостройки в избранное и они будут видны здесь"
			},
			"flatsList": {
				"filters": {
					"price": "Стоимость, {{currency}}",
					"area": "Площадь, м²",
					"from": "от",
					"to": "до",
					"interior": "Отделка"
				},
				"flats": {
					"showMore": "Показать еще"
				},
				"flatListItem": {
					"gallery": {
						"modalName": "Планировка",
						"floor": "{{floor}} этаж"
					},
					"number": "{{number}} этаж",
					"reserved": "Квартира зарезервирована<br />застройщиком",
					"sold": "Квартира продана",
					"promo": "Акция",
					"reserve": "Бронь",
					"priceFormatted": "{{priceFormatted}} {{currency}} за м²",
					"area": "{{area}} м²",
					"predChistInt": "Пред. чистовая",
					"housing": "Корпус {{pavilionName}}, секция {{sectionName}}",
					"showPlan": "См. планировку этажа",
					"flatNumber": "№ квартиры",
					"price": "Цена за м²",
					"inner": "Отделка",
					"finished": "Сдан",
					"emptyPlan": "Отсутствует планировка этажа"
				},
				"subFilters": {
					"flat1": "квартира",
					"flat2": "квартиры",
					"flat3": "квартир",
					"sort": "Сортировать по {{sort}}"
				},
				"flatsList": {
					"sorts": {
						"priceAllAsc": "увеличению цены",
						"priceAllDesc": "уменьшению цены",
						"areaAsc": "увеличению площади",
						"areaDesc": "уменьшению площади",
						"area": "{{area}} м²",
						"price": "{{price}} ₽/м²"
					},
					"flat1": "Квартира",
					"flat2": "Квартиры",
					"flat3": "Квартир",
					"notFound": "Нет подходящий квартир под ваш запрос",
					"startNewSearch": "Начать новый поиск",
					"soldOut": "Все квартиры проданы",
					"noForSale": "Нет квартир в продаже",
					"soldAllHouses": "Проданы все дома от застройщика",
					"soldAllFlats": "Проданы все квартиры от застройщика"
				}
			},
			"footer": {
				"innKpp": "ИНН 2318043183<br/>ОГРН 1162366056830",
				"address": "354000, Краснодарский край, <br/>г. Сочи, пер. Морской, 1/1а",
				"softDeveloper": "ООО “Недвекс” является разработчиком <br> программного обеспечения",
				"copied": "Все права защищены. 2025",
				"docs": "Документы"
			},
			"header": {
				"buildingTitle": {
					"verified": "Верифицированный Объект",
					"finished": "сдан",
					"almostFinished": "ЧАСТИЧНО СДАН",
					"inProgress": "СТРОИТСЯ",
					"today": "Сегодня",
					"lot": "Лот №{{id}}",
					"promo": "АКЦИЯ",
					"updatedAt": "Дата обновления информации о ЖК",
					"updatedFrom": "Информация от",
					"addToFavorites": "Добавить ЖК в избранное",
					"share": "Поделиться ссылкой на объект",
					"print": "Печать информации о ЖК"
				},
				"clientHeader": {
					"address": "Адрес",
					"phone": "Телефон",
					"mail": "Эл. почта",
					"website": "Вебсайт",
					"backToList": "ВЕРНУТЬСЯ К СПИСКУ"
				},
				"filtersBar": {
					"filters": {
						"viewTypes": {
							"title": "Вид из окна",
							"chooseViewType": "Выберите вид из окна",
							"clear": "СБРОСИТЬ",
							"notSelected": "Не выбрано"
						},
						"advantages": {
							"title": "Преимущества",
							"clear": "СБРОСИТЬ",
							"parking": "Паркинг",
							"elevator": "Лифт",
							"concierge": "Консьерж",
							"childrenArea": "Детская площадка",
							"recreationZone": "Зона отдыха",
							"pool": "Бассейн",
							"beach": "Пляж",
							"restaurant": "Ресторан",
							"operatedRoof": "Эксплуатационная кровля",
							"new": "Новинка",
							"zbbq": "Зона барбекю",
							"walkingArea": "Прогулочные зоны",
							"wellnessBuilding": "Оздоровительный корпус",
							"houseTerritory": "Закрытая территория",
							"spa": "SPA",
							"cctv": "Видеонаблюдение",
							"commercialProperty": "Коммерческие площади",
							"sportArea": "Спортивная площадка",
							"kpp": "КПП"
						},
						"area": {
							"title": "Укажите площадь",
							"clear": "СБРОСИТЬ",
							"from": "от",
							"fromFull": "Площадь от",
							"to": "до",
							"toFull": "Площадь до",
							"notSelected": "Не выбрано"
						},
						"buildingClass": {
							"variant1": "Эконом",
							"variant2": "Комфорт",
							"variant3": "Бизнес",
							"variant4": "Элит",
							"notSelected": "Не выбрано",
							"title": "Класс дома",
							"clear": "СБРОСИТЬ"
						},
						"deadline": {
							"title": "Выберите срок сдачи",
							"clear": "СБРОСИТЬ",
							"finished": "Дом сдан",
							"quarter": "{{data}} квартал",
							"notSelected": "Не выбрано",
							"deadlineEnd": "Дом сдан"
						},
						"decoration": {
							"clear": "СБРОСИТЬ",
							"title": "Отделка",
							"titleFull": "Отделка",
							"chernInt": "Черновая",
							"chistInt": "Чистовая",
							"predChistInt": "Пред. чистовая",
							"whiteBox": "White box",
							"repair": "Ремонт, мебель, техника",
							"remInt": "Ремонт",
							"chastRemInt": "Частичный ремонт",
							"notSelected": "Не выбрано"
						},
						"interior": {
							"chernInt": "Черновая",
							"chistInt": "Чистовая",
							"whiteBox": "White box",
							"repair": "Ремонт, мебель, техника",
							"predChistInt": "Пред. чистовая",
							"remInt": "Ремонт",
							"chastRemInt": "Частичный ремонт",
							"notSelected": "Не выбрано",
							"title": "Выберите тип отделки",
							"clear": "СБРОСИТЬ"
						},
						"payment": {
							"title": "Варианты оплаты",
							"clear": "СБРОСИТЬ",
							"notSelected": "Не выбрано",
							"taxes": "Возврат НДС",
							"cash": "Наличный расчет",
							"installments": "Рассрочка",
							"mat_capital": "Материнский капитал",
							"ipoteka": "Ипотека",
							"military_ipoteka": "Военная ипотека",
							"is_ipoteka_family": "Ипотека семейная",
							"is_ipoteka_state_support": "Ипотека с господдержкой",
							"is_ipoteka_it": "Ипотека IT",
							"is_ipoteka_tranche": "Ипотека траншевая",
							"is_ipoteka_subsidized": "Ипотека субсидированная",
							"is_ipoteka_preferential": "Ипотека льготная"
						},
						"price": {
							"cost": "{{price}} млн.",
							"perMeter": "{{min}} - {{max}} за м²",
							"notSelected": "Не выбрано",
							"clear": "СБРОСИТЬ",
							"title": "Укажите цену",
							"from": "Цена от",
							"to": "Цена до",
							"commonPrice": "Общая цена",
							"commonPriceMeter": "Цена за м²",
							"commonPriceWithCurrency": "Общая цена, {{currency}}",
							"commonPriceMeterWithCurrency": "Цена за м², {{currency}}"
						},
						"federalLaw": {
							"fz214": "ФЗ-214",
							"fz215": "ФЗ-215",
							"notSelected": "Не выбрано",
							"clear": "СБРОСИТЬ",
							"title": "Федеральный закон"
						},
						"registration": {
							"fz214": "ФЗ-214",
							"fz215": "ФЗ-215",
							"ust": "Юстиция",
							"inv": "Договор инвестирования",
							"part": "ДДУ / ФЗ-214",
							"buySale": "Договор купли-продажи",
							"contract": "Договор подряда",
							"prec": "Предварительный договор",
							"shared": "Паевой взнос",
							"reserv": "Договор бронирования",
							"loan": "Договор займа",
							"partnership": "Договор простого товарищества",
							"assignment": "Договор переуступки",
							"notSelected": "Не выбрано",
							"clear": "СБРОСИТЬ",
							"title": "Выберите тип оформления"
						},
						"sea": {
							"500": "До 500 м",
							"1500": "До 1500 м",
							"3000": "До 3000 м",
							"notSelected": "Не выбрано",
							"clear": "СБРОСИТЬ",
							"title": "Расстояние до моря"
						},
						"type": {
							"flat": "Квартира",
							"apt": "Апартаменты",
							"lvn": "Жилое помещение",
							"nlvn": "Нежилое помещение",
							"hotelRoom": "Гостиничный номер",
							"zhiloeHouse": "Жилой дом",
							"storageRoom": "Кладовое помещение",
							"notSelected": "Не выбрано",
							"clear": "СБРОСИТЬ",
							"title": "Тип недвижимости"
						},
						"districtTitle": "Район",
						"priceTitle": "Цена",
						"areaTitle": "Площадь",
						"registrationTitle": "Оформление",
						"deadlineTitle": "Срок сдачи",
						"paymentTitle": "Варианты оплаты",
						"moreTitle": "Еще"
					}
				},
				"regionPopup": {
					"title": "Выберите страну"
				},
				"search": {
					"title": "Поиск"
				},
				"user": {
					"tarif": "Тариф «{{tarif}}»",
					"day1": "день",
					"day2": "дня",
					"day3": "дней",
					"withClient": "Я с клиентом",
					"profile": "Профиль",
					"myProfile": "Мой профиль",
					"companyProfile": "Профиль компании",
					"logout": "Выйти",
					"withClient2": "С клиентом"
				},
				"menu": {
					"building": "Жилые комплексы",
					"kpAndTh": "КП и ТХ",
					"collections": "Подборки",
					"favorites": "Избранное"
				}
			},
			"login": {
				"formRegistration": {
					"workOptions1": "Частный агент",
					"workOptions2": "Работаю в агентстве недвижимости",
					"workOptions3": "Хочу подключить свое агенство",
					"title": "Регистрация в приложении Nedvex",
					"nameError": "Некорректно введено имя",
					"name": "Ваше имя",
					"surNameError": "Некорректно введена фамилия",
					"surName": "Ваша фамилия",
					"currentWork": "Выберите ваше место работы:",
					"currentWorkError": "Выберите вашу должность",
					"city": "Выберите город:",
					"cityError": "Выберите город",
					"phoneNumberError": "Некорректно введен номер телефона",
					"emailError": "Некорректно введен e-mail",
					"email": "Введите ваш e-mail",
					"send": "ОТПРАВИТЬ",
					"agree": "Нажимая на кнопку «Отправить» Вы соглашаетесь с нашей ",
					"politicianLink": "Политикой конфиденциальности",
					"eulaLink": "Пользовательским соглашением."
				},
				"formNumber": {
					"userNotFound": "Телефон не зарегистрирован",
					"serverError": "Ошибка сервера, попробуйте позже",
					"title": "Вход в приложение Nedvex",
					"button": "ВОЙТИ",
					"registration": "ЗАРЕГИСТРИРОВАТЬСЯ"
				},
				"formSMS": {
					"title": "Вход на сайт",
					"smsError": "Неправильный код авторизации",
					"sms": "Пожалуйста, введите код из SMS",
					"remainingTime": "Попробуйте через {{remainingTime}} сек",
					"submit": "Подтвердить",
					"resend": "Отправить код повторно"
				},
				"formTechnicalProblem": {
					"title": "Технические неполадки<br />Попробуйте позже"
				}
			},
			"notification": {
				"text": "Скачайте инсайты по рынку сочинской недвижимости от экспертов Nedvex, пройдя короткий опрос.",
				"link": "https://forms.yandex.ru/cloud/67221d87068ff05dd791691f",
				"textEnding": "и узнайте, как увеличить продажи в новом регионе",
				"cancel": "Отменить"
			},
			"payments": {
				"failPage": {
					"title": "Ошибка оплаты",
					"description": "К сожалению, мы не смогли принять ваш платеж.<br />Попробуйте еще раз.",
					"tryMore": "Попробовать еще раз"
				},
				"notification": {
					"title": "{{days}} до окончания {{tarif}} {{agencyName}}",
					"company": "платной подписки",
					"personal": "платной подписки",
					"company_test": "бесплатного тестового периода",
					"personal_test": "бесплатного тестового периода",
					"default": "бесплатного тестового периода",
					"day1": "день",
					"day2": "дня",
					"day3": "дней"
				},
				"payForTarif": {
					"title": "ВЫБОР ПОДПИСКИ",
					"subtitle": "Оставшиеся дни сохраняются после оплаты",
					"tarifImg": "Тариф «Частный»",
					"tarifSolo": "Тариф «Индивидуальный»",
					"description": "Ваш личный доступ к сервису",
					"popular": "Популярное",
					"price": "2000 ₽",
					"time": "1 месяц",
					"pay": "Оплатить подписку",
					"text": "Оставшиеся дни сохранятся <br />после оплаты",
					"button": "Оплатить",
					"months": {
						"1": "на 1 месяц",
						"3": "на 3 месяца",
						"12": "на 12 месяцев"
					}
				},
				"subscriptionBar": {
					"title": "{{countDay}} {{left}}",
					"day1": "день",
					"day2": "дня",
					"day3": "дней",
					"left1": "остался",
					"left2": "осталось",
					"left3": "осталось",
					"ended": "Закончилась подписка",
					"tarif": "Тариф: «{{tarif}}»",
					"workers": "{{workersCount}} из {{countPeople}} сотрудников",
					"text": "Оставшиеся дни сохранятся <br />после оплаты"
				},
				"successPage": {
					"title": "Успешная оплата",
					"description": " Вы успешно оплатили подписку. Спасибо! <br />Доступ к сервису восстановлен.",
					"goToMain": "Вернуться на главную"
				}
			},
			"profile": {
				"avatar": {
					"update": "Обновить фото",
					"upload": "Загрузить фото"
				},
				"tariffModal": {
					"title": "Выбрать тариф",
					"button": "Сформировать счет",
					"current": "текущий тариф",
					"error": {
						"title": "что-то пошло не так",
						"default": "При формировании счёта возникла ошибка. Повторите попытку через несколько минут.",
						"data": "При формировании счета возникла ошибка. Проверьте корректность введенных ИНН и КПП.",
						"count": "Вам необходимо уменьшить кол-во сотрудников до {{count}}."
					},
					"emptyInnOrKpp": {
						"title": "Ошибка",
						"body": "Необходимо заполнить ИНН и КПП"
					}
				},
				"avatarUploader": {
					"title": "Ваше фото",
					"button": "Обрезать и сохранить"
				},
				"employeeList": {
					"new": "Новый сотрудник",
					"deny": "Вы не можете добавить еще одного сотрудника в рамках текущего тарифного плана.",
					"allow": "Вы можете добавить еще {{countPeople}} сотрудников",
					"admin": "Администратор",
					"edit": "Редактировать",
					"delete": "Удалить",
					"cancel": "Отмена",
					"deleteWorker": "Удаление сотрудника",
					"areYouSure": "Вы уверены что хотите удалить сотрудника {{firstName}} {{lastName}}?"
				},
				"profileForm": {
					"saveButton": "Сохранить изменения",
					"logout": "Выйти из аккаунта",
					"leaveAgency": "Выйти из агентства",
					"firstName": "Имя",
					"firstNameLabel": "Иван",
					"lastName": "Ваша фамилия",
					"lastNameLabel": "Иванов",
					"phone": "Телефон",
					"email": "Электронная почта",
					"position": "Должность",
					"positionPlaceholder": "example@gmail.com",
					"company": "Компания",
					"companyPlaceholder": "Название компании",
					"about": "Расскажите о себе",
					"aboutPlaceholder": "Введите текст до 250 символов",
					"profileLink": "Ссылка на профиль",
					"vk": "Вконтакте",
					"ok": "Одноклассники",
					"validate": {
						"firstName": "Введите имя",
						"firstNameError": "Слишком длинное имя",
						"lastName": "Введите фамилию",
						"lastNameError": "Слишком длинная фамилия",
						"phone": "Введите телефон",
						"phoneConflict": "Номер уже зарегистрирован, обратитесь в поддержку",
						"phoneError": "Неверный телефон",
						"email": "Введите адрес",
						"emailError": "Неверный адрес",
						"emailError1": "Слишком длинный адрес",
						"emailConflict": "Почта уже зарегистрирована, обратитесь в поддержку",
						"position": "Введите должность",
						"positionError": "Слишком длинная должность",
						"positionError1": "Введите текст до 250 символов"
					},
					"leaveAgencyDialog": {
						"title": "Выйти из агентства?",
						"subtitle": "После выхода из агентства вы потеряете доступ к платформе. Вам нужно будет   оформить личную подписку или перейти в другое агентство",
						"leave": "Выйти",
						"cancel": "Отмена"
					},
					"informPopup": {
						"userBindedToAgencyTitle": "Пользователь привязан к другому агентству",
						"userBindedToAgencySubtitle": "Для того чтобы добавить пользователя в ваше агентство, ему необходимо выйти из своего текущего агентства",
						"userBindedToAgencyButton": "Хорошо",
						"userAlreadyExistsTitle": "Агент с таким номером уже есть",
						"userAlreadyExistsSubtitle": "Добавить его в карточку агентства?",
						"userAlreadyExistsButton": "Добавить"
					}
				},
				"company": {
					"validate": {
						"name": "Введите название компании",
						"nameError": "Слишком длинное название компании",
						"description": "Введите текст до 500 символов",
						"officeErrors1": "Введите название офиса",
						"officeErrors2": "Слишком длинное название офиса",
						"address": "Введите адрес",
						"phone": "Введите телефон",
						"email": "Введите электронную почту",
						"emailError": "Слишком длинный адрес",
						"inn": "Введите ИНН компании",
						"kpp": "Введите КПП компании"
					},
					"mainOffice": "Главный офис",
					"anotherOffice": "Дополнительный офис",
					"officeName": "Название офиса",
					"officeNamePlaceholder": "Офис в Сочи",
					"officeAddress": "Адрес офиса",
					"officeAddressPlaceholder": "Сочи, ул. Кооперативная, 8",
					"officePhone": "Телефон",
					"officeEmail": "Электронная почта",
					"plusOffice": "+ ДОПОЛНИТЕЛЬНЫЙ ОФИС",
					"title": "Профиль компании",
					"commonInfo": "Общая Информация",
					"workers": "Сотрудники",
					"form": {
						"name": "Название компании",
						"website": "Вебсайт",
						"description": "Описание компании",
						"inn": "ИНН",
						"kpp": "КПП"
					},
					"socialNets": "Социальные сети",
					"save": "Сохранить изменения"
				},
				"employerInteraction": {
					"edit": "Редактировать профиль",
					"new": "Новый сотрудник"
				},
				"profile": {
					"noPermission": "Чтобы изменить контактные данные обратитесь к администратору",
					"title": "Редактировать профиль",
					"profileTab": "MОИ ДАННЫЕ",
					"appointmentsTab": "МОИ ЗАПИСИ"
				},
				"appointments": {
					"futureAppointments": "БУДУЩИЕ",
					"pastAppointments": "ПРОШЕДШИЕ",
					"noAppointments": "Нет записей",
					"noFutureAppointments": "Вы еще не записались на показ объектов",
					"noPastAppointments": "Вы еще не проводили показ объектов",
					"dateAndTime": "Дата и время",
					"clientName": "Имя клиента",
					"clientDate": "Телефон клиента",
					"comment": "Комментарий",
					"agentName": "Имя агента",
					"agency": "Агентство"
				}
			},
			"realtorCard": {
				"title": "Я в социальных сетях",
				"in": "в"
			},
			"realtorPopup": {
				"office": "Офис",
				"onMap": "На карте",
				"minMap": "Свернуть карту",
				"showMap": "Показать карту",
				"phone": "Телефон",
				"address": "Адрес",
				"email": "Эл. почта",
				"website": "Вебсайт"
			},
			"searchFullscreen": {
				"constants": {
					"all1": "Введите название ЖК, района, улицы",
					"all2": "Введите название",
					"regions": "Введите название района",
					"sub_regions": "Введите название микрорайона",
					"buildings": "Введите название новостройки",
					"streets": "Введите название улицы"
				},
				"filters": {
					"all": "все",
					"buildings": "Новостройки",
					"areas": "Районы",
					"neighborhoods": "Микрорайоны",
					"streets": "Улицы"
				},
				"all": "все",
				"buildings": "Новостройки",
				"areas": "Районы",
				"neighborhoods": "Микрорайоны",
				"streets": "Улицы",
				"emptyResults": "Ничего не найдено",
				"emptyResultsDescription": "Мы ничего не нашли по вашему запросу"
			},
			"shareDialog": {
				"sendObject": "Отправить объект",
				"title": "Какие разделы будут видны по ссылке",
				"hint": "Отправляйте ссылку на объект клиентам",
				"copy": "Скопировать",
				"copied": "Ссылка скопирована",
				"savePdfFile": "Скачать презентацию"
			},
			"typeFilters": {
				"new": "Новинки",
				"promo": "Акции",
				"popular": "Популярные"
			}
		},
		"containers": {
			"logIn": {
				"title-phone": "Авторизация",
				"title-code": "Ввод кода",
				"subtitle-phone": "Введите номер телефона",
				"subtitle-code": "Код",
				"hint-phone-call": "Вам поступит звонок от робота. Можете<br/>не отвечать на него, запомните последние<br/>4 цифры",
				"hint-code-call": "Введите последние 4 цифры номера, с которого вам позвонил робот",
				"hint-phone-sms": "Укажите номер вашего телефона. На него поступит смс-сообщение с кодом для авторизации",
				"hint-code-sms": "Введите 5 цифр из SMS",
				"recall": "Отправить звонок повторно можно через {{sec}} сек.",
				"resend": "Отправить код повторно можно через {{sec}} сек.",
				"doRecall": "Отправить звонок повторно",
				"doResend": "Отправить код повторно",
				"error-code-phone": "Последние 4 цифры, звонившего номера телефона введены неверно",
				"error-code-sms": "Неверный код из SMS-сообщения. Попробуйте еще раз",
				"registration": "Нет аккаунта? Зарегистрируйтесь",
				"buttons": {
					"continue": "Продолжить",
					"bySms": "Войти по SMS",
					"byCall": "Войти по звонку",
					"enter": "Войти",
					"back": "Назад"
				},
				"description": {
					"1": "Платформа",
					"2": "недвижимости Сочи"
				},
				"footer": {
					"privacy": "Политика конфиденциальности",
					"eula": "Пользовательское соглашение",
					"inn": "ИНН 2318043183",
					"ogrn": "ОГРН 1162366056830",
					"copyright": "{{year}}. Все права защищены"
				},
				"technicalProblem": {
					"title": "Что-то пошло не так",
					"phone-call": "Не удалось отправить исходящий звонок, попробуйте другой способ входа — «Войти по SMS»",
					"phone-sms": "Не удалось отправить код по SMS, попробуйте другой способ входа — «Войти по звонку»"
				}
			},
			"login": {
				"title1": "Платформа недвижимости Сочи",
				"title2": "для агентов и агентств недвижимости",
				"tariffs": "Тарифы",
				"phone1": "8 (968) 3000 112",
				"phone1Link": "89683000112",
				"phone2": "8 (968) 3001 220",
				"phone2Link": "89683001220",
				"description1": "Самая большая и актуальная база новостроек",
				"description2": "Сочи с возможностью формировать подборки для ваших клиентов",
				"about1": "активных риэлторов в месяц пользуются нашим сервисом",
				"about2": "агентств недвижимости Сочи пользуются нашей платформой",
				"about3": "актуальных объектов недвижимости в базе приложения",
				"about4": "параметров по каждому объекту",
				"footer1": "ИНН 2318043183<br/>ОГРН 1162366056830",
				"footer2": "ООО “Недвекс” является разработчиком <br> программного обеспечения",
				"footer3": "Все права защищены. 2025",
				"docs": "Документы"
			}
		},
		"epics": {
			"addedToCollections1": "{{buildingName}} добавлен в подборки",
			"removeFromCollections1": "{{buildingName}} удалён из подборок",
			"addedToCollections2": "{{buildingName}} добавлен в подборку «{{collectionName}}»",
			"removeFromCollections2": "{{buildingName}} удалён из подбороки «{{collectionName}}»",
			"emptyFieldsError": "Не заполнены обязательные поля",
			"fieldsError": "Поля заполнены некорректно",
			"savedInfo": "Информация сохранена",
			"leavedFromAgency": "Вы вышли из агентства",
			"leaveAgencyError": "Не удалось выйти из агентства",
			"deletedCollection": "Подборка удалена",
			"registrationSuccessTitle": "Заявка успешно отправлена!",
			"registrationSuccessSubtitle": "Спасибо! Наш менеджер свяжется с вами для уточнения информации",
			"addedToFavorites": "{{buildingName}} добавлен в избранное",
			"deleteFromFavorites": "{{buildingName}} удалён из избранного",
			"loadCalendarError": "Не удалось записаться. Попробуйте зайти позже",
			"loadAppointmentStatusesError": "Не удалось перейти в Мои записи. Попробуйте зайти позже"
		},
		"utils": {
			"formatDate": {
				"today": "Сегодня",
				"yesterday": "Вчера"
			},
			"getTarifName": {
				"company": "Агентский",
				"personal": "Индивидуальный",
				"test": "Тестовый"
			},
			"getTarifPeriodName": {
				"company": "Оплаченный",
				"test": "Тестовый"
			},
			"monthToString": {
				"0": "января",
				"1": "февраля",
				"2": "марта",
				"3": "апреля",
				"4": "мая",
				"5": "июня",
				"6": "июля",
				"7": "августа",
				"8": "сентября",
				"9": "октября",
				"10": "ноября",
				"11": "декабря"
			},
			"updateString": {
				"todayAt": "Сегодня в {{time}}"
			}
		}
	};

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(2378);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	module.exports = curry;
	
	/*
	  function add(a, b, c) {
	    return a + b + c;
	  }
	  curry(add)(1)(2)(3); // 6
	  curry(add)(1)(2)(2); // 5
	  curry(add)(2)(4, 3); // 9
	
	  function add(...args) {
	    return args.reduce((sum, n) => sum + n, 0)
	  }
	  var curryAdd4 = curry(add, 4)
	  curryAdd4(1)(2, 3)(4); // 10
	
	  function converter(ratio, input) {
	    return (input*ratio).toFixed(1);
	  }
	  const curriedConverter = curry(converter)
	  const milesToKm = curriedConverter(1.62);
	  milesToKm(35); // 56.7
	  milesToKm(10); // 16.2
	*/
	
	function curry(fn, arity) {
	  return function curried() {
	    if (arity == null) {
	      arity = fn.length;
	    }
	    var args = [].slice.call(arguments);
	    if (args.length >= arity) {
	      return fn.apply(this, args);
	    } else {
	      return function() {
	        return curried.apply(this, args.concat([].slice.call(arguments)));
	      };
	    }
	  };
	}


/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity]
	 *  The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  result[key] = value;
	});
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = keyBy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(114)(module)))

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119),
	    root = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1697),
	    hashDelete = __webpack_require__(1698),
	    hashGet = __webpack_require__(1699),
	    hashHas = __webpack_require__(1700),
	    hashSet = __webpack_require__(1701);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119),
	    root = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119),
	    root = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(357),
	    setCacheAdd = __webpack_require__(1723),
	    setCacheHas = __webpack_require__(1724);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(119),
	    root = __webpack_require__(83);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(243),
	    eq = __webpack_require__(175);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(103);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(573),
	    keys = __webpack_require__(363);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1656),
	    isArray = __webpack_require__(75);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(147),
	    isObjectLike = __webpack_require__(120);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    equalArrays = __webpack_require__(579),
	    equalByTag = __webpack_require__(1689),
	    equalObjects = __webpack_require__(1690),
	    getTag = __webpack_require__(582),
	    isArray = __webpack_require__(75),
	    isBuffer = __webpack_require__(249),
	    isTypedArray = __webpack_require__(252);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    baseIsEqual = __webpack_require__(244);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(250),
	    isMasked = __webpack_require__(1705),
	    isObject = __webpack_require__(103),
	    toSource = __webpack_require__(588);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(147),
	    isLength = __webpack_require__(362),
	    isObjectLike = __webpack_require__(120);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1670),
	    baseMatchesProperty = __webpack_require__(1671),
	    identity = __webpack_require__(361),
	    isArray = __webpack_require__(75),
	    property = __webpack_require__(1748);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(103),
	    isPrototype = __webpack_require__(246),
	    nativeKeysIn = __webpack_require__(1719);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1665),
	    getMatchData = __webpack_require__(1692),
	    matchesStrictComparable = __webpack_require__(584);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(244),
	    get = __webpack_require__(589),
	    hasIn = __webpack_require__(1738),
	    isKey = __webpack_require__(360),
	    isStrictComparable = __webpack_require__(583),
	    matchesStrictComparable = __webpack_require__(584),
	    toKey = __webpack_require__(174);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    assignMergeValue = __webpack_require__(572),
	    baseFor = __webpack_require__(573),
	    baseMergeDeep = __webpack_require__(1673),
	    isObject = __webpack_require__(103),
	    keysIn = __webpack_require__(591),
	    safeGet = __webpack_require__(586);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(572),
	    cloneBuffer = __webpack_require__(1683),
	    cloneTypedArray = __webpack_require__(1684),
	    copyArray = __webpack_require__(577),
	    initCloneObject = __webpack_require__(1702),
	    isArguments = __webpack_require__(248),
	    isArray = __webpack_require__(75),
	    isArrayLikeObject = __webpack_require__(1739),
	    isBuffer = __webpack_require__(249),
	    isFunction = __webpack_require__(250),
	    isObject = __webpack_require__(103),
	    isPlainObject = __webpack_require__(1743),
	    isTypedArray = __webpack_require__(252),
	    safeGet = __webpack_require__(586),
	    toPlainObject = __webpack_require__(1751);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(574);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(361),
	    overRest = __webpack_require__(1722),
	    setToString = __webpack_require__(1726);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1733),
	    defineProperty = __webpack_require__(578),
	    identity = __webpack_require__(361);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(241),
	    arrayMap = __webpack_require__(571),
	    isArray = __webpack_require__(75),
	    isSymbol = __webpack_require__(251);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(569);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(83);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module)))

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1682);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1658),
	    baseAssignValue = __webpack_require__(243);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(83);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1676),
	    isIterateeCall = __webpack_require__(1703);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(241),
	    Uint8Array = __webpack_require__(569),
	    eq = __webpack_require__(175),
	    equalArrays = __webpack_require__(579),
	    mapToArray = __webpack_require__(1716),
	    setToArray = __webpack_require__(1725);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1691);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1661),
	    getSymbols = __webpack_require__(1694),
	    keys = __webpack_require__(363);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(583),
	    keys = __webpack_require__(363);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(241);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1655),
	    stubArray = __webpack_require__(1749);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(576),
	    isArguments = __webpack_require__(248),
	    isArray = __webpack_require__(75),
	    isIndex = __webpack_require__(359),
	    isLength = __webpack_require__(362),
	    toKey = __webpack_require__(174);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(247);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(247);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(247);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(247);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1659),
	    getPrototype = __webpack_require__(581),
	    isPrototype = __webpack_require__(246);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(175),
	    isArrayLike = __webpack_require__(176),
	    isIndex = __webpack_require__(359),
	    isObject = __webpack_require__(103);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1686);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(242);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(242);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(242);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(242);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1649),
	    ListCache = __webpack_require__(240),
	    Map = __webpack_require__(356);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(245);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(245);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(245);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(245);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1746);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(585);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(580);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module)))

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1654);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1677),
	    shortOut = __webpack_require__(1727);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(240);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(240),
	    Map = __webpack_require__(356),
	    MapCache = __webpack_require__(357);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1745).runInContext();
	module.exports = __webpack_require__(1735)(_, _);


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(1736),
	    fallbackHolder = __webpack_require__(1737);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1662),
	    hasPath = __webpack_require__(1696);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(176),
	    isObjectLike = __webpack_require__(120);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(575),
	    getTag = __webpack_require__(582),
	    isArguments = __webpack_require__(248),
	    isArray = __webpack_require__(75),
	    isArrayLike = __webpack_require__(176),
	    isBuffer = __webpack_require__(249),
	    isPrototype = __webpack_require__(246),
	    isTypedArray = __webpack_require__(252);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(244);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(147),
	    getPrototype = __webpack_require__(581),
	    isObjectLike = __webpack_require__(120);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(114)(module)))

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
	 */
	;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function e(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
	return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!(null==n||!n.length)&&-1<v(n,t,0)}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
	return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function _(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function v(n,t,r){if(t===t)n:{--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=_(n,d,r);return n}function g(n,t,r,e){
	--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function d(n){return n!==n}function y(n,t){var r=null==n?0:n.length;return r?m(n,t)/r:F}function b(n){return function(t){return null==t?T:t[n]}}function x(n){return function(t){return null==n?T:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function w(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function m(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==T&&(r=r===T?i:r+i)}return r;
	}function A(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function E(n,t){return c(t,function(t){return[t,n[t]]})}function k(n){return function(t){return n(t)}}function S(n,t){return c(t,function(t){return n[t]})}function O(n,t){return n.has(t)}function I(n,t){for(var r=-1,e=n.length;++r<e&&-1<v(t,n[r],0););return r}function R(n,t){for(var r=n.length;r--&&-1<v(t,n[r],0););return r}function z(n){return"\\"+Un[n]}function W(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n];
	}),r}function B(n,t){return function(r){return n(t(r))}}function L(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function U(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function C(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function D(n){if(Rn.test(n)){for(var t=On.lastIndex=0;On.test(n);)++t;n=t}else n=Qn(n);return n}function M(n){return Rn.test(n)?n.match(On)||[]:n.split("");
	}var T,$=1/0,F=NaN,N=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],P=/\b__p\+='';/g,Z=/\b(__p\+=)''\+/g,q=/(__e\(.*?\)|\b__t\))\+'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,K=/[&<>"']/g,G=RegExp(V.source),H=RegExp(K.source),J=/<%-([\s\S]+?)%>/g,Y=/<%([\s\S]+?)%>/g,Q=/<%=([\s\S]+?)%>/g,X=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,nn=/^\w*$/,tn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,rn=/[\\^$.*+?()[\]{}|]/g,en=RegExp(rn.source),un=/^\s+|\s+$/g,on=/^\s+/,fn=/\s+$/,cn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,an=/\{\n\/\* \[wrapped with (.+)\] \*/,ln=/,? & /,sn=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,hn=/\\(\\)?/g,pn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,_n=/\w*$/,vn=/^[-+]0x[0-9a-f]+$/i,gn=/^0b[01]+$/i,dn=/^\[object .+?Constructor\]$/,yn=/^0o[0-7]+$/i,bn=/^(?:0|[1-9]\d*)$/,xn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,jn=/($^)/,wn=/['\n\r\u2028\u2029\\]/g,mn="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",An="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+mn,En="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",kn=RegExp("['\u2019]","g"),Sn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),On=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+En+mn,"g"),In=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",An].join("|"),"g"),Rn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),zn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Wn="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Bn={};
	Bn["[object Float32Array]"]=Bn["[object Float64Array]"]=Bn["[object Int8Array]"]=Bn["[object Int16Array]"]=Bn["[object Int32Array]"]=Bn["[object Uint8Array]"]=Bn["[object Uint8ClampedArray]"]=Bn["[object Uint16Array]"]=Bn["[object Uint32Array]"]=true,Bn["[object Arguments]"]=Bn["[object Array]"]=Bn["[object ArrayBuffer]"]=Bn["[object Boolean]"]=Bn["[object DataView]"]=Bn["[object Date]"]=Bn["[object Error]"]=Bn["[object Function]"]=Bn["[object Map]"]=Bn["[object Number]"]=Bn["[object Object]"]=Bn["[object RegExp]"]=Bn["[object Set]"]=Bn["[object String]"]=Bn["[object WeakMap]"]=false;
	var Ln={};Ln["[object Arguments]"]=Ln["[object Array]"]=Ln["[object ArrayBuffer]"]=Ln["[object DataView]"]=Ln["[object Boolean]"]=Ln["[object Date]"]=Ln["[object Float32Array]"]=Ln["[object Float64Array]"]=Ln["[object Int8Array]"]=Ln["[object Int16Array]"]=Ln["[object Int32Array]"]=Ln["[object Map]"]=Ln["[object Number]"]=Ln["[object Object]"]=Ln["[object RegExp]"]=Ln["[object Set]"]=Ln["[object String]"]=Ln["[object Symbol]"]=Ln["[object Uint8Array]"]=Ln["[object Uint8ClampedArray]"]=Ln["[object Uint16Array]"]=Ln["[object Uint32Array]"]=true,
	Ln["[object Error]"]=Ln["[object Function]"]=Ln["[object WeakMap]"]=false;var Un={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Cn=parseFloat,Dn=parseInt,Mn=typeof global=="object"&&global&&global.Object===Object&&global,Tn=typeof self=="object"&&self&&self.Object===Object&&self,$n=Mn||Tn||Function("return this")(),Fn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Nn=Fn&&typeof module=="object"&&module&&!module.nodeType&&module,Pn=Nn&&Nn.exports===Fn,Zn=Pn&&Mn.process,qn=function(){
	try{var n=Nn&&Nn.f&&Nn.f("util").types;return n?n:Zn&&Zn.binding&&Zn.binding("util")}catch(n){}}(),Vn=qn&&qn.isArrayBuffer,Kn=qn&&qn.isDate,Gn=qn&&qn.isMap,Hn=qn&&qn.isRegExp,Jn=qn&&qn.isSet,Yn=qn&&qn.isTypedArray,Qn=b("length"),Xn=x({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I",
	"\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C",
	"\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i",
	"\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r",
	"\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij",
	"\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"}),nt=x({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),tt=x({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),rt=function x(mn){function An(n){if(yu(n)&&!ff(n)&&!(n instanceof Un)){if(n instanceof On)return n;if(oi.call(n,"__wrapped__"))return Fe(n)}return new On(n)}function En(){}function On(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=T}function Un(n){this.__wrapped__=n,
	this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Mn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Fn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Fn;++t<r;)this.add(n[t]);
	}function Zn(n){this.size=(this.__data__=new Tn(n)).size}function qn(n,t){var r,e=ff(n),u=!e&&of(n),i=!e&&!u&&af(n),o=!e&&!u&&!i&&_f(n),u=(e=e||u||i||o)?A(n.length,ni):[],f=u.length;for(r in n)!t&&!oi.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Se(r,f))||u.push(r);return u}function Qn(n){var t=n.length;return t?n[ir(0,t-1)]:T}function et(n,t){return De(Ur(n),pt(t,0,n.length))}function ut(n){return De(Ur(n))}function it(n,t,r){(r===T||lu(n[t],r))&&(r!==T||t in n)||st(n,t,r);
	}function ot(n,t,r){var e=n[t];oi.call(n,t)&&lu(e,r)&&(r!==T||t in n)||st(n,t,r)}function ft(n,t){for(var r=n.length;r--;)if(lu(n[r][0],t))return r;return-1}function ct(n,t,r,e){return uo(n,function(n,u,i){t(e,n,r(n),i)}),e}function at(n,t){return n&&Cr(t,Wu(t),n)}function lt(n,t){return n&&Cr(t,Bu(t),n)}function st(n,t,r){"__proto__"==t&&Ai?Ai(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function ht(n,t){for(var r=-1,e=t.length,u=Ku(e),i=null==n;++r<e;)u[r]=i?T:Ru(n,t[r]);return u;
	}function pt(n,t,r){return n===n&&(r!==T&&(n=n<=r?n:r),t!==T&&(n=n>=t?n:t)),n}function _t(n,t,e,u,i,o){var f,c=1&t,a=2&t,l=4&t;if(e&&(f=i?e(n,u,i,o):e(n)),f!==T)return f;if(!du(n))return n;if(u=ff(n)){if(f=me(n),!c)return Ur(n,f)}else{var s=vo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(af(n))return Ir(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Ae(n),!c)return a?Mr(n,lt(f,n)):Dr(n,at(f,n))}else{if(!Ln[s])return i?n:{};f=Ee(n,s,c)}}if(o||(o=new Zn),
	i=o.get(n))return i;o.set(n,f),pf(n)?n.forEach(function(r){f.add(_t(r,t,e,r,n,o))}):sf(n)&&n.forEach(function(r,u){f.set(u,_t(r,t,e,u,n,o))});var a=l?a?ve:_e:a?Bu:Wu,p=u?T:a(n);return r(p||n,function(r,u){p&&(u=r,r=n[u]),ot(f,u,_t(r,t,e,u,n,o))}),f}function vt(n){var t=Wu(n);return function(r){return gt(r,n,t)}}function gt(n,t,r){var e=r.length;if(null==n)return!e;for(n=Qu(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===T&&!(u in n)||!i(o))return false}return true}function dt(n,t,r){if(typeof n!="function")throw new ti("Expected a function");
	return bo(function(){n.apply(T,r)},t)}function yt(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;if(!l)return s;r&&(t=c(t,k(r))),e?(i=f,a=false):200<=t.length&&(i=O,a=false,t=new Nn(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function bt(n,t){var r=true;return uo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function xt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===T?o===o&&!wu(o):r(o,f)))var f=o,c=i;
	}return c}function jt(n,t){var r=[];return uo(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function wt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=ke),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?wt(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function mt(n,t){return n&&oo(n,t,Wu)}function At(n,t){return n&&fo(n,t,Wu)}function Et(n,t){return i(t,function(t){return _u(n[t])})}function kt(n,t){t=Sr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[Me(t[r++])];return r&&r==e?n:T}function St(n,t,r){return t=t(n),
	ff(n)?t:a(t,r(n))}function Ot(n){if(null==n)n=n===T?"[object Undefined]":"[object Null]";else if(mi&&mi in Qu(n)){var t=oi.call(n,mi),r=n[mi];try{n[mi]=T;var e=true}catch(n){}var u=ai.call(n);e&&(t?n[mi]=r:delete n[mi]),n=u}else n=ai.call(n);return n}function It(n,t){return n>t}function Rt(n,t){return null!=n&&oi.call(n,t)}function zt(n,t){return null!=n&&t in Qu(n)}function Wt(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=Ku(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,k(t))),s=Ci(p.length,s),
	l[a]=!r&&(t||120<=u&&120<=p.length)?new Nn(a&&p):T}var p=n[0],_=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;if(v?!O(v,d):!e(h,d,r)){for(a=i;--a;){var y=l[a];if(y?!O(y,d):!e(n[a],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Bt(n,t,r){var e={};return mt(n,function(n,u,i){t(e,r(n),u,i)}),e}function Lt(t,r,e){return r=Sr(r,t),t=2>r.length?t:kt(t,hr(r,0,-1)),r=null==t?t:t[Me(Ve(r))],null==r?T:n(r,t,e)}function Ut(n){return yu(n)&&"[object Arguments]"==Ot(n)}function Ct(n){
	return yu(n)&&"[object ArrayBuffer]"==Ot(n)}function Dt(n){return yu(n)&&"[object Date]"==Ot(n)}function Mt(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!yu(n)&&!yu(t))t=n!==n&&t!==t;else n:{var i=ff(n),o=ff(t),f=i?"[object Array]":vo(n),c=o?"[object Array]":vo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&af(n)){if(!af(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Zn),t=i||_f(n)?se(n,t,r,e,Mt,u):he(n,t,f,r,e,Mt,u);else{
	if(!(1&r)&&(i=a&&oi.call(n,"__wrapped__"),f=o&&oi.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Zn),t=Mt(n,t,r,e,u);break n}if(c)t:if(u||(u=new Zn),i=1&r,f=_e(n),o=f.length,c=_e(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:oi.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===T?h!==p&&!Mt(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l);
	}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Tt(n){return yu(n)&&"[object Map]"==vo(n)}function $t(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=Qu(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===T&&!(c in n))return false;
	}else{if(f=new Zn,e)var s=e(a,l,c,n,t,f);if(s===T?!Mt(l,a,3,e,f):!s)return false}}return true}function Ft(n){return!(!du(n)||ci&&ci in n)&&(_u(n)?hi:dn).test(Te(n))}function Nt(n){return yu(n)&&"[object RegExp]"==Ot(n)}function Pt(n){return yu(n)&&"[object Set]"==vo(n)}function Zt(n){return yu(n)&&gu(n.length)&&!!Bn[Ot(n)]}function qt(n){return typeof n=="function"?n:null==n?$u:typeof n=="object"?ff(n)?Jt(n[0],n[1]):Ht(n):Zu(n)}function Vt(n){if(!ze(n))return Li(n);var t,r=[];for(t in Qu(n))oi.call(n,t)&&"constructor"!=t&&r.push(t);
	return r}function Kt(n,t){return n<t}function Gt(n,t){var r=-1,e=su(n)?Ku(n.length):[];return uo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Ht(n){var t=xe(n);return 1==t.length&&t[0][2]?We(t[0][0],t[0][1]):function(r){return r===n||$t(r,n,t)}}function Jt(n,t){return Ie(n)&&t===t&&!du(t)?We(Me(n),t):function(r){var e=Ru(r,n);return e===T&&e===t?zu(r,n):Mt(t,e,3)}}function Yt(n,t,r,e,u){n!==t&&oo(t,function(i,o){if(u||(u=new Zn),du(i)){var f=u,c=Le(n,o),a=Le(t,o),l=f.get(a);if(l)it(n,o,l);else{
	var l=e?e(c,a,o+"",n,t,f):T,s=l===T;if(s){var h=ff(a),p=!h&&af(a),_=!h&&!p&&_f(a),l=a;h||p||_?ff(c)?l=c:hu(c)?l=Ur(c):p?(s=false,l=Ir(a,true)):_?(s=false,l=zr(a,true)):l=[]:xu(a)||of(a)?(l=c,of(c)?l=Ou(c):du(c)&&!_u(c)||(l=Ae(a))):s=false}s&&(f.set(a,l),Yt(l,a,r,e,f),f.delete(a)),it(n,o,l)}}else f=e?e(Le(n,o),i,o+"",n,t,u):T,f===T&&(f=i),it(n,o,f)},Bu)}function Qt(n,t){var r=n.length;if(r)return t+=0>t?r:0,Se(t,r)?n[t]:T}function Xt(n,t,r){var e=-1;return t=c(t.length?t:[$u],k(ye())),n=Gt(n,function(n){return{
	a:c(t,function(t){return t(n)}),b:++e,c:n}}),w(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Wr(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);break n}}e=n.b-t.b}return e})}function nr(n,t){return tr(n,t,function(t,r){return zu(n,r)})}function tr(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=kt(n,o);r(f,o)&&lr(i,Sr(o,n),f)}return i}function rr(n){return function(t){return kt(t,n)}}function er(n,t,r,e){var u=e?g:v,i=-1,o=t.length,f=n;for(n===t&&(t=Ur(t)),
	r&&(f=c(n,k(r)));++i<o;)for(var a=0,l=t[i],l=r?r(l):l;-1<(a=u(f,l,a,e));)f!==n&&xi.call(f,a,1),xi.call(n,a,1);return n}function ur(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];if(r==e||u!==i){var i=u;Se(u)?xi.call(n,u,1):xr(n,u)}}}function ir(n,t){return n+Ii(Ti()*(t-n+1))}function or(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=Ii(t/2))&&(n+=n);while(t);return r}function fr(n,t){return xo(Be(n,t,$u),n+"")}function cr(n){return Qn(Uu(n))}function ar(n,t){var r=Uu(n);
	return De(r,pt(t,0,r.length))}function lr(n,t,r,e){if(!du(n))return n;t=Sr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=Me(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):T;a===T&&(a=du(l)?l:Se(t[u+1])?[]:{})}ot(f,c,a),f=f[c]}return n}function sr(n){return De(Uu(n))}function hr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Ku(u);++e<u;)r[e]=n[e+t];return r}function pr(n,t){var r;return uo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}
	function _r(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!wu(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return vr(n,t,$u,r)}function vr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=wu(t),a=t===T;u<i;){var l=Ii((u+i)/2),s=r(n[l]),h=s!==T,p=null===s,_=s===s,v=wu(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Ci(i,4294967294)}function gr(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){
	var o=n[r],f=t?t(o):o;if(!r||!lu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function dr(n){return typeof n=="number"?n:wu(n)?F:+n}function yr(n){if(typeof n=="string")return n;if(ff(n))return c(n,yr)+"";if(wu(n))return ro?ro.call(n):"";var t=n+"";return"0"==t&&1/n==-$?"-0":t}function br(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(200<=i){if(u=t?null:so(n))return U(u);c=false,u=O,l=new Nn}else l=t?[]:a;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(c&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;
	t&&l.push(h),a.push(s)}else u(l,h,r)||(l!==a&&l.push(h),a.push(s))}return a}function xr(n,t){return t=Sr(t,n),n=2>t.length?n:kt(n,hr(t,0,-1)),null==n||delete n[Me(Ve(t))]}function jr(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?hr(n,e?0:i,e?i+1:u):hr(n,e?i+1:0,e?u:i)}function wr(n,t){var r=n;return r instanceof Un&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mr(n,t,r){var e=n.length;if(2>e)return e?br(n[0]):[];for(var u=-1,i=Ku(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=yt(i[u]||o,n[f],t,r));
	return br(wt(i,1),t,r)}function Ar(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:T);return o}function Er(n){return hu(n)?n:[]}function kr(n){return typeof n=="function"?n:$u}function Sr(n,t){return ff(n)?n:Ie(n,t)?[n]:jo(Iu(n))}function Or(n,t,r){var e=n.length;return r=r===T?e:r,!t&&r>=e?n:hr(n,t,r)}function Ir(n,t){if(t)return n.slice();var r=n.length,r=gi?gi(r):new n.constructor(r);return n.copy(r),r}function Rr(n){var t=new n.constructor(n.byteLength);return new vi(t).set(new vi(n)),
	t}function zr(n,t){return new n.constructor(t?Rr(n.buffer):n.buffer,n.byteOffset,n.length)}function Wr(n,t){if(n!==t){var r=n!==T,e=null===n,u=n===n,i=wu(n),o=t!==T,f=null===t,c=t===t,a=wu(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Br(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Ui(i-o,0),l=Ku(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];
	return l}function Lr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Ui(i-f,0),s=Ku(l+a);for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Ur(n,t){var r=-1,e=n.length;for(t||(t=Ku(e));++r<e;)t[r]=n[r];return t}function Cr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):T;c===T&&(c=n[f]),u?st(r,f,c):ot(r,f,c)}return r}function Dr(n,t){return Cr(n,po(n),t)}function Mr(n,t){return Cr(n,_o(n),t);
	}function Tr(n,r){return function(e,u){var i=ff(e)?t:ct,o=r?r():{};return i(e,n,ye(u,2),o)}}function $r(n){return fr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:T,o=2<u?r[2]:T,i=3<n.length&&typeof i=="function"?(u--,i):T;for(o&&Oe(r[0],r[1],o)&&(i=3>u?T:i,u=1),t=Qu(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Fr(n,t){return function(r,e){if(null==r)return r;if(!su(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=Qu(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function Nr(n){return function(t,r,e){
	var u=-1,i=Qu(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break}return t}}function Pr(n,t,r){function e(){return(this&&this!==$n&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Vr(n);return e}function Zr(n){return function(t){t=Iu(t);var r=Rn.test(t)?M(t):T,e=r?r[0]:t.charAt(0);return t=r?Or(r,1).join(""):t.slice(1),e[n]()+t}}function qr(n){return function(t){return l(Mu(Du(t).replace(kn,"")),n,"")}}function Vr(n){return function(){var t=arguments;switch(t.length){
	case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=eo(n.prototype),t=n.apply(r,t);return du(t)?t:r}}function Kr(t,r,e){function u(){for(var o=arguments.length,f=Ku(o),c=o,a=de(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:L(f,a),
	o-=c.length,o<e?ue(t,r,Jr,u.placeholder,T,f,c,T,T,e-o):n(this&&this!==$n&&this instanceof u?i:t,this,f)}var i=Vr(t);return u}function Gr(n){return function(t,r,e){var u=Qu(t);if(!su(t)){var i=ye(r,3);t=Wu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:T}}function Hr(n){return pe(function(t){var r=t.length,e=r,u=On.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ti("Expected a function");if(u&&!o&&"wrapper"==ge(i))var o=new On([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=ge(i),f="wrapper"==u?ho(i):T,o=f&&Re(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[ge(f[0])].apply(o,f[3]):1==i.length&&Re(i)?o[u]():o.thru(i);
	return function(){var n=arguments,e=n[0];if(o&&1==n.length&&ff(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Jr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Ku(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=de(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Br(y,e,u,_)),i&&(y=Lr(y,i,o,_)),d-=x,_&&d<a)return j=L(y,j),ue(n,t,Jr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Ci(f.length,x),m=Ur(y);w--;){
	var A=f[w];y[w]=Se(A,x)?m[A]:T}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==$n&&this instanceof l&&(b=g||Vr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?T:Vr(n);return l}function Yr(n,t){return function(r,e){return Bt(r,n,t(e))}}function Qr(n,t){return function(r,e){var u;if(r===T&&e===T)return t;if(r!==T&&(u=r),e!==T){if(u===T)return e;typeof r=="string"||typeof e=="string"?(r=yr(r),e=yr(e)):(r=dr(r),e=dr(e)),u=n(r,e)}return u}}function Xr(t){return pe(function(r){
	return r=c(r,k(ye())),fr(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ne(n,t){t=t===T?" ":yr(t);var r=t.length;return 2>r?r?or(t,n):t:(r=or(t,Oi(n/D(t))),Rn.test(t)?Or(M(r),0,n).join(""):r.slice(0,n))}function te(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=Ku(l+c),h=this&&this!==$n&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];return n(h,o?e:this,s)}var o=1&r,f=Vr(t);return i}function re(n){return function(t,r,e){
	e&&typeof e!="number"&&Oe(t,r,e)&&(r=e=T),t=Au(t),r===T?(r=t,t=0):r=Au(r),e=e===T?t<r?1:-1:Au(e);var u=-1;r=Ui(Oi((r-t)/(e||1)),0);for(var i=Ku(r);r--;)i[n?r:++u]=t,t+=e;return i}}function ee(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Su(t),r=Su(r)),n(t,r)}}function ue(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:T;o=l?T:o;var h=l?i:T;return i=l?T:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(T,u),Re(n)&&yo(r,u),r.placeholder=e,Ue(r,n,t)}function ie(n){
	var t=Yu[n];return function(n,r){if(n=Su(n),(r=null==r?0:Ci(Eu(r),292))&&Wi(n)){var e=(Iu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(Iu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function oe(n){return function(t){var r=vo(t);return"[object Map]"==r?W(t):"[object Set]"==r?C(t):E(t,n(t))}}function fe(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ti("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=T),o=o===T?o:Ui(Eu(o),0),f=f===T?f:Eu(f),a-=u?u.length:0,
	64&t){var l=e,s=u;e=u=T}var h=c?T:ho(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Br(e,r,h[4]):r,i[4]=e?L(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Lr(e,r,h[6]):r,i[6]=e?L(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Ci(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],
	t=i[1],r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===T?c?0:n.length:Ui(i[9]-a,0),!f&&24&t&&(t&=-25),Ue((h?co:yo)(t&&1!=t?8==t||16==t?Kr(n,t,f):32!=t&&33!=t||u.length?Jr.apply(T,i):te(n,t,r,e):Pr(n,t,r),i),n,t)}function ce(n,t,r,e){return n===T||lu(n,ei[r])&&!oi.call(e,r)?t:n}function ae(n,t,r,e,u,i){return du(n)&&du(t)&&(i.set(t,n),Yt(n,t,T,ae,i),i.delete(t)),n}function le(n){return xu(n)?T:n}function se(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;
	var c=-1,a=true,l=2&r?new Nn:T;for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],p=t[c];if(e)var _=o?e(p,s,c,t,n,i):e(s,p,c,n,t,i);if(_!==T){if(_)continue;a=false;break}if(l){if(!h(t,function(n,t){if(!O(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==p&&!u(s,p,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function he(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":
	if(n.byteLength!=t.byteLength||!i(new vi(n),new vi(t)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return lu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=W;case"[object Set]":if(f||(f=U),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=se(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(to)return to.call(n)==to.call(t)}
	return false}function pe(n){return xo(Be(n,T,Ze),n+"")}function _e(n){return St(n,Wu,po)}function ve(n){return St(n,Bu,_o)}function ge(n){for(var t=n.name+"",r=Gi[t],e=oi.call(Gi,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function de(n){return(oi.call(An,"placeholder")?An:n).placeholder}function ye(){var n=An.iteratee||Fu,n=n===Fu?qt:n;return arguments.length?n(arguments[0],arguments[1]):n}function be(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
	}function xe(n){for(var t=Wu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!du(u)]}return t}function je(n,t){var r=null==n?T:n[t];return Ft(r)?r:T}function we(n,t,r){t=Sr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=Me(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&gu(u)&&Se(o,u)&&(ff(n)||of(n)))}function me(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&oi.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ae(n){
	return typeof n.constructor!="function"||ze(n)?{}:eo(di(n))}function Ee(n,t,r){var e=n.constructor;switch(t){case"[object ArrayBuffer]":return Rr(n);case"[object Boolean]":case"[object Date]":return new e(+n);case"[object DataView]":return t=r?Rr(n.buffer):n.buffer,new n.constructor(t,n.byteOffset,n.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
	case"[object Uint16Array]":case"[object Uint32Array]":return zr(n,r);case"[object Map]":return new e;case"[object Number]":case"[object String]":return new e(n);case"[object RegExp]":return t=new n.constructor(n.source,_n.exec(n)),t.lastIndex=n.lastIndex,t;case"[object Set]":return new e;case"[object Symbol]":return to?Qu(to.call(n)):{}}}function ke(n){return ff(n)||of(n)||!!(ji&&n&&n[ji])}function Se(n,t){var r=typeof n;return t=null==t?9007199254740991:t,!!t&&("number"==r||"symbol"!=r&&bn.test(n))&&-1<n&&0==n%1&&n<t;
	}function Oe(n,t,r){if(!du(r))return false;var e=typeof t;return!!("number"==e?su(r)&&Se(t,r.length):"string"==e&&t in r)&&lu(r[t],n)}function Ie(n,t){if(ff(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!wu(n))||(nn.test(n)||!X.test(n)||null!=t&&n in Qu(t))}function Re(n){var t=ge(n),r=An[t];return typeof r=="function"&&t in Un.prototype&&(n===r||(t=ho(r),!!t&&n===t[0]))}function ze(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||ei)}function We(n,t){
	return function(r){return null!=r&&(r[n]===t&&(t!==T||n in Qu(r)))}}function Be(t,r,e){return r=Ui(r===T?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Ui(u.length-r,0),f=Ku(o);++i<o;)f[i]=u[r+i];for(i=-1,o=Ku(r+1);++i<r;)o[i]=u[i];return o[r]=e(f),n(t,this,o)}}function Le(n,t){if(("constructor"!==t||"function"!=typeof n[t])&&"__proto__"!=t)return n[t]}function Ue(n,t,r){var e=t+"";t=xo;var u,i=$e;return u=(u=e.match(an))?u[1].split(ln):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],
	r=r.join(2<i?", ":" "),e=e.replace(cn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Ce(n){var t=0,r=0;return function(){var e=Di(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(T,arguments)}}function De(n,t){var r=-1,e=n.length,u=e-1;for(t=t===T?e:t;++r<t;){var e=ir(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function Me(n){if(typeof n=="string"||wu(n))return n;var t=n+"";return"0"==t&&1/n==-$?"-0":t}function Te(n){if(null!=n){try{return ii.call(n)}catch(n){}
	return n+""}return""}function $e(n,t){return r(N,function(r){var e="_."+r[0];t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function Fe(n){if(n instanceof Un)return n.clone();var t=new On(n.__wrapped__,n.__chain__);return t.__actions__=Ur(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ne(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Eu(r),0>r&&(r=Ui(e+r,0)),_(n,ye(t,3),r)):-1}function Pe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==T&&(u=Eu(r),u=0>r?Ui(e+u,0):Ci(u,e-1)),
	_(n,ye(t,3),u,true)}function Ze(n){return(null==n?0:n.length)?wt(n,1):[]}function qe(n){return n&&n.length?n[0]:T}function Ve(n){var t=null==n?0:n.length;return t?n[t-1]:T}function Ke(n,t){return n&&n.length&&t&&t.length?er(n,t):n}function Ge(n){return null==n?n:$i.call(n)}function He(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){if(hu(n))return t=Ui(n.length,t),true}),A(t,function(t){return c(n,b(t))})}function Je(t,r){if(!t||!t.length)return[];var e=He(t);return null==r?e:c(e,function(t){
	return n(r,T,t)})}function Ye(n){return n=An(n),n.__chain__=true,n}function Qe(n,t){return t(n)}function Xe(){return this}function nu(n,t){return(ff(n)?r:uo)(n,ye(t,3))}function tu(n,t){return(ff(n)?e:io)(n,ye(t,3))}function ru(n,t){return(ff(n)?c:Gt)(n,ye(t,3))}function eu(n,t,r){return t=r?T:t,t=n&&null==t?n.length:t,fe(n,128,T,T,T,T,t)}function uu(n,t){var r;if(typeof t!="function")throw new ti("Expected a function");return n=Eu(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=T),
	r}}function iu(n,t,r){return t=r?T:t,n=fe(n,8,T,T,T,T,T,t),n.placeholder=iu.placeholder,n}function ou(n,t,r){return t=r?T:t,n=fe(n,16,T,T,T,T,T,t),n.placeholder=ou.placeholder,n}function fu(n,t,r){function e(t){var r=c,e=a;return c=a=T,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===T||r>=t||0>r||g&&n>=l}function i(){var n=Go();if(u(n))return o(n);var r,e=bo;r=n-_,n=t-(n-p),r=g?Ci(n,l-r):n,h=e(i,r)}function o(n){return h=T,d&&c?e(n):(c=a=T,s)}function f(){var n=Go(),r=u(n);if(c=arguments,
	a=this,p=n,r){if(h===T)return _=n=p,h=bo(i,t),v?e(n):s;if(g)return lo(h),h=bo(i,t),e(p)}return h===T&&(h=bo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ti("Expected a function");return t=Su(t)||0,du(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Ui(Su(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==T&&lo(h),_=0,c=p=a=h=T},f.flush=function(){return h===T?s:o(Go())},f}function cu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;
	return i.has(u)?i.get(u):(e=n.apply(this,e),r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ti("Expected a function");return r.cache=new(cu.Cache||Fn),r}function au(n){if(typeof n!="function")throw new ti("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function lu(n,t){return n===t||n!==n&&t!==t;
	}function su(n){return null!=n&&gu(n.length)&&!_u(n)}function hu(n){return yu(n)&&su(n)}function pu(n){if(!yu(n))return false;var t=Ot(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!xu(n)}function _u(n){return!!du(n)&&(n=Ot(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function vu(n){return typeof n=="number"&&n==Eu(n)}function gu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n;
	}function du(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function yu(n){return null!=n&&typeof n=="object"}function bu(n){return typeof n=="number"||yu(n)&&"[object Number]"==Ot(n)}function xu(n){return!(!yu(n)||"[object Object]"!=Ot(n))&&(n=di(n),null===n||(n=oi.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&ii.call(n)==li))}function ju(n){return typeof n=="string"||!ff(n)&&yu(n)&&"[object String]"==Ot(n)}function wu(n){return typeof n=="symbol"||yu(n)&&"[object Symbol]"==Ot(n);
	}function mu(n){if(!n)return[];if(su(n))return ju(n)?M(n):Ur(n);if(wi&&n[wi]){n=n[wi]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=vo(n),("[object Map]"==t?W:"[object Set]"==t?U:Uu)(n)}function Au(n){return n?(n=Su(n),n===$||n===-$?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Eu(n){n=Au(n);var t=n%1;return n===n?t?n-t:n:0}function ku(n){return n?pt(Eu(n),0,4294967295):0}function Su(n){if(typeof n=="number")return n;if(wu(n))return F;if(du(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,
	n=du(n)?n+"":n),typeof n!="string")return 0===n?n:+n;n=n.replace(un,"");var t=gn.test(n);return t||yn.test(n)?Dn(n.slice(2),t?2:8):vn.test(n)?F:+n}function Ou(n){return Cr(n,Bu(n))}function Iu(n){return null==n?"":yr(n)}function Ru(n,t,r){return n=null==n?T:kt(n,t),n===T?r:n}function zu(n,t){return null!=n&&we(n,t,zt)}function Wu(n){return su(n)?qn(n):Vt(n)}function Bu(n){if(su(n))n=qn(n,true);else if(du(n)){var t,r=ze(n),e=[];for(t in n)("constructor"!=t||!r&&oi.call(n,t))&&e.push(t);n=e}else{if(t=[],
	null!=n)for(r in Qu(n))t.push(r);n=t}return n}function Lu(n,t){if(null==n)return{};var r=c(ve(n),function(n){return[n]});return t=ye(t),tr(n,r,function(n,r){return t(n,r[0])})}function Uu(n){return null==n?[]:S(n,Wu(n))}function Cu(n){return $f(Iu(n).toLowerCase())}function Du(n){return(n=Iu(n))&&n.replace(xn,Xn).replace(Sn,"")}function Mu(n,t,r){return n=Iu(n),t=r?T:t,t===T?zn.test(n)?n.match(In)||[]:n.match(sn)||[]:n.match(t)||[]}function Tu(n){return function(){return n}}function $u(n){return n;
	}function Fu(n){return qt(typeof n=="function"?n:_t(n,1))}function Nu(n,t,e){var u=Wu(t),i=Et(t,u);null!=e||du(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=Et(t,Wu(t)));var o=!(du(e)&&"chain"in e&&!e.chain),f=_u(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Ur(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function Pu(){}
	function Zu(n){return Ie(n)?b(Me(n)):rr(n)}function qu(){return[]}function Vu(){return false}mn=null==mn?$n:rt.defaults($n.Object(),mn,rt.pick($n,Wn));var Ku=mn.Array,Gu=mn.Date,Hu=mn.Error,Ju=mn.Function,Yu=mn.Math,Qu=mn.Object,Xu=mn.RegExp,ni=mn.String,ti=mn.TypeError,ri=Ku.prototype,ei=Qu.prototype,ui=mn["__core-js_shared__"],ii=Ju.prototype.toString,oi=ei.hasOwnProperty,fi=0,ci=function(){var n=/[^.]+$/.exec(ui&&ui.keys&&ui.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),ai=ei.toString,li=ii.call(Qu),si=$n._,hi=Xu("^"+ii.call(oi).replace(rn,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pi=Pn?mn.Buffer:T,_i=mn.Symbol,vi=mn.Uint8Array,gi=pi?pi.g:T,di=B(Qu.getPrototypeOf,Qu),yi=Qu.create,bi=ei.propertyIsEnumerable,xi=ri.splice,ji=_i?_i.isConcatSpreadable:T,wi=_i?_i.iterator:T,mi=_i?_i.toStringTag:T,Ai=function(){
	try{var n=je(Qu,"defineProperty");return n({},"",{}),n}catch(n){}}(),Ei=mn.clearTimeout!==$n.clearTimeout&&mn.clearTimeout,ki=Gu&&Gu.now!==$n.Date.now&&Gu.now,Si=mn.setTimeout!==$n.setTimeout&&mn.setTimeout,Oi=Yu.ceil,Ii=Yu.floor,Ri=Qu.getOwnPropertySymbols,zi=pi?pi.isBuffer:T,Wi=mn.isFinite,Bi=ri.join,Li=B(Qu.keys,Qu),Ui=Yu.max,Ci=Yu.min,Di=Gu.now,Mi=mn.parseInt,Ti=Yu.random,$i=ri.reverse,Fi=je(mn,"DataView"),Ni=je(mn,"Map"),Pi=je(mn,"Promise"),Zi=je(mn,"Set"),qi=je(mn,"WeakMap"),Vi=je(Qu,"create"),Ki=qi&&new qi,Gi={},Hi=Te(Fi),Ji=Te(Ni),Yi=Te(Pi),Qi=Te(Zi),Xi=Te(qi),no=_i?_i.prototype:T,to=no?no.valueOf:T,ro=no?no.toString:T,eo=function(){
	function n(){}return function(t){return du(t)?yi?yi(t):(n.prototype=t,t=new n,n.prototype=T,t):{}}}();An.templateSettings={escape:J,evaluate:Y,interpolate:Q,variable:"",imports:{_:An}},An.prototype=En.prototype,An.prototype.constructor=An,On.prototype=eo(En.prototype),On.prototype.constructor=On,Un.prototype=eo(En.prototype),Un.prototype.constructor=Un,Mn.prototype.clear=function(){this.__data__=Vi?Vi(null):{},this.size=0},Mn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
	this.size-=n?1:0,n},Mn.prototype.get=function(n){var t=this.__data__;return Vi?(n=t[n],"__lodash_hash_undefined__"===n?T:n):oi.call(t,n)?t[n]:T},Mn.prototype.has=function(n){var t=this.__data__;return Vi?t[n]!==T:oi.call(t,n)},Mn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Vi&&t===T?"__lodash_hash_undefined__":t,this},Tn.prototype.clear=function(){this.__data__=[],this.size=0},Tn.prototype.delete=function(n){var t=this.__data__;return n=ft(t,n),!(0>n)&&(n==t.length-1?t.pop():xi.call(t,n,1),
	--this.size,true)},Tn.prototype.get=function(n){var t=this.__data__;return n=ft(t,n),0>n?T:t[n][1]},Tn.prototype.has=function(n){return-1<ft(this.__data__,n)},Tn.prototype.set=function(n,t){var r=this.__data__,e=ft(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Fn.prototype.clear=function(){this.size=0,this.__data__={hash:new Mn,map:new(Ni||Tn),string:new Mn}},Fn.prototype.delete=function(n){return n=be(this,n).delete(n),this.size-=n?1:0,n},Fn.prototype.get=function(n){return be(this,n).get(n);
	},Fn.prototype.has=function(n){return be(this,n).has(n)},Fn.prototype.set=function(n,t){var r=be(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},Nn.prototype.add=Nn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},Nn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.clear=function(){this.__data__=new Tn,this.size=0},Zn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Zn.prototype.get=function(n){
	return this.__data__.get(n)},Zn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Tn){var e=r.__data__;if(!Ni||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Fn(e)}return r.set(n,t),this.size=r.size,this};var uo=Fr(mt),io=Fr(At,true),oo=Nr(),fo=Nr(true),co=Ki?function(n,t){return Ki.set(n,t),n}:$u,ao=Ai?function(n,t){return Ai(n,"toString",{configurable:true,enumerable:false,value:Tu(t),writable:true})}:$u,lo=Ei||function(n){
	return $n.clearTimeout(n)},so=Zi&&1/U(new Zi([,-0]))[1]==$?function(n){return new Zi(n)}:Pu,ho=Ki?function(n){return Ki.get(n)}:Pu,po=Ri?function(n){return null==n?[]:(n=Qu(n),i(Ri(n),function(t){return bi.call(n,t)}))}:qu,_o=Ri?function(n){for(var t=[];n;)a(t,po(n)),n=di(n);return t}:qu,vo=Ot;(Fi&&"[object DataView]"!=vo(new Fi(new ArrayBuffer(1)))||Ni&&"[object Map]"!=vo(new Ni)||Pi&&"[object Promise]"!=vo(Pi.resolve())||Zi&&"[object Set]"!=vo(new Zi)||qi&&"[object WeakMap]"!=vo(new qi))&&(vo=function(n){
	var t=Ot(n);if(n=(n="[object Object]"==t?n.constructor:T)?Te(n):"")switch(n){case Hi:return"[object DataView]";case Ji:return"[object Map]";case Yi:return"[object Promise]";case Qi:return"[object Set]";case Xi:return"[object WeakMap]"}return t});var go=ui?_u:Vu,yo=Ce(co),bo=Si||function(n,t){return $n.setTimeout(n,t)},xo=Ce(ao),jo=function(n){n=cu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(tn,function(n,r,e,u){
	t.push(e?u.replace(hn,"$1"):r||n)}),t}),wo=fr(function(n,t){return hu(n)?yt(n,wt(t,1,hu,true)):[]}),mo=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),ye(r,2)):[]}),Ao=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),T,r):[]}),Eo=fr(function(n){var t=c(n,Er);return t.length&&t[0]===n[0]?Wt(t):[]}),ko=fr(function(n){var t=Ve(n),r=c(n,Er);return t===Ve(r)?t=T:r.pop(),r.length&&r[0]===n[0]?Wt(r,ye(t,2)):[]}),So=fr(function(n){var t=Ve(n),r=c(n,Er);return(t=typeof t=="function"?t:T)&&r.pop(),
	r.length&&r[0]===n[0]?Wt(r,T,t):[]}),Oo=fr(Ke),Io=pe(function(n,t){var r=null==n?0:n.length,e=ht(n,t);return ur(n,c(t,function(n){return Se(n,r)?+n:n}).sort(Wr)),e}),Ro=fr(function(n){return br(wt(n,1,hu,true))}),zo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),br(wt(n,1,hu,true),ye(t,2))}),Wo=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return br(wt(n,1,hu,true),T,t)}),Bo=fr(function(n,t){return hu(n)?yt(n,t):[]}),Lo=fr(function(n){return mr(i(n,hu))}),Uo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),
	mr(i(n,hu),ye(t,2))}),Co=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return mr(i(n,hu),T,t)}),Do=fr(He),Mo=fr(function(n){var t=n.length,t=1<t?n[t-1]:T,t=typeof t=="function"?(n.pop(),t):T;return Je(n,t)}),To=pe(function(n){function t(t){return ht(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Un&&Se(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:Qe,args:[t],thisArg:T}),new On(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(T),
	n})):this.thru(t)}),$o=Tr(function(n,t,r){oi.call(n,r)?++n[r]:st(n,r,1)}),Fo=Gr(Ne),No=Gr(Pe),Po=Tr(function(n,t,r){oi.call(n,r)?n[r].push(t):st(n,r,[t])}),Zo=fr(function(t,r,e){var u=-1,i=typeof r=="function",o=su(t)?Ku(t.length):[];return uo(t,function(t){o[++u]=i?n(r,t,e):Lt(t,r,e)}),o}),qo=Tr(function(n,t,r){st(n,r,t)}),Vo=Tr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ko=fr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&Oe(n,t[0],t[1])?t=[]:2<r&&Oe(t[0],t[1],t[2])&&(t=[t[0]]),
	Xt(n,wt(t,1),[])}),Go=ki||function(){return $n.Date.now()},Ho=fr(function(n,t,r){var e=1;if(r.length)var u=L(r,de(Ho)),e=32|e;return fe(n,e,t,r,u)}),Jo=fr(function(n,t,r){var e=3;if(r.length)var u=L(r,de(Jo)),e=32|e;return fe(t,e,n,r,u)}),Yo=fr(function(n,t){return dt(n,1,t)}),Qo=fr(function(n,t,r){return dt(n,Su(t)||0,r)});cu.Cache=Fn;var Xo=fr(function(t,r){r=1==r.length&&ff(r[0])?c(r[0],k(ye())):c(wt(r,1),k(ye()));var e=r.length;return fr(function(u){for(var i=-1,o=Ci(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);
	return n(t,this,u)})}),nf=fr(function(n,t){return fe(n,32,T,t,L(t,de(nf)))}),tf=fr(function(n,t){return fe(n,64,T,t,L(t,de(tf)))}),rf=pe(function(n,t){return fe(n,256,T,T,T,t)}),ef=ee(It),uf=ee(function(n,t){return n>=t}),of=Ut(function(){return arguments}())?Ut:function(n){return yu(n)&&oi.call(n,"callee")&&!bi.call(n,"callee")},ff=Ku.isArray,cf=Vn?k(Vn):Ct,af=zi||Vu,lf=Kn?k(Kn):Dt,sf=Gn?k(Gn):Tt,hf=Hn?k(Hn):Nt,pf=Jn?k(Jn):Pt,_f=Yn?k(Yn):Zt,vf=ee(Kt),gf=ee(function(n,t){return n<=t}),df=$r(function(n,t){
	if(ze(t)||su(t))Cr(t,Wu(t),n);else for(var r in t)oi.call(t,r)&&ot(n,r,t[r])}),yf=$r(function(n,t){Cr(t,Bu(t),n)}),bf=$r(function(n,t,r,e){Cr(t,Bu(t),n,e)}),xf=$r(function(n,t,r,e){Cr(t,Wu(t),n,e)}),jf=pe(ht),wf=fr(function(n,t){n=Qu(n);var r=-1,e=t.length,u=2<e?t[2]:T;for(u&&Oe(t[0],t[1],u)&&(e=1);++r<e;)for(var u=t[r],i=Bu(u),o=-1,f=i.length;++o<f;){var c=i[o],a=n[c];(a===T||lu(a,ei[c])&&!oi.call(n,c))&&(n[c]=u[c])}return n}),mf=fr(function(t){return t.push(T,ae),n(Of,T,t)}),Af=Yr(function(n,t,r){
	null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),n[t]=r},Tu($u)),Ef=Yr(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),oi.call(n,t)?n[t].push(r):n[t]=[r]},ye),kf=fr(Lt),Sf=$r(function(n,t,r){Yt(n,t,r)}),Of=$r(function(n,t,r,e){Yt(n,t,r,e)}),If=pe(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=Sr(t,n),e||(e=1<t.length),t}),Cr(n,ve(n),r),e&&(r=_t(r,7,le));for(var u=t.length;u--;)xr(r,t[u]);return r}),Rf=pe(function(n,t){return null==n?{}:nr(n,t);
	}),zf=oe(Wu),Wf=oe(Bu),Bf=qr(function(n,t,r){return t=t.toLowerCase(),n+(r?Cu(t):t)}),Lf=qr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Uf=qr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Cf=Zr("toLowerCase"),Df=qr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Mf=qr(function(n,t,r){return n+(r?" ":"")+$f(t)}),Tf=qr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),$f=Zr("toUpperCase"),Ff=fr(function(t,r){try{return n(t,T,r)}catch(n){return pu(n)?n:new Hu(n)}}),Nf=pe(function(n,t){
	return r(t,function(t){t=Me(t),st(n,t,Ho(n[t],n))}),n}),Pf=Hr(),Zf=Hr(true),qf=fr(function(n,t){return function(r){return Lt(r,n,t)}}),Vf=fr(function(n,t){return function(r){return Lt(n,r,t)}}),Kf=Xr(c),Gf=Xr(u),Hf=Xr(h),Jf=re(),Yf=re(true),Qf=Qr(function(n,t){return n+t},0),Xf=ie("ceil"),nc=Qr(function(n,t){return n/t},1),tc=ie("floor"),rc=Qr(function(n,t){return n*t},1),ec=ie("round"),uc=Qr(function(n,t){return n-t},0);return An.after=function(n,t){if(typeof t!="function")throw new ti("Expected a function");
	return n=Eu(n),function(){if(1>--n)return t.apply(this,arguments)}},An.ary=eu,An.assign=df,An.assignIn=yf,An.assignInWith=bf,An.assignWith=xf,An.at=jf,An.before=uu,An.bind=Ho,An.bindAll=Nf,An.bindKey=Jo,An.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return ff(n)?n:[n]},An.chain=Ye,An.chunk=function(n,t,r){if(t=(r?Oe(n,t,r):t===T)?1:Ui(Eu(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Ku(Oi(r/t));e<r;)i[u++]=hr(n,e,e+=t);return i},An.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){
	var i=n[t];i&&(u[e++]=i)}return u},An.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Ku(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return a(ff(r)?Ur(r):[r],wt(t,1))},An.cond=function(t){var r=null==t?0:t.length,e=ye();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new ti("Expected a function");return[e(n[0]),n[1]]}):[],fr(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})},An.conforms=function(n){return vt(_t(n,1))},An.constant=Tu,
	An.countBy=$o,An.create=function(n,t){var r=eo(n);return null==t?r:at(r,t)},An.curry=iu,An.curryRight=ou,An.debounce=fu,An.defaults=wf,An.defaultsDeep=mf,An.defer=Yo,An.delay=Qo,An.difference=wo,An.differenceBy=mo,An.differenceWith=Ao,An.drop=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),hr(n,0>t?0:t,e)):[]},An.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),t=e-t,hr(n,0,0>t?0:t)):[]},An.dropRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true,true):[];
	},An.dropWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true):[]},An.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&Oe(n,t,r)&&(r=0,e=u),u=n.length,r=Eu(r),0>r&&(r=-r>u?0:u+r),e=e===T||e>u?u:Eu(e),0>e&&(e+=u),e=r>e?0:ku(e);r<e;)n[r++]=t;return n},An.filter=function(n,t){return(ff(n)?i:jt)(n,ye(t,3))},An.flatMap=function(n,t){return wt(ru(n,t),1)},An.flatMapDeep=function(n,t){return wt(ru(n,t),$)},An.flatMapDepth=function(n,t,r){return r=r===T?1:Eu(r),
	wt(ru(n,t),r)},An.flatten=Ze,An.flattenDeep=function(n){return(null==n?0:n.length)?wt(n,$):[]},An.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===T?1:Eu(t),wt(n,t)):[]},An.flip=function(n){return fe(n,512)},An.flow=Pf,An.flowRight=Zf,An.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e},An.functions=function(n){return null==n?[]:Et(n,Wu(n))},An.functionsIn=function(n){return null==n?[]:Et(n,Bu(n))},An.groupBy=Po,An.initial=function(n){
	return(null==n?0:n.length)?hr(n,0,-1):[]},An.intersection=Eo,An.intersectionBy=ko,An.intersectionWith=So,An.invert=Af,An.invertBy=Ef,An.invokeMap=Zo,An.iteratee=Fu,An.keyBy=qo,An.keys=Wu,An.keysIn=Bu,An.map=ru,An.mapKeys=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,t(n,e,u),n)}),r},An.mapValues=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,e,t(n,e,u))}),r},An.matches=function(n){return Ht(_t(n,1))},An.matchesProperty=function(n,t){return Jt(n,_t(t,1))},An.memoize=cu,
	An.merge=Sf,An.mergeWith=Of,An.method=qf,An.methodOf=Vf,An.mixin=Nu,An.negate=au,An.nthArg=function(n){return n=Eu(n),fr(function(t){return Qt(t,n)})},An.omit=If,An.omitBy=function(n,t){return Lu(n,au(ye(t)))},An.once=function(n){return uu(2,n)},An.orderBy=function(n,t,r,e){return null==n?[]:(ff(t)||(t=null==t?[]:[t]),r=e?T:r,ff(r)||(r=null==r?[]:[r]),Xt(n,t,r))},An.over=Kf,An.overArgs=Xo,An.overEvery=Gf,An.overSome=Hf,An.partial=nf,An.partialRight=tf,An.partition=Vo,An.pick=Rf,An.pickBy=Lu,An.property=Zu,
	An.propertyOf=function(n){return function(t){return null==n?T:kt(n,t)}},An.pull=Oo,An.pullAll=Ke,An.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,ye(r,2)):n},An.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,T,r):n},An.pullAt=Io,An.range=Jf,An.rangeRight=Yf,An.rearg=rf,An.reject=function(n,t){return(ff(n)?i:jt)(n,au(ye(t,3)))},An.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=ye(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),
	u.push(e))}return ur(n,u),r},An.rest=function(n,t){if(typeof n!="function")throw new ti("Expected a function");return t=t===T?t:Eu(t),fr(n,t)},An.reverse=Ge,An.sampleSize=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:Eu(t),(ff(n)?et:ar)(n,t)},An.set=function(n,t,r){return null==n?n:lr(n,t,r)},An.setWith=function(n,t,r,e){return e=typeof e=="function"?e:T,null==n?n:lr(n,t,r,e)},An.shuffle=function(n){return(ff(n)?ut:sr)(n)},An.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Oe(n,t,r)?(t=0,
	r=e):(t=null==t?0:Eu(t),r=r===T?e:Eu(r)),hr(n,t,r)):[]},An.sortBy=Ko,An.sortedUniq=function(n){return n&&n.length?gr(n):[]},An.sortedUniqBy=function(n,t){return n&&n.length?gr(n,ye(t,2)):[]},An.split=function(n,t,r){return r&&typeof r!="number"&&Oe(n,t,r)&&(t=r=T),r=r===T?4294967295:r>>>0,r?(n=Iu(n))&&(typeof t=="string"||null!=t&&!hf(t))&&(t=yr(t),!t&&Rn.test(n))?Or(M(n),0,r):n.split(t,r):[]},An.spread=function(t,r){if(typeof t!="function")throw new ti("Expected a function");return r=null==r?0:Ui(Eu(r),0),
	fr(function(e){var u=e[r];return e=Or(e,0,r),u&&a(e,u),n(t,this,e)})},An.tail=function(n){var t=null==n?0:n.length;return t?hr(n,1,t):[]},An.take=function(n,t,r){return n&&n.length?(t=r||t===T?1:Eu(t),hr(n,0,0>t?0:t)):[]},An.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),t=e-t,hr(n,0>t?0:t,e)):[]},An.takeRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),false,true):[]},An.takeWhile=function(n,t){return n&&n.length?jr(n,ye(t,3)):[]},An.tap=function(n,t){return t(n),
	n},An.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ti("Expected a function");return du(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),fu(n,t,{leading:e,maxWait:t,trailing:u})},An.thru=Qe,An.toArray=mu,An.toPairs=zf,An.toPairsIn=Wf,An.toPath=function(n){return ff(n)?c(n,Me):wu(n)?[n]:Ur(jo(Iu(n)))},An.toPlainObject=Ou,An.transform=function(n,t,e){var u=ff(n),i=u||af(n)||_f(n);if(t=ye(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:du(n)&&_u(o)?eo(di(n)):{};
	}return(i?r:mt)(n,function(n,r,u){return t(e,n,r,u)}),e},An.unary=function(n){return eu(n,1)},An.union=Ro,An.unionBy=zo,An.unionWith=Wo,An.uniq=function(n){return n&&n.length?br(n):[]},An.uniqBy=function(n,t){return n&&n.length?br(n,ye(t,2)):[]},An.uniqWith=function(n,t){return t=typeof t=="function"?t:T,n&&n.length?br(n,T,t):[]},An.unset=function(n,t){return null==n||xr(n,t)},An.unzip=He,An.unzipWith=Je,An.update=function(n,t,r){return null==n?n:lr(n,t,kr(r)(kt(n,t)),void 0)},An.updateWith=function(n,t,r,e){
	return e=typeof e=="function"?e:T,null!=n&&(n=lr(n,t,kr(r)(kt(n,t)),e)),n},An.values=Uu,An.valuesIn=function(n){return null==n?[]:S(n,Bu(n))},An.without=Bo,An.words=Mu,An.wrap=function(n,t){return nf(kr(t),n)},An.xor=Lo,An.xorBy=Uo,An.xorWith=Co,An.zip=Do,An.zipObject=function(n,t){return Ar(n||[],t||[],ot)},An.zipObjectDeep=function(n,t){return Ar(n||[],t||[],lr)},An.zipWith=Mo,An.entries=zf,An.entriesIn=Wf,An.extend=yf,An.extendWith=bf,Nu(An,An),An.add=Qf,An.attempt=Ff,An.camelCase=Bf,An.capitalize=Cu,
	An.ceil=Xf,An.clamp=function(n,t,r){return r===T&&(r=t,t=T),r!==T&&(r=Su(r),r=r===r?r:0),t!==T&&(t=Su(t),t=t===t?t:0),pt(Su(n),t,r)},An.clone=function(n){return _t(n,4)},An.cloneDeep=function(n){return _t(n,5)},An.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,5,t)},An.cloneWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,4,t)},An.conformsTo=function(n,t){return null==t||gt(n,t,Wu(t))},An.deburr=Du,An.defaultTo=function(n,t){return null==n||n!==n?t:n},An.divide=nc,An.endsWith=function(n,t,r){
	n=Iu(n),t=yr(t);var e=n.length,e=r=r===T?e:pt(Eu(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},An.eq=lu,An.escape=function(n){return(n=Iu(n))&&H.test(n)?n.replace(K,nt):n},An.escapeRegExp=function(n){return(n=Iu(n))&&en.test(n)?n.replace(rn,"\\$&"):n},An.every=function(n,t,r){var e=ff(n)?u:bt;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.find=Fo,An.findIndex=Ne,An.findKey=function(n,t){return p(n,ye(t,3),mt)},An.findLast=No,An.findLastIndex=Pe,An.findLastKey=function(n,t){return p(n,ye(t,3),At);
	},An.floor=tc,An.forEach=nu,An.forEachRight=tu,An.forIn=function(n,t){return null==n?n:oo(n,ye(t,3),Bu)},An.forInRight=function(n,t){return null==n?n:fo(n,ye(t,3),Bu)},An.forOwn=function(n,t){return n&&mt(n,ye(t,3))},An.forOwnRight=function(n,t){return n&&At(n,ye(t,3))},An.get=Ru,An.gt=ef,An.gte=uf,An.has=function(n,t){return null!=n&&we(n,t,Rt)},An.hasIn=zu,An.head=qe,An.identity=$u,An.includes=function(n,t,r,e){return n=su(n)?n:Uu(n),r=r&&!e?Eu(r):0,e=n.length,0>r&&(r=Ui(e+r,0)),ju(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<v(n,t,r);
	},An.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Eu(r),0>r&&(r=Ui(e+r,0)),v(n,t,r)):-1},An.inRange=function(n,t,r){return t=Au(t),r===T?(r=t,t=0):r=Au(r),n=Su(n),n>=Ci(t,r)&&n<Ui(t,r)},An.invoke=kf,An.isArguments=of,An.isArray=ff,An.isArrayBuffer=cf,An.isArrayLike=su,An.isArrayLikeObject=hu,An.isBoolean=function(n){return true===n||false===n||yu(n)&&"[object Boolean]"==Ot(n)},An.isBuffer=af,An.isDate=lf,An.isElement=function(n){return yu(n)&&1===n.nodeType&&!xu(n)},An.isEmpty=function(n){
	if(null==n)return true;if(su(n)&&(ff(n)||typeof n=="string"||typeof n.splice=="function"||af(n)||_f(n)||of(n)))return!n.length;var t=vo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(ze(n))return!Vt(n).length;for(var r in n)if(oi.call(n,r))return false;return true},An.isEqual=function(n,t){return Mt(n,t)},An.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:T)?r(n,t):T;return e===T?Mt(n,t,T,r):!!e},An.isError=pu,An.isFinite=function(n){return typeof n=="number"&&Wi(n)},An.isFunction=_u,
	An.isInteger=vu,An.isLength=gu,An.isMap=sf,An.isMatch=function(n,t){return n===t||$t(n,t,xe(t))},An.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:T,$t(n,t,xe(t),r)},An.isNaN=function(n){return bu(n)&&n!=+n},An.isNative=function(n){if(go(n))throw new Hu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ft(n)},An.isNil=function(n){return null==n},An.isNull=function(n){return null===n},An.isNumber=bu,An.isObject=du,An.isObjectLike=yu,An.isPlainObject=xu,An.isRegExp=hf,
	An.isSafeInteger=function(n){return vu(n)&&-9007199254740991<=n&&9007199254740991>=n},An.isSet=pf,An.isString=ju,An.isSymbol=wu,An.isTypedArray=_f,An.isUndefined=function(n){return n===T},An.isWeakMap=function(n){return yu(n)&&"[object WeakMap]"==vo(n)},An.isWeakSet=function(n){return yu(n)&&"[object WeakSet]"==Ot(n)},An.join=function(n,t){return null==n?"":Bi.call(n,t)},An.kebabCase=Lf,An.last=Ve,An.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==T&&(u=Eu(r),u=0>u?Ui(e+u,0):Ci(u,e-1)),
	t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=_(n,d,u,true);return n},An.lowerCase=Uf,An.lowerFirst=Cf,An.lt=vf,An.lte=gf,An.max=function(n){return n&&n.length?xt(n,$u,It):T},An.maxBy=function(n,t){return n&&n.length?xt(n,ye(t,2),It):T},An.mean=function(n){return y(n,$u)},An.meanBy=function(n,t){return y(n,ye(t,2))},An.min=function(n){return n&&n.length?xt(n,$u,Kt):T},An.minBy=function(n,t){return n&&n.length?xt(n,ye(t,2),Kt):T},An.stubArray=qu,An.stubFalse=Vu,An.stubObject=function(){return{}},An.stubString=function(){
	return""},An.stubTrue=function(){return true},An.multiply=rc,An.nth=function(n,t){return n&&n.length?Qt(n,Eu(t)):T},An.noConflict=function(){return $n._===this&&($n._=si),this},An.noop=Pu,An.now=Go,An.pad=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return!t||e>=t?n:(t=(t-e)/2,ne(Ii(t),r)+n+ne(Oi(t),r))},An.padEnd=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return t&&e<t?n+ne(t-e,r):n},An.padStart=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return t&&e<t?ne(t-e,r)+n:n},An.parseInt=function(n,t,r){
	return r||null==t?t=0:t&&(t=+t),Mi(Iu(n).replace(on,""),t||0)},An.random=function(n,t,r){if(r&&typeof r!="boolean"&&Oe(n,t,r)&&(t=r=T),r===T&&(typeof t=="boolean"?(r=t,t=T):typeof n=="boolean"&&(r=n,n=T)),n===T&&t===T?(n=0,t=1):(n=Au(n),t===T?(t=n,n=0):t=Au(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Ti(),Ci(n+r*(t-n+Cn("1e-"+((r+"").length-1))),t)):ir(n,t)},An.reduce=function(n,t,r){var e=ff(n)?l:j,u=3>arguments.length;return e(n,ye(t,4),r,u,uo)},An.reduceRight=function(n,t,r){var e=ff(n)?s:j,u=3>arguments.length;
	return e(n,ye(t,4),r,u,io)},An.repeat=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:Eu(t),or(Iu(n),t)},An.replace=function(){var n=arguments,t=Iu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},An.result=function(n,t,r){t=Sr(t,n);var e=-1,u=t.length;for(u||(u=1,n=T);++e<u;){var i=null==n?T:n[Me(t[e])];i===T&&(e=u,i=r),n=_u(i)?i.call(n):i}return n},An.round=ec,An.runInContext=x,An.sample=function(n){return(ff(n)?Qn:cr)(n)},An.size=function(n){if(null==n)return 0;if(su(n))return ju(n)?D(n):n.length;
	var t=vo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Vt(n).length},An.snakeCase=Df,An.some=function(n,t,r){var e=ff(n)?h:pr;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.sortedIndex=function(n,t){return _r(n,t)},An.sortedIndexBy=function(n,t,r){return vr(n,t,ye(r,2))},An.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){var e=_r(n,t);if(e<r&&lu(n[e],t))return e}return-1},An.sortedLastIndex=function(n,t){return _r(n,t,true)},An.sortedLastIndexBy=function(n,t,r){return vr(n,t,ye(r,2),true);
	},An.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=_r(n,t,true)-1;if(lu(n[r],t))return r}return-1},An.startCase=Mf,An.startsWith=function(n,t,r){return n=Iu(n),r=null==r?0:pt(Eu(r),0,n.length),t=yr(t),n.slice(r,r+t.length)==t},An.subtract=uc,An.sum=function(n){return n&&n.length?m(n,$u):0},An.sumBy=function(n,t){return n&&n.length?m(n,ye(t,2)):0},An.template=function(n,t,r){var e=An.templateSettings;r&&Oe(n,t,r)&&(t=T),n=Iu(n),t=bf({},t,e,ce),r=bf({},t.imports,e.imports,ce);var u,i,o=Wu(r),f=S(r,o),c=0;
	r=t.interpolate||jn;var a="__p+='";r=Xu((t.escape||jn).source+"|"+r.source+"|"+(r===Q?pn:jn).source+"|"+(t.evaluate||jn).source+"|$","g");var l=oi.call(t,"sourceURL")?"//# sourceURL="+(t.sourceURL+"").replace(/[\r\n]/g," ")+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(wn,z),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=oi.call(t,"variable")&&t.variable)||(a="with(obj){"+a+"}"),
	a=(i?a.replace(P,""):a).replace(Z,"$1").replace(q,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Ff(function(){return Ju(o,l+"return "+a).apply(T,f)}),t.source=a,pu(t))throw t;return t},An.times=function(n,t){if(n=Eu(n),1>n||9007199254740991<n)return[];var r=4294967295,e=Ci(n,4294967295);for(t=ye(t),n-=4294967295,e=A(e,t);++r<n;)t(r);return e},An.toFinite=Au,
	An.toInteger=Eu,An.toLength=ku,An.toLower=function(n){return Iu(n).toLowerCase()},An.toNumber=Su,An.toSafeInteger=function(n){return n?pt(Eu(n),-9007199254740991,9007199254740991):0===n?n:0},An.toString=Iu,An.toUpper=function(n){return Iu(n).toUpperCase()},An.trim=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(un,""):n&&(t=yr(t))?(n=M(n),r=M(t),t=I(n,r),r=R(n,r)+1,Or(n,t,r).join("")):n},An.trimEnd=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(fn,""):n&&(t=yr(t))?(n=M(n),t=R(n,M(t))+1,
	Or(n,0,t).join("")):n},An.trimStart=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(on,""):n&&(t=yr(t))?(n=M(n),t=I(n,M(t)),Or(n,t).join("")):n},An.truncate=function(n,t){var r=30,e="...";if(du(t))var u="separator"in t?t.separator:u,r="length"in t?Eu(t.length):r,e="omission"in t?yr(t.omission):e;n=Iu(n);var i=n.length;if(Rn.test(n))var o=M(n),i=o.length;if(r>=i)return n;if(i=r-D(e),1>i)return e;if(r=o?Or(o,0,i).join(""):n.slice(0,i),u===T)return r+e;if(o&&(i+=r.length-i),hf(u)){if(n.slice(i).search(u)){
	var f=r;for(u.global||(u=Xu(u.source,Iu(_n.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===T?i:c)}}else n.indexOf(yr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},An.unescape=function(n){return(n=Iu(n))&&G.test(n)?n.replace(V,tt):n},An.uniqueId=function(n){var t=++fi;return Iu(n)+t},An.upperCase=Tf,An.upperFirst=$f,An.each=nu,An.eachRight=tu,An.first=qe,Nu(An,function(){var n={};return mt(An,function(t,r){oi.call(An.prototype,r)||(n[r]=t)}),n}(),{chain:false
	}),An.VERSION="4.17.15",r("bind bindKey curry curryRight partial partialRight".split(" "),function(n){An[n].placeholder=An}),r(["drop","take"],function(n,t){Un.prototype[n]=function(r){r=r===T?1:Ui(Eu(r),0);var e=this.__filtered__&&!t?new Un(this):this.clone();return e.__filtered__?e.__takeCount__=Ci(r,e.__takeCount__):e.__views__.push({size:Ci(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Un.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){
	var r=t+1,e=1==r||3==r;Un.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:ye(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){var r="take"+(t?"Right":"");Un.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Un.prototype[n]=function(){return this.__filtered__?new Un(this):this[r](1)}}),Un.prototype.compact=function(){return this.filter($u)},Un.prototype.find=function(n){
	return this.filter(n).head()},Un.prototype.findLast=function(n){return this.reverse().find(n)},Un.prototype.invokeMap=fr(function(n,t){return typeof n=="function"?new Un(this):this.map(function(r){return Lt(r,n,t)})}),Un.prototype.reject=function(n){return this.filter(au(ye(n)))},Un.prototype.slice=function(n,t){n=Eu(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Un(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==T&&(t=Eu(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Un.prototype.takeRightWhile=function(n){
	return this.reverse().takeWhile(n).reverse()},Un.prototype.toArray=function(){return this.take(4294967295)},mt(Un.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=An[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(An.prototype[t]=function(){function t(n){return n=u.apply(An,a([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Un,l=f[0],s=c||ff(o);s&&r&&typeof l=="function"&&1!=l.length&&(c=s=false);var h=this.__chain__,p=!!this.__actions__.length,l=i&&!h,c=c&&!p;
	return!i&&s?(o=c?o:new Un(this),o=n.apply(o,f),o.__actions__.push({func:Qe,args:[t],thisArg:T}),new On(o,h)):l&&c?n.apply(this,f):(o=this.thru(t),l?e?o.value()[0]:o.value():o)})}),r("pop push shift sort splice unshift".split(" "),function(n){var t=ri[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);An.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(ff(u)?u:[],n)}return this[r](function(r){return t.apply(ff(r)?r:[],n)});
	}}),mt(Un.prototype,function(n,t){var r=An[t];if(r){var e=r.name+"";oi.call(Gi,e)||(Gi[e]=[]),Gi[e].push({name:t,func:r})}}),Gi[Jr(T,2).name]=[{name:"wrapper",func:T}],Un.prototype.clone=function(){var n=new Un(this.__wrapped__);return n.__actions__=Ur(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Ur(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Ur(this.__views__),n},Un.prototype.reverse=function(){if(this.__filtered__){var n=new Un(this);
	n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Un.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=ff(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Ci(n,f+s);break;case"takeRight":f=Ui(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Ci(n,this.__takeCount__),!e||!u&&i==n&&l==n)return wr(t,this.__actions__);
	e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},An.prototype.at=To,An.prototype.chain=function(){return Ye(this)},An.prototype.commit=function(){return new On(this.value(),this.__chain__)},An.prototype.next=function(){this.__values__===T&&(this.__values__=mu(this.value()));var n=this.__index__>=this.__values__.length;return{done:n,value:n?T:this.__values__[this.__index__++]}},An.prototype.plant=function(n){
	for(var t,r=this;r instanceof En;){var e=Fe(r);e.__index__=0,e.__values__=T,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},An.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Un?(this.__actions__.length&&(n=new Un(this)),n=n.reverse(),n.__actions__.push({func:Qe,args:[Ge],thisArg:T}),new On(n,this.__chain__)):this.thru(Ge)},An.prototype.toJSON=An.prototype.valueOf=An.prototype.value=function(){return wr(this.__wrapped__,this.__actions__)},An.prototype.first=An.prototype.head,
	wi&&(An.prototype[wi]=Xe),An}(); true?($n._=rt, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return rt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Nn?((Nn.exports=rt)._=rt,Fn._=rt):$n._=rt}).call(this);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(114)(module)))

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(357);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1672),
	    createAssigner = __webpack_require__(1687);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1674),
	    basePropertyDeep = __webpack_require__(1675),
	    isKey = __webpack_require__(360),
	    toKey = __webpack_require__(174);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1685),
	    keysIn = __webpack_require__(591);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(1),_inheritsLoose=__webpack_require__(32),PropTypes=__webpack_require__(15),warning=__webpack_require__(306);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @providesModule UserAgent_DEPRECATED
	 */
	
	/**
	 *  Provides entirely client-side User Agent and OS detection. You should prefer
	 *  the non-deprecated UserAgent module when possible, which exposes our
	 *  authoritative server-side PHP-based detection to the client.
	 *
	 *  Usage is straightforward:
	 *
	 *    if (UserAgent_DEPRECATED.ie()) {
	 *      //  IE
	 *    }
	 *
	 *  You can also do version checks:
	 *
	 *    if (UserAgent_DEPRECATED.ie() >= 7) {
	 *      //  IE7 or better
	 *    }
	 *
	 *  The browser functions will return NaN if the browser does not match, so
	 *  you can also do version compares the other way:
	 *
	 *    if (UserAgent_DEPRECATED.ie() < 7) {
	 *      //  IE6 or worse
	 *    }
	 *
	 *  Note that the version is a float and may include a minor version number,
	 *  so you should always use range operators to perform comparisons, not
	 *  strict equality.
	 *
	 *  **Note:** You should **strongly** prefer capability detection to browser
	 *  version detection where it's reasonable:
	 *
	 *    http://www.quirksmode.org/js/support.html
	 *
	 *  Further, we have a large number of mature wrapper functions and classes
	 *  which abstract away many browser irregularities. Check the documentation,
	 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
	 *  another copy of "event || window.event".
	 *
	 */
	
	var _populated = false;
	
	// Browsers
	var _ie, _firefox, _opera, _webkit, _chrome;
	
	// Actual IE browser for compatibility mode
	var _ie_real_version;
	
	// Platforms
	var _osx, _windows, _linux, _android;
	
	// Architectures
	var _win64;
	
	// Devices
	var _iphone, _ipad, _native;
	
	var _mobile;
	
	function _populate() {
	  if (_populated) {
	    return;
	  }
	
	  _populated = true;
	
	  // To work around buggy JS libraries that can't handle multi-digit
	  // version numbers, Opera 10's user agent string claims it's Opera
	  // 9, then later includes a Version/X.Y field:
	  //
	  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
	  var uas = navigator.userAgent;
	  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
	  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
	
	  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
	  _ipad = /\b(iP[ao]d)/.exec(uas);
	  _android = /Android/i.exec(uas);
	  _native = /FBAN\/\w+;/i.exec(uas);
	  _mobile = /Mobile/i.exec(uas);
	
	  // Note that the IE team blog would have you believe you should be checking
	  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
	  // from either x64 or ia64;  so ultimately, you should just check for Win64
	  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
	  // Windows will send 'WOW64' instead.
	  _win64 = !!(/Win64/.exec(uas));
	
	  if (agent) {
	    _ie = agent[1] ? parseFloat(agent[1]) : (
	          agent[5] ? parseFloat(agent[5]) : NaN);
	    // IE compatibility mode
	    if (_ie && document && document.documentMode) {
	      _ie = document.documentMode;
	    }
	    // grab the "true" ie version from the trident token if available
	    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
	    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;
	
	    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
	    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
	    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
	    if (_webkit) {
	      // We do not add the regexp to the above test, because it will always
	      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
	      // the userAgent string.
	      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
	      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
	    } else {
	      _chrome = NaN;
	    }
	  } else {
	    _ie = _firefox = _opera = _chrome = _webkit = NaN;
	  }
	
	  if (os) {
	    if (os[1]) {
	      // Detect OS X version.  If no version number matches, set _osx to true.
	      // Version examples:  10, 10_6_1, 10.7
	      // Parses version number as a float, taking only first two sets of
	      // digits.  If only one set of digits is found, returns just the major
	      // version number.
	      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
	
	      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
	    } else {
	      _osx = false;
	    }
	    _windows = !!os[2];
	    _linux   = !!os[3];
	  } else {
	    _osx = _windows = _linux = false;
	  }
	}
	
	var UserAgent_DEPRECATED = {
	
	  /**
	   *  Check if the UA is Internet Explorer.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  ie: function() {
	    return _populate() || _ie;
	  },
	
	  /**
	   * Check if we're in Internet Explorer compatibility mode.
	   *
	   * @return bool true if in compatibility mode, false if
	   * not compatibility mode or not ie
	   */
	  ieCompatibilityMode: function() {
	    return _populate() || (_ie_real_version > _ie);
	  },
	
	
	  /**
	   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
	   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
	   * this when we don't need it -- tracked by #601957.
	   */
	  ie64: function() {
	    return UserAgent_DEPRECATED.ie() && _win64;
	  },
	
	  /**
	   *  Check if the UA is Firefox.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  firefox: function() {
	    return _populate() || _firefox;
	  },
	
	
	  /**
	   *  Check if the UA is Opera.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  opera: function() {
	    return _populate() || _opera;
	  },
	
	
	  /**
	   *  Check if the UA is WebKit.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  webkit: function() {
	    return _populate() || _webkit;
	  },
	
	  /**
	   *  For Push
	   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
	   */
	  safari: function() {
	    return UserAgent_DEPRECATED.webkit();
	  },
	
	  /**
	   *  Check if the UA is a Chrome browser.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  chrome : function() {
	    return _populate() || _chrome;
	  },
	
	
	  /**
	   *  Check if the user is running Windows.
	   *
	   *  @return bool `true' if the user's OS is Windows.
	   */
	  windows: function() {
	    return _populate() || _windows;
	  },
	
	
	  /**
	   *  Check if the user is running Mac OS X.
	   *
	   *  @return float|bool   Returns a float if a version number is detected,
	   *                       otherwise true/false.
	   */
	  osx: function() {
	    return _populate() || _osx;
	  },
	
	  /**
	   * Check if the user is running Linux.
	   *
	   * @return bool `true' if the user's OS is some flavor of Linux.
	   */
	  linux: function() {
	    return _populate() || _linux;
	  },
	
	  /**
	   * Check if the user is running on an iPhone or iPod platform.
	   *
	   * @return bool `true' if the user is running some flavor of the
	   *    iPhone OS.
	   */
	  iphone: function() {
	    return _populate() || _iphone;
	  },
	
	  mobile: function() {
	    return _populate() || (_iphone || _ipad || _android || _mobile);
	  },
	
	  nativeApp: function() {
	    // webviews inside of the native apps
	    return _populate() || _native;
	  },
	
	  android: function() {
	    return _populate() || _android;
	  },
	
	  ipad: function() {
	    return _populate() || _ipad;
	  }
	};
	
	module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(1753);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule normalizeWheel
	 * @typechecks
	 */
	
	'use strict';
	
	var UserAgent_DEPRECATED = __webpack_require__(1754);
	
	var isEventSupported = __webpack_require__(1755);
	
	
	// Reasonable defaults
	var PIXEL_STEP  = 10;
	var LINE_HEIGHT = 40;
	var PAGE_HEIGHT = 800;
	
	/**
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 */
	function normalizeWheel(/*object*/ event) /*object*/ {
	  var sX = 0, sY = 0,       // spinX, spinY
	      pX = 0, pY = 0;       // pixelX, pixelY
	
	  // Legacy
	  if ('detail'      in event) { sY = event.detail; }
	  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
	  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
	  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }
	
	  // side scrolling on FF with DOMMouseScroll
	  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	    sX = sY;
	    sY = 0;
	  }
	
	  pX = sX * PIXEL_STEP;
	  pY = sY * PIXEL_STEP;
	
	  if ('deltaY' in event) { pY = event.deltaY; }
	  if ('deltaX' in event) { pX = event.deltaX; }
	
	  if ((pX || pY) && event.deltaMode) {
	    if (event.deltaMode == 1) {          // delta in LINE units
	      pX *= LINE_HEIGHT;
	      pY *= LINE_HEIGHT;
	    } else {                             // delta in PAGE units
	      pX *= PAGE_HEIGHT;
	      pY *= PAGE_HEIGHT;
	    }
	  }
	
	  // Fall-back if spin cannot be determined
	  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
	  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }
	
	  return { spinX  : sX,
	           spinY  : sY,
	           pixelX : pX,
	           pixelY : pY };
	}
	
	
	/**
	 * The best combination if you prefer spinX + spinY normalization.  It favors
	 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	 * 'wheel' event, making spin speed determination impossible.
	 */
	normalizeWheel.getEventType = function() /*string*/ {
	  return (UserAgent_DEPRECATED.firefox())
	           ? 'DOMMouseScroll'
	           : (isEventSupported('wheel'))
	               ? 'wheel'
	               : 'mousewheel';
	};
	
	module.exports = normalizeWheel;


/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	var warn = "offline-plugin: runtime.install() was executed without OfflinePlugin being added to webpack.config.js. " +
	  "The installation of offline-plugin has not been performed. " +
	  "You can ignore this message if you are skipping the OfflinePlugin during development. " +
	  "Otherwise, you may have a configuration issue.";
	
	if (console.warn) {
	  console.warn(warn);
	} else if (console.log) {
	  console.log(warn);
	}
	
	exports.install = function() {};
	exports.applyUpdate = function() {};

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1759)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(594);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(594);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1764);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(149);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	var always = __webpack_require__(149);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry1 = __webpack_require__(11);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, Ramda's simple `map` function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xall = __webpack_require__(1840);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var curryN = __webpack_require__(51);
	var max = __webpack_require__(150);
	var pluck = __webpack_require__(181);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var curryN = __webpack_require__(51);
	var max = __webpack_require__(150);
	var pluck = __webpack_require__(181);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(1823);
	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xaperture = __webpack_require__(1841);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var apply = __webpack_require__(599);
	var curryN = __webpack_require__(51);
	var map = __webpack_require__(63);
	var max = __webpack_require__(150);
	var pluck = __webpack_require__(181);
	var reduce = __webpack_require__(87);
	var values = __webpack_require__(651);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var nAry = __webpack_require__(265);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isFunction = __webpack_require__(259);
	var and = __webpack_require__(597);
	var lift = __webpack_require__(264);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(256);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * `R.converge`: the left branch can produce a function while the right branch
	 * produces a value to be passed to that function as an argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(613);
	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(264);
	var not = __webpack_require__(635);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(641);
	var reverse = __webpack_require__(268);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry1 = __webpack_require__(11);
	var map = __webpack_require__(63);
	var max = __webpack_require__(150);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var constructN = __webpack_require__(603);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	 * least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(266);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(254);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var assoc = __webpack_require__(255);
	var dissoc = __webpack_require__(608);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @sig [String] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	  }
	});


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _dropLast = __webpack_require__(1825);
	var _xdropLast = __webpack_require__(1844);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _dropLastWhile = __webpack_require__(1826);
	var _xdropLastWhile = __webpack_require__(1845);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _dispatchable = __webpack_require__(37);
	var _xdropRepeatsWith = __webpack_require__(625);
	var dropRepeatsWith = __webpack_require__(610);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. `R.equals`
	 * is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xdropWhile = __webpack_require__(1846);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isFunction = __webpack_require__(259);
	var lift = __webpack_require__(264);
	var or = __webpack_require__(637);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xfind = __webpack_require__(1848);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xfindIndex = __webpack_require__(1849);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xfindLast = __webpack_require__(1850);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xfindLastIndex = __webpack_require__(1851);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _makeFlat = __webpack_require__(623);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(177);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(177);
	var _curry2 = __webpack_require__(3);
	var reduceBy = __webpack_require__(266);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all "equal" according to the provided equality function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of equal elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[idx], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _has = __webpack_require__(56);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(180);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	var add = __webpack_require__(254);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(266);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _indexOf = __webpack_require__(618);
	var _isArray = __webpack_require__(104);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(123);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Inserts the sub-list into the list, at index `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	var take = __webpack_require__(646);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(1824);
	var _functionName = __webpack_require__(1830);
	var _has = __webpack_require__(56);
	var identical = __webpack_require__(612);
	var keys = __webpack_require__(86);
	var type = __webpack_require__(378);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(1829);
	var _reduce = __webpack_require__(71);
	var _xfBase = __webpack_require__(42);
	var isArrayLike = __webpack_require__(179);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ }),
/* 1830 */
/***/ (function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(56);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(372);
	var _identity = __webpack_require__(374);
	var _isTransformer = __webpack_require__(375);
	var isArrayLike = __webpack_require__(179);
	var objOf = __webpack_require__(636);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _map = __webpack_require__(262);
	var _quote = __webpack_require__(1836);
	var _toISOString = __webpack_require__(1838);
	var keys = __webpack_require__(86);
	var reject = __webpack_require__(267);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _flatCat = __webpack_require__(1828);
	var map = __webpack_require__(63);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduce = __webpack_require__(71);
	var _xfBase = __webpack_require__(42);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(258);
	var _has = __webpack_require__(56);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduced = __webpack_require__(105);
	var _xfBase = __webpack_require__(42);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _curry2 = __webpack_require__(3);
	var _filter = __webpack_require__(617);
	var flip = __webpack_require__(257);
	var uniq = __webpack_require__(379);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.intersectionWith
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(373);
	var _curry3 = __webpack_require__(17);
	var uniqWith = __webpack_require__(380);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.intersection
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(177);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(613);
	var _curry3 = __webpack_require__(17);
	var _isTransformer = __webpack_require__(375);
	var _reduce = __webpack_require__(71);
	var _stepCat = __webpack_require__(1837);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _has = __webpack_require__(56);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Same as R.invertObj, however this accounts for objects with duplicate values
	 * by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys
	 * in an array.
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var keys = __webpack_require__(86);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var empty = __webpack_require__(611);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(178);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isArray = __webpack_require__(104);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var lens = __webpack_require__(263);
	var nth = __webpack_require__(180);
	var update = __webpack_require__(649);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var assocPath = __webpack_require__(600);
	var lens = __webpack_require__(263);
	var path = __webpack_require__(151);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var assoc = __webpack_require__(255);
	var lens = __webpack_require__(263);
	var prop = __webpack_require__(376);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * The mapAccum function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * The mapAccumRight function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to `mapAccum`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _reduce = __webpack_require__(71);
	var keys = __webpack_require__(86);
	
	
	/**
	 * An Object-specific version of `map`. The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * `map` instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isInteger = __webpack_require__(620);
	
	
	/**
	 * mathMod behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	 * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	 * when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var mean = __webpack_require__(632);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry1 = __webpack_require__(11);
	var _has = __webpack_require__(56);
	var toString = __webpack_require__(182);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      var count = 0;
	 *      var factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry1(function memoize(fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = toString(arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(372);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(372);
	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var mergeWithKey = __webpack_require__(633);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object. The key will be
	 * excluded from the returned object if the resulting value is `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see `mathMod`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(615);
	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xany = __webpack_require__(624);
	var any = __webpack_require__(598);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var curryN = __webpack_require__(51);
	var nth = __webpack_require__(180);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _of = __webpack_require__(1833);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _createPartialApplicator = __webpack_require__(616);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _createPartialApplicator = __webpack_require__(616);
	var flip = __webpack_require__(257);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(370);
	var juxt = __webpack_require__(628);
	var reject = __webpack_require__(267);
	
	
	/**
	 * Takes a predicate and a list or other "filterable" object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var equals = __webpack_require__(84);
	var path = __webpack_require__(151);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * `R.equals` terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var defaultTo = __webpack_require__(605);
	var path = __webpack_require__(151);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var path = __webpack_require__(151);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(602);
	var reverse = __webpack_require__(268);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(634);
	var reduce = __webpack_require__(87);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(262);
	var identity = __webpack_require__(371);
	var pickAll = __webpack_require__(639);
	var useWith = __webpack_require__(650);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var equals = __webpack_require__(84);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var is = __webpack_require__(627);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var _has = __webpack_require__(56);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _isNumber = __webpack_require__(621);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(258);
	var _reduce = __webpack_require__(71);
	var _reduced = __webpack_require__(105);
	
	
	/**
	 * Like `reduce`, `reduceWhile` returns a single item by iterating through
	 * the list, successively calling the iterator function. `reduceWhile` also
	 * takes a predicate that is evaluated before each step. If the predicate returns
	 * `false`, it "short-circuits" the iteration and returns the current value
	 * of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _reduced = __webpack_require__(105);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by reduceRight.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *      R.reduce(
	 *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	 *        0,
	 *        [1, 2, 3, 4, 5]) // 10
	 */
	
	module.exports = _curry1(_reduced);


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var always = __webpack_require__(149);
	var times = __webpack_require__(647);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Scan is similar to reduce, but returns a list of successively reduced values
	 * from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var always = __webpack_require__(149);
	var over = __webpack_require__(638);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(178);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var length = __webpack_require__(630);
	var slice = __webpack_require__(123);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var slice = __webpack_require__(123);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var concat = __webpack_require__(369);
	var difference = __webpack_require__(606);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var concat = __webpack_require__(369);
	var differenceWith = __webpack_require__(607);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var drop = __webpack_require__(609);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var _dispatchable = __webpack_require__(37);
	var _xtakeWhile = __webpack_require__(1855);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(614);
	var _curry2 = __webpack_require__(3);
	var _isRegExp = __webpack_require__(1831);
	var toString = __webpack_require__(182);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(178);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var _has = __webpack_require__(56);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(178);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(71);
	var _xwrap = __webpack_require__(626);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the `R.reduced` function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is R.identity. The init
	 * function can be used to provide an initial accumulator, but is ignored by
	 * transduce.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 * If some of the rows are shorter than the following rows, their elements are skipped:
	 *
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	var map = __webpack_require__(63);
	var sequence = __webpack_require__(644);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return sequence(of, map(f, traversable));
	});


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(85);
	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	var nAry = __webpack_require__(265);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var curryN = __webpack_require__(51);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry2 = __webpack_require__(3);
	var compose = __webpack_require__(368);
	var uniq = __webpack_require__(379);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(76);
	var _curry3 = __webpack_require__(17);
	var uniqWith = __webpack_require__(380);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      // coerceArray :: (a|[a]) -> [a]
	 *      var coerceArray = R.unless(R.isArrayLike, R.of);
	 *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	 *      coerceArray(1);         //=> [1]
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(374);
	var chain = __webpack_require__(367);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(11);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, map: function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	var equals = __webpack_require__(84);
	var map = __webpack_require__(63);
	var where = __webpack_require__(652);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in `R.equals` terms) as accessing that property of the spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(122);
	var _curry2 = __webpack_require__(3);
	var flip = __webpack_require__(257);
	var reject = __webpack_require__(267);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * `R.equals` is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(3);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(17);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(1960),r=__webpack_require__(2374);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1960 */
1308,
/* 1961 */
/***/ (function(module, exports) {

	/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
	
	var hasElementType = typeof Element !== 'undefined';
	var hasMap = typeof Map === 'function';
	var hasSet = typeof Set === 'function';
	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
	
	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
	
	function equal(a, b) {
	  // START: fast-deep-equal es6/index.js 3.1.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    // START: Modifications:
	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
	    //    to co-exist with es5.
	    // 2. Replace `for of` with es5 compliant iteration using `for`.
	    //    Basically, take:
	    //
	    //    ```js
	    //    for (i of a.entries())
	    //      if (!b.has(i[0])) return false;
	    //    ```
	    //
	    //    ... and convert to:
	    //
	    //    ```js
	    //    it = a.entries();
	    //    while (!(i = it.next()).done)
	    //      if (!b.has(i.value[0])) return false;
	    //    ```
	    //
	    //    **Note**: `i` access switches to `i.value`.
	    var it;
	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
	      return true;
	    }
	
	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      return true;
	    }
	    // END: Modifications
	
	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (a[i] !== b[i]) return false;
	      return true;
	    }
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	    // END: fast-deep-equal
	
	    // START: react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element) return false;
	
	    // custom handling for React/Preact
	    for (i = length; i-- !== 0;) {
	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner
	        // Preact-specific: avoid traversing Preact elements' __v and __o
	        //    __v = $_original / $_vnode
	        //    __o = $_owner
	        // These properties contain circular references and are not needed when
	        // comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of elements
	
	        continue;
	      }
	
	      // all other properties should be traversed as usual
	      if (!equal(a[keys[i]], b[keys[i]])) return false;
	    }
	    // END: react-fast-compare
	
	    // START: fast-deep-equal
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function isEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (((error.message || '').match(/stack|recursion/i))) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('react-fast-compare cannot handle circular refs');
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 1962 */
1308,
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_PureComponent) {
	      _inheritsLoose(SideEffect, _PureComponent);
	
	      function SideEffect() {
	        return _PureComponent.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.PureComponent);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.I18nextProvider = I18nextProvider;
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(152);
	
	function I18nextProvider(_ref) {
	  var i18n = _ref.i18n,
	      defaultNS = _ref.defaultNS,
	      children = _ref.children;
	  var value = (0, _react.useMemo)(function () {
	    return {
	      i18n: i18n,
	      defaultNS: defaultNS
	    };
	  }, [i18n, defaultNS]);
	  return (0, _react.createElement)(_context.I18nContext.Provider, {
	    value: value
	  }, children);
	}

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Trans = Trans;
	Object.defineProperty(exports, "nodesToString", {
	  enumerable: true,
	  get: function get() {
	    return _TransWithoutContext.nodesToString;
	  }
	});
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(183));
	
	var _react = __webpack_require__(1);
	
	var _TransWithoutContext = __webpack_require__(654);
	
	var _context = __webpack_require__(152);
	
	var _excluded = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function Trans(_ref) {
	  var children = _ref.children,
	      count = _ref.count,
	      parent = _ref.parent,
	      i18nKey = _ref.i18nKey,
	      context = _ref.context,
	      _ref$tOptions = _ref.tOptions,
	      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
	      values = _ref.values,
	      defaults = _ref.defaults,
	      components = _ref.components,
	      ns = _ref.ns,
	      i18nFromProps = _ref.i18n,
	      tFromProps = _ref.t,
	      shouldUnescape = _ref.shouldUnescape,
	      additionalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
	
	  var _ref2 = (0, _react.useContext)(_context.I18nContext) || {},
	      i18nFromContext = _ref2.i18n,
	      defaultNSFromContext = _ref2.defaultNS;
	
	  var i18n = i18nFromProps || i18nFromContext || (0, _context.getI18n)();
	  var t = tFromProps || i18n && i18n.t.bind(i18n);
	  return (0, _TransWithoutContext.Trans)(_objectSpread({
	    children: children,
	    count: count,
	    parent: parent,
	    i18nKey: i18nKey,
	    context: context,
	    tOptions: tOptions,
	    values: values,
	    defaults: defaults,
	    components: components,
	    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
	    i18n: i18n,
	    t: tFromProps,
	    shouldUnescape: shouldUnescape
	  }, additionalProps));
	}

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Translation = Translation;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(384));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(183));
	
	var _useTranslation3 = __webpack_require__(383);
	
	var _excluded = ["ns", "children"];
	
	function Translation(props) {
	  var ns = props.ns,
	      children = props.children,
	      options = (0, _objectWithoutProperties2["default"])(props, _excluded);
	
	  var _useTranslation = (0, _useTranslation3.useTranslation)(ns, options),
	      _useTranslation2 = (0, _slicedToArray2["default"])(_useTranslation, 3),
	      t = _useTranslation2[0],
	      i18n = _useTranslation2[1],
	      ready = _useTranslation2[2];
	
	  return children(t, {
	    i18n: i18n,
	    lng: i18n.language
	  }, ready);
	}

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initReactI18next = void 0;
	
	var _defaults = __webpack_require__(381);
	
	var _i18nInstance = __webpack_require__(382);
	
	var initReactI18next = {
	  type: '3rdParty',
	  init: function init(instance) {
	    (0, _defaults.setDefaults)(instance.options.react);
	    (0, _i18nInstance.setI18n)(instance);
	  }
	};
	exports.initReactI18next = initReactI18next;

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unescape = void 0;
	var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
	var htmlEntities = {
	  '&amp;': '&',
	  '&#38;': '&',
	  '&lt;': '<',
	  '&#60;': '<',
	  '&gt;': '>',
	  '&#62;': '>',
	  '&apos;': "'",
	  '&#39;': "'",
	  '&quot;': '"',
	  '&#34;': '"',
	  '&nbsp;': ' ',
	  '&#160;': ' ',
	  '&copy;': '©',
	  '&#169;': '©',
	  '&reg;': '®',
	  '&#174;': '®',
	  '&hellip;': '…',
	  '&#8230;': '…',
	  '&#x2F;': '/',
	  '&#47;': '/'
	};
	
	var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
	  return htmlEntities[m];
	};
	
	var unescape = function unescape(text) {
	  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
	};
	
	exports.unescape = unescape;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withSSR = withSSR;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(183));
	
	var _react = __webpack_require__(1);
	
	var _useSSR = __webpack_require__(655);
	
	var _context = __webpack_require__(152);
	
	var _utils = __webpack_require__(269);
	
	var _excluded = ["initialI18nStore", "initialLanguage"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function withSSR() {
	  return function Extend(WrappedComponent) {
	    function I18nextWithSSR(_ref) {
	      var initialI18nStore = _ref.initialI18nStore,
	          initialLanguage = _ref.initialLanguage,
	          rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
	      (0, _useSSR.useSSR)(initialI18nStore, initialLanguage);
	      return (0, _react.createElement)(WrappedComponent, _objectSpread({}, rest));
	    }
	
	    I18nextWithSSR.getInitialProps = (0, _context.composeInitialProps)(WrappedComponent);
	    I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
	    I18nextWithSSR.WrappedComponent = WrappedComponent;
	    return I18nextWithSSR;
	  };
	}

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTranslation = withTranslation;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(125));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(384));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(183));
	
	var _react = __webpack_require__(1);
	
	var _useTranslation3 = __webpack_require__(383);
	
	var _utils = __webpack_require__(269);
	
	var _excluded = ["forwardedRef"];
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function withTranslation(ns) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function Extend(WrappedComponent) {
	    function I18nextWithTranslation(_ref) {
	      var forwardedRef = _ref.forwardedRef,
	          rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
	
	      var _useTranslation = (0, _useTranslation3.useTranslation)(ns, _objectSpread(_objectSpread({}, rest), {}, {
	        keyPrefix: options.keyPrefix
	      })),
	          _useTranslation2 = (0, _slicedToArray2["default"])(_useTranslation, 3),
	          t = _useTranslation2[0],
	          i18n = _useTranslation2[1],
	          ready = _useTranslation2[2];
	
	      var passDownProps = _objectSpread(_objectSpread({}, rest), {}, {
	        t: t,
	        i18n: i18n,
	        tReady: ready
	      });
	
	      if (options.withRef && forwardedRef) {
	        passDownProps.ref = forwardedRef;
	      } else if (!options.withRef && forwardedRef) {
	        passDownProps.forwardedRef = forwardedRef;
	      }
	
	      return (0, _react.createElement)(WrappedComponent, passDownProps);
	    }
	
	    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
	    I18nextWithTranslation.WrappedComponent = WrappedComponent;
	
	    var forwardRef = function forwardRef(props, ref) {
	      return (0, _react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
	        forwardedRef: ref
	      }));
	    };
	
	    return options.withRef ? (0, _react.forwardRef)(forwardRef) : I18nextWithTranslation;
	  };
	}

/***/ }),
/* 1971 */
1627,
/* 1972 */
1628,
/* 1973 */
1629,
/* 1974 */
[2403, 656],
/* 1975 */
/***/ (function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
	  if (null != _i) {
	    var _s,
	      _e,
	      _x,
	      _r,
	      _arr = [],
	      _n = !0,
	      _d = !1;
	    try {
	      if (_x = (_i = _i.call(arr)).next, 0 === i) {
	        if (Object(_i) !== _i) return;
	        _n = !1;
	      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
	    } catch (err) {
	      _d = !0, _e = err;
	    } finally {
	      try {
	        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	    return _arr;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1976 */
1635,
/* 1977 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1978 */
[2405, 270],
/* 1979 */
[2407, 1971],
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleUp = function FaAngleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 26.4q0 0.3-0.2 0.5l-1.1 1.2q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.2q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleUp;
	module.exports = exports['default'];

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(153);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSearch = function FaSearch(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 18.6q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaSearch;
	module.exports = exports['default'];

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 5);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
	
	function getElementOffset(el) {
	  var rect = el.getBoundingClientRect();
	  var docEl = document.documentElement;
	
	  var rectTop = rect.top + window.pageYOffset - docEl.clientTop;
	  var rectLeft = rect.left + window.pageXOffset - docEl.clientLeft;
	
	  return {
	    top: rectTop,
	    left: rectLeft
	  };
	}
	
	function getClientPos(e) {
	  var pageX = void 0;
	  var pageY = void 0;
	
	  if (e.touches) {
	    pageX = e.touches[0].pageX;
	    pageY = e.touches[0].pageY;
	  } else {
	    pageX = e.pageX;
	    pageY = e.pageY;
	  }
	
	  return {
	    x: pageX,
	    y: pageY
	  };
	}
	
	function clamp(num, min, max) {
	  return Math.min(Math.max(num, min), max);
	}
	
	function isCropInvalid(crop) {
	  return !crop.width || !crop.height;
	}
	
	function inverseOrd(ord) {
	  var inversedOrd = void 0;
	
	  if (ord === 'n') inversedOrd = 's';else if (ord === 'ne') inversedOrd = 'sw';else if (ord === 'e') inversedOrd = 'w';else if (ord === 'se') inversedOrd = 'nw';else if (ord === 's') inversedOrd = 'n';else if (ord === 'sw') inversedOrd = 'ne';else if (ord === 'w') inversedOrd = 'e';else if (ord === 'nw') inversedOrd = 'se';
	
	  return inversedOrd;
	}
	
	function ensureAspectDimensions(cropObj, imageEl) {
	  var imageWidth = imageEl.naturalWidth;
	  var imageHeight = imageEl.naturalHeight;
	  var imageAspect = imageWidth / imageHeight;
	  var crop = _extends({}, cropObj);
	
	  if (crop.width) {
	    crop.height = crop.width / crop.aspect * imageAspect;
	  } else if (crop.height) {
	    crop.width = crop.height * crop.aspect / imageAspect;
	  }
	
	  if (crop.y + crop.height > 100) {
	    crop.height = 100 - crop.y;
	    crop.width = crop.height * crop.aspect / imageAspect;
	  }
	  if (crop.x + crop.width > 100) {
	    crop.width = 100 - crop.x;
	    crop.height = crop.width / crop.aspect * imageAspect;
	  }
	
	  return crop;
	}
	
	var ReactCrop = function (_Component) {
	  _inherits(ReactCrop, _Component);
	
	  function ReactCrop(props) {
	    _classCallCheck(this, ReactCrop);
	
	    var _this = _possibleConstructorReturn(this, (ReactCrop.__proto__ || Object.getPrototypeOf(ReactCrop)).call(this, props));
	
	    _this.onDocMouseTouchMove = _this.onDocMouseTouchMove.bind(_this);
	    _this.onDocMouseTouchEnd = _this.onDocMouseTouchEnd.bind(_this);
	    _this.onImageLoad = _this.onImageLoad.bind(_this);
	    _this.onComponentMouseTouchDown = _this.onComponentMouseTouchDown.bind(_this);
	    _this.onComponentKeyDown = _this.onComponentKeyDown.bind(_this);
	    _this.onCropMouseTouchDown = _this.onCropMouseTouchDown.bind(_this);
	
	    _this.state = {
	      crop: _this.nextCropState(props.crop)
	    };
	    return _this;
	  }
	
	  _createClass(ReactCrop, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousemove', this.onDocMouseTouchMove);
	      document.addEventListener('touchmove', this.onDocMouseTouchMove);
	
	      document.addEventListener('mouseup', this.onDocMouseTouchEnd);
	      document.addEventListener('touchend', this.onDocMouseTouchEnd);
	      document.addEventListener('touchcancel', this.onDocMouseTouchEnd);
	
	      if (this.imageRef.complete || this.imageRef.readyState) {
	        if (this.imageRef.naturalWidth === 0) {
	          // Broken load on iOS, PR #51
	          // https://css-tricks.com/snippets/jquery/fixing-load-in-ie-for-cached-images/
	          // http://stackoverflow.com/questions/821516/browser-independent-way-to-detect-when-image-has-been-loaded
	          var src = this.imageRef.src;
	          this.imageRef.src = EMPTY_GIF;
	          this.imageRef.src = src;
	        } else {
	          // Fixme: this is causing a double onImageLoaded event in normal cases.
	          this.onImageLoad(this.imageRef);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.crop) {
	        var nextCrop = this.nextCropState(nextProps.crop);
	        var aspectRatioChanged = nextCrop.aspect !== this.state.crop.aspect;
	
	        if (nextCrop.aspect) {
	          nextCrop = ensureAspectDimensions(nextCrop, this.imageRef);
	        }
	
	        this.cropInvalid = isCropInvalid(nextCrop);
	        this.setState({ crop: nextCrop }, function () {
	          if (aspectRatioChanged) {
	            _this2.props.onAspectRatioChange(nextCrop, _this2.getPixelCrop(nextCrop));
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.onDocMouseTouchMove);
	      document.removeEventListener('touchmove', this.onDocMouseTouchMove);
	
	      document.removeEventListener('mouseup', this.onDocMouseTouchEnd);
	      document.removeEventListener('touchend', this.onDocMouseTouchEnd);
	      document.removeEventListener('touchcancel', this.onDocMouseTouchEnd);
	    }
	  }, {
	    key: 'onDocMouseTouchMove',
	    value: function onDocMouseTouchMove(e) {
	      this.props.onDragStart();
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      if (!this.mouseDownOnCrop) {
	        return;
	      }
	
	      e.preventDefault(); // Stop drag selection.
	
	      var crop = this.state.crop;
	
	      var evData = this.evData;
	      var clientPos = getClientPos(e);
	
	      if (evData.isResize && crop.aspect && evData.cropOffset) {
	        clientPos.y = this.straightenYPath(clientPos.x);
	      }
	
	      var xDiffPx = clientPos.x - evData.clientStartX;
	      evData.xDiffPc = xDiffPx / evData.imageWidth * 100;
	
	      var yDiffPx = clientPos.y - evData.clientStartY;
	      evData.yDiffPc = yDiffPx / evData.imageHeight * 100;
	
	      if (evData.isResize) {
	        this.resizeCrop();
	      } else {
	        this.dragCrop();
	      }
	
	      this.cropInvalid = false;
	      this.props.onChange(crop, this.getPixelCrop(crop));
	      this.setState({ crop: crop });
	    }
	  }, {
	    key: 'onCropMouseTouchDown',
	    value: function onCropMouseTouchDown(e) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      e.preventDefault(); // Stop drag selection.
	
	      var crop = this.state.crop;
	
	      var clientPos = getClientPos(e);
	
	      // Focus for detecting keypress.
	      this.componentRef.focus();
	
	      var ord = e.target.dataset.ord;
	      var xInversed = ord === 'nw' || ord === 'w' || ord === 'sw';
	      var yInversed = ord === 'nw' || ord === 'n' || ord === 'ne';
	
	      var cropOffset = void 0;
	
	      if (crop.aspect) {
	        cropOffset = getElementOffset(this.cropSelectRef);
	      }
	
	      this.evData = {
	        imageWidth: this.imageRef.width,
	        imageHeight: this.imageRef.height,
	        clientStartX: clientPos.x,
	        clientStartY: clientPos.y,
	        cropStartWidth: crop.width,
	        cropStartHeight: crop.height,
	        cropStartX: xInversed ? crop.x + crop.width : crop.x,
	        cropStartY: yInversed ? crop.y + crop.height : crop.y,
	        xInversed: xInversed,
	        yInversed: yInversed,
	        xCrossOver: xInversed,
	        yCrossOver: yInversed,
	        startXCrossOver: xInversed,
	        startYCrossOver: yInversed,
	        isResize: e.target !== this.cropSelectRef,
	        ord: ord,
	        cropOffset: cropOffset
	      };
	
	      this.mouseDownOnCrop = true;
	    }
	  }, {
	    key: 'onComponentMouseTouchDown',
	    value: function onComponentMouseTouchDown(e) {
	      if (e.target !== this.imageCopyRef && e.target !== this.cropWrapperRef) {
	        return;
	      }
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      e.preventDefault(); // Stop drag selection.
	
	      var crop = this.props.keepSelection === true ? {} : this.state.crop;
	      var clientPos = getClientPos(e);
	
	      // Focus for detecting keypress.
	      this.componentRef.focus();
	
	      var imageOffset = getElementOffset(this.imageRef);
	      var xPc = (clientPos.x - imageOffset.left) / this.imageRef.width * 100;
	      var yPc = (clientPos.y - imageOffset.top) / this.imageRef.height * 100;
	
	      crop.x = xPc;
	      crop.y = yPc;
	      crop.width = 0;
	      crop.height = 0;
	
	      this.evData = {
	        imageWidth: this.imageRef.width,
	        imageHeight: this.imageRef.height,
	        clientStartX: clientPos.x,
	        clientStartY: clientPos.y,
	        cropStartWidth: crop.width,
	        cropStartHeight: crop.height,
	        cropStartX: crop.x,
	        cropStartY: crop.y,
	        xInversed: false,
	        yInversed: false,
	        xCrossOver: false,
	        yCrossOver: false,
	        startXCrossOver: false,
	        startYCrossOver: false,
	        isResize: true,
	        ord: 'nw'
	      };
	
	      this.mouseDownOnCrop = true;
	      this.setState({ newCropIsBeingDrawn: true });
	    }
	  }, {
	    key: 'onComponentKeyDown',
	    value: function onComponentKeyDown(e) {
	      var _this3 = this;
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      var keyCode = e.which;
	      var crop = this.state.crop;
	
	      var nudged = false;
	
	      if (!crop.width || !crop.height) {
	        return;
	      }
	
	      if (keyCode === ReactCrop.arrowKey.left) {
	        crop.x -= ReactCrop.nudgeStep;
	        nudged = true;
	      } else if (keyCode === ReactCrop.arrowKey.right) {
	        crop.x += ReactCrop.nudgeStep;
	        nudged = true;
	      } else if (keyCode === ReactCrop.arrowKey.up) {
	        crop.y -= ReactCrop.nudgeStep;
	        nudged = true;
	      } else if (keyCode === ReactCrop.arrowKey.down) {
	        crop.y += ReactCrop.nudgeStep;
	        nudged = true;
	      }
	
	      if (nudged) {
	        e.preventDefault(); // Stop drag selection.
	        crop.x = clamp(crop.x, 0, 100 - crop.width);
	        crop.y = clamp(crop.y, 0, 100 - crop.height);
	
	        this.setState({ crop: crop }, function () {
	          _this3.props.onChange(crop, _this3.getPixelCrop(crop));
	          _this3.props.onComplete(crop, _this3.getPixelCrop(crop));
	        });
	      }
	    }
	  }, {
	    key: 'onDocMouseTouchEnd',
	    value: function onDocMouseTouchEnd() {
	      this.props.onDragEnd();
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      if (this.mouseDownOnCrop) {
	        var crop = this.state.crop;
	
	        this.cropInvalid = isCropInvalid(crop);
	        this.mouseDownOnCrop = false;
	
	        this.props.onComplete(crop, this.getPixelCrop(crop));
	        this.setState({ newCropIsBeingDrawn: false });
	      }
	    }
	  }, {
	    key: 'onImageLoad',
	    value: function onImageLoad(imageEl) {
	      var crop = this.state.crop;
	
	      // If there is a width or height then infer the other to
	      // ensure the value is correct.
	      if (crop.aspect) {
	        crop = ensureAspectDimensions(crop, imageEl);
	        this.cropInvalid = isCropInvalid(crop);
	        this.setState({ crop: crop });
	      }
	      if (this.props.onImageLoaded) {
	        this.props.onImageLoaded(crop, imageEl, this.getPixelCrop(crop));
	      }
	    }
	  }, {
	    key: 'getPixelCrop',
	    value: function getPixelCrop(crop) {
	      return {
	        x: Math.round(this.imageRef.width * (crop.x / 100)),
	        y: Math.round(this.imageRef.height * (crop.y / 100)),
	        width: Math.round(this.imageRef.width * (crop.width / 100)),
	        height: Math.round(this.imageRef.height * (crop.height / 100))
	      };
	    }
	  }, {
	    key: 'getCropStyle',
	    value: function getCropStyle() {
	      return {
	        top: this.state.crop.y + '%',
	        left: this.state.crop.x + '%',
	        width: this.state.crop.width + '%',
	        height: this.state.crop.height + '%'
	      };
	    }
	  }, {
	    key: 'getNewSize',
	    value: function getNewSize() {
	      var crop = this.state.crop;
	
	      var evData = this.evData;
	      var imageAspect = evData.imageWidth / evData.imageHeight;
	
	      // New width.
	      var newWidth = evData.cropStartWidth + evData.xDiffPc;
	
	      if (evData.xCrossOver) {
	        newWidth = Math.abs(newWidth);
	      }
	
	      var maxWidth = this.props.maxWidth;
	
	      // Stop the box expanding on the opposite side when some edges are hit.
	      if (!this.state.newCropIsBeingDrawn) {
	        maxWidth = ['nw', 'w', 'sw'].indexOf(evData.inversedXOrd || evData.ord) > -1 ? evData.cropStartX : 100 - evData.cropStartX;
	        maxWidth = clamp(maxWidth, 100, this.props.maxWidth);
	      }
	
	      newWidth = clamp(newWidth, this.props.minWidth, maxWidth);
	
	      // New height.
	      var newHeight = void 0;
	
	      if (crop.aspect) {
	        newHeight = newWidth / crop.aspect * imageAspect;
	      } else {
	        newHeight = evData.cropStartHeight + evData.yDiffPc;
	      }
	
	      if (evData.yCrossOver) {
	        // Cap if polarity is inversed and the ape fills the y space.
	        newHeight = Math.min(Math.abs(newHeight), evData.cropStartY);
	      }
	
	      var maxHeight = this.props.maxHeight;
	
	      // Stop the box expanding on the opposite side when some edges are hit.
	      if (!this.state.newCropIsBeingDrawn) {
	        maxHeight = ['nw', 'n', 'ne'].indexOf(evData.inversedYOrd || evData.ord) > -1 ? evData.cropStartY : 100 - evData.cropStartY;
	        maxHeight = clamp(maxHeight, 100, this.props.maxHeight);
	      }
	
	      newHeight = clamp(newHeight, this.props.minHeight, maxHeight);
	
	      if (crop.aspect) {
	        newWidth = clamp(newHeight * crop.aspect / imageAspect, 0, 100);
	      }
	
	      return {
	        width: newWidth,
	        height: newHeight
	      };
	    }
	  }, {
	    key: 'dragCrop',
	    value: function dragCrop() {
	      var crop = this.state.crop;
	
	      var evData = this.evData;
	      crop.x = clamp(evData.cropStartX + evData.xDiffPc, 0, 100 - crop.width);
	      crop.y = clamp(evData.cropStartY + evData.yDiffPc, 0, 100 - crop.height);
	    }
	  }, {
	    key: 'resizeCrop',
	    value: function resizeCrop() {
	      var crop = this.state.crop;
	
	      var evData = this.evData;
	      var ord = evData.ord;
	
	      // On the inverse change the diff so it's the same and
	      // the same algo applies.
	      if (evData.xInversed) {
	        evData.xDiffPc -= evData.cropStartWidth * 2;
	      }
	      if (evData.yInversed) {
	        evData.yDiffPc -= evData.cropStartHeight * 2;
	      }
	
	      // New size.
	      var newSize = this.getNewSize();
	
	      // Adjust x/y to give illusion of 'staticness' as width/height is increased
	      // when polarity is inversed.
	      var newX = evData.cropStartX;
	      var newY = evData.cropStartY;
	
	      if (evData.xCrossOver) {
	        newX = crop.x + (crop.width - newSize.width);
	      }
	
	      if (evData.yCrossOver) {
	        // This not only removes the little "shake" when inverting at a diagonal, but for some
	        // reason y was way off at fast speeds moving sw->ne with fixed aspect only, I couldn't
	        // figure out why.
	        if (evData.lastYCrossover === false) {
	          newY = crop.y - newSize.height;
	        } else {
	          newY = crop.y + (crop.height - newSize.height);
	        }
	      }
	
	      // Apply x/y/width/height changes depending on ordinate (fixed aspect always applies both).
	      if (crop.aspect || ReactCrop.xyOrds.indexOf(ord) > -1) {
	        crop.x = clamp(newX, 0, 100 - newSize.width);
	        crop.y = clamp(newY, 0, 100 - newSize.height);
	
	        crop.width = newSize.width;
	        crop.height = newSize.height;
	      } else if (ReactCrop.xOrds.indexOf(ord) > -1) {
	        crop.x = clamp(newX, 0, 100 - newSize.width);
	        crop.width = newSize.width;
	      } else if (ReactCrop.yOrds.indexOf(ord) > -1) {
	        crop.y = clamp(newY, 0, 100 - newSize.height);
	        crop.height = newSize.height;
	      }
	
	      evData.lastYCrossover = evData.yCrossOver;
	      this.crossOverCheck();
	    }
	  }, {
	    key: 'straightenYPath',
	    value: function straightenYPath(clientX) {
	      var evData = this.evData;
	      var ord = evData.ord;
	      var cropOffset = evData.cropOffset;
	      var cropStartWidth = evData.cropStartWidth / 100 * evData.imageWidth;
	      var cropStartHeight = evData.cropStartHeight / 100 * evData.imageHeight;
	      var k = void 0;
	      var d = void 0;
	
	      if (ord === 'nw' || ord === 'se') {
	        k = cropStartHeight / cropStartWidth;
	        d = cropOffset.top - cropOffset.left * k;
	      } else {
	        k = -cropStartHeight / cropStartWidth;
	        d = cropOffset.top + (cropStartHeight - cropOffset.left * k);
	      }
	
	      return k * clientX + d;
	    }
	  }, {
	    key: 'createCropSelection',
	    value: function createCropSelection() {
	      var _this4 = this;
	
	      var disabled = this.props.disabled;
	
	      var style = this.getCropStyle();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(n) {
	            return _this4.cropSelectRef = n;
	          },
	          style: style,
	          className: 'ReactCrop__crop-selection',
	          onMouseDown: this.onCropMouseTouchDown,
	          onTouchStart: this.onCropMouseTouchDown
	        },
	        !disabled && _react2.default.createElement(
	          'div',
	          { className: 'ReactCrop__drag-elements' },
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-n', 'data-ord': 'n' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-e', 'data-ord': 'e' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-s', 'data-ord': 's' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-w', 'data-ord': 'w' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-nw', 'data-ord': 'nw' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-n', 'data-ord': 'n' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-ne', 'data-ord': 'ne' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-e', 'data-ord': 'e' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-se', 'data-ord': 'se' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-s', 'data-ord': 's' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-sw', 'data-ord': 'sw' }),
	          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-w', 'data-ord': 'w' })
	        )
	      );
	    }
	  }, {
	    key: 'nextCropState',
	    value: function nextCropState(crop) {
	      var nextCrop = _extends({}, ReactCrop.defaultCrop, crop);
	      this.cropInvalid = isCropInvalid(nextCrop);
	      return nextCrop;
	    }
	  }, {
	    key: 'crossOverCheck',
	    value: function crossOverCheck() {
	      var evData = this.evData;
	
	      if (!evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiffPc >= 0 || evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiffPc <= 0) {
	        evData.xCrossOver = !evData.xCrossOver;
	      }
	
	      if (!evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiffPc >= 0 || evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiffPc <= 0) {
	        evData.yCrossOver = !evData.yCrossOver;
	      }
	
	      var swapXOrd = evData.xCrossOver !== evData.startXCrossOver;
	      var swapYOrd = evData.yCrossOver !== evData.startYCrossOver;
	
	      evData.inversedXOrd = swapXOrd ? inverseOrd(evData.ord) : false;
	      evData.inversedYOrd = swapYOrd ? inverseOrd(evData.ord) : false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var cropSelection = void 0;
	
	      if (!this.cropInvalid) {
	        cropSelection = this.createCropSelection();
	      }
	
	      var componentClasses = ['ReactCrop'];
	
	      if (this.state.newCropIsBeingDrawn) {
	        componentClasses.push('ReactCrop--new-crop');
	      }
	      if (this.state.crop.aspect) {
	        componentClasses.push('ReactCrop--fixed-aspect');
	      }
	      if (this.props.disabled) {
	        componentClasses.push('ReactCrop--disabled');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(n) {
	            return _this5.componentRef = n;
	          },
	          className: componentClasses.join(' '),
	          onTouchStart: this.onComponentMouseTouchDown,
	          onMouseDown: this.onComponentMouseTouchDown,
	          tabIndex: '1',
	          onKeyDown: this.onComponentKeyDown
	        },
	        _react2.default.createElement('img', {
	          ref: function ref(n) {
	            return _this5.imageRef = n;
	          },
	          crossOrigin: this.props.crossorigin,
	          className: 'ReactCrop__image',
	          src: this.props.src,
	          onLoad: function onLoad(e) {
	            return _this5.onImageLoad(e.target);
	          },
	          alt: this.props.imageAlt
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactCrop__crop-wrapper',
	            ref: function ref(n) {
	              return _this5.cropWrapperRef = n;
	            }
	          },
	          _react2.default.createElement('img', {
	            ref: function ref(n) {
	              return _this5.imageCopyRef = n;
	            },
	            crossOrigin: this.props.crossorigin,
	            className: 'ReactCrop__image-copy',
	            src: this.props.src,
	            alt: this.props.imageAlt
	          }),
	          cropSelection
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ReactCrop;
	}(_react.Component);
	
	ReactCrop.propTypes = {
	  src: _propTypes2.default.string.isRequired,
	  crop: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  imageAlt: _propTypes2.default.string,
	  minWidth: _propTypes2.default.number,
	  minHeight: _propTypes2.default.number,
	  maxWidth: _propTypes2.default.number,
	  maxHeight: _propTypes2.default.number,
	  keepSelection: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onComplete: _propTypes2.default.func,
	  onImageLoaded: _propTypes2.default.func,
	  onAspectRatioChange: _propTypes2.default.func,
	  onDragStart: _propTypes2.default.func,
	  onDragEnd: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  crossorigin: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	ReactCrop.defaultProps = {
	  crop: undefined,
	  crossorigin: undefined,
	  disabled: false,
	  imageAlt: '',
	  maxWidth: 100,
	  maxHeight: 100,
	  minWidth: 0,
	  minHeight: 0,
	  keepSelection: false,
	  onChange: function onChange() {},
	  onComplete: function onComplete() {},
	  onImageLoaded: function onImageLoaded() {},
	  onAspectRatioChange: function onAspectRatioChange() {},
	  onDragStart: function onDragStart() {},
	  onDragEnd: function onDragEnd() {},
	  children: undefined
	};
	ReactCrop.xOrds = ['e', 'w'];
	ReactCrop.yOrds = ['n', 's'];
	ReactCrop.xyOrds = ['nw', 'ne', 'se', 'sw'];
	ReactCrop.arrowKey = {
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40
	};
	ReactCrop.nudgeStep = 0.2;
	ReactCrop.defaultCrop = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  aspect: false
	};
	
	
	module.exports = ReactCrop;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(8)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(10)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(3);
	var checkPropTypes = __webpack_require__(9);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(2);
	  var warning = __webpack_require__(4);
	  var ReactPropTypesSecret = __webpack_require__(3);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var ReactPropTypesSecret = __webpack_require__(3);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ })
	/******/ ]);

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1982);


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteComputer = __webpack_require__(660),
	    bs = __webpack_require__(1987);
	
	var ArrayInfiniteComputer = function (_InfiniteComputer) {
	  _inherits(ArrayInfiniteComputer, _InfiniteComputer);
	
	  function ArrayInfiniteComputer(heightData, numberOfChildren) {
	    _classCallCheck(this, ArrayInfiniteComputer);
	
	    var _this = _possibleConstructorReturn(this, (ArrayInfiniteComputer.__proto__ || Object.getPrototypeOf(ArrayInfiniteComputer)).call(this, heightData, numberOfChildren));
	
	    _this.prefixHeightData = _this.heightData.reduce(function (acc, next) {
	      if (acc.length === 0) {
	        return [next];
	      } else {
	        acc.push(acc[acc.length - 1] + next);
	        return acc;
	      }
	    }, []);
	    return _this;
	  }
	
	  _createClass(ArrayInfiniteComputer, [{
	    key: 'maybeIndexToIndex',
	    value: function maybeIndexToIndex(index) {
	      if (typeof index === 'undefined' || index === null) {
	        return this.prefixHeightData.length - 1;
	      } else {
	        return index;
	      }
	    }
	  }, {
	    key: 'getTotalScrollableHeight',
	    value: function getTotalScrollableHeight() {
	      var length = this.prefixHeightData.length;
	      return length === 0 ? 0 : this.prefixHeightData[length - 1];
	    }
	  }, {
	    key: 'getDisplayIndexStart',
	    value: function getDisplayIndexStart(windowTop) {
	      var foundIndex = bs.binaryIndexSearch(this.prefixHeightData, windowTop, bs.opts.CLOSEST_HIGHER);
	      return this.maybeIndexToIndex(foundIndex);
	    }
	  }, {
	    key: 'getDisplayIndexEnd',
	    value: function getDisplayIndexEnd(windowBottom) {
	      var foundIndex = bs.binaryIndexSearch(this.prefixHeightData, windowBottom, bs.opts.CLOSEST_HIGHER);
	      return this.maybeIndexToIndex(foundIndex);
	    }
	  }, {
	    key: 'getTopSpacerHeight',
	    value: function getTopSpacerHeight(displayIndexStart) {
	      var previous = displayIndexStart - 1;
	      return previous < 0 ? 0 : this.prefixHeightData[previous];
	    }
	  }, {
	    key: 'getBottomSpacerHeight',
	    value: function getBottomSpacerHeight(displayIndexEnd) {
	      if (displayIndexEnd === -1) {
	        return 0;
	      }
	      return this.getTotalScrollableHeight() - this.prefixHeightData[displayIndexEnd];
	    }
	  }]);
	
	  return ArrayInfiniteComputer;
	}(InfiniteComputer);
	
	module.exports = ArrayInfiniteComputer;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteComputer = __webpack_require__(660);
	
	var ConstantInfiniteComputer = function (_InfiniteComputer) {
	  _inherits(ConstantInfiniteComputer, _InfiniteComputer);
	
	  function ConstantInfiniteComputer() {
	    _classCallCheck(this, ConstantInfiniteComputer);
	
	    return _possibleConstructorReturn(this, (ConstantInfiniteComputer.__proto__ || Object.getPrototypeOf(ConstantInfiniteComputer)).apply(this, arguments));
	  }
	
	  _createClass(ConstantInfiniteComputer, [{
	    key: 'getTotalScrollableHeight',
	    value: function getTotalScrollableHeight() {
	      return this.heightData * this.numberOfChildren;
	    }
	  }, {
	    key: 'getDisplayIndexStart',
	    value: function getDisplayIndexStart(windowTop) {
	      return Math.floor(windowTop / this.heightData);
	    }
	  }, {
	    key: 'getDisplayIndexEnd',
	    value: function getDisplayIndexEnd(windowBottom) {
	      var nonZeroIndex = Math.ceil(windowBottom / this.heightData);
	      if (nonZeroIndex > 0) {
	        return nonZeroIndex - 1;
	      }
	      return nonZeroIndex;
	    }
	  }, {
	    key: 'getTopSpacerHeight',
	    value: function getTopSpacerHeight(displayIndexStart) {
	      return displayIndexStart * this.heightData;
	    }
	  }, {
	    key: 'getBottomSpacerHeight',
	    value: function getBottomSpacerHeight(displayIndexEnd) {
	      var nonZeroIndex = displayIndexEnd + 1;
	      return Math.max(0, (this.numberOfChildren - nonZeroIndex) * this.heightData);
	    }
	  }]);
	
	  return ConstantInfiniteComputer;
	}(InfiniteComputer);
	
	module.exports = ConstantInfiniteComputer;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = global.React || __webpack_require__(1);
	var PropTypes = global.PropTypes || __webpack_require__(15);
	
	var window = __webpack_require__(662);
	
	__webpack_require__(1989);
	var scaleEnum = __webpack_require__(661);
	var infiniteHelpers = __webpack_require__(1990);
	var _isFinite = __webpack_require__(567);
	
	var checkProps = __webpack_require__(1988);
	
	var Infinite = function (_React$Component) {
	  _inherits(Infinite, _React$Component);
	
	  _createClass(Infinite, null, [{
	    key: 'containerHeightScaleFactor',
	    value: function containerHeightScaleFactor(factor) {
	      if (!_isFinite(factor)) {
	        throw new Error('The scale factor must be a number.');
	      }
	      return {
	        type: scaleEnum.CONTAINER_HEIGHT_SCALE_FACTOR,
	        amount: factor
	      };
	    }
	  }]);
	
	  function Infinite(props) {
	    _classCallCheck(this, Infinite);
	
	    var _this = _possibleConstructorReturn(this, (Infinite.__proto__ || Object.getPrototypeOf(Infinite)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var nextInternalState = _this.recomputeInternalStateFromProps(props);
	
	    _this.computedProps = nextInternalState.computedProps;
	    _this.utils = nextInternalState.utils;
	    _this.shouldAttachToBottom = props.displayBottomUpwards;
	
	    var state = nextInternalState.newState;
	    state.scrollTimeout = undefined;
	    state.isScrolling = false;
	
	    _this.state = state;
	    return _this;
	  }
	
	  // Properties currently used but which may be
	  // refactored away in the future.
	
	
	  // Refs
	
	
	  _createClass(Infinite, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextInternalState = this.recomputeInternalStateFromProps(nextProps);
	
	      this.computedProps = nextInternalState.computedProps;
	      this.utils = nextInternalState.utils;
	
	      this.setState(nextInternalState.newState);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      if (this.props.displayBottomUpwards) {
	        this.preservedScrollState = this.utils.getScrollTop() - this.loadingSpinnerHeight;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.loadingSpinnerHeight = this.utils.getLoadingSpinnerHeight();
	
	      if (!prevProps.useWindowAsScrollContainer && this.props.useWindowAsScrollContainer) {
	        this.utils.subscribeToScrollListener();
	      }
	
	      if (this.props.displayBottomUpwards) {
	        var lowestScrollTop = this.getLowestPossibleScrollTop();
	        if (this.shouldAttachToBottom && this.utils.getScrollTop() < lowestScrollTop) {
	          this.utils.setScrollTop(lowestScrollTop);
	        } else if (prevProps.isInfiniteLoading && !this.props.isInfiniteLoading) {
	          this.utils.setScrollTop(this.state.infiniteComputer.getTotalScrollableHeight() - prevState.infiniteComputer.getTotalScrollableHeight() + this.preservedScrollState);
	        }
	      }
	
	      var hasLoadedMoreChildren = this.state.numberOfChildren !== prevState.numberOfChildren;
	      if (hasLoadedMoreChildren) {
	        var newApertureState = infiniteHelpers.recomputeApertureStateFromOptionsAndScrollTop(this.state, this.utils.getScrollTop());
	        this.setState(newApertureState);
	      }
	
	      var isMissingVisibleRows = hasLoadedMoreChildren && !this.hasAllVisibleItems() && !this.state.isInfiniteLoading;
	      if (isMissingVisibleRows) {
	        this.onInfiniteLoad();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.utils.subscribeToScrollListener();
	
	      if (!this.hasAllVisibleItems()) {
	        this.onInfiniteLoad();
	      }
	
	      if (this.props.displayBottomUpwards) {
	        var lowestScrollTop = this.getLowestPossibleScrollTop();
	        if (this.shouldAttachToBottom && this.utils.getScrollTop() < lowestScrollTop) {
	          this.utils.setScrollTop(lowestScrollTop);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.utils.unsubscribeFromScrollListener();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var displayables;
	      if (this.state.numberOfChildren > 1) {
	        displayables = this.computedProps.children.slice(this.state.displayIndexStart, this.state.displayIndexEnd + 1);
	      } else {
	        displayables = this.computedProps.children;
	      }
	
	      var infiniteScrollStyles = {};
	      if (this.state.isScrolling) {
	        infiniteScrollStyles.pointerEvents = 'none';
	      }
	
	      var topSpacerHeight = this.state.infiniteComputer.getTopSpacerHeight(this.state.displayIndexStart),
	          bottomSpacerHeight = this.state.infiniteComputer.getBottomSpacerHeight(this.state.displayIndexEnd);
	
	      // This asymmetry is due to a reluctance to use CSS to control
	      // the bottom alignment
	      if (this.computedProps.displayBottomUpwards) {
	        var heightDifference = this.computedProps.containerHeight - this.state.infiniteComputer.getTotalScrollableHeight();
	        if (heightDifference > 0) {
	          topSpacerHeight = heightDifference - this.loadingSpinnerHeight;
	        }
	      }
	
	      var loadingSpinner = this.computedProps.infiniteLoadBeginEdgeOffset === undefined ? null : React.createElement(
	        'div',
	        {
	          ref: function ref(c) {
	            _this2.loadingSpinner = c;
	          }
	        },
	        this.state.isInfiniteLoading ? this.computedProps.loadingSpinnerDelegate : null
	      );
	
	      // topSpacer and bottomSpacer take up the amount of space that the
	      // rendered elements would have taken up otherwise
	      return React.createElement(
	        'div',
	        {
	          className: this.computedProps.className,
	          ref: function ref(c) {
	            _this2.scrollable = c;
	          },
	          style: this.utils.buildScrollableStyle(),
	          onScroll: this.utils.nodeScrollListener
	        },
	        React.createElement(
	          'div',
	          {
	            ref: function ref(c) {
	              _this2.smoothScrollingWrapper = c;
	            },
	            style: infiniteScrollStyles
	          },
	          React.createElement('div', {
	            ref: function ref(c) {
	              _this2.topSpacer = c;
	            },
	            style: infiniteHelpers.buildHeightStyle(topSpacerHeight)
	          }),
	          this.computedProps.displayBottomUpwards && loadingSpinner,
	          displayables,
	          !this.computedProps.displayBottomUpwards && loadingSpinner,
	          React.createElement('div', {
	            ref: function ref(c) {
	              _this2.bottomSpacer = c;
	            },
	            style: infiniteHelpers.buildHeightStyle(bottomSpacerHeight)
	          })
	        )
	      );
	    }
	  }]);
	
	  return Infinite;
	}(React.Component);
	
	Infinite.propTypes = {
	  children: PropTypes.any,
	
	  handleScroll: PropTypes.func,
	
	  // preloadBatchSize causes updates only to
	  // happen each preloadBatchSize pixels of scrolling.
	  // Set a larger number to cause fewer updates to the
	  // element list.
	  preloadBatchSize: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
	    type: PropTypes.oneOf(['containerHeightScaleFactor']).isRequired,
	    amount: PropTypes.number.isRequired
	  })]),
	  // preloadAdditionalHeight determines how much of the
	  // list above and below the container is preloaded even
	  // when it is not currently visible to the user. In the
	  // regular scroll implementation, preloadAdditionalHeight
	  // is equal to the entire height of the list.
	  preloadAdditionalHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
	    type: PropTypes.oneOf(['containerHeightScaleFactor']).isRequired,
	    amount: PropTypes.number.isRequired
	  })]), // page to screen ratio
	
	  // The provided elementHeight can be either
	  //  1. a constant: all elements are the same height
	  //  2. an array containing the height of each element
	  elementHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
	  // This is the total height of the visible window. One
	  // of
	  containerHeight: PropTypes.number,
	  useWindowAsScrollContainer: PropTypes.bool,
	
	  displayBottomUpwards: PropTypes.bool.isRequired,
	
	  infiniteLoadBeginEdgeOffset: PropTypes.number,
	  onInfiniteLoad: PropTypes.func,
	  loadingSpinnerDelegate: PropTypes.node,
	
	  isInfiniteLoading: PropTypes.bool,
	  timeScrollStateLastsForAfterUserScrolls: PropTypes.number,
	
	  className: PropTypes.string,
	
	  styles: PropTypes.shape({
	    scrollableStyle: PropTypes.object
	  }).isRequired
	};
	Infinite.defaultProps = {
	  handleScroll: function handleScroll() {},
	
	  useWindowAsScrollContainer: false,
	
	  onInfiniteLoad: function onInfiniteLoad() {},
	  loadingSpinnerDelegate: React.createElement('div', null),
	
	  displayBottomUpwards: false,
	
	  isInfiniteLoading: false,
	  timeScrollStateLastsForAfterUserScrolls: 150,
	
	  className: '',
	
	  styles: {}
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.shouldAttachToBottom = false;
	  this.preservedScrollState = 0;
	  this.loadingSpinnerHeight = 0;
	
	  this.generateComputedUtilityFunctions = function (props) {
	    var utilities = {};
	    utilities.getLoadingSpinnerHeight = function () {
	      var loadingSpinnerHeight = 0;
	      if (_this3.loadingSpinner) {
	        loadingSpinnerHeight = _this3.loadingSpinner.offsetHeight || 0;
	      }
	      return loadingSpinnerHeight;
	    };
	    if (props.useWindowAsScrollContainer) {
	      utilities.subscribeToScrollListener = function () {
	        window.addEventListener('scroll', _this3.infiniteHandleScroll);
	      };
	      utilities.unsubscribeFromScrollListener = function () {
	        window.removeEventListener('scroll', _this3.infiniteHandleScroll);
	      };
	      utilities.nodeScrollListener = function () {};
	      utilities.getScrollTop = function () {
	        return window.pageYOffset;
	      };
	      utilities.setScrollTop = function (top) {
	        window.scroll(window.pageXOffset, top);
	      };
	      utilities.scrollShouldBeIgnored = function () {
	        return false;
	      };
	      utilities.buildScrollableStyle = function () {
	        return {};
	      };
	    } else {
	      utilities.subscribeToScrollListener = function () {};
	      utilities.unsubscribeFromScrollListener = function () {};
	      utilities.nodeScrollListener = _this3.infiniteHandleScroll;
	      utilities.getScrollTop = function () {
	        return _this3.scrollable ? _this3.scrollable.scrollTop : 0;
	      };
	
	      utilities.setScrollTop = function (top) {
	        if (_this3.scrollable) {
	          _this3.scrollable.scrollTop = top;
	        }
	      };
	      utilities.scrollShouldBeIgnored = function (event) {
	        return event.target !== _this3.scrollable;
	      };
	
	      utilities.buildScrollableStyle = function () {
	        return Object.assign({}, {
	          height: _this3.computedProps.containerHeight,
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          WebkitOverflowScrolling: 'touch'
	        }, _this3.computedProps.styles.scrollableStyle || {});
	      };
	    }
	    return utilities;
	  };
	
	  this.recomputeInternalStateFromProps = function (props) {
	    checkProps(props);
	    var computedProps = infiniteHelpers.generateComputedProps(props);
	    var utils = _this3.generateComputedUtilityFunctions(props);
	
	    var newState = {};
	
	    newState.numberOfChildren = React.Children.count(computedProps.children);
	    newState.infiniteComputer = infiniteHelpers.createInfiniteComputer(computedProps.elementHeight, computedProps.children);
	
	    if (computedProps.isInfiniteLoading !== undefined) {
	      newState.isInfiniteLoading = computedProps.isInfiniteLoading;
	    }
	
	    newState.preloadBatchSize = computedProps.preloadBatchSize;
	    newState.preloadAdditionalHeight = computedProps.preloadAdditionalHeight;
	
	    newState = Object.assign(newState, infiniteHelpers.recomputeApertureStateFromOptionsAndScrollTop(newState, utils.getScrollTop()));
	
	    return {
	      computedProps: computedProps,
	      utils: utils,
	      newState: newState
	    };
	  };
	
	  this.infiniteHandleScroll = function (e) {
	    if (_this3.utils.scrollShouldBeIgnored(e)) {
	      return;
	    }
	    _this3.computedProps.handleScroll(_this3.scrollable);
	    _this3.handleScroll(_this3.utils.getScrollTop());
	  };
	
	  this.manageScrollTimeouts = function () {
	    // Maintains a series of timeouts to set this.state.isScrolling
	    // to be true when the element is scrolling.
	
	    if (_this3.state.scrollTimeout) {
	      clearTimeout(_this3.state.scrollTimeout);
	    }
	
	    var that = _this3,
	        scrollTimeout = setTimeout(function () {
	      that.setState({
	        isScrolling: false,
	        scrollTimeout: undefined
	      });
	    }, _this3.computedProps.timeScrollStateLastsForAfterUserScrolls);
	
	    _this3.setState({
	      isScrolling: true,
	      scrollTimeout: scrollTimeout
	    });
	  };
	
	  this.getLowestPossibleScrollTop = function () {
	    return _this3.state.infiniteComputer.getTotalScrollableHeight() - _this3.computedProps.containerHeight;
	  };
	
	  this.hasAllVisibleItems = function () {
	    return !(_isFinite(_this3.computedProps.infiniteLoadBeginEdgeOffset) && _this3.state.infiniteComputer.getTotalScrollableHeight() < _this3.computedProps.containerHeight);
	  };
	
	  this.passedEdgeForInfiniteScroll = function (scrollTop) {
	    var edgeOffset = _this3.computedProps.infiniteLoadBeginEdgeOffset;
	    if (typeof edgeOffset !== 'number') {
	      return false;
	    }
	
	    if (_this3.computedProps.displayBottomUpwards) {
	      return !_this3.shouldAttachToBottom && scrollTop < edgeOffset;
	    } else {
	      return scrollTop > _this3.state.infiniteComputer.getTotalScrollableHeight() - _this3.computedProps.containerHeight - edgeOffset;
	    }
	  };
	
	  this.onInfiniteLoad = function () {
	    _this3.setState({ isInfiniteLoading: true });
	    _this3.computedProps.onInfiniteLoad();
	  };
	
	  this.handleScroll = function (scrollTop) {
	    _this3.shouldAttachToBottom = _this3.computedProps.displayBottomUpwards && scrollTop >= _this3.getLowestPossibleScrollTop();
	
	    _this3.manageScrollTimeouts();
	
	    var newApertureState = infiniteHelpers.recomputeApertureStateFromOptionsAndScrollTop(_this3.state, scrollTop);
	
	    if (_this3.passedEdgeForInfiniteScroll(scrollTop) && !_this3.state.isInfiniteLoading) {
	      _this3.setState(Object.assign({}, newApertureState));
	      _this3.onInfiniteLoad();
	    } else {
	      _this3.setState(newApertureState);
	    }
	  };
	};
	
	module.exports = Infinite;
	global.Infinite = Infinite;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

	"use strict";
	
	var opts = {
	  CLOSEST_LOWER: 1,
	  CLOSEST_HIGHER: 2
	};
	
	var binaryIndexSearch = function binaryIndexSearch(array /* : Array<number> */
	, item /* : number */
	, opt /* : number */
	) /* : ?number */{
	  var index;
	
	  var high = array.length - 1,
	      low = 0,
	      middle,
	      middleItem;
	
	  while (low <= high) {
	    middle = low + Math.floor((high - low) / 2);
	    middleItem = array[middle];
	
	    if (middleItem === item) {
	      return middle;
	    } else if (middleItem < item) {
	      low = middle + 1;
	    } else if (middleItem > item) {
	      high = middle - 1;
	    }
	  }
	
	  if (opt === opts.CLOSEST_LOWER && low > 0) {
	    index = low - 1;
	  } else if (opt === opts.CLOSEST_HIGHER && high < array.length - 1) {
	    index = high + 1;
	  }
	
	  return index;
	};
	
	module.exports = {
	  binaryIndexSearch: binaryIndexSearch,
	  opts: opts
	};

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// This module provides a centralized place for
	// runtime checking that the props passed to React Infinite
	// make the minimum amount of sense.
	
	var React = global.React || __webpack_require__(1);
	var _isFinite = __webpack_require__(567);
	
	module.exports = function (props) {
	  var rie = 'Invariant Violation: ';
	  if (!(props.containerHeight || props.useWindowAsScrollContainer)) {
	    throw new Error(rie + 'Either containerHeight or useWindowAsScrollContainer must be provided.');
	  }
	
	  if (!(_isFinite(props.elementHeight) || Array.isArray(props.elementHeight))) {
	    throw new Error(rie + 'You must provide either a number or an array of numbers as the elementHeight.');
	  }
	
	  if (Array.isArray(props.elementHeight)) {
	    if (React.Children.count(props.children) !== props.elementHeight.length) {
	      throw new Error(rie + 'There must be as many values provided in the elementHeight prop as there are children.');
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	  A number of polyfills for native functions are consolidated
	  here. We do this instead of using the libraries directly
	  because Flow is designed to make its type refinements
	  with these native functions.
	 */
	
	if (!Object.assign) {
	  Object.assign = __webpack_require__(1991);
	}
	
	if (!Array.isArray) {
	  Array.isArray = __webpack_require__(1645);
	}

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ConstantInfiniteComputer = __webpack_require__(1985);
	var ArrayInfiniteComputer = __webpack_require__(1984);
	var scaleEnum = __webpack_require__(661);
	var React = global.React || __webpack_require__(1);
	var window = __webpack_require__(662);
	
	function createInfiniteComputer(data, children) {
	  var computer;
	  var numberOfChildren = React.Children.count(children);
	
	  // This should be guaranteed by checkProps
	  if (Array.isArray(data)) {
	    computer = new ArrayInfiniteComputer(data, numberOfChildren);
	  } else {
	    computer = new ConstantInfiniteComputer(data, numberOfChildren);
	  }
	  return computer;
	}
	
	// Given the scrollTop of the container, computes the state the
	// component should be in. The goal is to abstract all of this
	// from any actual representation in the DOM.
	// The window is the block with any preloadAdditionalHeight
	// added to it.
	function recomputeApertureStateFromOptionsAndScrollTop(_ref, scrollTop) {
	  var preloadBatchSize = _ref.preloadBatchSize,
	      preloadAdditionalHeight = _ref.preloadAdditionalHeight,
	      infiniteComputer = _ref.infiniteComputer;
	
	  var blockNumber = preloadBatchSize === 0 ? 0 : Math.floor(scrollTop / preloadBatchSize),
	      blockStart = preloadBatchSize * blockNumber,
	      blockEnd = blockStart + preloadBatchSize,
	      apertureTop = Math.max(0, blockStart - preloadAdditionalHeight),
	      apertureBottom = Math.min(infiniteComputer.getTotalScrollableHeight(), blockEnd + preloadAdditionalHeight);
	
	  return {
	    displayIndexStart: infiniteComputer.getDisplayIndexStart(apertureTop),
	    displayIndexEnd: infiniteComputer.getDisplayIndexEnd(apertureBottom)
	  };
	}
	
	function generateComputedProps(props) {
	  // These are extracted so their type definitions do not conflict.
	  var containerHeight = props.containerHeight,
	      preloadBatchSize = props.preloadBatchSize,
	      preloadAdditionalHeight = props.preloadAdditionalHeight,
	      handleScroll = props.handleScroll,
	      onInfiniteLoad = props.onInfiniteLoad,
	      oldProps = _objectWithoutProperties(props, ['containerHeight', 'preloadBatchSize', 'preloadAdditionalHeight', 'handleScroll', 'onInfiniteLoad']);
	
	  var newProps = {};
	  containerHeight = typeof containerHeight === 'number' ? containerHeight : 0;
	  newProps.containerHeight = props.useWindowAsScrollContainer ? window.innerHeight : containerHeight;
	
	  newProps.handleScroll = handleScroll || function () {};
	  newProps.onInfiniteLoad = onInfiniteLoad || function () {};
	
	  var defaultPreloadBatchSizeScaling = {
	    type: scaleEnum.CONTAINER_HEIGHT_SCALE_FACTOR,
	    amount: 0.5
	  };
	  var batchSize = preloadBatchSize && preloadBatchSize.type ? preloadBatchSize : defaultPreloadBatchSizeScaling;
	
	  if (typeof preloadBatchSize === 'number') {
	    newProps.preloadBatchSize = preloadBatchSize;
	  } else if ((typeof batchSize === 'undefined' ? 'undefined' : _typeof(batchSize)) === 'object' && batchSize.type === scaleEnum.CONTAINER_HEIGHT_SCALE_FACTOR) {
	    newProps.preloadBatchSize = newProps.containerHeight * batchSize.amount;
	  } else {
	    newProps.preloadBatchSize = 0;
	  }
	
	  var defaultPreloadAdditionalHeightScaling = {
	    type: scaleEnum.CONTAINER_HEIGHT_SCALE_FACTOR,
	    amount: 1
	  };
	  var additionalHeight = preloadAdditionalHeight && preloadAdditionalHeight.type ? preloadAdditionalHeight : defaultPreloadAdditionalHeightScaling;
	  if (typeof preloadAdditionalHeight === 'number') {
	    newProps.preloadAdditionalHeight = preloadAdditionalHeight;
	  } else if ((typeof additionalHeight === 'undefined' ? 'undefined' : _typeof(additionalHeight)) === 'object' && additionalHeight.type === scaleEnum.CONTAINER_HEIGHT_SCALE_FACTOR) {
	    newProps.preloadAdditionalHeight = newProps.containerHeight * additionalHeight.amount;
	  } else {
	    newProps.preloadAdditionalHeight = 0;
	  }
	
	  return Object.assign(oldProps, newProps);
	}
	
	function buildHeightStyle(height) {
	  return {
	    width: '100%',
	    height: Math.ceil(height)
	  };
	}
	
	module.exports = {
	  createInfiniteComputer: createInfiniteComputer,
	  recomputeApertureStateFromOptionsAndScrollTop: recomputeApertureStateFromOptionsAndScrollTop,
	  generateComputedProps: generateComputedProps,
	  buildHeightStyle: buildHeightStyle
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(1)),reactDom=__webpack_require__(36);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var styled = __webpack_require__(2379);
	var styled__default = _interopDefault(styled);
	
	function _taggedTemplateLiteralLoose(strings, raw) {
	  if (!raw) {
	    raw = strings.slice(0);
	  }
	
	  strings.raw = raw;
	  return strings;
	}
	
	function _templateObject4() {
	  var data = _taggedTemplateLiteralLoose(["\n  width: var(--ReactInputVerificationCode-itemWidth);\n  height: var(--ReactInputVerificationCode-itemHeight);\n  padding: 0;\n  border-radius: 4px;\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: var(--ReactInputVerificationCode-itemHeight);\n  text-align: center;\n  border: 0;\n  box-shadow: inset 0 0 0 1px #ccc;\n  transition: box-shadow 0.2s ease-out;\n\n  &.is-active {\n    box-shadow: inset 0 0 0 2px #888;\n  }\n"]);
	
	  _templateObject4 = function _templateObject4() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject3() {
	  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: ", ";\n  opacity: 0;\n  width: var(--ReactInputVerificationCode-itemWidth);\n  height: var(--ReactInputVerificationCode-itemHeight);\n"]);
	
	  _templateObject3 = function _templateObject3() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  width: ", ";\n"]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteralLoose(["\n  :root {\n    --ReactInputVerificationCode-itemWidth: 4.5rem;\n    --ReactInputVerificationCode-itemHeight: 5rem;\n    --ReactInputVerificationCode-itemSpacing: 1rem;\n  }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	var GlobalStyle = styled.createGlobalStyle(_templateObject());
	var Container = styled__default.div(_templateObject2(), function (_ref) {
	  var itemsCount = _ref.itemsCount;
	  return "calc(\n      var(--ReactInputVerificationCode-itemWidth) * " + itemsCount + "\n      + var(--ReactInputVerificationCode-itemSpacing) * (" + itemsCount + " - 1)\n    )";
	});
	var Input = styled__default.input(_templateObject3(), function (_ref2) {
	  var activeIndex = _ref2.activeIndex;
	  return "calc(\n      var(--ReactInputVerificationCode-itemWidth) * " + activeIndex + "\n      + var(--ReactInputVerificationCode-itemSpacing) * " + activeIndex + "\n    )";
	});
	var Item = styled__default.div(_templateObject4());
	
	var KEY_CODE = {
	  BACKSPACE: 8,
	  ARROW_LEFT: 37,
	  ARROW_RIGHT: 39,
	  DELETE: 46
	};
	
	var ReactInputVerificationCode = function ReactInputVerificationCode(_ref) {
	  var _ref$autoFocus = _ref.autoFocus,
	      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
	      _ref$length = _ref.length,
	      length = _ref$length === void 0 ? 4 : _ref$length,
	      _ref$onChange = _ref.onChange,
	      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
	      _ref$onCompleted = _ref.onCompleted,
	      onCompleted = _ref$onCompleted === void 0 ? function () {} : _ref$onCompleted,
	      _ref$placeholder = _ref.placeholder,
	      placeholder = _ref$placeholder === void 0 ? '·' : _ref$placeholder,
	      pValue = _ref.value,
	      _ref$dataCy = _ref.dataCy,
	      dataCy = _ref$dataCy === void 0 ? 'verification-code' : _ref$dataCy,
	      _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'text' : _ref$type,
	      _ref$passwordMask = _ref.passwordMask,
	      passwordMask = _ref$passwordMask === void 0 ? '•' : _ref$passwordMask;
	  var emptyValue = new Array(length).fill(placeholder);
	
	  var _React$useState = React.useState(-1),
	      activeIndex = _React$useState[0],
	      setActiveIndex = _React$useState[1];
	
	  var _React$useState2 = React.useState(pValue ? pValue.split('') : emptyValue),
	      value = _React$useState2[0],
	      setValue = _React$useState2[1];
	
	  var codeInputRef = React.createRef();
	  var itemsRef = React.useMemo(function () {
	    return new Array(length).fill(null).map(function () {
	      return React.createRef();
	    });
	  }, [length]);
	  var isCodeRegex = new RegExp("^[0-9]{" + length + "}$");
	
	  var getItem = function getItem(index) {
	    var _itemsRef$index;
	
	    return (_itemsRef$index = itemsRef[index]) === null || _itemsRef$index === void 0 ? void 0 : _itemsRef$index.current;
	  };
	
	  var focusItem = function focusItem(index) {
	    var _getItem;
	
	    return (_getItem = getItem(index)) === null || _getItem === void 0 ? void 0 : _getItem.focus();
	  };
	
	  var blurItem = function blurItem(index) {
	    var _getItem2;
	
	    return (_getItem2 = getItem(index)) === null || _getItem2 === void 0 ? void 0 : _getItem2.blur();
	  };
	
	  var onItemFocus = function onItemFocus(index) {
	    return function () {
	      setActiveIndex(index);
	      if (codeInputRef.current) codeInputRef.current.focus();
	    };
	  };
	
	  var onInputKeyUp = function onInputKeyUp(_ref2) {
	    var key = _ref2.key,
	        keyCode = _ref2.keyCode;
	    var newValue = [].concat(value);
	    var nextIndex = activeIndex + 1;
	    var prevIndex = activeIndex - 1;
	    var codeInput = codeInputRef.current;
	    var currentItem = getItem(activeIndex);
	    var isLast = nextIndex === length;
	    var isDeleting = keyCode === KEY_CODE.DELETE || keyCode === KEY_CODE.BACKSPACE;
	
	    if (isDeleting) {
	      newValue[activeIndex] = placeholder;
	      setValue(newValue);
	
	      if (activeIndex > 0) {
	        setActiveIndex(prevIndex);
	        focusItem(prevIndex);
	      }
	
	      return;
	    }
	
	    if (Number.isNaN(+key)) return;
	    if (codeInput) codeInput.value = '';
	    newValue[activeIndex] = key;
	    setValue(newValue);
	
	    if (!isLast) {
	      setActiveIndex(nextIndex);
	      focusItem(nextIndex);
	      return;
	    }
	
	    if (codeInput) codeInput.blur();
	    if (currentItem) currentItem.blur();
	    setActiveIndex(-1);
	  };
	
	  var onInputChange = function onInputChange(e) {
	    var changeValue = e.target.value;
	    var isCode = isCodeRegex.test(changeValue);
	    if (!isCode) return;
	    setValue(changeValue.split(''));
	    blurItem(activeIndex);
	  };
	
	  var onInputBlur = function onInputBlur() {
	    if (activeIndex === -1) return;
	    blurItem(activeIndex);
	    setActiveIndex(-1);
	  };
	
	  React.useEffect(function () {
	    if (autoFocus && itemsRef[0].current) {
	      itemsRef[0].current.focus();
	    }
	  }, []);
	  React.useEffect(function () {
	    var codeInput = codeInputRef.current;
	    if (!codeInput) return;
	
	    var onPaste = function onPaste(e) {
	      var _e$clipboardData;
	
	      e.preventDefault();
	      var pastedString = (_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.getData('text');
	      if (!pastedString) return;
	      var isNumber = /^\d+$/.test(pastedString);
	      if (isNumber) setValue(pastedString.split('').slice(0, length));
	    };
	
	    codeInput.addEventListener('paste', onPaste);
	    return function () {
	      return codeInput.removeEventListener('paste', onPaste);
	    };
	  }, []);
	  React.useEffect(function () {
	    var stringValue = value.join('');
	    var isCompleted = stringValue.length === length;
	    if (isCompleted && stringValue !== emptyValue.join('')) onCompleted(stringValue);
	    onChange(stringValue);
	  }, [value, length]);
	  React.useEffect(function () {
	    if (typeof pValue !== 'string') return;
	    if (pValue === '' && value.join('') === emptyValue.join('')) return;
	    if (pValue !== value.join('')) setValue(pValue.split(''));
	  }, [pValue]);
	
	  var renderItemText = function renderItemText(itemValue) {
	    if (itemValue === placeholder) return placeholder;
	    return type === 'password' ? passwordMask : itemValue;
	  };
	
	  return React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), React.createElement(Container, {
	    className: 'ReactInputVerificationCode__container',
	    itemsCount: length
	  }, React.createElement(Input, {
	    ref: codeInputRef,
	    className: 'ReactInputVerificationCode__input',
	    autoComplete: 'one-time-code',
	    type: 'text',
	    inputMode: 'decimal',
	    id: 'one-time-code',
	    onChange: onInputChange,
	    onKeyUp: onInputKeyUp,
	    onBlur: onInputBlur,
	    activeIndex: activeIndex,
	    "data-cy": dataCy + "-otc-input"
	  }), itemsRef.map(function (ref, i) {
	    return React.createElement(Item, {
	      key: i,
	      ref: ref,
	      role: 'button',
	      tabIndex: 0,
	      className: "ReactInputVerificationCode__item " + (value[i] !== placeholder ? 'is-filled' : '') + " " + (i === activeIndex ? 'is-active' : ''),
	      onFocus: onItemFocus(i),
	      "data-cy": dataCy + "-" + i + "-item"
	    }, renderItemText(value[i]));
	  })));
	};
	
	module.exports = ReactInputVerificationCode;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 1995 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(1998);
	
	var _scrollParent = __webpack_require__(1999);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(1997);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(2000);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentLeft = void 0;
	  var parentHeight = void 0;
	  var parentWidth = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentLeft = _parent$getBoundingCl.left;
	    parentHeight = _parent$getBoundingCl.height;
	    parentWidth = _parent$getBoundingCl.width;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentLeft = defaultBoundingClientRect.left;
	    parentHeight = defaultBoundingClientRect.height;
	    parentWidth = defaultBoundingClientRect.width;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var left = void 0;
	  var height = void 0;
	  var width = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    left = _node$getBoundingClie.left;
	    height = _node$getBoundingClie.height;
	    width = _node$getBoundingClie.width;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    left = defaultBoundingClientRect.left;
	    height = defaultBoundingClientRect.height;
	    width = defaultBoundingClientRect.width;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	  var offsetLeft = left - intersectionLeft; // element's left relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!(node instanceof HTMLElement)) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var isString = function isString(string) {
	  return typeof string === 'string';
	};
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var scrollport = window;
	      var scrollContainer = this.props.scrollContainer;
	
	      if (scrollContainer) {
	        if (isString(scrollContainer)) {
	          scrollport = scrollport.document.querySelector(scrollContainer);
	        }
	      }
	      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0 && typeof window !== 'undefined') {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	var decorator = function decorator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component2) {
	      _inherits(LazyLoadDecorated, _Component2);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this2;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            LazyLoad,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};
	
	exports.lazyload = decorator;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!(node instanceof HTMLElement)) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _inputmaskCore = __webpack_require__(1641);
	
	var _inputmaskCore2 = _interopRequireDefault(_inputmaskCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start = void 0,
	      end = void 0;
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      var rangeEl = el.createTextRange();
	      var clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      var rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = (_temp2 = _class = function (_React$Component) {
	  _inherits(MaskedInput, _React$Component);
	
	  function MaskedInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MaskedInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._onChange = function (e) {
	      // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
	
	      var maskValue = _this.mask.getValue();
	      var incomingValue = e.target.value;
	      if (incomingValue !== maskValue) {
	        // only modify mask if form contents actually changed
	        _this._updateMaskSelection();
	        _this.mask.setValue(incomingValue); // write the whole updated value into the mask
	        e.target.value = _this._getDisplayValue(); // update the form with pattern applied to the value
	        _this._updateInputSelection();
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	    }, _this._onKeyDown = function (e) {
	      // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	      if (isUndo(e)) {
	        e.preventDefault();
	        if (_this.mask.undo()) {
	          e.target.value = _this._getDisplayValue();
	          _this._updateInputSelection();
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	        return;
	      } else if (isRedo(e)) {
	        e.preventDefault();
	        if (_this.mask.redo()) {
	          e.target.value = _this._getDisplayValue();
	          _this._updateInputSelection();
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	        return;
	      }
	
	      if (e.key === 'Backspace') {
	        e.preventDefault();
	        _this._updateMaskSelection();
	        if (_this.mask.backspace()) {
	          var value = _this._getDisplayValue();
	          e.target.value = value;
	          if (value) {
	            _this._updateInputSelection();
	          }
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	      }
	    }, _this._onKeyPress = function (e) {
	      // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	      // Ignore modified key presses
	      // Ignore enter key to allow form submission
	      if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	        return;
	      }
	
	      e.preventDefault();
	      _this._updateMaskSelection();
	      if (_this.mask.input(e.key || e.data)) {
	        e.target.value = _this.mask.getValue();
	        _this._updateInputSelection();
	        if (_this.props.onChange) {
	          _this.props.onChange(e);
	        }
	      }
	    }, _this._onPaste = function (e) {
	      // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)
	
	      e.preventDefault();
	      _this._updateMaskSelection();
	      // getData value needed for IE also works in FF & Chrome
	      if (_this.mask.paste(e.clipboardData.getData('Text'))) {
	        e.target.value = _this.mask.getValue();
	        // Timeout needed for IE
	        setTimeout(function () {
	          return _this._updateInputSelection();
	        }, 0);
	        if (_this.props.onChange) {
	          _this.props.onChange(e);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MaskedInput.prototype.componentWillMount = function componentWillMount() {
	    var options = {
	      pattern: this.props.mask,
	      value: this.props.value,
	      formatCharacters: this.props.formatCharacters
	    };
	    if (this.props.placeholderChar) {
	      options.placeholderChar = this.props.placeholderChar;
	    }
	    this.mask = new _inputmaskCore2.default(options);
	  };
	
	  MaskedInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	      // if we get a new value and a new mask at the same time
	      // check if the mask.value is still the initial value
	      // - if so use the nextProps value
	      // - otherwise the `this.mask` has a value for us (most likely from paste action)
	      if (this.mask.getValue() === this.mask.emptyValue) {
	        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	      } else {
	        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	      }
	    } else if (this.props.mask !== nextProps.mask) {
	      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	    } else if (this.props.value !== nextProps.value) {
	      this.mask.setValue(nextProps.value);
	    }
	  };
	
	  MaskedInput.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    if (nextProps.mask !== this.props.mask) {
	      this._updatePattern(nextProps);
	    }
	  };
	
	  MaskedInput.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
	      this._updateInputSelection();
	    }
	  };
	
	  MaskedInput.prototype._updatePattern = function _updatePattern(props) {
	    this.mask.setPattern(props.mask, {
	      value: this.mask.getRawValue(),
	      selection: getSelection(this.input)
	    });
	  };
	
	  MaskedInput.prototype._updateMaskSelection = function _updateMaskSelection() {
	    this.mask.selection = getSelection(this.input);
	  };
	
	  MaskedInput.prototype._updateInputSelection = function _updateInputSelection() {
	    setSelection(this.input, this.mask.selection);
	  };
	
	  MaskedInput.prototype._getDisplayValue = function _getDisplayValue() {
	    var value = this.mask.getValue();
	    return value === this.mask.emptyValue ? '' : value;
	  };
	
	  MaskedInput.prototype._keyPressPropName = function _keyPressPropName() {
	    if (typeof navigator !== 'undefined') {
	      return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	    }
	    return 'onKeyPress';
	  };
	
	  MaskedInput.prototype._getEventHandlers = function _getEventHandlers() {
	    var _ref;
	
	    return _ref = {
	      onChange: this._onChange,
	      onKeyDown: this._onKeyDown,
	      onPaste: this._onPaste
	    }, _ref[this._keyPressPropName()] = this._onKeyPress, _ref;
	  };
	
	  MaskedInput.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  MaskedInput.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  MaskedInput.prototype.render = function render() {
	    var _this2 = this;
	
	    var ref = function ref(r) {
	      _this2.input = r;
	    };
	    var maxLength = this.mask.pattern.length;
	    var value = this._getDisplayValue();
	    var eventHandlers = this._getEventHandlers();
	    var _props = this.props,
	        _props$size = _props.size,
	        size = _props$size === undefined ? maxLength : _props$size,
	        _props$placeholder = _props.placeholder,
	        placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	
	    var _props2 = this.props,
	        placeholderChar = _props2.placeholderChar,
	        formatCharacters = _props2.formatCharacters,
	        cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters']); // eslint-disable-line no-unused-vars
	
	
	    var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	    return _react2.default.createElement('input', inputProps);
	  };
	
	  return MaskedInput;
	}(_react2.default.Component), _class.defaultProps = {
	  value: ''
	}, _temp2);
	MaskedInput.propTypes =  false ? {
	  mask: _propTypes2.default.string.isRequired,
	
	  formatCharacters: _propTypes2.default.object,
	  placeholderChar: _propTypes2.default.string
	} : {};
	exports.default = MaskedInput;
	module.exports = exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(2004);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(663);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(387);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(2001);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var createHTMLElement = function createHTMLElement(name) {
	  return document.createElement(name);
	};
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = createHTMLElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = createHTMLElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	if (false) {
	  Modal.setCreateHTMLElement = function (fn) {
	    return createHTMLElement = fn;
	  };
	}
	
	exports.default = Modal;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(2007);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(2008);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(663);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(2006);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(387);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(664);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(2005);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });
	
	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	
	var _portalOpenInstances = __webpack_require__(664);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  var _arr = [before, after];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var item = _arr[_i];
	    if (!item) continue;
	    item.parentNode && item.parentNode.removeChild(item);
	  }
	  before = after = null;
	  instances = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  console.log("bodyTrap ----------");
	  console.log(instances.length);
	  var _arr2 = [before, after];
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var item = _arr2[_i2];
	    var check = item || {};
	    console.log(check.nodeName, check.className, check.id);
	  }
	  console.log("edn bodyTrap ----------");
	}
	/* eslint-enable no-console */
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before && !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function removeClass(at, cls) {
	  at.classList.remove(cls);
	}
	
	/* istanbul ignore next */
	function resetState() {
	  var htmlElement = document.getElementsByTagName("html")[0];
	  for (var cls in htmlClassList) {
	    removeClass(htmlElement, htmlClassList[cls]);
	  }
	
	  var body = document.body;
	  for (var _cls in docBodyClassList) {
	    removeClass(body, docBodyClassList[_cls]);
	  }
	
	  htmlClassList = {};
	  docBodyClassList = {};
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n  ";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
	    }
	
	    classes = document.body.className;
	
	    buffer += "\n\ndoc.body (" + classes + "):\n  ";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
	    }
	
	    buffer += "\n";
	
	    console.log(buffer);
	  }
	}
	/* eslint-enable no-console */
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(665);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  focusLaterElements = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    console.log("focusManager ----------");
	    focusLaterElements.forEach(function (f) {
	      var check = f || {};
	      console.log(check.nodeName, check.className, check.id);
	    });
	    console.log("end focusManager ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(665);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(388);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(271);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(390);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(391);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(365);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(389);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(170);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(388);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(271);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(390);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(391);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(365);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(389);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(170);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(388);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(271);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(390);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(2012);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(391);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(365);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(389);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(170);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(2009);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(2010);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(2011);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(2015);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(666);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(271);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(2014);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(666);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.dehydrate = dehydrate;
	exports.hydrate = hydrate;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	// TYPES
	// FUNCTIONS
	function dehydrateMutation(mutation) {
	  return {
	    mutationKey: mutation.options.mutationKey,
	    state: mutation.state
	  };
	} // Most config is not dehydrated but instead meant to configure again when
	// consuming the de/rehydrated data, typically with useQuery on the client.
	// Sometimes it might make sense to prefetch data on the server and include
	// in the html-payload, but not consume it on the initial render.
	
	
	function dehydrateQuery(query) {
	  return {
	    state: query.state,
	    queryKey: query.queryKey,
	    queryHash: query.queryHash
	  };
	}
	
	function defaultShouldDehydrateMutation(mutation) {
	  return mutation.state.isPaused;
	}
	
	function defaultShouldDehydrateQuery(query) {
	  return query.state.status === 'success';
	}
	
	function dehydrate(client, options) {
	  var _options, _options2;
	
	  options = options || {};
	  var mutations = [];
	  var queries = [];
	
	  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
	    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
	    client.getMutationCache().getAll().forEach(function (mutation) {
	      if (shouldDehydrateMutation(mutation)) {
	        mutations.push(dehydrateMutation(mutation));
	      }
	    });
	  }
	
	  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
	    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
	    client.getQueryCache().getAll().forEach(function (query) {
	      if (shouldDehydrateQuery(query)) {
	        queries.push(dehydrateQuery(query));
	      }
	    });
	  }
	
	  return {
	    mutations: mutations,
	    queries: queries
	  };
	}
	
	function hydrate(client, dehydratedState, options) {
	  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
	    return;
	  }
	
	  var mutationCache = client.getMutationCache();
	  var queryCache = client.getQueryCache();
	  var mutations = dehydratedState.mutations || [];
	  var queries = dehydratedState.queries || [];
	  mutations.forEach(function (dehydratedMutation) {
	    var _options$defaultOptio;
	
	    mutationCache.build(client, (0, _extends2.default)({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
	      mutationKey: dehydratedMutation.mutationKey
	    }), dehydratedMutation.state);
	  });
	  queries.forEach(function (dehydratedQuery) {
	    var _options$defaultOptio2;
	
	    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data
	
	    if (query) {
	      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
	        query.setState(dehydratedQuery.state);
	      }
	
	      return;
	    } // Restore query
	
	
	    queryCache.build(client, (0, _extends2.default)({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
	      queryKey: dehydratedQuery.queryKey,
	      queryHash: dehydratedQuery.queryHash
	    }), dehydratedQuery.state);
	  });
	}

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.Query = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _utils = __webpack_require__(43);
	
	var _notifyManager = __webpack_require__(57);
	
	var _logger = __webpack_require__(273);
	
	var _retryer = __webpack_require__(186);
	
	// CLASS
	var Query = /*#__PURE__*/function () {
	  function Query(config) {
	    this.abortSignalConsumed = false;
	    this.hadObservers = false;
	    this.defaultOptions = config.defaultOptions;
	    this.setOptions(config.options);
	    this.observers = [];
	    this.cache = config.cache;
	    this.queryKey = config.queryKey;
	    this.queryHash = config.queryHash;
	    this.initialState = config.state || this.getDefaultState(this.options);
	    this.state = this.initialState;
	    this.meta = config.meta;
	    this.scheduleGc();
	  }
	
	  var _proto = Query.prototype;
	
	  _proto.setOptions = function setOptions(options) {
	    var _this$options$cacheTi;
	
	    this.options = (0, _extends2.default)({}, this.defaultOptions, options);
	    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
	
	    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
	  };
	
	  _proto.setDefaultOptions = function setDefaultOptions(options) {
	    this.defaultOptions = options;
	  };
	
	  _proto.scheduleGc = function scheduleGc() {
	    var _this = this;
	
	    this.clearGcTimeout();
	
	    if ((0, _utils.isValidTimeout)(this.cacheTime)) {
	      this.gcTimeout = setTimeout(function () {
	        _this.optionalRemove();
	      }, this.cacheTime);
	    }
	  };
	
	  _proto.clearGcTimeout = function clearGcTimeout() {
	    if (this.gcTimeout) {
	      clearTimeout(this.gcTimeout);
	      this.gcTimeout = undefined;
	    }
	  };
	
	  _proto.optionalRemove = function optionalRemove() {
	    if (!this.observers.length) {
	      if (this.state.isFetching) {
	        if (this.hadObservers) {
	          this.scheduleGc();
	        }
	      } else {
	        this.cache.remove(this);
	      }
	    }
	  };
	
	  _proto.setData = function setData(updater, options) {
	    var _this$options$isDataE, _this$options;
	
	    var prevData = this.state.data; // Get the new data
	
	    var data = (0, _utils.functionalUpdate)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
	
	    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
	      data = prevData;
	    } else if (this.options.structuralSharing !== false) {
	      // Structurally share data between prev and new data if needed
	      data = (0, _utils.replaceEqualDeep)(prevData, data);
	    } // Set data and mark it as cached
	
	
	    this.dispatch({
	      data: data,
	      type: 'success',
	      dataUpdatedAt: options == null ? void 0 : options.updatedAt
	    });
	    return data;
	  };
	
	  _proto.setState = function setState(state, setStateOptions) {
	    this.dispatch({
	      type: 'setState',
	      state: state,
	      setStateOptions: setStateOptions
	    });
	  };
	
	  _proto.cancel = function cancel(options) {
	    var _this$retryer;
	
	    var promise = this.promise;
	    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
	    return promise ? promise.then(_utils.noop).catch(_utils.noop) : Promise.resolve();
	  };
	
	  _proto.destroy = function destroy() {
	    this.clearGcTimeout();
	    this.cancel({
	      silent: true
	    });
	  };
	
	  _proto.reset = function reset() {
	    this.destroy();
	    this.setState(this.initialState);
	  };
	
	  _proto.isActive = function isActive() {
	    return this.observers.some(function (observer) {
	      return observer.options.enabled !== false;
	    });
	  };
	
	  _proto.isFetching = function isFetching() {
	    return this.state.isFetching;
	  };
	
	  _proto.isStale = function isStale() {
	    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
	      return observer.getCurrentResult().isStale;
	    });
	  };
	
	  _proto.isStaleByTime = function isStaleByTime(staleTime) {
	    if (staleTime === void 0) {
	      staleTime = 0;
	    }
	
	    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utils.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
	  };
	
	  _proto.onFocus = function onFocus() {
	    var _this$retryer2;
	
	    var observer = this.observers.find(function (x) {
	      return x.shouldFetchOnWindowFocus();
	    });
	
	    if (observer) {
	      observer.refetch();
	    } // Continue fetch if currently paused
	
	
	    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
	  };
	
	  _proto.onOnline = function onOnline() {
	    var _this$retryer3;
	
	    var observer = this.observers.find(function (x) {
	      return x.shouldFetchOnReconnect();
	    });
	
	    if (observer) {
	      observer.refetch();
	    } // Continue fetch if currently paused
	
	
	    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
	  };
	
	  _proto.addObserver = function addObserver(observer) {
	    if (this.observers.indexOf(observer) === -1) {
	      this.observers.push(observer);
	      this.hadObservers = true; // Stop the query from being garbage collected
	
	      this.clearGcTimeout();
	      this.cache.notify({
	        type: 'observerAdded',
	        query: this,
	        observer: observer
	      });
	    }
	  };
	
	  _proto.removeObserver = function removeObserver(observer) {
	    if (this.observers.indexOf(observer) !== -1) {
	      this.observers = this.observers.filter(function (x) {
	        return x !== observer;
	      });
	
	      if (!this.observers.length) {
	        // If the transport layer does not support cancellation
	        // we'll let the query continue so the result can be cached
	        if (this.retryer) {
	          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
	            this.retryer.cancel({
	              revert: true
	            });
	          } else {
	            this.retryer.cancelRetry();
	          }
	        }
	
	        if (this.cacheTime) {
	          this.scheduleGc();
	        } else {
	          this.cache.remove(this);
	        }
	      }
	
	      this.cache.notify({
	        type: 'observerRemoved',
	        query: this,
	        observer: observer
	      });
	    }
	  };
	
	  _proto.getObserversCount = function getObserversCount() {
	    return this.observers.length;
	  };
	
	  _proto.invalidate = function invalidate() {
	    if (!this.state.isInvalidated) {
	      this.dispatch({
	        type: 'invalidate'
	      });
	    }
	  };
	
	  _proto.fetch = function fetch(options, fetchOptions) {
	    var _this2 = this,
	        _this$options$behavio,
	        _context$fetchOptions,
	        _abortController$abor;
	
	    if (this.state.isFetching) {
	      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
	        // Silently cancel current fetch if the user wants to cancel refetches
	        this.cancel({
	          silent: true
	        });
	      } else if (this.promise) {
	        var _this$retryer4;
	
	        // make sure that retries that were potentially cancelled due to unmounts can continue
	        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching
	
	        return this.promise;
	      }
	    } // Update config if passed, otherwise the config from the last execution is used
	
	
	    if (options) {
	      this.setOptions(options);
	    } // Use the options from the first observer with a query function if no function is found.
	    // This can happen when the query is hydrated or created with setQueryData.
	
	
	    if (!this.options.queryFn) {
	      var observer = this.observers.find(function (x) {
	        return x.options.queryFn;
	      });
	
	      if (observer) {
	        this.setOptions(observer.options);
	      }
	    }
	
	    var queryKey = (0, _utils.ensureQueryKeyArray)(this.queryKey);
	    var abortController = (0, _utils.getAbortController)(); // Create query function context
	
	    var queryFnContext = {
	      queryKey: queryKey,
	      pageParam: undefined,
	      meta: this.meta
	    };
	    Object.defineProperty(queryFnContext, 'signal', {
	      enumerable: true,
	      get: function get() {
	        if (abortController) {
	          _this2.abortSignalConsumed = true;
	          return abortController.signal;
	        }
	
	        return undefined;
	      }
	    }); // Create fetch function
	
	    var fetchFn = function fetchFn() {
	      if (!_this2.options.queryFn) {
	        return Promise.reject('Missing queryFn');
	      }
	
	      _this2.abortSignalConsumed = false;
	      return _this2.options.queryFn(queryFnContext);
	    }; // Trigger behavior hook
	
	
	    var context = {
	      fetchOptions: fetchOptions,
	      options: this.options,
	      queryKey: queryKey,
	      state: this.state,
	      fetchFn: fetchFn,
	      meta: this.meta
	    };
	
	    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
	      var _this$options$behavio2;
	
	      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
	    } // Store state in case the current fetch needs to be reverted
	
	
	    this.revertState = this.state; // Set to fetching state if not already in it
	
	    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
	      var _context$fetchOptions2;
	
	      this.dispatch({
	        type: 'fetch',
	        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
	      });
	    } // Try to fetch the data
	
	
	    this.retryer = new _retryer.Retryer({
	      fn: context.fetchFn,
	      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
	      onSuccess: function onSuccess(data) {
	        _this2.setData(data); // Notify cache callback
	
	
	        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
	
	        if (_this2.cacheTime === 0) {
	          _this2.optionalRemove();
	        }
	      },
	      onError: function onError(error) {
	        // Optimistically update state if needed
	        if (!((0, _retryer.isCancelledError)(error) && error.silent)) {
	          _this2.dispatch({
	            type: 'error',
	            error: error
	          });
	        }
	
	        if (!(0, _retryer.isCancelledError)(error)) {
	          // Notify cache callback
	          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error
	
	          (0, _logger.getLogger)().error(error);
	        } // Remove query after fetching if cache time is 0
	
	
	        if (_this2.cacheTime === 0) {
	          _this2.optionalRemove();
	        }
	      },
	      onFail: function onFail() {
	        _this2.dispatch({
	          type: 'failed'
	        });
	      },
	      onPause: function onPause() {
	        _this2.dispatch({
	          type: 'pause'
	        });
	      },
	      onContinue: function onContinue() {
	        _this2.dispatch({
	          type: 'continue'
	        });
	      },
	      retry: context.options.retry,
	      retryDelay: context.options.retryDelay
	    });
	    this.promise = this.retryer.promise;
	    return this.promise;
	  };
	
	  _proto.dispatch = function dispatch(action) {
	    var _this3 = this;
	
	    this.state = this.reducer(this.state, action);
	
	    _notifyManager.notifyManager.batch(function () {
	      _this3.observers.forEach(function (observer) {
	        observer.onQueryUpdate(action);
	      });
	
	      _this3.cache.notify({
	        query: _this3,
	        type: 'queryUpdated',
	        action: action
	      });
	    });
	  };
	
	  _proto.getDefaultState = function getDefaultState(options) {
	    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
	    var hasInitialData = typeof options.initialData !== 'undefined';
	    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
	    var hasData = typeof data !== 'undefined';
	    return {
	      data: data,
	      dataUpdateCount: 0,
	      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
	      error: null,
	      errorUpdateCount: 0,
	      errorUpdatedAt: 0,
	      fetchFailureCount: 0,
	      fetchMeta: null,
	      isFetching: false,
	      isInvalidated: false,
	      isPaused: false,
	      status: hasData ? 'success' : 'idle'
	    };
	  };
	
	  _proto.reducer = function reducer(state, action) {
	    var _action$meta, _action$dataUpdatedAt;
	
	    switch (action.type) {
	      case 'failed':
	        return (0, _extends2.default)({}, state, {
	          fetchFailureCount: state.fetchFailureCount + 1
	        });
	
	      case 'pause':
	        return (0, _extends2.default)({}, state, {
	          isPaused: true
	        });
	
	      case 'continue':
	        return (0, _extends2.default)({}, state, {
	          isPaused: false
	        });
	
	      case 'fetch':
	        return (0, _extends2.default)({}, state, {
	          fetchFailureCount: 0,
	          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
	          isFetching: true,
	          isPaused: false
	        }, !state.dataUpdatedAt && {
	          error: null,
	          status: 'loading'
	        });
	
	      case 'success':
	        return (0, _extends2.default)({}, state, {
	          data: action.data,
	          dataUpdateCount: state.dataUpdateCount + 1,
	          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
	          error: null,
	          fetchFailureCount: 0,
	          isFetching: false,
	          isInvalidated: false,
	          isPaused: false,
	          status: 'success'
	        });
	
	      case 'error':
	        var error = action.error;
	
	        if ((0, _retryer.isCancelledError)(error) && error.revert && this.revertState) {
	          return (0, _extends2.default)({}, this.revertState);
	        }
	
	        return (0, _extends2.default)({}, state, {
	          error: error,
	          errorUpdateCount: state.errorUpdateCount + 1,
	          errorUpdatedAt: Date.now(),
	          fetchFailureCount: state.fetchFailureCount + 1,
	          isFetching: false,
	          isPaused: false,
	          status: 'error'
	        });
	
	      case 'invalidate':
	        return (0, _extends2.default)({}, state, {
	          isInvalidated: true
	        });
	
	      case 'setState':
	        return (0, _extends2.default)({}, state, action.state);
	
	      default:
	        return state;
	    }
	  };
	
	  return Query;
	}();
	
	exports.Query = Query;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.QueryClient = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _utils = __webpack_require__(43);
	
	var _queryCache = __webpack_require__(674);
	
	var _mutationCache = __webpack_require__(671);
	
	var _focusManager = __webpack_require__(272);
	
	var _onlineManager = __webpack_require__(392);
	
	var _notifyManager = __webpack_require__(57);
	
	var _infiniteQueryBehavior = __webpack_require__(668);
	
	// CLASS
	var QueryClient = /*#__PURE__*/function () {
	  function QueryClient(config) {
	    if (config === void 0) {
	      config = {};
	    }
	
	    this.queryCache = config.queryCache || new _queryCache.QueryCache();
	    this.mutationCache = config.mutationCache || new _mutationCache.MutationCache();
	    this.defaultOptions = config.defaultOptions || {};
	    this.queryDefaults = [];
	    this.mutationDefaults = [];
	  }
	
	  var _proto = QueryClient.prototype;
	
	  _proto.mount = function mount() {
	    var _this = this;
	
	    this.unsubscribeFocus = _focusManager.focusManager.subscribe(function () {
	      if (_focusManager.focusManager.isFocused() && _onlineManager.onlineManager.isOnline()) {
	        _this.mutationCache.onFocus();
	
	        _this.queryCache.onFocus();
	      }
	    });
	    this.unsubscribeOnline = _onlineManager.onlineManager.subscribe(function () {
	      if (_focusManager.focusManager.isFocused() && _onlineManager.onlineManager.isOnline()) {
	        _this.mutationCache.onOnline();
	
	        _this.queryCache.onOnline();
	      }
	    });
	  };
	
	  _proto.unmount = function unmount() {
	    var _this$unsubscribeFocu, _this$unsubscribeOnli;
	
	    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
	    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
	  };
	
	  _proto.isFetching = function isFetching(arg1, arg2) {
	    var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2),
	        filters = _parseFilterArgs[0];
	
	    filters.fetching = true;
	    return this.queryCache.findAll(filters).length;
	  };
	
	  _proto.isMutating = function isMutating(filters) {
	    return this.mutationCache.findAll((0, _extends2.default)({}, filters, {
	      fetching: true
	    })).length;
	  };
	
	  _proto.getQueryData = function getQueryData(queryKey, filters) {
	    var _this$queryCache$find;
	
	    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
	  };
	
	  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
	    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
	      var queryKey = _ref.queryKey,
	          state = _ref.state;
	      var data = state.data;
	      return [queryKey, data];
	    });
	  };
	
	  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
	    var parsedOptions = (0, _utils.parseQueryArgs)(queryKey);
	    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
	    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
	  };
	
	  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
	    var _this2 = this;
	
	    return _notifyManager.notifyManager.batch(function () {
	      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
	        var queryKey = _ref2.queryKey;
	        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
	      });
	    });
	  };
	
	  _proto.getQueryState = function getQueryState(queryKey, filters) {
	    var _this$queryCache$find2;
	
	    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
	  };
	
	  _proto.removeQueries = function removeQueries(arg1, arg2) {
	    var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2),
	        filters = _parseFilterArgs2[0];
	
	    var queryCache = this.queryCache;
	
	    _notifyManager.notifyManager.batch(function () {
	      queryCache.findAll(filters).forEach(function (query) {
	        queryCache.remove(query);
	      });
	    });
	  };
	
	  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
	    var _this3 = this;
	
	    var _parseFilterArgs3 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3),
	        filters = _parseFilterArgs3[0],
	        options = _parseFilterArgs3[1];
	
	    var queryCache = this.queryCache;
	    var refetchFilters = (0, _extends2.default)({}, filters, {
	      active: true
	    });
	    return _notifyManager.notifyManager.batch(function () {
	      queryCache.findAll(filters).forEach(function (query) {
	        query.reset();
	      });
	      return _this3.refetchQueries(refetchFilters, options);
	    });
	  };
	
	  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
	    var _this4 = this;
	
	    var _parseFilterArgs4 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3),
	        filters = _parseFilterArgs4[0],
	        _parseFilterArgs4$ = _parseFilterArgs4[1],
	        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
	
	    if (typeof cancelOptions.revert === 'undefined') {
	      cancelOptions.revert = true;
	    }
	
	    var promises = _notifyManager.notifyManager.batch(function () {
	      return _this4.queryCache.findAll(filters).map(function (query) {
	        return query.cancel(cancelOptions);
	      });
	    });
	
	    return Promise.all(promises).then(_utils.noop).catch(_utils.noop);
	  };
	
	  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
	    var _ref3,
	        _filters$refetchActiv,
	        _filters$refetchInact,
	        _this5 = this;
	
	    var _parseFilterArgs5 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3),
	        filters = _parseFilterArgs5[0],
	        options = _parseFilterArgs5[1];
	
	    var refetchFilters = (0, _extends2.default)({}, filters, {
	      // if filters.refetchActive is not provided and filters.active is explicitly false,
	      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
	      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
	      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
	    });
	    return _notifyManager.notifyManager.batch(function () {
	      _this5.queryCache.findAll(filters).forEach(function (query) {
	        query.invalidate();
	      });
	
	      return _this5.refetchQueries(refetchFilters, options);
	    });
	  };
	
	  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
	    var _this6 = this;
	
	    var _parseFilterArgs6 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3),
	        filters = _parseFilterArgs6[0],
	        options = _parseFilterArgs6[1];
	
	    var promises = _notifyManager.notifyManager.batch(function () {
	      return _this6.queryCache.findAll(filters).map(function (query) {
	        return query.fetch(undefined, (0, _extends2.default)({}, options, {
	          meta: {
	            refetchPage: filters == null ? void 0 : filters.refetchPage
	          }
	        }));
	      });
	    });
	
	    var promise = Promise.all(promises).then(_utils.noop);
	
	    if (!(options == null ? void 0 : options.throwOnError)) {
	      promise = promise.catch(_utils.noop);
	    }
	
	    return promise;
	  };
	
	  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
	    var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
	    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
	
	    if (typeof defaultedOptions.retry === 'undefined') {
	      defaultedOptions.retry = false;
	    }
	
	    var query = this.queryCache.build(this, defaultedOptions);
	    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
	  };
	
	  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
	    return this.fetchQuery(arg1, arg2, arg3).then(_utils.noop).catch(_utils.noop);
	  };
	
	  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
	    var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
	    parsedOptions.behavior = (0, _infiniteQueryBehavior.infiniteQueryBehavior)();
	    return this.fetchQuery(parsedOptions);
	  };
	
	  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
	    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(_utils.noop).catch(_utils.noop);
	  };
	
	  _proto.cancelMutations = function cancelMutations() {
	    var _this7 = this;
	
	    var promises = _notifyManager.notifyManager.batch(function () {
	      return _this7.mutationCache.getAll().map(function (mutation) {
	        return mutation.cancel();
	      });
	    });
	
	    return Promise.all(promises).then(_utils.noop).catch(_utils.noop);
	  };
	
	  _proto.resumePausedMutations = function resumePausedMutations() {
	    return this.getMutationCache().resumePausedMutations();
	  };
	
	  _proto.executeMutation = function executeMutation(options) {
	    return this.mutationCache.build(this, options).execute();
	  };
	
	  _proto.getQueryCache = function getQueryCache() {
	    return this.queryCache;
	  };
	
	  _proto.getMutationCache = function getMutationCache() {
	    return this.mutationCache;
	  };
	
	  _proto.getDefaultOptions = function getDefaultOptions() {
	    return this.defaultOptions;
	  };
	
	  _proto.setDefaultOptions = function setDefaultOptions(options) {
	    this.defaultOptions = options;
	  };
	
	  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
	    var result = this.queryDefaults.find(function (x) {
	      return (0, _utils.hashQueryKey)(queryKey) === (0, _utils.hashQueryKey)(x.queryKey);
	    });
	
	    if (result) {
	      result.defaultOptions = options;
	    } else {
	      this.queryDefaults.push({
	        queryKey: queryKey,
	        defaultOptions: options
	      });
	    }
	  };
	
	  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
	    var _this$queryDefaults$f;
	
	    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
	      return (0, _utils.partialMatchKey)(queryKey, x.queryKey);
	    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
	  };
	
	  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
	    var result = this.mutationDefaults.find(function (x) {
	      return (0, _utils.hashQueryKey)(mutationKey) === (0, _utils.hashQueryKey)(x.mutationKey);
	    });
	
	    if (result) {
	      result.defaultOptions = options;
	    } else {
	      this.mutationDefaults.push({
	        mutationKey: mutationKey,
	        defaultOptions: options
	      });
	    }
	  };
	
	  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
	    var _this$mutationDefault;
	
	    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
	      return (0, _utils.partialMatchKey)(mutationKey, x.mutationKey);
	    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
	  };
	
	  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
	    if (options == null ? void 0 : options._defaulted) {
	      return options;
	    }
	
	    var defaultedOptions = (0, _extends2.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
	      _defaulted: true
	    });
	
	    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
	      defaultedOptions.queryHash = (0, _utils.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
	    }
	
	    return defaultedOptions;
	  };
	
	  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
	    return this.defaultQueryOptions(options);
	  };
	
	  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
	    if (options == null ? void 0 : options._defaulted) {
	      return options;
	    }
	
	    return (0, _extends2.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
	      _defaulted: true
	    });
	  };
	
	  _proto.clear = function clear() {
	    this.queryCache.clear();
	    this.mutationCache.clear();
	  };
	
	  return QueryClient;
	}();
	
	exports.QueryClient = QueryClient;

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useHydrate = useHydrate;
	exports.Hydrate = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _core = __webpack_require__(185);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	function useHydrate(state, options) {
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	
	  var optionsRef = _react.default.useRef(options);
	
	  optionsRef.current = options; // Running hydrate again with the same queries is safe,
	  // it wont overwrite or initialize existing queries,
	  // relying on useMemo here is only a performance optimization.
	  // hydrate can and should be run *during* render here for SSR to work properly
	
	  _react.default.useMemo(function () {
	    if (state) {
	      (0, _core.hydrate)(queryClient, state, optionsRef.current);
	    }
	  }, [queryClient, state]);
	}
	
	var Hydrate = function Hydrate(_ref) {
	  var children = _ref.children,
	      options = _ref.options,
	      state = _ref.state;
	  useHydrate(state, options);
	  return children;
	};
	
	exports.Hydrate = Hydrate;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  QueryClientProvider: true,
	  useQueryClient: true,
	  QueryErrorResetBoundary: true,
	  useQueryErrorResetBoundary: true,
	  useIsFetching: true,
	  useIsMutating: true,
	  useMutation: true,
	  useQuery: true,
	  useQueries: true,
	  useInfiniteQuery: true,
	  useHydrate: true,
	  Hydrate: true
	};
	exports.Hydrate = exports.useHydrate = exports.useInfiniteQuery = exports.useQueries = exports.useQuery = exports.useMutation = exports.useIsMutating = exports.useIsFetching = exports.useQueryErrorResetBoundary = exports.QueryErrorResetBoundary = exports.useQueryClient = exports.QueryClientProvider = void 0;
	
	__webpack_require__(2024);
	
	__webpack_require__(2025);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	exports.QueryClientProvider = _QueryClientProvider.QueryClientProvider;
	exports.useQueryClient = _QueryClientProvider.useQueryClient;
	
	var _QueryErrorResetBoundary = __webpack_require__(675);
	
	exports.QueryErrorResetBoundary = _QueryErrorResetBoundary.QueryErrorResetBoundary;
	exports.useQueryErrorResetBoundary = _QueryErrorResetBoundary.useQueryErrorResetBoundary;
	
	var _useIsFetching = __webpack_require__(2028);
	
	exports.useIsFetching = _useIsFetching.useIsFetching;
	
	var _useIsMutating = __webpack_require__(2029);
	
	exports.useIsMutating = _useIsMutating.useIsMutating;
	
	var _useMutation = __webpack_require__(2030);
	
	exports.useMutation = _useMutation.useMutation;
	
	var _useQuery = __webpack_require__(2032);
	
	exports.useQuery = _useQuery.useQuery;
	
	var _useQueries = __webpack_require__(2031);
	
	exports.useQueries = _useQueries.useQueries;
	
	var _useInfiniteQuery = __webpack_require__(2027);
	
	exports.useInfiniteQuery = _useInfiniteQuery.useInfiniteQuery;
	
	var _Hydrate = __webpack_require__(2020);
	
	exports.useHydrate = _Hydrate.useHydrate;
	exports.Hydrate = _Hydrate.Hydrate;
	
	var _types = __webpack_require__(2026);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  exports[key] = _types[key];
	});

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.logger = void 0;
	var logger = console;
	exports.logger = logger;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = _interopRequireDefault(__webpack_require__(36));
	
	var unstable_batchedUpdates = _reactDom.default.unstable_batchedUpdates;
	exports.unstable_batchedUpdates = unstable_batchedUpdates;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(185);
	
	var _reactBatchedUpdates = __webpack_require__(2023);
	
	_core.notifyManager.setBatchNotifyFunction(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(185);
	
	var _logger = __webpack_require__(2022);
	
	(0, _core.setLogger)(_logger.logger);

/***/ }),
/* 2026 */
2019,
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useInfiniteQuery = useInfiniteQuery;
	
	var _infiniteQueryObserver = __webpack_require__(669);
	
	var _utils = __webpack_require__(43);
	
	var _useBaseQuery = __webpack_require__(676);
	
	function useInfiniteQuery(arg1, arg2, arg3) {
	  var options = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
	  return (0, _useBaseQuery.useBaseQuery)(options, _infiniteQueryObserver.InfiniteQueryObserver);
	}

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useIsFetching = useIsFetching;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _notifyManager = __webpack_require__(57);
	
	var _utils = __webpack_require__(43);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	var checkIsFetching = function checkIsFetching(queryClient, filters, isFetching, setIsFetching) {
	  var newIsFetching = queryClient.isFetching(filters);
	
	  if (isFetching !== newIsFetching) {
	    setIsFetching(newIsFetching);
	  }
	};
	
	function useIsFetching(arg1, arg2) {
	  var mountedRef = _react.default.useRef(false);
	
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	
	  var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2),
	      filters = _parseFilterArgs[0];
	
	  var _React$useState = _react.default.useState(queryClient.isFetching(filters)),
	      isFetching = _React$useState[0],
	      setIsFetching = _React$useState[1];
	
	  var filtersRef = _react.default.useRef(filters);
	
	  filtersRef.current = filters;
	
	  var isFetchingRef = _react.default.useRef(isFetching);
	
	  isFetchingRef.current = isFetching;
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
	    var unsubscribe = queryClient.getQueryCache().subscribe(_notifyManager.notifyManager.batchCalls(function () {
	      if (mountedRef.current) {
	        checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
	      }
	    }));
	    return function () {
	      mountedRef.current = false;
	      unsubscribe();
	    };
	  }, [queryClient]);
	
	  return isFetching;
	}

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useIsMutating = useIsMutating;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _notifyManager = __webpack_require__(57);
	
	var _utils = __webpack_require__(43);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	function useIsMutating(arg1, arg2) {
	  var mountedRef = _react.default.useRef(false);
	
	  var filters = (0, _utils.parseMutationFilterArgs)(arg1, arg2);
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	
	  var _React$useState = _react.default.useState(queryClient.isMutating(filters)),
	      isMutating = _React$useState[0],
	      setIsMutating = _React$useState[1];
	
	  var filtersRef = _react.default.useRef(filters);
	
	  filtersRef.current = filters;
	
	  var isMutatingRef = _react.default.useRef(isMutating);
	
	  isMutatingRef.current = isMutating;
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    var unsubscribe = queryClient.getMutationCache().subscribe(_notifyManager.notifyManager.batchCalls(function () {
	      if (mountedRef.current) {
	        var newIsMutating = queryClient.isMutating(filtersRef.current);
	
	        if (isMutatingRef.current !== newIsMutating) {
	          setIsMutating(newIsMutating);
	        }
	      }
	    }));
	    return function () {
	      mountedRef.current = false;
	      unsubscribe();
	    };
	  }, [queryClient]);
	
	  return isMutating;
	}

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports.useMutation = useMutation;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _notifyManager = __webpack_require__(57);
	
	var _utils = __webpack_require__(43);
	
	var _mutationObserver = __webpack_require__(672);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	var _utils2 = __webpack_require__(677);
	
	function useMutation(arg1, arg2, arg3) {
	  var mountedRef = _react.default.useRef(false);
	
	  var _React$useState = _react.default.useState(0),
	      forceUpdate = _React$useState[1];
	
	  var options = (0, _utils.parseMutationArgs)(arg1, arg2, arg3);
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	
	  var obsRef = _react.default.useRef();
	
	  if (!obsRef.current) {
	    obsRef.current = new _mutationObserver.MutationObserver(queryClient, options);
	  } else {
	    obsRef.current.setOptions(options);
	  }
	
	  var currentResult = obsRef.current.getCurrentResult();
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    var unsubscribe = obsRef.current.subscribe(_notifyManager.notifyManager.batchCalls(function () {
	      if (mountedRef.current) {
	        forceUpdate(function (x) {
	          return x + 1;
	        });
	      }
	    }));
	    return function () {
	      mountedRef.current = false;
	      unsubscribe();
	    };
	  }, []);
	
	  var mutate = _react.default.useCallback(function (variables, mutateOptions) {
	    obsRef.current.mutate(variables, mutateOptions).catch(_utils.noop);
	  }, []);
	
	  if (currentResult.error && (0, _utils2.shouldThrowError)(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
	    throw currentResult.error;
	  }
	
	  return (0, _extends2.default)({}, currentResult, {
	    mutate: mutate,
	    mutateAsync: currentResult.mutate
	  });
	}

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	exports.__esModule = true;
	exports.useQueries = useQueries;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _notifyManager = __webpack_require__(57);
	
	var _queriesObserver = __webpack_require__(673);
	
	var _QueryClientProvider = __webpack_require__(127);
	
	function useQueries(queries) {
	  var mountedRef = _react.default.useRef(false);
	
	  var _React$useState = _react.default.useState(0),
	      forceUpdate = _React$useState[1];
	
	  var queryClient = (0, _QueryClientProvider.useQueryClient)();
	  var defaultedQueries = (0, _react.useMemo)(function () {
	    return queries.map(function (options) {
	      var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
	
	      defaultedOptions.optimisticResults = true;
	      return defaultedOptions;
	    });
	  }, [queries, queryClient]);
	
	  var _React$useState2 = _react.default.useState(function () {
	    return new _queriesObserver.QueriesObserver(queryClient, defaultedQueries);
	  }),
	      observer = _React$useState2[0];
	
	  var result = observer.getOptimisticResult(defaultedQueries);
	
	  _react.default.useEffect(function () {
	    mountedRef.current = true;
	    var unsubscribe = observer.subscribe(_notifyManager.notifyManager.batchCalls(function () {
	      if (mountedRef.current) {
	        forceUpdate(function (x) {
	          return x + 1;
	        });
	      }
	    }));
	    return function () {
	      mountedRef.current = false;
	      unsubscribe();
	    };
	  }, [observer]);
	
	  _react.default.useEffect(function () {
	    // Do not notify on updates because of changes in the options because
	    // these changes should already be reflected in the optimistic result.
	    observer.setQueries(defaultedQueries, {
	      listeners: false
	    });
	  }, [defaultedQueries, observer]);
	
	  return result;
	}

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useQuery = useQuery;
	
	var _core = __webpack_require__(185);
	
	var _utils = __webpack_require__(43);
	
	var _useBaseQuery = __webpack_require__(676);
	
	function useQuery(arg1, arg2, arg3) {
	  var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
	  return (0, _useBaseQuery.useBaseQuery)(parsedOptions, _core.QueryObserver);
	}

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	var _interopRequireWildcard = __webpack_require__(60)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _Context = __webpack_require__(128);
	
	var _Subscription = __webpack_require__(395);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(396);
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = (0, _Subscription.createSubscription)(store);
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(678));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(683));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(2035));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(2036));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(2037));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(2038));
	
	var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _bindActionCreators = _interopRequireDefault(__webpack_require__(2043));
	
	var _wrapMapToProps = __webpack_require__(679);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(679);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.defaultMergeProps = defaultMergeProps;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(684));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = finalPropsSelectorFactory;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(2039));
	
	var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(685));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6)["default"];
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(2033));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(678));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(128);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(2034));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(2041);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(2042);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(681);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(683));
	
	exports.shallowEqual = _shallowEqual["default"];

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(128);
	
	var _useStore = __webpack_require__(681);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(680);
	
	var _Subscription = __webpack_require__(395);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(396);
	
	var _Context = __webpack_require__(128);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return (0, _Subscription.createSubscription)(store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
	
	      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
	        selectedState = newSelectedState;
	      } else {
	        selectedState = latestSelectedState.current;
	      }
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
	
	        if (newStoreState === latestStoreState.current) {
	          return;
	        }
	
	        var _newSelectedState = latestSelector.current(newStoreState);
	
	        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = _newSelectedState;
	        latestStoreState.current = newStoreState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      if (!selector) {
	        throw new Error("You must pass a selector to useSelector");
	      }
	
	      if (typeof selector !== 'function') {
	        throw new Error("You must pass a function as a selector to useSelector");
	      }
	
	      if (typeof equalityFn !== 'function') {
	        throw new Error("You must pass a function as an equality function to useSelector");
	      }
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	
	function bindActionCreators(actionCreators, dispatch) {
	  var boundActionCreators = {};
	
	  var _loop = function _loop(key) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = function () {
	        return dispatch(actionCreator.apply(void 0, arguments));
	      };
	    }
	  };
	
	  for (var key in actionCreators) {
	    _loop(key);
	  }
	
	  return boundActionCreators;
	}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(36);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ }),
/* 2047 */
[2408, 2046],
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(15);var history=__webpack_require__(563);__webpack_require__(306);var createContext=_interopDefault(__webpack_require__(1752)),invariant=_interopDefault(__webpack_require__(462)),pathToRegexp=_interopDefault(__webpack_require__(1758));__webpack_require__(386);var hoistStatics=_interopDefault(__webpack_require__(352));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollLink = __webpack_require__(399);
	
	var _scrollLink2 = _interopRequireDefault(_scrollLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonElement = function (_React$Component) {
	  _inherits(ButtonElement, _React$Component);
	
	  function ButtonElement() {
	    _classCallCheck(this, ButtonElement);
	
	    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
	  }
	
	  _createClass(ButtonElement, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'input',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return ButtonElement;
	}(_react2.default.Component);
	
	;
	
	exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollElement = __webpack_require__(689);
	
	var _scrollElement2 = _interopRequireDefault(_scrollElement);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ElementWrapper = function (_React$Component) {
	  _inherits(ElementWrapper, _React$Component);
	
	  function ElementWrapper() {
	    _classCallCheck(this, ElementWrapper);
	
	    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
	  }
	
	  _createClass(ElementWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Remove `parentBindings` from props
	      var newProps = _extends({}, this.props);
	      if (newProps.parentBindings) {
	        delete newProps.parentBindings;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, newProps, { ref: function ref(el) {
	            _this2.props.parentBindings.domNode = el;
	          } }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ElementWrapper;
	}(_react2.default.Component);
	
	;
	
	ElementWrapper.propTypes = {
	  name: _propTypes2.default.string,
	  id: _propTypes2.default.string
	};
	
	exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollLink = __webpack_require__(399);
	
	var _scrollLink2 = _interopRequireDefault(_scrollLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkElement = function (_React$Component) {
	  _inherits(LinkElement, _React$Component);
	
	  function LinkElement() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkElement);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'a',
	        _this.props,
	        _this.props.children
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return LinkElement;
	}(_react2.default.Component);
	
	;
	
	exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* DEPRECATED */
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(36);
	
	var utils = __webpack_require__(276);
	var scrollSpy = __webpack_require__(400);
	var defaultScroller = __webpack_require__(275);
	var PropTypes = __webpack_require__(15);
	var scrollHash = __webpack_require__(690);
	
	var protoTypes = {
	  to: PropTypes.string.isRequired,
	  containerId: PropTypes.string,
	  container: PropTypes.object,
	  activeClass: PropTypes.string,
	  spy: PropTypes.bool,
	  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	  offset: PropTypes.number,
	  delay: PropTypes.number,
	  isDynamic: PropTypes.bool,
	  onClick: PropTypes.func,
	  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
	  absolute: PropTypes.bool,
	  onSetActive: PropTypes.func,
	  onSetInactive: PropTypes.func,
	  ignoreCancelEvents: PropTypes.bool,
	  hashSpy: PropTypes.bool
	};
	
	var Helpers = {
	  Scroll: function Scroll(Component, customScroller) {
	
	    console.warn("Helpers.Scroll is deprecated since v1.7.0");
	
	    var scroller = customScroller || defaultScroller;
	
	    var Scroll = function (_React$Component) {
	      _inherits(Scroll, _React$Component);
	
	      function Scroll(props) {
	        _classCallCheck(this, Scroll);
	
	        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {
	          active: false
	        };
	        return _this;
	      }
	
	      _createClass(Scroll, [{
	        key: 'getScrollSpyContainer',
	        value: function getScrollSpyContainer() {
	          var containerId = this.props.containerId;
	          var container = this.props.container;
	
	          if (containerId) {
	            return document.getElementById(containerId);
	          }
	
	          if (container && container.nodeType) {
	            return container;
	          }
	
	          return document;
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          if (this.props.spy || this.props.hashSpy) {
	            var scrollSpyContainer = this.getScrollSpyContainer();
	
	            if (!scrollSpy.isMounted(scrollSpyContainer)) {
	              scrollSpy.mount(scrollSpyContainer);
	            }
	
	            if (this.props.hashSpy) {
	              if (!scrollHash.isMounted()) {
	                scrollHash.mount(scroller);
	              }
	              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
	            }
	
	            if (this.props.spy) {
	              scrollSpy.addStateHandler(this.stateHandler);
	            }
	
	            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);
	
	            this.setState({
	              container: scrollSpyContainer
	            });
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          scrollSpy.unmount(this.stateHandler, this.spyHandler);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var className = "";
	
	          if (this.state && this.state.active) {
	            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	          } else {
	            className = this.props.className;
	          }
	
	          var props = _extends({}, this.props);
	
	          for (var prop in protoTypes) {
	            if (props.hasOwnProperty(prop)) {
	              delete props[prop];
	            }
	          }
	
	          props.className = className;
	          props.onClick = this.handleClick;
	
	          return React.createElement(Component, props);
	        }
	      }]);
	
	      return Scroll;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.scrollTo = function (to, props) {
	        scroller.scrollTo(to, _extends({}, _this2.state, props));
	      };
	
	      this.handleClick = function (event) {
	
	        /*
	         * give the posibility to override onClick
	         */
	
	        if (_this2.props.onClick) {
	          _this2.props.onClick(event);
	        }
	
	        /*
	         * dont bubble the navigation
	         */
	
	        if (event.stopPropagation) event.stopPropagation();
	        if (event.preventDefault) event.preventDefault();
	
	        /*
	         * do the magic!
	         */
	        _this2.scrollTo(_this2.props.to, _this2.props);
	      };
	
	      this.stateHandler = function () {
	        if (scroller.getActiveLink() !== _this2.props.to) {
	          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
	            _this2.props.onSetInactive();
	          }
	          _this2.setState({ active: false });
	        }
	      };
	
	      this.spyHandler = function (y) {
	
	        var scrollSpyContainer = _this2.getScrollSpyContainer();
	
	        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
	          return;
	        }
	
	        var to = _this2.props.to;
	        var element = null;
	        var elemTopBound = 0;
	        var elemBottomBound = 0;
	        var containerTop = 0;
	
	        if (scrollSpyContainer.getBoundingClientRect) {
	          var containerCords = scrollSpyContainer.getBoundingClientRect();
	          containerTop = containerCords.top;
	        }
	
	        if (!element || _this2.props.isDynamic) {
	          element = scroller.get(to);
	          if (!element) {
	            return;
	          }
	
	          var cords = element.getBoundingClientRect();
	          elemTopBound = cords.top - containerTop + y;
	          elemBottomBound = elemTopBound + cords.height;
	        }
	
	        var offsetY = y - _this2.props.offset;
	        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
	        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
	        var activeLink = scroller.getActiveLink();
	
	        if (isOutside) {
	          if (to === activeLink) {
	            scroller.setActiveLink(void 0);
	          }
	
	          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
	            scrollHash.changeHash();
	          }
	
	          if (_this2.props.spy && _this2.state.active) {
	            _this2.setState({ active: false });
	            _this2.props.onSetInactive && _this2.props.onSetInactive();
	          }
	
	          return scrollSpy.updateStates();
	        }
	
	        if (isInside && activeLink !== to) {
	          scroller.setActiveLink(to);
	
	          _this2.props.hashSpy && scrollHash.changeHash(to);
	
	          if (_this2.props.spy) {
	            _this2.setState({ active: true });
	            _this2.props.onSetActive && _this2.props.onSetActive(to);
	          }
	          return scrollSpy.updateStates();
	        }
	      };
	    };
	
	    ;
	
	    Scroll.propTypes = protoTypes;
	
	    Scroll.defaultProps = { offset: 0 };
	
	    return Scroll;
	  },
	  Element: function Element(Component) {
	
	    console.warn("Helpers.Element is deprecated since v1.7.0");
	
	    var Element = function (_React$Component2) {
	      _inherits(Element, _React$Component2);
	
	      function Element(props) {
	        _classCallCheck(this, Element);
	
	        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
	
	        _this3.childBindings = {
	          domNode: null
	        };
	        return _this3;
	      }
	
	      _createClass(Element, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          if (typeof window === 'undefined') {
	            return false;
	          }
	          this.registerElems(this.props.name);
	        }
	      }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	          if (this.props.name !== prevProps.name) {
	            this.registerElems(this.props.name);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (typeof window === 'undefined') {
	            return false;
	          }
	          defaultScroller.unregister(this.props.name);
	        }
	      }, {
	        key: 'registerElems',
	        value: function registerElems(name) {
	          defaultScroller.register(name, this.childBindings.domNode);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
	        }
	      }]);
	
	      return Element;
	    }(React.Component);
	
	    ;
	
	    Element.propTypes = {
	      name: PropTypes.string,
	      id: PropTypes.string
	    };
	
	    return Element;
	  }
	};
	
	module.exports = Helpers;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _passiveEventListeners = __webpack_require__(397);
	
	var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];
	
	exports.default = {
	  subscribe: function subscribe(cancelEvent) {
	    return typeof document !== 'undefined' && events.forEach(function (event) {
	      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
	    });
	  }
	};

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  /*
	   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
	   */
	  defaultEasing: function defaultEasing(x) {
	    if (x < 0.5) {
	      return Math.pow(x * 2, 2) / 2;
	    }
	    return 1 - Math.pow((1 - x) * 2, 2) / 2;
	  },
	  /*
	   * https://gist.github.com/gre/1650294
	   */
	  // no easing, no acceleration
	  linear: function linear(x) {
	    return x;
	  },
	  // accelerating from zero velocity
	  easeInQuad: function easeInQuad(x) {
	    return x * x;
	  },
	  // decelerating to zero velocity
	  easeOutQuad: function easeOutQuad(x) {
	    return x * (2 - x);
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuad: function easeInOutQuad(x) {
	    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
	  },
	  // accelerating from zero velocity 
	  easeInCubic: function easeInCubic(x) {
	    return x * x * x;
	  },
	  // decelerating to zero velocity π
	  easeOutCubic: function easeOutCubic(x) {
	    return --x * x * x + 1;
	  },
	  // acceleration until halfway, then deceleration 
	  easeInOutCubic: function easeInOutCubic(x) {
	    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
	  },
	  // accelerating from zero velocity 
	  easeInQuart: function easeInQuart(x) {
	    return x * x * x * x;
	  },
	  // decelerating to zero velocity 
	  easeOutQuart: function easeOutQuart(x) {
	    return 1 - --x * x * x * x;
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuart: function easeInOutQuart(x) {
	    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
	  },
	  // accelerating from zero velocity
	  easeInQuint: function easeInQuint(x) {
	    return x * x * x * x * x;
	  },
	  // decelerating to zero velocity
	  easeOutQuint: function easeOutQuint(x) {
	    return 1 + --x * x * x * x * x;
	  },
	  // acceleration until halfway, then deceleration 
	  easeInOutQuint: function easeInOutQuint(x) {
	    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
	  }
	};

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(691);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(692);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(277);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(277);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(691);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(2055);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(692);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(694);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(693);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(402);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(695);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(696);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(401);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(403);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2065);

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(2064);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(403);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(2062);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(698);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(170);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(2066);
	
	var _dots = __webpack_require__(2060);
	
	var _arrows = __webpack_require__(2059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(699);
	
	var _helpers = __webpack_require__(403);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(2063);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(1643);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(698);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(1181);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(1315);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(121);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = listen;
	exports.unlisten = unlisten;
	////////////////////////////////////////////////////////////////////////////////////////
	// Small helpers that provide an easy and effecient way to add/remove event listeners //
	////////////////////////////////////////////////////////////////////////////////////////
	
	var elementsWithListeners = [],
	    registeredListeners = [];
	
	function addListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	  if (idx === -1) {
	    idx = elementsWithListeners.length;
	    elementsWithListeners.push(el);
	    registeredListeners.push({ el: el, totalCount: 0 });
	  }
	
	  var listeners = registeredListeners[idx],
	      listener = listeners[event];
	
	  if (!listener) {
	    listener = listeners[event] = { callbacks: [] };
	    listener.cb = function (e) {
	      for (var i = 0, l = listener.callbacks.length; i < l; i += 1) {
	        listener.callbacks[i](e);
	      }
	    };
	    listeners.totalCount += 1;
	    listeners.el.addEventListener(event, listener.cb);
	  }
	
	  // just to prevent double listeners
	  if (listener.callbacks.indexOf(cb) !== -1) {
	    return;
	  }
	
	  listener.callbacks.push(cb);
	}
	
	function removeListener(el, event, cb) {
	  var idx = elementsWithListeners.indexOf(el);
	  if (idx === -1) {
	    return;
	  }
	
	  var listeners = registeredListeners[idx],
	      listener = listeners[event],
	      callbacks = listener ? listener.callbacks : [];
	
	  if (!listener || callbacks.indexOf(cb) === -1) {
	    return;
	  }
	
	  callbacks.splice(callbacks.indexOf(cb), 1);
	  if (callbacks.length > 0) {
	    return;
	  }
	
	  listeners.el.removeEventListener(event, listener.cb);
	  listeners.totalCount -= 1;
	  delete listeners[event];
	
	  if (listeners.totalCount > 0) {
	    return;
	  }
	
	  elementsWithListeners.splice(idx, 1);
	  registeredListeners.splice(idx, 1);
	}
	
	/**
	 * Subscribe cb to events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be called
	 */
	function listen(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    addListener(el, events[i], cb);
	  }
	}
	
	/**
	 * Unsubscribe cb from events list
	 * @param  {HTMLElement}   el       target element
	 * @param  {Array}         events   array of event names
	 * @param  {Function} cb   callback that should be unsubscribed
	 */
	
	function unlisten(el, events, cb) {
	  for (var i = 0, l = events.length; i < l; i += 1) {
	    removeListener(el, events[i], cb);
	  }
	}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = find;
	var basicSelectors = {};
	if (typeof document !== 'undefined') {
	  basicSelectors.body = document.body;
	  basicSelectors.window = window;
	  basicSelectors.document = document;
	}
	
	var matchesMethodName = function () {
	  if (typeof document !== 'undefined') {
	    var body = document.body;
	    return typeof body.matches === 'function' ? 'matches' : typeof body.webkitMatchesSelector === 'function' ? 'webkitMatchesSelector' : //webkit
	    typeof body.mozMatchesSelector === 'function' ? 'mozMatchesSelector' : //mozilla
	    typeof body.msMatchesSelector === 'function' ? 'msMatchesSelector' : //ie
	    typeof body.oMatchesSelector === 'function' ? 'oMatchesSelector' : //old opera
	    null;
	  }
	}();
	
	function find(selector, el) {
	  if (!selector) {
	    return null;
	  }
	
	  if (basicSelectors.hasOwnProperty(selector)) {
	    return basicSelectors[selector];
	  }
	
	  // select by id
	  if (selector[0] === '#') {
	    return document.getElementById(selector.slice(1));
	  }
	
	  if (!matchesMethodName) {
	    return null;
	  }
	
	  // eslint-disable-next-line no-cond-assign
	  while (el = el.parentElement) {
	    if (el[matchesMethodName](selector)) {
	      return el;
	    }
	  }
	
	  // nothing has been found :(
	  return null;
	}
	module.exports = exports['default'];

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getClosestTransformedParent;
	function getClosestTransformedParent(el) {
	    do {
	        var style = window.getComputedStyle(el);
	        if (style.transform !== 'none' || style.webkitTransform !== 'none') return el;
	        el = el.parentElement || el.parentNode;
	    } while (el !== null && el.nodeType === 1);
	    return null;
	}
	module.exports = exports['default'];

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(2067);
	
	var _find = __webpack_require__(2068);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _getClosestTransformedParent = __webpack_require__(2069);
	
	var _getClosestTransformedParent2 = _interopRequireDefault(_getClosestTransformedParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stickyOwnProps = ['mode', 'disabled', 'onFixedToggle', 'stickyStyle', 'stickyClassName', 'boundaryElement', 'scrollElement', 'bottomOffset', 'topOffset', 'positionRecheckInterval', 'noExceptionOnMissedScrollElement', 'wrapperCmp', 'holderCmp', 'hideOnBoundaryHit', 'offsetTransforms', 'holderProps'];
	
	var isEqual = function isEqual(obj1, obj2) {
	  var styles1 = obj1.styles;
	  var styles2 = obj2.styles;
	
	  if (obj1.fixed !== obj2.fixed || obj1.height !== obj2.height || !styles1 && styles2 || styles1 && !styles2) {
	    return false;
	  }
	
	  for (var field in styles1) {
	    if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var buildTopStyles = function buildTopStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var top = container.top,
	      height = container.height,
	      width = container.width,
	      boundaryBottom = container.boundaryBottom;
	
	
	  if (hideOnBoundaryHit || top + height + bottomOffset < boundaryBottom) {
	    return { top: top, width: width, position: 'fixed' };
	  }
	
	  return { width: width, bottom: bottomOffset, position: 'absolute' };
	};
	
	var buildBottomStyles = function buildBottomStyles(container, props) {
	  var bottomOffset = props.bottomOffset,
	      hideOnBoundaryHit = props.hideOnBoundaryHit;
	  var bottom = container.bottom,
	      height = container.height,
	      width = container.width,
	      boundaryTop = container.boundaryTop;
	
	
	  if (hideOnBoundaryHit || bottom - height - bottomOffset > boundaryTop) {
	    return { width: width, top: bottom - height, position: 'fixed' };
	  }
	
	  return { width: width, top: bottomOffset, position: 'absolute' };
	};
	
	var buildStickyStyle = function buildStickyStyle(mode, props, container) {
	  return (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
	};
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky(props) {
	    _classCallCheck(this, Sticky);
	
	    var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));
	
	    _this.createWrapperRef = function (wrapper) {
	      _this.wrapperEl = wrapper;
	    };
	
	    _this.createHolderRef = function (holder) {
	      _this.holderEl = holder;
	    };
	
	    _this.checkPosition = function () {
	      var holderEl = _this.holderEl,
	          wrapperEl = _this.wrapperEl,
	          boundaryElement = _this.boundaryElement,
	          scrollElement = _this.scrollElement,
	          disabled = _this.disabled;
	      var _this$props = _this.props,
	          mode = _this$props.mode,
	          onFixedToggle = _this$props.onFixedToggle,
	          offsetTransforms = _this$props.offsetTransforms;
	
	
	      if (disabled) {
	        if (_this.state.fixed) {
	          _this.setState({ fixed: false });
	        }
	        return;
	      }
	
	      var holderRect = holderEl.getBoundingClientRect();
	      var wrapperRect = wrapperEl.getBoundingClientRect();
	      var boundaryRect = boundaryElement ? getRect(boundaryElement) : { top: -Infinity, bottom: Infinity };
	      var scrollRect = getRect(scrollElement);
	      var fixed = _this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);
	
	      var offsets = null;
	      if (offsetTransforms && fixed) {
	        var closestTransformedParent = (0, _getClosestTransformedParent2.default)(scrollElement);
	        if (closestTransformedParent) offsets = getRect(closestTransformedParent);
	      }
	
	      var newState = {
	        fixed: fixed,
	        height: wrapperRect.height,
	        styles: fixed ? buildStickyStyle(mode, _this.props, {
	          boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
	          boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
	          top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
	          bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
	          width: holderRect.width,
	          height: wrapperRect.height
	        }) : null
	      };
	
	      if (fixed !== _this.state.fixed && onFixedToggle && typeof onFixedToggle === 'function') {
	        onFixedToggle(_this.state.fixed);
	      }
	
	      if (!isEqual(_this.state, newState)) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.disabled = props.disabled;
	    _this.state = {
	      height: 0,
	      fixed: false,
	      styles: null
	    };
	    return _this;
	  }
	
	  _createClass(Sticky, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var me = _reactDom2.default.findDOMNode(this);
	      var _props = this.props,
	          boundaryElement = _props.boundaryElement,
	          scrollElement = _props.scrollElement,
	          noExceptionOnMissedScrollElement = _props.noExceptionOnMissedScrollElement,
	          positionRecheckInterval = _props.positionRecheckInterval,
	          disabled = _props.disabled;
	
	
	      this.disabled = disabled;
	      this.boundaryElement = (0, _find2.default)(boundaryElement, me);
	      if (this.boundaryElement === window || this.boundaryElement === document) {
	        // such objects can't be used as boundary
	        // and in fact there is no point in such a case
	        this.boundaryElement = null;
	      }
	      this.scrollElement = scrollElement;
	      if (typeof scrollElement === 'string') {
	        this.scrollElement = (0, _find2.default)(scrollElement, me);
	      }
	
	      if (this.scrollElement) {
	        (0, _events.listen)(this.scrollElement, ['scroll'], this.checkPosition);
	      } else if (!noExceptionOnMissedScrollElement) {
	        throw new Error('Cannot find scrollElement ' + scrollElement);
	      }
	
	      (0, _events.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	      this.checkPosition();
	
	      if (positionRecheckInterval) {
	        this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
	      }
	    }
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(_ref) {
	      var disabled = _ref.disabled;
	
	      if (this.disabled !== disabled) {
	        this.disabled = disabled;
	        this.checkPosition();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.scrollElement) {
	        (0, _events.unlisten)(this.scrollElement, ['scroll'], this.checkPosition);
	      }
	      (0, _events.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
	      this.boundaryElement = null;
	      this.scrollElement = null;
	      clearTimeout(this.checkPositionIntervalId);
	    }
	  }, {
	    key: 'isFixed',
	    value: function isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
	      var _props2 = this.props,
	          hideOnBoundaryHit = _props2.hideOnBoundaryHit,
	          bottomOffset = _props2.bottomOffset,
	          topOffset = _props2.topOffset,
	          mode = _props2.mode;
	
	
	      if (this.disabled) {
	        return false;
	      }
	
	      if (boundaryRect && !instersect(boundaryRect, scrollRect, topOffset, bottomOffset)) {
	        return false;
	      }
	
	      var hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;
	
	      if (mode === 'top') {
	        return holderRect.top + topOffset < scrollRect.top && scrollRect.top + hideOffset <= boundaryRect.bottom;
	      }
	
	      return holderRect.bottom - topOffset > scrollRect.bottom && scrollRect.bottom - hideOffset >= boundaryRect.top;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var _state = this.state,
	          fixed = _state.fixed,
	          height = _state.height;
	      var stickyClassName = props.stickyClassName,
	          stickyStyle = props.stickyStyle,
	          holderCmp = props.holderCmp,
	          wrapperCmp = props.wrapperCmp,
	          holderProps = props.holderProps,
	          children = props.children;
	
	      var wrapperProps = sanitizeProps(props, stickyOwnProps);
	      // To ensure that this component becomes sticky immediately on mobile devices instead
	      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
	      // to 'kick' rendering of this element to the GPU
	      // @see http://stackoverflow.com/questions/32875046
	      var wrapperStyle = { transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' };
	      if (wrapperProps.style) {
	        wrapperStyle = _extends({}, wrapperStyle, wrapperProps.style);
	      }
	
	      if (fixed) {
	        wrapperProps.className += ' ' + stickyClassName;
	        wrapperStyle = _extends({}, wrapperStyle, stickyStyle, this.state.styles);
	      }
	
	      holderProps.style = _extends({}, holderProps.style, { minHeight: height + 'px' });
	      holderProps.ref = this.createHolderRef;
	
	      wrapperProps.style = wrapperStyle;
	      wrapperProps.ref = this.createWrapperRef;
	      return _react2.default.createElement(holderCmp, holderProps, _react2.default.createElement(wrapperCmp, wrapperProps, children));
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	// some helpers
	
	Sticky.propTypes = {
	  mode: _propTypes2.default.oneOf(['top', 'bottom']),
	  onFixedToggle: _propTypes2.default.func,
	  stickyStyle: _propTypes2.default.object,
	  stickyClassName: _propTypes2.default.string,
	  hideOnBoundaryHit: _propTypes2.default.bool,
	  offsetTransforms: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  boundaryElement: _propTypes2.default.string,
	  scrollElement: _propTypes2.default.any,
	  bottomOffset: _propTypes2.default.number,
	  topOffset: _propTypes2.default.number,
	  positionRecheckInterval: _propTypes2.default.number,
	  noExceptionOnMissedScrollElement: _propTypes2.default.bool,
	  wrapperCmp: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  holderCmp: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  holderProps: _propTypes2.default.object
	};
	Sticky.defaultProps = {
	  className: '',
	  style: {},
	  mode: 'top',
	  holderCmp: 'div',
	  holderProps: {},
	  wrapperCmp: 'div',
	  stickyClassName: 'sticky',
	  stickyStyle: null,
	  hideOnBoundaryHit: true,
	  offsetTransforms: false,
	  disabled: false,
	  boundaryElement: null,
	  scrollElement: 'window',
	  topOffset: 0,
	  bottomOffset: 0,
	  noExceptionOnMissedScrollElement: false,
	  positionRecheckInterval: 0
	};
	exports.default = Sticky;
	function getRect(el) {
	  if (el && typeof el.getBoundingClientRect === 'function') {
	    return el.getBoundingClientRect();
	  }
	
	  if (el === window || el === document) {
	    return { top: 0, left: 0, bottom: window.innerHeight, height: window.innerHeight, width: window.innerWidth, right: window.innerWidth };
	  }
	
	  return { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
	}
	
	function instersect(r1, r2, topOffset, bottomOffset) {
	  var r1Top = r1.top + topOffset,
	      r1Bottom = r1.bottom + bottomOffset;
	
	  return r1Top >= r2.top && r1Top <= r2.bottom || r1Bottom >= r2.top && r1Bottom <= r2.bottom || r1Bottom >= r2.bottom && r1Top <= r2.top;
	}
	
	/**
	 * Simply removes all unwanted props in order to avoid react 'unkown prop' warning
	 * @param  {Object} props     that should be sanitized
	 * @param  {Object} toRemove  array of prop names to remove
	 * @return {Object}           cloned and sanitized props
	 */
	function sanitizeProps(props, toRemove) {
	  props = _extends({}, props);
	  for (var i = 0, l = toRemove.length; i < l; i += 1) {
	    delete props[toRemove[i]];
	  }
	  return props;
	}
	module.exports = exports['default'];

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(15);
	var DetectPassiveEvents = __webpack_require__(1311).default;
	
	function getInitialState() {
	  return {
	    x: null,
	    y: null,
	    swiping: false,
	    start: 0
	  };
	}
	
	function getMovingPosition(e) {
	  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	function getPosition(e) {
	  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	
	function rotateByAngle(pos, angle) {
	  if (angle === 0) {
	    return pos;
	  }
	
	  var x = pos.x,
	      y = pos.y;
	
	
	  var angleInRadians = Math.PI / 180 * angle;
	  var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
	  var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
	  return { x: rotatedX, y: rotatedY };
	}
	
	function calculatePos(e, state) {
	  var _rotateByAngle = rotateByAngle(getMovingPosition(e), state.rotationAngle),
	      x = _rotateByAngle.x,
	      y = _rotateByAngle.y;
	
	  var deltaX = state.x - x;
	  var deltaY = state.y - y;
	
	  var absX = Math.abs(deltaX);
	  var absY = Math.abs(deltaY);
	
	  var time = Date.now() - state.start;
	  var velocity = Math.sqrt(absX * absX + absY * absY) / time;
	
	  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
	}
	
	var Swipeable = function (_React$Component) {
	  _inherits(Swipeable, _React$Component);
	
	  function Swipeable(props, context) {
	    _classCallCheck(this, Swipeable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.swipeable = getInitialState();
	
	    _this.eventStart = _this.eventStart.bind(_this);
	    _this.eventMove = _this.eventMove.bind(_this);
	    _this.eventEnd = _this.eventEnd.bind(_this);
	    _this.mouseDown = _this.mouseDown.bind(_this);
	    _this.mouseMove = _this.mouseMove.bind(_this);
	    _this.mouseUp = _this.mouseUp.bind(_this);
	    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
	    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
	    _this.elementRef = _this.elementRef.bind(_this);
	    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
	    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
	
	    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
	    return _this;
	  }
	
	  Swipeable.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.disabled !== this.props.disabled) {
	      this.cleanupMouseListeners();
	
	      this.swipeable = getInitialState();
	    }
	
	    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
	      this.cleanupTouchmoveEvent();
	    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cleanupMouseListeners();
	  };
	
	  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
	    document.addEventListener('mousemove', this.mouseMove);
	    document.addEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
	    document.removeEventListener('mousemove', this.mouseMove);
	    document.removeEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.mouseDown = function mouseDown(e) {
	    if (!this.props.trackMouse || e.type !== 'mousedown') {
	      return;
	    }
	
	    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);
	
	    this.setupMouseListeners();
	
	    this.eventStart(e);
	  };
	
	  Swipeable.prototype.mouseMove = function mouseMove(e) {
	    this.eventMove(e);
	  };
	
	  Swipeable.prototype.mouseUp = function mouseUp(e) {
	    this.cleanupMouseListeners();
	    this.eventEnd(e);
	  };
	
	  Swipeable.prototype.eventStart = function eventStart(e) {
	    if (e.touches && e.touches.length > 1) return;
	
	    var rotationAngle = this.props.rotationAngle;
	
	    var _rotateByAngle2 = rotateByAngle(getPosition(e), rotationAngle),
	        x = _rotateByAngle2.x,
	        y = _rotateByAngle2.y;
	
	    if (this.props.stopPropagation) e.stopPropagation();
	
	    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false, rotationAngle: rotationAngle };
	  };
	
	  Swipeable.prototype.eventMove = function eventMove(e) {
	    var _props = this.props,
	        stopPropagation = _props.stopPropagation,
	        delta = _props.delta,
	        onSwiping = _props.onSwiping,
	        onSwiped = _props.onSwiped,
	        onSwipingLeft = _props.onSwipingLeft,
	        onSwipedLeft = _props.onSwipedLeft,
	        onSwipingRight = _props.onSwipingRight,
	        onSwipedRight = _props.onSwipedRight,
	        onSwipingUp = _props.onSwipingUp,
	        onSwipedUp = _props.onSwipedUp,
	        onSwipingDown = _props.onSwipingDown,
	        onSwipedDown = _props.onSwipedDown,
	        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;
	
	
	    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
	      return;
	    }
	
	    var pos = calculatePos(e, this.swipeable);
	
	    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;
	
	    if (stopPropagation) e.stopPropagation();
	
	    if (onSwiping) {
	      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
	    }
	
	    var cancelablePageSwipe = false;
	    if (onSwiping || onSwiped) {
	      cancelablePageSwipe = true;
	    }
	
	    if (pos.absX > pos.absY) {
	      if (pos.deltaX > 0) {
	        if (onSwipingLeft || onSwipedLeft) {
	          onSwipingLeft && onSwipingLeft(e, pos.absX);
	          cancelablePageSwipe = true;
	        }
	      } else if (onSwipingRight || onSwipedRight) {
	        onSwipingRight && onSwipingRight(e, pos.absX);
	        cancelablePageSwipe = true;
	      }
	    } else if (pos.deltaY > 0) {
	      if (onSwipingUp || onSwipedUp) {
	        onSwipingUp && onSwipingUp(e, pos.absY);
	        cancelablePageSwipe = true;
	      }
	    } else if (onSwipingDown || onSwipedDown) {
	      onSwipingDown && onSwipingDown(e, pos.absY);
	      cancelablePageSwipe = true;
	    }
	
	    this.swipeable.swiping = true;
	
	    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
	  };
	
	  Swipeable.prototype.eventEnd = function eventEnd(e) {
	    var _props2 = this.props,
	        stopPropagation = _props2.stopPropagation,
	        flickThreshold = _props2.flickThreshold,
	        onSwiped = _props2.onSwiped,
	        onSwipedLeft = _props2.onSwipedLeft,
	        onSwipedRight = _props2.onSwipedRight,
	        onSwipedUp = _props2.onSwipedUp,
	        onSwipedDown = _props2.onSwipedDown,
	        onTap = _props2.onTap;
	
	
	    if (this.swipeable.swiping) {
	      var pos = calculatePos(e, this.swipeable);
	
	      if (stopPropagation) e.stopPropagation();
	
	      var isFlick = pos.velocity > flickThreshold;
	
	      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);
	
	      if (pos.absX > pos.absY) {
	        if (pos.deltaX > 0) {
	          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
	        } else {
	          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
	        }
	      } else if (pos.deltaY > 0) {
	        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
	      } else {
	        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
	      }
	    } else {
	      onTap && onTap(e);
	    }
	
	    this.swipeable = getInitialState();
	  };
	
	  Swipeable.prototype.elementRef = function elementRef(element) {
	    this.element = element;
	    this.props.innerRef && this.props.innerRef(element);
	  };
	
	  Swipeable.prototype.render = function render() {
	    var newProps = _extends({}, this.props);
	    if (!this.props.disabled) {
	      newProps.onTouchStart = this.eventStart;
	
	      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
	        newProps.onTouchMove = this.eventMove;
	      }
	
	      newProps.onTouchEnd = this.eventEnd;
	      newProps.onMouseDown = this.mouseDown;
	    }
	
	    newProps.ref = this.elementRef;
	
	    delete newProps.onSwiped;
	    delete newProps.onSwiping;
	    delete newProps.onSwipingUp;
	    delete newProps.onSwipingRight;
	    delete newProps.onSwipingDown;
	    delete newProps.onSwipingLeft;
	    delete newProps.onSwipedUp;
	    delete newProps.onSwipedRight;
	    delete newProps.onSwipedDown;
	    delete newProps.onSwipedLeft;
	    delete newProps.onTap;
	    delete newProps.flickThreshold;
	    delete newProps.delta;
	    delete newProps.preventDefaultTouchmoveEvent;
	    delete newProps.stopPropagation;
	    delete newProps.nodeName;
	    delete newProps.children;
	    delete newProps.trackMouse;
	    delete newProps.disabled;
	    delete newProps.innerRef;
	    delete newProps.rotationAngle;
	
	    return React.createElement(this.props.nodeName, newProps, this.props.children);
	  };
	
	  return Swipeable;
	}(React.Component);
	
	Swipeable.propTypes = {
	  onSwiped: PropTypes.func,
	  onSwiping: PropTypes.func,
	  onSwipingUp: PropTypes.func,
	  onSwipingRight: PropTypes.func,
	  onSwipingDown: PropTypes.func,
	  onSwipingLeft: PropTypes.func,
	  onSwipedUp: PropTypes.func,
	  onSwipedRight: PropTypes.func,
	  onSwipedDown: PropTypes.func,
	  onSwipedLeft: PropTypes.func,
	  onTap: PropTypes.func,
	  flickThreshold: PropTypes.number,
	  delta: PropTypes.number,
	  preventDefaultTouchmoveEvent: PropTypes.bool,
	  stopPropagation: PropTypes.bool,
	  nodeName: PropTypes.string,
	  trackMouse: PropTypes.bool,
	  disabled: PropTypes.bool,
	  innerRef: PropTypes.func,
	  children: PropTypes.node,
	  rotationAngle: PropTypes.number
	};
	
	Swipeable.defaultProps = {
	  flickThreshold: 0.6,
	  delta: 10,
	  preventDefaultTouchmoveEvent: false,
	  stopPropagation: false,
	  nodeName: 'div',
	  disabled: false,
	  rotationAngle: 0
	};
	
	module.exports = Swipeable;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var t,e=(t=__webpack_require__(1))&&"object"==typeof t&&"default"in t?t.default:t,n="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function o(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function r(t,e){return t(e={exports:{}},e.exports),e.exports}var s="function"==typeof Symbol&&Symbol.for,i=s?Symbol.for("react.element"):60103,a=s?Symbol.for("react.portal"):60106,c=s?Symbol.for("react.fragment"):60107,u=s?Symbol.for("react.strict_mode"):60108,p=s?Symbol.for("react.profiler"):60114,f=s?Symbol.for("react.provider"):60109,l=s?Symbol.for("react.context"):60110,d=s?Symbol.for("react.async_mode"):60111,m=s?Symbol.for("react.concurrent_mode"):60111,y=s?Symbol.for("react.forward_ref"):60112,h=s?Symbol.for("react.suspense"):60113,v=s?Symbol.for("react.suspense_list"):60120,b=s?Symbol.for("react.memo"):60115,j=s?Symbol.for("react.lazy"):60116,O=s?Symbol.for("react.block"):60121,_=s?Symbol.for("react.fundamental"):60117,g=s?Symbol.for("react.responder"):60118,E=s?Symbol.for("react.scope"):60119;function C(t){if("object"==typeof t&&null!==t){var e=t.$$typeof;switch(e){case i:switch(t=t.type){case d:case m:case c:case p:case u:case h:return t;default:switch(t=t&&t.$$typeof){case l:case y:case j:case b:case f:return t;default:return e}}case a:return e}}}function w(t){return C(t)===m}var x={AsyncMode:d,ConcurrentMode:m,ContextConsumer:l,ContextProvider:f,Element:i,ForwardRef:y,Fragment:c,Lazy:j,Memo:b,Portal:a,Profiler:p,StrictMode:u,Suspense:h,isAsyncMode:function(t){return w(t)||C(t)===d},isConcurrentMode:w,isContextConsumer:function(t){return C(t)===l},isContextProvider:function(t){return C(t)===f},isElement:function(t){return"object"==typeof t&&null!==t&&t.$$typeof===i},isForwardRef:function(t){return C(t)===y},isFragment:function(t){return C(t)===c},isLazy:function(t){return C(t)===j},isMemo:function(t){return C(t)===b},isPortal:function(t){return C(t)===a},isProfiler:function(t){return C(t)===p},isStrictMode:function(t){return C(t)===u},isSuspense:function(t){return C(t)===h},isValidElementType:function(t){return"string"==typeof t||"function"==typeof t||t===c||t===m||t===p||t===u||t===h||t===v||"object"==typeof t&&null!==t&&(t.$$typeof===j||t.$$typeof===b||t.$$typeof===f||t.$$typeof===l||t.$$typeof===y||t.$$typeof===_||t.$$typeof===g||t.$$typeof===E||t.$$typeof===O)},typeOf:C};r(function(t,e){}),r(function(t){t.exports=x}),Object,Object,Object,function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(t){o[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(t){return!1}}()&&Object;var P="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";function R(){}function S(){}Function.call.bind(Object.prototype.hasOwnProperty),S.resetWarningCache=R;var M=r(function(t){t.exports=function(){function t(t,e,n,o,r,s){if(s!==P){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:S,resetWarningCache:R};return n.PropTypes=n,n}()}),T=o(r(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){return t.displayName||t.name||("string"==typeof t&&t.length>0?t:"Unknown")}})),k=function(t,e){var n={};for(var o in t)-1===e.indexOf(o)&&(n[o]=t[o]);return n},$="__global_unique_id__",A=function(){return n[$]=(n[$]||0)+1},U=function(){},B=r(function(t,n){n.__esModule=!0;var o=s(M),r=s(A);function s(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}s(U),n.default=function(t,n){var s,u,p="__create-react-context-"+(0,r.default)()+"__",f=function(t){function e(){var n,o,r,s;i(this,e);for(var c=arguments.length,u=Array(c),p=0;p<c;p++)u[p]=arguments[p];return n=o=a(this,t.call.apply(t,[this].concat(u))),o.emitter=(r=o.props.value,s=[],{on:function(t){s.push(t)},off:function(t){s=s.filter(function(e){return e!==t})},get:function(){return r},set:function(t,e){r=t,s.forEach(function(t){return t(r,e)})}}),a(o,n)}return c(e,t),e.prototype.getChildContext=function(){var t;return(t={})[p]=this.emitter,t},e.prototype.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e=this.props.value,o=t.value,r=void 0;((s=e)===(i=o)?0!==s||1/s==1/i:s!=s&&i!=i)?r=0:(r="function"==typeof n?n(e,o):1073741823,0!=(r|=0)&&this.emitter.set(t.value,r))}var s,i},e.prototype.render=function(){return this.props.children},e}(e.Component);f.childContextTypes=((s={})[p]=o.default.object.isRequired,s);var l=function(e){function n(){var t,o;i(this,n);for(var r=arguments.length,s=Array(r),c=0;c<r;c++)s[c]=arguments[c];return t=o=a(this,e.call.apply(e,[this].concat(s))),o.state={value:o.getValue()},o.onUpdate=function(t,e){0!=((0|o.observedBits)&e)&&o.setState({value:o.getValue()})},a(o,t)}return c(n,e),n.prototype.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?1073741823:e},n.prototype.componentDidMount=function(){this.context[p]&&this.context[p].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?1073741823:t},n.prototype.componentWillUnmount=function(){this.context[p]&&this.context[p].off(this.onUpdate)},n.prototype.getValue=function(){return this.context[p]?this.context[p].get():t},n.prototype.render=function(){return(t=this.props.children,Array.isArray(t)?t[0]:t)(this.state.value);var t},n}(e.Component);return l.contextTypes=((u={})[p]=o.default.object,u),{Provider:f,Consumer:l}},t.exports=n.default});o(B);var D=o(r(function(t,n){n.__esModule=!0;var o=s(e),r=s(B);function s(t){return t&&t.__esModule?t:{default:t}}n.default=o.default.createContext||r.default,t.exports=n.default})),L=D(null),F=function(t){var n=T(t);return function(o){return e.createElement(L.Consumer,null,function(r){if(null===r)throw new Error("Couldn't find Yandex.Maps API in the context. Make sure that <"+n+" /> is inside <YMaps /> provider");return e.createElement(t,Object.assign({},{ymaps:r},o))})}},W=D(null),N=function(t){return function(n){return e.createElement(W.Consumer,null,function(o){return e.createElement(t,Object.assign({},{parent:o},n))})}};function q(t,n,o){void 0===n&&(n=!1),void 0===o&&(o=[]);var r=function(r){function s(){r.call(this),this.state={loading:!0},this._isMounted=!1}return r&&(s.__proto__=r),(s.prototype=Object.create(r&&r.prototype)).constructor=s,s.prototype.componentDidMount=function(){var t=this;this._isMounted=!0,this.props.ymaps.load().then(function(e){return Promise.all(o.concat(t.props.modules).map(e.loadModule)).then(function(){!0===t._isMounted&&t.setState({loading:!1},function(){t.props.onLoad(e)})})}).catch(function(e){!0===t._isMounted&&t.props.onError(e)})},s.prototype.componentWillUnmount=function(){this._isMounted=!1},s.prototype.render=function(){var o=this.props.ymaps,r=!1===n||!1===this.state.loading,s=k(this.props,["onLoad","onError","modules","ymaps"]);return r&&e.createElement(t,Object.assign({},{ymaps:o.getApi()},s))},s}(e.Component);return r.defaultProps={onLoad:Function.prototype,onError:Function.prototype,modules:[]},F(r)}var z={lang:"ru_RU",load:"",ns:"",mode:"release"},I={},Z=function(t){var e=Date.now().toString(32);this.options=t,this.namespace=t.query.ns||z.ns,this.onload="__yandex-maps-api-onload__$$"+e,this.onerror="__yandex-maps-api-onerror__$$"+e};Z.prototype.getApi=function(){return"undefined"!=typeof window&&this.namespace?window[this.namespace]:this.api},Z.prototype.setApi=function(t){return this.api=t},Z.prototype.getPromise=function(){return this.namespace?I[this.namespace]:this.promise},Z.prototype.setPromise=function(t){return this.namespace?I[this.namespace]=this.promise=t:this.promise=t},Z.prototype.load=function(){var t=this;if(this.getApi())return Promise.resolve(this.setApi(this.getApi()));if(this.getPromise())return this.setPromise(this.getPromise());var e=Object.assign({onload:this.onload,onerror:this.onerror},z,this.options.query),n=Object.keys(e).map(function(t){return t+"="+e[t]}).join("&"),o=["https://"+(this.options.enterprise?"enterprise.":"")+"api-maps.yandex.ru",this.options.version,"?"+n].join("/"),r=new Promise(function(e,n){window[t.onload]=function(n){delete window[t.onload],n.loadModule=t.loadModule.bind(t),n.ready(function(){return e(t.setApi(n))})},window[t.onerror]=function(e){delete window[t.onerror],n(e)},t.fetchScript(o).catch(window[t.onerror])});return this.setPromise(r)},Z.prototype.fetchScript=function(t){var e=this;return new Promise(function(n,o){e.script=document.createElement("script"),e.script.type="text/javascript",e.script.onload=n,e.script.onerror=o,e.script.src=t,e.script.async="async",document.head.appendChild(e.script)})},Z.prototype.loadModule=function(t){var e=this;return new Promise(function(n,o){e.getApi().modules.require(t,function(o){!function(t,e,n,o){void 0===o&&(o=!1),e="string"==typeof e?e.split("."):e.slice();for(var r,s=t;e.length>1;)s[r=e.shift()]||(s[r]={}),s=s[r];s[e[0]]=!0===o&&s[e[0]]||n}(e.api,t,o,!0),n(o)},o,e.getApi())})},Z._name="__react-yandex-maps__";var G=function(t){function n(e){t.call(this,e),this.ymaps=new Z(e)}return t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n,n.prototype.componentDidMount=function(){!0===this.props.preload&&this.ymaps.load()},n.prototype.render=function(){return e.createElement(L.Provider,{value:this.ymaps},this.props.children)},n}(e.Component);G.defaultProps={version:"2.1",enterprise:!1,query:{lang:"ru_RU",load:"",ns:""},preload:!1};var V=/^on(?=[A-Z])/;function Y(t){return Object.keys(t).reduce(function(e,n){if(V.test(n)){var o=n.replace(V,"").toLowerCase();e._events[o]=t[n]}else e[n]=t[n];return e},{_events:{}})}function H(t,e,n){"function"==typeof n&&t.events.add(e,n)}function J(t,e,n){"function"==typeof n&&t.events.remove(e,n)}function K(t,e,n){Object.keys(Object.assign({},e,n)).forEach(function(o){e[o]!==n[o]&&(J(t,o,e[o]),H(t,o,n[o]))})}var Q=function(t){return"default"+t.charAt(0).toUpperCase()+t.slice(1)};function X(t,e){return void 0!==t[e]||void 0===t[Q(e)]}function tt(t,e,n){return(X(t,e)?t[e]:t[Q(e)])||n}function et(t,e,n){if(void 0===n&&(n=null),t!==e){if(t&&(t.hasOwnProperty("current")?t.current=null:"function"==typeof t&&t(null)),!e)return;e.hasOwnProperty("current")?e.current=n:"function"==typeof e&&e(n)}}function nt(t){var e=t.width,n=t.height,o=t.style,r=t.className;return void 0!==o||void 0!==r?Object.assign({},o&&{style:o},r&&{className:r}):{style:{width:e,height:n}}}var ot=function(t){function n(){var e=this;t.call(this),this.state={instance:null},this._parentElement=null,this._getRef=function(t){e._parentElement=t}}return t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountObject(this._parentElement,this.props.ymaps.Map,this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){var t=nt(this.props),n=Y(this.props),o=k(n,["_events","state","defaultState","options","defaultOptions","instanceRef","ymaps","children","width","height","style","className"]);return e.createElement(W.Provider,{value:this.state.instance},e.createElement("div",Object.assign({},{ref:this._getRef},t,o),this.props.children))},n.mountObject=function(t,e,n){var o=Y(n),r=o.instanceRef,s=o._events,i=new e(t,tt(n,"state"),tt(n,"options"));return Object.keys(s).forEach(function(t){return H(i,t,s[t])}),et(null,r,i),i},n.updateObject=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"state")){var u=tt(e,"state",{}),p=tt(n,"state",{});u.type!==p.type&&t.setType(p.type),u.behaviors!==p.behaviors&&(u.behaviors&&t.behaviors.disable(u.behaviors),p.behaviors&&t.behaviors.enable(p.behaviors)),p.zoom&&u.zoom!==p.zoom&&t.setZoom(p.zoom),p.center&&u.center!==p.center&&t.setCenter(p.center),p.bounds&&u.bounds!==p.bounds&&t.setBounds(p.bounds)}if(X(n,"options")){var f=tt(e,"options"),l=tt(n,"options",{});f!==l&&t.options.set(l)}tt(e,"width")===tt(n,"width")&&tt(e,"height")===tt(n,"height")||t.container.fitToViewport(),K(t,a,r),et(c,s,t)},n.unmountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n._events;null!==t&&(Object.keys(r).forEach(function(e){return J(t,e,r[e])}),t.destroy(),et(o))},n}(e.Component);ot.defaultProps={width:320,height:240};var rt=q(ot,!0,["Map"]),st=function(t){function n(){var e=this;t.call(this),this.state={instance:null},this._parentElement=null,this._getRef=function(t){e._parentElement=t}}return t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=this;this._mounted=!0,this.props.ymaps.panorama.isSupported()&&n.mountObject(this._parentElement,this.props.ymaps.panorama,this.props).then(function(e){return t._mounted&&t.setState({instance:e})})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){this._mounted=!1,n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){var t=nt(this.props);return e.createElement("div",Object.assign({},{ref:this._getRef},t))},n.mountObject=function(t,e,n){var o=Y(n),r=o.instanceRef,s=o._events,i=tt(n,"point"),a=tt(n,"locateOptions"),c=tt(n,"options");return new Promise(function(n,o){e.locate(i,a).done(function(o){if(o.length>0){var i=new e.Player(t,o[0],c);et(null,r,i),Object.keys(s).forEach(function(t){return H(i,t,s[t])}),n(i)}},o)})},n.updateObject=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"options")){var u=tt(e,"options"),p=tt(n,"options");u!==p&&t.options.set(p)}if(X(n,"point")){var f=tt(n,"point"),l=tt(e,"point"),d=tt(n,"locateOptions");f!==l&&t.moveTo(f,d)}K(t,a,r),et(c,s,t)},n.unmountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n._events;null!==t&&(Object.keys(r).forEach(function(e){return J(t,e,r[e])}),et(o))},n}(e.Component);st.defaultProps={width:320,height:240};var it=q(st,!0,["panorama.isSupported","panorama.locate","panorama.createPlayer","panorama.Player"]),at=function(t){function n(){t.call(this),this.state={instance:null}}return t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountControl(this.props.ymaps.control[this.props.name],this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateControl(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountControl(this.state.instance,this.props)},n.prototype.render=function(){return e.createElement(W.Provider,{value:this.state.instance},this.props.children)},n.mountControl=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n.lazy,i=n._events,a=new t({data:tt(e,"data"),options:tt(e,"options"),state:tt(e,"state"),mapTypes:tt(e,"mapTypes"),lazy:s});if(Object.keys(i).forEach(function(t){return H(a,t,i[t])}),r&&r.controls&&"function"==typeof r.controls.add)r.controls.add(a);else{if(!r||!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount "+e.name);r.add(a)}return et(null,o,a),a},n.updateControl=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"options")){var u=tt(e,"options"),p=tt(n,"options");u!==p&&t.options.set(p)}if(X(n,"data")){var f=tt(e,"data"),l=tt(n,"data");f!==l&&t.data.set(l)}if(X(n,"state")){var d=tt(e,"state"),m=tt(n,"state");d!==m&&t.state.set(m)}if(X(n,"mapTypes")){var y=tt(e,"mapTypes"),h=tt(n,"mapTypes");y!==h&&(t.removeAllMapTypes(),h.forEach(function(e){return t.addMapType(e)}))}K(t,a,r),et(c,s,t)},n.unmountControl=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return J(t,e,s[e])}),r.controls&&"function"==typeof r.controls.remove?r.controls.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),et(o))},n}(e.Component),ct=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"Button"}))},!0,["control.Button"])),ut=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"FullscreenControl"}))},!0,["control.FullscreenControl"])),pt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"GeolocationControl"}))},!0,["control.GeolocationControl"])),ft=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"ListBox"}))},!0,["control.ListBox"])),lt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"ListBoxItem"}))},!0,["control.ListBoxItem"])),dt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"RouteButton"}))},!0,["control.RouteButton"])),mt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"RouteEditor"}))},!0,["control.RouteEditor"])),yt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"RoutePanel"}))},!0,["control.RoutePanel"])),ht=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"RulerControl"}))},!0,["control.RulerControl"])),vt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"SearchControl"}))},!0,["control.SearchControl"])),bt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"TrafficControl"}))},!0,["control.TrafficControl"])),jt=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"TypeSelector"}))},!0,["control.TypeSelector"])),Ot=N(q(function(t){return e.createElement(at,Object.assign({},t,{name:"ZoomControl"}))},!0,["control.ZoomControl"])),_t=N(q(function(t){function n(){t.call(this),this.state={instance:null}}return t&&(n.__proto__=t),(n.prototype=Object.create(t&&t.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountObject(this.props.ymaps.Clusterer,this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){return e.createElement(W.Provider,{value:this.state.instance},this.props.children)},n.mountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events,i=new t(tt(e,"options"));if(Object.keys(s).forEach(function(t){return H(i,t,s[t])}),r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(i);else{if(!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount Clusterer");r.add(i)}return et(null,o,i),i},n.updateObject=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"options")){var u=tt(e,"options"),p=tt(n,"options");u!==p&&t.options.set(p)}K(t,a,r),et(c,s,t)},n.unmountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return J(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),et(o))},n}(e.Component),!0,["Clusterer"])),gt=N(q(function(t){function e(){t.call(this),this.state={instance:null}}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.componentDidMount=function(){var t=e.mountObject(this.props.ymaps.ObjectManager,this.props);this.setState({instance:t})},e.prototype.componentDidUpdate=function(t){null!==this.state.instance&&e.updateObject(this.state.instance,t,this.props)},e.prototype.componentWillUnmount=function(){e.unmountObject(this.state.instance,this.props)},e.prototype.render=function(){return null},e.mountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events,i=tt(e,"options",{}),a=tt(e,"features",{}),c=tt(e,"filter",null),u=tt(e,"objects",{}),p=tt(e,"clusters",{}),f=new t(i);if(f.add(a||[]),f.setFilter(c),f.objects.options.set(u),f.clusters.options.set(p),Object.keys(s).forEach(function(t){return H(f,t,s[t])}),r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(f);else{if(!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount ObjectManager");r.add(f)}return et(null,o,f),f},e.updateObject=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"options")){var u=tt(e,"options"),p=tt(n,"options");u!==p&&t.options.set(p)}if(X(n,"objects")){var f=tt(e,"objects"),l=tt(n,"objects");f!==l&&t.objects.options.set(l)}if(X(n,"clusters")){var d=tt(e,"clusters"),m=tt(n,"clusters");d!==m&&t.clusters.options.set(m)}if(X(n,"filter")){var y=tt(e,"filter"),h=tt(n,"filter");y!==h&&t.setFilter(h)}if(X(n,"features")){var v=tt(e,"features"),b=tt(n,"features");v!==b&&(t.remove(v),t.add(b))}K(t,a,r),et(c,s,t)},e.unmountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return J(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),et(o))},e}(e.Component),!0,["ObjectManager"])),Et=function(t){function e(){t.call(this),this.state={instance:null}}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.componentDidMount=function(){var t=this.props,n=t.name,o=t.ymaps,r=t.dangerZone,s=e.mountObject(r&&"function"==typeof r.modifyConstructor?r.modifyConstructor(o[n]):o[n],this.props);this.setState({instance:s})},e.prototype.componentDidUpdate=function(t){null!==this.state.instance&&e.updateObject(this.state.instance,t,this.props)},e.prototype.componentWillUnmount=function(){e.unmountObject(this.state.instance,this.props)},e.prototype.render=function(){return null},e.mountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events,i=new t(tt(e,"geometry"),tt(e,"properties"),tt(e,"options"));if(Object.keys(s).forEach(function(t){return H(i,t,s[t])}),r&&r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(i);else{if(!r||!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount "+e.name);r.add(i)}return et(null,o,i),i},e.updateObject=function(t,e,n){var o=Y(n),r=o._events,s=o.instanceRef,i=Y(e),a=i._events,c=i.instanceRef;if(X(n,"geometry")){var u=tt(e,"geometry",{}),p=tt(n,"geometry",{});Array.isArray(p)&&p!==u?Array.isArray(p[0])&&"number"==typeof p[1]?(t.geometry.setCoordinates(p[0]),t.geometry.setRadius(p[1])):t.geometry.setCoordinates(p):"object"==typeof p&&(p.coordinates!==u.coordinates&&t.geometry.setCoordinates(p.coordinates),p.radius!==u.radius&&t.geometry.setRadius(p.radius))}if(X(n,"properties")){var f=tt(e,"properties"),l=tt(n,"properties");f!==l&&t.properties.set(l)}if(X(n,"options")){var d=tt(e,"options"),m=tt(n,"options");d!==m&&t.options.set(m)}K(t,a,r),et(c,s,t)},e.unmountObject=function(t,e){var n=Y(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return J(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),et(o))},e}(e.Component),Ct={modifyConstructor:function(t){function e(e,n,o){t.call(this,{geometry:e,properties:n},o)}return e.prototype=t.prototype,e}},wt=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"GeoObject",dangerZone:Ct}))},!0,["GeoObject"])),xt=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"Circle"}))},!0,["Circle"])),Pt=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"Placemark"}))},!0,["Placemark"])),Rt=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"Polygon"}))},!0,["Polygon"])),St=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"Polyline"}))},!0,["Polyline"])),Mt=N(q(function(t){return e.createElement(Et,Object.assign({},t,{name:"Rectangle"}))},!0,["Rectangle"]));exports.withYMaps=q,exports.YMaps=G,exports.Map=rt,exports.Panorama=it,exports.Button=ct,exports.FullscreenControl=ut,exports.GeolocationControl=pt,exports.ListBox=ft,exports.ListBoxItem=lt,exports.RouteButton=dt,exports.RouteEditor=mt,exports.RoutePanel=yt,exports.RulerControl=ht,exports.SearchControl=vt,exports.TrafficControl=bt,exports.TypeSelector=jt,exports.ZoomControl=Ot,exports.Clusterer=_t,exports.ObjectManager=gt,exports.GeoObject=wt,exports.Circle=xt,exports.Placemark=Pt,exports.Polygon=Rt,exports.Polyline=St,exports.Rectangle=Mt;
	//# sourceMappingURL=react-yandex-maps.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(2074),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 2074 */
1308,
/* 2075 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var initialState = typeof args[args.length - 1] !== 'function' && args.pop();
	  var reducers = args;
	
	  if (typeof initialState === 'undefined') {
	    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
	  }
	
	  return function (prevState, value) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var prevStateIsUndefined = typeof prevState === 'undefined';
	    var valueIsUndefined = typeof value === 'undefined';
	
	    if (prevStateIsUndefined && valueIsUndefined && initialState) {
	      return initialState;
	    }
	
	    return reducers.reduce(function (newState, reducer) {
	      return reducer.apply(undefined, [newState, value].concat(args));
	    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ASYNC_META = undefined;
	exports.default = createActionAsync;
	
	var _reduxAct = __webpack_require__(108);
	
	var _objectAssign = __webpack_require__(2109);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ASYNC_META = exports.ASYNC_META = {
	  REQUEST: "REQUEST",
	  OK: "OK",
	  ERROR: "ERROR",
	  RESET: "RESET"
	};
	
	var defaultOption = {
	  noRethrow: false,
	  request: {
	    metaReducer: function metaReducer(meta) {
	      return ASYNC_META.REQUEST;
	    }
	  },
	  ok: {
	    metaReducer: function metaReducer() {
	      return ASYNC_META.OK;
	    }
	  },
	  error: {
	    metaReducer: function metaReducer() {
	      return ASYNC_META.ERROR;
	    }
	  }
	};
	
	function createActionAsync(description, api) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOption;
	
	
	  options = {
	    noRethrow: options.noRethrow !== undefined ? options.noRethrow : defaultOption.noRethrow,
	    request: (0, _objectAssign2.default)({}, defaultOption.request, options.request),
	    ok: (0, _objectAssign2.default)({}, defaultOption.ok, options.ok),
	    error: (0, _objectAssign2.default)({}, defaultOption.error, options.error)
	  };
	
	  var actions = {
	    request: (0, _reduxAct.createAction)(description + '_' + ASYNC_META.REQUEST, options.request.payloadReducer, options.request.metaReducer),
	    ok: (0, _reduxAct.createAction)(description + '_' + ASYNC_META.OK, options.ok.payloadReducer, options.ok.metaReducer),
	    error: (0, _reduxAct.createAction)(description + '_' + ASYNC_META.ERROR, options.error.payloadReducer, options.error.metaReducer),
	    reset: (0, _reduxAct.createAction)(description + '_' + ASYNC_META.RESET)
	  };
	
	  var actionAsync = function actionAsync() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return function (dispatch, getState) {
	      var _options$request;
	
	      dispatch(actions.request.apply(actions, args));
	      if (options.request.callback) (_options$request = options.request).callback.apply(_options$request, [dispatch, getState].concat(args));
	      return api.apply(undefined, args.concat([dispatch, getState])).then(function (response) {
	        var _options$ok;
	
	        var out = {
	          request: args,
	          response: response
	        };
	
	        dispatch(actions.ok(out));
	        if (options.ok.callback) (_options$ok = options.ok).callback.apply(_options$ok, [dispatch, getState, response].concat(args));
	        return out;
	      }).catch(function (error) {
	        var _options$error;
	
	        var errorOut = {
	          actionAsync: actionAsync,
	          request: args,
	          error: error
	        };
	        dispatch(actions.error(errorOut));
	        if (options.error.callback) (_options$error = options.error).callback.apply(_options$error, [dispatch, getState, errorOut].concat(args));
	        if (!options.noRethrow) throw errorOut;
	      });
	    };
	  };
	
	  (0, _objectAssign2.default)(actionAsync, actions);
	  actionAsync.options = options;
	  return actionAsync;
	}

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(2080);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(2081);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = createReducerAsync;
	
	var _reduxAct = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultsState = {
	    loading: false,
	    request: null,
	    data: null,
	    error: null
	};
	
	function createReducerAsync(actionAsync) {
	    var _createReducer;
	
	    var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultsState;
	
	    return (0, _reduxAct.createReducer)((_createReducer = {}, (0, _defineProperty3.default)(_createReducer, actionAsync.request, function (state, payload) {
	        return (0, _extends3.default)({}, state, {
	            request: payload,
	            loading: true,
	            error: null
	        });
	    }), (0, _defineProperty3.default)(_createReducer, actionAsync.ok, function (state, payload) {
	        return (0, _extends3.default)({}, state, {
	            loading: false,
	            data: payload.response
	        });
	    }), (0, _defineProperty3.default)(_createReducer, actionAsync.error, function (state, payload) {
	        return (0, _extends3.default)({}, state, {
	            loading: false,
	            error: payload.error
	        });
	    }), (0, _defineProperty3.default)(_createReducer, actionAsync.reset, function () {
	        return defaultState;
	    }), _createReducer), defaultState);
	}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2082), __esModule: true };

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2083), __esModule: true };

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(2079);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(2078);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2107);
	module.exports = __webpack_require__(280).Object.assign;


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2108);
	var $Object = __webpack_require__(280).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(406);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(706);
	var toLength = __webpack_require__(2103);
	var toAbsoluteIndex = __webpack_require__(2102);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(2084);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(406);
	var document = __webpack_require__(405).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 2090 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(704);
	var createDesc = __webpack_require__(2099);
	module.exports = __webpack_require__(188) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(188) && !__webpack_require__(404)(function () {
	  return Object.defineProperty(__webpack_require__(2089)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 2093 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(188);
	var getKeys = __webpack_require__(2097);
	var gOPS = __webpack_require__(2095);
	var pIE = __webpack_require__(2098);
	var toObject = __webpack_require__(2104);
	var IObject = __webpack_require__(703);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(404)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(702);
	var toIObject = __webpack_require__(706);
	var arrayIndexOf = __webpack_require__(2086)(false);
	var IE_PROTO = __webpack_require__(2100)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(2096);
	var enumBugKeys = __webpack_require__(2090);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 2098 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 2099 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(2101)('keys');
	var uid = __webpack_require__(2106);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(280);
	var global = __webpack_require__(405);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(2093) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(705);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(705);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(700);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(406);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(701);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2094) });


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(701);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(188), 'Object', { defineProperty: __webpack_require__(704).f });


/***/ }),
/* 2109 */
1308,
/* 2110 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = asError;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function asError(action) {
	  if (_typeof(action) === 'object' && action !== null) {
	    action.error = true;
	  }
	
	  return action;
	}
	
	;

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = assignAll;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function assignAll(actions, stores) {
	  if (Array.isArray(actions)) {
	    return actions.map(function (action) {
	      return action.assignTo(stores);
	    });
	  }
	
	  return Object.keys(actions).reduce(function (assigns, action) {
	    return _extends(assigns, _defineProperty({}, action, actions[action].assignTo(stores)));
	  }, {});
	}
	
	;

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = bindAll;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function bindAll(actions, stores) {
	  if (Array.isArray(actions)) {
	    return actions.map(function (action) {
	      return action.bindTo(stores);
	    });
	  }
	
	  return Object.keys(actions).reduce(function (binds, action) {
	    return _extends(binds, _defineProperty({}, action, actions[action].bindTo(stores)));
	  }, {});
	}
	
	;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createReducer;
	
	var _batch = _interopRequireDefault(__webpack_require__(281));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function normalizeType(typeOrActionCreator) {
	  if (typeOrActionCreator && typeOrActionCreator.getType) {
	    return typeOrActionCreator.toString();
	  }
	
	  return typeOrActionCreator;
	}
	
	function createReducer() {
	  var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultState = arguments.length > 1 ? arguments[1] : undefined;
	  var opts = {
	    payload: true,
	    fallback: null
	  };
	
	  var reducer = _extends(reduce, {
	    has: has,
	    on: on,
	    off: off,
	    options: options
	  });
	
	  function has(typeOrActionCreator) {
	    return !!handlers[normalizeType(typeOrActionCreator)];
	  }
	
	  function on(typeOrActionCreator, handler) {
	    if (Array.isArray(typeOrActionCreator)) {
	      typeOrActionCreator.forEach(function (action) {
	        on(action, handler);
	      });
	    } else {
	      handlers[normalizeType(typeOrActionCreator)] = handler;
	    }
	
	    return reducer;
	  }
	
	  function off(typeOrActionCreator) {
	    if (Array.isArray(typeOrActionCreator)) {
	      typeOrActionCreator.forEach(off);
	    } else {
	      delete handlers[normalizeType(typeOrActionCreator)];
	    }
	
	    return reducer;
	  }
	
	  function options(newOpts) {
	    Object.keys(newOpts).forEach(function (name) {
	      return opts[name] = newOpts[name];
	    });
	    return reducer;
	  }
	
	  if (typeof handlers === 'function') {
	    var factory = handlers;
	    handlers = {};
	    factory(on, off);
	  }
	
	  if (!has(_batch["default"])) {
	    on(_batch["default"], function (state, payload) {
	      if (opts.payload) {
	        return payload.reduce(reduce, state);
	      } else {
	        return payload.payload.reduce(reduce, state);
	      }
	    });
	  }
	
	  function reduce() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments.length > 1 ? arguments[1] : undefined;
	
	    if (!action || typeof action.type !== 'string') {
	      return state;
	    }
	
	    if (action.type.startsWith('@@redux/')) {
	      return state;
	    }
	
	    var handler = handlers[action.type] || opts.fallback;
	
	    if (handler) {
	      if (opts.payload) {
	        return handler(state, action.payload, action.meta);
	      } else {
	        return handler(state, action);
	      }
	    }
	
	    return state;
	  }
	
	  ;
	  return reducer;
	}
	
	;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = disbatch;
	
	var _batch = _interopRequireDefault(__webpack_require__(281));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function disbatch(store) {
	  for (var _len = arguments.length, actions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    actions[_key - 1] = arguments[_key];
	  }
	
	  if (actions && actions.length > 0) {
	    if (!store || typeof store !== 'function' && typeof store.dispatch !== 'function') {
	      throw new TypeError('disbatch must take either a valid Redux store or a dispatch function as first parameter');
	    }
	
	    if (typeof store.dispatch === 'function') {
	      store = store.dispatch;
	    } // store is actually the dispatch function here
	
	
	    return store(_batch["default"].apply(void 0, actions));
	  } else {
	    if (!store || typeof store.dispatch !== 'function') {
	      throw new TypeError('disbatch must take a valid Redux store with a dispatch function as first parameter');
	    }
	
	    return _extends(store, {
	      disbatch: disbatch.bind(undefined, store)
	    });
	  }
	}

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var reduxLogger = _interopRequireWildcard(__webpack_require__(2116));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	var _default = {
	  reduxLogger: reduxLogger
	};
	exports["default"] = _default;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actionTransformer = actionTransformer;
	exports.logger = void 0;
	
	var _batch = _interopRequireDefault(__webpack_require__(281));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var batchType = _batch["default"].getType();
	
	function actionTransformer(action) {
	  if (action && action.type === batchType) {
	    action.payload.type = batchType;
	    return action.payload;
	  }
	
	  return action;
	}
	
	var logger = {};
	exports.logger = logger;
	
	var _loop = function _loop(level) {
	  if (typeof console[level] === 'function') {
	    logger[level] = function levelFn() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var lastArg = args.pop();
	
	      if (Array.isArray(lastArg) && lastArg.type === batchType) {
	        lastArg.forEach(function (action) {
	          console[level].apply(console, [].concat(args, [action]));
	        });
	      } else {
	        args.push(lastArg);
	        console[level].apply(console, args);
	      }
	    };
	  }
	};
	
	for (var level in console) {
	  _loop(level);
	}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = combineActions;
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(283));
	
	var _isSymbol = _interopRequireDefault(__webpack_require__(2128));
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(713));
	
	var _toString = _interopRequireDefault(__webpack_require__(716));
	
	var _isString = _interopRequireDefault(__webpack_require__(715));
	
	var _constants = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidActionType(type) {
	  return (0, _isString.default)(type) || (0, _isFunction.default)(type) || (0, _isSymbol.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty.default)(types)) {
	    return false;
	  }
	
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = new Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString.default).join(_constants.ACTION_TYPE_DELIMITER);
	  return {
	    toString: function toString() {
	      return combinedActionType;
	    }
	  };
	}

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createActions;
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(190));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(283));
	
	var _identity = _interopRequireDefault(__webpack_require__(408));
	
	var _isArray = _interopRequireDefault(__webpack_require__(2126));
	
	var _isString = _interopRequireDefault(__webpack_require__(715));
	
	var _isNil = _interopRequireDefault(__webpack_require__(714));
	
	var _getLastElement = _interopRequireDefault(__webpack_require__(2124));
	
	var _camelCase = _interopRequireDefault(__webpack_require__(710));
	
	var _arrayToObject = _interopRequireDefault(__webpack_require__(2121));
	
	var _flattenActionMap = _interopRequireDefault(__webpack_require__(2122));
	
	var _unflattenActionCreators = _interopRequireDefault(__webpack_require__(2130));
	
	var _createAction = _interopRequireDefault(__webpack_require__(407));
	
	var _constants = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var options = (0, _isPlainObject.default)((0, _getLastElement.default)(identityActions)) ? identityActions.pop() : {};
	  (0, _invariant.default)(identityActions.every(_isString.default) && ((0, _isString.default)(actionMap) || (0, _isPlainObject.default)(actionMap)), 'Expected optional object followed by string action types');
	
	  if ((0, _isString.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
	  }
	
	  return _objectSpread({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
	}
	
	function actionCreatorsFromActionMap(actionMap, options) {
	  var flatActionMap = (0, _flattenActionMap.default)(actionMap, options);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _unflattenActionCreators.default)(flatActionCreators, options);
	}
	
	function actionMapToActionCreators(actionMap, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      prefix = _ref.prefix,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace;
	
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction.default)(actionMapValue) || (0, _isNil.default)(actionMapValue)) {
	      return true;
	    }
	
	    if ((0, _isArray.default)(actionMapValue)) {
	      var _actionMapValue$ = actionMapValue[0],
	          payload = _actionMapValue$ === void 0 ? _identity.default : _actionMapValue$,
	          meta = actionMapValue[1];
	      return (0, _isFunction.default)(payload) && (0, _isFunction.default)(meta);
	    }
	
	    return false;
	  }
	
	  return (0, _arrayToObject.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var _objectSpread2;
	
	    var actionMapValue = actionMap[type];
	    (0, _invariant.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ("functions for " + type));
	    var prefixedType = prefix ? "" + prefix + namespace + type : type;
	    var actionCreator = (0, _isArray.default)(actionMapValue) ? _createAction.default.apply(void 0, [prefixedType].concat(actionMapValue)) : (0, _createAction.default)(prefixedType, actionMapValue);
	    return _objectSpread({}, partialActionCreators, (_objectSpread2 = {}, _objectSpread2[type] = actionCreator, _objectSpread2));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions, options) {
	  var actionMap = (0, _arrayToObject.default)(identityActions, function (partialActionMap, type) {
	    var _objectSpread3;
	
	    return _objectSpread({}, partialActionMap, (_objectSpread3 = {}, _objectSpread3[type] = _identity.default, _objectSpread3));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap, options);
	  return (0, _arrayToObject.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    var _objectSpread4;
	
	    return _objectSpread({}, partialActionCreators, (_objectSpread4 = {}, _objectSpread4[(0, _camelCase.default)(type)] = actionCreators[type], _objectSpread4));
	  });
	}

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _justCurryIt = _interopRequireDefault(__webpack_require__(1644));
	
	var _createAction = _interopRequireDefault(__webpack_require__(407));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(type, payloadCreator) {
	  return (0, _justCurryIt.default)((0, _createAction.default)(type, payloadCreator), payloadCreator.length);
	};
	
	exports.default = _default;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = handleActions;
	
	var _reduceReducers = _interopRequireDefault(__webpack_require__(2075));
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(190));
	
	var _isMap = _interopRequireDefault(__webpack_require__(284));
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(409));
	
	var _flattenReducerMap = _interopRequireDefault(__webpack_require__(2123));
	
	var _handleAction = _interopRequireDefault(__webpack_require__(709));
	
	var _get = _interopRequireDefault(__webpack_require__(712));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleActions(handlers, defaultState, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  (0, _invariant.default)((0, _isPlainObject.default)(handlers) || (0, _isMap.default)(handlers), 'Expected handlers to be a plain object.');
	  var flattenedReducerMap = (0, _flattenReducerMap.default)(handlers, options);
	  var reducers = (0, _ownKeys.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction.default)(type, (0, _get.default)(type, flattenedReducerMap), defaultState);
	  });
	
	  var reducer = _reduceReducers.default.apply(void 0, reducers.concat([defaultState]));
	
	  return function (state, action) {
	    if (state === void 0) {
	      state = defaultState;
	    }
	
	    return reducer(state, action);
	  };
	}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};
	
	exports.default = _default;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(190));
	
	var _flattenWhenNode = _interopRequireDefault(__webpack_require__(711));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _flattenWhenNode.default)(_isPlainObject.default);
	
	exports.default = _default;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(190));
	
	var _isMap = _interopRequireDefault(__webpack_require__(284));
	
	var _hasGeneratorInterface = _interopRequireDefault(__webpack_require__(2125));
	
	var _flattenWhenNode = _interopRequireDefault(__webpack_require__(711));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _flattenWhenNode.default)(function (node) {
	  return ((0, _isPlainObject.default)(node) || (0, _isMap.default)(node)) && !(0, _hasGeneratorInterface.default)(node);
	});
	
	exports.default = _default;

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(array) {
	  return array[array.length - 1];
	};
	
	exports.default = _default;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return Array.isArray(value);
	};
	
	exports.default = _default;

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === null;
	};
	
	exports.default = _default;

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
	};
	
	exports.default = _default;

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === undefined;
	};
	
	exports.default = _default;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unflattenActionCreators;
	
	var _constants = __webpack_require__(189);
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(713));
	
	var _camelCase = _interopRequireDefault(__webpack_require__(710));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unflattenActionCreators(flatActionCreators, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	      prefix = _ref.prefix;
	
	  function unflatten(flatActionType, partialNestedActionCreators, partialFlatActionTypePath) {
	    var nextNamespace = (0, _camelCase.default)(partialFlatActionTypePath.shift());
	
	    if ((0, _isEmpty.default)(partialFlatActionTypePath)) {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    } else {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    var unprefixedType = prefix ? type.replace("" + prefix + namespace, '') : type;
	    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
	  });
	  return nestedActionCreators;
	}

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var timers = {};
	
	  var middleware = function middleware() {
	    return function (dispatch) {
	      return function (action) {
	        var _action$meta = action.meta;
	        _action$meta = _action$meta === undefined ? {} : _action$meta;
	        var _action$meta$debounce = _action$meta.debounce;
	        var debounce = _action$meta$debounce === undefined ? {} : _action$meta$debounce;
	        var type = action.type;
	        var time = debounce.time;
	        var _debounce$key = debounce.key;
	        var key = _debounce$key === undefined ? type : _debounce$key;
	        var _debounce$cancel = debounce.cancel;
	        var cancel = _debounce$cancel === undefined ? false : _debounce$cancel;
	
	
	        var shouldDebounce = time && key || cancel && key;
	
	        if (!shouldDebounce) {
	          return dispatch(action);
	        }
	
	        if (timers[key]) {
	          clearTimeout(timers[key]);
	        }
	
	        if (!cancel) {
	          timers[key] = setTimeout(function () {
	            dispatch(action);
	          }, time);
	        }
	      };
	    };
	  };
	
	  middleware._timers = timers;
	
	  return middleware;
	};

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactRedux = __webpack_require__(5);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(719));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(724));
	
	var _eventConsts = __webpack_require__(2200);
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(726));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var _isEvent = _interopRequireDefault(__webpack_require__(411));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && typeof entity === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain["default"].getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	
	
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.isPristine = function () {
	        return _this.props.pristine;
	      };
	
	      _this.getValue = function () {
	        return _this.props.value;
	      };
	
	      _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        });
	        var defaultPrevented = false;
	
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative["default"] && (0, _isEvent["default"])(event)) {
	            onChange((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            var onChangeResult = onChange(event, newValue, previousValue, name); // Return value of change handler affecting preventDefault is RN
	            // specific behavior.
	
	            if (_isReactNative["default"]) {
	              defaultPrevented = onChangeResult;
	            }
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue)); // call post-change callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'change');
	          }
	        }
	      };
	
	      _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	        var defaultPrevented = false;
	
	        if (onFocus) {
	          if (!_isReactNative["default"]) {
	            onFocus((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), name);
	          } else {
	            defaultPrevented = onFocus(event, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      };
	
	      _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        }); // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	
	        if (onBlur) {
	          if (!_isReactNative["default"]) {
	            onBlur((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            defaultPrevented = onBlur(event, newValue, previousValue, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'blur');
	          }
	        }
	      };
	
	      _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            name = _this$props4.name,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event, name);
	        }
	      };
	
	      _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	        var defaultPrevented = false;
	
	        if (onDrop) {
	          onDrop((0, _extends2["default"])({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue, name);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedField.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        if (~(nextProps.immutableProps || []).indexOf(prop)) {
	          return _this2.props[prop] !== nextProps[prop];
	        }
	
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props6 = this.props,
	          component = _this$props6.component,
	          forwardRef = _this$props6.forwardRef,
	          name = _this$props6.name,
	          _reduxForm = _this$props6._reduxForm,
	          normalize = _this$props6.normalize,
	          onBlur = _this$props6.onBlur,
	          onChange = _this$props6.onChange,
	          onFocus = _this$props6.onFocus,
	          onDragStart = _this$props6.onDragStart,
	          onDrop = _this$props6.onDrop,
	          immutableProps = _this$props6.immutableProps,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["component", "forwardRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);
	
	      var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, rest, {
	        form: _reduxForm.form,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onDrop: this.handleDrop,
	        onDragStart: this.handleDragStart,
	        onFocus: this.handleFocus
	      })),
	          custom = _createFieldProps.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	      if (forwardRef) {
	        custom.ref = this.ref;
	      }
	
	      if (typeof component === 'string') {
	        var input = props.input,
	            meta = props.meta; // eslint-disable-line no-unused-vars
	        // flatten input into other props
	
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, input, {}, custom));
	      } else {
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, props, {}, custom));
	      }
	    };
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initialState = getIn(formState, "initial." + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for radios)
	
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedField);
	}
	
	var _default = createConnectedField;
	exports["default"] = _default;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFieldArray;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(158));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(364));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(137);
	
	var _createFieldArrayProps = _interopRequireDefault(__webpack_require__(2144));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size,
	      equals = structure.equals,
	      orderChanged = structure.orderChanged;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain["default"].getIn(syncErrors, name + "._error");
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + "._warning");
	  };
	
	  var ConnectedFieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedFieldArray.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      // Update if the elements of the value array was updated.
	      var thisValue = this.props.value;
	      var nextValue = nextProps.value;
	
	      if (thisValue && nextValue) {
	        var nextValueItemsSame = equals(nextValue, thisValue); //.every(val => ~thisValue.indexOf(val))
	
	        var nextValueItemsOrderChanged = orderChanged(thisValue, nextValue);
	        var thisValueLength = thisValue.length || thisValue.size;
	        var nextValueLength = nextValue.length || nextValue.size;
	
	        if (thisValueLength !== nextValueLength || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	          return !deepEqual(val, nextValue[index]);
	        })) {
	          return true;
	        }
	      }
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        // useful to debug rerenders
	        // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	        //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	        // }
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          component = _this$props.component,
	          forwardRef = _this$props.forwardRef,
	          name = _this$props.name,
	          _reduxForm = _this$props._reduxForm,
	          validate = _this$props.validate,
	          warn = _this$props.warn,
	          rerenderOnEveryChange = _this$props.rerenderOnEveryChange,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["component", "forwardRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"]);
	      var props = (0, _createFieldArrayProps["default"])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return (0, _react.createElement)(component, props);
	    };
	
	    (0, _createClass2["default"])(ConnectedFieldArray, [{
	      key: "dirty",
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    rerenderOnEveryChange: _propTypes["default"].bool
	  };
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initial = getIn(formState, "initial." + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name + "._error"),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name + "._error"),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	    return (0, _mapValues2["default"])({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFieldArray);
	}

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _reactRedux = __webpack_require__(5);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(719));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(724));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain["default"].getIn(syncErrors, name + "._error") || _plain["default"].getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFields, _React$Component);
	
	    function ConnectedFields(props) {
	      var _this;
	
	      _this = _React$Component.call(this, props) || this;
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	      _this.ref = _react["default"].createRef();
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        });
	        dispatch(_reduxForm.change(name, value)); // call post-change callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'change');
	        }
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        }); // dispatch blur action
	
	        dispatch(_reduxForm.blur(name, value)); // call post-blur callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'blur');
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	
	      return _this;
	    }
	
	    var _proto = ConnectedFields.prototype;
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	        return !_this2.props._fields[nextName];
	      }))) {
	        // names has changed. The cached event handlers need to be updated
	        this.prepareEventHandlers(nextProps);
	      }
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this3 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.isDirty = function isDirty() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).some(function (name) {
	        return _fields[name].dirty;
	      });
	    };
	
	    _proto.getValues = function getValues() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).reduce(function (accumulator, name) {
	        return _plain["default"].setIn(accumulator, name, _fields[name].value);
	      }, {});
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          component = _this$props4.component,
	          forwardRef = _this$props4.forwardRef,
	          _fields = _this$props4._fields,
	          _reduxForm = _this$props4._reduxForm,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["component", "forwardRef", "_fields", "_reduxForm"]);
	      var sectionPrefix = _reduxForm.sectionPrefix,
	          form = _reduxForm.form;
	
	      var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	        var connectedProps = _fields[name];
	
	        var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, connectedProps, {}, rest, {
	          form: form,
	          onBlur: _this4.onBlurFns[name],
	          onChange: _this4.onChangeFns[name],
	          onFocus: _this4.onFocusFns[name]
	        })),
	            custom = _createFieldProps.custom,
	            fieldProps = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	        accumulator.custom = custom;
	        var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	        return _plain["default"].setIn(accumulator, fieldName, fieldProps);
	      }, {}),
	          custom = _Object$keys$reduce.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_Object$keys$reduce, ["custom"]);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return _react["default"].createElement(component, (0, _extends2["default"])({}, props, {}, custom));
	    };
	
	    return ConnectedFields;
	  }(_react["default"].Component);
	
	  ConnectedFields.propTypes = {
	    component: _validateComponentProp["default"],
	    _fields: _propTypes["default"].object.isRequired,
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, "initial." + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, "values." + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, "asyncErrors." + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, "fields." + name),
	          submitError: getIn(formState, "submitErrors." + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for radios)
	
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFields);
	}

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createField = _interopRequireDefault(__webpack_require__(2142));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createField["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFieldArray = _interopRequireDefault(__webpack_require__(2143));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createFieldArray["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFields = _interopRequireDefault(__webpack_require__(2145));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createFields["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.onSubmit !== prevProps.onSubmit) {
	      this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm"]);
	    return /*#__PURE__*/_react["default"].createElement("form", rest);
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes["default"].func.isRequired,
	  _reduxForm: _propTypes["default"].object
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(Form);
	
	exports["default"] = _default;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var FormName = function FormName(_ref) {
	  var children = _ref.children,
	      _reduxForm = _ref._reduxForm;
	  return children({
	    form: _reduxForm && _reduxForm.form,
	    sectionPrefix: _reduxForm && _reduxForm.sectionPrefix
	  });
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormName);
	
	exports["default"] = _default;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(191));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var FormSection = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(FormSection, _Component);
	
	  function FormSection(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = FormSection.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        children = _this$props.children,
	        name = _this$props.name,
	        component = _this$props.component,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm", "children", "name", "component"]);
	
	    if (_react["default"].isValidElement(children)) {
	      return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	        value: (0, _extends2["default"])({}, this.props._reduxForm, {
	          sectionPrefix: (0, _prefixName["default"])(this.props, name)
	        }),
	        children: children
	      });
	    }
	
	    return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	      value: (0, _extends2["default"])({}, this.props._reduxForm, {
	        sectionPrefix: (0, _prefixName["default"])(this.props, name)
	      }),
	      children: (0, _react.createElement)(component, (0, _extends2["default"])({}, rest, {
	        children: children
	      }))
	    });
	  };
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes["default"].string.isRequired,
	  component: _validateComponentProp["default"]
	};
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormSection);
	
	exports["default"] = _default;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPromise = _interopRequireDefault(__webpack_require__(353));
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	
	  if (!(0, _isPromise["default"])(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (rejected) {
	        if (errors && Object.keys(errors).length) {
	          stop(errors);
	          return errors;
	        } else {
	          stop();
	          throw new Error('Asynchronous validation promise was rejected without errors.');
	        }
	      }
	
	      stop();
	      return Promise.resolve();
	    };
	  };
	
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	var _default = asyncValidation;
	exports["default"] = _default;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(158));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _ConnectedField = _interopRequireDefault(__webpack_require__(2132));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(728));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(191));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	function createField(structure) {
	  var ConnectedField = (0, _ConnectedField["default"])(structure);
	  var setIn = structure.setIn;
	
	  var Field = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Field, _Component);
	
	    function Field(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	
	        var previousValues = _this.props._reduxForm.getValues();
	
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues, name);
	      };
	
	      if (!props._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = Field.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'Field', function () {
	        return _this2.props.validate;
	      }, function () {
	        return _this2.props.warn;
	      });
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shallowCompare["default"])(this, nextProps, nextState);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
	      !_plain["default"].deepEqual(this.props.validate, nextProps.validate) || !_plain["default"].deepEqual(this.props.warn, nextProps.warn)) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'Field', function () {
	          return nextProps.validate;
	        }, function () {
	          return nextProps.warn;
	        });
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Field');
	      return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedField, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        normalize: this.normalize,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(Field, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref.current && this.ref.current.isPristine());
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref.current && this.ref.current.getValue();
	      }
	    }]);
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    format: _propTypes["default"].func,
	    normalize: _propTypes["default"].func,
	    onBlur: _propTypes["default"].func,
	    onChange: _propTypes["default"].func,
	    onFocus: _propTypes["default"].func,
	    onDragStart: _propTypes["default"].func,
	    onDrop: _propTypes["default"].func,
	    parse: _propTypes["default"].func,
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(Field);
	}
	
	var _default = createField;
	exports["default"] = _default;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldArray;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(158));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _ConnectedFieldArray = _interopRequireDefault(__webpack_require__(2133));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(191));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	
	      if (result) {
	        var _ref;
	
	        return _ref = {}, _ref[key] = result, _ref;
	      }
	    }
	  };
	};
	
	function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray["default"])(structure);
	
	  var FieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(FieldArray, _Component);
	
	    function FieldArray(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      if (!props._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = FieldArray.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'FieldArray', function () {
	        return wrapError(_this2.props.validate, '_error');
	      }, function () {
	        return wrapError(_this2.props.warn, '_warning');
	      });
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'FieldArray');
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to FieldArray');
	      return this.ref && this.ref.current.getRenderedComponent();
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedFieldArray, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(FieldArray, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.ref || this.ref.current.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref && this.ref.current.pristine);
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref ? this.ref.current.value : undefined;
	      }
	    }]);
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(FieldArray);
	}

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFieldArrayProps;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	function createFieldArrayProps(_ref, name, form, sectionPrefix, getValue, _ref2) {
	  var getIn = _ref.getIn;
	  var arrayInsert = _ref2.arrayInsert,
	      arrayMove = _ref2.arrayMove,
	      arrayPop = _ref2.arrayPop,
	      arrayPush = _ref2.arrayPush,
	      arrayRemove = _ref2.arrayRemove,
	      arrayRemoveAll = _ref2.arrayRemoveAll,
	      arrayShift = _ref2.arrayShift,
	      arraySplice = _ref2.arraySplice,
	      arraySwap = _ref2.arraySwap,
	      arrayUnshift = _ref2.arrayUnshift,
	      asyncError = _ref2.asyncError,
	      dirty = _ref2.dirty,
	      length = _ref2.length,
	      pristine = _ref2.pristine,
	      submitError = _ref2.submitError,
	      state = _ref2.state,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      value = _ref2.value,
	      props = _ref2.props,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	  var finalProps = (0, _extends2["default"])({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + "[" + index + "]", index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      splice: arraySplice,
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, {}, rest);
	  return finalProps;
	}

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(158));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _get = _interopRequireDefault(__webpack_require__(589));
	
	var _ConnectedFields = _interopRequireDefault(__webpack_require__(2134));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(728));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(191));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(131));
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var warnAndValidatePropType = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func), _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]))]);
	
	var fieldsPropTypes = {
	  component: _validateComponentProp["default"],
	  format: _propTypes["default"].func,
	  parse: _propTypes["default"].func,
	  props: _propTypes["default"].object,
	  forwardRef: _propTypes["default"].bool,
	  validate: warnAndValidatePropType,
	  warn: warnAndValidatePropType
	};
	
	var getFieldWarnAndValidate = function getFieldWarnAndValidate(prop, name) {
	  return Array.isArray(prop) || typeof prop === 'function' ? prop : (0, _get["default"])(prop, name, undefined);
	};
	
	function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields["default"])(structure);
	
	  var Fields = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Fields, _Component);
	
	    function Fields(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.connected = (0, _react.createRef)();
	
	      if (!props._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	
	      var error = validateNameProp(props.names);
	
	      if (error) {
	        throw error;
	      }
	
	      return _this;
	    }
	
	    var _proto = Fields.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return (0, _shallowCompare["default"])(this, nextProps);
	    };
	
	    _proto.componentDidMount = function componentDidMount() {
	      this.registerFields(this.props.names);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!_plain["default"].deepEqual(this.props.names, nextProps.names)) {
	        var props = this.props;
	        var unregister = props._reduxForm.unregister; // unregister old name
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName["default"])(props, name));
	        }); // register new name
	
	        this.registerFields(nextProps.names);
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      var props = this.props;
	      var unregister = props._reduxForm.unregister;
	      this.props.names.forEach(function (name) {
	        return unregister((0, _prefixName["default"])(props, name));
	      });
	    };
	
	    _proto.registerFields = function registerFields(names) {
	      var _this2 = this;
	
	      var props = this.props;
	      var register = props._reduxForm.register;
	      names.forEach(function (name) {
	        return register((0, _prefixName["default"])(props, name), 'Field', function () {
	          return getFieldWarnAndValidate(_this2.props.validate, name);
	        }, function () {
	          return getFieldWarnAndValidate(_this2.props.warn, name);
	        });
	      });
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Fields');
	      return this.connected.current ? this.connected.current.getRenderedComponent() : null;
	    };
	
	    _proto.render = function render() {
	      var props = this.props;
	      return (0, _react.createElement)(ConnectedFields, (0, _extends2["default"])({}, this.props, {
	        names: this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        }),
	        ref: this.connected
	      }));
	    };
	
	    (0, _createClass2["default"])(Fields, [{
	      key: "names",
	      get: function get() {
	        var props = this.props;
	        return this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        });
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return this.connected.current ? this.connected.current.isDirty() : false;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: "values",
	      get: function get() {
	        return this.connected.current ? this.connected.current.getValues() : {};
	      }
	    }]);
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = (0, _extends2["default"])({
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    }
	  }, fieldsPropTypes);
	  return (0, _ReduxFormContext.withReduxForm)(Fields);
	}

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createFormValueSelector;
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant["default"])(form, 'Form value must be specified');
	
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant["default"])(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + ".values." + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + ".values." + field);
	        return value === undefined ? accumulator : _plain["default"].setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	}

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(364));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(1741));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(1740));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(5);
	
	var _prefixName = _interopRequireDefault(__webpack_require__(191));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(FormValues, _React$Component);
	
	        function FormValues(props) {
	          var _this;
	
	          _this = _React$Component.call(this, props) || this;
	
	          if (!props._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	
	          _this.updateComponent(props);
	
	          return _this;
	        }
	
	        var _proto = FormValues.prototype;
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
	          if (typeof firstArg === 'function') {
	            this.updateComponent(props);
	          }
	        };
	
	        _proto.render = function render() {
	          var Component = this.Component;
	          return /*#__PURE__*/_react["default"].createElement(Component // so that the connected component updates props when sectionPrefix has changed
	          , (0, _extends2["default"])({
	            sectionPrefix: this.props._reduxForm.sectionPrefix
	          }, this.props));
	        };
	
	        _proto.updateComponent = function updateComponent(props) {
	          var valuesMap;
	          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	
	          if (typeof resolvedFirstArg === 'string') {
	            var _rest$reduce;
	
	            valuesMap = rest.reduce(function (result, k) {
	              result[k] = k;
	              return result;
	            }, (_rest$reduce = {}, _rest$reduce[resolvedFirstArg] = resolvedFirstArg, _rest$reduce));
	          } else {
	            valuesMap = resolvedFirstArg;
	          }
	
	          if ((0, _isEmpty2["default"])(valuesMap)) {
	            // maybe that empty valuesMap is ok if firstArg is a function?
	            // if this is the case, we probably should set this.Component = Component
	            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	          }
	
	          if ((0, _isEqual2["default"])(valuesMap, this._valuesMap)) {
	            // no change in valuesMap
	            return;
	          }
	
	          this._valuesMap = valuesMap;
	          this.setComponent();
	        };
	
	        _proto.setComponent = function setComponent() {
	          var _this2 = this;
	
	          var formValuesSelector = function formValuesSelector(_, _ref2) {
	            var sectionPrefix = _ref2.sectionPrefix;
	            // Yes, we're only using connect() for listening to updates.
	            // The second argument needs to be there so that connect calls
	            // the selector when props change
	            var getValues = _this2.props._reduxForm.getValues;
	            var values = getValues();
	            return (0, _mapValues2["default"])(_this2._valuesMap, function (path) {
	              return getIn(values, (0, _prefixName["default"])(_this2.props, path));
	            });
	          };
	
	          this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(function (_ref3) {
	            var sectionPrefix = _ref3.sectionPrefix,
	                otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["sectionPrefix"]);
	            return /*#__PURE__*/_react["default"].createElement(Component, otherProps);
	          });
	        };
	
	        return FormValues;
	      }(_react["default"].Component);
	
	      return (0, _ReduxFormContext.withReduxForm)(FormValues);
	    };
	  };
	}

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(250));
	
	var _actionTypes = __webpack_require__(410);
	
	var _deleteInWithCleanUp = _interopRequireDefault(__webpack_require__(2151));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var shouldDelete = function shouldDelete(_ref) {
	  var getIn = _ref.getIn;
	  return function (state, path) {
	    var initialValuesPath = null;
	
	    if (/^values/.test(path)) {
	      initialValuesPath = path.replace('values', 'initial');
	    }
	
	    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
	    return getIn(state, path) !== undefined && initialValueComparison;
	  };
	};
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(structure)(shouldDelete);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(_plain["default"])(shouldDelete);
	
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + "." + field);
	    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
	  };
	
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	
	    var existing = _plain["default"].getIn(slice, field);
	
	    return existing || force ? setIn(state, key, _plain["default"].setIn(slice, field, _plain["default"].splice(existing, index, removeNum, value))) : state;
	  };
	
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ARRAY_INSERT] = function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        index = _ref2$meta.index,
	        payload = _ref2.payload;
	    return arraySplice(state, field, index, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_MOVE] = function (state, _ref3) {
	    var _ref3$meta = _ref3.meta,
	        field = _ref3$meta.field,
	        from = _ref3$meta.from,
	        to = _ref3$meta.to;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + "." + field;
	
	        if (getIn(result, path)) {
	          var value = getIn(result, path + "[" + from + "]");
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_POP] = function (state, _ref4) {
	    var field = _ref4.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }, _behaviors[_actionTypes.ARRAY_PUSH] = function (state, _ref5) {
	    var field = _ref5.meta.field,
	        payload = _ref5.payload;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE] = function (state, _ref6) {
	    var _ref6$meta = _ref6.meta,
	        field = _ref6$meta.field,
	        index = _ref6$meta.index;
	    return arraySplice(state, field, index, 1);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE_ALL] = function (state, _ref7) {
	    var field = _ref7.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }, _behaviors[_actionTypes.ARRAY_SHIFT] = function (state, _ref8) {
	    var field = _ref8.meta.field;
	    return arraySplice(state, field, 0, 1);
	  }, _behaviors[_actionTypes.ARRAY_SPLICE] = function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        index = _ref9$meta.index,
	        removeNum = _ref9$meta.removeNum,
	        payload = _ref9.payload;
	    return arraySplice(state, field, index, removeNum, payload);
	  }, _behaviors[_actionTypes.ARRAY_SWAP] = function (state, _ref10) {
	    var _ref10$meta = _ref10.meta,
	        field = _ref10$meta.field,
	        indexA = _ref10$meta.indexA,
	        indexB = _ref10$meta.indexB;
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
	      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");
	
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
	        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
	      }
	    });
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_UNSHIFT] = function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	    return arraySplice(state, field, 0, 0, payload);
	  }, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref12) {
	    var field = _ref12.meta.field,
	        payload = _ref12.payload;
	    var result = state;
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	    result = deleteInWithCleanUp(result, "submitErrors." + field);
	    result = setIn(result, "fields." + field + ".autofilled", true);
	    result = setIn(result, "values." + field, payload);
	    return result;
	  }, _behaviors[_actionTypes.BLUR] = function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        payload = _ref13.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	
	    result = deleteIn(result, "fields." + field + ".active");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CHANGE] = function (state, _ref14) {
	    var _ref14$meta = _ref14.meta,
	        field = _ref14$meta.field,
	        touch = _ref14$meta.touch,
	        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
	        payload = _ref14.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '' || payload === undefined) {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if ((0, _isFunction2["default"])(payload)) {
	      var fieldCurrentValue = getIn(state, "values." + field);
	      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
	    } else {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, "submitErrors." + field);
	    }
	
	    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT] = function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT_ERRORS] = function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_ASYNC_ERROR] = function (state, _ref15) {
	    var field = _ref15.meta.field;
	    return deleteIn(state, "asyncErrors." + field);
	  }, _behaviors[_actionTypes.CLEAR_FIELDS] = function (state, _ref16) {
	    var _ref16$meta = _ref16.meta,
	        keepTouched = _ref16$meta.keepTouched,
	        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
	        fields = _ref16$meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	      if (!persistentSubmitErrors) {
	        result = deleteInWithCleanUp(result, "submitErrors." + field);
	      }
	
	      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	      if (!keepTouched) {
	        result = deleteIn(result, "fields." + field + ".touched");
	      }
	
	      var values = getIn(state, "initial." + field);
	      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.FOCUS] = function (state, _ref17) {
	    var field = _ref17.meta.field;
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, "fields." + previouslyActive + ".active");
	    result = setIn(result, "fields." + field + ".visited", true);
	    result = setIn(result, "fields." + field + ".active", true);
	    result = setIn(result, 'active', field);
	    return result;
	  }, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref18) {
	    var payload = _ref18.payload,
	        _ref18$meta = _ref18.meta,
	        keepDirty = _ref18$meta.keepDirty,
	        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
	        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
	        keepValues = _ref18$meta.keepValues;
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	
	    var warning = getIn(state, 'warning');
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	
	    var syncWarnings = getIn(state, 'syncWarnings');
	
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } // persist old errors, they will get recalculated if the new form values are different from the old values
	
	
	    var error = getIn(state, 'error');
	
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	
	    var syncErrors = getIn(state, 'syncErrors');
	
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var overwritePristineValue = function overwritePristineValue(name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        };
	
	        if (!updateUnregisteredFields) {
	          forEach(keys(registeredFields), function (name) {
	            return overwritePristineValue(name);
	          });
	        }
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	
	          if (updateUnregisteredFields) {
	            overwritePristineValue(name);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepValues) {
	      forEach(keys(previousValues), function (name) {
	        var previousValue = getIn(previousValues, name);
	        newValues = setIn(newValues, name, previousValue);
	      });
	      forEach(keys(previousInitialValues), function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
	      });
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }, _behaviors[_actionTypes.REGISTER_FIELD] = function (state, _ref19) {
	    var _ref19$payload = _ref19.payload,
	        name = _ref19$payload.name,
	        type = _ref19$payload.type;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(state, key);
	
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({
	        name: name,
	        type: type,
	        count: 1
	      });
	    }
	
	    return setIn(state, key, field);
	  }, _behaviors[_actionTypes.RESET] = function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var values = getIn(state, 'initial');
	
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.RESET_SECTION] = function (state, _ref20) {
	    var sections = _ref20.meta.sections;
	    var result = state;
	    sections.forEach(function (section) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + section);
	      result = deleteInWithCleanUp(result, "submitErrors." + section);
	      result = deleteInWithCleanUp(result, "fields." + section);
	      var values = getIn(state, "initial." + section);
	      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.SUBMIT] = function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref21) {
	    var field = _ref21.meta.field;
	    return setIn(state, 'asyncValidating', field || true);
	  }, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	    return setIn(state, 'submitting', true);
	  }, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref22) {
	    var payload = _ref22.payload;
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref23) {
	    var payload = _ref23.payload;
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_FAILED] = function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_SUCCEEDED] = function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }, _behaviors[_actionTypes.TOUCH] = function (state, _ref25) {
	    var fields = _ref25.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }, _behaviors[_actionTypes.UNREGISTER_FIELD] = function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        name = _ref26$payload.name,
	        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
	    var result = state;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(result, key);
	
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	
	      var syncErrors = getIn(result, 'syncErrors');
	
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	
	        if (_plain["default"].deepEqual(syncErrors, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	
	      var syncWarnings = getIn(result, 'syncWarnings');
	
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	
	        if (_plain["default"].deepEqual(syncWarnings, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	
	      result = deleteInWithCleanUp(result, "submitErrors." + name);
	      result = deleteInWithCleanUp(result, "asyncErrors." + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref27) {
	    var fields = _ref27.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, "fields." + field + ".touched");
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_ERRORS] = function (state, _ref28) {
	    var _ref28$payload = _ref28.payload,
	        syncErrors = _ref28$payload.syncErrors,
	        error = _ref28$payload.error;
	    var result = state;
	
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
	    var _ref29$payload = _ref29.payload,
	        syncWarnings = _ref29$payload.syncWarnings,
	        warning = _ref29$payload.warning;
	    var result = state;
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	
	    return result;
	  }, _behaviors);
	
	  var reducer = function reducer(state, action) {
	    if (state === void 0) {
	      state = empty;
	    }
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function (state, action) {
	      if (state === void 0) {
	        state = empty;
	      }
	
	      if (action === void 0) {
	        action = {
	          type: 'NONE'
	        };
	      }
	
	      var form = action && action.meta && action.meta.form;
	
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	  /**
	   * Adds additional functionality to the reducer
	   */
	
	
	  function decorate(target) {
	    target.plugin = function (reducers, config) {
	      var _this = this;
	
	      if (config === void 0) {
	        config = {};
	      }
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function (state, action) {
	        if (state === void 0) {
	          state = empty;
	        }
	
	        if (action === void 0) {
	          action = {
	            type: 'NONE'
	          };
	        }
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	
	
	        var form = action && action.meta && action.meta.form;
	
	        if (form && !config.receiveAllFormActions) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	var _default = createReducer;
	exports["default"] = _default;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(60);
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createReduxForm;
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(158));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(32));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));
	
	var _merge4 = _interopRequireDefault(__webpack_require__(1747));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(364));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(352));
	
	var _invariant = _interopRequireDefault(__webpack_require__(82));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(353));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(137);
	
	var _actions = _interopRequireDefault(__webpack_require__(718));
	
	var _asyncValidation = _interopRequireDefault(__webpack_require__(2141));
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(720));
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(722));
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(721));
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(723));
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(725));
	
	var _silenceEvents = _interopRequireDefault(__webpack_require__(2153));
	
	var _generateValidator = _interopRequireDefault(__webpack_require__(2156));
	
	var _handleSubmit = _interopRequireDefault(__webpack_require__(2166));
	
	var _isValid = _interopRequireDefault(__webpack_require__(412));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(2201));
	
	var _isHotReloading = _interopRequireDefault(__webpack_require__(2202));
	
	var _ReduxFormContext = __webpack_require__(97);
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	}; // extract field-specific actions
	
	
	var arrayInsert = _actions["default"].arrayInsert,
	    arrayMove = _actions["default"].arrayMove,
	    arrayPop = _actions["default"].arrayPop,
	    arrayPush = _actions["default"].arrayPush,
	    arrayRemove = _actions["default"].arrayRemove,
	    arrayRemoveAll = _actions["default"].arrayRemoveAll,
	    arrayShift = _actions["default"].arrayShift,
	    arraySplice = _actions["default"].arraySplice,
	    arraySwap = _actions["default"].arraySwap,
	    arrayUnshift = _actions["default"].arrayUnshift,
	    blur = _actions["default"].blur,
	    change = _actions["default"].change,
	    focus = _actions["default"].focus,
	    formActions = (0, _objectWithoutPropertiesLoose2["default"])(_actions["default"], ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	var propsToNotUpdateFor = [].concat(Object.keys(_actions["default"]), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS,
	      toJS = structure.toJS;
	  var isValid = (0, _isValid["default"])(structure);
	  return function (initialConfig) {
	    var config = (0, _extends2["default"])({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate["default"],
	      shouldValidate: _defaultShouldValidate["default"],
	      shouldError: _defaultShouldError["default"],
	      shouldWarn: _defaultShouldWarn["default"],
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      updateUnregisteredFields: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false,
	      submitAsSideEffect: false
	    }, initialConfig);
	    return function (WrappedComponent) {
	      var Form = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(Form, _React$Component);
	
	        function Form() {
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	          _this.wrapped = _react["default"].createRef();
	          _this.destroyed = false;
	          _this.fieldCounts = {};
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          _this.innerOnSubmit = undefined;
	          _this.submitPromise = undefined;
	
	          _this.initIfNeeded = function (nextProps) {
	            var enableReinitialize = _this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(_this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && _this.props.keepDirtyOnReinitialize;
	
	                _this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  keepValues: nextProps.keepValues,
	                  lastInitialValues: _this.props.initialValues,
	                  updateUnregisteredFields: nextProps.updateUnregisteredFields
	                });
	              }
	            } else if (_this.props.initialValues && (!_this.props.initialized || enableReinitialize)) {
	              _this.props.initialize(_this.props.initialValues, _this.props.keepDirtyOnReinitialize, {
	                keepValues: _this.props.keepValues,
	                updateUnregisteredFields: _this.props.updateUnregisteredFields
	              });
	            }
	          };
	
	          _this.updateSyncErrorsIfNeeded = function (nextSyncErrors, nextError, lastSyncErrors) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                updateSyncErrors = _this$props.updateSyncErrors;
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	
	            if (!(noErrors && nextNoErrors) && (!_plain["default"].deepEqual(lastSyncErrors, nextSyncErrors) || !_plain["default"].deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          };
	
	          _this.clearSubmitPromiseIfNeeded = function (nextProps) {
	            var submitting = _this.props.submitting;
	
	            if (_this.submitPromise && submitting && !nextProps.submitting) {
	              delete _this.submitPromise;
	            }
	          };
	
	          _this.submitIfNeeded = function (nextProps) {
	            var _this$props2 = _this.props,
	                clearSubmit = _this$props2.clearSubmit,
	                triggerSubmit = _this$props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	
	              _this.submit();
	            }
	          };
	
	          _this.shouldErrorFunction = function () {
	            var _this$props3 = _this.props,
	                shouldValidate = _this$props3.shouldValidate,
	                shouldError = _this$props3.shouldError;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldErrorOverridden = shouldError !== _defaultShouldError["default"];
	            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
	          };
	
	          _this.validateIfNeeded = function (nextProps) {
	            var _this$props4 = _this.props,
	                validate = _this$props4.validate,
	                values = _this$props4.values;
	
	            var shouldError = _this.shouldErrorFunction();
	
	            var fieldLevelValidate = _this.generateValidator();
	
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(_this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	
	              if (shouldError(validateParams)) {
	                var propsToValidate = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge2 = (0, _merge4["default"])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = (0, _objectWithoutPropertiesLoose2["default"])(_merge2, ["_error"]);
	
	                _this.lastFieldValidatorKeys = fieldValidatorKeys;
	
	                _this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            } else {
	              _this.lastFieldValidatorKeys = [];
	            }
	          };
	
	          _this.updateSyncWarningsIfNeeded = function (nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _this$props5 = _this.props,
	                warning = _this$props5.warning,
	                updateSyncWarnings = _this$props5.updateSyncWarnings;
	            var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	
	            if (!(noWarnings && nextNoWarnings) && (!_plain["default"].deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain["default"].deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          };
	
	          _this.shouldWarnFunction = function () {
	            var _this$props6 = _this.props,
	                shouldValidate = _this$props6.shouldValidate,
	                shouldWarn = _this$props6.shouldWarn;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldWarnOverridden = shouldWarn !== _defaultShouldWarn["default"];
	            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
	          };
	
	          _this.warnIfNeeded = function (nextProps) {
	            var _this$props7 = _this.props,
	                warn = _this$props7.warn,
	                values = _this$props7.values;
	
	            var shouldWarn = _this.shouldWarnFunction();
	
	            var fieldLevelWarn = _this.generateWarner();
	
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(_this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	
	              if (shouldWarn(validateParams)) {
	                var propsToWarn = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge3 = (0, _merge4["default"])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = (0, _objectWithoutPropertiesLoose2["default"])(_merge3, ["_warning"]);
	
	                _this.lastFieldWarnerKeys = fieldWarnerKeys;
	
	                _this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          };
	
	          _this.getValues = function () {
	            return _this.props.values;
	          };
	
	          _this.isValid = function () {
	            return _this.props.valid;
	          };
	
	          _this.isPristine = function () {
	            return _this.props.pristine;
	          };
	
	          _this.register = function (name, type, getValidator, getWarner) {
	            var lastCount = _this.fieldCounts[name];
	            var nextCount = (lastCount || 0) + 1;
	            _this.fieldCounts[name] = nextCount;
	
	            _this.props.registerField(name, type);
	
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          };
	
	          _this.unregister = function (name) {
	            var lastCount = _this.fieldCounts[name];
	            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
	
	            if (!_this.destroyed) {
	              var _this$props8 = _this.props,
	                  _destroyOnUnmount = _this$props8.destroyOnUnmount,
	                  forceUnregisterOnUnmount = _this$props8.forceUnregisterOnUnmount,
	                  unregisterField = _this$props8.unregisterField;
	
	              if (_destroyOnUnmount || forceUnregisterOnUnmount) {
	                unregisterField(name, _destroyOnUnmount);
	
	                if (!_this.fieldCounts[name]) {
	                  delete _this.fieldValidators[name];
	                  delete _this.fieldWarners[name];
	                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
	                    return key !== name;
	                  });
	                }
	              } else {
	                unregisterField(name, false);
	              }
	            }
	          };
	
	          _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	
	            if (!registeredFields) {
	              return [];
	            }
	
	            var keySeq = keys(registeredFields);
	
	            if (options) {
	              if (options.excludeFieldArray) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].type") !== 'FieldArray';
	                });
	              }
	
	              if (options.excludeUnregistered) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].count") !== 0;
	                });
	              }
	            }
	
	            return toJS(keySeq);
	          };
	
	          _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          };
	
	          _this.generateValidator = function () {
	            var validators = _this.getValidators();
	
	            return Object.keys(validators).length ? (0, _generateValidator["default"])(validators, structure) : undefined;
	          };
	
	          _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          };
	
	          _this.generateWarner = function () {
	            var warners = _this.getWarners();
	
	            return Object.keys(warners).length ? (0, _generateValidator["default"])(warners, structure) : undefined;
	          };
	
	          _this.asyncValidate = function (name, value, trigger) {
	            var _this$props9 = _this.props,
	                asyncBlurFields = _this$props9.asyncBlurFields,
	                asyncChangeFields = _this$props9.asyncChangeFields,
	                asyncErrors = _this$props9.asyncErrors,
	                asyncValidate = _this$props9.asyncValidate,
	                dispatch = _this$props9.dispatch,
	                initialized = _this$props9.initialized,
	                pristine = _this$props9.pristine,
	                shouldAsyncValidate = _this$props9.shouldAsyncValidate,
	                startAsyncValidation = _this$props9.startAsyncValidation,
	                stopAsyncValidation = _this$props9.stopAsyncValidation,
	                syncErrors = _this$props9.syncErrors,
	                values = _this$props9.values;
	            var submitting = !name;
	
	            var fieldNeedsValidation = function fieldNeedsValidation() {
	              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
	              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
	            };
	
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	
	              if (fieldNeedsValidation() && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : trigger,
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation["default"])(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          };
	
	          _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          };
	
	          _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          };
	
	          _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise["default"])(promise)) {
	              return promise;
	            }
	
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          };
	
	          _this.submit = function (submitOrEvent) {
	            var _this$props10 = _this.props,
	                onSubmit = _this$props10.onSubmit,
	                blur = _this$props10.blur,
	                change = _this$props10.change,
	                dispatch = _this$props10.dispatch;
	
	            if (!submitOrEvent || (0, _silenceEvent["default"])(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(onSubmit), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                    blur: blur,
	                    change: change
	                  }, dispatch)), // TODO: fix type, should be `Props`
	                  _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                    excludeFieldArray: true,
	                    excludeUnregistered: true
	                  })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents["default"])(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(submitOrEvent), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                  blur: blur,
	                  change: change
	                }, dispatch)), // TODO: fix type, should be `Props`
	                _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                  excludeFieldArray: true,
	                  excludeUnregistered: true
	                })));
	              });
	            }
	          };
	
	          _this.reset = function () {
	            return _this.props.reset();
	          };
	
	          return _this;
	        }
	
	        var _proto = Form.prototype;
	
	        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	          this.initIfNeeded(nextProps);
	          this.validateIfNeeded(nextProps);
	          this.warnIfNeeded(nextProps);
	          this.clearSubmitPromiseIfNeeded(nextProps);
	          this.submitIfNeeded(nextProps);
	          var onChange = nextProps.onChange,
	              values = nextProps.values,
	              dispatch = nextProps.dispatch;
	
	          if (onChange && !deepEqual(values, this.props.values)) {
	            onChange(values, dispatch, nextProps, this.props.values);
	          }
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	          var _this2 = this;
	
	          if (!this.props.pure) return true;
	          var _config$immutableProp = config.immutableProps,
	              immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
	          // https://twitter.com/erikras/status/915866544558788608
	
	          return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	            // useful to debug rerenders
	            // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	            //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	            // }
	            if (~immutableProps.indexOf(prop)) {
	              return _this2.props[prop] !== nextProps[prop];
	            }
	
	            return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	          }));
	        };
	
	        _proto.componentDidMount = function componentDidMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded(this.props);
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          var _this$props11 = this.props,
	              destroyOnUnmount = _this$props11.destroyOnUnmount,
	              destroy = _this$props11.destroy;
	
	          if (destroyOnUnmount && !(0, _isHotReloading["default"])()) {
	            this.destroyed = true;
	            destroy();
	          }
	        };
	
	        _proto.render = function render() {
	          var _ref,
	              _this3 = this;
	
	          // remove some redux-form config-only props
	
	          /* eslint-disable no-unused-vars */
	          var _this$props12 = this.props,
	              anyTouched = _this$props12.anyTouched,
	              array = _this$props12.array,
	              arrayInsert = _this$props12.arrayInsert,
	              arrayMove = _this$props12.arrayMove,
	              arrayPop = _this$props12.arrayPop,
	              arrayPush = _this$props12.arrayPush,
	              arrayRemove = _this$props12.arrayRemove,
	              arrayRemoveAll = _this$props12.arrayRemoveAll,
	              arrayShift = _this$props12.arrayShift,
	              arraySplice = _this$props12.arraySplice,
	              arraySwap = _this$props12.arraySwap,
	              arrayUnshift = _this$props12.arrayUnshift,
	              asyncErrors = _this$props12.asyncErrors,
	              asyncValidate = _this$props12.asyncValidate,
	              asyncValidating = _this$props12.asyncValidating,
	              blur = _this$props12.blur,
	              change = _this$props12.change,
	              clearSubmit = _this$props12.clearSubmit,
	              destroy = _this$props12.destroy,
	              destroyOnUnmount = _this$props12.destroyOnUnmount,
	              forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount,
	              dirty = _this$props12.dirty,
	              dispatch = _this$props12.dispatch,
	              enableReinitialize = _this$props12.enableReinitialize,
	              error = _this$props12.error,
	              focus = _this$props12.focus,
	              form = _this$props12.form,
	              getFormState = _this$props12.getFormState,
	              immutableProps = _this$props12.immutableProps,
	              initialize = _this$props12.initialize,
	              initialized = _this$props12.initialized,
	              initialValues = _this$props12.initialValues,
	              invalid = _this$props12.invalid,
	              keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize,
	              keepValues = _this$props12.keepValues,
	              updateUnregisteredFields = _this$props12.updateUnregisteredFields,
	              pristine = _this$props12.pristine,
	              propNamespace = _this$props12.propNamespace,
	              registeredFields = _this$props12.registeredFields,
	              registerField = _this$props12.registerField,
	              reset = _this$props12.reset,
	              resetSection = _this$props12.resetSection,
	              setSubmitFailed = _this$props12.setSubmitFailed,
	              setSubmitSucceeded = _this$props12.setSubmitSucceeded,
	              shouldAsyncValidate = _this$props12.shouldAsyncValidate,
	              shouldValidate = _this$props12.shouldValidate,
	              shouldError = _this$props12.shouldError,
	              shouldWarn = _this$props12.shouldWarn,
	              startAsyncValidation = _this$props12.startAsyncValidation,
	              startSubmit = _this$props12.startSubmit,
	              stopAsyncValidation = _this$props12.stopAsyncValidation,
	              stopSubmit = _this$props12.stopSubmit,
	              submitAsSideEffect = _this$props12.submitAsSideEffect,
	              submitting = _this$props12.submitting,
	              submitFailed = _this$props12.submitFailed,
	              submitSucceeded = _this$props12.submitSucceeded,
	              touch = _this$props12.touch,
	              touchOnBlur = _this$props12.touchOnBlur,
	              touchOnChange = _this$props12.touchOnChange,
	              persistentSubmitErrors = _this$props12.persistentSubmitErrors,
	              syncErrors = _this$props12.syncErrors,
	              syncWarnings = _this$props12.syncWarnings,
	              unregisterField = _this$props12.unregisterField,
	              untouch = _this$props12.untouch,
	              updateSyncErrors = _this$props12.updateSyncErrors,
	              updateSyncWarnings = _this$props12.updateSyncWarnings,
	              valid = _this$props12.valid,
	              validExceptSubmit = _this$props12.validExceptSubmit,
	              values = _this$props12.values,
	              warning = _this$props12.warning,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props12, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitAsSideEffect", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
	          /* eslint-enable no-unused-vars */
	
	          var reduxFormProps = (0, _extends2["default"])({
	            array: array,
	            anyTouched: anyTouched,
	            asyncValidate: this.asyncValidate,
	            asyncValidating: asyncValidating
	          }, (0, _redux.bindActionCreators)({
	            blur: blur,
	            change: change
	          }, dispatch), {
	            clearSubmit: clearSubmit,
	            destroy: destroy,
	            dirty: dirty,
	            dispatch: dispatch,
	            error: error,
	            form: form,
	            handleSubmit: this.submit,
	            initialize: initialize,
	            initialized: initialized,
	            initialValues: initialValues,
	            invalid: invalid,
	            pristine: pristine,
	            reset: reset,
	            resetSection: resetSection,
	            submitting: submitting,
	            submitAsSideEffect: submitAsSideEffect,
	            submitFailed: submitFailed,
	            submitSucceeded: submitSucceeded,
	            touch: touch,
	            untouch: untouch,
	            valid: valid,
	            warning: warning
	          });
	          var propsToPass = (0, _extends2["default"])({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, {}, rest);
	
	          if (isClassComponent(WrappedComponent)) {
	            ;
	            propsToPass.ref = this.wrapped;
	          }
	
	          var _reduxForm = (0, _extends2["default"])({}, this.props, {
	            getFormState: function getFormState(state) {
	              return getIn(_this3.props.getFormState(state), _this3.props.form);
	            },
	            asyncValidate: this.asyncValidate,
	            getValues: this.getValues,
	            sectionPrefix: undefined,
	            register: this.register,
	            unregister: this.unregister,
	            registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	              return _this3.innerOnSubmit = innerOnSubmit;
	            }
	          });
	
	          return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	            value: _reduxForm,
	            children: (0, _react.createElement)(WrappedComponent, propsToPass)
	          });
	        };
	
	        return Form;
	      }(_react["default"].Component);
	
	      Form.displayName = "Form(" + (0, _getDisplayName["default"])(WrappedComponent) + ")";
	      Form.WrappedComponent = WrappedComponent;
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes["default"].bool,
	        forceUnregisterOnUnmount: _propTypes["default"].bool,
	        form: _propTypes["default"].string.isRequired,
	        immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	        initialValues: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
	        getFormState: _propTypes["default"].func,
	        onSubmitFail: _propTypes["default"].func,
	        onSubmitSuccess: _propTypes["default"].func,
	        propNamespace: _propTypes["default"].string,
	        validate: _propTypes["default"].func,
	        warn: _propTypes["default"].func,
	        touchOnBlur: _propTypes["default"].bool,
	        touchOnChange: _propTypes["default"].bool,
	        triggerSubmit: _propTypes["default"].bool,
	        persistentSubmitErrors: _propTypes["default"].bool,
	        registeredFields: _propTypes["default"].any
	      };
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	        var initial = initialValues || stateInitial || empty;
	
	        if (!shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	
	        var syncErrors = getIn(formState, 'syncErrors') || _plain["default"].empty;
	
	        var syncWarnings = getIn(formState, 'syncWarnings') || _plain["default"].empty;
	
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        }; // Bind the first parameter on `props.form`
	
	
	        var boundFormACs = (0, _mapValues2["default"])(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues2["default"])(arrayActions, bindForm);
	
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	
	        var boundFocus = bindForm(focus); // Wrap action creators with `dispatch`
	
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	        return (0, _extends2["default"])({}, connectedFormACs, {}, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	      }, undefined, {
	        forwardRef: true
	      });
	      var ConnectedForm = (0, _hoistNonReactStatics["default"])(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config; // build outer component to expose instance api
	
	      var ReduxForm = /*#__PURE__*/function (_React$Component2) {
	        (0, _inheritsLoose2["default"])(ReduxForm, _React$Component2);
	
	        function ReduxForm() {
	          var _this4;
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          _this4 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
	          _this4.ref = _react["default"].createRef();
	          return _this4;
	        }
	
	        var _proto2 = ReduxForm.prototype;
	
	        _proto2.submit = function submit() {
	          return this.ref.current && this.ref.current.submit();
	        };
	
	        _proto2.reset = function reset() {
	          if (this.ref) {
	            this.ref.current.reset();
	          }
	        };
	
	        _proto2.render = function render() {
	          var _this$props13 = this.props,
	              initialValues = _this$props13.initialValues,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props13, ["initialValues"]);
	          return (0, _react.createElement)(ConnectedForm, (0, _extends2["default"])({}, rest, {
	            ref: this.ref,
	            // convert initialValues if need to
	            initialValues: fromJS(initialValues)
	          }));
	        };
	
	        (0, _createClass2["default"])(ReduxForm, [{
	          key: "valid",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isValid());
	          }
	        }, {
	          key: "invalid",
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: "pristine",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isPristine());
	          }
	        }, {
	          key: "dirty",
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: "values",
	          get: function get() {
	            return this.ref.current ? this.ref.current.getValues() : empty;
	          }
	        }, {
	          key: "fieldList",
	          get: function get() {
	            // mainly provided for testing
	            return this.ref.current ? this.ref.current.getFieldList() : [];
	          }
	        }, {
	          key: "wrappedInstance",
	          get: function get() {
	            // for testing
	            return this.ref.current && this.ref.current.wrapped.current;
	          }
	        }]);
	        return ReduxForm;
	      }(_react["default"].Component);
	
	      var WithContext = (0, _hoistNonReactStatics["default"])((0, _ReduxFormContext.withReduxForm)(ReduxForm), WrappedComponent);
	      WithContext.defaultProps = config;
	      return WithContext;
	    };
	  };
	}

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _reactRedux = __webpack_require__(5);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = (0, _extends2["default"])({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      var _ref2;
	
	      return _ref2 = {}, _ref2[prop] = getIn(getFormState(state), form + ".values"), _ref2;
	    } // ignore dispatch
	    );
	  };
	}

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(253));
	
	function createDeleteInWithCleanUp(structure) {
	  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
	    return function (state, path) {
	      return structure.getIn(state, path) !== undefined;
	    };
	  };
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      deleteIn = structure.deleteIn,
	      setIn = structure.setIn;
	  return function (shouldDelete) {
	    if (shouldDelete === void 0) {
	      shouldDelete = shouldDeleteDefault;
	    }
	
	    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	      if (path[path.length - 1] === ']') {
	        // array path
	        var pathTokens = (0, _toPath2["default"])(path);
	        pathTokens.pop();
	        var parent = getIn(state, pathTokens.join('.'));
	        return parent ? setIn(state, path) : state;
	      }
	
	      var result = state;
	
	      if (shouldDelete(structure)(state, path)) {
	        result = deleteIn(state, path);
	      }
	
	      var dotIndex = path.lastIndexOf('.');
	
	      if (dotIndex > 0) {
	        var parentPath = path.substring(0, dotIndex);
	
	        if (parentPath[parentPath.length - 1] !== ']') {
	          var _parent = getIn(result, parentPath);
	
	          if (deepEqual(_parent, empty)) {
	            return deleteInWithCleanUp(result, parentPath);
	          }
	        }
	      }
	
	      return result;
	    };
	
	    return deleteInWithCleanUp;
	  };
	}
	
	var _default = createDeleteInWithCleanUp;
	exports["default"] = _default;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(411));
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent["default"])(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	
	    return value;
	  }
	
	  return event;
	};
	
	var _default = getValue;
	exports["default"] = _default;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(725));
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent["default"])(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
	  };
	};
	
	var _default = silenceEvents;
	exports["default"] = _default;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValueSelector = _interopRequireDefault(__webpack_require__(2146));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createFormValueSelector["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValues = _interopRequireDefault(__webpack_require__(2147));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = generateValidator;
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	
	    if (error) {
	      return error;
	    }
	  }
	};
	
	function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	
	      if (error) {
	        errors = _plain["default"].setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	}

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(2179));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormAsyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormError = _interopRequireDefault(__webpack_require__(2180));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormError["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(2181));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormInitialValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(2182));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormMeta["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(2183));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormNames["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(2184));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormSubmitErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(2185));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormSyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(2186));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormSyncWarnings["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(2187));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _getFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(25));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(353));
	
	var _SubmissionError = __webpack_require__(717);
	
	var mergeErrors = function mergeErrors(_ref) {
	  var asyncErrors = _ref.asyncErrors,
	      syncErrors = _ref.syncErrors;
	  return asyncErrors && typeof asyncErrors.merge === 'function' ? asyncErrors.merge(syncErrors).toJS() : (0, _extends2["default"])({}, asyncErrors, {}, syncErrors);
	};
	
	var executeSubmit = function executeSubmit(submit, fields, props) {
	  var dispatch = props.dispatch,
	      submitAsSideEffect = props.submitAsSideEffect,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      values = props.values;
	  var result;
	
	  try {
	    result = submit(values, dispatch, props);
	  } catch (submitError) {
	    var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	    stopSubmit(error);
	    setSubmitFailed.apply(void 0, fields);
	
	    if (onSubmitFail) {
	      onSubmitFail(error, dispatch, submitError, props);
	    }
	
	    if (error || onSubmitFail) {
	      // if you've provided an onSubmitFail callback, don't re-throw the error
	      return error;
	    } else {
	      throw submitError;
	    }
	  }
	
	  if (submitAsSideEffect) {
	    if (result) {
	      dispatch(result);
	    }
	  } else {
	    if ((0, _isPromise["default"])(result)) {
	      startSubmit();
	      return result.then(function (submitResult) {
	        stopSubmit();
	        setSubmitSucceeded();
	
	        if (onSubmitSuccess) {
	          onSubmitSuccess(submitResult, dispatch, props);
	        }
	
	        return submitResult;
	      }, function (submitError) {
	        var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      });
	    } else {
	      setSubmitSucceeded();
	
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result, dispatch, props);
	      }
	    }
	  }
	
	  return result;
	};
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      setSubmitFailed = props.setSubmitFailed,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	  touch.apply(void 0, fields);
	
	  if (valid || persistentSubmitErrors) {
	    var asyncValidateResult = asyncValidate && asyncValidate();
	
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	
	        return executeSubmit(submit, fields, props);
	      })["catch"](function (asyncErrors) {
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return executeSubmit(submit, fields, props);
	    }
	  } else {
	    setSubmitFailed.apply(void 0, fields);
	    var errors = mergeErrors({
	      asyncErrors: asyncErrors,
	      syncErrors: syncErrors
	    });
	
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	
	    return errors;
	  }
	};
	
	var _default = handleSubmit;
	exports["default"] = _default;

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasError;
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + "._error"];
	
	    case 'FieldArray':
	      return [name + "._error"];
	
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	function createHasError(_ref) {
	  var getIn = _ref.getIn;
	  return function (field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	}

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(2188));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _hasSubmitFailed["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(2189));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _hasSubmitSucceeded["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(2190));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isAsyncValidating["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isDirty = _interopRequireDefault(__webpack_require__(2191));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isDirty["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(2192));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isInvalid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(727));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isPristine["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(2193));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isSubmitting["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isValid = _interopRequireDefault(__webpack_require__(412));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _isValid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(15));
	
	var any = _propTypes["default"].any,
	    bool = _propTypes["default"].bool,
	    func = _propTypes["default"].func,
	    shape = _propTypes["default"].shape,
	    string = _propTypes["default"].string,
	    oneOfType = _propTypes["default"].oneOfType,
	    object = _propTypes["default"].object,
	    number = _propTypes["default"].number;
	var formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired,
	  // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired,
	  // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired,
	  // true if any values are different from initialValues
	  error: any,
	  // form-wide error from '_error' key in validation result
	  form: string.isRequired,
	  // the name of the form
	  invalid: bool.isRequired,
	  // true if there are any validation errors
	  initialized: bool.isRequired,
	  // true if the form has been initialized
	  initialValues: object,
	  // the initialValues object passed to reduxForm
	  pristine: bool.isRequired,
	  // true if the values are the same as initialValues
	  pure: bool.isRequired,
	  // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired,
	  // true if the form is in the process of being submitted
	  submitAsSideEffect: bool.isRequired,
	  // true if onSubmit result will be dispatched
	  submitFailed: bool.isRequired,
	  // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired,
	  // true if the form was successfully submitted
	  valid: bool.isRequired,
	  // true if there are no validation errors
	  warning: any,
	  // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired,
	    // function to insert a value into an array field
	    move: func.isRequired,
	    // function to move a value within an array field
	    pop: func.isRequired,
	    // function to pop a value off of an array field
	    push: func.isRequired,
	    // function to push a value onto an array field
	    remove: func.isRequired,
	    // function to remove a value from an array field
	    removeAll: func.isRequired,
	    // function to remove all the values from an array field
	    shift: func.isRequired,
	    // function to shift a value out of an array field
	    splice: func.isRequired,
	    // function to splice a value into an array field
	    swap: func.isRequired,
	    // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	
	  }),
	  asyncValidate: func.isRequired,
	  // function to trigger async validation
	  autofill: func.isRequired,
	  // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired,
	  // action to mark a field as blurred
	  change: func.isRequired,
	  // action to change the value of a field
	  clearAsyncError: func.isRequired,
	  // action to clear the async error of a field
	  clearFields: func.isRequired,
	  // action to clean fields values for all fields
	  clearSubmitErrors: func.isRequired,
	  // action to remove submitErrors and error
	  destroy: func.isRequired,
	  // action to destroy the form's data in Redux
	  dispatch: func.isRequired,
	  // the Redux dispatch action
	  handleSubmit: func.isRequired,
	  // function to submit the form
	  initialize: func.isRequired,
	  // action to initialize form data
	  reset: func.isRequired,
	  // action to reset the form data to previously initialized values
	  resetSection: func.isRequired,
	  // action to reset the form sections data to previously initialized values
	  touch: func.isRequired,
	  // action to mark fields as touched
	  submit: func.isRequired,
	  // action to trigger a submission of the specified form
	  untouch: func.isRequired,
	  // action to mark fields as untouched
	  // triggerSubmit
	  triggerSubmit: bool,
	  // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	
	};
	exports.formPropTypes = formPropTypes;
	var fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	exports.fieldInputPropTypes = fieldInputPropTypes;
	var fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	exports.fieldMetaPropTypes = fieldMetaPropTypes;
	var fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	exports.fieldArrayMetaPropTypes = fieldArrayMetaPropTypes;
	var fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	exports.fieldArrayFieldsPropTypes = fieldArrayFieldsPropTypes;
	var fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	exports.fieldPropTypes = fieldPropTypes;
	var fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	exports.fieldArrayPropTypes = fieldArrayPropTypes;
	var _default = formPropTypes;
	exports["default"] = _default;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReducer = _interopRequireDefault(__webpack_require__(2148));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createReducer["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReduxForm = _interopRequireDefault(__webpack_require__(2149));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createReduxForm["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormAsyncErrors;
	
	function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
	    };
	  };
	}

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormError;
	
	function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".error");
	    };
	  };
	}

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormInitialValues;
	
	function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".initial");
	    };
	  };
	}

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormMeta;
	
	function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".fields") || empty;
	    };
	  };
	}

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormNames;
	
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSubmitErrors;
	
	function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".submitErrors") || empty;
	    };
	  };
	}

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncErrors;
	
	function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncErrors") || empty;
	    };
	  };
	}

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncWarnings;
	
	function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncWarnings") || empty;
	    };
	  };
	}

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormValues;
	
	function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".values");
	    };
	  };
	}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitFailed;
	
	function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitFailed");
	    };
	  };
	}

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitSucceeded;
	
	function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitSucceeded");
	    };
	  };
	}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsAsyncValidating;
	
	function createIsAsyncValidating(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".asyncValidating");
	    };
	  };
	}

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsDirty;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(727));
	
	function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine["default"])(structure)(form, getFormState);
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      return !isPristine.apply(void 0, [state].concat(fields));
	    };
	  };
	}

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = createIsInvalid;
	
	var _isValid = _interopRequireDefault(__webpack_require__(412));
	
	function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid["default"])(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	}

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsSubmitting;
	
	function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitting");
	    };
	  };
	}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(1742));
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(590));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var isEmpty = function isEmpty(obj) {
	  return (0, _isNil2["default"])(obj) || obj === '' || isNaN(obj);
	};
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    return isEmpty(obj) === isEmpty(other);
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react["default"].isValidElement(obj) || _react["default"].isValidElement(other)) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith2["default"])(a, b, customizer);
	};
	
	var _default = deepEqual;
	exports["default"] = _default;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(25));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(253));
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
	      }
	
	      var firstIndex = Number(first);
	
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));
	
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(state);
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	
	      return state;
	    }
	
	    if (first in state) {
	      var _extends2;
	
	      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));
	
	      return state[first] === _result ? state : (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
	    }
	
	    return state;
	  }
	
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
	    }
	
	    var _firstIndex = Number(first);
	
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(state);
	
	      _copy.splice(_firstIndex, 1);
	
	      return _copy;
	    }
	
	    return state;
	  }
	
	  if (first in state) {
	    var _copy2 = (0, _extends3["default"])({}, state);
	
	    delete _copy2[first];
	    return _copy2;
	  }
	
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(void 0, [state].concat((0, _toPath2["default"])(field)));
	};
	
	var _default = deleteIn;
	exports["default"] = _default;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(253));
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath2["default"])(field);
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports["default"] = _default;

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	
	var _default = keys;
	exports["default"] = _default;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(25));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(253));
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  var _extends2;
	
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      var _ref;
	
	      return _ref = {}, _ref[first] = next, _ref;
	    }
	
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath2["default"])(field), 0);
	};
	
	var _default = setIn;
	exports["default"] = _default;

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(array);
	
	      _copy2.splice(index, 0, true); // temporary placeholder
	
	
	      _copy2[index] = undefined; // set to undefined
	
	      return _copy2;
	    }
	
	    if (value != null) {
	      var _copy3 = [].concat(array);
	
	      _copy3.splice(index, removeNum, value); // removing and adding
	
	
	      return _copy3;
	    }
	
	    var _copy = [].concat(array);
	
	    _copy.splice(index, removeNum); // removing
	
	
	    return _copy;
	  }
	
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  } // trying to add outside of range: just set value
	
	
	  var copy = [].concat(array);
	  copy[index] = value;
	  return copy;
	};
	
	var _default = splice;
	exports["default"] = _default;

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.dataKey = void 0;
	var dataKey = 'text';
	exports.dataKey = dataKey;

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	var _default = getDisplayName;
	exports["default"] = _default;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isHotReloading = function isHotReloading() {
	  var castModule = module;
	  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
	};
	
	var _default = isHotReloading;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module)))

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createValues = _interopRequireDefault(__webpack_require__(2150));
	
	var _plain = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.combineEpics = void 0;
	var rxjs_1 = __webpack_require__(414);
	/**
	  Merges all epics into a single one.
	 */
	function combineEpics() {
	    var epics = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        epics[_i] = arguments[_i];
	    }
	    var merger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return rxjs_1.merge.apply(void 0, epics.map(function (epic) {
	            var output$ = epic.apply(void 0, args);
	            if (!output$) {
	                throw new TypeError("combineEpics: one of the provided Epics \"" + (epic.name || '<anonymous>') + "\" does not return a stream. Double check you're not missing a return statement!");
	            }
	            return output$;
	        }));
	    };
	    // Technically the `name` property on Function's are supposed to be read-only.
	    // While some JS runtimes allow it anyway (so this is useful in debugging)
	    // some actually throw an exception when you attempt to do so.
	    try {
	        Object.defineProperty(merger, 'name', {
	            value: "combineEpics(" + epics.map(function (epic) { return epic.name || '<anonymous>'; }).join(', ') + ")",
	        });
	    }
	    catch (e) { }
	    return merger;
	}
	exports.combineEpics = combineEpics;


/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createEpicMiddleware = void 0;
	var rxjs_1 = __webpack_require__(414);
	var operators_1 = __webpack_require__(839);
	var StateObservable_1 = __webpack_require__(729);
	var console_1 = __webpack_require__(413);
	function createEpicMiddleware(options) {
	    if (options === void 0) { options = {}; }
	    // This isn't great. RxJS doesn't publicly export the constructor for
	    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
	    // we don't want our internal queuing mechanism to be on the same queue as any
	    // other RxJS code outside of redux-observable internals.
	    var QueueScheduler = rxjs_1.queueScheduler.constructor;
	    var uniqueQueueScheduler = new QueueScheduler(rxjs_1.queueScheduler.schedulerActionCtor);
	    if (false) {
	        throw new TypeError('Providing your root Epic to `createEpicMiddleware(rootEpic)` is no longer supported, instead use `epicMiddleware.run(rootEpic)`\n\nLearn more: https://redux-observable.js.org/MIGRATION.html#setting-up-the-middleware');
	    }
	    var epic$ = new rxjs_1.Subject();
	    var store;
	    var epicMiddleware = function (_store) {
	        if (false) {
	            // https://github.com/redux-observable/redux-observable/issues/389
	            console_1.warn('this middleware is already associated with a store. createEpicMiddleware should be called for every store.\n\nLearn more: https://goo.gl/2GQ7Da');
	        }
	        store = _store;
	        var actionSubject$ = new rxjs_1.Subject();
	        var stateSubject$ = new rxjs_1.Subject();
	        var action$ = actionSubject$
	            .asObservable()
	            .pipe(operators_1.observeOn(uniqueQueueScheduler));
	        var state$ = new StateObservable_1.StateObservable(stateSubject$.pipe(operators_1.observeOn(uniqueQueueScheduler)), store.getState());
	        var result$ = epic$.pipe(operators_1.map(function (epic) {
	            var output$ = epic(action$, state$, options.dependencies);
	            if (!output$) {
	                throw new TypeError("Your root Epic \"" + (epic.name ||
	                    '<anonymous>') + "\" does not return a stream. Double check you're not missing a return statement!");
	            }
	            return output$;
	        }), operators_1.mergeMap(function (output$) {
	            return rxjs_1.from(output$).pipe(operators_1.subscribeOn(uniqueQueueScheduler), operators_1.observeOn(uniqueQueueScheduler));
	        }));
	        result$.subscribe(store.dispatch);
	        return function (next) {
	            return function (action) {
	                // Downstream middleware gets the action first,
	                // which includes their reducers, so state is
	                // updated before epics receive the action
	                var result = next(action);
	                // It's important to update the state$ before we emit
	                // the action because otherwise it would be stale
	                stateSubject$.next(store.getState());
	                actionSubject$.next(action);
	                return result;
	            };
	        };
	    };
	    epicMiddleware.run = function (rootEpic) {
	        if (false) {
	            console_1.warn('epicMiddleware.run(rootEpic) called before the middleware has been setup by redux. Provide the epicMiddleware instance to createStore() first.');
	        }
	        epic$.next(rootEpic);
	    };
	    return epicMiddleware;
	}
	exports.createEpicMiddleware = createEpicMiddleware;


/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ofType = void 0;
	var operators_1 = __webpack_require__(839);
	var console_1 = __webpack_require__(413);
	var keyHasType = function (type, key) {
	    return type === key || (typeof key === 'function' && type === key.toString());
	};
	/**
	 * Inferring the types of this is a bit challenging, and only works in newer
	 * versions of TypeScript.
	 *
	 * @param ...types One or more Redux action types you want to filter for, variadic.
	 */
	function ofType() {
	    var types = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        types[_i] = arguments[_i];
	    }
	    var len = types.length;
	    if (false) {
	        if (len === 0) {
	            console_1.warn('ofType was called without any types!');
	        }
	        if (types.some(function (key) { return key === null || key === undefined; })) {
	            console_1.warn('ofType was called with one or more undefined or null values!');
	        }
	    }
	    return operators_1.filter(len === 1
	        ? function (action) { return keyHasType(action.type, types[0]); }
	        : function (action) {
	            for (var i = 0; i < len; i++) {
	                if (keyHasType(action.type, types[i])) {
	                    return true;
	                }
	            }
	            return false;
	        });
	}
	exports.ofType = ofType;


/***/ }),
/* 2207 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createNotification = exports.nextNotification = exports.errorNotification = exports.COMPLETE_NOTIFICATION = void 0;
	exports.COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
	function errorNotification(error) {
	    return createNotification('E', undefined, error);
	}
	exports.errorNotification = errorNotification;
	function nextNotification(value) {
	    return createNotification('N', value, undefined);
	}
	exports.nextNotification = nextNotification;
	function createNotification(kind, value, error) {
	    return {
	        kind: kind,
	        value: value,
	        error: error,
	    };
	}
	exports.createNotification = createNotification;
	//# sourceMappingURL=NotificationFactories.js.map

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.firstValueFrom = void 0;
	var EmptyError_1 = __webpack_require__(133);
	var Subscriber_1 = __webpack_require__(192);
	function firstValueFrom(source, config) {
	    var hasConfig = typeof config === 'object';
	    return new Promise(function (resolve, reject) {
	        var subscriber = new Subscriber_1.SafeSubscriber({
	            next: function (value) {
	                resolve(value);
	                subscriber.unsubscribe();
	            },
	            error: reject,
	            complete: function () {
	                if (hasConfig) {
	                    resolve(config.defaultValue);
	                }
	                else {
	                    reject(new EmptyError_1.EmptyError());
	                }
	            },
	        });
	        source.subscribe(subscriber);
	    });
	}
	exports.firstValueFrom = firstValueFrom;
	//# sourceMappingURL=firstValueFrom.js.map

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lastValueFrom = void 0;
	var EmptyError_1 = __webpack_require__(133);
	function lastValueFrom(source, config) {
	    var hasConfig = typeof config === 'object';
	    return new Promise(function (resolve, reject) {
	        var _hasValue = false;
	        var _value;
	        source.subscribe({
	            next: function (value) {
	                _value = value;
	                _hasValue = true;
	            },
	            error: reject,
	            complete: function () {
	                if (_hasValue) {
	                    resolve(_value);
	                }
	                else if (hasConfig) {
	                    resolve(config.defaultValue);
	                }
	                else {
	                    reject(new EmptyError_1.EmptyError());
	                }
	            },
	        });
	    });
	}
	exports.lastValueFrom = lastValueFrom;
	//# sourceMappingURL=lastValueFrom.js.map

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindCallback = void 0;
	var bindCallbackInternals_1 = __webpack_require__(733);
	function bindCallback(callbackFunc, resultSelector, scheduler) {
	    return bindCallbackInternals_1.bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
	}
	exports.bindCallback = bindCallback;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindNodeCallback = void 0;
	var bindCallbackInternals_1 = __webpack_require__(733);
	function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
	    return bindCallbackInternals_1.bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
	}
	exports.bindNodeCallback = bindNodeCallback;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.connectable = void 0;
	var Subject_1 = __webpack_require__(46);
	var Observable_1 = __webpack_require__(28);
	var defer_1 = __webpack_require__(287);
	var DEFAULT_CONFIG = {
	    connector: function () { return new Subject_1.Subject(); },
	    resetOnDisconnect: true,
	};
	function connectable(source, config) {
	    if (config === void 0) { config = DEFAULT_CONFIG; }
	    var connection = null;
	    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
	    var subject = connector();
	    var result = new Observable_1.Observable(function (subscriber) {
	        return subject.subscribe(subscriber);
	    });
	    result.connect = function () {
	        if (!connection || connection.closed) {
	            connection = defer_1.defer(function () { return source; }).subscribe(subject);
	            if (resetOnDisconnect) {
	                connection.add(function () { return (subject = connector()); });
	            }
	        }
	        return connection;
	    };
	    return result;
	}
	exports.connectable = connectable;
	//# sourceMappingURL=connectable.js.map

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrames = void 0;
	var Observable_1 = __webpack_require__(28);
	var Subscription_1 = __webpack_require__(64);
	var performanceTimestampProvider_1 = __webpack_require__(2244);
	var animationFrameProvider_1 = __webpack_require__(822);
	function animationFrames(timestampProvider) {
	    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
	}
	exports.animationFrames = animationFrames;
	function animationFramesFactory(timestampProvider) {
	    var schedule = animationFrameProvider_1.animationFrameProvider.schedule;
	    return new Observable_1.Observable(function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var provider = timestampProvider || performanceTimestampProvider_1.performanceTimestampProvider;
	        var start = provider.now();
	        var run = function (timestamp) {
	            var now = provider.now();
	            subscriber.next({
	                timestamp: timestampProvider ? now : timestamp,
	                elapsed: now - start,
	            });
	            if (!subscriber.closed) {
	                subscription.add(schedule(run));
	            }
	        };
	        subscription.add(schedule(run));
	        return subscription;
	    });
	}
	var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
	//# sourceMappingURL=animationFrames.js.map

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.forkJoin = void 0;
	var Observable_1 = __webpack_require__(28);
	var argsArgArrayOrObject_1 = __webpack_require__(830);
	var innerFrom_1 = __webpack_require__(23);
	var args_1 = __webpack_require__(66);
	var OperatorSubscriber_1 = __webpack_require__(10);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var createObject_1 = __webpack_require__(831);
	function forkJoin() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resultSelector = args_1.popResultSelector(args);
	    var _a = argsArgArrayOrObject_1.argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
	    var result = new Observable_1.Observable(function (subscriber) {
	        var length = sources.length;
	        if (!length) {
	            subscriber.complete();
	            return;
	        }
	        var values = new Array(length);
	        var remainingCompletions = length;
	        var remainingEmissions = length;
	        var _loop_1 = function (sourceIndex) {
	            var hasValue = false;
	            innerFrom_1.innerFrom(sources[sourceIndex]).subscribe(OperatorSubscriber_1.createOperatorSubscriber(subscriber, function (value) {
	                if (!hasValue) {
	                    hasValue = true;
	                    remainingEmissions--;
	                }
	                values[sourceIndex] = value;
	            }, function () { return remainingCompletions--; }, undefined, function () {
	                if (!remainingCompletions || !hasValue) {
	                    if (!remainingEmissions) {
	                        subscriber.next(keys ? createObject_1.createObject(keys, values) : values);
	                    }
	                    subscriber.complete();
	                }
	            }));
	        };
	        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
	            _loop_1(sourceIndex);
	        }
	    });
	    return resultSelector ? result.pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector)) : result;
	}
	exports.forkJoin = forkJoin;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromEvent = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var Observable_1 = __webpack_require__(28);
	var mergeMap_1 = __webpack_require__(98);
	var isArrayLike_1 = __webpack_require__(441);
	var isFunction_1 = __webpack_require__(27);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	var nodeEventEmitterMethods = ['addListener', 'removeListener'];
	var eventTargetMethods = ['addEventListener', 'removeEventListener'];
	var jqueryMethods = ['on', 'off'];
	function fromEvent(target, eventName, options, resultSelector) {
	    if (isFunction_1.isFunction(options)) {
	        resultSelector = options;
	        options = undefined;
	    }
	    if (resultSelector) {
	        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	    }
	    var _a = __read(isEventTarget(target)
	        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
	        :
	            isNodeStyleEventEmitter(target)
	                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
	                : isJQueryStyleEventEmitter(target)
	                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
	                    : [], 2), add = _a[0], remove = _a[1];
	    if (!add) {
	        if (isArrayLike_1.isArrayLike(target)) {
	            return mergeMap_1.mergeMap(function (subTarget) { return fromEvent(subTarget, eventName, options); })(innerFrom_1.innerFrom(target));
	        }
	    }
	    if (!add) {
	        throw new TypeError('Invalid event target');
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var handler = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return subscriber.next(1 < args.length ? args : args[0]);
	        };
	        add(handler);
	        return function () { return remove(handler); };
	    });
	}
	exports.fromEvent = fromEvent;
	function toCommonHandlerRegistry(target, eventName) {
	    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
	}
	function isNodeStyleEventEmitter(target) {
	    return isFunction_1.isFunction(target.addListener) && isFunction_1.isFunction(target.removeListener);
	}
	function isJQueryStyleEventEmitter(target) {
	    return isFunction_1.isFunction(target.on) && isFunction_1.isFunction(target.off);
	}
	function isEventTarget(target) {
	    return isFunction_1.isFunction(target.addEventListener) && isFunction_1.isFunction(target.removeEventListener);
	}
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromEventPattern = void 0;
	var Observable_1 = __webpack_require__(28);
	var isFunction_1 = __webpack_require__(27);
	var mapOneOrManyArgs_1 = __webpack_require__(136);
	function fromEventPattern(addHandler, removeHandler, resultSelector) {
	    if (resultSelector) {
	        return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs_1.mapOneOrManyArgs(resultSelector));
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var handler = function () {
	            var e = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                e[_i] = arguments[_i];
	            }
	            return subscriber.next(e.length === 1 ? e[0] : e);
	        };
	        var retValue = addHandler(handler);
	        return isFunction_1.isFunction(removeHandler) ? function () { return removeHandler(handler, retValue); } : undefined;
	    });
	}
	exports.fromEventPattern = fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromSubscribable = void 0;
	var Observable_1 = __webpack_require__(28);
	function fromSubscribable(subscribable) {
	    return new Observable_1.Observable(function (subscriber) { return subscribable.subscribe(subscriber); });
	}
	exports.fromSubscribable = fromSubscribable;
	//# sourceMappingURL=fromSubscribable.js.map

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.generate = void 0;
	var identity_1 = __webpack_require__(47);
	var isScheduler_1 = __webpack_require__(293);
	var defer_1 = __webpack_require__(287);
	var scheduleIterable_1 = __webpack_require__(820);
	function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
	    var _a, _b;
	    var resultSelector;
	    var initialState;
	    if (arguments.length === 1) {
	        (_a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity_1.identity : _b, scheduler = _a.scheduler);
	    }
	    else {
	        initialState = initialStateOrOptions;
	        if (!resultSelectorOrScheduler || isScheduler_1.isScheduler(resultSelectorOrScheduler)) {
	            resultSelector = identity_1.identity;
	            scheduler = resultSelectorOrScheduler;
	        }
	        else {
	            resultSelector = resultSelectorOrScheduler;
	        }
	    }
	    function gen() {
	        var state;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    state = initialState;
	                    _a.label = 1;
	                case 1:
	                    if (!(!condition || condition(state))) return [3, 4];
	                    return [4, resultSelector(state)];
	                case 2:
	                    _a.sent();
	                    _a.label = 3;
	                case 3:
	                    state = iterate(state);
	                    return [3, 1];
	                case 4: return [2];
	            }
	        });
	    }
	    return defer_1.defer((scheduler
	        ?
	            function () { return scheduleIterable_1.scheduleIterable(gen(), scheduler); }
	        :
	            gen));
	}
	exports.generate = generate;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.iif = void 0;
	var defer_1 = __webpack_require__(287);
	function iif(condition, trueResult, falseResult) {
	    return defer_1.defer(function () { return (condition() ? trueResult : falseResult); });
	}
	exports.iif = iif;
	//# sourceMappingURL=iif.js.map

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.merge = void 0;
	var mergeAll_1 = __webpack_require__(195);
	var innerFrom_1 = __webpack_require__(23);
	var empty_1 = __webpack_require__(77);
	var args_1 = __webpack_require__(66);
	var from_1 = __webpack_require__(109);
	function merge() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args_1.popScheduler(args);
	    var concurrent = args_1.popNumber(args, Infinity);
	    var sources = args;
	    return !sources.length
	        ?
	            empty_1.EMPTY
	        : sources.length === 1
	            ?
	                innerFrom_1.innerFrom(sources[0])
	            :
	                mergeAll_1.mergeAll(concurrent)(from_1.from(sources, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.onErrorResumeNext = void 0;
	var empty_1 = __webpack_require__(77);
	var onErrorResumeNext_1 = __webpack_require__(778);
	var argsOrArgArray_1 = __webpack_require__(134);
	function onErrorResumeNext() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    return onErrorResumeNext_1.onErrorResumeNext(argsOrArgArray_1.argsOrArgArray(sources))(empty_1.EMPTY);
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pairs = void 0;
	var from_1 = __webpack_require__(109);
	function pairs(obj, scheduler) {
	    return from_1.from(Object.entries(obj), scheduler);
	}
	exports.pairs = pairs;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.partition = void 0;
	var not_1 = __webpack_require__(836);
	var filter_1 = __webpack_require__(110);
	var innerFrom_1 = __webpack_require__(23);
	function partition(source, predicate, thisArg) {
	    return [filter_1.filter(predicate, thisArg)(innerFrom_1.innerFrom(source)), filter_1.filter(not_1.not(predicate, thisArg))(innerFrom_1.innerFrom(source))];
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.range = void 0;
	var Observable_1 = __webpack_require__(28);
	var empty_1 = __webpack_require__(77);
	function range(start, count, scheduler) {
	    if (count == null) {
	        count = start;
	        start = 0;
	    }
	    if (count <= 0) {
	        return empty_1.EMPTY;
	    }
	    var end = count + start;
	    return new Observable_1.Observable(scheduler
	        ?
	            function (subscriber) {
	                var n = start;
	                return scheduler.schedule(function () {
	                    if (n < end) {
	                        subscriber.next(n++);
	                        this.schedule();
	                    }
	                    else {
	                        subscriber.complete();
	                    }
	                });
	            }
	        :
	            function (subscriber) {
	                var n = start;
	                while (n < end && !subscriber.closed) {
	                    subscriber.next(n++);
	                }
	                subscriber.complete();
	            });
	}
	exports.range = range;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.using = void 0;
	var Observable_1 = __webpack_require__(28);
	var innerFrom_1 = __webpack_require__(23);
	var empty_1 = __webpack_require__(77);
	function using(resourceFactory, observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        var resource = resourceFactory();
	        var result = observableFactory(resource);
	        var source = result ? innerFrom_1.innerFrom(result) : empty_1.EMPTY;
	        source.subscribe(subscriber);
	        return function () {
	            if (resource) {
	                resource.unsubscribe();
	            }
	        };
	    });
	}
	exports.using = using;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.partition = void 0;
	var not_1 = __webpack_require__(836);
	var filter_1 = __webpack_require__(110);
	function partition(predicate, thisArg) {
	    return function (source) {
	        return [filter_1.filter(predicate, thisArg)(source), filter_1.filter(not_1.not(predicate, thisArg))(source)];
	    };
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.race = void 0;
	var argsOrArgArray_1 = __webpack_require__(134);
	var raceWith_1 = __webpack_require__(432);
	function race() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return raceWith_1.raceWith.apply(void 0, __spreadArray([], __read(argsOrArgArray_1.argsOrArgArray(args))));
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleArray = void 0;
	var Observable_1 = __webpack_require__(28);
	function scheduleArray(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var i = 0;
	        return scheduler.schedule(function () {
	            if (i === input.length) {
	                subscriber.complete();
	            }
	            else {
	                subscriber.next(input[i++]);
	                if (!subscriber.closed) {
	                    this.schedule();
	                }
	            }
	        });
	    });
	}
	exports.scheduleArray = scheduleArray;
	//# sourceMappingURL=scheduleArray.js.map

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleObservable = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var observeOn_1 = __webpack_require__(196);
	var subscribeOn_1 = __webpack_require__(197);
	function scheduleObservable(input, scheduler) {
	    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	}
	exports.scheduleObservable = scheduleObservable;
	//# sourceMappingURL=scheduleObservable.js.map

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.schedulePromise = void 0;
	var innerFrom_1 = __webpack_require__(23);
	var observeOn_1 = __webpack_require__(196);
	var subscribeOn_1 = __webpack_require__(197);
	function schedulePromise(input, scheduler) {
	    return innerFrom_1.innerFrom(input).pipe(subscribeOn_1.subscribeOn(scheduler), observeOn_1.observeOn(scheduler));
	}
	exports.schedulePromise = schedulePromise;
	//# sourceMappingURL=schedulePromise.js.map

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scheduleReadableStreamLike = void 0;
	var scheduleAsyncIterable_1 = __webpack_require__(819);
	var isReadableStreamLike_1 = __webpack_require__(443);
	function scheduleReadableStreamLike(input, scheduler) {
	    return scheduleAsyncIterable_1.scheduleAsyncIterable(isReadableStreamLike_1.readableStreamLikeToAsyncGenerator(input), scheduler);
	}
	exports.scheduleReadableStreamLike = scheduleReadableStreamLike;
	//# sourceMappingURL=scheduleReadableStreamLike.js.map

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Action = void 0;
	var Subscription_1 = __webpack_require__(64);
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        return _super.call(this) || this;
	    }
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnimationFrameAction = void 0;
	var AsyncAction_1 = __webpack_require__(201);
	var animationFrameProvider_1 = __webpack_require__(822);
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider_1.animationFrameProvider.requestAnimationFrame(function () { return scheduler.flush(undefined); }));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (!scheduler.actions.some(function (action) { return action.id === id; })) {
	            animationFrameProvider_1.animationFrameProvider.cancelAnimationFrame(id);
	            scheduler._scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnimationFrameScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(202);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this._active = true;
	        var flushId = this._scheduled;
	        this._scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        action = action || actions.shift();
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions[0]) && action.id === flushId && actions.shift());
	        this._active = false;
	        if (error) {
	            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsapAction = void 0;
	var AsyncAction_1 = __webpack_require__(201);
	var immediateProvider_1 = __webpack_require__(2242);
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler._scheduled || (scheduler._scheduled = immediateProvider_1.immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (!scheduler.actions.some(function (action) { return action.id === id; })) {
	            immediateProvider_1.immediateProvider.clearImmediate(id);
	            scheduler._scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AsapScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(202);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this._active = true;
	        var flushId = this._scheduled;
	        this._scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        action = action || actions.shift();
	        do {
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        } while ((action = actions[0]) && action.id === flushId && actions.shift());
	        this._active = false;
	        if (error) {
	            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QueueAction = void 0;
	var AsyncAction_1 = __webpack_require__(201);
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QueueScheduler = void 0;
	var AsyncScheduler_1 = __webpack_require__(202);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.VirtualAction = exports.VirtualTimeScheduler = void 0;
	var AsyncAction_1 = __webpack_require__(201);
	var Subscription_1 = __webpack_require__(64);
	var AsyncScheduler_1 = __webpack_require__(202);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
	        if (schedulerActionCtor === void 0) { schedulerActionCtor = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Infinity; }
	        var _this = _super.call(this, schedulerActionCtor, function () { return _this.frame; }) || this;
	        _this.maxFrames = maxFrames;
	        _this.frame = 0;
	        _this.index = -1;
	        return _this;
	    }
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error;
	        var action;
	        while ((action = actions[0]) && action.delay <= maxFrames) {
	            actions.shift();
	            this.frame = action.delay;
	            if ((error = action.execute(action.state, action.delay))) {
	                break;
	            }
	        }
	        if (error) {
	            while ((action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = (scheduler.index += 1); }
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.index = index;
	        _this.active = true;
	        _this.index = scheduler.index = index;
	        return _this;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (Number.isFinite(delay)) {
	            if (!this.id) {
	                return _super.prototype.schedule.call(this, state, delay);
	            }
	            this.active = false;
	            var action = new VirtualAction(this.scheduler, this.work);
	            this.add(action);
	            return action.schedule(state, delay);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.animationFrame = exports.animationFrameScheduler = void 0;
	var AnimationFrameAction_1 = __webpack_require__(2233);
	var AnimationFrameScheduler_1 = __webpack_require__(2234);
	exports.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	exports.animationFrame = exports.animationFrameScheduler;
	//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.asap = exports.asapScheduler = void 0;
	var AsapAction_1 = __webpack_require__(2235);
	var AsapScheduler_1 = __webpack_require__(2236);
	exports.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	exports.asap = exports.asapScheduler;
	//# sourceMappingURL=asap.js.map

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.immediateProvider = void 0;
	var Immediate_1 = __webpack_require__(2247);
	var setImmediate = Immediate_1.Immediate.setImmediate, clearImmediate = Immediate_1.Immediate.clearImmediate;
	exports.immediateProvider = {
	    setImmediate: function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var delegate = exports.immediateProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
	    },
	    clearImmediate: function (handle) {
	        var delegate = exports.immediateProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=immediateProvider.js.map

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spreadArray = (this && this.__spreadArray) || function (to, from) {
	    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	        to[j] = from[i];
	    return to;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.intervalProvider = void 0;
	exports.intervalProvider = {
	    setInterval: function (handler, timeout) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        var delegate = exports.intervalProvider.delegate;
	        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
	            return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
	        }
	        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
	    },
	    clearInterval: function (handle) {
	        var delegate = exports.intervalProvider.delegate;
	        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=intervalProvider.js.map

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.performanceTimestampProvider = void 0;
	exports.performanceTimestampProvider = {
	    now: function () {
	        return (exports.performanceTimestampProvider.delegate || performance).now();
	    },
	    delegate: undefined,
	};
	//# sourceMappingURL=performanceTimestampProvider.js.map

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.queue = exports.queueScheduler = void 0;
	var QueueAction_1 = __webpack_require__(2237);
	var QueueScheduler_1 = __webpack_require__(2238);
	exports.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	exports.queue = exports.queueScheduler;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=types.js.map

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TestTools = exports.Immediate = void 0;
	var nextHandle = 1;
	var resolved;
	var activeHandles = {};
	function findAndClearHandle(handle) {
	    if (handle in activeHandles) {
	        delete activeHandles[handle];
	        return true;
	    }
	    return false;
	}
	exports.Immediate = {
	    setImmediate: function (cb) {
	        var handle = nextHandle++;
	        activeHandles[handle] = true;
	        if (!resolved) {
	            resolved = Promise.resolve();
	        }
	        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
	        return handle;
	    },
	    clearImmediate: function (handle) {
	        findAndClearHandle(handle);
	    },
	};
	exports.TestTools = {
	    pending: function () {
	        return Object.keys(activeHandles).length;
	    }
	};
	//# sourceMappingURL=Immediate.js.map

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isObservable = void 0;
	var Observable_1 = __webpack_require__(28);
	var isFunction_1 = __webpack_require__(27);
	function isObservable(obj) {
	    return !!obj && (obj instanceof Observable_1.Observable || (isFunction_1.isFunction(obj.lift) && isFunction_1.isFunction(obj.subscribe)));
	}
	exports.isObservable = isObservable;
	//# sourceMappingURL=isObservable.js.map

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FLUSH = exports.CANCEL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = middleware;
	
	var _lodash = __webpack_require__(2250);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CANCEL = exports.CANCEL = 'redux-throttle/CANCEL';
	var FLUSH = exports.FLUSH = 'redux-throttle/FLUSH';
	
	function map(throttled, action, method) {
	  if (action.payload && action.payload.type) {
	    var _ret = function () {
	      var types = action.payload.type;
	      if (!Array.isArray(types)) {
	        types = [types];
	      }
	      Object.keys(throttled).filter(function (t) {
	        return types.includes(t);
	      }).forEach(function (t) {
	        return throttled[t][method]();
	      });
	      return {
	        v: void 0
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	  Object.keys(throttled).forEach(function (t) {
	    return throttled[t][method]();
	  });
	  return;
	}
	
	function middleware() {
	  var defaultWait = arguments.length <= 0 || arguments[0] === undefined ? 300 : arguments[0];
	  var defaultThrottleOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var throttled = {};
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (action.type === CANCEL) {
	          map(throttled, action, 'cancel');
	          return next(action);
	        }
	
	        if (action.type === FLUSH) {
	          map(throttled, action, 'flush');
	          return next(action);
	        }
	
	        var shouldThrottle = (action.meta || {}).throttle;
	
	        // check if we don't need to throttle the action
	        if (!shouldThrottle) {
	          return next(action);
	        }
	
	        if (throttled[action.type]) {
	          // if it's a action which was throttled already
	          return throttled[action.type](action);
	        }
	
	        var wait = defaultWait;
	        var options = defaultThrottleOption;
	
	        if (!isNaN(shouldThrottle) && shouldThrottle !== true) {
	          wait = shouldThrottle;
	        } else if ((typeof shouldThrottle === 'undefined' ? 'undefined' : _typeof(shouldThrottle)) === 'object') {
	          wait = shouldThrottle.wait || defaultWait;
	          options = _extends({}, defaultThrottleOption, shouldThrottle);
	        }
	
	        throttled[action.type] = (0, _lodash2.default)(next, wait, options);
	
	        return throttled[action.type](action);
	      };
	    };
	  };
	}

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var debounce = __webpack_require__(41);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide an options object to indicate whether
	 * `func` should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the throttled function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=true] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = throttle;


/***/ }),
/* 2251 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCacheKeyComparator = createCacheKeyComparator;
	exports.defaultEqualityCheck = void 0;
	exports.defaultMemoize = defaultMemoize;
	// Cache implementation based on Erik Rasmussen's `lru-memoize`:
	// https://github.com/erikras/lru-memoize
	var NOT_FOUND = 'NOT_FOUND';
	
	function createSingletonCache(equals) {
	  var entry;
	  return {
	    get: function get(key) {
	      if (entry && equals(entry.key, key)) {
	        return entry.value;
	      }
	
	      return NOT_FOUND;
	    },
	    put: function put(key, value) {
	      entry = {
	        key: key,
	        value: value
	      };
	    },
	    getEntries: function getEntries() {
	      return entry ? [entry] : [];
	    },
	    clear: function clear() {
	      entry = undefined;
	    }
	  };
	}
	
	function createLruCache(maxSize, equals) {
	  var entries = [];
	
	  function get(key) {
	    var cacheIndex = entries.findIndex(function (entry) {
	      return equals(key, entry.key);
	    }); // We found a cached entry
	
	    if (cacheIndex > -1) {
	      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
	
	      if (cacheIndex > 0) {
	        entries.splice(cacheIndex, 1);
	        entries.unshift(entry);
	      }
	
	      return entry.value;
	    } // No entry found in cache, return sentinel
	
	
	    return NOT_FOUND;
	  }
	
	  function put(key, value) {
	    if (get(key) === NOT_FOUND) {
	      // TODO Is unshift slow?
	      entries.unshift({
	        key: key,
	        value: value
	      });
	
	      if (entries.length > maxSize) {
	        entries.pop();
	      }
	    }
	  }
	
	  function getEntries() {
	    return entries;
	  }
	
	  function clear() {
	    entries = [];
	  }
	
	  return {
	    get: get,
	    put: put,
	    getEntries: getEntries,
	    clear: clear
	  };
	}
	
	var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
	  return a === b;
	};
	
	exports.defaultEqualityCheck = defaultEqualityCheck;
	
	function createCacheKeyComparator(equalityCheck) {
	  return function areArgumentsShallowlyEqual(prev, next) {
	    if (prev === null || next === null || prev.length !== next.length) {
	      return false;
	    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	
	
	    var length = prev.length;
	
	    for (var i = 0; i < length; i++) {
	      if (!equalityCheck(prev[i], next[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	}
	
	// defaultMemoize now supports a configurable cache size with LRU behavior,
	// and optional comparison of the result value with existing values
	function defaultMemoize(func, equalityCheckOrOptions) {
	  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
	    equalityCheck: equalityCheckOrOptions
	  };
	  var _providedOptions$equa = providedOptions.equalityCheck,
	      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
	      _providedOptions$maxS = providedOptions.maxSize,
	      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
	      resultEqualityCheck = providedOptions.resultEqualityCheck;
	  var comparator = createCacheKeyComparator(equalityCheck);
	  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
	
	  function memoized() {
	    var value = cache.get(arguments);
	
	    if (value === NOT_FOUND) {
	      // @ts-ignore
	      value = func.apply(null, arguments);
	
	      if (resultEqualityCheck) {
	        var entries = cache.getEntries();
	        var matchingEntry = entries.find(function (entry) {
	          return resultEqualityCheck(entry.value, value);
	        });
	
	        if (matchingEntry) {
	          value = matchingEntry.value;
	        }
	      }
	
	      cache.put(arguments, value);
	    }
	
	    return value;
	  }
	
	  memoized.clearCache = function () {
	    return cache.clear();
	  };
	
	  return memoized;
	}

/***/ }),
/* 2253 */
/***/ (function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2253);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	exports.Observable = Observable_1.Observable;
	var ConnectableObservable_1 = __webpack_require__(844);
	exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
	var groupBy_1 = __webpack_require__(854);
	exports.GroupedObservable = groupBy_1.GroupedObservable;
	var observable_1 = __webpack_require__(157);
	exports.observable = observable_1.observable;
	var Subject_1 = __webpack_require__(52);
	exports.Subject = Subject_1.Subject;
	var BehaviorSubject_1 = __webpack_require__(840);
	exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
	var ReplaySubject_1 = __webpack_require__(444);
	exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
	var AsyncSubject_1 = __webpack_require__(295);
	exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
	var asap_1 = __webpack_require__(859);
	exports.asap = asap_1.asap;
	exports.asapScheduler = asap_1.asapScheduler;
	var async_1 = __webpack_require__(58);
	exports.async = async_1.async;
	exports.asyncScheduler = async_1.asyncScheduler;
	var queue_1 = __webpack_require__(860);
	exports.queue = queue_1.queue;
	exports.queueScheduler = queue_1.queueScheduler;
	var animationFrame_1 = __webpack_require__(2363);
	exports.animationFrame = animationFrame_1.animationFrame;
	exports.animationFrameScheduler = animationFrame_1.animationFrameScheduler;
	var VirtualTimeScheduler_1 = __webpack_require__(2362);
	exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
	exports.VirtualAction = VirtualTimeScheduler_1.VirtualAction;
	var Scheduler_1 = __webpack_require__(842);
	exports.Scheduler = Scheduler_1.Scheduler;
	var Subscription_1 = __webpack_require__(45);
	exports.Subscription = Subscription_1.Subscription;
	var Subscriber_1 = __webpack_require__(14);
	exports.Subscriber = Subscriber_1.Subscriber;
	var Notification_1 = __webpack_require__(296);
	exports.Notification = Notification_1.Notification;
	exports.NotificationKind = Notification_1.NotificationKind;
	var pipe_1 = __webpack_require__(461);
	exports.pipe = pipe_1.pipe;
	var noop_1 = __webpack_require__(460);
	exports.noop = noop_1.noop;
	var identity_1 = __webpack_require__(139);
	exports.identity = identity_1.identity;
	var isObservable_1 = __webpack_require__(2367);
	exports.isObservable = isObservable_1.isObservable;
	var ArgumentOutOfRangeError_1 = __webpack_require__(208);
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	var EmptyError_1 = __webpack_require__(209);
	exports.EmptyError = EmptyError_1.EmptyError;
	var ObjectUnsubscribedError_1 = __webpack_require__(303);
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
	var UnsubscriptionError_1 = __webpack_require__(862);
	exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
	var TimeoutError_1 = __webpack_require__(861);
	exports.TimeoutError = TimeoutError_1.TimeoutError;
	var bindCallback_1 = __webpack_require__(2258);
	exports.bindCallback = bindCallback_1.bindCallback;
	var bindNodeCallback_1 = __webpack_require__(2259);
	exports.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
	var combineLatest_1 = __webpack_require__(445);
	exports.combineLatest = combineLatest_1.combineLatest;
	var concat_1 = __webpack_require__(298);
	exports.concat = concat_1.concat;
	var defer_1 = __webpack_require__(446);
	exports.defer = defer_1.defer;
	var empty_1 = __webpack_require__(88);
	exports.empty = empty_1.empty;
	var forkJoin_1 = __webpack_require__(2260);
	exports.forkJoin = forkJoin_1.forkJoin;
	var from_1 = __webpack_require__(89);
	exports.from = from_1.from;
	var fromEvent_1 = __webpack_require__(2261);
	exports.fromEvent = fromEvent_1.fromEvent;
	var fromEventPattern_1 = __webpack_require__(2262);
	exports.fromEventPattern = fromEventPattern_1.fromEventPattern;
	var generate_1 = __webpack_require__(2263);
	exports.generate = generate_1.generate;
	var iif_1 = __webpack_require__(2264);
	exports.iif = iif_1.iif;
	var interval_1 = __webpack_require__(2265);
	exports.interval = interval_1.interval;
	var merge_1 = __webpack_require__(845);
	exports.merge = merge_1.merge;
	var never_1 = __webpack_require__(846);
	exports.never = never_1.never;
	var of_1 = __webpack_require__(299);
	exports.of = of_1.of;
	var onErrorResumeNext_1 = __webpack_require__(2266);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	var pairs_1 = __webpack_require__(2267);
	exports.pairs = pairs_1.pairs;
	var partition_1 = __webpack_require__(2268);
	exports.partition = partition_1.partition;
	var race_1 = __webpack_require__(847);
	exports.race = race_1.race;
	var range_1 = __webpack_require__(2269);
	exports.range = range_1.range;
	var throwError_1 = __webpack_require__(447);
	exports.throwError = throwError_1.throwError;
	var timer_1 = __webpack_require__(848);
	exports.timer = timer_1.timer;
	var using_1 = __webpack_require__(2270);
	exports.using = using_1.using;
	var zip_1 = __webpack_require__(448);
	exports.zip = zip_1.zip;
	var scheduled_1 = __webpack_require__(858);
	exports.scheduled = scheduled_1.scheduled;
	var empty_2 = __webpack_require__(88);
	exports.EMPTY = empty_2.EMPTY;
	var never_2 = __webpack_require__(846);
	exports.NEVER = never_2.NEVER;
	var config_1 = __webpack_require__(297);
	exports.config = config_1.config;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.outerValue = outerValue;
	        _this.outerIndex = outerIndex;
	        _this.index = 0;
	        return _this;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var asap_1 = __webpack_require__(859);
	var isNumeric_1 = __webpack_require__(304);
	var SubscribeOnObservable = (function (_super) {
	    __extends(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) { delayTime = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.delayTime = delayTime;
	        _this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
	            _this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            _this.scheduler = asap_1.asap;
	        }
	        return _this;
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) { delay = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return this.add(source.subscribe(subscriber));
	    };
	    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable_1.Observable));
	exports.SubscribeOnObservable = SubscribeOnObservable;
	//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var AsyncSubject_1 = __webpack_require__(295);
	var map_1 = __webpack_require__(72);
	var canReportError_1 = __webpack_require__(457);
	var isArray_1 = __webpack_require__(59);
	var isScheduler_1 = __webpack_require__(90);
	function bindCallback(callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler_1.isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map_1.map(function (args) { return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	            };
	        }
	    }
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var context = this;
	        var subject;
	        var params = {
	            context: context,
	            subject: subject,
	            callbackFunc: callbackFunc,
	            scheduler: scheduler,
	        };
	        return new Observable_1.Observable(function (subscriber) {
	            if (!scheduler) {
	                if (!subject) {
	                    subject = new AsyncSubject_1.AsyncSubject();
	                    var handler = function () {
	                        var innerArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            innerArgs[_i] = arguments[_i];
	                        }
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    };
	                    try {
	                        callbackFunc.apply(context, args.concat([handler]));
	                    }
	                    catch (err) {
	                        if (canReportError_1.canReportError(subject)) {
	                            subject.error(err);
	                        }
	                        else {
	                            console.warn(err);
	                        }
	                    }
	                }
	                return subject.subscribe(subscriber);
	            }
	            else {
	                var state = {
	                    args: args, subscriber: subscriber, params: params,
	                };
	                return scheduler.schedule(dispatch, 0, state);
	            }
	        });
	    };
	}
	exports.bindCallback = bindCallback;
	function dispatch(state) {
	    var _this = this;
	    var self = this;
	    var args = state.args, subscriber = state.subscriber, params = state.params;
	    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
	    var subject = params.subject;
	    if (!subject) {
	        subject = params.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function () {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i] = arguments[_i];
	            }
	            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	        };
	        try {
	            callbackFunc.apply(context, args.concat([handler]));
	        }
	        catch (err) {
	            subject.error(err);
	        }
	    }
	    this.add(subject.subscribe(subscriber));
	}
	function dispatchNext(state) {
	    var value = state.value, subject = state.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(state) {
	    var err = state.err, subject = state.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var AsyncSubject_1 = __webpack_require__(295);
	var map_1 = __webpack_require__(72);
	var canReportError_1 = __webpack_require__(457);
	var isScheduler_1 = __webpack_require__(90);
	var isArray_1 = __webpack_require__(59);
	function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler_1.isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map_1.map(function (args) { return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	            };
	        }
	    }
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var params = {
	            subject: undefined,
	            args: args,
	            callbackFunc: callbackFunc,
	            scheduler: scheduler,
	            context: this,
	        };
	        return new Observable_1.Observable(function (subscriber) {
	            var context = params.context;
	            var subject = params.subject;
	            if (!scheduler) {
	                if (!subject) {
	                    subject = params.subject = new AsyncSubject_1.AsyncSubject();
	                    var handler = function () {
	                        var innerArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            innerArgs[_i] = arguments[_i];
	                        }
	                        var err = innerArgs.shift();
	                        if (err) {
	                            subject.error(err);
	                            return;
	                        }
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    };
	                    try {
	                        callbackFunc.apply(context, args.concat([handler]));
	                    }
	                    catch (err) {
	                        if (canReportError_1.canReportError(subject)) {
	                            subject.error(err);
	                        }
	                        else {
	                            console.warn(err);
	                        }
	                    }
	                }
	                return subject.subscribe(subscriber);
	            }
	            else {
	                return scheduler.schedule(dispatch, 0, { params: params, subscriber: subscriber, context: context });
	            }
	        });
	    };
	}
	exports.bindNodeCallback = bindNodeCallback;
	function dispatch(state) {
	    var _this = this;
	    var params = state.params, subscriber = state.subscriber, context = state.context;
	    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
	    var subject = params.subject;
	    if (!subject) {
	        subject = params.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function () {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i] = arguments[_i];
	            }
	            var err = innerArgs.shift();
	            if (err) {
	                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	            }
	            else {
	                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	            }
	        };
	        try {
	            callbackFunc.apply(context, args.concat([handler]));
	        }
	        catch (err) {
	            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	        }
	    }
	    this.add(subject.subscribe(subscriber));
	}
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var isArray_1 = __webpack_require__(59);
	var map_1 = __webpack_require__(72);
	var isObject_1 = __webpack_require__(459);
	var from_1 = __webpack_require__(89);
	function forkJoin() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    if (sources.length === 1) {
	        var first_1 = sources[0];
	        if (isArray_1.isArray(first_1)) {
	            return forkJoinInternal(first_1, null);
	        }
	        if (isObject_1.isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
	            var keys = Object.keys(first_1);
	            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
	        }
	    }
	    if (typeof sources[sources.length - 1] === 'function') {
	        var resultSelector_1 = sources.pop();
	        sources = (sources.length === 1 && isArray_1.isArray(sources[0])) ? sources[0] : sources;
	        return forkJoinInternal(sources, null).pipe(map_1.map(function (args) { return resultSelector_1.apply(void 0, args); }));
	    }
	    return forkJoinInternal(sources, null);
	}
	exports.forkJoin = forkJoin;
	function forkJoinInternal(sources, keys) {
	    return new Observable_1.Observable(function (subscriber) {
	        var len = sources.length;
	        if (len === 0) {
	            subscriber.complete();
	            return;
	        }
	        var values = new Array(len);
	        var completed = 0;
	        var emitted = 0;
	        var _loop_1 = function (i) {
	            var source = from_1.from(sources[i]);
	            var hasValue = false;
	            subscriber.add(source.subscribe({
	                next: function (value) {
	                    if (!hasValue) {
	                        hasValue = true;
	                        emitted++;
	                    }
	                    values[i] = value;
	                },
	                error: function (err) { return subscriber.error(err); },
	                complete: function () {
	                    completed++;
	                    if (completed === len || !hasValue) {
	                        if (emitted === len) {
	                            subscriber.next(keys ?
	                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
	                                values);
	                        }
	                        subscriber.complete();
	                    }
	                }
	            }));
	        };
	        for (var i = 0; i < len; i++) {
	            _loop_1(i);
	        }
	    });
	}
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var isArray_1 = __webpack_require__(59);
	var isFunction_1 = __webpack_require__(210);
	var map_1 = __webpack_require__(72);
	var toString = (function () { return Object.prototype.toString; })();
	function fromEvent(target, eventName, options, resultSelector) {
	    if (isFunction_1.isFunction(options)) {
	        resultSelector = options;
	        options = undefined;
	    }
	    if (resultSelector) {
	        return fromEvent(target, eventName, options).pipe(map_1.map(function (args) { return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        function handler(e) {
	            if (arguments.length > 1) {
	                subscriber.next(Array.prototype.slice.call(arguments));
	            }
	            else {
	                subscriber.next(e);
	            }
	        }
	        setupSubscription(target, eventName, handler, subscriber, options);
	    });
	}
	exports.fromEvent = fromEvent;
	function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
	    var unsubscribe;
	    if (isEventTarget(sourceObj)) {
	        var source_1 = sourceObj;
	        sourceObj.addEventListener(eventName, handler, options);
	        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
	    }
	    else if (isJQueryStyleEventEmitter(sourceObj)) {
	        var source_2 = sourceObj;
	        sourceObj.on(eventName, handler);
	        unsubscribe = function () { return source_2.off(eventName, handler); };
	    }
	    else if (isNodeStyleEventEmitter(sourceObj)) {
	        var source_3 = sourceObj;
	        sourceObj.addListener(eventName, handler);
	        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	    }
	    else if (sourceObj && sourceObj.length) {
	        for (var i = 0, len = sourceObj.length; i < len; i++) {
	            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	        }
	    }
	    else {
	        throw new TypeError('Invalid event target');
	    }
	    subscriber.add(unsubscribe);
	}
	function isNodeStyleEventEmitter(sourceObj) {
	    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isEventTarget(sourceObj) {
	    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var isArray_1 = __webpack_require__(59);
	var isFunction_1 = __webpack_require__(210);
	var map_1 = __webpack_require__(72);
	function fromEventPattern(addHandler, removeHandler, resultSelector) {
	    if (resultSelector) {
	        return fromEventPattern(addHandler, removeHandler).pipe(map_1.map(function (args) { return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var handler = function () {
	            var e = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                e[_i] = arguments[_i];
	            }
	            return subscriber.next(e.length === 1 ? e[0] : e);
	        };
	        var retValue;
	        try {
	            retValue = addHandler(handler);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        if (!isFunction_1.isFunction(removeHandler)) {
	            return undefined;
	        }
	        return function () { return removeHandler(handler, retValue); };
	    });
	}
	exports.fromEventPattern = fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var identity_1 = __webpack_require__(139);
	var isScheduler_1 = __webpack_require__(90);
	function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	    var resultSelector;
	    var initialState;
	    if (arguments.length == 1) {
	        var options = initialStateOrOptions;
	        initialState = options.initialState;
	        condition = options.condition;
	        iterate = options.iterate;
	        resultSelector = options.resultSelector || identity_1.identity;
	        scheduler = options.scheduler;
	    }
	    else if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
	        initialState = initialStateOrOptions;
	        resultSelector = identity_1.identity;
	        scheduler = resultSelectorOrObservable;
	    }
	    else {
	        initialState = initialStateOrOptions;
	        resultSelector = resultSelectorOrObservable;
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var state = initialState;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                subscriber: subscriber,
	                iterate: iterate,
	                condition: condition,
	                resultSelector: resultSelector,
	                state: state
	            });
	        }
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return undefined;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return undefined;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return undefined;
	            }
	        } while (true);
	        return undefined;
	    });
	}
	exports.generate = generate;
	function dispatch(state) {
	    var subscriber = state.subscriber, condition = state.condition;
	    if (subscriber.closed) {
	        return undefined;
	    }
	    if (state.needIterate) {
	        try {
	            state.state = state.iterate(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	    }
	    else {
	        state.needIterate = true;
	    }
	    if (condition) {
	        var conditionResult = void 0;
	        try {
	            conditionResult = condition(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        if (!conditionResult) {
	            subscriber.complete();
	            return undefined;
	        }
	        if (subscriber.closed) {
	            return undefined;
	        }
	    }
	    var value;
	    try {
	        value = state.resultSelector(state.state);
	    }
	    catch (err) {
	        subscriber.error(err);
	        return undefined;
	    }
	    if (subscriber.closed) {
	        return undefined;
	    }
	    subscriber.next(value);
	    if (subscriber.closed) {
	        return undefined;
	    }
	    return this.schedule(state);
	}
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var defer_1 = __webpack_require__(446);
	var empty_1 = __webpack_require__(88);
	function iif(condition, trueResult, falseResult) {
	    if (trueResult === void 0) { trueResult = empty_1.EMPTY; }
	    if (falseResult === void 0) { falseResult = empty_1.EMPTY; }
	    return defer_1.defer(function () { return condition() ? trueResult : falseResult; });
	}
	exports.iif = iif;
	//# sourceMappingURL=iif.js.map

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var async_1 = __webpack_require__(58);
	var isNumeric_1 = __webpack_require__(304);
	function interval(period, scheduler) {
	    if (period === void 0) { period = 0; }
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (!isNumeric_1.isNumeric(period) || period < 0) {
	        period = 0;
	    }
	    if (!scheduler || typeof scheduler.schedule !== 'function') {
	        scheduler = async_1.async;
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        subscriber.add(scheduler.schedule(dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
	        return subscriber;
	    });
	}
	exports.interval = interval;
	function dispatch(state) {
	    var subscriber = state.subscriber, counter = state.counter, period = state.period;
	    subscriber.next(counter);
	    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
	}
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var from_1 = __webpack_require__(89);
	var isArray_1 = __webpack_require__(59);
	var empty_1 = __webpack_require__(88);
	function onErrorResumeNext() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    if (sources.length === 0) {
	        return empty_1.EMPTY;
	    }
	    var first = sources[0], remainder = sources.slice(1);
	    if (sources.length === 1 && isArray_1.isArray(first)) {
	        return onErrorResumeNext.apply(void 0, first);
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
	        return from_1.from(first).subscribe({
	            next: function (value) { subscriber.next(value); },
	            error: subNext,
	            complete: subNext,
	        });
	    });
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscription_1 = __webpack_require__(45);
	function pairs(obj, scheduler) {
	    if (!scheduler) {
	        return new Observable_1.Observable(function (subscriber) {
	            var keys = Object.keys(obj);
	            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
	                var key = keys[i];
	                if (obj.hasOwnProperty(key)) {
	                    subscriber.next([key, obj[key]]);
	                }
	            }
	            subscriber.complete();
	        });
	    }
	    else {
	        return new Observable_1.Observable(function (subscriber) {
	            var keys = Object.keys(obj);
	            var subscription = new Subscription_1.Subscription();
	            subscription.add(scheduler.schedule(dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
	            return subscription;
	        });
	    }
	}
	exports.pairs = pairs;
	function dispatch(state) {
	    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
	    if (!subscriber.closed) {
	        if (index < keys.length) {
	            var key = keys[index];
	            subscriber.next([key, obj[key]]);
	            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
	        }
	        else {
	            subscriber.complete();
	        }
	    }
	}
	exports.dispatch = dispatch;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var not_1 = __webpack_require__(866);
	var subscribeTo_1 = __webpack_require__(305);
	var filter_1 = __webpack_require__(155);
	var Observable_1 = __webpack_require__(24);
	function partition(source, predicate, thisArg) {
	    return [
	        filter_1.filter(predicate, thisArg)(new Observable_1.Observable(subscribeTo_1.subscribeTo(source))),
	        filter_1.filter(not_1.not(predicate, thisArg))(new Observable_1.Observable(subscribeTo_1.subscribeTo(source)))
	    ];
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	function range(start, count, scheduler) {
	    if (start === void 0) { start = 0; }
	    return new Observable_1.Observable(function (subscriber) {
	        if (count === undefined) {
	            count = start;
	            start = 0;
	        }
	        var index = 0;
	        var current = start;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(current++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	        return undefined;
	    });
	}
	exports.range = range;
	function dispatch(state) {
	    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	    if (index >= count) {
	        subscriber.complete();
	        return;
	    }
	    subscriber.next(start);
	    if (subscriber.closed) {
	        return;
	    }
	    state.index = index + 1;
	    state.start = start + 1;
	    this.schedule(state);
	}
	exports.dispatch = dispatch;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var from_1 = __webpack_require__(89);
	var empty_1 = __webpack_require__(88);
	function using(resourceFactory, observableFactory) {
	    return new Observable_1.Observable(function (subscriber) {
	        var resource;
	        try {
	            resource = resourceFactory();
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var result;
	        try {
	            result = observableFactory(resource);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var source = result ? from_1.from(result) : empty_1.EMPTY;
	        var subscription = source.subscribe(subscriber);
	        return function () {
	            subscription.unsubscribe();
	            if (resource) {
	                resource.unsubscribe();
	            }
	        };
	    });
	}
	exports.using = using;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var audit_1 = __webpack_require__(849);
	var timer_1 = __webpack_require__(848);
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function buffer(closingNotifier) {
	    return function bufferOperatorFunction(source) {
	        return source.lift(new BufferOperator(closingNotifier));
	    };
	}
	exports.buffer = buffer;
	var BufferOperator = (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	var BufferSubscriber = (function (_super) {
	    __extends(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        var _this = _super.call(this, destination) || this;
	        _this.buffer = [];
	        _this.add(innerSubscribe_1.innerSubscribe(closingNotifier, new innerSubscribe_1.SimpleInnerSubscriber(_this)));
	        return _this;
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function () {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return function bufferCountOperatorFunction(source) {
	        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	    };
	}
	exports.bufferCount = bufferCount;
	var BufferCountOperator = (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        if (!startBufferEvery || bufferSize === startBufferEvery) {
	            this.subscriberClass = BufferCountSubscriber;
	        }
	        else {
	            this.subscriberClass = BufferSkipCountSubscriber;
	        }
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	var BufferCountSubscriber = (function (_super) {
	    __extends(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferSize = bufferSize;
	        _this.buffer = [];
	        return _this;
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var buffer = this.buffer;
	        buffer.push(value);
	        if (buffer.length == this.bufferSize) {
	            this.destination.next(buffer);
	            this.buffer = [];
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer.length > 0) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber_1.Subscriber));
	var BufferSkipCountSubscriber = (function (_super) {
	    __extends(BufferSkipCountSubscriber, _super);
	    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferSize = bufferSize;
	        _this.startBufferEvery = startBufferEvery;
	        _this.buffers = [];
	        _this.count = 0;
	        return _this;
	    }
	    BufferSkipCountSubscriber.prototype._next = function (value) {
	        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
	        this.count++;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = buffers.length; i--;) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                buffers.splice(i, 1);
	                this.destination.next(buffer);
	            }
	        }
	    };
	    BufferSkipCountSubscriber.prototype._complete = function () {
	        var _a = this, buffers = _a.buffers, destination = _a.destination;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferSkipCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var Subscriber_1 = __webpack_require__(14);
	var isScheduler_1 = __webpack_require__(90);
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return function bufferTimeOperatorFunction(source) {
	        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	    };
	}
	exports.bufferTime = bufferTime;
	var BufferTimeOperator = (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	var BufferTimeSubscriber = (function (_super) {
	    __extends(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferTimeSpan = bufferTimeSpan;
	        _this.bufferCreationInterval = bufferCreationInterval;
	        _this.maxBufferSize = maxBufferSize;
	        _this.scheduler = scheduler;
	        _this.contexts = [];
	        var context = _this.openContext();
	        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (_this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
	            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: _this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
	            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	        return _this;
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context_1 = contexts[i];
	            var buffer = context_1.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context_1;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context_2 = contexts.shift();
	            destination.next(context_2.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (!this.closed && this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscription_1 = __webpack_require__(45);
	var subscribeToResult_1 = __webpack_require__(140);
	var OuterSubscriber_1 = __webpack_require__(138);
	function bufferToggle(openings, closingSelector) {
	    return function bufferToggleOperatorFunction(source) {
	        return source.lift(new BufferToggleOperator(openings, closingSelector));
	    };
	}
	exports.bufferToggle = bufferToggle;
	var BufferToggleOperator = (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	var BufferToggleSubscriber = (function (_super) {
	    __extends(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.closingSelector = closingSelector;
	        _this.contexts = [];
	        _this.add(subscribeToResult_1.subscribeToResult(_this, openings));
	        return _this;
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context_1 = contexts.shift();
	            context_1.subscription.unsubscribe();
	            context_1.buffer = null;
	            context_1.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context_2 = contexts.shift();
	            this.destination.next(context_2.buffer);
	            context_2.subscription.unsubscribe();
	            context_2.buffer = null;
	            context_2.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription_1.Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscription_1 = __webpack_require__(45);
	var innerSubscribe_1 = __webpack_require__(31);
	function bufferWhen(closingSelector) {
	    return function (source) {
	        return source.lift(new BufferWhenOperator(closingSelector));
	    };
	}
	exports.bufferWhen = bufferWhen;
	var BufferWhenOperator = (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	var BufferWhenSubscriber = (function (_super) {
	    __extends(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.closingSelector = closingSelector;
	        _this.subscribing = false;
	        _this.openBuffer();
	        return _this;
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = undefined;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function () {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier;
	        try {
	            var closingSelector = this.closingSelector;
	            closingNotifier = closingSelector();
	        }
	        catch (err) {
	            return this.error(err);
	        }
	        closingSubscription = new Subscription_1.Subscription();
	        this.closingSubscription = closingSubscription;
	        this.add(closingSubscription);
	        this.subscribing = true;
	        closingSubscription.add(innerSubscribe_1.innerSubscribe(closingNotifier, new innerSubscribe_1.SimpleInnerSubscriber(this)));
	        this.subscribing = false;
	    };
	    return BufferWhenSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function catchError(selector) {
	    return function catchErrorOperatorFunction(source) {
	        var operator = new CatchOperator(selector);
	        var caught = source.lift(operator);
	        return (operator.caught = caught);
	    };
	}
	exports.catchError = catchError;
	var CatchOperator = (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	var CatchSubscriber = (function (_super) {
	    __extends(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        var _this = _super.call(this, destination) || this;
	        _this.selector = selector;
	        _this.caught = caught;
	        return _this;
	    }
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err2) {
	                _super.prototype.error.call(this, err2);
	                return;
	            }
	            this._unsubscribeAndRecycle();
	            var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	            this.add(innerSubscriber);
	            var innerSubscription = innerSubscribe_1.innerSubscribe(result, innerSubscriber);
	            if (innerSubscription !== innerSubscriber) {
	                this.add(innerSubscription);
	            }
	        }
	    };
	    return CatchSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=catchError.js.map

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var combineLatest_1 = __webpack_require__(445);
	function combineAll(project) {
	    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isArray_1 = __webpack_require__(59);
	var combineLatest_1 = __webpack_require__(445);
	var from_1 = __webpack_require__(89);
	var none = {};
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0].slice();
	    }
	    return function (source) { return source.lift.call(from_1.from([source].concat(observables)), new combineLatest_1.CombineLatestOperator(project)); };
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var concat_1 = __webpack_require__(298);
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var concatMap_1 = __webpack_require__(851);
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function count(predicate) {
	    return function (source) { return source.lift(new CountOperator(predicate, source)); };
	}
	exports.count = count;
	var CountOperator = (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	var CountSubscriber = (function (_super) {
	    __extends(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.count = 0;
	        _this.index = 0;
	        return _this;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=count.js.map

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function debounce(durationSelector) {
	    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
	}
	exports.debounce = debounce;
	var DebounceOperator = (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	var DebounceSubscriber = (function (_super) {
	    __extends(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.durationSelector = durationSelector;
	        _this.hasValue = false;
	        return _this;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = innerSubscribe_1.innerSubscribe(duration, new innerSubscribe_1.SimpleInnerSubscriber(this));
	        if (subscription && !subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = undefined;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = undefined;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var async_1 = __webpack_require__(58);
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.dueTime = dueTime;
	        _this.scheduler = scheduler;
	        _this.debouncedSubscription = null;
	        _this.lastValue = null;
	        _this.hasValue = false;
	        return _this;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            var lastValue = this.lastValue;
	            this.lastValue = null;
	            this.hasValue = false;
	            this.destination.next(lastValue);
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var isDate_1 = __webpack_require__(864);
	var Subscriber_1 = __webpack_require__(14);
	var Notification_1 = __webpack_require__(296);
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteDelay = isDate_1.isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
	}
	exports.delay = delay;
	var DelayOperator = (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	var DelaySubscriber = (function (_super) {
	    __extends(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.delay = delay;
	        _this.scheduler = scheduler;
	        _this.queue = [];
	        _this.active = false;
	        _this.errored = false;
	        return _this;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            this.unsubscribe();
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        var destination = this.destination;
	        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification_1.Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification_1.Notification.createComplete());
	        this.unsubscribe();
	    };
	    return DelaySubscriber;
	}(Subscriber_1.Subscriber));
	var DelayMessage = (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Observable_1 = __webpack_require__(24);
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return new SubscriptionDelayObservable(source, subscriptionDelay)
	                .lift(new DelayWhenOperator(delayDurationSelector));
	        };
	    }
	    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
	}
	exports.delayWhen = delayWhen;
	var DelayWhenOperator = (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	var DelayWhenSubscriber = (function (_super) {
	    __extends(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.delayDurationSelector = delayDurationSelector;
	        _this.completed = false;
	        _this.delayNotifierSubscriptions = [];
	        _this.index = 0;
	        return _this;
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        try {
	            var delayNotifier = this.delayDurationSelector(value, index);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	        this.unsubscribe();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        if (subscriptionIdx !== -1) {
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	        }
	        return subscription.outerValue;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
	        if (notifierSubscription && !notifierSubscription.closed) {
	            var destination = this.destination;
	            destination.add(notifierSubscription);
	            this.delayNotifierSubscriptions.push(notifierSubscription);
	        }
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	var SubscriptionDelayObservable = (function (_super) {
	    __extends(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(source, subscriptionDelay) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subscriptionDelay = subscriptionDelay;
	        return _this;
	    }
	    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable_1.Observable));
	var SubscriptionDelaySubscriber = (function (_super) {
	    __extends(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.source = source;
	        _this.sourceSubscribed = false;
	        return _this;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.unsubscribe();
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function dematerialize() {
	    return function dematerializeOperatorFunction(source) {
	        return source.lift(new DeMaterializeOperator());
	    };
	}
	exports.dematerialize = dematerialize;
	var DeMaterializeOperator = (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	var DeMaterializeSubscriber = (function (_super) {
	    __extends(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function distinct(keySelector, flushes) {
	    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
	}
	exports.distinct = distinct;
	var DistinctOperator = (function () {
	    function DistinctOperator(keySelector, flushes) {
	        this.keySelector = keySelector;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
	    };
	    return DistinctOperator;
	}());
	var DistinctSubscriber = (function (_super) {
	    __extends(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, keySelector, flushes) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.values = new Set();
	        if (flushes) {
	            _this.add(innerSubscribe_1.innerSubscribe(flushes, new innerSubscribe_1.SimpleInnerSubscriber(_this)));
	        }
	        return _this;
	    }
	    DistinctSubscriber.prototype.notifyNext = function () {
	        this.values.clear();
	    };
	    DistinctSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        if (this.keySelector) {
	            this._useKeySelector(value);
	        }
	        else {
	            this._finalizeNext(value, value);
	        }
	    };
	    DistinctSubscriber.prototype._useKeySelector = function (value) {
	        var key;
	        var destination = this.destination;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this._finalizeNext(key, value);
	    };
	    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
	        var values = this.values;
	        if (!values.has(key)) {
	            values.add(key);
	            this.destination.next(value);
	        }
	    };
	    return DistinctSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	exports.DistinctSubscriber = DistinctSubscriber;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var distinctUntilChanged_1 = __webpack_require__(852);
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ArgumentOutOfRangeError_1 = __webpack_require__(208);
	var filter_1 = __webpack_require__(155);
	var throwIfEmpty_1 = __webpack_require__(302);
	var defaultIfEmpty_1 = __webpack_require__(204);
	var take_1 = __webpack_require__(453);
	function elementAt(index, defaultValue) {
	    if (index < 0) {
	        throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
	    }
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) { return source.pipe(filter_1.filter(function (v, i) { return i === index; }), take_1.take(1), hasDefaultValue
	        ? defaultIfEmpty_1.defaultIfEmpty(defaultValue)
	        : throwIfEmpty_1.throwIfEmpty(function () { return new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError(); })); };
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var concat_1 = __webpack_require__(298);
	var of_1 = __webpack_require__(299);
	function endWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i] = arguments[_i];
	    }
	    return function (source) { return concat_1.concat(source, of_1.of.apply(void 0, array)); };
	}
	exports.endWith = endWith;
	//# sourceMappingURL=endWith.js.map

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function every(predicate, thisArg) {
	    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
	}
	exports.every = every;
	var EveryOperator = (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	var EverySubscriber = (function (_super) {
	    __extends(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.thisArg = thisArg;
	        _this.source = source;
	        _this.index = 0;
	        _this.thisArg = thisArg || _this;
	        return _this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=every.js.map

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function exhaust() {
	    return function (source) { return source.lift(new SwitchFirstOperator()); };
	}
	exports.exhaust = exhaust;
	var SwitchFirstOperator = (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	var SwitchFirstSubscriber = (function (_super) {
	    __extends(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasCompleted = false;
	        _this.hasSubscription = false;
	        return _this;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(innerSubscribe_1.innerSubscribe(value, new innerSubscribe_1.SimpleInnerSubscriber(this)));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function () {
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var map_1 = __webpack_require__(72);
	var from_1 = __webpack_require__(89);
	var innerSubscribe_1 = __webpack_require__(31);
	function exhaustMap(project, resultSelector) {
	    if (resultSelector) {
	        return function (source) { return source.pipe(exhaustMap(function (a, i) { return from_1.from(project(a, i)).pipe(map_1.map(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
	    }
	    return function (source) {
	        return source.lift(new ExhaustMapOperator(project));
	    };
	}
	exports.exhaustMap = exhaustMap;
	var ExhaustMapOperator = (function () {
	    function ExhaustMapOperator(project) {
	        this.project = project;
	    }
	    ExhaustMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
	    };
	    return ExhaustMapOperator;
	}());
	var ExhaustMapSubscriber = (function (_super) {
	    __extends(ExhaustMapSubscriber, _super);
	    function ExhaustMapSubscriber(destination, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.hasSubscription = false;
	        _this.hasCompleted = false;
	        _this.index = 0;
	        return _this;
	    }
	    ExhaustMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    ExhaustMapSubscriber.prototype.tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.hasSubscription = true;
	        this._innerSub(result);
	    };
	    ExhaustMapSubscriber.prototype._innerSub = function (result) {
	        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe_1.innerSubscribe(result, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    ExhaustMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    ExhaustMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    ExhaustMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    ExhaustMapSubscriber.prototype.notifyComplete = function () {
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return ExhaustMapSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
	}
	exports.expand = expand;
	var ExpandOperator = (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	exports.ExpandOperator = ExpandOperator;
	var ExpandSubscriber = (function (_super) {
	    __extends(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.concurrent = concurrent;
	        _this.scheduler = scheduler;
	        _this.index = 0;
	        _this.active = 0;
	        _this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            _this.buffer = [];
	        }
	        return _this;
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            try {
	                var project = this.project;
	                var result = project(value, index);
	                if (!this.scheduler) {
	                    this.subscribeToProjection(result, value, index);
	                }
	                else {
	                    var state = { subscriber: this, result: result, value: value, index: index };
	                    var destination_1 = this.destination;
	                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	                }
	            }
	            catch (e) {
	                destination.error(e);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        var destination = this.destination;
	        destination.add(innerSubscribe_1.innerSubscribe(result, new innerSubscribe_1.SimpleInnerSubscriber(this)));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    ExpandSubscriber.prototype.notifyNext = function (innerValue) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	exports.ExpandSubscriber = ExpandSubscriber;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Subscription_1 = __webpack_require__(45);
	function finalize(callback) {
	    return function (source) { return source.lift(new FinallyOperator(callback)); };
	}
	exports.finalize = finalize;
	var FinallyOperator = (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	var FinallySubscriber = (function (_super) {
	    __extends(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        var _this = _super.call(this, destination) || this;
	        _this.add(new Subscription_1.Subscription(callback));
	        return _this;
	    }
	    return FinallySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=finalize.js.map

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var find_1 = __webpack_require__(853);
	function findIndex(predicate, thisArg) {
	    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmptyError_1 = __webpack_require__(209);
	var filter_1 = __webpack_require__(155);
	var take_1 = __webpack_require__(453);
	var defaultIfEmpty_1 = __webpack_require__(204);
	var throwIfEmpty_1 = __webpack_require__(302);
	var identity_1 = __webpack_require__(139);
	function first(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) { return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, take_1.take(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); })); };
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function ignoreElements() {
	    return function ignoreElementsOperatorFunction(source) {
	        return source.lift(new IgnoreElementsOperator());
	    };
	}
	exports.ignoreElements = ignoreElements;
	var IgnoreElementsOperator = (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	var IgnoreElementsSubscriber = (function (_super) {
	    __extends(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function isEmpty() {
	    return function (source) { return source.lift(new IsEmptyOperator()); };
	}
	exports.isEmpty = isEmpty;
	var IsEmptyOperator = (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	var IsEmptySubscriber = (function (_super) {
	    __extends(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmptyError_1 = __webpack_require__(209);
	var filter_1 = __webpack_require__(155);
	var takeLast_1 = __webpack_require__(454);
	var throwIfEmpty_1 = __webpack_require__(302);
	var defaultIfEmpty_1 = __webpack_require__(204);
	var identity_1 = __webpack_require__(139);
	function last(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) { return source.pipe(predicate ? filter_1.filter(function (v, i) { return predicate(v, i, source); }) : identity_1.identity, takeLast_1.takeLast(1), hasDefaultValue ? defaultIfEmpty_1.defaultIfEmpty(defaultValue) : throwIfEmpty_1.throwIfEmpty(function () { return new EmptyError_1.EmptyError(); })); };
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function mapTo(value) {
	    return function (source) { return source.lift(new MapToOperator(value)); };
	}
	exports.mapTo = mapTo;
	var MapToOperator = (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	var MapToSubscriber = (function (_super) {
	    __extends(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        var _this = _super.call(this, destination) || this;
	        _this.value = value;
	        return _this;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Notification_1 = __webpack_require__(296);
	function materialize() {
	    return function materializeOperatorFunction(source) {
	        return source.lift(new MaterializeOperator());
	    };
	}
	exports.materialize = materialize;
	var MaterializeOperator = (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	var MaterializeSubscriber = (function (_super) {
	    __extends(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification_1.Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var reduce_1 = __webpack_require__(301);
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
	        : function (x, y) { return x > y ? x : y; };
	    return reduce_1.reduce(max);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var merge_1 = __webpack_require__(845);
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mergeMap_1 = __webpack_require__(300);
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'function') {
	        return mergeMap_1.mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
	    }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return mergeMap_1.mergeMap(function () { return innerObservable; }, concurrent);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
	}
	exports.mergeScan = mergeScan;
	var MergeScanOperator = (function () {
	    function MergeScanOperator(accumulator, seed, concurrent) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	exports.MergeScanOperator = MergeScanOperator;
	var MergeScanSubscriber = (function (_super) {
	    __extends(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
	        var _this = _super.call(this, destination) || this;
	        _this.accumulator = accumulator;
	        _this.acc = acc;
	        _this.concurrent = concurrent;
	        _this.hasValue = false;
	        _this.hasCompleted = false;
	        _this.buffer = [];
	        _this.active = 0;
	        _this.index = 0;
	        return _this;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var destination = this.destination;
	            var ish = void 0;
	            try {
	                var accumulator = this.accumulator;
	                ish = accumulator(this.acc, value, index);
	            }
	            catch (e) {
	                return destination.error(e);
	            }
	            this.active++;
	            this._innerSub(ish);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish) {
	        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe_1.innerSubscribe(ish, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (innerValue) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	exports.MergeScanSubscriber = MergeScanSubscriber;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var reduce_1 = __webpack_require__(301);
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
	        : function (x, y) { return x < y ? x : y; };
	    return reduce_1.reduce(min);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var from_1 = __webpack_require__(89);
	var isArray_1 = __webpack_require__(59);
	var innerSubscribe_1 = __webpack_require__(31);
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	function onErrorResumeNextStatic() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i] = arguments[_i];
	    }
	    var source = undefined;
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    source = nextSources.shift();
	    return from_1.from(source).lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
	var OnErrorResumeNextOperator = (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = (function (_super) {
	    __extends(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.nextSources = nextSources;
	        return _this;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	        this.unsubscribe();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	        this.unsubscribe();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (!!next) {
	            var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
	            var destination = this.destination;
	            destination.add(innerSubscriber);
	            var innerSubscription = innerSubscribe_1.innerSubscribe(next, innerSubscriber);
	            if (innerSubscription !== innerSubscriber) {
	                destination.add(innerSubscription);
	            }
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function pairwise() {
	    return function (source) { return source.lift(new PairwiseOperator()); };
	}
	exports.pairwise = pairwise;
	var PairwiseOperator = (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	var PairwiseSubscriber = (function (_super) {
	    __extends(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasPrev = false;
	        return _this;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        var pair;
	        if (this.hasPrev) {
	            pair = [this.prev, value];
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	        if (pair) {
	            this.destination.next(pair);
	        }
	    };
	    return PairwiseSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var not_1 = __webpack_require__(866);
	var filter_1 = __webpack_require__(155);
	function partition(predicate, thisArg) {
	    return function (source) { return [
	        filter_1.filter(predicate, thisArg)(source),
	        filter_1.filter(not_1.not(predicate, thisArg))(source)
	    ]; };
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var map_1 = __webpack_require__(72);
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return function (source) { return map_1.map(plucker(properties, length))(source); };
	}
	exports.pluck = pluck;
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp != null ? currentProp[props[i]] : undefined;
	            if (p !== void 0) {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var multicast_1 = __webpack_require__(156);
	function publish(selector) {
	    return selector ?
	        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
	        multicast_1.multicast(new Subject_1.Subject());
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BehaviorSubject_1 = __webpack_require__(840);
	var multicast_1 = __webpack_require__(156);
	function publishBehavior(value) {
	    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncSubject_1 = __webpack_require__(295);
	var multicast_1 = __webpack_require__(156);
	function publishLast() {
	    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReplaySubject_1 = __webpack_require__(444);
	var multicast_1 = __webpack_require__(156);
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
	        scheduler = selectorOrScheduler;
	    }
	    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
	    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isArray_1 = __webpack_require__(59);
	var race_1 = __webpack_require__(847);
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function raceOperatorFunction(source) {
	        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var empty_1 = __webpack_require__(88);
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) {
	        if (count === 0) {
	            return empty_1.empty();
	        }
	        else if (count < 0) {
	            return source.lift(new RepeatOperator(-1, source));
	        }
	        else {
	            return source.lift(new RepeatOperator(count - 1, source));
	        }
	    };
	}
	exports.repeat = repeat;
	var RepeatOperator = (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	var RepeatSubscriber = (function (_super) {
	    __extends(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.count = count;
	        _this.source = source;
	        return _this;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var innerSubscribe_1 = __webpack_require__(31);
	function repeatWhen(notifier) {
	    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
	}
	exports.repeatWhen = repeatWhen;
	var RepeatWhenOperator = (function () {
	    function RepeatWhenOperator(notifier) {
	        this.notifier = notifier;
	    }
	    RepeatWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
	    };
	    return RepeatWhenOperator;
	}());
	var RepeatWhenSubscriber = (function (_super) {
	    __extends(RepeatWhenSubscriber, _super);
	    function RepeatWhenSubscriber(destination, notifier, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.notifier = notifier;
	        _this.source = source;
	        _this.sourceIsBeingSubscribedTo = true;
	        return _this;
	    }
	    RepeatWhenSubscriber.prototype.notifyNext = function () {
	        this.sourceIsBeingSubscribedTo = true;
	        this.source.subscribe(this);
	    };
	    RepeatWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.sourceIsBeingSubscribedTo === false) {
	            return _super.prototype.complete.call(this);
	        }
	    };
	    RepeatWhenSubscriber.prototype.complete = function () {
	        this.sourceIsBeingSubscribedTo = false;
	        if (!this.isStopped) {
	            if (!this.retries) {
	                this.subscribeToRetries();
	            }
	            if (!this.retriesSubscription || this.retriesSubscription.closed) {
	                return _super.prototype.complete.call(this);
	            }
	            this._unsubscribeAndRecycle();
	            this.notifications.next(undefined);
	        }
	    };
	    RepeatWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
	        if (notifications) {
	            notifications.unsubscribe();
	            this.notifications = undefined;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = undefined;
	        }
	        this.retries = undefined;
	    };
	    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
	        var _unsubscribe = this._unsubscribe;
	        this._unsubscribe = null;
	        _super.prototype._unsubscribeAndRecycle.call(this);
	        this._unsubscribe = _unsubscribe;
	        return this;
	    };
	    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
	        this.notifications = new Subject_1.Subject();
	        var retries;
	        try {
	            var notifier = this.notifier;
	            retries = notifier(this.notifications);
	        }
	        catch (e) {
	            return _super.prototype.complete.call(this);
	        }
	        this.retries = retries;
	        this.retriesSubscription = innerSubscribe_1.innerSubscribe(retries, new innerSubscribe_1.SimpleInnerSubscriber(this));
	    };
	    return RepeatWhenSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) { return source.lift(new RetryOperator(count, source)); };
	}
	exports.retry = retry;
	var RetryOperator = (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	var RetrySubscriber = (function (_super) {
	    __extends(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.count = count;
	        _this.source = source;
	        return _this;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var innerSubscribe_1 = __webpack_require__(31);
	function retryWhen(notifier) {
	    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
	}
	exports.retryWhen = retryWhen;
	var RetryWhenOperator = (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	var RetryWhenSubscriber = (function (_super) {
	    __extends(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.notifier = notifier;
	        _this.source = source;
	        return _this;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject_1.Subject();
	                try {
	                    var notifier = this.notifier;
	                    retries = notifier(errors);
	                }
	                catch (e) {
	                    return _super.prototype.error.call(this, e);
	                }
	                retriesSubscription = innerSubscribe_1.innerSubscribe(retries, new innerSubscribe_1.SimpleInnerSubscriber(this));
	            }
	            else {
	                this.errors = undefined;
	                this.retriesSubscription = undefined;
	            }
	            this._unsubscribeAndRecycle();
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = undefined;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = undefined;
	        }
	        this.retries = undefined;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function () {
	        var _unsubscribe = this._unsubscribe;
	        this._unsubscribe = null;
	        this._unsubscribeAndRecycle();
	        this._unsubscribe = _unsubscribe;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function sample(notifier) {
	    return function (source) { return source.lift(new SampleOperator(notifier)); };
	}
	exports.sample = sample;
	var SampleOperator = (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        var sampleSubscriber = new SampleSubscriber(subscriber);
	        var subscription = source.subscribe(sampleSubscriber);
	        subscription.add(innerSubscribe_1.innerSubscribe(this.notifier, new innerSubscribe_1.SimpleInnerSubscriber(sampleSubscriber)));
	        return subscription;
	    };
	    return SampleOperator;
	}());
	var SampleSubscriber = (function (_super) {
	    __extends(SampleSubscriber, _super);
	    function SampleSubscriber() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.hasValue = false;
	        return _this;
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var async_1 = __webpack_require__(58);
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
	}
	exports.sampleTime = sampleTime;
	var SampleTimeOperator = (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	var SampleTimeSubscriber = (function (_super) {
	    __extends(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.period = period;
	        _this.scheduler = scheduler;
	        _this.hasValue = false;
	        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
	        return _this;
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function sequenceEqual(compareTo, comparator) {
	    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
	}
	exports.sequenceEqual = sequenceEqual;
	var SequenceEqualOperator = (function () {
	    function SequenceEqualOperator(compareTo, comparator) {
	        this.compareTo = compareTo;
	        this.comparator = comparator;
	    }
	    SequenceEqualOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
	    };
	    return SequenceEqualOperator;
	}());
	exports.SequenceEqualOperator = SequenceEqualOperator;
	var SequenceEqualSubscriber = (function (_super) {
	    __extends(SequenceEqualSubscriber, _super);
	    function SequenceEqualSubscriber(destination, compareTo, comparator) {
	        var _this = _super.call(this, destination) || this;
	        _this.compareTo = compareTo;
	        _this.comparator = comparator;
	        _this._a = [];
	        _this._b = [];
	        _this._oneComplete = false;
	        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
	        return _this;
	    }
	    SequenceEqualSubscriber.prototype._next = function (value) {
	        if (this._oneComplete && this._b.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._a.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype._complete = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	        this.unsubscribe();
	    };
	    SequenceEqualSubscriber.prototype.checkValues = function () {
	        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
	        while (_a.length > 0 && _b.length > 0) {
	            var a = _a.shift();
	            var b = _b.shift();
	            var areEqual = false;
	            try {
	                areEqual = comparator ? comparator(a, b) : a === b;
	            }
	            catch (e) {
	                this.destination.error(e);
	            }
	            if (!areEqual) {
	                this.emit(false);
	            }
	        }
	    };
	    SequenceEqualSubscriber.prototype.emit = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    SequenceEqualSubscriber.prototype.nextB = function (value) {
	        if (this._oneComplete && this._a.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._b.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype.completeB = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	    };
	    return SequenceEqualSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
	var SequenceEqualCompareToSubscriber = (function (_super) {
	    __extends(SequenceEqualCompareToSubscriber, _super);
	    function SequenceEqualCompareToSubscriber(destination, parent) {
	        var _this = _super.call(this, destination) || this;
	        _this.parent = parent;
	        return _this;
	    }
	    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
	        this.parent.nextB(value);
	    };
	    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
	        this.parent.error(err);
	        this.unsubscribe();
	    };
	    SequenceEqualCompareToSubscriber.prototype._complete = function () {
	        this.parent.completeB();
	        this.unsubscribe();
	    };
	    return SequenceEqualCompareToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var multicast_1 = __webpack_require__(156);
	var refCount_1 = __webpack_require__(450);
	var Subject_1 = __webpack_require__(52);
	function shareSubjectFactory() {
	    return new Subject_1.Subject();
	}
	function share() {
	    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
	}
	exports.share = share;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReplaySubject_1 = __webpack_require__(444);
	function shareReplay(configOrBufferSize, windowTime, scheduler) {
	    var config;
	    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
	        config = configOrBufferSize;
	    }
	    else {
	        config = {
	            bufferSize: configOrBufferSize,
	            windowTime: windowTime,
	            refCount: false,
	            scheduler: scheduler,
	        };
	    }
	    return function (source) { return source.lift(shareReplayOperator(config)); };
	}
	exports.shareReplay = shareReplay;
	function shareReplayOperator(_a) {
	    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
	    var subject;
	    var refCount = 0;
	    var subscription;
	    var hasError = false;
	    var isComplete = false;
	    return function shareReplayOperation(source) {
	        refCount++;
	        var innerSub;
	        if (!subject || hasError) {
	            hasError = false;
	            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	            innerSub = subject.subscribe(this);
	            subscription = source.subscribe({
	                next: function (value) {
	                    subject.next(value);
	                },
	                error: function (err) {
	                    hasError = true;
	                    subject.error(err);
	                },
	                complete: function () {
	                    isComplete = true;
	                    subscription = undefined;
	                    subject.complete();
	                },
	            });
	            if (isComplete) {
	                subscription = undefined;
	            }
	        }
	        else {
	            innerSub = subject.subscribe(this);
	        }
	        this.add(function () {
	            refCount--;
	            innerSub.unsubscribe();
	            innerSub = undefined;
	            if (subscription && !isComplete && useRefCount && refCount === 0) {
	                subscription.unsubscribe();
	                subscription = undefined;
	                subject = undefined;
	            }
	        });
	    };
	}
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var EmptyError_1 = __webpack_require__(209);
	function single(predicate) {
	    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
	}
	exports.single = single;
	var SingleOperator = (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	var SingleSubscriber = (function (_super) {
	    __extends(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.seenValue = false;
	        _this.index = 0;
	        return _this;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this.tryNext(value, index);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value, index) {
	        try {
	            if (this.predicate(value, index, this.source)) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=single.js.map

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function skip(count) {
	    return function (source) { return source.lift(new SkipOperator(count)); };
	}
	exports.skip = skip;
	var SkipOperator = (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	var SkipSubscriber = (function (_super) {
	    __extends(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.count = 0;
	        return _this;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var ArgumentOutOfRangeError_1 = __webpack_require__(208);
	function skipLast(count) {
	    return function (source) { return source.lift(new SkipLastOperator(count)); };
	}
	exports.skipLast = skipLast;
	var SkipLastOperator = (function () {
	    function SkipLastOperator(_skipCount) {
	        this._skipCount = _skipCount;
	        if (this._skipCount < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    SkipLastOperator.prototype.call = function (subscriber, source) {
	        if (this._skipCount === 0) {
	            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
	        }
	        else {
	            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
	        }
	    };
	    return SkipLastOperator;
	}());
	var SkipLastSubscriber = (function (_super) {
	    __extends(SkipLastSubscriber, _super);
	    function SkipLastSubscriber(destination, _skipCount) {
	        var _this = _super.call(this, destination) || this;
	        _this._skipCount = _skipCount;
	        _this._count = 0;
	        _this._ring = new Array(_skipCount);
	        return _this;
	    }
	    SkipLastSubscriber.prototype._next = function (value) {
	        var skipCount = this._skipCount;
	        var count = this._count++;
	        if (count < skipCount) {
	            this._ring[count] = value;
	        }
	        else {
	            var currentIndex = count % skipCount;
	            var ring = this._ring;
	            var oldValue = ring[currentIndex];
	            ring[currentIndex] = value;
	            this.destination.next(oldValue);
	        }
	    };
	    return SkipLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function skipUntil(notifier) {
	    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
	}
	exports.skipUntil = skipUntil;
	var SkipUntilOperator = (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (destination, source) {
	        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	var SkipUntilSubscriber = (function (_super) {
	    __extends(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasValue = false;
	        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(_this);
	        _this.add(innerSubscriber);
	        _this.innerSubscription = innerSubscriber;
	        var innerSubscription = innerSubscribe_1.innerSubscribe(notifier, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            _this.add(innerSubscription);
	            _this.innerSubscription = innerSubscription;
	        }
	        return _this;
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function () {
	        this.hasValue = true;
	        if (this.innerSubscription) {
	            this.innerSubscription.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	    };
	    return SkipUntilSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function skipWhile(predicate) {
	    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
	}
	exports.skipWhile = skipWhile;
	var SkipWhileOperator = (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	var SkipWhileSubscriber = (function (_super) {
	    __extends(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.skipping = true;
	        _this.index = 0;
	        return _this;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var concat_1 = __webpack_require__(298);
	var isScheduler_1 = __webpack_require__(90);
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i] = arguments[_i];
	    }
	    var scheduler = array[array.length - 1];
	    if (isScheduler_1.isScheduler(scheduler)) {
	        array.pop();
	        return function (source) { return concat_1.concat(array, source, scheduler); };
	    }
	    else {
	        return function (source) { return concat_1.concat(array, source); };
	    }
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SubscribeOnObservable_1 = __webpack_require__(2257);
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function subscribeOnOperatorFunction(source) {
	        return source.lift(new SubscribeOnOperator(scheduler, delay));
	    };
	}
	exports.subscribeOn = subscribeOn;
	var SubscribeOnOperator = (function () {
	    function SubscribeOnOperator(scheduler, delay) {
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    SubscribeOnOperator.prototype.call = function (subscriber, source) {
	        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
	    };
	    return SubscribeOnOperator;
	}());
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var switchMap_1 = __webpack_require__(452);
	var identity_1 = __webpack_require__(139);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var switchMap_1 = __webpack_require__(452);
	function switchMapTo(innerObservable, resultSelector) {
	    return resultSelector ? switchMap_1.switchMap(function () { return innerObservable; }, resultSelector) : switchMap_1.switchMap(function () { return innerObservable; });
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var innerSubscribe_1 = __webpack_require__(31);
	function takeUntil(notifier) {
	    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
	}
	exports.takeUntil = takeUntil;
	var TakeUntilOperator = (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
	        var notifierSubscription = innerSubscribe_1.innerSubscribe(this.notifier, new innerSubscribe_1.SimpleInnerSubscriber(takeUntilSubscriber));
	        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
	            takeUntilSubscriber.add(notifierSubscription);
	            return source.subscribe(takeUntilSubscriber);
	        }
	        return takeUntilSubscriber;
	    };
	    return TakeUntilOperator;
	}());
	var TakeUntilSubscriber = (function (_super) {
	    __extends(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.seenValue = false;
	        return _this;
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function () {
	        this.seenValue = true;
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	    };
	    return TakeUntilSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	function takeWhile(predicate, inclusive) {
	    if (inclusive === void 0) { inclusive = false; }
	    return function (source) {
	        return source.lift(new TakeWhileOperator(predicate, inclusive));
	    };
	}
	exports.takeWhile = takeWhile;
	var TakeWhileOperator = (function () {
	    function TakeWhileOperator(predicate, inclusive) {
	        this.predicate = predicate;
	        this.inclusive = inclusive;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
	    };
	    return TakeWhileOperator;
	}());
	var TakeWhileSubscriber = (function (_super) {
	    __extends(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate, inclusive) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.inclusive = inclusive;
	        _this.index = 0;
	        return _this;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            if (this.inclusive) {
	                destination.next(value);
	            }
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var noop_1 = __webpack_require__(460);
	var isFunction_1 = __webpack_require__(210);
	function tap(nextOrObserver, error, complete) {
	    return function tapOperatorFunction(source) {
	        return source.lift(new DoOperator(nextOrObserver, error, complete));
	    };
	}
	exports.tap = tap;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	var TapSubscriber = (function (_super) {
	    __extends(TapSubscriber, _super);
	    function TapSubscriber(destination, observerOrNext, error, complete) {
	        var _this = _super.call(this, destination) || this;
	        _this._tapNext = noop_1.noop;
	        _this._tapError = noop_1.noop;
	        _this._tapComplete = noop_1.noop;
	        _this._tapError = error || noop_1.noop;
	        _this._tapComplete = complete || noop_1.noop;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            _this._context = _this;
	            _this._tapNext = observerOrNext;
	        }
	        else if (observerOrNext) {
	            _this._context = observerOrNext;
	            _this._tapNext = observerOrNext.next || noop_1.noop;
	            _this._tapError = observerOrNext.error || noop_1.noop;
	            _this._tapComplete = observerOrNext.complete || noop_1.noop;
	        }
	        return _this;
	    }
	    TapSubscriber.prototype._next = function (value) {
	        try {
	            this._tapNext.call(this._context, value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(value);
	    };
	    TapSubscriber.prototype._error = function (err) {
	        try {
	            this._tapError.call(this._context, err);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.error(err);
	    };
	    TapSubscriber.prototype._complete = function () {
	        try {
	            this._tapComplete.call(this._context);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        return this.destination.complete();
	    };
	    return TapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=tap.js.map

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var async_1 = __webpack_require__(58);
	var throttle_1 = __webpack_require__(856);
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
	}
	exports.throttleTime = throttleTime;
	var ThrottleTimeOperator = (function () {
	    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
	    };
	    return ThrottleTimeOperator;
	}());
	var ThrottleTimeSubscriber = (function (_super) {
	    __extends(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
	        var _this = _super.call(this, destination) || this;
	        _this.duration = duration;
	        _this.scheduler = scheduler;
	        _this.leading = leading;
	        _this.trailing = trailing;
	        _this._hasTrailingValue = false;
	        _this._trailingValue = null;
	        return _this;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	        else {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            if (this.leading) {
	                this.destination.next(value);
	            }
	            else if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	    };
	    ThrottleTimeSubscriber.prototype._complete = function () {
	        if (this._hasTrailingValue) {
	            this.destination.next(this._trailingValue);
	            this.destination.complete();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            if (this.trailing && this._hasTrailingValue) {
	                this.destination.next(this._trailingValue);
	                this._trailingValue = null;
	                this._hasTrailingValue = false;
	            }
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var scan_1 = __webpack_require__(451);
	var defer_1 = __webpack_require__(446);
	var map_1 = __webpack_require__(72);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return defer_1.defer(function () {
	        return source.pipe(scan_1.scan(function (_a, value) {
	            var current = _a.current;
	            return ({ value: value, current: scheduler.now(), last: current });
	        }, { current: scheduler.now(), value: undefined, last: undefined }), map_1.map(function (_a) {
	            var current = _a.current, last = _a.last, value = _a.value;
	            return new TimeInterval(value, current - last);
	        }));
	    }); };
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var TimeoutError_1 = __webpack_require__(861);
	var timeoutWith_1 = __webpack_require__(857);
	var throwError_1 = __webpack_require__(447);
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeoutWith_1.timeoutWith(due, throwError_1.throwError(new TimeoutError_1.TimeoutError()), scheduler);
	}
	exports.timeout = timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var async_1 = __webpack_require__(58);
	var map_1 = __webpack_require__(72);
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
	}
	exports.timestamp = timestamp;
	var Timestamp = (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var reduce_1 = __webpack_require__(301);
	function toArrayReducer(arr, item, index) {
	    if (index === 0) {
	        return [item];
	    }
	    arr.push(item);
	    return arr;
	}
	function toArray() {
	    return reduce_1.reduce(toArrayReducer, []);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var innerSubscribe_1 = __webpack_require__(31);
	function window(windowBoundaries) {
	    return function windowOperatorFunction(source) {
	        return source.lift(new WindowOperator(windowBoundaries));
	    };
	}
	exports.window = window;
	var WindowOperator = (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber(subscriber);
	        var sourceSubscription = source.subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(innerSubscribe_1.innerSubscribe(this.windowBoundaries, new innerSubscribe_1.SimpleInnerSubscriber(windowSubscriber)));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.window = new Subject_1.Subject();
	        destination.next(_this.window);
	        return _this;
	    }
	    WindowSubscriber.prototype.notifyNext = function () {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function () {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject_1.Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(innerSubscribe_1.SimpleOuterSubscriber));
	//# sourceMappingURL=window.js.map

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var Subject_1 = __webpack_require__(52);
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return function windowCountOperatorFunction(source) {
	        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
	    };
	}
	exports.windowCount = windowCount;
	var WindowCountOperator = (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	var WindowCountSubscriber = (function (_super) {
	    __extends(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.windowSize = windowSize;
	        _this.startWindowEvery = startWindowEvery;
	        _this.windows = [new Subject_1.Subject()];
	        _this.count = 0;
	        destination.next(_this.windows[0]);
	        return _this;
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject_1.Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var async_1 = __webpack_require__(58);
	var Subscriber_1 = __webpack_require__(14);
	var isNumeric_1 = __webpack_require__(304);
	var isScheduler_1 = __webpack_require__(90);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = Number(arguments[2]);
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = Number(arguments[1]);
	    }
	    return function windowTimeOperatorFunction(source) {
	        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
	    };
	}
	exports.windowTime = windowTime;
	var WindowTimeOperator = (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	var CountedSubject = (function (_super) {
	    __extends(CountedSubject, _super);
	    function CountedSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._numberOfNextedValues = 0;
	        return _this;
	    }
	    CountedSubject.prototype.next = function (value) {
	        this._numberOfNextedValues++;
	        _super.prototype.next.call(this, value);
	    };
	    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
	        get: function () {
	            return this._numberOfNextedValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CountedSubject;
	}(Subject_1.Subject));
	var WindowTimeSubscriber = (function (_super) {
	    __extends(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.windowTimeSpan = windowTimeSpan;
	        _this.windowCreationInterval = windowCreationInterval;
	        _this.maxWindowSize = maxWindowSize;
	        _this.scheduler = scheduler;
	        _this.windows = [];
	        var window = _this.openWindow();
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var closeState = { subscriber: _this, window: window, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
	            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
	            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	        return _this;
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_1 = windows[i];
	            if (!window_1.closed) {
	                window_1.next(value);
	                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
	                    this.closeWindow(window_1);
	                }
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_2 = windows.shift();
	            if (!window_2.closed) {
	                window_2.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new CountedSubject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        subscriber.closeWindow(window);
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(state) {
	    var subscriber = state.subscriber, window = state.window, context = state.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var Subscription_1 = __webpack_require__(45);
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	function windowToggle(openings, closingSelector) {
	    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
	}
	exports.windowToggle = windowToggle;
	var WindowToggleOperator = (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	var WindowToggleSubscriber = (function (_super) {
	    __extends(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.openings = openings;
	        _this.closingSelector = closingSelector;
	        _this.contexts = [];
	        _this.add(_this.openSubscription = subscribeToResult_1.subscribeToResult(_this, openings, openings));
	        return _this;
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_1 = contexts[index];
	                context_1.window.error(err);
	                context_1.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_2 = contexts[index];
	                context_2.window.complete();
	                context_2.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_3 = contexts[index];
	                context_3.window.unsubscribe();
	                context_3.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingNotifier = void 0;
	            try {
	                var closingSelector = this.closingSelector;
	                closingNotifier = closingSelector(innerValue);
	            }
	            catch (e) {
	                return this.error(e);
	            }
	            var window_1 = new Subject_1.Subject();
	            var subscription = new Subscription_1.Subscription();
	            var context_4 = { window: window_1, subscription: subscription };
	            this.contexts.push(context_4);
	            var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context_4);
	            if (innerSubscription.closed) {
	                this.closeWindow(this.contexts.length - 1);
	            }
	            else {
	                innerSubscription.context = context_4;
	                subscription.add(innerSubscription);
	            }
	            this.destination.next(window_1);
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subject_1 = __webpack_require__(52);
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	function windowWhen(closingSelector) {
	    return function windowWhenOperatorFunction(source) {
	        return source.lift(new WindowOperator(closingSelector));
	    };
	}
	exports.windowWhen = windowWhen;
	var WindowOperator = (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.closingSelector = closingSelector;
	        _this.openWindow();
	        return _this;
	    }
	    WindowSubscriber.prototype.notifyNext = function (_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) { innerSub = null; }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject_1.Subject();
	        this.destination.next(window);
	        var closingNotifier;
	        try {
	            var closingSelector = this.closingSelector;
	            closingNotifier = closingSelector();
	        }
	        catch (e) {
	            this.destination.error(e);
	            this.window.error(e);
	            return;
	        }
	        this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var OuterSubscriber_1 = __webpack_require__(138);
	var subscribeToResult_1 = __webpack_require__(140);
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return function (source) {
	        var project;
	        if (typeof args[args.length - 1] === 'function') {
	            project = args.pop();
	        }
	        var observables = args;
	        return source.lift(new WithLatestFromOperator(observables, project));
	    };
	}
	exports.withLatestFrom = withLatestFrom;
	var WithLatestFromOperator = (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	var WithLatestFromSubscriber = (function (_super) {
	    __extends(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.observables = observables;
	        _this.project = project;
	        _this.toRespond = [];
	        var len = observables.length;
	        _this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            _this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            _this.add(subscribeToResult_1.subscribeToResult(_this, observable, undefined, i));
	        }
	        return _this;
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var zip_1 = __webpack_require__(448);
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function zipOperatorFunction(source) {
	        return source.lift.call(zip_1.zip.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.zip = zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var zip_1 = __webpack_require__(448);
	function zipAll(project) {
	    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscription_1 = __webpack_require__(45);
	var iterator_1 = __webpack_require__(207);
	function scheduleIterable(input, scheduler) {
	    if (!input) {
	        throw new Error('Iterable cannot be null');
	    }
	    return new Observable_1.Observable(function (subscriber) {
	        var sub = new Subscription_1.Subscription();
	        var iterator;
	        sub.add(function () {
	            if (iterator && typeof iterator.return === 'function') {
	                iterator.return();
	            }
	        });
	        sub.add(scheduler.schedule(function () {
	            iterator = input[iterator_1.iterator]();
	            sub.add(scheduler.schedule(function () {
	                if (subscriber.closed) {
	                    return;
	                }
	                var value;
	                var done;
	                try {
	                    var result = iterator.next();
	                    value = result.value;
	                    done = result.done;
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (done) {
	                    subscriber.complete();
	                }
	                else {
	                    subscriber.next(value);
	                    this.schedule();
	                }
	            }));
	        }));
	        return sub;
	    });
	}
	exports.scheduleIterable = scheduleIterable;
	//# sourceMappingURL=scheduleIterable.js.map

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscription_1 = __webpack_require__(45);
	var observable_1 = __webpack_require__(157);
	function scheduleObservable(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var sub = new Subscription_1.Subscription();
	        sub.add(scheduler.schedule(function () {
	            var observable = input[observable_1.observable]();
	            sub.add(observable.subscribe({
	                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
	                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
	                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
	            }));
	        }));
	        return sub;
	    });
	}
	exports.scheduleObservable = scheduleObservable;
	//# sourceMappingURL=scheduleObservable.js.map

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	var Subscription_1 = __webpack_require__(45);
	function schedulePromise(input, scheduler) {
	    return new Observable_1.Observable(function (subscriber) {
	        var sub = new Subscription_1.Subscription();
	        sub.add(scheduler.schedule(function () { return input.then(function (value) {
	            sub.add(scheduler.schedule(function () {
	                subscriber.next(value);
	                sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
	            }));
	        }, function (err) {
	            sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
	        }); }));
	        return sub;
	    });
	}
	exports.schedulePromise = schedulePromise;
	//# sourceMappingURL=schedulePromise.js.map

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscription_1 = __webpack_require__(45);
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        return _super.call(this) || this;
	    }
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncAction_1 = __webpack_require__(205);
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (scheduler.actions.length === 0) {
	            cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncScheduler_1 = __webpack_require__(206);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Immediate_1 = __webpack_require__(2364);
	var AsyncAction_1 = __webpack_require__(205);
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (scheduler.actions.length === 0) {
	            Immediate_1.Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncScheduler_1 = __webpack_require__(206);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncAction_1 = __webpack_require__(205);
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncScheduler_1 = __webpack_require__(206);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var AsyncAction_1 = __webpack_require__(205);
	var AsyncScheduler_1 = __webpack_require__(206);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
	        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
	        _this.maxFrames = maxFrames;
	        _this.frame = 0;
	        _this.index = -1;
	        return _this;
	    }
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions[0]) && action.delay <= maxFrames) {
	            actions.shift();
	            this.frame = action.delay;
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = scheduler.index += 1; }
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.index = index;
	        _this.active = true;
	        _this.index = scheduler.index = index;
	        return _this;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (!this.id) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.active = false;
	        var action = new VirtualAction(this.scheduler, this.work);
	        this.add(action);
	        return action.schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AnimationFrameAction_1 = __webpack_require__(2356);
	var AnimationFrameScheduler_1 = __webpack_require__(2357);
	exports.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	exports.animationFrame = exports.animationFrameScheduler;
	//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 2364 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var nextHandle = 1;
	var RESOLVED = (function () { return Promise.resolve(); })();
	var activeHandles = {};
	function findAndClearHandle(handle) {
	    if (handle in activeHandles) {
	        delete activeHandles[handle];
	        return true;
	    }
	    return false;
	}
	exports.Immediate = {
	    setImmediate: function (cb) {
	        var handle = nextHandle++;
	        activeHandles[handle] = true;
	        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
	        return handle;
	    },
	    clearImmediate: function (handle) {
	        findAndClearHandle(handle);
	    },
	};
	exports.TestTools = {
	    pending: function () {
	        return Object.keys(activeHandles).length;
	    }
	};
	//# sourceMappingURL=Immediate.js.map

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var observable_1 = __webpack_require__(157);
	function isInteropObservable(input) {
	    return input && typeof input[observable_1.observable] === 'function';
	}
	exports.isInteropObservable = isInteropObservable;
	//# sourceMappingURL=isInteropObservable.js.map

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var iterator_1 = __webpack_require__(207);
	function isIterable(input) {
	    return input && typeof input[iterator_1.iterator] === 'function';
	}
	exports.isIterable = isIterable;
	//# sourceMappingURL=isIterable.js.map

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(24);
	function isObservable(obj) {
	    return !!obj && (obj instanceof Observable_1.Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
	}
	exports.isObservable = isObservable;
	//# sourceMappingURL=isObservable.js.map

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var iterator_1 = __webpack_require__(207);
	exports.subscribeToIterable = function (iterable) { return function (subscriber) {
	    var iterator = iterable[iterator_1.iterator]();
	    do {
	        var item = void 0;
	        try {
	            item = iterator.next();
	        }
	        catch (err) {
	            subscriber.error(err);
	            return subscriber;
	        }
	        if (item.done) {
	            subscriber.complete();
	            break;
	        }
	        subscriber.next(item.value);
	        if (subscriber.closed) {
	            break;
	        }
	    } while (true);
	    if (typeof iterator.return === 'function') {
	        subscriber.add(function () {
	            if (iterator.return) {
	                iterator.return();
	            }
	        });
	    }
	    return subscriber;
	}; };
	//# sourceMappingURL=subscribeToIterable.js.map

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var observable_1 = __webpack_require__(157);
	exports.subscribeToObservable = function (obj) { return function (subscriber) {
	    var obs = obj[observable_1.observable]();
	    if (typeof obs.subscribe !== 'function') {
	        throw new TypeError('Provided object does not correctly implement Symbol.observable');
	    }
	    else {
	        return obs.subscribe(subscriber);
	    }
	}; };
	//# sourceMappingURL=subscribeToObservable.js.map

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hostReportError_1 = __webpack_require__(458);
	exports.subscribeToPromise = function (promise) { return function (subscriber) {
	    promise.then(function (value) {
	        if (!subscriber.closed) {
	            subscriber.next(value);
	            subscriber.complete();
	        }
	    }, function (err) { return subscriber.error(err); })
	        .then(null, hostReportError_1.hostReportError);
	    return subscriber;
	}; };
	//# sourceMappingURL=subscribeToPromise.js.map

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Subscriber_1 = __webpack_require__(14);
	var rxSubscriber_1 = __webpack_require__(456);
	var Observer_1 = __webpack_require__(841);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var audit_1 = __webpack_require__(849);
	exports.audit = audit_1.audit;
	var auditTime_1 = __webpack_require__(2271);
	exports.auditTime = auditTime_1.auditTime;
	var buffer_1 = __webpack_require__(2272);
	exports.buffer = buffer_1.buffer;
	var bufferCount_1 = __webpack_require__(2273);
	exports.bufferCount = bufferCount_1.bufferCount;
	var bufferTime_1 = __webpack_require__(2274);
	exports.bufferTime = bufferTime_1.bufferTime;
	var bufferToggle_1 = __webpack_require__(2275);
	exports.bufferToggle = bufferToggle_1.bufferToggle;
	var bufferWhen_1 = __webpack_require__(2276);
	exports.bufferWhen = bufferWhen_1.bufferWhen;
	var catchError_1 = __webpack_require__(2277);
	exports.catchError = catchError_1.catchError;
	var combineAll_1 = __webpack_require__(2278);
	exports.combineAll = combineAll_1.combineAll;
	var combineLatest_1 = __webpack_require__(2279);
	exports.combineLatest = combineLatest_1.combineLatest;
	var concat_1 = __webpack_require__(2280);
	exports.concat = concat_1.concat;
	var concatAll_1 = __webpack_require__(850);
	exports.concatAll = concatAll_1.concatAll;
	var concatMap_1 = __webpack_require__(851);
	exports.concatMap = concatMap_1.concatMap;
	var concatMapTo_1 = __webpack_require__(2281);
	exports.concatMapTo = concatMapTo_1.concatMapTo;
	var count_1 = __webpack_require__(2282);
	exports.count = count_1.count;
	var debounce_1 = __webpack_require__(2283);
	exports.debounce = debounce_1.debounce;
	var debounceTime_1 = __webpack_require__(2284);
	exports.debounceTime = debounceTime_1.debounceTime;
	var defaultIfEmpty_1 = __webpack_require__(204);
	exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	var delay_1 = __webpack_require__(2285);
	exports.delay = delay_1.delay;
	var delayWhen_1 = __webpack_require__(2286);
	exports.delayWhen = delayWhen_1.delayWhen;
	var dematerialize_1 = __webpack_require__(2287);
	exports.dematerialize = dematerialize_1.dematerialize;
	var distinct_1 = __webpack_require__(2288);
	exports.distinct = distinct_1.distinct;
	var distinctUntilChanged_1 = __webpack_require__(852);
	exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	var distinctUntilKeyChanged_1 = __webpack_require__(2289);
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	var elementAt_1 = __webpack_require__(2290);
	exports.elementAt = elementAt_1.elementAt;
	var endWith_1 = __webpack_require__(2291);
	exports.endWith = endWith_1.endWith;
	var every_1 = __webpack_require__(2292);
	exports.every = every_1.every;
	var exhaust_1 = __webpack_require__(2293);
	exports.exhaust = exhaust_1.exhaust;
	var exhaustMap_1 = __webpack_require__(2294);
	exports.exhaustMap = exhaustMap_1.exhaustMap;
	var expand_1 = __webpack_require__(2295);
	exports.expand = expand_1.expand;
	var filter_1 = __webpack_require__(155);
	exports.filter = filter_1.filter;
	var finalize_1 = __webpack_require__(2296);
	exports.finalize = finalize_1.finalize;
	var find_1 = __webpack_require__(853);
	exports.find = find_1.find;
	var findIndex_1 = __webpack_require__(2297);
	exports.findIndex = findIndex_1.findIndex;
	var first_1 = __webpack_require__(2298);
	exports.first = first_1.first;
	var groupBy_1 = __webpack_require__(854);
	exports.groupBy = groupBy_1.groupBy;
	var ignoreElements_1 = __webpack_require__(2299);
	exports.ignoreElements = ignoreElements_1.ignoreElements;
	var isEmpty_1 = __webpack_require__(2300);
	exports.isEmpty = isEmpty_1.isEmpty;
	var last_1 = __webpack_require__(2301);
	exports.last = last_1.last;
	var map_1 = __webpack_require__(72);
	exports.map = map_1.map;
	var mapTo_1 = __webpack_require__(2302);
	exports.mapTo = mapTo_1.mapTo;
	var materialize_1 = __webpack_require__(2303);
	exports.materialize = materialize_1.materialize;
	var max_1 = __webpack_require__(2304);
	exports.max = max_1.max;
	var merge_1 = __webpack_require__(2305);
	exports.merge = merge_1.merge;
	var mergeAll_1 = __webpack_require__(449);
	exports.mergeAll = mergeAll_1.mergeAll;
	var mergeMap_1 = __webpack_require__(300);
	exports.mergeMap = mergeMap_1.mergeMap;
	exports.flatMap = mergeMap_1.flatMap;
	var mergeMapTo_1 = __webpack_require__(2306);
	exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
	var mergeScan_1 = __webpack_require__(2307);
	exports.mergeScan = mergeScan_1.mergeScan;
	var min_1 = __webpack_require__(2308);
	exports.min = min_1.min;
	var multicast_1 = __webpack_require__(156);
	exports.multicast = multicast_1.multicast;
	var observeOn_1 = __webpack_require__(855);
	exports.observeOn = observeOn_1.observeOn;
	var onErrorResumeNext_1 = __webpack_require__(2309);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	var pairwise_1 = __webpack_require__(2310);
	exports.pairwise = pairwise_1.pairwise;
	var partition_1 = __webpack_require__(2311);
	exports.partition = partition_1.partition;
	var pluck_1 = __webpack_require__(2312);
	exports.pluck = pluck_1.pluck;
	var publish_1 = __webpack_require__(2313);
	exports.publish = publish_1.publish;
	var publishBehavior_1 = __webpack_require__(2314);
	exports.publishBehavior = publishBehavior_1.publishBehavior;
	var publishLast_1 = __webpack_require__(2315);
	exports.publishLast = publishLast_1.publishLast;
	var publishReplay_1 = __webpack_require__(2316);
	exports.publishReplay = publishReplay_1.publishReplay;
	var race_1 = __webpack_require__(2317);
	exports.race = race_1.race;
	var reduce_1 = __webpack_require__(301);
	exports.reduce = reduce_1.reduce;
	var repeat_1 = __webpack_require__(2318);
	exports.repeat = repeat_1.repeat;
	var repeatWhen_1 = __webpack_require__(2319);
	exports.repeatWhen = repeatWhen_1.repeatWhen;
	var retry_1 = __webpack_require__(2320);
	exports.retry = retry_1.retry;
	var retryWhen_1 = __webpack_require__(2321);
	exports.retryWhen = retryWhen_1.retryWhen;
	var refCount_1 = __webpack_require__(450);
	exports.refCount = refCount_1.refCount;
	var sample_1 = __webpack_require__(2322);
	exports.sample = sample_1.sample;
	var sampleTime_1 = __webpack_require__(2323);
	exports.sampleTime = sampleTime_1.sampleTime;
	var scan_1 = __webpack_require__(451);
	exports.scan = scan_1.scan;
	var sequenceEqual_1 = __webpack_require__(2324);
	exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
	var share_1 = __webpack_require__(2325);
	exports.share = share_1.share;
	var shareReplay_1 = __webpack_require__(2326);
	exports.shareReplay = shareReplay_1.shareReplay;
	var single_1 = __webpack_require__(2327);
	exports.single = single_1.single;
	var skip_1 = __webpack_require__(2328);
	exports.skip = skip_1.skip;
	var skipLast_1 = __webpack_require__(2329);
	exports.skipLast = skipLast_1.skipLast;
	var skipUntil_1 = __webpack_require__(2330);
	exports.skipUntil = skipUntil_1.skipUntil;
	var skipWhile_1 = __webpack_require__(2331);
	exports.skipWhile = skipWhile_1.skipWhile;
	var startWith_1 = __webpack_require__(2332);
	exports.startWith = startWith_1.startWith;
	var subscribeOn_1 = __webpack_require__(2333);
	exports.subscribeOn = subscribeOn_1.subscribeOn;
	var switchAll_1 = __webpack_require__(2334);
	exports.switchAll = switchAll_1.switchAll;
	var switchMap_1 = __webpack_require__(452);
	exports.switchMap = switchMap_1.switchMap;
	var switchMapTo_1 = __webpack_require__(2335);
	exports.switchMapTo = switchMapTo_1.switchMapTo;
	var take_1 = __webpack_require__(453);
	exports.take = take_1.take;
	var takeLast_1 = __webpack_require__(454);
	exports.takeLast = takeLast_1.takeLast;
	var takeUntil_1 = __webpack_require__(2336);
	exports.takeUntil = takeUntil_1.takeUntil;
	var takeWhile_1 = __webpack_require__(2337);
	exports.takeWhile = takeWhile_1.takeWhile;
	var tap_1 = __webpack_require__(2338);
	exports.tap = tap_1.tap;
	var throttle_1 = __webpack_require__(856);
	exports.throttle = throttle_1.throttle;
	var throttleTime_1 = __webpack_require__(2339);
	exports.throttleTime = throttleTime_1.throttleTime;
	var throwIfEmpty_1 = __webpack_require__(302);
	exports.throwIfEmpty = throwIfEmpty_1.throwIfEmpty;
	var timeInterval_1 = __webpack_require__(2340);
	exports.timeInterval = timeInterval_1.timeInterval;
	var timeout_1 = __webpack_require__(2341);
	exports.timeout = timeout_1.timeout;
	var timeoutWith_1 = __webpack_require__(857);
	exports.timeoutWith = timeoutWith_1.timeoutWith;
	var timestamp_1 = __webpack_require__(2342);
	exports.timestamp = timestamp_1.timestamp;
	var toArray_1 = __webpack_require__(2343);
	exports.toArray = toArray_1.toArray;
	var window_1 = __webpack_require__(2344);
	exports.window = window_1.window;
	var windowCount_1 = __webpack_require__(2345);
	exports.windowCount = windowCount_1.windowCount;
	var windowTime_1 = __webpack_require__(2346);
	exports.windowTime = windowTime_1.windowTime;
	var windowToggle_1 = __webpack_require__(2347);
	exports.windowToggle = windowToggle_1.windowToggle;
	var windowWhen_1 = __webpack_require__(2348);
	exports.windowWhen = windowWhen_1.windowWhen;
	var withLatestFrom_1 = __webpack_require__(2349);
	exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
	var zip_1 = __webpack_require__(2350);
	exports.zip = zip_1.zip;
	var zipAll_1 = __webpack_require__(2351);
	exports.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2373 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2373);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      fn(el)
	      return 1
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 2376 */
/***/ (function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ }),
/* 2377 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 2378 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=__webpack_require__(2380),t=__webpack_require__(873),n=__webpack_require__(1),r=__webpack_require__(2377),o=__webpack_require__(2381),s=__webpack_require__(877);function i(e){return e&&e.__esModule?e:{default:e}}function a(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach(function(n){if("default"!==n){var r=Object.getOwnPropertyDescriptor(e,n);Object.defineProperty(t,n,r.get?r:{enumerable:!0,get:function(){return e[n]}})}}),t.default=e,Object.freeze(t)}var c=/*#__PURE__*/i(t),u=/*#__PURE__*/i(n),l=/*#__PURE__*/i(r),p=/*#__PURE__*/a(o),d=/*#__PURE__*/i(s),h="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",f="active",y="data-styled-version",m="6.1.13",v="/*!sc*/\n",g="undefined"!=typeof window&&"HTMLElement"in window,S=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==("production")),w={},_=/invalid hook call/i,b=new Set,E=function(t,r){if(false){var o=r?' with the id of "'.concat(r,'"'):"",s="The component ".concat(t).concat(o," has been created dynamically.\n")+"You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",i=console.error;try{var a=!0;console.error=function(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];_.test(t)?(a=!1,b.delete(s)):i.apply(void 0,e.__spreadArray([t],n,!1))},n.useRef(),a&&!b.has(s)&&(console.warn(s),b.add(s))}catch(e){_.test(e.message)&&b.delete(s)}finally{console.error=i}}},N=Object.freeze([]),P=Object.freeze({});function C(e,t,n){return void 0===n&&(n=P),e.theme!==n.theme&&e.theme||t||n.theme}var A=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),I=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,O=/(^-|-$)/g;function x(e){return e.replace(I,"-").replace(O,"")}var T=/(a)(d)/gi,D=52,R=function(e){return String.fromCharCode(e+(e>25?39:97))};function j(e){var t,n="";for(t=Math.abs(e);t>D;t=t/D|0)n=R(t%D)+n;return(R(t%D)+n).replace(T,"$1-$2")}var k,M=5381,V=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},F=function(e){return V(M,e)};function z(e){return j(F(e)>>>0)}function $(e){return"production"!==("production")&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function B(e){return"string"==typeof e&&("production"===("production")||e.charAt(0)===e.charAt(0).toLowerCase())}var L="function"==typeof Symbol&&Symbol.for,G=L?Symbol.for("react.memo"):60115,q=L?Symbol.for("react.forward_ref"):60112,Y={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},W={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},U=((k={})[q]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},k[G]=H,k);function J(e){return("type"in(t=e)&&t.type.$$typeof)===G?H:"$$typeof"in e?U[e.$$typeof]:Y;var t}var X=Object.defineProperty,Z=Object.getOwnPropertyNames,K=Object.getOwnPropertySymbols,Q=Object.getOwnPropertyDescriptor,ee=Object.getPrototypeOf,te=Object.prototype;function ne(e,t,n){if("string"!=typeof t){if(te){var r=ee(t);r&&r!==te&&ne(e,r,n)}var o=Z(t);K&&(o=o.concat(K(t)));for(var s=J(e),i=J(t),a=0;a<o.length;++a){var c=o[a];if(!(c in W||n&&n[c]||i&&c in i||s&&c in s)){var u=Q(t,c);try{X(e,c,u)}catch(e){}}}}return e}function re(e){return"function"==typeof e}function oe(e){return"object"==typeof e&&"styledComponentId"in e}function se(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ie(e,t){if(0===e.length)return"";for(var n=e[0],r=1;r<e.length;r++)n+=t?t+e[r]:e[r];return n}function ae(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function ce(e,t,n){if(void 0===n&&(n=!1),!n&&!ae(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var r=0;r<t.length;r++)e[r]=ce(e[r],t[r]);else if(ae(t))for(var r in t)e[r]=ce(e[r],t[r]);return e}function ue(e,t){Object.defineProperty(e,"toString",{value:t})}var le= false?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",18:"ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"}:{};function pe(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],r=[],o=1,s=e.length;o<s;o+=1)r.push(e[o]);return r.forEach(function(e){n=n.replace(/%[a-z]/,e)}),n}function de(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];return true?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):new Error(pe.apply(void 0,e.__spreadArray([le[t]],n,!1)).trim())}var he=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}return e.prototype.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)if((o<<=1)<0)throw de(16,"".concat(e));this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=(s=0,t.length);s<a;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++)},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+="".concat(this.tag.getRule(s)).concat(v);return t},e}(),fe=1<<30,ye=new Map,me=new Map,ve=1,ge=function(e){if(ye.has(e))return ye.get(e);for(;me.has(ve);)ve++;var t=ve++;if(false)throw de(16,"".concat(t));return ye.set(e,t),me.set(t,e),t},Se=function(e,t){ve=t+1,ye.set(e,t),me.set(t,e)},we="style[".concat(h,"][").concat(y,'="').concat(m,'"]'),_e=new RegExp("^".concat(h,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),be=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Ee=function(e,t){for(var n,r=(null!==(n=t.textContent)&&void 0!==n?n:"").split(v),o=[],s=0,i=r.length;s<i;s++){var a=r[s].trim();if(a){var c=a.match(_e);if(c){var u=0|parseInt(c[1],10),l=c[2];0!==u&&(Se(l,u),be(e,l,c[3]),e.getTag().insertRules(u,o)),o.length=0}else o.push(a)}}},Ne=function(e){for(var t=document.querySelectorAll(we),n=0,r=t.length;n<r;n++){var o=t[n];o&&o.getAttribute(h)!==f&&(Ee(e,o),o.parentNode&&o.parentNode.removeChild(o))}};function Pe(){return"undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null}var Ce=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){var t=Array.from(e.querySelectorAll("style[".concat(h,"]")));return t[t.length-1]}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(h,f),r.setAttribute(y,m);var i=Pe();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},Ae=function(){function e(e){this.element=Ce(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}throw de(17)}(this.element),this.length=0}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Ie=function(){function e(e){this.element=Ce(e),this.nodes=this.element.childNodes,this.length=0}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return!1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),Oe=function(){function e(e){this.rules=[],this.length=0}return e.prototype.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),xe=g,Te={isServer:!g,useCSSOMInjection:!S},De=function(){function t(t,n,r){void 0===t&&(t=P),void 0===n&&(n={});var o=this;this.options=e.__assign(e.__assign({},Te),t),this.gs=n,this.names=new Map(r),this.server=!!t.isServer,!this.server&&g&&xe&&(xe=!1,Ne(this)),ue(this,function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=function(n){var o=function(e){return me.get(e)}(n);if(void 0===o)return"continue";var s=e.names.get(o),i=t.getGroup(n);if(void 0===s||!s.size||0===i.length)return"continue";var a="".concat(h,".g").concat(n,'[id="').concat(o,'"]'),c="";void 0!==s&&s.forEach(function(e){e.length>0&&(c+="".concat(e,","))}),r+="".concat(i).concat(a,'{content:"').concat(c,'"}').concat(v)},s=0;s<n;s++)o(s);return r}(o)})}return t.registerId=function(e){return ge(e)},t.prototype.rehydrate=function(){!this.server&&g&&Ne(this)},t.prototype.reconstructWithOptions=function(n,r){return void 0===r&&(r=!0),new t(e.__assign(e.__assign({},this.options),n),this.gs,r&&this.names||void 0)},t.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new Oe(n):t?new Ae(n):new Ie(n)}(this.options),new he(e)));var e},t.prototype.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.prototype.registerName=function(e,t){if(ge(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(ge(e),n)},t.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.prototype.clearRules=function(e){this.getTag().clearGroup(ge(e)),this.clearNames(e)},t.prototype.clearTag=function(){this.tag=void 0},t}(),Re=/&/g,je=/^\s*\/\/.*$/gm;function ke(e,t){return e.map(function(e){return"rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return"".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=ke(e.children,t)),e})}function Me(e){var t,n,r,o=void 0===e?P:e,s=o.options,i=void 0===s?P:s,a=o.plugins,c=void 0===a?N:a,u=function(e,r,o){return o.startsWith(n)&&o.endsWith(n)&&o.replaceAll(n,"").length>0?".".concat(t):e},l=c.slice();l.push(function(e){e.type===p.RULESET&&e.value.includes("&")&&(e.props[0]=e.props[0].replace(Re,n).replace(r,u))}),i.prefix&&l.push(p.prefixer),l.push(p.stringify);var d=function(e,o,s,a){void 0===o&&(o=""),void 0===s&&(s=""),void 0===a&&(a="&"),t=a,n=o,r=new RegExp("\\".concat(n,"\\b"),"g");var c=e.replace(je,""),u=p.compile(s||o?"".concat(s," ").concat(o," { ").concat(c," }"):c);i.namespace&&(u=ke(u,i.namespace));var d=[];return p.serialize(u,p.middleware(l.concat(p.rulesheet(function(e){return d.push(e)})))),d};return d.hash=c.length?c.reduce(function(e,t){return t.name||de(15),V(e,t.name)},M).toString():"",d}var Ve=new De,Fe=Me(),ze=u.default.createContext({shouldForwardProp:void 0,styleSheet:Ve,stylis:Fe}),$e=ze.Consumer,Be=u.default.createContext(void 0);function Le(){return n.useContext(ze)}function Ge(e){var t=n.useState(e.stylisPlugins),r=t[0],o=t[1],s=Le().styleSheet,i=n.useMemo(function(){var t=s;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t},[e.disableCSSOMInjection,e.sheet,e.target,s]),a=n.useMemo(function(){return Me({options:{namespace:e.namespace,prefix:e.enableVendorPrefixes},plugins:r})},[e.enableVendorPrefixes,e.namespace,r]);n.useEffect(function(){l.default(r,e.stylisPlugins)||o(e.stylisPlugins)},[e.stylisPlugins]);var c=n.useMemo(function(){return{shouldForwardProp:e.shouldForwardProp,styleSheet:i,stylis:a}},[e.shouldForwardProp,i,a]);return u.default.createElement(ze.Provider,{value:c},u.default.createElement(Be.Provider,{value:a},e.children))}var qe=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=Fe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,ue(this,function(){throw de(12,String(n.name))})}return e.prototype.getName=function(e){return void 0===e&&(e=Fe),this.name+e.hash},e}(),Ye=function(e){return e>="A"&&e<="Z"};function We(e){for(var t="",n=0;n<e.length;n++){var r=e[n];if(1===n&&"-"===r&&"-"===e[0])return e;Ye(r)?t+="-"+r.toLowerCase():t+=r}return t.startsWith("ms-")?"-"+t:t}var He=function(e){return null==e||!1===e||""===e},Ue=function(t){var n,r,o=[];for(var s in t){var i=t[s];t.hasOwnProperty(s)&&!He(i)&&(Array.isArray(i)&&i.isCss||re(i)?o.push("".concat(We(s),":"),i,";"):ae(i)?o.push.apply(o,e.__spreadArray(e.__spreadArray(["".concat(s," {")],Ue(i),!1),["}"],!1)):o.push("".concat(We(s),": ").concat((n=s,null==(r=i)||"boolean"==typeof r||""===r?"":"number"!=typeof r||0===r||n in d.default||n.startsWith("--")?String(r).trim():"".concat(r,"px")),";")))}return o};function Je(e,t,n,r){if(He(e))return[];if(oe(e))return[".".concat(e.styledComponentId)];if(re(e)){if(!re(s=e)||s.prototype&&s.prototype.isReactComponent||!t)return[e];var o=e(t);return"production"===("production")||"object"!=typeof o||Array.isArray(o)||o instanceof qe||ae(o)||null===o||console.error("".concat($(e)," is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")),Je(o,t,n,r)}var s;return e instanceof qe?n?(e.inject(n,r),[e.getName(r)]):[e]:ae(e)?Ue(e):Array.isArray(e)?Array.prototype.concat.apply(N,e.map(function(e){return Je(e,t,n,r)})):[e.toString()]}function Xe(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!oe(n))return!1}return!0}var Ze=F(m),Ke=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===("production")&&(void 0===n||n.isStatic)&&Xe(e),this.componentId=t,this.baseHash=V(Ze,t),this.baseStyle=n,De.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))r=se(r,this.staticRulesId);else{var o=ie(Je(this.rules,e,t,n)),s=j(V(this.baseHash,o)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(o,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i)}r=se(r,s),this.staticRulesId=s}else{for(var a=V(this.baseHash,n.hash),c="",u=0;u<this.rules.length;u++){var l=this.rules[u];if("string"==typeof l)c+=l,"production"!==("production")&&(a=V(a,l));else if(l){var p=ie(Je(l,e,t,n));a=V(a,p+u),c+=p}}if(c){var d=j(a>>>0);t.hasNameForId(this.componentId,d)||t.insertRules(this.componentId,d,n(c,".".concat(d),void 0,this.componentId)),r=se(r,d)}}return r},e}(),Qe=u.default.createContext(void 0),et=Qe.Consumer,tt={},nt=new Set;function rt(t,r,o){var s=oe(t),i=t,a=!B(t),l=r.attrs,p=void 0===l?N:l,d=r.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":x(e);tt[n]=(tt[n]||0)+1;var r="".concat(n,"-").concat(z(m+n+tt[n]));return t?"".concat(t,"-").concat(r):r}(r.displayName,r.parentComponentId):d,f=r.displayName,y=void 0===f?function(e){return B(e)?"styled.".concat(e):"Styled(".concat($(e),")")}(t):f,v=r.displayName&&r.componentId?"".concat(x(r.displayName),"-").concat(r.componentId):r.componentId||h,g=s&&i.attrs?i.attrs.concat(p).filter(Boolean):p,S=r.shouldForwardProp;if(s&&i.shouldForwardProp){var w=i.shouldForwardProp;if(r.shouldForwardProp){var _=r.shouldForwardProp;S=function(e,t){return w(e,t)&&_(e,t)}}else S=w}var b=new Ke(o,v,s?i.componentStyle:void 0);function I(t,r){return function(t,r,o){var s=t.attrs,i=t.componentStyle,a=t.defaultProps,l=t.foldedComponentIds,p=t.styledComponentId,d=t.target,h=u.default.useContext(Qe),f=Le(),y=t.shouldForwardProp||f.shouldForwardProp;"production"!==("production")&&n.useDebugValue(p);var m=C(r,h,a)||P,v=function(t,n,r){for(var o,s=e.__assign(e.__assign({},n),{className:void 0,theme:r}),i=0;i<t.length;i+=1){var a=re(o=t[i])?o(s):o;for(var c in a)s[c]="className"===c?se(s[c],a[c]):"style"===c?e.__assign(e.__assign({},s[c]),a[c]):a[c]}return n.className&&(s.className=se(s.className,n.className)),s}(s,r,m),g=v.as||d,S={};for(var w in v)void 0===v[w]||"$"===w[0]||"as"===w||"theme"===w&&v.theme===m||("forwardedAs"===w?S.as=v.forwardedAs:y&&!y(w,g)||(S[w]=v[w],y||"development"!==("production")||c.default(w)||nt.has(w)||!A.has(g)||(nt.add(w),console.warn('styled-components: it looks like an unknown prop "'.concat(w,'" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));var _=function(e,t){var r=Le(),o=e.generateAndInjectStyles(t,r.styleSheet,r.stylis);return"production"!==("production")&&n.useDebugValue(o),o}(i,v);"production"!==("production")&&t.warnTooManyClasses&&t.warnTooManyClasses(_);var b=se(l,p);return _&&(b+=" "+_),v.className&&(b+=" "+v.className),S[B(g)&&!A.has(g)?"class":"className"]=b,S.ref=o,n.createElement(g,S)}(O,t,r)}I.displayName=y;var O=u.default.forwardRef(I);return O.attrs=g,O.componentStyle=b,O.displayName=y,O.shouldForwardProp=S,O.foldedComponentIds=s?se(i.foldedComponentIds,i.styledComponentId):"",O.styledComponentId=v,O.target=s?i.target:t,Object.defineProperty(O,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=s?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var r=0,o=t;r<o.length;r++)ce(e,o[r],!0);return e}({},i.defaultProps,e):e}}),"production"!==("production")&&(E(y,v),O.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'.concat(t,'"'):"";console.warn("Over ".concat(200," classes were generated for component ").concat(e).concat(s,".\n")+"Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={}}}}(y,v)),ue(O,function(){return".".concat(O.styledComponentId)}),a&&ne(O,t,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),O}function ot(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n}var st=function(e){return Object.assign(e,{isCss:!0})};function it(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];if(re(t)||ae(t))return st(Je(ot(N,e.__spreadArray([t],n,!0))));var o=t;return 0===n.length&&1===o.length&&"string"==typeof o[0]?Je(o):st(Je(ot(o,n)))}function at(t,n,r){if(void 0===r&&(r=P),!n)throw de(1,n);var o=function(o){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return t(n,r,it.apply(void 0,e.__spreadArray([o],s,!1)))};return o.attrs=function(o){return at(t,n,e.__assign(e.__assign({},r),{attrs:Array.prototype.concat(r.attrs,o).filter(Boolean)}))},o.withConfig=function(o){return at(t,n,e.__assign(e.__assign({},r),o))},o}var ct=function(e){return at(rt,e)},ut=ct;A.forEach(function(e){ut[e]=ct(e)});var lt=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=Xe(e),De.registerId(this.componentId+1)}return e.prototype.createStyles=function(e,t,n,r){var o=r(ie(Je(this.rules,t,n,r)),""),s=this.componentId+e;n.insertRules(s,s,o)},e.prototype.removeStyles=function(e,t){t.clearRules(this.componentId+e)},e.prototype.renderStyles=function(e,t,n,r){e>2&&De.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}(),pt=function(){function t(){var t=this;this._emitSheetCSS=function(){var e=t.instance.toString();if(!e)return"";var n=Pe(),r=ie([n&&'nonce="'.concat(n,'"'),"".concat(h,'="true"'),"".concat(y,'="').concat(m,'"')].filter(Boolean)," ");return"<style ".concat(r,">").concat(e,"</style>")},this.getStyleTags=function(){if(t.sealed)throw de(2);return t._emitSheetCSS()},this.getStyleElement=function(){var n;if(t.sealed)throw de(2);var r=t.instance.toString();if(!r)return[];var o=((n={})[h]="",n[y]=m,n.dangerouslySetInnerHTML={__html:r},n),s=Pe();return s&&(o.nonce=s),[u.default.createElement("style",e.__assign({},o,{key:"sc-0-0"}))]},this.seal=function(){t.sealed=!0},this.instance=new De({isServer:!0}),this.sealed=!1}return t.prototype.collectStyles=function(e){if(this.sealed)throw de(2);return u.default.createElement(Ge,{sheet:this.instance},e)},t.prototype.interleaveWithNodeStream=function(e){throw de(3)},t}(),dt={StyleSheet:De,mainSheet:Ve};"production"!==("production")&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");var ht="__sc-".concat(h,"__");"production"!==("production")&&"test"!==("production")&&"undefined"!=typeof window&&(window[ht]||(window[ht]=0),1===window[ht]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window[ht]+=1),exports.ServerStyleSheet=pt,exports.StyleSheetConsumer=$e,exports.StyleSheetContext=ze,exports.StyleSheetManager=Ge,exports.ThemeConsumer=et,exports.ThemeContext=Qe,exports.ThemeProvider=function(t){var r=u.default.useContext(Qe),o=n.useMemo(function(){return function(t,n){if(!t)throw de(14);if(re(t)){var r=t(n);if(false)throw de(7);return r}if(Array.isArray(t)||"object"!=typeof t)throw de(8);return n?e.__assign(e.__assign({},n),t):t}(t.theme,r)},[t.theme,r]);return t.children?u.default.createElement(Qe.Provider,{value:o},t.children):null},exports.__PRIVATE__=dt,exports.createGlobalStyle=function(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];var o=it.apply(void 0,e.__spreadArray([t],n,!1)),s="sc-global-".concat(z(JSON.stringify(o))),i=new lt(o,s);"production"!==("production")&&E(s);var a=function(e){var t=Le(),n=u.default.useContext(Qe),r=u.default.useRef(t.styleSheet.allocateGSInstance(s)).current;return"production"!==("production")&&u.default.Children.count(e.children)&&console.warn("The global style component ".concat(s," was given child JSX. createGlobalStyle does not render children.")),"production"!==("production")&&o.some(function(e){return"string"==typeof e&&-1!==e.indexOf("@import")})&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.styleSheet.server&&c(r,e,t.styleSheet,n,t.stylis),u.default.useLayoutEffect(function(){if(!t.styleSheet.server)return c(r,e,t.styleSheet,n,t.stylis),function(){return i.removeStyles(r,t.styleSheet)}},[r,e,t.styleSheet,n,t.stylis]),null};function c(t,n,r,o,s){if(i.isStatic)i.renderStyles(t,w,r,s);else{var c=e.__assign(e.__assign({},n),{theme:C(n,o,a.defaultProps)});i.renderStyles(t,c,r,s)}}return u.default.memo(a)},exports.css=it,exports.default=ut,exports.isStyledComponent=oe,exports.keyframes=function(t){for(var n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];"production"!==("production")&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");var o=ie(it.apply(void 0,e.__spreadArray([t],n,!1))),s=z(o);return new qe(s,o)},exports.styled=ut,exports.useTheme=function(){var e=n.useContext(Qe);if(!e)throw de(18);return e},exports.version=m,exports.withTheme=function(t){var n=u.default.forwardRef(function(n,r){var o=C(n,u.default.useContext(Qe),t.defaultProps);return"production"!==("production")&&void 0===o&&console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'.concat($(t),'"')),u.default.createElement(t,e.__assign({},n,{theme:o,ref:r}))});return n.displayName="WithTheme(".concat($(t),")"),ne(n,t)};
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, Symbol, Reflect, Promise, SuppressedError */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __esDecorate;
	var __runInitializers;
	var __propKey;
	var __setFunctionName;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	var __addDisposableResource;
	var __disposeResources;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	        var _, done = false;
	        for (var i = decorators.length - 1; i >= 0; i--) {
	            var context = {};
	            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	            if (kind === "accessor") {
	                if (result === void 0) continue;
	                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	                if (_ = accept(result.get)) descriptor.get = _;
	                if (_ = accept(result.set)) descriptor.set = _;
	                if (_ = accept(result.init)) initializers.unshift(_);
	            }
	            else if (_ = accept(result)) {
	                if (kind === "field") initializers.unshift(_);
	                else descriptor[key] = _;
	            }
	        }
	        if (target) Object.defineProperty(target, contextIn.name, descriptor);
	        done = true;
	    };
	
	    __runInitializers = function (thisArg, initializers, value) {
	        var useValue = arguments.length > 2;
	        for (var i = 0; i < initializers.length; i++) {
	            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	        }
	        return useValue ? value : void 0;
	    };
	
	    __propKey = function (x) {
	        return typeof x === "symbol" ? x : "".concat(x);
	    };
	
	    __setFunctionName = function (f, name, prefix) {
	        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    __addDisposableResource = function (env, value, async) {
	        if (value !== null && value !== void 0) {
	            if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
	            var dispose;
	            if (async) {
	                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
	                dispose = value[Symbol.asyncDispose];
	            }
	            if (dispose === void 0) {
	                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
	                dispose = value[Symbol.dispose];
	            }
	            if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
	            env.stack.push({ value: value, dispose: dispose, async: async });
	        }
	        else if (async) {
	            env.stack.push({ async: true });
	        }
	        return value;
	    };
	
	    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };
	
	    __disposeResources = function (env) {
	        function fail(e) {
	            env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
	            env.hasError = true;
	        }
	        function next() {
	            while (env.stack.length) {
	                var rec = env.stack.pop();
	                try {
	                    var result = rec.dispose && rec.dispose.call(rec.value);
	                    if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
	                }
	                catch (e) {
	                    fail(e);
	                }
	            }
	            if (env.hasError) throw env.error;
	        }
	        return next();
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__esDecorate", __esDecorate);
	    exporter("__runInitializers", __runInitializers);
	    exporter("__propKey", __propKey);
	    exporter("__setFunctionName", __setFunctionName);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	    exporter("__addDisposableResource", __addDisposableResource);
	    exporter("__disposeResources", __disposeResources);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	(function(e,r){ true?r(exports):typeof define==="function"&&define.amd?define(["exports"],r):(e=e||self,r(e.stylis={}))})(this,(function(e){"use strict";var r="-ms-";var a="-moz-";var c="-webkit-";var n="comm";var t="rule";var s="decl";var i="@page";var u="@media";var o="@import";var l="@charset";var f="@viewport";var p="@supports";var h="@document";var v="@namespace";var b="@keyframes";var d="@font-face";var w="@counter-style";var m="@font-feature-values";var g="@layer";var k="@scope";var $=Math.abs;var x=String.fromCharCode;var E=Object.assign;function y(e,r){return M(e,0)^45?(((r<<2^M(e,0))<<2^M(e,1))<<2^M(e,2))<<2^M(e,3):0}function O(e){return e.trim()}function T(e,r){return(e=r.exec(e))?e[0]:e}function A(e,r,a){return e.replace(r,a)}function C(e,r,a){return e.indexOf(r,a)}function M(e,r){return e.charCodeAt(r)|0}function S(e,r,a){return e.slice(r,a)}function R(e){return e.length}function P(e){return e.length}function z(e,r){return r.push(e),e}function N(e,r){return e.map(r).join("")}function j(e,r){return e.filter((function(e){return!T(e,r)}))}e.line=1;e.column=1;e.length=0;e.position=0;e.character=0;e.characters="";function U(r,a,c,n,t,s,i,u){return{value:r,root:a,parent:c,type:n,props:t,children:s,line:e.line,column:e.column,length:i,return:"",siblings:u}}function _(e,r){return E(U("",null,null,"",null,null,0,e.siblings),e,{length:-e.length},r)}function F(e){while(e.root)e=_(e.root,{children:[e]});z(e,e.siblings)}function I(){return e.character}function L(){e.character=e.position>0?M(e.characters,--e.position):0;if(e.column--,e.character===10)e.column=1,e.line--;return e.character}function D(){e.character=e.position<e.length?M(e.characters,e.position++):0;if(e.column++,e.character===10)e.column=1,e.line++;return e.character}function Y(){return M(e.characters,e.position)}function K(){return e.position}function V(r,a){return S(e.characters,r,a)}function W(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function B(r){return e.line=e.column=1,e.length=R(e.characters=r),e.position=0,[]}function G(r){return e.characters="",r}function H(r){return O(V(e.position-1,X(r===91?r+2:r===40?r+1:r)))}function Z(e){return G(J(B(e)))}function q(r){while(e.character=Y())if(e.character<33)D();else break;return W(r)>2||W(e.character)>3?"":" "}function J(r){while(D())switch(W(e.character)){case 0:z(re(e.position-1),r);break;case 2:z(H(e.character),r);break;default:z(x(e.character),r)}return r}function Q(r,a){while(--a&&D())if(e.character<48||e.character>102||e.character>57&&e.character<65||e.character>70&&e.character<97)break;return V(r,K()+(a<6&&Y()==32&&D()==32))}function X(r){while(D())switch(e.character){case r:return e.position;case 34:case 39:if(r!==34&&r!==39)X(e.character);break;case 40:if(r===41)X(r);break;case 92:D();break}return e.position}function ee(r,a){while(D())if(r+e.character===47+10)break;else if(r+e.character===42+42&&Y()===47)break;return"/*"+V(a,e.position-1)+"*"+x(r===47?r:D())}function re(r){while(!W(Y()))D();return V(r,e.position)}function ae(e){return G(ce("",null,null,null,[""],e=B(e),0,[0],e))}function ce(e,r,a,c,n,t,s,i,u){var o=0;var l=0;var f=s;var p=0;var h=0;var v=0;var b=1;var d=1;var w=1;var m=0;var g="";var k=n;var E=t;var y=c;var O=g;while(d)switch(v=m,m=D()){case 40:if(v!=108&&M(O,f-1)==58){if(C(O+=A(H(m),"&","&\f"),"&\f",$(o?i[o-1]:0))!=-1)w=-1;break}case 34:case 39:case 91:O+=H(m);break;case 9:case 10:case 13:case 32:O+=q(v);break;case 92:O+=Q(K()-1,7);continue;case 47:switch(Y()){case 42:case 47:z(te(ee(D(),K()),r,a,u),u);break;default:O+="/"}break;case 123*b:i[o++]=R(O)*w;case 125*b:case 59:case 0:switch(m){case 0:case 125:d=0;case 59+l:if(w==-1)O=A(O,/\f/g,"");if(h>0&&R(O)-f)z(h>32?se(O+";",c,a,f-1,u):se(A(O," ","")+";",c,a,f-2,u),u);break;case 59:O+=";";default:z(y=ne(O,r,a,o,l,n,i,g,k=[],E=[],f,t),t);if(m===123)if(l===0)ce(O,r,y,y,k,t,f,i,E);else switch(p===99&&M(O,3)===110?100:p){case 100:case 108:case 109:case 115:ce(e,y,y,c&&z(ne(e,y,y,0,0,n,i,g,n,k=[],f,E),E),n,E,f,i,c?k:E);break;default:ce(O,y,y,y,[""],E,0,i,E)}}o=l=h=0,b=w=1,g=O="",f=s;break;case 58:f=1+R(O),h=v;default:if(b<1)if(m==123)--b;else if(m==125&&b++==0&&L()==125)continue;switch(O+=x(m),m*b){case 38:w=l>0?1:(O+="\f",-1);break;case 44:i[o++]=(R(O)-1)*w,w=1;break;case 64:if(Y()===45)O+=H(D());p=Y(),l=f=R(g=O+=re(K())),m++;break;case 45:if(v===45&&R(O)==2)b=0}}return t}function ne(e,r,a,c,n,s,i,u,o,l,f,p){var h=n-1;var v=n===0?s:[""];var b=P(v);for(var d=0,w=0,m=0;d<c;++d)for(var g=0,k=S(e,h+1,h=$(w=i[d])),x=e;g<b;++g)if(x=O(w>0?v[g]+" "+k:A(k,/&\f/g,v[g])))o[m++]=x;return U(e,r,a,n===0?t:u,o,l,f,p)}function te(e,r,a,c){return U(e,r,a,n,x(I()),S(e,2,-2),0,c)}function se(e,r,a,c,n){return U(e,r,a,s,S(e,0,c),S(e,c+1,-1),c,n)}function ie(e,n,t){switch(y(e,n)){case 5103:return c+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return c+e+e;case 4789:return a+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return c+e+a+e+r+e+e;case 5936:switch(M(e,n+11)){case 114:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return c+e+r+A(e,/[svh]\w+-[tblr]{2}/,"lr")+e}case 6828:case 4268:case 2903:return c+e+r+e+e;case 6165:return c+e+r+"flex-"+e+e;case 5187:return c+e+A(e,/(\w+).+(:[^]+)/,c+"box-$1$2"+r+"flex-$1$2")+e;case 5443:return c+e+r+"flex-item-"+A(e,/flex-|-self/g,"")+(!T(e,/flex-|baseline/)?r+"grid-row-"+A(e,/flex-|-self/g,""):"")+e;case 4675:return c+e+r+"flex-line-pack"+A(e,/align-content|flex-|-self/g,"")+e;case 5548:return c+e+r+A(e,"shrink","negative")+e;case 5292:return c+e+r+A(e,"basis","preferred-size")+e;case 6060:return c+"box-"+A(e,"-grow","")+c+e+r+A(e,"grow","positive")+e;case 4554:return c+A(e,/([^-])(transform)/g,"$1"+c+"$2")+e;case 6187:return A(A(A(e,/(zoom-|grab)/,c+"$1"),/(image-set)/,c+"$1"),e,"")+e;case 5495:case 3959:return A(e,/(image-set\([^]*)/,c+"$1"+"$`$1");case 4968:return A(A(e,/(.+:)(flex-)?(.*)/,c+"box-pack:$3"+r+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+c+e+e;case 4200:if(!T(e,/flex-|baseline/))return r+"grid-column-align"+S(e,n)+e;break;case 2592:case 3360:return r+A(e,"template-","")+e;case 4384:case 3616:if(t&&t.some((function(e,r){return n=r,T(e.props,/grid-\w+-end/)}))){return~C(e+(t=t[n].value),"span",0)?e:r+A(e,"-start","")+e+r+"grid-row-span:"+(~C(t,"span",0)?T(t,/\d+/):+T(t,/\d+/)-+T(e,/\d+/))+";"}return r+A(e,"-start","")+e;case 4896:case 4128:return t&&t.some((function(e){return T(e.props,/grid-\w+-start/)}))?e:r+A(A(e,"-end","-span"),"span ","")+e;case 4095:case 3583:case 4068:case 2532:return A(e,/(.+)-inline(.+)/,c+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(R(e)-1-n>6)switch(M(e,n+1)){case 109:if(M(e,n+4)!==45)break;case 102:return A(e,/(.+:)(.+)-([^]+)/,"$1"+c+"$2-$3"+"$1"+a+(M(e,n+3)==108?"$3":"$2-$3"))+e;case 115:return~C(e,"stretch",0)?ie(A(e,"stretch","fill-available"),n,t)+e:e}break;case 5152:case 5920:return A(e,/(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/,(function(a,c,n,t,s,i,u){return r+c+":"+n+u+(t?r+c+"-span:"+(s?i:+i-+n)+u:"")+e}));case 4949:if(M(e,n+6)===121)return A(e,":",":"+c)+e;break;case 6444:switch(M(e,M(e,14)===45?18:11)){case 120:return A(e,/(.+:)([^;\s!]+)(;|(\s+)?!.+)?/,"$1"+c+(M(e,14)===45?"inline-":"")+"box$3"+"$1"+c+"$2$3"+"$1"+r+"$2box$3")+e;case 100:return A(e,":",":"+r)+e}break;case 5719:case 2647:case 2135:case 3927:case 2391:return A(e,"scroll-","scroll-snap-")+e}return e}function ue(e,r){var a="";for(var c=0;c<e.length;c++)a+=r(e[c],c,e,r)||"";return a}function oe(e,r,a,c){switch(e.type){case g:if(e.children.length)break;case o:case s:return e.return=e.return||e.value;case n:return"";case b:return e.return=e.value+"{"+ue(e.children,c)+"}";case t:if(!R(e.value=e.props.join(",")))return""}return R(a=ue(e.children,c))?e.return=e.value+"{"+a+"}":""}function le(e){var r=P(e);return function(a,c,n,t){var s="";for(var i=0;i<r;i++)s+=e[i](a,c,n,t)||"";return s}}function fe(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function pe(e,n,i,u){if(e.length>-1)if(!e.return)switch(e.type){case s:e.return=ie(e.value,e.length,i);return;case b:return ue([_(e,{value:A(e.value,"@","@"+c)})],u);case t:if(e.length)return N(i=e.props,(function(n){switch(T(n,u=/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":F(_(e,{props:[A(n,/:(read-\w+)/,":"+a+"$1")]}));F(_(e,{props:[n]}));E(e,{props:j(i,u)});break;case"::placeholder":F(_(e,{props:[A(n,/:(plac\w+)/,":"+c+"input-$1")]}));F(_(e,{props:[A(n,/:(plac\w+)/,":"+a+"$1")]}));F(_(e,{props:[A(n,/:(plac\w+)/,r+"input-$1")]}));F(_(e,{props:[n]}));E(e,{props:j(i,u)});break}return""}))}}function he(e){switch(e.type){case t:e.props=e.props.map((function(r){return N(Z(r),(function(r,a,c){switch(M(r,0)){case 12:return S(r,1,R(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+S(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return P(c)>1?"":r;case a=P(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}e.CHARSET=l;e.COMMENT=n;e.COUNTER_STYLE=w;e.DECLARATION=s;e.DOCUMENT=h;e.FONT_FACE=d;e.FONT_FEATURE_VALUES=m;e.IMPORT=o;e.KEYFRAMES=b;e.LAYER=g;e.MEDIA=u;e.MOZ=a;e.MS=r;e.NAMESPACE=v;e.PAGE=i;e.RULESET=t;e.SCOPE=k;e.SUPPORTS=p;e.VIEWPORT=f;e.WEBKIT=c;e.abs=$;e.alloc=B;e.append=z;e.assign=E;e.caret=K;e.char=I;e.charat=M;e.combine=N;e.comment=te;e.commenter=ee;e.compile=ae;e.copy=_;e.dealloc=G;e.declaration=se;e.delimit=H;e.delimiter=X;e.escaping=Q;e.filter=j;e.from=x;e.hash=y;e.identifier=re;e.indexof=C;e.lift=F;e.match=T;e.middleware=le;e.namespace=he;e.next=D;e.node=U;e.parse=ce;e.peek=Y;e.prefix=ie;e.prefixer=pe;e.prev=L;e.replace=A;e.ruleset=ne;e.rulesheet=fe;e.serialize=ue;e.sizeof=P;e.slice=V;e.stringify=oe;e.strlen=R;e.substr=S;e.token=W;e.tokenize=Z;e.tokenizer=J;e.trim=O;e.whitespace=q;Object.defineProperty(e,"__esModule",{value:true})}));
	//# sourceMappingURL=stylis.js.map


/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Supercluster = factory());
	})(this, (function () { 'use strict';
	
	function sortKD(ids, coords, nodeSize, left, right, depth) {
	    if (right - left <= nodeSize) { return; }
	
	    var m = (left + right) >> 1;
	
	    select(ids, coords, m, left, right, depth % 2);
	
	    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
	    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
	}
	
	function select(ids, coords, k, left, right, inc) {
	
	    while (right > left) {
	        if (right - left > 600) {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	            select(ids, coords, k, newLeft, newRight, inc);
	        }
	
	        var t = coords[2 * k + inc];
	        var i = left;
	        var j = right;
	
	        swapItem(ids, coords, left, k);
	        if (coords[2 * right + inc] > t) { swapItem(ids, coords, left, right); }
	
	        while (i < j) {
	            swapItem(ids, coords, i, j);
	            i++;
	            j--;
	            while (coords[2 * i + inc] < t) { i++; }
	            while (coords[2 * j + inc] > t) { j--; }
	        }
	
	        if (coords[2 * left + inc] === t) { swapItem(ids, coords, left, j); }
	        else {
	            j++;
	            swapItem(ids, coords, j, right);
	        }
	
	        if (j <= k) { left = j + 1; }
	        if (k <= j) { right = j - 1; }
	    }
	}
	
	function swapItem(ids, coords, i, j) {
	    swap(ids, i, j);
	    swap(coords, 2 * i, 2 * j);
	    swap(coords, 2 * i + 1, 2 * j + 1);
	}
	
	function swap(arr, i, j) {
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}
	
	function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
	    var stack = [0, ids.length - 1, 0];
	    var result = [];
	    var x, y;
	
	    while (stack.length) {
	        var axis = stack.pop();
	        var right = stack.pop();
	        var left = stack.pop();
	
	        if (right - left <= nodeSize) {
	            for (var i = left; i <= right; i++) {
	                x = coords[2 * i];
	                y = coords[2 * i + 1];
	                if (x >= minX && x <= maxX && y >= minY && y <= maxY) { result.push(ids[i]); }
	            }
	            continue;
	        }
	
	        var m = Math.floor((left + right) / 2);
	
	        x = coords[2 * m];
	        y = coords[2 * m + 1];
	
	        if (x >= minX && x <= maxX && y >= minY && y <= maxY) { result.push(ids[m]); }
	
	        var nextAxis = (axis + 1) % 2;
	
	        if (axis === 0 ? minX <= x : minY <= y) {
	            stack.push(left);
	            stack.push(m - 1);
	            stack.push(nextAxis);
	        }
	        if (axis === 0 ? maxX >= x : maxY >= y) {
	            stack.push(m + 1);
	            stack.push(right);
	            stack.push(nextAxis);
	        }
	    }
	
	    return result;
	}
	
	function within(ids, coords, qx, qy, r, nodeSize) {
	    var stack = [0, ids.length - 1, 0];
	    var result = [];
	    var r2 = r * r;
	
	    while (stack.length) {
	        var axis = stack.pop();
	        var right = stack.pop();
	        var left = stack.pop();
	
	        if (right - left <= nodeSize) {
	            for (var i = left; i <= right; i++) {
	                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) { result.push(ids[i]); }
	            }
	            continue;
	        }
	
	        var m = Math.floor((left + right) / 2);
	
	        var x = coords[2 * m];
	        var y = coords[2 * m + 1];
	
	        if (sqDist(x, y, qx, qy) <= r2) { result.push(ids[m]); }
	
	        var nextAxis = (axis + 1) % 2;
	
	        if (axis === 0 ? qx - r <= x : qy - r <= y) {
	            stack.push(left);
	            stack.push(m - 1);
	            stack.push(nextAxis);
	        }
	        if (axis === 0 ? qx + r >= x : qy + r >= y) {
	            stack.push(m + 1);
	            stack.push(right);
	            stack.push(nextAxis);
	        }
	    }
	
	    return result;
	}
	
	function sqDist(ax, ay, bx, by) {
	    var dx = ax - bx;
	    var dy = ay - by;
	    return dx * dx + dy * dy;
	}
	
	var defaultGetX = function (p) { return p[0]; };
	var defaultGetY = function (p) { return p[1]; };
	
	var KDBush = function KDBush(points, getX, getY, nodeSize, ArrayType) {
	    if ( getX === void 0 ) getX = defaultGetX;
	    if ( getY === void 0 ) getY = defaultGetY;
	    if ( nodeSize === void 0 ) nodeSize = 64;
	    if ( ArrayType === void 0 ) ArrayType = Float64Array;
	
	    this.nodeSize = nodeSize;
	    this.points = points;
	
	    var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
	
	    var ids = this.ids = new IndexArrayType(points.length);
	    var coords = this.coords = new ArrayType(points.length * 2);
	
	    for (var i = 0; i < points.length; i++) {
	        ids[i] = i;
	        coords[2 * i] = getX(points[i]);
	        coords[2 * i + 1] = getY(points[i]);
	    }
	
	    sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
	};
	
	KDBush.prototype.range = function range$1 (minX, minY, maxX, maxY) {
	    return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
	};
	
	KDBush.prototype.within = function within$1 (x, y, r) {
	    return within(this.ids, this.coords, x, y, r, this.nodeSize);
	};
	
	var defaultOptions = {
	    minZoom: 0,   // min zoom to generate clusters on
	    maxZoom: 16,  // max zoom level to cluster the points on
	    minPoints: 2, // minimum points to form a cluster
	    radius: 40,   // cluster radius in pixels
	    extent: 512,  // tile extent (radius is calculated relative to it)
	    nodeSize: 64, // size of the KD-tree leaf node, affects performance
	    log: false,   // whether to log timing info
	
	    // whether to generate numeric ids for input features (in vector tiles)
	    generateId: false,
	
	    // a reduce function for calculating custom cluster properties
	    reduce: null, // (accumulated, props) => { accumulated.sum += props.sum; }
	
	    // properties to use for individual points when running the reducer
	    map: function (props) { return props; } // props => ({sum: props.my_value})
	};
	
	var fround = Math.fround || (function (tmp) { return (function (x) { tmp[0] = +x; return tmp[0]; }); })(new Float32Array(1));
	
	var Supercluster = function Supercluster(options) {
	    this.options = extend(Object.create(defaultOptions), options);
	    this.trees = new Array(this.options.maxZoom + 1);
	};
	
	Supercluster.prototype.load = function load (points) {
	    var ref = this.options;
	        var log = ref.log;
	        var minZoom = ref.minZoom;
	        var maxZoom = ref.maxZoom;
	        var nodeSize = ref.nodeSize;
	
	    if (log) { console.time('total time'); }
	
	    var timerId = "prepare " + (points.length) + " points";
	    if (log) { console.time(timerId); }
	
	    this.points = points;
	
	    // generate a cluster object for each point and index input points into a KD-tree
	    var clusters = [];
	    for (var i = 0; i < points.length; i++) {
	        if (!points[i].geometry) { continue; }
	        clusters.push(createPointCluster(points[i], i));
	    }
	    this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
	
	    if (log) { console.timeEnd(timerId); }
	
	    // cluster points on max zoom, then cluster the results on previous zoom, etc.;
	    // results in a cluster hierarchy across zoom levels
	    for (var z = maxZoom; z >= minZoom; z--) {
	        var now = +Date.now();
	
	        // create a new set of clusters for the zoom and index them with a KD-tree
	        clusters = this._cluster(clusters, z);
	        this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
	
	        if (log) { console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now); }
	    }
	
	    if (log) { console.timeEnd('total time'); }
	
	    return this;
	};
	
	Supercluster.prototype.getClusters = function getClusters (bbox, zoom) {
	    var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
	    var minLat = Math.max(-90, Math.min(90, bbox[1]));
	    var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
	    var maxLat = Math.max(-90, Math.min(90, bbox[3]));
	
	    if (bbox[2] - bbox[0] >= 360) {
	        minLng = -180;
	        maxLng = 180;
	    } else if (minLng > maxLng) {
	        var easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
	        var westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
	        return easternHem.concat(westernHem);
	    }
	
	    var tree = this.trees[this._limitZoom(zoom)];
	    var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
	    var clusters = [];
	    for (var i = 0, list = ids; i < list.length; i += 1) {
	        var id = list[i];
	
	            var c = tree.points[id];
	        clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
	    }
	    return clusters;
	};
	
	Supercluster.prototype.getChildren = function getChildren (clusterId) {
	    var originId = this._getOriginId(clusterId);
	    var originZoom = this._getOriginZoom(clusterId);
	    var errorMsg = 'No cluster with the specified id.';
	
	    var index = this.trees[originZoom];
	    if (!index) { throw new Error(errorMsg); }
	
	    var origin = index.points[originId];
	    if (!origin) { throw new Error(errorMsg); }
	
	    var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
	    var ids = index.within(origin.x, origin.y, r);
	    var children = [];
	    for (var i = 0, list = ids; i < list.length; i += 1) {
	        var id = list[i];
	
	            var c = index.points[id];
	        if (c.parentId === clusterId) {
	            children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
	        }
	    }
	
	    if (children.length === 0) { throw new Error(errorMsg); }
	
	    return children;
	};
	
	Supercluster.prototype.getLeaves = function getLeaves (clusterId, limit, offset) {
	    limit = limit || 10;
	    offset = offset || 0;
	
	    var leaves = [];
	    this._appendLeaves(leaves, clusterId, limit, offset, 0);
	
	    return leaves;
	};
	
	Supercluster.prototype.getTile = function getTile (z, x, y) {
	    var tree = this.trees[this._limitZoom(z)];
	    var z2 = Math.pow(2, z);
	    var ref = this.options;
	        var extent = ref.extent;
	        var radius = ref.radius;
	    var p = radius / extent;
	    var top = (y - p) / z2;
	    var bottom = (y + 1 + p) / z2;
	
	    var tile = {
	        features: []
	    };
	
	    this._addTileFeatures(
	        tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
	        tree.points, x, y, z2, tile);
	
	    if (x === 0) {
	        this._addTileFeatures(
	            tree.range(1 - p / z2, top, 1, bottom),
	            tree.points, z2, y, z2, tile);
	    }
	    if (x === z2 - 1) {
	        this._addTileFeatures(
	            tree.range(0, top, p / z2, bottom),
	            tree.points, -1, y, z2, tile);
	    }
	
	    return tile.features.length ? tile : null;
	};
	
	Supercluster.prototype.getClusterExpansionZoom = function getClusterExpansionZoom (clusterId) {
	    var expansionZoom = this._getOriginZoom(clusterId) - 1;
	    while (expansionZoom <= this.options.maxZoom) {
	        var children = this.getChildren(clusterId);
	        expansionZoom++;
	        if (children.length !== 1) { break; }
	        clusterId = children[0].properties.cluster_id;
	    }
	    return expansionZoom;
	};
	
	Supercluster.prototype._appendLeaves = function _appendLeaves (result, clusterId, limit, offset, skipped) {
	    var children = this.getChildren(clusterId);
	
	    for (var i = 0, list = children; i < list.length; i += 1) {
	        var child = list[i];
	
	            var props = child.properties;
	
	        if (props && props.cluster) {
	            if (skipped + props.point_count <= offset) {
	                // skip the whole cluster
	                skipped += props.point_count;
	            } else {
	                // enter the cluster
	                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
	                // exit the cluster
	            }
	        } else if (skipped < offset) {
	            // skip a single point
	            skipped++;
	        } else {
	            // add a single point
	            result.push(child);
	        }
	        if (result.length === limit) { break; }
	    }
	
	    return skipped;
	};
	
	Supercluster.prototype._addTileFeatures = function _addTileFeatures (ids, points, x, y, z2, tile) {
	    for (var i$1 = 0, list = ids; i$1 < list.length; i$1 += 1) {
	        var i = list[i$1];
	
	            var c = points[i];
	        var isCluster = c.numPoints;
	
	        var tags = (void 0), px = (void 0), py = (void 0);
	        if (isCluster) {
	            tags = getClusterProperties(c);
	            px = c.x;
	            py = c.y;
	        } else {
	            var p = this.points[c.index];
	            tags = p.properties;
	            px = lngX(p.geometry.coordinates[0]);
	            py = latY(p.geometry.coordinates[1]);
	        }
	
	        var f = {
	            type: 1,
	            geometry: [[
	                Math.round(this.options.extent * (px * z2 - x)),
	                Math.round(this.options.extent * (py * z2 - y))
	            ]],
	            tags: tags
	        };
	
	        // assign id
	        var id = (void 0);
	        if (isCluster) {
	            id = c.id;
	        } else if (this.options.generateId) {
	            // optionally generate id
	            id = c.index;
	        } else if (this.points[c.index].id) {
	            // keep id if already assigned
	            id = this.points[c.index].id;
	        }
	
	        if (id !== undefined) { f.id = id; }
	
	        tile.features.push(f);
	    }
	};
	
	Supercluster.prototype._limitZoom = function _limitZoom (z) {
	    return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
	};
	
	Supercluster.prototype._cluster = function _cluster (points, zoom) {
	    var clusters = [];
	    var ref = this.options;
	        var radius = ref.radius;
	        var extent = ref.extent;
	        var reduce = ref.reduce;
	        var minPoints = ref.minPoints;
	    var r = radius / (extent * Math.pow(2, zoom));
	
	    // loop through each point
	    for (var i = 0; i < points.length; i++) {
	        var p = points[i];
	        // if we've already visited the point at this zoom level, skip it
	        if (p.zoom <= zoom) { continue; }
	        p.zoom = zoom;
	
	        // find all nearby points
	        var tree = this.trees[zoom + 1];
	        var neighborIds = tree.within(p.x, p.y, r);
	
	        var numPointsOrigin = p.numPoints || 1;
	        var numPoints = numPointsOrigin;
	
	        // count the number of points in a potential cluster
	        for (var i$1 = 0, list = neighborIds; i$1 < list.length; i$1 += 1) {
	            var neighborId = list[i$1];
	
	                var b = tree.points[neighborId];
	            // filter out neighbors that are already processed
	            if (b.zoom > zoom) { numPoints += b.numPoints || 1; }
	        }
	
	        // if there were neighbors to merge, and there are enough points to form a cluster
	        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
	            var wx = p.x * numPointsOrigin;
	            var wy = p.y * numPointsOrigin;
	
	            var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null;
	
	            // encode both zoom and point index on which the cluster originated -- offset by total length of features
	            var id = (i << 5) + (zoom + 1) + this.points.length;
	
	            for (var i$2 = 0, list$1 = neighborIds; i$2 < list$1.length; i$2 += 1) {
	                var neighborId$1 = list$1[i$2];
	
	                    var b$1 = tree.points[neighborId$1];
	
	                if (b$1.zoom <= zoom) { continue; }
	                b$1.zoom = zoom; // save the zoom (so it doesn't get processed twice)
	
	                var numPoints2 = b$1.numPoints || 1;
	                wx += b$1.x * numPoints2; // accumulate coordinates for calculating weighted center
	                wy += b$1.y * numPoints2;
	
	                b$1.parentId = id;
	
	                if (reduce) {
	                    if (!clusterProperties) { clusterProperties = this._map(p, true); }
	                    reduce(clusterProperties, this._map(b$1));
	                }
	            }
	
	            p.parentId = id;
	            clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));
	
	        } else { // left points as unclustered
	            clusters.push(p);
	
	            if (numPoints > 1) {
	                for (var i$3 = 0, list$2 = neighborIds; i$3 < list$2.length; i$3 += 1) {
	                    var neighborId$2 = list$2[i$3];
	
	                        var b$2 = tree.points[neighborId$2];
	                    if (b$2.zoom <= zoom) { continue; }
	                    b$2.zoom = zoom;
	                    clusters.push(b$2);
	                }
	            }
	        }
	    }
	
	    return clusters;
	};
	
	// get index of the point from which the cluster originated
	Supercluster.prototype._getOriginId = function _getOriginId (clusterId) {
	    return (clusterId - this.points.length) >> 5;
	};
	
	// get zoom of the point from which the cluster originated
	Supercluster.prototype._getOriginZoom = function _getOriginZoom (clusterId) {
	    return (clusterId - this.points.length) % 32;
	};
	
	Supercluster.prototype._map = function _map (point, clone) {
	    if (point.numPoints) {
	        return clone ? extend({}, point.properties) : point.properties;
	    }
	    var original = this.points[point.index].properties;
	    var result = this.options.map(original);
	    return clone && result === original ? extend({}, result) : result;
	};
	
	function createCluster(x, y, id, numPoints, properties) {
	    return {
	        x: fround(x), // weighted cluster center; round for consistency with Float32Array index
	        y: fround(y),
	        zoom: Infinity, // the last zoom the cluster was processed at
	        id: id, // encodes index of the first child of the cluster and its zoom level
	        parentId: -1, // parent cluster id
	        numPoints: numPoints,
	        properties: properties
	    };
	}
	
	function createPointCluster(p, id) {
	    var ref = p.geometry.coordinates;
	    var x = ref[0];
	    var y = ref[1];
	    return {
	        x: fround(lngX(x)), // projected point coordinates
	        y: fround(latY(y)),
	        zoom: Infinity, // the last zoom the point was processed at
	        index: id, // index of the source feature in the original input array,
	        parentId: -1 // parent cluster id
	    };
	}
	
	function getClusterJSON(cluster) {
	    return {
	        type: 'Feature',
	        id: cluster.id,
	        properties: getClusterProperties(cluster),
	        geometry: {
	            type: 'Point',
	            coordinates: [xLng(cluster.x), yLat(cluster.y)]
	        }
	    };
	}
	
	function getClusterProperties(cluster) {
	    var count = cluster.numPoints;
	    var abbrev =
	        count >= 10000 ? ((Math.round(count / 1000)) + "k") :
	        count >= 1000 ? ((Math.round(count / 100) / 10) + "k") : count;
	    return extend(extend({}, cluster.properties), {
	        cluster: true,
	        cluster_id: cluster.id,
	        point_count: count,
	        point_count_abbreviated: abbrev
	    });
	}
	
	// longitude/latitude to spherical mercator in [0..1] range
	function lngX(lng) {
	    return lng / 360 + 0.5;
	}
	function latY(lat) {
	    var sin = Math.sin(lat * Math.PI / 180);
	    var y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
	    return y < 0 ? 0 : y > 1 ? 1 : y;
	}
	
	// spherical mercator to longitude/latitude
	function xLng(x) {
	    return (x - 0.5) * 360;
	}
	function yLat(y) {
	    var y2 = (180 - y * 360) * Math.PI / 180;
	    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
	}
	
	function extend(dest, src) {
	    for (var id in src) { dest[id] = src[id]; }
	    return dest;
	}
	
	function getX(p) {
	    return p.x;
	}
	function getY(p) {
	    return p.y;
	}
	
	return Supercluster;
	
	}));


/***/ }),
/* 2383 */
/***/ (function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;
	module.exports.TinyEmitter = E;


/***/ }),
/* 2384 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = TinyQueue;
	module.exports.default = TinyQueue;
	
	function TinyQueue(data, compare) {
	    if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);
	
	    this.data = data || [];
	    this.length = this.data.length;
	    this.compare = compare || defaultCompare;
	
	    if (this.length > 0) {
	        for (var i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
	    }
	}
	
	function defaultCompare(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	}
	
	TinyQueue.prototype = {
	
	    push: function (item) {
	        this.data.push(item);
	        this.length++;
	        this._up(this.length - 1);
	    },
	
	    pop: function () {
	        if (this.length === 0) return undefined;
	
	        var top = this.data[0];
	        this.length--;
	
	        if (this.length > 0) {
	            this.data[0] = this.data[this.length];
	            this._down(0);
	        }
	        this.data.pop();
	
	        return top;
	    },
	
	    peek: function () {
	        return this.data[0];
	    },
	
	    _up: function (pos) {
	        var data = this.data;
	        var compare = this.compare;
	        var item = data[pos];
	
	        while (pos > 0) {
	            var parent = (pos - 1) >> 1;
	            var current = data[parent];
	            if (compare(item, current) >= 0) break;
	            data[pos] = current;
	            pos = parent;
	        }
	
	        data[pos] = item;
	    },
	
	    _down: function (pos) {
	        var data = this.data;
	        var compare = this.compare;
	        var halfLength = this.length >> 1;
	        var item = data[pos];
	
	        while (pos < halfLength) {
	            var left = (pos << 1) + 1;
	            var right = left + 1;
	            var best = data[left];
	
	            if (right < this.length && compare(data[right], best) < 0) {
	                left = right;
	                best = data[right];
	            }
	            if (compare(best, item) >= 0) break;
	
	            data[pos] = best;
	            pos = left;
	        }
	
	        data[pos] = item;
	    }
	};


/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(2387)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ }),
/* 2386 */
/***/ (function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(2386)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from) {
	        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	            to[j] = from[i];
	        return to;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2389);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ }),
/* 2391 */
/***/ (function(module, exports) {

	/**
	 * This file automatically generated from `pre-publish.js`.
	 * Do not manually edit.
	 */
	
	module.exports = {
	  "area": true,
	  "base": true,
	  "br": true,
	  "col": true,
	  "embed": true,
	  "hr": true,
	  "img": true,
	  "input": true,
	  "link": true,
	  "meta": true,
	  "param": true,
	  "source": true,
	  "track": true,
	  "wbr": true
	};


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 2393 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filters = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Filters2.default;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Collections = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collections2.default;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Wireframe = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Wireframe2 = _interopRequireDefault(_Wireframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Wireframe2.default;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement('div', { className: _styles2.default.Loader })
	  );
	};
	
	exports.default = Loader;

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Buildings = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Buildings2 = _interopRequireDefault(_Buildings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Buildings2.default;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Collection = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection2.default;

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Notification = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Notification2.default;

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Input = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Input2.default;

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Building = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Building2.default;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toPropertyKey = __webpack_require__(__webpack_module_template_argument_0__);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toPropertyKey = __webpack_require__(__webpack_module_template_argument_0__);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var _typeof = __webpack_require__(__webpack_module_template_argument_0__)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var _typeof = __webpack_require__(__webpack_module_template_argument_0__)["default"];
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_1__);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var arrayLikeToArray = __webpack_require__(__webpack_module_template_argument_0__);
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.c752bd7c.js